var jM = Object.defineProperty;
var qM = (e, t, n) => t in e ? jM(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var It = (e, t, n) => qM(e, typeof t != "symbol" ? t + "" : t, n);
import { ref as $, shallowRef as Ea, watch as Je, computed as E, getCurrentInstance as Zo, inject as bi, onMounted as jt, onBeforeUnmount as Tt, shallowReactive as WM, toRaw as YM, defineComponent as lt, openBlock as f, createElementBlock as h, normalizeStyle as Wt, normalizeClass as Re, Fragment as Te, createTextVNode as Ht, toDisplayString as y, createCommentVNode as O, renderList as nt, createVNode as Ze, createElementVNode as d, createBlock as Ge, unref as u, nextTick as Gt, Teleport as wi, Transition as Rr, withCtx as mt, withModifiers as yt, withKeys as Ca, renderSlot as On, resolveDynamicComponent as Ki, withDirectives as ln, vModelText as _n, provide as Wo, useSlots as GM, mergeProps as Tv, h as XM, resolveComponent as JM, vModelCheckbox as zc, getCurrentScope as y2, onScopeDispose as Oy, createStaticVNode as g2, onUpdated as ZM, reactive as b2, defineAsyncComponent as k2, watchEffect as QM, createSlots as eP, isRef as tP, vShow as w2 } from "vue";
import { ChevronDown as nP, Check as Av, Sparkles as aP, Plus as iP, History as oP, X as rP, Trash2 as sP, Undo2 as lP, Ban as uP, CircleAlert as t_, LoaderCircle as n_, Square as cP, Send as dP } from "lucide-vue-next";
import { Popover as fP, PopoverButton as pP, PopoverPanel as hP, Menu as mP, MenuButton as vP, MenuItems as yP, MenuItem as gP } from "@headlessui/vue";
function Ev(e) {
  return !!e && e.enabled && e.state === "ok";
}
const el = {
  "toolbar.new_folder": "New folder",
  "toolbar.upload": "Upload",
  "toolbar.search": "Search",
  "toolbar.search.placeholder": "Search by name or tag:…",
  "toolbar.view.list": "List",
  "toolbar.view.grid": "Grid",
  "toolbar.refresh": "Refresh",
  "toolbar.go_up": "Up one level",
  "ctx.open": "Open",
  "ctx.preview": "Preview",
  "ctx.download": "Download",
  "ctx.archive_create": "Create archive…",
  "ctx.archive_extract": "Extract archive…",
  "ctx.rename": "Rename",
  "ctx.delete": "Delete",
  "ctx.delete_perm": "Delete permanently",
  "ctx.restore": "Restore",
  "ctx.share": "Share",
  "ctx.move": "Move",
  "ctx.copy": "Copy",
  "ctx.cut": "Cut",
  "ctx.show_hidden": "Show hidden files",
  "ctx.hide_hidden": "Hide hidden files",
  "ctx.keep_local": "Keep on this computer",
  "ctx.keep_online": "Keep online only",
  "ctx.keep_reveal": "Open local folder",
  "ctx.keep_inherited": "Kept on this computer with its parent",
  "keep.started": "Will be kept on this computer - sync started",
  "keep.failed": "Could not keep on this computer",
  "keep.badge_kept": "On this computer",
  "keep.badge_syncing": "Syncing…",
  "keep.badge_cloud": "Online only",
  "keep.badge_partial": "Contains items kept on this computer",
  "keep.strip_transfer": "Syncing {name} - {done}/{total} ({pct}%)",
  "keep.strip_inventory": "Syncing {name} - scanning the server…",
  "keep.strip_settling": "Syncing {name} - settling…",
  "ctx.paste": "Paste",
  "ctx.info": "Info",
  "ctx.duplicate": "Duplicate",
  "ctx.new_file": "New file",
  "modal.delete.title": "Delete?",
  "modal.delete.message": "{count} items will be moved to trash.",
  "modal.delete.message_one": "{count} item will be moved to trash.",
  "modal.delete.confirm": "Move to Trash",
  "modal.delete.working": "Moving to Trash…",
  "modal.delete.cancel": "Cancel",
  "modal.delete.permanent_title": "Delete permanently?",
  "modal.delete.permanent_message": "{count} items will be deleted for good. This cannot be undone.",
  "modal.delete.permanent_message_one": "{count} item will be deleted for good. This cannot be undone.",
  "modal.delete.permanent_confirm": "Delete permanently",
  "modal.delete.permanent_working": "Deleting…",
  "modal.rename.title": "Rename",
  "modal.rename.save": "Save",
  "modal.rename.saving": "Renaming…",
  "modal.rename.cancel": "Cancel",
  "modal.rename.empty": "Type a name.",
  "modal.newfolder.title": "New folder",
  "modal.newfolder.placeholder": "Folder name",
  "modal.newfolder.create": "Create",
  "modal.newfolder.creating": "Creating…",
  "modal.newfolder.cancel": "Cancel",
  "modal.share.title": "Share link",
  "archive.create_title": "Create archive",
  "archive.extract_title": "Extract archive",
  "archive.create_count": "{count} selected items",
  "archive.create_count_one": "{count} selected item",
  "archive.filename": "Archive name",
  "archive.format": "Format",
  "archive.password_optional": "Password (optional)",
  "archive.password_confirm": "Confirm password",
  "archive.password_mismatch": "Passwords do not match.",
  "archive.encrypt_names": "Encrypt file names",
  "archive.compression": "Compression",
  "archive.solid": "Create solid archive",
  "archive.dictionary_size": "Dictionary size",
  "archive.dictionary_size_value": "{n} MiB",
  "archive.dictionary_hint": "Larger dictionaries can improve compression but use more memory while creating and extracting.",
  "archive.destination_folder": "Extract to folder",
  "archive.create": "Create",
  "archive.creating": "Creating…",
  "archive.extract": "Extract",
  "archive.extract_here": "Extract here",
  "archive.extract_to_folder": "Extract to folder",
  "archive.extracting": "Extracting…",
  "archive.cancel": "Cancel",
  "archive.invalid_name": "Enter a file name without slashes.",
  "archive.invalid_extension": "Archive name must use one of the available format extensions.",
  "archive.invalid_folder": "Enter a folder name without slashes.",
  "archive.password_required": "This archive requires a password.",
  "archive.password_title": "Archive password",
  "archive.continue": "Continue",
  "archive.opening": "Opening…",
  "archive.bad_password": "The archive password is incorrect.",
  "archive.target_exists": "An item with that name already exists. Choose another name or remove it first.",
  "archive.password_charset": "A ZIP password can use only ASCII characters: unaccented letters, digits and ordinary punctuation. Choose 7z to use any characters.",
  "archive.error_unsupported": "This archive cannot be extracted: this server cannot read its format, or it holds something filex does not extract (a link, a special file, or a file whose size it does not state).",
  "archive.error_limit": "This archive is larger than the server allows to extract.",
  "archive.error_unavailable": "This server cannot open this kind of archive right now.",
  "archive.created": "Archive created",
  "archive.queued": "Archive creation is running in the background",
  "archive.extracted": "Extracted {count} files",
  "archive.extracted_one": "Extracted {count} file",
  "archive.extraction_queued": "Archive extraction is running in the background",
  "archive.preparing_extract": "Reading {name}… the whole archive is read before it can be extracted.",
  "archive.already_preparing": "Still reading {name} - it is extracted once that is done",
  "archive.extraction_completed": "Extraction completed",
  "archive.extraction_cancelled": "Extraction cancelled after {count} files",
  "archive.extraction_cancelled_one": "Extraction cancelled after {count} file",
  "modal.share.pin": "PIN protected",
  "modal.share.expires": "Expires at",
  "modal.share.max_downloads": "Download limit",
  "modal.share.create": "Share",
  "modal.share.cancel": "Cancel",
  "modal.share.close": "Close",
  "modal.share.limit_applied": "(server limit applied)",
  "modal.share.copy": "Copy",
  "modal.share.url_copied": "Link copied",
  "modal.share.pin_copied": "PIN copied",
  "modal.share.cli_copied": "CLI command copied",
  "upload.progress": "Uploading",
  "upload.done": "Done",
  "upload.error": "Error",
  "upload.failed": "Could not upload “{name}”",
  "upload.aborted": "Aborted",
  "upload.cancel": "Cancel",
  "upload.resuming": "Resuming “{name}” from {percent}%",
  "upload.saving": "Saving to the storage…",
  "empty.folder": "This folder is empty",
  "empty.search": "No results",
  loading: "Loading…",
  "notFound.title": "Folder not found",
  "notFound.desc": "This folder does not exist, was moved, or you do not have access to it.",
  "notFound.goRoot": "Go to root folder",
  "col.name": "Name",
  "col.size": "Size",
  "col.modified": "Modified",
  "col.type": "Type",
  "unit.bytes": "B",
  "unit.kb": "KB",
  "unit.mb": "MB",
  "unit.gb": "GB",
  "unit.tb": "TB",
  "unit.pb": "PB",
  "breadcrumb.root": "Root",
  "breadcrumb.copy_path": "Copy path",
  "breadcrumb.go_to_path": "Go to path",
  "breadcrumb.path_placeholder": "fileman/foo/bar",
  "ops.copy": "Copying",
  "ops.move": "Moving",
  "ops.delete": "Deleting",
  "ops.queued": "queued",
  "ops.done": "done",
  "ops.error": "error",
  "node.trash": "Trash",
  /* gorunum:v1 - the singular kind, printed under a folder's name on a card
   * and beside it in the list. The plural section heading is a different
   * string on purpose. */
  "node.folder": "Folder",
  // --- Rich viewer chrome ---
  "viewer.open_in_new_tab": "Open in new tab",
  "viewer.loading": "Loading…",
  "viewer.failed_to_load": "Failed to load file",
  /* ⚠ Said to a PERSON: it used to tell them to "install the peer dependency". */
  "viewer.peer_not_installed": "This kind of file cannot be shown here. Download it to open it on your device.",
  "viewer.remote_image.label": "Remote image",
  "viewer.remote_image.title": "Load a remote image?",
  "viewer.remote_image.body": "This image is on another server. Loading it tells that server that this file was opened, and your IP address.",
  "viewer.remote_image.setting_hint": "To load them without asking, turn on “Load remote images in previews” in User settings → Preferences.",
  "viewer.remote_image.load": "Load image",
  "viewer.remote_image.load_all": "Load all remote images in this file",
  "viewer.remote_image.book_held": "Pictures from other servers in this book are not loaded.",
  "viewer.remote_image.book_load": "Load remote images…",
  "viewer.format_unsupported_3d": "The preview shows 3D models in .glb, .gltf and .usdz only. Download the file to open it in a 3D program.",
  "viewer.zoom_in": "Zoom in",
  "viewer.zoom_out": "Zoom out",
  "viewer.fit_width": "Fit width",
  "viewer.next_page": "Next page",
  "viewer.prev_page": "Previous page",
  "viewer.page_n_of_m": "Page {n} of {m}",
  "viewer.tags": "Tags",
  "viewer.layers": "Layers",
  "viewer.toc": "Contents",
  "viewer.font_smaller": "Smaller text",
  "viewer.font_larger": "Larger text",
  "viewer.search": "Search",
  "viewer.download": "Download",
  "viewer.saving": "Saving…",
  "viewer.save": "Save (Ctrl+S)",
  "viewer.saved": "Saved",
  "viewer.save_error": "Error",
  "viewer.editor_loading": "Loading editor…",
  "viewer.no_preview": "No preview for this file type yet.",
  "viewer.edit": "Edit",
  "viewer.close": "Close",
  "presence.expand": "Show names",
  "presence.collapse": "Collapse",
  "viewer.save_annotations": "Save annotations",
  "viewer.annotations_on": "Annotations: on",
  "viewer.annotations_off": "Annotations: off",
  "viewer.read_only": "Read only",
  "viewer.csv_first_row_header": "First row as header",
  "viewer.csv_filter": "Filter rows…",
  "viewer.epub_prev": "Previous",
  "viewer.epub_next": "Next",
  /* ⚠ The old sentence named an ENVIRONMENT VARIABLE to every reader
     ("operator must wire FILEX_DRAWIO_URL"). A person who only wanted to look
     at a diagram is told what they can do; `_admin` - someone who can fix it -
     is told where. */
  "viewer.drawio.disabled": "Diagrams cannot be opened here: this server has no draw.io. Download the file to open it elsewhere.",
  "viewer.drawio.disabled_admin": "draw.io is not set up on this server. Set it up in the admin panel under External services.",
  "viewer.drawio.load_failed": "This diagram could not be read. Download it to open it elsewhere.",
  "viewer.drawio.save_failed": "The diagram could not be saved. Your changes are still in the editor - try again.",
  "viewer.archive.entries": "{n} files",
  "viewer.archive.entries_one": "{n} file",
  "viewer.archive.empty": "Archive is empty.",
  "viewer.archive.error": "Could not read archive contents.",
  "viewer.archive.unsupported": "This kind of archive cannot be listed here. Download it to see what is inside.",
  "viewer.archive.too_large": "This archive is too large to list here. Download it to see what is inside.",
  "viewer.archive.open": "Open archive",
  "viewer.archive.root": "Archive",
  "viewer.archive.location": "Archive location",
  "viewer.archive.reading": "Still reading… the whole archive is read before its contents can be listed, which takes a while for a large one.",
  "viewer.name": "Name",
  "viewer.size": "Size",
  // --- cila:a - sorting / date groups / density ---
  "col.sort": "Sort",
  "group.today": "Today",
  "group.yesterday": "Yesterday",
  "group.this_week": "This week",
  "group.this_month": "This month",
  "group.no_date": "No date",
  "toolbar.density.compact": "Compact view",
  "toolbar.density.comfortable": "Comfortable view",
  // --- cila:c - command palette + shortcuts help + breadcrumb ---
  "palette.placeholder": "Search files, folders or commands…",
  "palette.files": "Files",
  "palette.commands": "Commands",
  "palette.goto": "Go to path",
  "palette.empty": "No results",
  "palette.hint": "↑↓ navigate · Enter select · Esc close",
  "cmd.view_toggle": "Toggle view (list ⇄ grid)",
  "cmd.trash": "Open trash",
  "shortcuts.title": "Keyboard shortcuts",
  "shortcuts.group.nav": "Navigation",
  "shortcuts.group.selection": "Selection",
  "shortcuts.group.file": "File operations",
  "shortcuts.palette": "Command palette",
  "shortcuts.search": "Focus search",
  "shortcuts.go_up": "Go up one level",
  "shortcuts.open": "Open selected item",
  "shortcuts.close": "Close / cancel",
  "shortcuts.toggle_hidden": "Show/hide hidden files",
  "shortcuts.help": "This help dialog",
  "shortcuts.select_all": "Select all",
  "shortcuts.star": "Star / unstar",
  "shortcuts.rename": "Rename",
  "shortcuts.delete": "Delete",
  "shortcuts.cut": "Cut",
  "shortcuts.copy": "Copy",
  "shortcuts.paste": "Paste",
  "breadcrumb.more": "Folders in between",
  // --- State screens + undo snackbar + connection badge (cila:b) ---
  "empty.hint": "Drag and drop files here",
  "empty.upload": "Upload files",
  "empty.search.title": "No files match your search",
  "empty.search.hint": "Try a different search term",
  "empty.trash.title": "Trash is empty",
  "error.title": "Could not load this folder",
  "error.retry": "Try again",
  "toast.undo": "Undo",
  "toast.undone": "Undone",
  "toast.undoing": "Undoing…",
  "toast.undo_queued": "The undo is queued - the operations panel shows when it is done",
  "toast.undo_failed": "Could not undo",
  "toast.renamed": "Renamed",
  "toast.rename_queued": "Renaming to “{name}”…",
  "toast.moved": "Moved",
  "toast.trashed": "Moved to trash",
  /* i18n:hardcoded - toast copy that used to be Turkish string literals in
     FileExplorer.vue, unreachable by any locale. */
  "toast.failed": "Operation failed",
  /* ── errorWords (lib/errorWords): how a failure is SAID. ⚠ No status code,
     no JSON, no environment variable ever reaches these; an administrator
     sees the raw words on a second line, nobody else does. ── */
  "err.status.400": "Bad request",
  "err.status.401": "Sign-in required",
  "err.status.403": "You are not allowed to do this",
  "err.status.404": "Not found",
  "err.status.409": "Already exists / conflict",
  "err.status.413": "File too large",
  "err.status.415": "Unsupported file type",
  "err.status.422": "Invalid data",
  "err.status.429": "Too many requests",
  "err.status.500": "Server error",
  "err.status.501": "Not supported",
  "err.status.502": "A connected service reported an error",
  "err.status.503": "Service unavailable",
  "err.status.504": "A connected service took too long to answer",
  "err.status.other": "The server refused this request.",
  "err.upload_stalled": "The upload stopped making progress. Try again - it continues where it stopped.",
  "err.network": "The server could not be reached. Check your connection and try again.",
  /* 0.54 (audit A1/A2): a refusal the server names is said in the SERVER's
     words (`message`, backend internal/apierr `server.error.*`); the copies
     that stood here (err.read_only, err.quota, err.e2e_*, err.name_taken,
     opc.err.*…) are gone with the tables of lib/errorWords that used them. */
  "err.save_failed": "Your changes could not be saved.",
  "err.load_failed": "This file could not be loaded.",
  "err.viewer_failed": "The viewer for this file could not be started. Download the file to open it.",
  "err.detail": "Details",
  "toast.copied": "Copied",
  "toast.deleted": "Deleted",
  "toast.cut": "Cut",
  "toast.cut_ready": "Cut - ready to paste",
  "toast.copy_ready": "Copied - ready to paste",
  "toast.same_folder_cut": "Cannot cut into the same folder",
  "toast.restored": "{n} items restored",
  "toast.restored_one": "{n} item restored",
  "toast.delete_queued": "Delete queued",
  "toast.trash_retention": "Items in the trash are removed automatically once the retention window ends. Permanent deletion is done from the admin panel.",
  /* The Trash row a permanent delete is on its way for (the admin Trash
     page's words: one sentence, both catalogues - lesson #447). */
  "trash.purging": "Deleting permanently…",
  "trash.row_busy": "Something is already being done to this item",
  "dropzone.hint": "Drop files here",
  "modal.newfolder.invalid": "Invalid character",
  "names.reserved": "“{name}” is reserved for filex’s own use. Choose another name.",
  /* ⚠ A missing or broken document server is said in words, never as the
     HTTP layer (it used to read `Config fetch 503: {"error":"onlyoffice not
     configured"}`). `_admin` is what someone who can fix it reads - where to
     fix it; everybody else reads how to get the file anyway. */
  "viewer.office_unconfigured": "Office documents cannot be opened here: this server has no ONLYOFFICE document server. Download the file to open it on your computer.",
  "viewer.office_unconfigured_admin": "ONLYOFFICE is not set up on this server, so office documents cannot be opened here. Set it up in the admin panel under External services.",
  "viewer.office_unreachable": "The document server is not answering right now. Try again later, or download the file.",
  "viewer.office_unreachable_admin": "The ONLYOFFICE document server is not answering. Check it in the admin panel under External services.",
  /* Task #92: the editor runs in a frame on another origin (the document
     server's own, or the interface origin), and that page never answered -
     the address does not reach this filex. */
  "viewer.office_frame_unreachable_admin": "The ONLYOFFICE editor frame did not load from {origin}. Check that the reverse proxy there sends the frame to filex ({env}).",
  "viewer.office_failed": "This document could not be opened in ONLYOFFICE. Download it to open it on your computer.",
  "viewer.csv_office_note": "Saved as CSV: only the values of the active sheet are kept. Formatting, formulas and other sheets are not saved.",
  "viewer.office_forbidden": "You do not have permission to open this document in ONLYOFFICE.",
  /* After ONLYOFFICE's "Download failed": which of its two failures it was,
     as filex saw it (lib/officeDiagnosis, issue #80). */
  "viewer.office_download_served": "The document server downloaded this file from filex, but your browser could not load the converted copy from the document server. Check the X-Forwarded-Proto and X-Forwarded-Host headers on the reverse proxy in front of the document server.",
  "viewer.office_download_not_requested": "The document server never asked filex for this file. If the file was opened before, the document server may be using its own copy of it.",
  "viewer.office_download_refused": "filex refused the document server’s request for this file: {reason}.",
  "viewer.office_fetch_reason.bad_link": "the address was malformed",
  "viewer.office_fetch_reason.signature_expired": "the address had expired",
  "viewer.office_fetch_reason.signature_bad": "its signature did not match (the JWT secret changed, or the address was altered)",
  "viewer.office_fetch_reason.not_found": "the file no longer exists",
  "viewer.office_fetch_reason.storage_unavailable": "the storage could not be opened",
  "viewer.office_fetch_reason.body_unavailable": "the file’s contents could not be found",
  "viewer.office_fetch_reason.object_missing": "the file is missing from the storage",
  "viewer.office_fetch_reason.read_failed": "reading the file from the storage failed",
  /* The explorer's Open on a document the document server would open, when
     there is none - shown to an administrator only (everyone else is not
     offered the entry at all; lib/serviceGate). */
  "ctx.needs_onlyoffice": "ONLYOFFICE is not set up - set it up in the admin panel under External services.",
  "ctx.needs_drawio": "draw.io is not set up - set it up in the admin panel under External services.",
  "viewer.pdf_inline_failed": "Your browser could not display this PDF inline.",
  "viewer.too_large": "File is too large (>1 MB).",
  "viewer.csv_rows": "{n} rows",
  "viewer.csv_rows_one": "{n} row",
  "presence.others": "{n} people",
  "presence.others_one": "{n} person",
  "conn.offline": "No live connection - changes may be delayed",
  "conn.tooltip": "Live connection to the server is unavailable; the list refreshes periodically. This notice disappears once the connection is back.",
  /* === bul:s3 === */
  "palette.everywhere": "Everywhere",
  "palette.searching": "Searching…",
  "palette.everywhere_failed": "The search could not be done. Try again.",
  "palette.saved": "Saved searches",
  "palette.save": "Save search",
  "palette.saved.delete": "Delete saved search",
  /* #168 - the admin panel's search (components/PanelSearch.vue). */
  "panelsearch.label": "Search the admin panel",
  "panelsearch.trigger": "Search",
  "panelsearch.placeholder": "Search pages, settings, people, apps…",
  "panelsearch.close": "Close search",
  "panelsearch.clear": "Clear the search",
  "panelsearch.results": "Search results",
  "panelsearch.group.page": "Pages",
  "panelsearch.group.setting": "Settings",
  "panelsearch.group.app": "Apps",
  "panelsearch.group.user": "Users",
  "panelsearch.group.group": "Groups",
  "panelsearch.group.key": "API keys",
  "panelsearch.group.storage": "Storages",
  "panelsearch.group.share": "Shares",
  "panelsearch.group.file": "Files",
  "panelsearch.group.recent": "Recent searches",
  "panelsearch.files_all": "Search files: {q}",
  "panelsearch.recent_remove": "Remove from recent searches",
  "panelsearch.recent_clear": "Clear recent searches",
  "panelsearch.empty": "Nothing matches “{q}”.",
  "panelsearch.searching": "Searching…",
  "panelsearch.failed": "Some results could not be loaded. The rest are shown.",
  "panelsearch.prefixes": "Narrow to one kind:",
  "panelsearch.count_one": "{n} result",
  "panelsearch.count": "{n} results",
  "search.in_content": "In content",
  "search.truncated": "More results than shown - narrow your search",
  "nav.more_shown": "Showing {shown} of {total}",
  "nav.load_more": "Load more",
  /* Catalog coverage (docs/LAZY-CATALOGUE.md, lib/catalogCoverage). One
     sentence per reason; the banner sits over a listing and over search
     results, and says what is left out and why. */
  "coverage.first_scan": "This storage’s first sync has not finished. Until it does, search, folder sizes and usage leave part of it out.",
  "coverage.lazy_filling": "filex is still cataloging this storage ({pct}% of the folders found so far). Until it finishes, search, folder sizes and usage leave part of it out.",
  "coverage.lazy_on_open": "Only the folders people open on this storage are cataloged. Search, folder sizes and usage cover those folders only.",
  "coverage.search_some": "Not everything on these storages is cataloged yet: {names}. This search may miss files there.",
  "coverage.catalog_all": "Catalog everything",
  "coverage.catalog_started": "Sync started - the whole storage is being cataloged.",
  "coverage.catalog_running": "Cataloging…",
  "coverage.cataloging": "Cataloging {storage}… this runs in the background, and this page says when it is done.",
  "coverage.catalog_done": "{storage} is cataloged in full",
  "coverage.catalog_failed": "Cataloging {storage} failed. The admin panel shows why, under the storage’s sync runs.",
  "coverage.catalog_stopped": "Cataloging {storage} was stopped before it finished",
  "coverage.catalog_joined": "A scan of {storage} was already running - this page says when it is done.",
  "coverage.catalog_gone": "{storage} was removed while it was being cataloged",
  "coverage.catalog_unfollowed": "Cataloging {storage} goes on in the background; the admin panel shows how it ends, under the storage’s sync runs",
  "size.at_least": "≥ {size}",
  "size.partial_hint": "Part of this folder is not cataloged yet, so its size is at least this.",
  "size.unknown_hint": "This folder is not cataloged yet, so its size is not known.",
  /* === bag:b4 === */
  "toolbar.more": "More actions",
  "toolbar.search.close": "Close search",
  "sheet.menu": "Actions",
  "sheet.close": "Close",
  /* === koru:k1 === */
  "toolbar.inspector": "Details",
  "ctx.details": "Details",
  /* yildiz:s1 - starring is an action, so it has a verb in the menu. */
  "ctx.star": "Star",
  "ctx.unstar": "Unstar",
  "star.failed": "Could not change the star",
  "shortcuts.inspector": "Toggle details panel",
  "inspector.title": "Details",
  "inspector.copy_name": "Copy name",
  "inspector.items": "{n} items",
  "inspector.items_one": "{n} item",
  "inspector.type": "Type",
  "inspector.select_hint": "Select an item to see its details.",
  /* pane:p1 - the panel HOLDS the last selected thing (owner's ruling,
     2026-09-13), so it can be describing an item in the half of a split
     window nobody is looking at. This line says which one and where. */
  "inspector.held": "Last selected - in {where}",
  "inspector.close": "Close",
  "inspector.section.general": "General",
  "inspector.section.tags": "Tags",
  /* etiket:t1 - TagPicker's own chrome. It printed these three in English
     regardless of the catalogue until 2026-09-13; `tags.open` is the chip's new
     "show me everything with this tag". */
  "tags.open": "Open tag: {tag}",
  "tags.add": "+ Add tag",
  "tags.name": "Tag name",
  "tags.remove": "Remove tag",
  /* etiket:k2 (v0.43.0) - the two KINDS of tag. Every place a tag is drawn
     says which kind it is, in words as well as the icon, because until this
     release a tag was silently shared with every account on the server. */
  "tags.kind.label": "Who sees this tag",
  "tags.kind.personal": "Personal",
  "tags.kind.team": "Team",
  "tags.kind.personal_help": "Only you see it",
  "tags.kind.team_help": "Everyone on your team who can see this file",
  "tags.kind.team_locked": "Adding or removing a team tag needs edit permission on this file.",
  "tags.chip.personal": "Personal tag “{tag}” - only you see it",
  "tags.chip.team": "Team tag “{tag}” - everyone on your team who can see this file sees it",
  "tags.add_submit": "Add",
  "inspector.section.versions": "Versions",
  "inspector.section.permissions": "Permissions",
  "inspector.section.shares": "Shares",
  "inspector.path": "Path",
  "inspector.size": "Size",
  "inspector.modified": "Modified",
  "inspector.mime": "MIME type",
  "inspector.etag": "ETag",
  "inspector.nodeId": "Node ID",
  "inspector.copy": "Copy",
  "inspector.copied": "Copied",
  "inspector.error": "Could not load",
  "inspector.items_summary": "{n} items, {size} total",
  "inspector.items_summary_one": "{n} item, {size} total",
  "inspector.folder_items": "{n} items",
  "inspector.folder_items_one": "{n} item",
  "inspector.versions.empty": "No version history",
  "inspector.versions.v": "Version {n}",
  "inspector.versions.restore": "Restore",
  "inspector.versions.restore_confirm": "Restore this version?",
  "inspector.versions.snapshot_current": "Snapshot the current state first",
  "inspector.versions.confirm": "Confirm",
  "inspector.versions.restoring": "Restoring…",
  "inspector.versions.cancel": "Cancel",
  "inspector.versions.take_snapshot": "Snapshot current state",
  "inspector.versions.snapshotting": "Taking a snapshot…",
  "inspector.versions.restored": "Version restored",
  "inspector.versions.snapshotted": "Snapshot taken",
  "inspector.versions.unsupported": "The server does not support this operation",
  "inspector.perm.none": "No access",
  "inspector.perm.viewer": "Viewer",
  "inspector.perm.editor": "Editor",
  "inspector.perm.owner": "Owner",
  "inspector.perm.manage": "Manage permissions",
  "inspector.shares.empty": "No share links",
  "inspector.shares.copy": "Copy link",
  /* wiring:c1 - theme gallery */
  "theme.menu": "Theme",
  "theme.title": "Theme gallery",
  "theme.hint": "A theme only changes the color palette - day or night is the choice above.",
  "theme.mode.label": "Appearance",
  "theme.mode.light": "Day",
  "theme.mode.dark": "Night",
  "theme.mode.auto": "Automatic",
  "theme.reset": "Reset to default",
  "theme.close": "Close",
  "theme.selected": "Selected",
  "theme.name.default": "Default",
  "theme.name.night": "Night blue",
  "theme.name.forest": "Forest",
  "theme.name.amber": "Amber",
  "theme.name.lilac": "Lilac",
  "theme.name.contrast": "High contrast",
  "theme.name.gray": "Soft gray",
  "theme.name.terminal": "Terminal green",
  /* === zaman:z3 - the time-zone picker (embed dialog + web settings) === */
  "tz.menu": "Time zone",
  "tz.title": "Time zone",
  "tz.label": "Show dates in",
  "tz.search": 'Search a city, country or offset - try "Istanbul" or "GMT+3"',
  "tz.default.device": "Use this device's zone ({zone})",
  "tz.default.account": "Use the account's zone ({zone})",
  "tz.default.host": "Use this site's default ({zone})",
  "tz.no_match": "No zone matches “{query}”. Try a city, a country, or an offset like GMT+3.",
  "tz.more": "{n} more - keep typing to narrow the list.",
  "tz.hint": "Saved in this browser only. Every date is stored as one moment in time and shown on the clock you pick here.",
  "tz.now": "Right now in {zone}: {time}",
  /* #275 - an embed's own language setting ("⋯" → Language), kept in this browser */
  "lang.menu": "Language",
  "lang.title": "Language",
  "lang.label": "Interface language",
  "lang.default.browser": "Browser language ({lang})",
  "lang.default.account": "Your account's language ({lang})",
  "lang.default.host": "This site's default ({lang})",
  "lang.default.default": "Default ({lang})",
  "lang.hint": "Saved in this browser only.",
  "lang.hint_account": "Saved in this browser and on your account, so your other devices and your notifications use it too.",
  /* === wiring:c2 - customizable shortcuts + quick look === */
  "shortcuts.quicklook": "Quick look",
  "shortcuts.customize": "Customize",
  "shortcuts.settings.menu": "Shortcuts",
  "shortcuts.settings.title": "Shortcut settings",
  "shortcuts.settings.hint": 'To remap a shortcut, press "Change" and then the new key combination. Changes are stored in this browser only.',
  "shortcuts.settings.change": "Change",
  "shortcuts.settings.capture": "Press keys… (Esc cancels)",
  "shortcuts.settings.reset": "Reset to default",
  "shortcuts.settings.reset_all": "Reset all",
  "shortcuts.settings.unbound": "Not set",
  "shortcuts.settings.fixed": "Fixed",
  "shortcuts.settings.customized": "Customized",
  "shortcuts.settings.conflict": 'is already used by "{name}".',
  "shortcuts.settings.conflict_fixed": 'is reserved by the fixed shortcut "{name}" - it cannot be used.',
  "shortcuts.settings.conflict_take": "Unassign old and use here",
  "shortcuts.settings.conflict_cancel": "Cancel",
  "quicklook.hint_close": "close",
  "quicklook.hint_nav": "previous/next",
  "quicklook.hint_open": "open",
  /* === /wiring:c2 === */
  /* === wiring:c3 - operations center === */
  "opc.title": "Operations",
  "opc.aria_badge": "{n} operations - toggle operations center",
  "opc.aria_badge_one": "{n} operation - toggle operations center",
  "opc.close": "Close",
  "opc.active": "In progress",
  "opc.history": "History",
  "opc.clear": "Clear",
  "opc.empty": "No operations",
  "opc.cancel": "Cancel",
  "opc.retry": "Retry",
  "opc.dismiss": "Dismiss",
  "opc.queued": "Queued",
  "opc.cancelling": "Cancel requested…",
  "opc.percent": "{n}%",
  "opc.items": "{done} of {total} items",
  "opc.trash_items": "{n} items from the trash",
  "opc.trash_items_one": "{n} item from the trash",
  "opc.status.running": "In progress",
  "opc.status.done": "Done",
  "opc.status.error": "Failed",
  "opc.status.aborted": "Cancelled",
  "opc.kind.upload": "Upload",
  "opc.kind.copy": "Copy",
  "opc.kind.move": "Move",
  "opc.kind.delete": "Delete",
  "opc.kind.rename": "Rename",
  "opc.kind.restore": "Restore",
  "opc.kind.purge": "Delete permanently",
  "opc.kind.convert": "Convert",
  "opc.kind.archive": "Archive",
  "opc.kind.plugin": "App",
  "opc.kind.trash": "Empty trash",
  "opc.kind.thumbs": "Thumbnail repair",
  /* A folder's contents on hover (FolderPeek, useFolderPeek). */
  "peek.items": "{n} items",
  "peek.items_one": "{n} item",
  "peek.more": "+{n} more",
  "peek.empty": "Empty",
  "peek.loading": "Looking inside…",
  "opc.open": "Open",
  /* App plugins - rows a WebAssembly plugin adds to the file menu, and the
     jobs they queue (docs/APP-PLUGINS-API.md). "App" is what the feature is
     called on every surface; "plugin" is the wire word. */
  "plugin.queued": "{label} queued",
  "plugin.done": "{label} finished",
  "plugin.failed": "{label} failed",
  "plugin.cancel_failed": "Could not cancel the job",
  "plugin.not_applicable": "This action does not apply to the selection",
  "plugin.needs_engine": "{name} is not installed on this server - install it and restart filex.",
  "plugin.needs_other": "{name} is not available on this server.",
  "plugin.needs_office": "Office documents need an office engine, and none runs on this server - install the Office editor app (Apps) or connect {name} under External services.",
  "plugin.confirm.title": "Confirm",
  "plugin.confirm.cancel": "Cancel",
  "plugin.confirm.run": "Run",
  "plugin.view.close": "Close",
  "appframe.confirm_title": "Confirm",
  "appframe.consent_clipboard": "{app} wants to copy text to your clipboard.",
  "appframe.consent_download": "{app} wants to save “{name}” to your computer.",
  "appframe.consent_print": "{app} wants to print “{name}”.",
  "appframe.consent_job": "{app} wants to start “{action}”.",
  "appframe.consent_allow": "Allow",
  "appframe.consent_deny": "Don’t allow",
  "appframe.unsaved_title": "Unsaved changes",
  "appframe.unsaved_text": "{app} has changes that are not saved. Close it anyway?",
  "appframe.state_no_account": "The app’s settings for an encrypted file are kept sealed for the account you are signed in as, and this page could not tell which account that is, so nothing was kept. Sign in again, or open the file where you are signed in.",
  "appframe.discard": "Close without saving",
  "appframe.keep_open": "Keep editing",
  "appframe.save_close": "Save and close",
  "appframe.updated": "{app} was updated to {version}.",
  "appframe.updated_reload": "An administrator approved a new version of {app}. Reload it to use the new version - save your work first.",
  "appframe.reload": "Reload",
  "appframe.dismiss": "Dismiss",
  "appframe.not_connected": "{app} did not start. Close it and open it again; if it keeps happening, tell your administrator.",
  "appframe.save_as_title": "{app}: save “{name}” to",
  "plugin.view.busy": "Working…",
  "plugin.view.unsupported": "This screen uses a component this version cannot draw ({type})",
  "plugin.view.error": "The app answered with an error",
  "plugin.output_missing": "The output is no longer where it was",
  /* M2 - surface components (components/plugin/nodes/*) */
  "plugin.view.loading": "Loading…",
  "plugin.view.preview_failed": "The preview could not be loaded",
  "plugin.steps.label": "Steps",
  "plugin.list.empty": "Nothing here yet",
  "plugin.list.actions": "Actions",
  /* The label on a table row's ONE action control (core RowActions.vue).
     The explorer's handle is the ⋮ glyph; a panel row's says what it is.
     Owner, 2026-09-20: "adminde 'Aksiyon' diye yazmalı". */
  "row.actions": "Actions",
  "plugin.people.placeholder": "Name or email",
  "plugin.people.placeholder_email": "Email address",
  "plugin.people.add": "Add",
  "plugin.people.remove": "Remove {name}",
  "plugin.people.invalid_email": "Enter a valid email address",
  "plugin.people.external_off": "Only people with an account can be added",
  "plugin.pin.label": "PIN",
  "plugin.file.choose": "Choose…",
  "plugin.file.clear": "Clear",
  "plugin.file.none": "Nothing chosen",
  /* M3 - the sign track: signature-pad + pdf-fields nodes, and the outside
     participant's public page (views/PublicSurface.vue via usePublicPage). */
  "plugin.sig.mode_draw": "Draw",
  "plugin.sig.mode_type": "Type",
  "plugin.sig.mode_upload": "Upload",
  "plugin.sig.draw_hint": "Sign here with your finger or mouse",
  "plugin.sig.type_placeholder": "Type your name",
  "plugin.sig.upload_pick": "Choose a picture…",
  "plugin.sig.upload_hint": "PNG or JPEG, at most {kb} KB",
  "plugin.sig.upload_too_big": "The picture is larger than {kb} KB",
  "plugin.sig.upload_bad_type": "Only PNG or JPEG pictures can be used",
  "plugin.sig.upload_unreadable": "The picture could not be read",
  "plugin.sig.clear": "Clear signature",
  "plugin.sig.signed": "Signature captured",
  "plugin.pdf.load_failed": "The document could not be loaded",
  "plugin.pdf.palette": "Field types",
  "plugin.pdf.pending": "Boxes waiting for a place",
  "plugin.pdf.place_box_hint": "Tap the page where “{name}” goes, or drag to size it",
  "plugin.pdf.all_placed": "Every box has a place",
  "plugin.pdf.place_idle": "Choose one of the boxes above, then tap the page where it goes.",
  "plugin.pdf.place_idle_done": "Tap a box on the page to take it off or copy it; drag it to move it.",
  "plugin.pdf.no_boxes": "No boxes yet. Add one below: give it a name, say whose it is, and place it on the document in the next step.",
  "plugin.pdf.add_box": "Add a box",
  "plugin.pdf.unplace": "Take off the page",
  "plugin.pdf.place_hint": "Tap the page where the {type} field goes, or drag to size it",
  "plugin.pdf.type_signature": "Signature",
  "plugin.pdf.type_initials": "Initials",
  "plugin.pdf.type_date": "Date",
  "plugin.pdf.type_text": "Text",
  "plugin.pdf.type_checkbox": "Checkbox",
  "plugin.pdf.tap_signature": "Tap to sign",
  "plugin.pdf.tap_initials": "Tap to initial",
  "plugin.pdf.tap_date": "Tap for today",
  "plugin.pdf.tap_text": "Text",
  "plugin.pdf.tap_checkbox": "Tap to tick",
  "plugin.pdf.label": "Name",
  "plugin.pdf.assignee": "Signer",
  "plugin.pdf.unassigned": "Anyone",
  "plugin.pdf.filled_by": "Filled by",
  "plugin.pdf.style": "How it is signed",
  "plugin.pdf.style_drawn": "Drawn",
  "plugin.pdf.style_typed": "Typed",
  "plugin.pdf.lines": "Printed under it",
  "plugin.pdf.lines_preview": "Under the signature:",
  "plugin.pdf.lines_none": "Nothing is printed under this signature.",
  "plugin.pdf.required": "Required",
  "plugin.pdf.copy_to_page": "Copy to page",
  "plugin.pdf.copy": "Copy",
  "plugin.pdf.delete": "Delete field",
  "plugin.pdf.zoom_in": "Zoom in",
  "plugin.pdf.zoom_out": "Zoom out",
  "plugin.pdf.zoom_fit": "Fit to width",
  "plugin.pdf.zoom_fit_page": "Fit the page to the screen",
  "plugin.pdf.pad_for": "Your {type}",
  "plugin.pdf.pad_done": "Done",
  "plugin.page.loading": "Loading…",
  "captcha.label": "Verification",
  "captcha.progress": "Verification progress",
  "captcha.fallback_intro": "The verification service cannot be reached, so your browser is doing a short check instead…",
  "captcha.fallback_done": "Verification complete.",
  "captcha.fallback_failed": "The check could not finish. Reload the page and try again.",
  "captcha.widget_failed": "The verification box could not load. If a content blocker is on, allow this page and reload it.",
  "captcha.invalid": "Verification failed. Please try again.",
  "captcha.unavailable": "Verification is not available right now. Try again in a few minutes.",
  "plugin.page.pin_title": "This page is protected",
  "plugin.page.pin_hint": "Enter the PIN you were given to continue",
  "plugin.page.pin_submit": "Continue",
  "plugin.page.pin_wrong": "That PIN is not right",
  "plugin.page.pin_locked": "Too many wrong PINs - wait a few minutes and try again",
  "plugin.page.unavailable_title": "This link is not available",
  "plugin.page.unavailable_text": "It may have expired, been used up or been withdrawn. Ask the person who sent it for a new one.",
  "plugin.page.accepted_title": "Received, thank you",
  "plugin.page.accepted_text": "Your answer has been recorded. You can close this page.",
  "plugin.page.done_title": "All done",
  "plugin.page.done_text": "There is nothing more to do here. You can close this page.",
  "plugin.page.error_title": "Something went wrong",
  "plugin.page.retry": "Try again",
  "plugin.page.files": "Documents",
  "plugin.page.open_file": "Open {name} in a new tab",
  "plugin.page.footer": "Served by filex",
  /* The public pages' own sentences (share, file request) are the SERVER's
     `server.public.*` (composables/usePublicText) - not keys of this file. */
  /* === App plugins v2 - a `page` view, an app's lock on a file, the output
     mode a job wrote in, and the faces + rules a signature field carries. === */
  "plugin.page_view.back": "Back to the files",
  "plugin.page_view.queued_title": "The job is queued",
  "plugin.page_view.queued_text": "filex is working on it. This page says when it is done, and its progress is in the operations tray too.",
  "plugin.page_view.finished_title": "The job is done",
  "plugin.page_view.finished_text": "There is nothing more to do here. You can go back to the files or close this tab.",
  "plugin.page_view.failed_title": "The job did not finish",
  "plugin.page_view.opening_title": "Opening the result",
  "plugin.page_view.open_ops": "Open the operations tray",
  "plugin.page_view.done_title": "All done",
  "plugin.page_view.done_text": "There is nothing more to do here. You can close this tab.",
  "plugin.page_view.error_title": "This screen could not be opened",
  "plugin.page_view.retry": "Try again",
  "plugin.page_view.blocked": "The new tab was blocked - allow pop-ups for this site, or the screen will open in a dialog",
  "plugin.output.sibling": "new file",
  "plugin.output.version": "new version",
  "plugin.output.sibling_title": "The result lands as a new file beside the original",
  "plugin.output.version_title": "The result replaces the file as a new version of it",
  "plugin.sign.font_label": "Handwriting",
  "plugin.pdf.font": "Font",
  "plugin.pdf.rule_number": "Numbers only",
  "plugin.pdf.rule_email": "Email address",
  "plugin.pdf.rule_length": "Between {min} and {max} characters",
  "plugin.pdf.rule_min": "At least {min} characters",
  "plugin.pdf.rule_max": "At most {max} characters",
  "plugin.pdf.err_number": "Enter a number",
  "plugin.pdf.err_email": "Enter a valid email address",
  "plugin.pdf.err_min": "Too short - at least {min} characters",
  "plugin.pdf.err_max": "Too long - at most {max} characters",
  "applock.badge": "Locked",
  "applock.some_app": "an app",
  "applock.held": "{app} locked this file",
  "applock.held_reason": "{app} locked this file: {reason}",
  "applock.until": "- until {date}",
  "applock.inspector": "Held by an app",
  /* issue #34 - a symlink the server will NOT follow (lib/symlink). The badge
     is the short word on the row; `why` is the sentence behind it, shown on
     hover, in the details panel and in the toast when somebody tries to open
     one. ⚠ Broken and outside-of-root are DIFFERENT states and must read
     differently: only one has an administrator remedy, and offering that
     remedy for a target that has been deleted sends the person to a settings
     screen that cannot help them. */
  "symlink.badge.outside_root": "Outside storage",
  "symlink.badge.broken": "Broken link",
  "symlink.badge.unresolved": "Remote link",
  "symlink.badge.unknown": "Link",
  "symlink.why.outside_root": `A link whose target lies outside this storage, which is why it cannot be opened. An administrator can allow it with "Follow symlinks that leave this folder" in the storage's settings.`,
  "symlink.why.broken": "A link whose target no longer exists, so there is nothing to open. It has to be repaired or removed on the server - no setting can bring the target back.",
  "symlink.why.unresolved": "A link on a remote server. filex cannot tell whether its target is inside this storage, so it does not follow it and cannot open it.",
  "symlink.why.unknown": "A link filex will not follow, so it cannot be opened. Its target is either outside this storage, missing, or on a remote server filex cannot resolve.",
  "symlink.inspector": "A link that cannot be opened",
  /* Issue #104 - an entry the storage could not answer for (lib/unavailable).
     The sentence says what it means and what happens next; the storage's own
     answer follows it ({reason}), usually in English. */
  "unavailable.why.file": "The storage could not say whether this file still exists. It cannot be opened or changed until the storage answers for it again; the next scan checks.",
  "unavailable.why.dir": "The storage could not say whether this folder still exists. Neither the folder nor anything inside it can be opened or changed until the storage answers for it again; the next scan checks.",
  "unavailable.withReason": "{why} The storage answered: {reason}",
  "unavailable.inspector": "Unavailable",
  /* 0.50 - why a file has no thumbnail, on the file itself (lib/thumbNote):
     the marker's name and the sentence a resting pointer or a tap shows. */
  "thumbNote.corrupt": "Damaged",
  "thumbNote.corrupt_why": "No thumbnail: the file could not be read. It may be damaged or incomplete.",
  "thumbNote.encrypted": "Encrypted",
  "thumbNote.encrypted_why": "No thumbnail: the file is encrypted or protected by a password.",
  "thumbNote.too_large": "Too large",
  "thumbNote.too_large_why": "No thumbnail: the file is larger than the thumbnail size limit.",
  "thumbNote.full": "{label}. {why}",
  "plugin.pdf.rule": "Accepts",
  "plugin.pdf.rule_kind_any": "Any text",
  "plugin.pdf.rule_kind_number": "Numbers only",
  "plugin.pdf.rule_kind_email": "Email address",
  "plugin.pdf.rule_min_label": "Min length",
  "plugin.pdf.rule_max_label": "Max length",
  "plugin.pdf.format": "Date layout",
  "plugin.pdf.date_order": "Date order",
  "plugin.pdf.date_separator": "Separator",
  "plugin.pdf.date_example": "Example",
  "opc.kind.archive-create": "Creating archive",
  "opc.kind.archive-extract": "Extracting archive",
  /* === wiring:c4 - onboarding tour + accessibility + error card === */
  "tour.aria": "Onboarding tour",
  "tour.restart": "Restart the tour",
  "tour.skip": "Skip tour",
  "tour.back": "Back",
  "tour.next": "Next",
  "tour.done": "Done",
  "tour.progress": "{n} / {m}",
  "tour.step.nav.title": "Storages & views",
  "tour.step.nav.desc": "Home, Shared with me, Recent, Starred and Trash are always in this panel, with your storages and connections underneath. The button in the top-left corner collapses it to a rail and brings it back.",
  "tour.step.nav.desc_closed": "This button opens the navigation panel: Home, Shared with me, Recent, Starred and Trash, with your storages and connections underneath.",
  "tour.step.new.title": "Add something",
  "tour.step.new.desc": "Everything new starts here - upload from this device, create a folder, or ask somebody else for a file. Dropping files onto the window uploads them as well.",
  "tour.step.new.desc_fab": "This button uploads files from this device. Dropping files onto the window works as well.",
  "tour.step.search.title": "Search",
  "tour.step.search.desc": 'This field searches the whole storage by name - separators and one typo are forgiven, so "invoice 2026" finds invoice_2026.pdf. Add tag:invoice to filter by tag. The sliders button opens advanced search, and {palette} opens the command palette, which runs commands too.',
  "tour.step.crumb.title": "Where you are",
  "tour.step.crumb.desc": "This trail is the address of the folder on screen. Click any step to go back up, and the chevron beside the last one lists the folders inside it.",
  "tour.step.filters.title": "Narrow the list",
  "tour.step.filters.desc": "Type, Owner, Modified and Size filter the folder you are in, the box beside them matches names as you type, and the control at the end of the row sorts.",
  "tour.step.view.title": "Switch views",
  "tour.step.view.desc": "Change how this folder is drawn; your choice is remembered.",
  "tour.step.details.title": "Details & sharing",
  "tour.step.details.desc": 'Select a file and open this panel for its details, its activity and its share links. For the full menu, right-click the file or use the button at the end of its row - "Share" there creates a link with an optional PIN and expiry.',
  "tour.step.help.title": "Shortcuts",
  "tour.step.help.desc": 'Press {help} for the shortcut cheat-sheet and {palette} for the command palette. Theme and "Restart the tour" are in the "More actions" menu at the top right; your account and sign-out are behind the avatar beside it.',
  "error.hint": "This may be a temporary network or server problem. Please try again.",
  "error.details": "Technical details",
  "col.star": "Star",
  "toolbar.view_label": "View",
  "list.aria": "File list",
  "grid.aria": "File grid",
  /* === wiring:d1 - tabs + split pane === */
  "tabs.strip": "Tabs",
  "tabs.new": "New tab",
  "tabs.close": "Close tab",
  "tabs.split": "Split view",
  "tabs.split_off": "Close split",
  "ctx.open_new_tab": "Open in new tab",
  "ctx.open_with": "Open with {app}",
  "ctx.open_with_builtin": "Open with the built-in viewer",
  "ctx.open_with_choose": "Choose an app…",
  "openWith.title": "Open with",
  "openWith.lead": "Which app should open {name}?",
  "openWith.builtin": "filex viewer (built-in)",
  "openWith.onlyoffice": "ONLYOFFICE (spreadsheet editor)",
  "openWith.now": "Opens it now",
  "openWith.always": "Always use this app for {ext} files",
  "openWith.hint": "Kept on your account. You can change it in Settings, Default apps.",
  "openWith.open": "Open",
  "shortcuts.group.tabs": "Tabs",
  "shortcuts.tab_new": "New tab",
  "shortcuts.tab_close": "Close tab",
  "shortcuts.tab_next": "Next tab",
  "shortcuts.tab_prev": "Previous tab",
  /* tus:t1 - the menu verbs */
  "shortcuts.new_folder": "New folder",
  "shortcuts.upload": "Upload files",
  "shortcuts.refresh": "Refresh the listing",
  "shortcuts.download": "Download",
  "shortcuts.preview": "Preview",
  "shortcuts.share": "Share",
  "shortcuts.tags": "Tags",
  "shortcuts.open_tab": "Open in a new tab",
  "shortcuts.copy_path": "Copy path",
  "shortcuts.copy_id": "Copy id",
  "shortcuts.restore": "Restore from trash",
  "shortcuts.settings.reserved": "is taken by the browser before the page sees it, so it would do nothing here. Pick another key.",
  "shortcuts.settings.reserved_badge": "Desktop app only",
  "shortcuts.settings.reserved_title": "The browser handles this combination itself. It fires in the desktop app and in an installed PWA, not in a browser tab.",
  "cmd.tab_new": "Open a new tab",
  "cmd.split_toggle": "Toggle split view",
  "split.pane": "Secondary pane",
  "split.close": "Close the side pane",
  "split.error": "Could not load the listing",
  "split.retry": "Retry",
  "split.copy_queued": "Copy queued",
  "split.move_queued": "Move queued",
  "toast.move_kept_both": "Move queued. A name was already taken there, so that item will be kept beside the existing one with “-copy” added. This move cannot be undone.",
  "split.cross_copy": "Different storages - copy queued instead",
  "dragout.downloading": "Downloading into the folder you dropped on…",
  "dragout.downloading_n": "Downloading into the folder you dropped on - {n} files so far…",
  "dragout.downloading_n_one": "Downloading into the folder you dropped on - {n} file so far…",
  "dragout.stop": "Stop",
  "dragout.stopping": "Stopping…",
  "dragout.stopped": "Stopped - what had arrived stays in the folder",
  "dragout.not_found": "Could not find where it was dropped - a drop onto an application (rather than a folder) cannot be filled in",
  "dragout.done": "Download finished",
  "dragout.ready": "Files are ready - drag them to your desktop",
  "dragout.preparing": "Getting them ready to drag…",
  "split.cross_move": "Different storages - move queued (bytes travel, then the original is removed)",
  /* === /wiring:d1 === */
  /* wiring:d2 - gallery view */
  "toolbar.view.gallery": "Gallery",
  "gallery.aria": "File gallery",
  /* /wiring:d2 */
  /* wiring:d3 - inspector node comments */
  "inspector.section.comments": "Comments",
  "inspector.comments.empty": "No comments yet.",
  "inspector.comments.placeholder": "Write a comment…",
  "inspector.comments.send": "Send",
  "inspector.comments.delete": "Delete comment",
  /* wiring:e2 - end-to-end encrypted folders */
  "e2e.create.title": "Create encrypted folder",
  "e2e.create.option": "Create encrypted folder…",
  "e2e.create.pw_label": "Folder password",
  "e2e.create.pw_placeholder": "At least 8 characters",
  "e2e.create.pw2_label": "Repeat the password",
  "e2e.create.warn_title": "NO WAY BACK",
  "e2e.create.warn_body": "Files in this folder can only be opened with this password or the recovery key shown once when the folder is created. The password is NEVER stored on the server, and filex keeps no copy of the recovery key either. Lose both and the contents are gone for good.",
  "e2e.create.ack": "I understand: if I lose both the password and the recovery key, my data cannot be recovered.",
  "e2e.create.ack_required": "Please confirm the warning to continue.",
  "e2e.create.pw_short": "Password must be at least 8 characters.",
  "e2e.create.pw_mismatch": "Passwords do not match.",
  "e2e.create.bad_name": "Invalid folder name.",
  "e2e.create.create": "Create encrypted folder",
  "e2e.create.busy": "Creating…",
  "e2e.create.done": "Encrypted folder created",
  "e2e.create.failed": "Could not create the encrypted folder",
  "e2e.create.nested": "You cannot create an encrypted folder inside another one.",
  /* wiring:e2 policy - asking an administrator to allow one encryption
     (E2eRequestModal), where the tenant's policy wants an approval first. */
  "e2e.request.ctx": "Request encryption…",
  "e2e.request.option": "Request an encrypted folder…",
  "e2e.request.title": "Request encryption for “{name}”",
  "e2e.request.lead": "Making an encrypted folder here needs an administrator’s approval. Say why you need it; you will be told the answer. An approval is for you and this folder: it can be used once, to make one new encrypted folder directly inside it.",
  "e2e.request.lead_folder": "Encrypting this folder needs an administrator’s approval. Say why you need it; you will be told the answer. An approval is for you and this folder: it can be used once, to encrypt this folder where it is, and not a folder inside it.",
  "e2e.request.lead_file": "Encrypting this file needs an administrator’s approval. Say why you need it; you will be told the answer. An approval is for you and the folder this file is in: it can be used once, for one new encrypted file there.",
  "e2e.request.reason": "Reason",
  "e2e.request.reason_placeholder": "What it holds, and why it must be encrypted",
  "e2e.request.reason_required": "Write a reason for the administrator.",
  "e2e.request.send": "Send request",
  "e2e.request.sending": "Sending…",
  "e2e.request.sent": "Request sent. You will be notified when an administrator answers.",
  "e2e.request.already": "You already asked for this; it is waiting for an administrator.",
  "e2e.request.failed": "The request could not be sent.",
  "e2e.locked.title": "This folder is end-to-end encrypted",
  "e2e.locked.hint": "Enter the folder password to see its contents. The password stays in this tab’s memory only.",
  "e2e.locked.pw_placeholder": "Folder password",
  "e2e.locked.unlock": "Unlock",
  "e2e.locked.busy": "Verifying…",
  "e2e.unlock.wrong": "Wrong password.",
  "e2e.unlock.damaged": "The password is right, but the folder key in the key file (.filex-e2e.json) does not open: the file is damaged. Try the recovery key.",
  "e2e.unlock.marker_missing": "Could not read the key file (.filex-e2e.json).",
  /* ikon:emoji - the listing marker's accessible name. The row used to print
     a 🔒 and nothing else; the padlock that replaced it is aria-hidden inside
     the tile, so the span that carries it says this instead. */
  "e2e.badge": "Encrypted folder",
  "e2e.strip.label": "Encrypted folder - unlocked",
  "e2e.strip.lock": "Lock",
  /* wiring:e2 password - changing a folder's password */
  "e2e.password.strip_action": "Change password…",
  "e2e.password.title": "Change the folder password",
  "e2e.password.reset_title": "Set a new password for this folder",
  "e2e.password.reset_lead": "You opened this folder with its recovery key, so its password was lost or may be known to someone. Set a new one now. Closing this dialog locks the folder again.",
  "e2e.password.current": "Current password",
  "e2e.password.recovery": "Recovery key",
  "e2e.password.use_recovery": "I do not remember it - use the recovery key",
  "e2e.password.use_current": "Use the current password instead",
  "e2e.password.new": "New password",
  "e2e.password.current_required": "Enter the current password, or use the recovery key.",
  "e2e.password.bad_recovery": "That is not a recovery key (32 characters, in groups of four).",
  "e2e.password.same": "The new password is the same as the current one.",
  "e2e.password.cheap_note": "Only the folder’s key file changes. No file is re-encrypted, and the recovery key and any escrow key keep working.",
  "e2e.password.old_copies": "Someone who knows the old password and has an old copy of the key file (a version, a backup) can still open the folder with it. If that is a risk, tick “Also replace the folder key”.",
  "e2e.password.rotate_label": "Also replace the folder key (re-wraps every file’s key; use this if the old password may be known)",
  "e2e.password.rekey_title": "This folder is from before v0.31: its key comes from its password",
  "e2e.password.rekey_body": "A new password therefore needs a new folder key, and the key of every file in the folder is re-wrapped under it. The contents are not re-encrypted. It can take a while, and if it is interrupted it continues where it stopped; the files open throughout.",
  "e2e.password.rotate_title": "The folder key is replaced too",
  "e2e.password.rotate_body": "Every file’s key is re-wrapped under a new folder key. The contents are not re-encrypted. If it is interrupted it continues where it stopped; the files open throughout.",
  "e2e.password.rekey_rk_new": "You get a new recovery key, shown once; the old one stops working.",
  "e2e.password.rekey_rk_kept": "The recovery key you used keeps working.",
  "e2e.password.rekey_escrow": "The operator’s escrow key keeps working: its slot is sealed to the new folder key.",
  "e2e.password.rekey_ack": "I understand: this re-wraps the key of every file in the folder.",
  "e2e.password.submit": "Change password",
  "e2e.password.busy": "Changing…",
  "e2e.password.lock_instead": "Lock the folder instead",
  "e2e.password.wrong_current": "Wrong password.",
  "e2e.password.wrong_recovery": "Wrong recovery key.",
  "e2e.password.escrow_blocked": "This folder has an escrow slot for a key this installation does not have, and replacing the folder key would lose it. Nothing was changed.",
  "e2e.password.failed": "Could not change the password. Nothing was changed.",
  "e2e.password.done": "Password changed. The old password no longer opens this folder.",
  "e2e.password.resume_title": "File keys are still being re-wrapped",
  "e2e.password.resume_body": "The password was changed and a new folder key issued. Some files still have their key under the previous one; they open either way. Continue to finish.",
  "e2e.password.progress": "{n} files re-wrapped so far · {failed} failed",
  "e2e.password.progress_one": "{n} file re-wrapped so far · {failed} failed",
  "e2e.password.rekey_partial": "{n} files could not be re-wrapped. They still open with the previous key; continue to try again.",
  "e2e.password.rekey_partial_one": "{n} file could not be re-wrapped. It still opens with the previous key; continue to try again.",
  "e2e.password.rekey_done": "New folder key in place ({n} files re-wrapped). The old password opens nothing here any more.",
  "e2e.password.rekey_done_one": "New folder key in place ({n} file re-wrapped). The old password opens nothing here any more.",
  "e2e.recovery.lead_replaced": "The folder has a new key, so it has a new recovery key too - the old one no longer opens it. Shown once; filex keeps no copy.",
  /* wiring:e2 names - encrypted file and folder names */
  "e2e.unlock.unsupported": "This folder needs a newer filex: it uses {features}, which this version does not understand. Nothing was changed.",
  "e2e.settings.open": "Encryption settings…",
  "e2e.settings.title": "Encryption settings",
  "e2e.settings.level": "Encryption level",
  "e2e.settings.password": "Password",
  "e2e.settings.escrow": "Escrow key",
  "e2e.settings.close": "Close",
  "e2e.level.content": "Contents only",
  "e2e.level.names": "Contents and names",
  "e2e.level.content_hint": "File contents are encrypted. File and folder names stay readable to the server, so WebDAV, the command line and desktop sync keep working with them, and every filex since 0.31 opens the folder.",
  "e2e.level.names_hint": "Contents and file and folder names are encrypted: the server sees only scrambled names. WebDAV, the command line and desktop sync see them scrambled too, and filex 0.47 and older will not open the folder.",
  "e2e.level.pending": "the change of level has not finished",
  "e2e.level.change": "Change level…",
  "e2e.level.raise_title": "Move this folder to “Contents and names”?",
  "e2e.level.raise_body": "filex gives every file and folder in here an encrypted name, in this browser. The contents are not touched, and if it is interrupted it continues where it stopped. filex does not offer the way back to readable names.",
  "e2e.level.raise_ack": "I understand what changes",
  "e2e.level.raise_go": "Encrypt the names",
  /* wiring:e2 vault - level 3, the vault (docs/E2E-VAULT-FORMAT.md) */
  "e2e.level.vault": "Vault",
  "e2e.level.vault_hint": "Contents, names and the whole tree are encrypted: the server keeps only packs of one size, and does not see how many files there are, their names, their sizes or their dates.",
  "e2e.level.vault_cost": "What it costs: one person writes at a time, and only filex opens it (the web app, the desktop app, filex decrypt and filex vault mount). WebDAV, folder sync, share links and previews on the server do not reach inside.",
  "e2e.vault.pack_label": "Pack size",
  "e2e.vault.pack_4": "4 MiB",
  "e2e.vault.pack_4_help": "The default. The smallest change uploads 4 MiB.",
  "e2e.vault.pack_16": "16 MiB",
  "e2e.vault.pack_16_help": "Fewer, larger files on the server. Every change uploads at least 16 MiB.",
  "e2e.vault.pack_hint": "Chosen now and never again. Every pack on the server is this size, and what it does not use is filled with random bytes.",
  "e2e.vault.read_only": "Read-only. An upload, a new folder or any other change takes the write lock, when nobody else holds it.",
  "e2e.vault.writing": "You are writing to this vault. If you do nothing for {left}, it goes back to read-only.",
  "e2e.vault.lock_countdown": "If nothing is done in it for {left}, the vault locks and asks for the password again.",
  "e2e.vault.held_by": "{name} has been writing since {since}. The vault is read-only for you.",
  "e2e.vault.someone": "Someone",
  "e2e.vault.take_over": "Take over",
  "e2e.vault.lost_idle": "You did nothing for {n} minutes, so this vault went back to read-only. Nothing was lost.",
  "e2e.vault.lost_idle_one": "You did nothing for {n} minute, so this vault went back to read-only. Nothing was lost.",
  "e2e.vault.lost_taken": "Someone else took over writing. What you saved stays; the vault is read-only for you.",
  "e2e.vault.lost_taken_by": "{name} took over writing. What you saved stays; the vault is read-only for you.",
  "e2e.vault.lost_broken_by": "{name} ended your write lock. What you saved stays; the vault is read-only for you.",
  "e2e.vault.lost_connection": "The connection was lost, so this vault went back to read-only.",
  "e2e.vault.lost_expired": "The write lock ran out, so this vault went back to read-only.",
  "e2e.vault.unsaved": "Not saved: {names}. Do it again when the vault is free.",
  "e2e.vault.saving": "Saving…",
  "e2e.vault.saving_progress": "Saving: {done} of {total}",
  "e2e.vault.dismiss": "OK",
  "e2e.vault.continue": "Continue from this state",
  "e2e.vault.ro_damaged": "The newest state of this vault is damaged. You are looking at the one from {when}, read-only.",
  "e2e.vault.ro_damaged_short": "The newest state of this vault is damaged. You are looking at an older one, read-only.",
  "e2e.vault.ro_rollback": "The server offers an older state of this vault than this tab has already seen. It stays read-only here.",
  "e2e.vault.ro_newer": "A newer filex wrote this vault. This version reads it and does not change it.",
  "e2e.vault.unreadable": "No state of this vault can be read: nothing can be shown, and nothing is written.",
  "e2e.vault.limit_warn": "This vault holds {held} of at most {max} files and folders.",
  "e2e.vault.cross": "Nothing moves between a vault and the folders outside it on the server: download it from one, then upload it into the other.",
  "e2e.vault.dl_too_big": "This browser cannot save a file this large from memory. Use a browser that saves straight to disk (Chrome, Edge), or filex decrypt.",
  "e2e.vault.damaged_file": "This file is damaged in the vault and could not be read.",
  "e2e.vault.level_fixed": "A vault stays a vault: its level does not change and its key is not replaced. To start again with a new key, make a new vault and move the files into it.",
  "e2e.vault.locked_idle_toast": "Nothing was done in “{name}” for 15 minutes, so the vault locked itself. Enter the password to open it again.",
  "e2e.vault.open_failed": "The vault could not be opened.",
  "e2e.vault.err.parent_missing": "The folder it was going into is not there any more.",
  "e2e.vault.err.parent_not_folder": "“{name}” is a file, not a folder.",
  "e2e.vault.err.name_taken": "“{name}” is already taken there.",
  "e2e.vault.err.bad_name": "“{name}” cannot be a name in a vault: 1 to 255 bytes, without slashes or control characters, and not . or ..",
  "e2e.vault.err.too_deep": "Folders in a vault go at most 256 deep.",
  "e2e.vault.err.not_found": "“{name}” is not in the vault any more.",
  "e2e.vault.err.is_folder": "“{name}” is a folder.",
  "e2e.vault.err.into_itself": "A folder cannot go into itself.",
  "e2e.vault.err.too_many_entries": "This vault is full: it holds at most 250 000 files and folders. Nothing was changed.",
  "e2e.vault.err.index_too_large": "This vault's index has reached its limit. Nothing was changed.",
  "e2e.vault.err.newer_format": "A newer filex wrote this vault. This version reads it and does not change it.",
  "e2e.vault.err.size_mismatch": "A file changed while it was being uploaded. Upload it again.",
  "e2e.vault.err.changed": "“{name}” changed in the vault since it was opened, so it was not saved over. Open it again to see the newer version.",
  "e2e.vault.err.failed": "The change could not be saved.",
  "userSettings.vault.idle": "Vault: back to read-only after",
  "userSettings.vault.idle_help": "How long a vault you write to stays yours while you do nothing in it. Then others may write; your vault goes back to read-only, and 15 minutes later it locks.",
  "userSettings.vault.minutes": "{n} minutes",
  "userSettings.vault.minutes_one": "{n} minute",
  "userSettings.vault.saved": "Saved",
  "userSettings.vault.failed": "Could not save the vault setting.",
  "e2e.names.move_unreadable": "Not moved: the name of one of the items cannot be read.",
  "e2e.names.move_taken": "Not moved: “{name}” is already taken in that folder. Rename one of the two first.",
  "e2e.convert.ctx": "Encrypt with E2EE…",
  "e2e.convert.title": "Encrypt “{name}”",
  "e2e.convert.lead": "Every file in this folder is encrypted where it is, in this browser, with the password below. Nothing moves; at level 1 the names stay as they are. If it is interrupted, opening the folder again continues it.",
  "e2e.convert.past_title": "What the server already has",
  "e2e.convert.past_body": "Encrypting protects these files from now on. Until now the server has had them in the clear, and some copies remain: filex drops its thumbnails and the text it extracted for search, and can delete older versions and trash entries from this folder.",
  "e2e.convert.drop_versions": "Delete the older versions of these files (they are plaintext)",
  "e2e.convert.drop_trash": "Delete the trash entries that came from this folder",
  "e2e.convert.past_outside": "Backups, replicas and copies anyone already made are outside filex and stay as they are.",
  "e2e.convert.submit": "Encrypt folder",
  "e2e.convert.nested": "This folder holds an encrypted folder. Encrypted folders cannot be nested, so nothing was changed.",
  "e2e.convert.failed": "The folder could not be encrypted. Files already encrypted stay so; open the folder to continue.",
  "e2e.convert.stopped": "Stopped after {n} files. Continue from the strip above the folder.",
  "e2e.convert.stopped_one": "Stopped after {n} file. Continue from the strip above the folder.",
  "e2e.convert.partial": "{n} files could not be encrypted (changed meanwhile, too large, or not writable). They are still plaintext; try again to continue.",
  "e2e.convert.partial_one": "{n} file could not be encrypted (changed meanwhile, too large, or not writable). It is still plaintext; try again to continue.",
  "e2e.convert.too_large_here": "{n} files are too large for this browser to send in one piece, and this server takes no upload in pieces, so they could not be encrypted where they are. They are still plaintext, and the folder stays unfinished until they are encrypted.",
  "e2e.convert.too_large_here_one": "{n} file is too large for this browser to send in one piece, and this server takes no upload in pieces, so it could not be encrypted where it is. It is still plaintext, and the folder stays unfinished until it is encrypted.",
  "e2e.convert.large_progress": "Encrypting “{name}”: {percent}%",
  "e2e.convert.busy": "Encrypting the folder…",
  "e2e.convert.resume_title": "Finish encrypting this folder",
  "e2e.convert.resume_body": "Encrypting this folder started and did not finish. Files it has not reached yet are still plaintext on the server. Continuing picks up where it stopped.",
  "e2e.convert.progress": "{n} of {total} files encrypted · {failed} not done",
  "e2e.convert.progress_one": "{n} of {total} files encrypted · {failed} not done",
  "e2e.convert.done": "Folder encrypted ({n} files). Old versions deleted: {versions}; trash entries deleted: {trash}.",
  "e2e.convert.done_one": "Folder encrypted ({n} file). Old versions deleted: {versions}; trash entries deleted: {trash}.",
  "e2e.convert.cleanup_failed": "The folder is encrypted, but its old versions and trash entries could not be deleted - only the folder’s owner or an administrator can.",
  "e2e.names.locked_item": "🔒 Encrypted item",
  "e2e.names.unreadable_item": "🔒 Unreadable name",
  "e2e.names.key_failed": "The key file says the names in this folder are encrypted, but their key does not open with this one. Nothing was changed.",
  "e2e.names.write_failed": "Could not write the name file of a long name, so nothing was uploaded.",
  "e2e.names.bad_name": "“{name}” cannot be used in an encrypted folder: a name must be 1-255 bytes, with no slash, backslash or control character.",
  "e2e.names.offer_cost": "What changes: WebDAV, the command line and desktop sync will see scrambled names, and filex 0.47 and older will refuse to open this folder. The server still sees how many items there are and how big they are.",
  "e2e.names.resume_title": "Finish encrypting the names",
  "e2e.names.resume_body": "Encrypting the names in this folder started and did not finish. Items it has not reached yet still have readable names. Continuing picks up where it stopped.",
  "e2e.names.resume": "Continue",
  "e2e.names.stop": "Stop",
  "e2e.names.busy": "Encrypting names…",
  "e2e.names.progress": "{n} names encrypted so far · {failed} could not be renamed",
  "e2e.names.progress_one": "{n} name encrypted so far · {failed} could not be renamed",
  "e2e.names.done": "Names encrypted ({n} items renamed). The server no longer sees them.",
  "e2e.names.done_one": "Names encrypted ({n} item renamed). The server no longer sees them.",
  "e2e.names.stopped": "Stopped after {n} names. The rest keep their readable names until you continue.",
  "e2e.names.stopped_one": "Stopped after {n} name. The rest keep their readable names until you continue.",
  "e2e.names.partial": "{n} items could not be renamed (no permission, or a name a disk cannot hold). Their names stay readable; try again to continue.",
  "e2e.names.partial_one": "{n} item could not be renamed (no permission, or a name a disk cannot hold). Its name stays readable; try again to continue.",
  "e2e.names.failed": "Could not encrypt the names. Nothing already renamed is lost; try again to continue.",
  "e2e.names.strip_fix": "Fix {n} names (readable, or moved in from outside filex)",
  "e2e.names.strip_fix_one": "Fix {n} name (readable, or moved in from outside filex)",
  "e2e.create.names_root_hint": "The folder’s own name stays readable either way - it sits in a folder that is not encrypted. Pick a name that gives nothing away.",
  "e2e.locked_toast": "Folder locked",
  "e2e.app_closed_unsaved": "The changes to “{name}” that were not saved are gone: the app closed when the folder locked.",
  "e2e.upload.locked": "Unlock the folder first",
  "e2e.decrypting": "Decrypting…",
  "e2e.decrypt_failed": "Could not decrypt the file (password changed or file corrupted).",
  /* wiring:e2 recovery - recovery keys + operator escrow */
  "e2e.create.escrow_title": "This server holds a second key",
  "e2e.create.escrow_body": "Key escrow is enabled on this installation, so its operator can open this folder without your password. Using that key notifies you. Escrow is fixed when the server is installed and cannot be turned off for a folder.",
  "e2e.locked.use_recovery": "Lost the password? Use a recovery key",
  "e2e.recovery.title": "Save your recovery key",
  "e2e.recovery.title_upgraded": "Your recovery key",
  "e2e.recovery.lead": "This key opens the folder without its password. It is shown once - filex does not store it and cannot show it again.",
  "e2e.recovery.lead_upgraded": "This folder now has a recovery key. It opens the folder without its password, is shown once, and is not stored by filex.",
  "e2e.recovery.copy": "Copy",
  "e2e.recovery.copied": "Copied",
  "e2e.recovery.download": "Download as a file",
  "e2e.recovery.warn_title": "TREAT THIS LIKE A PASSWORD",
  "e2e.recovery.warn_body": "Anyone holding this key can read the folder. Keep it somewhere separate from the password - a key stored next to the password protects you from forgetting, not from anyone else.",
  "e2e.recovery.escrow_title": "This server also holds a key",
  "e2e.recovery.escrow_body": "Key escrow is enabled here, so the operator of this installation can open this folder without your password. You are notified when that key is used.",
  "e2e.recovery.escrow_kid": "Escrow key",
  "e2e.recovery.ack": "I have saved this key somewhere safe.",
  "e2e.recovery.done": "Done",
  "e2e.recover.title": "Unlock without the password",
  "e2e.recover.none": "This folder was created before recovery keys existed, so it has none. Its password is the only way in. Unlock it with the password once and filex will offer to add a recovery key.",
  "e2e.recover.tab_recovery": "Recovery key",
  "e2e.recover.tab_escrow": "Escrow key",
  "e2e.recover.recovery_hint": "The key shown once when this folder was created.",
  "e2e.recover.recovery_placeholder": "XXXX-XXXX-XXXX-XXXX-XXXX-XXXX-XXXX-XXXX",
  "e2e.recover.escrow_warn_title": "The owner will be told",
  "e2e.recover.escrow_warn_body": "Opening a folder with the escrow key notifies its owner. Use it only when you are entitled to.",
  "e2e.recover.escrow_kid": "Escrow key",
  "e2e.recover.escrow_predates": "This installation has an escrow key, but this folder does not. It was created before escrow was turned on here, so its master key was never wrapped to the escrow identity. The escrow key will not open it. Nothing the operator can do changes that - adding a slot needs this folder’s password, which the server has never had. The folder’s owner can grant it: unlock with the password, then choose to give the operator a key. Until they do, use the password or the recovery key.",
  "e2e.recover.escrow_other_key": "This folder carries an escrow key from a DIFFERENT installation. It was created elsewhere and restored here, so this installation’s escrow key does not open it. Only the private key belonging to the escrow key it was sealed to can.",
  "e2e.recover.escrow_placeholder": "Paste the escrow private key (PKCS#8, base64 or PEM)",
  "e2e.recover.bad_format": "That does not look like a recovery key. It is 32 characters in eight groups of four.",
  "e2e.recover.escrow_required": "Paste the escrow private key.",
  "e2e.recover.wrong_recovery": "That recovery key does not open this folder.",
  "e2e.recover.wrong_escrow": "That escrow key does not open this folder. A folder created before escrow was turned on has no escrow slot until its owner grants one - until then, use the password or the recovery key.",
  "e2e.recover.bad_escrow_key": "That is not a readable private key (expected PKCS#8, base64 or PEM).",
  "e2e.recover.notify_failed": "Could not notify the folder owner, so the folder was not unlocked. Escrow use is always announced.",
  "e2e.recover.recovery_done": "Unlocked with the recovery key",
  "e2e.recover.escrow_done": "Unlocked with the escrow key - the owner has been notified",
  "e2e.recover.unlock": "Unlock",
  "e2e.recover.busy": "Unlocking…",
  "e2e.escrowoffer.title": "Give the operator a key to this folder?",
  "e2e.escrowoffer.body": "This folder was created before key escrow was turned on here, so the operator of this installation cannot open it. Right now - while your password is in memory - filex can seal this folder to the escrow key. Your files are not re-encrypted or moved; only the key file changes.",
  "e2e.escrowoffer.consequence": "What this means: the operator gains a second, permanent way into this folder, without your password. You are notified when that key is used, but that notification is an announcement rather than a control.",
  "e2e.escrowoffer.learn_more": "What escrow can and cannot do",
  "e2e.escrowoffer.password_label": "Folder password",
  "e2e.escrowoffer.password_required": "Enter the folder password.",
  "e2e.escrowoffer.wrong_password": "That is not this folder’s password.",
  "e2e.escrowoffer.accept": "Give the operator a key",
  "e2e.escrowoffer.decline": "No, keep it to myself",
  "e2e.escrowoffer.cancel": "Cancel",
  "e2e.escrowoffer.busy": "Sealing…",
  "e2e.escrowoffer.done": "The operator can now open this folder with the escrow key",
  "e2e.escrowoffer.declined_toast": "Kept to yourself. filex will not ask again for this folder.",
  "e2e.escrowoffer.decline_failed": "Could not record your answer, so filex will ask again next time. Nothing about the folder changed.",
  "e2e.escrowoffer.failed": "Could not give the operator a key to this folder",
  "e2e.escrowoffer.strip_action": "Escrow key…",
  "e2e.upgrade.title": "This folder has no recovery key",
  "e2e.upgrade.body": "It was created before recovery keys existed, so its password is the only way in. Right now - and only right now, while the password is in memory - filex can add one. Your files are not re-encrypted or moved.",
  "e2e.upgrade.escrow_note": "Note: this installation has key escrow enabled, so adding a recovery key also lets its operator open this folder without your password.",
  "e2e.upgrade.accept": "Create a recovery key",
  "e2e.upgrade.decline": "Not now",
  "e2e.upgrade.busy": "Creating…",
  "e2e.upgrade.failed": "Could not add a recovery key to this folder",
  "e2e.download.failed": "Could not download the encrypted file.",
  /* /wiring:e2 */
  /* ── connections: storage config + "how to connect" ──────────────
     `storages.*` keys are the ones the BACKEND's driver descriptors
     name (each driver package declares one next to its Init). They are
     kept identical to web/src/locales/*.json on purpose: the same
     descriptor is rendered on both surfaces, so a field that reads
     "Base path" in the admin panel and something else in the desktop
     app would be the same drift this whole mechanism exists to stop. */
  "conn.title": "Connections",
  "conn.subtitle": "How to reach {host} from your own computer: mount it, or point a client at it.",
  "conn.close": "Close",
  "conn.list.disabled": "Disabled",
  "conn.form.required": "Required",
  "conn.form.advanced": "Advanced settings",
  /* A two-button decision's own words, when the declaration did not name them. */
  "conn.form.yes": "Yes",
  "conn.form.no": "No",
  "conn.form.noFields": "This server did not describe any settings for this driver.",
  "conn.form.reveal": "Show",
  "conn.form.hide": "Hide",
  "conn.guide.protocol": "Protocol",
  "conn.guide.storage": "Storage",
  "conn.guide.allStorages": "All storages",
  "conn.guide.copy": "Copy",
  "conn.guide.copied": "Copied",
  "conn.guide.goodToKnow": "Good to know",
  "conn.guide.userPlaceholder": "your-email@example.com",
  "conn.guide.secretPlaceholder": "your-password-or-api-key",
  "conn.guide.fact.url": "Address",
  "conn.guide.fact.urlRootHint": "Every storage you can see appears as a folder under this address.",
  "conn.guide.fact.urlStorageHint": "Mounts “{storage}” directly. Drop the last segment to see every storage.",
  "conn.guide.fact.user": "Username",
  "conn.guide.fact.password": "Password",
  "conn.guide.webdav.summary": "WebDAV mounts filex as a drive: Windows Explorer, macOS Finder, Linux, rclone and Cyberduck all speak it, and every change is mirrored back into filex.",
  "conn.guide.webdav.userHint": "Your username or your email - not your display name.",
  "conn.guide.webdav.passwordHint": "Your account password, or an API key (API keys, in the navigation panel). An account with two-factor authentication MUST use an API key: Basic auth has no second-factor slot.",
  "conn.guide.webdav.win.s1": "Open File Explorer, right-click This PC and choose “Map network drive…”.",
  "conn.guide.webdav.win.s2": "Pick a drive letter and enter {url} as the folder.",
  "conn.guide.webdav.win.s3": "Tick “Connect using different credentials” and sign in with the username and password above.",
  "conn.guide.webdav.win.cmdCaption": "Command Prompt (same thing, without the wizard)",
  "conn.guide.webdav.win.limits": "Windows has three built-in limits that look exactly like filex bugs: transfers stop at ~47.7 MB, folders with about a thousand files refuse to open (“Disk is not formatted”), and the WebClient service must be restarted after changing either.",
  "conn.guide.webdav.win.regCaption": "Run as administrator, then reconnect the drive",
  "conn.guide.webdav.win.https": "HTTPS is mandatory. Windows sends Basic credentials over TLS only, and over plain http:// it silently refuses with no useful message. Do not set BasicAuthLevel to 2 - use TLS.",
  "conn.guide.webdav.win.persist": "The mapped drive does not survive a sign-out: since Windows 7 Basic credentials cannot be stored in Credential Manager, and /persistent:yes does not change that. Re-run the command from a logon script if you need it back automatically.",
  "conn.guide.webdav.win.service": "If nothing mounts at all, make sure the WebClient service is running: sc config WebClient start= auto && net start WebClient.",
  "conn.guide.webdav.mac.s1": "In Finder choose Go → Connect to Server… (⌘K).",
  "conn.guide.webdav.mac.s2": "Enter {url} and connect.",
  "conn.guide.webdav.mac.s3": "Authenticate with the username and password above.",
  "conn.guide.webdav.mac.note": "The drive appears under Locations; each storage is a top-level folder.",
  "conn.guide.webdav.linux.mountCaption": "davfs2, or the desktop file manager (GNOME Files, Dolphin)",
  "conn.guide.webdav.linux.gvfsComment": "or paste this address into GNOME Files / Dolphin",
  "conn.guide.webdav.linux.locks": "davfs2 needs locking turned off. filex keeps WebDAV locks in process memory, so they do not survive a restart and are not shared between replicas - davfs2 assumes otherwise and hangs.",
  "conn.guide.webdav.rclone.obscureCaption": "rclone stores an obscured password - run this first and paste the output below",
  "conn.guide.webdav.rclone.passPlaceholder": "<output of rclone obscure>",
  "conn.guide.webdav.rclone.useCaption": "Using it",
  "conn.guide.webdav.duck.s1": "New Bookmark → WebDAV (HTTPS).",
  "conn.guide.webdav.duck.s2": "Server {host}, port 443.",
  "conn.guide.webdav.duck.s3": "Path {path}.",
  "conn.guide.webdav.duck.s4": "Username {user}, password as above.",
  "conn.guide.webdav.note.delete": "A WebDAV delete is permanent. The web UI moves files to the filex trash; a client delete removes the object from the backing storage directly.",
  "conn.guide.webdav.note.locks": "Locks live in server memory: they do not survive a restart and are not shared between replicas. They exist to satisfy Windows and Office, not to arbitrate concurrent edits.",
  "conn.guide.webdav.note.permissions": "You see exactly what you see in the web UI. The root lists only the storages you may open, and a path outside your grants answers 404 rather than 403, so the tree never leaks what exists.",
  "conn.guide.webdav.note.http": "This server is reachable over plain http://. Windows will refuse to send your credentials at all, and every other client sends your password in the clear. Put filex behind TLS before mounting it.",
  // ── S3 endpoint: keys and the guide ──────────────────────────────
  "conn.s3keys.title": "S3 access keys",
  "conn.s3keys.lead": "An access key lets any S3 client - rclone, restic, the AWS CLI, mc, s3fs, Cyberduck - connect to filex. It carries your own permissions and nothing more.",
  "conn.s3keys.disabled": "The S3 endpoint is switched off on this server (FILEX_S3). A key minted here will not connect until an operator turns it back on.",
  "conn.s3keys.cannotMint": "You are not signed in with an account that can mint access keys. The instructions below still apply - ask for a key and paste it in.",
  "conn.s3keys.label": "What is it for? (laptop backup, CI, …)",
  "conn.s3keys.defaultLabel": "access key",
  "conn.s3keys.everyBucket": "Every bucket I can see",
  "conn.s3keys.prefix": "Folder inside the bucket (optional)",
  "conn.s3keys.mint": "Create key",
  "conn.s3keys.inheritNote": "A key can only ever narrow what you already have: your grants and your role. Confining it to one bucket or folder is the difference between a laptop backup and a credential that can read everything.",
  "conn.s3keys.once": "Copy the secret now - this is the only time it is shown.",
  "conn.s3keys.accessKeyID": "Access key ID",
  "conn.s3keys.secret": "Secret key",
  "conn.s3keys.dismiss": "I have copied it",
  "conn.s3keys.col.label": "Label",
  "conn.s3keys.col.key": "Access key ID",
  "conn.s3keys.col.scope": "Limited to",
  "conn.s3keys.col.lastUsed": "Last used",
  "conn.s3keys.scopeAll": "everything you can see",
  "conn.s3keys.noLabel": "(no label)",
  "conn.s3keys.neverUsed": "never",
  "conn.s3keys.enable": "Enable",
  "conn.s3keys.disable": "Disable",
  "conn.s3keys.revoke": "Revoke",
  "conn.s3keys.confirm": "Sure?",
  "conn.s3keys.empty": "No access keys yet.",
  "conn.guide.s3.summary": "The S3 endpoint makes filex the destination for anything that speaks S3 - backups, sync tools, SDKs - using the storages you already have.",
  "conn.guide.s3.keyPlaceholder": "create a key above",
  "conn.guide.s3.secretPlaceholder": "shown once, when you create the key",
  "conn.guide.s3.fact.endpoint": "Endpoint",
  "conn.guide.s3.fact.endpointHint": "Point the client here, not at the web address of filex.",
  "conn.guide.s3.fact.bucket": "Bucket",
  "conn.guide.s3.fact.bucketHint": "A bucket is a filex storage. Buckets are created by an administrator, not by the client.",
  "conn.guide.s3.fact.key": "Access key ID",
  "conn.guide.s3.fact.keyHint": "The public half. It travels in every request.",
  "conn.guide.s3.fact.secret": "Secret key",
  "conn.guide.s3.fact.secretHint": "Shown once, when the key is created. filex cannot show it again - create a new key if it is lost.",
  "conn.guide.s3.fact.region": "Region",
  "conn.guide.s3.fact.regionHint": "filex has no regions; any value works and is echoed back. Clients still insist on one.",
  "conn.guide.s3.fact.addressing": "Addressing",
  "conn.guide.s3.fact.pathStyle": "path-style (required)",
  "conn.guide.s3.fact.pathStyleHint": "There is no dedicated S3 host on this install, so bucket.host does not resolve.",
  "conn.guide.s3.fact.virtualHosted": "virtual-hosted or path-style",
  "conn.guide.s3.fact.virtualHostedHint": "This install has its own S3 host, so both styles work.",
  "conn.guide.s3.rclone.useCaption": "Use it",
  "conn.guide.s3.rclone.mtime": "filex carries the file modification time (x-amz-meta-mtime), so rclone sync settles after the first run instead of re-uploading everything.",
  "conn.guide.s3.aws.configureCaption": "Configure once",
  "conn.guide.s3.aws.useCaption": "Use it",
  "conn.guide.s3.aws.pathStyle": "Add path addressing to your AWS config, or every command fails at DNS.",
  "conn.guide.s3.restic.envCaption": "Environment",
  "conn.guide.s3.restic.useCaption": "Back up, verify, prune",
  "conn.guide.s3.restic.verified": "Verified against this endpoint: restic check --read-data reads every pack byte for byte and reports no errors.",
  "conn.guide.s3.mc.aliasCaption": "Add the alias",
  "conn.guide.s3.mc.useCaption": "Use it",
  "conn.guide.s3.s3fs.credsCaption": "Credentials file",
  "conn.guide.s3.s3fs.mountCaption": "Mount it",
  "conn.guide.s3.s3fs.note": "Editing a file over s3fs rewrites the whole object, and a delete goes to the filex trash. Good for a shared folder, not for a database.",
  "conn.guide.s3.duck.s1": "New bookmark → Amazon S3.",
  "conn.guide.s3.duck.s2": "Server: {host}.",
  "conn.guide.s3.duck.s3": "Access key ID: {key}, secret as above.",
  "conn.guide.s3.duck.s4": "Open the bookmark; the buckets are your filex storages.",
  "conn.guide.s3.duck.pathStyle": 'In Preferences → S3, turn OFF "Use virtual host style" - this install has no wildcard S3 host.',
  "conn.guide.s3.sdk.note": "Any SigV4 client works the same way: endpoint, key, secret, and path addressing when this install has no S3 host of its own.",
  "conn.guide.s3.note.buckets": "A bucket is a filex storage. A client can create folders and objects inside one, but not the bucket itself - that needs a driver and a path, which an S3 request cannot express.",
  "conn.guide.s3.note.permissions": 'The key sees exactly what you see. A bucket you may not open answers "no such bucket" rather than "forbidden", so the endpoint never reveals what exists.',
  "conn.guide.s3.note.trash": "A delete goes to the filex trash, the same as everywhere else, and is recoverable until the retention policy sweeps it.",
  "conn.guide.s3.note.mtime": "Uploads carry their modification time, and the checksums clients send (Content-MD5, x-amz-checksum-*) are verified - a corrupted upload is refused rather than stored.",
  "conn.guide.s3.note.pathStyle": "This install has no dedicated S3 host, so clients must be told to use path-style addressing. Without it a current SDK fails at DNS with an error that names neither filex nor the cause.",
  "conn.guide.s3.note.http": "This endpoint is plain http://. Signatures still protect the request, but the objects travel in the clear. Put filex behind TLS before pointing a backup at it.",
  // ── SFTP endpoint: keys and the guide ────────────────────────────
  "conn.sshkeys.title": "SSH keys",
  "conn.sshkeys.lead": "Register a public key and every SSH client - sftp, scp, WinSCP, FileZilla, rclone, sshfs - can connect without sending your password.",
  "conn.sshkeys.disabled": "The SFTP endpoint is switched off on this server (FILEX_SFTP). A key registered here will not connect until an operator turns it back on.",
  "conn.sshkeys.cannotAdd": "You are not signed in with an account that can register keys.",
  "conn.sshkeys.paste": "Paste the contents of ~/.ssh/id_ed25519.pub",
  "conn.sshkeys.name": "Name (optional - the key comment is used otherwise)",
  "conn.sshkeys.add": "Add key",
  "conn.sshkeys.noCopyId": "ssh-copy-id cannot work here: it appends to ~/.ssh/authorized_keys over a shell, and filex has none. This box is the way in.",
  "conn.sshkeys.col.name": "Name",
  "conn.sshkeys.col.fingerprint": "Fingerprint",
  "conn.sshkeys.col.added": "Added",
  "conn.sshkeys.col.lastUsed": "Last used",
  "conn.sshkeys.noName": "(no name)",
  "conn.sshkeys.neverUsed": "never",
  "conn.sshkeys.enable": "Enable",
  "conn.sshkeys.disable": "Disable",
  "conn.sshkeys.remove": "Remove",
  "conn.sshkeys.confirm": "Sure?",
  "conn.sshkeys.empty": "No keys yet. Without one, clients sign in with your account password.",
  "conn.guide.sftp.summary": "SFTP makes filex reachable by anything that already speaks SSH - a backup job, a scanner, WinSCP, rclone, or a mounted folder.",
  "conn.guide.sftp.fact.host": "Host",
  "conn.guide.sftp.fact.hostHint": "The same machine as the web app, on a port of its own.",
  "conn.guide.sftp.fact.port": "Port",
  "conn.guide.sftp.fact.portHint": "Not 22 and not 443: SFTP is raw TCP and cannot go through the web proxy.",
  "conn.guide.sftp.fact.userHint": "Your username. An @ in it would have to be quoted in most client config files, which is what the username avoids.",
  "conn.guide.sftp.fact.auth": "Sign in with",
  "conn.guide.sftp.fact.authKey": "your registered SSH key (or your password)",
  "conn.guide.sftp.fact.authPassword": "your account password - or register a key above",
  "conn.guide.sftp.fact.authHint": "An API key works as a password too, and is revocable on its own. An account with two-factor sign-in must use an SSH key or an API key.",
  "conn.guide.sftp.fact.path": "Path",
  "conn.guide.sftp.fact.pathHint": "The first folder is a storage; the root lists the ones you may open.",
  "conn.guide.sftp.openssh.connectCaption": "Connect, put, get",
  "conn.guide.sftp.openssh.noShell": "There is no shell here - only the SFTP subsystem. `ssh host command` is refused on purpose, and scp works because OpenSSH 9 speaks SFTP for it.",
  "conn.guide.sftp.key.tab": "Set up a key",
  "conn.guide.sftp.key.s1": "Generate a key pair on the machine that will connect (skip if you already have one).",
  "conn.guide.sftp.key.s2": "Copy the PUBLIC half - the .pub file, never the other one.",
  "conn.guide.sftp.key.s3": "Paste it into the box above and connect; no password is sent from then on.",
  "conn.guide.sftp.key.genCaption": "On your own machine",
  "conn.guide.sftp.key.noCopyId": "ssh-copy-id will NOT work against filex: it needs a shell to append to ~/.ssh/authorized_keys, and there is none. Paste the key above instead.",
  "conn.guide.sftp.winscp.s1": "New site → File protocol: SFTP.",
  "conn.guide.sftp.winscp.s2": "Host name: {host}, port: {port}.",
  "conn.guide.sftp.winscp.s3": "User name: {user}. For a key: Advanced → SSH → Authentication → private key file.",
  "conn.guide.sftp.winscp.s4": "WinSCP needs a .ppk private key - use its own tool (Tools → PuTTYgen) to convert an OpenSSH key once.",
  "conn.guide.sftp.filezilla.s1": "File → Site Manager → New site, Protocol: SFTP.",
  "conn.guide.sftp.filezilla.s2": "Host: {host}, port: {port}.",
  "conn.guide.sftp.filezilla.s3": "User: {user}. Logon type: Normal for a password, or Key file for a key.",
  "conn.guide.sftp.rclone.useCaption": "Use it",
  "conn.guide.sftp.sshfs.mountCaption": "Mount and unmount",
  "conn.guide.sftp.sshfs.note": "A mounted folder rewrites the whole file on every save. Good for documents, not for a database or a video you are editing in place.",
  "conn.guide.sftp.note.storages": "The root is not a home directory: it lists the storages you may open, and the first path segment names one.",
  "conn.guide.sftp.note.permissions": "The permission bits your client draws come from your access level here, so a file shown as read-only really is one for you.",
  "conn.guide.sftp.note.trash": "A delete goes to the filex trash, the same as everywhere else, and is recoverable until the retention policy sweeps it.",
  "conn.guide.sftp.note.totp": "If your account has two-factor sign-in, the password will not work here - SSH has no way to ask for the code. Register an SSH key, or use an API key as the password.",
  "conn.guide.sftp.note.disabled": "The SFTP endpoint is switched off on this server. These instructions will work once an operator enables it.",
  // ── FTPS ─────────────────────────────────────────────────────────
  "conn.guide.ftps.summary": "FTPS is here for the equipment that only ever learned FTP - scan-to-folder printers, EDI counterparties, older lab and industrial software. Always over TLS.",
  "conn.guide.ftps.fact.host": "Host",
  "conn.guide.ftps.fact.hostHint": "The same machine as the web app, on a port of its own.",
  "conn.guide.ftps.fact.port": "Port",
  "conn.guide.ftps.fact.portHint": "The control channel. Data moves on a separate port from the passive range below.",
  "conn.guide.ftps.fact.mode": "Encryption",
  "conn.guide.ftps.fact.modeValue": "FTPS - explicit TLS (AUTH TLS), required",
  "conn.guide.ftps.fact.modeHint": 'Plain FTP is refused before the password is read. Choose "Require explicit FTP over TLS", never "plain FTP" and never "implicit".',
  "conn.guide.ftps.fact.userHint": "Your username, or your email. An API key works as the password too and can be revoked on its own.",
  "conn.guide.ftps.fact.passwordHint": "Your account password, or an API key. An account with two-factor sign-in must use an API key - FTP has no way to ask for the code.",
  "conn.guide.ftps.fact.pasv": "Passive ports",
  "conn.guide.ftps.fact.pasvHint": "Data connections land here. If your firewall blocks this range the transfer HANGS with no error on either side - that is the classic FTP failure.",
  "conn.guide.ftps.filezilla.s1": "File → Site Manager → New site, Protocol: FTP.",
  "conn.guide.ftps.filezilla.s2": "Host: {host}, port: {port}.",
  "conn.guide.ftps.filezilla.s3": 'Encryption: "Require explicit FTP over TLS". Logon type: Normal, user: {user}.',
  "conn.guide.ftps.filezilla.s4": "Transfer settings → Passive. Active mode is refused by this server.",
  "conn.guide.ftps.winscp.s1": "New site → File protocol: FTP, Encryption: TLS/SSL Explicit encryption.",
  "conn.guide.ftps.winscp.s2": "Host name: {host}, port: {port}.",
  "conn.guide.ftps.winscp.s3": "User name: {user}, password as above.",
  "conn.guide.ftps.curl.caption": "Upload and download",
  "conn.guide.ftps.curl.sslReqd": "--ssl-reqd is not optional: it makes curl REQUIRE TLS instead of falling back to plaintext. This server refuses plaintext anyway, but the habit protects you against the servers that do not.",
  "conn.guide.ftps.lftp.caption": "Connect",
  "conn.guide.ftps.lftp.protectData": "ssl-protect-data encrypts the FILE as well as the sign-in. Without it lftp signs in over TLS and then sends your file in the clear - which is the FTPS misconfiguration people actually ship.",
  "conn.guide.ftps.rclone.useCaption": "Use it",
  "conn.guide.ftps.printer.tab": "Scanner / printer",
  "conn.guide.ftps.printer.s1": "In the device's scan-to-FTP settings: server {host}, port {port}.",
  "conn.guide.ftps.printer.s2": "User: {user}, password as above. Create an API key for the device rather than using your own password - it can be revoked without changing anything else.",
  "conn.guide.ftps.printer.s3": "Path: {path} - or a folder inside it that you created first. The device cannot create a storage.",
  "conn.guide.ftps.printer.s4": 'Turn ON "SSL/TLS" or "FTPS explicit", and PASSIVE mode.',
  "conn.guide.ftps.printer.noTLS": "Plenty of scan-to-FTP firmware cannot do TLS at all. This server will not talk to such a device, and that is deliberate - the alternative is your documents and your password crossing the office network in the clear.",
  "conn.guide.ftps.note.tls": "TLS is mandatory and there is no switch to turn it off. Plain FTP sends your password in the clear and your file after it.",
  "conn.guide.ftps.note.passive": "Passive mode only. Active mode has the server dial back to the client, which does not survive NAT and is blocked by most firewalls.",
  "conn.guide.ftps.note.storages": "The root is not a home directory: it lists the storages you may open, and the first path segment names one.",
  "conn.guide.ftps.note.trash": "A delete goes to the filex trash, the same as everywhere else, and is recoverable until the retention policy sweeps it.",
  "conn.guide.ftps.note.prefer": "If the client can speak SFTP, prefer it: one connection, one port, no passive-mode surprises.",
  "conn.guide.ftps.note.selfSigned": "This server is using a self-signed certificate. It encrypts the channel but proves nothing about who is on the other end - most clients will ask you to accept it once. Supply a real certificate for anything that matters.",
  "conn.guide.ftps.note.disabled": "The FTPS endpoint is switched off on this server. These instructions will work once an operator enables it.",
  // ── NFS ──────────────────────────────────────────────────────────
  "conn.nfs.title": "NFS exports",
  "conn.nfs.lead": "An export lets a machine on your network mount filex as a drive - a media player, a build server, a backup box.",
  "conn.nfs.pathIsSecret": "⚠ The export path IS the password. NFS cannot ask a client who it is without Kerberos, so filex puts 32 random bytes in the path instead: whoever knows it can mount as you. Treat the mount line like a credential - /etc/fstab is world-readable on most systems.",
  "conn.nfs.disabled": "The NFS endpoint is switched off on this server (FILEX_NFS). An export created here will not mount until an operator turns it back on.",
  "conn.nfs.cannotMint": "You are not signed in with an account that can create exports.",
  "conn.nfs.label": "What is it for? (media player, backup box, …)",
  "conn.nfs.defaultLabel": "nfs export",
  "conn.nfs.everyStorage": "Every storage I can see",
  "conn.nfs.prefix": "Folder inside the storage (optional)",
  "conn.nfs.allowCidrs": "Allowed addresses, e.g. 192.168.1.0/24 (optional)",
  "conn.nfs.readOnly": "Read-only",
  "conn.nfs.readOnlyHint": "Read-only is the safer default for a machine: it refuses every write through this mount whatever your own permissions are. An address list narrows it further - outside it, the mount is refused.",
  "conn.nfs.mint": "Create export",
  "conn.nfs.once": "Copy this now - the path is shown only once and cannot be recovered.",
  "conn.nfs.dismiss": "I have copied it",
  "conn.nfs.col.label": "Label",
  "conn.nfs.col.scope": "Limited to",
  "conn.nfs.col.mode": "Mode",
  "conn.nfs.col.lastUsed": "Last mounted",
  "conn.nfs.scopeAll": "everything you can see",
  "conn.nfs.modeRead": "read-only",
  "conn.nfs.modeWrite": "read/write",
  "conn.nfs.noLabel": "(no label)",
  "conn.nfs.neverUsed": "never",
  "conn.nfs.enable": "Enable",
  "conn.nfs.disable": "Disable",
  "conn.nfs.revoke": "Revoke",
  "conn.nfs.confirm": "Sure?",
  "conn.nfs.empty": "No exports yet.",
  "conn.guide.nfs.summary": "NFS mounts filex as a drive on a machine in your own network - the NAS protocol, for the devices that expect one.",
  "conn.guide.nfs.pathPlaceholder": "create an export above",
  "conn.guide.nfs.fact.host": "Host",
  "conn.guide.nfs.fact.hostHint": "The same machine as the web app, on a port of its own.",
  "conn.guide.nfs.fact.port": "Port",
  "conn.guide.nfs.fact.portHint": "Both port= and mountport= must be set to this; filex serves the mount and NFS services on one port.",
  "conn.guide.nfs.fact.export": "Export path",
  "conn.guide.nfs.fact.exportHint": "This is the credential. It is shown once, when you create the export, and is stored hashed - filex cannot show it again.",
  "conn.guide.nfs.fact.options": "Mount options",
  "conn.guide.nfs.fact.optionsHint": "nolock because filex does not run the NFS lock manager; nfsvers=3 because that is what this server speaks.",
  "conn.guide.nfs.linux.mountCaption": "Mount it",
  "conn.guide.nfs.linux.fstabSecret": "An /etc/fstab line containing this path is a password in a world-readable file. Use a credentials-protected automount, or keep the mount in a root-only unit, if that matters where you are.",
  "conn.guide.nfs.mac.mountCaption": "Mount it",
  "conn.guide.nfs.mac.resvport": "macOS needs resvport: its client insists on a privileged source port and refuses the mount without it.",
  "conn.guide.nfs.win.s1": 'Turn on "Services for NFS" → "Client for NFS" in Windows Features (Pro and Enterprise only; Home does not have it).',
  "conn.guide.nfs.win.s2": "Open a Command Prompt as administrator.",
  "conn.guide.nfs.win.s3": "Map the export to a drive letter with the command below.",
  "conn.guide.nfs.win.cmdCaption": "Map it to Z:",
  "conn.guide.nfs.win.port": "Windows has no way to say which port the mount service is on, so it can only reach an NFS server on the standard port 2049. If this server is on another port, use SFTP or the filex desktop app instead.",
  "conn.guide.nfs.nas.tab": "NAS / media player",
  "conn.guide.nfs.nas.s1": "In the device's NFS settings: server {host}, port {port} (set both the NFS and the mount port if it asks for them separately).",
  "conn.guide.nfs.nas.s2": "Remote path: the export path above, exactly as shown.",
  "conn.guide.nfs.nas.s3": "NFS version 3, no locking. Create the export read-only unless the device genuinely needs to write.",
  "conn.guide.nfs.note.unencrypted": "NFSv3 is not encrypted. Anyone who can read the traffic sees your files, and anyone who learns the path can mount them. Use it on a home or office network, or over a VPN - never across the internet.",
  "conn.guide.nfs.note.pathIsSecret": "The export path is the whole credential. Revoke it from the list above if it leaks; there is nothing else to change.",
  "conn.guide.nfs.note.noPortmapper": "There is no portmapper on port 111, so a client that is not told the port cannot find the server. That is why every command here carries port= and mountport=.",
  "conn.guide.nfs.note.uid": "The user and group ids your client sends are ignored: the mount already knows whose it is. The permissions you see come from your access in filex.",
  "conn.guide.nfs.note.trash": "A delete goes to the filex trash, the same as everywhere else, and is recoverable until the retention policy sweeps it.",
  "conn.guide.nfs.note.revoke": "Revoking takes effect on the next request, not instantly: NFS has no session to end, so a client with the mount open sees its next operation fail.",
  "conn.guide.nfs.note.disabled": "The NFS endpoint is switched off on this server. These instructions will work once an operator enables it.",
  "conn.tokens.title": "API keys",
  "conn.tokens.lead": "FTPS, WebDAV and filex mount all sign in with an API key instead of your account password. Create one here - it can be revoked on its own, and an account with two-factor sign-in cannot use its password on these at all.",
  "conn.tokens.mint": "Create API key",
  "conn.tokens.once": "Copy it now - this is the only time it is shown. Only a hash is stored, so it cannot be shown again.",
  "conn.tokens.dismiss": "I have copied it",
  "conn.tokens.cannotMint": "This session cannot create API keys. Sign in with your own account to create one.",
  "conn.tokens.empty": "No API keys yet.",
  "conn.tokens.neverUsed": "never",
  "conn.tokens.revoke": "Revoke",
  "conn.tokens.confirm": "Sure?",
  "conn.tokens.col.label": "Name",
  "conn.tokens.col.scopes": "Permissions",
  "conn.tokens.col.comments": "Comments",
  "conn.tokens.col.used": "Last used",
  "conn.tokens.revokeHint": "Revoking stops a connection that is already open, not just the next sign-in: an SFTP or FTPS session is cut and a mount stops working within about half a minute.",
  "conn.guide.mount.summary": "filex mount attaches a remote filex server to a folder on this machine, over the same HTTPS the browser uses. It is the only one of these that works from anywhere - no LAN, no extra server, no third-party client.",
  "conn.guide.mount.fact.url": "Server URL",
  "conn.guide.mount.fact.urlHint": "The same address you use in the browser. Nothing else has to be reachable.",
  "conn.guide.mount.fact.token": "API key",
  "conn.guide.mount.fact.tokenPlaceholder": "create one under API keys",
  "conn.guide.mount.fact.tokenHint": "An API key, not your password - it can be revoked on its own, and an account with 2FA cannot use its password here at all.",
  "conn.guide.mount.fact.remote": "What to mount",
  "conn.guide.mount.fact.remoteHint": "Leave --remote off to see every storage as a folder, or name one storage - or a folder inside it - to mount just that.",
  "conn.guide.mount.linux.mountCaption": "Mount it",
  "conn.guide.mount.linux.umountCaption": "Unmount it",
  "conn.guide.mount.linux.umountWarn": "Unmount with fusermount, not by killing the process. A mount whose process died without detaching leaves a folder where every ls hangs until somebody runs fusermount by hand.",
  "conn.guide.mount.linux.systemdCaption": "Mount it at sign-in (systemd user unit)",
  "conn.guide.mount.win.winfsp": "Windows needs WinFsp installed once - it is free and open source: https://winfsp.dev. Nothing else, and no administrator rights after that.",
  "conn.guide.mount.win.mountCaption": "Mount it as a drive",
  "conn.guide.mount.win.freeLetter": "Pick a drive letter that is FREE. The letter is created by the mount, not attached to something that already exists, and pointing it at one that is in use fails with a message that does not say so.",
  "conn.guide.mount.win.stop": "Stop it with Ctrl-C in that window. The drive disappears and nothing is left behind on this machine.",
  "conn.guide.mount.mac.unsupported": "filex mount does not work on macOS. It needs macFUSE, whose license does not allow a program like filex to install it for you, and whose Go binding needs a C compiler filex deliberately does not require. The command refuses here rather than appearing to work and doing nothing.",
  "conn.guide.mount.mac.alternatives": "On macOS, use the filex desktop app with folder sync (keeps the files on disk), or SFTP with a client that mounts drives.",
  "conn.guide.mount.note.notASync": "This is not a sync. Nothing is copied to this machine except a small read cache, so a mount opens one file out of a hundred thousand without downloading the rest. If you want the files when you are offline, use folder sync instead.",
  "conn.guide.mount.note.reachable": "It reaches the server through whatever proxy or tunnel the browser goes through, because underneath it is the same API. Your permissions and your storages come with it.",
  "conn.guide.mount.note.wholeFileWrites": "A file you write through the mount is uploaded when the program closes it, not while it is being written. Editing a very large file in place is slower here than a local disk; copying it in and out is not.",
  "conn.guide.mount.note.trash": "A delete goes to the filex trash, the same as everywhere else, and is recoverable until the retention policy sweeps it.",
  "conn.guide.mount.note.revoke": "Revoke the API key to stop a mount. It stops serving within half a minute, even if the mount is still attached.",
  "storages.driver.ftp": "FTP / FTPS",
  "storages.driver.local": "Local filesystem",
  "storages.driver.s3": "S3 / Hetzner / MinIO",
  "storages.driver.sftp": "SFTP",
  "storages.driver.smb": "SMB / CIFS (NAS)",
  "storages.driver.webdav": "WebDAV",
  "storages.fieldHelp.smbShare": "The share name alone, without the server: `media`, not `\\\\nas\\media`.",
  "storages.fieldHelp.smbDomain": "Only for a Windows domain account. Leave empty for a NAS.",
  "storages.fieldHelp.smbRoot": "Sub-folder inside the share. Leave empty for the whole share.",
  "storages.fields.share": "Share",
  "storages.fields.domain": "Domain / workgroup",
  "storages.fieldHelp.disablePresign": "On by default: uploads and the downloads behind public share links stream through filex, so the bucket endpoint never has to be reachable from a browser (a LAN-only MinIO just works). Turn it off only when the endpoint is reachable from your users' browsers (AWS, a public MinIO) and you want them to talk to the bucket directly - faster for very large files, and the store must accept SDK-signed URLs (Ceph RGW / some Hetzner setups answer SignatureDoesNotMatch).",
  "storages.fieldHelp.endpoint": "Leave empty for AWS S3. Any S3-compatible store needs its endpoint.",
  "storages.fieldHelp.hostKey": "A single public key in authorized_keys / known_hosts line form.",
  "storages.fieldHelp.insecureSkipHostKey": "Accepts any host key. Only for throwaway hosts.",
  "storages.fieldHelp.keyPath": "Path to a key file on the server, read when the storage starts. Used when the PEM field is empty.",
  "storages.fieldHelp.knownHosts": "OpenSSH known_hosts path for strict host-key checking. Default is trust-on-first-use in ~/.filex/known_hosts.",
  "storages.fieldHelp.passive": "Off switches to active mode, which needs the server to dial back into this host.",
  "storages.fieldHelp.path": "Directory on the server. It is created if missing; filex never mounts /.",
  "storages.fieldHelp.pathStyle": "On for every non-AWS store. It is turned on automatically when an endpoint is set and this was never touched.",
  "storages.fieldHelp.prefix": "Sub-folder inside the bucket. Required: filex never takes ownership of the bucket root.",
  "storages.fieldHelp.region": 'Defaults to "auto" when left empty.',
  "storages.fieldHelp.root": "Sub-folder on the backend. Required: filex never mounts the account root.",
  "storages.fieldHelp.sftpAuth": "Either a password or a private key is required.",
  "storages.fieldHelp.tls": "Plain FTP sends credentials in the clear - turn this on whenever the server supports it.",
  "storages.fields.accessKey": "Access key",
  "storages.fields.basePath": "Base path",
  "storages.fields.bucket": "Bucket",
  "storages.fields.disablePresign": "Stream transfers through filex",
  "storages.fields.endpoint": "Endpoint",
  "storages.fields.host": "Host",
  "storages.fields.hostKey": "Pinned host key",
  "storages.fields.insecureSkipHostKey": "Skip host-key verification (insecure)",
  "storages.fields.keyPath": "Private key file",
  "storages.fields.knownHosts": "known_hosts file",
  "storages.fields.name": "Display name",
  "storages.fields.namePlaceholder": "Personal photos",
  "storages.fields.passive": "Passive mode (PASV)",
  "storages.fields.password": "Password",
  "storages.fields.path": "Filesystem path",
  "storages.fields.pathStyle": "Use path-style URLs (Hetzner, MinIO)",
  "storages.fields.port": "Port",
  "storages.fields.prefix": "Prefix",
  "storages.fields.privateKey": "Private key (PEM)",
  "storages.fields.rbac": "Per-item access control (RBAC)",
  "storages.fields.rbacHint": "When on, non-admins see only the files and folders granted to them (listed under Folder access). When off, everyone opens the storage according to their role.",
  "storages.fields.readOnly": "Read-only mount",
  "storages.fields.region": "Region",
  "storages.fields.root": "Base path",
  "storages.fields.secretKey": "Secret key",
  "storages.fields.tls": "FTPS (explicit AUTH TLS)",
  "storages.fields.url": "Base URL",
  "storages.fields.user": "User",
  "storages.fields.s3AttemptTimeout": "Attempt timeout (seconds)",
  "storages.fields.s3MaxAttempts": "Attempts per request",
  "storages.fields.s3TotalTimeout": "Give up after (seconds)",
  "storages.fieldHelp.s3AttemptTimeout": "How long one attempt may wait for a sign of life from the store: connecting, the TLS handshake, the answer after the request is sent, and each next piece of the answer. A transfer that keeps moving is never cut, however long it takes; an upload the store stops taking is cut after 60 seconds, or after this if it is longer. Copies and renames wait up to 10 minutes for the answer, because the store answers them only when the copy is done.",
  "storages.fieldHelp.s3MaxAttempts": "How many times a request is tried in all when the failure can pass: a network error, a timeout, a 5xx answer, throttling. 1 turns retrying off. A refusal (403, a missing bucket, a host name that does not resolve) is never retried.",
  "storages.fieldHelp.s3TotalTimeout": "No new attempt starts unless it could finish within this many seconds of the first, so an upload or a listing on a store that is down reports the outage within this time. A transfer that is under way is not cut. A request that timed out is tried again only when this is at least twice the attempt timeout.",
  "storages.fields.attemptTimeout": "Attempt timeout (seconds)",
  "storages.fields.maxAttempts": "Attempts per request",
  "storages.fields.totalTimeout": "Give up after (seconds)",
  "storages.fieldHelp.attemptTimeout": "How long one attempt may wait for a sign of life from the server: connecting, logging in, the answer to each request, and each next piece of a transfer. A transfer that keeps moving is never cut, however long it takes; an upload the server stops taking is cut after 60 seconds, or after this if it is longer.",
  "storages.fieldHelp.webdavAttemptTimeout": "How long one attempt may wait for a sign of life from the server: connecting, logging in, the answer to each request, and each next piece of a transfer. A transfer that keeps moving is never cut, however long it takes; an upload the server stops taking is cut after 60 seconds, or after this if it is longer. Copies, moves and deletes wait up to 10 minutes for the answer, because the server answers them only when the work is done.",
  "storages.fieldHelp.maxAttempts": "How many times a request is tried in all when the failure can pass: the connection is refused or drops, no answer comes in time, the server answers that it is unavailable (5xx). 1 turns retrying off. A refusal (a wrong password, a missing folder, a certificate that does not verify) is never retried, and neither is an upload that has started sending.",
  "storages.fieldHelp.totalTimeout": "No new attempt starts unless it could finish within this many seconds of the first, so a server that is down is reported within this time. A transfer that is under way is not cut. A request that timed out is tried again only when this is at least twice the attempt timeout.",
  /* === gezinti:g1 - navigation panel (SideNav) === */
  "sidenav.title": "Navigation",
  "sidenav.views": "Views",
  "sidenav.storages": "Storages",
  "sidenav.home": "Home",
  "sidenav.myfiles": "My files",
  "sidenav.recent": "Recent",
  "sidenav.starred": "Starred",
  "sidenav.shared": "Shared with me",
  // The mirror of the row above, and it sits right under it: what came in,
  // and what went out. ⚠ "My shares", not "Shared by me" - the page lists
  // LINKS the person minted, not files they granted somebody access to.
  "sidenav.myshares": "My shares",
  "sidenav.trash": "Trash",
  "sidenav.collapse": "Collapse navigation",
  "sidenav.expand": "Expand navigation",
  "sidenav.close": "Close navigation",
  // ⚠ `open`/`close` are the DRAWER's pair, `expand`/`collapse` the docked
  // panel's, and they are not interchangeable - see the note on
  // `navToggleLabel` in Toolbar.vue. Below 560px the panel is a drawer over
  // the listing: it is not narrowed to a rail, it is not on screen at all, so
  // "expand" would promise a width change to something that has no width.
  "sidenav.open": "Open navigation",
  "sidenav.storage.shared": "Shared",
  "sidenav.storage.readOnly": "Read-only",
  // #57 - a storage row's order menu (right click, a long press, Shift+F10).
  // "Sort by name" writes an order the person can keep adjusting; it is not a
  // mode. "Use default order" lets the person's own order go: the panel then
  // follows the administrator's order (or, with none, the server's). The two
  // `.done`/`.none` lines are the reason a greyed row gives.
  "sidenav.storage.moveUp": "Move up",
  "sidenav.storage.moveDown": "Move down",
  "sidenav.storage.sortName": "Sort by name",
  "sidenav.storage.sortName.done": "Already sorted by name",
  "sidenav.storage.defaultOrder": "Use default order",
  "sidenav.storage.defaultOrder.none": "Already in the default order",
  // ⚠ `toolbar.nav` is GONE, and nothing replaced it. It was the one label on
  // the panel's collapse control, first as the noun "Navigation" - which names
  // the panel and never says the button does anything to it, so the owner
  // could not find how to collapse the panel (2026-09-13: "yan menüyü kısıp
  // açabilir olalım ya bence") - and then as the static stopgap "Show or hide
  // navigation". The four `sidenav.*` verbs above are the real fix: the label
  // is bound to `navOpen`, so it says *collapse* when it will collapse and
  // *expand* when it will expand.
  "node.home": "Home",
  "node.recent": "Recent",
  "node.starred": "Starred",
  "node.shared": "Shared with me",
  "empty.recent.title": "Nothing opened yet",
  "empty.recent.hint": "Files you open show up here",
  "empty.starred.title": "Nothing starred yet",
  "empty.starred.hint": "Star a file to find it here",
  "empty.shared.title": "Nothing has been shared with you",
  "empty.shared.hint": "Folders and files other people share appear here",
  /* etiket:t1 */
  "sidenav.tags": "Tags",
  "sidenav.tags.empty": "No tags yet - add one from a file’s right-click menu.",
  "sidenav.tags.more": "Show {count} more",
  "sidenav.tags.less": "Show fewer",
  "sidenav.tags.personal": "Personal",
  "sidenav.tags.team": "Team",
  "empty.tag.title": "Nothing is tagged “{tag}”",
  "empty.tag.hint": "Right-click a file and choose Tags to put it here",
  "sidenav.connections": "Connections",
  "sidenav.apps": "Apps",
  // #162 - the store screen: the catalog of the stores an administrator turned
  // on, where a person asks for an app.
  "sidenav.appstore": "App store",
  "sidenav.connect": "Connections",
  "sidenav.apikeys": "API keys",
  "overlay.close": "Close",
  "conn.tokens.scopes": "Permissions",
  "conn.tokens.root": "Limit to one folder (optional)",
  "conn.tokens.rootPlaceholder": "storage://folder",
  "conn.tokens.expiry": "Expires in (days)",
  "conn.tokens.expiryNever": "never",
  "conn.tokens.defaultName": "API key {date}",
  "conn.tokens.namePlaceholder": "Name - e.g. backup script",
  "conn.tokens.capNote": "Your own access is the ceiling - a permission you do not have is refused, not granted.",
  "conn.tokens.scopesRequired": "Choose at least one permission - an API key is never issued with none.",
  "conn.tokens.comments": "Comments",
  "conn.tokens.commentsRead": "Read",
  "conn.tokens.commentsRw": "Read and write",
  "conn.tokens.commentsHint": "Adding and deleting comments is a permission of its own - “write” does not include it. Every API key reads them.",
  "conn.tokens.commentsToRw": "Comments: allow writing",
  "conn.tokens.commentsToRead": "Comments: read only",
  /* === /gezinti:g1 === */
  /* === surucu:d1 - the shell (GitHub #14); every profile, no longer a
     `uiProfile: 'drive'` opt-in === */
  "drive.new": "New",
  "drive.new.upload": "Upload files",
  "drive.new.folder": "New folder",
  "drive.new.request": "Request files",
  "drive.new.document": "New document",
  /* === belge:n1 - "New document": the picker under + New =================
     Type names are NOT listed here. A tile reads its words from
     lib/fileIcons `typeLabelFor`, the same table the listing's Type column
     uses, so ".docx" is called the same thing in both places and a new type
     needs no string at all. Only this dialog's own chrome lives below. */
  "newdoc.title": "New document",
  "newdoc.type.label": "Document type",
  "newdoc.group.document": "Documents",
  "newdoc.group.text": "Text and code",
  "newdoc.group.diagram": "Diagrams",
  "newdoc.group.app": "Apps",
  /* ⚠ One name per service, the name its own project uses: draw.io (not
     "drawio", not "diagrams.net") and ONLYOFFICE - the QA sweep of
     2026-09-21 found draw.io called three things on three screens. */
  "newdoc.empty.title": "No document types are available",
  "newdoc.empty.body": "This server did not offer any type this app can create.",
  "newdoc.empty.blocked": "Every type this server can create needs an editor service that is not configured here.",
  "newdoc.name": "Name",
  "newdoc.name.placeholder": "File name, e.g. notes.txt or LICENSE",
  "newdoc.untitled": "Untitled",
  "newdoc.err.slash": "A name cannot contain a slash.",
  "newdoc.err.exists": "{name} is already here. Choose another name.",
  "newdoc.err.bare_ext": "Give the file a name, not only an extension.",
  "newdoc.err.ext_needs_type": "A .{ext} file has to be created as its own type - an empty one would not open. Choose that type, or another extension.",
  "newdoc.hint.ext_added": "This type keeps its extension, so the file will be created as {name}.",
  // Drafts (issue #71): a new document is a draft until its first save.
  "sidenav.drafts": "Drafts",
  "sidenav.drafts.count": "{n} drafts",
  "sidenav.drafts.count_one": "{n} draft",
  "node.drafts": "Drafts",
  "empty.drafts.title": "No drafts",
  "empty.drafts.hint": "A new document waits here until you save it where it belongs.",
  "drafts.lead": "New documents that have not been saved yet. Only you can see them.",
  "drafts.count_of": "{n} of {limit} drafts",
  "drafts.col.target": "Save to",
  "drafts.col.storage": "Storage",
  "drafts.action.save": "Save to disk",
  "drafts.open_hint": "Open {name}",
  "drafts.no_match": "No draft matches the filter.",
  "draft.badge": "Draft",
  "draft.bar.target": "will be saved to {folder}",
  "draft.save": "Save",
  "draft.saved_to": "{name} was saved to {folder}.",
  "draft.discarded": "{name} was moved to the trash.",
  "draft.kept": "Kept in Drafts",
  "draft.editing": "Editing…",
  "draft.close.title": "Close this draft?",
  "draft.close.body": "{name} is a draft for {folder} and has not been saved there yet.",
  "draft.close.hint": "A kept draft waits in Drafts. Discard moves it to the trash.",
  "draft.close.save": "Save to disk",
  "draft.close.keep": "Keep in Drafts",
  "draft.close.discard": "Discard",
  "outside.title": "This file changed outside filex",
  "outside.body": "{name} was changed somewhere else while it was open here, and this editor has changes of its own. Which version should stay?",
  "outside.theirs": "Keep the outside version",
  "outside.theirs_hint": "the changes made here are dropped and the outside version is loaded.",
  "outside.mine": "Write mine",
  "outside.mine_hint": "your version replaces the outside one when it is saved.",
  "outside.both": "Keep both",
  "outside.both_hint": "the outside version stays where it is, and yours is saved beside it as a separate copy (name.filex-conflict-time).",
  "outside.hint": "Until you choose, nothing is written over either version.",
  "outside.pending": "This file changed outside filex. Nothing is written over either version until you choose which one stays.",
  "outside.choose": "Choose…",
  "outside.note.reloaded": "The file was updated outside filex; the new version is loaded.",
  "outside.note.theirs": "The outside version is loaded; the changes made here were dropped.",
  "outside.note.mine": "Your version will replace the outside one when it is saved.",
  "outside.note.both": "The outside version stays; yours will be saved beside it as a separate copy.",
  "draft.taken.title": "A file with this name is already there",
  "draft.taken.body": "{folder} already has a file called {name}. Save the draft as {suggested} instead?",
  "draft.taken.confirm": "Save as {name}",
  "upload.taken.body": "{folder} already has something called {name}, and a vault keeps no earlier version. Upload it as {suggested} instead?",
  "upload.taken.confirm": "Upload as {name}",
  "newdoc.hint.draft": "It opens as a draft: nothing is created in the folder until you save it.",
  "newdoc.err.draft_limit": "You already keep as many drafts as this server allows ({limit}). Save or delete some in Drafts first.",
  "newdoc.err.draft_limit_any": "You already keep as many drafts as this server allows. Save or delete some in Drafts first.",
  "newdoc.open_drafts": "Open Drafts",
  "newdoc.location": "Location",
  "newdoc.location.none": "Choose a folder",
  "newdoc.location.change": "Change",
  "newdoc.location.noaccess": "You cannot save into this folder.",
  "newdoc.create": "Create",
  "newdoc.creating": "Creating…",
  "newdoc.cancel": "Cancel",
  // ⚠ The top search field searches the WHOLE storage (and every storage at
  // the root) - never only the open folder. The scope named here is therefore
  // the storage, not the folder; "Filter in this folder…" (FilterBar) is the
  // folder-scoped one. It used to say "Search in Photos" for a folder called
  // Photos, which was a lie (2026-09-19).
  "drive.search.placeholder": "Search in {scope}",
  "drive.search.placeholder_all": "Search all storages",
  "drive.search.hint_title": "Search everywhere and run commands ({combo})",
  "drive.storage.used": "{used} of {total} used",
  "drive.storage.used_unlimited": "{used} used",
  "drive.storage.used_partial": "at least {used} used",
  "drive.storage.label": "Storage",
  /* === gorunum:v3-shell - the Home view (the overview, inside the shell) ==
   * The section headings are `sidenav.storages` / `sidenav.recent` /
   * `sidenav.starred` and the two empty states are `empty.recent.*` /
   * `empty.starred.*`, on purpose: the block headed "Recent" on Home and the
   * panel row labelled "Recent" beside it are the same thing, and a second
   * string for it is how the two drift apart one translation at a time. Only
   * what exists nowhere else is below. */
  "home.title": "Home",
  "home.storages.empty": "No storages yet",
  "home.storages.hint": "A storage is a place filex reads and writes - an administrator adds them.",
  "drive.section.folders": "Folders",
  "drive.section.files": "Files",
  "filter.aria": "Filters",
  "filter.type": "Type",
  "filter.type.any": "Any type",
  "filter.type.folder": "Folders",
  "filter.type.document": "Documents",
  "filter.type.spreadsheet": "Spreadsheets",
  "filter.type.presentation": "Presentations",
  "filter.type.pdf": "PDFs",
  "filter.type.image": "Images",
  "filter.type.video": "Videos",
  "filter.type.audio": "Audio",
  "filter.type.archive": "Archives",
  "filter.type.code": "Code",
  "filter.modified": "Modified",
  "filter.modified.any": "Any time",
  "filter.modified.today": "Today",
  "filter.modified.7d": "Last 7 days",
  "filter.modified.30d": "Last 30 days",
  "filter.modified.year": "This year",
  "filter.size": "Size",
  "filter.size.any": "Any size",
  "filter.size.lt1": "Under 1 MB",
  "filter.size.1to10": "1 - 10 MB",
  "filter.size.10to100": "10 - 100 MB",
  "filter.size.gt100": "Over 100 MB",
  /* surucu:d1-actions - the ⋮ menu at the end of the filter row. Only its own
     NAME is new: every row inside it reuses the string that verb already has
     (`toolbar.new_folder`, `toolbar.upload`, `ctx.paste`, `shortcuts.select_all`,
     `selection.clear`), because a menu that renames a command is a menu the
     reader has to learn twice. */
  "filter.actions": "Listing actions",
  "filter.clear": "Clear filters",
  "filter.empty.title": "Nothing here matches those filters",
  "filter.empty.hint": "Clear a filter, or search everywhere with the field above.",
  "filter.count": "{shown} of {total}",
  "inspector.tab.details": "Details",
  "inspector.tab.activity": "Activity",
  "inspector.people": "People with access",
  "inspector.people.you": "You",
  "inspector.people.inherited": "from a parent folder",
  "inspector.people.empty": "Only you, and anyone with a link below.",
  "inspector.people.manage": "Manage access",
  "inspector.link": "Shared link",
  "inspector.link.none": "Not shared",
  "inspector.link.create": "Create link",
  "inspector.link.copy": "Copy link",
  "inspector.activity.empty": "No activity recorded for this item yet.",
  "inspector.activity.hint": "Versions are written when a file changes; comments are written by people.",
  "inspector.activity.version": "Version {n} saved",
  "inspector.activity.comment": "Comment by {who}",
  "inspector.activity.select": "Select a file or folder to see its activity.",
  /* === /surucu:d1 === */
  /* === gorunum:v1-chrome - the filter row's name box === */
  "filter.find": "Filter in this folder…",
  /* surucu:d1-scope - the same box where the rows are not a folder's contents.
     It has to say what it narrows: at the drive list "this folder" names
     nothing, and on Home it would name three blocks at once. */
  "filter.find.storages": "Filter storages…",
  "filter.find.home": "Filter Home…",
  /* === gorunum:v1-viewer - the full-bleed overlay's own chrome === */
  "viewer.share": "Share",
  "viewer.nav_prev": "Previous file",
  "viewer.nav_next": "Next file",
  /* The counter in the top bar's meta line: "246.3 KB • Sep 9, 2026 • 1 of 9". */
  "viewer.counter": "{i} of {n}",
  "viewer.original_size": "Original size",
  "viewer.zoom_reset": "Reset zoom",
  "viewer.fullscreen": "Full screen",
  "viewer.exit_fullscreen": "Exit full screen",
  "viewer.md_placeholder": "# Markdown here…",
  /* === gorunum:v1-selbar - the selection bar that replaces the filter row === */
  "selection.count": "{n} selected",
  "selection.clear": "Clear selection",
  /* === gorunum:v1-preview - the kind, said in words ======================
     The Type column used to print the extension in caps. These are what it
     prints instead; the table that picks one is in `lib/fileIcons.ts`
     (`typeLabelKey`), so this list and that one are the only two places a
     kind is named. Anything unmapped still falls back to the uppercased
     extension - these names improve on that fallback, they do not replace
     it. `Folder` is NOT here: it is `node.folder`, which the grid card's
     caption already prints. */
  "ftype.typescript": "TypeScript",
  "ftype.javascript": "JavaScript",
  "ftype.vue": "Vue component",
  "ftype.python": "Python",
  "ftype.go": "Go",
  "ftype.rust": "Rust",
  "ftype.php": "PHP",
  "ftype.ruby": "Ruby",
  "ftype.java": "Java",
  "ftype.kotlin": "Kotlin",
  "ftype.swift": "Swift",
  "ftype.c": "C source",
  "ftype.cpp": "C++ source",
  "ftype.csharp": "C# source",
  "ftype.stylesheet": "Stylesheet",
  "ftype.html": "HTML document",
  "ftype.json": "JSON data",
  "ftype.yaml": "YAML",
  "ftype.xml": "XML",
  "ftype.toml": "TOML",
  "ftype.sql": "SQL",
  "ftype.shell": "Shell script",
  "ftype.powershell": "PowerShell script",
  "ftype.markdown": "Markdown",
  "ftype.plaintext": "Plain text",
  "ftype.log": "Log file",
  "ftype.config": "Configuration",
  "ftype.sheet": "Spreadsheet",
  "ftype.figma": "Figma design",
  "ftype.drawio": "draw.io diagram",
  "ftype.design": "Design file",
  "ftype.image": "Image",
  "ftype.video": "Video",
  "ftype.audio": "Audio",
  "ftype.pdf": "PDF document",
  "ftype.document": "Document",
  "ftype.slides": "Presentation",
  "ftype.archive": "Archive",
  "ftype.code": "Code",
  /* === gorunum:v1-advsearch - the Advanced search dialog ==================
   * Two `filter.*` keys are added here rather than beside their siblings
   * because they are new members of shared unions the dialog introduced
   * (`modified: 'around'`, `size: 'range'`); the filter row never selects
   * them, but `chipLabel` would print the raw key if one ever reached it. */
  "filter.modified.around": "Around a date",
  "filter.size.range": "Custom range",
  "advsearch.open": "Advanced search",
  "advsearch.title": "Advanced search",
  "advsearch.subtitle": "Find files by name, content, path, or tags.",
  "advsearch.close": "Close",
  "advsearch.content.heading": "Content search",
  "advsearch.viewall": "View all results",
  "advsearch.where.any_short": "Anywhere",
  "advsearch.where.here_short": "Only here",
  "advsearch.where.skip_short": "Skip this",
  "advsearch.server.legend": "What the server searches",
  "advsearch.client.legend": "Narrow the results that come back",
  "advsearch.query.label": "Words",
  "advsearch.query.placeholder": "Part of a name, or words inside a file",
  "advsearch.scope.label": "Look in",
  "advsearch.scope.name": "Names and paths",
  "advsearch.scope.content": "File contents",
  "advsearch.scope.all": "Both",
  "advsearch.scope.hint": "Contents are searched from the index, which covers text-like files up to 200 KB.",
  "advsearch.people.name_only": "Owner is read off the rows that come back, and only a name search returns rows that carry one.",
  "advsearch.scope.name_only": "Only names and paths here: a content hit reaches the explorer without the storage it came from, so content search is offered on single-storage deployments only.",
  "advsearch.tags.label": "Tags",
  "advsearch.tags.placeholder": "invoice, quarterly report",
  "advsearch.tags.exclude": "Without tags",
  "advsearch.tags.exclude_placeholder": "archive",
  "advsearch.tags.hint": "Separate with commas. Tags narrow: several tags means files carrying all of them, and a tag nobody has applied returns nothing. A name matches your personal tag and your team’s tag of that name alike.",
  "advsearch.where.label": "Folder",
  "advsearch.where.any": "Anywhere in this storage",
  "advsearch.where.here": "Only in {folder}",
  "advsearch.where.skip": "Everywhere except {folder}",
  "advsearch.around.label": "Within",
  "advsearch.around.date": "Date and time",
  "advsearch.around.h1": "1 hour",
  "advsearch.around.d1": "1 day",
  "advsearch.around.w1": "1 week",
  "advsearch.size.range_label": "Between",
  "advsearch.size.from": "From",
  "advsearch.size.to": "To",
  "advsearch.count.idle": "Type something, or pick a tag.",
  "advsearch.count.counting": "Counting…",
  "advsearch.count.result": "{n} matching items",
  "advsearch.count.capped": "{n} matching items in the first page of hits",
  "advsearch.count.result_one": "{n} matching item",
  "advsearch.count.capped_one": "{n} matching item in the first page of hits",
  "advsearch.count.error": "The count could not be run.",
  "advsearch.count.cost": "The count runs this search. Type, owner, date, size and folder narrow the results it finds.",
  "advsearch.wire": "Type this in the search box next time:",
  "advsearch.reset": "Reset",
  "advsearch.cancel": "Cancel",
  "advsearch.submit": "Search",
  /* === gorunum:v2-topbar - the page bar is gone; the explorer's own header
     and breadcrumb row carry what it used to. === */
  "breadcrumb.subfolders": "Subfolders",
  "breadcrumb.subfolders.empty": "No subfolders here",
  "header.admin": "Admin panel",
  "header.settings": "Settings",
  "header.signout": "Sign out",
  "ai.assistant": "AI assistant",
  "assistant.new": "New conversation",
  "assistant.history": "Conversations",
  "assistant.history_empty": "No conversations yet.",
  "assistant.close": "Close the assistant",
  "assistant.delete": "Delete this conversation",
  "assistant.intro": "Ask the assistant to find, read, summarise, tidy up or move your files. It works with your permissions only. Changes that can be undone happen at once, with an Undo; anything that cannot be undone waits for your approval. Encrypted folders and the vault are never sent to it.",
  "assistant.placeholder": "Ask about your files...",
  "assistant.send": "Send",
  "assistant.stop": "Stop",
  "assistant.working": "Working...",
  "assistant.with_selection": "With the {count} selected items",
  "assistant.with_selection_one": "With the {count} selected item",
  "assistant.approve": "Approve",
  "assistant.decline": "Decline",
  "assistant.undo": "Undo",
  /* gorunum:v2-share - the Share / Permissions dialog's own chrome. The
     controls inside it keep the strings they already had; these are the new
     shell: the title, the one switch, the sentence that says who can open the
     item right now, and the three named sections it all folds into. */
  "access.title": 'Share "{name}"',
  "access.title_storage": 'Access to "{name}"',
  "access.close": "Close",
  "access.done": "Done",
  "access.copy": "Copy",
  "access.copied": "Copied",
  "access.link.switch": "Link sharing",
  "access.who.private": "Only people with access can open it.",
  "access.who.link": "Anyone with the link can open it.",
  "access.who.pin": "Anyone with the link and the PIN can open it.",
  "access.who.existing": "Link sharing is on - {n} links already exist.",
  "access.who.existing_one": "Link sharing is on - {n} link already exists.",
  "access.section.link": "Link options",
  "access.section.people": "People with access",
  "access.section.drop": "Request files",
  "access.sum.pin_on": "PIN on",
  "access.sum.pin_off": "No PIN",
  "access.sum.people": "{n} people",
  "access.sum.people_one": "{n} person",
  "access.sum.people_none": "No one yet",
  "access.sum.groups": "{n} groups",
  "access.sum.groups_one": "{n} group",
  "access.sum.drop": "{n} upload links",
  "access.sum.drop_one": "{n} upload link",
  "access.sum.drop_none": "No upload link",
  /* Ownership - the Owner column and the People chip. "System" is the honest
     word for a row nobody put here through filex (the scanner found it, or it
     was written straight into the bucket); it is a real answer, not a blank. */
  "col.owner": "Owner",
  "owner.you": "You",
  "owner.system": "System",
  "owner.unknown": "Unknown",
  "owner.external": "Uploaded through an upload link",
  "owner.last_actor": "Last changed by {who}",
  "filter.people": "Owner",
  "filter.people.any": "Anyone",
  "filter.people.me": "You",
  "filter.people.system": "System",
  "filter.people.someone": "Someone else",
  /* surucu:d1-sort - the listing sort control at the trailing edge of the
     filter row. The four key names are `col.*`: the menu offers exactly the
     words the list view's own column headers carry, so the two controls that
     drive one sort cannot name it differently. */
  "sort.by": "Sort by",
  "sort.asc": "Ascending",
  "sort.desc": "Descending",
  /* The order a SEARCH RESULT is in. It is not a fifth sort key - it is what
     the control prints instead of a key while the rows on screen were ranked
     by the server, so the button stops claiming a sort it is not performing.
     `_why` is the reason the control is closed, and the owner asked for the
     reason to be written rather than for the control to go quietly inert. */
  "sort.relevance": "Relevance",
  "sort.relevance_why": "Search results are listed by how well they match. Your sort comes back when you leave the search.",
  /* === tablo:t1 - the table's own configuration ==========================
     Since v0.43 everything about how a folder looks - view, sort AND columns -
     belongs to the folder it was changed in; a folder nobody changed opens
     with the person's default (their settings), else the instance's.
     `folder_hint` is that rule in one sentence, written where the person who
     is about to be surprised by it can read it. */
  "col.location": "Location",
  "col.deleted": "Deleted",
  "col.deleted_from": "Deleted from",
  "col.deleted_by": "Deleted by",
  "col.remaining": "Time left",
  "cols.menu": "Column options",
  "cols.title": "Columns",
  "cols.resize": "Resize {col}",
  "cols.sort_by": "Sort by {col}",
  "cols.move_left": "Move {col} left",
  "cols.move_right": "Move {col} right",
  "cols.reset": "Reset columns",
  "cols.folder_title": "Folder view",
  "cols.folder_hint": "A change you make here stays in this folder. Folders you have never changed open with your default view (Settings → Default folder view).",
  "cols.forget_folder": "Forget this folder's view",
  "cols.apply_all": "Make this my default for all folders ({count} remembered)",
  /* === tablo:t3 - THE ONE TABLE (components/DataTable.vue) ================
     Every table in the product speaks these, so a column menu or a pager is
     never the one English thing on a Turkish page. */
  "table.empty": "Nothing here yet",
  "table.prev": "Previous page",
  "table.next": "Next page",
  "table.sort_paged": "This list is split into pages. Sorting would only re-order the page on screen, so it is off here - narrow the list with the search or filters instead.",
  /* === tablo:t1 - the trash banner ======================================
     ⚠ `retention` is only used when the deployment has TOLD us the number
     (GET /api/admin/protection). Everywhere else `retention_unknown` says the
     same thing without naming a period we cannot verify: a banner that states
     the wrong retention is worse than no banner, because people act on it. */
  "trash.retention": "Items in the trash are permanently deleted after {days} days.",
  "trash.retention_one": "Items in the trash are permanently deleted after {days} day.",
  "trash.retention_unknown": "Items in the trash are permanently deleted after a retention period set by your administrator.",
  "trash.empty_action": "Empty trash",
  "trash.empty_confirm_title": "Empty the trash?",
  /* 0.54 (finding D1): the confirmation waits for the server's count of
     what "Empty trash" deletes, and the Trash view is paged. Every
     sentence about the trash itself is the server's (server.trash.*). */
  "trash.empty_counting": "Counting what is in the trash…",
  "trash.show_more": "Show more",
  "trash.shown_of": "{shown} of {total} shown",
  "trash.days_remaining": "{n} days",
  "trash.days_remaining_one": "{n} day",
  "trash.days_remaining_due": "Due for deletion",
  "trash.deleted_by_nobody": "Not recorded: quarantined by the virus scan, or deleted before filex kept this",
  "empty.trash.hint": "Files you delete land here first, so you can put them back.",
  /* tasi:m1 - the destination picker (modals/DestinationPickerModal.vue) and
     the two selection verbs built on it. */
  "destpicker.title.move": "Move to",
  "destpicker.title.copy": "Copy to",
  "destpicker.title.choose": "Choose a folder",
  "destpicker.confirm.move": "Move here",
  "destpicker.confirm.copy": "Copy here",
  "destpicker.confirm.choose": "Choose this folder",
  "destpicker.title.choose_file": "Choose a file",
  "destpicker.confirm.choose_file": "Choose this file",
  "destpicker.title.save": "Save to",
  "destpicker.confirm.save": "Save here",
  "destpicker.pick_a_file": "Select a file from the list.",
  "destpicker.empty_files": "This folder is empty",
  "destpicker.cancel": "Cancel",
  "destpicker.up": "Up one level",
  "destpicker.crumbs": "Location",
  "destpicker.drives": "Storages",
  "destpicker.loading": "Loading…",
  "destpicker.empty": "No subfolders here",
  "destpicker.unreadable": "This folder cannot be opened.",
  "destpicker.readonly": "Read-only",
  "destpicker.readonly_here": "You cannot write into this folder.",
  "destpicker.pick_a_drive": "Open a storage to choose a folder inside it.",
  "destpicker.target": "Destination: {name}",
  "destpicker.tag.blocked": "Not allowed",
  "destpicker.blocked.self": "A folder cannot be moved into itself.",
  "destpicker.blocked.descendant": "A folder cannot be moved into one of its own subfolders.",
  "destpicker.tag.vault": "Vault",
  "destpicker.blocked.vault_in": "Nothing goes into a vault from here: upload into it from inside the vault.",
  "destpicker.blocked.vault_out": "What is in a vault moves only inside that vault. Download it to take it out.",
  "ctx.move_to": "Move to…",
  "ctx.copy_to": "Copy to…",
  "ctx.access.one_only": "Sharing works on one item at a time.",
  "ctx.storage_access": "Access…",
  "toast.archive.preparing": "Preparing the archive…",
  "toast.archive.started": "Downloading {name} ({count} files)",
  "toast.archive.started_one": "Downloading {name} ({count} file)",
  "toast.archive.empty": "Nothing to download - the selection contains no readable file.",
  "toast.moved_to": "Move to {name} queued",
  "toast.copied_to": "Copy to {name} queued",
  "toast.already_there": "The selected items are already in {name} - nothing was sent",
  /* ── dil:paket - strings that used to be inline `en ? … : …` pairs in
     FileExplorer / RecentlyOpened, where no language pack could reach them
     (and where a pack's language fell through to TURKISH). */
  "ctx.tags_menu": "Tags…",
  "toast.node_id_copied": "Node id {id} copied",
  "toast.read_only_here": "Read-only here",
  "recents.title": "Recently opened",
  "recents.refresh": "Refresh",
  "recents.empty": "Nothing here yet.",
  "recents.loading": "Loading…",
  "recents.close": "Close",
  "tags.title": "Tags",
  "tags.close": "Close",
  "share.ttl.never": "This link does not expire.",
  "share.ttl.until": "This link is valid until {when}.",
  "share.ttl.ceiling": "Links can be valid for at most {days} days (server setting).",
  "share.ttl.ceiling_one": "Links can be valid for at most {days} day (server setting).",
  /* ── dil:paket - the share / access dialog (modals/PermissionsModal.vue). These were ~90 inline (tr, en) pairs: no language pack could reach them, and under any third language the dialog spoke TURKISH. access.ui.emails_comma_separated / access.ui.send / access.ui.mail_not_set_up are the mail-row lines another branch rewrote in the same release, converted at the v0.43.0 merge. */
  "access.ui.level_viewer": "Viewer",
  "access.ui.level_viewer_desc": "view + download",
  "access.ui.level_editor": "Editor",
  "access.ui.level_editor_desc": "read + write + delete",
  "access.ui.level_owner": "Owner",
  "access.ui.level_owner_desc": "edit + manage access",
  "access.ui.never": "Never",
  "access.ui.days": "{days} days",
  "access.ui.days_one": "{days} day",
  "access.ui.unlimited": "Unlimited",
  "access.ui.downloads": "{count} downloads",
  "access.ui.downloads_one": "{count} download",
  "access.ui.inherited_from": "Inherited from",
  "access.ui.whole_storage": "Whole storage",
  "access.ui.storage_root_hint": "Everyone added here reaches every file and folder in this storage, in the web interface, the desktop app and over every protocol. Folder grants inside it stay as they are; where two apply, the higher level counts.",
  "access.ui.access_granted": "Access granted.",
  "access.ui.enter_a_valid_email": "Enter a valid email.",
  "access.ui.recipient_lang": "Recipient's language",
  "access.ui.recipient_lang_server": "The server's language",
  "access.ui.user_created_invite_emailed": "User created, invite emailed.",
  "access.ui.user_created_share_the_temp_password": "User created. Share the temp password.",
  "access.ui.server_limit_applied": "(server limit applied)",
  "access.ui.protect_with_a_pin": "Protect with a PIN",
  "access.ui.expiry": "Expiry",
  "access.ui.download_limit": "Download limit",
  "access.ui.create_link": "Create link",
  "access.ui.replace_link": "Replace the link with these settings",
  "access.ui.replace_link_hint": "The address changes: the current link stops working.",
  "access.ui.create_then_send": "Create a link, then it will be sent to {email}.",
  "access.ui.command_line": "Command line",
  "access.ui.share": "Share",
  "access.ui.existing_links": "Existing links",
  "access.ui.rbac_off_here": "Per-item access control is off on this storage - everyone opens it according to their role, so people added here would change nothing. Turn it on in the admin panel under Storages (this storage → Per-item access control).",
  "access.ui.other_links": "Other links",
  "access.ui.revoke": "Revoke",
  "access.ui.loading": "Loading…",
  "access.ui.name_or_email": "Name or email",
  "access.ui.add": "Add",
  "access.ui.no_account_for_this_email_what_next": "No account for this email - what next?",
  "access.ui.user": "User",
  "access.ui.viewer": "Viewer",
  "access.ui.create_user_grant": "Create user + grant",
  "access.ui.just_send_a_share_link": "Just send a share link →",
  "access.ui.temp_password": "Temp password:",
  "access.ui.people_with_access": "Who has access",
  "access.ui.group": "Group",
  "access.ui.group_title": "The group “{name}” - everyone in it",
  "access.ui.group_owner_confirm": "Owner lets everyone in “{name}” manage who has access here - including sharing it with other people and groups. Give the group Owner?",
  "access.ui.group_owner_give": "Give owner access",
  "access.ui.not_shared_with_anyone_yet": "Not shared with anyone yet.",
  "access.ui.remove": "Remove",
  "access.ui.a_public_link_that_lets_anyone_upload_fi": "A public link that lets anyone UPLOAD files into this folder. Uploaders never see the folder's existing files.",
  "access.ui.hide_upload_limits": "Hide upload limits",
  "access.ui.upload_limits": "Upload limits",
  "access.ui.max_files": "Max files",
  "access.ui.mb_file": "MB / file",
  "access.ui.allowed_types": "Allowed types",
  "access.ui.all_e_g_pdf_jpg": "all (e.g. pdf, jpg)",
  "access.ui.ask_uploader_name": "Ask uploader name",
  "access.ui.emails_comma_separated": "email(s) - comma separated",
  "access.ui.send": "Send",
  "access.ui.mail_not_set_up": "Email is not set up - set it up in the admin panel under Settings (Email / SMTP).",
  /* ── wiring:e2 fxe - single encrypted files (.fxe), streamed downloads ── */
  "e2e.fxe.type": "Encrypted file",
  "e2e.fxe.ctx_encrypt": "Encrypt with E2EE…",
  "e2e.fxe.ctx_download_raw": "Download encrypted file",
  "e2e.fxe.ctx_password": "Change password…",
  "e2e.fxe.ctx_remove": "Remove encryption…",
  "e2e.fxe.encrypt_title": "Encrypt this file",
  "e2e.fxe.encrypt_lead": "“{name}” is encrypted in this browser with a password of its own. The server keeps only ciphertext. The password or the recovery key opens it - here, or offline with filex decrypt.",
  "e2e.fxe.pw_label": "File password",
  "e2e.fxe.hide_label": "Hide the file name too",
  "e2e.fxe.hide_on_hint": "Stored as “{stored}”: the server sees neither the name nor the type. The real name is sealed inside the file and shown once you open it here.",
  "e2e.fxe.hide_off_hint": "Stored as “{stored}”: the name stays readable to the server; the content does not.",
  "e2e.fxe.seen_title": "What the server has already seen",
  "e2e.fxe.seen_lead": "Until now this file was stored in the clear, and encrypting it cannot take that back:",
  "e2e.fxe.seen_trash": "The original goes to the trash and stays there until the trash retention period ends or an administrator empties it. You cannot delete it for good yourself.",
  "e2e.fxe.seen_versions": "Its earlier versions stay in its version history; only an administrator can delete them.",
  "e2e.fxe.seen_thumb": "A thumbnail made from it stays on the server until the original is deleted for good. Its search-index entry is removed when it goes to the trash.",
  "e2e.fxe.seen_backups": "Backups, copies and downloads made before now still hold it.",
  "e2e.fxe.warn_body": "This file opens only with this password or the recovery key shown once after it is encrypted. filex keeps neither. Lose both and the contents are gone for good.",
  "e2e.fxe.escrow_body": "Key escrow is enabled on this installation: its operator holds a key that opens this file without your password.",
  "e2e.fxe.encrypt_submit": "Encrypt",
  "e2e.fxe.encrypt_busy": "Encrypting and uploading… {percent}%",
  "e2e.fxe.size_unknown": "The size of this file is not known yet. Refresh the folder and try again.",
  "e2e.fxe.bad_name": "This name cannot be sealed into an encrypted file (it is over 255 bytes, or holds a slash or a control character). Rename the file first.",
  "e2e.fxe.name_too_long": "The name is too long to add “.fxe” to it. Tick “Hide the file name too”, or rename the file first.",
  "e2e.fxe.encrypted": "“{name}” is encrypted. The original is in the trash.",
  "e2e.fxe.original_kept": "The encrypted copy is saved, but “{name}” could not be moved to the trash. Delete the original yourself.",
  "e2e.fxe.upload_too_big": "This server has no chunked upload, and the file is too large to send in one piece from this browser.",
  "e2e.fxe.unlock_title_open": "Open an encrypted file",
  "e2e.fxe.unlock_title_download": "Download decrypted",
  "e2e.fxe.unlock_title_remove": "Remove encryption",
  "e2e.fxe.unlock_lead": "“{name}” is encrypted. Its password is checked here, in this browser, and is never sent to the server.",
  "e2e.fxe.known_note": "Already opened in this tab - no password needed.",
  "e2e.fxe.use_password": "Use the password instead",
  "e2e.fxe.remove_warn_title": "The plaintext goes back to the server",
  "e2e.fxe.remove_warn_body": "The file is decrypted here and uploaded as a plain file under its original name: the server, its administrators, thumbnails, search and backups can read it again. The encrypted file goes to the trash.",
  "e2e.fxe.unlock_open": "Open",
  "e2e.fxe.unlock_download": "Download",
  "e2e.fxe.unlock_remove": "Remove encryption",
  "e2e.fxe.unlock_busy": "Working…",
  "e2e.fxe.save_again": "Unlocked. Your browser wants one more click before it asks where to save the file.",
  "e2e.fxe.save_button": "Save…",
  "e2e.fxe.progress": "{percent}% done",
  "e2e.fxe.wrong_password": "Wrong password.",
  "e2e.fxe.wrong_recovery": "That recovery key does not open this file.",
  "e2e.fxe.damaged": "This file is damaged or was tampered with (or it changed since it was opened). Nothing was saved.",
  "e2e.fxe.not_readable": "This is not a filex encrypted file, or its header is damaged.",
  "e2e.fxe.unsupported": "This file needs a newer filex (it requires: {features}).",
  "e2e.fxe.downloaded": "“{name}” saved.",
  "e2e.fxe.removed": "Encryption removed: “{name}” is a plain file again. The encrypted file is in the trash.",
  "e2e.fxe.password_title": "Change the file password",
  "e2e.fxe.password_cost": "Only the file’s header changes: the content is sent back byte for byte, and the recovery key keeps working.",
  "e2e.fxe.password_old_copies": "An earlier version of this file - its version history, a backup, a copy someone downloaded - still opens with the OLD password.",
  "e2e.fxe.password_done": "Password changed. The old password no longer opens this file.",
  "e2e.recovery.warn_body_file": "Anyone holding this key can read the file. Keep it somewhere separate from the password - a key stored next to the password protects you from forgetting, not from anyone else.",
  "e2e.recovery.lead_file": "This key opens the file without its password. It is shown once - filex does not store it and cannot show it again.",
  "e2e.dl.ctx_encrypted_copy": "Download encrypted copy",
  "e2e.dl.too_big": "This browser can save at most {limit} of decrypted data at once, and this is {size}. Use Chrome or Edge (they save straight to disk), the filex desktop app, or download the encrypted file and run filex decrypt.",
  "e2e.dl.click_again": "Click Download again to choose where to save it.",
  "e2e.dl.zip_started": "Decrypting into “{name}”…",
  "e2e.dl.zip_done": "“{name}” saved - decrypted, with the real names.",
  "e2e.dl.zip_done_plain": "“{name}” saved. {n} files in it were never encrypted and are in it as they were.",
  "e2e.dl.zip_done_plain_one": "“{name}” saved. {n} file in it was never encrypted and is in it as it was.",
  "e2e.dl.zip_damaged": "A file in the folder is damaged or was tampered with. The download stopped and nothing was saved.",
  "e2e.upload.streaming_unsupported": "This file is over 200 MB, and this server has no chunked upload to send it encrypted piece by piece.",
  /* wiring:e2 fxe escrow - the escrow key opens a single file, and its owner is told */
  "e2e.fxe.use_escrow": "Use the escrow key",
  "e2e.fxe.escrow_warn_title": "The file’s owner will be told",
  "e2e.fxe.escrow_warn_body": "Opening a file with the escrow key notifies its owner, before the file is opened. Use it only when you are entitled to.",
  "e2e.fxe.escrow_predates": "This installation has an escrow key, but this file was encrypted without it (before escrow was turned on here), so the escrow key does not open it. Use the password or the recovery key.",
  "e2e.fxe.escrow_other_key": "This file is sealed to the escrow key of a DIFFERENT installation, so this installation’s escrow key does not open it.",
  "e2e.fxe.wrong_escrow": "That escrow key does not open this file.",
  "e2e.fxe.escrow_notify_failed": "Could not notify the file’s owner, so the file was not opened. Escrow use is always announced.",
  "e2e.fxe.escrow_done": "Opened with the escrow key - the owner has been notified",
  /* wiring:e2 fxe purge - an administrator deletes the original for good */
  "e2e.fxe.seen_trash_admin": "The original goes to the trash and stays there until the trash retention period ends - unless you delete it for good below.",
  "e2e.fxe.seen_versions_admin": "Its earlier versions stay in its version history - unless you delete them for good below.",
  "e2e.fxe.purge_label": "Delete the original for good (administrator)",
  "e2e.fxe.purge_hint": "Its earlier versions and its trash entry are deleted as soon as the encrypted copy is saved, so no plaintext of it stays on this server. There is no undo. Backups and copies made before now are not reached.",
  "e2e.fxe.purge_others": "This file belongs to {owner}, not to you. Delete their original and its versions for good.",
  "e2e.fxe.purge_others_unknown": "This file has no recorded owner - it is not yours. Delete the original and its versions for good.",
  "e2e.fxe.purge_others_required": "Confirm that you are deleting someone else’s file for good.",
  "e2e.fxe.purge_no_id": "This file is not in the catalog yet, so it cannot be deleted for good. Refresh the folder and try again.",
  "e2e.fxe.purged": "“{name}” is encrypted. The original, its versions and its trash entry are deleted for good.",
  "e2e.fxe.purge_failed": "The encrypted copy of “{name}” is saved, but the original could not be deleted for good ({reason}). Delete it from the trash and its version history.",
  /* wiring:e2 fxe big - a decrypted download too large for this browser's memory */
  "e2e.big.title": "Too large to decrypt in this browser",
  "e2e.big.lead": "“{name}” is {size} once decrypted. This browser decrypts a download in its memory and can hold at most {limit} of it, so nothing was downloaded.",
  "e2e.big.lead_grew": "“{name}” grew past {limit} while it was being decrypted. This browser decrypts a download in its memory and cannot hold more, so nothing was saved.",
  "e2e.big.instead": "Decrypt it on your own computer instead:",
  "e2e.big.step_file": "Download the encrypted file, as it is (the button below).",
  "e2e.big.step_folder": "Download the encrypted folder as a zip (the button below) - it carries the folder’s key file.",
  "e2e.big.step_run": "In the folder you saved it to, run filex decrypt and give it the password:",
  "e2e.big.copy": "Copy",
  "e2e.big.copied": "Copied",
  "e2e.big.other_ways": "Chrome, Edge and the filex desktop app decrypt straight to disk, whatever the size.",
  "e2e.big.close": "Close",
  "e2e.big.download_file": "Download encrypted file",
  "e2e.big.download_folder": "Download encrypted folder (zip)",
  /* /wiring:e2 fxe */
  /* ── dil:paket - accessible names that were English literals */
  "breadcrumb.aria": "Breadcrumb",
  "e2e.recovery_key_aria": "Recovery key",
  "modal.close": "Close",
  "modal.busy_close.keep": "Keep going",
  "modal.busy_close.confirm": "Stop and close",
  /* ── the bell and the account menu (2026-09-27: moved here from the admin
     app so the desktop app's explorer draws the same ones). ⚠ SHARED keys:
     the admin app's catalogue has every one of them under the same name, with
     the same English and Turkish (web/tests/i18n/langPackCatalogue.test.ts),
     so a language pack translates each once for both screens. */
  "notifications.bell": "Notifications",
  "notifications.unreadCount": "{n} unread",
  "notifications.title": "Notifications",
  "notifications.markAllRead": "Mark all read",
  "notifications.markRead": "Mark read",
  "notifications.empty": "No notifications yet",
  "notifications.viewAll": "View all",
  "notifications.manageAdmin": "Manage notifications",
  "notifications.openTarget": "Open what this is about",
  "notifications.unreadOnly": "Unread only",
  "notifications.pageOf": "Page {page} of {pages} · {total} in total",
  "notifications.severity.info": "Info",
  "notifications.severity.warning": "Warning",
  "notifications.severity.error": "Error",
  "notifications.severity.critical": "Critical",
  "common.prev": "Previous",
  "common.next": "Next",
  "explore.account": "Account",
  /* ── the user settings dialog (2026-09-27: moved here from the admin app
     so the desktop app opens the same dialog inside its window). ⚠ SHARED
     keys: the admin app's catalogue has each under the same name with the same
     English and Turkish (web/tests/i18n/langPackCatalogue.test.ts). An
     account field's refusal is the server's sentence (POST
     /api/auth/account/check, lib/accountRules), not a key here. */
  "common.cancel": "Cancel",
  "common.close": "Close",
  "common.confirm": "Confirm",
  "common.currentPassword": "Current password",
  "common.email": "Email",
  "common.loading": "Loading…",
  "common.newPassword": "New password",
  "common.remove": "Remove",
  "common.save": "Save",
  "common.saving": "Saving…",
  "errors.generic": "Something went wrong",
  "errors.validationFailed": "Please check the highlighted fields",
  "install.desktopAllDownloads": "All downloads and release notes",
  "install.desktopSubtitle": "Sync folders to this computer and keep them up to date in the background. Available for {platform}.",
  "install.install": "Install",
  "install.menuInstructions": "Open your browser's menu and choose “Install app” or “Add to Home screen”.",
  "install.iosInstructions": "Tap Share (on iOS 26: ⋯, then Share), then “Add to Home Screen” and Add.",
  "nav.themeAuto": "Auto",
  "nav.themeDark": "Dark",
  "nav.themeLight": "Light",
  "notifications.prefs.browser": "Browser notifications",
  "notifications.prefs.browserHint": "Raise a notification outside the tab when something new arrives. Clicking it opens the file, folder or share it is about.",
  "notifications.prefs.desktopHandled": "The desktop app shows these itself",
  "notifications.prefs.enableBrowser": "Allow notifications",
  "notifications.prefs.inApp": "In-app bell",
  "notifications.prefs.inAppHint": "Turning this off empties your bell. Nothing stops being recorded - an admin still sees every event.",
  "notifications.prefs.iosHomeScreen": "On an iPhone or iPad, notifications work in {name} added to the Home Screen (iOS 16.4 or later), not in a browser tab.",
  "notifications.prefs.movedToSettings": "Your own notification settings - the bell, browser pop-ups, which events - are in your user settings.",
  "notifications.prefs.openSettings": "Open my notification settings",
  "notifications.prefs.permDefault": "Permission not asked yet",
  "notifications.prefs.permDenied": "Blocked by this browser",
  "notifications.prefs.permDeniedHint": "Re-allow notifications for this site in your browser settings.",
  "notifications.prefs.permGranted": "Allowed by this browser",
  "notifications.prefs.permUnsupported": "This browser cannot show notifications",
  "notifications.prefs.push": "Push notifications on this device",
  "notifications.prefs.pushAdded": "Added {date}",
  "notifications.prefs.pushDevices": "Devices that receive push notifications",
  "notifications.prefs.pushDisabled": "Turned off on the server (FILEX_PUSH_ENABLED).",
  "notifications.prefs.pushFailed": "Push notifications could not be turned on for this device.",
  "notifications.prefs.pushHint": "What your bell tells you reaches this phone or browser even while {name} is closed - the same notifications, at the same moment.",
  "notifications.prefs.pushKeyUnreadable": "The server's push key no longer opens (FILEX_SECRET_KEY changed). Rotate it under Admin → Notifications.",
  "notifications.prefs.pushNoSecretKey": "Push notifications need FILEX_SECRET_KEY on the server: the key they are signed with is stored encrypted with it.",
  "notifications.prefs.pushOn": "On for this device",
  "notifications.prefs.pushRemove": "Remove",
  "notifications.prefs.pushRemoveLabel": "Remove {device}",
  "notifications.prefs.pushTest": "Send a test",
  "notifications.prefs.pushTestNone": "No device took the test.",
  "notifications.prefs.pushTestSent": "Test sent to {count} devices",
  "notifications.prefs.pushTestSent_one": "Test sent to {count} device",
  "notifications.prefs.pushThisDevice": "This device",
  "notifications.prefs.pushUnavailable": "Not available on this server",
  "notifications.prefs.pushUnnamed": "A device",
  "notifications.prefs.pushUnsupported": "This browser cannot receive push notifications",
  "notifications.prefs.saved": "Preference saved",
  "notifications.prefs.title": "Your notifications",
  "profile.avatar.change": "Change photo",
  "profile.avatar.failed": "That image could not be processed - try another one.",
  "profile.avatar.help": "Shown next to your name, and in the file explorer's collaboration bar - on every client signed in as you. Resized to 160px automatically.",
  "profile.avatar.label": "Profile picture",
  "profile.avatar.notImage": "Please choose an image file.",
  "profile.locale": "Language",
  "profile.passwordChanged": "Password changed",
  "profile.saved": "Profile saved",
  "profile.totp.code": "Verification code",
  "profile.totp.disable": "Disable 2FA",
  "profile.totp.disabled": "Disabled",
  "profile.totp.enable": "Enable 2FA",
  "profile.totp.enabled": "Enabled",
  "profile.totp.recoveryHint": "Save these now - each one signs you in once if you lose your authenticator. They are shown only this time.",
  "profile.totp.recoveryTitle": "Recovery codes",
  "profile.totp.scanHint": "Scan this QR code with your authenticator app, then enter the 6-digit code.",
  "profile.totp.title": "Two-factor authentication",
  "profile.username.label": "Username",
  "quota.title": "Storage quota",
  "quota.tooltip": "{used} of {limit} used ({percent})",
  "quota.unlimitedTooltip": "{used} used · unlimited",
  "userSettings.adminBadge": "Admin",
  "userSettings.demoReadOnly": "This is a shared demo account, so its profile, password and second factor cannot be changed.",
  "userSettings.footNote.ai": "There is nothing on this tab to save.",
  "userSettings.footNote.notifications": "Saved as you change them.",
  "userSettings.footNote.preferences": "Saved as you change them.",
  "userSettings.footNote.profile": "Changes on this tab are saved when you press Save.",
  "userSettings.footNote.security": "Each action here applies on its own.",
  "userSettings.heading": "User settings",
  "userSettings.headingSub": "Manage your profile, preferences, and security.",
  "userSettings.notifications.adminAlerts": "Administrator alerts",
  "userSettings.notifications.adminAlertsHint": "Updates, replicas, sign-in providers, tenant domains and the other alerts for administrators",
  "userSettings.notifications.device": "Desktop notifications",
  "userSettings.notifications.deviceHint": "Your computer's own notifications when something new arrives, also while filex runs in the background.",
  "userSettings.notifications.digestHint": "Kinds marked urgent reach you at once. The rest are held for {minutes} min and arrive as one summary, folder by folder.",
  "userSettings.notifications.digestOffHint": "Every kind reaches you at once. Turn Urgent off for a kind to get it in one summary instead, folder by folder.",
  "userSettings.notifications.events.archive_created": "An archive finishes being created",
  "userSettings.notifications.events.archive_extracted": "An archive finishes extracting",
  "userSettings.notifications.events.comment_added": "Someone comments on a file",
  "userSettings.notifications.events.drop_received": "A file arrives through a request link",
  "userSettings.notifications.events.e2e_escrow_used": "An encrypted folder is opened with the escrow key",
  "userSettings.notifications.events.e2e_password_changed": "The password of your encrypted folder is changed",
  "userSettings.notifications.events.e2e_request_created": "Someone asks to encrypt a folder or a file",
  "userSettings.notifications.events.e2e_request_decided": "Your encryption request is answered",
  "userSettings.notifications.events.file_deleted": "A file is deleted for good",
  "userSettings.notifications.events.file_infected": "A virus is found in a file",
  "userSettings.notifications.events.file_moved": "A file is moved or renamed",
  "userSettings.notifications.events.file_trashed": "A file goes to the trash",
  "userSettings.notifications.events.file_updated": "A file is changed",
  "userSettings.notifications.events.file_upload_failed": "An upload does not finish",
  "userSettings.notifications.events.file_uploaded": "A new file arrives",
  "userSettings.notifications.events.notification_digest": "A summary of the notifications I did not mark urgent",
  "userSettings.notifications.events.plugin_notice": "An installed app sends you a message",
  "userSettings.notifications.events.share_created": "Someone creates a share link",
  "userSettings.notifications.eventsHint": "Turning one off keeps it out of your bell. Nothing stops being recorded - an administrator still sees every event.",
  "userSettings.notifications.eventsTitle": "What to tell me about",
  "userSettings.notifications.urgent": "Urgent",
  "userSettings.notifications.urgentFor": "Tell me at once: {event}",
  "userSettings.open": "User settings",
  "userSettings.prefs.appearance": "Appearance",
  "userSettings.prefs.compact": "Use compact file list",
  "userSettings.prefs.compactHint": "Tighter rows in the file explorer.",
  "userSettings.prefs.remoteImages": "Load remote images in previews",
  "userSettings.prefs.remoteImagesHint": "Pictures from other servers in a file's preview load without asking. Off, each one waits for a click, because loading it tells that server the file was opened. Thumbnails never load them.",
  "userSettings.prefs.desktopApp": "Desktop app",
  "userSettings.prefs.desktopAppHint": "The reminder in the corner of the app can be closed for good - these downloads stay here.",
  "userSettings.prefs.folderView": "Default folder view",
  "userSettings.prefs.folderViewHint": "How a folder you have never changed opens. A folder you have changed keeps its own view - changing this does not touch it.",
  "userSettings.prefs.fvColumns": "Your default columns are customized (set with “Make this my default for all folders”).",
  "userSettings.prefs.fvColumnsReset": "Reset them",
  "userSettings.prefs.fvDir": "Direction",
  "userSettings.prefs.fvDir_asc": "Ascending",
  "userSettings.prefs.fvDir_desc": "Descending",
  "userSettings.prefs.fvForget": "Forget them all",
  "userSettings.prefs.fvInherit": "Server default ({value})",
  "userSettings.prefs.fvMode": "View",
  "userSettings.prefs.fvSort": "Sort by",
  "userSettings.prefs.fvSort_modified": "Modified",
  "userSettings.prefs.fvSort_name": "Name",
  "userSettings.prefs.fvSort_size": "Size",
  "userSettings.prefs.fvSort_type": "Type",
  "userSettings.prefs.fvView_gallery": "Gallery",
  "userSettings.prefs.fvView_grid": "Grid",
  "userSettings.prefs.fvView_list": "List",
  "userSettings.prefs.installApp": "Install as a web app",
  "userSettings.prefs.installAppLead": "Put {name} on this device's home screen: it opens in a window of its own, like an app.",
  "userSettings.prefs.languageHint": "Applies here right away, and is saved on your account for the next browser you sign in from.",
  "userSettings.prefs.mode": "Light or dark",
  "userSettings.prefs.modeHint": "Which variant is painted. Auto follows your operating system.",
  "userSettings.prefs.openTrigger": "Open files with",
  "userSettings.prefs.openTriggerDouble": "Double-click",
  "userSettings.prefs.openTriggerHint": "How a mouse opens a file. On a touchscreen a tap always opens, and the checkbox always selects.",
  "userSettings.prefs.openTriggerSingle": "Single-click",
  "userSettings.prefs.palette": "Color palette",
  "userSettings.prefs.paletteHint": "Which colors that variant is made of. Every palette has a light and a dark version, so this and the setting above work together.",
  "userSettings.prefs.shortcuts": "Keyboard shortcuts",
  "userSettings.prefs.shortcutsEdit": "Edit…",
  "userSettings.prefs.shortcutsHint": "The keys the file manager answers to.",
  "userSettings.prefs.startPage": "Start page",
  "userSettings.prefs.startPageHint": "Where filex opens when you sign in or go to the front door. Following a link straight to a page still takes you there.",
  "userSettings.prefs.startPage_admin": "Admin panel",
  "userSettings.prefs.startPage_files": "Files",
  "userSettings.prefs.startPage_home": "Home",
  "userSettings.prefs.timezone": "Time zone",
  "userSettings.prefs.timezoneHint": "Dates are stored as a moment in time and shown on the clock you pick here, so everyone sees the same instant on their own clock. Saved to your account, so it follows you to another browser.",
  "userSettings.prefs.timezoneNow": "Right now in {zone}: {time}",
  "userSettings.saveChanges": "Save changes",
  "userSettings.scope.account": "Account",
  "userSettings.scope.accountHint": "Saved on your account: the same wherever you sign in.",
  "userSettings.scope.device": "This device",
  "userSettings.scope.deviceHint": "Saved on this device only: another computer, phone or browser keeps its own.",
  "userSettings.scope.deviceNotifyHint": "How this device tells you about something new, saved on this device only.",
  "userSettings.scope.myAccount": "My account",
  "userSettings.scope.myAccountHint": "What reaches your bell, saved on your account.",
  "userSettings.security.passwordTitle": "Change password",
  "userSettings.security.totpDisabled": "Two-factor authentication is off",
  "userSettings.security.totpEnabled": "Two-factor authentication is on",
  "userSettings.subtitle.ai": "Nothing for you to set here yet.",
  "userSettings.subtitle.notifications": "What reaches your bell, and what reaches your desktop.",
  "userSettings.subtitle.preferences": "How this app looks and reads on your devices.",
  "userSettings.subtitle.profile": "Your name, email and picture - what other people see.",
  "userSettings.subtitle.security": "Your password and second factor.",
  "userSettings.tabs.ai": "AI assistant",
  "userSettings.ai.state.on": "The assistant is on.",
  "userSettings.ai.state.off": "The assistant is turned off on this server.",
  "userSettings.ai.state.not_configured": "The administrator has not set the assistant up yet.",
  "userSettings.ai.state.not_permitted": "The assistant is on, but your role does not include it.",
  "userSettings.ai.provider": "Who reads what you write",
  "userSettings.ai.providerHint": "Your messages, and the files the assistant reads for you, are sent to this provider. Every file it reads is in the audit log.",
  "userSettings.ai.confirmAll": "Ask me before every change",
  "userSettings.ai.confirmAllHint": "Off: changes that can be undone (move, rename, edit, delete to the trash) happen at once, with an Undo. On: they wait for your approval too. Anything that cannot be undone always waits.",
  "userSettings.ai.history": "Conversation history",
  "userSettings.ai.retention": "Conversations are kept on the server for {count} days after they were last used.",
  "userSettings.ai.retention_one": "Conversations are kept on the server for {count} day after they were last used.",
  "userSettings.ai.clear": "Delete my conversations",
  "userSettings.ai.clearConfirm": "Delete them all for good?",
  "userSettings.ai.cleared": "Your conversations were deleted.",
  "userSettings.ai.saveFailed": "That could not be saved.",
  "userSettings.tabs.notifications": "Notifications",
  "userSettings.tabs.preferences": "Preferences",
  "userSettings.tabs.profile": "Profile",
  "userSettings.tabs.security": "Security",
  "userSettings.apps.title": "Default apps",
  "userSettings.apps.lead": `Choose one in a file's menu: Open with, Choose an app…, then tick "Always use this app". Only the apps your administrator left on for a kind are offered.`,
  "userSettings.apps.empty": "You have not chosen an app for any kind of file yet: every file opens with what your administrator put first.",
  "userSettings.apps.reset": "Reset",
  "userSettings.apps.resetAll": "Reset all",
  "userSettings.apps.unavailable": "No longer available: it opens with {app} until you choose again.",
  "userSettings.apps.change": "The app that opens {ext} files",
  "userSettings.title": "User settings",
  "users.fields.displayName": "Display name",
  "profile.username.helpText": "Your username. You can sign in with it or with your email - and connection clients (SFTP, FTP) need it, because an @ in the name they sign in with has to be escaped in their config files.",
  "userSettings.prefs.fvKeptCount": "{count} folders keep a view of their own.",
  "userSettings.prefs.fvKeptCount_one": "{count} folder keeps a view of its own."
}, _2 = {
  "toolbar.new_folder": "Yeni klasör",
  "toolbar.upload": "Yükle",
  "toolbar.search": "Ara",
  "toolbar.search.placeholder": "Ada ya da tag: ile ara…",
  "toolbar.view.list": "Liste",
  "toolbar.view.grid": "Izgara",
  "toolbar.refresh": "Yenile",
  "toolbar.go_up": "Üst klasör",
  "ctx.open": "Aç",
  "ctx.preview": "Önizle",
  "ctx.download": "İndir",
  "ctx.archive_create": "Arşiv oluştur…",
  "ctx.archive_extract": "Arşivi çıkar…",
  "ctx.rename": "Yeniden adlandır",
  "ctx.delete": "Sil",
  "ctx.delete_perm": "Kalıcı olarak sil",
  "ctx.restore": "Geri getir",
  "ctx.share": "Paylaş",
  "ctx.move": "Taşı",
  "ctx.copy": "Kopyala",
  "ctx.cut": "Kes",
  "ctx.show_hidden": "Gizli dosyaları göster",
  "ctx.hide_hidden": "Gizli dosyaları gizle",
  "ctx.keep_local": "Bilgisayarda tut",
  "ctx.keep_online": "Yalnızca çevrimiçi tut",
  "ctx.keep_reveal": "Yerel klasörü aç",
  "ctx.keep_inherited": "Üst klasörle bilgisayarda tutuluyor",
  "keep.started": "Bilgisayarda tutulacak - eşitleme başladı",
  "keep.failed": "Bilgisayarda tutulamadı",
  "keep.badge_kept": "Bilgisayarda",
  "keep.badge_syncing": "Eşitleniyor…",
  "keep.badge_cloud": "Yalnızca çevrimiçi",
  "keep.badge_partial": "İçinde bilgisayarda tutulanlar var",
  "keep.strip_transfer": "{name} eşitleniyor - {done}/{total} (%{pct})",
  "keep.strip_inventory": "{name} eşitleniyor - sunucu taranıyor…",
  "keep.strip_settling": "{name} eşitleniyor - son durum kaydediliyor…",
  "ctx.paste": "Yapıştır",
  "ctx.info": "Bilgi",
  "ctx.duplicate": "Kopyasını oluştur",
  "ctx.new_file": "Yeni dosya",
  "modal.delete.title": "Silinsin mi?",
  "modal.delete.message": "{count} öğe çöpe atılacak.",
  "modal.delete.message_one": "{count} öğe çöpe atılacak.",
  "modal.delete.confirm": "Çöpe at",
  "modal.delete.working": "Çöpe taşınıyor…",
  "modal.delete.cancel": "Vazgeç",
  "modal.delete.permanent_title": "Kalıcı olarak silinsin mi?",
  "modal.delete.permanent_message": "{count} öğe kalıcı olarak silinecek. Bu geri alınamaz.",
  "modal.delete.permanent_message_one": "{count} öğe kalıcı olarak silinecek. Bu geri alınamaz.",
  "modal.delete.permanent_confirm": "Kalıcı olarak sil",
  "modal.delete.permanent_working": "Siliniyor…",
  "modal.rename.title": "Yeniden adlandır",
  "modal.rename.save": "Kaydet",
  "modal.rename.saving": "Yeniden adlandırılıyor…",
  "modal.rename.cancel": "Vazgeç",
  "modal.rename.empty": "Bir ad yazın.",
  "modal.newfolder.title": "Yeni klasör",
  "modal.newfolder.placeholder": "Klasör adı",
  "modal.newfolder.create": "Oluştur",
  "modal.newfolder.creating": "Oluşturuluyor…",
  "modal.newfolder.cancel": "Vazgeç",
  "modal.share.title": "Paylaşım bağlantısı",
  "archive.create_title": "Arşiv oluştur",
  "archive.extract_title": "Arşivi çıkar",
  "archive.create_count": "{count} öğe seçildi",
  "archive.create_count_one": "{count} öğe seçildi",
  "archive.filename": "Arşiv adı",
  "archive.format": "Biçim",
  "archive.password_optional": "Parola (isteğe bağlı)",
  "archive.password_confirm": "Parolayı doğrula",
  "archive.password_mismatch": "Parolalar birbiriyle eşleşmiyor.",
  "archive.encrypt_names": "Dosya adlarını şifrele",
  "archive.compression": "Sıkıştırma",
  "archive.solid": "Katı arşiv oluştur",
  "archive.dictionary_size": "Sözlük boyutu",
  "archive.dictionary_size_value": "{n} MiB",
  "archive.dictionary_hint": "Daha büyük sözlükler sıkıştırmayı iyileştirebilir ancak oluşturma ve çıkarma sırasında daha fazla bellek kullanır.",
  "archive.destination_folder": "Çıkarılacak klasör",
  "archive.create": "Oluştur",
  "archive.creating": "Oluşturuluyor…",
  "archive.extract": "Çıkar",
  "archive.extract_here": "Buraya çıkar",
  "archive.extract_to_folder": "Klasöre çıkar",
  "archive.extracting": "Çıkarılıyor…",
  "archive.cancel": "Vazgeç",
  "archive.invalid_name": "Eğik çizgi içermeyen bir dosya adı girin.",
  "archive.invalid_extension": "Arşiv adı kullanılabilir biçim uzantılarından biriyle bitmelidir.",
  "archive.invalid_folder": "Eğik çizgi içermeyen bir klasör adı girin.",
  "archive.password_required": "Bu arşiv için parola gerekiyor.",
  "archive.password_title": "Arşiv parolası",
  "archive.continue": "Devam et",
  "archive.opening": "Açılıyor…",
  "archive.bad_password": "Arşiv parolası yanlış.",
  "archive.target_exists": "Bu ada sahip bir öğe zaten var. Başka bir ad seçin veya önce mevcut öğeyi kaldırın.",
  "archive.password_charset": "ZIP parolasında yalnızca ASCII karakterler kullanılabilir; ç, ğ, ı, İ, ö, ş, ü gibi harfler kullanılamaz. Her karakteri kullanmak için 7z biçimini seçin.",
  "archive.error_unsupported": "Bu arşiv çıkarılamıyor: bu sunucu biçimini okuyamıyor ya da içinde filex’in çıkarmadığı bir şey var (bağlantı, özel dosya ya da boyutunu belirtmeyen bir dosya).",
  "archive.error_limit": "Bu arşiv, sunucunun çıkarmaya izin verdiği boyutu aşıyor.",
  "archive.error_unavailable": "Bu sunucu şu anda bu tür bir arşivi açamıyor.",
  "archive.created": "Arşiv oluşturuldu",
  "archive.queued": "Arşiv oluşturma arka planda çalışıyor",
  "archive.extracted": "{count} dosya çıkarıldı",
  "archive.extracted_one": "{count} dosya çıkarıldı",
  "archive.extraction_queued": "Arşiv çıkarma arka planda çalışıyor",
  "archive.preparing_extract": "{name} okunuyor… çıkarılmadan önce arşivin tamamı okunur.",
  "archive.already_preparing": "{name} hâlâ okunuyor - okuma bitince bir kez çıkarılacak",
  "archive.extraction_completed": "Çıkarma tamamlandı",
  "archive.extraction_cancelled": "Çıkarma {count} dosyadan sonra iptal edildi",
  "archive.extraction_cancelled_one": "Çıkarma {count} dosyadan sonra iptal edildi",
  "modal.share.pin": "PIN koruması",
  "modal.share.expires": "Son kullanma",
  "modal.share.max_downloads": "İndirme limiti",
  "modal.share.create": "Paylaş",
  "modal.share.cancel": "Vazgeç",
  "modal.share.close": "Kapat",
  "modal.share.limit_applied": "(sunucu sınırı uygulandı)",
  "modal.share.copy": "Kopyala",
  "modal.share.url_copied": "Bağlantı kopyalandı",
  "modal.share.pin_copied": "PIN kopyalandı",
  "modal.share.cli_copied": "CLI komutu kopyalandı",
  "upload.progress": "Yükleniyor",
  "upload.done": "Tamamlandı",
  "upload.error": "Hata",
  "upload.failed": "“{name}” yüklenemedi",
  "upload.aborted": "İptal edildi",
  "upload.cancel": "İptal",
  "upload.resuming": "“{name}” %{percent} noktasından devam ediyor",
  "upload.saving": "Depoya kaydediliyor…",
  "empty.folder": "Bu klasör boş",
  "empty.search": "Sonuç bulunamadı",
  loading: "Yükleniyor…",
  "notFound.title": "Klasör bulunamadı",
  "notFound.desc": "Bu klasör mevcut değil, taşınmış ya da erişim yetkiniz yok.",
  "notFound.goRoot": "Kök klasöre dön",
  "col.name": "Ad",
  "col.size": "Boyut",
  "col.modified": "Değiştirilme",
  "col.type": "Tür",
  "unit.bytes": "B",
  "unit.kb": "KB",
  "unit.mb": "MB",
  "unit.gb": "GB",
  "unit.tb": "TB",
  "unit.pb": "PB",
  "breadcrumb.root": "Kök",
  "breadcrumb.copy_path": "Yolu kopyala",
  "breadcrumb.go_to_path": "Yola git",
  "breadcrumb.path_placeholder": "fileman/foo/bar",
  "ops.copy": "Kopyalanıyor",
  "ops.move": "Taşınıyor",
  "ops.delete": "Siliniyor",
  "ops.queued": "sırada",
  "ops.done": "tamamlandı",
  "ops.error": "hata",
  "node.trash": "Çöp kutusu",
  "node.folder": "Klasör",
  // --- Zengin önizleyici chrome ---
  "viewer.open_in_new_tab": "Yeni sekmede aç",
  "viewer.loading": "Yükleniyor…",
  "viewer.failed_to_load": "Dosya yüklenemedi",
  "viewer.peer_not_installed": "Bu tür bir dosya burada gösterilemiyor. Cihazınızda açmak için indirin.",
  "viewer.remote_image.label": "Uzak görsel",
  "viewer.remote_image.title": "Uzak görsel yüklensin mi?",
  "viewer.remote_image.body": "Bu görsel başka bir sunucuda. Yüklerseniz o sunucu bu dosyanın açıldığını ve IP adresinizi öğrenir.",
  "viewer.remote_image.setting_hint": "Sormadan yüklenmeleri için Kullanıcı ayarları → Tercihler bölümünde “Önizlemelerde uzak görselleri yükle” seçeneğini açın.",
  "viewer.remote_image.load": "Görseli yükle",
  "viewer.remote_image.load_all": "Bu dosyadaki tüm uzak görselleri yükle",
  "viewer.remote_image.book_held": "Bu kitapta başka sunuculardaki görseller yüklenmedi.",
  "viewer.remote_image.book_load": "Uzak görselleri yükle…",
  "viewer.format_unsupported_3d": "Önizleme yalnızca .glb, .gltf ve .usdz biçimindeki 3B modelleri gösterir. Dosyayı indirip bir 3B programında açın.",
  "viewer.zoom_in": "Yakınlaştır",
  "viewer.zoom_out": "Uzaklaştır",
  "viewer.fit_width": "Sayfa genişliğine sığdır",
  "viewer.next_page": "Sonraki sayfa",
  "viewer.prev_page": "Önceki sayfa",
  "viewer.page_n_of_m": "Sayfa {n} / {m}",
  "viewer.tags": "Etiketler",
  "viewer.layers": "Katmanlar",
  "viewer.toc": "İçindekiler",
  "viewer.font_smaller": "Yazıyı küçült",
  "viewer.font_larger": "Yazıyı büyüt",
  "viewer.search": "Ara",
  "viewer.download": "İndir",
  "viewer.saving": "Kaydediliyor…",
  "viewer.save": "Kaydet (Ctrl+S)",
  "viewer.saved": "Kaydedildi",
  "viewer.save_error": "Hata",
  "viewer.editor_loading": "Editör yükleniyor…",
  "viewer.no_preview": "Bu dosya tipi için önizleme henüz yok.",
  "viewer.edit": "Düzenle",
  "viewer.close": "Kapat",
  "presence.expand": "Adları göster",
  "presence.collapse": "Küçült",
  "viewer.save_annotations": "Açıklamaları kaydet",
  "viewer.annotations_on": "Açıklamalar: açık",
  "viewer.annotations_off": "Açıklamalar: kapalı",
  "viewer.read_only": "Salt okunur",
  "viewer.csv_first_row_header": "İlk satır başlık olsun",
  "viewer.csv_filter": "Satır filtrele…",
  "viewer.epub_prev": "Önceki",
  "viewer.epub_next": "Sonraki",
  /* ⚠ Eski cümle her okuyucuya bir ORTAM DEĞİŞKENİ söylüyordu ("yönetici
     FILEX_DRAWIO_URL'yi ayarlamalı"). Yalnızca bir diyagrama bakmak isteyen
     kişiye ne yapabileceği; `_admin` - düzeltebilecek kişiye - nereden
     düzelteceği söylenir. */
  "viewer.drawio.disabled": "Diyagramlar burada açılamıyor: bu sunucuda draw.io yok. Başka bir yerde açmak için dosyayı indirin.",
  "viewer.drawio.disabled_admin": "Bu sunucuda draw.io kurulu değil. Yönetim panelinde Dış servisler altından kurabilirsiniz.",
  "viewer.drawio.load_failed": "Bu diyagram okunamadı. Başka bir yerde açmak için indirin.",
  "viewer.drawio.save_failed": "Diyagram kaydedilemedi. Değişiklikleriniz hâlâ düzenleyicide - yeniden deneyin.",
  "viewer.archive.entries": "{n} dosya",
  "viewer.archive.entries_one": "{n} dosya",
  "viewer.archive.empty": "Arşiv boş.",
  "viewer.archive.error": "Arşiv okunamadı.",
  "viewer.archive.unsupported": "Bu tür bir arşiv burada listelenemiyor. İçinde ne olduğunu görmek için indirin.",
  "viewer.archive.too_large": "Bu arşiv burada listelenemeyecek kadar büyük. İçinde ne olduğunu görmek için indirin.",
  "viewer.archive.open": "Arşivi aç",
  "viewer.archive.root": "Arşiv",
  "viewer.archive.location": "Arşiv konumu",
  "viewer.archive.reading": "Hâlâ okunuyor… İçeriği listelenmeden önce arşivin tamamı okunur; büyük bir arşivde bu biraz sürer.",
  "viewer.name": "Ad",
  "viewer.size": "Boyut",
  // --- cila:a - sıralama / tarih grupları / yoğunluk ---
  "col.sort": "Sırala",
  "group.today": "Bugün",
  "group.yesterday": "Dün",
  "group.this_week": "Bu hafta",
  "group.this_month": "Bu ay",
  "group.no_date": "Tarihsiz",
  "toolbar.density.compact": "Sıkışık görünüm",
  "toolbar.density.comfortable": "Rahat görünüm",
  // --- cila:c - komut paleti + kısayol yardımı + breadcrumb ---
  "palette.placeholder": "Dosya, klasör veya komut ara…",
  "palette.files": "Dosyalar",
  "palette.commands": "Komutlar",
  "palette.goto": "Yola git",
  "palette.empty": "Sonuç bulunamadı",
  "palette.hint": "↑↓ gezin · Enter seç · Esc kapat",
  "cmd.view_toggle": "Görünümü değiştir (liste ⇄ ızgara)",
  "cmd.trash": "Çöp kutusunu aç",
  "shortcuts.title": "Klavye kısayolları",
  "shortcuts.group.nav": "Gezinme",
  "shortcuts.group.selection": "Seçim",
  "shortcuts.group.file": "Dosya işlemleri",
  "shortcuts.palette": "Komut paleti",
  "shortcuts.search": "Aramaya odaklan",
  "shortcuts.go_up": "Üst klasöre çık",
  "shortcuts.open": "Seçili öğeyi aç",
  "shortcuts.close": "Kapat / vazgeç",
  "shortcuts.toggle_hidden": "Gizli dosyaları göster/gizle",
  "shortcuts.help": "Bu yardım penceresi",
  "shortcuts.select_all": "Tümünü seç",
  "shortcuts.star": "Yıldızla / yıldızı kaldır",
  "shortcuts.rename": "Yeniden adlandır",
  "shortcuts.delete": "Sil",
  "shortcuts.cut": "Kes",
  "shortcuts.copy": "Kopyala",
  "shortcuts.paste": "Yapıştır",
  "breadcrumb.more": "Aradaki klasörler",
  // --- State screens + undo snackbar + connection badge (cila:b) ---
  "empty.hint": "Dosyaları buraya sürükleyip bırakın",
  "empty.upload": "Dosya yükle",
  "empty.search.title": "Aramanızla eşleşen dosya yok",
  "empty.search.hint": "Farklı bir arama terimi deneyin",
  "empty.trash.title": "Çöp kutusu boş",
  "error.title": "Liste yüklenemedi",
  "error.retry": "Yeniden dene",
  "toast.undo": "Geri al",
  "toast.undone": "Geri alındı",
  "toast.undoing": "Geri alınıyor…",
  "toast.undo_queued": "Geri alma kuyruğa alındı - bittiğini işlemler paneli gösterecek",
  "toast.undo_failed": "Geri alınamadı",
  "toast.renamed": "Yeniden adlandırıldı",
  "toast.rename_queued": "“{name}” olarak yeniden adlandırılıyor…",
  "toast.moved": "Taşındı",
  "toast.trashed": "Çöpe taşındı",
  /* i18n:hardcoded - FileExplorer.vue'da düz string olarak duran, hiçbir dilin
     değiştiremediği bildirim metinleri. */
  "toast.failed": "İşlem başarısız",
  "err.status.400": "Geçersiz istek",
  "err.status.401": "Oturum açmanız gerekiyor",
  "err.status.403": "Bu işlem için yetkiniz yok",
  "err.status.404": "Bulunamadı",
  "err.status.409": "Zaten var / çakışma",
  "err.status.413": "Dosya çok büyük",
  "err.status.415": "Bu dosya türü desteklenmiyor",
  "err.status.422": "Geçersiz veri",
  "err.status.429": "Çok fazla istek, biraz bekleyin",
  "err.status.500": "Sunucu hatası",
  "err.status.501": "Bu işlem desteklenmiyor",
  "err.status.502": "Bağlı bir servis hata verdi",
  "err.status.503": "Servis şu an kullanılamıyor",
  "err.status.504": "Bağlı bir servis zamanında yanıt vermedi",
  "err.status.other": "Sunucu bu isteği kabul etmedi.",
  "err.upload_stalled": "Yükleme ilerlemeyi bıraktı. Yeniden deneyin - kaldığı yerden devam eder.",
  "err.network": "Sunucuya ulaşılamadı. Bağlantınızı kontrol edip yeniden deneyin.",
  /* 0.54: sunucunun adını verdiği ret, sunucunun cümlesiyle söylenir (`message`, server.error.*). */
  "err.save_failed": "Değişiklikleriniz kaydedilemedi.",
  "err.load_failed": "Bu dosya yüklenemedi.",
  "err.viewer_failed": "Bu dosyanın görüntüleyicisi başlatılamadı. Açmak için dosyayı indirin.",
  "err.detail": "Ayrıntı",
  "toast.copied": "Kopyalandı",
  "toast.deleted": "Silindi",
  "toast.cut": "Kesildi",
  "toast.cut_ready": "Kes → Yapıştır hazır",
  "toast.copy_ready": "Kopyala → Yapıştır hazır",
  "toast.same_folder_cut": "Aynı klasöre kesilemez",
  "toast.restored": "{n} öğe geri getirildi",
  "toast.restored_one": "{n} öğe geri getirildi",
  "toast.delete_queued": "Silme kuyruğa alındı",
  "toast.trash_retention": "Çöpteki öğeler saklama süresi sonunda otomatik silinir. Kalıcı silme yönetici panelinden yapılır.",
  /* Kalıcı silinmesi yolda olan çöp satırı (yönetici Çöp sayfasının sözleri:
     iki katalogda tek cümle - ders #447). */
  "trash.purging": "Kalıcı olarak siliniyor…",
  "trash.row_busy": "Bu öğe üzerinde zaten bir iş sürüyor",
  "dropzone.hint": "Dosyaları buraya bırak",
  "modal.newfolder.invalid": "Geçersiz karakter",
  "names.reserved": "“{name}” adı filex’in kendi kullanımına ayrılmış. Başka bir ad seçin.",
  /* ⚠ Eksik ya da bozuk belge sunucusu kelimelerle söylenir, asla HTTP
     katmanıyla değil (eskiden `Config fetch 503: {"error":"onlyoffice not
     configured"}` yazıyordu). `_admin`, düzeltebilecek kişinin okuduğu -
     nereden düzelteceği; diğer herkes dosyayı yine de nasıl alacağını okur. */
  "viewer.office_unconfigured": "Ofis belgeleri burada açılamıyor: bu sunucuda ONLYOFFICE belge sunucusu yok. Dosyayı bilgisayarınızda açmak için indirin.",
  "viewer.office_unconfigured_admin": "Bu sunucuda ONLYOFFICE kurulu değil, bu yüzden ofis belgeleri burada açılamıyor. Yönetim panelinde Dış servisler altından kurabilirsiniz.",
  "viewer.office_unreachable": "Belge sunucusu şu anda yanıt vermiyor. Daha sonra yeniden deneyin ya da dosyayı indirin.",
  "viewer.office_unreachable_admin": "ONLYOFFICE belge sunucusu yanıt vermiyor. Yönetim panelinde Dış servisler altından kontrol edin.",
  /* Görev #92: düzenleyici başka bir kökendeki (belge sunucusunun kendi
     kökeni ya da arayüz kökeni) bir çerçevede çalışır ve o sayfa hiç yanıt
     vermedi - adres bu filex'e ulaşmıyor. */
  "viewer.office_frame_unreachable_admin": "ONLYOFFICE düzenleyici çerçevesi {origin} adresinden yüklenmedi. Oradaki vekil sunucunun çerçeveyi filex'e yönlendirdiğini kontrol edin ({env}).",
  "viewer.office_failed": "Bu belge ONLYOFFICE ile açılamadı. Bilgisayarınızda açmak için indirin.",
  "viewer.csv_office_note": "CSV olarak kaydedilir: yalnızca etkin sayfanın değerleri kalır. Biçimlendirme, formüller ve diğer sayfalar kaydedilmez.",
  "viewer.office_forbidden": "Bu belgeyi ONLYOFFICE ile açma izniniz yok.",
  /* ONLYOFFICE'in "Download failed" (İndirme başarısız) hatasından sonra:
     iki durumdan hangisi olduğu, filex'in gördüğüyle (lib/officeDiagnosis,
     #80). */
  "viewer.office_download_served": "Belge sunucusu bu dosyayı filex’ten indirdi, ancak tarayıcınız dönüştürülmüş kopyayı belge sunucusundan yükleyemedi. Belge sunucusunun önündeki vekil sunucunun X-Forwarded-Proto ve X-Forwarded-Host başlıklarına bakın.",
  "viewer.office_download_not_requested": "Belge sunucusu bu dosyayı filex’ten hiç istemedi. Dosya daha önce açıldıysa belge sunucusu kendi kopyasını kullanıyor olabilir.",
  "viewer.office_download_refused": "filex, belge sunucusunun bu dosya için yaptığı isteği şu nedenle reddetti: {reason}.",
  "viewer.office_fetch_reason.bad_link": "adres bozuktu",
  "viewer.office_fetch_reason.signature_expired": "adresin süresi dolmuştu",
  "viewer.office_fetch_reason.signature_bad": "imzası eşleşmedi (JWT sırrı değişti ya da adres değiştirildi)",
  "viewer.office_fetch_reason.not_found": "dosya artık yok",
  "viewer.office_fetch_reason.storage_unavailable": "depo açılamadı",
  "viewer.office_fetch_reason.body_unavailable": "dosyanın içeriği bulunamadı",
  "viewer.office_fetch_reason.object_missing": "dosya depoda yok",
  "viewer.office_fetch_reason.read_failed": "dosya depodan okunamadı",
  /* Gezginin "Aç" girdisi, belge sunucusu yokken - yalnızca yöneticiye
     gösterilir (diğer herkese girdi hiç sunulmaz; lib/serviceGate). */
  "ctx.needs_onlyoffice": "ONLYOFFICE kurulu değil - yönetim panelinde Dış servisler altından kurun.",
  "ctx.needs_drawio": "draw.io kurulu değil - yönetim panelinde Dış servisler altından kurun.",
  "viewer.pdf_inline_failed": "Tarayıcı PDF'i inline açamadı.",
  "viewer.too_large": "Dosya çok büyük (>1 MB).",
  "viewer.csv_rows": "{n} satır",
  "viewer.csv_rows_one": "{n} satır",
  "presence.others": "{n} kişi",
  "presence.others_one": "{n} kişi",
  "conn.offline": "Canlı bağlantı yok - değişiklikler gecikebilir",
  "conn.tooltip": "Sunucuyla canlı bağlantı kurulamadı; liste belirli aralıklarla otomatik yenilenir. Bağlantı geri gelince bu uyarı kaybolur.",
  /* === bul:s3 === */
  "palette.everywhere": "Her yerde",
  "palette.searching": "Aranıyor…",
  "palette.everywhere_failed": "Arama yapılamadı. Yeniden deneyin.",
  "palette.saved": "Kayıtlı aramalar",
  "palette.save": "Aramayı kaydet",
  "palette.saved.delete": "Kayıtlı aramayı sil",
  /* #168 - yönetim panelinin araması (components/PanelSearch.vue). */
  "panelsearch.label": "Yönetim panelinde ara",
  "panelsearch.trigger": "Ara",
  "panelsearch.placeholder": "Sayfa, ayar, kişi, uygulama ara…",
  "panelsearch.close": "Aramayı kapat",
  "panelsearch.clear": "Aramayı temizle",
  "panelsearch.results": "Arama sonuçları",
  "panelsearch.group.page": "Sayfalar",
  "panelsearch.group.setting": "Ayarlar",
  "panelsearch.group.app": "Uygulamalar",
  "panelsearch.group.user": "Kullanıcılar",
  "panelsearch.group.group": "Gruplar",
  "panelsearch.group.key": "API anahtarları",
  "panelsearch.group.storage": "Depolar",
  "panelsearch.group.share": "Paylaşımlar",
  "panelsearch.group.file": "Dosyalar",
  "panelsearch.group.recent": "Son aramalar",
  "panelsearch.files_all": "Dosyalarda ara: {q}",
  "panelsearch.recent_remove": "Son aramalardan kaldır",
  "panelsearch.recent_clear": "Son aramaları temizle",
  "panelsearch.empty": "“{q}” ile eşleşen bir şey yok.",
  "panelsearch.searching": "Aranıyor…",
  "panelsearch.failed": "Sonuçların bir kısmı yüklenemedi. Gelenler gösteriliyor.",
  "panelsearch.prefixes": "Tek bir türe daraltın:",
  "panelsearch.count_one": "{n} sonuç",
  "panelsearch.count": "{n} sonuç",
  "search.in_content": "İçerikte",
  "search.truncated": "Gösterilenden daha fazla sonuç var - aramanızı daraltın",
  "nav.more_shown": "{total} öğeden {shown} tanesi gösteriliyor",
  "nav.load_more": "Daha fazla yükle",
  /* Katalog kapsamı (docs/LAZY-CATALOGUE.md, lib/catalogCoverage). */
  "coverage.first_scan": "Bu deponun ilk senkronu henüz bitmedi. Bitene kadar arama, klasör boyutları ve kullanım deponun bir kısmını kapsamaz.",
  "coverage.lazy_filling": "filex bu depoyu hâlâ kataloglıyor (şimdiye kadar bulunan klasörlerin %{pct} kadarı tamam). Bitene kadar arama, klasör boyutları ve kullanım deponun bir kısmını kapsamaz.",
  "coverage.lazy_on_open": "Bu depoda yalnız açılan klasörler kataloglanır. Arama, klasör boyutları ve kullanım yalnız bu klasörleri kapsar.",
  "coverage.search_some": "Şu depoların tamamı henüz kataloglanmadı: {names}. Bu arama oradaki bazı dosyaları bulamayabilir.",
  "coverage.catalog_all": "Tümünü katalogla",
  "coverage.catalog_started": "Senkron başladı - deponun tamamı kataloglanıyor.",
  "coverage.catalog_running": "Kataloglanıyor…",
  "coverage.cataloging": "{storage} kataloglanıyor… arka planda sürüyor, bittiğinde bu sayfa söyleyecek.",
  "coverage.catalog_done": "{storage} baştan sona kataloglandı",
  "coverage.catalog_failed": "{storage} kataloglanamadı. Nedenini yönetim panelinde, deponun senkron geçmişinde görebilirsiniz.",
  "coverage.catalog_stopped": "{storage} kataloglaması bitmeden durduruldu",
  "coverage.catalog_joined": "{storage} zaten taranıyordu - bittiğinde bu sayfa haber verecek.",
  "coverage.catalog_gone": "{storage} kataloglanırken kaldırıldı",
  "coverage.catalog_unfollowed": "{storage} arka planda kataloglanmaya devam ediyor; nasıl bittiğini yönetim panelinde deponun senkron geçmişi gösterir",
  "size.at_least": "≥ {size}",
  "size.partial_hint": "Bu klasörün bir kısmı henüz kataloglanmadı; boyutu en az bu kadar.",
  "size.unknown_hint": "Bu klasör henüz kataloglanmadı; boyutu bilinmiyor.",
  /* === bag:b4 === */
  "toolbar.more": "Diğer işlemler",
  "toolbar.search.close": "Aramayı kapat",
  "sheet.menu": "İşlemler",
  "sheet.close": "Kapat",
  /* === koru:k1 === */
  "toolbar.inspector": "Ayrıntılar",
  "ctx.details": "Ayrıntılar",
  /* yildiz:s1 - yıldızlamak bir eylem, menüde de öyle görünür. */
  "ctx.star": "Yıldızla",
  "ctx.unstar": "Yıldızı kaldır",
  "star.failed": "Yıldız değiştirilemedi",
  "shortcuts.inspector": "Ayrıntılar panelini aç/kapat",
  "inspector.title": "Ayrıntılar",
  "inspector.copy_name": "Adı kopyala",
  "inspector.items": "{n} öğe",
  "inspector.items_one": "{n} öğe",
  "inspector.type": "Tür",
  "inspector.select_hint": "Ayrıntılarını görmek için bir öğe seçin.",
  /* pane:p1 - panel SON seçilen şeyi tutar (bakımcının kararı, 2026-09-13);
     dolayısıyla bölünmüş pencerenin bakılmayan yarısındaki bir öğeyi
     anlatıyor olabilir. Bu satır hangisi olduğunu ve nerede durduğunu söyler. */
  "inspector.held": "Son seçilen - {where} içinde",
  "inspector.close": "Kapat",
  "inspector.section.general": "Genel",
  "inspector.section.tags": "Etiketler",
  /* etiket:t1 - TagPicker'ın kendi çerçevesi. 2026-09-13'e kadar bu üçü
     katalogdan bağımsız olarak İngilizce basılıyordu; `tags.open` ise çipin
     yeni "bu etiketi taşıyan her şeyi göster" kapısı. */
  "tags.open": "Etiketi aç: {tag}",
  "tags.add": "+ Etiket ekle",
  "tags.name": "Etiket adı",
  "tags.remove": "Etiketi kaldır",
  /* etiket:k2 (v0.43.0) - etiketin iki TÜRÜ. Etiket nerede çiziliyorsa türünü
     simgeyle birlikte sözcükle de söyler: bu sürüme kadar her etiket sessizce
     sunucudaki herkesle paylaşılıyordu. */
  "tags.kind.label": "Bu etiketi kim görür",
  "tags.kind.personal": "Kişisel",
  "tags.kind.team": "Ekip",
  "tags.kind.personal_help": "Yalnızca siz görürsünüz",
  "tags.kind.team_help": "Bu dosyayı görebilen ekibindeki herkes görür",
  "tags.kind.team_locked": "Ekip etiketi eklemek ya da kaldırmak için bu dosyada düzenleme yetkiniz olmalı.",
  "tags.chip.personal": "Kişisel etiket “{tag}” - yalnızca siz görürsünüz",
  "tags.chip.team": "Ekip etiketi “{tag}” - bu dosyayı görebilen ekibindeki herkes görür",
  "tags.add_submit": "Ekle",
  "inspector.section.versions": "Sürümler",
  "inspector.section.permissions": "İzinler",
  "inspector.section.shares": "Paylaşımlar",
  "inspector.path": "Yol",
  "inspector.size": "Boyut",
  "inspector.modified": "Değiştirilme",
  "inspector.mime": "MIME türü",
  "inspector.etag": "ETag",
  "inspector.nodeId": "Düğüm kimliği",
  "inspector.copy": "Kopyala",
  "inspector.copied": "Kopyalandı",
  "inspector.error": "Yüklenemedi",
  "inspector.items_summary": "{n} öğe, toplam {size}",
  "inspector.items_summary_one": "{n} öğe, toplam {size}",
  "inspector.folder_items": "{n} öğe",
  "inspector.folder_items_one": "{n} öğe",
  "inspector.versions.empty": "Sürüm geçmişi yok",
  "inspector.versions.v": "Sürüm {n}",
  "inspector.versions.restore": "Geri yükle",
  "inspector.versions.restore_confirm": "Bu sürüm geri yüklensin mi?",
  "inspector.versions.snapshot_current": "Önce şimdiki halin sürümünü al",
  "inspector.versions.confirm": "Onayla",
  "inspector.versions.restoring": "Geri yükleniyor…",
  "inspector.versions.cancel": "Vazgeç",
  "inspector.versions.take_snapshot": "Şimdiki halin sürümünü al",
  "inspector.versions.snapshotting": "Sürüm alınıyor…",
  "inspector.versions.restored": "Sürüm geri yüklendi",
  "inspector.versions.snapshotted": "Sürüm alındı",
  "inspector.versions.unsupported": "Sunucu bu işlemi desteklemiyor",
  "inspector.perm.none": "Erişim yok",
  "inspector.perm.viewer": "Görüntüleyen",
  "inspector.perm.editor": "Düzenleyen",
  "inspector.perm.owner": "Sahip",
  "inspector.perm.manage": "İzinleri yönet",
  "inspector.shares.empty": "Paylaşım bağlantısı yok",
  "inspector.shares.copy": "Bağlantıyı kopyala",
  /* wiring:c1 - tema galerisi */
  "theme.menu": "Tema",
  "theme.title": "Tema galerisi",
  "theme.hint": "Tema yalnız renk paletini değiştirir; gündüz mü gece mi olduğu yukarıdaki seçim.",
  "theme.mode.label": "Görünüm",
  "theme.mode.light": "Gündüz",
  "theme.mode.dark": "Gece",
  "theme.mode.auto": "Otomatik",
  "theme.reset": "Varsayılana dön",
  "theme.close": "Kapat",
  "theme.selected": "Seçili",
  "theme.name.default": "Varsayılan",
  "theme.name.night": "Gece mavisi",
  "theme.name.forest": "Orman",
  "theme.name.amber": "Kehribar",
  "theme.name.lilac": "Leylak",
  "theme.name.contrast": "Yüksek kontrast",
  "theme.name.gray": "Yumuşak gri",
  "theme.name.terminal": "Terminal yeşili",
  /* === zaman:z3 - saat dilimi seçici (gömme penceresi + web ayarları) === */
  "tz.menu": "Saat dilimi",
  "tz.title": "Saat dilimi",
  "tz.label": "Tarihleri şu saatle göster",
  "tz.search": "Şehir, ülke ya da saat farkı arayın - “İstanbul” veya “GMT+3” deneyin",
  "tz.default.device": "Bu cihazın saat dilimini kullan ({zone})",
  "tz.default.account": "Hesabınızın saat dilimini kullan ({zone})",
  "tz.default.host": "Bu sitenin varsayılanını kullan ({zone})",
  "tz.no_match": "“{query}” ile eşleşen saat dilimi yok. Bir şehir, bir ülke ya da GMT+3 gibi bir fark deneyin.",
  "tz.more": "{n} kayıt daha var - listeyi daraltmak için yazmayı sürdürün.",
  "tz.hint": "Yalnızca bu tarayıcıda saklanır. Her tarih tek bir an olarak saklanır ve burada seçtiğiniz saatle gösterilir.",
  "tz.now": "{zone} bölgesinde şu an: {time}",
  /* #275 - gömmenin kendi dil ayarı ("⋯" → Dil), bu tarayıcıda tutulur */
  "lang.menu": "Dil",
  "lang.title": "Dil",
  "lang.label": "Arayüz dili",
  "lang.default.browser": "Tarayıcının dili ({lang})",
  "lang.default.account": "Hesabınızın dili ({lang})",
  "lang.default.host": "Bu sitenin varsayılanı ({lang})",
  "lang.default.default": "Varsayılan ({lang})",
  "lang.hint": "Yalnızca bu tarayıcıda saklanır.",
  "lang.hint_account": "Bu tarayıcıda ve hesabınızda saklanır; diğer cihazlarınız ve bildirimleriniz de bu dili kullanır.",
  /* === wiring:c2 - özelleştirilebilir kısayollar + hızlı bakış === */
  "shortcuts.quicklook": "Hızlı bakış",
  "shortcuts.customize": "Özelleştir",
  "shortcuts.settings.menu": "Kısayollar",
  "shortcuts.settings.title": "Kısayol ayarları",
  "shortcuts.settings.hint": 'Bir kısayolu değiştirmek için "Değiştir"e basıp yeni tuş kombinasyonuna basın. Değişiklikler yalnızca bu tarayıcıda saklanır.',
  "shortcuts.settings.change": "Değiştir",
  "shortcuts.settings.capture": "Tuşlara basın… (Esc iptal)",
  "shortcuts.settings.reset": "Varsayılana dön",
  "shortcuts.settings.reset_all": "Tümünü sıfırla",
  "shortcuts.settings.unbound": "Atanmadı",
  "shortcuts.settings.fixed": "Sabit",
  "shortcuts.settings.customized": "Özelleştirildi",
  "shortcuts.settings.conflict": 'kombinasyonu "{name}" kısayolunda kullanılıyor.',
  "shortcuts.settings.conflict_fixed": 'kombinasyonu "{name}" sabit kısayoluna ayrılmış - kullanılamaz.',
  "shortcuts.settings.conflict_take": "Eskisini boşa çıkar ve ata",
  "shortcuts.settings.conflict_cancel": "Vazgeç",
  "quicklook.hint_close": "kapat",
  "quicklook.hint_nav": "önceki/sonraki",
  "quicklook.hint_open": "aç",
  /* === /wiring:c2 === */
  /* === wiring:c3 - işlem merkezi === */
  "opc.title": "İşlemler",
  "opc.aria_badge": "{n} işlem - işlem merkezini aç/kapat",
  "opc.aria_badge_one": "{n} işlem - işlem merkezini aç/kapat",
  "opc.close": "Kapat",
  "opc.active": "Sürüyor",
  "opc.history": "Geçmiş",
  "opc.clear": "Temizle",
  "opc.empty": "İşlem yok",
  "opc.cancel": "İptal",
  "opc.retry": "Yeniden dene",
  "opc.dismiss": "Kapat",
  "opc.queued": "Sırada",
  "opc.cancelling": "İptal isteniyor…",
  "opc.percent": "%{n}",
  "opc.items": "{total} öğeden {done}",
  "opc.trash_items": "Çöpten {n} öğe",
  "opc.trash_items_one": "Çöpten {n} öğe",
  "opc.status.running": "Sürüyor",
  "opc.status.done": "Bitti",
  "opc.status.error": "Hata",
  "opc.status.aborted": "İptal edildi",
  "opc.kind.upload": "Yükleme",
  "opc.kind.copy": "Kopyalama",
  "opc.kind.move": "Taşıma",
  "opc.kind.delete": "Silme",
  "opc.kind.rename": "Yeniden adlandırma",
  "opc.kind.restore": "Geri getirme",
  "opc.kind.purge": "Kalıcı silme",
  "opc.kind.convert": "Dönüştürme",
  "opc.kind.archive": "Arşiv",
  "opc.kind.plugin": "Uygulama",
  "opc.kind.trash": "Çöp kutusunu boşaltma",
  "opc.kind.thumbs": "Küçük resim onarımı",
  /* A folder's contents on hover (FolderPeek, useFolderPeek). */
  "peek.items": "{n} öğe",
  "peek.items_one": "{n} öğe",
  "peek.more": "+{n} tane daha",
  "peek.empty": "Boş",
  "peek.loading": "İçine bakılıyor…",
  "opc.open": "Aç",
  /* Uygulama eklentileri - dosya menüsüne eklenen satırlar ve kuyruğa
     aldıkları işler (docs/APP-PLUGINS-API.md). */
  "plugin.queued": "{label} kuyruğa alındı",
  "plugin.done": "{label} tamamlandı",
  "plugin.failed": "{label} başarısız",
  "plugin.cancel_failed": "İş iptal edilemedi",
  "plugin.not_applicable": "Bu işlem seçime uygulanamaz",
  "plugin.needs_engine": "{name} bu sunucuda kurulu değil - sunucuya kurup filex'i yeniden başlatın.",
  "plugin.needs_other": "{name} bu sunucuda kullanılamıyor.",
  "plugin.needs_office": "Ofis belgeleri için bir ofis motoru gerekiyor ve bu sunucuda çalışan yok - Ofis düzenleyici uygulamasını kurun (Uygulamalar) ya da Dış servisler sayfasından {name} bağlayın.",
  "plugin.confirm.title": "Onayla",
  "plugin.confirm.cancel": "Vazgeç",
  "plugin.confirm.run": "Çalıştır",
  "plugin.view.close": "Kapat",
  "appframe.confirm_title": "Onay",
  "appframe.consent_clipboard": "{app} panonuza metin kopyalamak istiyor.",
  "appframe.consent_download": "{app}, “{name}” dosyasını bilgisayarınıza kaydetmek istiyor.",
  "appframe.consent_print": "{app}, “{name}” belgesini yazdırmak istiyor.",
  "appframe.consent_job": "{app} “{action}” işini başlatmak istiyor.",
  "appframe.consent_allow": "İzin ver",
  "appframe.consent_deny": "İzin verme",
  "appframe.unsaved_title": "Kaydedilmemiş değişiklikler",
  "appframe.state_no_account": "Uygulamanın şifreli bir dosya için ayarları, oturum açtığınız hesaba göre mühürlenerek saklanır; bu sayfa hangi hesap olduğunu öğrenemedi, bu yüzden hiçbir şey saklanmadı. Yeniden oturum açın ya da dosyayı oturum açtığınız yerde açın.",
  "appframe.unsaved_text": "{app} içinde kaydedilmemiş değişiklikler var. Yine de kapatılsın mı?",
  "appframe.discard": "Kaydetmeden kapat",
  "appframe.keep_open": "Düzenlemeye devam et",
  "appframe.save_close": "Kaydet ve kapat",
  "appframe.updated": "{app}, {version} sürümüne güncellendi.",
  "appframe.updated_reload": "Bir yönetici {app} uygulamasının yeni sürümünü onayladı. Yeni sürümü kullanmak için yeniden yükleyin - önce çalışmanızı kaydedin.",
  "appframe.reload": "Yeniden yükle",
  "appframe.dismiss": "Kapat",
  "appframe.not_connected": "{app} başlamadı. Kapatıp yeniden açın; tekrar ederse yöneticinize haber verin.",
  "appframe.save_as_title": "{app}: “{name}” nereye kaydedilsin?",
  "plugin.view.busy": "Çalışıyor…",
  "plugin.view.unsupported": "Bu ekran, bu sürümün çizemediği bir bileşen kullanıyor ({type})",
  "plugin.view.error": "Uygulama hata döndürdü",
  "plugin.output_missing": "Çıktı artık eski yerinde değil",
  /* M2 - surface components (components/plugin/nodes/*) */
  "plugin.view.loading": "Yükleniyor…",
  "plugin.view.preview_failed": "Önizleme yüklenemedi",
  "plugin.steps.label": "Adımlar",
  "plugin.list.empty": "Henüz bir şey yok",
  "plugin.list.actions": "İşlemler",
  /* The label on a table row's ONE action control (core RowActions.vue).
     The explorer's handle is the ⋮ glyph; a panel row's says what it is.
     Owner, 2026-09-20: "adminde 'Aksiyon' diye yazmalı". */
  "row.actions": "Aksiyon",
  "plugin.people.placeholder": "Ad veya e-posta",
  "plugin.people.placeholder_email": "E-posta adresi",
  "plugin.people.add": "Ekle",
  "plugin.people.remove": "{name} kişisini kaldır",
  "plugin.people.invalid_email": "Geçerli bir e-posta adresi girin",
  "plugin.people.external_off": "Yalnızca hesabı olan kişiler eklenebilir",
  "plugin.pin.label": "PIN",
  "plugin.file.choose": "Seç…",
  "plugin.file.clear": "Temizle",
  "plugin.file.none": "Seçim yok",
  /* M3 - imza yolu: signature-pad + pdf-fields düğümleri ve dış katılımcının
     herkese açık sayfası (views/PublicSurface.vue, usePublicPage). */
  "plugin.sig.mode_draw": "Çiz",
  "plugin.sig.mode_type": "Yaz",
  "plugin.sig.mode_upload": "Yükle",
  "plugin.sig.draw_hint": "Parmağınızla ya da fareyle buraya imzalayın",
  "plugin.sig.type_placeholder": "Adınızı yazın",
  "plugin.sig.upload_pick": "Görsel seç…",
  "plugin.sig.upload_hint": "PNG ya da JPEG, en çok {kb} KB",
  "plugin.sig.upload_too_big": "Görsel {kb} KB sınırından büyük",
  "plugin.sig.upload_bad_type": "Yalnızca PNG ya da JPEG görsel kullanılabilir",
  "plugin.sig.upload_unreadable": "Görsel okunamadı",
  "plugin.sig.clear": "İmzayı temizle",
  "plugin.sig.signed": "İmza alındı",
  "plugin.pdf.load_failed": "Belge yüklenemedi",
  "plugin.pdf.palette": "Alan türleri",
  "plugin.pdf.pending": "Yeri bekleyen kutular",
  "plugin.pdf.place_box_hint": "“{name}” kutusunun gideceği yere dokunun ya da boyutlandırmak için sürükleyin",
  "plugin.pdf.all_placed": "Her kutunun bir yeri var",
  "plugin.pdf.place_idle": "Yukarıdaki kutulardan birini seçin, sonra sayfada gideceği yere dokunun.",
  "plugin.pdf.place_idle_done": "Kaldırmak ya da kopyalamak için sayfadaki bir kutuya dokunun; taşımak için sürükleyin.",
  "plugin.pdf.no_boxes": "Henüz kutu yok. Aşağıdan ekleyin: adını verin, kimin olduğunu söyleyin; yerini bir sonraki adımda belgede seçeceksiniz.",
  "plugin.pdf.add_box": "Kutu ekle",
  "plugin.pdf.unplace": "Sayfadan kaldır",
  "plugin.pdf.place_hint": "{type} alanının gideceği yere dokunun ya da boyutlandırmak için sürükleyin",
  "plugin.pdf.type_signature": "İmza",
  "plugin.pdf.type_initials": "Paraf",
  "plugin.pdf.type_date": "Tarih",
  "plugin.pdf.type_text": "Metin",
  "plugin.pdf.type_checkbox": "Onay kutusu",
  "plugin.pdf.tap_signature": "İmzalamak için dokunun",
  "plugin.pdf.tap_initials": "Paraflamak için dokunun",
  "plugin.pdf.tap_date": "Bugünün tarihi için dokunun",
  "plugin.pdf.tap_text": "Metin",
  "plugin.pdf.tap_checkbox": "İşaretlemek için dokunun",
  "plugin.pdf.label": "Ad",
  "plugin.pdf.assignee": "İmzacı",
  "plugin.pdf.unassigned": "Herkes",
  "plugin.pdf.filled_by": "Dolduran",
  "plugin.pdf.style": "Nasıl imzalanır",
  "plugin.pdf.style_drawn": "Çizerek",
  "plugin.pdf.style_typed": "Yazarak",
  "plugin.pdf.lines": "Altına yazılanlar",
  "plugin.pdf.lines_preview": "İmzanın altında:",
  "plugin.pdf.lines_none": "Bu imzanın altına bir şey yazılmaz.",
  "plugin.pdf.required": "Zorunlu",
  "plugin.pdf.copy_to_page": "Sayfaya kopyala",
  "plugin.pdf.copy": "Kopyala",
  "plugin.pdf.delete": "Alanı sil",
  "plugin.pdf.zoom_in": "Yakınlaştır",
  "plugin.pdf.zoom_out": "Uzaklaştır",
  "plugin.pdf.zoom_fit": "Genişliğe sığdır",
  "plugin.pdf.zoom_fit_page": "Sayfayı ekrana sığdır",
  "plugin.pdf.pad_for": "{type} alanınız",
  "plugin.pdf.pad_done": "Tamam",
  "plugin.page.loading": "Yükleniyor…",
  "captcha.label": "Doğrulama",
  "captcha.progress": "Doğrulama ilerlemesi",
  "captcha.fallback_intro": "Doğrulama servisine ulaşılamıyor; tarayıcınız onun yerine kısa bir doğrulama hesabı yapıyor…",
  "captcha.fallback_done": "Doğrulama tamamlandı.",
  "captcha.fallback_failed": "Doğrulama tamamlanamadı. Sayfayı yenileyip yeniden deneyin.",
  "captcha.widget_failed": "Doğrulama kutusu yüklenemedi. Bir içerik engelleyici açıksa bu sayfaya izin verip sayfayı yenileyin.",
  "captcha.invalid": "Doğrulama başarısız oldu. Lütfen yeniden deneyin.",
  "captcha.unavailable": "Doğrulama şu anda kullanılamıyor. Birkaç dakika sonra yeniden deneyin.",
  "plugin.page.pin_title": "Bu sayfa korumalı",
  "plugin.page.pin_hint": "Devam etmek için size verilen PIN'i girin",
  "plugin.page.pin_submit": "Devam et",
  "plugin.page.pin_wrong": "Bu PIN doğru değil",
  "plugin.page.pin_locked": "Çok fazla yanlış PIN girildi - birkaç dakika bekleyip yeniden deneyin",
  "plugin.page.unavailable_title": "Bu bağlantı kullanılamıyor",
  "plugin.page.unavailable_text": "Süresi dolmuş, hakkı tükenmiş ya da geri çekilmiş olabilir. Gönderen kişiden yeni bir bağlantı isteyin.",
  "plugin.page.accepted_title": "Alındı, teşekkürler",
  "plugin.page.accepted_text": "Yanıtınız kaydedildi. Bu sayfayı kapatabilirsiniz.",
  "plugin.page.done_title": "Tamamlandı",
  "plugin.page.done_text": "Burada yapılacak başka bir şey kalmadı. Bu sayfayı kapatabilirsiniz.",
  "plugin.page.error_title": "Bir sorun oluştu",
  "plugin.page.retry": "Yeniden dene",
  "plugin.page.files": "Belgeler",
  "plugin.page.open_file": "{name} dosyasını yeni sekmede aç",
  "plugin.page.footer": "filex ile sunuldu",
  /* Herkese açık sayfaların (paylaşım, dosya isteği) kendi cümleleri
     sunucunundur: `server.public.*` (composables/usePublicText). */
  /* === Uygulama eklentileri v2 - `page` görünümü, uygulamanın dosya kilidi,
     işin yazdığı çıktı kipi, imza alanının yazı tipleri ve kuralları. === */
  "plugin.page_view.back": "Dosyalara dön",
  "plugin.page_view.queued_title": "İş kuyruğa alındı",
  "plugin.page_view.queued_text": "filex işi yürütüyor. Bittiğinde bu sayfa söyler; ilerleyişi işlemler tepsisinde de görünür.",
  "plugin.page_view.finished_title": "İş bitti",
  "plugin.page_view.finished_text": "Burada yapılacak başka bir şey kalmadı. Dosyalara dönebilir ya da bu sekmeyi kapatabilirsiniz.",
  "plugin.page_view.failed_title": "İş tamamlanamadı",
  "plugin.page_view.opening_title": "Sonuç açılıyor",
  "plugin.page_view.open_ops": "İşlemler tepsisini aç",
  "plugin.page_view.done_title": "Tamamlandı",
  "plugin.page_view.done_text": "Burada yapılacak başka bir şey kalmadı. Bu sekmeyi kapatabilirsiniz.",
  "plugin.page_view.error_title": "Bu ekran açılamadı",
  "plugin.page_view.retry": "Yeniden dene",
  "plugin.page_view.blocked": "Yeni sekme engellendi - bu site için açılır pencerelere izin verin, yoksa ekran pencere içinde açılır",
  "plugin.output.sibling": "yeni dosya",
  "plugin.output.version": "yeni sürüm",
  "plugin.output.sibling_title": "Sonuç, aslının yanına yeni bir dosya olarak iner",
  "plugin.output.version_title": "Sonuç, dosyanın yerine yeni bir sürümü olarak geçer",
  "plugin.sign.font_label": "El yazısı",
  "plugin.pdf.font": "Yazı tipi",
  "plugin.pdf.rule_number": "Yalnızca sayı",
  "plugin.pdf.rule_email": "E-posta adresi",
  "plugin.pdf.rule_length": "{min} ile {max} karakter arasında",
  "plugin.pdf.rule_min": "En az {min} karakter",
  "plugin.pdf.rule_max": "En çok {max} karakter",
  "plugin.pdf.err_number": "Bir sayı girin",
  "plugin.pdf.err_email": "Geçerli bir e-posta adresi girin",
  "plugin.pdf.err_min": "Çok kısa - en az {min} karakter",
  "plugin.pdf.err_max": "Çok uzun - en çok {max} karakter",
  "applock.badge": "Kilitli",
  "applock.some_app": "bir uygulama",
  "applock.held": "{app} bu dosyayı kilitledi",
  "applock.held_reason": "{app} bu dosyayı kilitledi: {reason}",
  "applock.until": "- {date} tarihine kadar",
  "applock.inspector": "Uygulama kilidi",
  /* issue #34 - sunucunun İZLEMEDİĞİ sembolik bağ (lib/symlink). Rozet satırdaki
     kısa söz; `why` ise arkasındaki cümle - üzerine gelince, ayrıntılar panelinde
     ve biri açmaya kalkıştığında çıkan bildirimde. ⚠ Kırık bağ ile depo dışına
     çıkan bağ AYRI durumlardır ve ayrı okunmalıdır: yalnızca birinin yönetici
     çaresi vardır; silinmiş bir hedef için o çareyi önermek insanı işe yaramayacak
     bir ayar ekranına yollar. */
  "symlink.badge.outside_root": "Depo dışında",
  "symlink.badge.broken": "Kırık bağ",
  "symlink.badge.unresolved": "Uzak bağ",
  "symlink.badge.unknown": "Bağlantı",
  "symlink.why.outside_root": 'Hedefi bu deponun dışında kalan bir bağ; bu yüzden açılamıyor. Bir yönetici, deponun ayarlarındaki "Bu klasörün dışına çıkan sembolik bağları izle" seçeneğiyle buna izin verebilir.',
  "symlink.why.broken": "Hedefi artık var olmayan bir bağ; açılacak bir şey yok. Sunucuda onarılması ya da kaldırılması gerekir - hiçbir ayar silinmiş hedefi geri getirmez.",
  "symlink.why.unresolved": "Uzak sunucudaki bir bağ. filex hedefinin bu deponun içinde olup olmadığını bilemediği için bağı izlemez ve açamaz.",
  "symlink.why.unknown": "filex'in izlemediği bir bağ, bu yüzden açılamıyor. Hedefi ya bu deponun dışında, ya kayıp, ya da filex'in çözümleyemediği uzak bir sunucuda.",
  "symlink.inspector": "Açılamayan bir bağ",
  "unavailable.why.file": "Depo bu dosyanın hâlâ var olup olmadığını söyleyemedi. Depo yeniden yanıt verene kadar dosya açılamaz ve değiştirilemez; bir sonraki tarama yeniden denetler.",
  "unavailable.why.dir": "Depo bu klasörün hâlâ var olup olmadığını söyleyemedi. Depo yeniden yanıt verene kadar ne klasör ne de içindekiler açılabilir ya da değiştirilebilir; bir sonraki tarama yeniden denetler.",
  "unavailable.withReason": "{why} Deponun yanıtı: {reason}",
  "unavailable.inspector": "Kullanılamıyor",
  /* 0.50 - why a file has no thumbnail, on the file itself (lib/thumbNote). */
  "thumbNote.corrupt": "Bozuk",
  "thumbNote.corrupt_why": "Küçük resim yok: dosya okunamadı. Bozuk ya da eksik olabilir.",
  "thumbNote.encrypted": "Şifreli",
  "thumbNote.encrypted_why": "Küçük resim yok: dosya şifreli ya da parolayla korunuyor.",
  "thumbNote.too_large": "Çok büyük",
  "thumbNote.too_large_why": "Küçük resim yok: dosya, küçük resim boyut sınırından büyük.",
  "thumbNote.full": "{label}. {why}",
  "plugin.pdf.rule": "Kabul ettiği",
  "plugin.pdf.rule_kind_any": "Serbest metin",
  "plugin.pdf.rule_kind_number": "Yalnızca sayı",
  "plugin.pdf.rule_kind_email": "E-posta adresi",
  "plugin.pdf.rule_min_label": "En az uzunluk",
  "plugin.pdf.rule_max_label": "En çok uzunluk",
  "plugin.pdf.format": "Tarih biçimi",
  "plugin.pdf.date_order": "Tarih sırası",
  "plugin.pdf.date_separator": "Ayraç",
  "plugin.pdf.date_example": "Örnek",
  "opc.kind.archive-create": "Arşiv oluşturuluyor",
  "opc.kind.archive-extract": "Arşiv çıkarılıyor",
  /* === wiring:c4 - onboarding turu + erişilebilirlik + hata kartı === */
  "tour.aria": "Tanıtım turu",
  "tour.restart": "Turu tekrar başlat",
  "tour.skip": "Turu atla",
  "tour.back": "Geri",
  "tour.next": "İleri",
  "tour.done": "Bitti",
  "tour.progress": "{n} / {m}",
  "tour.step.nav.title": "Depolar ve görünümler",
  "tour.step.nav.desc": "Ana sayfa, Benimle paylaşılanlar, Son kullanılanlar, Yıldızlılar ve Çöp kutusu hep bu panelde durur; altında da depolarınız ve bağlantılarınız. Sol üst köşedeki düğme paneli ince bir şeride indirir ve geri açar.",
  "tour.step.nav.desc_closed": "Bu düğme gezinti panelini açar: Ana sayfa, Benimle paylaşılanlar, Son kullanılanlar, Yıldızlılar ve Çöp kutusu; altında da depolarınız ve bağlantılarınız.",
  "tour.step.new.title": "Yeni bir şey ekle",
  "tour.step.new.desc": "Yeni olan her şey buradan başlar: bu cihazdan dosya yükleyebilir, klasör oluşturabilir ya da birinden dosya isteyebilirsiniz. Dosyaları pencereye sürükleyip bırakmak da yükler.",
  "tour.step.new.desc_fab": "Bu düğme bu cihazdan dosya yükler. Dosyaları pencereye sürükleyip bırakmak da çalışır.",
  "tour.step.search.title": "Arama",
  "tour.step.search.desc": 'Bu alan deponun tamamında ada göre arar; ayraçları ve bir harflik yazım hatasını affeder, yani "fatura 2026" yazdığınızda fatura_2026.pdf gelir. tag:fatura yazarak etikete göre filtreleyebilirsiniz. Yanındaki sürgü düğmesi gelişmiş aramayı, {palette} ise komut paletini açar; palet komut da çalıştırır.',
  "tour.step.crumb.title": "Bulunduğunuz yer",
  "tour.step.crumb.desc": "Bu iz, ekrandaki klasörün adresidir. Adımlardan birine tıklayarak üste çıkabilir, sonuncusunun yanındaki oktan içindeki klasörleri görebilirsiniz.",
  "tour.step.filters.title": "Listeyi daralt",
  "tour.step.filters.desc": "Tür, Sahibi, Değiştirilme ve Boyut bulunduğunuz klasörü filtreler; yanındaki kutu siz yazdıkça adlara göre eşleşir, satırın sonundaki denetim ise sıralar.",
  "tour.step.view.title": "Görünümü değiştir",
  "tour.step.view.desc": "Bu klasörün nasıl çizildiğini değiştirir; seçiminiz hatırlanır.",
  "tour.step.details.title": "Ayrıntılar ve paylaşım",
  "tour.step.details.desc": 'Bir dosyayı seçip bu paneli açtığınızda ayrıntılarını, hareketlerini ve paylaşım bağlantılarını görürsünüz. Tam menü için dosyaya sağ tıklayın ya da satırının sonundaki düğmeyi kullanın: oradaki "Paylaş" ile PIN ve son kullanma süresi verilebilen bir bağlantı oluşturulur.',
  "tour.step.help.title": "Kısayollar",
  "tour.step.help.desc": '{help} tuşu kısayol kartını, {palette} komut paletini açar. Tema ve "Turu tekrar başlat" sağ üstteki "Diğer işlemler" menüsünde; hesabınız ve oturumu kapatma ise yanındaki avatarın arkasında.',
  "error.hint": "Bağlantı ya da sunucu kaynaklı geçici bir sorun olabilir. Yeniden deneyin.",
  "error.details": "Teknik ayrıntılar",
  "col.star": "Yıldız",
  "toolbar.view_label": "Görünüm",
  "list.aria": "Dosya listesi",
  "grid.aria": "Dosya ızgarası",
  /* === wiring:d1 - sekmeler + split panel === */
  "tabs.strip": "Sekmeler",
  "tabs.new": "Yeni sekme",
  "tabs.close": "Sekmeyi kapat",
  "tabs.split": "Görünümü böl",
  "tabs.split_off": "Bölmeyi kapat",
  "ctx.open_new_tab": "Yeni sekmede aç",
  "ctx.open_with": "{app} ile aç",
  "ctx.open_with_builtin": "Yerleşik görüntüleyiciyle aç",
  "ctx.open_with_choose": "Uygulama seç…",
  "openWith.title": "Birlikte aç",
  "openWith.lead": "{name} hangi uygulamayla açılsın?",
  "openWith.builtin": "filex görüntüleyicisi (yerleşik)",
  "openWith.onlyoffice": "ONLYOFFICE (tablo düzenleyici)",
  "openWith.now": "Şu an bununla açılıyor",
  "openWith.always": "{ext} dosyalarını her zaman bu uygulamayla aç",
  "openWith.hint": "Hesabınızda saklanır. Ayarlar, Varsayılan uygulamalar bölümünden değiştirebilirsiniz.",
  "openWith.open": "Aç",
  "shortcuts.group.tabs": "Sekmeler",
  "shortcuts.tab_new": "Yeni sekme",
  "shortcuts.tab_close": "Sekmeyi kapat",
  "shortcuts.tab_next": "Sonraki sekme",
  "shortcuts.tab_prev": "Önceki sekme",
  /* tus:t1 - menü fiilleri */
  "shortcuts.new_folder": "Yeni klasör",
  "shortcuts.upload": "Dosya yükle",
  "shortcuts.refresh": "Listeyi yenile",
  "shortcuts.download": "İndir",
  "shortcuts.preview": "Önizle",
  "shortcuts.share": "Paylaş",
  "shortcuts.tags": "Etiketler",
  "shortcuts.open_tab": "Yeni sekmede aç",
  "shortcuts.copy_path": "Yolu kopyala",
  "shortcuts.copy_id": "Kimliği kopyala",
  "shortcuts.restore": "Çöp kutusundan geri al",
  "shortcuts.settings.reserved": "tarayıcı tarafından sayfaya ulaşmadan yakalanıyor, burada hiçbir şey yapmaz. Başka bir tuş seçin.",
  "shortcuts.settings.reserved_badge": "Yalnız masaüstü uygulamasında",
  "shortcuts.settings.reserved_title": "Bu kombinasyonu tarayıcının kendisi işliyor. Masaüstü uygulamasında ve kurulu PWA’da çalışır, tarayıcı sekmesinde çalışmaz.",
  "cmd.tab_new": "Yeni sekme aç",
  "cmd.split_toggle": "Görünümü böl / birleştir",
  "split.pane": "İkincil panel",
  "split.close": "Yan paneli kapat",
  "split.error": "Liste yüklenemedi",
  "split.retry": "Yeniden dene",
  "split.copy_queued": "Kopyalama kuyruğa alındı",
  "split.move_queued": "Taşıma kuyruğa alındı",
  "toast.move_kept_both": "Taşıma kuyruğa alındı. Hedefte aynı adla bir öğe vardı, taşınan öğe onun yanına “-copy” ekiyle konacak. Bu taşıma geri alınamaz.",
  "split.cross_copy": "Depolar farklı - kopyalama kuyruğa alındı",
  "dragout.downloading": "Bırakılan klasöre indiriliyor…",
  "dragout.downloading_n": "Bırakılan klasöre indiriliyor - şimdiye dek {n} dosya…",
  "dragout.downloading_n_one": "Bırakılan klasöre indiriliyor - şimdiye dek {n} dosya…",
  "dragout.stop": "Durdur",
  "dragout.stopping": "Durduruluyor…",
  "dragout.stopped": "Durduruldu - gelenler klasörde kalıyor",
  "dragout.not_found": "Bırakılan yer bulunamadı - dosya bir klasöre değil bir uygulamaya bırakıldıysa indirme yapılamaz",
  "dragout.done": "İndirme tamamlandı",
  "dragout.ready": "Dosyalar hazır - masaüstüne sürükleyebilirsiniz",
  "dragout.preparing": "Sürükleme için hazırlanıyor…",
  "split.cross_move": "Depolar farklı - taşıma kuyruğa alındı (baytlar aktarılıp kaynak silinir)",
  /* === /wiring:d1 === */
  /* wiring:d2 - galeri görünümü */
  "toolbar.view.gallery": "Galeri",
  "gallery.aria": "Dosya galerisi",
  /* /wiring:d2 */
  /* wiring:d3 - Yorumlar (inspector node comments) */
  "inspector.section.comments": "Yorumlar",
  "inspector.comments.empty": "Henüz yorum yok.",
  "inspector.comments.placeholder": "Yorum yaz…",
  "inspector.comments.send": "Gönder",
  "inspector.comments.delete": "Yorumu sil",
  /* wiring:e2 - uçtan uca şifreli klasörler */
  "e2e.create.title": "Şifreli klasör oluştur",
  "e2e.create.option": "Şifreli klasör oluştur…",
  "e2e.create.pw_label": "Klasör parolası",
  "e2e.create.pw_placeholder": "En az 8 karakter",
  "e2e.create.pw2_label": "Parolayı tekrar girin",
  "e2e.create.warn_title": "GERİ DÖNÜŞÜ YOK",
  "e2e.create.warn_body": "Bu klasördeki dosyalar yalnız bu parolayla ya da klasör oluşturulurken bir kez gösterilen kurtarma anahtarıyla açılır. Parola sunucuda TUTULMAZ; kurtarma anahtarının da filex'te kopyası kalmaz. İkisini de kaybederseniz içerik sonsuza dek gider.",
  "e2e.create.ack": "Anladım: parolayı da kurtarma anahtarını da kaybedersem verilerim kurtarılamaz.",
  "e2e.create.ack_required": "Devam etmek için uyarıyı onaylayın.",
  "e2e.create.pw_short": "Parola en az 8 karakter olmalı.",
  "e2e.create.pw_mismatch": "Parolalar birbirini tutmuyor.",
  "e2e.create.bad_name": "Geçersiz klasör adı.",
  "e2e.create.create": "Şifreli klasörü oluştur",
  "e2e.create.busy": "Oluşturuluyor…",
  "e2e.create.done": "Şifreli klasör oluşturuldu",
  "e2e.create.failed": "Şifreli klasör oluşturulamadı",
  "e2e.create.nested": "Şifreli klasörün içine ikinci bir şifreli klasör açılamaz.",
  /* wiring:e2 policy - bir yöneticiden şifreleme izni istemek. */
  "e2e.request.ctx": "Şifreleme iste…",
  "e2e.request.option": "Şifreli klasör iste…",
  "e2e.request.title": "“{name}” için şifreleme iste",
  "e2e.request.lead": "Burada şifreli klasör oluşturmak için yönetici onayı gerekiyor. Neden gerektiğini yazın; yanıt size bildirilir. Onay sizin ve bu klasör içindir: hemen içinde yeni bir şifreli klasör oluşturmak için bir kez kullanılabilir.",
  "e2e.request.lead_folder": "Bu klasörü şifrelemek için yönetici onayı gerekiyor. Neden gerektiğini yazın; yanıt size bildirilir. Onay sizin ve bu klasör içindir: bu klasörü olduğu yerde şifrelemek için bir kez kullanılabilir, içindeki bir klasör için kullanılamaz.",
  "e2e.request.lead_file": "Bu dosyayı şifrelemek için yönetici onayı gerekiyor. Neden gerektiğini yazın; yanıt size bildirilir. Onay sizin ve bu dosyanın bulunduğu klasör içindir: orada yeni bir şifreli dosya için bir kez kullanılabilir.",
  "e2e.request.reason": "Gerekçe",
  "e2e.request.reason_placeholder": "İçinde ne var, neden şifrelenmesi gerekiyor",
  "e2e.request.reason_required": "Yönetici için bir gerekçe yazın.",
  "e2e.request.send": "İsteği gönder",
  "e2e.request.sending": "Gönderiliyor…",
  "e2e.request.sent": "İstek gönderildi. Bir yönetici yanıtladığında size bildirilecek.",
  "e2e.request.already": "Bunu zaten istediniz; bir yöneticinin yanıtını bekliyor.",
  "e2e.request.failed": "İstek gönderilemedi.",
  "e2e.locked.title": "Bu klasör uçtan uca şifreli",
  "e2e.locked.hint": "İçeriği görmek için klasör parolasını girin. Parola yalnız bu sekmede, bellekte tutulur.",
  "e2e.locked.pw_placeholder": "Klasör parolası",
  "e2e.locked.unlock": "Kilidi aç",
  "e2e.locked.busy": "Doğrulanıyor…",
  "e2e.unlock.wrong": "Parola yanlış.",
  "e2e.unlock.damaged": "Parola doğru ama anahtar dosyasındaki (.filex-e2e.json) klasör anahtarı açılmıyor: dosya bozulmuş. Kurtarma anahtarını deneyin.",
  "e2e.unlock.marker_missing": "Anahtar dosyası (.filex-e2e.json) okunamadı.",
  /* ikon:emoji - listedeki işaretin erişilebilir adı. Satır eskiden yalnız
     bir 🔒 basıyordu; onun yerini alan asma kilit kutunun içinde
     aria-hidden, dolayısıyla adı taşıyan yer bu. */
  "e2e.badge": "Şifreli klasör",
  "e2e.strip.label": "Şifreli klasör - kilit açık",
  "e2e.strip.lock": "Kilitle",
  /* wiring:e2 password - klasör parolasını değiştirme */
  "e2e.password.strip_action": "Parolayı değiştir…",
  "e2e.password.title": "Klasör parolasını değiştir",
  "e2e.password.reset_title": "Bu klasör için yeni bir parola belirleyin",
  "e2e.password.reset_lead": "Bu klasörü kurtarma anahtarıyla açtınız; parolası kaybolmuş ya da başkası tarafından biliniyor olabilir. Şimdi yeni bir parola belirleyin. Bu pencereyi kapatmak klasörü yeniden kilitler.",
  "e2e.password.current": "Mevcut parola",
  "e2e.password.recovery": "Kurtarma anahtarı",
  "e2e.password.use_recovery": "Hatırlamıyorum - kurtarma anahtarını kullan",
  "e2e.password.use_current": "Bunun yerine mevcut parolayı kullan",
  "e2e.password.new": "Yeni parola",
  "e2e.password.current_required": "Mevcut parolayı girin ya da kurtarma anahtarını kullanın.",
  "e2e.password.bad_recovery": "Bu bir kurtarma anahtarı değil (dörderli gruplar hâlinde 32 karakter).",
  "e2e.password.same": "Yeni parola mevcut parolayla aynı.",
  "e2e.password.cheap_note": "Yalnız klasörün anahtar dosyası değişir. Hiçbir dosya yeniden şifrelenmez; kurtarma anahtarı ve varsa emanet anahtarı çalışmaya devam eder.",
  "e2e.password.old_copies": "Eski parolayı bilen ve anahtar dosyasının eski bir kopyasına (bir sürüm, bir yedek) sahip olan biri klasörü onunla hâlâ açabilir. Bu bir risk ise “Klasör anahtarını da değiştir”i işaretleyin.",
  "e2e.password.rotate_label": "Klasör anahtarını da değiştir (her dosyanın anahtarı yeniden sarılır; eski parola başkasınca biliniyor olabilirse kullanın)",
  "e2e.password.rekey_title": "Bu klasör v0.31 öncesinden: anahtarı parolasından türetiliyor",
  "e2e.password.rekey_body": "Bu yüzden yeni bir parola yeni bir klasör anahtarı gerektirir ve klasördeki her dosyanın anahtarı onunla yeniden sarılır. İçerik yeniden şifrelenmez. Biraz sürebilir; yarıda kalırsa kaldığı yerden devam eder, dosyalar bu sırada da açılır.",
  "e2e.password.rotate_title": "Klasör anahtarı da değişir",
  "e2e.password.rotate_body": "Her dosyanın anahtarı yeni bir klasör anahtarıyla yeniden sarılır. İçerik yeniden şifrelenmez. Yarıda kalırsa kaldığı yerden devam eder; dosyalar bu sırada da açılır.",
  "e2e.password.rekey_rk_new": "Yeni bir kurtarma anahtarı alırsınız, bir kez gösterilir; eskisi artık çalışmaz.",
  "e2e.password.rekey_rk_kept": "Kullandığınız kurtarma anahtarı çalışmaya devam eder.",
  "e2e.password.rekey_escrow": "İşletmecinin emanet anahtarı çalışmaya devam eder: yuvası yeni klasör anahtarına mühürlenir.",
  "e2e.password.rekey_ack": "Anlıyorum: bu, klasördeki her dosyanın anahtarını yeniden sarar.",
  "e2e.password.submit": "Parolayı değiştir",
  "e2e.password.busy": "Değiştiriliyor…",
  "e2e.password.lock_instead": "Bunun yerine klasörü kilitle",
  "e2e.password.wrong_current": "Parola yanlış.",
  "e2e.password.wrong_recovery": "Kurtarma anahtarı yanlış.",
  "e2e.password.escrow_blocked": "Bu klasörün, bu kurulumda bulunmayan bir anahtar için emanet yuvası var; klasör anahtarını değiştirmek onu kaybettirir. Hiçbir şey değiştirilmedi.",
  "e2e.password.failed": "Parola değiştirilemedi. Hiçbir şey değiştirilmedi.",
  "e2e.password.done": "Parola değişti. Eski parola bu klasörü artık açmıyor.",
  "e2e.password.resume_title": "Dosya anahtarları hâlâ yeniden sarılıyor",
  "e2e.password.resume_body": "Parola değişti ve yeni bir klasör anahtarı verildi. Bazı dosyaların anahtarı hâlâ öncekinin altında; her iki durumda da açılırlar. Bitirmek için devam edin.",
  "e2e.password.progress": "Şu ana kadar {n} dosya yeniden sarıldı · {failed} başarısız",
  "e2e.password.progress_one": "Şu ana kadar {n} dosya yeniden sarıldı · {failed} başarısız",
  "e2e.password.rekey_partial": "{n} dosya yeniden sarılamadı. Önceki anahtarla hâlâ açılıyorlar; yeniden denemek için devam edin.",
  "e2e.password.rekey_partial_one": "{n} dosya yeniden sarılamadı. Önceki anahtarla hâlâ açılıyor; yeniden denemek için devam edin.",
  "e2e.password.rekey_done": "Yeni klasör anahtarı yerinde ({n} dosya yeniden sarıldı). Eski parola burada artık hiçbir şey açmıyor.",
  "e2e.password.rekey_done_one": "Yeni klasör anahtarı yerinde ({n} dosya yeniden sarıldı). Eski parola burada artık hiçbir şey açmıyor.",
  "e2e.recovery.lead_replaced": "Klasörün yeni bir anahtarı var, bu yüzden yeni bir kurtarma anahtarı da var - eskisi artık açmıyor. Bir kez gösterilir; filex kopyasını tutmaz.",
  /* wiring:e2 names - şifreli dosya ve klasör adları */
  "e2e.unlock.unsupported": "Bu klasör daha yeni bir filex istiyor: bu sürümün tanımadığı bir özellik kullanıyor ({features}). Hiçbir şey değiştirilmedi.",
  "e2e.settings.open": "Şifreleme ayarları…",
  "e2e.settings.title": "Şifreleme ayarları",
  "e2e.settings.level": "Şifreleme seviyesi",
  "e2e.settings.password": "Parola",
  "e2e.settings.escrow": "Emanet anahtarı",
  "e2e.settings.close": "Kapat",
  "e2e.level.content": "Yalnız içerik",
  "e2e.level.names": "İçerik ve adlar",
  "e2e.level.content_hint": "Dosya içerikleri şifrelenir. Dosya ve klasör adları sunucuya açık kalır; böylece WebDAV, komut satırı ve masaüstü senkronu adlarla çalışmayı sürdürür ve 0.31'den beri her filex klasörü açar.",
  "e2e.level.names_hint": "İçerik de dosya ve klasör adları da şifrelenir: sunucu yalnız karıştırılmış adlar görür. WebDAV, komut satırı ve masaüstü senkronu da adları karıştırılmış görür; filex 0.47 ve öncesi klasörü açmaz.",
  "e2e.level.pending": "seviye değişikliği bitmedi",
  "e2e.level.change": "Seviyeyi değiştir…",
  "e2e.level.raise_title": "Bu klasör “İçerik ve adlar” seviyesine geçsin mi?",
  "e2e.level.raise_body": "filex buradaki her dosya ve klasöre bu tarayıcıda şifreli bir ad verir. İçeriğe dokunulmaz; yarıda kalırsa kaldığı yerden devam eder. filex açık adlara geri dönüş yolu sunmaz.",
  "e2e.level.raise_ack": "Neyin değiştiğini anladım",
  "e2e.level.raise_go": "Adları şifrele",
  /* wiring:e2 vault - 3. seviye, kasa (docs/E2E-VAULT-FORMAT.md) */
  "e2e.level.vault": "Kasa",
  "e2e.level.vault_hint": "İçerik, adlar ve bütün ağaç şifrelenir: sunucu yalnız aynı boyda paketler tutar; kaç dosya olduğunu, adlarını, boyutlarını ve tarihlerini görmez.",
  "e2e.level.vault_cost": "Bedeli: aynı anda yalnız bir kişi yazar ve kasayı yalnız filex açar (web, masaüstü, filex decrypt ve filex vault mount). WebDAV, klasör eşitleme, paylaşım bağlantıları ve sunucudaki önizlemeler içine ulaşmaz.",
  "e2e.vault.pack_label": "Paket boyutu",
  "e2e.vault.pack_4": "4 MiB",
  "e2e.vault.pack_4_help": "Varsayılan. En küçük değişiklik 4 MiB yükler.",
  "e2e.vault.pack_16": "16 MiB",
  "e2e.vault.pack_16_help": "Sunucuda daha az ve daha büyük dosya. Her değişiklik en az 16 MiB yükler.",
  "e2e.vault.pack_hint": "Yalnız şimdi seçilir, sonra değişmez. Sunucudaki her paket bu boydadır; kullanılmayan yeri rastgele baytlarla doldurulur.",
  "e2e.vault.read_only": "Salt okunur. Bir yükleme, yeni bir klasör ya da başka bir değişiklik, kimse tutmuyorsa yazma kilidini alır.",
  "e2e.vault.writing": "Bu kasaya şu an siz yazıyorsunuz. {left} boyunca hiçbir şey yapmazsanız salt okunura döner.",
  "e2e.vault.lock_countdown": "{left} boyunca içinde hiçbir şey yapılmazsa kasa kilitlenir ve parolayı yeniden sorar.",
  "e2e.vault.held_by": "{name} {since} tarihinden beri yazıyor. Kasa sizin için salt okunur.",
  "e2e.vault.someone": "Biri",
  "e2e.vault.take_over": "Devral",
  "e2e.vault.lost_idle": "{n} dakika boyunca hiçbir şey yapmadığınız için kasa salt okunura döndü. Hiçbir şey kaybolmadı.",
  "e2e.vault.lost_idle_one": "{n} dakika boyunca hiçbir şey yapmadığınız için kasa salt okunura döndü. Hiçbir şey kaybolmadı.",
  "e2e.vault.lost_taken": "Yazmayı başka biri devraldı. Kaydettikleriniz yerinde duruyor; kasa sizin için salt okunur.",
  "e2e.vault.lost_taken_by": "{name} yazmayı devraldı. Kaydettikleriniz yerinde duruyor; kasa sizin için salt okunur.",
  "e2e.vault.lost_broken_by": "{name} yazma kilidinizi kaldırdı. Kaydettikleriniz yerinde duruyor; kasa sizin için salt okunur.",
  "e2e.vault.lost_connection": "Bağlantı koptuğu için kasa salt okunura döndü.",
  "e2e.vault.lost_expired": "Yazma kilidinin süresi dolduğu için kasa salt okunura döndü.",
  "e2e.vault.unsaved": "Kaydedilmedi: {names}. Kasa boşalınca yeniden yapın.",
  "e2e.vault.saving": "Kaydediliyor…",
  "e2e.vault.saving_progress": "Kaydediliyor: {total} içinden {done}",
  "e2e.vault.dismiss": "Tamam",
  "e2e.vault.continue": "Bu durumdan devam et",
  "e2e.vault.ro_damaged": "Bu kasanın en yeni durumu bozuk. {when} tarihli durumu görüyorsunuz, salt okunur.",
  "e2e.vault.ro_damaged_short": "Bu kasanın en yeni durumu bozuk. Daha eski bir durumu görüyorsunuz, salt okunur.",
  "e2e.vault.ro_rollback": "Sunucu bu kasanın, bu sekmenin daha önce gördüğünden eski bir durumunu sunuyor. Kasa burada salt okunur kalır.",
  "e2e.vault.ro_newer": "Bu kasayı daha yeni bir filex yazmış. Bu sürüm onu okur ama değiştirmez.",
  "e2e.vault.unreadable": "Bu kasanın hiçbir durumu okunamıyor: hiçbir şey gösterilemez ve hiçbir şey yazılmaz.",
  "e2e.vault.limit_warn": "Bu kasa en fazla {max} dosya ve klasör tutabilir; şu an {held} tane tutuyor.",
  "e2e.vault.cross": "Sunucuda kasa ile dışındaki klasörler arasında hiçbir şey taşınmaz: birinden indirin, sonra ötekine yükleyin.",
  "e2e.vault.dl_too_big": "Bu tarayıcı bu kadar büyük bir dosyayı bellekten kaydedemez. Doğrudan diske kaydeden bir tarayıcı (Chrome, Edge) ya da filex decrypt kullanın.",
  "e2e.vault.damaged_file": "Bu dosya kasada bozuk ve okunamadı.",
  "e2e.vault.level_fixed": "Kasa kasa olarak kalır: seviyesi değişmez, anahtarı yenilenmez. Yeni bir anahtarla baştan başlamak için yeni bir kasa oluşturup dosyaları içine taşıyın.",
  "e2e.vault.locked_idle_toast": "“{name}” içinde 15 dakika hiçbir şey yapılmadığı için kasa kendini kilitledi. Yeniden açmak için parolayı girin.",
  "e2e.vault.open_failed": "Kasa açılamadı.",
  "e2e.vault.err.parent_missing": "İçine gideceği klasör artık yok.",
  "e2e.vault.err.parent_not_folder": "“{name}” bir klasör değil, bir dosya.",
  "e2e.vault.err.name_taken": "Orada “{name}” adı zaten var.",
  "e2e.vault.err.bad_name": "“{name}” kasada ad olamaz: 1 ile 255 bayt arası olmalı, eğik çizgi ya da denetim karakteri içermemeli, . ya da .. olmamalı.",
  "e2e.vault.err.too_deep": "Kasada klasörler en fazla 256 düzey iç içe olabilir.",
  "e2e.vault.err.not_found": "“{name}” artık kasada yok.",
  "e2e.vault.err.is_folder": "“{name}” bir klasör.",
  "e2e.vault.err.into_itself": "Bir klasör kendi içine taşınamaz.",
  "e2e.vault.err.too_many_entries": "Bu kasa dolu: en fazla 250 000 dosya ve klasör tutar. Hiçbir şey değiştirilmedi.",
  "e2e.vault.err.index_too_large": "Bu kasanın dizini sınırına ulaştı. Hiçbir şey değiştirilmedi.",
  "e2e.vault.err.newer_format": "Bu kasayı daha yeni bir filex yazmış. Bu sürüm onu okur ama değiştirmez.",
  "e2e.vault.err.size_mismatch": "Bir dosya yüklenirken değişti. Yeniden yükleyin.",
  "e2e.vault.err.changed": "“{name}” açıldığından beri kasada değişti, bu yüzden üzerine kaydedilmedi. Yeni sürümü görmek için yeniden açın.",
  "e2e.vault.err.failed": "Değişiklik kaydedilemedi.",
  "userSettings.vault.idle": "Kasa: salt okunura dönme süresi",
  "userSettings.vault.idle_help": "Yazdığınız bir kasada hiçbir şey yapmadığınızda kasanın ne kadar süre sizde kalacağı. Sonra başkaları yazabilir; kasanız salt okunura döner ve 15 dakika sonra kilitlenir.",
  "userSettings.vault.minutes": "{n} dakika",
  "userSettings.vault.minutes_one": "{n} dakika",
  "userSettings.vault.saved": "Kaydedildi",
  "userSettings.vault.failed": "Kasa ayarı kaydedilemedi.",
  "e2e.names.move_unreadable": "Taşınmadı: öğelerden birinin adı okunamıyor.",
  "e2e.names.move_taken": "Taşınmadı: o klasörde “{name}” adı zaten var. Önce ikisinden birinin adını değiştirin.",
  "e2e.convert.ctx": "E2EE ile şifrele…",
  "e2e.convert.title": "“{name}” klasörünü şifrele",
  "e2e.convert.lead": "Bu klasördeki her dosya bulunduğu yerde, bu tarayıcıda, aşağıdaki parolayla şifrelenir. Hiçbir şey yer değiştirmez; 1. seviyede adlar olduğu gibi kalır. Yarıda kalırsa klasörü yeniden açınca devam eder.",
  "e2e.convert.past_title": "Sunucuda zaten olanlar",
  "e2e.convert.past_body": "Şifreleme bu dosyaları bundan sonrası için korur. Şimdiye kadar sunucu onları açık hâlde tuttu ve bazı kopyalar kalır: filex küçük resimlerini ve arama için çıkardığı metni siler; bu klasörün eski sürümlerini ve çöp kutusundaki kayıtlarını da silebilir.",
  "e2e.convert.drop_versions": "Bu dosyaların eski sürümlerini sil (şifresizdirler)",
  "e2e.convert.drop_trash": "Bu klasörden çöp kutusuna gidenleri sil",
  "e2e.convert.past_outside": "Yedekler, kopya sunucular ve birinin önceden aldığı kopyalar filex'in dışındadır ve olduğu gibi kalır.",
  "e2e.convert.submit": "Klasörü şifrele",
  "e2e.convert.nested": "Bu klasörün içinde şifreli bir klasör var. Şifreli klasörler iç içe olamaz; hiçbir şey değiştirilmedi.",
  "e2e.convert.failed": "Klasör şifrelenemedi. Şifrelenmiş dosyalar öyle kalır; devam etmek için klasörü açın.",
  "e2e.convert.stopped": "{n} dosyadan sonra durduruldu. Klasörün üstündeki şeritten devam edebilirsiniz.",
  "e2e.convert.stopped_one": "{n} dosyadan sonra durduruldu. Klasörün üstündeki şeritten devam edebilirsiniz.",
  "e2e.convert.partial": "{n} dosya şifrelenemedi (bu arada değişti, çok büyük ya da yazılamıyor). Hâlâ şifresizler; devam etmek için yeniden deneyin.",
  "e2e.convert.partial_one": "{n} dosya şifrelenemedi (bu arada değişti, çok büyük ya da yazılamıyor). Hâlâ şifresiz; devam etmek için yeniden deneyin.",
  "e2e.convert.too_large_here": "{n} dosya bu tarayıcının tek parçada gönderebileceğinden büyük ve bu sunucu parça parça yükleme almıyor; bu yüzden yerlerinde şifrelenemediler. Hâlâ şifresizler ve onlar şifrelenene kadar klasörün şifrelenmesi tamamlanmış sayılmaz.",
  "e2e.convert.too_large_here_one": "{n} dosya bu tarayıcının tek parçada gönderebileceğinden büyük ve bu sunucu parça parça yükleme almıyor; bu yüzden yerinde şifrelenemedi. Hâlâ şifresiz ve o şifrelenene kadar klasörün şifrelenmesi tamamlanmış sayılmaz.",
  "e2e.convert.large_progress": "“{name}” şifreleniyor: %{percent}",
  "e2e.convert.busy": "Klasör şifreleniyor…",
  "e2e.convert.resume_title": "Bu klasörü şifrelemeyi bitirin",
  "e2e.convert.resume_body": "Bu klasörü şifreleme işi başladı ama bitmedi. Henüz ulaşılmayan dosyalar sunucuda hâlâ şifresiz. Devam ederseniz kaldığı yerden sürer.",
  "e2e.convert.progress": "{total} dosyanın {n} tanesi şifrelendi · {failed} dosya kaldı",
  "e2e.convert.progress_one": "{total} dosyanın {n} tanesi şifrelendi · {failed} dosya kaldı",
  "e2e.convert.done": "Klasör şifrelendi ({n} dosya). Silinen eski sürüm: {versions}; silinen çöp kaydı: {trash}.",
  "e2e.convert.done_one": "Klasör şifrelendi ({n} dosya). Silinen eski sürüm: {versions}; silinen çöp kaydı: {trash}.",
  "e2e.convert.cleanup_failed": "Klasör şifrelendi ama eski sürümleri ve çöp kayıtları silinemedi - bunu yalnız klasörün sahibi ya da bir yönetici yapabilir.",
  "e2e.names.locked_item": "🔒 Şifreli öğe",
  "e2e.names.unreadable_item": "🔒 Adı okunamıyor",
  "e2e.names.key_failed": "Anahtar dosyası bu klasördeki adların şifreli olduğunu söylüyor ama ad anahtarı bu anahtarla açılmıyor. Hiçbir şey değiştirilmedi.",
  "e2e.names.write_failed": "Uzun bir adın ad dosyası yazılamadı, bu yüzden hiçbir şey yüklenmedi.",
  "e2e.names.bad_name": "“{name}” şifreli klasörde kullanılamaz: ad 1-255 bayt olmalı; bölü, ters bölü ya da kontrol karakteri içeremez.",
  "e2e.names.offer_cost": "Ne değişir: WebDAV, komut satırı ve masaüstü senkronu adları karıştırılmış görür; filex 0.47 ve öncesi bu klasörü açmayı reddeder. Sunucu kaç öğe olduğunu ve boyutlarını hâlâ görür.",
  "e2e.names.resume_title": "Adları şifrelemeyi bitirin",
  "e2e.names.resume_body": "Bu klasördeki adları şifreleme işi başladı ama bitmedi. Henüz ulaşılmayan öğelerin adları hâlâ açık. Devam ederseniz kaldığı yerden sürer.",
  "e2e.names.resume": "Devam et",
  "e2e.names.stop": "Durdur",
  "e2e.names.busy": "Adlar şifreleniyor…",
  "e2e.names.progress": "Şu ana kadar {n} ad şifrelendi · {failed} öğe yeniden adlandırılamadı",
  "e2e.names.progress_one": "Şu ana kadar {n} ad şifrelendi · {failed} öğe yeniden adlandırılamadı",
  "e2e.names.done": "Adlar şifrelendi ({n} öğe yeniden adlandırıldı). Sunucu artık adları göremiyor.",
  "e2e.names.done_one": "Adlar şifrelendi ({n} öğe yeniden adlandırıldı). Sunucu artık adları göremiyor.",
  "e2e.names.stopped": "{n} addan sonra durduruldu. Kalanlar siz devam edene kadar açık adlarını korur.",
  "e2e.names.stopped_one": "{n} addan sonra durduruldu. Kalanlar siz devam edene kadar açık adlarını korur.",
  "e2e.names.partial": "{n} öğe yeniden adlandırılamadı (izin yok ya da ad bir diskte tutulamıyor). Adları açık kalıyor; devam etmek için yeniden deneyin.",
  "e2e.names.partial_one": "{n} öğe yeniden adlandırılamadı (izin yok ya da ad bir diskte tutulamıyor). Adı açık kalıyor; devam etmek için yeniden deneyin.",
  "e2e.names.failed": "Adlar şifrelenemedi. Zaten yeniden adlandırılanlar kaybolmaz; devam etmek için yeniden deneyin.",
  "e2e.names.strip_fix": "{n} adı düzelt (açık kalmış ya da filex dışından taşınmış)",
  "e2e.names.strip_fix_one": "{n} adı düzelt (açık kalmış ya da filex dışından taşınmış)",
  "e2e.create.names_root_hint": "Klasörün kendi adı her durumda açık kalır - şifresiz bir klasörün içinde durur. Hiçbir şey ele vermeyen bir ad seçin.",
  "e2e.locked_toast": "Klasör kilitlendi",
  "e2e.app_closed_unsaved": "“{name}” dosyasında kaydedilmemiş değişiklikler kayboldu: klasör kilitlenince uygulama kapandı.",
  "e2e.upload.locked": "Önce klasörün kilidini açın",
  "e2e.decrypting": "Çözülüyor…",
  "e2e.decrypt_failed": "Dosya çözülemedi (parola değişmiş ya da dosya bozulmuş olabilir).",
  /* wiring:e2 recovery - kurtarma anahtarı + yönetici escrow'u */
  "e2e.create.escrow_title": "Bu sunucunun da bir anahtarı var",
  "e2e.create.escrow_body": "Bu kurulumda anahtar emaneti (escrow) açık: sunucunun işletmecisi bu klasörü parolanız olmadan açabilir. O anahtar kullanıldığında size bildirim gelir. Escrow sunucu kurulurken sabitlenir; bir klasör için kapatılamaz.",
  "e2e.locked.use_recovery": "Parolayı mı kaybettiniz? Kurtarma anahtarı kullanın",
  "e2e.recovery.title": "Kurtarma anahtarınızı saklayın",
  "e2e.recovery.title_upgraded": "Kurtarma anahtarınız",
  "e2e.recovery.lead": "Bu anahtar klasörü parolasız açar. Yalnız bir kez gösterilir - filex bu anahtarı saklamaz ve bir daha gösteremez.",
  "e2e.recovery.lead_upgraded": "Bu klasörün artık bir kurtarma anahtarı var. Klasörü parolasız açar, yalnız bir kez gösterilir ve filex'te kopyası kalmaz.",
  "e2e.recovery.copy": "Kopyala",
  "e2e.recovery.copied": "Kopyalandı",
  "e2e.recovery.download": "Dosya olarak indir",
  "e2e.recovery.warn_title": "BUNU PAROLA GİBİ SAKLAYIN",
  "e2e.recovery.warn_body": "Bu anahtarı eline geçiren herkes klasörü okuyabilir. Parolanızdan ayrı bir yerde tutun - parolanın yanında duran bir anahtar sizi unutmaya karşı korur, başkasına karşı değil.",
  "e2e.recovery.escrow_title": "Bu sunucunun da bir anahtarı var",
  "e2e.recovery.escrow_body": "Bu kurulumda anahtar emaneti açık: sunucunun işletmecisi bu klasörü parolanız olmadan açabilir. O anahtar kullanıldığında size bildirim gelir.",
  "e2e.recovery.escrow_kid": "Emanet anahtarı",
  "e2e.recovery.ack": "Bu anahtarı güvenli bir yere kaydettim.",
  "e2e.recovery.done": "Tamam",
  "e2e.recover.title": "Parolasız kilit açma",
  "e2e.recover.none": "Bu klasör kurtarma anahtarları eklenmeden önce oluşturulmuş, bu yüzden anahtarı yok. Tek giriş yolu parolası. Bir kez parolayla açın, filex kurtarma anahtarı eklemeyi önerecek.",
  "e2e.recover.tab_recovery": "Kurtarma anahtarı",
  "e2e.recover.tab_escrow": "Emanet anahtarı",
  "e2e.recover.recovery_hint": "Klasör oluşturulurken bir kez gösterilen anahtar.",
  "e2e.recover.recovery_placeholder": "XXXX-XXXX-XXXX-XXXX-XXXX-XXXX-XXXX-XXXX",
  "e2e.recover.escrow_warn_title": "Klasörün sahibine haber gidecek",
  "e2e.recover.escrow_warn_body": "Emanet anahtarıyla açılan klasörün sahibine bildirim gönderilir. Yalnız yetkiniz olduğunda kullanın.",
  "e2e.recover.escrow_kid": "Emanet anahtarı",
  "e2e.recover.escrow_predates": "Bu kurulumun emanet anahtarı var ama bu klasörün yok. Klasör, emanet burada açılmadan önce oluşturulmuş; ana anahtarı emanet kimliğine hiç sarmalanmadı. Emanet anahtarı bu klasörü açmaz. İşletmecinin yapabileceği hiçbir şey bunu değiştirmez - sarmalama için klasörün parolası gerekir ve sunucu onu hiçbir zaman görmedi. Klasörün sahibi verebilir: parolayla kilidi açıp işletmeciye anahtar vermeyi seçebilir. O yapılana kadar parolayı ya da kurtarma anahtarını kullanın.",
  "e2e.recover.escrow_other_key": "Bu klasör BAŞKA bir kurulumun emanet anahtarını taşıyor. Başka yerde oluşturulup buraya geri yüklenmiş, bu yüzden bu kurulumun emanet anahtarı onu açmaz. Yalnızca sarmalandığı emanet anahtarının özel yarısı açabilir.",
  "e2e.recover.escrow_placeholder": "Emanet özel anahtarını yapıştırın (PKCS#8, base64 ya da PEM)",
  "e2e.recover.bad_format": "Bu bir kurtarma anahtarına benzemiyor. Dörtlü sekiz grup, toplam 32 karakter olmalı.",
  "e2e.recover.escrow_required": "Emanet özel anahtarını yapıştırın.",
  "e2e.recover.wrong_recovery": "Bu kurtarma anahtarı bu klasörü açmıyor.",
  "e2e.recover.wrong_escrow": "Bu emanet anahtarı bu klasörü açmıyor. Emanet açılmadan önce oluşturulmuş bir klasörün, sahibi izin verene kadar emanet anahtarı yoktur - o zamana kadar parolayı ya da kurtarma anahtarını kullanın.",
  "e2e.recover.bad_escrow_key": "Bu okunabilir bir özel anahtar değil (PKCS#8, base64 ya da PEM bekleniyor).",
  "e2e.recover.notify_failed": "Klasör sahibine bildirim gönderilemedi, bu yüzden kilit açılmadı. Emanet anahtarının kullanımı her zaman duyurulur.",
  "e2e.recover.recovery_done": "Kurtarma anahtarıyla açıldı",
  "e2e.recover.escrow_done": "Emanet anahtarıyla açıldı - klasör sahibine bildirildi",
  "e2e.recover.unlock": "Kilidi aç",
  "e2e.recover.busy": "Açılıyor…",
  "e2e.escrowoffer.title": "İşletmeciye bu klasörün anahtarı verilsin mi?",
  "e2e.escrowoffer.body": "Bu klasör, burada anahtar emaneti açılmadan önce oluşturulmuş; bu yüzden kurulumun işletmecisi onu açamıyor. Şu anda - parolanız bellekteyken - filex bu klasörü emanet anahtarına sarmalayabilir. Dosyalarınız yeniden şifrelenmez, hiçbir yere taşınmaz; yalnızca anahtar dosyası değişir.",
  "e2e.escrowoffer.consequence": "Bunun anlamı: işletmeci, parolanız olmadan bu klasöre giren ikinci ve kalıcı bir yol kazanır. O anahtar kullanıldığında size bildirim gelir, ama bu bildirim bir denetim değil yalnızca bir duyurudur.",
  "e2e.escrowoffer.learn_more": "Emanet anahtarı neyi yapar, neyi yapamaz",
  "e2e.escrowoffer.password_label": "Klasör parolası",
  "e2e.escrowoffer.password_required": "Klasör parolasını girin.",
  "e2e.escrowoffer.wrong_password": "Bu, bu klasörün parolası değil.",
  "e2e.escrowoffer.accept": "İşletmeciye anahtar ver",
  "e2e.escrowoffer.decline": "Hayır, bende kalsın",
  "e2e.escrowoffer.cancel": "Vazgeç",
  "e2e.escrowoffer.busy": "Sarmalanıyor…",
  "e2e.escrowoffer.done": "İşletmeci artık bu klasörü emanet anahtarıyla açabilir",
  "e2e.escrowoffer.declined_toast": "Sizde kaldı. filex bu klasör için bir daha sormayacak.",
  "e2e.escrowoffer.decline_failed": "Cevabınız kaydedilemedi, bu yüzden filex bir dahakine yine soracak. Klasörde hiçbir şey değişmedi.",
  "e2e.escrowoffer.failed": "İşletmeciye bu klasörün anahtarı verilemedi",
  "e2e.escrowoffer.strip_action": "Emanet anahtarı…",
  "e2e.upgrade.title": "Bu klasörün kurtarma anahtarı yok",
  "e2e.upgrade.body": "Kurtarma anahtarları eklenmeden önce oluşturulmuş, bu yüzden tek giriş yolu parolası. Şu anda - ve yalnız şu anda, parola bellekteyken - filex bir tane ekleyebilir. Dosyalarınız yeniden şifrelenmez, hiçbir yere taşınmaz.",
  "e2e.upgrade.escrow_note": "Not: bu kurulumda anahtar emaneti açık; kurtarma anahtarı eklemek aynı zamanda işletmecinin bu klasörü parolanız olmadan açabilmesi demektir.",
  "e2e.upgrade.accept": "Kurtarma anahtarı oluştur",
  "e2e.upgrade.decline": "Şimdi değil",
  "e2e.upgrade.busy": "Oluşturuluyor…",
  "e2e.upgrade.failed": "Bu klasöre kurtarma anahtarı eklenemedi",
  "e2e.download.failed": "Şifreli dosya indirilemedi.",
  /* /wiring:e2 */
  /* ── connections: storage config + "how to connect" ──────────────
     `storages.*` keys are the ones the BACKEND's driver descriptors
     name (each driver package declares one next to its Init). They are
     kept identical to web/src/locales/*.json on purpose: the same
     descriptor is rendered on both surfaces, so a field that reads
     "Base path" in the admin panel and something else in the desktop
     app would be the same drift this whole mechanism exists to stop. */
  "conn.title": "Bağlantılar",
  "conn.subtitle": "{host} sunucusuna kendi bilgisayarınızdan nasıl erişilir: bağlayın ya da bir istemciyi buraya yönlendirin.",
  "conn.close": "Kapat",
  "conn.list.disabled": "Kapalı",
  "conn.form.required": "Zorunlu",
  "conn.form.advanced": "Gelişmiş ayarlar",
  "conn.form.yes": "Evet",
  "conn.form.no": "Hayır",
  "conn.form.noFields": "Bu sunucu bu sürücü için hiçbir ayar tanımlamadı.",
  "conn.form.reveal": "Göster",
  "conn.form.hide": "Gizle",
  "conn.guide.protocol": "Protokol",
  "conn.guide.storage": "Depo",
  "conn.guide.allStorages": "Tüm depolar",
  "conn.guide.copy": "Kopyala",
  "conn.guide.copied": "Kopyalandı",
  "conn.guide.goodToKnow": "Bilmekte fayda var",
  "conn.guide.userPlaceholder": "eposta@ornek.com",
  "conn.guide.secretPlaceholder": "parolanız-ya-da-api-anahtarınız",
  "conn.guide.fact.url": "Adres",
  "conn.guide.fact.urlRootHint": "Görebildiğiniz her depo bu adresin altında bir klasör olarak görünür.",
  "conn.guide.fact.urlStorageHint": "Doğrudan “{storage}” deposunu bağlar. Son parçayı silerseniz tüm depoları görürsünüz.",
  "conn.guide.fact.user": "Kullanıcı adı",
  "conn.guide.fact.password": "Parola",
  "conn.guide.webdav.summary": "WebDAV, filex’i bir sürücü gibi bağlar: Windows Gezgini, macOS Finder, Linux, rclone ve Cyberduck bu protokolü konuşur ve yapılan her değişiklik filex’e yansır.",
  "conn.guide.webdav.userHint": "Kullanıcı adınız ya da e-postanız - görünen adınız değil.",
  "conn.guide.webdav.passwordHint": "Hesap parolanız ya da bir API anahtarı (gezinti panelindeki API anahtarları bölümü). İki adımlı doğrulaması açık bir hesap ZORUNLU olarak API anahtarı kullanır: Basic kimlik doğrulamasında ikinci adım için yer yoktur.",
  "conn.guide.webdav.win.s1": "Dosya Gezgini’ni açın, Bu bilgisayar’a sağ tıklayın ve “Ağ sürücüsü bağla…” deyin.",
  "conn.guide.webdav.win.s2": "Bir sürücü harfi seçin ve klasör olarak {url} adresini girin.",
  "conn.guide.webdav.win.s3": "“Farklı kimlik bilgileri kullanarak bağlan” kutusunu işaretleyin ve yukarıdaki kullanıcı adı/parola ile girin.",
  "conn.guide.webdav.win.cmdCaption": "Komut İstemi (sihirbaz olmadan aynı iş)",
  "conn.guide.webdav.win.limits": "Windows’un tam olarak filex hatası gibi görünen üç yerleşik sınırı vardır: aktarımlar ~47,7 MB’ta durur, yaklaşık bin dosyalı klasörler açılmaz (“Disk biçimlendirilmemiş”) ve her iki ayarı değiştirdikten sonra WebClient hizmeti yeniden başlatılmalıdır.",
  "conn.guide.webdav.win.regCaption": "Yönetici olarak çalıştırın, sonra sürücüyü yeniden bağlayın",
  "conn.guide.webdav.win.https": "HTTPS zorunludur. Windows Basic kimlik bilgilerini yalnızca TLS üzerinden gönderir; düz http:// üzerinde hiçbir açıklama vermeden reddeder. BasicAuthLevel değerini 2 yapmayın - TLS kullanın.",
  "conn.guide.webdav.win.persist": "Bağlanan sürücü oturum kapatmayı atlatamaz: Windows 7’den beri Basic kimlik bilgileri Kimlik Bilgisi Yöneticisi’nde saklanamaz ve /persistent:yes bunu değiştirmez. Kendiliğinden geri gelsin istiyorsanız komutu bir oturum açma betiğinden yeniden çalıştırın.",
  "conn.guide.webdav.win.service": "Hiç bağlanamıyorsa WebClient hizmetinin çalıştığından emin olun: sc config WebClient start= auto && net start WebClient.",
  "conn.guide.webdav.mac.s1": "Finder’da Git → Sunucuya Bağlan… (⌘K) yolunu izleyin.",
  "conn.guide.webdav.mac.s2": "{url} adresini girip bağlanın.",
  "conn.guide.webdav.mac.s3": "Yukarıdaki kullanıcı adı ve parolayla kimliğinizi doğrulayın.",
  "conn.guide.webdav.mac.note": "Sürücü Konumlar altında görünür; her depo en üst düzeyde bir klasördür.",
  "conn.guide.webdav.linux.mountCaption": "davfs2 ya da masaüstü dosya yöneticisi (GNOME Dosyalar, Dolphin)",
  "conn.guide.webdav.linux.gvfsComment": "ya da bu adresi GNOME Dosyalar / Dolphin icine yapistirin",
  "conn.guide.webdav.linux.locks": "davfs2 için kilitler kapatılmalıdır. filex WebDAV kilitlerini süreç belleğinde tutar; yeniden başlatmayı atlatamazlar ve kopyalar arasında paylaşılmazlar - davfs2 tersini varsayar ve takılır.",
  "conn.guide.webdav.rclone.obscureCaption": "rclone parolayı gizlenmiş biçimde saklar - önce bunu çalıştırıp çıktısını aşağıya yapıştırın",
  "conn.guide.webdav.rclone.passPlaceholder": "<rclone obscure çıktısı>",
  "conn.guide.webdav.rclone.useCaption": "Kullanımı",
  "conn.guide.webdav.duck.s1": "Yeni Yer İmi → WebDAV (HTTPS).",
  "conn.guide.webdav.duck.s2": "Sunucu {host}, port 443.",
  "conn.guide.webdav.duck.s3": "Yol {path}.",
  "conn.guide.webdav.duck.s4": "Kullanıcı adı {user}, parola yukarıdaki gibi.",
  "conn.guide.webdav.note.delete": "WebDAV üzerinden silme kalıcıdır. Web arayüzü dosyaları filex çöp kutusuna taşır; istemciden silme ise nesneyi doğrudan arka uçtan kaldırır.",
  "conn.guide.webdav.note.locks": "Kilitler sunucu belleğinde durur: yeniden başlatmayı atlatamazlar ve kopyalar arasında paylaşılmazlar. Windows ile Office’i memnun etmek için varlar, eşzamanlı düzenlemeyi hakemlemek için değil.",
  "conn.guide.webdav.note.permissions": "Web arayüzünde ne görüyorsanız burada da onu görürsünüz. Kök yalnızca açabildiğiniz depoları listeler; yetkiniz dışındaki bir yol 403 değil 404 döner, böylece ağaç neyin var olduğunu sızdırmaz.",
  "conn.guide.webdav.note.http": "Bu sunucuya düz http:// ile erişiliyor. Windows kimlik bilgilerinizi hiç göndermez, diğer tüm istemciler ise parolanızı açık metin olarak yollar. Bağlamadan önce filex’i TLS arkasına alın.",
  // ── S3 ucu: anahtarlar ve rehber ─────────────────────────────────
  "conn.s3keys.title": "S3 erişim anahtarları",
  "conn.s3keys.lead": "Bir erişim anahtarı, S3 konuşan her istemcinin - rclone, restic, AWS CLI, mc, s3fs, Cyberduck - filex’e bağlanmasını sağlar. Anahtar sizin yetkinizi taşır, bir fazlasını değil.",
  "conn.s3keys.disabled": "Bu sunucuda S3 ucu kapalı (FILEX_S3). Burada üretilen anahtar, yönetici ucu tekrar açana kadar bağlanmaz.",
  "conn.s3keys.cannotMint": "Erişim anahtarı üretebilecek bir hesapla oturum açmış değilsiniz. Aşağıdaki talimatlar yine geçerli - bir anahtar isteyip yapıştırmanız yeter.",
  "conn.s3keys.label": "Ne için? (dizüstü yedeği, CI, …)",
  "conn.s3keys.defaultLabel": "erişim anahtarı",
  "conn.s3keys.everyBucket": "Görebildiğim tüm kovalar",
  "conn.s3keys.prefix": "Kova içindeki klasör (isteğe bağlı)",
  "conn.s3keys.mint": "Anahtar oluştur",
  "conn.s3keys.inheritNote": "Bir anahtar sahip olduğunuz yetkiyi yalnızca DARALTABİLİR: yetkileriniz ve rolünüz. Anahtarı tek bir kovaya ya da klasöre kısıtlamak, bir dizüstü yedeği ile her şeyi okuyabilen bir kimlik arasındaki farktır.",
  "conn.s3keys.once": "Gizli anahtarı şimdi kopyalayın - bir daha gösterilmeyecek.",
  "conn.s3keys.accessKeyID": "Erişim anahtarı kimliği",
  "conn.s3keys.secret": "Gizli anahtar",
  "conn.s3keys.dismiss": "Kopyaladım",
  "conn.s3keys.col.label": "Etiket",
  "conn.s3keys.col.key": "Erişim anahtarı kimliği",
  "conn.s3keys.col.scope": "Kapsam",
  "conn.s3keys.col.lastUsed": "Son kullanım",
  "conn.s3keys.scopeAll": "görebildiğiniz her şey",
  "conn.s3keys.noLabel": "(etiketsiz)",
  "conn.s3keys.neverUsed": "hiç",
  "conn.s3keys.enable": "Aç",
  "conn.s3keys.disable": "Kapat",
  "conn.s3keys.revoke": "İptal et",
  "conn.s3keys.confirm": "Emin misiniz?",
  "conn.s3keys.empty": "Henüz erişim anahtarı yok.",
  "conn.guide.s3.summary": "S3 ucu, S3 konuşan her şeyin - yedekleme, eşitleme araçları, SDK’lar - hedefi olarak filex’i kullanmanızı sağlar; hem de zaten sahip olduğunuz depolarla.",
  "conn.guide.s3.keyPlaceholder": "yukarıdan bir anahtar oluşturun",
  "conn.guide.s3.secretPlaceholder": "anahtarı oluştururken bir kez gösterilir",
  "conn.guide.s3.fact.endpoint": "Uç adresi",
  "conn.guide.s3.fact.endpointHint": "İstemciyi buraya yöneltin, filex’in web adresine değil.",
  "conn.guide.s3.fact.bucket": "Kova",
  "conn.guide.s3.fact.bucketHint": "Kova = filex deposu. Kovaları istemci değil yönetici oluşturur.",
  "conn.guide.s3.fact.key": "Erişim anahtarı kimliği",
  "conn.guide.s3.fact.keyHint": "Genel yarısı; her istekte gider.",
  "conn.guide.s3.fact.secret": "Gizli anahtar",
  "conn.guide.s3.fact.secretHint": "Yalnızca anahtar oluşturulurken bir kez gösterilir. filex bir daha gösteremez - kaybolduysa yeni anahtar üretin.",
  "conn.guide.s3.fact.region": "Bölge",
  "conn.guide.s3.fact.regionHint": "filex’te bölge yok; hangi değeri verirseniz aynen geri döner. Yine de istemciler bir değer ister.",
  "conn.guide.s3.fact.addressing": "Adresleme",
  "conn.guide.s3.fact.pathStyle": "yol tabanlı (zorunlu)",
  "conn.guide.s3.fact.pathStyleHint": "Bu kurulumda S3’e ayrılmış bir alan adı yok, yani kova.host çözülmez.",
  "conn.guide.s3.fact.virtualHosted": "sanal-host ya da yol tabanlı",
  "conn.guide.s3.fact.virtualHostedHint": "Bu kurulumun kendi S3 alan adı var, iki adresleme de çalışır.",
  "conn.guide.s3.rclone.useCaption": "Kullanımı",
  "conn.guide.s3.rclone.mtime": "filex dosyanın değişiklik zamanını taşır (x-amz-meta-mtime); böylece rclone sync ilk turdan sonra oturur, her seferinde her şeyi yeniden yüklemez.",
  "conn.guide.s3.aws.configureCaption": "Bir kez ayarlayın",
  "conn.guide.s3.aws.useCaption": "Kullanımı",
  "conn.guide.s3.aws.pathStyle": "AWS yapılandırmanıza yol tabanlı adreslemeyi ekleyin; yoksa her komut DNS aşamasında düşer.",
  "conn.guide.s3.restic.envCaption": "Ortam değişkenleri",
  "conn.guide.s3.restic.useCaption": "Yedekle, doğrula, buda",
  "conn.guide.s3.restic.verified": "Bu uca karşı ölçüldü: restic check --read-data her pack’i bayt bayt okuyor ve hata bulmuyor.",
  "conn.guide.s3.mc.aliasCaption": "Takma adı ekleyin",
  "conn.guide.s3.mc.useCaption": "Kullanımı",
  "conn.guide.s3.s3fs.credsCaption": "Kimlik dosyası",
  "conn.guide.s3.s3fs.mountCaption": "Bağlayın",
  "conn.guide.s3.s3fs.note": "s3fs üzerinden bir dosyayı düzenlemek nesnenin tamamını yeniden yazar; silme ise filex çöp kutusuna gider. Paylaşılan bir klasör için iyi, veritabanı için değil.",
  "conn.guide.s3.duck.s1": "Yeni yer imi → Amazon S3.",
  "conn.guide.s3.duck.s2": "Sunucu: {host}.",
  "conn.guide.s3.duck.s3": "Erişim anahtarı kimliği: {key}, gizli anahtar yukarıdaki.",
  "conn.guide.s3.duck.s4": "Yer imini açın; kovalar sizin filex depolarınızdır.",
  "conn.guide.s3.duck.pathStyle": 'Tercihler → S3 altında "Use virtual host style" seçeneğini KAPATIN - bu kurulumda joker S3 alan adı yok.',
  "conn.guide.s3.sdk.note": "SigV4 konuşan her istemci aynı şekilde çalışır: uç adresi, anahtar, gizli anahtar ve bu kurulumun kendi S3 alan adı yoksa yol tabanlı adresleme.",
  "conn.guide.s3.note.buckets": "Kova = filex deposu. İstemci kovanın İÇİNDE klasör ve nesne oluşturabilir, ama kovanın kendisini oluşturamaz: kova bir sürücü ve bir yol ister, bunu bir S3 isteği ifade edemez.",
  "conn.guide.s3.note.permissions": 'Anahtar tam olarak sizin gördüğünüzü görür. Açamayacağınız bir kova "yasak" değil "böyle bir kova yok" der; böylece uç, neyin var olduğunu sızdırmaz.',
  "conn.guide.s3.note.trash": "Silme her yerdeki gibi filex çöp kutusuna gider ve saklama politikası süpürene kadar geri alınabilir.",
  "conn.guide.s3.note.mtime": "Yüklemeler değişiklik zamanını taşır; istemcinin gönderdiği sağlama toplamları (Content-MD5, x-amz-checksum-*) doğrulanır - bozulmuş bir yükleme saklanmaz, reddedilir.",
  "conn.guide.s3.note.pathStyle": "Bu kurulumda S3’e ayrılmış alan adı yok; istemcilere yol tabanlı adresleme söylenmeli. Söylenmezse güncel bir SDK, ne filex’i ne de sebebi anan bir DNS hatasıyla düşer.",
  "conn.guide.s3.note.http": "Bu uç düz http://. İmzalar isteği yine korur ama nesneler açık metin gider. Bir yedeği buraya yöneltmeden önce filex’i TLS arkasına alın.",
  // ── SFTP ucu: anahtarlar ve rehber ───────────────────────────────
  "conn.sshkeys.title": "SSH anahtarları",
  "conn.sshkeys.lead": "Bir açık anahtar kaydedin; SSH konuşan her istemci - sftp, scp, WinSCP, FileZilla, rclone, sshfs - parolanızı göndermeden bağlansın.",
  "conn.sshkeys.disabled": "Bu sunucuda SFTP ucu kapalı (FILEX_SFTP). Burada kaydedilen anahtar, yönetici ucu açana kadar bağlanmaz.",
  "conn.sshkeys.cannotAdd": "Anahtar kaydedebilecek bir hesapla oturum açmış değilsiniz.",
  "conn.sshkeys.paste": "~/.ssh/id_ed25519.pub dosyasının içeriğini yapıştırın",
  "conn.sshkeys.name": "Ad (isteğe bağlı - boşsa anahtarın kendi yorumu kullanılır)",
  "conn.sshkeys.add": "Anahtar ekle",
  "conn.sshkeys.noCopyId": "ssh-copy-id burada çalışamaz: kabuk üzerinden ~/.ssh/authorized_keys dosyasına ekler, filex’in kabuğu yoktur. Anahtar eklemenin yolu bu kutudur.",
  "conn.sshkeys.col.name": "Ad",
  "conn.sshkeys.col.fingerprint": "Parmak izi",
  "conn.sshkeys.col.added": "Eklendi",
  "conn.sshkeys.col.lastUsed": "Son kullanım",
  "conn.sshkeys.noName": "(adsız)",
  "conn.sshkeys.neverUsed": "hiç",
  "conn.sshkeys.enable": "Aç",
  "conn.sshkeys.disable": "Kapat",
  "conn.sshkeys.remove": "Sil",
  "conn.sshkeys.confirm": "Emin misiniz?",
  "conn.sshkeys.empty": "Henüz anahtar yok. Anahtarsız istemciler hesap parolanızla oturum açar.",
  "conn.guide.sftp.summary": "SFTP, filex’i SSH konuşan her şeyin erişebileceği hâle getirir: bir yedekleme işi, bir tarayıcı, WinSCP, rclone ya da bağlanmış bir klasör.",
  "conn.guide.sftp.fact.host": "Sunucu",
  "conn.guide.sftp.fact.hostHint": "Web uygulamasıyla aynı makine, kendine ait bir portta.",
  "conn.guide.sftp.fact.port": "Port",
  "conn.guide.sftp.fact.portHint": "Ne 22 ne 443: SFTP ham TCP’dir, web vekilinin içinden geçemez.",
  "conn.guide.sftp.fact.userHint": "Kullanıcı adınız. İçinde @ işareti olsaydı çoğu istemcinin ayar dosyasında tırnaklanması gerekirdi; kullanıcı adı tam da bunu ortadan kaldırır.",
  "conn.guide.sftp.fact.auth": "Oturum açma yöntemi",
  "conn.guide.sftp.fact.authKey": "kayıtlı SSH anahtarınız (ya da parolanız)",
  "conn.guide.sftp.fact.authPassword": "hesap parolanız - ya da yukarıdan bir anahtar kaydedin",
  "conn.guide.sftp.fact.authHint": "API anahtarı da parola yerine geçer ve tek başına iptal edilebilir. İki adımlı doğrulaması açık bir hesap SSH anahtarı ya da API anahtarı kullanmalıdır.",
  "conn.guide.sftp.fact.path": "Yol",
  "conn.guide.sftp.fact.pathHint": "İlk klasör bir depodur; kök, açabildiğiniz depoları listeler.",
  "conn.guide.sftp.openssh.connectCaption": "Bağlan, gönder, al",
  "conn.guide.sftp.openssh.noShell": "Burada kabuk yok, yalnız SFTP alt sistemi var. `ssh sunucu komut` bilerek reddedilir; scp çalışır çünkü OpenSSH 9 onun için de SFTP konuşur.",
  "conn.guide.sftp.key.tab": "Anahtar kurulumu",
  "conn.guide.sftp.key.s1": "Bağlanacak makinede bir anahtar çifti üretin (zaten varsa atlayın).",
  "conn.guide.sftp.key.s2": "AÇIK yarısını kopyalayın - .pub dosyası, asla diğeri değil.",
  "conn.guide.sftp.key.s3": "Yukarıdaki kutuya yapıştırıp bağlanın; o andan sonra parola gönderilmez.",
  "conn.guide.sftp.key.genCaption": "Kendi makinenizde",
  "conn.guide.sftp.key.noCopyId": "ssh-copy-id filex’e karşı ÇALIŞMAZ: ~/.ssh/authorized_keys dosyasına eklemek için kabuğa ihtiyacı var, filex’te kabuk yok. Anahtarı yukarıdan yapıştırın.",
  "conn.guide.sftp.winscp.s1": "Yeni site → Dosya protokolü: SFTP.",
  "conn.guide.sftp.winscp.s2": "Sunucu adı: {host}, port: {port}.",
  "conn.guide.sftp.winscp.s3": "Kullanıcı adı: {user}. Anahtar için: Gelişmiş → SSH → Kimlik Doğrulama → özel anahtar dosyası.",
  "conn.guide.sftp.winscp.s4": "WinSCP .ppk biçiminde özel anahtar ister - OpenSSH anahtarını kendi aracıyla (Araçlar → PuTTYgen) bir kez dönüştürün.",
  "conn.guide.sftp.filezilla.s1": "Dosya → Site Yöneticisi → Yeni site, Protokol: SFTP.",
  "conn.guide.sftp.filezilla.s2": "Sunucu: {host}, port: {port}.",
  "conn.guide.sftp.filezilla.s3": "Kullanıcı: {user}. Giriş türü: parola için Normal, anahtar için Anahtar dosyası.",
  "conn.guide.sftp.rclone.useCaption": "Kullanımı",
  "conn.guide.sftp.sshfs.mountCaption": "Bağla ve çöz",
  "conn.guide.sftp.sshfs.note": "Bağlanmış bir klasörde her kayıt dosyanın tamamını yeniden yazar. Belgeler için iyi; veritabanı ya da yerinde düzenlediğiniz bir video için değil.",
  "conn.guide.sftp.note.storages": "Kök bir ev dizini değildir: açabildiğiniz depoları listeler ve yolun ilk parçası bir depoyu adlandırır.",
  "conn.guide.sftp.note.permissions": "İstemcinizin çizdiği izin bitleri buradaki erişim seviyenizden gelir; yani salt-okunur görünen bir dosya sizin için gerçekten öyledir.",
  "conn.guide.sftp.note.trash": "Silme her yerdeki gibi filex çöp kutusuna gider ve saklama politikası süpürene kadar geri alınabilir.",
  "conn.guide.sftp.note.totp": "Hesabınızda iki adımlı doğrulama açıksa parola burada çalışmaz - SSH’ın kodu soracak bir kanalı yok. Bir SSH anahtarı kaydedin ya da parola yerine API anahtarı kullanın.",
  "conn.guide.sftp.note.disabled": "Bu sunucuda SFTP ucu kapalı. Yönetici açtığında bu talimatlar çalışacaktır.",
  // ── FTPS ─────────────────────────────────────────────────────────
  "conn.guide.ftps.summary": "FTPS, yalnızca FTP öğrenmiş ekipman için var: tarayıp-klasöre-atan yazıcılar, EDI muhatapları, eski laboratuvar ve endüstri yazılımları. Her zaman TLS üzerinden.",
  "conn.guide.ftps.fact.host": "Sunucu",
  "conn.guide.ftps.fact.hostHint": "Web uygulamasıyla aynı makine, kendine ait bir portta.",
  "conn.guide.ftps.fact.port": "Port",
  "conn.guide.ftps.fact.portHint": "Kontrol kanalı. Veri, aşağıdaki pasif aralıktan ayrı bir porttan akar.",
  "conn.guide.ftps.fact.mode": "Şifreleme",
  "conn.guide.ftps.fact.modeValue": "FTPS - açık (explicit) TLS, zorunlu",
  "conn.guide.ftps.fact.modeHint": 'Düz FTP, parola okunmadan reddedilir. "Require explicit FTP over TLS" seçin; "plain FTP" ya da "implicit" asla.',
  "conn.guide.ftps.fact.userHint": "Kullanıcı adınız ya da e-postanız. Parola yerine bir API anahtarı da kullanılabilir ve tek başına iptal edilebilir.",
  "conn.guide.ftps.fact.passwordHint": "Hesap parolanız ya da bir API anahtarı. İki adımlı doğrulaması açık bir hesap API anahtarı kullanmalıdır - FTP'nin kodu soracak bir yolu yok.",
  "conn.guide.ftps.fact.pasv": "Pasif portlar",
  "conn.guide.ftps.fact.pasvHint": "Veri bağlantıları buraya düşer. Güvenlik duvarınız bu aralığı kapatıyorsa aktarım iki tarafta da hata vermeden ASILI KALIR - FTP'nin klasik arızası budur.",
  "conn.guide.ftps.filezilla.s1": "Dosya → Site Yöneticisi → Yeni site, Protokol: FTP.",
  "conn.guide.ftps.filezilla.s2": "Sunucu: {host}, port: {port}.",
  "conn.guide.ftps.filezilla.s3": 'Şifreleme: "Require explicit FTP over TLS". Giriş türü: Normal, kullanıcı: {user}.',
  "conn.guide.ftps.filezilla.s4": "Aktarım ayarları → Pasif. Bu sunucu aktif modu reddeder.",
  "conn.guide.ftps.winscp.s1": "Yeni site → Dosya protokolü: FTP, Şifreleme: TLS/SSL Explicit encryption.",
  "conn.guide.ftps.winscp.s2": "Sunucu adı: {host}, port: {port}.",
  "conn.guide.ftps.winscp.s3": "Kullanıcı adı: {user}, parola yukarıdaki.",
  "conn.guide.ftps.curl.caption": "Gönder ve al",
  "conn.guide.ftps.curl.sslReqd": "--ssl-reqd isteğe bağlı değil: curl'ün düz metne geri düşmek yerine TLS'i ZORUNLU kılmasını sağlar. Bu sunucu zaten düz metni reddediyor, ama alışkanlık sizi reddetmeyen sunuculara karşı korur.",
  "conn.guide.ftps.lftp.caption": "Bağlan",
  "conn.guide.ftps.lftp.protectData": "ssl-protect-data yalnız oturum açmayı değil DOSYAYI da şifreler. Olmazsa lftp TLS ile oturum açar ve dosyayı açık metin gönderir - sahada en sık yapılan FTPS yanlışı budur.",
  "conn.guide.ftps.rclone.useCaption": "Kullanımı",
  "conn.guide.ftps.printer.tab": "Tarayıcı / yazıcı",
  "conn.guide.ftps.printer.s1": "Cihazın tara-ve-FTP'ye-gönder ayarlarında: sunucu {host}, port {port}.",
  "conn.guide.ftps.printer.s2": "Kullanıcı: {user}, parola yukarıdaki. Cihaz için kendi parolanız yerine bir API anahtarı oluşturun - başka hiçbir şeyi değiştirmeden iptal edilebilir.",
  "conn.guide.ftps.printer.s3": "Yol: {path} - ya da önceden oluşturduğunuz bir alt klasör. Cihaz depo oluşturamaz.",
  "conn.guide.ftps.printer.s4": '"SSL/TLS" ya da "FTPS explicit" seçeneğini AÇIN ve PASİF modu seçin.',
  "conn.guide.ftps.printer.noTLS": "Tara-ve-gönder yazılımlarının önemli bir kısmı TLS konuşamıyor. Bu sunucu öyle bir cihazla konuşmayacak ve bu bilinçli: alternatifi, belgelerinizin ve parolanızın ofis ağında açık metin dolaşması.",
  "conn.guide.ftps.note.tls": "TLS zorunludur ve kapatan bir düğme yoktur. Düz FTP parolanızı açık metin gönderir, ardından dosyanızı da.",
  "conn.guide.ftps.note.passive": "Yalnızca pasif mod. Aktif modda sunucu istemciyi geri arar; bu NAT arkasında çalışmaz ve çoğu güvenlik duvarı tarafından engellenir.",
  "conn.guide.ftps.note.storages": "Kök bir ev dizini değildir: açabildiğiniz depoları listeler ve yolun ilk parçası bir depoyu adlandırır.",
  "conn.guide.ftps.note.trash": "Silme her yerdeki gibi filex çöp kutusuna gider ve saklama politikası süpürene kadar geri alınabilir.",
  "conn.guide.ftps.note.prefer": "İstemci SFTP konuşabiliyorsa onu tercih edin: tek bağlantı, tek port, pasif mod sürprizi yok.",
  "conn.guide.ftps.note.selfSigned": "Bu sunucu kendinden imzalı bir sertifika kullanıyor. Kanalı şifreler ama karşı tarafın kim olduğunu kanıtlamaz; çoğu istemci bir kez onay ister. Önemli bir iş için gerçek sertifika koyun.",
  "conn.guide.ftps.note.disabled": "Bu sunucuda FTPS ucu kapalı. Yönetici açtığında bu talimatlar çalışacaktır.",
  // ── NFS ──────────────────────────────────────────────────────────
  "conn.nfs.title": "NFS export'ları",
  "conn.nfs.lead": "Bir export, ağınızdaki bir makinenin filex'i sürücü olarak bağlamasını sağlar - medya oynatıcı, derleme sunucusu, yedek kutusu.",
  "conn.nfs.pathIsSecret": "⚠ Export yolu PAROLANIN TA KENDİSİDİR. NFS, Kerberos olmadan istemciye kim olduğunu soramaz; bu yüzden filex yola 32 rastgele bayt koyar: yolu bilen sizin adınıza bağlanır. Bağlama satırını bir kimlik bilgisi gibi saklayın - /etc/fstab çoğu sistemde herkes tarafından okunabilir.",
  "conn.nfs.disabled": "Bu sunucuda NFS ucu kapalı (FILEX_NFS). Burada oluşturulan export, yönetici ucu açana kadar bağlanmaz.",
  "conn.nfs.cannotMint": "Export oluşturabilecek bir hesapla oturum açmış değilsiniz.",
  "conn.nfs.label": "Ne için? (medya oynatıcı, yedek kutusu, …)",
  "conn.nfs.defaultLabel": "nfs export",
  "conn.nfs.everyStorage": "Görebildiğim tüm depolar",
  "conn.nfs.prefix": "Depo içindeki klasör (isteğe bağlı)",
  "conn.nfs.allowCidrs": "İzinli adresler, örn. 192.168.1.0/24 (isteğe bağlı)",
  "conn.nfs.readOnly": "Salt okunur",
  "conn.nfs.readOnlyHint": "Bir makine için güvenli varsayılan salt okunurdur: sizin yetkiniz ne olursa olsun bu bağlantı üzerinden her yazmayı reddeder. Adres listesi daha da daraltır - listenin dışından gelen bağlanamaz.",
  "conn.nfs.mint": "Export oluştur",
  "conn.nfs.once": "Şimdi kopyalayın - yol yalnızca bir kez gösterilir ve geri alınamaz.",
  "conn.nfs.dismiss": "Kopyaladım",
  "conn.nfs.col.label": "Etiket",
  "conn.nfs.col.scope": "Kapsam",
  "conn.nfs.col.mode": "Mod",
  "conn.nfs.col.lastUsed": "Son bağlanma",
  "conn.nfs.scopeAll": "görebildiğiniz her şey",
  "conn.nfs.modeRead": "salt okunur",
  "conn.nfs.modeWrite": "okuma/yazma",
  "conn.nfs.noLabel": "(etiketsiz)",
  "conn.nfs.neverUsed": "hiç",
  "conn.nfs.enable": "Aç",
  "conn.nfs.disable": "Kapat",
  "conn.nfs.revoke": "İptal et",
  "conn.nfs.confirm": "Emin misiniz?",
  "conn.nfs.empty": "Henüz export yok.",
  "conn.guide.nfs.summary": "NFS, filex'i kendi ağınızdaki bir makinede sürücü olarak bağlar - NAS protokolü, onu bekleyen cihazlar için.",
  "conn.guide.nfs.pathPlaceholder": "yukarıdan bir export oluşturun",
  "conn.guide.nfs.fact.host": "Sunucu",
  "conn.guide.nfs.fact.hostHint": "Web uygulamasıyla aynı makine, kendine ait bir portta.",
  "conn.guide.nfs.fact.port": "Port",
  "conn.guide.nfs.fact.portHint": "Hem port= hem mountport= buna ayarlanmalı; filex mount ve NFS servislerini tek portta veriyor.",
  "conn.guide.nfs.fact.export": "Export yolu",
  "conn.guide.nfs.fact.exportHint": "Kimlik bilgisi budur. Export oluşturulurken bir kez gösterilir ve hash'li saklanır - filex bir daha gösteremez.",
  "conn.guide.nfs.fact.options": "Bağlama seçenekleri",
  "conn.guide.nfs.fact.optionsHint": "nolock, çünkü filex NFS kilit yöneticisini çalıştırmıyor; nfsvers=3, çünkü bu sunucunun konuştuğu sürüm bu.",
  "conn.guide.nfs.linux.mountCaption": "Bağla",
  "conn.guide.nfs.linux.fstabSecret": "Bu yolu içeren bir /etc/fstab satırı, herkesin okuyabildiği bir dosyadaki paroladır. Ortamınızda önemliyse kimlik korumalı automount kullanın ya da bağlamayı yalnız root'un okuyabildiği bir unit dosyasında tutun.",
  "conn.guide.nfs.mac.mountCaption": "Bağla",
  "conn.guide.nfs.mac.resvport": "macOS resvport ister: istemcisi ayrıcalıklı bir kaynak portta ısrar eder ve olmadan bağlantıyı reddeder.",
  "conn.guide.nfs.win.s1": `Windows Özellikleri'nden "Services for NFS" → "Client for NFS" bileşenini açın (yalnız Pro ve Enterprise; Home'da yok).`,
  "conn.guide.nfs.win.s2": "Komut İstemi'ni yönetici olarak açın.",
  "conn.guide.nfs.win.s3": "Aşağıdaki komutla export'u bir sürücü harfine bağlayın.",
  "conn.guide.nfs.win.cmdCaption": "Z: sürücüsüne bağla",
  "conn.guide.nfs.win.port": "Windows'un mount servisinin portunu söyleme imkânı yok; yalnızca standart 2049 portundaki bir NFS sunucusuna erişebilir. Bu sunucu başka bir porttaysa SFTP'yi ya da filex masaüstü uygulamasını kullanın.",
  "conn.guide.nfs.nas.tab": "NAS / medya oynatıcı",
  "conn.guide.nfs.nas.s1": "Cihazın NFS ayarlarında: sunucu {host}, port {port} (ayrı ayrı soruyorsa hem NFS hem mount portunu ayarlayın).",
  "conn.guide.nfs.nas.s2": "Uzak yol: yukarıdaki export yolu, birebir.",
  "conn.guide.nfs.nas.s3": "NFS sürüm 3, kilitleme kapalı. Cihazın gerçekten yazması gerekmiyorsa export'u salt okunur oluşturun.",
  "conn.guide.nfs.note.unencrypted": "NFSv3 şifreli değildir. Trafiği okuyabilen dosyalarınızı görür, yolu öğrenen bağlanabilir. Ev/ofis ağında ya da VPN üzerinden kullanın - internet üzerinden asla.",
  "conn.guide.nfs.note.pathIsSecret": "Export yolu kimlik bilgisinin tamamıdır. Sızarsa yukarıdaki listeden iptal edin; değiştirilecek başka bir şey yok.",
  "conn.guide.nfs.note.noPortmapper": "111 portunda portmapper yok; portu söylenmeyen istemci sunucuyu bulamaz. Buradaki her komutun port= ve mountport= taşımasının sebebi bu.",
  "conn.guide.nfs.note.uid": "İstemcinizin gönderdiği kullanıcı ve grup kimlikleri yok sayılır: bağlantı zaten kime ait olduğunu biliyor. Gördüğünüz izinler filex'teki erişiminizden gelir.",
  "conn.guide.nfs.note.trash": "Silme her yerdeki gibi filex çöp kutusuna gider ve saklama politikası süpürene kadar geri alınabilir.",
  "conn.guide.nfs.note.revoke": "İptal anında değil, bir sonraki istekte etkili olur: NFS'te sonlandırılacak bir oturum yok, bağlantısı açık olan istemci sıradaki işleminde hata alır.",
  "conn.guide.nfs.note.disabled": "Bu sunucuda NFS ucu kapalı. Yönetici açtığında bu talimatlar çalışacaktır.",
  "conn.tokens.title": "API anahtarları",
  "conn.tokens.lead": "FTPS, WebDAV ve filex mount hesap parolanız yerine bir API anahtarıyla oturum açar. Buradan oluşturun - tek başına iptal edilebilir, ayrıca iki adımlı doğrulaması açık bir hesap bunlarda parolasını zaten kullanamaz.",
  "conn.tokens.mint": "API anahtarı oluştur",
  "conn.tokens.once": "Şimdi kopyalayın - yalnızca bir kez gösterilir. Sunucuda yalnız özeti saklandığı için bir daha gösterilemez.",
  "conn.tokens.dismiss": "Kopyaladım",
  "conn.tokens.cannotMint": "Bu oturum API anahtarı oluşturamıyor. Kendi hesabınızla oturum açıp oluşturun.",
  "conn.tokens.empty": "Henüz API anahtarı yok.",
  "conn.tokens.neverUsed": "hiç",
  "conn.tokens.revoke": "İptal et",
  "conn.tokens.confirm": "Emin misiniz?",
  "conn.tokens.col.label": "Ad",
  "conn.tokens.col.scopes": "İzinler",
  "conn.tokens.col.comments": "Yorumlar",
  "conn.tokens.col.used": "Son kullanım",
  "conn.tokens.revokeHint": "İptal, yalnız bir sonraki oturum açmayı değil AÇIK bağlantıyı da durdurur: SFTP ya da FTPS oturumu kesilir, bağlı bir sürücü yarım dakika içinde çalışmayı bırakır.",
  "conn.guide.mount.summary": "filex mount, uzaktaki bir filex sunucusunu bu makinede bir klasöre bağlar - tarayıcının kullandığı aynı HTTPS üzerinden. Buradakilerin her yerden çalışan tek yöntemi: yerel ağ da gerekmez, ek sunucu da, üçüncü parti bir istemci de.",
  "conn.guide.mount.fact.url": "Sunucu adresi",
  "conn.guide.mount.fact.urlHint": "Tarayıcıda kullandığınız adresin aynısı. Başka hiçbir şeye erişilebilir olması gerekmez.",
  "conn.guide.mount.fact.token": "API anahtarı",
  "conn.guide.mount.fact.tokenPlaceholder": "API anahtarları bölümünden oluşturun",
  "conn.guide.mount.fact.tokenHint": "Parolanız değil, bir API anahtarı - tek başına iptal edilebilir, ayrıca 2FA açık bir hesap burada parolasını zaten kullanamaz.",
  "conn.guide.mount.fact.remote": "Neyi bağlayacağınız",
  "conn.guide.mount.fact.remoteHint": "--remote vermezseniz her depo bir klasör olarak görünür; tek bir depoyu - ya da onun içindeki bir klasörü - adlandırırsanız yalnızca o bağlanır.",
  "conn.guide.mount.linux.mountCaption": "Bağlayın",
  "conn.guide.mount.linux.umountCaption": "Ayırın",
  "conn.guide.mount.linux.umountWarn": "Süreci öldürerek değil, fusermount ile ayırın. Ayrılmadan ölen bir bağlantı, birileri elle fusermount çalıştırana kadar her ls komutunun asılı kaldığı bir klasör bırakır.",
  "conn.guide.mount.linux.systemdCaption": "Oturum açılınca otomatik bağlansın (systemd kullanıcı birimi)",
  "conn.guide.mount.win.winfsp": "Windows'ta bir kez WinFsp kurulması gerekiyor - ücretsiz ve açık kaynak: https://winfsp.dev. Başka bir şey gerekmiyor, sonrasında yönetici hakkı da istemiyor.",
  "conn.guide.mount.win.mountCaption": "Sürücü olarak bağlayın",
  "conn.guide.mount.win.freeLetter": "BOŞ bir sürücü harfi seçin. Harf bağlama sırasında oluşturulur, var olan bir şeye eklenmez; kullanımdaki bir harfi verirseniz bunu söylemeyen bir hatayla başarısız olur.",
  "conn.guide.mount.win.stop": "O pencerede Ctrl-C ile durdurun. Sürücü kaybolur ve bu makinede hiçbir şey kalmaz.",
  "conn.guide.mount.mac.unsupported": "filex mount macOS'ta çalışmıyor. macFUSE gerekiyor; lisansı filex gibi bir programın onu sizin yerinize kurmasına izin vermiyor ve Go bağlaması filex'in bilinçli olarak kullanmadığı bir C derleyicisi istiyor. Komut burada çalışıyormuş gibi görünüp hiçbir şey yapmak yerine açıkça reddediyor.",
  "conn.guide.mount.mac.alternatives": "macOS'ta filex masaüstü uygulamasını klasör eşitlemesiyle kullanın (dosyalar diskte durur) ya da sürücü bağlayabilen bir istemciyle SFTP.",
  "conn.guide.mount.note.notASync": "Bu bir eşitleme değildir. Küçük bir okuma önbelleği dışında bu makineye hiçbir şey kopyalanmaz; yüz bin dosyanın içinden birini gerisini indirmeden açar. Dosyaları çevrimdışıyken istiyorsanız klasör eşitlemesini kullanın.",
  "conn.guide.mount.note.reachable": "Sunucuya, tarayıcının geçtiği hangi vekil ya da tünel varsa oradan ulaşır - çünkü altında aynı API vardır. İzinleriniz ve depolarınız da birlikte gelir.",
  "conn.guide.mount.note.wholeFileWrites": "Bağlantı üzerinden yazdığınız dosya, yazılırken değil, program onu kapattığında yüklenir. Çok büyük bir dosyayı yerinde düzenlemek burada yerel diskten yavaştır; içeri ve dışarı kopyalamak değildir.",
  "conn.guide.mount.note.trash": "Silme her yerdeki gibi filex çöp kutusuna gider ve saklama politikası süpürene kadar geri alınabilir.",
  "conn.guide.mount.note.revoke": "Bir bağlantıyı durdurmak için API anahtarını iptal edin. Bağlantı hâlâ takılı olsa bile yarım dakika içinde hizmet vermeyi bırakır.",
  "storages.driver.ftp": "FTP / FTPS",
  "storages.driver.local": "Yerel dosya sistemi",
  "storages.driver.s3": "S3 / Hetzner / MinIO",
  "storages.driver.sftp": "SFTP",
  "storages.driver.smb": "SMB / CIFS (NAS)",
  "storages.driver.webdav": "WebDAV",
  "storages.fieldHelp.smbShare": "Sunucu adı olmadan yalnızca paylaşım adı: `\\\\nas\\media` değil, `media`.",
  "storages.fieldHelp.smbDomain": "Yalnızca Windows etki alanı hesabı için. NAS kullanıyorsanız boş bırakın.",
  "storages.fieldHelp.smbRoot": "Paylaşımın içindeki alt klasör. Paylaşımın tamamı için boş bırakın.",
  "storages.fields.share": "Paylaşım",
  "storages.fields.domain": "Etki alanı / çalışma grubu",
  "storages.fieldHelp.disablePresign": "Varsayılan olarak açık: yüklemeler ve herkese açık paylaşım bağlantılarındaki indirmeler filex üzerinden akar; kova endpoint'inin tarayıcıdan erişilebilir olması gerekmez (yalnız yerel ağdaki MinIO doğrudan çalışır). Yalnızca endpoint kullanıcıların tarayıcısından erişilebiliyorsa (AWS, herkese açık MinIO) ve tarayıcının kovayla doğrudan konuşmasını istiyorsanız kapatın - çok büyük dosyalarda daha hızlıdır, ama depo SDK'nın imzaladığı URL'leri kabul etmelidir (Ceph RGW / bazı Hetzner kurulumları SignatureDoesNotMatch döner).",
  "storages.fieldHelp.endpoint": "AWS S3 için boş bırakın. S3 uyumlu diğer tüm depolar kendi endpoint'ini ister.",
  "storages.fieldHelp.hostKey": "authorized_keys / known_hosts satır biçiminde tek bir açık anahtar.",
  "storages.fieldHelp.insecureSkipHostKey": "Her sunucu anahtarını kabul eder. Yalnızca geçici sunucular için.",
  "storages.fieldHelp.keyPath": "Sunucudaki anahtar dosyasının yolu; depo başlarken okunur. PEM alanı boşken kullanılır.",
  "storages.fieldHelp.knownHosts": "Katı sunucu anahtarı denetimi için OpenSSH known_hosts yolu. Varsayılan, ~/.filex/known_hosts içinde ilk bağlantıda güven.",
  "storages.fieldHelp.passive": "Kapatmak aktif moda geçirir; bu, sunucunun bu makineye geri bağlanmasını gerektirir.",
  "storages.fieldHelp.path": "Sunucudaki dizin. Yoksa oluşturulur; filex asla / dizinini mount etmez.",
  "storages.fieldHelp.pathStyle": "AWS dışındaki tüm depolarda açık olmalı. Endpoint girildiyse ve bu alana hiç dokunulmadıysa kendiliğinden açılır.",
  "storages.fieldHelp.prefix": "Kova içindeki alt klasör. Zorunlu: filex kova kökünün sahipliğini asla almaz.",
  "storages.fieldHelp.region": 'Boş bırakılırsa "auto" kullanılır.',
  "storages.fieldHelp.root": "Arka uçtaki alt klasör. Zorunlu: filex hesabın kökünü asla mount etmez.",
  "storages.fieldHelp.sftpAuth": "Parola ya da özel anahtardan biri zorunludur.",
  "storages.fieldHelp.tls": "Düz FTP kimlik bilgilerini açık metin gönderir - sunucu destekliyorsa açın.",
  "storages.fields.accessKey": "Access key",
  "storages.fields.basePath": "Temel yol",
  "storages.fields.bucket": "Kova",
  "storages.fields.disablePresign": "Aktarımları filex üzerinden geçir",
  "storages.fields.endpoint": "Endpoint",
  "storages.fields.host": "Sunucu",
  "storages.fields.hostKey": "Sabitlenmiş sunucu anahtarı",
  "storages.fields.insecureSkipHostKey": "Sunucu anahtarı doğrulamasını atla (güvensiz)",
  "storages.fields.keyPath": "Özel anahtar dosyası",
  "storages.fields.knownHosts": "known_hosts dosyası",
  "storages.fields.name": "Görünen ad",
  "storages.fields.namePlaceholder": "Kişisel fotoğraflar",
  "storages.fields.passive": "Pasif mod (PASV)",
  "storages.fields.password": "Parola",
  "storages.fields.path": "Dizin yolu",
  "storages.fields.pathStyle": "Path-style URL kullan (Hetzner, MinIO)",
  "storages.fields.port": "Port",
  "storages.fields.prefix": "Önek (prefix)",
  "storages.fields.privateKey": "Özel anahtar (PEM)",
  "storages.fields.rbac": "Öğe bazlı erişim denetimi (RBAC)",
  "storages.fields.rbacHint": "Açıkken yönetici olmayanlar yalnızca kendilerine yetki verilen dosya ve klasörleri görür (Klasör erişimi sayfasında listelenir). Kapalıyken herkes depoyu rolüne göre açar.",
  "storages.fields.readOnly": "Salt okunur mount",
  "storages.fields.region": "Bölge",
  "storages.fields.root": "Temel yol",
  "storages.fields.secretKey": "Secret key",
  "storages.fields.tls": "FTPS (açık AUTH TLS)",
  "storages.fields.url": "Temel URL",
  "storages.fields.user": "Kullanıcı",
  "storages.fields.s3AttemptTimeout": "Deneme zaman aşımı (saniye)",
  "storages.fields.s3MaxAttempts": "İstek başına deneme sayısı",
  "storages.fields.s3TotalTimeout": "Vazgeçme süresi (saniye)",
  "storages.fieldHelp.s3AttemptTimeout": "Tek bir denemenin depodan bir yaşam belirtisi için bekleyebileceği süre: bağlanma, TLS el sıkışması, istek gönderildikten sonraki cevap ve cevabın her yeni parçası. İlerleyen bir aktarım, süresi ne olursa olsun hiçbir zaman kesilmez; deponun almayı bıraktığı bir yükleme 60 saniye sonra, bu değer daha uzunsa bu kadar sonra kesilir. Kopyalama ve yeniden adlandırma cevap için 10 dakikaya kadar bekler, çünkü depo bunları ancak kopya bittiğinde cevaplar.",
  "storages.fieldHelp.s3MaxAttempts": "Hata geçebilecek türdeyse bir isteğin toplamda kaç kez deneneceği: ağ hatası, zaman aşımı, 5xx cevabı, hız sınırlaması. 1 yeniden denemeyi kapatır. Bir ret (403, bulunmayan bir kova, çözümlenmeyen bir sunucu adı) hiçbir zaman yeniden denenmez.",
  "storages.fieldHelp.s3TotalTimeout": "İlk denemeden itibaren bu kadar saniye içinde bitemeyecek yeni bir deneme başlatılmaz; böylece çalışmayan bir depoya yükleme ya da listeleme, kesintiyi bu süre içinde bildirir. Sürmekte olan bir aktarım kesilmez. Zaman aşımına uğrayan bir istek ancak bu değer deneme zaman aşımının en az iki katıysa yeniden denenir.",
  "storages.fields.attemptTimeout": "Deneme zaman aşımı (saniye)",
  "storages.fields.maxAttempts": "İstek başına deneme sayısı",
  "storages.fields.totalTimeout": "Vazgeçme süresi (saniye)",
  "storages.fieldHelp.attemptTimeout": "Tek bir denemenin sunucudan bir yaşam belirtisi için bekleyebileceği süre: bağlanma, oturum açma, her isteğin cevabı ve bir aktarımın her yeni parçası. İlerleyen bir aktarım, süresi ne olursa olsun hiçbir zaman kesilmez; sunucunun almayı bıraktığı bir yükleme 60 saniye sonra, bu değer daha uzunsa bu kadar sonra kesilir.",
  "storages.fieldHelp.webdavAttemptTimeout": "Tek bir denemenin sunucudan bir yaşam belirtisi için bekleyebileceği süre: bağlanma, oturum açma, her isteğin cevabı ve bir aktarımın her yeni parçası. İlerleyen bir aktarım, süresi ne olursa olsun hiçbir zaman kesilmez; sunucunun almayı bıraktığı bir yükleme 60 saniye sonra, bu değer daha uzunsa bu kadar sonra kesilir. Kopyalama, taşıma ve silme cevap için 10 dakikaya kadar bekler, çünkü sunucu bunları ancak iş bittiğinde cevaplar.",
  "storages.fieldHelp.maxAttempts": "Hata geçebilecek türdeyse bir isteğin toplamda kaç kez deneneceği: bağlantı reddedilir ya da kopar, cevap zamanında gelmez, sunucu şu an hizmet veremediğini söyler (5xx). 1 yeniden denemeyi kapatır. Bir ret (yanlış parola, bulunmayan bir klasör, doğrulanamayan bir sertifika) hiçbir zaman yeniden denenmez; gönderilmeye başlamış bir yükleme de yeniden denenmez.",
  "storages.fieldHelp.totalTimeout": "İlk denemeden itibaren bu kadar saniye içinde bitemeyecek yeni bir deneme başlatılmaz; böylece çalışmayan bir sunucu bu süre içinde bildirilir. Sürmekte olan bir aktarım kesilmez. Zaman aşımına uğrayan bir istek ancak bu değer deneme zaman aşımının en az iki katıysa yeniden denenir.",
  /* === gezinti:g1 - gezinti paneli (SideNav) === */
  "sidenav.title": "Gezinti",
  "sidenav.views": "Görünümler",
  "sidenav.storages": "Depolar",
  "sidenav.home": "Ana sayfa",
  "sidenav.myfiles": "Dosyalarım",
  "sidenav.recent": "Son kullanılanlar",
  "sidenav.starred": "Yıldızlılar",
  "sidenav.shared": "Benimle paylaşılanlar",
  // Üstteki satırın aynası ve tam altında durur: gelen ile giden.
  "sidenav.myshares": "Paylaştıklarım",
  "sidenav.trash": "Çöp kutusu",
  "sidenav.collapse": "Gezintiyi daralt",
  "sidenav.expand": "Gezintiyi genişlet",
  "sidenav.close": "Gezintiyi kapat",
  // ⚠ aç/kapat çifti ÇEKMECENİN, daralt/genişlet çifti yerleşik PANELİN -
  // ikisi birbirinin yerine kullanılamaz; bkz. en.ts'teki not ve Toolbar.vue
  // içindeki `navToggleLabel`. 560px altında panel listenin üzerine gelen bir
  // çekmecedir: raya inmez, hiç ekranda değildir; "genişlet" olmayan bir
  // genişliği büyütmeyi vaat ederdi.
  "sidenav.open": "Gezintiyi aç",
  "sidenav.storage.shared": "Paylaşılan",
  "sidenav.storage.readOnly": "Salt okunur",
  // #57 - depo satırının sıralama menüsü (sağ tık, uzun basış, Shift+F10).
  // "Ada göre sırala" bir mod değildir; kişinin elle düzeltmeye devam
  // edebileceği bir sıra yazar. "Varsayılan sırayı kullan" kişinin kendi
  // sırasını bırakır: panel yöneticinin sırasına (yoksa sunucununkine) döner.
  "sidenav.storage.moveUp": "Yukarı taşı",
  "sidenav.storage.moveDown": "Aşağı taşı",
  "sidenav.storage.sortName": "Ada göre sırala",
  "sidenav.storage.sortName.done": "Zaten ada göre sıralı",
  "sidenav.storage.defaultOrder": "Varsayılan sırayı kullan",
  "sidenav.storage.defaultOrder.none": "Zaten varsayılan sırada",
  // ⚠ `toolbar.nav` KALDIRILDI, yerine bir şey konmadı - bkz. en.ts'teki not.
  // Paneli daraltan tek denetimin etiketiydi; önce "Gezinti" (panelin adı,
  // düğmenin ne yaptığını söylemiyor), sonra "Gezintiyi göster/gizle" (sabit
  // geçici çözüm). Gerçek düzeltme yukarıdaki dört `sidenav.*` fiili:
  // etiket `navOpen`'a bağlı, daraltacaksa "daralt", genişletecekse
  // "genişlet" yazıyor.
  "node.home": "Ana sayfa",
  "node.recent": "Son kullanılanlar",
  "node.starred": "Yıldızlılar",
  "node.shared": "Benimle paylaşılanlar",
  "empty.recent.title": "Henüz hiçbir şey açılmadı",
  "empty.recent.hint": "Açtığınız dosyalar burada görünür",
  "empty.starred.title": "Henüz yıldızlı dosya yok",
  "empty.starred.hint": "Bir dosyayı yıldızlayın; burada bulursunuz",
  "empty.shared.title": "Sizinle henüz bir şey paylaşılmadı",
  "empty.shared.hint": "Başkalarının paylaştığı klasör ve dosyalar burada görünür",
  /* etiket:t1 */
  "sidenav.tags": "Etiketler",
  "sidenav.tags.empty": "Henüz etiket yok - bir dosyaya sağ tıklayıp Etiketler’den ekleyebilirsiniz.",
  "sidenav.tags.more": "{count} tane daha göster",
  "sidenav.tags.less": "Daha az göster",
  "sidenav.tags.personal": "Kişisel",
  "sidenav.tags.team": "Ekip",
  "empty.tag.title": "“{tag}” etiketli hiçbir şey yok",
  "empty.tag.hint": "Bir dosyaya sağ tıklayıp Etiketler’i seçin; dosya burada görünür",
  "sidenav.connections": "Bağlantılar",
  "sidenav.apps": "Uygulamalar",
  // #162 - mağaza ekranı: yöneticinin açtığı mağazaların kataloğu.
  "sidenav.appstore": "Uygulama mağazası",
  "sidenav.connect": "Bağlantılar",
  "sidenav.apikeys": "API anahtarları",
  "overlay.close": "Kapat",
  "conn.tokens.scopes": "İzinler",
  "conn.tokens.root": "Tek bir klasörle sınırla (isteğe bağlı)",
  "conn.tokens.rootPlaceholder": "depo://klasör",
  "conn.tokens.expiry": "Geçerlilik (gün)",
  "conn.tokens.expiryNever": "süresiz",
  "conn.tokens.defaultName": "API anahtarı {date}",
  "conn.tokens.namePlaceholder": "Ad - ör. yedekleme betiği",
  "conn.tokens.capNote": "Tavan kendi erişiminizdir - sahip olmadığınız bir izin reddedilir, verilmez.",
  "conn.tokens.scopesRequired": "En az bir izin seçin - hiçbir izni olmayan bir API anahtarı verilmez.",
  "conn.tokens.comments": "Yorumlar",
  "conn.tokens.commentsRead": "Okuma",
  "conn.tokens.commentsRw": "Okuma ve yazma",
  "conn.tokens.commentsHint": "Yorum eklemek ve silmek ayrı bir izindir - “write” bunu kapsamaz. Her API anahtarı yorumları okur.",
  "conn.tokens.commentsToRw": "Yorumlar: yazmaya izin ver",
  "conn.tokens.commentsToRead": "Yorumlar: yalnız okuma",
  /* === /gezinti:g1 === */
  /* === surucu:d1 - kabuk (GitHub #14); artık `uiProfile: 'drive'` ile
     gelen bir seçenek değil, her profilde çizilir === */
  "drive.new": "Yeni",
  "drive.new.upload": "Dosya yükle",
  "drive.new.folder": "Yeni klasör",
  "drive.new.request": "Dosya iste",
  "drive.new.document": "Yeni belge",
  /* === belge:n1 - "Yeni belge": + Yeni altındaki seçici ==================
     Tür adları BURADA durmuyor. Her kutucuk sözcüklerini lib/fileIcons
     `typeLabelFor`den okur - listedeki Tür sütununun okuduğu tablonun
     aynısı - böylece ".docx" iki yerde de aynı adla anılır ve yeni bir tür
     için hiç dizge gerekmez. Aşağıda yalnız bu pencerenin kendi metni var. */
  "newdoc.title": "Yeni belge",
  "newdoc.type.label": "Belge türü",
  "newdoc.group.document": "Belgeler",
  "newdoc.group.text": "Metin ve kod",
  "newdoc.group.diagram": "Çizimler",
  "newdoc.group.app": "Uygulamalar",
  /* ⚠ Her servisin tek adı, kendi projesinin kullandığı ad: draw.io
     ("drawio" ya da "diagrams.net" değil) ve ONLYOFFICE. */
  "newdoc.empty.title": "Kullanılabilir belge türü yok",
  "newdoc.empty.body": "Bu sunucu, bu uygulamanın oluşturabileceği bir tür sunmadı.",
  "newdoc.empty.blocked": "Bu sunucunun oluşturabildiği her tür, burada tanımlı olmayan bir düzenleyici servisine bağlı.",
  "newdoc.name": "Ad",
  "newdoc.name.placeholder": "Dosya adı, ör. notlar.txt ya da LICENSE",
  "newdoc.untitled": "Adsız",
  "newdoc.err.slash": "Ad eğik çizgi içeremez.",
  "newdoc.err.exists": "{name} burada zaten var. Başka bir ad seçin.",
  "newdoc.err.bare_ext": "Dosyaya yalnız bir uzantı değil, bir ad verin.",
  "newdoc.err.ext_needs_type": ".{ext} dosyası kendi türüyle oluşturulmalı - boş bir dosya açılmaz. O türü ya da başka bir uzantıyı seçin.",
  "newdoc.hint.ext_added": "Bu tür uzantısını korur; dosya {name} adıyla oluşturulacak.",
  // Drafts (issue #71): a new document is a draft until its first save.
  "sidenav.drafts": "Taslaklar",
  "sidenav.drafts.count": "{n} taslak",
  "sidenav.drafts.count_one": "{n} taslak",
  "node.drafts": "Taslaklar",
  "empty.drafts.title": "Taslak yok",
  "empty.drafts.hint": "Yeni bir belge, ait olduğu yere kaydedilene kadar burada bekler.",
  "drafts.lead": "Henüz kaydedilmemiş yeni belgeler. Bunları yalnızca siz görebilirsiniz.",
  "drafts.count_of": "{n} / {limit} taslak",
  "drafts.col.target": "Kaydedileceği yer",
  "drafts.col.storage": "Depo",
  "drafts.action.save": "Diske kaydet",
  "drafts.open_hint": "{name} dosyasını aç",
  "drafts.no_match": "Filtreye uyan taslak yok.",
  "draft.badge": "Taslak",
  "draft.bar.target": "{folder} konumuna kaydedilecek",
  "draft.save": "Kaydet",
  "draft.saved_to": "{name}, {folder} konumuna kaydedildi.",
  "draft.discarded": "{name} çöp kutusuna taşındı.",
  "draft.kept": "Taslaklarda tutuluyor",
  "draft.editing": "Düzenleniyor…",
  "draft.close.title": "Bu taslak kapatılsın mı?",
  "draft.close.body": "{name}, {folder} için bir taslak ve henüz oraya kaydedilmedi.",
  "draft.close.hint": "Tutulan taslak Taslaklar’da bekler. Çöpe at, taslağı çöp kutusuna taşır.",
  "draft.close.save": "Diske kaydet",
  "draft.close.keep": "Taslaklarda tut",
  "draft.close.discard": "Çöpe at",
  "outside.title": "Bu dosya dışarıda değişti",
  "outside.body": "{name} burada açıkken başka bir yerde değiştirildi ve bu düzenleyicide de değişiklikler var. Hangi sürüm kalsın?",
  "outside.theirs": "Dışarıdakini koru",
  "outside.theirs_hint": "burada yapılan değişiklikler atılır, dışarıdaki sürüm yüklenir.",
  "outside.mine": "Benimkini yaz",
  "outside.mine_hint": "kaydedildiğinde sizin sürümünüz dışarıdakinin üstüne yazılır.",
  "outside.both": "İkisini de tut",
  "outside.both_hint": "dışarıdaki sürüm yerinde kalır, sizinki yanına ayrı bir kopya olarak kaydedilir (ad.filex-conflict-zaman).",
  "outside.hint": "Siz seçene kadar hiçbir sürümün üstüne yazılmaz.",
  "outside.pending": "Bu dosya dışarıda değişti. Hangi sürümün kalacağını seçene kadar hiçbir sürümün üstüne yazılmaz.",
  "outside.choose": "Seç…",
  "outside.note.reloaded": "Dosya dışarıda güncellendi, yeni sürüm yüklendi.",
  "outside.note.theirs": "Dışarıdaki sürüm yüklendi; burada yapılan değişiklikler atıldı.",
  "outside.note.mine": "Sizin sürümünüz kaydedildiğinde dışarıdakinin üstüne yazılacak.",
  "outside.note.both": "Dışarıdaki sürüm yerinde kalıyor; sizinki kaydedildiğinde yanına ayrı bir kopya olarak yazılacak.",
  "draft.taken.title": "Bu adda bir dosya zaten var",
  "draft.taken.body": "{folder} konumunda {name} adında bir dosya zaten var. Taslak {suggested} olarak kaydedilsin mi?",
  "draft.taken.confirm": "{name} olarak kaydet",
  "upload.taken.body": "{folder} konumunda {name} adında bir öğe zaten var ve kasa eski sürümleri saklamaz. {suggested} olarak yüklensin mi?",
  "upload.taken.confirm": "{name} olarak yükle",
  "newdoc.hint.draft": "Taslak olarak açılır: siz kaydedene kadar klasörde hiçbir şey oluşturulmaz.",
  "newdoc.err.draft_limit": "Bu sunucunun izin verdiği kadar taslağınız var ({limit}). Önce Taslaklar’da bazılarını kaydedin ya da silin.",
  "newdoc.err.draft_limit_any": "Bu sunucunun izin verdiği sayıda taslağınız var. Önce Taslaklar’da bazılarını kaydedin ya da silin.",
  "newdoc.open_drafts": "Taslakları aç",
  "newdoc.location": "Konum",
  "newdoc.location.none": "Bir klasör seçin",
  "newdoc.location.change": "Değiştir",
  "newdoc.location.noaccess": "Bu klasöre kaydedemezsiniz.",
  "newdoc.create": "Oluştur",
  "newdoc.creating": "Oluşturuluyor…",
  "newdoc.cancel": "Vazgeç",
  "drive.search.placeholder": "{scope} deposunda ara",
  "drive.search.placeholder_all": "Tüm depolarda ara",
  "drive.search.hint_title": "Her yerde ara ve komut çalıştır ({combo})",
  "drive.storage.used": "{total} alanın {used} kadarı dolu",
  "drive.storage.used_unlimited": "{used} kullanılıyor",
  "drive.storage.used_partial": "en az {used} kullanılıyor",
  "drive.storage.label": "Depolama",
  /* === gorunum:v3-shell - Ana sayfa görünümü (kabuğun içindeki genel bakış)
   * Bölüm başlıkları `sidenav.storages` / `sidenav.recent` / `sidenav.starred`,
   * boş durumlar da `empty.recent.*` / `empty.starred.*` - bilerek: Ana
   * sayfadaki "Son kullanılanlar" başlığı ile yanındaki panel satırı aynı
   * şeydir, ikisine ayrı metin yazmak onları çeviri çeviri birbirinden
   * ayırmanın yoludur. Aşağıda yalnızca başka hiçbir yerde olmayanlar var. */
  "home.title": "Ana sayfa",
  "home.storages.empty": "Henüz depo yok",
  "home.storages.hint": "Depo, filex’in okuyup yazdığı yerdir - depoları yönetici ekler.",
  "drive.section.folders": "Klasörler",
  "drive.section.files": "Dosyalar",
  "filter.aria": "Filtreler",
  "filter.type": "Tür",
  "filter.type.any": "Her tür",
  "filter.type.folder": "Klasörler",
  "filter.type.document": "Belgeler",
  "filter.type.spreadsheet": "Hesap tabloları",
  "filter.type.presentation": "Sunumlar",
  "filter.type.pdf": "PDF’ler",
  "filter.type.image": "Görseller",
  "filter.type.video": "Videolar",
  "filter.type.audio": "Ses dosyaları",
  "filter.type.archive": "Arşivler",
  "filter.type.code": "Kod",
  "filter.modified": "Değiştirilme",
  "filter.modified.any": "Her zaman",
  "filter.modified.today": "Bugün",
  "filter.modified.7d": "Son 7 gün",
  "filter.modified.30d": "Son 30 gün",
  "filter.modified.year": "Bu yıl",
  "filter.size": "Boyut",
  "filter.size.any": "Her boyut",
  "filter.size.lt1": "1 MB altı",
  "filter.size.1to10": "1 - 10 MB",
  "filter.size.10to100": "10 - 100 MB",
  "filter.size.gt100": "100 MB üstü",
  /* surucu:d1-actions - filtre satırının sonundaki ⋮ menüsü. Yalnızca menünün
     KENDİ adı yeni: içindeki her satır o eylemin zaten sahip olduğu metni
     kullanır (`toolbar.new_folder`, `toolbar.upload`, `ctx.paste`,
     `shortcuts.select_all`, `selection.clear`) - bir komutu yeniden adlandıran
     menü, okuyucuya aynı şeyi iki kez öğretir. */
  "filter.actions": "Liste işlemleri",
  "filter.clear": "Filtreleri temizle",
  "filter.empty.title": "Bu filtrelere uyan bir şey yok",
  "filter.empty.hint": "Bir filtreyi kaldırın ya da yukarıdaki alandan her yerde arayın.",
  "filter.count": "{total} öğeden {shown} tanesi",
  "inspector.tab.details": "Ayrıntılar",
  "inspector.tab.activity": "Etkinlik",
  "inspector.people": "Erişimi olan kişiler",
  "inspector.people.you": "Siz",
  "inspector.people.inherited": "üst klasörden",
  "inspector.people.empty": "Yalnızca siz ve aşağıdaki bağlantıya sahip olanlar.",
  "inspector.people.manage": "Erişimi yönet",
  "inspector.link": "Paylaşım bağlantısı",
  "inspector.link.none": "Paylaşılmadı",
  "inspector.link.create": "Bağlantı oluştur",
  "inspector.link.copy": "Bağlantıyı kopyala",
  "inspector.activity.empty": "Bu öğe için henüz etkinlik kaydı yok.",
  "inspector.activity.hint": "Sürümler dosya değiştikçe, yorumlar ise insanlar yazdıkça birikir.",
  "inspector.activity.version": "{n}. sürüm kaydedildi",
  "inspector.activity.comment": "{who} yorum yaptı",
  "inspector.activity.select": "Etkinliğini görmek için bir dosya ya da klasör seçin.",
  /* === /surucu:d1 === */
  /* === gorunum:v1-chrome - filtre satırındaki ad kutusu === */
  "filter.find": "Bu klasörde filtrele…",
  /* surucu:d1-scope - satırların bir klasörün içeriği olmadığı yerlerde aynı
     kutu. Neyi daralttığını söylemek zorunda: depo listesinde "bu klasör" hiçbir
     şeyi adlandırmaz, Ana sayfada ise üç bloğu birden adlandırırdı. */
  "filter.find.storages": "Depolarda filtrele…",
  "filter.find.home": "Ana sayfada filtrele…",
  /* === gorunum:v1-viewer - tam ekran görüntüleyicinin kendi çerçevesi === */
  "viewer.share": "Paylaş",
  "viewer.nav_prev": "Önceki dosya",
  "viewer.nav_next": "Sonraki dosya",
  /* Üst çubuğun künye satırındaki sayaç: "246,3 KB • 9 Eyl 2026 • 1 / 9". */
  "viewer.counter": "{i} / {n}",
  "viewer.original_size": "Özgün boyut",
  "viewer.zoom_reset": "Yakınlaştırmayı sıfırla",
  "viewer.fullscreen": "Tam ekran",
  "viewer.exit_fullscreen": "Tam ekrandan çık",
  "viewer.md_placeholder": "# Markdown buraya…",
  /* === gorunum:v1-selbar - filtre satırının yerini alan seçim çubuğu === */
  "selection.count": "{n} seçildi",
  "selection.clear": "Seçimi temizle",
  /* === gorunum:v1-preview - türün adı, kelimeyle =======================
     Tür sütunu eskiden uzantıyı büyük harfle yazıyordu; artık bunları
     yazıyor. Hangisinin seçileceğine `lib/fileIcons.ts` karar verir
     (`typeLabelKey`) - bir türü adlandıran yalnız iki yer var: o tablo ve bu
     liste. Eşleşmeyen her şey yine büyük harfli uzantıya düşer. `Klasör`
     burada DEĞİL: o `node.folder`, grid kartının alt yazısı zaten onu basar. */
  "ftype.typescript": "TypeScript",
  "ftype.javascript": "JavaScript",
  "ftype.vue": "Vue bileşeni",
  "ftype.python": "Python",
  "ftype.go": "Go",
  "ftype.rust": "Rust",
  "ftype.php": "PHP",
  "ftype.ruby": "Ruby",
  "ftype.java": "Java",
  "ftype.kotlin": "Kotlin",
  "ftype.swift": "Swift",
  "ftype.c": "C kaynağı",
  "ftype.cpp": "C++ kaynağı",
  "ftype.csharp": "C# kaynağı",
  "ftype.stylesheet": "Stil dosyası",
  "ftype.html": "HTML belgesi",
  "ftype.json": "JSON verisi",
  "ftype.yaml": "YAML",
  "ftype.xml": "XML",
  "ftype.toml": "TOML",
  "ftype.sql": "SQL",
  "ftype.shell": "Kabuk betiği",
  "ftype.powershell": "PowerShell betiği",
  "ftype.markdown": "Markdown",
  "ftype.plaintext": "Düz metin",
  "ftype.log": "Günlük dosyası",
  "ftype.config": "Ayar dosyası",
  "ftype.sheet": "Hesap tablosu",
  "ftype.drawio": "draw.io diyagramı",
  "ftype.figma": "Figma tasarımı",
  "ftype.design": "Tasarım dosyası",
  "ftype.image": "Görsel",
  "ftype.video": "Video",
  "ftype.audio": "Ses",
  "ftype.pdf": "PDF belgesi",
  "ftype.document": "Belge",
  "ftype.slides": "Sunum",
  "ftype.archive": "Arşiv",
  "ftype.code": "Kod",
  /* === gorunum:v1-advsearch - Gelişmiş arama penceresi ===================
   * İki `filter.*` anahtarı kardeşlerinin yanında değil burada: paylaşılan
   * birleşimlere pencerenin eklediği yeni üyeler (`modified: 'around'`,
   * `size: 'range'`). Filtre satırı bunları hiç seçmez ama biri oraya
   * ulaşırsa `chipLabel` ham anahtarı yazardı. */
  "filter.modified.around": "Bir tarihin çevresinde",
  "filter.size.range": "Özel aralık",
  "advsearch.open": "Gelişmiş arama",
  "advsearch.title": "Gelişmiş arama",
  "advsearch.subtitle": "Dosyaları ada, içeriğe, yola ya da etikete göre bulun.",
  "advsearch.close": "Kapat",
  "advsearch.content.heading": "İçerik araması",
  "advsearch.viewall": "Tüm sonuçları gör",
  "advsearch.where.any_short": "Her yerde",
  "advsearch.where.here_short": "Yalnız burada",
  "advsearch.where.skip_short": "Burayı atla",
  "advsearch.server.legend": "Sunucunun aradığı",
  "advsearch.client.legend": "Gelen sonuçları daralt",
  "advsearch.query.label": "Kelimeler",
  "advsearch.query.placeholder": "Adın bir parçası ya da dosyanın içindeki kelimeler",
  "advsearch.scope.label": "Nerede arasın",
  "advsearch.scope.name": "Ad ve yol",
  "advsearch.scope.content": "Dosya içeriği",
  "advsearch.scope.all": "İkisi de",
  "advsearch.scope.hint": "İçerik, dizinden aranır; dizin metin türü dosyaların ilk 200 KB’ını kapsar.",
  "advsearch.people.name_only": "Sahip, gelen satırlardan okunur; sahip bilgisi taşıyan satırları da yalnız ad araması döndürür.",
  "advsearch.scope.name_only": "Burada yalnız ad ve yol: içerik sonucu gezgine hangi depodan geldiği bilgisi olmadan ulaşır, bu yüzden içerik araması yalnız tek depolu kurulumlarda sunulur.",
  "advsearch.tags.label": "Etiketler",
  "advsearch.tags.placeholder": "fatura, üç aylık rapor",
  "advsearch.tags.exclude": "Şu etiketler hariç",
  "advsearch.tags.exclude_placeholder": "arşiv",
  "advsearch.tags.hint": "Virgülle ayırın. Etiket daraltır: birden çok etiket hepsini birden taşıyan dosyalar demektir, hiç kullanılmamış bir etiket ise hiçbir şey döndürmez. Bir ad, o adı taşıyan kişisel etiketinizi de ekibinizin etiketini de bulur.",
  "advsearch.where.label": "Klasör",
  "advsearch.where.any": "Bu deponun her yerinde",
  "advsearch.where.here": "Yalnız {folder} içinde",
  "advsearch.where.skip": "{folder} dışındaki her yerde",
  "advsearch.around.label": "Şu kadar içinde",
  "advsearch.around.date": "Tarih ve saat",
  "advsearch.around.h1": "1 saat",
  "advsearch.around.d1": "1 gün",
  "advsearch.around.w1": "1 hafta",
  "advsearch.size.range_label": "Şunun arasında",
  "advsearch.size.from": "En az",
  "advsearch.size.to": "En çok",
  "advsearch.count.idle": "Bir şeyler yazın ya da etiket seçin.",
  "advsearch.count.counting": "Sayılıyor…",
  "advsearch.count.result": "{n} eşleşen öğe",
  "advsearch.count.capped": "Sonuçların ilk sayfasında {n} eşleşen öğe",
  "advsearch.count.result_one": "{n} eşleşen öğe",
  "advsearch.count.capped_one": "Sonuçların ilk sayfasında {n} eşleşen öğe",
  "advsearch.count.error": "Sayım çalıştırılamadı.",
  "advsearch.count.cost": "Sayım bu aramayı çalıştırır. Tür, sahip, tarih, boyut ve klasör bulduğu sonuçları daraltır.",
  "advsearch.wire": "Bir dahaki sefere arama kutusuna şunu yazabilirsiniz:",
  "advsearch.reset": "Sıfırla",
  "advsearch.cancel": "Vazgeç",
  "advsearch.submit": "Ara",
  /* === gorunum:v2-topbar - sayfanın üst barı kalktı; onun taşıdıklarını
     artık gezginin kendi başlığı ve kırıntı satırı taşıyor. === */
  "breadcrumb.subfolders": "Alt klasörler",
  "breadcrumb.subfolders.empty": "Burada alt klasör yok",
  "header.admin": "Yönetim paneli",
  "header.settings": "Ayarlar",
  "header.signout": "Oturumu kapat",
  "ai.assistant": "AI asistanı",
  "assistant.new": "Yeni konuşma",
  "assistant.history": "Konuşmalar",
  "assistant.history_empty": "Henüz konuşma yok.",
  "assistant.close": "Asistanı kapat",
  "assistant.delete": "Bu konuşmayı sil",
  "assistant.intro": "Asistandan dosyalarınızı bulmasını, okumasını, özetlemesini, düzenlemesini ya da taşımasını isteyin. Yalnız sizin izinlerinizle çalışır. Geri alınabilen değişiklikler hemen yapılır ve Geri al bağlantısı bırakır; geri alınamayan her şey onayınızı bekler. Şifreli klasörler ve kasa ona hiçbir zaman gönderilmez.",
  "assistant.placeholder": "Dosyalarınız hakkında sorun...",
  "assistant.send": "Gönder",
  "assistant.stop": "Durdur",
  "assistant.working": "Çalışıyor...",
  "assistant.with_selection": "Seçili {count} öğeyle birlikte",
  "assistant.with_selection_one": "Seçili {count} öğeyle birlikte",
  "assistant.approve": "Onayla",
  "assistant.decline": "Reddet",
  "assistant.undo": "Geri al",
  /* gorunum:v2-share - Paylaş / İzinler penceresinin kendi çerçevesi. İçindeki
     denetimler eski metinlerini koruyor; buradakiler yeni kabuk: başlık, tek
     anahtar, "şu anda kim açabilir" cümlesi ve her şeyin katlandığı üç adlı
     bölüm. */
  "access.title": '"{name}" paylaşımı',
  "access.title_storage": '"{name}" erişimi',
  "access.close": "Kapat",
  "access.done": "Bitti",
  "access.copy": "Kopyala",
  "access.copied": "Kopyalandı",
  "access.link.switch": "Bağlantı paylaşımı",
  "access.who.private": "Yalnızca erişimi olan kişiler açabilir.",
  "access.who.link": "Bağlantıyı bilen herkes açabilir.",
  "access.who.pin": "Bağlantıyı ve PIN'i bilen herkes açabilir.",
  "access.who.existing": "Bağlantı paylaşımı açık - {n} bağlantı var.",
  "access.who.existing_one": "Bağlantı paylaşımı açık - {n} bağlantı var.",
  "access.section.link": "Bağlantı seçenekleri",
  "access.section.people": "Erişimi olanlar",
  "access.section.drop": "Dosya iste",
  "access.sum.pin_on": "PIN var",
  "access.sum.pin_off": "PIN yok",
  "access.sum.people": "{n} kişi",
  "access.sum.people_one": "{n} kişi",
  "access.sum.people_none": "Henüz kimse yok",
  "access.sum.groups": "{n} grup",
  "access.sum.groups_one": "{n} grup",
  "access.sum.drop": "{n} yükleme bağlantısı",
  "access.sum.drop_one": "{n} yükleme bağlantısı",
  "access.sum.drop_none": "Yükleme bağlantısı yok",
  /* Sahiplik - Sahibi sütunu ve Kişiler çipi. "Sistem", filex üzerinden kimsenin
     koymadığı satırın dürüst karşılığıdır (tarayıcı buldu ya da doğrudan kovaya
     yazıldı); boşluk değil, gerçek bir cevaptır. */
  "col.owner": "Sahibi",
  "owner.you": "Siz",
  "owner.system": "Sistem",
  "owner.unknown": "Bilinmiyor",
  "owner.external": "Yükleme bağlantısıyla geldi",
  "owner.last_actor": "Son değiştiren: {who}",
  "filter.people": "Sahibi",
  "filter.people.any": "Herkes",
  "filter.people.me": "Siz",
  "filter.people.system": "Sistem",
  "filter.people.someone": "Başka biri",
  /* surucu:d1-sort - filtre satırının sağ ucundaki sıralama denetimi. Dört
     ölçütün adı `col.*`: menü, liste görünümünün sütun başlıklarındaki
     sözcüklerin aynısını sunar - tek bir sıralamayı süren iki denetim onu
     farklı adlarla anamaz. */
  "sort.by": "Sıralama ölçütü",
  "sort.asc": "Artan",
  "sort.desc": "Azalan",
  /* Bir ARAMA SONUCUNUN sırası. Beşinci bir sıralama ölçütü değildir -
     ekrandaki satırları sunucu sıraladığında denetim, ölçüt adı yerine bunu
     yazar; böylece yapmadığı bir sıralamayı üstlenmez. `_why` denetimin neden
     kapalı olduğudur: bakımcı, denetimin sessizce işlevsizleşmesini değil
     nedeninin yazılmasını istedi. */
  "sort.relevance": "Alaka",
  "sort.relevance_why": "Arama sonuçları eşleşme yakınlığına göre listelenir. Seçtiğiniz sıralama, aramadan çıkınca geri gelir.",
  /* === tablo:t1 - tablonun kendi yapılandırması ==========================
     v0.43'ten beri bir klasörün görünüşüne dair her şey - görünüm, sıralama VE
     sütunlar - değiştirildiği klasöre aittir; kimsenin değiştirmediği klasör
     kişinin varsayılanıyla (ayarlarından), o yoksa kurulumunkiyle açılır.
     `folder_hint` bu kuralı tek cümlede, tam da ona şaşıracak kişinin
     okuyabileceği yerde söyler. */
  "col.location": "Konum",
  "col.deleted": "Silinme",
  "col.deleted_from": "Silindiği yer",
  "col.deleted_by": "Silen",
  "col.remaining": "Kalan süre",
  "cols.menu": "Sütun seçenekleri",
  "cols.title": "Sütunlar",
  "cols.resize": "{col} sütununu yeniden boyutlandır",
  "cols.sort_by": "{col} sütununa göre sırala",
  "cols.move_left": "{col} sütununu sola taşı",
  "cols.move_right": "{col} sütununu sağa taşı",
  "cols.reset": "Sütunları sıfırla",
  "cols.folder_title": "Klasör görünümü",
  "cols.folder_hint": "Burada yaptığınız değişiklik bu klasörde kalır. Hiç değiştirmediğiniz klasörler varsayılan görünümünüzle açılır (Ayarlar → Varsayılan klasör görünümü).",
  "cols.forget_folder": "Bu klasörün görünümünü unut",
  "cols.apply_all": "Bunu tüm klasörler için varsayılanım yap ({count} klasör hatırlanıyor)",
  /* === tablo:t3 - TEK TABLO (components/DataTable.vue) ====================
     Üründeki her tablo bunları konuşur; Türkçe bir sayfada sütun menüsü ya da
     sayfalayıcı İngilizce kalmasın. */
  "table.empty": "Henüz burada bir şey yok",
  "table.prev": "Önceki sayfa",
  "table.next": "Sonraki sayfa",
  "table.sort_paged": "Bu liste sayfalara bölünmüş. Sıralama yalnızca ekrandaki sayfayı yeniden dizerdi, bu yüzden burada kapalı - listeyi arama ya da filtrelerle daraltın.",
  /* === tablo:t1 - çöp kutusu bilgi şeridi ================================
     ⚠ `retention` yalnızca kurulum bize sayıyı SÖYLEDİĞİNDE kullanılır
     (GET /api/admin/protection). Diğer her durumda `retention_unknown` aynı
     şeyi, doğrulayamadığımız bir süreyi taahhüt etmeden söyler: yanlış saklama
     süresi yazan bir şerit, hiç şerit olmamasından kötüdür - insanlar ona
     bakıp karar verir. */
  "trash.retention": "Çöp kutusundaki öğeler {days} gün sonra kalıcı olarak silinir.",
  "trash.retention_one": "Çöp kutusundaki öğeler {days} gün sonra kalıcı olarak silinir.",
  "trash.retention_unknown": "Çöp kutusundaki öğeler, yöneticinizin belirlediği saklama süresi dolunca kalıcı olarak silinir.",
  "trash.empty_action": "Çöp kutusunu boşalt",
  "trash.empty_confirm_title": "Çöp kutusu boşaltılsın mı?",
  "trash.empty_counting": "Çöp kutusundakiler sayılıyor…",
  "trash.show_more": "Daha fazla göster",
  "trash.shown_of": "{total} öğenin {shown} tanesi gösteriliyor",
  "trash.days_remaining": "{n} gün",
  "trash.days_remaining_one": "{n} gün",
  "trash.days_remaining_due": "Silinmek üzere",
  "trash.deleted_by_nobody": "Kayıt yok: virüs taraması karantinaya almış ya da filex bunu tutmaya başlamadan önce silinmiş",
  "empty.trash.hint": "Sildiğiniz dosyalar önce buraya düşer, böylece geri alabilirsiniz.",
  /* tasi:m1 - hedef klasör seçici (modals/DestinationPickerModal.vue) ve
     üzerine kurulan iki seçim eylemi. */
  "destpicker.title.move": "Şuraya taşı",
  "destpicker.title.copy": "Şuraya kopyala",
  "destpicker.title.choose": "Klasör seç",
  "destpicker.confirm.move": "Buraya taşı",
  "destpicker.confirm.copy": "Buraya kopyala",
  "destpicker.confirm.choose": "Bu klasörü seç",
  "destpicker.title.choose_file": "Dosya seç",
  "destpicker.confirm.choose_file": "Bu dosyayı seç",
  "destpicker.title.save": "Şuraya kaydet",
  "destpicker.confirm.save": "Buraya kaydet",
  "destpicker.pick_a_file": "Listeden bir dosya seçin.",
  "destpicker.empty_files": "Bu klasör boş",
  "destpicker.cancel": "Vazgeç",
  "destpicker.up": "Bir üst klasör",
  "destpicker.crumbs": "Konum",
  "destpicker.drives": "Depolar",
  "destpicker.loading": "Yükleniyor…",
  "destpicker.empty": "Burada alt klasör yok",
  "destpicker.unreadable": "Bu klasör açılamıyor.",
  "destpicker.readonly": "Salt okunur",
  "destpicker.readonly_here": "Bu klasöre yazamazsınız.",
  "destpicker.pick_a_drive": "Bir klasör seçmek için önce bir depo açın.",
  "destpicker.target": "Hedef: {name}",
  "destpicker.tag.blocked": "Uygun değil",
  "destpicker.blocked.self": "Bir klasör kendi içine taşınamaz.",
  "destpicker.blocked.descendant": "Bir klasör kendi alt klasörlerinden birine taşınamaz.",
  "destpicker.tag.vault": "Kasa",
  "destpicker.blocked.vault_in": "Buradan kasaya bir şey konmaz: kasanın içinden yükleyin.",
  "destpicker.blocked.vault_out": "Kasadakiler yalnız o kasanın içinde taşınır. Dışarı almak için indirin.",
  "ctx.move_to": "Şuraya taşı…",
  "ctx.copy_to": "Şuraya kopyala…",
  "ctx.access.one_only": "Paylaşım aynı anda tek öğe için çalışır.",
  "ctx.storage_access": "Erişim…",
  "toast.archive.preparing": "Arşiv hazırlanıyor…",
  "toast.archive.started": "{name} indiriliyor ({count} dosya)",
  "toast.archive.started_one": "{name} indiriliyor ({count} dosya)",
  "toast.archive.empty": "İndirilecek bir şey yok - seçimde okunabilir dosya bulunmuyor.",
  "toast.moved_to": "{name} klasörüne taşıma kuyruğa alındı",
  "toast.copied_to": "{name} klasörüne kopyalama kuyruğa alındı",
  "toast.already_there": "Seçilen öğeler zaten {name} içinde - hiçbir şey gönderilmedi",
  /* ── dil:paket - bkz. en.ts */
  "ctx.tags_menu": "Etiketler…",
  "toast.node_id_copied": "Node id {id} kopyalandı",
  "toast.read_only_here": "Burada yazma yetkiniz yok",
  "recents.title": "Son açılanlar",
  "recents.refresh": "Yenile",
  "recents.empty": "Henüz bir şey yok.",
  "recents.loading": "Yükleniyor…",
  "recents.close": "Kapat",
  "tags.title": "Etiketler",
  "tags.close": "Kapat",
  "share.ttl.never": "Bu bağlantının süresi yoktur.",
  "share.ttl.until": "Bu bağlantı {when} tarihine kadar geçerli.",
  "share.ttl.ceiling": "Bağlantılar en fazla {days} gün geçerli olabilir (sunucu ayarı).",
  "share.ttl.ceiling_one": "Bağlantılar en fazla {days} gün geçerli olabilir (sunucu ayarı).",
  /* ── dil:paket - paylaşım / erişim penceresi (bkz. en.ts) */
  "access.ui.level_viewer": "Görüntüleyen",
  "access.ui.level_viewer_desc": "görüntüle + indir",
  "access.ui.level_editor": "Düzenleyen",
  "access.ui.level_editor_desc": "oku + yaz + sil",
  "access.ui.level_owner": "Sahip",
  "access.ui.level_owner_desc": "düzenle + izin yönet",
  "access.ui.never": "Süresiz",
  "access.ui.days": "{days} gün",
  "access.ui.days_one": "{days} gün",
  "access.ui.unlimited": "Sınırsız",
  "access.ui.downloads": "{count} indirme",
  "access.ui.downloads_one": "{count} indirme",
  "access.ui.inherited_from": "Üst klasörden gelir",
  "access.ui.whole_storage": "Tüm depo",
  "access.ui.storage_root_hint": "Buraya eklenen herkes bu depodaki her dosya ve klasöre erişir: web arayüzünde, masaüstü uygulamasında ve her protokolde. İçindeki klasör yetkileri olduğu gibi kalır; ikisi birden geçerliyse yüksek olan sayılır.",
  "access.ui.access_granted": "Yetki verildi.",
  "access.ui.enter_a_valid_email": "Geçerli bir e-posta girin.",
  "access.ui.recipient_lang": "Alıcının dili",
  "access.ui.recipient_lang_server": "Sunucunun dili",
  "access.ui.user_created_invite_emailed": "Kullanıcı açıldı, davet e-postası gönderildi.",
  "access.ui.user_created_share_the_temp_password": "Kullanıcı açıldı. Geçici parolayı iletin.",
  "access.ui.server_limit_applied": "(sunucu sınırı uygulandı)",
  "access.ui.protect_with_a_pin": "PIN ile koru",
  "access.ui.expiry": "Süre",
  "access.ui.download_limit": "İndirme limiti",
  "access.ui.create_link": "Bağlantı oluştur",
  "access.ui.replace_link": "Bağlantıyı bu ayarlarla yenile",
  "access.ui.replace_link_hint": "Adres değişir: şu anki bağlantı çalışmayı bırakır.",
  "access.ui.create_then_send": "Bir bağlantı oluşturun, ardından {email} adresine gönderin.",
  "access.ui.command_line": "Komut satırı",
  "access.ui.share": "Paylaş",
  "access.ui.existing_links": "Mevcut bağlantılar",
  "access.ui.rbac_off_here": "Bu depoda öğe bazlı erişim denetimi kapalı - herkes depoyu rolüne göre açar, burada eklenen kişiler bir şey değiştirmez. Yönetim panelinde Depolar altından (bu depo → Öğe bazlı erişim denetimi) açın.",
  "access.ui.other_links": "Diğer bağlantılar",
  "access.ui.revoke": "İptal",
  "access.ui.loading": "Yükleniyor…",
  "access.ui.name_or_email": "Ad ya da e-posta",
  "access.ui.add": "Ekle",
  "access.ui.no_account_for_this_email_what_next": "Bu e-postada hesap yok. Ne yapmak istersiniz?",
  "access.ui.user": "Kullanıcı",
  "access.ui.viewer": "Görüntüleyen",
  "access.ui.create_user_grant": "Kullanıcı oluştur + yetki ver",
  "access.ui.just_send_a_share_link": "Yalnızca paylaşım bağlantısı gönder →",
  "access.ui.temp_password": "Geçici parola:",
  "access.ui.people_with_access": "Erişimi olanlar",
  "access.ui.group": "Grup",
  "access.ui.group_title": "“{name}” grubu - içindeki herkes",
  "access.ui.group_owner_confirm": "Sahip düzeyi, “{name}” grubundaki herkesin buraya kimin erişebileceğini yönetmesine izin verir - başka kişi ve gruplarla paylaşmak dâhil. Gruba Sahip verilsin mi?",
  "access.ui.group_owner_give": "Sahip yap",
  "access.ui.not_shared_with_anyone_yet": "Henüz kimseyle paylaşılmadı.",
  "access.ui.remove": "Kaldır",
  "access.ui.a_public_link_that_lets_anyone_upload_fi": "Bu klasöre herkesin dosya YÜKLEYEBİLECEĞİ herkese açık bir bağlantı. Yükleyenler klasördeki mevcut dosyaları göremez.",
  "access.ui.hide_upload_limits": "Yükleme sınırlarını gizle",
  "access.ui.upload_limits": "Yükleme sınırları",
  "access.ui.max_files": "En fazla dosya",
  "access.ui.mb_file": "Dosya başı MB",
  "access.ui.allowed_types": "İzinli türler",
  "access.ui.all_e_g_pdf_jpg": "hepsi (örn. pdf, jpg)",
  "access.ui.ask_uploader_name": "Yükleyenin adını sor",
  "access.ui.emails_comma_separated": "e-posta(lar) - virgülle ayırın",
  "access.ui.send": "Gönder",
  "access.ui.mail_not_set_up": "E-posta kurulu değil - yönetim panelinde Ayarlar altından (E-posta / SMTP) kurun.",
  /* ── wiring:e2 fxe - tek şifreli dosyalar (.fxe), akışlı indirmeler ── */
  "e2e.fxe.type": "Şifreli dosya",
  "e2e.fxe.ctx_encrypt": "E2EE ile şifrele…",
  "e2e.fxe.ctx_download_raw": "Şifreli dosyayı indir",
  "e2e.fxe.ctx_password": "Parolayı değiştir…",
  "e2e.fxe.ctx_remove": "Şifrelemeyi kaldır…",
  "e2e.fxe.encrypt_title": "Bu dosyayı şifrele",
  "e2e.fxe.encrypt_lead": "“{name}” bu tarayıcıda, kendine ait bir parolayla şifrelenir. Sunucu yalnızca şifreli veriyi saklar. Dosyayı parola ya da kurtarma anahtarı açar - burada ya da çevrimdışı olarak filex decrypt ile.",
  "e2e.fxe.pw_label": "Dosya parolası",
  "e2e.fxe.hide_label": "Dosya adını da gizle",
  "e2e.fxe.hide_on_hint": "“{stored}” olarak saklanır: sunucu ne adı ne de türü görür. Gerçek ad dosyanın içinde mühürlüdür; dosyayı burada açınca görünür.",
  "e2e.fxe.hide_off_hint": "“{stored}” olarak saklanır: ad sunucu tarafından okunabilir kalır, içerik kalmaz.",
  "e2e.fxe.seen_title": "Sunucunun zaten gördükleri",
  "e2e.fxe.seen_lead": "Bu dosya şimdiye kadar şifresiz saklandı ve şifrelemek bunu geri almaz:",
  "e2e.fxe.seen_trash": "Asıl dosya çöp kutusuna gider ve çöp kutusunun saklama süresi dolana ya da bir yönetici boşaltana kadar orada kalır. Kalıcı olarak kendiniz silemezsiniz.",
  "e2e.fxe.seen_versions": "Önceki sürümleri sürüm geçmişinde kalır; onları yalnızca bir yönetici silebilir.",
  "e2e.fxe.seen_thumb": "Ondan üretilmiş bir küçük resim, asıl dosya kalıcı olarak silinene kadar sunucuda kalır. Arama dizinindeki kaydı, dosya çöp kutusuna gidince kaldırılır.",
  "e2e.fxe.seen_backups": "Bundan önce alınmış yedekler, kopyalar ve indirmeler onu hâlâ içerir.",
  "e2e.fxe.warn_body": "Bu dosya yalnızca bu parolayla ya da şifrelemeden sonra bir kez gösterilen kurtarma anahtarıyla açılır. filex ikisini de saklamaz. İkisini de kaybederseniz içerik kalıcı olarak kaybolur.",
  "e2e.fxe.escrow_body": "Bu kurulumda anahtar emaneti açık: işletmecisi, bu dosyayı parolanız olmadan açan bir anahtara sahip.",
  "e2e.fxe.encrypt_submit": "Şifrele",
  "e2e.fxe.encrypt_busy": "Şifreleniyor ve yükleniyor… %{percent}",
  "e2e.fxe.size_unknown": "Bu dosyanın boyutu henüz bilinmiyor. Klasörü yenileyip tekrar deneyin.",
  "e2e.fxe.bad_name": "Bu ad şifreli bir dosyanın içine mühürlenemez (255 baytı aşıyor ya da eğik çizgi veya denetim karakteri içeriyor). Önce dosyayı yeniden adlandırın.",
  "e2e.fxe.name_too_long": "Ad, sonuna “.fxe” eklenemeyecek kadar uzun. “Dosya adını da gizle” kutusunu işaretleyin ya da önce dosyayı yeniden adlandırın.",
  "e2e.fxe.encrypted": "“{name}” şifrelendi. Asıl dosya çöp kutusunda.",
  "e2e.fxe.original_kept": "Şifreli kopya kaydedildi, ancak “{name}” çöp kutusuna taşınamadı. Asıl dosyayı kendiniz silin.",
  "e2e.fxe.upload_too_big": "Bu sunucuda parçalı yükleme yok ve dosya bu tarayıcıdan tek parça gönderilemeyecek kadar büyük.",
  "e2e.fxe.unlock_title_open": "Şifreli dosyayı aç",
  "e2e.fxe.unlock_title_download": "Çözerek indir",
  "e2e.fxe.unlock_title_remove": "Şifrelemeyi kaldır",
  "e2e.fxe.unlock_lead": "“{name}” şifreli. Parolası burada, bu tarayıcıda denetlenir ve asla sunucuya gönderilmez.",
  "e2e.fxe.known_note": "Bu sekmede zaten açıldı - parola gerekmiyor.",
  "e2e.fxe.use_password": "Onun yerine parolayı kullan",
  "e2e.fxe.remove_warn_title": "Şifresiz içerik sunucuya geri döner",
  "e2e.fxe.remove_warn_body": "Dosya burada çözülür ve özgün adıyla şifresiz bir dosya olarak yüklenir: sunucu, yöneticileri, küçük resimler, arama ve yedekler onu yeniden okuyabilir. Şifreli dosya çöp kutusuna gider.",
  "e2e.fxe.unlock_open": "Aç",
  "e2e.fxe.unlock_download": "İndir",
  "e2e.fxe.unlock_remove": "Şifrelemeyi kaldır",
  "e2e.fxe.unlock_busy": "İşleniyor…",
  "e2e.fxe.save_again": "Kilit açıldı. Tarayıcınız, dosyanın nereye kaydedileceğini sormadan önce bir tıklama daha istiyor.",
  "e2e.fxe.save_button": "Kaydet…",
  "e2e.fxe.progress": "%{percent} tamamlandı",
  "e2e.fxe.wrong_password": "Parola yanlış.",
  "e2e.fxe.wrong_recovery": "Bu kurtarma anahtarı bu dosyayı açmıyor.",
  "e2e.fxe.damaged": "Bu dosya bozuk ya da kurcalanmış (veya açıldığından beri değişmiş). Hiçbir şey kaydedilmedi.",
  "e2e.fxe.not_readable": "Bu bir filex şifreli dosyası değil ya da başlığı bozuk.",
  "e2e.fxe.unsupported": "Bu dosya daha yeni bir filex gerektiriyor (gereken: {features}).",
  "e2e.fxe.downloaded": "“{name}” kaydedildi.",
  "e2e.fxe.removed": "Şifreleme kaldırıldı: “{name}” yeniden şifresiz bir dosya. Şifreli dosya çöp kutusunda.",
  "e2e.fxe.password_title": "Dosya parolasını değiştir",
  "e2e.fxe.password_cost": "Yalnızca dosyanın başlığı değişir: içerik bayt bayt aynen geri gönderilir ve kurtarma anahtarı çalışmaya devam eder.",
  "e2e.fxe.password_old_copies": "Bu dosyanın önceki bir sürümü - sürüm geçmişi, bir yedek, birinin indirdiği bir kopya - ESKİ parolayla açılmaya devam eder.",
  "e2e.fxe.password_done": "Parola değişti. Eski parola bu dosyayı artık açmıyor.",
  "e2e.recovery.warn_body_file": "Bu anahtara sahip olan herkes dosyayı okuyabilir. Onu paroladan ayrı bir yerde saklayın - parolanın yanında duran bir anahtar sizi unutmaktan korur, başkalarından değil.",
  "e2e.recovery.lead_file": "Bu anahtar dosyayı parolası olmadan açar. Yalnızca bir kez gösterilir - filex onu saklamaz ve bir daha gösteremez.",
  "e2e.dl.ctx_encrypted_copy": "Şifreli kopyayı indir",
  "e2e.dl.too_big": "Bu tarayıcı tek seferde en çok {limit} çözülmüş veri kaydedebilir, bu ise {size}. Chrome ya da Edge (doğrudan diske kaydeder), filex masaüstü uygulamasını kullanın ya da şifreli dosyayı indirip filex decrypt çalıştırın.",
  "e2e.dl.click_again": "Nereye kaydedileceğini seçmek için İndir’e bir kez daha tıklayın.",
  "e2e.dl.zip_started": "“{name}” içine çözülerek yazılıyor…",
  "e2e.dl.zip_done": "“{name}” kaydedildi - çözülmüş, gerçek adlarla.",
  "e2e.dl.zip_done_plain": "“{name}” kaydedildi. İçindeki {n} dosya hiç şifrelenmemişti ve olduğu gibi eklendi.",
  "e2e.dl.zip_done_plain_one": "“{name}” kaydedildi. İçindeki {n} dosya hiç şifrelenmemişti ve olduğu gibi eklendi.",
  "e2e.dl.zip_damaged": "Klasördeki bir dosya bozuk ya da kurcalanmış. İndirme durduruldu ve hiçbir şey kaydedilmedi.",
  "e2e.upload.streaming_unsupported": "Bu dosya 200 MB’tan büyük ve bu sunucuda onu parça parça şifreli göndermek için parçalı yükleme yok.",
  /* wiring:e2 fxe escrow - emanet anahtarı tek bir dosyayı açar, sahibine haber gider */
  "e2e.fxe.use_escrow": "Emanet anahtarını kullan",
  "e2e.fxe.escrow_warn_title": "Dosyanın sahibine haber gidecek",
  "e2e.fxe.escrow_warn_body": "Emanet anahtarıyla açılan dosyanın sahibine, dosya açılmadan önce bildirim gönderilir. Yalnız yetkiniz olduğunda kullanın.",
  "e2e.fxe.escrow_predates": "Bu kurulumun emanet anahtarı var, ama bu dosya onsuz şifrelenmiş (emanet burada açılmadan önce), bu yüzden emanet anahtarı onu açmaz. Parolayı ya da kurtarma anahtarını kullanın.",
  "e2e.fxe.escrow_other_key": "Bu dosya BAŞKA bir kurulumun emanet anahtarına mühürlenmiş, bu yüzden bu kurulumun emanet anahtarı onu açmaz.",
  "e2e.fxe.wrong_escrow": "Bu emanet anahtarı bu dosyayı açmıyor.",
  "e2e.fxe.escrow_notify_failed": "Dosyanın sahibine bildirim gönderilemedi, bu yüzden dosya açılmadı. Emanet anahtarının kullanımı her zaman duyurulur.",
  "e2e.fxe.escrow_done": "Emanet anahtarıyla açıldı - dosya sahibine bildirildi",
  /* wiring:e2 fxe purge - yönetici aslını kalıcı olarak siler */
  "e2e.fxe.seen_trash_admin": "Asıl dosya çöp kutusuna gider ve çöp kutusunun saklama süresi dolana kadar orada kalır - aşağıda kalıcı olarak silmediğiniz sürece.",
  "e2e.fxe.seen_versions_admin": "Önceki sürümleri sürüm geçmişinde kalır - aşağıda kalıcı olarak silmediğiniz sürece.",
  "e2e.fxe.purge_label": "Aslını kalıcı olarak sil (yönetici)",
  "e2e.fxe.purge_hint": "Şifreli kopya kaydedilir kaydedilmez önceki sürümleri ve çöp kutusundaki kaydı silinir; açık hâlinden bu sunucuda hiçbir şey kalmaz. Geri alınamaz. Daha önce alınmış yedeklere ve kopyalara ulaşılmaz.",
  "e2e.fxe.purge_others": "Bu dosya sizin değil, {owner} adlı kullanıcının. Onun aslını ve sürümlerini kalıcı olarak sil.",
  "e2e.fxe.purge_others_unknown": "Bu dosyanın kayıtlı bir sahibi yok - sizin değil. Aslını ve sürümlerini kalıcı olarak sil.",
  "e2e.fxe.purge_others_required": "Başkasının dosyasını kalıcı olarak sildiğinizi onaylayın.",
  "e2e.fxe.purge_no_id": "Bu dosya henüz katalogda değil, bu yüzden kalıcı olarak silinemez. Klasörü yenileyip tekrar deneyin.",
  "e2e.fxe.purged": "“{name}” şifrelendi. Aslı, sürümleri ve çöp kutusundaki kaydı kalıcı olarak silindi.",
  "e2e.fxe.purge_failed": "“{name}” dosyasının şifreli kopyası kaydedildi, ama aslı kalıcı olarak silinemedi ({reason}). Çöp kutusundan ve sürüm geçmişinden silin.",
  /* wiring:e2 fxe big - bu tarayıcının belleğine sığmayan çözülmüş indirme */
  "e2e.big.title": "Bu tarayıcıda çözülemeyecek kadar büyük",
  "e2e.big.lead": "“{name}” çözüldüğünde {size}. Bu tarayıcı indirmeyi belleğinde çözer ve en çok {limit} tutabilir, bu yüzden hiçbir şey indirilmedi.",
  "e2e.big.lead_grew": "“{name}” çözülürken {limit} sınırını aştı. Bu tarayıcı indirmeyi belleğinde çözer ve daha fazlasını tutamaz, bu yüzden hiçbir şey kaydedilmedi.",
  "e2e.big.instead": "Bunun yerine kendi bilgisayarınızda çözün:",
  "e2e.big.step_file": "Şifreli dosyayı olduğu gibi indirin (aşağıdaki düğme).",
  "e2e.big.step_folder": "Şifreli klasörü zip olarak indirin (aşağıdaki düğme) - klasörün anahtar dosyası da içindedir.",
  "e2e.big.step_run": "Kaydettiğiniz klasörde filex decrypt komutunu çalıştırıp parolayı girin:",
  "e2e.big.copy": "Kopyala",
  "e2e.big.copied": "Kopyalandı",
  "e2e.big.other_ways": "Chrome, Edge ve filex masaüstü uygulaması, boyutu ne olursa olsun doğrudan diske çözer.",
  "e2e.big.close": "Kapat",
  "e2e.big.download_file": "Şifreli dosyayı indir",
  "e2e.big.download_folder": "Şifreli klasörü indir (zip)",
  /* /wiring:e2 fxe */
  /* ── dil:paket - İngilizce sabit yazılmış erişilebilir adlar */
  "breadcrumb.aria": "Konum yolu",
  "e2e.recovery_key_aria": "Kurtarma anahtarı",
  "modal.close": "Kapat",
  "modal.busy_close.keep": "Devam etsin",
  "modal.busy_close.confirm": "Durdur ve kapat",
  /* ── zil ve hesap menüsü (2026-09-27: masaüstü uygulamasının gezgini de
     aynılarını çizsin diye yönetim uygulamasından buraya taşındı). ⚠ ORTAK
     anahtarlar: yönetim uygulamasının kataloğunda her biri aynı adla, aynı
     İngilizce ve Türkçeyle durur (web/tests/i18n/langPackCatalogue.test.ts),
     bir dil paketi her birini iki ekran için bir kez çevirir. */
  "notifications.bell": "Bildirim zili",
  "notifications.unreadCount": "{n} okunmamış",
  "notifications.title": "Bildirimler",
  "notifications.markAllRead": "Tümünü okundu işaretle",
  "notifications.markRead": "Okundu işaretle",
  "notifications.empty": "Henüz bildirim yok",
  "notifications.viewAll": "Tüm bildirimleri gör",
  "notifications.manageAdmin": "Bildirim yönetimi",
  "notifications.openTarget": "Bildirimin konusunu aç",
  "notifications.unreadOnly": "Sadece okunmamış",
  "notifications.pageOf": "Sayfa {page} / {pages} · toplam {total}",
  "notifications.severity.info": "Bilgi",
  "notifications.severity.warning": "Uyarı",
  "notifications.severity.error": "Hata",
  "notifications.severity.critical": "Kritik",
  "common.prev": "Önceki",
  "common.next": "İleri",
  "explore.account": "Hesap",
  /* ── kullanıcı ayarları penceresi (2026-09-27: masaüstü uygulaması aynı
     pencereyi kendi içinde açsın diye yönetim uygulamasından buraya taşındı).
     ⚠ ORTAK anahtarlar; ardından gelenler bu tablonun kendisinin (yönetim
     kataloğu onları yalnız vue-i18n'in anladığı sözdizimiyle yazar). */
  "common.cancel": "İptal",
  "common.close": "Kapat",
  "common.confirm": "Onayla",
  "common.currentPassword": "Mevcut parola",
  "common.email": "E-posta",
  "common.loading": "Yükleniyor…",
  "common.newPassword": "Yeni parola",
  "common.remove": "Kaldır",
  "common.save": "Kaydet",
  "common.saving": "Kaydediliyor…",
  "errors.generic": "Bir şeyler ters gitti",
  "errors.validationFailed": "Lütfen işaretli alanları kontrol edin",
  "install.desktopAllDownloads": "Tüm indirmeler ve sürüm notları",
  "install.desktopSubtitle": "Klasörleri bu bilgisayara eşitleyin, arka planda güncel kalsınlar. {platform} için mevcut.",
  "install.install": "Kur",
  "install.menuInstructions": "Tarayıcınızın menüsünü açıp “Uygulamayı yükle” ya da “Ana ekrana ekle”yi seçin.",
  "install.iosInstructions": "Paylaş'a dokunun (iOS 26'da önce ⋯, sonra Paylaş), ardından “Ana Ekrana Ekle” ve Ekle'ye dokunun.",
  "nav.themeAuto": "Otomatik",
  "nav.themeDark": "Karanlık",
  "nav.themeLight": "Aydınlık",
  "notifications.prefs.browser": "Tarayıcı bildirimleri",
  "notifications.prefs.browserHint": "Yeni bir şey geldiğinde sekmenin dışında bildirim göster. Bildirime tıklayınca konusu olan dosya, klasör ya da paylaşım açılır.",
  "notifications.prefs.desktopHandled": "Masaüstü uygulaması bunları kendisi gösteriyor",
  "notifications.prefs.enableBrowser": "Bildirimlere izin ver",
  "notifications.prefs.inApp": "Uygulama içi zil",
  "notifications.prefs.inAppHint": "Kapatırsanız ziliniz boşalır. Hiçbir kayıt silinmez - yönetici tüm olayları görmeye devam eder.",
  "notifications.prefs.iosHomeScreen": "iPhone ve iPad'de bildirimler tarayıcı sekmesinde değil, ana ekrana eklenmiş {name} uygulamasında çalışır (iOS 16.4 ve sonrası).",
  "notifications.prefs.movedToSettings": "Kendi bildirim ayarlarınız - zil, tarayıcı bildirimleri, hangi olaylar - kullanıcı ayarlarınızda.",
  "notifications.prefs.openSettings": "Bildirim ayarlarımı aç",
  "notifications.prefs.permDefault": "İzin henüz istenmedi",
  "notifications.prefs.permDenied": "Bu tarayıcıda engellendi",
  "notifications.prefs.permDeniedHint": "Tarayıcı ayarlarından bu siteye bildirim iznini yeniden verin.",
  "notifications.prefs.permGranted": "Bu tarayıcıda izin verildi",
  "notifications.prefs.permUnsupported": "Bu tarayıcı bildirim gösteremiyor",
  "notifications.prefs.push": "Bu cihazda anlık bildirim",
  "notifications.prefs.pushAdded": "Eklendi: {date}",
  "notifications.prefs.pushDevices": "Anlık bildirim alan cihazlar",
  "notifications.prefs.pushDisabled": "Sunucuda kapatılmış (FILEX_PUSH_ENABLED).",
  "notifications.prefs.pushFailed": "Bu cihazda anlık bildirimler açılamadı.",
  "notifications.prefs.pushHint": "Zilinizin size söyledikleri, {name} kapalıyken de bu telefona ya da tarayıcıya ulaşır: aynı bildirimler, aynı anda.",
  "notifications.prefs.pushKeyUnreadable": "Sunucunun anlık bildirim anahtarı artık açılamıyor (FILEX_SECRET_KEY değişmiş). Yönetim → Bildirimler sayfasında anahtarı yenileyin.",
  "notifications.prefs.pushNoSecretKey": "Anlık bildirimler için sunucuda FILEX_SECRET_KEY tanımlı olmalı: bildirimleri imzalayan anahtar onunla şifrelenerek saklanır.",
  "notifications.prefs.pushOn": "Bu cihazda açık",
  "notifications.prefs.pushRemove": "Kaldır",
  "notifications.prefs.pushRemoveLabel": "Kaldır: {device}",
  "notifications.prefs.pushTest": "Deneme gönder",
  "notifications.prefs.pushTestNone": "Deneme hiçbir cihaza ulaşmadı.",
  "notifications.prefs.pushTestSent": "Deneme {count} cihaza gönderildi",
  "notifications.prefs.pushTestSent_one": "Deneme {count} cihaza gönderildi",
  "notifications.prefs.pushThisDevice": "Bu cihaz",
  "notifications.prefs.pushUnavailable": "Bu sunucuda kullanılamıyor",
  "notifications.prefs.pushUnnamed": "Bir cihaz",
  "notifications.prefs.pushUnsupported": "Bu tarayıcı anlık bildirim alamıyor",
  "notifications.prefs.saved": "Tercih kaydedildi",
  "notifications.prefs.title": "Bildirimleriniz",
  "profile.avatar.change": "Fotoğrafı değiştir",
  "profile.avatar.failed": "Bu görsel işlenemedi - başka bir tane deneyin.",
  "profile.avatar.help": "Adınızın yanında ve dosya yöneticisinin işbirliği çubuğunda görünür - hesabınızla açılan her istemcide. Otomatik olarak 160 piksele küçültülür.",
  "profile.avatar.label": "Profil fotoğrafı",
  "profile.avatar.notImage": "Lütfen bir görsel dosyası seçin.",
  "profile.locale": "Dil",
  "profile.passwordChanged": "Parola değiştirildi",
  "profile.saved": "Profil kaydedildi",
  "profile.totp.code": "Doğrulama kodu",
  "profile.totp.disable": "2FA'yı kapat",
  "profile.totp.disabled": "Pasif",
  "profile.totp.enable": "2FA'yı aç",
  "profile.totp.enabled": "Aktif",
  "profile.totp.recoveryHint": "Bunları şimdi kaydedin - doğrulayıcınızı kaybederseniz her biri bir kez oturum açmanızı sağlar. Yalnızca bu sefer gösterilir.",
  "profile.totp.recoveryTitle": "Kurtarma kodları",
  "profile.totp.scanHint": "Bu QR kodu doğrulayıcı uygulamanızla tarayın, sonra 6 haneli kodu girin.",
  "profile.totp.title": "İki adımlı doğrulama",
  "profile.username.label": "Kullanıcı adı",
  "quota.title": "Depolama kotası",
  "quota.tooltip": "{used} / {limit} kullanıldı ({percent})",
  "quota.unlimitedTooltip": "{used} kullanıldı · sınırsız",
  "userSettings.adminBadge": "Yönetici",
  "userSettings.demoReadOnly": "Bu ortak bir demo hesabı; profili, parolası ve ikinci faktörü değiştirilemez.",
  "userSettings.footNote.ai": "Bu sekmede kaydedilecek bir şey yok.",
  "userSettings.footNote.notifications": "Değiştirdiğiniz anda kaydedilir.",
  "userSettings.footNote.preferences": "Değiştirdiğiniz anda kaydedilir.",
  "userSettings.footNote.profile": "Bu sekmedeki değişiklikler Kaydet'e bastığınızda kaydedilir.",
  "userSettings.footNote.security": "Buradaki her işlem kendi başına uygulanır.",
  "userSettings.heading": "Kullanıcı ayarları",
  "userSettings.headingSub": "Profilinizi, tercihlerinizi ve güvenliğinizi yönetin.",
  "userSettings.notifications.adminAlerts": "Yönetici uyarıları",
  "userSettings.notifications.adminAlertsHint": "Güncellemeler, kopyalar, oturum açma sağlayıcıları, kiracı alan adları ve yöneticilere yönelik diğer uyarılar",
  "userSettings.notifications.device": "Masaüstü bildirimleri",
  "userSettings.notifications.deviceHint": "Yeni bir şey geldiğinde, filex arka planda çalışırken de bilgisayarınızın kendi bildirimleri.",
  "userSettings.notifications.digestHint": "Acil olarak işaretlenen türler size hemen ulaşır. Diğerleri {minutes} dakika bekletilir ve klasör klasör tek bir özet olarak gelir.",
  "userSettings.notifications.digestOffHint": "Her tür size hemen ulaşır. Bir türün Acil anahtarını kapatırsanız o tür, klasör klasör tek bir özet olarak gelir.",
  "userSettings.notifications.events.archive_created": "Bir arşiv oluşturulduğunda",
  "userSettings.notifications.events.archive_extracted": "Bir arşiv çıkarıldığında",
  "userSettings.notifications.events.comment_added": "Biri bir dosyaya yorum yaptığında",
  "userSettings.notifications.events.drop_received": "İstek bağlantısıyla bir dosya geldiğinde",
  "userSettings.notifications.events.e2e_escrow_used": "Şifreli bir klasör emanet anahtarıyla açıldığında",
  "userSettings.notifications.events.e2e_password_changed": "Şifreli klasörünüzün parolası değiştiğinde",
  "userSettings.notifications.events.e2e_request_created": "Biri bir klasörü ya da dosyayı şifrelemek istediğinde",
  "userSettings.notifications.events.e2e_request_decided": "Şifreleme isteğiniz yanıtlandığında",
  "userSettings.notifications.events.file_deleted": "Bir dosya kalıcı olarak silindiğinde",
  "userSettings.notifications.events.file_infected": "Bir dosyada virüs bulunduğunda",
  "userSettings.notifications.events.file_moved": "Bir dosya taşındığında ya da adı değiştiğinde",
  "userSettings.notifications.events.file_trashed": "Bir dosya çöp kutusuna taşındığında",
  "userSettings.notifications.events.file_updated": "Bir dosya değiştiğinde",
  "userSettings.notifications.events.file_upload_failed": "Bir yükleme tamamlanmadığında",
  "userSettings.notifications.events.file_uploaded": "Yeni bir dosya geldiğinde",
  "userSettings.notifications.events.notification_digest": "Acil olarak işaretlemediğim bildirimlerin özeti",
  "userSettings.notifications.events.plugin_notice": "Kurulu bir uygulama size mesaj gönderdiğinde",
  "userSettings.notifications.events.share_created": "Biri paylaşım bağlantısı oluşturduğunda",
  "userSettings.notifications.eventsHint": "Birini kapatmak onu zilinizin dışında tutar. Hiçbir şey kaydedilmekten çıkmaz - yönetici her olayı görmeye devam eder.",
  "userSettings.notifications.eventsTitle": "Nelerden haberdar olayım",
  "userSettings.notifications.urgent": "Acil",
  "userSettings.notifications.urgentFor": "Hemen bildir: {event}",
  "userSettings.open": "Kullanıcı ayarları",
  "userSettings.prefs.appearance": "Görünüm",
  "userSettings.prefs.compact": "Sıkışık dosya listesi kullan",
  "userSettings.prefs.compactHint": "Dosya gezgininde daha dar satırlar.",
  "userSettings.prefs.remoteImages": "Önizlemelerde uzak görselleri yükle",
  "userSettings.prefs.remoteImagesHint": "Bir dosyanın önizlemesinde başka sunuculardaki görseller sormadan yüklenir. Kapalıyken her biri bir tıklama bekler, çünkü yüklemek o sunucuya dosyanın açıldığını bildirir. Küçük resimler bunları hiçbir zaman yüklemez.",
  "userSettings.prefs.desktopApp": "Masaüstü uygulaması",
  "userSettings.prefs.desktopAppHint": "Uygulamanın köşesindeki hatırlatmayı kapattığınızda bir daha çıkmaz - indirmeler burada kalır.",
  "userSettings.prefs.folderView": "Varsayılan klasör görünümü",
  "userSettings.prefs.folderViewHint": "Hiç değiştirmediğiniz bir klasörün nasıl açılacağı. Değiştirdiğiniz klasörler kendi görünümünü korur - bu ayar onlara dokunmaz.",
  "userSettings.prefs.fvColumns": "Varsayılan sütunlarınız özelleştirilmiş (“Bunu tüm klasörler için varsayılanım yap” ile ayarlandı).",
  "userSettings.prefs.fvColumnsReset": "Sıfırla",
  "userSettings.prefs.fvDir": "Yön",
  "userSettings.prefs.fvDir_asc": "Artan",
  "userSettings.prefs.fvDir_desc": "Azalan",
  "userSettings.prefs.fvForget": "Hepsini unut",
  "userSettings.prefs.fvInherit": "Sunucu varsayılanı ({value})",
  "userSettings.prefs.fvMode": "Görünüm",
  "userSettings.prefs.fvSort": "Sıralama",
  "userSettings.prefs.fvSort_modified": "Değiştirilme",
  "userSettings.prefs.fvSort_name": "Ad",
  "userSettings.prefs.fvSort_size": "Boyut",
  "userSettings.prefs.fvSort_type": "Tür",
  "userSettings.prefs.fvView_gallery": "Galeri",
  "userSettings.prefs.fvView_grid": "Izgara",
  "userSettings.prefs.fvView_list": "Liste",
  "userSettings.prefs.installApp": "Web uygulaması olarak kur",
  "userSettings.prefs.installAppLead": "Bu cihazın ana ekranına ekleyin: {name} bir uygulama gibi kendi penceresinde açılır.",
  "userSettings.prefs.languageHint": "Burada hemen uygulanır; bir sonraki tarayıcıda da açılsın diye hesabınıza kaydedilir.",
  "userSettings.prefs.mode": "Aydınlık ya da karanlık",
  "userSettings.prefs.modeHint": "Hangi sürümün çizileceği. Otomatik, işletim sisteminizi izler.",
  "userSettings.prefs.openTrigger": "Dosyaları açma",
  "userSettings.prefs.openTriggerDouble": "Çift tık",
  "userSettings.prefs.openTriggerHint": "Farenin dosyayı nasıl açtığı. Dokunmatik ekranda tek dokunuş her zaman açar, kutucuk her zaman seçer.",
  "userSettings.prefs.openTriggerSingle": "Tek tık",
  "userSettings.prefs.palette": "Renk paleti",
  "userSettings.prefs.paletteHint": "O sürümün hangi renklerden oluştuğu. Her paletin aydınlık ve karanlık bir sürümü vardır; bu ayarla üstteki ayar birlikte çalışır.",
  "userSettings.prefs.shortcuts": "Klavye kısayolları",
  "userSettings.prefs.shortcutsEdit": "Düzenle…",
  "userSettings.prefs.shortcutsHint": "Dosya yöneticisinin yanıt verdiği tuşlar.",
  "userSettings.prefs.startPage": "Açılış sayfası",
  "userSettings.prefs.startPageHint": "Oturum açtığınızda ya da ana adrese geldiğinizde filex burayı açar. Doğrudan bir sayfanın bağlantısına tıkladığınızda yine o sayfaya gidersiniz.",
  "userSettings.prefs.startPage_admin": "Yönetim paneli",
  "userSettings.prefs.startPage_files": "Dosyalar",
  "userSettings.prefs.startPage_home": "Ana sayfa",
  "userSettings.prefs.timezone": "Saat dilimi",
  "userSettings.prefs.timezoneHint": "Tarihler bir an olarak saklanır ve burada seçtiğiniz saatle gösterilir; böylece herkes aynı anı kendi saatiyle görür. Hesabınıza kaydedilir, başka bir tarayıcıda da geçerli olur.",
  "userSettings.prefs.timezoneNow": "{zone} bölgesinde şu an: {time}",
  "userSettings.saveChanges": "Değişiklikleri kaydet",
  "userSettings.scope.account": "Hesap",
  "userSettings.scope.accountHint": "Hesabınızda saklanır: nerede oturum açarsanız açın aynıdır.",
  "userSettings.scope.device": "Bu cihaz",
  "userSettings.scope.deviceHint": "Yalnızca bu cihazda saklanır: başka bir bilgisayar, telefon ya da tarayıcı kendi ayarını tutar.",
  "userSettings.scope.deviceNotifyHint": "Bu cihazın size yeni bir şeyi nasıl haber vereceği; yalnızca bu cihazda saklanır.",
  "userSettings.scope.myAccount": "Hesabım",
  "userSettings.scope.myAccountHint": "Zilinize nelerin düşeceği; hesabınızda saklanır.",
  "userSettings.security.passwordTitle": "Parolayı değiştir",
  "userSettings.security.totpDisabled": "İki adımlı doğrulama kapalı",
  "userSettings.security.totpEnabled": "İki adımlı doğrulama açık",
  "userSettings.subtitle.ai": "Burada henüz ayarlayabileceğiniz bir şey yok.",
  "userSettings.subtitle.notifications": "Zilinize ve masaüstünüze neyin ulaşacağı.",
  "userSettings.subtitle.preferences": "Uygulamanın cihazlarınızda nasıl göründüğü ve okunduğu.",
  "userSettings.subtitle.profile": "Adınız, e-postanız ve fotoğrafınız - başkalarının gördüğü bilgiler.",
  "userSettings.subtitle.security": "Parolanız ve ikinci faktörünüz.",
  "userSettings.tabs.ai": "AI asistanı",
  "userSettings.ai.state.on": "Asistan açık.",
  "userSettings.ai.state.off": "Asistan bu sunucuda kapalı.",
  "userSettings.ai.state.not_configured": "Yönetici asistanı henüz kurmadı.",
  "userSettings.ai.state.not_permitted": "Asistan açık ama rolünüz onu kapsamıyor.",
  "userSettings.ai.provider": "Yazdıklarınızı kim okuyor",
  "userSettings.ai.providerHint": "Mesajlarınız ve asistanın sizin için okuduğu dosyalar bu sağlayıcıya gönderilir. Okuduğu her dosya denetim kaydında yer alır.",
  "userSettings.ai.confirmAll": "Her değişiklikten önce bana sor",
  "userSettings.ai.confirmAllHint": "Kapalıyken geri alınabilen değişiklikler (taşıma, yeniden adlandırma, düzenleme, çöp kutusuna silme) hemen yapılır ve Geri al bırakır. Açıkken bunlar da onayınızı bekler. Geri alınamayan her şey her zaman bekler.",
  "userSettings.ai.history": "Konuşma geçmişi",
  "userSettings.ai.retention": "Konuşmalar son kullanımlarından sonra {count} gün sunucuda saklanır.",
  "userSettings.ai.retention_one": "Konuşmalar son kullanımlarından sonra {count} gün sunucuda saklanır.",
  "userSettings.ai.clear": "Konuşmalarımı sil",
  "userSettings.ai.clearConfirm": "Hepsi kalıcı olarak silinsin mi?",
  "userSettings.ai.cleared": "Konuşmalarınız silindi.",
  "userSettings.ai.saveFailed": "Bu kaydedilemedi.",
  "userSettings.tabs.notifications": "Bildirimler",
  "userSettings.tabs.preferences": "Tercihler",
  "userSettings.tabs.profile": "Profil",
  "userSettings.tabs.security": "Güvenlik",
  "userSettings.apps.title": "Varsayılan uygulamalar",
  "userSettings.apps.lead": 'Bir dosyanın menüsünden seçin: Birlikte aç, Uygulama seç…, sonra "Her zaman bu uygulamayla aç" kutusunu işaretleyin. Yalnız yöneticinizin o tür için açık bıraktığı uygulamalar sunulur.',
  "userSettings.apps.empty": "Henüz hiçbir dosya türü için uygulama seçmediniz: her dosya, yöneticinizin ilk sıraya koyduğu uygulamayla açılır.",
  "userSettings.apps.reset": "Sıfırla",
  "userSettings.apps.resetAll": "Tümünü sıfırla",
  "userSettings.apps.unavailable": "Artık kullanılamıyor: siz yeniden seçene kadar {app} ile açılıyor.",
  "userSettings.apps.change": "{ext} dosyalarını açan uygulama",
  "userSettings.title": "Kullanıcı ayarları",
  "users.fields.displayName": "Görünen ad",
  "profile.username.helpText": "Kullanıcı adınız. Oturum açarken bunu da e-postanızı da kullanabilirsiniz - bağlantı istemcileri (SFTP, FTP) için ise bu ad gerekir, çünkü oturum açtıkları addaki @ işareti onların ayar dosyalarında kaçış gerektirir.",
  "userSettings.prefs.fvKeptCount": "{count} klasör kendi görünümünü koruyor.",
  "userSettings.prefs.fvKeptCount_one": "{count} klasör kendi görünümünü koruyor."
}, bP = "filex-base", kP = /^(\/[A-Za-z0-9_~.-]+)+$/;
function wP(e) {
  var a, i;
  const t = e ?? (typeof document < "u" ? document : null);
  if (!t) return "";
  let n = "";
  try {
    n = ((i = (a = t.querySelector(`meta[name="${bP}"]`)) == null ? void 0 : a.getAttribute("content")) == null ? void 0 : i.trim()) ?? "";
  } catch {
    return "";
  }
  return !n || !kP.test(n) || n.split("/").some((o) => o === "." || o === "..") ? "" : n;
}
function rc() {
  return wP();
}
function cpe(e) {
  return rc() + e;
}
function Ly(e, t) {
  if (/^[a-z][a-z0-9+.-]*:\/\//i.test(t)) return t;
  const n = String(e ?? "").replace(/\/+$/, "");
  return !n || !t.startsWith("/") ? t : n + t;
}
function Yo(e) {
  return String(e ?? rc()).replace(/\/+$/, "");
}
const oi = $(0), bl = $(!1), x2 = ["en", "tr"], a_ = {
  en: "English",
  tr: "Türkçe",
  de: "Deutsch",
  fr: "Français",
  es: "Español",
  it: "Italiano",
  nl: "Nederlands",
  pt: "Português",
  pl: "Polski",
  ru: "Русский",
  uk: "Українська",
  ar: "العربية",
  fa: "فارسی",
  az: "Azərbaycanca",
  ja: "日本語",
  ko: "한국어",
  zh: "中文"
};
function S2(e) {
  if (a_[e]) return a_[e];
  try {
    const t = new Intl.DisplayNames([e], { type: "language" }).of(e);
    if (t && t.toLowerCase() !== e)
      return t.charAt(0).toLocaleUpperCase(e) + t.slice(1);
  } catch {
  }
  return e.toUpperCase();
}
const Gu = { en: el, tr: _2 }, ka = /* @__PURE__ */ new Map(), Xu = /* @__PURE__ */ new Map(), Cp = /^[a-z]{2,3}(-[a-z0-9]{2,8})*$/;
function $2(e) {
  return Cp.test(String(e ?? "").trim().toLowerCase().replace(/_/g, "-"));
}
function Aa(e) {
  const t = String(e ?? "").trim().toLowerCase().replace(/_/g, "-");
  if (!Cp.test(t)) return "";
  if (ka.has(t)) return t;
  const n = t.split("-")[0];
  if (Dl(n) || ka.has(n)) return n;
  for (const a of ka.keys()) if (a.startsWith(`${n}-`)) return a;
  return t;
}
function Dl(e) {
  return x2.includes(e);
}
function T2(e) {
  const t = {};
  for (const [n, a] of Object.entries(e ?? {}))
    typeof a != "string" || !a.trim() || !n || n.split(".").some((i) => i === "__proto__" || i === "constructor" || i === "prototype") || (t[n] = a);
  return t;
}
function _P(e) {
  const t = String((e == null ? void 0 : e.code) ?? "").trim().toLowerCase().replace(/_/g, "-"), n = Cp.test(t) ? t : "";
  n && (ka.set(n, {
    code: n,
    label: String(e.label ?? "").trim() || S2(n),
    source: e.source === "plugin" ? "plugin" : e.source || "builtin",
    plugin: e.plugin,
    rtl: e.rtl === !0,
    strings: e.strings ? T2(e.strings) : null
  }), oi.value += 1);
}
function A2(e) {
  ka.clear(), Xu.clear();
  for (const t of e ?? []) _P(t);
  oi.value += 1;
}
function dpe(e) {
  let t = !1;
  for (const [n, a] of ka)
    a.source === "plugin" && a.plugin === e && (ka.delete(n), t = !0);
  t && (oi.value += 1);
}
function fpe() {
  ka.clear(), Xu.clear(), vo = {}, ll = null, bl.value = !1, oi.value += 1;
}
function mo() {
  oi.value;
  const e = x2.map((t) => ({
    code: t,
    label: S2(t),
    source: "builtin"
  }));
  for (const [t, n] of ka)
    Dl(t) || e.push({ code: t, label: n.label, source: n.source, plugin: n.plugin, rtl: n.rtl });
  return e;
}
function qf(e) {
  oi.value;
  const t = Aa(e);
  return !!t && (Dl(t) || ka.has(t));
}
function Vu(e) {
  return qf(e) ? !0 : !bl.value && $2(e);
}
function xP(e) {
  const t = Aa(e), n = Dl(t) ? Gu[t] : void 0, a = ka.get(t);
  return a && a.strings === null && C2(t), !(a != null && a.strings) || !Object.keys(a.strings).length ? n ?? Gu.en : { ...Gu.en, ...n ?? {}, ...a.strings };
}
function E2(e) {
  const t = Aa(e), n = Dl(t) ? Gu[t] : void 0, a = ka.get(t);
  a && a.strings === null && C2(t);
  const i = a != null && a.strings && Object.keys(a.strings).length ? a.strings : null;
  return n ? { lang: t, strings: i ? { ...n, ...i } : n } : i ? { lang: t, strings: i } : { lang: "en", strings: Gu.en };
}
function ppe(e) {
  var t;
  return { ...((t = ka.get(Aa(e))) == null ? void 0 : t.strings) ?? {} };
}
const SP = 1e4;
let vo = {}, ll = null;
function C2(e) {
  const t = Aa(e), n = ka.get(t);
  if (!n) return Promise.resolve(!1);
  if (n.strings !== null) return Promise.resolve(Object.keys(n.strings).length > 0);
  const a = Xu.get(t);
  if (a) return a;
  const i = vo.fetchImpl ?? (typeof fetch == "function" ? fetch : null);
  if (!i) return Promise.resolve(!1);
  const o = Yo(vo.base), l = (async () => {
    let c = {};
    try {
      const m = vo.headers ? await vo.headers() : {}, v = await i(`${o}/api/public/ui-locales/${encodeURIComponent(t)}`, {
        method: "GET",
        headers: { Accept: "application/json", ...m },
        credentials: "same-origin"
      });
      if (v.ok) {
        const x = await v.json();
        c = T2(x == null ? void 0 : x.strings);
      }
    } catch {
    }
    const p = ka.get(t);
    return p === n && (p.strings = c, oi.value += 1), Xu.delete(t), Object.keys(c).length > 0;
  })();
  return Xu.set(t, l), l;
}
function z2(e, t) {
  if (t && (vo = t), !e) return mo();
  const n = Array.isArray(e.ui_locales) ? e.ui_locales : [], a = new Set(n.map((o) => String((o == null ? void 0 : o.code) ?? "").toLowerCase())), i = (e.locales ?? []).map((o) => String(o ?? "").trim().toLowerCase()).filter((o) => Cp.test(o) && !Dl(o) && !a.has(o)).map((o) => ({ code: o, source: "plugin" }));
  return A2([...n, ...i]), bl.value = !0, mo();
}
function $P(e = {}) {
  const t = EP(e);
  return ll = t, t.finally(() => {
    ll === t && (ll = null);
  }), t;
}
function TP(e = {}) {
  return ll || (bl.value ? Promise.resolve(mo()) : $P(e));
}
async function AP(e, t) {
  const n = t.timeoutMs && t.timeoutMs > 0 ? t.timeoutMs : 0, a = n && typeof AbortController == "function" ? new AbortController() : null, i = (async () => {
    try {
      const c = t.headers ? await t.headers() : {}, p = await e(`${Yo(t.base)}/api/public/branding`, {
        method: "GET",
        headers: { Accept: "application/json", ...c },
        credentials: "same-origin",
        ...a ? { signal: a.signal } : {}
      });
      return p.ok ? await p.json() : null;
    } catch {
      return null;
    }
  })();
  if (!n) return i;
  let o;
  const l = new Promise((c) => {
    o = setTimeout(() => {
      a == null || a.abort(), c(null);
    }, n);
  });
  try {
    return await Promise.race([i, l]);
  } finally {
    clearTimeout(o);
  }
}
async function EP(e) {
  Yo(vo.base) !== Yo(e.base) && (A2([]), bl.value = !1), vo = e;
  const t = e.fetchImpl ?? (typeof fetch == "function" ? fetch : null);
  if (!t) return mo();
  const n = await AP(t, e);
  return vo !== e ? mo() : n ? (z2(n), mo()) : (bl.value = !0, oi.value += 1, mo());
}
const CP = "en";
function Wi(e) {
  return e && Vu(e) ? Aa(e) : M2();
}
function M2() {
  return P2(Cv()) || CP;
}
function Cv() {
  try {
    const e = typeof navigator > "u" ? void 0 : navigator;
    return e ? e.languages && e.languages.length ? e.languages : [e.language] : [];
  } catch {
    return [];
  }
}
function P2(e) {
  for (const t of e)
    if (t && qf(t)) return Aa(t);
  return "";
}
const zP = [".filex-trash", ".versions", ".thumbs", ".filex-open", ".filex-drafts"], MP = ".filex-drafts", O2 = ".keepdir", L2 = new Set(zP);
function D2(e) {
  let t = String(e ?? "").trim().replace(/\\/g, "/");
  const n = t.indexOf("://");
  return n >= 0 && (t = t.slice(n + 3)), t.split("/").filter((a) => a && a !== ".");
}
function zp(e) {
  const t = String(e ?? "").trim();
  return L2.has(t) || t === O2;
}
function Wf(e) {
  const t = D2(e);
  return t.some((n) => L2.has(n)) ? !0 : t.length > 0 && t[t.length - 1] === O2;
}
function zv(e) {
  const t = String(e ?? "");
  if (!Wf(t)) return t;
  const n = t.indexOf("://");
  return n >= 0 ? t.slice(0, n + 3) : "";
}
function i_(e) {
  const t = D2(e);
  return t.length !== 4 || t[0] !== MP || !/^[1-9][0-9]*$/.test(t[1]) || !/^[0-9a-f]{8,32}$/.test(t[2]) || zp(t[3]) ? "" : t[2];
}
const Ru = (e) => Array.isArray(e) ? e.filter((t) => typeof t == "string").map((t) => t.toLowerCase()) : [], Mc = Ea(null), R2 = Ea({});
function PP(e) {
  if (!e) return;
  const t = e.edit_kinds;
  t && typeof t == "object" && (Mc.value = {
    office: new Set(Ru(t.office)),
    text: new Set(Ru(t.text)),
    names: new Set(Ru(t.text_names)),
    prefixes: Ru(t.text_mime_prefixes),
    mimes: new Set(Ru(t.text_mimes))
  });
  const n = e.limits;
  n && typeof n == "object" && (R2.value = { ...n });
}
function hpe() {
  return Mc.value !== null;
}
function Mv(e) {
  var t;
  return ((t = Mc.value) == null ? void 0 : t.office.has(String(e ?? "").toLowerCase())) ?? !1;
}
function I2(e) {
  const t = Mc.value;
  if (!t) return !1;
  const n = String(e ?? "").split(";")[0].trim().toLowerCase();
  return n ? t.mimes.has(n) || t.prefixes.some((a) => n.startsWith(a)) : !1;
}
function OP(e) {
  const t = e.replace(/[\\/]+$/, "").split(/[\\/]/);
  return (t[t.length - 1] ?? "").toLowerCase();
}
function LP(e) {
  const t = e.lastIndexOf(".");
  return t >= 0 ? e.slice(t + 1) : "";
}
function mpe(e) {
  const t = Mc.value;
  if (!t || !e) return !1;
  const n = OP(String(e.basename ?? "")), a = String(e.extension ?? LP(n)).toLowerCase();
  return a && t.text.has(a) || n && t.names.has(n) ? !0 : I2(e.mime_type);
}
function Pc(e) {
  const t = R2.value[e];
  return typeof t == "number" && t > 0 ? t : void 0;
}
function vpe(e) {
  return Array.from(e).length;
}
function Dy(e, t) {
  if (!t) return e;
  const n = Array.from(e);
  return n.length > t ? n.slice(0, t).join("") : e;
}
const DP = E(() => {
  oi.value;
  const e = /* @__PURE__ */ new Set();
  for (const t of mo())
    t.rtl === !0 && e.add(t.code);
  return e;
});
function kl(e) {
  const t = Aa(e ?? "");
  return t && DP.value.has(t) ? "rtl" : "ltr";
}
function ype(e = typeof document < "u" ? document.documentElement : null) {
  if (!e) return () => {
  };
  const t = () => {
    const i = kl(e.getAttribute("lang"));
    e.getAttribute("dir") !== i && e.setAttribute("dir", i);
  };
  t();
  const n = typeof MutationObserver < "u" ? new MutationObserver(t) : null;
  n == null || n.observe(e, { attributes: !0, attributeFilter: ["lang"] });
  const a = Je(oi, t);
  return () => {
    n == null || n.disconnect(), a();
  };
}
function ei(e) {
  var n;
  const t = (n = e == null ? void 0 : e.closest) == null ? void 0 : n.call(e, '[dir="rtl"], [dir="ltr"]');
  return (t == null ? void 0 : t.getAttribute("dir")) === "rtl" ? "rtl" : "ltr";
}
function Pv(e) {
  return e === "rtl" ? -1 : 1;
}
function Yf(e, t) {
  const n = e === "ArrowRight" ? 1 : e === "ArrowLeft" ? -1 : 0;
  return n === 0 ? 0 : n * Pv(t);
}
function Ur(e, t) {
  return t === "rtl" ? e.right : e.left;
}
function o_(e, t) {
  return t === "rtl" ? e.left : e.right;
}
function Ov(e) {
  const t = Math.abs(e.scrollLeft);
  return { start: t > 0, end: e.scrollWidth - e.clientWidth - t > 1 };
}
function r_(e, t, n, a, i = 8) {
  const o = a === "rtl" ? n - e : e;
  let l = o;
  if (o + t > n - i) {
    const c = o - t;
    l = c >= i ? c : Math.max(i, n - t - i);
  }
  return a === "rtl" ? n - l - t : l;
}
function Oc(e, t, n, a, i = 8) {
  const o = a === "rtl" ? n - e : e, l = o + t > n - i ? Math.max(i, n - i - t) : o;
  return a === "rtl" ? n - l - t : l;
}
const Gf = "⁦", s_ = "⁧", Xf = "⁨", sc = "⁩", RP = new RegExp("[\\u2066-\\u2069]?\\d[\\d.,]*(?:\\s?[A-Za-z%]{1,3})?[\\u2066-\\u2069]?\\s*\\/\\s*[\\u2066-\\u2069]?\\d[\\d.,]*(?:\\s?[A-Za-z%]{1,3})?[\\u2066-\\u2069]?|[A-Za-z][\\w+.-]*:[^\\s,\\u060C)\\u2066-\\u2069]+|\\/(?:[A-Za-z0-9_.~%+-]+\\/)+[A-Za-z0-9_.~%+-]*|(?<![A-Za-z0-9_.~%+:\\/-])\\/(?=[A-Za-z0-9_.~%+-]*[A-Za-z0-9])[A-Za-z0-9_.~%+-]*[A-Za-z0-9_~%+-](?!\\.?[A-Za-z0-9_~%+:-])", "g");
function IP(e) {
  if (!(e[0] === Gf || e[0] === Xf || e[0] === s_) || e[e.length - 1] !== sc) return !1;
  let t = 0;
  for (let n = 0; n < e.length; n++) {
    const a = e[n];
    if (a === Gf || a === Xf || a === s_ ? t += 1 : a === sc && (t -= 1), t === 0 && n < e.length - 1) return !1;
  }
  return t === 0;
}
function N2(e) {
  return e.replace(RP, (t, n, a) => {
    if (IP(t)) return t;
    const i = a[n - 1], o = a[n + t.length];
    return (i === Gf || i === Xf) && o === sc ? t : Gf + t + sc;
  });
}
function Yi(e, t) {
  return kl(e) === "rtl" ? N2(t) : t;
}
function NP(e) {
  return Xf + e + sc;
}
function B2(e) {
  if (e === "code") return "ltr";
  if (e === "text") return "auto";
}
function Jf(e, t) {
  return typeof (e == null ? void 0 : e.foreign) == "function" ? e.foreign(t) : t;
}
function wl(e) {
  const t = (n, a = {}) => {
    const i = xP(e)[n] ?? n, o = Object.entries(a).reduce((l, [c, p]) => l.replaceAll(`{${c}}`, String(p)), i);
    return Yi(e, o);
  };
  return t.foreign = (n) => Yi(e, n), t;
}
const F2 = {
  400: "err.status.400",
  401: "err.status.401",
  403: "err.status.403",
  404: "err.status.404",
  409: "err.status.409",
  413: "err.status.413",
  415: "err.status.415",
  422: "err.status.422",
  429: "err.status.429",
  500: "err.status.500",
  501: "err.status.501",
  /* ⚠ 502 and 504 are what an APP answers with (handlers/app_plugins.go
     callFail: any plugin error, and a plugin that ran out of time). */
  502: "err.status.502",
  503: "err.status.503",
  504: "err.status.504"
};
function gpe(e, t) {
  return U2(e, wl(t));
}
function U2(e, t) {
  return t(F2[e] ?? (e >= 500 ? "err.status.500" : "err.status.other"));
}
function bpe(e) {
  return e >= 400 && e < 500 && e in F2;
}
function Ry(e) {
  const t = e.message;
  return typeof t == "string" ? t.trim() : "";
}
function kpe(e, t) {
  if (!e || typeof e != "object" || Array.isArray(e)) return "";
  const n = Ry(e);
  return n ? Yi(t, n) : "";
}
function Iy(e) {
  try {
    const t = JSON.parse(e);
    return t && typeof t == "object" && !Array.isArray(t) ? t : {};
  } catch {
    return {};
  }
}
function BP(e) {
  const t = Iy(e).error;
  return typeof t == "string" ? t : "";
}
function wpe(e, t, n) {
  return Ny(e, t, wl(n));
}
function Ny(e, t, n, a = {}) {
  const i = a.server || Ry(Iy(t));
  return i ? Jf(n, i) : U2(e, n);
}
function fa(e, t, n) {
  const a = Iy(t), i = Ry(a), o = new Error(Ny(e, t, wl(n), { server: i }));
  o.status = e, o.code = BP(t), o.detail = t.slice(0, 300), o.said = !0, i && (o.server = i);
  const l = a.admin_hint;
  return typeof l == "string" && l && (o.hint = l), typeof a.reason == "string" && a.reason && (o.reason = a.reason), o;
}
function Za(e, t) {
  const n = (o) => Yi(t, o), a = e;
  if (!a || a.said !== !0) return n(a instanceof Error ? a.message : e ? String(e) : "");
  if (a.server) return n(a.server);
  const i = a.code ?? "";
  return i && !By(i) && !/^[a-z0-9_]+$/.test(i) ? n(i) : n(a.message ?? "");
}
function Lv(e, t) {
  const n = new Error(wl(e)("err.network"));
  return n.detail = t instanceof Error ? t.message : t ? String(t) : "", n.said = !0, n;
}
function By(e) {
  const t = e.trim();
  return t ? /^[[{]/.test(t) || // a JSON body
  /\b[1-5]\d\d\b\s+[A-Z][a-z]+/.test(t) || // "500 Internal Server Error"
  /\b[A-Z][A-Z0-9]+_[A-Z0-9_]+\b/.test(t) || // FILEX_SECRET_KEY
  /\b(panic|goroutine|stack trace|Traceback|at [\w$.]+ \()/i.test(t) || /^[\w.-]+: [\w.-]+(: |$)/.test(t) || // "protocolauth: no secret key…"
  /(^|\s)\/(?:[\w.-]+\/){2,}/.test(t) || // /var/lib/filex/…
  /\b[a-z][\w.-]*: [^:()]{1,60}: [a-z][\w.-]*: /i.test(t) || // a Go error chain "a: b: c: d"
  /\b(ECONNREFUSED|ETIMEDOUT|EOF|nil pointer|dial tcp|x509|context deadline exceeded)\b/i.test(t) : !1;
}
function FP(e) {
  const t = /^(.*\S)\s*\(([^()]*)\)\s*$/.exec(e);
  return t && By(t[2]) ? [t[1], t[2]] : [e, ""];
}
function H2(e, t, n = {}) {
  const a = e, i = (a == null ? void 0 : a.said) === !0, o = i ? (a == null ? void 0 : a.detail) ?? "" : a instanceof Error ? a.message : e ? String(e) : "", l = i ? n.t && typeof (a == null ? void 0 : a.status) == "number" ? Ny(a.status, a.detail ?? "", n.t, { server: a.server }) : (a == null ? void 0 : a.message) || t : t;
  !i && o && typeof console < "u" && console.warn("[filex]", o);
  const c = Jf(n.t, l), p = Jf(n.t, o);
  return n.callerAdmin && o && o !== l ? { text: c, detail: p } : { text: c };
}
function Zf(e, t, n = {}) {
  const i = e.op_type === "plugin" || e.op_type === "plugin-action" ? t("plugin.failed", { label: e.label || e.action || t("opc.kind.plugin") }) : t("toast.failed");
  return UP(
    { error: e.error_message, error_code: e.error_code, error_engine: e.error_engine, error_text: e.error_text },
    i,
    t,
    n
  );
}
function UP(e, t, n, a = {}) {
  const i = (e.error ?? "").trim(), o = a.callerAdmin === !0, l = (m) => Jf(n, m), c = (m) => o && i && i !== m ? { text: l(m), detail: l(i) } : { text: l(m) }, p = (e.error_text ?? "").trim();
  if (p) return c(p);
  switch (e.error_code) {
    case "cancelled":
      return { text: n("opc.status.aborted") };
    case "app": {
      const [m, v] = FP(i);
      return m && !By(m) ? v && o ? { text: l(m), detail: l(i) } : { text: l(m) } : c(t);
    }
  }
  return c(t);
}
const HP = "DRAFT_LIMIT", KP = "TARGET_TAKEN", VP = "FOLDER_GONE";
function Fy(e, t) {
  const n = e == null ? void 0 : e.detail;
  if (n)
    try {
      const a = JSON.parse(n);
      return a && typeof a == "object" ? a[t] : void 0;
    } catch {
      return;
    }
}
function _pe(e) {
  return Fy(e, "code") === HP;
}
function xpe(e) {
  return Fy(e, "code") === VP;
}
function Spe(e) {
  const t = Fy(e, "limit");
  return typeof t == "number" && t > 0 ? t : null;
}
function jP(e, t) {
  const n = e.replace(/\/+$/, ""), a = (l) => `${n}/${encodeURIComponent(l)}`;
  async function i(l, c = {}) {
    const p = await t.request(l, {
      ...c,
      headers: { "Content-Type": "application/json", ...c.headers ?? {} }
    }), m = await p.text().catch(() => "");
    let v = null;
    if (m)
      try {
        v = JSON.parse(m);
      } catch {
        v = null;
      }
    return { status: p.status, body: v, text: m };
  }
  function o(l, c) {
    throw fa(l, c, t.locale);
  }
  return {
    /**
     * New document, as a draft (the New document dialog's request): the same
     * body as `action=newfile`, answered with the same fields — `path` is the
     * draft's — plus the draft itself. A refusal throws; DRAFT_LIMIT is the
     * one the dialog says in its own words (isDraftLimit).
     */
    async create(l, c, p, m = {}) {
      var x;
      const v = await i(n, {
        method: "POST",
        body: JSON.stringify(m.exactName ? { path: l, name: c, type: p, exact_name: !0 } : { path: l, name: c, type: p })
      });
      return (v.status !== 201 || !((x = v.body) != null && x.draft)) && o(v.status, v.text), v.body;
    },
    /** Every draft of the caller's, across every storage they can see. */
    async list() {
      const l = await i(n);
      return (l.status !== 200 || !l.body) && o(l.status, l.text), { drafts: l.body.drafts ?? [], count: l.body.count ?? 0, limit: l.body.limit ?? 0 };
    },
    /** How many — the navigation panel's badge. */
    async count() {
      const l = await i(`${n}/count`);
      return (l.status !== 200 || !l.body) && o(l.status, l.text), { count: l.body.count ?? 0, limit: l.body.limit ?? 0 };
    },
    /** One draft — what an editor on a draft's path asks. */
    async get(l) {
      const c = await i(a(l));
      return (c.status !== 200 || !c.body) && o(c.status, c.text), c.body;
    },
    /**
     * Save the draft where it is meant to go — under `as` when given (only
     * ever the `suggested` name a taken answer offered).
     */
    async save(l, c) {
      var m, v;
      const p = await i(`${a(l)}/save`, { method: "POST", body: JSON.stringify(c ? { as: c } : {}) });
      if (p.status === 200 && ((m = p.body) != null && m.path))
        return { saved: !0, path: p.body.path, name: p.body.name ?? "", targetDir: p.body.target_dir ?? "" };
      if (p.status === 409 && ((v = p.body) == null ? void 0 : v.code) === KP && p.body.suggested)
        return {
          saved: !1,
          taken: !0,
          name: p.body.name ?? "",
          suggested: p.body.suggested,
          targetDir: p.body.target_dir ?? ""
        };
      o(p.status, p.text);
    },
    /** Discard it: the draft goes to the trash (restorable until it ages out). */
    async discard(l) {
      const c = await i(a(l), { method: "DELETE" });
      c.status !== 200 && o(c.status, c.text);
    }
  };
}
function K2(e) {
  const t = e.indexOf("://"), n = t >= 0 ? e.slice(0, t) : "", a = (t >= 0 ? e.slice(t + 3) : e).replace(/^\/+|\/+$/g, "");
  return [n, ...a.split("/").filter(Boolean)].filter(Boolean).join(" / ");
}
const qP = "X-Filex-Text-Dialect", V2 = [",", ";", "	", "|"], j2 = /^[a-z0-9_-]{1,40}$/i;
function WP(e) {
  if (!e) return;
  let t;
  try {
    t = JSON.parse(e);
  } catch {
    return;
  }
  const n = t;
  if (!(!n || typeof n != "object" || typeof n.delimiter != "string" || !V2.includes(n.delimiter) || typeof n.bom != "boolean" || typeof n.crlf != "boolean" || typeof n.encoding != "string" || !j2.test(n.encoding)))
    return { delimiter: n.delimiter, bom: n.bom, crlf: n.crlf, encoding: n.encoding.toLowerCase() };
}
function YP(e, t) {
  try {
    return new TextDecoder(t).decode(e);
  } catch {
    return new TextDecoder().decode(e);
  }
}
function q2(e) {
  if (e == null) return;
  if (typeof e != "object" || Array.isArray(e)) return null;
  const t = e, n = {};
  if (t.delimiter !== void 0) {
    if (typeof t.delimiter != "string" || !V2.includes(t.delimiter)) return null;
    n.csv_delimiter = t.delimiter;
  }
  if (t.encoding !== void 0) {
    if (typeof t.encoding != "string" || !j2.test(t.encoding)) return null;
    n.csv_encoding = t.encoding;
  }
  if (t.bom !== void 0) {
    if (typeof t.bom != "boolean") return null;
    n.csv_bom = t.bom ? "1" : "0";
  }
  if (t.eol !== void 0) {
    if (t.eol !== "crlf" && t.eol !== "lf") return null;
    n.csv_eol = t.eol;
  }
  return n;
}
const GP = "/api/files/pdf";
function XP(e) {
  return /\.pdf$/i.test(e);
}
function JP(e, t) {
  const n = t.slice(t.lastIndexOf("/") + 1);
  return `${e.replace(/\/+$/, "")}/${encodeURIComponent(n)}?${new URLSearchParams({ path: t }).toString()}`;
}
const ZP = ["zero", "one", "two", "few", "many", "other"], l_ = ["one", "other"], u_ = /* @__PURE__ */ new Map();
function W2(e) {
  const t = String(e ?? ""), n = u_.get(t);
  if (n !== void 0) return n;
  let a = null;
  if (typeof Intl < "u" && typeof Intl.PluralRules == "function")
    try {
      a = new Intl.PluralRules(t || "en");
    } catch {
      try {
        a = new Intl.PluralRules("en");
      } catch {
        a = null;
      }
    }
  return u_.set(t, a), a;
}
const c_ = /* @__PURE__ */ new Map(), QP = 999;
function eO(e) {
  const t = String(e ?? ""), n = c_.get(t);
  if (n) return n;
  let a = l_;
  const i = W2(t);
  if (i)
    try {
      const o = /* @__PURE__ */ new Set(["other"]);
      for (let l = 0; l <= QP; l++) o.add(i.select(l));
      a = ZP.filter((l) => o.has(l));
    } catch {
      a = l_;
    }
  return c_.set(t, a), a;
}
function Uy(e, t) {
  if (!Number.isFinite(t)) return "other";
  const n = Math.abs(t), a = W2(e);
  if (!a) return n === 1 ? "one" : "other";
  try {
    return a.select(n);
  } catch {
    return n === 1 ? "one" : "other";
  }
}
function $pe(e, t, n) {
  const a = Math.abs(t), i = eO(e), o = Uy(e, a);
  if (n === i.length && n > 1) {
    const l = i.indexOf(o);
    return l >= 0 ? l : n - 1;
  }
  return n === 1 ? 0 : n === 2 ? o === "one" ? 0 : 1 : n === 3 ? a === 0 ? 0 : o === "one" ? 1 : 2 : n - 1;
}
function tO(e) {
  return e.includes(".") && e.replace(/[. ]/g, "") === "";
}
function nO(e) {
  return e !== "" && e.replace(/ /g, "") === "";
}
const aO = String.fromCodePoint(0), iO = new RegExp(
  "[" + String.fromCodePoint(1) + "-" + String.fromCodePoint(31) + String.fromCodePoint(127) + "]"
);
function Hy(e) {
  return e.replace(new RegExp("^\\p{White_Space}+|\\p{White_Space}+$", "gu"), "");
}
function Y2(e) {
  return e === "" || nO(e) ? "empty" : e.includes("/") || e.includes("\\") ? "separator" : e.includes(aO) ? "nul" : iO.test(e) ? "control" : tO(e) ? "dots" : null;
}
const G2 = /* @__PURE__ */ new Set([
  1564,
  8206,
  8207,
  8234,
  8235,
  8236,
  8237,
  8238,
  8294,
  8295,
  8296,
  8297
]), xf = String.fromCodePoint(65533);
function oO(e) {
  return G2.has(e);
}
const X2 = new RegExp(
  "[" + [...G2].map((e) => String.fromCodePoint(e)).join("") + "]",
  "u"
);
function da(e) {
  if (!e || !X2.test(e)) return e;
  let t = "";
  for (const n of e)
    t += oO(n.codePointAt(0) ?? 0) ? xf : n;
  return t;
}
const rO = 8294, sO = 8295, lO = 8296, uO = 8297;
function cO(e) {
  return e >= 8234 && e <= 8238;
}
function J2(e) {
  if (!e || !X2.test(e)) return e;
  const t = [...e], n = [];
  for (let a = 0; a < t.length; a++) {
    const i = t[a].codePointAt(0) ?? 0;
    cO(i) ? t[a] = xf : i === rO || i === sO || i === lO ? n.push(a) : i === uO && (n.length ? n.pop() : t[a] = xf);
  }
  for (const a of n) t[a] = xf;
  return t.join("");
}
const dO = Object.freeze([
  "viewer",
  "host",
  "account",
  "device"
]);
function Z2(e) {
  for (const t of dO) {
    if (t === "device") break;
    const n = e[t];
    if (typeof n == "string" && n && ns(n)) return { zone: n, tier: t };
  }
  return { zone: void 0, tier: "device" };
}
const Ju = "filex.timezone.viewer", Qf = "filex.timezone", fO = [
  "UTC",
  "Europe/Istanbul",
  "Europe/London",
  "Europe/Berlin",
  "Europe/Paris",
  "Europe/Madrid",
  "Europe/Moscow",
  "America/New_York",
  "America/Chicago",
  "America/Denver",
  "America/Los_Angeles",
  "America/Sao_Paulo",
  "Africa/Cairo",
  "Africa/Lagos",
  "Asia/Dubai",
  "Asia/Karachi",
  "Asia/Kolkata",
  "Asia/Shanghai",
  "Asia/Tokyo",
  "Asia/Seoul",
  "Asia/Singapore",
  "Australia/Sydney",
  "Pacific/Auckland"
];
function Q2() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
  } catch {
    return "UTC";
  }
}
function ns(e) {
  if (!e) return !1;
  try {
    return new Intl.DateTimeFormat("en-US", { timeZone: e }), !0;
  } catch {
    return !1;
  }
}
function Tpe() {
  try {
    const e = Intl.supportedValuesOf;
    if (typeof e == "function") {
      const t = e("timeZone");
      if (Array.isArray(t) && t.length)
        return t.includes("UTC") ? [...t] : ["UTC", ...t];
    }
  } catch {
  }
  return [...fO];
}
function d_(e, t) {
  const n = t ?? pO();
  try {
    const a = new Intl.DateTimeFormat("en-CA", {
      timeZone: n,
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    }).formatToParts(e), i = (p) => {
      var m;
      return Number((m = a.find((v) => v.type === p)) == null ? void 0 : m.value);
    }, o = i("year"), l = i("month"), c = i("day");
    if (!Number.isFinite(o) || !Number.isFinite(l) || !Number.isFinite(c))
      throw new Error("unparsable");
    return Math.floor(Date.UTC(o, l - 1, c) / 864e5);
  } catch {
    return Math.floor(
      Date.UTC(e.getFullYear(), e.getMonth(), e.getDate()) / 864e5
    );
  }
}
function Zu(e) {
  try {
    const t = localStorage.getItem(e);
    return t && ns(t) ? t : "";
  } catch {
    return "";
  }
}
function ex(e, t) {
  try {
    t ? localStorage.setItem(e, t) : localStorage.removeItem(e);
  } catch {
  }
}
const Ky = typeof window < "u", Hr = $(Ky ? Zu(Ju) : "");
function tx() {
  const e = $([]);
  return {
    set(t, n) {
      const a = e.value.find((i) => i.owner === t);
      if (n === null) {
        a && (e.value = e.value.filter((i) => i !== a));
        return;
      }
      a && a.zone === n || (e.value = [...e.value.filter((i) => i.owner !== t), { owner: t, zone: n }]);
    },
    of(t) {
      var n;
      return ((n = e.value.find((a) => a.owner === t)) == null ? void 0 : n.zone) ?? null;
    },
    current() {
      const t = e.value;
      return t.length ? t[t.length - 1].zone : "";
    },
    /** The newest answer among the owners `pick` accepts. */
    currentWhere(t) {
      const n = e.value.filter((a) => t(a.owner));
      return n.length ? n[n.length - 1].zone : "";
    }
  };
}
const Lc = tx(), wo = tx(), Mp = /* @__PURE__ */ new Set(), Vy = E(
  () => Z2({
    viewer: Hr.value,
    host: Lc.current(),
    account: wo.current()
  })
);
function pO() {
  return Vy.value.zone;
}
function Ape() {
  return Vy.value;
}
const nx = Symbol("filex-explorer-clock");
function hO(e) {
  return e ? {
    viewer: Hr.value,
    host: Lc.of(e) ?? "",
    account: wo.of(e) ?? wo.currentWhere((t) => Mp.has(t))
  } : vO();
}
function mO(e) {
  return e ? Z2(hO(e)) : Vy.value;
}
function ax(e) {
  return mO(e).zone;
}
function vO() {
  return {
    viewer: Hr.value,
    host: Lc.current(),
    account: wo.current()
  };
}
function Epe() {
  return Hr.value;
}
function yO(e) {
  const t = e && ns(e) ? e : "";
  Hr.value = t, ex(Ju, t);
  try {
    window.dispatchEvent(new CustomEvent("filex:timezone", { detail: t }));
  } catch {
  }
}
function gO(e, t) {
  Lc.set(e, t && ns(t) ? t : null);
}
function Sf(e, t, n = {}) {
  if (t == null) {
    wo.set(e, null);
    return;
  }
  const a = t && ns(t) ? t : "";
  wo.set(e, a), n.remember && (Mp.add(e), ex(Qf, a));
}
function bO(e) {
  return wo.of(e);
}
function kO(e) {
  return {
    get: () => bO(e) ?? "",
    set: (t) => {
      Sf(e, t && ns(t) ? t : "", { remember: !0 }), yO("");
    }
  };
}
function Cpe() {
  return Ky ? Zu(Qf) : "";
}
function wO(e) {
  Lc.set(e, null), wo.set(e, null), Mp.delete(e);
}
if (Ky)
  try {
    window.addEventListener("storage", (e) => {
      if ((e.key === null || e.key === Ju) && (Hr.value = Zu(Ju)), e.key === null || e.key === Qf) {
        const t = Zu(Qf);
        for (const n of Mp) wo.set(n, t);
      }
    }), window.addEventListener("filex:timezone", (e) => {
      const t = e.detail;
      Hr.value = typeof t == "string" ? t && ns(t) ? t : "" : Zu(Ju);
    });
  } catch {
  }
const f_ = /* @__PURE__ */ new Map();
function gi(e) {
  if (!e || e === "en") return "en-US";
  if (e === "tr") return "tr-TR";
  let t = f_.get(e);
  if (!t) {
    try {
      t = Intl.getCanonicalLocales(e)[0] || "en-US";
    } catch {
      t = "en-US";
    }
    f_.set(e, t);
  }
  return t;
}
const p_ = [
  "unit.bytes",
  "unit.kb",
  "unit.mb",
  "unit.gb",
  "unit.tb",
  "unit.pb"
], _O = {
  "unit.bytes": "B",
  "unit.kb": "KB",
  "unit.mb": "MB",
  "unit.gb": "GB",
  "unit.tb": "TB",
  "unit.pb": "PB"
};
function xO(e, t = {}) {
  const n = t.empty ?? "-";
  if (e == null || !Number.isFinite(e) || e < 0) return n;
  const a = t.base ?? 1e3, i = t.unit ?? ((m) => _O[m]);
  let o = 0, l = e;
  for (; l >= a && o < p_.length - 1; )
    l /= a, o += 1;
  const c = o === 0 ? 0 : t.digits === "fixed1" ? 1 : l < 10 ? 2 : 1;
  let p;
  if (t.numberLocale == null)
    p = l.toFixed(c);
  else {
    const m = SO(t.numberLocale, c, t.digits === "fixed1" ? c : 0);
    p = m ? m.format(l) : l.toFixed(c);
  }
  return `${p} ${i(p_[o])}`;
}
const lf = /* @__PURE__ */ new Map();
function SO(e, t, n) {
  const a = `${e}|${t}|${n}`;
  if (!lf.has(a))
    try {
      lf.set(a, new Intl.NumberFormat(e, {
        maximumFractionDigits: t,
        minimumFractionDigits: n
      }));
    } catch {
      lf.set(a, null);
    }
  return lf.get(a) ?? null;
}
const h_ = /* @__PURE__ */ new Map();
function ix(e, t, n) {
  const a = ax(n), i = `${e}|${a ?? `device:${Q2()}`}|${JSON.stringify(t)}`;
  let o = h_.get(i);
  return o || (o = new Intl.DateTimeFormat(e, { ...t, timeZone: a }), h_.set(i, o)), o;
}
function ep(e, t, n, a) {
  try {
    return ix(gi(t), n, a).format(e);
  } catch {
    return e.toISOString();
  }
}
const $O = /^(\d{4})-(\d{2})-(\d{2})$/, m_ = /* @__PURE__ */ new Map();
function TO(e, t) {
  const n = $O.exec(e.trim());
  if (!n) return "";
  const a = new Date(Date.UTC(Number(n[1]), Number(n[2]) - 1, Number(n[3])));
  if (Number.isNaN(a.getTime())) return "";
  const i = gi(t);
  let o = m_.get(i);
  try {
    return o || (o = new Intl.DateTimeFormat(i, { month: "short", day: "numeric", year: "numeric", timeZone: "UTC" }), m_.set(i, o)), o.format(a);
  } catch {
    return "";
  }
}
function $f(e) {
  if (!e) return null;
  const t = new Date(e * (e < 1e12 ? 1e3 : 1));
  return Number.isNaN(t.getTime()) ? null : t;
}
function ox(e) {
  if (e == null || e === "") return null;
  if (e instanceof Date) return Number.isNaN(e.getTime()) ? null : e;
  if (typeof e == "number") return $f(e);
  const t = new Date(e);
  return Number.isNaN(t.getTime()) ? null : t;
}
const AO = { month: "short", day: "numeric", year: "numeric" }, EO = { timeStyle: "short" };
function rx(e, t, n = {}, a) {
  const i = ox(e);
  if (!i) return "";
  const o = ep(i, t, AO, a);
  return n.time ? `${o}, ${ep(i, t, EO, a)}` : o;
}
function CO(e, t, n) {
  const a = ox(e);
  if (!a) return "";
  const i = ax(n) ?? Q2();
  return `${ep(a, t, { dateStyle: "full", timeStyle: "long" }, n)} (${i})`;
}
const sx = Symbol("filex-explorer-locale"), zO = ["count", "n", "days"];
function v_(e, t, n, a = "en") {
  const i = zO.find((c) => c in t);
  if (i === void 0) return e;
  const o = Uy(a, Number(t[i]));
  if (o === "other") return e;
  const l = `${e}_${o}`;
  return n(l) ? l : e;
}
function Vs(e, t) {
  const n = e[t];
  return typeof n == "string" && n ? n : void 0;
}
function MO(e, t, n = {}) {
  const a = e.strings, i = v_(t, n, (c) => Vs(a, c) !== void 0, e.lang), o = Vs(a, i) ?? Vs(a, t);
  if (o !== void 0) return o;
  if (a === el) return t;
  const l = v_(t, n, (c) => Vs(el, c) !== void 0, "en");
  return Vs(el, l) ?? Vs(el, t) ?? t;
}
function PO(e) {
  if (e.trashed) return !0;
  const t = e.extra_metadata;
  return t && typeof t == "object" && "deleted_at" in t ? !0 : typeof e.path == "string" && /(^|[/:])\.trash\//.test(e.path);
}
function y_(e, t) {
  return Object.entries(t).reduce(
    (n, [a, i]) => n.replaceAll(`{${a}}`, String(i)),
    e
  );
}
function lx(e, t, n, a) {
  const i = MO(e, t, n), o = {};
  for (const [c, p] of Object.entries(n)) o[c] = typeof p == "string" ? J2(p) : p;
  if (!a) return y_(i, o);
  const l = {};
  for (const [c, p] of Object.entries(o)) l[c] = typeof p == "string" ? NP(p) : p;
  return N2(y_(i, l));
}
function zpe(e, t, n = {}) {
  return lx(E2(e), t, n, kl(e) === "rtl");
}
function pt(e) {
  const t = () => typeof e == "function" ? e() : e.value, n = E(() => (oi.value, E2(t()))), a = Zo() ? bi(nx, void 0) : void 0, i = E(() => kl(t()));
  function o(b, C = {}) {
    return lx(n.value, b, C, i.value === "rtl");
  }
  o.foreign = (b) => Yi(t(), b);
  function l(b) {
    return xO(b, {
      unit: (C) => o(C),
      numberLocale: gi(t())
    });
  }
  function c(b) {
    return b ? b.size_partial ? typeof b.size == "number" && b.size > 0 ? o("size.at_least", { size: l(b.size) }) : "-" : l(b.size) : l(null);
  }
  function p(b) {
    if (b != null && b.size_partial)
      return typeof b.size == "number" && b.size > 0 ? o("size.partial_hint") : o("size.unknown_hint");
  }
  function m(b) {
    return b.basename === ".trash" ? o("node.trash") : da(v(b));
  }
  function v(b) {
    if (b.basename === ".trash") return o("node.trash");
    if (typeof b.fxe_name == "string" && b.fxe_name) return b.fxe_name;
    if (PO(b)) {
      const C = b.basename.match(/^\d{8}-\d{6}-[A-Za-z0-9]+__(.+)$/);
      if (C) return C[1];
    }
    return b.basename;
  }
  function x(b, C = {}) {
    return rx(b, t(), C, a);
  }
  function w(b) {
    return CO(b, t(), a);
  }
  function S(b) {
    const C = b instanceof Date ? b : $f(b);
    return C ? ep(C, t(), { month: "long", year: "numeric" }, a) : "";
  }
  function k(b) {
    const C = b instanceof Date ? b : $f(b);
    if (!C) return "";
    try {
      return ix("en-CA", { year: "numeric", month: "2-digit" }, a).format(C);
    } catch {
      return `${C.getFullYear()}-${String(C.getMonth() + 1).padStart(2, "0")}`;
    }
  }
  return {
    t: o,
    formatSize: l,
    formatNodeSize: c,
    nodeSizeHint: p,
    formatDate: x,
    formatDateFull: w,
    formatMonthYear: S,
    zonedYearMonth: k,
    /**
     * zaman:z1 — the wire's `last_modified` as a `Date`, or null.
     *
     * Handed out because "seconds or milliseconds" is a fact about the WIRE,
     * not about formatting, and every caller that needs the instant itself
     * (rather than a string) was otherwise re-typing `v * (v < 1e12 ? 1000 :
     * 1)`. ListView had the third copy and used it to group rows by day — so
     * the grouping and the cell four pixels away were reading the same number
     * through two different converters.
     */
    toDate: $f,
    nodeDisplayName: m,
    nodeName: v,
    /**
     * ⚠ RTL — which way this surface's language is written (`lib/direction`,
     * the server's one list). Bind it as `dir` on anything Teleported out of
     * the explorer's root: under `<body>` a menu inherits the HOST page's
     * direction, not the language its own words are in.
     */
    dir: i
  };
}
const Kr = $(0), lc = $(0), OO = E(() => Kr.value !== 0), Mpe = E(() => Kr.value), Ppe = E(() => lc.value), LO = 3e3;
let uc = 0;
function g_(e = Date.now()) {
  uc = e || 1;
}
function DO() {
  uc = 0;
}
typeof window < "u" && typeof window.addEventListener == "function" && (window.addEventListener("beforeunload", () => g_()), window.addEventListener("pagehide", () => g_()), window.addEventListener("pageshow", () => DO()));
function RO(e) {
  const t = e;
  return !t || typeof t != "object" ? !1 : t.name === "AbortError" || t.name === "CanceledError" || t.code === "ERR_CANCELED" ? !0 : t.code === "ECONNABORTED" && typeof t.message == "string" && /aborted/i.test(t.message);
}
function IO(e, t = Date.now()) {
  return RO(e) ? !0 : uc !== 0 && t - uc < LO;
}
function Dv(e, t = Date.now(), n) {
  return IO(n, t) ? "folded" : (Kr.value === 0 && (Kr.value = t || 1), e === "background" ? (lc.value += 1, "folded") : "say");
}
function Rv() {
  Kr.value === 0 && lc.value === 0 || (Kr.value = 0, lc.value = 0);
}
function Ope() {
  Kr.value = 0, lc.value = 0, uc = 0;
}
function NO(e) {
  const t = String(e ?? "get").toLowerCase();
  return t === "get" || t === "head" || t === "options" ? "background" : "action";
}
function ux(e) {
  const t = e.apiBase != null ? e.apiBase.replace(/\/+$/, "") : null;
  function n(i, o) {
    return i || (t === null ? null : `${t}${o}`);
  }
  const a = e.endpoint ?? (t !== null ? `${t}/api/files/manager` : null);
  if (!a)
    throw new Error(
      "[@brftech/filex-core] config requires either `apiBase` or `endpoint`"
    );
  return {
    manager: a,
    // Staged (chunked + resumable) uploads — what useUploadChunked speaks on
    // every driver. The {id} routes are derived from this one.
    uploadBegin: n(e.uploadBegin, "/api/files/upload/begin"),
    shareCreate: n(e.shareCreate, "/api/files/share"),
    shareList: n(e.shareList, "/api/files/share"),
    shareDelete: n(e.shareDelete, "/api/files/share/{uuid}"),
    limits: n(e.limits, "/api/files/limits"),
    capabilities: n(e.capabilities, "/api/files/capabilities"),
    pdfPreview: n(e.pdfPreview, GP),
    me: n(e.me, "/api/auth/me"),
    archiveList: n(e.archiveList, "/api/files/archive/list"),
    archiveExtract: n(e.archiveExtract, "/api/files/archive/extract"),
    archiveCreate: n(e.archiveCreate, "/api/files/archive/create"),
    archiveAdd: n(e.archiveAdd, "/api/files/archive/add"),
    copy: n(e.copy, "/api/files/copy"),
    moveAsync: n(e.moveAsync, "/api/files/move"),
    deleteAsync: n(e.deleteAsync, "/api/files/delete"),
    opsList: n(e.opsList, "/api/files/ops"),
    opsShow: n(e.opsShow, "/api/files/ops/{id}"),
    onlyOfficeConfig: n(e.onlyOfficeConfig, "/api/files/onlyoffice/config"),
    saveText: n(e.saveText, "/api/files/save-text"),
    restore: n(e.restore, "/api/files/restore"),
    // filex trash: list soft-deleted nodes + restore one by node id.
    trashList: n(e.trashList, "/api/files/manager/trash"),
    trashRestore: n(e.trashRestore, "/api/files/manager/restore"),
    /* An operator's "Delete permanently" of one trash entry (`{id}`). */
    trashPurge: n(e.trashPurge, "/api/admin/trash/{id}"),
    /* An operator's permanent delete of a selection, in one request. */
    trashPurgeBatch: n(e.trashPurgeBatch, "/api/admin/trash/purge"),
    /* An operator's "Empty trash": POST starts it, GET follows it,
       `/preview` counts what it would delete. */
    trashEmpty: n(e.trashEmpty, "/api/admin/trash/empty"),
    /* An operator's hard delete of one version (`{id}`). */
    versionPurge: n(e.versionPurge, "/api/admin/versions/{id}"),
    /* wiring:e2 — escrow proof-of-possession, then the owner is told. */
    e2eEscrowChallenge: n(e.e2eEscrowChallenge, "/api/files/e2e/escrow/challenge"),
    e2eEscrowUsed: n(e.e2eEscrowUsed, "/api/files/e2e/escrow/used"),
    /* wiring:e2 convert — after a folder is encrypted in place. */
    e2eCleanup: n(e.e2eCleanup, "/api/files/e2e/cleanup"),
    /* wiring:e2 policy — may this account encrypt here, and asking for it. */
    e2eAllowed: n(e.e2eAllowed, "/api/files/e2e/allowed"),
    e2eRequests: n(e.e2eRequests, "/api/files/e2e/requests"),
    /* App plugins — docs/APP-PLUGINS-API.md. */
    pluginActions: n(e.pluginActions, "/api/files/plugins/actions"),
    pluginActionRun: n(e.pluginActionRun, "/api/files/plugins/actions/{plugin}/{action}/run"),
    pluginView: n(e.pluginView, "/api/files/plugins/views/{plugin}/{view}"),
    pluginViewEvent: n(e.pluginViewEvent, "/api/files/plugins/views/{plugin}/{view}/event"),
    pluginUsers: n(e.pluginUsers, "/api/files/plugins/users"),
    opsCancel: n(e.opsCancel, "/api/files/ops/{id}/cancel"),
    /* v4 — an app's own interface (AppFrame): its module, and its saves. */
    pluginUICall: n(e.pluginUICall, "/api/files/plugins/ui/{plugin}/{view}/call"),
    pluginUISave: n(e.pluginUISave, "/api/files/plugins/ui/{plugin}/{view}/save"),
    /* 0.54 - what an interface reads of its file, checked by the server (#211). */
    pluginUIRead: n(e.pluginUIRead, "/api/files/plugins/ui/{plugin}/{view}/read"),
    /* 0.56 - editing together (files:co-edit): the relay's routes (#189). */
    pluginUICoEdit: n(e.pluginUICoEdit, "/api/files/plugins/ui/{plugin}/{view}/coedit"),
    /* 0.52.0 - a paid app's license, as the app itself reads it (fx.license.get()). */
    pluginLicense: n(e.pluginLicense, "/api/files/plugins/license/{plugin}")
  };
}
const BO = ["allowed", "request", "denied"];
function FO(e) {
  return typeof e == "string" && BO.includes(e) ? e : "allowed";
}
async function UO(e) {
  if (typeof e == "function") {
    const t = e();
    return t instanceof Promise ? await t : t;
  }
  return e;
}
function HO(e) {
  return e ? "kind" in e ? e : e.type === "bearer" ? { kind: "bearer", token: e.token } : e.type === "csrf" ? { kind: "csrf", csrf: e.csrf } : { kind: "none" } : { kind: "none" };
}
const KO = 8 << 20;
function Rl(e, t = {}) {
  const n = ux(e), a = HO(e.auth);
  let i = null;
  async function o(oe = {}) {
    const le = { Accept: "application/json", ...oe };
    if (a.kind === "bearer") {
      const Me = await UO(a.token);
      Me && (le.Authorization = `Bearer ${Me}`, i = Me);
    } else if (a.kind === "csrf")
      le["X-CSRF-TOKEN"] = a.csrf, le["X-Requested-With"] = "XMLHttpRequest";
    else if (a.kind === "basic") {
      const Me = btoa(`${a.user}:${a.pass}`);
      le.Authorization = `Basic ${Me}`;
    }
    return le;
  }
  function l(oe = {}) {
    const le = { Accept: "application/json", ...oe };
    if (a.kind === "bearer") {
      const Me = typeof a.token == "string" ? a.token : i;
      Me && (le.Authorization = `Bearer ${Me}`);
    } else if (a.kind === "csrf")
      le["X-CSRF-TOKEN"] = a.csrf, le["X-Requested-With"] = "XMLHttpRequest";
    else if (a.kind === "basic") {
      const Me = btoa(`${a.user}:${a.pass}`);
      le.Authorization = `Basic ${Me}`;
    }
    return le;
  }
  function c() {
    return a.kind === "csrf" ? "include" : "same-origin";
  }
  const p = () => {
    var oe;
    return ((oe = t.screenLocale) == null ? void 0 : oe.call(t)) ?? Wi(e.locale);
  };
  async function m(oe, le = {}) {
    const Me = await v(oe, le);
    if (!Me.ok) {
      const it = await Me.text().catch(() => "");
      throw fa(Me.status, it, p());
    }
    if (Me.status === 204 || Me.status === 205) return;
    const Ve = await Me.text();
    if (Ve)
      return JSON.parse(Ve);
  }
  async function v(oe, le = {}) {
    const Me = {
      // ⚠⚠ The language on SCREEN, not the one the browser was installed in.
      // Everything the server writes for a person — a plugin's surface, the
      // labels inside it, the message on a queued job — is rendered with the
      // request's `Accept-Language`. Chrome sends `en-US` whatever filex is
      // set to, so a Turkish window asked a signing wizard for its screens
      // and got "Identity" and an English help line in the middle of Turkish
      // ones. The window's own language is the only right answer here.
      "Accept-Language": gi(p()),
      ...await o(),
      ...le.headers ?? {}
    };
    let Ve;
    try {
      Ve = await fetch(oe, {
        ...le,
        headers: Me,
        credentials: c()
      });
    } catch (it) {
      throw (it == null ? void 0 : it.name) === "AbortError" ? it : (Dv(NO(le.method), Date.now(), it), Lv(p(), it));
    }
    return Rv(), Ve;
  }
  const x = n.manager.replace(/\/manager(\?.*)?$/, "/drafts"), w = jP(x, {
    request: v,
    get locale() {
      return p();
    }
  });
  function S(oe = "") {
    return n.manager.replace(/\/manager(\?.*)?$/, "/permissions") + oe;
  }
  async function k(oe) {
    return m(S() + "?path=" + encodeURIComponent(oe));
  }
  async function b(oe) {
    return m(S("/resolve") + "?email=" + encodeURIComponent(oe));
  }
  async function C(oe) {
    return m(S("/users") + "?q=" + encodeURIComponent(oe));
  }
  async function T(oe) {
    try {
      return await m(S("/groups") + "?q=" + encodeURIComponent(oe));
    } catch {
      return { groups: [] };
    }
  }
  async function A(oe, le) {
    return m(S("/groups/" + oe), { method: "PATCH", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ level: le }) });
  }
  async function L(oe) {
    return m(S("/groups/" + oe), { method: "DELETE" });
  }
  async function z(oe) {
    return m(S(), { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(oe) });
  }
  async function D(oe, le) {
    return m(S("/" + oe), { method: "PATCH", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ level: le }) });
  }
  async function U(oe) {
    return m(S("/" + oe), { method: "DELETE" });
  }
  async function q(oe) {
    return m(S("/invite"), { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(oe) });
  }
  async function P(oe) {
    return m(S("/share-mail"), { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(oe) });
  }
  async function R(oe, le) {
    const Me = new URLSearchParams({ share: oe });
    return le && Me.set("lang", le), m(S("/share-message") + "?" + Me.toString());
  }
  function W(oe) {
    const le = new URLSearchParams();
    for (const [Me, Ve] of Object.entries(oe))
      Ve != null && le.set(Me, String(Ve));
    return le.toString();
  }
  function N(oe, le = {}) {
    const Me = n.manager.includes("?") ? "&" : "?";
    return `${n.manager}${Me}${W({ q: oe, action: oe, ...le })}`;
  }
  async function J(oe) {
    return m(N("index", { path: zv(oe) }));
  }
  async function H(oe, le, Me) {
    return m(N("search", { ...Me ?? {}, path: zv(oe), filter: le }));
  }
  async function ne(oe, le = {}) {
    return (await j(oe, le)).hits;
  }
  async function j(oe, le = {}) {
    const Me = n.manager.replace(/\/manager(\?.*)?$/, "/search"), Ve = Me.includes("?") ? "&" : "?", it = `${Me}${Ve}${W({ ...le.narrow ?? {}, q: oe, limit: le.limit, scope: le.scope })}`, Z = await m(it);
    return {
      hits: Array.isArray(Z == null ? void 0 : Z.results) ? Z.results : [],
      truncated: typeof (Z == null ? void 0 : Z.truncated) == "boolean" ? Z.truncated : void 0,
      total: typeof (Z == null ? void 0 : Z.total) == "number" ? Z.total : void 0
    };
  }
  async function re(oe, le, Me) {
    const Ve = n.manager.replace(/\/manager(\?.*)?$/, "/search/match"), it = await m(Ve, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ q: oe, names: le }),
      signal: Me
    });
    return Array.isArray(it == null ? void 0 : it.matches) ? it.matches : [];
  }
  async function he() {
    const oe = n.manager.replace(/\/manager(\?.*)?$/, "/quota/me");
    try {
      const le = await m(oe);
      return le && typeof le.used_bytes == "number" ? le : null;
    } catch {
      return null;
    }
  }
  async function ue() {
    const oe = n.manager.replace(/\/manager(\?.*)?$/, "/quota/storages");
    try {
      const le = await m(oe);
      return Array.isArray(le == null ? void 0 : le.storages) ? le.storages : null;
    } catch {
      return null;
    }
  }
  async function ae() {
    const oe = n.manager.replace(/\/api\/files\/manager(\?.*)?$/, "").replace(/\/$/, "");
    try {
      const le = await m(`${oe}/api/app-store`);
      return {
        visible: (le == null ? void 0 : le.visible) === !0,
        stores: Array.isArray(le == null ? void 0 : le.stores) ? le.stores.filter((Me) => typeof Me == "string") : []
      };
    } catch {
      return null;
    }
  }
  async function fe(oe) {
    return m(N("subfolders", { path: oe }));
  }
  async function _(oe, le) {
    return m(N("newfolder"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path: oe, name: le })
    });
  }
  async function Q(oe, le, Me, Ve = {}) {
    return m(N("newfile"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(Ve.exactName ? { path: oe, name: le, type: Me, exact_name: !0 } : { path: oe, name: le, type: Me })
    });
  }
  async function K(oe, le, Me) {
    return m(N("newfile"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path: oe, name: le, type: Me, exact_name: !0, dry_run: !0 })
    });
  }
  async function I(oe, le, Me) {
    return m(N("rename"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path: oe, item: le, name: Me })
    });
  }
  async function Y(oe, le, Me) {
    return m(N("rename", { queued: 1 }), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path: oe, item: le, name: Me })
    });
  }
  async function B(oe, le, Me) {
    return m(N("move"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path: oe, item: Me, items: le.map((Ve) => ({ path: Ve })) })
    });
  }
  async function V(oe, le) {
    return m(N("delete"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path: oe, items: le.map((Me) => ({ path: Me })) })
    });
  }
  async function be(oe, le) {
    const Me = [];
    for (let Ve = 0; Ve < oe.length; Ve += 1e3) {
      const it = oe.slice(Ve, Ve + 1e3), Z = await m(N("allowed"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ permissions: le, items: it.map((ee) => ({ path: ee })) })
      });
      it.forEach((ee, we) => {
        var Ye;
        return Me.push(((Ye = Z.allowed) == null ? void 0 : Ye[we]) ?? []);
      });
    }
    return Me;
  }
  async function Fe(oe, le) {
    if (!n.copy) throw new Error("copy endpoint not configured");
    return m(n.copy, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ source: oe, target: le })
    });
  }
  async function ze(oe, le, Me, Ve, it) {
    const Z = oe === "copy" ? n.copy : n.moveAsync;
    if (!Z) throw new Error(`${oe} endpoint not configured`);
    return m(Z, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ source: [le], target: Me, name: Ve, ...it ? { sourceDir: it } : {} })
    });
  }
  async function Ue(oe, le, Me) {
    if (!n.moveAsync) throw new Error("moveAsync endpoint not configured");
    return m(n.moveAsync, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ source: oe, target: le, sourceDir: Me })
    });
  }
  async function We(oe, le) {
    if (!n.deleteAsync) throw new Error("deleteAsync endpoint not configured");
    return m(n.deleteAsync, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ source: oe, sourceDir: le })
    });
  }
  async function $t(oe) {
    if (!n.restore) throw new Error("restore endpoint not configured");
    return m(n.restore, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ source: oe })
    });
  }
  async function St(oe) {
    if (!n.trashRestore) throw new Error("trashRestore endpoint not configured");
    const le = n.trashRestore.includes("?") ? "&" : "?", Me = await m(
      ge(`${n.trashRestore}${le}queued=1`),
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ node_ids: oe })
      }
    );
    return { ops: Me.ops ?? [], summary: Me.summary ?? "" };
  }
  async function at(oe, le = {}) {
    if (!n.trashList) throw new Error("trashList endpoint not configured");
    const Me = [];
    oe && Me.push(`storage=${encodeURIComponent(oe)}`), le.limit && Me.push(`limit=${le.limit}`), le.offset && Me.push(`offset=${le.offset}`);
    const Ve = n.trashList, it = Me.length ? `${Ve}${Ve.includes("?") ? "&" : "?"}${Me.join("&")}` : Ve;
    return m(ge(it));
  }
  async function kt(oe) {
    const le = n.trashRestore;
    if (!le) throw new Error("trashRestore endpoint not configured");
    return m(ge(le), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ node_ids: oe })
    });
  }
  async function ht(oe, le = {}) {
    const Me = n.trashPurgeBatch;
    if (!Me) throw new Error("trashPurgeBatch endpoint not configured");
    const Ve = le.queued ? `${Me}${Me.includes("?") ? "&" : "?"}queued=1` : Me;
    return m(ge(Ve), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ node_ids: oe })
    });
  }
  async function Ie() {
    const oe = n.trashEmpty;
    if (!oe) throw new Error("trashEmpty endpoint not configured");
    return m(ge(`${oe.replace(/\/+$/, "")}/preview`));
  }
  async function se(oe, le = {}) {
    const Me = n.trashPurge;
    if (!Me) throw new Error("trashPurge endpoint not configured");
    let Ve = Me.replace("{id}", encodeURIComponent(String(oe)));
    le.queued && (Ve += `${Ve.includes("?") ? "&" : "?"}queued=1`);
    const it = await m(Ve, { method: "DELETE" });
    return it != null && it.op ? { op: it.op } : {};
  }
  async function xe(oe) {
    const le = n.versionPurge;
    if (!le) throw new Error("versionPurge endpoint not configured");
    await m(le.replace("{id}", encodeURIComponent(String(oe))), { method: "DELETE" });
  }
  async function me(oe, le, Me, Ve) {
    const it = new FormData();
    it.append("path", oe);
    for (const [ee, we] of Object.entries(Ve ?? {})) it.append(ee, we);
    for (const ee of le)
      it.append("file[]", ee, ee.name);
    for (const ee of le)
      it.append("name[]", ee.name);
    const Z = await o();
    return new Promise((ee, we) => {
      const Ye = new XMLHttpRequest();
      Ye.open("POST", N("upload"));
      for (const [rt, vt] of Object.entries(Z))
        rt !== "Content-Type" && Ye.setRequestHeader(rt, vt);
      Ye.withCredentials = c() === "include", Ye.upload.onprogress = (rt) => {
        Me && rt.lengthComputable && Me(Math.round(rt.loaded / rt.total * 100));
      }, Ye.onload = () => {
        if (Rv(), Ye.status >= 200 && Ye.status < 300)
          try {
            ee(JSON.parse(Ye.responseText));
          } catch (rt) {
            we(rt);
          }
        else
          we(fa(Ye.status, Ye.responseText || "", p()));
      }, Ye.onerror = () => {
        Dv("action"), we(Lv(p()));
      }, Ye.send(it);
    });
  }
  function De(oe) {
    return N("download", { path: oe });
  }
  let ot = !!e.pdfPreview;
  function ft(oe) {
    return ot && n.pdfPreview && XP(oe) ? JP(n.pdfPreview, oe) : N("preview", { path: oe });
  }
  async function gt(oe, le = {}) {
    const Me = await o(), Ve = await fetch(ft(oe), {
      headers: Me,
      credentials: c(),
      // ⚠ The preview endpoint answers `Cache-Control: private, max-age=60`,
      // which is right for the thing it was built for — a viewer re-opening
      // an image — and wrong for anything the client treats as CONTROL data.
      // `.filex-e2e.json` is control data: after the client rewrites it
      // (recovery upgrade, escrow slot, escrow refusal) the next read inside
      // that minute came back PRE-write, so the folder looked un-upgraded
      // and the question filex had just been answered was asked again.
      // Measured 2026-09-05 in a real browser: decline the escrow offer,
      // reopen the folder, and the offer was back.
      cache: le.fresh ? "no-store" : "default"
    });
    if (!Ve.ok) {
      const we = await Ve.text().catch(() => "");
      throw fa(Ve.status, we, p());
    }
    const it = await Ve.blob(), Z = it.type || Ve.headers.get("content-type") || "";
    return { url: URL.createObjectURL(it), blob: it, mime: Z };
  }
  async function Ut(oe) {
    const le = await o(), Me = await fetch(ft(oe), {
      headers: le,
      credentials: c()
    });
    if (!Me.ok) {
      const Ve = await Me.text().catch(() => "");
      throw fa(Me.status, Ve, p());
    }
    return Me.arrayBuffer();
  }
  async function Xe() {
    return n.limits ? m(n.limits) : { max_upload_mb: 1024 };
  }
  async function je() {
    if (!n.capabilities)
      return {
        ffmpeg: !1,
        ghostscript: !1,
        max_chunk_mb: 5,
        upload_limit_mb: 1024,
        onlyoffice_url: e.onlyOfficeBase ?? null,
        drawio_url: e.drawioBase ?? null
      };
    const oe = await m(n.capabilities);
    return PP(oe), oe.pdf_preview === !0 && (ot = !0), oe;
  }
  async function Be() {
    var le;
    if (!n.me) return null;
    const oe = await m(n.me);
    return !oe || !Array.isArray(oe.permissions) ? null : {
      admin: ((le = oe.user) == null ? void 0 : le.role) === "admin",
      permissions: [...oe.permissions, ...oe.permissions_in_folders ?? []],
      byFolder: oe.permissions_by_folder ?? []
    };
  }
  function ie(oe, le) {
    return Object.entries(le).reduce(
      (Me, [Ve, it]) => Me.replaceAll(`{${Ve}}`, encodeURIComponent(String(it))),
      oe
    );
  }
  function ge(oe) {
    return `${oe}${oe.includes("?") ? "&" : "?"}lang=${encodeURIComponent(p())}`;
  }
  function G(oe) {
    return /^https?:\/\//i.test(oe) ? oe : n.manager.replace(/\/api\/files\/manager(\?.*)?$/, "").replace(/\/$/, "") + (oe.startsWith("/") ? oe : `/${oe}`);
  }
  function ye() {
    return n.manager.replace(/\/api\/files\/manager(\?.*)?$/, "").replace(/\/$/, "") + "/_print/";
  }
  async function te(oe) {
    if (!n.pluginLicense) throw new Error("pluginLicense endpoint not configured");
    return m(ie(n.pluginLicense, { plugin: oe }));
  }
  async function Ce(oe, le, Me) {
    if (!n.pluginUICall) throw new Error("pluginUICall endpoint not configured");
    return m(ge(ie(n.pluginUICall, { plugin: oe, view: le })), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(Me)
    });
  }
  async function Ne(oe, le, Me, Ve, it) {
    if (!n.pluginUISave) throw new Error("pluginUISave endpoint not configured");
    const Z = { ...(it == null ? void 0 : it.extra) ?? {}, ...q2(it == null ? void 0 : it.csv) ?? {} }, ee = Object.entries(Z).map(([ke, Oe]) => `&${encodeURIComponent(ke)}=${encodeURIComponent(Oe)}`).join(""), we = ("path" in Me ? `path=${encodeURIComponent(Me.path)}` : `dir=${encodeURIComponent(Me.dir)}&name=${encodeURIComponent(Me.name)}`) + ee, Ye = `${it != null && it.e2e ? "&e2e=1" : ""}${it != null && it.expect ? `&expect=${encodeURIComponent(it.expect)}` : ""}`, rt = ie(n.pluginUISave, { plugin: oe, view: le }), vt = `${rt}${rt.includes("?") ? "&" : "?"}${we}${Ye}`, Bt = Pc("app_ui_save_chunk_bytes") ?? KO, Qt = (ke, Oe) => m(ke, { method: "PUT", headers: { "Content-Type": "application/octet-stream" }, body: Oe });
    if (Ve instanceof Blob && Ve.size <= Bt)
      return m(vt, {
        method: "PUT",
        headers: { "Content-Type": Ve.type || "application/octet-stream" },
        body: Ve
      });
    let en = "", Ot = 0;
    const kn = async (ke, Oe) => {
      const st = en ? `${vt}&session=${encodeURIComponent(en)}&offset=${Ot}${Oe ? "&final=1" : ""}` : `${vt}&chunk=start${Oe ? "&final=1" : ""}`, tn = await Qt(st, ke);
      return Oe || (en = tn.session ?? en, Ot = tn.received ?? Ot + ke.size), tn;
    };
    if (Ve instanceof Blob)
      for (let ke = 0; ; ke += Bt) {
        const Oe = Math.min(ke + Bt, Ve.size), st = Ve.slice(ke, Oe);
        if (Oe >= Ve.size) return await kn(st, !0);
        await kn(st, !1);
      }
    const Pa = Ve.getReader();
    let cn = [], pe = 0;
    for (; ; ) {
      const { done: ke, value: Oe } = await Pa.read();
      for (Oe && Oe.byteLength && (cn.push(Oe), pe += Oe.byteLength); pe >= Bt && !ke; ) {
        const st = new Blob(cn);
        await kn(st.slice(0, Bt), !1);
        const tn = new Uint8Array(await st.slice(Bt).arrayBuffer());
        cn = tn.byteLength ? [tn] : [], pe = tn.byteLength;
      }
      if (ke) {
        const st = new Blob(cn);
        return !en && st.size <= Bt ? m(vt, { method: "PUT", headers: { "Content-Type": "application/octet-stream" }, body: st }) : await kn(st, !0);
      }
    }
  }
  async function _e(oe) {
    const le = await o(), Me = await fetch(ft(oe), { headers: le, credentials: c(), cache: "no-store" });
    if (!Me.ok) {
      const Ve = await Me.text().catch(() => "");
      throw fa(Me.status, Ve, p());
    }
    return Me;
  }
  async function Ae(oe, le, Me, Ve) {
    if (!n.pluginUIRead) {
      if (Ve != null && Ve.e2e) throw new Error("pluginUIRead endpoint not configured");
      return _e(Me);
    }
    const it = ie(n.pluginUIRead, { plugin: oe, view: le }), Z = await o(), ee = Ve != null && Ve.e2e ? "&e2e=1" : "", we = await fetch(`${it}${it.includes("?") ? "&" : "?"}path=${encodeURIComponent(Me)}${ee}`, {
      headers: Z,
      credentials: c(),
      cache: "no-store"
    });
    if (!we.ok) {
      const Ye = await we.text().catch(() => "");
      throw fa(we.status, Ye, p());
    }
    return we;
  }
  function Pe(oe, le) {
    if (!n.pluginUICoEdit) throw new Error("pluginUICoEdit endpoint not configured");
    return ie(n.pluginUICoEdit, { plugin: oe, view: le });
  }
  async function _t(oe, le, Me, Ve = {}) {
    return m(`${Pe(oe, le)}/join`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path: Me, ...Ve })
    });
  }
  async function Et(oe, le, Me, Ve, it, Z = {}) {
    const ee = `${Pe(oe, le)}/${encodeURIComponent(Me)}/${Ve}`;
    return Z.keepalive === !0 && xn(ee, JSON.stringify(it)) ? {} : m(ee, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(it),
      keepalive: Z.keepalive === !0
    });
  }
  function xn(oe, le) {
    if (a.kind !== "none") return !1;
    const Me = typeof navigator > "u" ? void 0 : navigator;
    if (typeof (Me == null ? void 0 : Me.sendBeacon) != "function") return !1;
    try {
      return Me.sendBeacon(oe, le);
    } catch {
      return !1;
    }
  }
  function Dt(oe, le, Me, Ve, it) {
    return `${Pe(oe, le)}/${encodeURIComponent(Me)}/blob/${encodeURIComponent(Ve)}?client=${encodeURIComponent(it.client)}&token=${encodeURIComponent(it.token)}`;
  }
  async function bn(oe, le, Me, Ve, it, Z) {
    await m(Dt(oe, le, Me, Ve, it), {
      method: "PUT",
      headers: { "Content-Type": "application/octet-stream" },
      body: new Blob([Z])
    });
  }
  async function un(oe, le, Me, Ve, it) {
    const Z = await v(Dt(oe, le, Me, Ve, it), { cache: "no-store" });
    if (!Z.ok) {
      const ee = await Z.text().catch(() => "");
      throw fa(Z.status, ee, p());
    }
    return Z.arrayBuffer();
  }
  async function Jt() {
    if (!n.pluginActions) return { actions: [], views: [] };
    const oe = await m(n.pluginActions);
    return {
      actions: (oe == null ? void 0 : oe.actions) ?? [],
      views: (oe == null ? void 0 : oe.views) ?? [],
      ...oe != null && oe.open_rules ? { open_rules: oe.open_rules } : {}
    };
  }
  async function Ln(oe, le, Me) {
    if (!n.pluginActionRun) throw new Error("pluginActionRun endpoint not configured");
    return m(ge(ie(n.pluginActionRun, { plugin: oe, action: le })), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(Me)
    });
  }
  async function Vn(oe, le, Me, Ve) {
    if (!n.pluginView) throw new Error("pluginView endpoint not configured");
    const it = ie(n.pluginView, { plugin: oe, view: le }), Z = [
      Me ? `path=${encodeURIComponent(Me)}` : "",
      Ve ? `section=${encodeURIComponent(Ve)}` : ""
    ].filter(Boolean);
    return m(ge(it + (Z.length ? `?${Z.join("&")}` : "")));
  }
  async function Ft(oe, le, Me) {
    if (!n.pluginViewEvent) throw new Error("pluginViewEvent endpoint not configured");
    return m(ge(ie(n.pluginViewEvent, { plugin: oe, view: le })), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(Me)
    });
  }
  async function na(oe, le) {
    if (!n.pluginUsers) throw Object.assign(new Error("pluginUsers endpoint not configured"), { status: 404 });
    const Me = `${n.pluginUsers}?plugin=${encodeURIComponent(oe)}&q=${encodeURIComponent(le)}`, Ve = await m(Me);
    return { users: (Ve == null ? void 0 : Ve.users) ?? [] };
  }
  async function Kt(oe) {
    if (!n.opsCancel) throw new Error("opsCancel endpoint not configured");
    await m(ie(n.opsCancel, { id: oe }), { method: "POST" });
  }
  async function bt(oe) {
    if (!n.e2eEscrowChallenge) throw new Error("e2e escrow endpoint not configured");
    return m(n.e2eEscrowChallenge, {
      method: "POST",
      body: JSON.stringify({ path: oe })
    });
  }
  async function Dn(oe) {
    if (!n.e2eEscrowUsed) throw new Error("e2e escrow endpoint not configured");
    return m(n.e2eEscrowUsed, {
      method: "POST",
      body: JSON.stringify(oe)
    });
  }
  async function In(oe, le = 16) {
    const Me = { ...await o(), Range: `bytes=0-${le - 1}` }, Ve = await fetch(ft(oe), { headers: Me, credentials: c(), cache: "no-store" });
    if (!Ve.ok) {
      const we = await Ve.text().catch(() => "");
      throw fa(Ve.status, we, p());
    }
    if (!Ve.body) return new Uint8Array(await Ve.arrayBuffer()).slice(0, le);
    const it = Ve.body.getReader(), Z = new Uint8Array(le);
    let ee = 0;
    try {
      for (; ee < le; ) {
        const { done: we, value: Ye } = await it.read();
        if (we || !Ye) break;
        const rt = Math.min(Ye.length, le - ee);
        Z.set(Ye.subarray(0, rt), ee), ee += rt;
      }
    } finally {
      it.cancel().catch(() => {
      });
    }
    return Z.slice(0, ee);
  }
  async function Cn(oe) {
    if (!n.e2eCleanup) throw new Error("e2e cleanup endpoint not configured");
    return m(n.e2eCleanup, { method: "POST", body: JSON.stringify(oe) });
  }
  async function fn(oe, le = {}) {
    var it;
    const Me = n.e2eAllowed;
    if (!Me || !oe.length) return oe.map(() => "allowed");
    const Ve = [];
    try {
      for (let Z = 0; Z < oe.length; Z += 1e3) {
        const ee = oe.slice(Z, Z + 1e3), we = await m(Me, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            items: ee.map((Ye) => typeof Ye == "string" ? { path: Ye } : Ye.kind ? { path: Ye.path, kind: Ye.kind } : { path: Ye.path })
          })
        });
        ee.forEach((Ye, rt) => {
          var vt;
          return Ve.push(FO((vt = we == null ? void 0 : we.encrypt) == null ? void 0 : vt[rt]));
        });
      }
    } catch (Z) {
      return console.warn("[filex] could not ask who may encrypt here; offering encryption as before", Z), (it = le.onFailed) == null || it.call(le), oe.map(() => "allowed");
    }
    return Ve;
  }
  async function mn(oe) {
    if (!n.e2eRequests) throw new Error("e2e requests endpoint not configured");
    return m(n.e2eRequests, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(oe)
    });
  }
  async function aa(oe) {
    if (!n.shareCreate) throw new Error("shareCreate endpoint not configured");
    return m(n.shareCreate, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(oe)
    });
  }
  async function zn(oe) {
    if (!n.shareList) return { shares: [] };
    const le = n.shareList.includes("?") ? "&" : "?";
    return m(`${n.shareList}${le}path=${encodeURIComponent(oe)}`);
  }
  async function Mn(oe) {
    if (!n.shareDelete) throw new Error("shareDelete endpoint not configured");
    const le = n.shareDelete.replace("{uuid}", encodeURIComponent(oe));
    return m(le, { method: "DELETE" });
  }
  async function rn(oe, le) {
    if (!n.archiveList) throw new Error("archiveList endpoint not configured");
    return {
      entries: (await m(
        n.archiveList,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ path: oe, password: le })
        }
      )).entries.map((Ve) => ({
        name: Ve.name,
        size: Ve.size,
        isDir: Ve.is_dir,
        lastModified: Ve.mtime
      }))
    };
  }
  async function ve(oe, le = {}) {
    if (!n.archiveExtract) throw new Error("archiveExtract endpoint not configured");
    return m(n.archiveExtract, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path: oe, ...le })
    });
  }
  async function Le(oe) {
    if (!n.archiveCreate) throw new Error("archiveCreate endpoint not configured");
    return m(n.archiveCreate, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(oe)
    });
  }
  async function He(oe, le) {
    if (!n.archiveAdd) throw new Error("archiveAdd endpoint not configured");
    return m(n.archiveAdd, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path: oe, files: le })
    });
  }
  function Ke(oe = "") {
    return n.manager.replace(/\/manager(\?.*)?$/, "/versions") + oe;
  }
  async function xt(oe) {
    const le = await m(
      Ke() + "?node_id=" + encodeURIComponent(String(oe))
    );
    return Array.isArray(le == null ? void 0 : le.versions) ? le.versions : [];
  }
  async function Qe(oe, le, Me = !0) {
    await m(Ke("/restore"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        node_id: oe,
        version_id: le,
        snapshot_current: Me
      })
    });
  }
  async function ce(oe) {
    await m(Ke("/snapshot"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ node_id: oe })
    });
  }
  function qe(oe = "") {
    return n.manager.replace(/\/manager(\?.*)?$/, "/comments") + oe;
  }
  async function dt(oe) {
    const le = await m(
      qe() + "?node_id=" + encodeURIComponent(String(oe))
    );
    return Array.isArray(le == null ? void 0 : le.comments) ? le.comments : [];
  }
  async function Nt(oe, le) {
    return (await m(qe(), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ node_id: oe, body: le })
    })).comment;
  }
  async function hn(oe) {
    await m(qe("/" + encodeURIComponent(String(oe))), {
      method: "DELETE"
    });
  }
  async function nn() {
    const oe = n.manager.replace(/\/manager(\?.*)?$/, "/ws-ticket");
    try {
      return await m(oe, { method: "POST" });
    } catch {
      return null;
    }
  }
  return {
    /** The language this client says things in (`FileApiOptions.screenLocale`). */
    screenLocale: p,
    // Realtime
    wsTicket: nn,
    // Manager
    index: J,
    search: H,
    globalSearch: ne,
    globalSearchPage: j,
    matchNames: re,
    quotaMe: he,
    storageUsage: ue,
    appStoreStatus: ae,
    subfolders: fe,
    newFolder: _,
    newFile: Q,
    newFileCheck: K,
    drafts: w,
    draftsBase: x,
    rename: I,
    renameQueued: Y,
    move: B,
    copy: Fe,
    moveAsync: Ue,
    deleteAsync: We,
    deleteItems: V,
    allowedAt: be,
    myPermissions: Be,
    restore: $t,
    listTrash: at,
    restoreBatch: kt,
    restoreQueued: St,
    purgeTrash: se,
    purgeBatch: ht,
    trashEmptyPreview: Ie,
    purgeVersion: xe,
    uploadMultipart: me,
    downloadUrl: De,
    previewUrl: ft,
    fetchBlob: gt,
    fetchArrayBuffer: Ut,
    // Peripheral
    limits: Xe,
    capabilities: je,
    /* wiring:e2 */
    e2eEscrowChallenge: bt,
    e2eEscrowUsed: Dn,
    e2eCleanup: Cn,
    /* wiring:e2 policy */
    e2eAllowedAt: fn,
    e2eRequest: mn,
    fetchHead: In,
    transferNamed: ze,
    /* App plugins */
    pluginActions: Jt,
    pluginActionRun: Ln,
    pluginView: Vn,
    pluginViewEvent: Ft,
    pluginUsers: na,
    opsCancel: Kt,
    appUIUrl: G,
    printFrameUrl: ye,
    pluginUICall: Ce,
    pluginUISave: Ne,
    pluginUIRead: Ae,
    pluginLicense: te,
    coeditJoin: _t,
    coeditCall: Et,
    coeditBlobPut: bn,
    coeditBlobGet: un,
    fetchResponse: _e,
    createShare: aa,
    listShares: zn,
    revokeShare: Mn,
    archiveList: rn,
    archiveExtract: ve,
    archiveCreate: Le,
    archiveAdd: He,
    // Version history (koru:k1 inspector)
    listVersions: xt,
    restoreVersion: Qe,
    snapshotVersion: ce,
    // Node comments (calisma:d3 inspector)
    listComments: dt,
    addComment: Nt,
    deleteComment: hn,
    // Permissions (RBAC panel)
    listPermissions: k,
    resolveEmail: b,
    searchUsers: C,
    searchGroups: T,
    addPermission: z,
    updatePermission: D,
    deletePermission: U,
    updateGroupPermission: A,
    deleteGroupPermission: L,
    invitePermission: q,
    shareMail: P,
    shareMessage: R,
    // Internals (exposed for useUploadChunked + PreviewModal)
    endpoints: n,
    authHeaders: o,
    authHeadersSync: l,
    credentialsMode: c,
    jsonFetch: m,
    // One request with this client's credential and language, answered as
    // the Response (a stream's reader: the AI assistant, lib/assistant).
    rawRequest: v,
    withScreenLang: ge
  };
}
function ul() {
  const e = globalThis.crypto;
  if (typeof (e == null ? void 0 : e.randomUUID) == "function") return e.randomUUID();
  const t = new Uint8Array(16);
  if (typeof (e == null ? void 0 : e.getRandomValues) == "function") e.getRandomValues(t);
  else for (let a = 0; a < t.length; a++) t[a] = Math.floor(Math.random() * 256);
  t[6] = t[6] & 15 | 64, t[8] = t[8] & 63 | 128;
  const n = Array.from(t, (a) => a.toString(16).padStart(2, "0")).join("");
  return `${n.slice(0, 8)}-${n.slice(8, 12)}-${n.slice(12, 16)}-${n.slice(16, 20)}-${n.slice(20)}`;
}
const jy = "filex:uploads:v1";
function Dm(e) {
  if (!e) return;
  const t = Date.parse(e);
  return Number.isFinite(t) ? t : void 0;
}
function Rm(e, t) {
  return [e, t.name, t.size, t.lastModified ?? 0].join("\0");
}
function VO() {
  try {
    return typeof localStorage > "u" ? null : (localStorage.getItem(jy), localStorage);
  } catch {
    return null;
  }
}
function qy(e) {
  if (!e) return {};
  try {
    const t = e.getItem(jy);
    if (!t) return {};
    const n = JSON.parse(t);
    return n && typeof n == "object" ? n : {};
  } catch {
    return {};
  }
}
function Wy(e, t) {
  if (e)
    try {
      e.setItem(jy, JSON.stringify(t));
    } catch {
    }
}
function cx(e, t = Date.now()) {
  const n = qy(e);
  let a = !1;
  for (const [i, o] of Object.entries(n)) {
    const l = o == null ? void 0 : o.expiresAt;
    (!(o != null && o.uploadId) || typeof l != "number" || !Number.isFinite(l) || t >= l) && (delete n[i], a = !0);
  }
  return a && Wy(e, n), n;
}
function b_(e, t, n = Date.now()) {
  return cx(e, n)[t] ?? null;
}
function k_(e, t, n, a = Date.now()) {
  const i = qy(e);
  i[t] = { ...n, updatedAt: a }, Wy(e, i);
}
function Iu(e, t) {
  const n = qy(e);
  t in n && (delete n[t], Wy(e, n));
}
function jO(e, t = Date.now()) {
  return Object.values(cx(e, t)).sort((n, a) => a.updatedAt - n.updatedAt);
}
function qO(e) {
  return !e || e === "staging";
}
function w_(e) {
  return e.stagedUnsupported = !0, e;
}
function Yy(e) {
  return !!(e != null && e.stagedUnsupported);
}
function WO(e, t, n = VO()) {
  const a = e.chunkSize ?? 8388608, i = () => {
    var k;
    return ((k = t.screenLocale) == null ? void 0 : k.call(t)) ?? Wi(e.locale);
  };
  function o() {
    const k = t.endpoints.uploadBegin;
    return k ? k.replace(/\/begin$/, "") : t.endpoints.manager.replace(/\/manager(\?.*)?$/, "/upload");
  }
  function l() {
    return !!o();
  }
  function c() {
    return a;
  }
  function p(k) {
    return l() && k.size > c();
  }
  function m(k, b) {
    return b_(n, Rm(k, b));
  }
  function v() {
    return jO(n);
  }
  async function x(k) {
    Iu(n, Rm(k.path, { name: k.name, size: k.size, lastModified: k.lastModified }));
    try {
      await t.jsonFetch(`${o()}/${encodeURIComponent(k.uploadId)}`, { method: "DELETE" });
    } catch {
    }
  }
  async function w(k) {
    return t.jsonFetch(`${o()}/${encodeURIComponent(k)}`);
  }
  async function S(k) {
    var N, J, H;
    const b = Rm(k.path, k.file), C = k.source ?? null, T = C ? C.size : k.file.size, A = C ? null : n, L = {
      id: ul(),
      file: k.file,
      path: k.path,
      totalBytes: T,
      uploadedBytes: 0,
      percent: 0,
      status: "initializing",
      cancel: () => {
      }
    };
    let z = !1, D = null, U;
    L.cancel = () => {
      var ne;
      z = !0, D == null || D.abort(), (ne = C == null ? void 0 : C.cancel) == null || ne.call(C);
    };
    let q = 0;
    function P(ne = 0) {
      var j;
      L.uploadedBytes = Math.min(L.totalBytes, q + ne), L.percent = L.totalBytes > 0 ? Math.min(100, Math.round(L.uploadedBytes / L.totalBytes * 100)) : L.status === "done" ? 100 : 0, (j = k.onProgress) == null || j.call(k, L);
    }
    try {
      if (!l())
        throw w_(new Error("staged upload endpoint not configured"));
      const ne = o();
      let j = "", re = k.chunkSize ?? a, he;
      U = void 0;
      const ue = b_(A, b);
      if (ue)
        try {
          const Q = await w(ue.uploadId);
          qO(Q.state) && (Q.total_size ?? 0) === T ? (j = ue.uploadId, he = Dm(Q.expires_at) ?? ue.expiresAt, re = Q.chunk_size ?? Q.chunkSize ?? ue.chunkSize, q = Q.offset ?? 0, L.resumedFrom = q) : Iu(A, b);
        } catch {
          Iu(A, b);
        }
      if (!j) {
        let Q;
        try {
          Q = await t.jsonFetch(`${ne}/begin`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              path: k.path,
              name: k.file.name,
              size: T,
              mime: k.file.type || "application/octet-stream",
              // Asked for, not imposed: the server clamps this to its own
              // limits and its answer is what the loop below uses.
              chunk_size: k.chunkSize ?? a
            })
          });
        } catch (K) {
          const I = K.status;
          throw (I === 404 || I === 501) && w_(K), K;
        }
        if (!(Q != null && Q.id)) throw new Error("begin returned no upload id");
        j = Q.id, he = Dm(Q.expires_at), re = Q.chunk_size ?? Q.chunkSize ?? re, q = Q.offset ?? 0;
      }
      L.uploadId = j, L.status = "uploading", k_(A, b, {
        uploadId: j,
        path: k.path,
        name: k.file.name,
        size: T,
        lastModified: k.file.lastModified,
        chunkSize: re,
        offset: q,
        expiresAt: he
      }), P();
      const ae = 4;
      for (; q < T; ) {
        if (z) throw new DOMException("Aborted by user", "AbortError");
        const Q = Math.min(q + re, T), K = C ? await C.read(q, Q) : new Blob([await k.file.slice(q, Q).arrayBuffer()]);
        if (z) throw new DOMException("Aborted by user", "AbortError");
        let I = -1, Y = null;
        for (let B = 0; B < ae; B++) {
          if (B > 0) {
            if (await x_(300 * B + Math.floor(Math.random() * 150)), z) throw new DOMException("Aborted by user", "AbortError");
            try {
              const V = await w(j);
              if ((V.offset ?? 0) >= Q) {
                I = V.offset ?? Q;
                break;
              }
              if ((V.offset ?? 0) !== q) {
                q = V.offset ?? q, P(), I = -2;
                break;
              }
            } catch {
            }
          }
          try {
            if (z) throw new DOMException("Aborted by user", "AbortError");
            I = await R(j, K, q, Q, T);
            break;
          } catch (V) {
            const be = V instanceof Error ? V : new Error(String(V));
            if (z || be.name === "AbortError") throw be;
            const Fe = be.status;
            if (Fe && Fe !== 400 && Fe !== 409 && Fe < 500) throw be;
            Y = be;
          }
        }
        if (I !== -2) {
          if (I < 0) throw Y ?? new Error("chunk upload failed");
          if (I <= q)
            throw console.warn("[filex] upload stalled at byte", q), new Error(wl(i())("err.upload_stalled"));
          q = I, U !== void 0 && (he = U), P(), k_(A, b, {
            uploadId: j,
            path: k.path,
            name: k.file.name,
            size: T,
            lastModified: k.file.lastModified,
            chunkSize: re,
            offset: q,
            expiresAt: he
          });
        }
      }
      if (z) throw new DOMException("Aborted by user", "AbortError");
      L.status = "committing", P();
      const fe = new URLSearchParams(k.commitQuery ?? {}).toString(), _ = await t.jsonFetch(
        `${ne}/${encodeURIComponent(j)}/commit${fe ? `?${fe}` : ""}`,
        { method: "POST" }
      );
      return Iu(A, b), L.opId = _ == null ? void 0 : _.op_id, L.nodeId = _ == null ? void 0 : _.node_id, k.waitForTransfer !== !1 && (_ != null && _.op_id) && t.endpoints.opsShow && (L.status = "transferring", P(), await W(_.op_id)), L.status = "done", q = L.totalBytes, P(), (N = k.onDone) == null || N.call(k, L, _), _;
    } catch (ne) {
      const j = ne instanceof Error ? ne : new Error(String(ne));
      if (L.status = j.name === "AbortError" ? "aborted" : "error", L.error = j.message, P(), Yy(j) || (J = C == null ? void 0 : C.cancel) == null || J.call(C), L.uploadId && (L.status === "aborted" || C)) {
        Iu(A, b);
        try {
          await t.jsonFetch(`${o()}/${encodeURIComponent(L.uploadId)}`, {
            method: "DELETE"
          });
        } catch {
        }
      }
      throw (H = k.onError) == null || H.call(k, L, j), j;
    }
    function R(ne, j, re, he, ue) {
      return new Promise((ae, fe) => {
        const _ = new XMLHttpRequest(), Q = 12e4;
        let K, I = 0, Y = 0;
        const B = () => {
          clearTimeout(K), D = null, _.onload = _.onerror = _.onabort = _.onprogress = null, _.upload.onprogress = null;
        }, V = () => {
          clearTimeout(K), K = setTimeout(() => {
            B(), _.abort(), fe(new Error(wl(i())("err.upload_stalled")));
          }, Q);
        };
        D = _, _.open("PUT", `${o()}/${encodeURIComponent(ne)}`);
        const be = t.authHeadersSync({
          "Content-Type": "application/octet-stream",
          "Content-Range": `bytes ${re}-${he - 1}/${ue}`
        });
        for (const [Fe, ze] of Object.entries(be)) _.setRequestHeader(Fe, ze);
        _.withCredentials = t.credentialsMode() === "include", _.upload.onprogress = (Fe) => {
          Fe.loaded > I && (I = Fe.loaded, V()), Fe.lengthComputable && P(Fe.loaded);
        }, _.onprogress = (Fe) => {
          Fe.loaded > Y && (Y = Fe.loaded, V());
        }, _.onload = () => {
          if (B(), Rv(), _.status >= 200 && _.status < 300) {
            try {
              const Fe = JSON.parse(_.responseText);
              U = Dm(Fe.expires_at) ?? U, ae(Fe.offset ?? he);
            } catch {
              ae(he);
            }
            return;
          }
          fe(fa(_.status, _.responseText || "", i()));
        }, _.onerror = () => {
          B(), Dv("action"), fe(Lv(i()));
        }, _.onabort = () => {
          B(), fe(new DOMException("Aborted", "AbortError"));
        }, V();
        try {
          _.send(j);
        } catch (Fe) {
          B(), fe(Fe);
        }
      });
    }
    async function W(ne) {
      const j = t.endpoints.opsShow;
      if (!j) return;
      const re = j.replace("{id}", String(ne));
      let he = 200, ue = 0;
      for (; ; ) {
        if (z) throw new DOMException("Aborted by user", "AbortError");
        try {
          const ae = await t.jsonFetch(re);
          if ((ae == null ? void 0 : ae.status) === "ok") return;
          if ((ae == null ? void 0 : ae.status) === "failed" || (ae == null ? void 0 : ae.status) === "partial")
            throw new __(ae.error || "transfer failed");
          ue = 0;
        } catch (ae) {
          if (ae instanceof __ || ae.name === "AbortError") throw ae;
          if (++ue >= YO) return;
        }
        await x_(he), he = Math.min(he * 2, 2e3);
      }
    }
  }
  return {
    uploadFile: S,
    /** True when this file is big enough (and the endpoints exist) to chunk. */
    shouldChunk: p,
    /** The size at which chunking kicks in. */
    threshold: c,
    resumableFor: m,
    listResumable: v,
    discardResumable: x
  };
}
const YO = 6;
class __ extends Error {
  constructor(t) {
    super(t), this.name = "TransferFailedError";
  }
}
function x_(e) {
  return new Promise((t) => setTimeout(t, e));
}
function S_(e) {
  const t = $(/* @__PURE__ */ new Set()), n = $(null);
  function a(w, S = {}) {
    if (S.shift && n.value) {
      const k = e(), b = k.findIndex((z) => z.path === n.value), C = k.findIndex((z) => z.path === w);
      if (b === -1 || C === -1) {
        t.value = /* @__PURE__ */ new Set([w]), n.value = w;
        return;
      }
      const [T, A] = b < C ? [b, C] : [C, b], L = /* @__PURE__ */ new Set();
      for (let z = T; z <= A; z++) L.add(k[z].path);
      t.value = L;
      return;
    }
    if (S.ctrl) {
      const k = new Set(t.value);
      k.has(w) ? k.delete(w) : k.add(w), t.value = k, n.value = w;
      return;
    }
    t.value = /* @__PURE__ */ new Set([w]), n.value = w;
  }
  function i() {
    t.value = /* @__PURE__ */ new Set(), n.value = null;
  }
  function o() {
    t.value = new Set(e().map((w) => w.path));
  }
  function l(w) {
    return t.value.has(w);
  }
  function c(w) {
    const S = new Set(t.value);
    S.add(w), t.value = S;
  }
  function p(w) {
    const S = new Set(t.value);
    S.delete(w), t.value = S;
  }
  const m = E(() => t.value.size), v = E(() => t.value.size === 0), x = E(() => e().filter((S) => t.value.has(S.path)));
  return { selected: t, anchor: n, click: a, clear: i, selectAll: o, has: l, add: c, remove: p, size: m, isEmpty: v, nodes: x };
}
function dx(e) {
  var n;
  const t = e;
  return !t || typeof t.tagName != "string" ? !1 : t.tagName === "INPUT" || t.tagName === "TEXTAREA" || t.tagName === "SELECT" || t.isContentEditable || ((n = t.getAttribute) == null ? void 0 : n.call(t, "role")) === "textbox" ? !0 : typeof t.closest == "function" && !!t.closest(".monaco-editor");
}
const GO = /* @__PURE__ */ new Set([
  "Ctrl+N",
  "Ctrl+Shift+N",
  "Ctrl+T",
  "Ctrl+Shift+T",
  "Ctrl+W",
  "Ctrl+Shift+W",
  "Ctrl+Tab",
  "Ctrl+Shift+Tab",
  "Ctrl+Q",
  "Ctrl+Shift+I",
  "Ctrl+Shift+J",
  "Ctrl+Shift+C",
  "F11",
  "F12"
]);
function Lpe(e) {
  return GO.has(e);
}
const as = [
  // Navigation
  { id: "palette", defaultCombo: "Ctrl+K", labelKey: "shortcuts.palette", groupKey: "shortcuts.group.nav" },
  { id: "search", defaultCombo: "/", labelKey: "shortcuts.search", groupKey: "shortcuts.group.nav" },
  { id: "go-up", defaultCombo: "Alt+↑", fixedCombos: ["Backspace"], labelKey: "shortcuts.go_up", groupKey: "shortcuts.group.nav" },
  { id: "open", defaultCombo: "Enter", prevent: !1, labelKey: "shortcuts.open", groupKey: "shortcuts.group.nav" },
  { id: "quicklook", defaultCombo: "Space", labelKey: "shortcuts.quicklook", groupKey: "shortcuts.group.nav" },
  { id: "close", defaultCombo: "Esc", customizable: !1, prevent: !1, inForms: !0, labelKey: "shortcuts.close", groupKey: "shortcuts.group.nav" },
  { id: "inspector", defaultCombo: "I", labelKey: "shortcuts.inspector", groupKey: "shortcuts.group.nav" },
  { id: "help", defaultCombo: "?", labelKey: "shortcuts.help", groupKey: "shortcuts.group.nav" },
  { id: "toggle-hidden", defaultCombo: "Ctrl+Shift+.", labelKey: "shortcuts.toggle_hidden", groupKey: "shortcuts.group.nav" },
  /* yildiz:s1 — starring is an action, so it belongs where the other verbs
   * are. A bare letter like the inspector's `I`; the handler ignores events
   * from form controls, so it never eats a keystroke meant for a filename. */
  { id: "star", defaultCombo: "S", labelKey: "shortcuts.star", groupKey: "shortcuts.group.file" },
  // Selection
  { id: "select-all", defaultCombo: "Ctrl+A", labelKey: "shortcuts.select_all", groupKey: "shortcuts.group.selection" },
  // File operations
  { id: "rename", defaultCombo: "F2", labelKey: "shortcuts.rename", groupKey: "shortcuts.group.file" },
  { id: "delete", defaultCombo: "Del", labelKey: "shortcuts.delete", groupKey: "shortcuts.group.file" },
  { id: "cut", defaultCombo: "Ctrl+X", labelKey: "shortcuts.cut", groupKey: "shortcuts.group.file" },
  { id: "copy", defaultCombo: "Ctrl+C", labelKey: "shortcuts.copy", groupKey: "shortcuts.group.file" },
  { id: "paste", defaultCombo: "Ctrl+V", labelKey: "shortcuts.paste", groupKey: "shortcuts.group.file" },
  /* wiring:d1 — tabs. Note: browsers reserve Ctrl+T/W/Tab in normal pages
   * (preventDefault can't stop them there); they work in webcomponent/PWA/
   * kiosk contexts and stay remappable through the settings modal. */
  { id: "tab-new", defaultCombo: "Ctrl+T", labelKey: "shortcuts.tab_new", groupKey: "shortcuts.group.tabs" },
  { id: "tab-close", defaultCombo: "Ctrl+W", labelKey: "shortcuts.tab_close", groupKey: "shortcuts.group.tabs" },
  { id: "tab-next", defaultCombo: "Ctrl+Tab", labelKey: "shortcuts.tab_next", groupKey: "shortcuts.group.tabs" },
  { id: "tab-prev", defaultCombo: "Ctrl+Shift+Tab", labelKey: "shortcuts.tab_prev", groupKey: "shortcuts.group.tabs" },
  /* /wiring:d1 */
  /* tus:t1 — the rest of the menu verbs. Until now these were reachable only
   * by right-clicking, and the right-click menu named no keys at all, so 16 of
   * the registry's actions were invisible unless somebody opened the `?` sheet
   * on their own. The ones with no default are deliberate: they are rare
   * enough that taking a key from the user by default is the wrong trade, and
   * they are in the registry so the user can take one. */
  { id: "new-folder", defaultCombo: "Shift+N", labelKey: "shortcuts.new_folder", groupKey: "shortcuts.group.file" },
  { id: "upload", defaultCombo: "U", labelKey: "shortcuts.upload", groupKey: "shortcuts.group.file" },
  { id: "refresh", defaultCombo: "R", labelKey: "shortcuts.refresh", groupKey: "shortcuts.group.nav" },
  { id: "download", defaultCombo: "D", labelKey: "shortcuts.download", groupKey: "shortcuts.group.file" },
  { id: "preview", defaultCombo: "P", labelKey: "shortcuts.preview", groupKey: "shortcuts.group.nav" },
  { id: "share", defaultCombo: "Shift+S", labelKey: "shortcuts.share", groupKey: "shortcuts.group.file" },
  { id: "tags", defaultCombo: "T", labelKey: "shortcuts.tags", groupKey: "shortcuts.group.file" },
  { id: "open-tab", defaultCombo: "", labelKey: "shortcuts.open_tab", groupKey: "shortcuts.group.tabs" },
  { id: "copy-path", defaultCombo: "", labelKey: "shortcuts.copy_path", groupKey: "shortcuts.group.file" },
  { id: "copy-id", defaultCombo: "", labelKey: "shortcuts.copy_id", groupKey: "shortcuts.group.file" },
  { id: "restore", defaultCombo: "", labelKey: "shortcuts.restore", groupKey: "shortcuts.group.file" }
  /* /tus:t1 */
], XO = {
  palette: "onPathJump",
  search: "onFocusSearch",
  "go-up": "onGoUp",
  open: "onOpen",
  quicklook: "onQuickLook",
  close: "onClose",
  inspector: "onToggleInspector",
  "toggle-hidden": "onToggleHidden",
  star: "onStar",
  help: "onShowHelp",
  "select-all": "onSelectAll",
  rename: "onRename",
  delete: "onDelete",
  cut: "onCut",
  copy: "onCopy",
  paste: "onPaste",
  /* wiring:d1 */
  "tab-new": "onTabNew",
  "tab-close": "onTabClose",
  "tab-next": "onTabNext",
  "tab-prev": "onTabPrev",
  /* tus:t1 */
  "new-folder": "onNewFolder",
  upload: "onUpload",
  refresh: "onRefresh",
  download: "onDownload",
  preview: "onPreview",
  share: "onShare",
  tags: "onTags",
  "open-tab": "onOpenTab",
  "copy-path": "onCopyPath",
  "copy-id": "onCopyId",
  restore: "onRestore"
}, Iv = "filex.shortcuts";
function JO() {
  try {
    const e = localStorage.getItem(Iv);
    if (!e) return {};
    const t = JSON.parse(e);
    if (!t || typeof t != "object") return {};
    const n = {};
    for (const [a, i] of Object.entries(t))
      typeof i == "string" && as.some((o) => o.id === a) && (n[a] = i);
    return n;
  } catch {
    return {};
  }
}
const Vi = $(JO());
function Gy() {
  try {
    Object.keys(Vi.value).length === 0 ? localStorage.removeItem(Iv) : localStorage.setItem(Iv, JSON.stringify(Vi.value));
  } catch {
  }
}
function Xy(e) {
  return as.find((t) => t.id === e);
}
function Dc(e) {
  var n;
  const t = Vi.value[e];
  return t !== void 0 ? t : ((n = Xy(e)) == null ? void 0 : n.defaultCombo) ?? "";
}
function Dpe(e, t) {
  const n = Xy(e);
  if (!n || n.customizable === !1) return;
  const a = { ...Vi.value };
  t === n.defaultCombo ? delete a[e] : a[e] = t, Vi.value = a, Gy();
}
function Rpe(e) {
  if (!(e in Vi.value)) return;
  const t = { ...Vi.value };
  delete t[e], Vi.value = t, Gy();
}
function Ipe() {
  Vi.value = {}, Gy();
}
function Npe(e, t) {
  var n;
  if (!e) return null;
  for (const a of as)
    if (a.id !== t) {
      if ((n = a.fixedCombos) != null && n.includes(e)) return { id: a.id, fixed: !0 };
      if (Dc(a.id) === e) return { id: a.id, fixed: a.customizable === !1 };
    }
  return null;
}
const ZO = {
  " ": "Space",
  Spacebar: "Space",
  Escape: "Esc",
  Delete: "Del",
  ArrowUp: "↑",
  ArrowDown: "↓",
  ArrowLeft: "←",
  ArrowRight: "→",
  PageUp: "PgUp",
  PageDown: "PgDn"
}, QO = /* @__PURE__ */ new Set(["Control", "Alt", "Shift", "Meta", "AltGraph", "CapsLock", "NumLock", "ScrollLock", "Fn", "Dead"]);
function e3(e) {
  const t = e.key;
  if (!t || QO.has(t)) return null;
  const n = ZO[t];
  return n || (t.length === 1 ? t.toUpperCase() : t);
}
function fx(e) {
  const t = e3(e);
  if (!t) return null;
  const n = [];
  (e.ctrlKey || e.metaKey) && n.push("Ctrl"), e.altKey && n.push("Alt");
  const a = t.length === 1 && t.toUpperCase() === t.toLowerCase();
  return e.shiftKey && !a && n.push("Shift"), n.push(t), n.join("+");
}
function t3() {
  return E(
    () => as.map((e) => {
      const t = Dc(e.id), n = e.fixedCombos ?? [];
      return {
        id: e.id,
        combo: t,
        fixedCombos: n,
        keys: [t, ...n].filter((a) => !!a),
        labelKey: e.labelKey,
        groupKey: e.groupKey,
        customizable: e.customizable !== !1,
        overridden: Vi.value[e.id] !== void 0
      };
    })
  );
}
function n3() {
  return typeof navigator < "u" && /mac|iphone|ipad|ipod/i.test(navigator.platform || navigator.userAgent || "");
}
function a3(e) {
  return e ? n3() ? e.replace(/\bCtrl\b/g, "⌘") : e : "";
}
const i3 = {
  open: "open",
  "open-tab": "open-tab",
  preview: "preview",
  download: "download",
  access: "share",
  details: "inspector",
  "copy-id": "copy-id",
  "copy-path": "copy-path",
  rename: "rename",
  cut: "cut",
  copy: "copy",
  paste: "paste",
  star: "star",
  tags: "tags",
  delete: "delete",
  restore: "restore",
  "new-folder": "new-folder",
  "toggle-hidden": "toggle-hidden",
  upload: "upload",
  refresh: "refresh"
};
function px(e) {
  const t = i3[e] ?? e;
  return as.some((n) => n.id === t) ? Jy(t) : "";
}
function Jy(e) {
  return a3(Dc(e));
}
function hx(e, t) {
  var i, o;
  const n = Dc(t);
  if (!n) return !1;
  const a = fx(e);
  return a === n ? !0 : ((o = (i = Xy(t)) == null ? void 0 : i.fixedCombos) == null ? void 0 : o.includes(a ?? "")) ?? !1;
}
as.map((e) => ({
  keys: [e.defaultCombo, ...e.fixedCombos ?? []].filter((t) => !!t),
  labelKey: e.labelKey,
  groupKey: e.groupKey
}));
function o3(e, t) {
  const n = E(() => {
    const i = /* @__PURE__ */ new Map();
    for (const o of as) {
      const l = Dc(o.id);
      l && i.set(l, o);
    }
    return i;
  });
  function a(i) {
    var x;
    if (!e.value || i.key !== "Escape" && document.querySelector(".fe-ctx-backdrop")) return;
    const l = i.target, c = dx(l), p = fx(i);
    if (!p) return;
    if (p === "Backspace") {
      if (c) return;
      (x = t.hasSelection) != null && x.call(t) && t.onDelete ? (i.preventDefault(), t.onDelete()) : t.onGoUp && (i.preventDefault(), t.onGoUp());
      return;
    }
    const m = n.value.get(p);
    if (!m || c && !m.inForms || p === "Space" && l && typeof l.closest == "function" && l.closest('button, a, select, summary, [role="button"], [role="menuitem"]'))
      return;
    const v = t[XO[m.id]];
    v && (m.prevent !== !1 && i.preventDefault(), v());
  }
  jt(() => window.addEventListener("keydown", a)), Tt(() => window.removeEventListener("keydown", a));
}
function Il() {
  let e;
  try {
    e = typeof window < "u" && typeof window.matchMedia == "function" ? window.matchMedia("(prefers-color-scheme: dark)") : void 0;
  } catch {
    e = void 0;
  }
  const t = $(!!(e != null && e.matches)), n = (a) => {
    t.value = a.matches;
  };
  return jt(() => {
    var a;
    return (a = e == null ? void 0 : e.addEventListener) == null ? void 0 : a.call(e, "change", n);
  }), Tt(() => {
    var a;
    return (a = e == null ? void 0 : e.removeEventListener) == null ? void 0 : a.call(e, "change", n);
  }), t;
}
const r3 = "apps";
function s3(e) {
  const t = `${r3}/${encodeURIComponent(e.plugin)}/${encodeURIComponent(e.view)}`;
  return e.path ? `${t}?path=${encodeURIComponent(e.path)}` : t;
}
function mx(e, t) {
  return `${String(e ?? "").replace(/\/+$/, "")}/${s3(t)}`;
}
function tp(e) {
  return e === "page";
}
function Pp(e) {
  if (!e || typeof e != "object") return !1;
  const t = e;
  return typeof t.path == "string" && t.path.trim() !== "";
}
function l3(e) {
  const t = String(e ?? "").indexOf("://");
  if (t <= 0) return "";
  const n = e.slice(0, t), a = e.slice(t + 3).replace(/^\/+/, ""), i = a.lastIndexOf("/"), o = i > 0 ? a.slice(0, i) : "";
  return o ? `${n}/${o}` : n;
}
function $_(e, t) {
  var o;
  if (!Pp(e) || !t.plugin) return { href: "", newTab: !1 };
  const n = String(t.base ?? "").replace(/\/+$/, "");
  if (e.view && tp((o = t.placementOf) == null ? void 0 : o.call(t, e.view)))
    return { href: mx(n, { plugin: t.plugin, view: e.view, path: e.path }), newTab: !0 };
  const a = [`select=${encodeURIComponent(e.path)}`, `app=${encodeURIComponent(t.plugin)}`];
  e.action ? a.push(`appAction=${encodeURIComponent(e.action)}`) : e.view && a.push(`appView=${encodeURIComponent(e.view)}`);
  const i = l3(e.path);
  return { href: `${n}/explore?${a.join("&")}${i ? `#${i}` : ""}`, newTab: !1 };
}
const u3 = 2e3, c3 = 8e3;
function T_(e) {
  const t = (...m) => {
    for (const v of m) if (typeof v == "number") return v;
    return 0;
  }, n = (...m) => {
    for (const v of m) if (typeof v == "string" && v !== "") return v;
    return null;
  }, a = String(e.status ?? "pending"), i = a === "ok" || a === "done" ? "done" : a === "failed" || a === "partial" || a === "error" ? "error" : a === "cancelled" ? "cancelled" : a === "cancelling" ? "cancelling" : a === "running" ? "running" : "pending", o = Array.isArray(e.sources) ? e.sources : [], l = n(e.op_type, e.kind) ?? "delete", c = Array.isArray(e.outputs) ? e.outputs.map((m) => m && typeof m == "object" ? n(m.path) : null).filter((m) => m !== null).map((m) => ({ path: m })) : void 0;
  let p;
  if (Pp(e.open)) {
    const m = n(e.open.action), v = n(e.open.view);
    p = { path: e.open.path, ...m ? { action: m } : {}, ...v ? { view: v } : {} };
  }
  return {
    id: t(e.id),
    op_type: l === "plugin-action" ? "plugin" : l,
    status: i,
    progress_total: t(e.progress_total, e.total, o.length),
    progress_done: t(e.progress_done, e.done),
    bytes_total: t(e.bytes_total),
    bytes_done: t(e.bytes_done),
    objects_total: t(e.objects_total),
    objects_done: t(e.objects_done),
    target_path: n(e.target_path, e.dest),
    source_dir: n(e.source_dir),
    source_count: t(e.source_count, o.length),
    error_message: n(e.error_message, e.error),
    error_code: n(e.error_code) ?? void 0,
    error_engine: n(e.error_engine) ?? void 0,
    error_text: n(e.error_text) ?? void 0,
    cancellable: e.cancellable === !0,
    started_at: n(e.started_at),
    finished_at: n(e.finished_at),
    created_at: n(e.created_at),
    plugin: n(e.plugin) ?? void 0,
    action: n(e.action) ?? void 0,
    label: n(e.label) ?? void 0,
    message: n(e.message) ?? void 0,
    summary: n(e.summary) ?? void 0,
    wait_text: n(e.wait_text) ?? void 0,
    outputs: c,
    ...p ? { open: p } : {}
  };
}
function vx(e, t, n = {}) {
  const a = $([]), i = /* @__PURE__ */ new Set(), o = /* @__PURE__ */ new Set(), l = /* @__PURE__ */ new Map();
  let c = !1;
  const p = E(
    () => a.value.some((b) => b.status === "pending" || b.status === "running" || b.status === "cancelling")
  );
  let m;
  function v() {
    m || t.endpoints.opsList && (m = setInterval(() => {
      w();
    }, u3), w());
  }
  function x() {
    m && (clearInterval(m), m = void 0);
  }
  async function w() {
    var b;
    if (t.endpoints.opsList)
      try {
        const T = ((await t.jsonFetch(t.withScreenLang(t.endpoints.opsList))).ops || []).map(T_);
        for (const R of T)
          (R.status === "done" || R.status === "error" || R.status === "cancelled") && !i.has(R.id) && (i.add(R.id), l.set(R.id, Date.now()), o.delete(R.id) && ((b = n.onSettled) == null || b.call(n, R)));
        const A = new Set(a.value.map((R) => R.id)), L = T.filter((R) => R.status === "pending" || R.status === "running" || R.status === "cancelling" ? !0 : c ? A.has(R.id) : !1), z = new Set(L.map((R) => R.id)), D = a.value.filter((R) => !z.has(R.id)), U = [...L, ...D];
        c = !0;
        const q = Date.now(), P = U.filter((R) => {
          if (R.status === "pending" || R.status === "running" || R.status === "cancelling") return !0;
          const W = l.get(R.id);
          return W !== void 0 && q - W < c3;
        });
        a.value = P, !p.value && P.length === 0 && x();
      } catch (C) {
        console.warn("[usePendingOps] poll failed:", C);
      }
  }
  function S(b) {
    const C = T_(b);
    i.has(C.id) || o.add(C.id), a.value.some((A) => A.id === C.id) || (a.value = [C, ...a.value]), v();
  }
  function k(b) {
    a.value = a.value.filter((C) => C.id !== b), l.delete(b);
  }
  return Tt(() => {
    x();
  }), {
    ops: a,
    hasActive: p,
    register: S,
    dismiss: k,
    poll: w,
    startPolling: v,
    stopPolling: x
  };
}
function Qu(e) {
  return e === "folder" || e === "vault" || e === "file";
}
function Zy(e) {
  return e ? e.e2e === !0 || e.encrypted === "folder" || e.encrypted === "vault" || typeof e.e2e_root == "string" && e.e2e_root !== "" : !1;
}
function yx(e) {
  return e ? Zy(e) || e.encrypted === "file" : !1;
}
function gx(e, t) {
  if (!t || !Array.isArray(e.app_state)) return [];
  const n = `${t}:`;
  return e.app_state.filter((a) => typeof a == "string" && a.startsWith(n)).map((a) => a.slice(n.length));
}
function Qy(e, t) {
  let n = String(e.extension ?? "").toLowerCase();
  if (!n && e.basename) {
    const a = e.basename.lastIndexOf(".");
    a > 0 && (n = e.basename.slice(a + 1).toLowerCase());
  }
  return {
    kind: e.type === "dir" ? "dir" : "file",
    ext: n,
    mime: e.mime_type ?? "",
    state: gx(e, t)
  };
}
function d3(e, t) {
  return e === t ? !0 : e.endsWith("/*") ? t.startsWith(e.slice(0, -1)) : !1;
}
function eg(e, t) {
  const n = e ?? {}, a = t.length;
  if (a === 0 || a > 1 && !n.multi) return !1;
  const i = n.min ?? 0, o = n.max ?? 0;
  if (i > 0 && a < i || o > 0 && a > o) return !1;
  const l = n.kind || "file", c = (n.ext ?? []).map((x) => x.toLowerCase()), p = (n.mime ?? []).map((x) => x.toLowerCase()), m = n.state ?? [], v = n.no_state ?? [];
  for (const x of t) {
    if (l !== "any" && l !== x.kind) return !1;
    const w = x.state ?? [];
    if (m.length > 0 && !m.some((b) => w.includes(b)) || v.some((b) => w.includes(b))) return !1;
    if (c.length === 0 && p.length === 0) continue;
    const S = String(x.ext ?? "").toLowerCase();
    let k = c.includes(S);
    if (!k) {
      const b = String(x.mime ?? "").toLowerCase();
      k = p.some((C) => d3(C, b));
    }
    if (!k) return !1;
  }
  return !0;
}
function tg(e, t, n) {
  return eg(e, t.map((a) => Qy(a, n)));
}
function Xt(e, t) {
  if (!e) return "";
  if (typeof e == "string") return e;
  const n = String(t || "en").toLowerCase().split("-")[0], a = e[n];
  if (typeof a == "string" && a !== "") return a;
  const i = e.en;
  if (typeof i == "string" && i !== "") return i;
  for (const o of Object.values(e))
    if (typeof o == "string" && o !== "") return o;
  return "";
}
function f3(e, t) {
  if (!e) return "";
  if (typeof e == "string") return e;
  const n = String(t || "en").toLowerCase().split("-")[0], a = e[n];
  return typeof a == "string" && a !== "" ? a : "";
}
function ng(e, t, n) {
  const a = f3(e, t);
  if (a) return a;
  const i = n();
  return i || Xt(e, t);
}
function p3(e, t) {
  switch (e.kind) {
    case "engine":
      return t("plugin.needs_engine", { name: e.name });
    case "office":
      return t("plugin.needs_office", { name: e.name });
  }
  return t("plugin.needs_other", { name: e.name });
}
function ag(e) {
  return e.key || `plugin:${e.plugin}/${e.id}`;
}
function h3(e) {
  return e.startsWith("plugin:");
}
function m3(e) {
  var t;
  return e.output_mode === "sibling" || e.output_mode === "version" || ((t = e.applies) == null ? void 0 : t.writable) === !0;
}
function v3(e) {
  return e.read_only_ok === !1;
}
const Im = { none: 0, viewer: 1, editor: 2, owner: 3 };
function y3(e) {
  return e.min_role === "owner" ? "owner" : e.min_role === "editor" || m3(e) ? "editor" : "viewer";
}
function g3(e, t, n) {
  var i;
  if ((i = t.lock) != null && i.plugin && t.lock.plugin === e.plugin) return !0;
  const a = n(t);
  return a === void 0 || !(a in Im) ? !0 : Im[a] >= Im[y3(e)];
}
function bx(e, t) {
  return t.length === 0 ? [] : e.filter((n) => tg(n.applies, t, n.plugin));
}
function b3(e, t, n) {
  var w;
  if (n.trash || n.e2e) return [];
  if (t.some((S) => yx(S) || S.mime_type === "inode/storage")) return [];
  const a = n.permOf, i = (S) => !(n.readOnly && v3(S)) && (!a || t.every((k) => g3(S, k, a))), o = bx(e, t).filter(i), l = /* @__PURE__ */ new Map();
  if (n.needWords)
    for (const S of e) {
      if (o.includes(S) || !((w = S.gated) != null && w.length) || !i(S)) continue;
      const k = S.gated.find(
        (b) => tg({ ...S.applies, ext: b.ext ?? [], mime: [] }, t, S.plugin)
      );
      k && l.set(S, n.needWords(k.needs));
    }
  const c = e.filter((S) => o.includes(S) || l.has(S));
  if (c.length === 0) return [];
  const p = n.hasIcon ?? (() => !1), m = /* @__PURE__ */ new Map();
  for (const S of c) {
    const k = m.get(S.plugin);
    k ? k.push(S) : m.set(S.plugin, [S]);
  }
  const v = [];
  let x = !0;
  for (const [S, k] of m) {
    v.push({ divider: !0, key: x ? "sep-plugins" : `sep-plugin:${S}`, label: "" }), x = !1;
    for (const b of k) {
      const C = l.get(b);
      v.push({
        key: ag(b),
        label: Xt(b.label, n.locale),
        icon: b.icon && p(b.icon) ? b.icon : "plugin",
        danger: b.danger === !0,
        ...C ? { disabled: !0, title: C } : {}
      });
    }
  }
  return v;
}
const k3 = 5 * 60 * 1e3, Nv = /* @__PURE__ */ new Map();
function w3() {
  Nv.clear();
}
function _3(e) {
  let t = Nv.get(e);
  return t || (t = { at: 0, data: $({ actions: [], views: [] }), inflight: null }, Nv.set(e, t)), t;
}
function x3(e, t) {
  const n = e.endpoints.pluginActions ?? "", a = _3(n || "(none)"), i = $(!1), o = $(null), l = E(() => t() && n !== ""), c = E(() => l.value ? a.data.value.actions : []), p = E(() => l.value ? a.data.value.views : []), m = E(() => l.value ? a.data.value.open_rules ?? {} : {});
  async function v(k = !1) {
    return l.value ? a.at > 0 && Date.now() - a.at < k3 && !k ? (i.value = !0, a.data.value) : (a.inflight || (a.inflight = e.pluginActions().then((C) => (a.data.value = { actions: C.actions ?? [], views: C.views ?? [], open_rules: C.open_rules ?? {} }, a.at = Date.now(), o.value = null, a.data.value)).catch((C) => (o.value = String((C == null ? void 0 : C.message) ?? C), a.data.value)).finally(() => {
      a.inflight = null, i.value = !0;
    })), a.inflight) : { actions: [], views: [] };
  }
  Je(
    l,
    (k) => {
      k && v();
    },
    { immediate: !0 }
  );
  function x(k) {
    return bx(c.value, k);
  }
  function w(k) {
    return c.value.find((b) => ag(b) === k);
  }
  function S(k, b, C) {
    return e.pluginActionRun(k.plugin, k.id, {
      paths: b.map((T) => T.path),
      params: C
    });
  }
  return { enabled: l, actions: c, views: p, openRules: m, loaded: i, error: o, refresh: v, actionsFor: x, byKey: w, run: S };
}
const S3 = 25e3, $3 = 15e3, T3 = 6;
class A3 {
  constructor(t) {
    It(this, "ws", null);
    It(this, "opts");
    It(this, "closed", !1);
    It(this, "connecting", !1);
    It(this, "retries", 0);
    It(this, "fallback", !1);
    It(this, "pingTimer", null);
    It(this, "reconnectTimer", null);
    // Last-known intent, replayed on (re)connect.
    It(this, "currentPath", null);
    It(this, "currentFocus", null);
    this.opts = t, this.connect();
  }
  /** Subscribe to a folder ("<adapter>://<dir>"). Swaps the active room and
   *  resets focus. Passing null unsubscribes (drive list / trash have no room). */
  subscribe(t) {
    this.currentPath = t, this.currentFocus = null, t && this.send({ type: "subscribe", path: t });
  }
  /** Report the file the user is focused on (or null to clear). */
  setFocus(t) {
    this.currentFocus = t, this.send({ type: "focus", file: t });
  }
  /** Tear down permanently — call on unmount. */
  close() {
    this.closed = !0, this.clearTimers(), this.dropSocket();
  }
  async connect() {
    if (this.closed || this.connecting || this.ws) return;
    this.connecting = !0;
    let t = null;
    try {
      t = await this.opts.getTicket();
    } catch {
      t = null;
    }
    if (this.connecting = !1, this.closed) return;
    if (!t || !t.ticket || !t.ws_url) {
      this.fail();
      return;
    }
    const n = t.ws_url.includes("?") ? "&" : "?";
    let a;
    try {
      a = new WebSocket(`${t.ws_url}${n}ticket=${encodeURIComponent(t.ticket)}`);
    } catch {
      this.fail();
      return;
    }
    this.ws = a, a.onopen = () => {
      var i, o;
      this.retries = 0, this.setFallback(!1), (o = (i = this.opts.handlers).onStatus) == null || o.call(i, !0), this.currentPath && this.send({ type: "subscribe", path: this.currentPath }), this.currentFocus !== null && this.send({ type: "focus", file: this.currentFocus }), this.startPing();
    }, a.onmessage = (i) => {
      var c, p, m, v, x, w, S, k, b, C;
      let o;
      try {
        o = JSON.parse(typeof i.data == "string" ? i.data : "");
      } catch {
        return;
      }
      const l = o;
      if ((l == null ? void 0 : l.type) === "change") (p = (c = this.opts.handlers).onChange) == null || p.call(c, o);
      else if ((l == null ? void 0 : l.type) === "presence") (v = (m = this.opts.handlers).onPresence) == null || v.call(m, o);
      else if ((l == null ? void 0 : l.type) === "app.updated") {
        const T = o;
        typeof T.app == "string" && typeof T.version == "string" && ((w = (x = this.opts.handlers).onAppUpdated) == null || w.call(x, T));
      } else if ((l == null ? void 0 : l.type) === "vault.generation" || (l == null ? void 0 : l.type) === "vault.lock") {
        const T = o;
        typeof T.path == "string" && ((k = (S = this.opts.handlers).onVault) == null || k.call(S, T));
      } else (l == null ? void 0 : l.type) === "access.changed" && ((C = (b = this.opts.handlers).onAccessChanged) == null || C.call(b, { all: o.scope === "all" }));
    }, a.onerror = () => {
    }, a.onclose = () => {
      var i, o;
      this.stopPing(), this.ws = null, (o = (i = this.opts.handlers).onStatus) == null || o.call(i, !1), this.fail();
    };
  }
  // fail schedules a capped reconnect; after MAX_RETRIES it gives up on the live
  // socket and flips to fallback (polling) mode.
  fail() {
    if (this.closed || this.reconnectTimer) return;
    if (this.retries >= T3) {
      this.setFallback(!0);
      return;
    }
    const t = Math.min(1e3 * 2 ** this.retries, $3);
    this.retries += 1, this.reconnectTimer = setTimeout(() => {
      this.reconnectTimer = null, this.connect();
    }, t);
  }
  setFallback(t) {
    var n, a;
    this.fallback !== t && (this.fallback = t, (a = (n = this.opts.handlers).onFallback) == null || a.call(n, t));
  }
  send(t) {
    const n = this.ws;
    if (!(!n || n.readyState !== WebSocket.OPEN))
      try {
        n.send(JSON.stringify(t));
      } catch {
      }
  }
  startPing() {
    this.stopPing(), this.pingTimer = setInterval(() => this.send({ type: "ping" }), S3);
  }
  stopPing() {
    this.pingTimer && (clearInterval(this.pingTimer), this.pingTimer = null);
  }
  dropSocket() {
    if (this.ws) {
      try {
        this.ws.onclose = null, this.ws.close();
      } catch {
      }
      this.ws = null;
    }
  }
  clearTimers() {
    this.stopPing(), this.reconnectTimer && (clearTimeout(this.reconnectTimer), this.reconnectTimer = null);
  }
}
function E3(e, t) {
  const n = t.now ?? (() => Date.now());
  let a = null, i = null;
  const o = () => {
    const l = n();
    i === null && (i = l);
    const c = i + t.maxWait - l, p = Math.max(0, Math.min(t.wait, c));
    a && clearTimeout(a), a = setTimeout(() => {
      a = null, i = null, e();
    }, p);
  };
  return o.cancel = () => {
    a && clearTimeout(a), a = null, i = null;
  }, o;
}
const Bv = /* @__PURE__ */ new Set();
function C3(e, t) {
  for (const n of [...Bv])
    try {
      n(e, t);
    } catch {
    }
}
function z3(e) {
  return Bv.add(e), () => {
    Bv.delete(e);
  };
}
const M3 = 200, P3 = 2e3, O3 = 12e3;
function L3(e, t) {
  const n = $([]), a = $(!1), i = $(!1);
  let o = null, l = null, c = !1;
  const p = E3(() => t.reload(), {
    wait: M3,
    maxWait: P3
  });
  let m = null;
  function v(T) {
    l && T.path && T.path !== l || (n.value = Array.isArray(T.users) ? T.users : []);
  }
  function x(T) {
    w3(), C3(T.app, T.version);
  }
  function w(T) {
    i.value = T, T ? (n.value = [], m || (m = setInterval(() => t.reload(), O3))) : m && (clearInterval(m), m = null);
  }
  function S() {
    o || (o = new A3({
      getTicket: () => e.wsTicket(),
      handlers: {
        onChange: p,
        onPresence: v,
        onAppUpdated: x,
        onVault: (T) => {
          var A;
          return (A = t.onVault) == null ? void 0 : A.call(t, T);
        },
        onAccessChanged: (T) => {
          var A;
          return (A = t.onAccess) == null ? void 0 : A.call(t, { all: T.all, resync: !1 });
        },
        onFallback: w,
        onStatus: (T) => {
          var A;
          a.value = T, T && c && ((A = t.onAccess) == null || A.call(t, { all: !1, resync: !0 })), T && (c = !0);
        }
      }
    }));
  }
  function k(T) {
    n.value = [], l = T, o == null || o.subscribe(T);
  }
  function b(T) {
    o == null || o.setFocus(T);
  }
  function C() {
    p.cancel(), m && (clearInterval(m), m = null), o == null || o.close(), o = null, c = !1, i.value = !1;
  }
  return { presenceUsers: n, connected: a, degraded: i, start: S, subscribe: k, setFocus: b, stop: C };
}
const D3 = 500;
function R3(e) {
  const t = e.thumb_url;
  if (!t) return null;
  const n = t.indexOf("?");
  if (n === -1) return `${t}||${e.last_modified ?? ""}`;
  const a = new URLSearchParams(t.slice(n + 1)).get("v") ?? "";
  return `${t.slice(0, n)}|${a}|${e.last_modified ?? ""}`;
}
function I3(e, t) {
  const n = WM(/* @__PURE__ */ new Map()), a = [], i = /* @__PURE__ */ new Set(), o = /* @__PURE__ */ new Set(), l = (m) => Ly(e, m);
  function c(m) {
    const v = m.thumb_url, x = R3(m);
    if (!v || !x) return null;
    const w = n.get(x);
    return w || (!i.has(v) && !o.has(x) && p(v, x), null);
  }
  async function p(m, v) {
    o.add(v);
    try {
      const x = await fetch(l(m), {
        headers: await t.authHeaders({ Accept: "*/*" }),
        credentials: t.credentialsMode()
      });
      if (!x.ok) throw new Error(String(x.status));
      const w = await x.blob();
      if (a.length >= D3) {
        const S = a.shift(), k = YM(n), b = S ? k.get(S) : void 0;
        S && b && (URL.revokeObjectURL(b), k.delete(S));
      }
      a.push(v), n.set(v, URL.createObjectURL(w));
    } catch {
      i.add(m);
    } finally {
      o.delete(v);
    }
  }
  return { src: c };
}
let np = null, ap = null, Tf = null, Af = null;
function Op() {
  np || (np = import(
    /* @vite-ignore */
    "monaco-editor"
  ).then((e) => (Tf = e.default ?? e, Tf)).catch(() => (Tf = null, null))), ap || (ap = import(
    /* @vite-ignore */
    "./common-xdTjul80.js"
  ).then((e) => (Af = e.default ?? e, Af)).catch(() => (Af = null, null)));
}
async function N3() {
  return np || Op(), np;
}
async function B3() {
  return ap || Op(), ap;
}
function F3() {
  return Tf;
}
function U3() {
  return Af;
}
function Bpe() {
  return Op(), {
    ensureMonaco: N3,
    ensureHighlight: B3,
    getMonaco: F3,
    getHighlight: U3
  };
}
const H3 = ["title"], K3 = ["src", "alt"], V3 = {
  key: 2,
  class: "fx-presence-dot",
  "aria-hidden": "true"
}, A_ = /* @__PURE__ */ lt({
  __name: "PresenceAvatar",
  props: {
    user: {},
    title: {}
  },
  setup(e) {
    const t = e, n = E(() => {
      const c = (t.user.avatar ?? "").trim();
      return /^(data:image\/|https?:\/\/|\/)/.test(c) ? c : "";
    }), a = $(!1), i = E(() => !!n.value && !a.value), o = E(() => {
      const c = t.user.name.trim().split(/\s+/).filter(Boolean);
      return c.length === 0 ? "?" : c.length === 1 ? c[0].slice(0, 2).toUpperCase() : (c[0][0] + c[c.length - 1][0]).toUpperCase();
    }), l = E(() => {
      const c = t.user.uid ?? String(t.user.id);
      let p = 0;
      for (let m = 0; m < c.length; m++) p = p * 31 + c.charCodeAt(m) >>> 0;
      return p % 360;
    });
    return (c, p) => (f(), h("span", {
      class: Re(["fx-presence-avatar", { "fx-presence-avatar--photo": i.value }]),
      style: Wt({ backgroundColor: `hsl(${l.value} 60% 45%)` }),
      title: e.title
    }, [
      i.value ? (f(), h("img", {
        key: 0,
        class: "fx-presence-photo",
        src: n.value,
        alt: e.user.name,
        onError: p[0] || (p[0] = (m) => a.value = !0)
      }, null, 40, K3)) : (f(), h(Te, { key: 1 }, [
        Ht(y(o.value), 1)
      ], 64)),
      e.user.file ? (f(), h("span", V3)) : O("", !0)
    ], 14, H3));
  }
}), j3 = {
  key: 0,
  class: "fx-presence-chips"
}, q3 = ["title"], W3 = { class: "fx-presence-chip-name" }, Y3 = {
  key: 0,
  class: "fx-presence-chip-file"
}, G3 = ["title"], X3 = {
  key: 0,
  class: "fx-presence-more"
}, J3 = ["title"], Z3 = { class: "fx-presence-file" }, Q3 = ["title", "aria-expanded"], E_ = "filex.presence.expanded", eL = /* @__PURE__ */ lt({
  __name: "PresenceBar",
  props: {
    users: {},
    selfId: {},
    locale: {}
  },
  setup(e) {
    const t = e, { t: n } = pt(() => Wi(t.locale)), a = E(
      () => (t.users ?? []).filter((p) => t.selfId == null || p.id !== t.selfId)
    ), i = $((() => {
      try {
        return localStorage.getItem(E_) === "1";
      } catch {
        return !1;
      }
    })());
    function o() {
      i.value = !i.value;
      try {
        localStorage.setItem(E_, i.value ? "1" : "0");
      } catch {
      }
    }
    function l(p) {
      return p.uid ?? String(p.id);
    }
    function c(p) {
      return p.file ? `${p.name} · ${p.file}` : p.name;
    }
    return (p, m) => a.value.length ? (f(), h("div", {
      key: 0,
      class: Re(["fx-presence", { "fx-presence--wide": i.value }])
    }, [
      i.value ? (f(), h("div", j3, [
        (f(!0), h(Te, null, nt(a.value, (v) => (f(), h("span", {
          key: l(v),
          class: "fx-presence-chip",
          title: c(v)
        }, [
          Ze(A_, { user: v }, null, 8, ["user"]),
          d("span", W3, [
            d("bdi", null, y(v.name), 1)
          ]),
          v.file ? (f(), h("span", Y3, "· " + y(v.file), 1)) : O("", !0)
        ], 8, q3))), 128))
      ])) : (f(), h(Te, { key: 1 }, [
        d("div", {
          class: "fx-presence-avatars",
          title: a.value.map(c).join(", ")
        }, [
          (f(!0), h(Te, null, nt(a.value.slice(0, 5), (v) => (f(), Ge(A_, {
            key: l(v),
            user: v,
            title: c(v)
          }, null, 8, ["user", "title"]))), 128)),
          a.value.length > 5 ? (f(), h("span", X3, "+" + y(a.value.length - 5), 1)) : O("", !0)
        ], 8, G3),
        d("span", {
          class: "fx-presence-text",
          title: a.value.map(c).join(", ")
        }, [
          Ht(y(a.value.length === 1 ? a.value[0].name : u(n)("presence.others", { n: a.value.length })) + " ", 1),
          a.value.length === 1 && a.value[0].file ? (f(), h(Te, { key: 0 }, [
            m[0] || (m[0] = Ht(" · ", -1)),
            d("span", Z3, y(a.value[0].file), 1)
          ], 64)) : O("", !0)
        ], 8, J3)
      ], 64)),
      d("button", {
        type: "button",
        class: "fx-presence-toggle",
        title: i.value ? u(n)("presence.collapse") : u(n)("presence.expand"),
        "aria-expanded": i.value,
        onClick: o
      }, y(i.value ? "‹" : "›"), 9, Q3)
    ], 2)) : O("", !0);
  }
}), tL = '<path d="M4.5 15.5v3A2 2 0 0 0 6.5 20.5h11a2 2 0 0 0 2-2v-3"/>', nL = '<path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12z"/><circle cx="12" cy="12" r="3"/>', C_ = "M12 3.6l2.6 5.3 5.85.85-4.23 4.12 1 5.83L12 16.97l-5.22 2.73 1-5.83L3.55 9.75l5.85-.85z", z_ = '<path d="M8 3.5h8"/><path d="M9.6 3.5v6.1L7.2 12.3v1.7h9.6v-1.7L14.4 9.6V3.5"/><path d="M12 14v6.5"/>', Nm = '<rect x="3.5" y="4.5" width="17" height="15" rx="2"/>', M_ = '<path d="M4 6.5h16"/><path d="M9.5 6.5V4.9a1.4 1.4 0 0 1 1.4-1.4h2.2a1.4 1.4 0 0 1 1.4 1.4v1.6"/><path d="M6.6 6.5l.85 12.1a2 2 0 0 0 2 1.9h5.1a2 2 0 0 0 2-1.9l.85-12.1"/><path d="M10.3 10.3v6.4"/><path d="M13.7 10.3v6.4"/>', P_ = '<path d="M6.8 3.5h10.4a1.6 1.6 0 0 1 1.6 1.6v15.4l-6.8-3.9-6.8 3.9V5.1A1.6 1.6 0 0 1 6.8 3.5z"/>', kx = {
  /* ── opening ─────────────────────────────────────────────────────────── */
  open: '<path d="M14 3.5h6.5V10"/><path d="M20.5 3.5L12 12"/><path d="M18 13.5v5a2 2 0 0 1-2 2H5.5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h5"/>',
  "open-tab": '<rect x="3" y="4.5" width="18" height="15" rx="2"/><path d="M3 9.5h18"/><path d="M9.5 4.5v5"/>',
  preview: nL,
  download: tL + '<path d="M12 4v11.5"/><path d="M7.5 11L12 15.5 16.5 11"/>',
  "archive-create": '<path d="M5 8.5h14v11H5z"/><path d="M4 4h16v4.5H4z"/><path d="M12 11v5"/><path d="M9.5 13.5h5"/>',
  "archive-extract": '<path d="M5 8.5h14v11H5z"/><path d="M4 4h16v4.5H4z"/><path d="M12 10.5v6"/><path d="M9.5 14l2.5 2.5 2.5-2.5"/>',
  upload: '<path d="M4.5 15.5v3A2 2 0 0 0 6.5 20.5h11a2 2 0 0 0 2-2v-3"/><path d="M12 15.5V4"/><path d="M7.5 8.5L12 4l4.5 4.5"/>',
  convert: '<path d="M4 8.5h13"/><path d="M13.5 5L17 8.5 13.5 12"/><path d="M20 15.5H7"/><path d="M10.5 12L7 15.5 10.5 19"/>',
  /* "Paylaş / İzinler" — the three-node share, not a chain link: this row
     opens permissions as well as a link, and people are the subject. */
  access: '<circle cx="17.5" cy="6" r="2.5"/><circle cx="6.5" cy="12" r="2.5"/><circle cx="17.5" cy="18" r="2.5"/><path d="M8.75 10.8l6.5-3.6"/><path d="M8.75 13.2l6.5 3.6"/>',
  details: '<circle cx="12" cy="12" r="8.5"/><path d="M12 11.2v5.6"/><circle cx="12" cy="7.7" r="0.9" fill="currentColor" stroke="none"/>',
  /* ── identity / clipboard ────────────────────────────────────────────── */
  "copy-id": '<rect x="2.5" y="5" width="19" height="14" rx="2.5"/><circle cx="8.5" cy="10.8" r="2"/><path d="M5.3 16.2c.5-1.5 1.75-2.4 3.2-2.4s2.7.9 3.2 2.4"/><path d="M14.8 10h4.2"/><path d="M14.8 13.6h4.2"/>',
  /* A clipboard carrying a path separator — this copies the location, not the
     thing that lives at it. */
  "copy-path": '<path d="M9 4.5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-12a2 2 0 0 0-2-2h-2"/><rect x="9" y="2.8" width="6" height="3.6" rx="1.2"/><path d="M10 11.2l2.4 2.4-2.4 2.4"/>',
  rename: '<path d="M4 20l.9-4.1 11-11a2.05 2.05 0 0 1 2.9 2.9l-11 11z"/><path d="M14 7l3 3"/>',
  cut: '<circle cx="6.5" cy="17.5" r="2.5"/><circle cx="6.5" cy="6.5" r="2.5"/><path d="M8.6 8.3L19 19"/><path d="M8.6 15.7L19 5"/>',
  copy: '<rect x="9" y="9" width="11.5" height="11.5" rx="2"/><path d="M15 6v-.5a2 2 0 0 0-2-2H5.5a2 2 0 0 0-2 2V13a2 2 0 0 0 2 2H6"/>',
  paste: '<path d="M9 4.5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-12a2 2 0 0 0-2-2h-2"/><rect x="9" y="2.8" width="6" height="3.6" rx="1.2"/>',
  /* ── metadata ────────────────────────────────────────────────────────── */
  /* star = "not starred yet, do it" (outline); unstar = the state you are in
     (filled). The renderer picks between them by name, see FileExplorer. */
  star: `<path d="${C_}"/>`,
  unstar: `<path d="${C_}" fill="currentColor"/>`,
  tags: '<path d="M3.5 11.4V5.2a1.7 1.7 0 0 1 1.7-1.7h6.2a1.7 1.7 0 0 1 1.2.5l7.2 7.2a1.7 1.7 0 0 1 0 2.4l-6.2 6.2a1.7 1.7 0 0 1-2.4 0L4 12.6a1.7 1.7 0 0 1-.5-1.2z"/><circle cx="8" cy="8" r="1.3"/>',
  /* ── destructive / recovery ──────────────────────────────────────────── */
  delete: M_,
  "open-trash": M_,
  /* The undo arrow, not a rotating one: "Geri Yükle" puts a thing back where
     it was, and that is the gesture people already read as undo. */
  restore: '<path d="M9 6L5 10l4 4"/><path d="M5 10h9a5 5 0 0 1 0 10h-3.5"/>',
  /* ── folder-level ────────────────────────────────────────────────────── */
  "new-folder": '<path d="M3 7.5a2 2 0 0 1 2-2h4.2a2 2 0 0 1 1.4.6l1.4 1.4H19a2 2 0 0 1 2 2V17a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><path d="M12 11.3v5"/><path d="M9.5 13.8h5"/>',
  /* belge:n1 — a page with a plus: "make me a new document of some type".
     Keyed by the action's own key, so the menu row carries no icon of its
     own and no emoji enters the markup. */
  "new-document": '<path d="M13.5 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h5"/><path d="M13.5 3l5 5"/><path d="M13.5 3v5h5"/><path d="M17.5 14.5v6"/><path d="M14.5 17.5h6"/>',
  refresh: '<path d="M20.5 12a8.5 8.5 0 1 1-2.49-6.01"/><path d="M18 1.5V6h-4.5"/>',
  /* ── desktop sync ("keep on this device") ────────────────────────────── */
  "keep-local": z_,
  "keep-online": '<path d="M7 18.5h10a3.5 3.5 0 0 0 0-7 5 5 0 0 0-9.6-1.2A4.2 4.2 0 0 0 7 18.5z"/>',
  /* Kept because a parent folder is kept — the pin, with the branch it came
     down. The row is disabled; the glyph says why. */
  "keep-inherited": z_ + '<path d="M2.5 20.5h3.6a1.6 1.6 0 0 0 1.6-1.6V17"/>',
  "keep-reveal": '<path d="M2.5 17.5V6.5a2 2 0 0 1 2-2h3.8a2 2 0 0 1 1.4.6l1.4 1.4h4.4a2 2 0 0 1 2 2v1.8"/><path d="M4 19.5h13.4a2 2 0 0 0 1.9-1.37l2-6A1.4 1.4 0 0 0 20 10.3H9.4a2 2 0 0 0-1.9 1.37L5.5 18"/>',
  /* ── view preferences ────────────────────────────────────────────────── */
  "toggle-hidden": '<path d="M3.5 3.5l17 17"/><path d="M9.9 6A9.6 9.6 0 0 1 12 5.5c6 0 9.5 6.5 9.5 6.5a17.3 17.3 0 0 1-3.35 4.15"/><path d="M6.55 7.7A17.4 17.4 0 0 0 2.5 12S6 18.5 12 18.5a9.7 9.7 0 0 0 3.95-.85"/><path d="M10.2 10.3a2.9 2.9 0 0 0 3.9 4.1"/>',
  density: '<path d="M8.5 8L12 4.5 15.5 8"/><path d="M8.5 16L12 19.5 15.5 16"/><path d="M12 4.5v15"/>',
  "view-list": '<path d="M8.5 6.5h12"/><path d="M8.5 12h12"/><path d="M8.5 17.5h12"/><path d="M4 6.5h.01"/><path d="M4 12h.01"/><path d="M4 17.5h.01"/>',
  "view-grid": '<rect x="3.5" y="3.5" width="7" height="7" rx="1.5"/><rect x="13.5" y="3.5" width="7" height="7" rx="1.5"/><rect x="3.5" y="13.5" width="7" height="7" rx="1.5"/><rect x="13.5" y="13.5" width="7" height="7" rx="1.5"/>',
  "view-gallery": '<rect x="3" y="4.5" width="18" height="15" rx="2"/><circle cx="8.3" cy="9.6" r="1.5"/><path d="M4.3 17l4.7-4.7 3 3 3-3 5 4.7"/>',
  nav: Nm + '<path d="M9.5 4.5v15"/>',
  inspector: Nm + '<path d="M14.5 4.5v15"/>',
  /* ── explorer settings ───────────────────────────────────────────────── */
  "shortcut-settings": '<rect x="2.5" y="6" width="19" height="12" rx="2.5"/><path d="M6.5 9.8h.01"/><path d="M10 9.8h.01"/><path d="M13.5 9.8h.01"/><path d="M17 9.8h.01"/><path d="M6.5 12.9h.01"/><path d="M10 12.9h.01"/><path d="M13.5 12.9h.01"/><path d="M17 12.9h.01"/><path d="M8.6 15.6h6.8"/>',
  /* Light/dark as the thing it actually switches: one disc, half of it inked. */
  theme: '<circle cx="12" cy="12" r="8.5"/><path d="M12 3.5a8.5 8.5 0 0 1 0 17z" fill="currentColor" stroke="none"/>',
  /* zaman:z3 — a clock face, for the Time zone row. */
  timezone: '<circle cx="12" cy="12" r="8.5"/><path d="M12 7.2V12l3.2 2"/>',
  /* #275 — a globe, for an embed's Language row. */
  language: '<circle cx="12" cy="12" r="8.5"/><path d="M3.5 12h17"/><path d="M12 3.5c2.3 2.3 3.5 5.1 3.5 8.5s-1.2 6.2-3.5 8.5c-2.3-2.3-3.5-5.1-3.5-8.5s1.2-6.2 3.5-8.5z"/>',
  tour: '<path d="M2.5 9L12 4.5 21.5 9 12 13.5z"/><path d="M6.6 11.1v4.4c0 1.6 2.4 2.9 5.4 2.9s5.4-1.3 5.4-2.9v-4.4"/>',
  /* "Dosya İste" — the public drop link. A chain, because what this makes is
     a URL to hand somebody. */
  "request-files": '<path d="M10.2 13.8a4.2 4.2 0 0 0 6.1 0l2.3-2.3a4.3 4.3 0 0 0-6.1-6.1l-1.35 1.35"/><path d="M13.8 10.2a4.2 4.2 0 0 0-6.1 0l-2.3 2.3a4.3 4.3 0 0 0 6.1 6.1l1.35-1.35"/>',
  /* ── toolbar chrome that is not a ContextAction ──────────────────────── */
  "go-up": '<path d="M12 20V5"/><path d="M5.5 11.5L12 5l6.5 6.5"/>',
  /* #57 — the storage row's order menu (SideNav). One step up or down is a
     SHORT arrow, so it does not read as `go-up`'s "to the parent folder";
     "Sort by name" is the A→Z mark every file manager uses; "Use default order" is
     the refresh circle turning back. All vertical or rotational, so none of
     them is mirrored in a right-to-left interface. */
  "move-up": '<path d="M12 18V7"/><path d="M7.5 11.5L12 7l4.5 4.5"/>',
  "move-down": '<path d="M12 6v11"/><path d="M7.5 12.5L12 17l4.5-4.5"/>',
  "sort-name": '<path d="M3.5 10.5L6.5 3.5l3 7"/><path d="M4.7 8h3.6"/><path d="M4 13.5h5l-5 7h5"/><path d="M17 4v16"/><path d="M13.5 16.5L17 20l3.5-3.5"/>',
  "reset-order": '<path d="M3.5 12a8.5 8.5 0 1 0 2.49-6.01"/><path d="M6 1.5V6h4.5"/>',
  /* === gorunum:v2-topbar — the breadcrumb row's own controls ============
     The crumb trail gained the reference shell's three affordances: a home
     crumb in place of the bare "/" root, a chevron on the last crumb that
     lists what is inside it, and the path editor we already had (its glyph
     moves here from Breadcrumb.vue so every mark in the row comes from one
     file). */
  home: '<path d="M3.5 10.6L12 3.5l8.5 7.1"/><path d="M5.6 9.4V19a1.5 1.5 0 0 0 1.5 1.5h9.8a1.5 1.5 0 0 0 1.5-1.5V9.4"/><path d="M9.9 20.5v-5.2h4.2v5.2"/>',
  subfolders: '<path d="M6.8 9.8L12 15l5.2-5.2"/>',
  "edit-path": '<path d="M4 20h4l10-10a2.1 2.1 0 0 0-3-3L5 17z"/><path d="M14.5 6.5l3 3"/>',
  /* === gorunum:v2-topbar — the header's trailing cluster ================
     The page chrome around the explorer is gone, so the account-level doors
     are drawn by the header itself (the host fills them through the
     `header-actions` slot). The glyphs live here so an embedder's cluster
     comes out the same weight and colour as everything beside it. */
  admin: '<rect x="3" y="3.5" width="7.4" height="7.4" rx="1.6"/><rect x="13.6" y="3.5" width="7.4" height="4.6" rx="1.6"/><rect x="13.6" y="10.7" width="7.4" height="9.8" rx="1.6"/><rect x="3" y="13.6" width="7.4" height="6.9" rx="1.6"/>',
  /* ⚠ A PERSON, not a cog. The first draft drew the gear as a ringed disc with
     eight spokes and at 16px it came out as a SUN — sitting in the very row
     the light/dark toggle had just been removed from, which is the one thing
     the mark must not be mistaken for (measured at 1440 and 390: it read as a
     theme switch in both). The account bust is what the reference hangs this
     menu on, and the tooltip says which settings. */
  account: '<circle cx="12" cy="8.2" r="3.6"/><path d="M4.9 20.3a7.35 7.35 0 0 1 14.2 0"/>',
  "sign-out": '<path d="M9.5 20.5H6a2 2 0 0 1-2-2v-13a2 2 0 0 1 2-2h3.5"/><path d="M15.5 16.5L20 12l-4.5-4.5"/><path d="M20 12H9"/>',
  /* The AI assistant (task #269) - a spark, the mark every assistant in this
     class of product wears; it is the same glyph the "coming soon" button
     wore, so it did not change under people's fingers when it came alive. */
  ai: '<path d="M12 3.2l1.75 4.3 4.3 1.75-4.3 1.75L12 15.3l-1.75-4.3L5.95 9.25l4.3-1.75z"/><path d="M18.2 15.1l.8 1.95 1.95.8-1.95.8-.8 1.95-.8-1.95-1.95-.8 1.95-.8z"/>',
  /* The notification bell, for the host's header cluster (web/src
     NotificationBell.vue). ⚠ Drawn HERE, not taken from the app's icon
     library: it sits in the same row as refresh, the spark and the avatar,
     and a glyph at a foreign stroke weight in that row is the exact mismatch
     this set exists to prevent. A dome on a flared rim, the clapper below. */
  bell: '<path d="M6.2 16.6V11a5.8 5.8 0 0 1 11.6 0v5.6l1.7 1.9H4.5z"/><path d="M10.1 21a2.1 2.1 0 0 0 3.8 0"/>',
  /* === /gorunum:v2-topbar === */
  search: '<circle cx="10.8" cy="10.8" r="6.3"/><path d="M15.4 15.4l5.1 5.1"/>',
  /* gorunum:v1-advsearch — sliders, not a funnel. A funnel says "throw rows
     away"; this control opens a dialog where you SET things, and two of its
     three rows are exactly a slider's job (a size range, a time window). */
  filter: '<path d="M4 7.5h4"/><path d="M13 7.5h7"/><circle cx="10.5" cy="7.5" r="2.4"/><path d="M4 16.5h7"/><path d="M16 16.5h4"/><circle cx="13.5" cy="16.5" r="2.4"/>',
  more: '<circle cx="5.5" cy="12" r="1.2" fill="currentColor" stroke="none"/><circle cx="12" cy="12" r="1.2" fill="currentColor" stroke="none"/><circle cx="18.5" cy="12" r="1.2" fill="currentColor" stroke="none"/>',
  close: '<path d="M5.5 5.5l13 13"/><path d="M18.5 5.5l-13 13"/>',
  /* A share link. Two half-chains, which is what a link IS. The details
     panel's "Not shared / Create link" row used to draw a chain EMOJI
     there, i.e. whatever glyph the OS happened to ship, full-colour,
     beside a column of stroked grey ones. */
  link: '<path d="M10 13.5a4.5 4.5 0 0 0 6.8.5l2.7-2.7a4.5 4.5 0 0 0-6.36-6.36L11.6 6.5"/><path d="M14 10.5a4.5 4.5 0 0 0-6.8-.5l-2.7 2.7a4.5 4.5 0 0 0 6.36 6.36l1.53-1.53"/>',
  /* baglan:b1 — "Connections". A PLUG, deliberately not the chain above:
     the empty screen's account menu draws both rows one under the other
     ("Paylaştıklarım", then "Bağlantılar"), and one mark on two adjacent rows
     is the misreading this set exists to stop. It is also the mark the admin
     panel's own Connections entry already wears (web lib/adminNav.ts, lucide `Cable`),
     so the two ways into the same screen agree on what it looks like. */
  connect: '<path d="M9 8.5V3"/><path d="M15 8.5V3"/><path d="M6 8.5h12v4.5a4.5 4.5 0 0 1-4.5 4.5h-3A4.5 4.5 0 0 1 6 13z"/><path d="M12 17.5V21"/>',
  /* === ikon:emoji — the command palette's own rows =======================
   * The palette printed `{{ it.icon }}` as TEXT: `➜ 📁 ⬆ ▦ 🗑 ⟳ ↑ 🎨 ⌨ 🎓 ⧉ ◫
   * 💾 🔖`. Thirteen marks from four different type families, in a list whose
   * neighbours — the context menu it duplicates and the toolbar it launches —
   * had already moved here. Most of the keys it needed were drawn already
   * (`tour` is the mortarboard, `shortcut-settings` the keyboard, the three
   * `view-*` the mode chips); these six are what was genuinely missing. */
  /* "Go to path" — the arrow goes INTO the box, the mirror of `sign-out`.
     A bare arrow would have said "next", which this row is not. */
  goto: '<path d="M13.5 4.5h4a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2h-4"/><path d="M10 8.2L13.8 12 10 15.8"/><path d="M4.5 12h9.3"/>',
  /* A second pane opened beside the first — `nav`/`inspector`'s panel with the
     divider down the middle, because that is literally what split view is. */
  split: Nm + '<path d="M12 4.5v15"/>',
  /* A new tab: `open-tab`'s window, with the plus in the body rather than on
     the tab strip (at 16px a plus up there merges into the tab). */
  "tab-new": '<rect x="3" y="4.5" width="18" height="15" rx="2"/><path d="M3 9.5h18"/><path d="M9.5 4.5v5"/><path d="M12 12.1v5"/><path d="M9.5 14.6h5"/>',
  bookmark: P_,
  "save-search": P_ + '<path d="M12 7.2v5.2"/><path d="M9.4 9.8h5.2"/>',
  /* The padlock, for the rows and strips that talk ABOUT encryption ("create
     an encrypted folder", "this one is unlocked"). The listing marker is a
     different drawing on purpose — there the lock is cut out of the folder,
     because the row still has to read as a folder. */
  lock: '<rect x="4.5" y="10.3" width="15" height="10.2" rx="2.2"/><path d="M7.9 10.3V7.6a4.1 4.1 0 0 1 8.2 0v2.7"/><circle cx="12" cy="15.4" r="1.5"/>',
  /* === ikon:emoji — states the viewers and modals report ================
   * `✓ ✗ ⚠️ ⏳` in the viewer chrome. The first two are typographic and came
   * out at whatever weight the UI font had; the last two are colour emoji, so
   * a fallback screen's 48px mark was the only full-colour thing on a grey
   * page. `progress` is drawn as an open ring because it is SPUN by CSS
   * (`@keyframes fe-spin`) — an hourglass cannot say "still going". */
  /* An app plugin's row when its manifest names no glyph this set draws: a
     puzzle piece, the mark every extension surface already wears. Rows whose
     manifest icon IS a key here (`convert`, `lock`, …) get that glyph instead
     — lib/pluginMenu decides, this only draws. */
  plugin: '<path d="M9.5 4.5a2 2 0 1 1 4 0h3a1.5 1.5 0 0 1 1.5 1.5v3a2 2 0 1 1 0 4v3a1.5 1.5 0 0 1-1.5 1.5h-3a2 2 0 1 1-4 0h-3A1.5 1.5 0 0 1 5 16v-3a2 2 0 1 1 0-4V6a1.5 1.5 0 0 1 1.5-1.5z"/>',
  /* A pen signing on a line — the e-signature app's own icon (manifest
     `icon: "sign"`). ⚠ Drawn here because a key the catalogue does not know
     falls back to the generic plugin piece: the sidebar and every menu showed
     the Signatures app as "some app" until it was (2026-09-21, a tester). */
  sign: '<path d="M12.5 20.5h8"/><path d="M16.2 3.9a2.05 2.05 0 0 1 2.9 2.9L8 17.9l-3.9 1 1-3.9z"/><path d="M14.6 5.5l2.9 2.9"/>',
  check: '<path d="M4.8 12.6l4.7 4.7L19.2 6.9"/>',
  alert: '<path d="M10.7 4.6L2.9 18.2a1.5 1.5 0 0 0 1.3 2.25h15.6a1.5 1.5 0 0 0 1.3-2.25L13.3 4.6a1.5 1.5 0 0 0-2.6 0z"/><path d="M12 9.9v4.3"/><circle cx="12" cy="17.4" r="0.9" fill="currentColor" stroke="none"/>',
  progress: '<path d="M20.5 12a8.5 8.5 0 1 1-8.5-8.5"/>'
}, aL = /* @__PURE__ */ new Set(["restore", "goto", "sign-out", "copy-path", "nav", "inspector"]), O_ = /* @__PURE__ */ new Map();
function zt(e) {
  if (!e) return "";
  const t = O_.get(e);
  if (t !== void 0) return t;
  const n = kx[e], a = n ? `<svg class="${aL.has(e) ? "fe-aicon fe-aicon--dir" : "fe-aicon"}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">${n}</svg>` : "";
  return O_.set(e, a), a;
}
function Fpe() {
  return Object.keys(kx);
}
const iL = "__fe-ctx-late";
function Fv(e) {
  const t = [];
  for (const n of e)
    n.hidden || n.divider && (t.length === 0 || t[t.length - 1].divider) || t.push(n);
  for (; t.length > 0 && t[t.length - 1].divider; ) t.pop();
  return t;
}
function oL(e, t) {
  const n = /* @__PURE__ */ new Map();
  for (const c of Fv(t))
    !c.divider && !n.has(c.key) && n.set(c.key, c);
  const a = /* @__PURE__ */ new Set(), i = e.map((c) => c.divider ? c : (a.add(c.key), n.get(c.key) ?? { ...c, disabled: !0 })), o = [...n.values()].filter((c) => !a.has(c.key));
  if (!o.length) return i;
  const l = { key: iL, label: "", divider: !0 };
  return [...i, l, ...o];
}
const ig = 80;
function Rc(e, t = ig) {
  var i;
  if (typeof window > "u" || typeof document > "u") return t;
  const n = Array.isArray(e) ? e : [e];
  let a = t;
  for (const o of n) {
    let l = o ?? null;
    for (let c = 0; l && c < 200 && !(l === document.body || l === document.documentElement); c++) {
      let p = Number.NaN, m = !1;
      try {
        const v = window.getComputedStyle(l);
        m = (v.position || "static") !== "static", p = Number.parseInt(v.zIndex, 10);
      } catch {
      }
      m && Number.isFinite(p) && p + 1 > a && (a = p + 1), l = l.parentElement ?? /* Out the top of a shadow tree, if the host put us in one. */
      ((i = l.getRootNode()) == null ? void 0 : i.host) ?? null;
    }
  }
  return a;
}
function rL(e, t) {
  if (typeof document > "u") return [];
  const n = [document.activeElement];
  if (typeof e == "number" && typeof t == "number" && document.elementFromPoint)
    try {
      n.push(document.elementFromPoint(e, t));
    } catch {
    }
  return n;
}
const sL = ["dir", "data-prefers-dark"], lL = ["aria-label"], uL = ["aria-label", "onKeydown"], cL = { class: "fe-sheet__items" }, dL = {
  key: 0,
  class: "fe-ctx__sep",
  role: "separator"
}, fL = ["disabled", "title", "data-testid", "onClick"], pL = ["innerHTML"], hL = {
  key: 1,
  class: "fe-ctx__icon",
  "aria-hidden": "true"
}, mL = { class: "fe-ctx__label" }, vL = {
  key: 2,
  class: "fe-ctx__key",
  "aria-hidden": "true"
}, yL = ["aria-label"], gL = {
  key: 0,
  class: "fe-ctx__sep",
  role: "separator"
}, bL = ["disabled", "title", "data-testid", "onClick"], kL = ["innerHTML"], wL = {
  key: 1,
  class: "fe-ctx__icon",
  "aria-hidden": "true"
}, _L = { class: "fe-ctx__label" }, xL = {
  key: 2,
  class: "fe-ctx__key",
  "aria-hidden": "true"
}, _l = /* @__PURE__ */ lt({
  __name: "ContextMenu",
  props: {
    locale: {},
    actions: {},
    theme: {},
    sheet: { type: Boolean }
  },
  emits: ["select"],
  setup(e, { expose: t, emit: n }) {
    const a = e, i = n, { t: o, dir: l } = pt(() => a.locale);
    function c(K) {
      return px(K.shortcutId ?? K.key);
    }
    function p(K) {
      return zt(K.icon || K.key);
    }
    const m = $(!1), v = $(0), x = $(0), w = $(ig), S = $([]), k = $(null);
    let b = 0, C = 0, T = null;
    async function A(K, I) {
      var Y, B;
      if (T = document.activeElement ?? null, w.value = Rc(rL(K.clientX, K.clientY)), ae.value = null, j.value = null, m.value = !0, v.value = K.clientX, x.value = K.clientY, b = K.clientX, C = K.clientY, S.value = I, await Gt(), m.value && (ae.value = Fv(a.actions)), a.sheet) {
        const V = (Y = P.value) == null ? void 0 : Y.getBoundingClientRect().height;
        V && (j.value = V), (B = P.value) == null || B.focus();
        return;
      }
      L(), U(0);
    }
    function L() {
      const K = k.value;
      if (!K || typeof window > "u") return;
      K.style.maxHeight = "", K.style.overflowY = "";
      const I = K.getBoundingClientRect(), Y = 8, B = window.innerWidth, V = window.innerHeight, be = V - 2 * Y;
      if (I.height > be) {
        K.style.maxHeight = be + "px", K.style.overflowY = "auto", x.value = Y, v.value = r_(b, I.width, B, l.value, Y);
        return;
      }
      if (C + I.height > V - Y) {
        const Fe = C - I.height;
        x.value = Fe >= Y ? Fe : Math.max(Y, V - I.height - Y);
      }
      v.value = r_(b, I.width, B, l.value, Y);
    }
    function z() {
      var K;
      m.value = !1, ae.value = null, j.value = null, R.value = !1, W.value = 0, (K = T == null ? void 0 : T.focus) == null || K.call(T), T = null;
    }
    function D() {
      const K = a.sheet ? P.value : k.value;
      return K ? Array.from(
        K.querySelectorAll(".fe-ctx__item:not(:disabled)")
      ) : [];
    }
    function U(K) {
      var B;
      const I = D();
      if (I.length === 0) return;
      const Y = (K % I.length + I.length) % I.length;
      (B = I[Y]) == null || B.focus();
    }
    function q(K) {
      const I = D();
      if (I.length === 0) return;
      const Y = document.activeElement, B = Y ? I.indexOf(Y) : -1;
      if (B === -1) {
        U(K > 0 ? 0 : I.length - 1);
        return;
      }
      U(B + K);
    }
    const P = $(null), R = $(!1), W = $(0);
    let N = 0;
    function J(K) {
      const I = K.touches[0];
      I && (R.value = !0, N = I.clientY, W.value = 0);
    }
    function H(K) {
      if (!R.value) return;
      const I = K.touches[0];
      I && (W.value = Math.max(0, I.clientY - N));
    }
    function ne() {
      if (!R.value) return;
      const K = W.value > 72;
      R.value = !1, K ? z() : W.value = 0;
    }
    const j = $(null), re = E(() => {
      const K = {};
      return j.value !== null && (K.height = `${j.value}px`), W.value > 0 && (K.transform = `translateY(${W.value}px)`, K.transition = "none"), Object.keys(K).length ? K : void 0;
    });
    function he(K) {
      K.disabled || (i("select", K, S.value), z());
    }
    function ue(K) {
      if (K.key === "Escape") {
        K.stopPropagation(), z();
        return;
      }
      if (K.key === "Enter" || K.key === " ") {
        K.stopPropagation();
        return;
      }
      K.key === "ArrowDown" ? (K.preventDefault(), K.stopPropagation(), q(1)) : K.key === "ArrowUp" ? (K.preventDefault(), K.stopPropagation(), q(-1)) : K.key === "Home" ? (K.preventDefault(), U(0)) : K.key === "End" ? (K.preventDefault(), U(-1)) : K.key === "Tab" && (K.preventDefault(), z());
    }
    const ae = $(null), fe = E(
      () => ae.value ? oL(ae.value, a.actions) : Fv(a.actions)
    );
    Je(
      () => fe.value.length,
      async () => {
        if (!m.value || !ae.value || a.sheet) return;
        await Gt();
        const K = k.value;
        if (!K || typeof window > "u") return;
        const I = K.getBoundingClientRect(), Y = window.innerHeight - 8 - I.top;
        Y > 0 && I.height > Y && (K.style.maxHeight = Y + "px", K.style.overflowY = "auto");
      }
    );
    const _ = Il(), Q = E(() => `fe-ctx-backdrop--theme-${a.theme || "auto"}`);
    return t({ show: A, hide: z }), (K, I) => (f(), Ge(wi, { to: "body" }, [
      Ze(Rr, {
        name: e.sheet ? "fe-sheet" : "fe-ctx"
      }, {
        default: mt(() => [
          m.value ? (f(), h("div", {
            key: 0,
            class: Re(["fe-ctx-backdrop", [Q.value, { "fe-ctx-backdrop--sheet": e.sheet }]]),
            dir: u(l),
            style: Wt({
              zIndex: w.value
              /* katman:z1 */
            }),
            "data-prefers-dark": u(_) ? "1" : "0",
            onClick: z,
            onContextmenu: yt(z, ["prevent"]),
            onKeydown: ue
          }, [
            e.sheet ? (f(), h("div", {
              key: 0,
              ref_key: "sheetEl",
              ref: P,
              class: "fe-sheet",
              role: "menu",
              "aria-label": u(o)("sheet.menu"),
              tabindex: "-1",
              style: Wt(re.value),
              onClick: I[0] || (I[0] = yt(() => {
              }, ["stop"]))
            }, [
              d("div", {
                class: "fe-sheet__handle",
                role: "button",
                tabindex: "0",
                "aria-label": u(o)("sheet.close"),
                onClick: z,
                onKeydown: Ca(yt(z, ["prevent"]), ["enter"]),
                onTouchstartPassive: J,
                onTouchmovePassive: H,
                onTouchend: ne,
                onTouchcancel: ne
              }, null, 40, uL),
              d("div", cL, [
                (f(!0), h(Te, null, nt(fe.value, (Y, B) => (f(), h(Te, {
                  key: Y.key || B
                }, [
                  Y.divider ? (f(), h("div", dL)) : (f(), h("button", {
                    key: 1,
                    type: "button",
                    class: Re(["fe-ctx__item fe-sheet__item", { "is-danger": Y.danger, "is-disabled": Y.disabled }]),
                    disabled: Y.disabled,
                    title: Y.title,
                    "data-testid": Y.testid,
                    role: "menuitem",
                    onClick: (V) => he(Y)
                  }, [
                    p(Y) ? (f(), h("span", {
                      key: 0,
                      class: "fe-ctx__icon",
                      "aria-hidden": "true",
                      innerHTML: p(Y)
                    }, null, 8, pL)) : Y.icon ? (f(), h("span", hL, y(Y.icon), 1)) : O("", !0),
                    d("span", mL, y(Y.label), 1),
                    c(Y) ? (f(), h("span", vL, y(c(Y)), 1)) : O("", !0)
                  ], 10, fL))
                ], 64))), 128))
              ])
            ], 12, lL)) : (f(), h("div", {
              key: 1,
              ref_key: "menuEl",
              ref: k,
              class: "fe-ctx",
              role: "menu",
              "aria-orientation": "vertical",
              "aria-label": u(o)("sheet.menu"),
              style: Wt({ top: x.value + "px", left: v.value + "px" }),
              onClick: I[1] || (I[1] = yt(() => {
              }, ["stop"]))
            }, [
              (f(!0), h(Te, null, nt(fe.value, (Y, B) => (f(), h(Te, {
                key: Y.key || B
              }, [
                Y.divider ? (f(), h("div", gL)) : (f(), h("button", {
                  key: 1,
                  type: "button",
                  class: Re(["fe-ctx__item", { "is-danger": Y.danger, "is-disabled": Y.disabled }]),
                  disabled: Y.disabled,
                  title: Y.title,
                  "data-testid": Y.testid,
                  role: "menuitem",
                  onClick: (V) => he(Y)
                }, [
                  p(Y) ? (f(), h("span", {
                    key: 0,
                    class: "fe-ctx__icon",
                    "aria-hidden": "true",
                    innerHTML: p(Y)
                  }, null, 8, kL)) : Y.icon ? (f(), h("span", wL, y(Y.icon), 1)) : O("", !0),
                  d("span", _L, y(Y.label), 1),
                  c(Y) ? (f(), h("span", xL, y(c(Y)), 1)) : O("", !0)
                ], 10, bL))
              ], 64))), 128))
            ], 12, yL))
          ], 46, sL)) : O("", !0)
        ]),
        _: 1
      }, 8, ["name"])
    ]));
  }
}), SL = ["aria-pressed", "title", "aria-label"], $L = {
  key: 1,
  class: "fe-toolbar__mark"
}, TL = ["src"], AL = { key: 1 }, EL = { class: "fe-toolbar__primary" }, CL = ["title"], zL = ["innerHTML"], ML = { class: "fe-btn__label" }, PL = ["title", "aria-label"], OL = ["innerHTML"], LL = ["title"], DL = ["innerHTML"], RL = { class: "fe-btn__label" }, IL = { class: "fe-toolbar__search-group fe-toolbar__search-group--drive" }, NL = {
  class: "fe-search fe-drivesearch",
  "data-testid": "drive-search"
}, BL = ["placeholder", "value", "aria-label"], FL = ["title", "aria-label"], UL = ["innerHTML"], HL = ["title", "aria-label"], KL = { class: "fe-toolbar__tail" }, VL = ["title", "aria-label"], jL = ["innerHTML"], qL = ["title", "aria-label", "aria-pressed"], WL = ["innerHTML"], YL = ["title", "aria-label"], GL = ["innerHTML"], XL = {
  class: "fe-drivesearch",
  "data-testid": "drive-search"
}, JL = ["placeholder", "value", "aria-label"], ZL = ["title", "aria-label"], QL = ["innerHTML"], eD = ["title", "aria-label"], tD = { class: "fe-toolbar__tail" }, nD = ["title", "aria-label", "aria-pressed"], aD = ["innerHTML"], iD = ["title", "aria-label"], oD = ["innerHTML"], rD = ["aria-label"], sD = {
  class: "fe-selbar__count",
  role: "status",
  "data-testid": "selection-count"
}, lD = ["disabled", "title", "aria-label", "data-key", "data-testid", "onClick"], uD = ["innerHTML"], cD = ["title", "aria-label"], dD = ["innerHTML"], fD = ["data-key"], pD = ["innerHTML"], hD = ["title", "aria-label"], mD = ["innerHTML"], uf = "filex.density", vD = 32, L_ = "fe:header-menu", yD = /* @__PURE__ */ lt({
  __name: "Toolbar",
  props: {
    viewMode: {},
    searchQuery: {},
    trashActive: { type: Boolean },
    actions: {},
    selectionMode: {},
    selectionCount: {},
    selectionPane: {},
    pasteEnabled: { type: Boolean },
    canGoUp: { type: Boolean },
    atVirtualRoot: { type: Boolean },
    canWrite: { type: Boolean },
    locale: {},
    languageRow: { type: Boolean },
    narrow: { type: Boolean },
    theme: {},
    inspectorOpen: { type: Boolean },
    assistantButton: { type: Boolean },
    assistantOpen: { type: Boolean },
    navOpen: { type: Boolean },
    navEnabled: { type: Boolean },
    viewModes: {},
    scopeLabel: {},
    brandName: {},
    brandMarkUrl: {},
    searchEscalates: { type: Boolean }
  },
  emits: ["update:viewMode", "update:searchQuery", "open-advanced-search", "new-folder", "upload", "refresh", "go-up", "action", "open-recents", "update:density", "toggle-inspector", "toggle-assistant", "toggle-nav", "open-theme", "open-shortcut-settings", "open-timezone", "open-language", "open-palette"],
  setup(e, { expose: t, emit: n }) {
    function a(te) {
      return zt(te.icon || te.key);
    }
    const i = e, o = n, l = $(
      (() => {
        try {
          return localStorage.getItem(uf) === "compact" ? "compact" : "comfortable";
        } catch {
          return "comfortable";
        }
      })()
    );
    function c() {
      try {
        const te = localStorage.getItem(uf) === "compact" ? "compact" : "comfortable";
        te !== l.value && (l.value = te, o("update:density", te));
      } catch {
      }
    }
    function p(te) {
      (te.key === null || te.key === uf) && c();
    }
    jt(() => {
      o("update:density", l.value), window.addEventListener("storage", p), window.addEventListener("filex:density", c);
    }), Tt(() => {
      window.removeEventListener("storage", p), window.removeEventListener("filex:density", c);
    });
    function m() {
      l.value = l.value === "compact" ? "comfortable" : "compact";
      try {
        localStorage.setItem(uf, l.value);
      } catch {
      }
      o("update:density", l.value);
    }
    const { t: v, dir: x } = pt(() => i.locale), w = $(null), S = $(i.searchQuery);
    Je(() => i.searchQuery, (te) => {
      S.value = te;
    });
    let k;
    function b(te) {
      const Ce = te.target.value;
      S.value = Ce, k && clearTimeout(k), k = setTimeout(() => o("update:searchQuery", Ce), 200);
    }
    async function C() {
      var te, Ce;
      await Gt(), (te = w.value) == null || te.focus(), (Ce = w.value) == null || Ce.select();
    }
    t({ focusSearch: C });
    const T = E(() => i.selectionMode ?? "none"), A = E(() => i.actions.filter((te) => !te.divider && !te.hidden)), L = /* @__PURE__ */ new Set(["download", "access", "cut", "copy", "star", "restore", "delete"]), z = E(() => T.value !== "none"), D = E(() => {
      const te = [], Ce = [];
      let Ne = 0;
      for (const _e of i.actions)
        if (!_e.hidden) {
          if (_e.divider) {
            Ce.push(_e);
            continue;
          }
          L.has(_e.key) && a(_e) ? te.push(_e) : (Ce.push(_e), Ne++);
        }
      return { icons: te, rest: Ne ? Ce : [], restCount: Ne };
    }), U = $(null), q = $(null), P = $(null), R = $(null), W = $(Number.MAX_SAFE_INTEGER), N = E(() => D.value.icons.slice(0, W.value)), J = E(() => D.value.icons.slice(W.value)), H = E(() => {
      const te = J.value, Ce = D.value.rest;
      return te.length && Ce.length ? [...te, { divider: !0, key: "selbar-sep", label: "" }, ...Ce] : [...te, ...Ce];
    });
    function ne() {
      var bn;
      const te = U.value, Ce = q.value, Ne = D.value.icons.length;
      if (!te || !Ce) {
        W.value = Ne;
        return;
      }
      const _e = parseFloat(getComputedStyle(te).gap) || 4, Ae = Array.from(Ce.children).map((un) => un.offsetWidth + _e), Pe = Ae.reduce((un, Jt) => un + Jt, 0), _t = te.clientWidth, Et = (((bn = P.value) == null ? void 0 : bn.offsetWidth) || vD) + _e;
      if (Pe <= _t - (D.value.rest.length ? Et : 0)) {
        W.value = Ae.length;
        return;
      }
      let xn = Et, Dt = 0;
      for (const un of Ae) {
        if (xn + un > _t) break;
        xn += un, Dt += 1;
      }
      W.value = Dt;
    }
    let j;
    Je(U, (te) => {
      j == null || j.disconnect(), j = void 0, te && typeof ResizeObserver < "u" && (j = new ResizeObserver(() => ne()), j.observe(te)), Gt(ne);
    }), Tt(() => j == null ? void 0 : j.disconnect()), Je(
      () => [A.value, i.narrow, i.trashActive, T.value],
      () => void Gt(ne),
      { deep: !1 }
    );
    function re() {
      var Ce, Ne;
      const te = (Ce = P.value) == null ? void 0 : Ce.getBoundingClientRect();
      (Ne = R.value) == null || Ne.show({ clientX: te ? o_(te, x.value) : 0, clientY: te ? te.bottom + 4 : 0 }, []);
    }
    const he = $(null), ue = Ea(null), ae = $(!1), fe = Ea(null), _ = Ea(null);
    function Q() {
      var Ne;
      const te = (Ne = he.value) == null ? void 0 : Ne.closest(".fe");
      if (!te) return null;
      const Ce = i.selectionPane;
      if (Ce && /^[A-Za-z][\w-]*$/.test(Ce)) {
        const _e = te.querySelector(`.fe__primary[data-pane="${Ce}"]`);
        if (_e) return _e;
      }
      return te.querySelector(".fe__primary");
    }
    function K() {
      const te = ue.value;
      te && (te.classList.remove("is-active"), ae.value && te.remove()), ue.value = null, ae.value = !1;
    }
    function I() {
      var Ne;
      const te = Q();
      if (!te) {
        K(), _.value = null, fe.value = null;
        return;
      }
      if (_.value === te && ((Ne = ue.value) != null && Ne.isConnected)) return;
      K(), _.value = te, fe.value = te.querySelector(":scope > .fe__body");
      const Ce = te.querySelector(":scope > .fe-selbar-slot");
      if (Ce)
        ue.value = Ce, ae.value = !1;
      else {
        const _e = document.createElement("div");
        _e.className = "fe-selbar-slot";
        const Ae = te.querySelector(":scope > .fe-tabs") ?? te.querySelector(":scope > .fe-subhead, :scope > .fe-subhead--plain");
        Ae ? Ae.insertAdjacentElement("afterend", _e) : te.prepend(_e), ue.value = _e, ae.value = !0;
      }
      Y(), Ue();
    }
    jt(I), Tt(K);
    function Y() {
      var te;
      (te = ue.value) == null || te.classList.toggle("is-active", z.value);
    }
    Je(z, Y, { immediate: !0 }), Je([() => i.selectionPane, z], () => I());
    const B = $(0);
    let V, be = !1;
    function Fe() {
      const te = _.value;
      te && (B.value = te.querySelectorAll('[data-fe-path][aria-selected="true"]').length);
    }
    function ze() {
      if (be) return;
      be = !0, ((Ce) => typeof requestAnimationFrame == "function" ? requestAnimationFrame(Ce) : setTimeout(Ce, 16))(() => {
        be = !1, Fe();
      });
    }
    function Ue() {
      if (V == null || V.disconnect(), V = void 0, !z.value) {
        B.value = 0;
        return;
      }
      Fe(), !(typeof MutationObserver > "u" || !_.value) && (V = new MutationObserver(ze), V.observe(_.value, {
        subtree: !0,
        childList: !0,
        attributes: !0,
        attributeFilter: ["aria-selected"]
      }));
    }
    Je(z, Ue), Tt(() => V == null ? void 0 : V.disconnect());
    const We = E(() => typeof i.selectionCount == "number" ? i.selectionCount : T.value === "none" ? 0 : Math.max(B.value, T.value === "multi" ? 2 : 1)), $t = E(() => v("selection.count", { n: String(We.value) }));
    function St() {
      var te;
      o("action", "clear-selection"), (te = fe.value) == null || te.dispatchEvent(new MouseEvent("click", { bubbles: !0 }));
    }
    function at(te) {
      o("action", te);
    }
    const kt = $(!1);
    let ht;
    function Ie(te) {
      kt.value = !!(te && "matches" in te && te.matches);
    }
    jt(() => {
      var te;
      typeof window > "u" || !window.matchMedia || (ht = window.matchMedia("(pointer: coarse)"), Ie(ht), (te = ht.addEventListener) == null || te.call(ht, "change", Ie));
    }), Tt(() => {
      var te;
      (te = ht == null ? void 0 : ht.removeEventListener) == null || te.call(ht, "change", Ie);
    });
    const se = $(null), xe = $(null);
    function me(te) {
      return !i.viewModes || i.viewModes.includes(te);
    }
    const De = E(() => {
      const te = [];
      return i.narrow && te.push({ key: "refresh", label: v("toolbar.refresh") }), te.push({
        key: "density",
        label: l.value === "compact" ? v("toolbar.density.comfortable") : v("toolbar.density.compact")
      }), i.viewMode !== "list" && me("list") && te.push({ key: "view-list", label: v("toolbar.view.list") }), i.viewMode !== "grid" && me("grid") && te.push({ key: "view-grid", label: v("toolbar.view.grid") }), i.viewMode !== "gallery" && me("gallery") && te.push({ key: "view-gallery", label: v("toolbar.view.gallery") }), te.push({ key: "inspector", label: v("toolbar.inspector") }), te.push({ key: "theme", label: v("theme.menu") }), te.push({ key: "timezone", label: v("tz.menu") }), i.languageRow && te.push({ key: "language", label: v("lang.menu") }), te.push({ key: "shortcut-settings", label: v("shortcuts.settings.menu") }), te.push({ key: "tour", label: v("tour.restart") }), te;
    });
    function ot(te) {
      const Ce = [], Ne = !i.trashActive && !i.atVirtualRoot && i.canWrite !== !1;
      return T.value === "none" && Ne && (Ce.push({ key: "new-folder", label: v("toolbar.new_folder") }), i.pasteEnabled && Ce.push({ key: "paste", label: v("ctx.paste") })), z.value || Ce.push(...A.value), te.length && (Ce.length && Ce.push({ divider: !0, key: "bag-sep", label: "" }), Ce.push(...te)), Ce;
    }
    const ft = E(() => Jy("palette"));
    function gt(te, Ce) {
      const Ne = px(Ce);
      return Ne ? `${te} (${Ne})` : te;
    }
    const Ut = E(() => i.narrow ? i.navOpen ? v("sidenav.close") : v("sidenav.open") : i.navOpen ? v("sidenav.collapse") : v("sidenav.expand")), Xe = E(
      () => i.scopeLabel ? v("drive.search.placeholder", { scope: i.scopeLabel }) : v("drive.search.placeholder_all")
    );
    function je(te) {
      if (hx(te, "palette")) {
        te.preventDefault(), te.stopPropagation(), o("open-palette", S.value);
        return;
      }
      i.searchEscalates && te.key === "Enter" && S.value && (te.preventDefault(), te.stopPropagation(), o("open-palette", S.value));
    }
    const Be = $(!1);
    function ie() {
      const te = he.value;
      if (!te) return;
      const Ce = {
        items: De.value.map((Ne) => ({ ...Ne })),
        run: (Ne) => ye({ key: Ne }),
        claimed: !1
      };
      te.dispatchEvent(
        new CustomEvent(L_, { detail: Ce, bubbles: !0, composed: !0 })
      ), Be.value = !!Ce.claimed;
    }
    jt(() => void Gt(ie)), Je(De, () => void Gt(ie), { deep: !1 }), Tt(() => {
      typeof document > "u" || document.dispatchEvent(
        new CustomEvent(L_, {
          detail: { items: [], run: () => {
          }, claimed: !1 }
        })
      );
    });
    const ge = E(() => {
      const te = Be.value ? [] : De.value;
      return i.narrow ? ot(te) : te;
    });
    function G() {
      var Ce, Ne;
      const te = (Ce = se.value) == null ? void 0 : Ce.getBoundingClientRect();
      (Ne = xe.value) == null || Ne.show({ clientX: te ? o_(te, x.value) : 0, clientY: te ? te.bottom + 4 : 0 }, []);
    }
    function ye(te) {
      var Ce;
      switch (te.key) {
        case "new-folder":
          o("new-folder");
          break;
        case "refresh":
          o("refresh");
          break;
        case "density":
          m();
          break;
        case "view-list":
          o("update:viewMode", "list");
          break;
        case "view-grid":
          o("update:viewMode", "grid");
          break;
        case "view-gallery":
          o("update:viewMode", "gallery");
          break;
        case "inspector":
          o("toggle-inspector");
          break;
        case "nav":
          o("toggle-nav");
          break;
        case "theme":
          o("open-theme");
          break;
        case "shortcut-settings":
          o("open-shortcut-settings");
          break;
        case "timezone":
          o("open-timezone");
          break;
        case "language":
          o("open-language");
          break;
        case "tour":
          (Ce = he.value) == null || Ce.dispatchEvent(new CustomEvent("fe:tour-restart", { bubbles: !0 }));
          break;
        default:
          at(te.key);
      }
    }
    return (te, Ce) => (f(), h("div", {
      ref_key: "rootEl",
      ref: he,
      class: Re(["fe-toolbar", {
        "fe-toolbar--narrow": e.narrow,
        /* surucu:d1 — ALWAYS on. It is no longer a variant: this is the only
           header filex has, and the modifier survives as the hook the one
           visual definition in styles/base.css was written against. Dropping it
           would mean moving those rules, not deleting a state. */
        "fe-toolbar--drive": !0
      }])
    }, [
      e.navEnabled !== !1 || te.$slots.brand || e.brandName || e.brandMarkUrl ? (f(), h("div", {
        key: 0,
        class: Re(["fe-toolbar__brand", {
          "fe-toolbar__brand--gutter": e.navEnabled !== !1,
          /* gezinti:g3 — the panel collapsed to its rail, so this gutter has to
             collapse with it. `navOpen === false`, never `!navOpen`: the prop is
             optional, and an embedder that does not pass it must keep the
             expanded layout rather than lose its wordmark to a `undefined`. */
          "fe-toolbar__brand--rail": !e.narrow && e.navEnabled !== !1 && e.navOpen === !1
        }])
      }, [
        e.navEnabled !== !1 ? (f(), h("button", {
          key: 0,
          type: "button",
          class: "fe-btn fe-btn--icon-only fe-toolbar__nav",
          "aria-pressed": !!e.navOpen,
          title: Ut.value,
          "aria-label": Ut.value,
          "data-testid": "toolbar-nav",
          onClick: Ce[0] || (Ce[0] = (Ne) => o("toggle-nav"))
        }, [...Ce[12] || (Ce[12] = [
          d("svg", {
            class: "fe-ficon",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "1.8",
            "stroke-linecap": "round",
            "aria-hidden": "true",
            focusable: "false"
          }, [
            d("path", { d: "M4 7h16M4 12h16M4 17h16" })
          ], -1)
        ])], 8, SL)) : O("", !0),
        !e.narrow && e.navOpen !== !1 ? (f(), h("div", $L, [
          On(te.$slots, "brand", {}, () => [
            e.brandMarkUrl ? (f(), h("img", {
              key: 0,
              class: "fe-toolbar__markimg",
              src: e.brandMarkUrl,
              alt: ""
            }, null, 8, TL)) : O("", !0),
            e.brandName ? (f(), h("span", AL, y(e.brandName), 1)) : O("", !0)
          ])
        ])) : O("", !0)
      ], 2)) : O("", !0),
      e.narrow ? (f(), h(Te, { key: 2 }, [
        d("div", XL, [
          Ce[14] || (Ce[14] = d("svg", {
            class: "fe-ficon fe-drivesearch__glass",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "1.9",
            "stroke-linecap": "round",
            "aria-hidden": "true",
            focusable: "false"
          }, [
            d("circle", {
              cx: "11",
              cy: "11",
              r: "6.5"
            }),
            d("path", { d: "M16 16l4.5 4.5" })
          ], -1)),
          d("input", {
            ref_key: "searchEl",
            ref: w,
            type: "search",
            class: "fe-drivesearch__input",
            placeholder: Xe.value,
            value: S.value,
            "aria-label": u(v)("toolbar.search"),
            onInput: b,
            onKeydown: je
          }, null, 40, JL),
          d("button", {
            type: "button",
            class: "fe-drivesearch__tune",
            title: u(v)("advsearch.open"),
            "aria-label": u(v)("advsearch.open"),
            "data-testid": "drive-search-advanced",
            onClick: Ce[8] || (Ce[8] = (Ne) => o("open-advanced-search", S.value))
          }, [
            d("span", {
              class: "fe-icon",
              "aria-hidden": "true",
              innerHTML: u(zt)("filter")
            }, null, 8, QL)
          ], 8, ZL),
          d("button", {
            type: "button",
            class: "fe-drivesearch__kbd",
            title: u(v)("drive.search.hint_title", { combo: ft.value }),
            "aria-label": u(v)("drive.search.hint_title", { combo: ft.value }),
            "data-testid": "drive-search-palette",
            onClick: Ce[9] || (Ce[9] = (Ne) => o("open-palette", S.value))
          }, y(ft.value), 9, eD)
        ]),
        d("div", tD, [
          e.assistantButton ? (f(), h("button", {
            key: 0,
            type: "button",
            class: Re(["fe-btn fe-btn--icon-only", { "is-active": e.assistantOpen }]),
            title: u(v)("ai.assistant"),
            "aria-label": u(v)("ai.assistant"),
            "aria-pressed": e.assistantOpen ? "true" : "false",
            "data-testid": "header-ai",
            onClick: Ce[10] || (Ce[10] = (Ne) => o("toggle-assistant"))
          }, [
            d("span", {
              class: "fe-icon",
              "aria-hidden": "true",
              innerHTML: u(zt)("ai")
            }, null, 8, aD)
          ], 10, nD)) : O("", !0),
          ge.value.length > 0 ? (f(), h("button", {
            key: 1,
            ref_key: "moreBtnEl",
            ref: se,
            type: "button",
            class: "fe-btn fe-btn--icon-only",
            title: u(v)("toolbar.more"),
            "aria-label": u(v)("toolbar.more"),
            "aria-haspopup": "menu",
            "data-testid": "drive-more",
            onClick: G
          }, [
            d("span", {
              class: "fe-icon",
              "aria-hidden": "true",
              innerHTML: u(zt)("more")
            }, null, 8, oD)
          ], 8, iD)) : O("", !0),
          On(te.$slots, "header-actions")
        ])
      ], 64)) : (f(), h(Te, { key: 1 }, [
        d("div", EL, [
          e.navEnabled === !1 && T.value === "none" && !e.trashActive && !e.atVirtualRoot && e.canWrite !== !1 ? (f(), h("button", {
            key: 0,
            type: "button",
            class: "fe-btn fe-btn--primary",
            title: gt(u(v)("toolbar.new_folder"), "new-folder"),
            onClick: Ce[1] || (Ce[1] = (Ne) => o("new-folder"))
          }, [
            d("span", {
              class: "fe-icon",
              "aria-hidden": "true",
              innerHTML: u(zt)("new-folder")
            }, null, 8, zL),
            d("span", ML, y(u(v)("toolbar.new_folder")), 1)
          ], 8, CL)) : O("", !0),
          e.navEnabled === !1 && !e.atVirtualRoot && e.canWrite !== !1 ? (f(), h("button", {
            key: 1,
            type: "button",
            class: "fe-btn fe-btn--icon-only",
            title: gt(u(v)("toolbar.upload"), "upload"),
            "aria-label": u(v)("toolbar.upload"),
            onClick: Ce[2] || (Ce[2] = (Ne) => o("upload"))
          }, [
            d("span", {
              class: "fe-icon",
              "aria-hidden": "true",
              innerHTML: u(zt)("upload")
            }, null, 8, OL)
          ], 8, PL)) : O("", !0),
          e.pasteEnabled && T.value === "none" && !e.trashActive && !e.atVirtualRoot && e.canWrite !== !1 ? (f(), h("button", {
            key: 2,
            type: "button",
            class: "fe-btn",
            title: gt(u(v)("ctx.paste"), "paste"),
            onClick: Ce[3] || (Ce[3] = (Ne) => at("paste"))
          }, [
            d("span", {
              class: "fe-icon",
              "aria-hidden": "true",
              innerHTML: u(zt)("paste")
            }, null, 8, DL),
            d("span", RL, y(u(v)("ctx.paste")), 1)
          ], 8, LL)) : O("", !0)
        ]),
        d("div", IL, [
          d("div", NL, [
            Ce[13] || (Ce[13] = d("svg", {
              class: "fe-ficon fe-drivesearch__glass",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "1.9",
              "stroke-linecap": "round",
              "aria-hidden": "true",
              focusable: "false"
            }, [
              d("circle", {
                cx: "11",
                cy: "11",
                r: "6.5"
              }),
              d("path", { d: "M16 16l4.5 4.5" })
            ], -1)),
            d("input", {
              ref_key: "searchEl",
              ref: w,
              type: "search",
              class: "fe-search__input fe-drivesearch__input",
              placeholder: Xe.value,
              value: S.value,
              "aria-label": u(v)("toolbar.search"),
              onInput: b,
              onKeydown: je
            }, null, 40, BL),
            d("button", {
              type: "button",
              class: "fe-drivesearch__tune",
              title: u(v)("advsearch.open"),
              "aria-label": u(v)("advsearch.open"),
              "data-testid": "drive-search-advanced",
              onClick: Ce[4] || (Ce[4] = (Ne) => o("open-advanced-search", S.value))
            }, [
              d("span", {
                class: "fe-icon",
                "aria-hidden": "true",
                innerHTML: u(zt)("filter")
              }, null, 8, UL)
            ], 8, FL),
            d("button", {
              type: "button",
              class: "fe-drivesearch__kbd",
              title: u(v)("drive.search.hint_title", { combo: ft.value }),
              "aria-label": u(v)("drive.search.hint_title", { combo: ft.value }),
              "data-testid": "drive-search-palette",
              onClick: Ce[5] || (Ce[5] = (Ne) => o("open-palette", S.value))
            }, y(ft.value), 9, HL)
          ])
        ]),
        d("div", KL, [
          d("button", {
            type: "button",
            class: "fe-btn fe-btn--icon-only",
            title: gt(u(v)("toolbar.refresh"), "refresh"),
            "aria-label": u(v)("toolbar.refresh"),
            onClick: Ce[6] || (Ce[6] = (Ne) => o("refresh"))
          }, [
            d("span", {
              class: "fe-icon",
              "aria-hidden": "true",
              innerHTML: u(zt)("refresh")
            }, null, 8, jL)
          ], 8, VL),
          e.assistantButton ? (f(), h("button", {
            key: 0,
            type: "button",
            class: Re(["fe-btn fe-btn--icon-only", { "is-active": e.assistantOpen }]),
            title: u(v)("ai.assistant"),
            "aria-label": u(v)("ai.assistant"),
            "aria-pressed": e.assistantOpen ? "true" : "false",
            "data-testid": "header-ai",
            onClick: Ce[7] || (Ce[7] = (Ne) => o("toggle-assistant"))
          }, [
            d("span", {
              class: "fe-icon",
              "aria-hidden": "true",
              innerHTML: u(zt)("ai")
            }, null, 8, WL)
          ], 10, qL)) : O("", !0),
          ge.value.length > 0 ? (f(), h("button", {
            key: 1,
            ref_key: "moreBtnEl",
            ref: se,
            type: "button",
            class: "fe-btn fe-btn--icon-only",
            title: u(v)("toolbar.more"),
            "aria-label": u(v)("toolbar.more"),
            "aria-haspopup": "menu",
            "data-testid": "drive-more",
            onClick: G
          }, [
            d("span", {
              class: "fe-icon",
              "aria-hidden": "true",
              innerHTML: u(zt)("more")
            }, null, 8, GL)
          ], 8, YL)) : O("", !0),
          On(te.$slots, "header-actions")
        ])
      ], 64)),
      Ze(_l, {
        ref_key: "moreRef",
        ref: xe,
        locale: e.locale,
        theme: e.theme || "auto",
        sheet: kt.value,
        actions: ge.value,
        onSelect: ye
      }, null, 8, ["locale", "theme", "sheet", "actions"]),
      (f(), Ge(wi, {
        to: ue.value || "body",
        disabled: !ue.value
      }, [
        z.value ? (f(), h("div", {
          key: 0,
          class: Re(["fe-selbar", { "fe-selbar--inline": !ue.value }]),
          role: "toolbar",
          "aria-label": $t.value,
          "data-testid": "selection-bar"
        }, [
          d("span", sD, y($t.value), 1),
          d("div", {
            ref_key: "selBarEl",
            ref: U,
            class: "fe-selbar__actions"
          }, [
            (f(!0), h(Te, null, nt(N.value, (Ne) => (f(), h("button", {
              key: Ne.key,
              type: "button",
              class: Re(["fe-selbar__btn", { "fe-selbar__btn--danger": Ne.danger, "is-disabled": Ne.disabled }]),
              disabled: Ne.disabled,
              title: Ne.title || gt(Ne.label, Ne.key),
              "aria-label": Ne.label,
              "data-key": Ne.key,
              "data-testid": `selbar-${Ne.key}`,
              onClick: (_e) => at(Ne.key)
            }, [
              d("span", {
                class: "fe-icon",
                "aria-hidden": "true",
                innerHTML: a(Ne)
              }, null, 8, uD)
            ], 10, lD))), 128)),
            H.value.length > 0 ? (f(), h("button", {
              key: 0,
              ref_key: "selMoreBtnEl",
              ref: P,
              type: "button",
              class: "fe-selbar__btn",
              title: u(v)("toolbar.more"),
              "aria-label": u(v)("toolbar.more"),
              "aria-haspopup": "menu",
              "data-testid": "selbar-more",
              onClick: re
            }, [
              d("span", {
                class: "fe-icon",
                "aria-hidden": "true",
                innerHTML: u(zt)("more")
              }, null, 8, dD)
            ], 8, cD)) : O("", !0),
            d("div", {
              ref_key: "measureEl",
              ref: q,
              class: "fe-selbar__measure",
              "aria-hidden": "true"
            }, [
              (f(!0), h(Te, null, nt(D.value.icons, (Ne) => (f(), h("button", {
                key: "m-" + Ne.key,
                type: "button",
                class: "fe-selbar__btn",
                "data-key": Ne.key,
                tabindex: "-1"
              }, [
                d("span", {
                  class: "fe-icon",
                  "aria-hidden": "true",
                  innerHTML: a(Ne)
                }, null, 8, pD)
              ], 8, fD))), 128))
            ], 512)
          ], 512),
          d("button", {
            type: "button",
            class: "fe-selbar__close",
            title: u(v)("selection.clear"),
            "aria-label": u(v)("selection.clear"),
            "data-testid": "selection-clear",
            onClick: St
          }, [
            d("span", {
              class: "fe-icon",
              "aria-hidden": "true",
              innerHTML: u(zt)("close")
            }, null, 8, mD)
          ], 8, hD)
        ], 10, rD)) : O("", !0)
      ], 8, ["to", "disabled"])),
      Ze(_l, {
        ref_key: "selMoreRef",
        ref: R,
        locale: e.locale,
        theme: e.theme || "auto",
        sheet: kt.value,
        actions: H.value,
        onSelect: Ce[11] || (Ce[11] = (Ne) => at(Ne.key))
      }, null, 8, ["locale", "theme", "sheet", "actions"])
    ], 2));
  }
}), gD = 6e4;
function bD(e) {
  return e === "personal" || e === "team";
}
function Upe(e, t) {
  var n;
  return (n = e.find((a) => a.name === t)) == null ? void 0 : n.key;
}
function Uv(e) {
  const t = e ?? {};
  return Array.isArray(t.items) ? t.items.filter(
    (n) => !!n && typeof n.name == "string" && n.name !== "" && bD(n.kind)
  ) : Array.isArray(t.tags) ? t.tags.filter((n) => typeof n == "string" && n !== "").map((n) => ({ name: n, kind: "team" })) : [];
}
const Hv = /* @__PURE__ */ new Map(), Ef = /* @__PURE__ */ new Map();
function kD() {
  Hv.clear(), Ef.clear();
}
const Kv = /* @__PURE__ */ new Set();
function wD(e) {
  return Kv.add(e), () => {
    Kv.delete(e);
  };
}
function _D() {
  kD();
  for (const e of [...Kv])
    try {
      e();
    } catch {
    }
}
async function D_(e = {}) {
  const t = e.apiBase ?? "", n = t || "(same-origin)";
  if (!e.force) {
    const i = Hv.get(n);
    if (i && Date.now() - i.at < gD) return i.tags;
    const o = Ef.get(n);
    if (o) return o;
  }
  const a = (async () => {
    try {
      const i = await fetch(`${t}/api/files/manager/tags/all`, {
        headers: await (e.authHeaders ?? (() => ({})))(),
        credentials: e.authCredentials ?? "same-origin"
      });
      if (!i.ok) return [];
      const o = Uv(await i.json());
      return Hv.set(n, { at: Date.now(), tags: o }), o;
    } catch {
      return [];
    } finally {
      Ef.delete(n);
    }
  })();
  return Ef.set(n, a), a;
}
async function xD(e, t = {}, n = {}) {
  const a = t.apiBase ?? "", i = new URLSearchParams({ tag: e, limit: String(n.limit ?? 100), offset: String(n.offset ?? 0) });
  n.kind && i.set("kind", n.kind), n.sort && i.set("sort", n.sort);
  const o = await fetch(`${a}/api/files/manager/tagged?${i}`, {
    headers: await (t.authHeaders ?? (() => ({})))(),
    credentials: t.authCredentials ?? "same-origin"
  });
  if (!o.ok) throw new Error(String(o.status));
  const l = await o.json(), c = Array.isArray(l == null ? void 0 : l.nodes) ? l.nodes : [];
  return {
    rows: c,
    total: typeof (l == null ? void 0 : l.total) == "number" ? l.total : (n.offset ?? 0) + c.length,
    truncated: (l == null ? void 0 : l.truncated) === !0
  };
}
const SD = ["width", "height", "data-tag-kind"], Vv = /* @__PURE__ */ lt({
  __name: "TagKindIcon",
  props: {
    kind: {},
    size: {}
  },
  setup(e) {
    return (t, n) => (f(), h("svg", {
      class: Re(["fe-tagkind", `fe-tagkind--${e.kind}`]),
      width: e.size ?? 12,
      height: e.size ?? 12,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "aria-hidden": "true",
      focusable: "false",
      "data-tag-kind": e.kind
    }, [
      e.kind === "team" ? (f(), h(Te, { key: 0 }, [
        n[0] || (n[0] = d("circle", {
          cx: "9",
          cy: "8",
          r: "3.2"
        }, null, -1)),
        n[1] || (n[1] = d("path", { d: "M3 20c0-3.3 2.7-6 6-6s6 2.7 6 6" }, null, -1)),
        n[2] || (n[2] = d("circle", {
          cx: "17",
          cy: "9",
          r: "2.6"
        }, null, -1)),
        n[3] || (n[3] = d("path", { d: "M16.5 14.2c2.6.3 4.5 2.6 4.5 5.3" }, null, -1))
      ], 64)) : (f(), h(Te, { key: 1 }, [
        n[4] || (n[4] = d("circle", {
          cx: "12",
          cy: "8",
          r: "3.6"
        }, null, -1)),
        n[5] || (n[5] = d("path", { d: "M5 20c0-3.9 3.1-7 7-7s7 3.1 7 7" }, null, -1))
      ], 64))
    ], 10, SD));
  }
}), $D = ["role", "aria-labelledby", "aria-label", "data-testid"], TD = { class: "fe-choice__strip" }, AD = ["role", "aria-checked", "aria-pressed", "aria-label", "aria-describedby", "tabindex", "disabled", "data-testid", "onClick", "onKeydown"], ED = {
  key: 1,
  class: "fe-choice__label"
}, CD = {
  key: 2,
  class: "fe-choice__help"
}, zD = ["id", "data-testid"], MD = ["data-testid"], mi = /* @__PURE__ */ lt({
  __name: "ChoiceButtons",
  props: {
    options: {},
    modelValue: {},
    multi: { type: Boolean },
    disabled: { type: Boolean },
    invalid: { type: Boolean },
    segmented: { type: Boolean },
    iconOnly: { type: Boolean },
    ariaLabelledby: {},
    ariaLabel: {},
    testidPrefix: {},
    testid: {}
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, a = t, i = E(() => !!n.segmented || !!n.iconOnly), o = `fe-choice-${Math.random().toString(36).slice(2, 10)}`, l = (C) => `${o}-tip-${C}`;
    function c(C) {
      return i.value ? C.help || (n.iconOnly ? C.label : "") : "";
    }
    const p = E(() => {
      var C;
      return !i.value || n.multi ? "" : ((C = n.options.find((T) => v(T.value))) == null ? void 0 : C.help) ?? "";
    }), m = E(() => {
      const C = n.modelValue;
      return Array.isArray(C) ? C.map((T) => String(T)) : C == null || C === "" ? [] : [String(C)];
    });
    function v(C) {
      return m.value.includes(C);
    }
    function x(C) {
      var T;
      return !!n.disabled || !!((T = n.options.find((A) => A.value === C)) != null && T.disabled);
    }
    function w(C) {
      if (!x(C)) {
        if (n.multi) {
          const T = v(C) ? m.value.filter((L) => L !== C) : [...m.value, C], A = n.options.map((L) => L.value);
          a("update:modelValue", A.filter((L) => T.includes(L)));
          return;
        }
        a("update:modelValue", C);
      }
    }
    function S(C) {
      const T = n.options.length;
      for (let A = 0; A < T; A++) {
        const L = C === 1 ? A : T - 1 - A;
        if (!n.options[L].disabled) return L;
      }
      return -1;
    }
    function k(C, T) {
      var U;
      if (n.multi || n.disabled) return;
      const A = n.options.length;
      let L;
      if (C.key === "Home" || C.key === "End") {
        if (C.preventDefault(), L = S(C.key === "Home" ? 1 : -1), L < 0) return;
      } else {
        if (!["ArrowRight", "ArrowDown", "ArrowLeft", "ArrowUp"].includes(C.key)) return;
        C.preventDefault();
        const P = C.key === "ArrowDown" ? 1 : C.key === "ArrowUp" ? -1 : Yf(C.key, ei(C.currentTarget));
        if (!A || (L = (T + P + A) % A, n.options[L].disabled)) return;
      }
      w(n.options[L].value);
      const z = C.currentTarget.closest(".fe-choice"), D = z == null ? void 0 : z.querySelectorAll("[data-choice]");
      (U = D == null ? void 0 : D[L]) == null || U.focus();
    }
    function b(C, T) {
      return n.multi ? 0 : m.value.length ? v(C) ? 0 : -1 : T === 0 ? 0 : -1;
    }
    return (C, T) => (f(), h("div", {
      class: Re(["fe-choice", {
        "is-invalid": e.invalid,
        "is-disabled": e.disabled,
        "fe-choice--segmented": i.value,
        "fe-choice--icons": e.iconOnly
      }]),
      role: e.multi ? "group" : "radiogroup",
      "aria-labelledby": e.ariaLabelledby,
      "aria-label": e.ariaLabel,
      "data-testid": e.testid ?? "choice-buttons"
    }, [
      d("div", TD, [
        (f(!0), h(Te, null, nt(e.options, (A, L) => (f(), h("span", {
          key: A.value,
          class: "fe-choice__cell"
        }, [
          d("button", {
            type: "button",
            "data-choice": "",
            class: Re(["fe-choice__btn", { "is-on": v(A.value) }]),
            role: e.multi ? void 0 : "radio",
            "aria-checked": e.multi ? void 0 : v(A.value) ? "true" : "false",
            "aria-pressed": e.multi ? v(A.value) ? "true" : "false" : void 0,
            "aria-label": e.iconOnly ? A.label : void 0,
            "aria-describedby": i.value && A.help ? l(L) : void 0,
            tabindex: b(A.value, L),
            disabled: e.disabled || A.disabled,
            "data-testid": e.testidPrefix ? `${e.testidPrefix}-${A.value}` : void 0,
            onClick: (z) => w(A.value),
            onKeydown: (z) => k(z, L)
          }, [
            A.icon ? (f(), Ge(Ki(A.icon), {
              key: 0,
              class: "fe-choice__icon",
              "aria-hidden": "true"
            })) : O("", !0),
            e.iconOnly ? O("", !0) : (f(), h("span", ED, y(A.label), 1)),
            A.help && !i.value ? (f(), h("span", CD, y(A.help), 1)) : O("", !0)
          ], 42, AD),
          c(A) ? (f(), h("span", {
            key: 0,
            id: l(L),
            class: "fe-choice__tip",
            "aria-hidden": "true",
            "data-testid": e.testidPrefix ? `${e.testidPrefix}-${A.value}-tip` : void 0
          }, y(c(A)), 9, zD)) : O("", !0)
        ]))), 128))
      ]),
      p.value ? (f(), h("p", {
        key: 0,
        class: "fe-choice__note",
        "aria-hidden": "true",
        "data-testid": e.testidPrefix ? `${e.testidPrefix}-note` : void 0
      }, y(p.value), 9, MD)) : O("", !0)
    ], 10, $D));
  }
}), PD = ["data-tag-kind"], OD = ["title", "aria-label", "data-testid", "onClick"], LD = ["aria-label", "onClick"], DD = ["placeholder", "aria-label"], wx = /* @__PURE__ */ lt({
  __name: "TagPicker",
  props: {
    nodeId: {},
    locale: {},
    apiBase: {},
    authHeaders: { type: Function },
    authCredentials: {},
    palette: {}
  },
  emits: ["change", "error", "open"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = pt(() => n.locale ?? "en");
    function o(J) {
      return `${i("tags.open", { tag: J.name })} · ${i(`tags.chip.${J.kind}`, { tag: J.name })}`;
    }
    const l = $([]), c = $(!0), p = $(!1), m = $(!1), v = $(!1), x = $(""), w = $("personal"), S = $(null), k = E(() => [
      ...l.value.filter((J) => J.kind === "personal"),
      ...l.value.filter((J) => J.kind === "team")
    ]), b = E(() => [
      { value: "personal", label: i("tags.kind.personal"), help: i("tags.kind.personal_help") },
      {
        value: "team",
        label: i("tags.kind.team"),
        help: c.value ? i("tags.kind.team_help") : i("tags.kind.team_locked"),
        disabled: !c.value
      }
    ]), C = E(() => n.palette ?? [
      "#ef4444",
      "#f59e0b",
      "#10b981",
      "#3b82f6",
      "#8b5cf6",
      "#ec4899",
      "#14b8a6",
      "#f97316"
    ]);
    function T(J) {
      let H = 0;
      for (let j = 0; j < J.length; j++) H = H * 31 + J.charCodeAt(j) | 0;
      const ne = C.value;
      return ne[Math.abs(H) % ne.length];
    }
    function A(J) {
      return J.kind === "personal" || c.value;
    }
    async function L(J = {}) {
      return { ...await (n.authHeaders ?? (() => ({})))(), ...J };
    }
    function z(J) {
      const H = J ?? {};
      p.value = !Array.isArray(H.items), l.value = Uv(J), typeof H.can_edit_team == "boolean" && (c.value = H.can_edit_team);
    }
    async function D() {
      m.value = !0;
      try {
        const J = n.apiBase ?? "", H = await fetch(`${J}/api/files/manager/tags?node_id=${n.nodeId}`, {
          headers: await L(),
          credentials: n.authCredentials ?? "same-origin"
        });
        H.ok && z(await H.json());
      } catch (J) {
        a("error", J instanceof Error ? J.message : String(J));
      } finally {
        m.value = !1;
      }
    }
    async function U(J) {
      const H = [...l.value];
      l.value = J;
      try {
        const ne = n.apiBase ?? "", j = p.value ? { node_id: n.nodeId, tags: J.map((ue) => ue.name) } : { node_id: n.nodeId, items: J }, re = await fetch(`${ne}/api/files/manager/tags`, {
          method: "POST",
          headers: await L({ "Content-Type": "application/json" }),
          credentials: n.authCredentials ?? "same-origin",
          body: JSON.stringify(j)
        });
        if (!re.ok) throw fa(re.status, await re.text().catch(() => ""), n.locale);
        const he = await re.json().catch(() => null);
        !p.value && he && Array.isArray(he.items) && (l.value = Uv(he)), _D(), a("change", l.value.map((ue) => ue.name), l.value);
      } catch (ne) {
        l.value = H, a("error", ne instanceof Error ? ne.message : String(ne));
      }
    }
    function q() {
      x.value = "", w.value = "personal", v.value = !1;
    }
    const P = E(() => Pc("tag_max_runes"));
    Je(x, (J) => {
      const H = Dy(J, P.value);
      H !== J && (x.value = H);
    });
    function R() {
      const J = x.value.trim(), H = p.value ? "team" : w.value;
      if (!J || l.value.some((ne) => ne.kind === H && ne.name === J)) {
        q();
        return;
      }
      U([...l.value, { name: J, kind: H }]), q();
    }
    function W(J) {
      var ne;
      if (p.value) {
        R();
        return;
      }
      const H = J.relatedTarget;
      H && ((ne = S.value) != null && ne.contains(H)) || x.value.trim() || q();
    }
    function N(J) {
      U(l.value.filter((H) => H !== J));
    }
    return jt(D), Je(() => n.nodeId, D), (J, H) => (f(), h("div", {
      class: Re(["filex-tag-picker", { "is-loading": m.value }])
    }, [
      (f(!0), h(Te, null, nt(k.value, (ne) => (f(), h("span", {
        key: `${ne.kind}:${ne.name}`,
        class: Re(["filex-tag", `filex-tag--${ne.kind}`]),
        "data-tag-kind": ne.kind,
        style: Wt({ "--filex-tag-color": T(ne.name) })
      }, [
        Ze(Vv, {
          kind: ne.kind
        }, null, 8, ["kind"]),
        d("button", {
          class: "filex-tag-open",
          type: "button",
          title: o(ne),
          "aria-label": o(ne),
          "data-testid": `tag-open-${ne.name}`,
          onClick: (j) => a("open", ne.name, ne.kind)
        }, y(ne.name), 9, OD),
        A(ne) ? (f(), h("button", {
          key: 0,
          class: "filex-tag-x",
          type: "button",
          "aria-label": `${u(i)("tags.remove")}: ${ne.name}`,
          onClick: (j) => N(ne)
        }, "×", 8, LD)) : O("", !0)
      ], 14, PD))), 128)),
      v.value ? (f(), h("form", {
        key: 0,
        ref_key: "addForm",
        ref: S,
        class: "filex-tag-add",
        onSubmit: yt(R, ["prevent"])
      }, [
        ln(d("input", {
          "onUpdate:modelValue": H[0] || (H[0] = (ne) => x.value = ne),
          autofocus: "",
          placeholder: u(i)("tags.name"),
          "aria-label": u(i)("tags.name"),
          onBlur: W,
          onKeydown: Ca(q, ["escape"])
        }, null, 40, DD), [
          [_n, x.value]
        ]),
        p.value ? O("", !0) : (f(), h("div", {
          key: 0,
          class: "filex-tag-kindwrap",
          onMousedown: H[2] || (H[2] = yt(() => {
          }, ["prevent"]))
        }, [
          Ze(mi, {
            "model-value": w.value,
            options: b.value,
            "aria-label": u(i)("tags.kind.label"),
            "testid-prefix": "tag-kind",
            "onUpdate:modelValue": H[1] || (H[1] = (ne) => w.value = ne === "team" ? "team" : "personal")
          }, null, 8, ["model-value", "options", "aria-label"])
        ], 32)),
        d("button", {
          class: "filex-tag-add-submit",
          type: "submit",
          onMousedown: H[3] || (H[3] = yt(() => {
          }, ["prevent"]))
        }, y(u(i)("tags.add_submit")), 33)
      ], 544)) : (f(), h("button", {
        key: 1,
        class: "filex-tag-add-btn",
        type: "button",
        onClick: H[4] || (H[4] = (ne) => v.value = !0)
      }, y(u(i)("tags.add")), 1))
    ], 2));
  }
}), R_ = { tr: _2, en: el }, _x = {};
function _i(e, t) {
  for (const n of t) _x[n] = e;
}
_i("image", ["jpg", "jpeg", "png", "webp", "gif", "bmp", "avif", "heic", "svg", "ico", "tiff", "tif"]);
_i("video", ["mp4", "webm", "mov", "mkv", "avi", "ogv", "m4v"]);
_i("audio", ["mp3", "wav", "flac", "ogg", "m4a", "aac", "opus"]);
_i("pdf", ["pdf"]);
_i("doc", ["doc", "docx", "odt", "rtf"]);
_i("sheet", ["xls", "xlsx", "ods", "csv", "tsv"]);
_i("slides", ["ppt", "pptx", "odp"]);
_i("archive", ["zip", "tar", "gz", "bz2", "7z", "rar", "xz", "zst"]);
const xx = /* @__PURE__ */ new Set([
  "jar",
  "war",
  "ear",
  "aar",
  "apk",
  "aab",
  "apks",
  "xapk",
  "ipa",
  "whl",
  "egg",
  "vsix",
  "nupkg",
  "snupkg",
  "xpi",
  "crx",
  "appx",
  "appxbundle",
  "msix",
  "msixbundle",
  "deb",
  "rpm",
  "snap",
  "gem",
  "crate"
]);
_i("archive", [...xx]);
_i("code", [
  "js",
  "ts",
  "jsx",
  "tsx",
  "mjs",
  "cjs",
  "vue",
  "py",
  "go",
  "rs",
  "php",
  "rb",
  "java",
  "kt",
  "swift",
  "c",
  "cpp",
  "h",
  "hpp",
  "cs",
  "css",
  "scss",
  "less",
  "html",
  "htm",
  "json",
  "yml",
  "yaml",
  "xml",
  "sh",
  "bash",
  "ps1",
  "sql",
  "toml"
]);
_i("text", ["txt", "md", "markdown", "log", "ini", "conf", "cfg", "env"]);
function cc(e) {
  return e.mime_type === "inode/storage";
}
function xi(e) {
  if (cc(e)) return "storage";
  if (e.basename === ".trash") return "trash";
  if (e.type === "dir") return "folder";
  const t = (e.extension || "").toLowerCase();
  return t ? _x[t] ?? "unknown" : I2(e.mime_type) ? "text" : "unknown";
}
const Ho = '<path d="M6.5 3h7L18.5 8v11.5a1.5 1.5 0 0 1-1.5 1.5H6.5A1.5 1.5 0 0 1 5 19.5v-15A1.5 1.5 0 0 1 6.5 3z"/><path d="M13.5 3v5h5"/>', RD = {
  // Folder is the one "filled" member — a soft currentColor wash keeps it
  // visually anchored without breaking the line style.
  /**
   * gorunum:v1 — the folder is SOLID, and it is the one glyph that never
   * gets a tile. A folder is the most common thing in a listing; drawn as an
   * outline in the same weight as the file glyphs it disappears into them,
   * and the eye has to read the label to tell a folder from a document. Filled
   * and in its own colour it is recognisable before the name is read.
   */
  folder: '<path d="M2.5 6.5A2.5 2.5 0 0 1 5 4h4.6a2.5 2.5 0 0 1 1.77.73L13 6.4h6a2.5 2.5 0 0 1 2.5 2.5v8.6A2.5 2.5 0 0 1 19 20H5a2.5 2.5 0 0 1-2.5-2.5z" fill="currentColor" stroke="none"/>',
  image: '<rect x="3" y="5" width="18" height="14" rx="2"/><circle cx="8.6" cy="10" r="1.6"/><path d="M5.2 16.6l4.3-4.3 3 3 2.4-2.4 3.9 3.7"/>',
  video: '<rect x="3" y="5" width="18" height="14" rx="2"/><path d="M10.2 9.3v5.4l4.8-2.7z" fill="currentColor" stroke="none"/>',
  audio: '<path d="M9 17.5V7.2l9-2.2v10.4"/><circle cx="6.8" cy="17.6" r="2.2"/><circle cx="15.8" cy="15.5" r="2.2"/>',
  pdf: Ho + '<rect x="7.5" y="12" width="9" height="5" rx="1" fill="currentColor" fill-opacity="0.14"/>',
  doc: Ho + '<path d="M8.5 13h7M8.5 16h7"/>',
  sheet: Ho + '<path d="M8 12.5h8M8 15.5h8M8 18h8M12 12.5V18"/>',
  slides: Ho + '<rect x="8" y="12.5" width="8" height="5" rx="0.8"/>',
  archive: Ho + '<path d="M10 3v1.6M10 6.6v1.6M10 10.2v1.6"/><rect x="8.6" y="14" width="2.8" height="3.4" rx="0.8"/>',
  code: Ho + '<path d="M10.4 12.5L8.3 15l2.1 2.5M13.6 12.5l2.1 2.5-2.1 2.5"/>',
  text: Ho + '<path d="M8.5 12h7M8.5 15h7M8.5 18h4.5"/>',
  // The two-bay drive the sidebar already draws for the same storages, so a
  // drive is one shape across the panel rather than one per surface.
  storage: '<rect x="3" y="5" width="18" height="6" rx="1.6"/><rect x="3" y="13" width="18" height="6" rx="1.6"/><path d="M6.5 8h.01M6.5 16h.01"/>',
  trash: '<path d="M4 7h16"/><path d="M9.5 7V5.6A1.6 1.6 0 0 1 11.1 4h1.8a1.6 1.6 0 0 1 1.6 1.6V7"/><path d="M6.2 7l.85 11.6A1.6 1.6 0 0 0 8.65 20h6.7a1.6 1.6 0 0 0 1.6-1.4L17.8 7"/><path d="M10.2 10.8v5.6M13.8 10.8v5.6"/>',
  unknown: Ho + '<path d="M10.3 13.1a1.8 1.8 0 1 1 2.5 1.9c-.6.3-.8.7-.8 1.4"/><circle cx="12" cy="18.4" r="0.9" fill="currentColor" stroke="none"/>'
}, I_ = /* @__PURE__ */ new Map();
function N_(e) {
  let t = I_.get(e);
  return t || (t = `<svg class="fe-ficon fe-ficon--${e}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">${RD[e]}</svg>`, I_.set(e, t)), t;
}
const B_ = /* @__PURE__ */ new Map();
function Sx(e) {
  if (e === "folder")
    return `<span class="fe-ftile fe-ftile--folder">${N_(e)}</span>`;
  let t = B_.get(e);
  return t || (t = `<span class="fe-ftile fe-ftile--${e}">${N_(e)}</span>`, B_.set(e, t)), t;
}
function wa(e) {
  return ID(e) ? BD() : Sx(xi(e));
}
function ID(e) {
  return e.type === "dir" ? !1 : (e.extension || "").toLowerCase() === "fxe" ? !0 : typeof e.basename == "string" && e.basename.toLowerCase().endsWith(".fxe") && e.basename.length > 4;
}
const ND = '<path fill="currentColor" stroke="none" fill-rule="evenodd" d="M6.5 3h7L18.5 8v11.5a1.5 1.5 0 0 1-1.5 1.5H6.5A1.5 1.5 0 0 1 5 19.5v-15A1.5 1.5 0 0 1 6.5 3zM9.7 12.2a2.3 2.3 0 0 1 4.6 0h-1.05a1.25 1.25 0 0 0-2.5 0zM9.2 12.2h5.6a1 1 0 0 1 1 1v3.6a1 1 0 0 1-1 1H9.2a1 1 0 0 1-1-1v-3.6a1 1 0 0 1 1-1z"/>';
let Bm = "";
function BD() {
  return Bm || (Bm = `<span class="fe-ftile fe-ftile--unknown fe-ftile--file-locked"><svg class="fe-ficon fe-ficon--file-locked" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">${ND}</svg></span>`), Bm;
}
function Vr(e) {
  return e.type === "dir" && e.e2e === !0;
}
const FD = '<path fill="currentColor" stroke="none" fill-rule="evenodd" d="M2.5 6.5A2.5 2.5 0 0 1 5 4h4.6a2.5 2.5 0 0 1 1.77.73L13 6.4h6a2.5 2.5 0 0 1 2.5 2.5v8.6A2.5 2.5 0 0 1 19 20H5a2.5 2.5 0 0 1-2.5-2.5zM9.7 12a2.3 2.3 0 0 1 4.6 0h-1.05a1.25 1.25 0 0 0-2.5 0zM9.2 12h5.6a1 1 0 0 1 1 1v3.6a1 1 0 0 1-1 1H9.2a1 1 0 0 1-1-1V13a1 1 0 0 1 1-1z"/>';
let Fm = "";
function xl() {
  return Fm || (Fm = `<span class="fe-ftile fe-ftile--folder fe-ftile--folder-locked"><svg class="fe-ficon fe-ficon--folder" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">${FD}</svg></span>`), Fm;
}
const UD = {
  // Languages the person reading the column thinks of by name.
  ts: "ftype.typescript",
  tsx: "ftype.typescript",
  mts: "ftype.typescript",
  cts: "ftype.typescript",
  js: "ftype.javascript",
  jsx: "ftype.javascript",
  mjs: "ftype.javascript",
  cjs: "ftype.javascript",
  vue: "ftype.vue",
  py: "ftype.python",
  go: "ftype.go",
  rs: "ftype.rust",
  php: "ftype.php",
  rb: "ftype.ruby",
  java: "ftype.java",
  kt: "ftype.kotlin",
  swift: "ftype.swift",
  c: "ftype.c",
  h: "ftype.c",
  cpp: "ftype.cpp",
  hpp: "ftype.cpp",
  cs: "ftype.csharp",
  // Structured text that is code by family but not a language.
  css: "ftype.stylesheet",
  scss: "ftype.stylesheet",
  less: "ftype.stylesheet",
  html: "ftype.html",
  htm: "ftype.html",
  json: "ftype.json",
  yml: "ftype.yaml",
  yaml: "ftype.yaml",
  xml: "ftype.xml",
  toml: "ftype.toml",
  sql: "ftype.sql",
  sh: "ftype.shell",
  bash: "ftype.shell",
  zsh: "ftype.shell",
  ps1: "ftype.powershell",
  // Plain-text family members that are each their own thing.
  md: "ftype.markdown",
  markdown: "ftype.markdown",
  txt: "ftype.plaintext",
  log: "ftype.log",
  ini: "ftype.config",
  conf: "ftype.config",
  cfg: "ftype.config",
  env: "ftype.config",
  // Tabular: a `.csv` IS a spreadsheet to the person looking at the column,
  // whatever the program that wrote it was.
  csv: "ftype.sheet",
  tsv: "ftype.sheet",
  // Design files. No icon family of their own (they fall to `unknown`, which
  // is a decision for the GLYPH, not for the word) — naming them still beats
  // printing "FIG".
  fig: "ftype.figma",
  // ⚠ Named, not "DRAWIO": the uppercased extension was a fourth spelling of
  // draw.io beside "Drawio", "drawio" and "diagrams.net" (QA, 2026-09-21).
  drawio: "ftype.drawio",
  dio: "ftype.drawio",
  sketch: "ftype.design",
  xd: "ftype.design",
  psd: "ftype.design",
  ai: "ftype.design"
}, HD = {
  folder: "node.folder",
  image: "ftype.image",
  video: "ftype.video",
  audio: "ftype.audio",
  pdf: "ftype.pdf",
  doc: "ftype.document",
  sheet: "ftype.sheet",
  slides: "ftype.slides",
  archive: "ftype.archive",
  code: "ftype.code",
  text: "ftype.plaintext"
};
function $x(e) {
  if (e.type === "dir") return "node.folder";
  const t = (e.extension || "").trim().toLowerCase();
  if (t === "fxe") return "e2e.fxe.type";
  const n = UD[t];
  return n || (xx.has(t) ? null : HD[xi(e)] ?? null);
}
function jv(e, t) {
  const n = $x(e);
  return n ? t(n) : Tx(e) || "-";
}
function Tx(e) {
  return (e.extension || "").trim().toUpperCase();
}
const Bn = 16, Lp = new Uint8Array(Bn);
class F_ extends Error {
  constructor(t = "aes-siv: authentication failed") {
    super(t), this.name = "SivAuthError";
  }
}
function Go(e) {
  return new Uint8Array(e).buffer;
}
function ip(e) {
  const t = new Uint8Array(Bn);
  let n = 0;
  for (let a = Bn - 1; a >= 0; a--) {
    const i = e[a];
    t[a] = (i << 1 | n) & 255, n = i >>> 7;
  }
  return e[0] & 128 && (t[Bn - 1] ^= 135), t;
}
function qv(e, t, n) {
  for (let a = 0; a < n.length; a++) e[t + a] ^= n[a];
}
function U_(e, t) {
  const n = new Uint8Array(Bn);
  for (let a = 0; a < Bn; a++) n[a] = e[a] ^ t[a];
  return n;
}
async function KD(e, t) {
  const n = await crypto.subtle.encrypt({ name: "AES-CBC", iv: Go(Lp) }, e, Go(t));
  return new Uint8Array(n).slice(0, Bn);
}
async function Um(e, t) {
  const n = Math.max(1, Math.ceil(t.length / Bn)), a = t.length > 0 && t.length % Bn === 0, i = new Uint8Array(n * Bn);
  i.set(t);
  const o = (n - 1) * Bn;
  return a ? qv(i, o, e.k1) : (i[t.length] = 128, qv(i, o, e.k2)), new Uint8Array(
    await crypto.subtle.encrypt({ name: "AES-CBC", iv: Go(Lp) }, e.mac, Go(i))
  ).slice(o, o + Bn);
}
async function Ax(e, t, n) {
  let a = await Um(e, Lp);
  for (const o of t) a = U_(ip(a), await Um(e, o));
  let i;
  if (n.length >= Bn)
    i = n.slice(), qv(i, n.length - Bn, a);
  else {
    const o = new Uint8Array(Bn);
    o.set(n), o[n.length] = 128, i = U_(ip(a), o);
  }
  return Um(e, i);
}
function VD(e) {
  const t = e.slice();
  return t[8] &= 127, t[12] &= 127, t;
}
async function Ex(e, t, n) {
  if (n.length === 0) return new Uint8Array(0);
  const a = await crypto.subtle.encrypt(
    { name: "AES-CTR", counter: Go(VD(t)), length: 32 },
    e.ctr,
    Go(n)
  );
  return new Uint8Array(a);
}
async function jD(e) {
  if (e.length !== 32 && e.length !== 64)
    throw new Error("aes-siv: key must be 32 or 64 bytes");
  const t = e.length / 2, n = await crypto.subtle.importKey("raw", Go(e.slice(0, t)), { name: "AES-CBC" }, !1, [
    "encrypt"
  ]), a = await crypto.subtle.importKey("raw", Go(e.slice(t)), { name: "AES-CTR" }, !1, [
    "encrypt",
    "decrypt"
  ]), i = await KD(n, Lp), o = ip(i), l = ip(o);
  return { mac: n, ctr: a, k1: o, k2: l };
}
async function Cx(e, t, n = []) {
  const a = await Ax(e, n, t), i = await Ex(e, a, t), o = new Uint8Array(Bn + i.length);
  return o.set(a, 0), o.set(i, Bn), o;
}
async function qD(e, t, n = []) {
  if (t.length < Bn) throw new F_("aes-siv: ciphertext too short");
  const a = t.slice(0, Bn), i = await Ex(e, a, t.slice(Bn)), o = await Ax(e, n, i);
  let l = 0;
  for (let c = 0; c < Bn; c++) l |= o[c] ^ a[c];
  if (l !== 0)
    throw i.fill(0), new F_();
  return i;
}
const zx = "AES-SIV-512", Mx = "b64url", WD = 220, YD = 255, Px = 64, Sl = 16, GD = ".fxl", Ox = ".fxl.name", XD = new TextEncoder().encode("filex-e2e-dir-id"), JD = 16, Lx = /^[A-Za-z0-9_-]+$/, og = "[A-Za-z0-9_-]{43}", Dx = "[A-Za-z0-9_-]{22}", ZD = new RegExp(`^(${og})\\.fxl\\.name$`), QD = new RegExp(`^(${og})\\.fxl$`), e4 = new RegExp(`^(${og})\\.fxl\\.(${Dx})$`), t4 = new RegExp(`^([A-Za-z0-9_-]{23,})\\.(${Dx})$`), n4 = 23;
function Xo(e) {
  let t = "";
  for (let n = 0; n < e.length; n++) t += String.fromCharCode(e[n]);
  return btoa(t).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}
function _o(e) {
  if (!e || !Lx.test(e) || e.length % 4 === 1) return null;
  const t = e.replace(/-/g, "+").replace(/_/g, "/"), n = t + "===".slice((t.length + 3) % 4);
  let a;
  try {
    a = atob(n);
  } catch {
    return null;
  }
  const i = new Uint8Array(a.length);
  for (let o = 0; o < a.length; o++) i[o] = a.charCodeAt(o);
  return Xo(i) !== e ? null : i;
}
function rg(e) {
  return (e ?? "").normalize("NFC");
}
function Gi(e) {
  const t = rg(e);
  return t ? t === "." || t === ".." ? "dot" : t.includes("/") || t.includes("\\") ? "slash" : /[\u0000-\u001f\u007f]/.test(t) ? "control" : new TextEncoder().encode(t).length > YD ? "too_long" : null : "empty";
}
function a4() {
  return crypto.getRandomValues(new Uint8Array(Px));
}
function Rx() {
  return crypto.getRandomValues(new Uint8Array(Sl));
}
const i4 = Rx;
async function sg(e, t, n) {
  if (e.length !== Px) throw new Error("e2e: name key must be 64 bytes");
  if (n.length !== Sl) throw new Error("e2e: a folder id is 16 bytes");
  return { siv: await jD(e), long: t, rootId: n.slice() };
}
async function Ix(e) {
  const t = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(e));
  return Xo(new Uint8Array(t));
}
async function o4(e, t, n) {
  return (await Cx(e.siv, new TextEncoder().encode(rg(n)), [
    t,
    XD
  ])).slice(0, Sl);
}
function Nl(e) {
  let t = ZD.exec(e);
  if (t) return { kind: "sidecar", hash: t[1] };
  if (t = e4.exec(e), t) {
    const n = _o(t[2]);
    if (n && n.length === Sl) return { kind: "longdir", hash: t[1], dirId: n };
  }
  if (t = QD.exec(e), t) return { kind: "long", hash: t[1] };
  if (t = t4.exec(e), t) {
    const n = _o(t[2]);
    if (n && n.length === Sl) return { kind: "dir", encoded: t[1], dirId: n };
  }
  return e.length >= n4 && Lx.test(e) ? { kind: "file", encoded: e } : { kind: "plain" };
}
function r4(e) {
  return Nl(e).dirId ?? null;
}
async function Wv(e, t, n) {
  return r4(n) ?? o4(e, t, n);
}
async function Yv(e, t, n, a = {}) {
  const i = Gi(t);
  if (i) throw new Error(`e2e: invalid name (${i})`);
  const o = new TextEncoder().encode(rg(t)), l = Xo(await Cx(e.siv, o, [n])), p = a.isDir || !!a.dirId ? a.dirId ?? Rx() : void 0, m = p ? `.${Xo(p)}` : "";
  if (l.length + m.length <= e.long)
    return { stored: l + m, encoded: l, ...p ? { dirId: p } : {} };
  const v = await Ix(l);
  return {
    stored: `${v}${GD}${m}`,
    encoded: l,
    ...p ? { dirId: p } : {},
    sidecar: { name: `${v}${Ox}`, content: l }
  };
}
async function Nx(e, t, n) {
  const a = _o(t);
  if (!a || a.length <= JD) return null;
  try {
    const i = await qD(e.siv, a, [n]);
    return new TextDecoder("utf-8", { fatal: !0 }).decode(i);
  } catch {
    return null;
  }
}
async function H_(e, t, n) {
  const a = await Nx(e, t, n);
  return a === null ? null : Gi(a) ? "unsafe" : a;
}
async function Bx(e, t, n, a) {
  const i = Nl(t);
  if (i.kind === "sidecar") return { name: null, state: "sidecar" };
  if (i.kind === "plain") return { name: t, state: "plain" };
  if (i.kind === "long" || i.kind === "longdir") {
    const c = ((a ? await a(`${i.hash}${Ox}`) : null) ?? "").trim();
    if (!c || await Ix(c) !== i.hash)
      return { name: null, state: "unreadable" };
    const p = await H_(e, c, n);
    return p === null || p === "unsafe" ? { name: null, state: "unreadable" } : { name: p, state: "enc" };
  }
  const o = await H_(e, i.encoded, n);
  return o === "unsafe" ? { name: null, state: "unreadable" } : o !== null ? { name: o, state: "enc" } : i.kind === "dir" ? { name: null, state: "unreadable" } : { name: t, state: "plain" };
}
function op(e) {
  const t = e.lastIndexOf(".");
  return t <= 0 || t === e.length - 1 ? "" : e.slice(t + 1).toLowerCase();
}
const So = 20, s4 = 10, l4 = 24, jr = 7, Hi = 16, Ic = 2, u4 = 4294967295, dc = 12, yi = 97, Gv = 9, Xv = 21, Fx = 48, Jv = 69, Ux = 76, Hx = 32, rp = new TextEncoder().encode("filexe2e");
function Nc(e) {
  return typeof e == "number" && Number.isInteger(e) && e >= s4 && e <= l4;
}
function Bc(e) {
  if (!Nc(e)) throw new Error(`e2e: unsupported chunk size 2^${e}`);
  return 2 ** e;
}
function Kx(e, t, n) {
  if (e.length !== jr) throw new Error("e2e: the nonce prefix must be 7 bytes");
  if (!Number.isInteger(t) || t < 0 || t > u4)
    throw new Error("e2e: too many chunks for one stream");
  const a = new Uint8Array(dc);
  return a.set(e, 0), new DataView(a.buffer).setUint32(jr, t, !1), a[dc - 1] = n ? 1 : 0, a;
}
function Vx(e, t = So) {
  if (!Number.isSafeInteger(e) || e < 0) throw new Error("e2e: bad plaintext size");
  return e === 0 ? 1 : Math.ceil(e / Bc(t));
}
function lg(e, t = So) {
  return e + Hi * Vx(e, t);
}
function c4(e, t = So) {
  if (!Nc(t) || !Number.isSafeInteger(e) || e < Hi) return null;
  const n = 2 ** t + Hi, a = Math.ceil(e / n), i = e - (a - 1) * n;
  return i < Hi || a > 1 && i === Hi ? null : e - Hi * a;
}
function jx() {
  return crypto.getRandomValues(new Uint8Array(jr));
}
class Dp {
  constructor() {
    It(this, "parts", []);
    It(this, "head", 0);
    It(this, "length", 0);
  }
  push(t) {
    t.length !== 0 && (this.parts.push(t), this.length += t.length);
  }
  /** The next `n` bytes (n ≤ length), as a fresh buffer. */
  take(t) {
    if (t > this.length) throw new Error("ByteQueue: not enough bytes");
    const n = new Uint8Array(t);
    let a = 0;
    for (; a < t; ) {
      const i = this.parts[0], o = Math.min(i.length - this.head, t - a);
      n.set(i.subarray(this.head, this.head + o), a), a += o, this.head += o, this.head === i.length && (this.parts.shift(), this.head = 0);
    }
    return this.length -= t, n;
  }
}
function $l(e) {
  if (e instanceof Uint8Array) return e;
  if (e instanceof ArrayBuffer) return new Uint8Array(e);
  if (ArrayBuffer.isView(e)) return new Uint8Array(e.buffer, e.byteOffset, e.byteLength);
  throw new TypeError("e2e: a stream carried something that is not bytes");
}
class Rp {
  constructor(t) {
    It(this, "reader");
    It(this, "q", new Dp());
    It(this, "done", !1);
    this.reader = t.getReader();
  }
  /** Up to `n` bytes; fewer only when the stream ended. */
  async read(t) {
    for (; this.q.length < t && !this.done; ) {
      const { done: n, value: a } = await this.reader.read();
      n ? this.done = !0 : this.q.push($l(a));
    }
    return this.q.take(Math.min(t, this.q.length));
  }
  /** Everything not read yet, as a stream. The reader is spent afterwards. */
  rest() {
    const t = this.q.take(this.q.length), n = this.reader;
    let a = t.length > 0 ? t : null;
    const i = this.done;
    return new ReadableStream({
      async pull(o) {
        if (a) {
          o.enqueue(a), a = null;
          return;
        }
        if (i) {
          o.close();
          return;
        }
        const { done: l, value: c } = await n.read();
        l ? o.close() : o.enqueue($l(c));
      },
      cancel(o) {
        return n.cancel(o);
      }
    });
  }
  cancel(t) {
    return this.reader.cancel(t);
  }
}
function Fc(e, t) {
  const n = t.getReader();
  let a = !1;
  return new ReadableStream({
    async pull(i) {
      if (!a && (a = !0, e.length > 0)) {
        i.enqueue(e);
        return;
      }
      const { done: o, value: l } = await n.read();
      o ? i.close() : i.enqueue($l(l));
    },
    cancel(i) {
      return n.cancel(i);
    }
  });
}
async function d4(e, t = Number.MAX_SAFE_INTEGER) {
  const n = new Dp(), a = e.getReader();
  for (; ; ) {
    const { done: i, value: o } = await a.read();
    if (i) break;
    if (n.push($l(o)), n.length > t)
      throw await a.cancel(), new Error("e2e: more data than expected");
  }
  return n.take(n.length);
}
async function K_(e, t, n, a, i) {
  return new Uint8Array(
    await crypto.subtle.encrypt({ name: "AES-GCM", iv: Kx(t, n, a) }, e, i)
  );
}
async function Zv(e, t, n, a, i) {
  try {
    return new Uint8Array(
      await crypto.subtle.decrypt({ name: "AES-GCM", iv: Kx(t, n, a) }, e, i)
    );
  } catch {
    throw new dn(
      a ? "e2e: the last chunk failed authentication (the file is truncated, extended or damaged)" : `e2e: chunk ${n} failed authentication (the file is damaged, reordered or truncated)`
    );
  }
}
function qx(e, t, n = So, a = {}) {
  const i = Bc(n);
  if (t.length !== jr) throw new Error("e2e: the nonce prefix must be 7 bytes");
  const o = new Dp();
  let l = 0, c = 0;
  return new TransformStream({
    async transform(p, m) {
      var x;
      const v = $l(p);
      if (c += v.length, a.expectSize !== void 0 && c > a.expectSize)
        throw new Error("e2e: the file is longer than it said it was");
      for (o.push(v); o.length > i; )
        m.enqueue(await K_(e, t, l++, !1, o.take(i))), (x = a.onProgress) == null || x.call(a, l * i);
    },
    async flush(p) {
      var m;
      if (a.expectSize !== void 0 && c !== a.expectSize)
        throw new Error("e2e: the file is shorter than it said it was");
      p.enqueue(await K_(e, t, l++, !0, o.take(o.length))), (m = a.onProgress) == null || m.call(a, c);
    }
  });
}
function Wx(e, t, n = So, a = {}) {
  const i = Bc(n) + Hi;
  if (t.length !== jr) throw new Error("e2e: the nonce prefix must be 7 bytes");
  const o = new Dp();
  let l = 0, c = 0;
  const p = (m) => {
    if (c += m.length, a.expectSize !== void 0 && c > a.expectSize)
      throw new dn("e2e: the file holds more than its header says");
    return m;
  };
  return new TransformStream({
    async transform(m, v) {
      for (o.push($l(m)); o.length > i; ) v.enqueue(p(await Zv(e, t, l++, !1, o.take(i))));
    },
    async flush(m) {
      if (o.length < Hi) throw new dn("e2e: the encrypted content is truncated");
      if (l > 0 && o.length === Hi)
        throw new dn("e2e: the encrypted content ends in an empty chunk no writer produces");
      if (m.enqueue(p(await Zv(e, t, l++, !0, o.take(o.length)))), a.expectSize !== void 0 && c !== a.expectSize)
        throw new dn("e2e: the file holds less than its header says");
    }
  });
}
async function f4(e, t, n, a = So) {
  const i = Bc(a), o = i + Hi, l = c4(n.length, a);
  if (l === null) throw new dn("e2e: the encrypted content has an impossible length");
  const c = new Uint8Array(l), p = Vx(l, a);
  for (let m = 0; m < p; m++) {
    const v = m === p - 1, x = n.slice(m * o, v ? n.length : (m + 1) * o);
    c.set(await Zv(e, t, m, v, x), m * i);
  }
  return c;
}
function Yx() {
  return crypto.getRandomValues(new Uint8Array(Hx));
}
async function Ip(e) {
  if (e.length !== Hx) throw new dn("e2e: a file key must be 32 bytes");
  return crypto.subtle.importKey("raw", e, { name: "AES-GCM" }, !1, ["encrypt", "decrypt"]);
}
function p4(e) {
  if (e.wrapIV.length !== dc || e.wrappedDek.length !== Fx)
    throw new Error("e2e: bad wrapped key");
  Bc(e.log2);
  const t = new Uint8Array(yi);
  return t.set(rp, 0), t[8] = Ic, t.set(e.wrapIV, Gv), t.set(e.wrappedDek, Xv), t.set(e.prefix, Jv), t[Ux] = e.log2, t;
}
function Gx(e) {
  if (e.length < yi) throw new Error("e2e: not an encrypted file");
  for (let n = 0; n < rp.length; n++)
    if (e[n] !== rp[n]) throw new Error("e2e: not an encrypted file");
  if (e[8] !== Ic) throw new Error(`e2e: unsupported version ${e[8]}`);
  const t = e[Ux];
  if (!Nc(t)) throw new Error(`e2e: unsupported chunk size 2^${t}`);
  return {
    wrapIV: e.slice(Gv, Gv + dc),
    wrappedDek: e.slice(Xv, Xv + Fx),
    prefix: e.slice(Jv, Jv + jr),
    log2: t
  };
}
function h4(e, t = So) {
  return yi + lg(e, t);
}
async function Xx(e, t, n, a) {
  for (const i of t ? [e, t] : [e]) {
    let o;
    try {
      o = new Uint8Array(await crypto.subtle.decrypt({ name: "AES-GCM", iv: n }, i, a));
    } catch {
      continue;
    }
    try {
      return await Ip(o);
    } finally {
      o.fill(0);
    }
  }
  throw new dn("e2e: DEK unwrap failed (wrong key?)");
}
async function V_(e, t, n, a = {}) {
  const i = a.chunkLog2 ?? So, o = Yx(), l = crypto.getRandomValues(new Uint8Array(dc));
  let c, p;
  try {
    p = new Uint8Array(await crypto.subtle.encrypt({ name: "AES-GCM", iv: l }, e, o)), c = await Ip(o);
  } finally {
    o.fill(0);
  }
  const m = jx(), v = p4({ wrapIV: l, wrappedDek: p, prefix: m, log2: i }), x = n.pipeThrough(
    qx(c, m, i, { expectSize: t, onProgress: a.onProgress })
  );
  return { stream: Fc(v, x), size: h4(t, i) };
}
async function m4(e, t, n) {
  const a = Gx(t), i = await Xx(e, n, a.wrapIV, a.wrappedDek);
  return (await f4(i, a.prefix, t.subarray(yi), a.log2)).buffer;
}
const v4 = 200 * 1024 * 1024 + yi + 16;
function Qv(e, t, n, a = {}) {
  const i = new Rp(n);
  let o = null;
  return new ReadableStream({
    async start(l) {
      var w;
      const c = await i.read(yi);
      if (!(c.length >= 8 && rp.every((S, k) => c[k] === S))) {
        if (!a.passPlain) throw new Error("e2e: not an encrypted file");
        (w = a.onPlain) == null || w.call(a), o = Fc(c, i.rest()).getReader();
        return;
      }
      if (c.length < yi) throw new dn("e2e: the encrypted file is truncated");
      if (c[8] === Ic) {
        const S = Gx(c), k = await Xx(e, t, S.wrapIV, S.wrappedDek);
        o = i.rest().pipeThrough(Wx(k, S.prefix, S.log2)).getReader();
        return;
      }
      if (c[8] !== 1) throw new Error(`e2e: unsupported version ${c[8]}`);
      const m = await d4(i.rest(), v4 - yi), v = new Uint8Array(yi + m.length);
      v.set(c, 0), v.set(m, yi);
      let x;
      try {
        x = await up(e, v.buffer);
      } catch (S) {
        if (!t || !(S instanceof dn)) throw S;
        x = await up(t, v.buffer);
      }
      l.enqueue(new Uint8Array(x)), l.close();
    },
    async pull(l) {
      if (!o) return;
      const { done: c, value: p } = await o.read();
      c ? l.close() : l.enqueue(p);
    },
    cancel(l) {
      return o ? o.cancel(l) : i.cancel(l);
    }
  });
}
const y4 = yi, fc = "vault", Jx = 1, g4 = 16, b4 = 24, Zx = 22, k4 = 24, w4 = [Zx, k4], ug = 16, Hpe = 25e4;
function _4(e) {
  return typeof e == "number" && Number.isInteger(e) && e >= g4 && e <= b4;
}
function Qx() {
  return import("./keys-DipYOEOJ.js");
}
const ga = ".filex-e2e.json", x4 = "filexe2e", cg = 1, Np = 2, $o = 3, S4 = ["names", "rekey", "conv", fc], Bp = 6e5, Fp = 6e5, eS = 1e8, ec = 200 * 1024 * 1024, sp = 8, Cf = 20, tS = "RSA-OAEP-256", Qo = "filex-e2e-verify-v1", zf = new TextEncoder().encode(x4), pc = 97, cl = 9, dl = 21, nS = 48, ey = 69, ji = 12, ki = 32, $4 = "filex-e2e-recovery-v1", T4 = 16;
class dn extends Error {
  constructor(t = "e2e: decrypt failed") {
    super(t), this.name = "E2eDecryptError";
  }
}
function Ma(e) {
  let t = "";
  for (let n = 0; n < e.length; n++) t += String.fromCharCode(e[n]);
  return btoa(t);
}
function ea(e) {
  const t = atob(e), n = new Uint8Array(t.length);
  for (let a = 0; a < t.length; a++) n[a] = t.charCodeAt(a);
  return n;
}
function gn(e) {
  return new Uint8Array(e).buffer;
}
function A4(e, t) {
  const n = new Uint8Array(e.length + t.length);
  return n.set(e, 0), n.set(t, e.length), Ma(n);
}
async function ni(e, t) {
  const n = crypto.getRandomValues(new Uint8Array(ji)), a = new Uint8Array(
    await crypto.subtle.encrypt({ name: "AES-GCM", iv: gn(n) }, e, gn(t))
  );
  return A4(n, a);
}
function j_(e, t) {
  return ni(e, t);
}
function q_(e, t) {
  return Ba(e, t);
}
async function Ba(e, t) {
  let n;
  try {
    n = ea(t);
  } catch {
    return null;
  }
  if (n.length <= ji) return null;
  try {
    const a = await crypto.subtle.decrypt(
      { name: "AES-GCM", iv: gn(n.slice(0, ji)) },
      e,
      gn(n.slice(ji))
    );
    return new Uint8Array(a);
  } catch {
    return null;
  }
}
async function er(e, t, n) {
  const a = await crypto.subtle.importKey(
    "raw",
    new TextEncoder().encode(e),
    "PBKDF2",
    !1,
    ["deriveKey"]
  );
  return crypto.subtle.deriveKey(
    { name: "PBKDF2", salt: gn(t), iterations: n, hash: "SHA-256" },
    a,
    { name: "AES-GCM", length: 256 },
    !1,
    // non-extractable
    ["encrypt", "decrypt"]
  );
}
async function dg(e, t, n) {
  const a = await crypto.subtle.importKey(
    "raw",
    new TextEncoder().encode(e),
    "PBKDF2",
    !1,
    ["deriveBits"]
  ), i = await crypto.subtle.deriveBits(
    { name: "PBKDF2", salt: gn(t), iterations: n, hash: "SHA-256" },
    a,
    ki * 8
  );
  return new Uint8Array(i);
}
async function hc(e) {
  return crypto.subtle.importKey("raw", gn(e), { name: "AES-GCM" }, !1, [
    "encrypt",
    "decrypt"
  ]);
}
async function fg(e, t) {
  return qr(e) ? (await Qx()).importVaultFmk(t) : hc(t);
}
const ty = "0123456789ABCDEFGHJKMNPQRSTVWXYZ";
function E4(e) {
  let t = 0, n = 0, a = "";
  for (let i = 0; i < e.length; i++)
    for (n = n << 8 | e[i], t += 8; t >= 5; )
      a += ty[n >>> t - 5 & 31], t -= 5;
  return t > 0 && (a += ty[n << 5 - t & 31]), (a.match(/.{1,4}/g) || []).join("-");
}
function Up() {
  return E4(crypto.getRandomValues(new Uint8Array(Cf)));
}
function pg(e) {
  const t = (e || "").toUpperCase().replace(/[\s-]/g, "").replace(/O/g, "0").replace(/[IL]/g, "1"), n = Math.ceil(Cf * 8 / 5);
  if (t.length !== n) return null;
  const a = new Uint8Array(Cf);
  let i = 0, o = 0, l = 0;
  for (const c of t) {
    const p = ty.indexOf(c);
    if (p < 0) return null;
    i = i << 5 | p, o += 5, o >= 8 && (a[l++] = i >>> o - 8 & 255, o -= 8);
  }
  return l === Cf ? a : null;
}
async function hg(e, t) {
  const n = await crypto.subtle.importKey("raw", gn(e), "HKDF", !1, ["deriveKey"]);
  return crypto.subtle.deriveKey(
    {
      name: "HKDF",
      hash: "SHA-256",
      salt: gn(t),
      info: gn(new TextEncoder().encode($4))
    },
    n,
    { name: "AES-GCM", length: 256 },
    !1,
    ["encrypt", "decrypt"]
  );
}
async function Hp(e, t) {
  const n = pg(t);
  if (!n) throw new Error("e2e: malformed recovery key");
  const a = crypto.getRandomValues(new Uint8Array(T4)), i = await hg(n, a), o = { salt: Ma(a), blob: await ni(i, e) };
  return n.fill(0), o;
}
async function C4(e) {
  return crypto.subtle.importKey(
    "spki",
    gn(ea(e)),
    { name: "RSA-OAEP", hash: "SHA-256" },
    !0,
    ["encrypt"]
  );
}
async function aS(e) {
  const t = (e || "").replace(/-----[A-Z ]+-----/g, "").replace(/\s+/g, "");
  return crypto.subtle.importKey(
    "pkcs8",
    gn(ea(t)),
    { name: "RSA-OAEP", hash: "SHA-256" },
    !1,
    ["decrypt"]
  );
}
async function iS(e) {
  const t = new Uint8Array(await crypto.subtle.digest("SHA-256", gn(ea(e))));
  return Array.from(t.slice(0, 8)).map((n) => n.toString(16).padStart(2, "0")).join("");
}
async function Uc(e, t) {
  const n = await C4(t), a = new Uint8Array(await crypto.subtle.encrypt({ name: "RSA-OAEP" }, n, gn(e)));
  return { kid: await iS(t), alg: tS, blob: Ma(a) };
}
async function Kpe(e, t = Bp) {
  const n = Math.max(Fp, t), a = crypto.getRandomValues(new Uint8Array(16)), i = await er(e, a, n), o = await ni(i, new TextEncoder().encode(Qo));
  return { marker: { v: 1, salt: Ma(a), iter: n, verify: o }, kek: i };
}
async function oS(e, t) {
  const n = a4(), a = i4(), i = {
    alg: zx,
    enc: Mx,
    long: WD,
    key: await ni(e, n),
    root_id: Xo(a)
  };
  t && (i.pending = !0);
  const o = await sg(n, i.long, a);
  return n.fill(0), { slot: i, key: o };
}
async function ny(e, t = {}) {
  const n = Math.max(Fp, t.iterations ?? Bp), a = crypto.getRandomValues(new Uint8Array(16)), i = await er(e, a, n), o = crypto.getRandomValues(new Uint8Array(ki)), l = Up(), c = {
    v: Np,
    salt: Ma(a),
    iter: n,
    verify: await ni(i, new TextEncoder().encode(Qo)),
    fmk: "wrapped",
    fmk_pw: await ni(i, o),
    rk: await Hp(o, l)
  };
  t.escrowPublicKey && (c.esc = await Uc(o, t.escrowPublicKey));
  const p = await hc(o);
  if (o.fill(0), !t.encryptNames) return { marker: c, fmk: p, recoveryKey: l };
  const m = await oS(p, !1);
  return c.v = $o, c.req = ["names"], c.names = m.slot, { marker: c, fmk: p, recoveryKey: l, names: m.key };
}
async function z4(e, t = {}) {
  const n = t.packLog2 ?? Zx;
  if (!w4.includes(n)) throw new Error(`e2e: a vault's packs are 2^22 or 2^24 bytes, not 2^${n}`);
  const [{ importVaultFmk: a }, { cryptoRandom: i, sealIndexFile: o }, { encodeIndexBody: l }] = await Promise.all([
    Qx(),
    import("./writer-D15dP8hs.js").then((C) => C.w),
    import("./vindex-BdgPjmq3.js")
  ]), c = Math.max(Fp, t.iterations ?? Bp), p = crypto.getRandomValues(new Uint8Array(16)), m = await er(e, p, c), v = crypto.getRandomValues(new Uint8Array(ki)), x = Up(), w = crypto.getRandomValues(new Uint8Array(ug)), S = {
    v: $o,
    req: [fc],
    salt: Ma(p),
    iter: c,
    verify: await ni(m, new TextEncoder().encode(Qo)),
    fmk: "wrapped",
    fmk_pw: await ni(m, v),
    rk: await Hp(v, x)
  };
  t.escrowPublicKey && (S.esc = await Uc(v, t.escrowPublicKey)), S.vault = { v: Jx, id: Xo(w), pack: n };
  const k = await a(v);
  v.fill(0);
  const b = await o(k, w, 1, l(/* @__PURE__ */ new Map(), []).body, i);
  return { marker: S, fmk: k, recoveryKey: x, vaultId: w, index: b };
}
async function M4(e, t, n = {}) {
  if (e.v !== 1) throw new Error("e2e: not a v1 marker");
  const a = ea(e.salt), i = await er(t, a, e.iter), o = await Ba(i, e.verify);
  if (!o || new TextDecoder().decode(o) !== Qo)
    throw new dn("e2e: wrong password");
  const l = await dg(t, a, e.iter), c = Up(), p = {
    v: Np,
    salt: e.salt,
    iter: e.iter,
    verify: e.verify,
    fmk: "kek",
    rk: await Hp(l, c)
  };
  return n.escrowPublicKey && (p.esc = await Uc(l, n.escrowPublicKey)), l.fill(0), { marker: p, fmk: i, recoveryKey: c };
}
async function P4(e, t, n) {
  if (!Xi(e)) throw new Error("e2e: not a v2 marker");
  if (e.esc) throw new Error("e2e: this folder already has an escrow slot");
  if (!n) throw new Error("e2e: no escrow public key");
  const a = ea(e.salt), i = await er(t, a, e.iter), o = await Ba(i, e.verify);
  if (!o || new TextDecoder().decode(o) !== Qo)
    throw new dn("e2e: wrong password");
  let l;
  if (e.fmk === "wrapped") {
    const m = e.fmk_pw ? await Ba(i, e.fmk_pw) : null;
    if (!m || m.length !== ki)
      throw new dn("e2e: could not unwrap the folder master key");
    l = m;
  } else
    l = await dg(t, a, e.iter);
  const c = await Uc(l, n);
  l.fill(0);
  const p = { ...e, esc: c };
  return delete p.esc_declined, p;
}
function O4(e, t) {
  return { ...e, esc_declined: t };
}
function W_(e, t) {
  return !t || !e || !Xi(e) || e.esc ? "n/a" : e.esc_declined ? "declined" : "offer";
}
function Xi(e) {
  return e.v === 2 || e.v === $o;
}
function lp(e) {
  let t;
  try {
    t = JSON.parse(e);
  } catch {
    return null;
  }
  if (!t || typeof t != "object" || t.v !== 1 && !Xi(t) || typeof t.salt != "string" || typeof t.verify != "string" || typeof t.iter != "number" || !Number.isInteger(t.iter) || t.iter < 1 || t.iter > eS || Xi(t) && (t.fmk !== "kek" && t.fmk !== "wrapped" || t.fmk === "wrapped" && typeof t.fmk_pw != "string"))
    return null;
  const n = [];
  if (t.v === $o) {
    if (!Array.isArray(t.req) || t.req.some((a) => typeof a != "string")) return null;
    for (const a of t.req) S4.includes(a) || n.push(a);
    if (t.req.includes(fc)) {
      if (t.req.length !== 1 || t.fmk !== "wrapped" || typeof t.fmk_pw != "string" || t.names !== void 0 || t.rekey !== void 0 || t.conv !== void 0) return null;
      const a = L4(t.vault);
      if (a === "malformed") return null;
      a === "newer" && n.push(`${fc} v${t.vault.v}`);
    } else if (t.vault !== void 0)
      return null;
    if (t.req.includes("names") && !D4(t.names)) return null;
    if (t.req.includes("rekey")) {
      if (t.fmk !== "wrapped" || !t.rekey || typeof t.rekey.from != "string") return null;
    } else if (t.rekey !== void 0)
      return null;
    if (t.req.includes("conv")) {
      if (!t.conv || typeof t.conv != "object" || t.conv.pending !== !0) return null;
    } else if (t.conv !== void 0)
      return null;
  } else if (t.req !== void 0 || t.names !== void 0 || t.rekey !== void 0 || t.conv !== void 0 || t.vault !== void 0)
    return null;
  return { marker: t, unsupported: n };
}
function L4(e) {
  var n;
  if (!e || typeof e != "object" || Array.isArray(e)) return "malformed";
  const t = e;
  return typeof t.v != "number" || !Number.isInteger(t.v) || t.v < 1 || typeof t.id != "string" || ((n = _o(t.id)) == null ? void 0 : n.length) !== ug || !_4(t.pack) ? "malformed" : t.v > Jx ? "newer" : null;
}
function qr(e) {
  return !!e && e.v === $o && Array.isArray(e.req) && e.req.length === 1 && e.req[0] === fc && !!e.vault;
}
function Vpe(e) {
  if (!qr(e)) return null;
  const t = _o(e.vault.id);
  return t && t.length === ug ? t : null;
}
function D4(e) {
  var t;
  return !!e && typeof e == "object" && e.alg === zx && e.enc === Mx && typeof e.key == "string" && typeof e.long == "number" && Number.isInteger(e.long) && e.long >= 64 && e.long <= 255 && typeof e.root_id == "string" && ((t = _o(e.root_id)) == null ? void 0 : t.length) === Sl;
}
function jpe(e) {
  const t = lp(e);
  return !t || t.unsupported.length > 0 ? null : t.marker;
}
function qi(e) {
  return !!e && e.v === $o && Array.isArray(e.req) && e.req.includes("names") && !!e.names;
}
async function R4(e, t) {
  if (!qi(e)) return null;
  const n = await Ba(t, e.names.key);
  if (!n || n.length !== 64) return null;
  const a = await sg(n, e.names.long, _o(e.names.root_id));
  return n.fill(0), a;
}
async function Y_(e, t) {
  if (e.v !== 2) throw new Error("e2e: only a v2 folder can switch to encrypted names");
  const n = await oS(t, !0);
  return { marker: {
    ...e,
    v: $o,
    req: ["names"],
    names: n.slot
  }, names: n.key };
}
function I4(e) {
  if (!qi(e)) throw new Error("e2e: this folder has no encrypted names");
  const t = { ...e.names };
  return delete t.pending, { ...e, names: t };
}
const N4 = ["content", "names", "vault"], qpe = "content";
function Wpe(e = {}) {
  return N4.filter((t) => t !== "vault" || e.vault === !0);
}
function B4(e) {
  return qr(e) ? "vault" : e && qi(e) ? e.names.pending ? "pending" : "names" : "content";
}
function F4(e) {
  return !!e && e.v === 2 && !qi(e);
}
function G_(e) {
  return !!e && Xi(e) && !!e.rk;
}
function rS(e) {
  return !!e && Xi(e) && !!e.esc;
}
function sS(e, t) {
  return t ? rS(e) ? e.esc.kid === t ? "available" : "other-key" : "predates" : "off";
}
async function lS(e, t) {
  const n = await er(t, ea(e.salt), e.iter), a = await Ba(n, e.verify);
  return !a || new TextDecoder().decode(a) !== Qo ? null : n;
}
async function uS(e, t) {
  if (e.v === 1 || e.fmk === "kek") return t;
  if (!e.fmk_pw) return null;
  const n = await Ba(t, e.fmk_pw);
  if (!n || n.length !== ki) return null;
  const a = await fg(e, n);
  return n.fill(0), a;
}
async function Ype(e, t) {
  const n = await lS(e, t);
  return n ? uS(e, n) : null;
}
async function cS(e, t) {
  const n = await lS(e, t);
  if (!n) return { error: "wrong" };
  const a = await uS(e, n);
  return a ? { fmk: a } : { error: "damaged" };
}
async function dS(e, t) {
  if (!Xi(e) || !e.rk) return null;
  const n = pg(t);
  if (!n) return null;
  let a;
  try {
    a = ea(e.rk.salt);
  } catch {
    return null;
  }
  const i = await hg(n, a);
  n.fill(0);
  const o = await Ba(i, e.rk.blob);
  if (!o || o.length !== ki) return null;
  const l = await fg(e, o);
  return o.fill(0), l;
}
async function fS(e, t) {
  if (!Xi(e) || !e.esc || e.esc.alg !== tS) return null;
  let n;
  try {
    n = new Uint8Array(
      await crypto.subtle.decrypt(
        { name: "RSA-OAEP" },
        t,
        gn(ea(e.esc.blob))
      )
    );
  } catch {
    return null;
  }
  if (n.length !== ki) return null;
  const a = await fg(e, n);
  return n.fill(0), a;
}
function Tl(e) {
  const t = e instanceof Uint8Array ? e : new Uint8Array(e);
  if (t.length < zf.length) return !1;
  for (let n = 0; n < zf.length; n++)
    if (t[n] !== zf[n]) return !1;
  return !0;
}
async function ay(e, t) {
  if (t.byteLength > ec)
    throw new Error("e2e: file exceeds the 200MB single-shot limit");
  const n = crypto.getRandomValues(new Uint8Array(32)), a = await crypto.subtle.importKey("raw", gn(n), { name: "AES-GCM" }, !1, [
    "encrypt"
  ]), i = crypto.getRandomValues(new Uint8Array(ji)), o = crypto.getRandomValues(new Uint8Array(ji)), l = new Uint8Array(
    await crypto.subtle.encrypt({ name: "AES-GCM", iv: gn(i) }, e, gn(n))
  ), c = new Uint8Array(
    await crypto.subtle.encrypt({ name: "AES-GCM", iv: gn(o) }, a, t)
  );
  n.fill(0);
  const p = new Uint8Array(pc + c.length);
  return p.set(zf, 0), p[8] = cg, p.set(i, cl), p.set(l, dl), p.set(o, ey), p.set(c, pc), p.buffer;
}
async function up(e, t) {
  const n = new Uint8Array(t);
  if (!Tl(n) || n.length < pc)
    throw new Error("e2e: not an encrypted file");
  if (n[8] === Ic) return m4(e, n);
  if (n[8] !== cg)
    throw new Error(`e2e: unsupported version ${n[8]}`);
  const a = n.slice(cl, cl + ji), i = n.slice(dl, dl + nS), o = n.slice(ey, ey + ji);
  let l;
  try {
    l = await crypto.subtle.decrypt({ name: "AES-GCM", iv: gn(a) }, e, gn(i));
  } catch {
    throw new dn("e2e: DEK unwrap failed (wrong key?)");
  }
  const c = await crypto.subtle.importKey("raw", l, { name: "AES-GCM" }, !1, ["decrypt"]);
  try {
    return await crypto.subtle.decrypt(
      { name: "AES-GCM", iv: gn(o) },
      c,
      gn(n.slice(pc))
    );
  } catch {
    throw new dn("e2e: content decrypt failed");
  }
}
async function pS(e, t) {
  if ("recoveryKey" in t) {
    if (!Xi(e) || !e.rk) throw new dn("e2e: this folder has no recovery key");
    const l = pg(t.recoveryKey);
    if (!l) throw new dn("e2e: wrong recovery key");
    let c;
    try {
      c = ea(e.rk.salt);
    } catch {
      throw new dn("e2e: damaged recovery slot");
    }
    const p = await hg(l, c);
    l.fill(0);
    const m = await Ba(p, e.rk.blob);
    if (!m || m.length !== ki) throw new dn("e2e: wrong recovery key");
    return m;
  }
  const n = ea(e.salt), a = await er(t.password, n, e.iter), i = await Ba(a, e.verify);
  if (!i || new TextDecoder().decode(i) !== Qo)
    throw new dn("e2e: wrong password");
  if (e.v === 1 || e.fmk === "kek") return dg(t.password, n, e.iter);
  const o = e.fmk_pw ? await Ba(a, e.fmk_pw) : null;
  if (!o || o.length !== ki) throw new dn("e2e: could not unwrap the folder master key");
  return o;
}
async function hS(e, t, n) {
  if ((e ?? "").length < sp)
    throw new Error(`e2e: the new password must be at least ${sp} characters`);
  const a = Math.max(Fp, n ?? Bp), i = crypto.getRandomValues(new Uint8Array(16)), o = await er(e, i, a);
  return {
    salt: Ma(i),
    iter: a,
    verify: await ni(o, new TextEncoder().encode(Qo)),
    fmk: "wrapped",
    fmk_pw: await ni(o, t)
  };
}
function mS(e) {
  return e.v === 1 || e.fmk === "kek";
}
function fl(e) {
  return !!e && Array.isArray(e.req) && e.req.includes("rekey") && !!e.rekey;
}
async function vS(e, t, n, a = {}) {
  if (mS(e))
    throw new Error("e2e: this folder needs its file keys re-wrapped to change its password (startRekey)");
  if (fl(e)) throw new Error("e2e: finish the re-key first");
  const i = await pS(e, t);
  try {
    return { ...e, ...await hS(n, i, a.iterations) };
  } finally {
    i.fill(0);
  }
}
class yS extends Error {
  constructor(t = "e2e: the escrow slot cannot be carried over to the new folder key") {
    super(t), this.name = "E2eRekeyEscrowError";
  }
}
async function U4(e, t, n, a = {}) {
  if (fl(e)) throw new Error("e2e: a re-key is already in progress; resume it");
  if (qr(e)) throw new Error("e2e: a vault is not re-keyed; make a new vault instead");
  const i = await pS(e, t), o = crypto.getRandomValues(new Uint8Array(ki));
  try {
    const l = await hc(i), c = await hc(o);
    let p;
    if (Xi(e) && e.esc) {
      const b = a.escrowPublicKey || null;
      if (!b || await iS(b) !== e.esc.kid) throw new yS();
      p = await Uc(o, b);
    }
    const m = "recoveryKey" in t, v = m ? t.recoveryKey : Up();
    let x, w;
    if (qi(e)) {
      const b = await Ba(l, e.names.key);
      if (!b || b.length !== 64) throw new dn("e2e: could not open the name key");
      w = { ...e.names, key: await ni(c, b) }, x = await sg(b, e.names.long, _o(e.names.root_id)), b.fill(0);
    }
    const S = Array.from(/* @__PURE__ */ new Set([...e.req ?? [], "rekey"])), k = {
      ...e,
      v: $o,
      req: S,
      ...await hS(n, o, a.iterations),
      rk: await Hp(o, v),
      rekey: { from: await ni(c, i), pending: !0 }
    };
    return p && (k.esc = p), w && (k.names = w), {
      marker: k,
      fmk: c,
      previous: l,
      recoveryKey: v,
      recoveryKeyIsNew: !m,
      ...x ? { names: x } : {}
    };
  } finally {
    i.fill(0), o.fill(0);
  }
}
async function H4(e, t) {
  if (!fl(e)) return null;
  const n = await Ba(t, e.rekey.from);
  if (!n || n.length !== ki) return null;
  const a = await hc(n);
  return n.fill(0), a;
}
async function gS(e, t, n) {
  const a = new Uint8Array(e);
  if (!Tl(a) || a.length < pc) throw new Error("e2e: not an encrypted file");
  if (a[8] !== cg && a[8] !== Ic) throw new Error(`e2e: unsupported version ${a[8]}`);
  const i = a.slice(cl, cl + ji), o = a.slice(dl, dl + nS);
  try {
    return await crypto.subtle.decrypt({ name: "AES-GCM", iv: gn(i) }, n, gn(o)), null;
  } catch {
  }
  let l;
  try {
    l = new Uint8Array(
      await crypto.subtle.decrypt({ name: "AES-GCM", iv: gn(i) }, t, gn(o))
    );
  } catch {
    throw new dn("e2e: this file opens under neither the new nor the previous folder key");
  }
  const c = crypto.getRandomValues(new Uint8Array(ji)), p = new Uint8Array(
    await crypto.subtle.encrypt({ name: "AES-GCM", iv: gn(c) }, n, gn(l))
  );
  l.fill(0);
  const m = a.slice();
  return m.set(c, cl), m.set(p, dl), m.buffer;
}
function X_(e) {
  var t;
  return !!e && Array.isArray(e.req) && e.req.includes("conv") && ((t = e.conv) == null ? void 0 : t.pending) === !0;
}
function K4(e, t = (/* @__PURE__ */ new Date()).toISOString(), n) {
  if (qr(e)) throw new Error("e2e: a vault is never converted");
  const a = Array.from(/* @__PURE__ */ new Set([...e.req ?? [], "conv"])), i = { pending: !0, started: t, ...n ? { cleanup: n } : {} };
  return { ...e, v: $o, req: a, conv: i };
}
function V4(e) {
  const t = { ...e };
  delete t.conv;
  const n = (e.req ?? []).filter((a) => a !== "conv");
  return n.length > 0 ? t.req = n : (delete t.req, t.v = Np), t;
}
function j4(e) {
  const t = { ...e };
  delete t.rekey;
  const n = (e.req ?? []).filter((a) => a !== "rekey");
  return n.length > 0 ? t.req = n : (delete t.req, t.v = Np), t;
}
async function q4(e, t, n) {
  try {
    return await up(e, n);
  } catch (a) {
    if (!t || !(a instanceof dn)) throw a;
    return up(t, n);
  }
}
function W4() {
  const e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map();
  return {
    get(a) {
      return e.get(a);
    },
    set(a, i, o, l) {
      e.set(a, i), o ? t.set(a, o) : t.delete(a), l ? n.set(a, l) : n.delete(a);
    },
    /** The previous FMK of a folder mid re-key (files not re-wrapped yet). */
    previous(a) {
      return n.get(a);
    },
    /** A re-key finished: the previous FMK is no longer needed. */
    dropPrevious(a) {
      n.delete(a);
    },
    /** The folder's name key; undefined for a content-only folder or a locked one. */
    names(a) {
      return t.get(a);
    },
    setNames(a, i) {
      e.has(a) && t.set(a, i);
    },
    /** Every unlocked root, for resolving a path from any view. */
    roots() {
      return [...e.keys()];
    },
    /** Drop one folder's keys ("Lock"). */
    lock(a) {
      e.delete(a), t.delete(a), n.delete(a);
    },
    has(a) {
      return e.has(a);
    },
    clear() {
      e.clear(), t.clear(), n.clear();
    }
  };
}
function mg(e) {
  const t = e.indexOf("://");
  return t === -1 ? e : e.slice(t + 3);
}
function Y4(e) {
  const t = mg(String(e ?? "")), n = t.lastIndexOf("/");
  return n === -1 ? "" : t.slice(0, n);
}
function Ir(e) {
  return typeof e.e2e_display_dir == "string" ? e.e2e_display_dir : Y4(e.path);
}
function G4(e) {
  return (e || []).filter((t) => !(zp(t.basename) || Wf(t.path) || t.basename === ".trash" || t.basename === ga));
}
const bS = "filex.showHidden";
function X4() {
  try {
    return localStorage.getItem(bS) === "1";
  } catch {
    return !1;
  }
}
const tc = $(X4());
function J4(e) {
  tc.value = e;
  try {
    localStorage.setItem(bS, e ? "1" : "0");
  } catch {
  }
}
function Z4(e, t) {
  return t ? e || [] : (e || []).filter((n) => !(n.basename || "").startsWith("."));
}
function Mr(e) {
  return Z4(G4(e), tc.value);
}
function Q4(e) {
  const t = mg(e);
  return t === "fileman" || t === "";
}
function e5(e) {
  return mg(e).startsWith("fileman/.trash");
}
function t5(e) {
  return {
    type: "dir",
    path: `${e}://fileman/.trash`,
    basename: ".trash",
    extension: "",
    storage: e,
    visibility: "private",
    size: 0,
    file_size: 0,
    mime_type: "inode/directory",
    extra_metadata: {}
  };
}
function kS(e, t, n, a, i = {}) {
  return !a || i.navOffersTrash || i.isSearchResult || e5(n) || !Q4(n) ? !1 : (e.unshift(t5(t)), !0);
}
async function wS(e, t, n) {
  try {
    const { storages: a } = await n.listTrash(t, { limit: 1 }), i = e.find((c) => c.basename === ".trash");
    if (!i) return;
    const o = (a ?? []).find((c) => c.storage_name === t);
    i.size = (o == null ? void 0 : o.bytes) ?? 0;
    const l = o != null && o.newest_deleted_at ? Date.parse(o.newest_deleted_at) : NaN;
    Number.isNaN(l) || (i.last_modified = l);
  } catch {
  }
}
const _S = {
  /* gorunum:v3-shell — Home is a destination like the rest, so it gets a
     sentinel like the rest: a restored tab, a reload and a pasted `#.home`
     all have to reopen the overview instead of asking the backend for a
     folder called `.home` and landing on "not found". */
  ".home": "node.home",
  ".trash": "node.trash",
  ".recent": "node.recent",
  ".starred": "node.starred",
  ".shared": "node.shared",
  /* Drafts (issue #71): a view like the rest — a reload on `#.drafts` opens
     it, instead of asking the backend for a folder called `.drafts`. */
  ".drafts": "node.drafts"
}, xS = ".tag~", SS = [
  [".mytag~", "personal"],
  [".teamtag~", "team"],
  [xS, ""]
];
function n5(e, t = "") {
  var a;
  return `${((a = SS.find(([, i]) => i === t)) == null ? void 0 : a[0]) ?? xS}${e}`;
}
function vg(e) {
  for (const [t, n] of SS)
    if (e.startsWith(t)) {
      const a = e.slice(t.length);
      return a ? { tag: a, kind: n } : null;
    }
  return null;
}
function $S(e) {
  var t;
  return ((t = vg(e)) == null ? void 0 : t.tag) ?? "";
}
function a5(e) {
  var n;
  const t = (e || "").replace(/^\/+|\/+$/g, "");
  return ((n = vg(t.split("/").pop() || t)) == null ? void 0 : n.kind) ?? "";
}
function i5(e) {
  const t = (e || "").replace(/^\/+|\/+$/g, "");
  return $S(t.split("/").pop() || t);
}
function cp(e, t) {
  const n = _S[e];
  if (n) return t(n);
  const a = vg(e);
  return a ? a.kind ? `#${a.tag} · ${t(`tags.kind.${a.kind}`)}` : `#${a.tag}` : "";
}
function TS(e) {
  const t = String(e ?? "").replace(/^\/+|\/+$/g, "");
  return t ? !!_S[t] || !!$S(t) : !1;
}
function dp(e, t) {
  const n = e.type === "dir" ? 0 : 1, a = t.type === "dir" ? 0 : 1;
  return n - a;
}
function Kp() {
  return { w: {}, hidden: [] };
}
function Vp(e, t) {
  const n = Kp();
  if (!e || typeof e != "object" || Array.isArray(e)) return n;
  const a = (p) => t.find((m) => m.id === p), i = e, o = {};
  if (i.w && typeof i.w == "object")
    for (const [p, m] of Object.entries(i.w)) {
      const v = a(p);
      !v || typeof m != "number" || !Number.isFinite(m) || (o[v.id] = Math.min(v.max, Math.max(v.min, Math.round(m))));
    }
  const l = Array.isArray(i.hidden) ? [...new Set(i.hidden.filter((p) => {
    var m;
    return (m = a(p)) == null ? void 0 : m.hideable;
  }))] : [], c = Array.isArray(i.o) ? [...new Set(i.o.filter((p) => !!a(p)))] : void 0;
  return c && c.length ? { w: o, hidden: l, o: c } : { w: o, hidden: l };
}
function AS(e, t, n) {
  const a = [...e];
  if (t < 0 || t >= a.length) return a;
  const i = Math.max(0, Math.min(a.length - 1, n));
  if (i === t) return a;
  const [o] = a.splice(t, 1);
  return a.splice(i, 0, o), a;
}
function ES(e, t) {
  const n = (o) => {
    var l;
    return ((l = t.find((c) => c.id === o)) == null ? void 0 : l.hideable) === !0;
  };
  let a = 0;
  for (; a < e.length && !n(e[a]); ) a++;
  let i = e.length - 1;
  for (; i >= 0 && !n(e[i]); ) i--;
  return { lo: a, hi: Math.max(a, i) };
}
const o5 = 3;
function CS(e, t, n = {}) {
  var A;
  const a = n.lead ?? ((A = e()[0]) == null ? void 0 : A.id), i = E(() => Vp(t.get(), e())), o = (L) => e().find((z) => z.id === L);
  function l(L) {
    t.set(L);
  }
  function c() {
    const L = e().map((U) => U.id), z = i.value.o;
    if (!z || z.length === 0)
      return [a, ...L.filter((U) => U !== a)];
    const D = z.filter((U) => L.includes(U) && U !== a);
    D.unshift(a);
    for (const U of L) D.includes(U) || D.push(U);
    return D;
  }
  function p(L) {
    const z = o(L);
    return z ? i.value.w[L] ?? z.width : 0;
  }
  function m(L, z) {
    const D = o(L);
    if (!D || !D.resizable) return;
    const U = Math.min(D.max, Math.max(D.min, Math.round(z)));
    i.value.w[L] !== U && l({ ...i.value, w: { ...i.value.w, [L]: U } });
  }
  function v() {
    return i.value.w[a] === void 0;
  }
  function x(L) {
    const z = { ...i.value.w };
    let D = !1;
    for (const [U, q] of Object.entries(L)) {
      if (typeof q != "number" || !Number.isFinite(q) || z[U] !== void 0) continue;
      const P = o(U);
      !P || !P.resizable || (z[U] = Math.min(P.max, Math.max(P.min, Math.round(q))), D = !0);
    }
    D && l({ ...i.value, w: z });
  }
  function w(L) {
    return i.value.hidden.includes(L);
  }
  function S(L, z) {
    const D = o(L);
    if (!D || !D.hideable || L === a || w(L) === z) return;
    const U = new Set(i.value.hidden);
    z ? U.add(L) : U.delete(L), l({ ...i.value, hidden: [...U] });
  }
  function k(L, z) {
    const D = o(L);
    if (!D || !D.hideable || L === a) return;
    const U = c(), q = U.indexOf(L);
    if (q === -1) return;
    const P = ES(U, e()), R = Math.max(P.lo, Math.min(P.hi, z)), W = AS(U, q, R);
    W.join() !== U.join() && l({ ...i.value, o: W });
  }
  function b() {
    l(Kp());
  }
  function C() {
    var L;
    return t.customised ? t.customised() : Object.keys(i.value.w).length > 0 || i.value.hidden.length > 0 || (((L = i.value.o) == null ? void 0 : L.length) ?? 0) > 0;
  }
  function T(L, z, D = {}) {
    var _;
    const U = D.gap ?? 8, q = D.padding ?? 24, P = D.check ?? 0, R = D.menu ?? 28, W = o(a), N = c().filter((Q) => Q !== a && z.includes(Q) && !w(Q)), J = {};
    for (const Q of N) J[Q] = p(Q);
    J[a] = p(a);
    const H = (Q) => {
      const K = (P > 0 ? 1 : 0) + 1 + Q + 1;
      return P + R + q + U * (K - 1);
    }, ne = H(N.length), j = v(), re = D.leadAuto ?? (W == null ? void 0 : W.width) ?? J[a], he = W ? Math.min(re, W.min) : J[a], ue = N.slice(0, o5), ae = H(ue.length) + he + ue.reduce((Q, K) => {
      var I;
      return Q + (((I = o(K)) == null ? void 0 : I.min) ?? J[K]);
    }, 0);
    if (j && L > 0 && W) {
      const Q = L - ne;
      let K = N.reduce((Y, B) => Y + J[B], 0);
      const I = Q - re;
      if (K > I) {
        const Y = N.reduce((B, V) => {
          var be;
          return B + (J[V] - (((be = o(V)) == null ? void 0 : be.min) ?? J[V]));
        }, 0);
        if (Y > 0) {
          const B = Math.min(1, (K - I) / Y);
          for (const V of N) {
            const be = ((_ = o(V)) == null ? void 0 : _.min) ?? J[V];
            J[V] = Math.max(be, J[V] - Math.ceil((J[V] - be) * B));
          }
          K = N.reduce((V, be) => V + J[be], 0);
        }
      }
      J[a] = Math.round(Math.max(he, Math.min(W.max, Q - K)));
    }
    const fe = ne + J[a] + N.reduce((Q, K) => Q + J[K], 0);
    return { visible: N, widths: J, total: fe, auto: j, stackBelow: ae };
  }
  return {
    lead: a,
    specs: e,
    spec: o,
    order: c,
    width: p,
    setWidth: m,
    hidden: w,
    setHidden: S,
    move: k,
    widthsAreAuto: v,
    freeze: x,
    reset: b,
    customised: C,
    state: () => i.value,
    layout: T
  };
}
function r5(e = Kp()) {
  const t = Ea(e);
  return {
    get: () => t.value,
    set: (n) => {
      t.value = n;
    }
  };
}
let Ji = null;
const is = $(!1), Hc = $(!1);
function Xs() {
  return is.value;
}
function Gpe() {
  return !0;
}
function Xpe(e) {
}
function zS() {
  return Math.floor(Date.now() / 1e3);
}
function yg(e) {
  return e === "list" || e === "grid" || e === "gallery";
}
function gg(e) {
  return e === "name" || e === "type" || e === "modified" || e === "size";
}
function bg(e) {
  return e === "asc" || e === "desc";
}
function Wr(e) {
  var t;
  return !!e && (Object.keys(e.w).length > 0 || e.hidden.length > 0 || (((t = e.o) == null ? void 0 : t.length) ?? 0) > 0);
}
const Fn = $({});
function s5(e) {
  if (!e || typeof e != "object" || Array.isArray(e)) return {};
  const t = {};
  for (const [n, a] of Object.entries(e)) {
    if (!a || typeof a != "object") continue;
    const i = a, l = { t: typeof i.t == "number" && Number.isFinite(i.t) ? i.t : 0 };
    if (yg(i.v) && (l.v = i.v), gg(i.k) && (l.k = i.k), bg(i.d) && (l.d = i.d), i.c !== void 0) {
      const c = Vp(i.c, tr);
      Wr(c) && (l.c = c);
    }
    (l.v || l.k || l.c) && (t[n] = l);
  }
  return t;
}
const J_ = 300;
function l5() {
  const e = Object.entries(Fn.value);
  if (e.length <= J_) return;
  e.sort((n, a) => a[1].t - n[1].t);
  const t = {};
  for (const [n, a] of e.slice(0, J_)) t[n] = a;
  Fn.value = t;
}
function Z_(e, t) {
  const n = String(e ?? "").trim(), a = String(t ?? "").replace(/^[a-z][a-z0-9+.-]*:\/\//i, "").replace(/\/{2,}/g, "/").replace(/^\/+|\/+$/g, "");
  return n ? a ? `${n}/${a}` : n : a;
}
const u5 = ".root", Hm = {};
function MS(e) {
  if (!e) return null;
  const t = Fn.value[e];
  if (t) {
    const { t: n, ...a } = t, i = Hm[e];
    return i && !a.k ? { ...i, ...a } : a;
  }
  return Hm[e] ? { ...Hm[e] } : null;
}
function iy(e) {
  return !!e && !!Fn.value[e];
}
function c5() {
  return Object.keys(Fn.value).length;
}
function PS(e, t) {
  if (!e) return;
  const n = Fn.value[e], a = { ...n ?? {}, ...t, t: zS() };
  if (t.c !== void 0 && !Wr(t.c) && delete a.c, !a.v && !a.k && !a.c) {
    n && OS(e);
    return;
  }
  Fn.value = { ...Fn.value, [e]: a }, l5(), xo();
}
function d5(e) {
  if (!e) return;
  const t = Fn.value[e];
  if (!t) return;
  const n = zS();
  t.t !== n && (Fn.value = { ...Fn.value, [e]: { ...t, t: n } }, xo());
}
function OS(e) {
  if (!e || !Fn.value[e]) return;
  const t = { ...Fn.value };
  delete t[e], Fn.value = t, xo();
}
function Jpe() {
  Fn.value = {}, xo();
}
const za = $({}), Kc = $({});
function kg(e) {
  if (!e || typeof e != "object" || Array.isArray(e)) return {};
  const t = e, n = {};
  if (yg(t.v) && (n.v = t.v), gg(t.k) && (n.k = t.k, bg(t.d) && (n.d = t.d)), t.c !== void 0) {
    const a = Vp(t.c, tr);
    Wr(a) && (n.c = a);
  }
  return n;
}
function f5(e) {
  let t = e;
  if (typeof e == "string")
    try {
      t = JSON.parse(e);
    } catch {
      return {};
    }
  if (!t || typeof t != "object" || Array.isArray(t)) return {};
  const n = t, a = {};
  if (yg(n.v) && (a.v = n.v), gg(n.k) && (a.k = n.k, bg(n.d) && (a.d = n.d)), Array.isArray(n.hidden)) {
    const i = n.hidden.filter(
      (o) => typeof o == "string" && tr.some((l) => l.id === o && l.hideable)
    );
    i.length && (a.hidden = [...new Set(i)]);
  }
  return a;
}
function Zpe() {
  return za.value;
}
function LS(e) {
  const t = { ...za.value };
  for (const [n, a] of Object.entries(e))
    a == null ? delete t[n] : t[n] = a;
  za.value = kg(t), mc(), xo();
}
function p5(e) {
  za.value = kg({ ...za.value, ...e }), Fn.value = {}, mc(), xo();
}
function Qpe() {
  return Kc.value;
}
function h5(e) {
  Kc.value = f5(e), mc();
}
function jp() {
  const e = za.value, t = Kc.value, n = {}, a = e.v ?? t.v;
  return a && (n.v = a), e.k ? (n.k = e.k, e.d && (n.d = e.d)) : t.k && (n.k = t.k, t.d && (n.d = t.d)), n;
}
function m5(e) {
  const t = MS(e), n = jp(), a = {}, i = (t == null ? void 0 : t.v) ?? n.v;
  return i && (a.v = i), t != null && t.k ? (a.k = t.k, t.d && (a.d = t.d)) : n.k && (a.k = n.k, n.d && (a.d = n.d)), a;
}
const tr = [
  { id: "name", width: 260, min: 120, max: 900, hideable: !1, resizable: !0 },
  { id: "type", width: 88, min: 64, max: 220, hideable: !0, resizable: !0 },
  { id: "location", width: 160, min: 80, max: 420, hideable: !0, resizable: !0 },
  { id: "owner", width: 104, min: 72, max: 260, hideable: !0, resizable: !0 },
  { id: "modified", width: 160, min: 96, max: 300, hideable: !0, resizable: !0 },
  /* The Trash only: how long an item has left before it is purged. */
  { id: "remaining", width: 112, min: 80, max: 220, hideable: !0, resizable: !0 },
  { id: "size", width: 88, min: 64, max: 200, hideable: !0, resizable: !0 },
  { id: "star", width: 24, min: 24, max: 24, hideable: !1, resizable: !1 }
], Q_ = { check: 28, menu: 28 }, ehe = 120, v5 = 220, DS = {
  gap: 8,
  padding: 24,
  check: Q_.check,
  menu: Q_.menu,
  leadAuto: v5
};
function e1() {
  if (za.value.c) return za.value.c;
  const e = Kc.value.hidden;
  return e && e.length ? { w: {}, hidden: [...e] } : Kp();
}
function RS(e) {
  return CS(
    () => tr,
    {
      get: () => {
        var n;
        const t = e();
        return t ? ((n = Fn.value[t]) == null ? void 0 : n.c) ?? e1() : e1();
      },
      set: (t) => {
        const n = e();
        if (!n) {
          LS({ c: Wr(t) ? t : void 0 });
          return;
        }
        PS(n, { c: t });
      },
      customised: () => {
        var n;
        const t = e();
        return t ? !!((n = Fn.value[t]) != null && n.c) : Wr(za.value.c);
      }
    },
    { lead: "name" }
  );
}
const ri = RS(() => "");
function oy() {
  return ri.order();
}
const the = AS;
function nhe(e) {
  return ES(e, tr);
}
function ahe(e, t) {
  ri.move(e, t);
}
function ihe(e, t) {
  const n = oy().filter((l) => {
    var c;
    return (c = tr.find((p) => p.id === l)) == null ? void 0 : c.hideable;
  }), a = n.indexOf(e);
  if (a === -1) return;
  const i = a + t;
  if (i < 0 || i >= n.length) return;
  const o = n[i];
  ri.move(e, oy().indexOf(o));
}
function ohe(e, t) {
  const n = oy().filter((i) => {
    var o;
    return (o = tr.find((l) => l.id === i)) == null ? void 0 : o.hideable;
  }), a = n.indexOf(e);
  return a === -1 ? !1 : a + t >= 0 && a + t < n.length;
}
function rhe(e) {
  return ri.width(e);
}
function she(e, t) {
  ri.setWidth(e, t);
}
function lhe() {
  return ri.widthsAreAuto();
}
function uhe(e) {
  ri.freeze(e);
}
function che(e) {
  return ri.hidden(e);
}
function dhe(e, t) {
  ri.setHidden(e, t);
}
function fhe() {
  ri.reset();
}
function phe() {
  return ri.customised();
}
function hhe(e, t, n = {}) {
  return ri.layout(e, t, { ...DS, ...n });
}
const cf = {
  sort: "filex.list-sort",
  view: "brf-file-explorer:view-mode"
};
function mc() {
  const e = jp();
  try {
    if (e.k) {
      const t = e.d ?? (e.k === "modified" ? "desc" : "asc");
      localStorage.setItem(cf.sort, JSON.stringify({ key: e.k, dir: t }));
    } else localStorage.removeItem(cf.sort);
    e.v ? localStorage.setItem(cf.view, e.v) : localStorage.removeItem(cf.view);
  } catch {
  }
}
const IS = ["on", "f", "p", "c", "g", "u"], vc = $(0), po = $({});
function y5(e) {
  const t = {};
  for (const [n, a] of Object.entries(e))
    IS.includes(n) || (t[n] = a);
  return t;
}
function g5() {
  const e = {
    ...po.value,
    on: !0,
    f: Fn.value,
    u: vc.value
  };
  return Object.keys(za.value).length && (e.p = za.value), e;
}
function b5(e) {
  if (!e || IS.includes(e))
    throw new Error(`viewPrefsSlot: "${e}" is reserved by lib/viewPrefs`);
  return {
    get: () => po.value[e],
    set(t) {
      po.value = { ...po.value, [e]: t }, xo();
    },
    clear() {
      if (!(e in po.value)) return;
      const t = { ...po.value };
      delete t[e], po.value = t, xo();
    },
    ready: () => is.value,
    persistable: () => Hc.value
  };
}
const k5 = 800;
let go, yc = !1;
function xo() {
  !is.value || !Hc.value || !Ji || (yc = !0, go && clearTimeout(go), go = setTimeout(Al, k5));
}
function Al() {
  go && clearTimeout(go), go = void 0, !(!yc || !Ji || !Hc.value) && (yc = !1, vc.value = Date.now(), Ji.save(g5()));
}
typeof window < "u" && (window.addEventListener("pagehide", Al), window.addEventListener("visibilitychange", () => {
  typeof document < "u" && document.visibilityState === "hidden" && Al();
}));
function w5(e) {
  Ji || (Ji = e, (async () => (await BS(!0), is.value = !0, x5()))());
}
function mhe() {
  Al(), FS();
}
function vhe() {
  return Ji !== null;
}
const fp = /* @__PURE__ */ new Set();
function NS(e) {
  return fp.add(e), () => fp.delete(e);
}
function t1() {
  for (const e of fp)
    try {
      e();
    } catch {
    }
}
async function BS(e) {
  if (!Ji) return;
  let t = null;
  try {
    t = await Ji.load();
  } catch {
    t = null;
  }
  if (!t || typeof t != "object" || Array.isArray(t)) {
    mc(), t1();
    return;
  }
  const n = t, a = typeof n.u == "number" && Number.isFinite(n.u) ? n.u : 0;
  if (!e) {
    if (yc) {
      Al();
      return;
    }
    if (a <= vc.value) return;
  }
  Fn.value = s5(n.f);
  let i = !1;
  if (n.p !== void 0)
    za.value = kg(n.p);
  else {
    const o = Vp(n.c, tr);
    za.value = Wr(o) ? { c: o } : {}, i = Wr(o) || n.g !== void 0 || n.c !== void 0;
  }
  vc.value = a, po.value = y5(n), Hc.value = !0, mc(), i && (is.value = !0, xo()), t1();
}
const _5 = 3e3;
let ry = 0, n1 = !1;
function a1(e = !1) {
  if (!Ji || !is.value) return;
  const t = Date.now();
  !e && t - ry < _5 || (ry = t, BS(!1));
}
function x5() {
  n1 || typeof window > "u" || (n1 = !0, window.addEventListener("focus", () => a1()), typeof document < "u" && document.addEventListener("visibilitychange", () => {
    document.visibilityState === "visible" && a1();
  }));
}
function FS() {
  Ji = null, is.value = !1, Hc.value = !1, Fn.value = {}, za.value = {}, Kc.value = {}, vc.value = 0, ry = 0, po.value = {}, yc = !1, go && clearTimeout(go), go = void 0;
}
function yhe() {
  FS(), fp.clear();
}
function ghe() {
  Al();
}
const wg = ["name", "type", "modified", "size"], S5 = "filex.list-sort", nc = "name";
function El(e) {
  return e === "modified" ? "desc" : "asc";
}
function $5(e) {
  return typeof e == "string" && wg.includes(e);
}
function T5() {
  const e = { key: nc, dir: El(nc) };
  if (typeof localStorage > "u") return e;
  try {
    const t = localStorage.getItem(S5);
    if (!t) return e;
    const n = JSON.parse(t), a = $5(n.key) ? n.key : nc, i = n.dir === "asc" || n.dir === "desc" ? n.dir : El(a);
    return { key: a, dir: i };
  } catch {
    return e;
  }
}
const US = $("en");
function _g(e) {
  US.value = e;
}
function i1(e) {
  const t = e.last_modified;
  return t ? t * (t < 1e12 ? 1e3 : 1) : null;
}
function HS(e, t) {
  return (e || "").localeCompare(t || "", void 0, {
    numeric: !0,
    sensitivity: "base"
  });
}
function o1(e, t) {
  return HS(e.basename, t.basename);
}
function r1(e) {
  const t = $x(e);
  if (t)
    return (R_[US.value] ?? R_.en)[t] ?? t;
  const n = (e.extension || "").trim();
  return n ? n.toUpperCase() : "";
}
function A5(e, t, n, a) {
  const i = t === "asc" ? 1 : -1;
  switch (e) {
    case "name":
      return i * o1(n, a);
    case "size":
      return i * ((n.size ?? -1) - (a.size ?? -1));
    case "type": {
      const o = r1(n).localeCompare(r1(a), void 0, { sensitivity: "base" });
      return o !== 0 ? i * o : o1(n, a);
    }
    default: {
      const o = i1(n), l = i1(a);
      return o == null && l == null ? 0 : o == null ? 1 : l == null ? -1 : i * (o - l);
    }
  }
}
const KS = /* @__PURE__ */ new Set(), sy = /* @__PURE__ */ new WeakMap();
function VS() {
  const e = xg(), t = $(e.key), n = $(e.dir);
  function a(v, x) {
    t.value = v, n.value = x ?? El(v);
  }
  function i(v, x) {
    t.value = v, n.value = x;
  }
  function o() {
    n.value = n.value === "asc" ? "desc" : "asc";
  }
  function l(v) {
    t.value === v ? o() : a(v);
  }
  function c(v, x) {
    return dp(v, x) || A5(t.value, n.value, v, x);
  }
  function p(v) {
    return v === "relevance" ? dp : c;
  }
  const m = {
    key: t,
    dir: n,
    setSort: a,
    applySort: i,
    toggleSortDir: o,
    chooseSortKey: l,
    compareNodes: c,
    compareInOrder: p,
    sortListing: (v, x = "sort") => [...v || []].sort(p(x))
  };
  return KS.add(m), sy.set(m, { ...e }), m;
}
const qp = VS(), jS = Symbol("fe-sort-store");
function Vc() {
  return bi(jS, qp);
}
function s1() {
  return qp.key.value;
}
function l1() {
  return qp.dir.value;
}
function u1(e, t) {
  qp.applySort(e, t);
}
function xg() {
  const e = jp();
  return e.k ? { key: e.k, dir: e.d ?? El(e.k) } : Xs() ? { key: nc, dir: El(nc) } : T5();
}
NS(() => {
  const e = xg();
  for (const t of KS) {
    const n = sy.get(t);
    !n || t.key.value !== n.key || t.dir.value !== n.dir || (t.applySort(e.key, e.dir), sy.set(t, { ...e }));
  }
});
function E5(e) {
  const t = `${(e.apiBase ?? "").replace(/\/+$/, "")}/api/files/manager/view-prefs`, n = e.credentials ?? "same-origin";
  return {
    async load() {
      var o;
      const a = await fetch(t, {
        headers: { ...await ((o = e.headers) == null ? void 0 : o.call(e)) ?? {} },
        credentials: n
      });
      if (!a.ok) return null;
      const i = await a.json();
      return h5((i == null ? void 0 : i.instance_default) ?? null), (i == null ? void 0 : i.prefs) ?? null;
    },
    save(a) {
      (async () => {
        var i;
        try {
          const o = JSON.stringify({ prefs: a });
          await fetch(t, {
            method: "PUT",
            headers: {
              ...await ((i = e.headers) == null ? void 0 : i.call(e)) ?? {},
              "Content-Type": "application/json"
            },
            credentials: n,
            body: o,
            /* ⚠ `keepalive` is what lets the save fired on `pagehide` outlive
             * the page — but browsers reject a keepalive body over 64 KB
             * outright, so the flag goes only on documents that fit. */
            keepalive: o.length < 6e4
          });
        } catch {
        }
      })();
    }
  };
}
function C5(e) {
  w5(E5(e));
}
const qS = Symbol("fe-table-env");
function z5(e) {
  Wo(qS, e);
}
function M5() {
  return bi(qS, null);
}
function Km(e, t, n) {
  return e ? {} : t ? { disabled: !0, title: n } : { hidden: !0 };
}
function bhe(e) {
  var n;
  if (!e) return !1;
  const t = (n = e.external) == null ? void 0 : n.onlyoffice;
  return t && !Ev(t) ? !1 : !!e.onlyoffice_url;
}
const Vm = {
  links: "share.links",
  uploadLinks: "share.upload_links",
  users: "share.users"
}, P5 = Object.freeze({ links: !0, uploadLinks: !0, users: !0 });
function O5(e) {
  return {
    links: e(Vm.links),
    uploadLinks: e(Vm.uploadLinks),
    users: e(Vm.users)
  };
}
function L5(e, t) {
  return e.links || e.users || t && e.uploadLinks;
}
function D5(e) {
  const t = e.indexOf("://");
  return t > 0 && e.slice(t + 3).replace(/\/+/g, "") === "";
}
function khe(e, t) {
  return D5(e) ? { ...t, links: !1, uploadLinks: !1 } : t;
}
function R5(e) {
  const t = String(e.storage || e.path).replace(/:\/\/.*$/, "").replace(/^\/+|\/+$/g, "");
  return {
    path: `${t}://`,
    basename: e.basename || t,
    type: "dir",
    mime_type: "inode/storage",
    perm: "owner"
  };
}
function I5(e, t) {
  return [
    { key: "open", label: e("ctx.open") },
    { key: "open-tab", label: e("ctx.open_new_tab") },
    {
      key: "storage-access",
      label: e("ctx.storage_access"),
      icon: "access",
      hidden: !(t.manages && t.shareUsers)
    }
  ];
}
const N5 = /* @__PURE__ */ new Set(["none", "viewer", "editor", "owner"]);
function WS(e) {
  return typeof e == "string" && N5.has(e) ? e : void 0;
}
function B5(e) {
  const t = {};
  if (!Array.isArray(e)) return t;
  for (const n of e) {
    const a = n, i = WS(a == null ? void 0 : a.perm);
    typeof (a == null ? void 0 : a.name) == "string" && i && (t[a.name] = i);
  }
  return t;
}
function F5(e, t, n) {
  var a;
  return WS((a = t == null ? void 0 : t.find((i) => i.name === e)) == null ? void 0 : a.perm) ?? n[e];
}
function U5(e) {
  return e.admin || e.level === "owner";
}
function YS(e, t) {
  return e && !t;
}
function c1(e, t, n) {
  return YS(e, t) && (n == null ? void 0 : n.visible) === !0;
}
function GS(e, t) {
  return t ? !0 : e.some(Zy);
}
function XS(e, t = {}) {
  return t.busy || e.op_type !== "plugin" || e.status !== "done" || !e.plugin || !Pp(e.open) ? null : { plugin: e.plugin, open: e.open };
}
const H5 = ["standard", "simple"], jm = "standard", ly = /* @__PURE__ */ new Set();
function K5(e) {
  if (e === "simple") return "simple";
  if (e === "standard" || e === void 0 || e === null || e === "")
    return jm;
  const t = typeof e == "string" ? e : String(e);
  return !ly.has(t) && typeof console < "u" && (ly.add(t), console.warn(
    `[filex] unknown uiProfile ${JSON.stringify(t)} - using "${jm}". Valid values: ${H5.map((n) => `"${n}"`).join(", ")}. (The former "drive" profile was removed; pass "simple" for the reduced explorer.)`
  )), jm;
}
function whe() {
  ly.clear();
}
function tl(e, t) {
  return e ? e.endsWith("://") || e.endsWith("/") ? e + t : `${e}/${t}` : t;
}
function Na(e) {
  const t = e.indexOf("://"), n = t === -1 ? "" : e.slice(0, t + 3), a = (t === -1 ? e : e.slice(t + 3)).replace(/\/+$/, ""), i = a.lastIndexOf("/");
  return i === -1 ? n : n + a.slice(0, i);
}
function pl(e) {
  const t = e.indexOf("://"), n = (t === -1 ? e : e.slice(t + 3)).replace(/\/+$/, ""), a = n.lastIndexOf("/");
  return a === -1 ? n : n.slice(a + 1);
}
function Pn(e) {
  const t = e.indexOf("://");
  return t === -1 ? e.replace(/^\/+|\/+$/g, "") : e.slice(0, t + 3) + e.slice(t + 3).replace(/^\/+|\/+$/g, "");
}
function qm(e) {
  const t = e.indexOf("://");
  return t === -1 ? e : e.slice(t + 3);
}
function nl(e, t) {
  const n = Pn(e), a = Pn(t);
  if (!a) return !1;
  const i = a.endsWith("://") ? a : `${a}/`;
  return n.length > i.length && n.startsWith(i);
}
function d1(e, t) {
  const n = Pn(e), a = Pn(t), i = a.endsWith("://") ? a : `${a}/`;
  return n.slice(i.length).split("/").filter(Boolean);
}
function Mf(e) {
  return typeof e.e2e_stored == "string" ? e.e2e_stored : e.basename;
}
function V5(e) {
  const { api: t, ring: n } = e, a = $(0), i = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map(), l = /* @__PURE__ */ new Map(), c = /* @__PURE__ */ new Set();
  function p() {
    a.value++;
  }
  async function m(re) {
    try {
      const { blob: he, url: ue } = await t.fetchBlob(tl(re, ga), { fresh: !0 });
      URL.revokeObjectURL(ue);
      const ae = lp(await he.text()), fe = ae ? { marker: ae.marker, unsupported: ae.unsupported } : { marker: null, unsupported: [] };
      return o.set(re, fe.marker), fe;
    } catch {
      return o.set(re, null), { marker: null, unsupported: [] };
    }
  }
  async function v(re) {
    const he = Pn(re);
    let ue = i.get(he);
    return ue || (ue = m(he), i.set(he, ue)), (await ue).marker;
  }
  function x(re) {
    const he = Pn(re);
    return o.has(he) ? o.get(he) : void 0;
  }
  function w(re, he) {
    const ue = Pn(re);
    o.set(ue, he), i.set(ue, Promise.resolve({ marker: he, unsupported: [] })), p();
  }
  function S(re) {
    const he = Pn(re);
    i.delete(he), o.delete(he), l.delete(he);
    for (const ue of [...T.keys()]) ue.startsWith(`${he}|`) && T.delete(ue);
    p();
  }
  function k(re) {
    return qi(x(re) ?? null);
  }
  function b(re, he) {
    if (he && nl(re, he)) return Pn(he);
    let ue = null;
    const ae = /* @__PURE__ */ new Set([...n.roots(), ...o.keys()]);
    for (const fe of ae)
      nl(re, fe) && (!ue || fe.length > ue.length) && (ue = Pn(fe));
    return ue;
  }
  function C(re) {
    const he = Pn(re);
    let ue = l.get(he);
    return ue || (ue = /* @__PURE__ */ new Map(), l.set(he, ue)), ue;
  }
  const T = /* @__PURE__ */ new Map();
  function A(re, he, ue) {
    const ae = Pn(ue), fe = Pn(he);
    if (ae === fe || !nl(ae, fe)) return Promise.resolve(re.rootId);
    const _ = `${fe}|${ae}`;
    let Q = T.get(_);
    return Q || (Q = A(re, he, Na(ae)).then((K) => Wv(re, K, pl(ae))), T.set(_, Q)), Q;
  }
  const L = /* @__PURE__ */ new Map();
  function z(re, he, ue, ae) {
    const fe = C(he), _ = `${Pn(ue)}/${ae}`, Q = fe.get(_);
    if (Q) return Promise.resolve(Q);
    const K = `${Pn(he)}|${_}`, I = L.get(K);
    if (I) return I;
    const Y = A(re, he, ue).then((B) => Bx(re, ae, B, async (V) => {
      try {
        const be = await t.fetchArrayBuffer(tl(ue, V));
        return new TextDecoder().decode(be);
      } catch {
        return null;
      }
    })).then((B) => (B.state !== "unreadable" && fe.set(_, B), B)).finally(() => L.delete(K));
    return L.set(K, Y), Y;
  }
  function D(re, he, ue, ae) {
    C(re).set(`${Pn(he)}/${ue.stored}`, { name: ae, state: "enc" }), p();
  }
  async function U(re, he) {
    const ue = n.names(re), ae = d1(he, re);
    if (!ue) return ae.map(() => null);
    const fe = [];
    let _ = Pn(re);
    for (const Q of ae) {
      const K = await z(ue, re, _, Q);
      fe.push(K.name), _ = tl(_, Q);
    }
    return fe;
  }
  async function q(re) {
    const he = b(re);
    if (!he) return null;
    const ue = n.names(he);
    return ue ? z(ue, he, Na(re), pl(re)) : null;
  }
  async function P(re, he) {
    const ue = qm(Pn(re)), fe = (await U(re, Na(he))).map((_) => _ === null ? e.lockedLabel() : _);
    return [ue, ...fe].filter(Boolean).join("/");
  }
  async function R(re, he = {}) {
    return he.root && await v(he.root), (await Promise.all(re.map((ae) => W(ae, he.root ?? null)))).filter((ae) => ae !== null);
  }
  async function W(re, he) {
    var be;
    const ue = re.type === "file" ? (be = e.fileName) == null ? void 0 : be.call(e, re.path) : void 0;
    ue && (re = { ...re, fxe_name: ue });
    const ae = typeof re.e2e_root == "string" && re.e2e_root || he, fe = b(re.path, ae);
    if (!fe) return re;
    const _ = await v(fe);
    if (!qi(_)) return re;
    const Q = Mf(re);
    if (Q === ga || Nl(Q).kind === "sidecar") return null;
    const I = n.names(fe), Y = await P(fe, re.path), B = { ...re, e2e_stored: Q, e2e_root: fe, e2e_display_dir: Y };
    if (!I)
      return { ...B, basename: e.lockedLabel(), extension: "", e2e_name_state: "locked" };
    const V = await z(I, fe, Na(re.path), Q);
    return V.state === "enc" && V.name !== null ? {
      ...B,
      basename: V.name,
      extension: re.type === "dir" ? "" : op(V.name),
      e2e_name_state: "enc"
    } : V.state === "plain" ? { ...B, basename: Q, e2e_name_state: "plain" } : { ...B, basename: e.unreadableLabel(), extension: "", e2e_name_state: "unreadable" };
  }
  function N(re) {
    a.value;
    const he = b(re);
    if (!he) return null;
    const ue = x(he);
    if (ue === void 0)
      return v(he).then(p), null;
    if (!qi(ue)) return null;
    const ae = n.names(he);
    if (!ae) return e.lockedLabel();
    const fe = pl(re), _ = Na(re), Q = `${Pn(_)}/${fe}`, K = C(he).get(Q);
    if (K) return K.name ?? e.unreadableLabel();
    const I = `${he}|${Q}`;
    return c.has(I) || (c.add(I), z(ae, he, _, fe).finally(() => {
      c.delete(I), p();
    })), "…";
  }
  function J(re) {
    a.value;
    const he = b(re);
    if (!he || !k(he)) return qm(Pn(re));
    const ue = qm(Pn(he)), ae = d1(re, he), fe = [];
    let _ = Pn(he);
    for (const Q of ae)
      _ = tl(_, Q), fe.push(N(_) ?? Q);
    return [ue, ...fe].filter(Boolean).join("/");
  }
  function H(re) {
    const he = Pn(re);
    for (const ue of /* @__PURE__ */ new Set([...n.roots(), ...o.keys()])) {
      const ae = Pn(ue);
      if ((he === ae || nl(he, ae)) && k(ae)) return ae;
    }
    return null;
  }
  async function ne(re, he, ue = {}) {
    const ae = H(re);
    if (!ae) return null;
    const fe = n.names(ae);
    if (!fe) throw new Error("e2e: the folder is locked");
    const _ = await A(fe, ae, re), Q = ue.keepIdOf ? await A(fe, ae, ue.keepIdOf) : void 0, K = await Yv(fe, he, _, { isDir: ue.isDir, dirId: Q });
    return D(ae, re, K, he.normalize("NFC")), K;
  }
  async function j(re) {
    const he = b(re) ?? H(re);
    if (!he) return null;
    const ue = n.names(he);
    return ue ? A(ue, he, re) : null;
  }
  return {
    version: a,
    markerFor: v,
    markerCached: x,
    setMarker: w,
    forget: S,
    namesOn: k,
    rootOf: b,
    decorate: R,
    decodePath: U,
    plainNameOf: q,
    segmentLabel: N,
    displayPath: J,
    writesEncrypted: H,
    nameForWrite: ne,
    dirIdFor: j,
    remember: D,
    bump: p
  };
}
const jc = Symbol("filex.e2eNameView"), j5 = { class: "filex-recent" }, q5 = ["title", "aria-label", "disabled"], W5 = ["innerHTML"], Y5 = { key: 0 }, G5 = ["data-fe-path"], X5 = ["onClick", "onContextmenu"], J5 = { class: "filex-recent-name" }, Z5 = { class: "filex-recent-meta" }, Q5 = {
  key: 1,
  class: "filex-recent-empty"
}, e8 = {
  key: 2,
  class: "filex-recent-empty"
}, t8 = /* @__PURE__ */ lt({
  __name: "RecentlyOpened",
  props: {
    apiBase: {},
    authHeaders: { type: Function },
    authCredentials: {},
    limit: {},
    refreshKey: {},
    locale: {}
  },
  emits: ["open", "context", "error"],
  setup(e, { emit: t }) {
    const n = e, { t: a } = pt(() => n.locale ?? "en"), i = t, o = $([]), l = $(!1), c = bi(jc, null), p = $({});
    async function m(w) {
      if (!c) return;
      const S = w.map((T) => ({
        id: T.id,
        type: T.type === "dir" ? "dir" : "file",
        path: typeof T.storage == "string" && T.storage ? `${T.storage}://${String(T.path).replace(/^\/+/, "")}` : String(T.path),
        basename: T.name,
        ...typeof T.e2e_root == "string" && T.e2e_root ? { e2e_root: T.e2e_root } : {}
      })), k = await c.decorate(S), b = new Set(k.map((T) => T.id)), C = {};
      for (const T of k) typeof T.id == "number" && T.e2e_stored && (C[T.id] = T.basename);
      p.value = C, b.size !== w.length && (o.value = w.filter((T) => b.has(T.id)));
    }
    c && Je(c.version, () => void m(o.value));
    async function v() {
      l.value = !0;
      try {
        const w = await (n.authHeaders ?? (() => ({})))(), S = n.apiBase ?? "", k = n.limit ?? 20, b = await fetch(`${S}/api/files/manager/recent?limit=${k}`, {
          headers: w,
          credentials: n.authCredentials ?? "same-origin"
        });
        if (b.ok) {
          const C = await b.json();
          o.value = Array.isArray(C.nodes) ? C.nodes : Array.isArray(C.entries) ? C.entries : Array.isArray(C) ? C : [], await m(o.value);
        }
      } catch (w) {
        i("error", w instanceof Error ? w.message : String(w));
      } finally {
        l.value = !1;
      }
    }
    function x(w) {
      if (!w) return "";
      const S = new Date(w).getTime();
      if (Number.isNaN(S)) return "";
      const k = Date.now() - S;
      try {
        const b = new Intl.RelativeTimeFormat(gi(n.locale), { numeric: "auto", style: "short" });
        return k < 6e4 ? b.format(0, "second") : k < 36e5 ? b.format(-Math.floor(k / 6e4), "minute") : k < 864e5 ? b.format(-Math.floor(k / 36e5), "hour") : b.format(-Math.floor(k / 864e5), "day");
      } catch {
        return new Date(S).toISOString().slice(0, 16).replace("T", " ");
      }
    }
    return jt(v), Je(() => n.refreshKey, v), (w, S) => (f(), h("div", j5, [
      d("header", null, [
        d("h3", null, y(u(a)("recents.title")), 1),
        d("button", {
          class: "filex-recent-refresh",
          type: "button",
          title: u(a)("recents.refresh"),
          "aria-label": u(a)("recents.refresh"),
          onClick: v,
          disabled: l.value
        }, [
          d("span", {
            "aria-hidden": "true",
            innerHTML: u(zt)("refresh")
          }, null, 8, W5)
        ], 8, q5)
      ]),
      o.value.length ? (f(), h("ul", Y5, [
        (f(!0), h(Te, null, nt(o.value, (k) => (f(), h("li", {
          key: k.id,
          "data-testid": "recent-tray-item",
          "data-fe-path": k.path
        }, [
          d("button", {
            type: "button",
            class: "filex-recent-item",
            onClick: (b) => i("open", k),
            onContextmenu: yt((b) => i("context", k, b), ["prevent"])
          }, [
            d("span", J5, [
              d("bdi", null, y(p.value[k.id] ?? k.name), 1)
            ]),
            d("span", Z5, y(x(k.last_opened)), 1)
          ], 40, X5)
        ], 8, G5))), 128))
      ])) : l.value ? (f(), h("p", e8, y(u(a)("recents.loading")), 1)) : (f(), h("p", Q5, y(u(a)("recents.empty")), 1))
    ]));
  }
}), jo = {
  type: "any",
  modified: "any",
  size: "any",
  name: "",
  aroundDate: "",
  aroundSpan: "d1",
  sizeMin: null,
  sizeMax: null,
  pathMode: "any",
  pathBase: "",
  people: "any"
};
function yo(e) {
  return e.normalize("NFD").replace(new RegExp("\\p{M}+", "gu"), "").toLowerCase().replace(/ı/g, "i");
}
function Sg(e) {
  return (e.name ?? "").trim();
}
function JS(e) {
  return (e.pathMode ?? "any") !== "any" && !!(e.pathBase ?? "");
}
function $g(e) {
  return e.people ?? "any";
}
function al(e) {
  return e.type !== "any" || e.modified !== "any" || e.size !== "any" || Sg(e) !== "" || JS(e) || $g(e) !== "any";
}
function n8(e) {
  return (e.type !== "any" ? 1 : 0) + (e.modified !== "any" ? 1 : 0) + (e.size !== "any" ? 1 : 0) + (Sg(e) !== "" ? 1 : 0) + (JS(e) ? 1 : 0) + ($g(e) !== "any" ? 1 : 0);
}
const a8 = {
  folder: ["folder"],
  document: ["doc", "text"],
  spreadsheet: ["sheet"],
  presentation: ["slides"],
  pdf: ["pdf"],
  image: ["image"],
  video: ["video"],
  audio: ["audio"],
  archive: ["archive"],
  code: ["code"]
};
function i8(e, t) {
  if (t === "any") return !0;
  if (t === "folder") return e.type === "dir";
  if (e.type === "dir") return !1;
  const n = e.kind;
  return typeof n == "string" && n !== "" ? n === t || t === "document" && n === "text" : a8[t].includes(xi(e));
}
const o8 = {
  h1: 36e5,
  d1: 864e5,
  w1: 7 * 864e5
};
function r8(e) {
  const t = (e ?? "").trim();
  if (!t) return null;
  const n = Date.parse(t.includes("T") ? t : `${t}T00:00`);
  return Number.isNaN(n) ? null : n;
}
function ZS(e, t = Date.now()) {
  const n = e.modified;
  if (n === "any") return null;
  if (n === "around") {
    const i = r8(e.aroundDate);
    if (i === null) return null;
    const o = o8[e.aroundSpan ?? "d1"];
    return { after: i - o, before: i + o };
  }
  if (n === "year") {
    const i = new Date(t).getFullYear();
    return { after: new Date(i, 0, 1).getTime(), before: new Date(i + 1, 0, 1).getTime() - 1 };
  }
  if (n === "today") {
    const i = new Date(t);
    return i.setHours(0, 0, 0, 0), { after: i.getTime() };
  }
  return { after: t - (n === "7d" ? 7 : 30) * 864e5 };
}
function s8(e, t, n) {
  const a = ZS(t, n);
  if (!a) return !0;
  const i = typeof e.last_modified == "number" ? e.last_modified : 0;
  return !(!i || a.after !== void 0 && i < a.after || a.before !== void 0 && i > a.before);
}
const js = 1024 * 1024;
function QS(e) {
  switch (e.size) {
    case "any":
      return null;
    case "lt1":
      return { max: js - 1 };
    case "1to10":
      return { min: js, max: 10 * js - 1 };
    case "10to100":
      return { min: 10 * js, max: 100 * js - 1 };
    case "gt100":
      return { min: 100 * js };
    case "range": {
      const t = typeof e.sizeMin == "number" ? e.sizeMin : void 0, n = typeof e.sizeMax == "number" ? e.sizeMax : void 0;
      return { min: t, max: n };
    }
  }
  return null;
}
function l8(e, t) {
  const n = QS(t);
  if (!n) return !0;
  if (e.type === "dir") return !1;
  const a = typeof e.size == "number" ? e.size : 0;
  return !(n.min !== void 0 && a < n.min || n.max !== void 0 && a > n.max);
}
function e$(e, t) {
  return t ? yo(e || "").includes(yo(t)) : !0;
}
function u8(e, t) {
  const n = t.pathMode ?? "any", a = (t.pathBase ?? "").replace(/\/+$/, "");
  if (n === "any" || !a) return !0;
  const i = e.path || "", o = i === a || i.startsWith(`${a}/`);
  return n === "here" ? o : !o;
}
function gc(e) {
  const t = e.owner_id;
  return typeof t == "number" && t > 0 ? t : null;
}
function Wp(e) {
  return e.owner_self === !0;
}
function Tg(e) {
  const t = e.owner_name;
  return typeof t == "string" ? t : "";
}
function f1(e) {
  const t = e.deleted_by_id;
  return typeof t == "number" && t > 0 ? t : null;
}
function p1(e) {
  return e.deleted_by_self === !0;
}
function c8(e) {
  const t = e.deleted_by_name;
  return typeof t == "string" ? t : "";
}
function d8(e) {
  return e.external_upload === !0;
}
function f8(e) {
  const t = [{ value: "any" }, { value: "me" }, { value: "system" }], n = /* @__PURE__ */ new Set();
  for (const o of e) {
    const l = gc(o);
    l === null || Wp(o) || n.has(l) || (n.add(l), t.push({ value: `u:${l}`, name: Tg(o) }));
  }
  const a = t.slice(0, 3), i = t.slice(3).sort((o, l) => (o.name ?? "").localeCompare(l.name ?? "", void 0, { sensitivity: "base" }));
  return [...a, ...i];
}
function p8(e, t) {
  const n = $g(t);
  if (n === "any") return !0;
  if (n === "me") return Wp(e);
  if (n === "system") return gc(e) === null;
  const a = Number(n.slice(2));
  return Number.isFinite(a) && gc(e) === a;
}
function uy(e, t, n = Date.now()) {
  return al({ ...t, name: "" }) ? e.filter(
    (a) => i8(a, t.type) && s8(a, t, n) && l8(a, t) && u8(a, t) && p8(a, t)
  ) : e;
}
const h8 = /* @__PURE__ */ lt({
  __name: "UploadProgress",
  props: {
    jobs: {},
    locale: {},
    center: {}
  },
  emits: ["cancel", "dismiss", "retry"],
  setup(e, { emit: t }) {
    const n = e, { t: a } = pt(() => n.locale);
    function i(c) {
      return c === "committing" || c === "transferring";
    }
    const o = t;
    function l(c) {
      return c === "done" ? "done" : c === "error" ? "error" : c === "aborted" ? "aborted" : "running";
    }
    return Je(
      () => n.jobs,
      (c) => {
        n.center.sync(
          "upload",
          c.map((p) => ({
            input: {
              id: p.id,
              kind: "upload",
              name: p.displayName ?? p.file.name,
              percent: i(p.status) ? null : p.totalBytes > 0 || p.status === "done" ? p.percent : null,
              message: i(p.status) ? a("upload.saving") : null,
              status: l(p.status),
              error: p.error ?? null,
              uploadedBytes: p.uploadedBytes,
              totalBytes: p.totalBytes,
              // Cancellable only while chunks are still moving: once the commit is
              // accepted the bytes are filex's and the ops worker owns the rest.
              cancellable: p.status === "uploading" || p.status === "initializing",
              retryable: p.status === "error"
            },
            actions: {
              cancel: () => o("cancel", p),
              dismiss: () => o("dismiss", p),
              retry: () => o("retry", p)
            }
          }))
        );
      },
      { immediate: !0 }
    ), (c, p) => O("", !0);
  }
});
function Wm(e) {
  return Math.max(0, Math.min(100, Math.round(e)));
}
function t$(e) {
  if (e.progress_total > 1) return null;
  const t = e.objects_total ?? 0;
  return t > 0 ? { done: e.objects_done ?? 0, total: t } : null;
}
function m8(e) {
  if (e.status === "done") return 100;
  const t = e.bytes_total ?? 0, n = e.bytes_done ?? 0;
  if (t > 0) return Wm(n / t * 100);
  if (n > 0) return null;
  if (e.progress_total <= 1) {
    const a = t$(e);
    return a ? Wm(a.done / a.total * 100) : null;
  }
  return Wm(e.progress_done / e.progress_total * 100);
}
const v8 = /* @__PURE__ */ lt({
  __name: "PendingOpsTray",
  props: {
    ops: {},
    locale: {},
    center: {},
    outputModeOf: { type: Function },
    callerAdmin: { type: Boolean }
  },
  emits: ["dismiss", "cancel", "open"],
  setup(e, { emit: t }) {
    const n = e, { t: a } = pt(() => n.locale);
    function i(k) {
      return Zf(k, a, { callerAdmin: n.callerAdmin === !0 });
    }
    const o = t;
    function l(k) {
      return k.status === "done" ? "done" : k.status === "cancelled" ? "aborted" : k.status === "error" ? "error" : "running";
    }
    const c = /* @__PURE__ */ new Set([
      "copy",
      "move",
      "delete",
      "rename",
      "restore",
      "purge",
      "plugin",
      "archive-create",
      "archive-extract"
    ]);
    function p(k) {
      return k.op_type === "trash-empty" ? "trash" : k.op_type === "thumb-repair" ? "thumbs" : c.has(k.op_type) ? k.op_type : "plugin";
    }
    function m(k) {
      return k.op_type === "plugin";
    }
    function v(k) {
      return k.status !== "pending" && k.status !== "running" ? !1 : k.op_type === "archive-create" || k.op_type === "archive-extract" ? k.cancellable : m(k) ? !0 : (k.op_type === "trash-empty" || k.op_type === "thumb-repair") && n.callerAdmin === !0;
    }
    const x = (k) => m8(k);
    function w(k) {
      if (k.op_type === "trash-empty" || k.op_type === "thumb-repair") return "";
      const b = k.label || k.target_path || k.source_dir || "";
      return b || (k.op_type === "restore" || k.op_type === "purge" ? a("opc.trash_items", { n: k.progress_total || k.source_count }) : "");
    }
    function S(k) {
      const b = t$(k);
      return b ? { itemsDone: b.done, itemsTotal: b.total } : {};
    }
    return Je(
      () => n.ops,
      (k) => {
        n.center.sync(
          "ops",
          k.map((b) => {
            var C;
            return {
              input: {
                id: b.id,
                kind: p(b),
                name: w(b),
                percent: x(b),
                status: l(b),
                error: b.status === "error" ? i(b).text : null,
                errorDetail: b.status === "error" ? i(b).detail ?? null : null,
                queued: b.status === "pending",
                waitText: b.status === "pending" ? b.wait_text ?? null : null,
                cancelling: b.status === "cancelling",
                doneCount: b.progress_done,
                totalCount: b.progress_total,
                ...S(b),
                cancellable: v(b),
                retryable: !1,
                message: b.message ?? null,
                outputs: (b.outputs ?? []).map((T) => T.path),
                outputMode: (m(b) ? (C = n.outputModeOf) == null ? void 0 : C.call(n, b) : void 0) ?? null
              },
              actions: {
                cancel: () => o("cancel", b.id),
                dismiss: () => o("dismiss", b.id),
                open: (T) => o("open", b.id, T)
              }
            };
          })
        );
      },
      { immediate: !0 }
    ), (k, b) => O("", !0);
  }
});
function qc(e) {
  if (!e || e.locked !== !0) return null;
  const t = e.lock;
  return !t || typeof t != "object" || typeof t.plugin != "string" || !t.plugin ? null : t;
}
function _he(e) {
  return e.some((t) => qc(t) !== null);
}
function cy(e) {
  const t = e;
  if (!t || t.status !== 423) return null;
  const n = { plugin: "" };
  typeof t.server == "string" && t.server && (n.message = t.server);
  try {
    const a = JSON.parse(String(t.detail ?? ""));
    typeof a.plugin == "string" && (n.plugin = a.plugin), a.plugin_label && typeof a.plugin_label == "object" && (n.plugin_label = a.plugin_label), typeof a.path == "string" && (n.path = a.path), typeof a.reason == "string" && a.reason && (n.reason = a.reason), a.reason_text && typeof a.reason_text == "object" && (n.reason_text = a.reason_text), typeof a.until == "string" && a.until && (n.until = a.until), !n.message && typeof a.message == "string" && a.message && (n.message = a.message);
  } catch {
  }
  return n;
}
function y8(e, t) {
  return e && (Xt(e.reason_text, t || "en") || e.reason) || "";
}
function Yr(e, t) {
  if (!e) return "";
  const n = e.message;
  if (n) return Yi(t.locale, n);
  const a = Xt(e.plugin_label, t.locale || "en") || e.plugin || t.t("applock.some_app"), i = y8(e, t.locale), o = i ? t.t("applock.held_reason", { app: a, reason: i }) : t.t("applock.held", { app: a }), l = g8(e.until, t);
  return l ? `${o} ${l}` : o;
}
function g8(e, t) {
  if (!e) return "";
  const n = Date.parse(e);
  if (!Number.isFinite(n)) return "";
  const a = t.formatDate ? t.formatDate(n, { time: !0 }) : new Date(n).toISOString();
  return t.t("applock.until", { date: a });
}
const b8 = ["outside_root", "broken", "unresolved"];
function n$(e) {
  if (!e || e.symlink !== !0) return null;
  const t = e.link_state;
  return typeof t == "string" && b8.includes(t) ? t : "unknown";
}
function k8(e, t) {
  switch (e) {
    case "outside_root":
      return { state: e, badge: t.t("symlink.badge.outside_root"), why: t.t("symlink.why.outside_root") };
    case "broken":
      return { state: e, badge: t.t("symlink.badge.broken"), why: t.t("symlink.why.broken") };
    case "unresolved":
      return { state: e, badge: t.t("symlink.badge.unresolved"), why: t.t("symlink.why.unresolved") };
    case "unknown":
      return { state: e, badge: t.t("symlink.badge.unknown"), why: t.t("symlink.why.unknown") };
    default:
      return null;
  }
}
function Wc(e, t) {
  return k8(n$(e), t);
}
function xhe(e) {
  return n$(e) !== null;
}
function a$(e) {
  return !!e && e.unavailable === !0;
}
function Yc(e, t) {
  if (!a$(e)) return null;
  const n = e.type === "dir" ? t.t("unavailable.why.dir") : t.t("unavailable.why.file"), a = typeof e.unavailable_reason == "string" ? e.unavailable_reason.trim() : "", i = a ? t.t("unavailable.withReason", { why: n, reason: a }) : n;
  return { badge: "!", why: n, reason: a, full: i };
}
function Yp(e) {
  if (!e) return "";
  for (const t of [e.name, e.display_name, e.username, e.email]) {
    const n = typeof t == "string" ? t.trim() : "";
    if (n) return n;
  }
  return "";
}
function w8(e, t) {
  const n = Yp(e);
  return n ? [...n][0].toLocaleUpperCase(t) : "";
}
function Ag(e) {
  const t = Number(e);
  return Number.isFinite(t) ? (Math.round(t / 90) * 90 % 360 + 360) % 360 : 0;
}
const h1 = { w: 0.02, h: 0.01 }, pp = (e) => Math.min(1, Math.max(0, e));
function hl(e) {
  const t = Math.min(1, Math.max(h1.w, Number(e.w) || 0)), n = Math.min(1, Math.max(h1.h, Number(e.h) || 0)), a = Math.min(1 - t, pp(Number(e.x) || 0)), i = Math.min(1 - n, pp(Number(e.y) || 0));
  return { x: a, y: i, w: t, h: n };
}
function df(e, t) {
  return hl({
    x: Math.min(e.x, t.x),
    y: Math.min(e.y, t.y),
    w: Math.abs(e.x - t.x),
    h: Math.abs(e.y - t.y)
  });
}
function She(e, t) {
  return {
    left: e.x * t.width,
    top: e.y * t.height,
    width: e.w * t.width,
    height: e.h * t.height
  };
}
function $he(e, t) {
  const n = t.width || 1, a = t.height || 1;
  return { x: e.left / n, y: e.top / a, w: e.width / n, h: e.height / a };
}
function m1(e, t) {
  return { x: pp(e.x / (t.width || 1)), y: pp(e.y / (t.height || 1)) };
}
function i$(e) {
  const t = Ag(e.rotation);
  return t === 90 || t === 270 ? { width: e.height, height: e.width } : { width: e.width, height: e.height };
}
function v1(e, t, n) {
  const a = Ag(n.rotation), i = n.width, o = n.height;
  switch (a) {
    case 90:
      return { x: t, y: i - e };
    case 180:
      return { x: i - e, y: o - t };
    case 270:
      return { x: o - t, y: e };
    default:
      return { x: e, y: t };
  }
}
function y1(e, t, n) {
  const a = Ag(n.rotation), i = n.width, o = n.height;
  switch (a) {
    case 90:
      return { X: i - t, Y: e };
    case 180:
      return { X: i - e, Y: o - t };
    case 270:
      return { X: t, Y: o - e };
    default:
      return { X: e, Y: t };
  }
}
function The(e, t) {
  const n = v1(e.x * t.width, e.y * t.height, t), a = v1((e.x + e.w) * t.width, (e.y + e.h) * t.height, t), { height: i } = i$(t), o = Math.min(n.x, a.x), l = Math.max(n.x, a.x), c = Math.min(n.y, a.y), p = Math.max(n.y, a.y);
  return o$({ x: o, y: i - p, w: l - o, h: p - c });
}
function Ahe(e, t) {
  const { height: n } = i$(t), a = { x: e.x, y: n - (e.y + e.h) }, i = { x: e.x + e.w, y: n - e.y }, o = y1(a.x, a.y, t), l = y1(i.x, i.y, t), c = t.width || 1, p = t.height || 1;
  return o$({
    x: Math.min(o.X, l.X) / c,
    y: Math.min(o.Y, l.Y) / p,
    w: Math.abs(o.X - l.X) / c,
    h: Math.abs(o.Y - l.Y) / p
  });
}
function o$(e) {
  const t = {};
  for (const [n, a] of Object.entries(e)) t[n] = Math.round(a * 1e6) / 1e6;
  return t;
}
function _8(e, t, n = 16) {
  const a = Math.max(0, e.width), i = Math.max(0, e.height) - n;
  if (!t.width || !t.height || i <= 0) return a;
  const o = i * t.width / t.height;
  return Math.max(120, Math.min(a, o));
}
const Cl = [
  { key: "caveat", name: "Caveat", kind: "hand", className: "fe-signfont--caveat", stack: "'Caveat', cursive" },
  {
    key: "dancing-script",
    name: "Dancing Script",
    kind: "hand",
    className: "fe-signfont--dancing-script",
    stack: "'Dancing Script', cursive"
  },
  {
    key: "homemade-apple",
    name: "Homemade Apple",
    kind: "hand",
    className: "fe-signfont--homemade-apple",
    stack: "'Homemade Apple', cursive"
  },
  {
    key: "inter",
    name: "Inter",
    kind: "formal",
    className: "fe-signfont--inter",
    stack: 'Inter, system-ui, -apple-system, "Segoe UI", Roboto, sans-serif'
  },
  {
    key: "source-serif",
    name: "Source Serif 4",
    kind: "formal",
    className: "fe-signfont--source-serif",
    stack: "'Source Serif 4', Georgia, 'Times New Roman', serif"
  }
], r$ = "caveat";
function s$(e) {
  const t = String(e ?? "");
  return Cl.find((n) => n.key === t) ?? Cl.find((n) => n.key === r$);
}
function bc(e) {
  return typeof e == "string" && Cl.some((t) => t.key === e);
}
const dy = ["any", "number", "email"];
function x8(e) {
  return typeof e == "string" && dy.includes(e);
}
function S8(e) {
  if (!e || typeof e != "object") return null;
  const t = e, a = { kind: x8(t.kind) ? t.kind : "any" }, i = Math.trunc(Number(t.min)), o = Math.trunc(Number(t.max));
  return Number.isFinite(i) && i > 0 && (a.min = i), Number.isFinite(o) && o > 0 && (a.max = o), a.kind === "any" && a.min === void 0 && a.max === void 0 ? null : a;
}
function $8(e) {
  return e ? e.kind === "number" ? "numeric" : e.kind === "email" ? "email" : "text" : "text";
}
function l$(e) {
  if (e)
    return e.max && e.max > 0 ? e.max : void 0;
}
function T8(e, t) {
  let n = String(e ?? "");
  if (!t) return n;
  if (t.kind === "number") {
    const i = n.startsWith("-");
    let o = !1;
    n = n.split("").filter((l) => l >= "0" && l <= "9" ? !0 : (l === "." || l === ",") && !o ? (o = !0, !0) : !1).join(""), i && (n = `-${n}`);
  } else t.kind === "email" && (n = n.replace(/\s+/g, ""));
  const a = l$(t);
  return a && n.length > a && (n = n.slice(0, a)), n;
}
function A8(e, t) {
  const n = typeof e == "string" ? e.trim() : "";
  return !t || n === "" ? "" : t.min && n.length < t.min ? "min" : t.max && n.length > t.max ? "max" : t.kind === "number" ? /^-?\d+([.,]\d+)?$/.test(n) ? "" : "number" : t.kind === "email" ? /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(n) ? "" : "email" : "";
}
const Pf = ["signature", "initials", "date", "text", "checkbox"];
function u$(e) {
  return e === "signature" || e === "initials";
}
function c$(e, t) {
  if (!Array.isArray(e)) return [];
  const n = [], a = /* @__PURE__ */ new Set();
  for (const i of e) {
    if (!i || typeof i != "object") continue;
    const o = typeof i.id == "string" ? i.id.trim() : "";
    if (!o || a.has(o)) continue;
    a.add(o);
    const l = { id: o, label: i.label ?? o };
    t(l, i), n.push(l);
  }
  return n;
}
function E8(e) {
  return c$(e, (t, n) => {
    n.examples && typeof n.examples == "object" && !Array.isArray(n.examples) && (t.examples = n.examples), n.default === !0 && (t.default = !0);
  });
}
function C8(e, t) {
  if (Array.isArray(e.lines)) {
    const n = new Set(e.lines);
    return t.filter((a) => n.has(a.id)).map((a) => a.id);
  }
  return t.filter((n) => n.default).map((n) => n.id);
}
function z8(e, t) {
  const n = e.examples ?? {};
  return n[t || "*"] ?? n["*"] ?? "";
}
const hp = {
  signature: { w: 0.28, h: 0.06 },
  initials: { w: 0.1, h: 0.05 },
  date: { w: 0.16, h: 0.035 },
  text: { w: 0.26, h: 0.035 },
  checkbox: { w: 0.03, h: 0.022 }
}, Ym = ["#2563eb", "#16a34a", "#d97706", "#9333ea", "#dc2626", "#0891b2"];
function d$(e) {
  return typeof e == "string" && Pf.includes(e);
}
function M8(e) {
  if (!Array.isArray(e)) return [...Pf];
  const t = e.filter(d$);
  return t.length ? Pf.filter((n) => t.includes(n)) : [...Pf];
}
function Of(e) {
  if (!Array.isArray(e)) return [];
  const t = [], n = /* @__PURE__ */ new Set();
  for (const a of e) {
    if (!a || typeof a != "object") continue;
    const i = String(a.id ?? "");
    if (!i || n.has(i) || !d$(a.type)) continue;
    n.add(i);
    const o = hl({ x: Number(a.x), y: Number(a.y), w: Number(a.w), h: Number(a.h) }), l = Math.max(1, Math.trunc(Number(a.page) || 1)), c = { id: i, type: a.type, page: l, ...o };
    typeof a.label == "string" && a.label && (c.label = a.label), typeof a.assignee == "string" && a.assignee && (c.assignee = a.assignee), a.required === !0 && (c.required = !0), a.placed === !1 && (c.placed = !1), a.value !== void 0 && a.value !== null && (c.value = a.value);
    const p = S8(a.rule);
    p && (c.rule = p), typeof a.format == "string" && a.format.trim() && (c.format = a.format.trim()), bc(a.font) && (c.font = a.font), u$(a.type) && (a.style === "typed" && (c.style = "typed"), Array.isArray(a.lines) && (c.lines = [...new Set(a.lines.filter((m) => typeof m == "string" && !!m))].slice(0, 16))), t.push(c);
  }
  return t;
}
function fy(e) {
  return e.placed !== !1;
}
function P8(e) {
  return e.filter((t) => !fy(t));
}
function O8(e, t, n = {}) {
  var o;
  const a = hp[t], i = {
    id: Eg(t, e),
    type: t,
    page: 1,
    x: 0.1,
    y: 0.1,
    w: a.w,
    h: a.h,
    placed: !1
  };
  return (o = n.label) != null && o.trim() && (i.label = n.label.trim()), n.assignee && (i.assignee = n.assignee), n.required && (i.required = !0), i;
}
function L8(e) {
  return c$(e, (t, n) => {
    typeof n.example == "string" && n.example.trim() && (t.example = n.example.trim()), typeof n.order == "string" && n.order.trim() && (t.order = n.order.trim()), n.order_label && (t.orderLabel = n.order_label), typeof n.separator == "string" && n.separator !== "" && (t.separator = n.separator), n.separator_label && (t.separatorLabel = n.separator_label);
  });
}
function D8(e) {
  if (!e || typeof e != "object" || Array.isArray(e)) return {};
  const t = e, n = {};
  for (const a of ["order", "separator", "example"]) {
    const i = t[a];
    (typeof i == "string" ? i.trim() : i && typeof i == "object") && (n[a] = i);
  }
  return n;
}
function R8(e) {
  if (!e.length) return null;
  const t = [], n = [];
  for (const a of e) {
    if (a.order === void 0 || a.separator === void 0) return null;
    t.some((i) => i.id === a.order) || t.push({ id: a.order, label: a.orderLabel ?? a.order }), n.some((i) => i.id === a.separator) || n.push({ id: a.separator, label: a.separatorLabel ?? a.separator });
  }
  return t.length && n.length ? { orders: t, separators: n } : null;
}
function g1(e, t, n) {
  var i, o;
  const a = e.find((l) => l.order === t && l.separator === n);
  return a ? a.id : ((i = e.find((l) => l.order === t)) == null ? void 0 : i.id) ?? ((o = e[0]) == null ? void 0 : o.id) ?? "";
}
function I8(e, t) {
  const n = e.find((a) => a.id === t);
  return !n || n.order === void 0 || n.separator === void 0 ? null : { order: n.order, separator: n.separator };
}
function N8(e) {
  const t = [];
  let n = 0;
  for (; n < e.length; )
    e.startsWith("YYYY", n) ? (t.push("YYYY"), n += 4) : e.startsWith("YY", n) ? (t.push("YY"), n += 2) : e.startsWith("DD", n) ? (t.push("DD"), n += 2) : e.startsWith("MM", n) ? (t.push("MM"), n += 2) : n += 1;
  return t;
}
function B8(e, t, n) {
  return N8(e).map((i) => i === "YYYY" ? String(n.getFullYear()).padStart(4, "0") : i === "YY" ? String(n.getFullYear() % 100).padStart(2, "0") : i === "MM" ? String(n.getMonth() + 1).padStart(2, "0") : String(n.getDate()).padStart(2, "0")).join(t);
}
function F8(e) {
  return Array.isArray(e) ? e.filter((t) => t && typeof t == "object" && typeof t.id == "string" && t.id).map((t) => ({
    id: t.id,
    label: t.label ?? t.id,
    color: typeof t.color == "string" ? t.color : void 0
  })) : [];
}
function U8(e, t) {
  const n = e.findIndex((a) => a.id === t);
  return n < 0 ? Ym[0] : e[n].color || Ym[n % Ym.length];
}
function f$(e, t) {
  return e.assignee ? !!t && e.assignee === t : !0;
}
function py(e) {
  const t = e.value;
  return e.type === "checkbox" ? t === !0 : typeof t == "string" ? t !== "" : t != null;
}
function p$(e, t) {
  return {
    fields: e.filter((n) => f$(n, t) && py(n)).map((n) => {
      const a = { id: n.id, value: n.value };
      return n.label && (a.label = n.label), n.font && (a.font = n.font), n.rule && (a.rule = n.rule), a;
    })
  };
}
function H8(e, t) {
  const n = t == null ? void 0 : t.fields;
  if (!Array.isArray(n)) return e;
  const a = /* @__PURE__ */ new Map();
  for (const i of n)
    i && typeof i.id == "string" && a.set(i.id, { value: i.value, font: bc(i.font) ? i.font : void 0 });
  return e.map((i) => {
    const o = a.get(i.id);
    return o ? { ...i, value: o.value, ...o.font ? { font: o.font } : {} } : i;
  });
}
function Ehe(e, t, n) {
  return e.map((a) => a.id === t ? { ...a, font: n } : a);
}
function K8(e, t, n) {
  return e.map((a) => {
    if (a.id !== t) return a;
    const i = { ...a };
    return n == null || n === "" || n === !1 ? delete i.value : i.value = n, i;
  });
}
function Eg(e, t) {
  const n = { signature: "sig", initials: "ini", date: "date", text: "text", checkbox: "chk" }[e], a = new Set(t.map((i) => i.id));
  for (let i = 1; ; i++) {
    const o = `${n}-${i}`;
    if (!a.has(o)) return o;
  }
}
function b1(e, t, n, a, i = hp[t], o) {
  const l = hl({ x: a.x, y: a.y, w: i.w, h: i.h }), c = { id: Eg(t, e), type: t, page: n, ...l };
  return o && (c.assignee = o), c;
}
function V8(e, t, n) {
  const a = e.find((o) => o.id === t);
  if (!a) return e;
  const i = { ...a, id: Eg(a.type, e), page: Math.max(1, Math.trunc(n)) };
  return delete i.value, [...e, i];
}
function j8(e = /* @__PURE__ */ new Date()) {
  const t = e.getFullYear(), n = String(e.getMonth() + 1).padStart(2, "0"), a = String(e.getDate()).padStart(2, "0");
  return `${t}-${n}-${a}`;
}
function Gc(e, t) {
  var n;
  for (const a of e ?? [])
    t(a), (n = a.children) != null && n.length && Gc(a.children, t);
}
function q8(e) {
  const t = {};
  return Gc(e, (n) => {
    var i;
    const a = n.props ?? {};
    if (n.type === "form") {
      const o = a;
      for (const l of o.fields ?? []) {
        if (!(l != null && l.key)) continue;
        const c = (i = o.values) == null ? void 0 : i[l.key];
        c !== void 0 ? t[l.key] = k1(l, c) : l.default !== void 0 ? t[l.key] = k1(l, l.default) : l.multi === !0 && l.type === "select" && (t[l.key] = []);
      }
      return;
    }
    if (n.id) {
      if (n.type === "people-picker") {
        const o = a.value;
        t[n.id] = Array.isArray(o) ? o.filter((l) => l && typeof l.email == "string") : [];
      } else if (n.type === "file-chooser") {
        const o = a.value;
        t[n.id] = typeof o == "string" ? o : "";
      } else if (n.type === "pin-input")
        t[n.id] = "";
      else if (n.type === "signature-pad")
        t[n.id] = null;
      else if (n.type === "pdf-fields") {
        const o = a, l = Of(o.fields);
        t[n.id] = o.mode === "fill" ? p$(l, o.signer) : l;
      }
    }
  }), t;
}
function k1(e, t) {
  return e.multi !== !0 || e.type !== "select" ? t : Array.isArray(t) ? t.map((n) => String(n)) : t == null || t === "" ? [] : [String(t)];
}
const W8 = /* @__PURE__ */ new Set(["string", "int", "bool", "password", "select"]);
function Y8(e) {
  const t = String(e.style ?? "").toLowerCase();
  return t === "choice" ? !0 : t === "switch" ? !1 : (e.options ?? []).length > 0 ? !0 : e.required === !0;
}
function G8(e, t) {
  const n = e.secret ? "password" : W8.has(String(e.type)) ? e.type : "string";
  return {
    key: e.key,
    type: n,
    label: Xt(e.label, t) || e.key,
    help: Xt(e.help, t) || void 0,
    i18n_key: "",
    required: e.required === !0,
    secret: e.secret === !0,
    default: e.default,
    placeholder: Xt(e.placeholder, t) || void 0,
    options: (e.options ?? []).map((a) => ({ value: String(a.value), label: Xt(a.label, t) || String(a.value) })),
    min: e.min,
    max: e.max,
    monospace: e.monospace === !0,
    // ⚠⚠ `text` IS the contract's long text (wire.Field: "string | password
    // | int | bool | select | text"), and the field renderer draws a textarea
    // only on `multiline`. Nothing mapped the two, so every long field a
    // plugin asked for arrived as a one-line box — including the signing
    // app's list of signers, under a help line that says "one per line".
    multiline: e.multiline === !0 || String(e.type) === "text",
    choice: n === "select" || n === "bool" && Y8(e),
    multi: e.multi === !0
  };
}
function X8(e) {
  const t = e.trim(), n = t.indexOf("@");
  return n > 0 && n < t.length - 1 && !/\s/.test(t) && t.indexOf("@", n + 1) === -1;
}
function hy(e) {
  return e == null ? !1 : typeof e == "string" ? e.trim() !== "" : Array.isArray(e) ? e.length > 0 : !0;
}
function J8(e) {
  return e == null ? [] : Array.isArray(e) ? e.map((t) => String(t)) : typeof e == "boolean" ? [e ? "true" : "false"] : [String(e)];
}
function h$(e, t) {
  if (!e || !e.key) return !0;
  const n = t == null ? void 0 : t[e.key], a = e.equals ?? [];
  if (!a.length) return hy(n);
  if (!hy(n)) return !1;
  const i = J8(n);
  return a.some((o) => i.includes(String(o)));
}
function Cg(e, t) {
  const n = (e ?? []).filter((i) => i && i.key);
  if (!n.length) return [];
  let a = n;
  for (let i = 0; i <= n.length; i++) {
    const o = m$(n, a, t), l = n.filter((c) => h$(c.show_when, o));
    if (l.length === a.length) return l;
    a = l;
  }
  return a;
}
function m$(e, t, n) {
  const a = new Set(t.map((o) => o.key)), i = { ...n };
  for (const o of e) a.has(o.key) || delete i[o.key];
  return i;
}
function v$(e, t) {
  return e.required === !0 ? !0 : e.required_when ? h$(e.required_when, t) : !1;
}
function y$(e) {
  const t = [];
  return Gc(e, (n) => {
    var i;
    if (n.type !== "form") return;
    const a = (i = n.props) == null ? void 0 : i.fields;
    for (const o of a ?? []) o && o.key && t.push(o);
  }), t;
}
function Z8(e, t) {
  const n = y$(e);
  if (!n.length) return [];
  const a = new Set(Cg(n, t).map((i) => i.key));
  return n.filter((i) => !a.has(i.key)).map((i) => i.key);
}
function Q8(e, t) {
  const n = Z8(e, t);
  if (!n.length) return { ...t };
  const a = { ...t };
  for (const i of n) delete a[i];
  return a;
}
function w1(e, t) {
  const n = y$(e);
  if (!n.length) return [];
  const a = Cg(n, t), i = m$(n, a, t);
  return a.filter((o) => v$(o, i) && !hy(i[o.key]));
}
const eR = 300;
function Gp(e, t) {
  const n = $(null), a = $({}), i = $(!1), o = $(""), l = $([]), c = E(() => {
    var A;
    return ((A = n.value) == null ? void 0 : A.actions) ?? [];
  }), p = E(() => {
    var A;
    return (A = n.value) == null ? void 0 : A.errors;
  });
  function m(A, L = !1) {
    n.value = A, o.value = "", l.value = [];
    const z = q8(A == null ? void 0 : A.nodes);
    a.value = L ? { ...z, ...a.value } : z;
  }
  function v(A) {
    var L;
    if (a.value = A, l.value.length) {
      const z = w1((L = n.value) == null ? void 0 : L.nodes, A).map((D) => D.key);
      z.length !== l.value.length && (l.value = z);
    }
  }
  let x = null;
  function w() {
    x !== null && clearTimeout(x), x = null;
  }
  function S() {
    w(), x = setTimeout(() => {
      x = null, b("change");
    }, eR);
  }
  let k = 0;
  async function b(A, L, z = {}) {
    var P, R, W, N, J, H;
    if (!n.value) return;
    const D = A !== "change";
    if (D) {
      if (w(), i.value) return;
      i.value = !0;
    }
    const U = ++k;
    o.value = "";
    const q = (P = e.paths) == null ? void 0 : P.call(e);
    try {
      const ne = await e.api.pluginViewEvent(e.plugin, e.view, {
        path: (R = e.path) == null ? void 0 : R.call(e),
        ...q != null && q.length ? { paths: [...q] } : {},
        state: ((W = n.value) == null ? void 0 : W.state) ?? {},
        event: A,
        action_id: L,
        // ⚠⚠ The values a HIDDEN field holds are dropped here, not blanked
        // (v3 §2.1: "a value belonging to a hidden field is dropped before
        // the job runs — it cannot arrive as a surprise"). The plugin is
        // re-asked the same question by the host at submit; this is the
        // client half of the same promise, and it also keeps a `change`
        // event from echoing back a field the step no longer shows.
        data: { values: Q8((N = n.value) == null ? void 0 : N.nodes, a.value), ...z }
      });
      if (!D && U !== k) return;
      if (ne.op) {
        t.onOp(ne.op), t.onDone();
        return;
      }
      const j = ne.surface;
      if (!j) {
        o.value = e.errorText();
        return;
      }
      const re = Xt(j.toast, e.locale());
      re && t.onToast(re);
      const he = Pp(j.open) ? j.open : null;
      if (j.done) {
        t.onDone(), he && ((J = t.onOpen) == null || J.call(t, he));
        return;
      }
      m(j, !D), he && ((H = t.onOpen) == null || H.call(t, he));
    } catch (ne) {
      if (!D && U !== k) return;
      o.value = Yi(e.locale(), String((ne == null ? void 0 : ne.message) ?? ne)) || e.errorText();
    } finally {
      D && (i.value = !1);
    }
  }
  function C(A) {
    var L;
    if (i.value || A.disabled) return Promise.resolve();
    if (A.primary) {
      const z = w1((L = n.value) == null ? void 0 : L.nodes, a.value);
      if (l.value = z.map((D) => D.key), z.length) return Promise.resolve();
    }
    return b(A.primary ? "submit" : "action", A.id);
  }
  function T(A) {
    return b("action", A.action_id, { row_id: A.row_id });
  }
  return Zo() && Tt(w), {
    current: n,
    values: a,
    busy: i,
    failure: o,
    footer: c,
    errors: p,
    invalidKeys: l,
    setSurface: m,
    updateValues: v,
    scheduleChange: S,
    post: b,
    press: C,
    rowAction: T,
    dispose: w
  };
}
const Lf = ["draw", "type", "upload"], tR = 200 * 1024, g$ = 600, b$ = 200, nR = 480, aR = 160, _1 = "#111111", my = r$;
function k$(e) {
  return typeof e == "string" && Lf.includes(e);
}
function iR(e) {
  if (!Array.isArray(e)) return [...Lf];
  const t = e.filter(k$);
  return t.length ? Lf.filter((n) => t.includes(n)) : [...Lf];
}
function ju(e) {
  const t = e;
  return !!t && typeof t == "object" && typeof t.png_b64 == "string" && t.png_b64 !== "" && k$(t.mode);
}
function oR(e) {
  const t = e;
  return t && bc(t.font) ? t.font : my;
}
function rR(e, t) {
  const n = Number(e), a = Number(t);
  return {
    width: Number.isFinite(n) && n > 0 ? Math.min(g$, Math.max(120, Math.round(n))) : nR,
    height: Number.isFinite(a) && a > 0 ? Math.min(b$, Math.max(60, Math.round(a))) : aR
  };
}
function sR(e, t, n, a) {
  if (!(e > 0) || !(t > 0)) return { width: n, height: a };
  const i = Math.min(1, n / e, a / t);
  return { width: Math.max(1, Math.round(e * i)), height: Math.max(1, Math.round(t * i)) };
}
function lR(e) {
  const t = e.indexOf("base64,");
  return t >= 0 ? e.slice(t + 7) : e;
}
function uR(e) {
  return e.type !== "image/png" && e.type !== "image/jpeg" ? "bad_type" : e.size > tR ? "too_big" : "ok";
}
function cR(e, t, n) {
  let a = Math.min(96, Math.floor(n * 0.6));
  for (; a > 12 && e(a) > t; ) a -= 2;
  return a;
}
const dR = 44;
function fR(e, t, n, a) {
  const i = t.height - e.bottom - 8, o = e.top - 8, l = Math.min(320, a * dR + 8), c = i < Math.min(l, 160) && o > i, p = Math.min(Math.max(e.width, 180), t.width - 16), m = Oc(Ur(e, n), p, t.width, n);
  return {
    top: Math.round(e.bottom + 4),
    bottom: Math.round(t.height - e.top + 4),
    start: Math.round(n === "rtl" ? t.width - m - p : m),
    width: Math.round(p),
    maxHeight: Math.round(Math.max(120, Math.min(320, c ? o : i))),
    up: c
  };
}
const pR = ["id", "disabled", "aria-expanded", "aria-activedescendant", "aria-label", "aria-labelledby", "aria-describedby", "aria-required", "aria-invalid", "data-testid", "data-value"], hR = ["name", "value", "required", "disabled"], mR = ["dir", "aria-labelledby", "data-testid"], vR = ["id", "aria-selected", "aria-disabled", "data-value", "data-testid", "onMousemove", "onClick"], yR = { class: "fe-select__label" }, gR = { class: "fe-select__text" }, bR = {
  key: 0,
  class: "fe-select__help"
}, kc = /* @__PURE__ */ lt({
  __name: "ChoiceSelect",
  props: {
    modelValue: { default: null },
    options: {},
    id: { default: void 0 },
    name: { default: void 0 },
    placeholder: { default: "" },
    required: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    invalid: { type: Boolean, default: !1 },
    size: { default: "md" },
    ariaLabel: { default: void 0 },
    ariaLabelledby: { default: void 0 },
    ariaDescribedby: { default: void 0 },
    requiredMessage: { default: "" },
    testid: { default: void 0 }
  },
  emits: ["update:modelValue", "change", "invalid"],
  setup(e, { expose: t, emit: n }) {
    const a = e, i = n, o = `fe-sel-${Math.random().toString(36).slice(2, 10)}`, l = E(() => a.id ?? o), c = `${o}-list`, p = (B) => `${o}-opt-${B}`, m = $(!1), v = $(-1), x = $(null), w = $(null), S = $(null), k = $(null), b = $({
      top: 0,
      bottom: 0,
      start: 0,
      width: 0,
      maxHeight: 280,
      up: !1,
      z: ig,
      dir: "ltr"
    }), C = $({}), T = $(!1);
    let A = "", L = 0;
    const z = (B) => B == null || B === "", D = E(() => a.options.findIndex((B) => B.value === a.modelValue)), U = E(() => a.options[D.value]), q = E(() => {
      var B;
      return ((B = U.value) == null ? void 0 : B.label) ?? a.placeholder;
    }), P = E(() => a.invalid || T.value), R = E(() => a.required || !!a.name);
    function W() {
      var B;
      (B = S.value) == null || B.setCustomValidity(a.required && z(a.modelValue) ? a.requiredMessage || " " : "");
    }
    Je(
      () => a.modelValue,
      (B) => {
        z(B) || (T.value = !1), Gt(W);
      },
      { immediate: !0 }
    ), Je(() => a.required, () => void Gt(W)), Je(
      () => a.disabled,
      (B) => {
        B && ue(!1);
      }
    );
    function N(B, V) {
      const be = a.options.length;
      for (let Fe = 0, ze = B; Fe < be; Fe++, ze += V) {
        if (ze < 0 || ze >= be) return -1;
        if (!a.options[ze].disabled) return ze;
      }
      return -1;
    }
    const J = [
      "--fe-bg",
      "--fe-bg-hover",
      "--fe-border",
      "--fe-text",
      "--fe-text-muted",
      "--fe-primary",
      "--fe-primary-ink",
      "--fe-radius",
      "--fe-radius-sm",
      "--fe-shadow",
      "--fe-text-xs"
    ];
    function H(B) {
      const V = {};
      try {
        const be = window.getComputedStyle(B);
        for (const Fe of J) {
          const ze = be.getPropertyValue(Fe).trim();
          ze && (V[Fe] = ze);
        }
        be.fontFamily && (V["font-family"] = be.fontFamily), be.fontSize && (V["font-size"] = be.fontSize);
      } catch {
      }
      return V;
    }
    function ne() {
      const B = x.value;
      if (!B) return;
      const V = ei(B), be = fR(
        B.getBoundingClientRect(),
        { width: window.innerWidth, height: window.innerHeight },
        V,
        a.options.length
      );
      b.value = { ...be, z: b.value.z, dir: V };
    }
    function j(B) {
      var be, Fe;
      const V = B.target;
      !V || (be = x.value) != null && be.contains(V) || (Fe = w.value) != null && Fe.contains(V) || ue(!1);
    }
    function re(B) {
      B ? (window.addEventListener("resize", ne), window.addEventListener("scroll", ne, !0), document.addEventListener("pointerdown", j, !0)) : (window.removeEventListener("resize", ne), window.removeEventListener("scroll", ne, !0), document.removeEventListener("pointerdown", j, !0));
    }
    async function he(B) {
      if (a.disabled || m.value) return;
      const V = x.value;
      k.value = (V == null ? void 0 : V.closest("dialog[open]")) ?? document.body, V && (C.value = H(V), b.value = { ...b.value, z: Rc(V) }), ne(), m.value = !0, v.value = B ?? (D.value >= 0 ? D.value : N(0, 1)), re(!0), await Gt(), fe();
    }
    function ue(B = !0) {
      var V;
      m.value && (m.value = !1, A = "", re(!1), B && ((V = x.value) == null || V.focus()));
    }
    function ae(B, V = !0) {
      const be = a.options[B];
      !be || be.disabled || (be.value !== a.modelValue && (i("update:modelValue", be.value), i("change", be.value)), ue(V));
    }
    function fe() {
      const B = document.getElementById(p(v.value));
      B && typeof B.scrollIntoView == "function" && B.scrollIntoView({ block: "nearest" });
    }
    function _(B) {
      B < 0 || (v.value = B, Gt(fe));
    }
    function Q(B) {
      const V = Date.now();
      A = V - L > 600 ? B : A + B, L = V;
      const be = a.options.length, Fe = A.length > 1 ? Math.max(v.value, 0) : v.value + 1, ze = A.toLocaleLowerCase();
      for (let Ue = 0; Ue < be; Ue++) {
        const We = (Fe + Ue + be) % be, $t = a.options[We];
        if (!$t.disabled && $t.label.toLocaleLowerCase().startsWith(ze)) return We;
      }
      return -1;
    }
    function K(B) {
      if (a.disabled) return;
      const V = B.key;
      if (!m.value) {
        if (V === "ArrowDown" || V === "ArrowUp" || V === "Enter" || V === " ")
          B.preventDefault(), he();
        else if (V === "Home" || V === "End")
          B.preventDefault(), he(V === "Home" ? N(0, 1) : N(a.options.length - 1, -1));
        else if (V.length === 1 && !B.ctrlKey && !B.metaKey && !B.altKey) {
          const be = Q(V);
          be >= 0 && he(be);
        }
        return;
      }
      switch (V) {
        case "ArrowDown":
          if (B.preventDefault(), B.altKey) return;
          _(N(v.value + 1, 1));
          return;
        case "ArrowUp":
          if (B.preventDefault(), B.altKey) return ae(v.value);
          _(N(v.value - 1, -1));
          return;
        case "Home":
          B.preventDefault(), _(N(0, 1));
          return;
        case "End":
          B.preventDefault(), _(N(a.options.length - 1, -1));
          return;
        case "PageDown":
          B.preventDefault(), _(N(Math.min(v.value + 10, a.options.length - 1), -1));
          return;
        case "PageUp":
          B.preventDefault(), _(N(Math.max(v.value - 10, 0), 1));
          return;
        case "Enter":
        case " ":
          B.preventDefault(), ae(v.value);
          return;
        case "Escape":
          B.preventDefault(), B.stopPropagation(), ue();
          return;
        case "Tab":
          ae(v.value, !1);
          return;
      }
      if (V.length === 1 && !B.ctrlKey && !B.metaKey && !B.altKey) {
        const be = Q(V);
        be >= 0 && _(be);
      }
    }
    function I() {
      m.value ? ue() : he();
    }
    function Y(B) {
      var be, Fe;
      B.preventDefault(), T.value = !0, i("invalid", B);
      const V = ((be = S.value) == null ? void 0 : be.form) ?? null;
      if (V) {
        if (V.dataset.fxInvalidFocus) return;
        V.dataset.fxInvalidFocus = "1", queueMicrotask(() => {
          delete V.dataset.fxInvalidFocus;
        });
      }
      (Fe = x.value) == null || Fe.focus();
    }
    return Tt(() => re(!1)), t({ focus: () => {
      var B;
      return (B = x.value) == null ? void 0 : B.focus();
    }, open: he, close: ue }), (B, V) => (f(), h("span", {
      class: Re(["fe-select", [
        e.size !== "md" ? `fe-select--${e.size}` : "",
        { "is-open": m.value, "is-disabled": e.disabled, "is-invalid": P.value }
      ]])
    }, [
      d("button", {
        id: l.value,
        ref_key: "trigger",
        ref: x,
        type: "button",
        class: "fe-select__trigger",
        role: "combobox",
        disabled: e.disabled,
        "aria-haspopup": "listbox",
        "aria-expanded": m.value ? "true" : "false",
        "aria-controls": c,
        "aria-activedescendant": m.value && v.value >= 0 ? p(v.value) : void 0,
        "aria-label": e.ariaLabel,
        "aria-labelledby": e.ariaLabelledby,
        "aria-describedby": e.ariaDescribedby,
        "aria-required": e.required ? "true" : void 0,
        "aria-invalid": P.value ? "true" : void 0,
        "data-testid": e.testid,
        "data-value": e.modelValue ?? "",
        onClick: I,
        onKeydown: K,
        onKeyup: V[0] || (V[0] = Ca(yt(() => {
        }, ["prevent"]), ["space"]))
      }, [
        d("span", {
          class: Re(["fe-select__value", { "is-placeholder": !U.value }])
        }, y(q.value), 3),
        Ze(u(nP), {
          class: "fe-select__chev",
          "aria-hidden": "true"
        })
      ], 40, pR),
      R.value ? (f(), h("input", {
        key: 0,
        ref_key: "hidden",
        ref: S,
        class: "fe-select__native",
        tabindex: "-1",
        "aria-hidden": "true",
        name: e.name,
        value: e.modelValue ?? "",
        required: e.required,
        disabled: e.disabled,
        onInvalid: Y
      }, null, 40, hR)) : O("", !0),
      m.value && k.value ? (f(), Ge(wi, {
        key: 1,
        to: k.value
      }, [
        d("ul", {
          id: c,
          ref_key: "panel",
          ref: w,
          class: Re(["fe-select__panel", { "is-up": b.value.up }]),
          dir: b.value.dir,
          role: "listbox",
          "aria-labelledby": e.ariaLabelledby ?? l.value,
          style: Wt([
            C.value,
            {
              insetInlineStart: b.value.start + "px",
              width: b.value.width + "px",
              maxHeight: b.value.maxHeight + "px",
              top: b.value.up ? void 0 : b.value.top + "px",
              bottom: b.value.up ? b.value.bottom + "px" : void 0,
              zIndex: b.value.z
            }
          ]),
          "data-testid": e.testid ? `${e.testid}-list` : void 0,
          onMousedown: V[1] || (V[1] = yt(() => {
          }, ["prevent"]))
        }, [
          (f(!0), h(Te, null, nt(e.options, (be, Fe) => (f(), h("li", {
            id: p(Fe),
            key: String(be.value),
            class: Re(["fe-select__option", { "is-active": Fe === v.value, "is-selected": be.value === e.modelValue }]),
            role: "option",
            "aria-selected": be.value === e.modelValue ? "true" : "false",
            "aria-disabled": be.disabled ? "true" : void 0,
            "data-value": be.value,
            "data-testid": e.testid ? `${e.testid}-option-${be.value === "" ? "none" : be.value}` : void 0,
            onMousemove: (ze) => !be.disabled && (v.value = Fe),
            onClick: (ze) => ae(Fe)
          }, [
            d("span", yR, [
              d("span", gR, y(be.label), 1),
              be.help ? (f(), h("span", bR, y(be.help), 1)) : O("", !0)
            ]),
            be.value === e.modelValue ? (f(), Ge(u(Av), {
              key: 0,
              class: "fe-select__check",
              "aria-hidden": "true"
            })) : O("", !0)
          ], 42, vR))), 128))
        ], 46, mR)
      ], 8, ["to"])) : O("", !0)
    ], 2));
  }
}), kR = { class: "fe-cfield" }, wR = {
  key: 0,
  class: "fe-cfield__empty"
}, _R = {
  key: 0,
  class: "fe-cfield__check"
}, xR = ["checked", "disabled", "onChange"], SR = ["for"], $R = {
  key: 0,
  class: "fe-cfield__req",
  "aria-hidden": "true"
}, TR = ["id", "value", "placeholder", "disabled", "onInput"], AR = {
  key: 5,
  class: "fe-cfield__secret"
}, ER = ["id", "type", "value", "placeholder", "disabled", "onInput"], CR = ["title", "aria-label", "onClick"], zR = ["innerHTML"], MR = ["id", "type", "value", "placeholder", "min", "max", "disabled", "onInput"], PR = {
  key: 7,
  class: "fe-cfield__help"
}, OR = {
  key: 8,
  class: "fe-cfield__error"
}, LR = {
  key: 1,
  class: "fe-cfield__adv"
}, DR = {
  key: 0,
  class: "fe-cfield__advbody"
}, RR = {
  key: 0,
  class: "fe-cfield__check"
}, IR = ["checked", "disabled", "onChange"], NR = ["for"], BR = ["id", "type", "value", "placeholder", "disabled", "onInput"], FR = {
  key: 2,
  class: "fe-cfield__help"
}, UR = {
  key: 3,
  class: "fe-cfield__error"
}, HR = /* @__PURE__ */ lt({
  __name: "StorageFields",
  props: {
    fields: {},
    modelValue: {},
    locale: {},
    invalid: {},
    errors: {},
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = pt(() => n.locale), o = $(!1), l = $({}), c = E(() => n.fields.filter((R) => !R.advanced)), p = E(() => n.fields.filter((R) => R.advanced));
    function m(R) {
      const W = i(R.i18n_key);
      return W === R.i18n_key ? R.label : W;
    }
    function v(R) {
      if (!R.help_i18n_key) return R.help ?? "";
      const W = i(R.help_i18n_key);
      return W === R.help_i18n_key ? R.help ?? "" : W;
    }
    function x(R) {
      if (!R.i18n_key) return R.label;
      const W = i(R.i18n_key);
      return W === R.i18n_key ? R.label : W;
    }
    function w(R, W) {
      a("update:modelValue", { ...n.modelValue, [R]: W });
    }
    function S(R) {
      var N, J;
      const W = (N = n.modelValue) == null ? void 0 : N[R.key];
      if (W != null) return W;
      for (const H of R.aliases ?? []) {
        const ne = (J = n.modelValue) == null ? void 0 : J[H];
        if (ne != null) return ne;
      }
      return R.default ?? void 0;
    }
    function k(R) {
      const W = S(R);
      return W == null ? "" : String(W);
    }
    function b(R) {
      const W = S(R);
      return W === "" || W === void 0 || W === null ? "" : String(W);
    }
    function C(R) {
      return S(R) === !0;
    }
    function T(R) {
      var W;
      return (n.invalid ?? []).includes(R.key) || !!((W = n.errors) != null && W[R.key]);
    }
    function A(R) {
      var W;
      return ((W = n.errors) == null ? void 0 : W[R.key]) || (T(R) ? i("conn.form.required") : "");
    }
    function L(R) {
      if (R.type === "bool") {
        const W = (R.options ?? []).filter((H) => H.value === "true" || H.value === "false"), N = W.find((H) => H.value === "true"), J = W.find((H) => H.value === "false");
        return [
          { value: "true", label: N ? x(N) : i("conn.form.yes") },
          { value: "false", label: J ? x(J) : i("conn.form.no") }
        ];
      }
      return (R.options ?? []).map((W) => ({ value: W.value, label: x(W) }));
    }
    function z(R) {
      const W = S(R);
      return R.type === "bool" ? W === !0 || W === "true" ? "true" : W === !1 || W === "false" ? "false" : "" : R.multi ? Array.isArray(W) ? W.map((N) => String(N)) : W == null || W === "" ? [] : [String(W)] : W == null ? "" : String(W);
    }
    function D(R, W) {
      if (R.type === "bool") {
        w(R.key, W === "true");
        return;
      }
      w(R.key, W);
    }
    function U(R) {
      return R.choice === !0 && (R.type === "select" || R.type === "bool");
    }
    function q(R) {
      return R.type === "int" ? "number" : R.type === "password" && !l.value[R.key] ? "password" : "text";
    }
    function P(R) {
      l.value = { ...l.value, [R]: !l.value[R] };
    }
    return (R, W) => (f(), h("div", kR, [
      e.fields.length ? O("", !0) : (f(), h("p", wR, y(u(i)("conn.form.noFields")), 1)),
      (f(!0), h(Te, null, nt(c.value, (N) => (f(), h("div", {
        key: N.key,
        class: Re(["fe-cfield__row", { "is-invalid": T(N) }])
      }, [
        N.type === "bool" && !U(N) ? (f(), h("label", _R, [
          d("input", {
            type: "checkbox",
            checked: C(N),
            disabled: e.disabled,
            onChange: (J) => w(N.key, J.target.checked)
          }, null, 40, xR),
          d("span", null, y(m(N)), 1)
        ])) : (f(), h("label", {
          key: 1,
          class: "fe-cfield__label",
          for: `fe-cf-${N.key}`
        }, [
          Ht(y(m(N)), 1),
          N.required ? (f(), h("span", $R, "*")) : O("", !0)
        ], 8, SR)),
        U(N) ? (f(), Ge(mi, {
          key: 2,
          options: L(N),
          "model-value": z(N),
          multi: N.multi === !0,
          disabled: e.disabled,
          invalid: T(N),
          "aria-label": m(N),
          "testid-prefix": `fe-choice-${N.key}`,
          "onUpdate:modelValue": (J) => D(N, J)
        }, null, 8, ["options", "model-value", "multi", "disabled", "invalid", "aria-label", "testid-prefix", "onUpdate:modelValue"])) : N.type === "select" ? (f(), Ge(kc, {
          key: 3,
          id: `fe-cf-${N.key}`,
          "model-value": k(N),
          options: L(N),
          disabled: e.disabled,
          invalid: T(N),
          "onUpdate:modelValue": (J) => w(N.key, String(J))
        }, null, 8, ["id", "model-value", "options", "disabled", "invalid", "onUpdate:modelValue"])) : N.multiline ? (f(), h("textarea", {
          key: 4,
          id: `fe-cf-${N.key}`,
          class: Re(["fe-cfield__input fe-cfield__input--area", { "fe-cfield__input--mono": N.monospace }]),
          rows: "4",
          value: k(N),
          placeholder: N.placeholder,
          disabled: e.disabled,
          onInput: (J) => w(N.key, J.target.value)
        }, null, 42, TR)) : N.type === "password" ? (f(), h("div", AR, [
          d("input", {
            id: `fe-cf-${N.key}`,
            class: "fe-cfield__input fe-cfield__input--mono",
            type: q(N),
            autocomplete: "new-password",
            spellcheck: "false",
            value: k(N),
            placeholder: N.placeholder,
            disabled: e.disabled,
            onInput: (J) => w(N.key, J.target.value)
          }, null, 40, ER),
          d("button", {
            type: "button",
            class: "fe-cfield__eye",
            title: l.value[N.key] ? u(i)("conn.form.hide") : u(i)("conn.form.reveal"),
            "aria-label": l.value[N.key] ? u(i)("conn.form.hide") : u(i)("conn.form.reveal"),
            onClick: (J) => P(N.key)
          }, [
            d("span", {
              "aria-hidden": "true",
              innerHTML: u(zt)(l.value[N.key] ? "toggle-hidden" : "preview")
            }, null, 8, zR)
          ], 8, CR)
        ])) : N.type !== "bool" ? (f(), h("input", {
          key: 6,
          id: `fe-cf-${N.key}`,
          class: Re(["fe-cfield__input", { "fe-cfield__input--mono": N.monospace }]),
          type: q(N),
          value: N.type === "int" ? b(N) : k(N),
          placeholder: N.placeholder,
          min: N.min,
          max: N.max,
          disabled: e.disabled,
          onInput: (J) => w(
            N.key,
            N.type === "int" ? J.target.value === "" ? null : Number(J.target.value) : J.target.value
          )
        }, null, 42, MR)) : O("", !0),
        v(N) ? (f(), h("p", PR, y(v(N)), 1)) : O("", !0),
        A(N) ? (f(), h("p", OR, y(A(N)), 1)) : O("", !0)
      ], 2))), 128)),
      p.value.length ? (f(), h("div", LR, [
        d("button", {
          type: "button",
          class: "fe-cfield__advtoggle",
          onClick: W[0] || (W[0] = (N) => o.value = !o.value)
        }, y(o.value ? "▾" : "▸") + " " + y(u(i)("conn.form.advanced")), 1),
        o.value ? (f(), h("div", DR, [
          (f(!0), h(Te, null, nt(p.value, (N) => (f(), h("div", {
            key: N.key,
            class: "fe-cfield__row"
          }, [
            N.type === "bool" ? (f(), h("label", RR, [
              d("input", {
                type: "checkbox",
                checked: C(N),
                disabled: e.disabled,
                onChange: (J) => w(N.key, J.target.checked)
              }, null, 40, IR),
              d("span", null, y(m(N)), 1)
            ])) : (f(), h(Te, { key: 1 }, [
              d("label", {
                class: "fe-cfield__label",
                for: `fe-cfa-${N.key}`
              }, y(m(N)), 9, NR),
              d("input", {
                id: `fe-cfa-${N.key}`,
                class: Re(["fe-cfield__input", { "fe-cfield__input--mono": N.monospace }]),
                type: q(N),
                value: N.type === "int" ? b(N) : k(N),
                placeholder: N.placeholder,
                disabled: e.disabled,
                onInput: (J) => w(
                  N.key,
                  N.type === "int" ? J.target.value === "" ? null : Number(J.target.value) : J.target.value
                )
              }, null, 42, BR)
            ], 64)),
            v(N) ? (f(), h("p", FR, y(v(N)), 1)) : O("", !0),
            A(N) ? (f(), h("p", UR, y(A(N)), 1)) : O("", !0)
          ]))), 128))
        ])) : O("", !0)
      ])) : O("", !0)
    ]));
  }
}), KR = {
  class: "fe-surface__form",
  "data-testid": "surface-form"
}, VR = /* @__PURE__ */ lt({
  __name: "SurfaceForm",
  props: {
    fields: {},
    values: {},
    locale: {},
    errors: {},
    disabled: { type: Boolean },
    invalid: {}
  },
  emits: ["update:values"],
  setup(e, { emit: t }) {
    const n = e, a = t, i = E(() => Cg(n.fields, n.values)), o = E(
      () => i.value.map((c) => ({ ...G8(c, n.locale), required: v$(c, n.values) }))
    ), l = E(() => {
      var p;
      const c = {};
      for (const m of o.value) {
        const v = Xt((p = n.errors) == null ? void 0 : p[m.key], n.locale);
        v && (c[m.key] = v);
      }
      return c;
    });
    return (c, p) => (f(), h("div", KR, [
      Ze(HR, {
        fields: o.value,
        "model-value": e.values,
        locale: e.locale,
        errors: l.value,
        invalid: e.invalid,
        disabled: e.disabled,
        "onUpdate:modelValue": p[0] || (p[0] = (m) => a("update:values", m))
      }, null, 8, ["fields", "model-value", "locale", "errors", "invalid", "disabled"])
    ]));
  }
}), jR = ["aria-label"], qR = ["aria-current", "data-step"], WR = {
  class: "fe-steps__marker",
  "aria-hidden": "true"
}, YR = {
  key: 0,
  class: "fe-ficon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  focusable: "false"
}, GR = { class: "fe-steps__label" }, XR = /* @__PURE__ */ lt({
  __name: "SurfaceSteps",
  props: {
    items: {},
    locale: {}
  },
  setup(e) {
    const t = e, { t: n } = pt(() => t.locale);
    function a(i) {
      return i === "done" || i === "active" ? i : "todo";
    }
    return (i, o) => (f(), h("ol", {
      class: "fe-steps",
      "aria-label": u(n)("plugin.steps.label"),
      "data-testid": "surface-steps"
    }, [
      (f(!0), h(Te, null, nt(e.items ?? [], (l, c) => (f(), h("li", {
        key: l.id || c,
        class: Re(["fe-steps__item", `is-${a(l.state)}`]),
        "aria-current": a(l.state) === "active" ? "step" : void 0,
        "data-step": l.id
      }, [
        d("span", WR, [
          a(l.state) === "done" ? (f(), h("svg", YR, [...o[0] || (o[0] = [
            d("path", { d: "M4.8 12.6l4.7 4.7L19.2 6.9" }, null, -1)
          ])])) : (f(), h(Te, { key: 1 }, [
            Ht(y(c + 1), 1)
          ], 64))
        ]),
        d("span", GR, y(u(Xt)(l.label, e.locale)), 1)
      ], 10, qR))), 128))
    ], 8, jR));
  }
});
let Gm = null;
function w$() {
  return Gm || (Gm = b5("t")), Gm;
}
function zg() {
  const e = w$().get();
  return e && typeof e == "object" && !Array.isArray(e) ? e : {};
}
function _$(e, t) {
  const n = zg(), a = { ...n[e] ?? {} };
  for (const [o, l] of Object.entries(t))
    l === void 0 ? delete a[o] : a[o] = l;
  const i = { ...n };
  Object.keys(a).length ? i[e] = a : delete i[e], w$().set(i);
}
function JR(e) {
  return {
    get: () => {
      var t;
      return (t = zg()[e]) == null ? void 0 : t.c;
    },
    set: (t) => {
      var a;
      const n = Object.keys(t.w).length > 0 || t.hidden.length > 0 || (((a = t.o) == null ? void 0 : a.length) ?? 0) > 0;
      _$(e, { c: n ? t : void 0 });
    }
  };
}
function ZR(e) {
  var n;
  const t = (n = zg()[e]) == null ? void 0 : n.s;
  return !t || typeof t.k != "string" || t.d !== "asc" && t.d !== "desc" ? null : { key: t.k, dir: t.d };
}
function QR(e, t) {
  _$(e, { s: t ? { k: t.key, d: t.dir } : void 0 });
}
const Xm = "data-fe-cut-title";
function x1(e) {
  const t = e;
  return t.scrollWidth > t.clientWidth;
}
function eI(e) {
  return (e.textContent ?? "").replace(/\s+/g, " ").trim();
}
function tI(e, t) {
  if (!t || typeof Element > "u" || !(e instanceof Element)) return;
  const n = e.closest(".tbl-pill");
  if (!n || !t.contains(n)) return;
  const a = n.getAttribute(Xm), i = n.getAttribute("title");
  if (i !== null && i !== a) return;
  const o = Array.from(n.querySelectorAll(".tbl-pill__text")), l = x1(n) || o.some(x1), c = eI(n);
  l && c ? (n.setAttribute("title", c), n.setAttribute(Xm, c)) : a !== null && (n.removeAttribute("title"), n.removeAttribute(Xm));
}
const nI = ["aria-checked", "aria-label", "title"], Mg = /* @__PURE__ */ lt({
  __name: "ItemCheck",
  props: {
    on: { type: Boolean },
    label: {}
  },
  setup(e) {
    return (t, n) => (f(), h("button", {
      type: "button",
      class: Re(["fe-list__check", { "is-on": e.on }]),
      role: "checkbox",
      "aria-checked": e.on ? "true" : "false",
      "aria-label": e.label,
      title: e.label,
      onMousedown: n[0] || (n[0] = yt(() => {
      }, ["prevent"]))
    }, null, 42, nI));
  }
}), aI = ["disabled", "data-testid"], iI = /* @__PURE__ */ lt({
  __name: "RowActions",
  props: {
    actions: {},
    locale: { default: "en" },
    label: {},
    disabled: { type: Boolean },
    theme: {},
    testid: {}
  },
  emits: ["select"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i, dir: o } = pt(() => n.locale), l = $(
      null
    ), c = E(() => n.label || i("row.actions")), p = E(
      () => n.actions.filter((w) => !w.hidden).map((w) => ({
        ...w,
        shortcutId: w.shortcutId ?? "",
        testid: w.testid ?? (n.testid ? `${n.testid}-${w.key}` : void 0)
      }))
    ), m = E(() => p.value.some((w) => !w.divider && !w.disabled));
    function v(w) {
      var k, b;
      const S = (k = w.currentTarget) == null ? void 0 : k.getBoundingClientRect();
      (b = l.value) == null || b.show(
        // ⚠ RTL: the START corner (right in RTL), as ListView `onRowMenu` does.
        { clientX: S ? Ur(S, o.value) : w.clientX, clientY: S ? S.bottom : w.clientY },
        []
      );
    }
    function x(w) {
      a("select", w.key, w);
    }
    return (w, S) => (f(), h("div", {
      class: "tbl-rowactions",
      onClick: S[0] || (S[0] = yt(() => {
      }, ["stop"]))
    }, [
      d("button", {
        type: "button",
        class: "tbl-rowactions__btn",
        disabled: e.disabled || !m.value,
        "data-testid": e.testid,
        "data-fe-control": "",
        "aria-haspopup": "menu",
        onClick: yt(v, ["stop"])
      }, [
        d("span", null, y(c.value), 1),
        S[1] || (S[1] = d("span", {
          class: "tbl-rowactions__caret",
          "aria-hidden": "true"
        }, "▾", -1))
      ], 8, aI),
      Ze(_l, {
        ref_key: "menu",
        ref: l,
        locale: e.locale,
        theme: e.theme,
        actions: p.value,
        onSelect: x
      }, null, 8, ["locale", "theme", "actions"])
    ]));
  }
}), oI = {
  key: 0,
  class: "tbl-bar"
}, rI = {
  key: 1,
  class: "fe-list__refreshing",
  role: "status"
}, sI = { class: "fe-sr-only" }, lI = ["aria-label", "aria-busy", "data-table-id"], uI = ["data-sort-label"], cI = {
  key: 0,
  class: "fe-list__col fe-list__col--check",
  role: "columnheader"
}, dI = ["aria-sort", "data-col"], fI = ["disabled", "title"], pI = { class: "fe-list__sort-label" }, hI = {
  key: 0,
  class: "fe-list__sort-arrow",
  "aria-hidden": "true"
}, mI = ["title"], vI = ["aria-valuenow", "aria-valuemin", "aria-valuemax", "aria-label", "title"], yI = ["aria-sort", "aria-label", "data-col", "onPointerdown", "onKeydown"], gI = ["disabled", "title", "onClick"], bI = { class: "fe-list__sort-label" }, kI = {
  key: 0,
  class: "fe-list__sort-arrow",
  "aria-hidden": "true"
}, wI = ["title"], _I = ["aria-valuenow", "aria-valuemin", "aria-valuemax", "aria-label", "title", "onPointerdown", "onDblclick", "onKeydown"], xI = ["title", "aria-label", "aria-expanded"], SI = ["role"], $I = {
  key: 0,
  class: "fe-list__group",
  role: "presentation"
}, TI = ["aria-selected", "onClick", "onDblclick", "onContextmenu", "onDragstart", "onDragover", "onDragleave", "onDrop", "onTouchstartPassive"], AI = ["onClick"], EI = ["title"], CI = { class: "fe-list__cell-text" }, zI = ["data-col", "data-label", "title"], MI = {
  key: 0,
  class: "fe-list__cell-text"
}, PI = {
  key: 0,
  class: "fe-list__empty fe-list__empty--loading",
  role: "row"
}, OI = ["aria-colspan"], LI = {
  key: 1,
  class: "fe-list__empty",
  role: "row"
}, DI = ["aria-colspan"], RI = {
  key: 2,
  class: "tbl-foot"
}, II = {
  key: 0,
  class: "tbl-pager"
}, NI = ["disabled", "aria-label", "title"], BI = {
  class: "tbl-pager__at",
  dir: "ltr"
}, FI = ["disabled", "aria-label", "title"], UI = ["dir", "data-prefers-dark"], HI = ["aria-label", "onKeydown"], KI = { class: "fe-colmenu__title" }, VI = ["aria-checked", "onClick"], jI = { class: "fe-colmenu__label" }, qI = ["disabled", "title", "aria-label", "onClick"], WI = { "aria-hidden": "true" }, YI = ["disabled", "title", "aria-label", "onClick"], GI = { "aria-hidden": "true" }, XI = {
  key: 0,
  class: "fe-colmenu__sep",
  role: "separator"
}, JI = { class: "fe-colmenu__label" }, Jm = 8, qs = 12, S1 = 28, ZI = 160, QI = 160, eN = 5, tN = 300, os = /* @__PURE__ */ lt({
  inheritAttrs: !1,
  __name: "DataTable",
  props: {
    rows: {},
    columns: {},
    rowKey: { type: [String, Function], default: void 0 },
    tableId: { default: void 0 },
    columnStore: { default: void 0 },
    candidates: { default: void 0 },
    metrics: { default: void 0 },
    locale: { default: void 0 },
    theme: { default: void 0 },
    loading: { type: Boolean },
    empty: { default: void 0 },
    ariaLabel: { default: void 0 },
    selectable: { type: Boolean },
    isSelected: { type: Function, default: void 0 },
    sort: { default: void 0 },
    sortClosed: { default: void 0 },
    groups: { default: void 0 },
    rowClass: { type: Function, default: void 0 },
    rowAttrs: { type: Function, default: void 0 },
    rowActions: { type: Function, default: void 0 },
    rowActionsTestId: { type: Function, default: void 0 },
    actionsWidth: { default: void 0 },
    framed: { type: Boolean, default: !0 },
    page: { default: void 0 },
    pageSize: { default: void 0 },
    total: { default: void 0 },
    pages: { default: void 0 },
    footNote: { default: void 0 }
  },
  emits: ["sort", "row-click", "row-dblclick", "row-contextmenu", "check-click", "row-action", "row-dragstart", "row-dragover", "row-dragleave", "row-drop", "row-touchstart", "row-touchend", "row-touchmove", "page"],
  setup(e, { expose: t, emit: n }) {
    var cn;
    const a = e, i = n, o = M5(), l = E(() => a.locale ?? (o == null ? void 0 : o.locale.value) ?? "en"), c = E(() => {
      var pe;
      return a.theme ?? ((pe = o == null ? void 0 : o.theme) == null ? void 0 : pe.value);
    }), { t: p, dir: m } = pt(() => l.value), v = E(() => {
      const pe = /* @__PURE__ */ new Map();
      for (const ke of a.columns) pe.set(ke.id, ke);
      return pe;
    }), x = E(() => {
      var pe;
      return ((pe = a.columns.find((ke) => ke.lead) ?? a.columns[0]) == null ? void 0 : pe.id) ?? "";
    }), w = E(
      () => a.columns.map((pe) => {
        const ke = pe.id === x.value, Oe = pe.width ?? (ke ? 240 : 140);
        return {
          id: pe.id,
          width: Oe,
          min: Math.min(pe.min ?? (ke ? 120 : 56), Oe),
          max: Math.max(pe.max ?? 900, Oe),
          hideable: ke ? !1 : pe.hideable !== !1,
          resizable: pe.resizable !== !1
        };
      })
    ), S = CS(
      () => w.value,
      a.tableId ? JR(a.tableId) : r5(),
      { lead: x.value }
    ), k = E(() => a.columnStore ?? S), b = E(
      () => (a.candidates ?? a.columns.map((pe) => pe.id)).filter((pe) => pe !== k.value.lead)
    ), C = S1 + qs, T = E(() => a.actionsWidth ?? (a.rowActions ? 92 : 28)), A = E(() => ({
      gap: Jm,
      padding: qs * 2,
      check: a.selectable ? S1 : 0,
      menu: T.value,
      ...a.metrics ?? {}
    })), L = $(null), z = $(0);
    let D = null, U = 0, q = 0;
    const P = $(!1), R = $(!1);
    function W(pe) {
      if (!pe) return;
      const ke = Ov(pe).end;
      ke !== R.value && (R.value = ke);
    }
    function N(pe) {
      const ke = pe.currentTarget;
      if (!ke) return;
      const Oe = Ov(ke).start;
      Oe !== P.value && (P.value = Oe), W(ke);
    }
    Je(
      L,
      (pe) => {
        D == null || D.disconnect(), D = null, q && cancelAnimationFrame(q), q = 0, !(!pe || typeof ResizeObserver > "u") && (D = new ResizeObserver((ke) => {
          var st, tn;
          U = ((tn = (st = ke[0]) == null ? void 0 : st.contentRect) == null ? void 0 : tn.width) ?? 0, !q && (q = requestAnimationFrame(() => {
            q = 0, Math.abs(U - z.value) >= 1 && (z.value = U);
          }));
        }), D.observe(pe));
      },
      { flush: "post" }
    );
    const J = E(() => k.value.layout(z.value, b.value, A.value)), H = E(() => J.value.visible), ne = E(() => z.value > 0 && z.value < J.value.stackBelow);
    Je(
      [() => J.value.total, z, ne],
      () => W(L.value),
      { flush: "post" }
    ), Je(ne, (pe) => {
      pe && (P.value = !1);
    });
    const j = (pe, { slots: ke }) => {
      var Oe, st;
      return pe.on ? XM("div", { class: "fe-list__stack-value" }, (Oe = ke.default) == null ? void 0 : Oe.call(ke)) : (st = ke.default) == null ? void 0 : st.call(ke);
    };
    j.props = ["on"];
    function re(pe) {
      var ke;
      return ((ke = v.value.get(pe)) == null ? void 0 : ke.headerLabel) === !1;
    }
    function he(pe) {
      return ne.value && !re(pe);
    }
    const ue = E(() => {
      if (!ne.value) return null;
      const pe = H.value.filter((ke) => !re(ke));
      return pe.length ? pe[pe.length - 1] : null;
    });
    function ae(pe) {
      tI(pe.target, L.value);
    }
    const fe = E(() => ne.value ? void 0 : { width: `${J.value.total}px` }), _ = E(
      () => (a.selectable ? C + Jm : qs) + (J.value.widths[k.value.lead] ?? k.value.width(k.value.lead))
    ), Q = E(
      () => !ne.value && z.value > 0 && z.value - _.value >= ZI
    ), K = E(() => T.value + qs), I = E(
      () => !ne.value && (z.value <= 0 || z.value - _.value - K.value >= QI)
    ), Y = E(() => ({
      "--fe-list-lead": a.selectable ? `${C + Jm}px` : "0px"
    }));
    function B(pe) {
      if (ne.value) return;
      let ke = J.value.widths[pe] ?? k.value.width(pe);
      return pe === k.value.lead && Q.value && !a.selectable && (ke += qs), { flex: `0 0 ${ke}px` };
    }
    const V = E(
      () => ne.value || T.value === 28 ? void 0 : { flex: `0 0 ${T.value + qs}px` }
    );
    function be(pe) {
      const ke = v.value.get(pe), Oe = ["fe-list__col", "fe-list__cell"];
      return ke != null && ke.class && Oe.push(ke.class), pe === k.value.lead && Oe.push("fe-list__col--lead"), (ke == null ? void 0 : ke.align) === "right" ? Oe.push("is-right") : (ke == null ? void 0 : ke.align) === "center" && Oe.push("is-center"), Oe;
    }
    function Fe(pe) {
      var ke;
      return ((ke = v.value.get(pe)) == null ? void 0 : ke.label) ?? pe;
    }
    const ze = E(() => a.sort !== void 0), Ue = $(
      a.tableId ? ZR(a.tableId) : null
    ), We = E(() => ze.value ? a.sort ?? null : Ue.value), $t = E(
      () => (a.pages ?? 1) > 1 || a.total != null && a.total > a.rows.length
    ), St = E(() => a.sortClosed ? a.sortClosed : !ze.value && $t.value ? p("table.sort_paged") : null);
    function at(pe) {
      var ke;
      return ((ke = v.value.get(pe)) == null ? void 0 : ke.sortable) === !0;
    }
    const kt = E(
      () => ne.value && !St.value && [k.value.lead, ...H.value].some(at) ? p("sort.by") : void 0
    );
    function ht(pe) {
      if (St.value || !at(pe)) return;
      const ke = We.value, Oe = v.value.get(pe), st = ke && ke.key === pe ? { key: pe, dir: ke.dir === "asc" ? "desc" : "asc" } : { key: pe, dir: (Oe == null ? void 0 : Oe.sortDir) ?? "asc" };
      ze.value || (Ue.value = st, a.tableId && QR(a.tableId, st)), i("sort", st);
    }
    function Ie(pe) {
      const ke = We.value;
      return St.value || !ke || ke.key !== pe ? "" : ke.dir === "asc" ? "↑" : "↓";
    }
    function se(pe) {
      if (!at(pe)) return;
      const ke = We.value;
      return St.value || !ke || ke.key !== pe ? "none" : ke.dir === "asc" ? "ascending" : "descending";
    }
    function xe(pe) {
      return St.value ?? p("cols.sort_by", { col: Fe(pe) });
    }
    function me(pe, ke) {
      const Oe = v.value.get(ke);
      return Oe != null && Oe.sortValue ? Oe.sortValue(pe) : Oe != null && Oe.format ? Oe.format(pe) : pe == null ? void 0 : pe[ke];
    }
    function De(pe, ke) {
      const Oe = pe == null || pe === "", st = ke == null || ke === "";
      return Oe && st ? 0 : Oe ? 1 : st ? -1 : typeof pe == "number" && typeof ke == "number" ? pe - ke : typeof pe == "boolean" && typeof ke == "boolean" ? Number(pe) - Number(ke) : String(pe).localeCompare(String(ke), l.value, { numeric: !0, sensitivity: "base" });
    }
    const ot = E(() => {
      const pe = We.value;
      if (ze.value || St.value || !pe || !v.value.has(pe.key)) return a.rows;
      const ke = pe.dir === "asc" ? 1 : -1;
      return a.rows.map((Oe, st) => ({ row: Oe, i: st, v: me(Oe, pe.key) })).sort((Oe, st) => {
        const tn = Oe.v === null || Oe.v === void 0 || Oe.v === "", Lt = st.v === null || st.v === void 0 || st.v === "";
        return tn !== Lt ? tn ? 1 : -1 : ke * De(Oe.v, st.v) || Oe.i - st.i;
      }).map((Oe) => Oe.row);
    }), ft = E(() => a.groups ?? [{ id: "all", items: ot.value }]), gt = GM(), Ut = E(() => a.empty === void 0 ? p("table.empty") : a.empty ?? ""), Xe = E(() => !a.loading && ie.value === 0 && (!!gt.empty || Ut.value !== "")), je = E(() => ie.value > 0 || a.loading && ie.value === 0 || Xe.value), Be = E(() => H.value.length + 2 + (a.selectable ? 1 : 0)), ie = E(() => ft.value.reduce((pe, ke) => pe + ke.items.length, 0));
    function ge(pe, ke) {
      return typeof a.rowKey == "function" ? a.rowKey(pe) : a.rowKey ? pe == null ? void 0 : pe[a.rowKey] : ke;
    }
    function G(pe) {
      return a.isSelected ? a.isSelected(pe) : !1;
    }
    function ye(pe, ke) {
      return pe == null ? void 0 : pe[ke];
    }
    function te(pe, ke) {
      const Oe = v.value.get(ke), st = Oe != null && Oe.format ? Oe.format(pe) : pe == null ? void 0 : pe[ke];
      return st == null || st === "" ? "-" : J2(String(st));
    }
    function Ce(pe, ke) {
      const Oe = v.value.get(ke);
      if (Oe != null && Oe.title) return Oe.title(pe);
      const st = te(pe, ke);
      return st === "-" ? void 0 : st;
    }
    function Ne(pe, ke) {
      var Oe;
      return [
        "fe-list__row",
        { "is-selected": G(pe), "is-clickable": !!_e.value },
        (Oe = a.rowClass) == null ? void 0 : Oe.call(a, pe, ke)
      ];
    }
    const _e = $(!1);
    let Ae = null;
    function Pe() {
      k.value.widthsAreAuto() && k.value.freeze(J.value.widths);
    }
    function _t(pe) {
      var ke;
      return ((ke = k.value.spec(pe)) == null ? void 0 : ke.resizable) === !0;
    }
    function Et(pe) {
      return Math.round(J.value.widths[pe] ?? k.value.width(pe));
    }
    function xn(pe) {
      var ke;
      return (ke = k.value.spec(pe)) == null ? void 0 : ke.min;
    }
    function Dt(pe) {
      var ke;
      return (ke = k.value.spec(pe)) == null ? void 0 : ke.max;
    }
    function bn(pe, ke) {
      _t(pe) && (ke.preventDefault(), ke.stopPropagation(), Pe(), Ae = { id: pe, startX: ke.clientX, startW: k.value.width(pe), sign: Pv(ei(L.value)) }, window.addEventListener("pointermove", un), window.addEventListener("pointerup", Jt));
    }
    function un(pe) {
      Ae && k.value.setWidth(Ae.id, Ae.startW + Ae.sign * (pe.clientX - Ae.startX));
    }
    function Jt() {
      Ae = null, window.removeEventListener("pointermove", un), window.removeEventListener("pointerup", Jt);
    }
    function Ln(pe, ke) {
      if (ke.ctrlKey || ke.metaKey) return;
      const Oe = 16 * Yf(ke.key, ei(L.value));
      Oe && (ke.preventDefault(), Pe(), k.value.setWidth(pe, k.value.width(pe) + Oe));
    }
    function Vn(pe) {
      const ke = k.value.spec(pe);
      ke && (Pe(), k.value.setWidth(pe, ke.width));
    }
    let Ft = null;
    const na = $(null), Kt = $(null);
    let bt = 0;
    function Dn(pe) {
      var ke;
      return pe !== k.value.lead && ((ke = k.value.spec(pe)) == null ? void 0 : ke.hideable) === !0;
    }
    function In(pe, ke) {
      ke.button !== 0 || !Dn(pe) || ne.value || (Ft = { id: pe, startX: ke.clientX, armed: !1 }, window.addEventListener("pointermove", mn), window.addEventListener("pointerup", aa), window.addEventListener("keydown", He, !0), window.addEventListener("pointercancel", Cn), window.addEventListener("blur", Cn));
    }
    function Cn() {
      const pe = (Ft == null ? void 0 : Ft.armed) === !0;
      Ke(), pe && (bt = Date.now());
    }
    function fn() {
      const pe = H.value;
      let ke = 0;
      for (; ke < pe.length && !Dn(pe[ke]); ) ke++;
      let Oe = pe.length;
      for (; Oe > ke && !Dn(pe[Oe - 1]); ) Oe--;
      return { first: ke, last: Oe };
    }
    function mn(pe) {
      var Ul;
      if (!Ft) return;
      if (!Ft.armed) {
        if (Math.abs(pe.clientX - Ft.startX) < eN) return;
        Ft.armed = !0, na.value = Ft.id;
      }
      const ke = (Ul = L.value) == null ? void 0 : Ul.querySelector(".fe-list__head");
      if (!ke) return;
      const Oe = Array.from(ke.children).filter((To) => To.classList.contains("fe-list__col")), st = a.selectable ? 2 : 1, tn = Oe.slice(st, st + H.value.length), Lt = Pv(ei(L.value));
      let xa = tn.length;
      for (let To = 0; To < tn.length; To++) {
        const ad = tn[To].getBoundingClientRect();
        if (Lt * (pe.clientX - (ad.left + ad.width / 2)) < 0) {
          xa = To;
          break;
        }
      }
      const { first: Un, last: Si } = fn();
      xa = Math.max(Un, Math.min(Si, xa));
      const ir = H.value.indexOf(Ft.id);
      Kt.value = xa === ir || xa === ir + 1 ? null : xa;
    }
    function aa() {
      const pe = Ft, ke = Kt.value;
      Ke(), pe != null && pe.armed && (bt = Date.now(), ke != null && zn(pe.id, ke));
    }
    function zn(pe, ke) {
      const Oe = H.value, st = Oe.indexOf(pe);
      if (st === -1 || ke === st || ke === st + 1) return;
      const Lt = Oe.filter((Si) => Si !== pe)[ke > st ? ke - 1 : ke], xa = k.value.order().filter((Si) => Si !== pe), Un = Lt ? xa.indexOf(Lt) : xa.length;
      Un !== -1 && k.value.move(pe, Un);
    }
    function Mn() {
      return k.value.order().filter((pe) => Dn(pe) && b.value.includes(pe));
    }
    function rn(pe, ke) {
      const Oe = Mn(), st = Oe.indexOf(pe), tn = st + ke;
      if (st === -1 || tn < 0 || tn >= Oe.length) return;
      const Lt = Oe[tn], Un = k.value.order().filter((Si) => Si !== pe).indexOf(Lt);
      Un !== -1 && k.value.move(pe, ke === -1 ? Un : Un + 1);
    }
    function ve(pe, ke) {
      const Oe = Mn(), st = Oe.indexOf(pe);
      return st !== -1 && st + ke >= 0 && st + ke < Oe.length;
    }
    function Le(pe, ke) {
      if (!ke.ctrlKey && !ke.metaKey) return;
      const Oe = Yf(ke.key, ei(L.value));
      !Oe || !Dn(pe) || (ke.preventDefault(), ke.stopPropagation(), rn(pe, Oe));
    }
    function He(pe) {
      pe.key === "Escape" && (pe.stopPropagation(), Cn());
    }
    function Ke() {
      Ft = null, na.value = null, Kt.value = null, window.removeEventListener("pointermove", mn), window.removeEventListener("pointerup", aa), window.removeEventListener("keydown", He, !0), window.removeEventListener("pointercancel", Cn), window.removeEventListener("blur", Cn);
    }
    function xt(pe) {
      Date.now() - bt > tN || (bt = 0, pe.preventDefault(), pe.stopPropagation());
    }
    const Qe = $(!1), ce = $(0), qe = $(0);
    let dt = 0;
    const Nt = $(null), hn = Il(), nn = E(() => `fe-ctx-backdrop--theme-${c.value || "auto"}`), oe = E(
      () => m.value === "rtl" ? { earlier: { key: "cols.move_right", arrow: "→" }, later: { key: "cols.move_left", arrow: "←" } } : { earlier: { key: "cols.move_left", arrow: "←" }, later: { key: "cols.move_right", arrow: "→" } }
    ), le = E(
      () => (
        /* In the person's OWN order, so the list reads as the table on screen. */
        k.value.order().filter((pe) => Dn(pe) && b.value.includes(pe)).map((pe) => ({
          id: pe,
          label: Fe(pe),
          on: !k.value.hidden(pe),
          canEarlier: ve(pe, -1),
          canLater: ve(pe, 1)
        }))
      )
    ), Me = E(() => k.value.customised());
    async function Ve(pe) {
      var st;
      pe.preventDefault(), pe.stopPropagation();
      const ke = pe.currentTarget, Oe = ke == null ? void 0 : ke.getBoundingClientRect();
      dt = pe.clientX || (Oe ? Ur(Oe, m.value) : 0), ce.value = dt, qe.value = pe.clientY || (Oe ? Oe.bottom : 0), Qe.value = !0, await Gt(), it(), (st = Nt.value) == null || st.focus();
    }
    function it() {
      const pe = Nt.value;
      if (!pe) return;
      const ke = pe.getBoundingClientRect(), Oe = 8;
      ce.value = Oc(dt, ke.width, window.innerWidth, m.value, Oe), ke.bottom > window.innerHeight - Oe && (qe.value = Math.max(Oe, window.innerHeight - Oe - ke.height));
    }
    function Z() {
      Qe.value = !1;
    }
    function ee(pe) {
      pe.key === "Escape" && (pe.stopPropagation(), Z());
    }
    Je(Qe, (pe) => {
      typeof window > "u" || (pe ? window.addEventListener("keydown", ee, !0) : window.removeEventListener("keydown", ee, !0));
    });
    function we(pe) {
      k.value.setHidden(pe, !k.value.hidden(pe));
    }
    function Ye() {
      k.value.reset();
    }
    Tt(() => {
      D == null || D.disconnect(), D = null, q && cancelAnimationFrame(q), q = 0, Jt(), Ke(), typeof window < "u" && window.removeEventListener("keydown", ee, !0);
    });
    const rt = E(() => a.pages != null ? Math.max(1, a.pages) : !a.total || !a.pageSize ? 1 : Math.max(1, Math.ceil(a.total / a.pageSize))), vt = E(() => a.page ?? 1), Bt = E(() => rt.value > 1), Qt = E(() => {
      if (a.total != null && a.pageSize != null && a.total > 0) {
        const pe = (vt.value - 1) * a.pageSize + 1, ke = Math.min(vt.value * a.pageSize, a.total);
        return `${pe} - ${ke} / ${a.total}`;
      }
      return "";
    });
    function en(pe) {
      pe < 1 || pe > rt.value || i("page", pe);
    }
    const Ot = Zo();
    _e.value = !!((cn = Ot == null ? void 0 : Ot.vnode.props) != null && cn.onRowClick);
    function kn(pe, ke) {
      i("row-click", pe, ke);
    }
    function Pa(pe, ke, Oe) {
      i("row-action", pe, ke, Oe);
    }
    return t({ store: k, layout: J, pinLead: Q, stacked: ne }), (pe, ke) => (f(), h(Te, null, [
      d("div", Tv(pe.$attrs, {
        class: ["fe-table", { "fe-table--framed": e.framed, "fe-table--bare": !e.framed }]
      }), [
        pe.$slots.toolbar ? (f(), h("div", oI, [
          On(pe.$slots, "toolbar")
        ])) : O("", !0),
        e.loading && ie.value > 0 ? (f(), h("div", rI, [
          d("span", sI, y(u(p)("loading")), 1)
        ])) : O("", !0),
        d("div", {
          ref_key: "listEl",
          ref: L,
          class: Re(["fe-list", {
            "is-loading": e.loading,
            "is-scrolled-x": P.value,
            "is-more-end": R.value,
            "is-pin-lead": Q.value,
            "is-pin-menu": I.value,
            "is-stacked": ne.value,
            "fe-list--nocheck": !e.selectable
          }]),
          style: Wt(Y.value),
          role: "grid",
          "aria-label": e.ariaLabel,
          "aria-busy": e.loading ? "true" : void 0,
          "data-table-id": e.tableId,
          onScrollPassive: N
        }, [
          d("div", {
            class: Re(["fe-list__head", { "is-dragging-col": !!na.value }]),
            role: "row",
            "data-sort-label": kt.value,
            style: Wt(fe.value),
            onContextmenu: Ve,
            onClickCapture: xt
          }, [
            e.selectable ? (f(), h("div", cI)) : O("", !0),
            d("div", {
              class: Re(be(k.value.lead)),
              role: "columnheader",
              style: Wt(B(k.value.lead)),
              "aria-sort": se(k.value.lead),
              "data-col": k.value.lead
            }, [
              at(k.value.lead) ? (f(), h("button", {
                key: 0,
                type: "button",
                class: "fe-list__sort",
                disabled: !!St.value,
                title: xe(k.value.lead),
                onClick: ke[0] || (ke[0] = (Oe) => ht(k.value.lead))
              }, [
                d("span", pI, y(Fe(k.value.lead)), 1),
                Ie(k.value.lead) ? (f(), h("span", hI, y(Ie(k.value.lead)), 1)) : O("", !0)
              ], 8, fI)) : (f(), h("span", {
                key: 1,
                class: "fe-list__head-label",
                title: Fe(k.value.lead)
              }, y(Fe(k.value.lead)), 9, mI)),
              _t(k.value.lead) && !ne.value ? (f(), h("span", {
                key: 2,
                class: "fe-list__resize",
                role: "separator",
                "aria-orientation": "vertical",
                tabindex: "0",
                "aria-valuenow": Et(k.value.lead),
                "aria-valuemin": xn(k.value.lead),
                "aria-valuemax": Dt(k.value.lead),
                "aria-label": u(p)("cols.resize", { col: Fe(k.value.lead) }),
                title: u(p)("cols.resize", { col: Fe(k.value.lead) }),
                onPointerdown: ke[1] || (ke[1] = (Oe) => bn(k.value.lead, Oe)),
                onDblclick: ke[2] || (ke[2] = yt((Oe) => Vn(k.value.lead), ["stop"])),
                onKeydown: ke[3] || (ke[3] = (Oe) => Ln(k.value.lead, Oe))
              }, null, 40, vI)) : O("", !0)
            ], 14, dI),
            (f(!0), h(Te, null, nt(H.value, (Oe, st) => (f(), h("div", {
              key: Oe,
              class: Re([
                be(Oe),
                {
                  "is-col-dragging": na.value === Oe,
                  "is-drop-before": Kt.value === st,
                  "is-drop-after": Kt.value === H.value.length && st === H.value.length - 1,
                  "is-movable": Dn(Oe) && !ne.value
                }
              ]),
              role: "columnheader",
              style: Wt(B(Oe)),
              "aria-sort": se(Oe),
              "aria-label": re(Oe) ? Fe(Oe) : void 0,
              "data-col": Oe,
              onPointerdown: (tn) => In(Oe, tn),
              onKeydown: (tn) => Le(Oe, tn)
            }, [
              at(Oe) ? (f(), h("button", {
                key: 0,
                type: "button",
                class: "fe-list__sort",
                disabled: !!St.value,
                title: xe(Oe),
                onClick: (tn) => ht(Oe)
              }, [
                d("span", bI, y(Fe(Oe)), 1),
                Ie(Oe) ? (f(), h("span", kI, y(Ie(Oe)), 1)) : O("", !0)
              ], 8, gI)) : re(Oe) ? O("", !0) : (f(), h("span", {
                key: 1,
                class: "fe-list__head-label",
                title: Fe(Oe)
              }, y(Fe(Oe)), 9, wI)),
              _t(Oe) && !ne.value ? (f(), h("span", {
                key: 2,
                class: "fe-list__resize",
                role: "separator",
                "aria-orientation": "vertical",
                tabindex: "0",
                "aria-valuenow": Et(Oe),
                "aria-valuemin": xn(Oe),
                "aria-valuemax": Dt(Oe),
                "aria-label": u(p)("cols.resize", { col: Fe(Oe) }),
                title: u(p)("cols.resize", { col: Fe(Oe) }),
                onPointerdown: (tn) => bn(Oe, tn),
                onDblclick: yt((tn) => Vn(Oe), ["stop"]),
                onKeydown: (tn) => Ln(Oe, tn)
              }, null, 40, _I)) : O("", !0)
            ], 46, yI))), 128)),
            d("div", {
              class: Re(["fe-list__col fe-list__col--menu", { "is-wide": T.value !== 28 }]),
              style: Wt(V.value),
              role: "columnheader"
            }, [
              d("button", {
                type: "button",
                class: "fe-list__menu fe-list__colmenu-btn",
                title: u(p)("cols.menu"),
                "aria-label": u(p)("cols.menu"),
                "aria-haspopup": "dialog",
                "aria-expanded": Qe.value ? "true" : "false",
                onClick: Ve
              }, [...ke[12] || (ke[12] = [
                d("span", { "aria-hidden": "true" }, "⋮", -1)
              ])], 8, xI)
            ], 6)
          ], 46, uI),
          d("div", {
            class: "fe-list__body",
            role: je.value ? "rowgroup" : "presentation",
            onPointerover: ae
          }, [
            (f(!0), h(Te, null, nt(ft.value, (Oe) => (f(), h(Te, {
              key: Oe.id
            }, [
              Oe.label ? (f(), h("div", $I, y(Oe.label), 1)) : O("", !0),
              (f(!0), h(Te, null, nt(Oe.items, (st, tn) => (f(), h("div", Tv({
                key: ge(st, tn),
                class: Ne(st, tn),
                role: "row",
                style: fe.value,
                "aria-selected": e.selectable ? G(st) ? "true" : "false" : void 0
              }, { ref_for: !0 }, e.rowAttrs ? e.rowAttrs(st) : {}, {
                onClick: (Lt) => kn(st, Lt),
                onDblclick: (Lt) => i("row-dblclick", st, Lt),
                onContextmenu: (Lt) => i("row-contextmenu", st, Lt),
                onDragstart: (Lt) => i("row-dragstart", st, Lt),
                onDragover: (Lt) => i("row-dragover", st, Lt),
                onDragleave: (Lt) => i("row-dragleave", st, Lt),
                onDrop: (Lt) => i("row-drop", st, Lt),
                onTouchstartPassive: (Lt) => i("row-touchstart", st, Lt),
                onTouchend: ke[7] || (ke[7] = (Lt) => i("row-touchend", Lt)),
                onTouchmovePassive: ke[8] || (ke[8] = (Lt) => i("row-touchmove", Lt))
              }), [
                e.selectable ? (f(), h("div", {
                  key: 0,
                  class: "fe-list__col fe-list__col--check",
                  role: "gridcell",
                  "data-fe-control": "",
                  onClick: yt((Lt) => i("check-click", st, Lt), ["stop"]),
                  onDblclick: ke[4] || (ke[4] = yt(() => {
                  }, ["stop"]))
                }, [
                  Ze(Mg, {
                    on: G(st),
                    label: te(st, k.value.lead)
                  }, null, 8, ["on", "label"])
                ], 40, AI)) : O("", !0),
                d("div", {
                  class: Re(be(k.value.lead)),
                  role: "gridcell",
                  style: Wt(B(k.value.lead)),
                  title: pe.$slots[`cell-${k.value.lead}`] ? void 0 : Ce(st, k.value.lead)
                }, [
                  On(pe.$slots, `cell-${k.value.lead}`, {
                    row: st,
                    value: ye(st, k.value.lead)
                  }, () => [
                    d("span", CI, [
                      d("bdi", null, y(te(st, k.value.lead)), 1)
                    ])
                  ])
                ], 14, EI),
                (f(!0), h(Te, null, nt(H.value, (Lt) => (f(), h("div", {
                  key: Lt,
                  class: Re([
                    be(Lt),
                    { "is-stack-fact": he(Lt), "is-stack-last": ue.value === Lt, "is-stack-tail": ne.value && !he(Lt) }
                  ]),
                  role: "gridcell",
                  style: Wt(B(Lt)),
                  "data-col": Lt,
                  "data-label": he(Lt) ? Fe(Lt) : void 0,
                  title: pe.$slots[`cell-${Lt}`] ? void 0 : Ce(st, Lt)
                }, [
                  Ze(j, {
                    on: he(Lt)
                  }, {
                    default: mt(() => [
                      On(pe.$slots, `cell-${Lt}`, {
                        row: st,
                        value: ye(st, Lt)
                      }, () => [
                        re(Lt) ? O("", !0) : (f(), h("span", MI, [
                          d("bdi", null, y(te(st, Lt)), 1)
                        ]))
                      ])
                    ]),
                    _: 2
                  }, 1032, ["on"])
                ], 14, zI))), 128)),
                d("div", {
                  class: Re(["fe-list__col fe-list__col--menu", { "is-wide": T.value !== 28 }]),
                  style: Wt(V.value),
                  role: "gridcell",
                  "data-fe-control": "",
                  onClick: ke[5] || (ke[5] = yt(() => {
                  }, ["stop"])),
                  onDblclick: ke[6] || (ke[6] = yt(() => {
                  }, ["stop"]))
                }, [
                  On(pe.$slots, "actions", { row: st }, () => {
                    var Lt;
                    return [
                      e.rowActions && e.rowActions(st).length ? (f(), Ge(iI, {
                        key: 0,
                        locale: l.value,
                        theme: c.value,
                        actions: e.rowActions(st),
                        testid: (Lt = e.rowActionsTestId) == null ? void 0 : Lt.call(e, st),
                        onSelect: (xa, Un) => Pa(xa, st, Un)
                      }, null, 8, ["locale", "theme", "actions", "testid", "onSelect"])) : O("", !0)
                    ];
                  })
                ], 38)
              ], 16, TI))), 128))
            ], 64))), 128)),
            e.loading && ie.value === 0 ? (f(), h("div", PI, [
              d("div", {
                role: "gridcell",
                "aria-colspan": Be.value,
                "aria-live": "polite"
              }, y(u(p)("loading")), 9, OI)
            ])) : Xe.value ? (f(), h("div", LI, [
              d("div", {
                role: "gridcell",
                "aria-colspan": Be.value
              }, [
                On(pe.$slots, "empty", {}, () => [
                  Ht(y(Ut.value), 1)
                ])
              ], 8, DI)
            ])) : O("", !0)
          ], 40, SI)
        ], 46, lI),
        Bt.value || e.footNote || pe.$slots.foot ? (f(), h("div", RI, [
          d("span", null, [
            On(pe.$slots, "foot", {}, () => [
              Ht(y(e.footNote || Qt.value), 1)
            ])
          ]),
          Bt.value ? (f(), h("div", II, [
            d("button", {
              type: "button",
              class: "tbl-page",
              disabled: vt.value <= 1,
              "aria-label": u(p)("table.prev"),
              title: u(p)("table.prev"),
              onClick: ke[9] || (ke[9] = (Oe) => en(vt.value - 1))
            }, "‹", 8, NI),
            d("span", BI, y(vt.value) + " / " + y(rt.value), 1),
            d("button", {
              type: "button",
              class: "tbl-page",
              disabled: vt.value >= rt.value,
              "aria-label": u(p)("table.next"),
              title: u(p)("table.next"),
              onClick: ke[10] || (ke[10] = (Oe) => en(vt.value + 1))
            }, "›", 8, FI)
          ])) : O("", !0)
        ])) : O("", !0)
      ], 16),
      (f(), Ge(wi, { to: "body" }, [
        Qe.value ? (f(), h("div", {
          key: 0,
          class: Re(["fe-colmenu__backdrop", nn.value]),
          dir: u(m),
          "data-prefers-dark": u(hn) ? "1" : "0",
          onClick: Z,
          onContextmenu: yt(Z, ["prevent"])
        }, [
          d("div", {
            ref_key: "colMenuEl",
            ref: Nt,
            class: "fe-colmenu",
            role: "dialog",
            tabindex: "-1",
            "aria-label": u(p)("cols.menu"),
            style: Wt({ top: qe.value + "px", left: ce.value + "px" }),
            onClick: ke[11] || (ke[11] = yt(() => {
            }, ["stop"])),
            onKeydown: Ca(yt(Z, ["stop"]), ["esc"])
          }, [
            d("p", KI, y(u(p)("cols.title")), 1),
            (f(!0), h(Te, null, nt(le.value, (Oe) => (f(), h("div", {
              key: Oe.id,
              class: "fe-colmenu__line"
            }, [
              d("button", {
                type: "button",
                class: "fe-colmenu__row",
                role: "checkbox",
                "aria-checked": Oe.on ? "true" : "false",
                onClick: (st) => we(Oe.id)
              }, [
                d("span", {
                  class: Re(["fe-list__check fe-colmenu__tick", { "is-on": Oe.on }]),
                  "aria-hidden": "true"
                }, null, 2),
                d("span", jI, y(Oe.label), 1)
              ], 8, VI),
              d("button", {
                type: "button",
                class: "fe-colmenu__nudge",
                disabled: !Oe.canEarlier,
                title: u(p)(oe.value.earlier.key, { col: Oe.label }),
                "aria-label": u(p)(oe.value.earlier.key, { col: Oe.label }),
                onClick: (st) => rn(Oe.id, -1)
              }, [
                d("span", WI, y(oe.value.earlier.arrow), 1)
              ], 8, qI),
              d("button", {
                type: "button",
                class: "fe-colmenu__nudge",
                disabled: !Oe.canLater,
                title: u(p)(oe.value.later.key, { col: Oe.label }),
                "aria-label": u(p)(oe.value.later.key, { col: Oe.label }),
                onClick: (st) => rn(Oe.id, 1)
              }, [
                d("span", GI, y(oe.value.later.arrow), 1)
              ], 8, YI)
            ]))), 128)),
            Me.value ? (f(), h("div", XI)) : O("", !0),
            Me.value ? (f(), h("button", {
              key: 1,
              type: "button",
              class: "fe-colmenu__row",
              onClick: Ye
            }, [
              d("span", JI, y(u(p)("cols.reset")), 1)
            ])) : O("", !0),
            On(pe.$slots, "colmenu-extra", { close: Z })
          ], 44, HI)
        ], 42, UI)) : O("", !0)
      ]))
    ], 64));
  }
});
function nN(e, t, n, a) {
  if (!e || t !== "date" && t !== "datetime") return e;
  const i = TO(e, n);
  if (i) return i;
  const o = Date.parse(e.trim());
  return Number.isNaN(o) ? e : a(o, { time: t === "datetime" }) || e;
}
const aN = {
  class: "fe-slist",
  "data-testid": "surface-list"
}, iN = /* @__PURE__ */ lt({
  __name: "SurfaceList",
  props: {
    columns: {},
    rows: {},
    empty: {},
    locale: {},
    disabled: { type: Boolean },
    tableId: {}
  },
  emits: ["action"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i, formatDate: o } = pt(() => n.locale), l = E(() => n.rows ?? []), c = E(() => l.value.some((w) => (w.actions ?? []).length > 0)), p = E(() => ng(n.empty, n.locale, () => i("plugin.list.empty")));
    function m(w, S) {
      var k;
      return Xt((k = w.cells) == null ? void 0 : k[S], n.locale);
    }
    const v = E(
      () => (n.columns ?? []).map((w) => {
        const S = typeof w.width == "number" && Number.isFinite(w.width) ? Math.round(w.width) : void 0;
        return {
          id: w.key,
          label: Xt(w.label, n.locale),
          width: S === void 0 ? void 0 : Math.min(900, Math.max(60, S)),
          align: w.align,
          sortable: w.sortable !== !1,
          // A date column is printed the explorer's way, and sorted by the value.
          format: (k) => nN(m(k, w.key), w.format, n.locale, o),
          sortValue: (k) => {
            var C;
            const b = (C = k.sort) == null ? void 0 : C[w.key];
            return typeof b == "number" || typeof b == "string" ? b : m(k, w.key);
          }
        };
      })
    );
    function x(w) {
      return (w.actions ?? []).map((S) => ({
        key: S.id,
        label: Xt(S.label, n.locale),
        danger: S.danger,
        disabled: n.disabled,
        testid: `surface-list-action-${w.id}-${S.id}`
      }));
    }
    return (w, S) => (f(), h("div", aN, [
      Ze(os, {
        "table-id": e.tableId,
        columns: v.value,
        rows: l.value,
        "row-key": "id",
        locale: e.locale,
        empty: p.value,
        "row-attrs": (k) => ({ "data-row": k.id }),
        "row-actions": c.value ? x : void 0,
        "row-actions-test-id": (k) => (k.actions ?? []).length ? `surface-list-actions-${k.id}` : void 0,
        onRowAction: S[0] || (S[0] = (k, b) => a("action", { action_id: k, row_id: b.id }))
      }, null, 8, ["table-id", "columns", "rows", "locale", "empty", "row-attrs", "row-actions", "row-actions-test-id"])
    ]));
  }
}), oN = {
  class: "fe-sprogress",
  "data-testid": "surface-progress"
}, rN = { class: "fe-sprogress__head" }, sN = { class: "fe-sprogress__label" }, lN = {
  key: 0,
  class: "fe-sprogress__pct"
}, uN = ["aria-label", "aria-valuenow"], cN = /* @__PURE__ */ lt({
  __name: "SurfaceProgress",
  props: {
    value: {},
    label: {},
    locale: {}
  },
  setup(e) {
    const t = e, { t: n } = pt(() => t.locale), a = E(() => {
      const o = t.value;
      return o == null || !Number.isFinite(Number(o)) ? null : Math.min(100, Math.max(0, Math.round(Number(o))));
    }), i = E(() => ng(t.label, t.locale, () => n("plugin.view.busy")));
    return (o, l) => (f(), h("div", oN, [
      d("div", rN, [
        d("span", sN, y(i.value), 1),
        a.value !== null ? (f(), h("span", lN, y(a.value) + "%", 1)) : O("", !0)
      ]),
      d("div", {
        class: Re(["fe-sprogress__track", { "is-indeterminate": a.value === null }]),
        role: "progressbar",
        "aria-label": i.value,
        "aria-valuemin": "0",
        "aria-valuemax": "100",
        "aria-valuenow": a.value === null ? void 0 : a.value
      }, [
        d("div", {
          class: "fe-sprogress__bar",
          style: Wt(a.value === null ? void 0 : { width: `${a.value}%` })
        }, null, 4)
      ], 10, uN)
    ]));
  }
}), x$ = ",،、，", dN = ";؛；", $1 = /* @__PURE__ */ new Map();
function fN(e) {
  const t = `${e.spaces ? 1 : 0}${e.semicolons ? 1 : 0}${e.newlines ? 1 : 0}`;
  let n = $1.get(t);
  if (!n) {
    const a = x$ + (e.semicolons ? dN : "") + (e.newlines ? "\\n\\r" : "") + (e.spaces ? "\\s" : "");
    n = new RegExp(`[${a}]+`, "u"), $1.set(t, n);
  }
  return n;
}
function pN(e, t = {}) {
  return String(e ?? "").split(fN(t)).map((n) => n.trim()).filter((n) => n !== "");
}
function hN(e) {
  return e.length === 1 && x$.includes(e);
}
const mN = {
  key: 0,
  class: "fe-speople__chips",
  "data-testid": "surface-people-chips"
}, vN = ["title"], yN = {
  class: "fe-speople__av",
  "aria-hidden": "true"
}, gN = { class: "fe-speople__name" }, bN = ["disabled", "title", "aria-label", "data-testid", "onClick"], kN = {
  key: 1,
  class: "fe-speople__addwrap"
}, wN = ["placeholder", "disabled", "aria-invalid"], _N = ["disabled"], xN = {
  key: 1,
  class: "fe-share__suggest fe-speople__suggest",
  "data-testid": "surface-people-suggest"
}, SN = ["onMousedown"], $N = { class: "fe-share__av fe-share__av--sm" }, TN = { class: "fe-share__suggesttxt" }, AN = { class: "fe-share__suggestname" }, EN = { class: "fe-share__suggestmeta" }, CN = {
  key: 2,
  class: "fe-surface__error",
  role: "alert"
}, zN = /* @__PURE__ */ lt({
  __name: "SurfacePeoplePicker",
  props: {
    id: {},
    modelValue: {},
    multi: { type: Boolean },
    allowExternal: { type: Boolean },
    api: {},
    plugin: {},
    locale: {},
    disabled: { type: Boolean },
    invalid: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = pt(() => n.locale), o = $(""), l = $([]), c = $(!1), p = $(!n.api || !n.plugin), m = $("");
    let v = null, x = 0;
    const w = E(() => n.modelValue ?? []), S = E(() => n.allowExternal === !0 || p.value), k = E(() => n.multi !== !0 && w.value.length >= 1);
    function b(q) {
      return Yp({ name: q.name, email: q.email });
    }
    function C(q) {
      const P = String(q.email ?? "").trim().toLowerCase();
      if (!P) return;
      const R = n.multi === !0 ? w.value.filter((W) => W.email.toLowerCase() !== P) : [];
      a("update:modelValue", [...R, { ...q, email: P }]), o.value = "", l.value = [], c.value = !1, m.value = "";
    }
    function T(q) {
      a("update:modelValue", w.value.filter((P) => P.email !== q));
    }
    function A() {
      m.value = "";
      const q = o.value.trim();
      if (v && clearTimeout(v), !q || p.value) {
        l.value = [], c.value = !1;
        return;
      }
      v = setTimeout(() => void L(q), 180);
    }
    async function L(q) {
      if (!n.api || !n.plugin || p.value) return;
      const P = ++x;
      try {
        const R = await n.api.pluginUsers(n.plugin, q);
        if (P !== x) return;
        l.value = (R.users ?? []).filter((W) => W && typeof W.email == "string"), c.value = l.value.length > 0;
      } catch (R) {
        if (P !== x) return;
        const W = R == null ? void 0 : R.status;
        (W === 403 || W === 404) && (p.value = !0), l.value = [], c.value = !1;
      }
    }
    function z() {
      const q = o.value.trim();
      if (q) {
        if (!S.value) {
          m.value = i("plugin.people.external_off");
          return;
        }
        if (!X8(q)) {
          m.value = i("plugin.people.invalid_email");
          return;
        }
        C({ email: q });
      }
    }
    function D(q) {
      q.key === "Enter" || hN(q.key) ? (q.preventDefault(), z()) : q.key === "Backspace" && o.value === "" && w.value.length ? T(w.value[w.value.length - 1].email) : q.key === "Escape" && (c.value = !1);
    }
    function U() {
      setTimeout(() => {
        c.value = !1;
      }, 120);
    }
    return Je(
      () => [n.api, n.plugin],
      ([q, P]) => {
        q && P && (p.value = !1);
      }
    ), Tt(() => {
      v && clearTimeout(v);
    }), (q, P) => (f(), h("div", {
      class: Re(["fe-speople", { "is-invalid": e.invalid }]),
      "data-testid": "surface-people"
    }, [
      w.value.length ? (f(), h("ul", mN, [
        (f(!0), h(Te, null, nt(w.value, (R) => (f(), h("li", {
          key: R.email,
          class: "fe-speople__chip",
          title: R.email
        }, [
          d("span", yN, y(b(R).charAt(0).toUpperCase()), 1),
          d("span", gN, y(b(R)), 1),
          d("button", {
            type: "button",
            class: "fe-speople__remove",
            disabled: e.disabled,
            title: u(i)("plugin.people.remove", { name: b(R) }),
            "aria-label": u(i)("plugin.people.remove", { name: b(R) }),
            "data-testid": `surface-people-remove-${R.email}`,
            onClick: (W) => T(R.email)
          }, [...P[1] || (P[1] = [
            d("svg", {
              class: "fe-ficon",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "aria-hidden": "true",
              focusable: "false"
            }, [
              d("path", { d: "M6 6l12 12M18 6L6 18" })
            ], -1)
          ])], 8, bN)
        ], 8, vN))), 128))
      ])) : O("", !0),
      k.value ? O("", !0) : (f(), h("div", kN, [
        ln(d("input", {
          "onUpdate:modelValue": P[0] || (P[0] = (R) => o.value = R),
          class: "fe-cfield__input fe-speople__input",
          type: "email",
          autocomplete: "off",
          spellcheck: "false",
          placeholder: p.value ? u(i)("plugin.people.placeholder_email") : u(i)("plugin.people.placeholder"),
          disabled: e.disabled,
          "aria-invalid": e.invalid ? "true" : void 0,
          "data-testid": "surface-people-input",
          onInput: A,
          onKeydown: D,
          onFocus: A,
          onBlur: U
        }, null, 40, wN), [
          [_n, o.value]
        ]),
        S.value ? (f(), h("button", {
          key: 0,
          type: "button",
          class: "fe-btn fe-btn--sm",
          disabled: e.disabled || !o.value.trim(),
          "data-testid": "surface-people-add",
          onClick: z
        }, y(u(i)("plugin.people.add")), 9, _N)) : O("", !0),
        c.value ? (f(), h("ul", xN, [
          (f(!0), h(Te, null, nt(l.value, (R) => (f(), h("li", {
            key: R.user_id ?? R.email,
            onMousedown: yt((W) => C(R), ["prevent"])
          }, [
            d("span", $N, y(b(R).charAt(0).toUpperCase()), 1),
            d("span", TN, [
              d("span", AN, y(b(R)), 1),
              d("span", EN, y(R.email), 1)
            ])
          ], 40, SN))), 128))
        ])) : O("", !0)
      ])),
      m.value ? (f(), h("p", CN, y(m.value), 1)) : O("", !0)
    ], 2));
  }
}), MN = {
  class: "fe-spin",
  "data-testid": "surface-pin"
}, PN = ["for"], ON = ["id", "maxlength", "size", "value", "disabled", "aria-invalid"], LN = /* @__PURE__ */ lt({
  __name: "SurfacePinInput",
  props: {
    id: {},
    length: {},
    modelValue: {},
    locale: {},
    disabled: { type: Boolean },
    invalid: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = pt(() => n.locale), o = E(() => {
      const c = Number(n.length);
      return Number.isInteger(c) && c > 0 ? c : void 0;
    });
    function l(c) {
      const p = c.target.value.replace(/\s+/g, "").slice(0, o.value);
      c.target.value = p, a("update:modelValue", p);
    }
    return (c, p) => (f(), h("div", MN, [
      d("label", {
        class: "fe-cfield__label",
        for: `fe-spin-${e.id}`
      }, y(u(i)("plugin.pin.label")), 9, PN),
      d("input", {
        id: `fe-spin-${e.id}`,
        class: Re(["fe-cfield__input fe-cfield__input--mono fe-spin__input", { "is-invalid": e.invalid }]),
        type: "text",
        inputmode: "numeric",
        autocomplete: "one-time-code",
        spellcheck: "false",
        maxlength: o.value,
        size: o.value,
        value: e.modelValue,
        disabled: e.disabled,
        "aria-invalid": e.invalid ? "true" : void 0,
        style: Wt({ "--spin-len": o.value }),
        onInput: l
      }, null, 46, ON)
    ]));
  }
}), Jn = "@@drives";
function zl(e) {
  const t = e.indexOf("://");
  return t < 0 ? ["", vy(e)] : [e.slice(0, t), vy(e.slice(t + 3))];
}
function Ml(e, t) {
  const n = vy(t);
  return n ? `${e}://${n}` : `${e}://`;
}
function vy(e) {
  return e.replace(/^\/+|\/+$/g, "");
}
function Pg(e, t) {
  if (e === Jn) return null;
  const [n, a] = zl(e);
  if (!n) return null;
  if (!a) return t ? Jn : null;
  const i = a.split("/");
  return i.pop(), Ml(n, i.join("/"));
}
function ml(e, t) {
  if (e === Jn) return t;
  const [n, a] = zl(e);
  if (!a) return n || t;
  const i = a.split("/");
  return i[i.length - 1] || n;
}
function DN(e) {
  if (e === Jn || !e) return [];
  const [t, n] = zl(e);
  if (!t) return [];
  const a = [{ label: t, path: Ml(t, "") }];
  if (!n) return a;
  let i = "";
  for (const o of n.split("/"))
    i = i ? `${i}/${o}` : o, a.push({ label: o, path: Ml(t, i) });
  return a;
}
function S$(e) {
  return e == null || e === "" || e === "editor" || e === "owner";
}
function Og(e, t) {
  if (e === Jn || t === Jn) return !1;
  const [n, a] = zl(e), [i, o] = zl(t);
  return n !== i ? !1 : o === "" ? !0 : a === o || a.startsWith(o + "/");
}
function Lg(e, t) {
  if (!t || t.length === 0 || e === Jn) return null;
  const n = (i) => {
    const [o, l] = zl(i);
    return Ml(o, l);
  }, a = n(e);
  for (const i of t)
    if (i) {
      if (a === n(i)) return "self";
      if (Og(e, i)) return "descendant";
    }
  return null;
}
function RN(e, t) {
  if (!e || e === Jn) return null;
  for (const n of t) if (n && Og(e, n)) return n;
  return null;
}
function $$(e, t, n) {
  if (!e || e === Jn) return null;
  const a = n(e);
  return t ? a === t ? null : "out" : a ? "into" : null;
}
function IN(e, t, n) {
  return $$(e, t, n) ? !(t && Og(t, e)) : !1;
}
function NN(e, t, n = {}) {
  const a = [];
  for (const i of e ?? []) {
    if (i.type !== "dir") {
      n.files && i.type === "file" && a.push({ path: i.path, label: i.basename, writable: !0, blocked: null, kind: "file" });
      continue;
    }
    a.push({
      path: i.path,
      label: i.basename,
      writable: S$(i.perm),
      blocked: Lg(i.path, t),
      kind: "dir"
    });
  }
  return a;
}
function BN(e, t) {
  return (e ?? []).map((n) => {
    const a = Ml(n, "");
    return {
      path: a,
      label: n,
      // A storage root's own writability is not knowable from the drive list;
      // it is answered by the listing when the user opens it. Offering it as
      // writable here and letting the listing correct that is the honest
      // order — the alternative greys out every drive until each is opened.
      writable: !0,
      blocked: Lg(a, t),
      kind: "dir"
    };
  });
}
function FN(e, t) {
  const n = ((t == null ? void 0 : t.length) ?? 0) > 1;
  if (e && e.includes("://")) return e;
  if (n) return Jn;
  const a = t == null ? void 0 : t[0];
  return a ? Ml(a, "") : Jn;
}
const wc = [];
function UN(e) {
  wc.push(e);
}
function HN(e) {
  const t = wc.lastIndexOf(e);
  t >= 0 && wc.splice(t, 1);
}
function T1(e) {
  return wc[wc.length - 1] === e;
}
const KN = ["aria-labelledby", "aria-label", "aria-busy"], VN = {
  key: 0,
  class: "fe-modal__head"
}, jN = ["aria-label", "disabled"], qN = { class: "fe-modal__body" }, WN = {
  key: 1,
  class: "fe-modal__ask",
  role: "alert",
  "data-testid": "modal-busy-close"
}, YN = { class: "fe-modal__ask-text" }, GN = { class: "fe-modal__ask-actions" }, XN = {
  key: 2,
  class: "fe-modal__actions"
}, Zm = 'input:not([disabled]),select:not([disabled]),textarea:not([disabled]),button:not([disabled]),a[href],[tabindex]:not([tabindex="-1"])', ta = /* @__PURE__ */ lt({
  __name: "Modal",
  props: {
    locale: {},
    open: { type: Boolean },
    title: {},
    size: {},
    closeOnBackdrop: { type: Boolean, default: !0 },
    chromeless: { type: Boolean },
    fullbleed: { type: Boolean },
    theme: {},
    busy: { type: Boolean },
    busyClose: { default: null },
    bare: { type: Boolean },
    labelledby: {}
  },
  emits: ["close"],
  setup(e, { emit: t }) {
    const n = e, a = Zo() ? bi(sx, void 0) : void 0, { t: i } = pt(() => n.locale ?? (a == null ? void 0 : a()) ?? "en"), o = t, l = $(null);
    let c = 0;
    const p = `fe-modal-title-${++c}-${Math.random().toString(36).slice(2, 7)}`;
    let m = null, v = null;
    const x = Symbol("fe-modal");
    let w = !1, S;
    function k() {
      const R = l.value;
      if (!R) return;
      const W = R.querySelector("[data-fe-autofocus]");
      if (W) {
        W.focus();
        return;
      }
      const N = (H) => {
        var ne;
        return ((ne = R.querySelector(H)) == null ? void 0 : ne.querySelector(Zm)) ?? null;
      }, J = N(".fe-modal__body") ?? N(".fe-modal__actions") ?? R.querySelector(Zm);
      J == null || J.focus();
    }
    function b() {
      w || (w = !0, m = document.activeElement ?? null, v = null, UN(x), document.addEventListener("keydown", D), S = setTimeout(() => {
        var R;
        if (S = void 0, !(typeof document > "u") && w && T1(x) && !((R = l.value) != null && R.contains(document.activeElement))) {
          const W = document.activeElement;
          v = W && W !== document.body && W !== m ? W : null, k();
        }
      }, 30));
    }
    function C() {
      var W;
      if (!w) return;
      w = !1, S !== void 0 && (clearTimeout(S), S = void 0), document.removeEventListener("keydown", D), HN(x);
      const R = m != null && m.isConnected ? m : v != null && v.isConnected ? v : m;
      (W = R == null ? void 0 : R.focus) == null || W.call(R), m = null, v = null;
    }
    Je(
      () => n.open,
      (R) => R ? b() : C(),
      { immediate: !0 }
    ), Tt(C);
    const T = $(!1), A = $(null);
    Je(
      () => [n.busy, n.open],
      ([R, W]) => {
        (!R || !W) && (T.value = !1);
      }
    );
    function L() {
      if (!n.busy) {
        o("close");
        return;
      }
      n.busyClose && (T.value = !0, Gt(() => {
        var R;
        return (R = A.value) == null ? void 0 : R.focus();
      }));
    }
    function z() {
      T.value = !1, o("close");
    }
    function D(R) {
      if (T1(x)) {
        if (R.key === "Escape") {
          if (n.chromeless) return;
          if (T.value) {
            T.value = !1;
            return;
          }
          if (n.busy) return;
          o("close");
          return;
        }
        if (R.key === "Tab" && l.value) {
          const W = Array.from(l.value.querySelectorAll(Zm)).filter(
            (ne) => ne.offsetParent !== null || ne === document.activeElement
          );
          if (W.length === 0) return;
          const N = W[0], J = W[W.length - 1], H = document.activeElement;
          R.shiftKey && (H === N || !l.value.contains(H)) ? (R.preventDefault(), J.focus()) : !R.shiftKey && (H === J || !l.value.contains(H)) && (R.preventDefault(), N.focus());
        }
      }
    }
    let U = !1;
    function q(R) {
      U = R.target === R.currentTarget;
    }
    function P(R) {
      const W = U;
      U = !1, !(!n.closeOnBackdrop || n.chromeless || n.busy) && (R.target !== R.currentTarget || !W || o("close"));
    }
    return (R, W) => (f(), Ge(Rr, { name: "fe-modal" }, {
      default: mt(() => [
        e.open ? (f(), h("div", {
          key: 0,
          class: Re(["fe fe-modal__backdrop", [
            { "fe-modal__backdrop--chromeless": e.chromeless },
            { "fe-modal__backdrop--fullbleed": e.fullbleed && !e.chromeless },
            e.theme === "light" ? "fe--theme-light" : "",
            e.theme === "dark" ? "fe--theme-dark" : ""
          ]]),
          role: "presentation",
          onPointerdown: q,
          onClick: P
        }, [
          d("div", {
            ref_key: "cardEl",
            ref: l,
            class: Re(["fe-modal__card", [
              e.bare ? "fe-modal__card--bare" : `fe-modal__card--${e.size || "md"}`,
              e.chromeless && "fe-modal__card--chromeless",
              e.fullbleed && !e.chromeless && "fe-modal__card--fullbleed"
            ]]),
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": e.labelledby || (e.title && !e.chromeless && !e.fullbleed && !e.bare ? p : void 0),
            "aria-label": e.labelledby ? void 0 : (!e.title || e.chromeless || e.fullbleed || e.bare) && e.title || void 0,
            "aria-busy": e.busy ? "true" : void 0,
            onClick: W[1] || (W[1] = yt(() => {
            }, ["stop"]))
          }, [
            e.title && !e.chromeless && !e.fullbleed && !e.bare ? (f(), h("header", VN, [
              d("h2", {
                id: p,
                class: "fe-modal__title"
              }, y(e.title), 1),
              d("button", {
                type: "button",
                class: "fe-modal__close",
                "aria-label": u(i)("modal.close"),
                disabled: e.busy && !e.busyClose,
                onClick: L
              }, "×", 8, jN)
            ])) : O("", !0),
            d("div", qN, [
              On(R.$slots, "default")
            ]),
            T.value && e.busyClose ? (f(), h("div", WN, [
              d("p", YN, y(e.busyClose.question), 1),
              d("div", GN, [
                d("button", {
                  ref_key: "keepEl",
                  ref: A,
                  type: "button",
                  class: "fe-btn",
                  "data-testid": "modal-busy-close-keep",
                  onClick: W[0] || (W[0] = (N) => T.value = !1)
                }, y(u(i)("modal.busy_close.keep")), 513),
                d("button", {
                  type: "button",
                  class: "fe-btn fe-btn--danger",
                  "data-testid": "modal-busy-close-confirm",
                  onClick: z
                }, y(e.busyClose.confirm || u(i)("modal.busy_close.confirm")), 1)
              ])
            ])) : O("", !0),
            R.$slots.actions && !e.chromeless && !e.fullbleed && !e.bare ? (f(), h("footer", XN, [
              On(R.$slots, "actions")
            ])) : O("", !0)
          ], 10, KN)
        ], 34)) : O("", !0)
      ]),
      _: 3
    }));
  }
}), JN = {
  class: "fe-destpick",
  "data-testid": "destpicker"
}, ZN = { class: "fe-destpick__bar" }, QN = ["disabled", "title", "aria-label"], eB = ["aria-label"], tB = ["onClick"], nB = {
  key: 1,
  class: "fe-destpick__crumb is-current"
}, aB = {
  class: "fe-destpick__rows",
  "data-testid": "destpicker-rows"
}, iB = {
  key: 0,
  class: "fe-destpick__note"
}, oB = {
  key: 1,
  class: "fe-destpick__note"
}, rB = {
  key: 2,
  class: "fe-destpick__note"
}, sB = ["disabled", "title", "aria-pressed", "data-testid", "onClick"], lB = ["innerHTML"], uB = { class: "fe-destpick__rowname" }, cB = {
  key: 0,
  class: "fe-destpick__rowtag",
  "data-testid": "destpicker-vault-tag"
}, dB = {
  key: 1,
  class: "fe-destpick__rowtag"
}, fB = {
  key: 2,
  class: "fe-destpick__rowtag"
}, pB = {
  key: 3,
  class: "fe-destpick__rowinto",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true",
  focusable: "false"
}, hB = {
  key: 1,
  class: "fe-destpick__target",
  "data-testid": "destpicker-target"
}, mB = ["disabled"], Dg = /* @__PURE__ */ lt({
  __name: "DestinationPickerModal",
  props: {
    open: { type: Boolean },
    api: {},
    locale: {},
    storages: {},
    startAt: {},
    moving: {},
    mode: {},
    title: {},
    theme: {},
    pick: {},
    busy: { type: Boolean },
    vaultRoots: {},
    vaultFrom: {}
  },
  emits: ["close", "pick"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = pt(() => n.locale), o = $(Jn), l = $([]), c = $(!1), p = $(void 0), m = $(!1), v = E(() => {
      var fe;
      return (((fe = n.storages) == null ? void 0 : fe.length) ?? 0) > 1;
    }), x = E(() => i("destpicker.drives")), w = E(() => n.pick === "file"), S = $(null);
    let k = /* @__PURE__ */ new Map();
    const b = $([]);
    function C(fe) {
      const _ = String(fe ?? "").replace(/\/+$/, "");
      _ && !b.value.includes(_) && (b.value = [...b.value, _]);
    }
    function T(fe) {
      return RN(fe, [...n.vaultRoots ?? [], ...b.value]);
    }
    Je(
      () => n.open,
      (fe) => {
        fe && (k = /* @__PURE__ */ new Map(), b.value = [], z(FN(n.startAt, n.storages)));
      },
      { immediate: !0 }
    );
    const A = bi(jc, null);
    async function L(fe) {
      const _ = k.get(fe);
      if (_) return _;
      try {
        let Q = await n.api.index(fe);
        typeof Q.e2e_vault_root == "string" && Q.e2e_vault_root && C(Q.e2e_vault_root);
        for (const K of Q.files ?? []) K.type === "dir" && K.e2e_vault && C(K.path);
        if (A) {
          const K = typeof Q.e2e_root == "string" && Q.e2e_root ? Q.e2e_root : null;
          Q = { ...Q, files: await A.decorate(Q.files ?? [], { root: K }) };
        }
        return k.set(fe, Q), Q;
      } catch {
        return;
      }
    }
    async function z(fe) {
      if (o.value = fe, m.value = !1, S.value = null, fe === Jn) {
        p.value = void 0, l.value = BN(n.storages, n.moving);
        return;
      }
      c.value = !0;
      const _ = await L(fe);
      if (o.value !== fe) return;
      c.value = !1, p.value = _, m.value = !_;
      const Q = T(fe), K = Q && Q !== (n.vaultFrom ?? null) ? [] : _ == null ? void 0 : _.files;
      l.value = NN(K, n.moving, { files: w.value }).map((I) => {
        if (I.kind !== "dir") return I;
        const Y = T(I.path) === I.path.replace(/\/+$/, ""), B = !I.blocked && IN(I.path, n.vaultFrom ?? null, T);
        return { ...I, vault: Y, blocked: B ? "vault" : I.blocked };
      });
    }
    const D = E(() => Pg(o.value, v.value)), U = E(
      () => DN(o.value).map((fe) => ({ ...fe, label: (A == null ? void 0 : A.segmentLabel(fe.path)) ?? fe.label }))
    ), q = E(() => Lg(o.value, n.moving)), P = E(() => (b.value, $$(o.value, n.vaultFrom ?? null, T))), R = E(() => o.value === Jn || !p.value || p.value.read_only ? !1 : S$(p.value.perm)), W = E(() => n.busy || o.value === Jn || P.value ? !1 : w.value ? S.value !== null : R.value && q.value === null), N = E(() => o.value !== Jn && !(w.value && !m.value)), J = E(() => o.value === Jn ? i("destpicker.pick_a_drive") : w.value ? m.value ? i("destpicker.unreadable") : P.value ? i("destpicker.blocked.vault_in") : S.value === null ? i("destpicker.pick_a_file") : "" : q.value === "self" ? i("destpicker.blocked.self") : q.value === "descendant" ? i("destpicker.blocked.descendant") : P.value === "into" ? i("destpicker.blocked.vault_in") : P.value === "out" ? i("destpicker.blocked.vault_out") : m.value ? i("destpicker.unreadable") : p.value && !R.value ? i("destpicker.readonly_here") : ""), H = E(() => n.title ? n.title : n.mode === "move" ? i("destpicker.title.move") : n.mode === "copy" ? i("destpicker.title.copy") : n.mode === "save" ? i("destpicker.title.save") : w.value ? i("destpicker.title.choose_file") : i("destpicker.title.choose")), ne = E(() => n.mode === "move" ? i("destpicker.confirm.move") : n.mode === "copy" ? i("destpicker.confirm.copy") : n.mode === "save" ? i("destpicker.confirm.save") : w.value ? i("destpicker.confirm.choose_file") : i("destpicker.confirm.choose")), j = E(
      () => w.value && S.value !== null ? ml(S.value, x.value) : ml(o.value, x.value)
    );
    function re(fe) {
      return fe.kind === "file" ? wa({ type: "file", basename: fe.label }) : Sx("folder");
    }
    function he(fe) {
      return fe.kind === "file" ? fe.label : fe.blocked === "self" ? i("destpicker.blocked.self") : fe.blocked === "descendant" ? i("destpicker.blocked.descendant") : fe.blocked === "vault" ? i(n.vaultFrom ? "destpicker.blocked.vault_out" : "destpicker.blocked.vault_in") : fe.writable ? fe.label : i("destpicker.readonly");
    }
    function ue(fe) {
      if (fe.kind === "file") {
        S.value = fe.path;
        return;
      }
      fe.blocked || z(fe.path);
    }
    function ae() {
      W.value && a("pick", w.value && S.value !== null ? S.value : o.value);
    }
    return (fe, _) => (f(), Ge(ta, {
      open: e.open,
      title: H.value,
      size: "md",
      locale: e.locale,
      theme: e.theme,
      busy: e.busy,
      onClose: _[3] || (_[3] = (Q) => a("close"))
    }, {
      actions: mt(() => [
        d("button", {
          type: "button",
          class: "fe-btn",
          onClick: _[2] || (_[2] = (Q) => a("close"))
        }, y(u(i)("destpicker.cancel")), 1),
        d("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          disabled: !W.value,
          "data-testid": "destpicker-confirm",
          onClick: ae
        }, y(ne.value), 9, mB)
      ]),
      default: mt(() => [
        d("div", JN, [
          d("div", ZN, [
            d("button", {
              type: "button",
              class: "fe-destpick__up",
              disabled: !D.value,
              title: u(i)("destpicker.up"),
              "aria-label": u(i)("destpicker.up"),
              "data-testid": "destpicker-up",
              onClick: _[0] || (_[0] = (Q) => z(D.value))
            }, [..._[4] || (_[4] = [
              d("svg", {
                class: "fe-ficon",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "aria-hidden": "true",
                focusable: "false"
              }, [
                d("path", { d: "M12 19V5M5 12l7-7 7 7" })
              ], -1)
            ])], 8, QN),
            d("nav", {
              class: "fe-destpick__crumbs",
              "aria-label": u(i)("destpicker.crumbs")
            }, [
              v.value ? (f(), h("button", {
                key: 0,
                type: "button",
                class: Re(["fe-destpick__crumb", { "is-current": o.value === u(Jn) }]),
                onClick: _[1] || (_[1] = (Q) => z(u(Jn)))
              }, y(x.value), 3)) : O("", !0),
              (f(!0), h(Te, null, nt(U.value, (Q) => (f(), h(Te, {
                key: Q.path
              }, [
                _[5] || (_[5] = d("span", {
                  class: "fe-destpick__sep",
                  "aria-hidden": "true"
                }, "/", -1)),
                d("button", {
                  type: "button",
                  class: Re(["fe-destpick__crumb", { "is-current": Q.path === o.value }]),
                  onClick: (K) => z(Q.path)
                }, y(Q.label), 11, tB)
              ], 64))), 128)),
              !v.value && !U.value.length ? (f(), h("span", nB, y(u(ml)(o.value, x.value)), 1)) : O("", !0)
            ], 8, eB)
          ]),
          d("ul", aB, [
            c.value ? (f(), h("li", iB, y(u(i)("destpicker.loading")), 1)) : m.value ? (f(), h("li", oB, y(u(i)("destpicker.unreadable")), 1)) : l.value.length ? O("", !0) : (f(), h("li", rB, y(w.value ? u(i)("destpicker.empty_files") : u(i)("destpicker.empty")), 1)),
            (f(!0), h(Te, null, nt(l.value, (Q) => (f(), h("li", {
              key: Q.path
            }, [
              d("button", {
                type: "button",
                class: Re(["fe-destpick__row", {
                  "is-locked": !Q.writable,
                  "is-blocked": !!Q.blocked,
                  "is-file": Q.kind === "file",
                  "is-picked": Q.kind === "file" && S.value === Q.path
                }]),
                disabled: !!Q.blocked,
                title: he(Q),
                "aria-pressed": Q.kind === "file" ? S.value === Q.path : void 0,
                "data-testid": "destpicker-row-" + Q.label,
                onClick: (K) => ue(Q)
              }, [
                d("span", {
                  class: "fe-destpick__rowicon",
                  "aria-hidden": "true",
                  innerHTML: re(Q)
                }, null, 8, lB),
                d("span", uB, [
                  d("bdi", null, y(Q.label), 1)
                ]),
                Q.vault ? (f(), h("span", cB, y(u(i)("destpicker.tag.vault")), 1)) : O("", !0),
                Q.blocked ? (f(), h("span", dB, y(u(i)("destpicker.tag.blocked")), 1)) : Q.writable ? O("", !0) : (f(), h("span", fB, y(u(i)("destpicker.readonly")), 1)),
                Q.kind === "dir" ? (f(), h("svg", pB, [..._[6] || (_[6] = [
                  d("path", { d: "M9 5l7 7-7 7" }, null, -1)
                ])])) : O("", !0)
              ], 10, sB)
            ]))), 128))
          ]),
          J.value ? (f(), h("p", {
            key: 0,
            class: Re(["fe-destpick__reason", { "is-hint": !N.value }]),
            "data-testid": "destpicker-reason"
          }, y(J.value), 3)) : (f(), h("p", hB, y(u(i)("destpicker.target", { name: j.value })), 1))
        ])
      ]),
      _: 1
    }, 8, ["open", "title", "locale", "theme", "busy"]));
  }
}), vB = ["title"], yB = ["disabled"], gB = ["disabled"], bB = /* @__PURE__ */ lt({
  __name: "SurfaceFileChooser",
  props: {
    id: {},
    kind: {},
    modelValue: {},
    locale: {},
    theme: {},
    api: {},
    storages: {},
    startAt: {},
    disabled: { type: Boolean },
    invalid: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = pt(() => n.locale), o = $(!1), l = E(() => n.kind === "dir" ? "dir" : "file"), c = E(() => n.modelValue ? ml(n.modelValue, "") || n.modelValue : ""), p = E(() => n.modelValue ? l.value === "dir" ? n.modelValue : Pg(n.modelValue, !1) ?? n.modelValue : n.startAt);
    function m(v) {
      o.value = !1, a("update:modelValue", v);
    }
    return (v, x) => (f(), h("div", {
      class: Re(["fe-sfile", { "is-invalid": e.invalid }]),
      "data-testid": "surface-file-chooser"
    }, [
      d("span", {
        class: Re(["fe-sfile__value", { "fe-sfile__value--empty": !e.modelValue }]),
        title: e.modelValue || void 0,
        "data-testid": "surface-file-chooser-value"
      }, y(c.value || u(i)("plugin.file.none")), 11, vB),
      d("button", {
        type: "button",
        class: "fe-btn fe-btn--sm",
        disabled: e.disabled || !e.api,
        "data-testid": "surface-file-chooser-open",
        onClick: x[0] || (x[0] = (w) => o.value = !0)
      }, y(u(i)("plugin.file.choose")), 9, yB),
      e.modelValue ? (f(), h("button", {
        key: 0,
        type: "button",
        class: "fe-btn fe-btn--sm",
        disabled: e.disabled,
        "data-testid": "surface-file-chooser-clear",
        onClick: x[1] || (x[1] = (w) => a("update:modelValue", ""))
      }, y(u(i)("plugin.file.clear")), 9, gB)) : O("", !0),
      e.api ? (f(), Ge(Dg, {
        key: 1,
        open: o.value,
        api: e.api,
        locale: e.locale,
        mode: "choose",
        pick: l.value,
        storages: e.storages,
        "start-at": p.value,
        onClose: x[2] || (x[2] = (w) => o.value = !1),
        onPick: m
      }, null, 8, ["open", "api", "locale", "pick", "storages", "start-at"])) : O("", !0)
    ], 2));
  }
}), kB = ["data-state"], wB = {
  key: 0,
  class: "fe-surface__text fe-surface__text--muted"
}, _B = {
  key: 1,
  class: "fe-surface__text fe-surface__text--muted"
}, xB = ["src", "alt"], SB = ["src"], $B = ["src"], TB = ["src", "type"], AB = ["innerHTML"], EB = ["title"], CB = /* @__PURE__ */ lt({
  __name: "SurfacePreview",
  props: {
    path: {},
    fileRef: {},
    fileUrl: { type: Function },
    locale: {},
    api: {}
  },
  setup(e) {
    const t = e, { t: n } = pt(() => t.locale), a = $(null), i = $(""), o = $("loading");
    let l = 0;
    const c = E(() => t.fileRef && t.fileUrl ? t.fileUrl(t.fileRef) : null), p = E(() => {
      var S;
      return ((S = c.value) == null ? void 0 : S.name) || ml(t.path, "") || t.path || t.fileRef || "";
    }), m = E(() => {
      const S = i.value;
      return S.startsWith("image/") ? "image" : S.startsWith("video/") ? "video" : S.startsWith("audio/") ? "audio" : "other";
    }), v = E(() => wa({ type: "file", basename: p.value }));
    function x() {
      a.value && a.value.startsWith("blob:") && URL.revokeObjectURL(a.value), a.value = null;
    }
    async function w() {
      const S = ++l;
      if (x(), i.value = "", t.fileRef) {
        if (!c.value) {
          o.value = "error";
          return;
        }
        a.value = c.value.url, i.value = c.value.mime || "", o.value = "ok";
        return;
      }
      if (!t.api || !t.path) {
        o.value = "error";
        return;
      }
      o.value = "loading";
      try {
        const k = await t.api.fetchBlob(t.path);
        if (S !== l) {
          URL.revokeObjectURL(k.url);
          return;
        }
        a.value = k.url, i.value = k.mime || "", o.value = "ok";
      } catch {
        if (S !== l) return;
        o.value = "error";
      }
    }
    return Je([() => t.path, () => t.fileRef], () => void w(), { immediate: !0 }), Tt(() => {
      l++, x();
    }), (S, k) => (f(), h("figure", {
      class: "fe-spreview",
      "data-testid": "surface-preview",
      "data-state": o.value
    }, [
      o.value === "loading" ? (f(), h("p", wB, y(u(n)("plugin.view.loading")), 1)) : o.value === "error" ? (f(), h("p", _B, y(u(n)("plugin.view.preview_failed")), 1)) : (f(), h(Te, { key: 2 }, [
        m.value === "image" && a.value ? (f(), h("img", {
          key: 0,
          class: "fe-spreview__media",
          src: a.value,
          alt: p.value
        }, null, 8, xB)) : m.value === "video" && a.value ? (f(), h("video", {
          key: 1,
          class: "fe-spreview__media",
          src: a.value,
          controls: "",
          preload: "metadata"
        }, null, 8, SB)) : m.value === "audio" && a.value ? (f(), h("audio", {
          key: 2,
          class: "fe-spreview__audio",
          src: a.value,
          controls: "",
          preload: "metadata"
        }, null, 8, $B)) : e.fileRef && a.value ? (f(), h("embed", {
          key: 3,
          class: "fe-spreview__media fe-spreview__embed",
          src: a.value,
          type: i.value || void 0
        }, null, 8, TB)) : (f(), h("span", {
          key: 4,
          class: "fe-spreview__tile",
          "aria-hidden": "true",
          innerHTML: v.value
        }, null, 8, AB))
      ], 64)),
      d("figcaption", {
        class: "fe-spreview__name",
        title: e.path
      }, y(p.value), 9, EB)
    ], 8, kB));
  }
}), zB = ["data-mode", "role", "aria-labelledby"], MB = ["id"], PB = {
  key: 0,
  class: "fe-cfield__req",
  "aria-hidden": "true"
}, OB = {
  key: 1,
  class: "fe-ssig__modes",
  role: "tablist"
}, LB = ["aria-selected", "disabled", "data-testid", "onClick"], DB = ["aria-label"], RB = {
  key: 0,
  class: "fe-ssig__hint"
}, IB = {
  key: 3,
  class: "fe-ssig__typewrap"
}, NB = ["id", "placeholder", "disabled", "value"], BB = ["aria-label"], FB = ["disabled", "title", "aria-pressed", "data-testid", "onClick"], UB = ["src"], HB = {
  key: 4,
  class: "fe-ssig__uploadwrap"
}, KB = { class: "fe-btn fe-btn--sm fe-ssig__pick" }, VB = ["disabled"], jB = { class: "fe-ssig__hint" }, qB = {
  key: 0,
  class: "fe-surface__error",
  role: "alert"
}, WB = ["src"], YB = { class: "fe-ssig__foot" }, GB = ["disabled"], XB = {
  key: 0,
  class: "fe-ssig__signed"
}, T$ = /* @__PURE__ */ lt({
  __name: "SurfaceSignaturePad",
  props: {
    id: {},
    modes: {},
    width: {},
    height: {},
    modelValue: {},
    locale: {},
    disabled: { type: Boolean },
    invalid: { type: Boolean },
    font: {},
    fonts: {},
    label: {},
    required: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = pt(() => n.locale), o = E(() => iR(n.modes)), l = E(() => rR(n.width, n.height)), c = $(ju(n.modelValue) && o.value.includes(n.modelValue.mode) ? n.modelValue.mode : o.value[0]), p = E(() => {
      const ae = Array.isArray(n.fonts) ? n.fonts.filter(bc) : [];
      return ae.length ? Cl.filter((fe) => ae.includes(fe.key)) : Cl;
    });
    function m() {
      const ae = p.value.map((_) => _.key), fe = ju(n.modelValue) ? oR(n.modelValue) : void 0;
      return fe && ae.includes(fe) ? fe : bc(n.font) && ae.includes(n.font) ? n.font : ae.includes(my) ? my : ae[0];
    }
    const v = $(null), x = $(""), w = $(m()), S = $(""), k = $(""), b = E(() => ju(n.modelValue)), C = E(() => ju(n.modelValue) ? `data:image/png;base64,${n.modelValue.png_b64}` : "");
    function T(ae) {
      if (!ae) return null;
      try {
        return ae.getContext("2d");
      } catch {
        return null;
      }
    }
    function A() {
      return typeof window < "u" && window.devicePixelRatio > 0 ? Math.min(3, window.devicePixelRatio) : 1;
    }
    function L() {
      const ae = v.value;
      if (!ae) return;
      const fe = A();
      ae.width = Math.round(l.value.width * fe), ae.height = Math.round(l.value.height * fe);
      const _ = T(ae);
      _ && (_.setTransform(1, 0, 0, 1, 0, 0), _.clearRect(0, 0, ae.width, ae.height), _.scale(fe, fe), _.lineWidth = 2.2, _.lineCap = "round", _.lineJoin = "round", _.strokeStyle = _1);
    }
    let z = !1, D = null;
    function U(ae) {
      const fe = v.value, _ = fe == null ? void 0 : fe.getBoundingClientRect();
      if (!fe || !_ || !_.width) return { x: ae.clientX, y: ae.clientY };
      const Q = l.value.width / _.width, K = l.value.height / _.height;
      return { x: (ae.clientX - _.left) * Q, y: (ae.clientY - _.top) * K };
    }
    function q(ae) {
      var _, Q, K;
      if (n.disabled) return;
      const fe = T(v.value);
      if (fe) {
        z = !0, D = U(ae);
        try {
          (Q = (_ = ae.target).setPointerCapture) == null || Q.call(_, ae.pointerId);
        } catch {
        }
        fe.beginPath(), fe.moveTo(D.x, D.y), fe.lineTo(D.x + 0.1, D.y + 0.1), fe.stroke(), (K = ae.preventDefault) == null || K.call(ae);
      }
    }
    function P(ae) {
      var Q;
      if (!z || !D) return;
      const fe = T(v.value);
      if (!fe) return;
      const _ = U(ae);
      fe.beginPath(), fe.moveTo(D.x, D.y), fe.lineTo(_.x, _.y), fe.stroke(), D = _, (Q = ae.preventDefault) == null || Q.call(ae);
    }
    function R() {
      z && (z = !1, D = null, W(v.value, "draw"));
    }
    function W(ae, fe) {
      if (!ae) return;
      let _ = "";
      try {
        _ = ae.toDataURL("image/png");
      } catch {
        _ = "";
      }
      const Q = lR(_);
      Q && (fe !== "draw" && (k.value = _), a("update:modelValue", fe === "type" ? { png_b64: Q, mode: fe, font: w.value } : { png_b64: Q, mode: fe }));
    }
    async function N(ae, fe) {
      const _ = document.fonts;
      if (!(!_ || typeof _.load != "function"))
        try {
          await _.load(`${ae}px ${fe}`, "Aa");
        } catch {
        }
    }
    async function J() {
      const ae = x.value.trim();
      if (!ae) {
        k.value = "", a("update:modelValue", null);
        return;
      }
      const fe = s$(w.value).stack;
      if (await N(Math.round(l.value.height * 0.6), fe), x.value.trim() !== ae) return;
      const _ = document.createElement("canvas"), Q = 2, { width: K, height: I } = l.value;
      _.width = K * Q, _.height = I * Q;
      const Y = T(_);
      if (!Y) return;
      Y.scale(Q, Q), Y.fillStyle = _1, Y.textBaseline = "middle";
      const B = cR(
        (V) => (Y.font = `${V}px ${fe}`, Y.measureText(ae).width),
        K - 24,
        I
      );
      Y.font = `${B}px ${fe}`, Y.fillText(ae, 12, I / 2), W(_, "type");
    }
    function H(ae) {
      n.disabled || ae === w.value || (w.value = ae, x.value.trim() && J());
    }
    const ne = $(null);
    function j(ae) {
      var Y;
      const fe = ae.target, _ = (Y = fe.files) == null ? void 0 : Y[0];
      if (fe.value = "", !_) return;
      const Q = uR(_);
      if (Q !== "ok") {
        S.value = Q;
        return;
      }
      S.value = "";
      const K = URL.createObjectURL(_), I = new Image();
      I.onload = () => {
        URL.revokeObjectURL(K);
        const B = sR(I.naturalWidth, I.naturalHeight, g$, b$), V = document.createElement("canvas");
        V.width = B.width, V.height = B.height;
        const be = T(V);
        be && (be.drawImage(I, 0, 0, B.width, B.height), W(V, "upload"));
      }, I.onerror = () => {
        URL.revokeObjectURL(K), S.value = "unreadable";
      }, I.src = K;
    }
    function re() {
      x.value = "", k.value = "", S.value = "", L(), a("update:modelValue", null);
    }
    function he(ae) {
      ae !== c.value && (c.value = ae);
    }
    Je(c, async (ae) => {
      ae === "draw" && (await Gt(), L());
    }), Je(l, () => {
      c.value === "draw" && L();
    }), jt(() => {
      c.value === "draw" && L();
    }), Tt(() => {
      z = !1;
    });
    const ue = E(() => {
      switch (S.value) {
        case "too_big":
          return i("plugin.sig.upload_too_big", { kb: 200 });
        case "bad_type":
          return i("plugin.sig.upload_bad_type");
        case "unreadable":
          return i("plugin.sig.upload_unreadable");
        default:
          return "";
      }
    });
    return (ae, fe) => (f(), h("div", {
      class: Re(["fe-ssig", { "is-invalid": e.invalid, "is-disabled": e.disabled }]),
      "data-testid": "surface-signature",
      "data-mode": c.value,
      role: e.label ? "group" : void 0,
      "aria-labelledby": e.label ? `fe-ssig-${e.id}-lbl` : void 0
    }, [
      e.label ? (f(), h("span", {
        key: 0,
        id: `fe-ssig-${e.id}-lbl`,
        class: "fe-cfield__label",
        "data-testid": "surface-signature-label"
      }, [
        Ht(y(e.label), 1),
        e.required ? (f(), h("span", PB, "*")) : O("", !0)
      ], 8, MB)) : O("", !0),
      o.value.length > 1 ? (f(), h("div", OB, [
        (f(!0), h(Te, null, nt(o.value, (_) => (f(), h("button", {
          key: _,
          type: "button",
          class: Re(["fe-btn fe-btn--sm", { "fe-btn--primary": _ === c.value }]),
          role: "tab",
          "aria-selected": _ === c.value ? "true" : "false",
          disabled: e.disabled,
          "data-testid": `surface-signature-mode-${_}`,
          onClick: (Q) => he(_)
        }, y(u(i)(`plugin.sig.mode_${_}`)), 11, LB))), 128))
      ])) : O("", !0),
      c.value === "draw" ? (f(), h("div", {
        key: 2,
        class: "fe-ssig__padwrap",
        style: Wt({ maxWidth: `${l.value.width}px` })
      }, [
        d("canvas", {
          ref_key: "canvas",
          ref: v,
          class: "fe-ssig__canvas",
          style: Wt({ aspectRatio: `${l.value.width} / ${l.value.height}` }),
          "aria-label": u(i)("plugin.sig.draw_hint"),
          "data-testid": "surface-signature-canvas",
          onPointerdown: q,
          onPointermove: P,
          onPointerup: R,
          onPointercancel: R,
          onPointerleave: R
        }, null, 44, DB),
        b.value ? O("", !0) : (f(), h("p", RB, y(u(i)("plugin.sig.draw_hint")), 1))
      ], 4)) : c.value === "type" ? (f(), h("div", IB, [
        d("input", {
          id: `fe-ssig-${e.id}`,
          class: "fe-cfield__input fe-ssig__typed",
          type: "text",
          placeholder: u(i)("plugin.sig.type_placeholder"),
          disabled: e.disabled,
          value: x.value,
          autocomplete: "name",
          "data-testid": "surface-signature-typed",
          onInput: fe[0] || (fe[0] = (_) => {
            x.value = _.target.value, J();
          })
        }, null, 40, NB),
        p.value.length > 1 ? (f(), h("div", {
          key: 0,
          class: "fe-signfonts",
          role: "group",
          "aria-label": u(i)("plugin.sign.font_label"),
          "data-testid": "surface-signature-fonts"
        }, [
          (f(!0), h(Te, null, nt(p.value, (_) => (f(), h("button", {
            key: _.key,
            type: "button",
            class: Re(["fe-signfonts__btn", [_.className, { "is-on": _.key === w.value }]]),
            disabled: e.disabled,
            title: _.name,
            "aria-pressed": _.key === w.value ? "true" : "false",
            "data-testid": `surface-signature-font-${_.key}`,
            onClick: (Q) => H(_.key)
          }, y(x.value.trim() || _.name), 11, FB))), 128))
        ], 8, BB)) : O("", !0),
        d("div", {
          class: "fe-ssig__preview",
          style: Wt({ maxWidth: `${l.value.width}px`, aspectRatio: `${l.value.width} / ${l.value.height}` })
        }, [
          k.value || C.value ? (f(), h("img", {
            key: 0,
            class: "fe-ssig__img",
            src: k.value || C.value,
            alt: ""
          }, null, 8, UB)) : O("", !0)
        ], 4)
      ])) : (f(), h("div", HB, [
        d("label", KB, [
          d("input", {
            ref_key: "fileInput",
            ref: ne,
            type: "file",
            accept: "image/png,image/jpeg",
            class: "fe-ssig__file",
            disabled: e.disabled,
            "data-testid": "surface-signature-file",
            onChange: j
          }, null, 40, VB),
          Ht(" " + y(u(i)("plugin.sig.upload_pick")), 1)
        ]),
        d("p", jB, y(u(i)("plugin.sig.upload_hint", { kb: 200 })), 1),
        ue.value ? (f(), h("p", qB, y(ue.value), 1)) : O("", !0),
        k.value || C.value ? (f(), h("div", {
          key: 1,
          class: "fe-ssig__preview",
          style: Wt({ maxWidth: `${l.value.width}px` })
        }, [
          d("img", {
            class: "fe-ssig__img",
            src: k.value || C.value,
            alt: ""
          }, null, 8, WB)
        ], 4)) : O("", !0)
      ])),
      d("div", YB, [
        d("button", {
          type: "button",
          class: "fe-btn fe-btn--sm",
          disabled: e.disabled || !b.value,
          "data-testid": "surface-signature-clear",
          onClick: re
        }, y(u(i)("plugin.sig.clear")), 9, GB),
        b.value ? (f(), h("span", XB, y(u(i)("plugin.sig.signed")), 1)) : O("", !0)
      ])
    ], 10, zB));
  }
});
async function A$(e) {
  const t = await fetch(e.url, {
    headers: e.headers ?? {},
    credentials: e.credentials ?? "same-origin",
    signal: e.signal
  });
  if (!t.ok) {
    const n = await t.text().catch(() => "");
    throw fa(t.status, n, void 0);
  }
  return t;
}
async function JB(e) {
  return (await A$(e)).arrayBuffer();
}
async function Che(e) {
  return (await A$(e)).text();
}
const mp = "filex", ZB = /^#(?:[0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/;
function Rg(e) {
  const t = String(e ?? "").trim();
  return ZB.test(t) ? t.length === 4 ? `#${t[1]}${t[1]}${t[2]}${t[2]}${t[3]}${t[3]}`.toLowerCase() : t.toLowerCase() : "";
}
function QB(e, t) {
  const n = Rg(e);
  if (!n) return "";
  const a = parseInt(n.slice(1), 16), i = (l) => Math.max(0, Math.min(255, Math.round((a >> l & 255) * t))), o = (l) => l.toString(16).padStart(2, "0");
  return `#${o(i(16))}${o(i(8))}${o(i(0))}`;
}
function E$(e) {
  const t = Rg(e);
  if (!t) return "";
  const n = parseInt(t.slice(1), 16), a = (o) => {
    const l = o / 255;
    return l <= 0.04045 ? l / 12.92 : ((l + 0.055) / 1.055) ** 2.4;
  };
  return 0.2126 * a(n >> 16 & 255) + 0.7152 * a(n >> 8 & 255) + 0.0722 * a(n & 255) > 0.42 ? "#0b0f14" : "#ffffff";
}
function C$(e) {
  const t = Rg(e);
  if (!t) return {};
  const n = parseInt(t.slice(1), 16), a = `${n >> 16 & 255}, ${n >> 8 & 255}, ${n & 255}`;
  return {
    "--fe-primary": t,
    "--fe-primary-hover": QB(t, 0.85),
    "--fe-text-on-primary": E$(t),
    // ⚠ The TINT and the ink on it, or the accent only half arrives: the
    // button turned orange while the round badge behind the padlock, the
    // focus ring on the PIN box and the row hover stayed the stock blue
    // (measured on the first after-shot of the restored gate). The old
    // Go-rendered page derived exactly these from the same colour
    // (`--px-accent-soft: rgba(r,g,b,0.14)`, `color: var(--px-accent)`), and
    // a translucent tint is right rather than a solid: it composites onto
    // the card in light and in dark without a second value.
    "--fe-primary-soft": `rgba(${a}, 0.14)`,
    "--fe-primary-ink": t
  };
}
function e6(e = {}) {
  const t = $(null), n = $(!1), a = E(() => {
    var w, S;
    return ((S = (w = t.value) == null ? void 0 : w.name) == null ? void 0 : S.trim()) || mp;
  }), i = E(() => {
    var w, S;
    return !!((S = (w = t.value) == null ? void 0 : w.name) != null && S.trim()) && a.value !== mp;
  }), o = E(() => {
    var w, S;
    return ((S = (w = t.value) == null ? void 0 : w.logo_url) == null ? void 0 : S.trim()) || "";
  }), l = E(() => {
    var w, S;
    return ((S = (w = t.value) == null ? void 0 : w.footer_text) == null ? void 0 : S.trim()) || "";
  }), c = E(() => {
    var w;
    return ((w = t.value) == null ? void 0 : w.hide_powered_by) === !0;
  }), p = E(() => {
    var S;
    const w = (S = t.value) == null ? void 0 : S.theme;
    return w === "light" || w === "dark" ? w : "auto";
  }), m = E(() => {
    var w;
    return ((w = t.value) == null ? void 0 : w.locales) ?? [];
  }), v = E(() => {
    var w;
    return C$((w = t.value) == null ? void 0 : w.accent);
  });
  async function x() {
    const w = e.fetchImpl ?? (typeof fetch == "function" ? fetch : null);
    if (!w) return null;
    const S = Yo(e.base);
    for (const k of ["/api/public/branding", "/api/branding"])
      try {
        const b = await w(`${S}${k}`, {
          method: "GET",
          headers: { Accept: "application/json" },
          credentials: "same-origin"
        });
        if (!b.ok) continue;
        return t.value = await b.json(), n.value = !0, z2(t.value, { base: e.base, fetchImpl: e.fetchImpl }), t.value;
      } catch {
      }
    return null;
  }
  return { branding: t, loaded: n, name: a, whitelabel: i, logo: o, footerText: l, hidePoweredBy: c, themeDefault: p, locales: m, accentStyle: v, load: x };
}
let Qm = null;
function t6(e) {
  return `https://cdn.jsdelivr.net/npm/pdfjs-dist@${e}/legacy/build/pdf.worker.min.mjs`;
}
function n6(e) {
  return Qm || (Qm = (async () => {
    try {
      const t = await import(
        /* @vite-ignore */
        "./pdf-CaPYsOUo.js"
      ), n = t.default ?? t;
      return n.GlobalWorkerOptions && !n.GlobalWorkerOptions.workerSrc && (n.GlobalWorkerOptions.workerSrc = e || t6(n.version || "5.7.284")), n;
    } catch {
      return null;
    }
  })()), Qm;
}
const a6 = ["data-testid"], i6 = { class: "fe-spdf__propname" }, o6 = { class: "fe-spdf__prop" }, r6 = ["value", "placeholder", "disabled", "data-testid"], s6 = {
  key: 0,
  class: "fe-spdf__prop"
}, l6 = ["id", "data-testid"], u6 = ["data-testid"], c6 = ["id"], d6 = { class: "fe-spdf__prop fe-spdf__prop--check" }, f6 = ["checked", "disabled", "data-testid"], p6 = { class: "fe-spdf__prop" }, h6 = ["id"], m6 = { class: "fe-spdf__prop" }, v6 = ["value", "disabled", "data-testid"], y6 = { class: "fe-spdf__prop" }, g6 = ["value", "disabled", "data-testid"], b6 = { class: "fe-spdf__prop" }, k6 = ["id"], w6 = { class: "fe-spdf__prop" }, _6 = ["id"], x6 = ["data-testid"], S6 = { class: "fe-spdf__dateex-title" }, $6 = { class: "fe-spdf__dateex-value" }, T6 = {
  key: 4,
  class: "fe-spdf__prop"
}, A6 = ["id"], E6 = ["aria-label", "data-testid"], C6 = ["title", "disabled", "aria-pressed", "data-testid", "onClick"], z6 = ["data-testid"], M6 = ["id"], P6 = ["data-testid"], O6 = { class: "fe-spdf__linepreview-title" }, L6 = {
  key: 1,
  class: "fe-spdf__linepreview-line is-none"
}, D6 = ["disabled", "data-testid"], ev = "*", A1 = /* @__PURE__ */ lt({
  __name: "PdfFieldEditor",
  props: {
    field: {},
    signers: {},
    formats: {},
    dateLabels: {},
    locale: {},
    disabled: { type: Boolean },
    testidPrefix: {},
    stampLines: {}
  },
  emits: ["patch", "remove"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = pt(() => n.locale), o = E(() => n.testidPrefix || "surface-pdf");
    function l(B) {
      return i(`plugin.pdf.type_${B}`);
    }
    function c(B) {
      const V = { ...n.field };
      B(V), a("patch", V);
    }
    function p(B) {
      c((V) => {
        B ? V.label = B : delete V.label;
      });
    }
    function m(B) {
      c((V) => {
        B ? V.assignee = B : delete V.assignee;
      });
    }
    function v(B) {
      c((V) => {
        B ? V.required = !0 : delete V.required;
      });
    }
    function x(B) {
      c((V) => {
        const be = dy.includes(B) ? B : "any", Fe = { ...V.rule ?? { kind: "any" }, kind: be };
        be === "any" && !Fe.min && !Fe.max ? delete V.rule : V.rule = Fe;
      });
    }
    function w(B, V) {
      const be = Math.trunc(Number(String(V ?? "").trim()));
      c((Fe) => {
        const ze = { ...Fe.rule ?? { kind: "any" } };
        Number.isFinite(be) && be > 0 ? ze[B] = be : delete ze[B], ze.kind === "any" && !ze.min && !ze.max ? delete Fe.rule : Fe.rule = ze;
      });
    }
    function S(B) {
      c((V) => {
        B ? V.format = B : delete V.format;
      });
    }
    function k(B) {
      c((V) => {
        V.font = B;
      });
    }
    const b = E(() => u$(n.field.type)), C = E(() => n.field.style ?? "drawn");
    function T(B) {
      c((V) => {
        B === "typed" ? V.style = "typed" : delete V.style;
      });
    }
    const A = E(() => [
      { value: "drawn", label: i("plugin.pdf.style_drawn") },
      { value: "typed", label: i("plugin.pdf.style_typed") }
    ]), L = E(() => n.field.type === "checkbox" ? !1 : b.value ? C.value === "typed" : !0), z = E(() => E8(n.stampLines)), D = E(() => C8(n.field, z.value)), U = E(
      () => z.value.map((B) => ({ value: B.id, label: Xt(B.label, n.locale) || B.id }))
    );
    function q(B) {
      const V = (Array.isArray(B) ? B : [B]).filter(Boolean);
      c((be) => {
        be.lines = V;
      });
    }
    const P = E(
      () => D.value.map((B) => z.value.find((V) => V.id === B)).filter((B) => !!B).map((B) => Xt(z8(B, n.field.assignee), n.locale) || Xt(B.label, n.locale))
    ), R = E(() => i(b.value ? "plugin.pdf.assignee" : "plugin.pdf.filled_by")), W = E(() => [
      { value: ev, label: i("plugin.pdf.unassigned") },
      ...n.signers.map((B) => ({ value: B.id, label: Xt(B.label, n.locale) || B.id }))
    ]), N = E(
      () => dy.map((B) => ({ value: B, label: i(`plugin.pdf.rule_kind_${B}`) }))
    ), J = E(() => L8(n.formats)), H = E(
      () => J.value.map((B) => ({ value: B.id, label: Xt(B.label, n.locale) || B.id, help: B.example }))
    ), ne = E(() => {
      var B;
      return n.field.format ?? ((B = J.value[0]) == null ? void 0 : B.id) ?? "";
    }), j = E(() => R8(J.value)), re = E(() => D8(n.dateLabels));
    function he(B, V) {
      return ng(re.value[B], n.locale, () => i(V));
    }
    const ue = E(() => I8(J.value, ne.value)), ae = E(() => {
      var B, V, be;
      return ((B = ue.value) == null ? void 0 : B.order) ?? ((be = (V = j.value) == null ? void 0 : V.orders[0]) == null ? void 0 : be.id) ?? "";
    }), fe = E(() => {
      var B, V, be;
      return ((B = ue.value) == null ? void 0 : B.separator) ?? ((be = (V = j.value) == null ? void 0 : V.separators[0]) == null ? void 0 : be.id) ?? "";
    }), _ = E(
      () => {
        var B;
        return (((B = j.value) == null ? void 0 : B.orders) ?? []).map((V) => ({ value: V.id, label: Xt(V.label, n.locale) || V.id }));
      }
    ), Q = E(
      () => {
        var B;
        return (((B = j.value) == null ? void 0 : B.separators) ?? []).map((V) => ({ value: V.id, label: Xt(V.label, n.locale) || V.id }));
      }
    ), K = E(() => B8(ae.value, fe.value, /* @__PURE__ */ new Date()));
    function I(B) {
      S(g1(J.value, B, fe.value));
    }
    function Y(B) {
      S(g1(J.value, ae.value, B));
    }
    return (B, V) => {
      var be, Fe, ze;
      return f(), h("div", {
        class: "fe-spdf__props",
        "data-testid": `${o.value}-editor`
      }, [
        d("span", i6, y(l(e.field.type)), 1),
        d("label", o6, [
          d("span", null, y(u(i)("plugin.pdf.label")), 1),
          d("input", {
            class: "fe-cfield__input fe-spdf__name",
            type: "text",
            value: e.field.label ?? "",
            placeholder: l(e.field.type),
            disabled: e.disabled,
            "data-testid": `${o.value}-label`,
            onInput: V[0] || (V[0] = (Ue) => p(Ue.target.value))
          }, null, 40, r6)
        ]),
        e.signers.length ? (f(), h("div", s6, [
          d("span", {
            id: `${o.value}-${e.field.id}-assignee-lbl`,
            "data-testid": `${o.value}-assignee-label`
          }, y(R.value), 9, l6),
          Ze(mi, {
            options: W.value,
            "model-value": e.field.assignee || ev,
            disabled: e.disabled,
            "aria-labelledby": `${o.value}-${e.field.id}-assignee-lbl`,
            "testid-prefix": `${o.value}-assignee`,
            "onUpdate:modelValue": V[1] || (V[1] = (Ue) => m(String(Ue) === ev ? "" : String(Ue)))
          }, null, 8, ["options", "model-value", "disabled", "aria-labelledby", "testid-prefix"])
        ])) : O("", !0),
        b.value ? (f(), h("div", {
          key: 1,
          class: "fe-spdf__prop",
          "data-testid": `${o.value}-style`
        }, [
          d("span", {
            id: `${o.value}-${e.field.id}-style-lbl`
          }, y(u(i)("plugin.pdf.style")), 9, c6),
          Ze(mi, {
            options: A.value,
            "model-value": C.value,
            disabled: e.disabled,
            "aria-labelledby": `${o.value}-${e.field.id}-style-lbl`,
            "testid-prefix": `${o.value}-style`,
            "onUpdate:modelValue": V[2] || (V[2] = (Ue) => T(String(Ue)))
          }, null, 8, ["options", "model-value", "disabled", "aria-labelledby", "testid-prefix"])
        ], 8, u6)) : O("", !0),
        d("label", d6, [
          d("input", {
            type: "checkbox",
            checked: e.field.required === !0,
            disabled: e.disabled,
            "data-testid": `${o.value}-required`,
            onChange: V[3] || (V[3] = (Ue) => v(Ue.target.checked))
          }, null, 40, f6),
          d("span", null, y(u(i)("plugin.pdf.required")), 1)
        ]),
        e.field.type === "text" ? (f(), h(Te, { key: 2 }, [
          d("div", p6, [
            d("span", {
              id: `${o.value}-${e.field.id}-rule-lbl`
            }, y(u(i)("plugin.pdf.rule")), 9, h6),
            Ze(mi, {
              options: N.value,
              "model-value": ((be = e.field.rule) == null ? void 0 : be.kind) ?? "any",
              disabled: e.disabled,
              "aria-labelledby": `${o.value}-${e.field.id}-rule-lbl`,
              "testid-prefix": `${o.value}-rule`,
              "onUpdate:modelValue": V[4] || (V[4] = (Ue) => x(String(Ue)))
            }, null, 8, ["options", "model-value", "disabled", "aria-labelledby", "testid-prefix"])
          ]),
          d("label", m6, [
            d("span", null, y(u(i)("plugin.pdf.rule_min_label")), 1),
            d("input", {
              class: "fe-cfield__input fe-spdf__num",
              type: "number",
              min: "0",
              value: ((Fe = e.field.rule) == null ? void 0 : Fe.min) ?? "",
              disabled: e.disabled,
              "data-testid": `${o.value}-rule-min`,
              onInput: V[5] || (V[5] = (Ue) => w("min", Ue.target.value))
            }, null, 40, v6)
          ]),
          d("label", y6, [
            d("span", null, y(u(i)("plugin.pdf.rule_max_label")), 1),
            d("input", {
              class: "fe-cfield__input fe-spdf__num",
              type: "number",
              min: "0",
              value: ((ze = e.field.rule) == null ? void 0 : ze.max) ?? "",
              disabled: e.disabled,
              "data-testid": `${o.value}-rule-max`,
              onInput: V[6] || (V[6] = (Ue) => w("max", Ue.target.value))
            }, null, 40, g6)
          ])
        ], 64)) : O("", !0),
        e.field.type === "date" && j.value ? (f(), h(Te, { key: 3 }, [
          d("div", b6, [
            d("span", {
              id: `${o.value}-${e.field.id}-order-lbl`
            }, y(he("order", "plugin.pdf.date_order")), 9, k6),
            Ze(mi, {
              options: _.value,
              "model-value": ae.value,
              disabled: e.disabled,
              "aria-labelledby": `${o.value}-${e.field.id}-order-lbl`,
              "testid-prefix": `${o.value}-order`,
              "onUpdate:modelValue": V[7] || (V[7] = (Ue) => I(String(Ue)))
            }, null, 8, ["options", "model-value", "disabled", "aria-labelledby", "testid-prefix"])
          ]),
          d("div", w6, [
            d("span", {
              id: `${o.value}-${e.field.id}-sep-lbl`
            }, y(he("separator", "plugin.pdf.date_separator")), 9, _6),
            Ze(mi, {
              options: Q.value,
              "model-value": fe.value,
              disabled: e.disabled,
              "aria-labelledby": `${o.value}-${e.field.id}-sep-lbl`,
              "testid-prefix": `${o.value}-sep`,
              "onUpdate:modelValue": V[8] || (V[8] = (Ue) => Y(String(Ue)))
            }, null, 8, ["options", "model-value", "disabled", "aria-labelledby", "testid-prefix"])
          ]),
          d("p", {
            class: "fe-spdf__dateex",
            "data-testid": `${o.value}-date-example`
          }, [
            d("span", S6, y(he("example", "plugin.pdf.date_example")), 1),
            d("bdi", $6, y(K.value), 1)
          ], 8, x6)
        ], 64)) : e.field.type === "date" && H.value.length ? (f(), h("div", T6, [
          d("span", {
            id: `${o.value}-${e.field.id}-format-lbl`
          }, y(u(i)("plugin.pdf.format")), 9, A6),
          Ze(mi, {
            options: H.value,
            "model-value": ne.value,
            disabled: e.disabled,
            "aria-labelledby": `${o.value}-${e.field.id}-format-lbl`,
            "testid-prefix": `${o.value}-format`,
            "onUpdate:modelValue": V[9] || (V[9] = (Ue) => S(String(Ue)))
          }, null, 8, ["options", "model-value", "disabled", "aria-labelledby", "testid-prefix"])
        ])) : O("", !0),
        L.value ? (f(), h("div", {
          key: 5,
          class: "fe-signfonts fe-spdf__prop",
          role: "group",
          "aria-label": u(i)("plugin.pdf.font"),
          "data-testid": `${o.value}-fonts`
        }, [
          (f(!0), h(Te, null, nt(u(Cl), (Ue) => (f(), h("button", {
            key: Ue.key,
            type: "button",
            class: Re(["fe-signfonts__btn", [Ue.className, { "is-on": (e.field.font ?? "caveat") === Ue.key }]]),
            title: Ue.name,
            disabled: e.disabled,
            "aria-pressed": (e.field.font ?? "caveat") === Ue.key ? "true" : "false",
            "data-testid": `${o.value}-font-${Ue.key}`,
            onClick: (We) => k(Ue.key)
          }, " Aa ", 10, C6))), 128))
        ], 8, E6)) : O("", !0),
        b.value && U.value.length ? (f(), h("div", {
          key: 6,
          class: "fe-spdf__prop fe-spdf__lines",
          "data-testid": `${o.value}-lines`
        }, [
          d("span", {
            id: `${o.value}-${e.field.id}-lines-lbl`
          }, y(u(i)("plugin.pdf.lines")), 9, M6),
          Ze(mi, {
            options: U.value,
            "model-value": D.value,
            multi: "",
            disabled: e.disabled,
            "aria-labelledby": `${o.value}-${e.field.id}-lines-lbl`,
            "testid-prefix": `${o.value}-line`,
            "onUpdate:modelValue": q
          }, null, 8, ["options", "model-value", "disabled", "aria-labelledby", "testid-prefix"]),
          d("div", {
            class: "fe-spdf__linepreview",
            "data-testid": `${o.value}-lines-preview`
          }, [
            d("span", O6, y(u(i)("plugin.pdf.lines_preview")), 1),
            P.value.length ? (f(!0), h(Te, { key: 0 }, nt(P.value, (Ue, We) => (f(), h("span", {
              key: We,
              class: "fe-spdf__linepreview-line"
            }, y(Ue), 1))), 128)) : (f(), h("span", L6, y(u(i)("plugin.pdf.lines_none")), 1))
          ], 8, P6)
        ], 8, z6)) : O("", !0),
        On(B.$slots, "extra"),
        d("button", {
          type: "button",
          class: "fe-btn fe-btn--sm fe-btn--danger",
          disabled: e.disabled,
          "data-testid": `${o.value}-delete`,
          onClick: V[10] || (V[10] = (Ue) => a("remove"))
        }, y(u(i)("plugin.pdf.delete")), 9, D6)
      ], 8, a6);
    };
  }
}), R6 = ["data-state", "data-layout"], I6 = {
  key: 0,
  class: "fe-spdf__bar"
}, N6 = ["aria-label"], B6 = ["disabled", "aria-pressed", "data-testid", "onClick"], F6 = {
  key: 0,
  class: "fe-spdf__done",
  "data-testid": "surface-pdf-all-placed"
}, U6 = ["aria-label"], H6 = ["disabled", "aria-pressed", "data-testid", "onClick"], K6 = { class: "fe-spdf__zoom" }, V6 = ["aria-label", "disabled"], j6 = ["aria-label", "disabled"], q6 = ["aria-label", "disabled"], W6 = {
  key: 1,
  class: "fe-surface__text fe-surface__text--info fe-spdf__hint"
}, Y6 = {
  key: 2,
  class: "fe-spdf__define",
  "data-testid": "surface-pdf-define"
}, G6 = {
  key: 0,
  class: "fe-spdf__empty",
  "data-testid": "surface-pdf-no-boxes"
}, X6 = ["data-testid"], J6 = {
  class: "fe-spdf__cardno",
  "aria-hidden": "true"
}, Z6 = ["aria-label"], Q6 = { class: "fe-spdf__addlbl" }, eF = ["disabled", "data-testid", "onClick"], tF = {
  key: 3,
  class: "fe-spdf__strip",
  "data-testid": "surface-pdf-strip"
}, nF = {
  key: 0,
  class: "fe-spdf__props",
  "data-testid": "surface-pdf-selected"
}, aF = {
  key: 0,
  class: "fe-spdf__propwho"
}, iF = {
  key: 1,
  class: "fe-spdf__prop"
}, oF = ["max"], rF = {
  key: 1,
  class: "fe-surface__text fe-surface__text--info fe-spdf__hint",
  "data-testid": "surface-pdf-place-hint"
}, sF = {
  key: 2,
  class: "fe-surface__text fe-surface__text--muted fe-spdf__hint",
  "data-testid": "surface-pdf-idle-hint"
}, lF = {
  key: 4,
  "data-testid": "surface-pdf-selected"
}, uF = {
  key: 0,
  class: "fe-spdf__prop"
}, cF = ["max"], dF = {
  key: 0,
  class: "fe-surface__text fe-surface__text--muted"
}, fF = {
  key: 1,
  class: "fe-surface__unknown",
  role: "alert",
  "data-testid": "surface-pdf-error"
}, pF = {
  key: 2,
  class: "fe-spdf__pages"
}, hF = ["data-page", "onPointerdown"], mF = ["data-testid", "data-field-type", "role", "tabindex", "title", "onPointerdown", "onClick", "onKeydown"], vF = ["src"], yF = ["value", "placeholder", "aria-label", "inputmode", "maxlength", "aria-invalid", "aria-describedby", "title", "disabled", "data-testid", "onInput"], gF = ["innerHTML"], bF = {
  key: 4,
  class: "fe-spdf__label"
}, kF = {
  key: 0,
  class: "fe-spdf__who"
}, wF = {
  key: 1,
  class: "fe-spdf__who"
}, _F = ["id", "role", "data-testid"], xF = ["onPointerdown"], SF = {
  key: 6,
  class: "fe-spdf__pad",
  "data-testid": "surface-pdf-pad"
}, $F = { class: "fe-surface__text fe-surface__text--muted" }, TF = /* @__PURE__ */ lt({
  __name: "SurfacePdfFields",
  props: {
    id: {},
    src: {},
    mode: {},
    fields: {},
    signers: {},
    signer: {},
    types: {},
    formats: {},
    dateLabels: {},
    modelValue: {},
    locale: {},
    theme: {},
    disabled: { type: Boolean },
    invalid: { type: Boolean },
    api: {},
    fileUrl: { type: Function },
    pdfWorkerUrl: {},
    layout: {},
    pageHeight: {},
    stampLines: {}
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = pt(() => n.locale), o = E(() => n.mode !== "fill"), l = E(() => n.mode === "define"), c = E(() => n.mode === "place"), p = E(() => F8(n.signers)), m = E(() => M8(n.types)), v = $([]);
    let x;
    function w() {
      o.value ? v.value = Array.isArray(n.modelValue) ? Of(n.modelValue) : Of(n.fields) : v.value = H8(Of(n.fields), n.modelValue);
    }
    function S() {
      const ve = o.value ? v.value.map((Le) => ({ ...Le })) : p$(v.value, n.signer);
      x = ve, a("update:modelValue", ve);
    }
    let k = !1;
    function b() {
      if (se) {
        k = !0;
        return;
      }
      w();
    }
    w(), Je([() => n.fields, () => n.mode, () => n.signer], () => b()), Je(
      () => n.modelValue,
      (ve) => {
        ve !== x && b();
      }
    );
    const C = E(() => {
      const ve = /* @__PURE__ */ new Map();
      for (const Le of v.value) {
        if (!fy(Le)) continue;
        const He = ve.get(Le.page) ?? [];
        He.push(Le), ve.set(Le.page, He);
      }
      return ve;
    });
    function T(ve) {
      return U8(p.value, ve.assignee);
    }
    function A(ve) {
      const Le = T(ve), He = E$(Le);
      return He ? { "--spdf-color": Le, "--spdf-ink": He } : { "--spdf-color": Le };
    }
    function L(ve) {
      const Le = p.value.find((He) => He.id === ve);
      return Le ? Xt(Le.label, n.locale) || Le.id : ve || "";
    }
    function z(ve) {
      return !o.value && f$(ve, n.signer);
    }
    function D(ve) {
      return i(`plugin.pdf.type_${ve}`);
    }
    function U(ve) {
      const Le = (ve.label ?? "").trim();
      if (Le) return Le;
      const He = v.value.filter((Ke) => Ke.type === ve.type && !(Ke.label ?? "").trim());
      return He.length < 2 ? D(ve.type) : `${D(ve.type)} ${He.findIndex((Ke) => Ke.id === ve.id) + 1}`;
    }
    const q = $("loading"), P = $([]), R = $(1), W = $(null), N = $(640), J = $(0), H = E(() => n.layout === "page");
    let ne = null, j = 0, re = null, he = null;
    const ue = /* @__PURE__ */ new Map(), ae = /* @__PURE__ */ new Map(), fe = /* @__PURE__ */ new Map(), _ = E(() => {
      if (!H.value) return N.value;
      const ve = P.value[0];
      return ve ? _8({ width: N.value, height: J.value }, ve) : N.value;
    }), Q = E(() => Math.max(120, Math.round(_.value * R.value)));
    async function K() {
      var He, Ke;
      const ve = n.src ?? {};
      if (ve.path) {
        if (!n.api) throw new Error("no api");
        const xt = await n.api.fetchBlob(ve.path);
        return URL.revokeObjectURL(xt.url), xt.blob.arrayBuffer();
      }
      const Le = ve.url || (ve.ref ? (Ke = (He = n.fileUrl) == null ? void 0 : He.call(n, ve.ref)) == null ? void 0 : Ke.url : "");
      if (!Le) throw new Error("no source");
      return JB({ url: Le, headers: {}, credentials: "same-origin" });
    }
    async function I() {
      var Le, He;
      const ve = ++j;
      q.value = "loading", P.value = [], Y();
      try {
        (Le = ne == null ? void 0 : ne.destroy) == null || Le.call(ne);
      } catch {
      }
      ne = null;
      try {
        const Ke = await n6(n.pdfWorkerUrl ?? void 0);
        if (!Ke) throw new Error("pdfjs unavailable");
        const xt = await K();
        if (ve !== j) return;
        const Qe = await Ke.getDocument({ data: xt }).promise;
        if (ve !== j) {
          (He = Qe.destroy) == null || He.call(Qe);
          return;
        }
        ne = Qe;
        const ce = [];
        for (let qe = 1; qe <= Qe.numPages; qe++) {
          const Nt = (await Qe.getPage(qe)).getViewport({ scale: 1 });
          ce.push({ num: qe, width: Nt.width, height: Nt.height, rotation: Nt.rotation ?? 0 });
        }
        if (ve !== j) return;
        P.value = ce, q.value = "ok", await Gt(), V();
      } catch {
        if (ve !== j) return;
        q.value = "error";
      }
    }
    function Y() {
      re == null || re.disconnect(), re = null, ue.clear(), ae.clear(), fe.clear();
    }
    function B(ve, Le) {
      if (!(Le instanceof HTMLDivElement)) return;
      const He = ue.get(ve);
      He !== Le && (He && (re == null || re.unobserve(He)), ue.set(ve, Le), ne && (re ? re.observe(Le) : typeof IntersectionObserver > "u" && be(ve), He && (ae.delete(ve), fe.delete(ve))));
    }
    function V() {
      if (typeof IntersectionObserver > "u") {
        for (const ve of ue.keys()) be(ve);
        return;
      }
      re = new IntersectionObserver(
        (ve) => {
          for (const Le of ve) {
            const He = Number(Le.target.dataset.page);
            Le.isIntersecting && be(He);
          }
        },
        { rootMargin: "200px 0px" }
      );
      for (const ve of ue.values()) re.observe(ve);
    }
    async function be(ve) {
      if (!ne || !ue.get(ve)) return;
      const He = Q.value;
      if (ae.get(ve) === He) return;
      ae.set(ve, He);
      const Ke = P.value.find((qe) => qe.num === ve);
      if (!Ke) return;
      const xt = typeof window < "u" && window.devicePixelRatio > 0 ? Math.min(3, window.devicePixelRatio) : 1, Qe = He / Ke.width * xt, ce = ne;
      try {
        const qe = await ce.getPage(ve), dt = qe.getViewport({ scale: Qe }), Nt = document.createElement("canvas");
        Nt.className = "fe-spdf__canvas", Nt.width = Math.round(dt.width), Nt.height = Math.round(dt.height);
        const hn = Nt.getContext("2d");
        if (!hn || (await qe.render({ canvasContext: hn, viewport: dt }).promise, ce !== ne || ae.get(ve) !== He)) return;
        const nn = ue.get(ve);
        if (!nn) return;
        const oe = fe.get(ve);
        oe && oe.parentNode === nn ? nn.replaceChild(Nt, oe) : nn.prepend(Nt), fe.set(ve, Nt);
      } catch {
        ae.get(ve) === He && ae.delete(ve);
      }
    }
    function Fe() {
      for (const ve of ue.keys())
        ae.has(ve) && (ae.delete(ve), be(ve));
    }
    Je(Q, () => Fe());
    function ze() {
      R.value = Math.min(3, Math.round(R.value * 1.25 * 100) / 100);
    }
    function Ue() {
      R.value = Math.max(0.5, Math.round(R.value / 1.25 * 100) / 100);
    }
    function We() {
      R.value = 1;
    }
    function $t() {
      const ve = W.value;
      ve && (N.value = ve.clientWidth || N.value, J.value = ve.clientHeight || J.value, !(typeof ResizeObserver > "u") && (he == null || he.disconnect(), he = new ResizeObserver(() => St()), he.observe(ve)));
    }
    function St() {
      var He, Ke;
      if (se) {
        at = !0;
        return;
      }
      const ve = ((He = W.value) == null ? void 0 : He.clientWidth) ?? 0, Le = ((Ke = W.value) == null ? void 0 : Ke.clientHeight) ?? 0;
      ve > 0 && Math.abs(ve - N.value) > 2 && (N.value = ve), Le > 0 && Math.abs(Le - J.value) > 2 && (J.value = Le);
    }
    let at = !1;
    Je(W, () => {
      Gt($t);
    }), jt(() => {
      $t(), I();
    });
    const kt = E(() => {
      const ve = n.src ?? {};
      return [ve.ref ?? "", ve.path ?? "", ve.url ?? ""].join("\0");
    });
    Je(kt, () => void I()), Tt(() => {
      var ve;
      j++, Y(), he == null || he.disconnect();
      try {
        (ve = ne == null ? void 0 : ne.destroy) == null || ve.call(ne);
      } catch {
      }
      ne = null;
    });
    const ht = $(""), Ie = $("");
    let se = null;
    const xe = $(null);
    function me(ve, Le) {
      const He = Le.getBoundingClientRect();
      return m1({ x: ve.clientX - He.left, y: ve.clientY - He.top }, { width: He.width, height: He.height });
    }
    function De(ve) {
      const Le = ue.get(ve.page), He = Le && Le.isConnected ? Le : ve.el;
      if (!He || !He.isConnected) return null;
      const Ke = He.getBoundingClientRect();
      return Ke.width >= 1 && Ke.height >= 1 ? Ke : null;
    }
    function ot(ve, Le) {
      return m1({ x: ve.clientX - Le.left, y: ve.clientY - Le.top }, { width: Le.width, height: Le.height });
    }
    function ft(ve) {
      Ie.value = Ie.value === ve ? "" : ve, ht.value = "";
    }
    function gt(ve) {
      const Le = O8(v.value, ve, {
        assignee: Pe(),
        required: !0
      });
      v.value = [...v.value, Le], S();
    }
    function Ut(ve) {
      v.value = v.value.map((Le) => Le.id === ve.id ? ve : Le), S();
    }
    function Xe(ve) {
      v.value = v.value.filter((Le) => Le.id !== ve), ht.value === ve && (ht.value = ""), S();
    }
    const je = E(() => P8(v.value)), Be = $("");
    function ie(ve) {
      Be.value = Be.value === ve ? "" : ve, ht.value = "";
    }
    function ge(ve, Le) {
      const He = Be.value;
      He && (v.value = v.value.map((Ke) => {
        if (Ke.id !== He) return Ke;
        const xt = { ...Ke, page: ve, ...hl(Le) };
        return delete xt.placed, xt;
      }), Be.value = "", ht.value = He, S());
    }
    function G() {
      const ve = ht.value;
      ve && (v.value = v.value.map((Le) => Le.id === ve ? { ...Le, placed: !1 } : Le), ht.value = "", S());
    }
    function ye(ve) {
      const Le = L(ve.assignee), He = U(ve);
      return Le ? `${He} · ${Le}` : He;
    }
    function te(ve, Le) {
      var Ke, xt;
      if (!o.value || n.disabled) return;
      const He = ve.currentTarget;
      if (c.value && Be.value) {
        se = { kind: "place", page: Le, el: He, start: me(ve, He) }, xe.value = null, Et(), (Ke = ve.preventDefault) == null || Ke.call(ve);
        return;
      }
      if (Ie.value) {
        se = { kind: "place", page: Le, el: He, start: me(ve, He) }, xe.value = null, Et(), (xt = ve.preventDefault) == null || xt.call(ve);
        return;
      }
      ht.value = "";
    }
    function Ce(ve, Le, He) {
      var xt;
      if (!o.value || n.disabled) return;
      const Ke = ve.currentTarget.closest(".fe-spdf__page");
      Ke && (ht.value = Le.id, Ie.value = "", se = { kind: "move", page: He, el: Ke, start: me(ve, Ke), id: Le.id, orig: { ...Le } }, Et(), ve.stopPropagation(), (xt = ve.preventDefault) == null || xt.call(ve));
    }
    function Ne(ve, Le, He) {
      var xt;
      if (!o.value || n.disabled) return;
      const Ke = ve.currentTarget.closest(".fe-spdf__page");
      Ke && (ht.value = Le.id, se = { kind: "resize", page: He, el: Ke, start: me(ve, Ke), id: Le.id, orig: { ...Le } }, Et(), ve.stopPropagation(), (xt = ve.preventDefault) == null || xt.call(ve));
    }
    function _e(ve) {
      if (!se) return;
      const Le = De(se);
      if (!Le) return;
      const He = ot(ve, Le);
      if (se.kind === "place") {
        const dt = df(se.start, He);
        xe.value = { page: se.page, ...dt };
        return;
      }
      if (!se.id || !se.orig) return;
      const Ke = He.x - se.start.x, xt = He.y - se.start.y, Qe = se.orig, ce = se.kind === "move" ? hl({ x: Qe.x + Ke, y: Qe.y + xt, w: Qe.w, h: Qe.h }) : hl({ x: Qe.x, y: Qe.y, w: Qe.w + Ke, h: Qe.h + xt }), qe = se.id;
      v.value = v.value.map((dt) => dt.id === qe ? { ...dt, ...ce } : dt);
    }
    function Ae(ve) {
      if (!se) return;
      const Le = se;
      se = null, xn();
      const He = De(Le);
      at && (at = !1, St());
      const Ke = Le.kind === "place" || Le.kind === "move" || Le.kind === "resize";
      if (k && (k = !1, Ke || w()), !He) {
        xe.value = null, (Le.kind === "move" || Le.kind === "resize") && S();
        return;
      }
      if (Le.kind === "place" && c.value && Be.value) {
        const xt = ot(ve, He), Qe = v.value.find((dt) => dt.id === Be.value), qe = Math.abs(xt.x - Le.start.x) > 0.01 || Math.abs(xt.y - Le.start.y) > 0.01 ? df(Le.start, xt) : { x: xt.x - ((Qe == null ? void 0 : Qe.w) ?? 0.2) / 2, y: xt.y - ((Qe == null ? void 0 : Qe.h) ?? 0.05) / 2, w: (Qe == null ? void 0 : Qe.w) ?? 0.2, h: (Qe == null ? void 0 : Qe.h) ?? 0.05 };
        ge(Le.page, qe), xe.value = null;
        return;
      }
      if (Le.kind === "place" && Ie.value) {
        const xt = ot(ve, He), Qe = Math.abs(xt.x - Le.start.x) > 0.01 || Math.abs(xt.y - Le.start.y) > 0.01, ce = Ie.value, qe = Qe ? b1(v.value, ce, Le.page, df(Le.start, xt), df(Le.start, xt), Pe()) : b1(v.value, ce, Le.page, { x: xt.x - hp[ce].w / 2, y: xt.y - hp[ce].h / 2 }, void 0, Pe());
        v.value = [...v.value, { ...qe, label: D(ce) }], ht.value = qe.id, xe.value = null, S();
        return;
      }
      if (xe.value = null, Le.kind === "move" || Le.kind === "resize") {
        const xt = v.value.find((ce) => ce.id === Le.id), Qe = Le.orig;
        (!xt || !Qe || xt.x !== Qe.x || xt.y !== Qe.y || xt.w !== Qe.w || xt.h !== Qe.h) && S();
      }
    }
    function Pe() {
      return p.value.length === 1 ? p.value[0].id : void 0;
    }
    const _t = $(!1);
    function Et() {
      _t.value = !0, window.addEventListener("pointermove", _e), window.addEventListener("pointerup", Ae), window.addEventListener("pointercancel", Ae);
    }
    function xn() {
      _t.value = !1, window.removeEventListener("pointermove", _e), window.removeEventListener("pointerup", Ae), window.removeEventListener("pointercancel", Ae);
    }
    const Dt = E(() => v.value.find((ve) => ve.id === ht.value) ?? null), bn = $(1);
    function un() {
      if (!Dt.value) return;
      const ve = v.value.length;
      v.value = V8(v.value, ht.value, bn.value), v.value.length !== ve && (ht.value = v.value[v.value.length - 1].id, S());
    }
    function Jt() {
      const ve = W.value, Le = Dt.value;
      if (!ve || !Le || se || !fy(Le)) return;
      const He = ue.get(Le.page);
      if (!He) return;
      const Ke = He.getBoundingClientRect(), xt = ve.getBoundingClientRect();
      if (!Ke.height || !xt.height) return;
      const Qe = Ke.top - xt.top + ve.scrollTop + Le.y * Ke.height, ce = Qe + Le.h * Ke.height, qe = 24;
      Qe < ve.scrollTop + qe ? ve.scrollTop = Math.max(0, Qe - qe) : ce > ve.scrollTop + ve.clientHeight - qe && (ve.scrollTop = ce - ve.clientHeight + qe);
    }
    Je(ht, () => void Gt(Jt));
    const Ln = $("");
    function Vn(ve, Le) {
      v.value = K8(v.value, ve, Le), S();
    }
    function Ft(ve) {
      if (!(o.value || n.disabled || !z(ve)))
        switch (ve.type) {
          case "signature":
          case "initials":
            Ln.value = Ln.value === ve.id ? "" : ve.id;
            break;
          case "checkbox":
            Vn(ve.id, ve.value !== !0);
            break;
          case "date":
            Vn(ve.id, py(ve) ? "" : j8());
            break;
        }
    }
    function na(ve, Le) {
      const He = Le.target, Ke = T8(He.value, mn(ve));
      Ke !== He.value && (He.value = Ke), Vn(ve.id, Ke);
    }
    const Kt = E(() => v.value.find((ve) => ve.id === Ln.value) ?? null), bt = E(() => {
      var ve;
      return ((ve = Kt.value) == null ? void 0 : ve.style) === "typed" ? ["type"] : ["draw", "upload"];
    }), Dn = E(
      () => {
        var ve;
        return ((ve = Kt.value) == null ? void 0 : ve.style) === "typed" && Kt.value.font ? [Kt.value.font] : void 0;
      }
    ), In = E(() => {
      var Le;
      const ve = (Le = Kt.value) == null ? void 0 : Le.value;
      return typeof ve == "string" && ve ? { png_b64: ve, mode: "draw" } : null;
    });
    function Cn(ve) {
      Kt.value && Vn(Kt.value.id, (ve == null ? void 0 : ve.png_b64) ?? "");
    }
    function fn(ve) {
      return typeof ve.value == "string" && ve.value ? `data:image/png;base64,${ve.value}` : "";
    }
    function mn(ve) {
      return ve.type === "text" ? ve.rule ?? null : null;
    }
    function aa(ve) {
      const Le = mn(ve);
      if (!Le) return "";
      const He = [];
      return Le.kind === "number" ? He.push(i("plugin.pdf.rule_number")) : Le.kind === "email" && He.push(i("plugin.pdf.rule_email")), Le.min && Le.max ? He.push(i("plugin.pdf.rule_length", { min: Le.min, max: Le.max })) : Le.min ? He.push(i("plugin.pdf.rule_min", { min: Le.min })) : Le.max && He.push(i("plugin.pdf.rule_max", { max: Le.max })), He.join(" · ");
    }
    function zn(ve) {
      const Le = mn(ve), He = A8(ve.value, Le);
      return !He || !Le ? "" : He === "min" ? i("plugin.pdf.err_min", { min: Le.min ?? 0 }) : He === "max" ? i("plugin.pdf.err_max", { max: Le.max ?? 0 }) : i(`plugin.pdf.err_${He}`);
    }
    function Mn(ve) {
      return s$(ve.font).className;
    }
    const rn = zt("check");
    return (ve, Le) => (f(), h("div", {
      class: Re(["fe-spdf", {
        "is-edit": o.value,
        "is-fill": !o.value,
        "is-invalid": e.invalid,
        "is-disabled": e.disabled,
        "is-placing": !!Ie.value || !!Be.value,
        "is-define": l.value,
        "fe-spdf--page": H.value && !l.value
      }]),
      "data-testid": "surface-pdf-fields",
      style: Wt(H.value ? { "--spdf-h": e.pageHeight || "100%" } : void 0),
      "data-state": q.value,
      "data-layout": H.value ? "page" : "inline"
    }, [
      l.value ? O("", !0) : (f(), h("div", I6, [
        c.value ? (f(), h("div", {
          key: 0,
          class: "fe-spdf__palette",
          role: "toolbar",
          "aria-label": u(i)("plugin.pdf.pending")
        }, [
          (f(!0), h(Te, null, nt(je.value, (He) => (f(), h("button", {
            key: He.id,
            type: "button",
            class: Re(["fe-btn fe-btn--sm", { "fe-btn--primary": Be.value === He.id }]),
            style: Wt({ "--spdf-color": T(He) }),
            disabled: e.disabled || q.value !== "ok",
            "aria-pressed": Be.value === He.id ? "true" : "false",
            "data-testid": `surface-pdf-pending-${He.id}`,
            onClick: (Ke) => ie(He.id)
          }, y(ye(He)), 15, B6))), 128)),
          je.value.length ? O("", !0) : (f(), h("span", F6, y(u(i)("plugin.pdf.all_placed")), 1))
        ], 8, N6)) : o.value ? (f(), h("div", {
          key: 1,
          class: "fe-spdf__palette",
          role: "toolbar",
          "aria-label": u(i)("plugin.pdf.palette")
        }, [
          (f(!0), h(Te, null, nt(m.value, (He) => (f(), h("button", {
            key: He,
            type: "button",
            class: Re(["fe-btn fe-btn--sm", { "fe-btn--primary": Ie.value === He }]),
            disabled: e.disabled || q.value !== "ok",
            "aria-pressed": Ie.value === He ? "true" : "false",
            "data-testid": `surface-pdf-type-${He}`,
            onClick: (Ke) => ft(He)
          }, y(D(He)), 11, H6))), 128))
        ], 8, U6)) : O("", !0),
        d("div", K6, [
          d("button", {
            type: "button",
            class: "fe-btn fe-btn--sm",
            "aria-label": u(i)("plugin.pdf.zoom_out"),
            disabled: q.value !== "ok",
            onClick: Ue
          }, "−", 8, V6),
          d("button", {
            type: "button",
            class: "fe-btn fe-btn--sm fe-spdf__zoomval",
            "aria-label": u(i)(H.value ? "plugin.pdf.zoom_fit_page" : "plugin.pdf.zoom_fit"),
            disabled: q.value !== "ok",
            onClick: We
          }, y(Math.round(R.value * 100)) + "% ", 9, j6),
          d("button", {
            type: "button",
            class: "fe-btn fe-btn--sm",
            "aria-label": u(i)("plugin.pdf.zoom_in"),
            disabled: q.value !== "ok",
            onClick: ze
          }, "+", 8, q6)
        ])
      ])),
      o.value && !l.value && !c.value && Ie.value ? (f(), h("p", W6, y(u(i)("plugin.pdf.place_hint", { type: D(Ie.value) })), 1)) : O("", !0),
      l.value ? (f(), h("div", Y6, [
        v.value.length ? O("", !0) : (f(), h("div", G6, y(u(i)("plugin.pdf.no_boxes")), 1)),
        (f(!0), h(Te, null, nt(v.value, (He, Ke) => (f(), h("div", {
          key: He.id,
          class: "fe-spdf__card",
          style: Wt(A(He)),
          "data-testid": `surface-pdf-card-${He.id}`
        }, [
          d("span", J6, y(Ke + 1), 1),
          Ze(A1, {
            field: He,
            signers: p.value,
            formats: e.formats,
            "date-labels": e.dateLabels,
            "stamp-lines": e.stampLines,
            locale: e.locale,
            disabled: e.disabled,
            "testid-prefix": `surface-pdf-card-${He.id}`,
            onPatch: Ut,
            onRemove: (xt) => Xe(He.id)
          }, null, 8, ["field", "signers", "formats", "date-labels", "stamp-lines", "locale", "disabled", "testid-prefix", "onRemove"])
        ], 12, X6))), 128)),
        d("div", {
          class: "fe-spdf__add",
          role: "toolbar",
          "aria-label": u(i)("plugin.pdf.add_box")
        }, [
          d("span", Q6, y(u(i)("plugin.pdf.add_box")), 1),
          (f(!0), h(Te, null, nt(m.value, (He) => (f(), h("button", {
            key: He,
            type: "button",
            class: "fe-btn fe-btn--sm",
            disabled: e.disabled,
            "data-testid": `surface-pdf-add-${He}`,
            onClick: (Ke) => gt(He)
          }, " + " + y(D(He)), 9, eF))), 128))
        ], 8, Z6)
      ])) : c.value ? (f(), h("div", tF, [
        Dt.value ? (f(), h("div", nF, [
          d("span", {
            class: "fe-spdf__propname",
            style: Wt({ "--spdf-color": T(Dt.value) })
          }, y(U(Dt.value)), 5),
          L(Dt.value.assignee) ? (f(), h("span", aF, y(L(Dt.value.assignee)), 1)) : O("", !0),
          d("button", {
            type: "button",
            class: "fe-btn fe-btn--sm",
            "data-testid": "surface-pdf-unplace",
            onClick: G
          }, y(u(i)("plugin.pdf.unplace")), 1),
          P.value.length > 1 ? (f(), h("label", iF, [
            d("span", null, y(u(i)("plugin.pdf.copy_to_page")), 1),
            ln(d("input", {
              "onUpdate:modelValue": Le[0] || (Le[0] = (He) => bn.value = He),
              class: "fe-cfield__input fe-spdf__num",
              type: "number",
              min: "1",
              max: P.value.length,
              "data-testid": "surface-pdf-copy-page"
            }, null, 8, oF), [
              [
                _n,
                bn.value,
                void 0,
                { number: !0 }
              ]
            ]),
            d("button", {
              type: "button",
              class: "fe-btn fe-btn--sm",
              "data-testid": "surface-pdf-copy",
              onClick: un
            }, y(u(i)("plugin.pdf.copy")), 1)
          ])) : O("", !0),
          d("button", {
            type: "button",
            class: "fe-btn fe-btn--sm fe-btn--danger",
            "data-testid": "surface-pdf-delete",
            onClick: Le[1] || (Le[1] = (He) => Xe(Dt.value.id))
          }, y(u(i)("plugin.pdf.delete")), 1)
        ])) : Be.value ? (f(), h("p", rF, y(u(i)("plugin.pdf.place_box_hint", { name: ye(v.value.find((He) => He.id === Be.value) ?? v.value[0]) })), 1)) : (f(), h("p", sF, y(u(i)(je.value.length ? "plugin.pdf.place_idle" : "plugin.pdf.place_idle_done")), 1))
      ])) : o.value && Dt.value && !_t.value ? (f(), h("div", lF, [
        Ze(A1, {
          field: Dt.value,
          signers: p.value,
          formats: e.formats,
          "date-labels": e.dateLabels,
          "stamp-lines": e.stampLines,
          locale: e.locale,
          disabled: e.disabled,
          "testid-prefix": "surface-pdf",
          onPatch: Ut,
          onRemove: Le[3] || (Le[3] = (He) => Xe(Dt.value.id))
        }, {
          extra: mt(() => [
            P.value.length > 1 ? (f(), h("label", uF, [
              d("span", null, y(u(i)("plugin.pdf.copy_to_page")), 1),
              ln(d("input", {
                "onUpdate:modelValue": Le[2] || (Le[2] = (He) => bn.value = He),
                class: "fe-cfield__input fe-spdf__num",
                type: "number",
                min: "1",
                max: P.value.length,
                "data-testid": "surface-pdf-copy-page"
              }, null, 8, cF), [
                [
                  _n,
                  bn.value,
                  void 0,
                  { number: !0 }
                ]
              ]),
              d("button", {
                type: "button",
                class: "fe-btn fe-btn--sm",
                "data-testid": "surface-pdf-copy",
                onClick: un
              }, y(u(i)("plugin.pdf.copy")), 1)
            ])) : O("", !0)
          ]),
          _: 1
        }, 8, ["field", "signers", "formats", "date-labels", "stamp-lines", "locale", "disabled"])
      ])) : O("", !0),
      l.value ? O("", !0) : (f(), h("div", {
        key: 5,
        ref_key: "containerEl",
        ref: W,
        class: "fe-spdf__scroll"
      }, [
        q.value === "loading" ? (f(), h("p", dF, y(u(i)("plugin.view.loading")), 1)) : q.value === "error" ? (f(), h("p", fF, y(u(i)("plugin.pdf.load_failed")), 1)) : (f(), h("div", pF, [
          (f(!0), h(Te, null, nt(P.value, (He) => (f(), h("div", {
            key: He.num,
            ref_for: !0,
            ref: (Ke) => B(He.num, Ke),
            class: "fe-spdf__page",
            "data-page": He.num,
            style: Wt({ width: `${Q.value}px`, aspectRatio: `${He.width} / ${He.height}` }),
            onPointerdown: (Ke) => te(Ke, He.num)
          }, [
            (f(!0), h(Te, null, nt(C.value.get(He.num) ?? [], (Ke) => (f(), h("div", {
              key: Ke.id,
              class: Re(["fe-spdf__field", [
                `fe-spdf__field--${Ke.type}`,
                {
                  "is-selected": o.value && ht.value === Ke.id,
                  "is-mine": z(Ke),
                  "is-foreign": !o.value && !z(Ke),
                  "is-filled": u(py)(Ke),
                  "is-required": Ke.required === !0
                }
              ]]),
              style: Wt({ left: `${Ke.x * 100}%`, top: `${Ke.y * 100}%`, width: `${Ke.w * 100}%`, height: `${Ke.h * 100}%`, "--spdf-color": T(Ke) }),
              "data-testid": `surface-pdf-field-${Ke.id}`,
              "data-field-type": Ke.type,
              role: z(Ke) ? "button" : void 0,
              tabindex: z(Ke) ? 0 : void 0,
              title: o.value || !z(Ke) ? L(Ke.assignee) : void 0,
              onPointerdown: (xt) => Ce(xt, Ke, He.num),
              onClick: (xt) => Ft(Ke),
              onKeydown: Ca(yt((xt) => Ft(Ke), ["prevent"]), ["enter"])
            }, [
              (Ke.type === "signature" || Ke.type === "initials") && fn(Ke) ? (f(), h("img", {
                key: 0,
                class: "fe-spdf__sig",
                src: fn(Ke),
                alt: ""
              }, null, 8, vF)) : Ke.type === "text" && z(Ke) ? (f(), h("input", {
                key: 1,
                class: Re(["fe-spdf__text", Mn(Ke)]),
                type: "text",
                value: typeof Ke.value == "string" ? Ke.value : "",
                placeholder: U(Ke),
                "aria-label": U(Ke),
                inputmode: u($8)(mn(Ke)),
                maxlength: u(l$)(mn(Ke)),
                "aria-invalid": zn(Ke) ? "true" : void 0,
                "aria-describedby": aa(Ke) ? `${e.id}-${Ke.id}-rule` : void 0,
                title: aa(Ke) || void 0,
                disabled: e.disabled,
                "data-testid": `surface-pdf-text-${Ke.id}`,
                onPointerdown: Le[4] || (Le[4] = yt(() => {
                }, ["stop"])),
                onClick: Le[5] || (Le[5] = yt(() => {
                }, ["stop"])),
                onInput: (xt) => na(Ke, xt)
              }, null, 42, yF)) : Ke.type === "checkbox" && Ke.value === !0 ? (f(), h("span", {
                key: 2,
                class: "fe-spdf__check",
                "aria-hidden": "true",
                innerHTML: u(rn)
              }, null, 8, gF)) : Ke.type === "date" && typeof Ke.value == "string" && Ke.value ? (f(), h("span", {
                key: 3,
                class: Re(["fe-spdf__val", Mn(Ke)])
              }, y(Ke.value), 3)) : (f(), h("span", bF, [
                Ht(y(U(Ke)) + " ", 1),
                z(Ke) ? (f(), h("small", kF, y(u(i)(`plugin.pdf.tap_${Ke.type}`)), 1)) : Ke.assignee && (o.value || !z(Ke)) ? (f(), h("small", wF, y(L(Ke.assignee)), 1)) : O("", !0)
              ])),
              !o.value && z(Ke) && Ke.type === "text" && (zn(Ke) || aa(Ke)) ? (f(), h("span", {
                key: 5,
                id: `${e.id}-${Ke.id}-rule`,
                class: Re(["fe-spdf__rule", { "is-bad": !!zn(Ke) }]),
                role: zn(Ke) ? "alert" : void 0,
                "data-testid": `surface-pdf-rule-${Ke.id}`
              }, y(zn(Ke) || aa(Ke)), 11, _F)) : O("", !0),
              o.value ? (f(), h("span", {
                key: 6,
                class: "fe-spdf__handle",
                "data-testid": "surface-pdf-handle",
                onPointerdown: (xt) => Ne(xt, Ke, He.num)
              }, null, 40, xF)) : O("", !0)
            ], 46, mF))), 128)),
            xe.value && xe.value.page === He.num ? (f(), h("div", {
              key: 0,
              class: "fe-spdf__field fe-spdf__field--ghost",
              style: Wt({ left: `${xe.value.x * 100}%`, top: `${xe.value.y * 100}%`, width: `${xe.value.w * 100}%`, height: `${xe.value.h * 100}%` })
            }, null, 4)) : O("", !0)
          ], 44, hF))), 128))
        ]))
      ], 512)),
      !o.value && Kt.value ? (f(), h("div", SF, [
        d("p", $F, y(u(i)("plugin.pdf.pad_for", { type: U(Kt.value) })), 1),
        Ze(T$, {
          id: `${e.id}-${Kt.value.id}`,
          "model-value": In.value,
          modes: bt.value,
          font: Kt.value.font,
          fonts: Dn.value,
          locale: e.locale,
          disabled: e.disabled,
          width: Kt.value.type === "initials" ? 240 : void 0,
          height: Kt.value.type === "initials" ? 120 : void 0,
          "onUpdate:modelValue": Cn
        }, null, 8, ["id", "model-value", "modes", "font", "fonts", "locale", "disabled", "width", "height"]),
        d("button", {
          type: "button",
          class: "fe-btn fe-btn--sm",
          "data-testid": "surface-pdf-pad-done",
          onClick: Le[6] || (Le[6] = (He) => Ln.value = "")
        }, y(u(i)("plugin.pdf.pad_done")), 1)
      ])) : O("", !0)
    ], 14, R6));
  }
}), AF = { class: "fe-surface" }, EF = ["data-node"], CF = {
  key: 1,
  class: "fe-surface__divider"
}, zF = {
  key: 2,
  class: "fe-surface__row"
}, MF = ["data-node-type"], PF = {
  key: 14,
  class: "fe-surface__error"
}, OF = /* @__PURE__ */ lt({
  __name: "SurfaceRenderer",
  props: {
    nodes: {},
    locale: {},
    theme: {},
    errors: {},
    values: {},
    api: {},
    plugin: {},
    storages: {},
    startAt: {},
    disabled: { type: Boolean },
    fileUrl: { type: Function },
    pdfWorkerUrl: {},
    invalidKeys: {},
    layout: {},
    pageHeight: {}
  },
  emits: ["update:values", "change", "action"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = pt(() => n.locale), o = () => n.values ?? {};
    function l(b, C) {
      a("update:values", { ...o(), [b]: C });
    }
    function c(b) {
      a("update:values", b), a("change");
    }
    function p(b, C) {
      l(b.id, C), m(b).mode !== "fill" && a("change");
    }
    function m(b) {
      return b.props ?? {};
    }
    function v(b) {
      const C = m(b);
      return Xt(C.text ?? C.value ?? "", n.locale);
    }
    function x(b) {
      const C = String(m(b).tone ?? "");
      return C === "muted" || C === "danger" || C === "info" ? `fe-surface__text--${C}` : "";
    }
    function w(b) {
      return !b.id || !n.errors ? "" : Xt(n.errors[b.id], n.locale);
    }
    function S(b) {
      return typeof b == "string" ? b : "";
    }
    function k(b) {
      return Array.isArray(b) ? b : [];
    }
    return (b, C) => {
      const T = JM("SurfaceRenderer", !0);
      return f(), h("div", AF, [
        (f(!0), h(Te, null, nt(e.nodes, (A, L) => (f(), h(Te, {
          key: A.id || L
        }, [
          A.type === "text" ? (f(), h("p", {
            key: 0,
            class: Re(["fe-surface__text", [x(A), m(A).heading ? "fe-surface__text--heading" : ""]]),
            "data-node": A.id || void 0
          }, y(v(A)), 11, EF)) : A.type === "divider" ? (f(), h("hr", CF)) : A.type === "row" ? (f(), h("div", zF, [
            Ze(T, {
              nodes: A.children ?? [],
              locale: e.locale,
              theme: e.theme,
              errors: e.errors,
              values: e.values,
              api: e.api,
              plugin: e.plugin,
              storages: e.storages,
              "start-at": e.startAt,
              disabled: e.disabled,
              "file-url": e.fileUrl,
              "pdf-worker-url": e.pdfWorkerUrl,
              "invalid-keys": e.invalidKeys,
              layout: e.layout,
              "page-height": e.pageHeight,
              "onUpdate:values": C[0] || (C[0] = (z) => a("update:values", z)),
              onChange: C[1] || (C[1] = (z) => a("change")),
              onAction: C[2] || (C[2] = (z) => a("action", z))
            }, null, 8, ["nodes", "locale", "theme", "errors", "values", "api", "plugin", "storages", "start-at", "disabled", "file-url", "pdf-worker-url", "invalid-keys", "layout", "page-height"])
          ])) : A.type === "form" ? (f(), Ge(VR, {
            key: 3,
            fields: m(A).fields ?? [],
            values: o(),
            locale: e.locale,
            errors: e.errors,
            invalid: e.invalidKeys,
            disabled: e.disabled,
            "onUpdate:values": c
          }, null, 8, ["fields", "values", "locale", "errors", "invalid", "disabled"])) : A.type === "steps" ? (f(), Ge(XR, {
            key: 4,
            items: m(A).items ?? [],
            locale: e.locale
          }, null, 8, ["items", "locale"])) : A.type === "list" ? (f(), Ge(iN, {
            key: 5,
            columns: m(A).columns ?? [],
            rows: m(A).rows ?? [],
            empty: m(A).empty,
            locale: e.locale,
            disabled: e.disabled,
            "table-id": e.plugin ? `app.${e.plugin}.${A.id || "list"}` : void 0,
            onAction: C[3] || (C[3] = (z) => a("action", z))
          }, null, 8, ["columns", "rows", "empty", "locale", "disabled", "table-id"])) : A.type === "progress" ? (f(), Ge(cN, {
            key: 6,
            value: m(A).value,
            label: m(A).label,
            locale: e.locale
          }, null, 8, ["value", "label", "locale"])) : A.type === "people-picker" && A.id ? (f(), Ge(zN, {
            key: 7,
            id: A.id,
            "model-value": k(o()[A.id]),
            multi: m(A).multi === !0,
            "allow-external": m(A).allow_external === !0,
            api: e.api,
            plugin: e.plugin,
            locale: e.locale,
            disabled: e.disabled,
            invalid: !!w(A),
            "onUpdate:modelValue": (z) => l(A.id, z)
          }, null, 8, ["id", "model-value", "multi", "allow-external", "api", "plugin", "locale", "disabled", "invalid", "onUpdate:modelValue"])) : A.type === "pin-input" && A.id ? (f(), Ge(LN, {
            key: 8,
            id: A.id,
            length: m(A).length,
            "model-value": S(o()[A.id]),
            locale: e.locale,
            disabled: e.disabled,
            invalid: !!w(A),
            "onUpdate:modelValue": (z) => l(A.id, z)
          }, null, 8, ["id", "length", "model-value", "locale", "disabled", "invalid", "onUpdate:modelValue"])) : A.type === "file-chooser" && A.id ? (f(), Ge(bB, {
            key: 9,
            id: A.id,
            kind: m(A).kind,
            "model-value": S(o()[A.id]),
            api: e.api,
            storages: e.storages,
            "start-at": e.startAt,
            locale: e.locale,
            theme: e.theme,
            disabled: e.disabled,
            invalid: !!w(A),
            "onUpdate:modelValue": (z) => l(A.id, z)
          }, null, 8, ["id", "kind", "model-value", "api", "storages", "start-at", "locale", "theme", "disabled", "invalid", "onUpdate:modelValue"])) : A.type === "preview" ? (f(), Ge(CB, {
            key: 10,
            path: S(m(A).path),
            "file-ref": S(m(A).ref),
            "file-url": e.fileUrl,
            api: e.api,
            locale: e.locale
          }, null, 8, ["path", "file-ref", "file-url", "api", "locale"])) : A.type === "signature-pad" && A.id ? (f(), Ge(T$, {
            key: 11,
            id: A.id,
            modes: m(A).modes,
            width: m(A).width,
            height: m(A).height,
            font: m(A).font,
            fonts: m(A).fonts,
            label: u(Xt)(m(A).label ?? "", e.locale),
            required: m(A).required === !0,
            "model-value": u(ju)(o()[A.id]) ? o()[A.id] : null,
            locale: e.locale,
            disabled: e.disabled,
            invalid: !!w(A),
            "onUpdate:modelValue": (z) => l(A.id, z)
          }, null, 8, ["id", "modes", "width", "height", "font", "fonts", "label", "required", "model-value", "locale", "disabled", "invalid", "onUpdate:modelValue"])) : A.type === "pdf-fields" && A.id ? (f(), Ge(TF, {
            key: 12,
            id: A.id,
            src: m(A).src,
            mode: m(A).mode,
            fields: m(A).fields,
            layout: e.layout,
            "page-height": e.pageHeight,
            signers: m(A).signers,
            signer: m(A).signer,
            types: m(A).types,
            formats: m(A).formats,
            "date-labels": m(A).date_labels,
            "stamp-lines": m(A).stamp_lines,
            "model-value": o()[A.id],
            api: e.api,
            "file-url": e.fileUrl,
            "pdf-worker-url": e.pdfWorkerUrl,
            locale: e.locale,
            theme: e.theme,
            disabled: e.disabled,
            invalid: !!w(A),
            "onUpdate:modelValue": (z) => p(A, z)
          }, null, 8, ["id", "src", "mode", "fields", "layout", "page-height", "signers", "signer", "types", "formats", "date-labels", "stamp-lines", "model-value", "api", "file-url", "pdf-worker-url", "locale", "theme", "disabled", "invalid", "onUpdate:modelValue"])) : (f(), h("p", {
            key: 13,
            class: "fe-surface__unknown",
            "data-node-type": A.type
          }, y(u(i)("plugin.view.unsupported", { type: A.type })), 9, MF)),
          w(A) && A.type !== "form" ? (f(), h("p", PF, y(w(A)), 1)) : O("", !0)
        ], 64))), 128))
      ]);
    };
  }
}), LF = {
  key: 1,
  class: "fe-surface__text fe-surface__text--info",
  role: "status"
}, DF = {
  key: 2,
  class: "fe-surface__text fe-surface__text--muted"
}, RF = {
  key: 3,
  class: "fe-surface__error",
  role: "alert"
}, Xp = /* @__PURE__ */ lt({
  __name: "SurfaceConversation",
  props: {
    conv: {},
    locale: {},
    theme: {},
    api: {},
    plugin: {},
    storages: {},
    startAt: {},
    fileUrl: { type: Function },
    toast: {},
    layout: {},
    pageHeight: {}
  },
  setup(e) {
    const t = e, { t: n } = pt(() => t.locale);
    return (a, i) => (f(), h(Te, null, [
      e.conv.current.value ? (f(), Ge(OF, {
        key: 0,
        nodes: e.conv.current.value.nodes ?? [],
        locale: e.locale,
        theme: e.theme,
        errors: e.conv.errors.value,
        values: e.conv.values.value,
        api: e.api,
        plugin: e.plugin,
        storages: e.storages,
        "start-at": e.startAt,
        "file-url": e.fileUrl,
        layout: e.layout,
        "page-height": e.pageHeight,
        "invalid-keys": e.conv.invalidKeys.value,
        disabled: e.conv.busy.value,
        "onUpdate:values": e.conv.updateValues,
        onChange: e.conv.scheduleChange,
        onAction: e.conv.rowAction
      }, null, 8, ["nodes", "locale", "theme", "errors", "values", "api", "plugin", "storages", "start-at", "file-url", "layout", "page-height", "invalid-keys", "disabled", "onUpdate:values", "onChange", "onAction"])) : O("", !0),
      e.toast ? (f(), h("p", LF, y(e.toast), 1)) : O("", !0),
      e.conv.busy.value ? (f(), h("p", DF, y(u(n)("plugin.view.busy")), 1)) : O("", !0),
      e.conv.failure.value ? (f(), h("p", RF, y(e.conv.failure.value), 1)) : O("", !0)
    ], 64));
  }
});
function IF(e) {
  let t = !1;
  return Gc(e, (n) => {
    n.type === "steps" && (t = !0);
  }), t;
}
const NF = /* @__PURE__ */ new Set(["back", "prev", "previous", "stepback", "goback", "prevstep", "previousstep"]);
function BF(e) {
  const t = String((e == null ? void 0 : e.id) ?? "").toLowerCase().replace(/[^a-z]/g, "");
  return NF.has(t);
}
function FF(e, t) {
  const n = (e ?? []).filter((l) => l && l.id);
  if (!t)
    return { back: null, others: n, primary: null };
  const a = n.find(BF) ?? null, i = n.filter((l) => l !== a), o = i.find((l) => l.primary === !0) ?? null;
  return { back: a, others: i.filter((l) => l !== o), primary: o };
}
const UF = ["disabled", "data-testid", "onClick"], Jp = /* @__PURE__ */ lt({
  __name: "SurfaceFooterButtons",
  props: {
    conv: {},
    locale: {},
    testidPrefix: {},
    small: { type: Boolean }
  },
  setup(e) {
    const t = e, n = E(() => {
      var l;
      return IF((l = t.conv.current.value) == null ? void 0 : l.nodes);
    }), a = E(() => FF(t.conv.footer.value, n.value)), i = E(() => {
      const l = a.value;
      return [...l.back ? [l.back] : [], ...l.others, ...l.primary ? [l.primary] : []];
    });
    function o(l) {
      return n.value ? l === a.value.primary : l.primary === !0;
    }
    return (l, c) => (f(!0), h(Te, null, nt(i.value, (p) => (f(), h("button", {
      key: p.id,
      type: "button",
      class: Re(["fe-btn", {
        "fe-btn--sm": e.small,
        "fe-btn--primary": o(p) && !p.danger,
        "fe-btn--danger": p.danger,
        "fe-surface__back": n.value && p === a.value.back
      }]),
      disabled: t.conv.busy.value || p.disabled,
      "data-testid": `${e.testidPrefix}-action-${p.id}`,
      onClick: (m) => t.conv.press(p)
    }, y(u(Xt)(p.label, e.locale)), 11, UF))), 128));
  }
}), z$ = 1, HF = "filex:hello", KF = "filex:port", VF = [
  "session.get",
  "file.read",
  "file.save",
  "file.saveAs",
  "ui.dirty",
  "ui.title",
  "ui.toast",
  "ui.confirm",
  "ui.close",
  "clipboard.write",
  "ui.download",
  "engine.call",
  "job.submit",
  "state.get",
  "state.set",
  "license.get",
  "ui.print",
  "coedit.join",
  "coedit.subscribe",
  "coedit.append",
  "coedit.lease",
  "coedit.cursor",
  "coedit.blob.put",
  "coedit.blob.get",
  "coedit.leave"
], ya = {
  /** `file.read({as: 'text'})` refuses a file larger than this; read a stream. */
  maxTextBytes: 32 << 20,
  /** One `state.set` value, as JSON. */
  maxStateBytes: 8192,
  /** A `ui.toast` / `ui.title` text, in characters. */
  maxLineChars: 300,
  /** How long the SDK waits for the host's port. */
  connectTimeoutMs: 1e4,
  /** The largest file `ui.download` hands the person (streamed or not). */
  maxDownloadBytes: 256 << 20,
  /**
   * The largest PDF `ui.print` prints (filex 0.55). Lower than a download:
   * a download can stream to disk, a print is held whole in the page (one
   * Blob) until the print dialog has read it, and a document worth printing
   * is far smaller.
   */
  maxPrintBytes: 64 << 20,
  /**
   * The largest file of an encrypted folder filex hands an app in the clear
   * or takes back from it (filex 0.56, `FileInfo.plaintext`): it is
   * decrypted and encrypted whole in the page, as filex's own explorer does
   * for a file of this size.
   */
  maxEncryptedBytes: 200 << 20
};
function jF(e) {
  return !!e && typeof e == "object" && e.type === HF && typeof e.v == "number";
}
function qF(e) {
  return !!e && typeof e == "object" && typeof e.id == "number" && typeof e.method == "string";
}
function WF(e) {
  return VF.includes(e);
}
const tv = { inFlight: 32, perWindow: 400, windowMs: 1e4 };
class ct extends Error {
  constructor(n, a) {
    super(a || n);
    It(this, "code");
    this.name = "BridgeFailure", this.code = n;
  }
}
function YF(e) {
  if (!e || typeof e != "object") return [];
  const t = [];
  for (const n of Object.values(e))
    (n instanceof ArrayBuffer || typeof ReadableStream < "u" && n instanceof ReadableStream) && t.push(n);
  return t;
}
const GF = /^[a-z][a-z0-9_]{0,39}$/;
function XF(e) {
  if (e instanceof ct) return { code: e.code, message: e.message };
  const t = e ?? {}, n = typeof t.status == "number" ? t.status : 0, a = typeof t.code == "string" && GF.test(t.code) ? t.code : "";
  let i = "failed";
  return n === 404 ? i = "not_found" : n === 413 ? i = "too_large" : n === 400 || n === 422 ? i = "invalid" : n === 409 && a === "read_only" ? i = "read_only" : n === 403 && a === "not_granted" && (i = "not_granted"), { code: i, message: a || i };
}
function JF(e) {
  const t = e.win ?? window;
  let n = null, a = !1, i = 0, o = !1, l = 0;
  const c = /* @__PURE__ */ new Map();
  function p(C) {
    var T;
    if (n) {
      n.onmessage = null;
      try {
        n.close();
      } catch {
      }
      n = null;
      for (const [, A] of c)
        clearTimeout(A.timer), A.reject(new ct("unavailable", "the interface went away"));
      c.clear(), (T = e.onDisconnect) == null || T.call(e, C);
    }
  }
  let m = 0, v = 0, x = 0;
  function w() {
    const C = Date.now();
    return C - v >= tv.windowMs && (v = C, x = 0), x >= tv.perWindow ? !1 : (x++, !0);
  }
  async function S(C, T, A, L) {
    let z, D = [];
    if (!w())
      z = { id: T, error: { code: "unavailable", message: "busy" } };
    else if (!WF(A))
      z = { id: T, error: { code: "unknown_method", message: A } };
    else {
      const U = e.handlers[A];
      if (!U)
        z = { id: T, error: { code: "unavailable", message: `${A} is not offered here` } };
      else if (m >= tv.inFlight)
        z = { id: T, error: { code: "unavailable", message: "busy" } };
      else {
        m++;
        try {
          const q = await U(L);
          z = { id: T, result: q }, D = YF(q);
        } catch (q) {
          z = { id: T, error: XF(q) };
        } finally {
          m--;
        }
      }
    }
    if (C === n)
      try {
        C.postMessage(z, D);
      } catch {
        C.postMessage({ id: T, error: { code: "failed", message: "the answer cannot be sent to the interface" } });
      }
  }
  function k(C) {
    return (T) => {
      const A = T.data;
      if (!(!A || typeof A != "object")) {
        if (typeof A.hid == "number") {
          const L = c.get(A.hid);
          if (!L) return;
          if (c.delete(A.hid), clearTimeout(L.timer), A.error) {
            const z = A.error;
            L.reject(new ct(z.code ?? "failed", z.message));
          } else L.resolve(A.result);
          return;
        }
        qF(A) && S(C, A.id, A.method, A.params);
      }
    };
  }
  function b(C) {
    var z, D;
    if (o || a) return;
    const T = e.frame(), A = T == null ? void 0 : T.contentWindow;
    if (!T || !A || C.source !== A || !jF(C.data) || i > 1) return;
    a = !0;
    const L = new MessageChannel();
    n = L.port1, n.onmessage = k(n), (z = n.start) == null || z.call(n), A.postMessage({ type: KF, v: z$ }, "*", [L.port2]), (D = e.onConnect) == null || D.call(e);
  }
  return t.addEventListener("message", b), {
    connected: () => n !== null,
    emit(C, T, A = []) {
      if (n)
        try {
          n.postMessage({ event: C, data: T }, A);
        } catch {
        }
    },
    ask(C, T, A = 6e4) {
      const L = n;
      if (!L) return Promise.reject(new ct("unavailable", "the interface is not connected"));
      const z = ++l;
      return new Promise((D, U) => {
        const q = setTimeout(() => {
          c.delete(z), U(new ct("failed", `the interface did not answer "${C}"`));
        }, A);
        c.set(z, { resolve: D, reject: U, timer: q }), L.postMessage({ hid: z, request: C, params: T });
      });
    },
    frameLoaded() {
      i++, i > 1 && p("reload");
    },
    destroy() {
      o = !0, t.removeEventListener("message", b), p("destroyed");
    }
  };
}
const ZF = [
  "theme",
  "palette",
  "density",
  "locale",
  "storageOrder",
  "tour",
  "appState",
  "appStateE2e",
  "appsSeen",
  "openWith",
  "remoteImages"
], QF = ["openWith"], vp = ["theme", "palette", "density", "locale", "storageOrder"], _c = {
  theme: "filex.theme",
  palette: "filex.palette",
  density: "filex.density",
  locale: "filex.locale",
  // New in 0.45.2 (#57); no earlier reader to stay compatible with.
  storageOrder: "filex.storageOrder"
}, M$ = 400, yy = "filex.session";
let Zp = !1;
function eU() {
  try {
    return localStorage.getItem(yy) === "1";
  } catch {
    return !1;
  }
}
function nr() {
  return Zp ? !1 : ai.sessionAware ? eU() : !0;
}
function tU(e) {
  try {
    e ? localStorage.setItem(yy, "1") : localStorage.removeItem(yy);
  } catch {
  }
  e && (Zp = !1);
}
function zhe() {
  Zp = !0;
}
const P$ = new Set(Object.values(_c));
function nU(e) {
  P$.add(e);
}
const O$ = /* @__PURE__ */ new Set();
function aU(e) {
  O$.add(e);
}
function Mhe() {
  tU(!1);
  for (const e of P$)
    try {
      localStorage.removeItem(e);
    } catch {
    }
  for (const e of O$)
    try {
      e();
    } catch {
    }
  Qa = {}, Qp = !1, Xr = {}, ra !== null && clearTimeout(ra), ra = null, Df();
}
let ai = { surface: "web" }, Qa = {}, Qp = !1, Bl = !1, Xc = !1;
const yp = /* @__PURE__ */ new Set(), xc = /* @__PURE__ */ new Set();
function iU(e) {
  ai = { ...e }, Bl = !0;
}
function Fl() {
  return Bl;
}
function oU() {
  return Xc;
}
function rU(e) {
  return Xc ? (e(), () => {
  }) : (xc.add(e), () => xc.delete(e));
}
function Df() {
  Xc = !0;
  const e = [...xc];
  xc.clear();
  for (const t of e)
    try {
      t();
    } catch {
    }
}
function Qi() {
  return { ...Qa };
}
function L$() {
  return Qp;
}
function Jc(e) {
  return yp.add(e), () => yp.delete(e);
}
function D$() {
  const e = Qi();
  for (const t of yp)
    try {
      t(e);
    } catch {
    }
}
function gp(e) {
  try {
    return localStorage.getItem(_c[e]) ?? "";
  } catch {
    return "";
  }
}
function Gr(e, t) {
  try {
    t ? localStorage.setItem(_c[e], t) : localStorage.removeItem(_c[e]);
  } catch {
  }
}
function sU() {
  const e = {};
  for (const t of vp) {
    const n = gp(t);
    n && (e[t] = n);
  }
  return e;
}
function R$() {
  return `${Yo(ai.base)}/api/me/prefs?surface=${encodeURIComponent(ai.surface)}`;
}
async function Ig(e) {
  const t = { Accept: "application/json" };
  e && (t["Content-Type"] = "application/json");
  const n = ai.headers ? await ai.headers() : {};
  return { ...t, ...n };
}
function lU(e) {
  const t = { Accept: "application/json" };
  t["Content-Type"] = "application/json";
  const n = ai.headers ? ai.headers() : {};
  return n && typeof n.then != "function" ? { ...t, ...n } : t;
}
function uU(e) {
  const t = e && typeof e == "object" ? e : {}, n = t.prefs && typeof t.prefs == "object" ? t.prefs : t, a = {};
  for (const i of ZF) {
    const o = n[i];
    typeof o == "string" && o && (a[i] = o);
  }
  return a;
}
async function cU() {
  if (!Bl)
    return Df(), null;
  const e = ai.fetchImpl ?? (typeof fetch == "function" ? fetch : null);
  if (!e)
    return Df(), null;
  Xc = !1;
  try {
    const t = await e(R$(), {
      method: "GET",
      headers: await Ig(!1),
      credentials: "same-origin",
      cache: "no-store"
    });
    if (!t.ok) return null;
    if (Qa = uU(await t.json()), Qp = !0, !Object.keys(Qa).length) {
      const n = sU();
      if (delete n.locale, Object.keys(n).length) {
        Qa = n;
        for (const a of vp) n[a] && (Xr[a] = n[a]);
        ra !== null && clearTimeout(ra), ra = setTimeout(() => {
          Pl = eh();
        }, M$);
      }
    }
    for (const n of vp)
      n === "locale" && !Qa[n] || Gr(n, Qa[n] ?? "");
    return D$(), Qi();
  } catch {
    return null;
  } finally {
    Df();
  }
}
let Xr = {}, ra = null, Pl = null;
async function eh(e = !1) {
  ra = null;
  const t = Xr;
  if (Xr = {}, !Object.keys(t).length || !Bl) return;
  const n = Qi();
  for (const l of QF) delete n[l];
  const a = { prefs: n }, i = ai.fetchImpl ?? (typeof fetch == "function" ? fetch : null);
  if (!i) return;
  const o = JSON.stringify(a);
  try {
    await i(R$(), {
      method: "PUT",
      headers: e ? lU(!0) : await Ig(!0),
      credentials: "same-origin",
      body: o,
      // ⚠ Sent while the page is going away: `keepalive` is what lets the
      // request outlive it. Browsers reject a keepalive body over 64 KB
      // outright, so the flag goes only on documents that fit.
      ...e && o.length < 6e4 ? { keepalive: !0 } : {}
    });
  } catch {
  }
}
function Zi(e, t) {
  Qa = { ...Qa, [e]: t }, vp.includes(e) && Gr(e, t), Xr = { ...Xr, [e]: t }, ra !== null && clearTimeout(ra), ra = setTimeout(() => {
    Pl = eh();
  }, M$);
}
function Ng(e, t) {
  Qa = { ...Qa, [e]: t }, D$();
}
async function I$(e, t) {
  if (!Bl) return null;
  const n = ai.fetchImpl ?? (typeof fetch == "function" ? fetch : null);
  if (!n) return null;
  try {
    return await n(`${Yo(ai.base)}${e}`, {
      method: t.method,
      headers: await Ig(t.body !== void 0),
      credentials: "same-origin",
      body: t.body
    });
  } catch {
    return null;
  }
}
async function dU() {
  ra !== null && (clearTimeout(ra), Pl = eh()), await Pl;
}
function E1() {
  ra !== null && (clearTimeout(ra), Pl = eh(!0));
}
typeof window < "u" && (window.addEventListener("pagehide", E1), document.addEventListener("visibilitychange", () => {
  document.visibilityState === "hidden" && E1();
}));
function Phe() {
  Qa = {}, Qp = !1, Zp = !1, Xr = {}, ra !== null && clearTimeout(ra), ra = null, Pl = null, yp.clear(), Xc = !1, xc.clear(), Bl = !1;
}
function N$() {
  return Pc("app_state_max_bytes");
}
const fU = new TextEncoder();
function B$(e) {
  return fU.encode(e).length;
}
function th(e) {
  const t = Qi()[e];
  if (!t) return {};
  try {
    const n = JSON.parse(t);
    return n && typeof n == "object" && !Array.isArray(n) ? n : {};
  } catch {
    return {};
  }
}
function pU(e, t) {
  const n = th("appState")[e];
  return n && Object.prototype.hasOwnProperty.call(n, t) ? n[t] : void 0;
}
class Sc extends Error {
}
function F$(e, t) {
  if (!e || e.length > 128 || e === "__proto__" || e === "constructor" || e === "prototype")
    throw new Sc("a state key is 1-128 characters");
  const n = t === void 0 ? void 0 : JSON.stringify(t);
  if (n !== void 0 && n.length > ya.maxStateBytes)
    throw new Sc(`a state value is at most ${ya.maxStateBytes} bytes as JSON`);
  return n;
}
function hU(e, t, n) {
  const a = F$(t, n), i = th("appState"), o = { ...i[e] ?? {} };
  a === void 0 ? delete o[t] : o[t] = JSON.parse(a);
  const l = N$();
  if (l !== void 0 && B$(JSON.stringify(o)) > l)
    throw new Sc(`an app keeps at most ${l} bytes`);
  const c = { ...i, [e]: o };
  Object.keys(o).length || delete c[e], Zi("appState", JSON.stringify(c));
}
function mU(e) {
  const t = th("appsSeen")[e];
  return typeof t == "string" ? t : "";
}
function C1(e, t) {
  const n = th("appsSeen");
  n[e] !== t && Zi("appsSeen", JSON.stringify({ ...n, [e]: t }));
}
const vU = 1e4, yU = 1500, gU = 15 * 6e4, bU = 600, kU = 4 << 20, U$ = "application/pdf", Jr = [37, 80, 68, 70, 45], wU = [
  "background-color",
  "color",
  "border-top-color",
  "border-right-color",
  "border-bottom-color",
  "border-left-color",
  "border-top-width",
  "border-right-width",
  "border-bottom-width",
  "border-left-width",
  "border-top-style",
  "border-right-style",
  "border-bottom-style",
  "border-left-style",
  "border-top-left-radius",
  "border-top-right-radius",
  "border-bottom-right-radius",
  "border-bottom-left-radius",
  "font-family",
  "font-size",
  "font-weight",
  "line-height",
  "letter-spacing",
  "padding-top",
  "padding-right",
  "padding-bottom",
  "padding-left"
];
function ac(e) {
  const t = e instanceof Uint8Array ? e : e instanceof ArrayBuffer ? new Uint8Array(e) : null;
  return !t || t.byteLength < Jr.length ? !1 : Jr.every((n, a) => t[a] === n);
}
class ua extends Error {
  constructor(n, a) {
    super(a || n);
    It(this, "code");
    this.name = "PrintFailure", this.code = n;
  }
}
function nv() {
  return new ua("invalid", "the data is not a PDF");
}
function _U(e, t) {
  const n = Math.min(Jr.length - e.byteLength, t.byteLength);
  if (n <= 0) return e;
  const a = new Uint8Array(e.byteLength + n);
  return a.set(e), a.set(t.subarray(0, n), e.byteLength), a;
}
async function xU(e, t) {
  const n = () => new ua("too_large", `at most ${Math.floor(t / 1048576)} MiB`);
  if (e instanceof ArrayBuffer) {
    if (e.byteLength > t) throw n();
    if (!ac(e)) throw nv();
    return new Blob([e], { type: U$ });
  }
  let a = null, i = [], o = 0, l = 0, c = new Uint8Array(0);
  for await (const p of e) {
    if (!(p instanceof Uint8Array)) throw new ua("invalid", "a PDF stream carries bytes (Uint8Array)");
    if (c.byteLength < Jr.length && (c = _U(c, p), c.byteLength >= Jr.length && !ac(c)))
      throw nv();
    if (l += p.byteLength, l > t) throw n();
    i.push(p), o += p.byteLength, o >= kU && (a = z1(a, i), i = [], o = 0);
  }
  if (!ac(c)) throw nv();
  return i.length || !a ? z1(a, i) : a;
}
function z1(e, t) {
  return new Blob(e ? [e, ...t] : t, { type: U$ });
}
function SU(e) {
  var i;
  const t = {}, n = (i = e == null ? void 0 : e.ownerDocument) == null ? void 0 : i.defaultView;
  if (!e || !n || typeof n.getComputedStyle != "function") return t;
  const a = n.getComputedStyle(e);
  for (const o of wU) {
    const l = a.getPropertyValue(o).trim();
    l && (t[o] = l);
  }
  return t;
}
async function $U(e) {
  if (typeof Blob > "u" || !(e instanceof Blob) || e.size < Jr.length) return !1;
  try {
    return ac(await e.slice(0, Jr.length).arrayBuffer());
  } catch {
    return !1;
  }
}
const M1 = "position:absolute;width:1px;height:1px;border:0;opacity:0;pointer-events:none;inset-inline-start:-10000px;top:0";
function TU(e, t) {
  return `display:block;width:${e}px;height:${t}px;border:0;background:transparent;color-scheme:normal`;
}
function P1(e, t, n, a) {
  const i = typeof e == "number" && Number.isFinite(e) ? Math.round(e) : a;
  return Math.min(n, Math.max(t, i));
}
async function AU(e, t, n = {}) {
  var c, p;
  const a = n.win ?? window, i = a.document;
  if ((c = n.signal) != null && c.aborted) throw new ua("cancelled", "the person said no");
  if (!await $U(t)) throw new ua("invalid", "not a PDF");
  let o;
  try {
    o = new URL(e, a.location.href).origin;
  } catch {
    throw new ua("unavailable", "no print page");
  }
  if (!o || o === "null") throw new ua("unavailable", "no print page");
  if ((p = n.signal) != null && p.aborted) throw new ua("cancelled", "the person said no");
  const l = i.createElement("iframe");
  return l.setAttribute("referrerpolicy", "no-referrer"), l.setAttribute("aria-hidden", "true"), l.setAttribute("tabindex", "-1"), l.setAttribute("title", n.label || "print"), l.dataset.testid = "appframe-print", l.style.cssText = M1, l.setAttribute("src", e), new Promise((m, v) => {
    var P;
    let x = !1, w = !1, S = null, k = null, b = null, C = null, T = null;
    function A() {
      l.style.cssText = M1, l.setAttribute("aria-hidden", "true"), l.setAttribute("tabindex", "-1");
    }
    function L(R) {
      var W;
      if (!x) {
        x = !0, a.removeEventListener("message", q), l.removeEventListener("load", D), (W = n.signal) == null || W.removeEventListener("abort", z);
        for (const N of [S, k, b, C]) N && clearTimeout(N);
        T && (T.port1.onmessage = null), R ? (l.remove(), v(R)) : (A(), m(l));
      }
    }
    function z() {
      try {
        T == null || T.port1.postMessage({ type: "cancel" });
      } catch {
      }
      L(new ua("cancelled", "the person said no"));
    }
    function D() {
      x || T || k || (k = setTimeout(() => {
        T || L(new ua("unavailable", "the print page may not be shown here"));
      }, n.loadGraceMs ?? yU));
    }
    function U(R) {
      var N;
      const W = R.data;
      if (!(x || !W || typeof W != "object")) {
        if (W.state === "ask") {
          if (w) return;
          w = !0;
          const J = P1(W.width, 24, 480, 96), H = P1(W.height, 16, 96, 36);
          l.style.cssText = TU(J, H), l.removeAttribute("aria-hidden"), l.removeAttribute("tabindex"), (N = n.onAsk) == null || N.call(n, { width: J, height: H }), C = setTimeout(() => {
            try {
              T == null || T.port1.postMessage({ type: "arm" });
            } catch {
            }
          }, n.armMs ?? bU);
          return;
        }
        W.ok === !0 ? L(null) : L(new ua(W.code === "invalid" ? "invalid" : "failed", "the PDF could not be printed"));
      }
    }
    function q(R) {
      const W = l.contentWindow;
      if (x || !W || R.source !== W) return;
      const N = R.data;
      if (!N || typeof N != "object" || N.type !== "filex:print-ready" || T || R.origin !== o) return;
      S && clearTimeout(S), k && clearTimeout(k);
      const J = new MessageChannel();
      T = J, J.port1.onmessage = U, b = setTimeout(() => L(new ua("failed", "the print page did not answer")), n.answerMs ?? gU);
      try {
        W.postMessage({ type: "filex:print", pdf: t, label: n.label ?? "", look: n.look ?? {} }, o, [J.port2]);
      } catch {
        L(new ua("failed", "the PDF could not be handed to the print page"));
      }
    }
    a.addEventListener("message", q), l.addEventListener("load", D), (P = n.signal) == null || P.addEventListener("abort", z), S = setTimeout(() => L(new ua("unavailable", "the print page did not load")), n.readyMs ?? vU), (n.mount ?? i.body).appendChild(l);
  });
}
const Zc = new TextEncoder(), EU = new TextDecoder();
function Zr(e) {
  return new Uint8Array(e);
}
const CU = Zr(Zc.encode("filex-state1")), zU = Zr(Zc.encode("filex-app-state")), MU = "filex-app-state-v1-key", PU = "filex-app-state-v1-id", OU = "filex-app-state-v1", H$ = 1, vl = 12, LU = 16, DU = 16, RU = "local";
async function IU() {
  var t, n;
  if (!Fl()) return RU;
  const e = await I$("/api/auth/me", { method: "GET" });
  if (!e || !e.ok) return null;
  try {
    const a = (n = (t = await e.json()) == null ? void 0 : t.user) == null ? void 0 : n.id;
    if (typeof a == "number" && Number.isSafeInteger(a) && a > 0) return `u${a}`;
    if (typeof a == "string" && /^[A-Za-z0-9_-]{1,64}$/.test(a)) return `u${a}`;
  } catch {
  }
  return null;
}
async function NU(e) {
  var n;
  if (((n = e.algorithm) == null ? void 0 : n.name) === "HKDF") return e;
  const t = new Uint8Array(await crypto.subtle.encrypt({ name: "AES-GCM", iv: CU }, e, new Uint8Array(32)));
  try {
    return await crypto.subtle.importKey("raw", t.subarray(0, 32), "HKDF", !1, ["deriveKey", "deriveBits"]);
  } finally {
    t.fill(0);
  }
}
function O1(e, t, n) {
  return { name: "HKDF", hash: "SHA-256", salt: zU, info: Zr(Zc.encode(`${e}\0${t}\0${n}`)) };
}
const ff = /* @__PURE__ */ new WeakMap();
function K$(e) {
  let t = ff.get(e);
  if (!t) {
    const n = { account: IU().catch(() => null), byApp: /* @__PURE__ */ new Map() };
    n.account.then((a) => {
      a === null && ff.get(e) === n && ff.delete(e);
    }), ff.set(e, n), t = n;
  }
  return t;
}
function L1(e, t, n) {
  const { byApp: a } = K$(e), i = `${t}\0${n}`;
  let o = a.get(i);
  return o || (o = (async () => {
    const l = await NU(e), c = await crypto.subtle.deriveKey(O1(MU, t, n), l, { name: "AES-GCM", length: 256 }, !1, ["encrypt", "decrypt"]), p = new Uint8Array(await crypto.subtle.deriveBits(O1(PU, t, n), l, DU * 8));
    return { id: Xo(p), key: c, account: t };
  })(), a.set(i, o), o.catch(() => a.delete(i))), o;
}
async function BU(e, t, n) {
  const a = await K$(e).account;
  if (a === null) return null;
  const i = await L1(e, a, t);
  return n ? { ...i, previous: await L1(n, a, t) } : i;
}
function gy() {
  const e = Qi().appStateE2e;
  if (!e) return {};
  try {
    const t = JSON.parse(e);
    return t && typeof t == "object" && !Array.isArray(t) ? t : {};
  } catch {
    return {};
  }
}
function V$(e, t) {
  const n = e[t];
  return n && typeof n == "object" && !Array.isArray(n) ? { ...n } : {};
}
function j$(e, t) {
  return Zr(Zc.encode(`${OU}\0${t.account}\0${e}\0${t.id}`));
}
async function FU(e, t, n) {
  const a = crypto.getRandomValues(new Uint8Array(vl)), i = Zr(Zc.encode(JSON.stringify(n)));
  try {
    const o = new Uint8Array(await crypto.subtle.encrypt({ name: "AES-GCM", iv: a, additionalData: j$(e, t) }, t.key, i)), l = new Uint8Array(1 + vl + o.length);
    return l[0] = H$, l.set(a, 1), l.set(o, 1 + vl), Xo(l);
  } finally {
    i.fill(0);
  }
}
async function D1(e, t, n) {
  if (typeof n != "string") return null;
  const a = _o(n);
  if (!a || a.length < 1 + vl + LU || a[0] !== H$) return null;
  let i;
  try {
    i = new Uint8Array(
      await crypto.subtle.decrypt(
        { name: "AES-GCM", iv: Zr(a.subarray(1, 1 + vl)), additionalData: j$(e, t) },
        t.key,
        Zr(a.subarray(1 + vl))
      )
    );
  } catch {
    return null;
  }
  try {
    const o = JSON.parse(EU.decode(i));
    return o && typeof o == "object" && !Array.isArray(o) ? o : null;
  } catch {
    return null;
  } finally {
    i.fill(0);
  }
}
async function q$(e, t) {
  const n = V$(gy(), e);
  if (n[t.id] !== void 0) return await D1(e, t, n[t.id]) ?? {};
  const a = t.previous;
  return a && n[a.id] !== void 0 ? await D1(e, a, n[a.id]) ?? {} : {};
}
async function UU(e, t, n) {
  const a = await q$(e, t);
  return Object.prototype.hasOwnProperty.call(a, n) ? a[n] : void 0;
}
const pf = /* @__PURE__ */ new Map();
async function HU(e, t, n, a) {
  const i = F$(n, a), l = (pf.get(e) ?? Promise.resolve()).catch(() => {
  }).then(() => KU(e, t, n, i));
  pf.set(e, l);
  try {
    await l;
  } finally {
    pf.get(e) === l && pf.delete(e);
  }
}
async function KU(e, t, n, a) {
  const i = { ...await q$(e, t) };
  a === void 0 ? delete i[n] : i[n] = JSON.parse(a);
  const o = V$(gy(), e);
  t.previous && delete o[t.previous.id], Object.keys(i).length ? o[t.id] = await FU(e, t, i) : delete o[t.id];
  const l = N$();
  if (l !== void 0 && B$(JSON.stringify(o)) > l)
    throw new Sc(`an app keeps at most ${l} bytes, sealed, in an encrypted folder`);
  const c = { ...gy(), [e]: o };
  Object.keys(o).length || delete c[e], Zi("appStateE2e", JSON.stringify(c));
}
class W$ extends Error {
  constructor() {
    super("the sealed app store needs the account this page is signed in as"), this.name = "LedgerNeedsAccount";
  }
}
async function Y$(e, t, n) {
  const a = await BU(e, t, n);
  if (!a) throw new W$();
  return a;
}
class Nr extends Error {
  constructor(t) {
    super(`at most ${t >> 20} MiB in an encrypted folder`), this.limit = t, this.name = "TooLargeToHand";
  }
}
const Ol = Math.min(ya.maxEncryptedBytes, ec);
function VU(e, t) {
  return {
    vault: t ?? null,
    async open(n, a, i = Ol) {
      const o = e(n);
      if (!o)
        return await a.cancel().catch(() => {
        }), null;
      const l = Qv(o.fmk, o.previous, a, { passPlain: !0 }).getReader(), c = [];
      let p = 0;
      try {
        for (; ; ) {
          const { done: x, value: w } = await l.read();
          if (x) break;
          if (p += w.byteLength, p > i) throw new Nr(i);
          c.push(w);
        }
      } catch (x) {
        await l.cancel(x).catch(() => {
        });
        for (const w of c) w.fill(0);
        throw x;
      }
      const m = new Uint8Array(p);
      let v = 0;
      for (const x of c)
        m.set(x, v), v += x.byteLength, x.fill(0);
      return m;
    },
    async seal(n, a, i = Ol) {
      if (a.byteLength > i) throw new Nr(i);
      const o = e(n);
      return o ? ay(o.fmk, a.buffer.byteLength === a.byteLength ? a.buffer : a.slice().buffer) : null;
    },
    async ledger(n, a) {
      const i = e(n);
      return i ? Y$(i.fmk, a, i.previous) : null;
    },
    folderKeys(n) {
      return e(n);
    }
  };
}
class bp extends Error {
  constructor(t) {
    super(`vault: ${t}`), this.why = t, this.name = "VaultAppRefused";
  }
}
function jU(e) {
  if (e.buffer instanceof ArrayBuffer && e.byteOffset === 0 && e.byteLength === e.buffer.byteLength) return e;
  const t = new Uint8Array(e.byteLength);
  return t.set(e), e.fill(0), t;
}
function qU(e) {
  return {
    async read(t, n = Ol) {
      const a = await e.readForApp(t, n);
      if (a.ok) return { bytes: jU(a.bytes), sig: a.sig };
      if (a.why === "locked") return null;
      throw a.why === "too_large" ? new Nr(n) : new bp(a.why);
    },
    async save(t, n, a, i = Ol) {
      if (n.byteLength > i) throw new Nr(i);
      const o = await e.saveForApp(t, n, a);
      if (!o.ok) throw new bp(o.why);
      return { size: o.size, sig: o.sig };
    },
    async ledger(t, n) {
      const a = e.keyForApp(t);
      return a ? Y$(a, n) : null;
    }
  };
}
const WU = {
  txt: "text/plain",
  md: "text/markdown",
  log: "text/plain",
  csv: "text/csv",
  json: "application/json",
  xml: "application/xml",
  html: "text/html",
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  png: "image/png",
  gif: "image/gif",
  webp: "image/webp",
  bmp: "image/bmp",
  avif: "image/avif",
  svg: "image/svg+xml",
  pdf: "application/pdf",
  mp4: "video/mp4",
  webm: "video/webm",
  mov: "video/quicktime",
  m4v: "video/mp4",
  mp3: "audio/mpeg",
  wav: "audio/wav",
  ogg: "audio/ogg",
  flac: "audio/flac",
  m4a: "audio/mp4",
  aac: "audio/aac",
  opus: "audio/opus"
};
function il(e) {
  return WU[(e || "").toLowerCase()] || "application/octet-stream";
}
const G$ = "files:e2e-plaintext";
function YU(e) {
  return !!e && e.includes(G$);
}
const bo = "builtin", Ll = "onlyoffice", GU = ["csv"];
function nh(e) {
  return GU.includes(String(e ?? "").toLowerCase());
}
function X$(e, t) {
  return !!e && e.type === "file" && (!!(t != null && t.inEncrypted) || yx(e));
}
function J$(e) {
  return `app:${e.plugin}/${e.id}`;
}
function R1(e) {
  return e ? e === bo || e === Ll || e.startsWith("app:") ? e : `app:${e}` : null;
}
function Rf(e) {
  return (e == null ? void 0 : e.id) === Ll;
}
function Lr(e) {
  return e ? String(Qy(e).ext ?? "").toLowerCase() : "";
}
function Z$(e) {
  return e.filter((t) => t.placement === "viewer" && !!t.ui);
}
function XU(e, t) {
  return !t || t.type !== "file" ? [] : Z$(e).filter((n) => eg(n.applies ?? {}, [Qy(t, n.plugin)]));
}
function JU(e) {
  const t = il(e);
  return t === "application/octet-stream" ? "" : t;
}
function ZU(e, t, n) {
  const a = JU(n);
  return Z$(e).filter(
    (i) => {
      var o;
      return YU((o = i.ui) == null ? void 0 : o.grants) && eg(i.applies ?? {}, [{ kind: "file", ext: n, mime: a, state: gx({ app_state: t.app_state }, i.plugin) }]);
    }
  );
}
function QU(e, t, n) {
  var p;
  const a = typeof t == "string" ? { name: t } : t, i = op(a.name ?? ""), o = ZU(e, a, i), l = o.length === 0 ? { on: [{ id: bo, view: null }], off: [], custom: !1 } : eT([...o.map((m) => ({ id: J$(m), view: m })), { id: bo, view: null }], (p = n == null ? void 0 : n.rules) == null ? void 0 : p[i]), c = typeof (n == null ? void 0 : n.personal) == "function" ? n.personal(i) : n == null ? void 0 : n.personal;
  return { ...l, kind: i, handler: tT(l.on, n == null ? void 0 : n.choice, c) };
}
function eH(e, t) {
  if (!(t != null && t.e2ePlaintext) || e.type !== "file" || e.encrypted === "vault" || e.encrypted === "file") return !1;
  const n = e.e2e_name_state;
  return n === void 0 || n === "enc" || n === "plain";
}
function tH(e) {
  return { name: String(e.basename ?? ""), ...Array.isArray(e.app_state) ? { app_state: e.app_state } : {} };
}
function nH(e) {
  return !!e && typeof e.e2e_stored == "string";
}
function aH(e, t) {
  return !!(t != null && t.e2ePlaintext) && e.type === "file" && e.encrypted === "vault";
}
function Q$(e, t, n, a) {
  if (!t || t.type !== "file") return { on: [], off: [], custom: !1 };
  if (X$(t, a)) {
    if (!(t.encrypted === "vault" ? aH(t, a) : eH(t, a))) return { on: [{ id: bo, view: null }], off: [], custom: !1 };
    const { on: l, off: c, custom: p } = QU(e, tH(t), { rules: n });
    return { on: l, off: c, custom: p };
  }
  const i = [
    ...a != null && a.onlyOffice && nh(Lr(t)) ? [{ id: Ll, view: null }] : [],
    ...XU(e, t).map((o) => ({ id: J$(o), view: o })),
    { id: bo, view: null }
  ];
  return eT(i, n == null ? void 0 : n[Lr(t)]);
}
function eT(e, t) {
  if (!t) return { on: e, off: [], custom: !1 };
  const n = new Set(t.off ?? []), a = new Map(e.map((c) => [c.id, c])), i = /* @__PURE__ */ new Set(), o = [];
  for (const c of t.order ?? []) {
    const p = a.get(c);
    !p || n.has(c) || i.has(c) || (i.add(c), o.push(p));
  }
  const l = [];
  for (const c of e)
    n.has(c.id) ? l.push(c) : i.has(c.id) || o.push(c);
  return { on: o, off: l, custom: !0 };
}
function qu(e, t, n, a, i, o) {
  return !t || t.type !== "file" ? null : tT(iH(Q$(e, t, a, o).on, t, o), n, i);
}
function iH(e, t, n) {
  const a = Lr(t);
  return n != null && n.onlyOffice || !Mv(a) || nh(a) || !e.some((i) => i.view) ? e : e.filter((i) => i.id !== bo);
}
function tT(e, t, n) {
  const a = (i) => i ? e.find((o) => o.id === i) ?? null : null;
  return a(R1(t)) ?? a(R1(n)) ?? e[0] ?? null;
}
function Ohe(e, t, n, a, i, o) {
  var l;
  return ((l = qu(e, t, n, a, i, o)) == null ? void 0 : l.view) ?? null;
}
const oH = "X-Filex-Version";
function rH(e) {
  const t = /^(\d{1,15}):(\d{1,15})$/.exec((e ?? "").trim());
  if (t)
    return { size: Number(t[1]), modified: Number(t[2]) };
}
const sH = /^[a-z0-9]{2,8}$/;
function lH(e) {
  const t = {}, n = e == null ? void 0 : e.beside;
  if (n != null && n !== "") {
    if (typeof n != "string") return null;
    const i = n.trim().replace(/^\./, "").toLowerCase();
    if (!sH.test(i)) return null;
    t.beside = i;
  }
  const a = e == null ? void 0 : e.conflict;
  if (a != null) {
    if (a !== "copy") return null;
    t.conflict = "copy";
  }
  return t;
}
const Bg = 32, uH = "", cH = ["changes", "lock", "release"], yl = 12, nT = "filex-oo-sk-v1", aT = "filex-oo-v1", iT = "filex-oo-eph-v1", oT = "filex-oo-blob-v1", dH = "filex-oo-log", fH = "filex-oo-eph", pH = "filex-oo-blob";
function ko(e) {
  return new Uint8Array(e).buffer;
}
const $c = new TextEncoder(), hH = new TextDecoder("utf-8", { fatal: !0 });
function ar(e, ...t) {
  return ko($c.encode(JSON.stringify([e, ...t])));
}
async function ah(e, t, n) {
  const a = crypto.getRandomValues(new Uint8Array(yl)), i = new Uint8Array(
    await crypto.subtle.encrypt({ name: "AES-GCM", iv: ko(a), additionalData: n }, e, ko(t))
  ), o = new Uint8Array(yl + i.length);
  return o.set(a, 0), o.set(i, yl), o;
}
async function ih(e, t, n) {
  if (t.length <= yl) return null;
  try {
    const a = await crypto.subtle.decrypt(
      { name: "AES-GCM", iv: ko(t.slice(0, yl)), additionalData: n },
      e,
      ko(t.slice(yl))
    );
    return new Uint8Array(a);
  } catch {
    return null;
  }
}
function oh(e) {
  try {
    return ea(e);
  } catch {
    return null;
  }
}
function rT(e) {
  try {
    return JSON.parse(hH.decode(e));
  } catch {
    return;
  }
}
function mH() {
  return crypto.getRandomValues(new Uint8Array(Bg));
}
async function vH(e, t, n) {
  if (t.length !== Bg) throw new Error("e2eoffice: a session key is 32 bytes");
  return Ma(await ah(e, t, ar(nT, n.sid, n.file)));
}
async function yH(e, t, n) {
  const a = oh(t);
  if (!a) return null;
  const i = await ih(e, a, ar(nT, n.sid, n.file));
  if (!i || i.length !== Bg) return null;
  try {
    return await by(i, n.sid);
  } finally {
    i.fill(0);
  }
}
async function by(e, t) {
  const n = await crypto.subtle.importKey("raw", ko(e), "HKDF", !1, ["deriveKey"]), a = (c) => crypto.subtle.deriveKey(
    { name: "HKDF", hash: "SHA-256", salt: ko($c.encode(t)), info: ko($c.encode(c)) },
    n,
    { name: "AES-GCM", length: 256 },
    !1,
    ["encrypt", "decrypt"]
  ), [i, o, l] = await Promise.all([a(dH), a(fH), a(pH)]);
  return { log: i, eph: o, blob: l };
}
async function gH(e, t, n, a) {
  const i = $c.encode(JSON.stringify({ p: n, b: a }));
  return Ma(await ah(e, i, ar(aT, t.sid, t.seq, t.client, t.ctr, t.kind)));
}
async function bH(e, t, n) {
  const a = oh(n);
  if (!a) return null;
  const i = await ih(e, a, ar(aT, t.sid, t.seq, t.client, t.ctr, t.kind));
  if (!i) return null;
  const o = rT(i);
  if (!o || typeof o != "object" || Array.isArray(o)) return null;
  const l = o;
  return typeof l.p != "string" ? null : { prev: l.p, body: l.b };
}
async function kH(e) {
  const t = oh(e) ?? new Uint8Array(0), n = new Uint8Array(await crypto.subtle.digest("SHA-256", ko(t)));
  return Array.from(n, (a) => a.toString(16).padStart(2, "0")).join("");
}
const wH = ["join", "leave", "saved"];
class _H {
  constructor(t, n, a = 0, i = uH) {
    It(this, "seq");
    It(this, "last");
    It(this, "ctrs", /* @__PURE__ */ new Map());
    It(this, "failed", null);
    this.key = t, this.sid = n, this.seq = a, this.last = i;
  }
  /** The last entry taken. */
  get head() {
    return this.seq;
  }
  /** What the next sealed entry has to name as `prev`. */
  get digest() {
    return this.last;
  }
  /** The counter a writer used last (0 = none yet). */
  counter(t) {
    return this.ctrs.get(t) ?? 0;
  }
  async read(t) {
    const n = (o) => (this.failed = o, { ok: !1, seq: t.seq, problem: o });
    if (this.failed) return { ok: !1, seq: t.seq, problem: this.failed };
    if (t.seq !== this.seq + 1) return n("gap");
    if (wH.includes(t.kind))
      return this.seq = t.seq, { ok: !0, seq: t.seq, kind: t.kind, client: t.client };
    if (!cH.includes(t.kind)) return n("kind");
    const a = t.ctr ?? 0;
    if (typeof t.ct != "string" || a < 1) return n("forged");
    const i = await bH(
      this.key,
      { sid: this.sid, seq: t.seq, client: t.client, ctr: a, kind: t.kind },
      t.ct
    );
    return i ? i.prev !== this.last ? n("chain") : a <= this.counter(t.client) ? n("replay") : (this.ctrs.set(t.client, a), this.last = await kH(t.ct), this.seq = t.seq, { ok: !0, seq: t.seq, kind: t.kind, client: t.client, body: i.body }) : n("forged");
  }
}
async function xH(e, t, n) {
  const a = $c.encode(JSON.stringify(n));
  return Ma(await ah(e, a, ar(iT, t.sid, t.client, t.ctr)));
}
async function SH(e, t, n) {
  const a = oh(n);
  if (!a) return;
  const i = await ih(e, a, ar(iT, t.sid, t.client, t.ctr));
  return i ? rT(i) : void 0;
}
function $H(e, t, n) {
  return ah(e, n, ar(oT, t.sid, t.name));
}
function TH(e, t, n) {
  return ih(e, n, ar(oT, t.sid, t.name));
}
function kp() {
  const e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Map();
  let n = 0;
  return {
    async add(a) {
      const i = ++n;
      return e.set(i, { ...a, id: i }), i;
    },
    async remove(a) {
      e.delete(a);
    },
    async listPath(a) {
      return [...e.values()].filter((i) => i.path === a).sort((i, o) => (i.id ?? 0) - (o.id ?? 0));
    },
    hold(a) {
      t.set(a, (t.get(a) ?? 0) + 1);
      let i = !1;
      return () => {
        if (i) return;
        i = !0;
        const o = (t.get(a) ?? 1) - 1;
        o > 0 ? t.set(a, o) : t.delete(a);
      };
    },
    async live(a) {
      return t.has(a);
    }
  };
}
const AH = "filex-coedit", Ko = "outbox", I1 = "filex-coedit-member:";
function N1() {
  try {
    return typeof navigator < "u" && navigator.locks ? navigator.locks : void 0;
  } catch {
    return;
  }
}
function av(e) {
  return new Promise((t, n) => {
    e.onsuccess = () => t(e.result), e.onerror = () => n(e.error);
  });
}
function EH() {
  const e = kp(), t = kp();
  let n = null;
  const a = () => (n || (n = new Promise((i) => {
    try {
      if (typeof indexedDB > "u") return i(null);
      const o = indexedDB.open(AH, 1);
      o.onupgradeneeded = () => {
        o.result.createObjectStore(Ko, { keyPath: "id", autoIncrement: !0 }).createIndex("by_path", "path");
      }, o.onsuccess = () => {
        const l = o.result;
        if (l.objectStoreNames.contains(Ko)) return i(l);
        l.close(), i(null);
      }, o.onerror = () => i(null), o.onblocked = () => i(null);
    } catch {
      i(null);
    }
  })), n);
  return {
    async add(i) {
      const o = await a();
      if (!o) return e.add(i);
      const l = o.transaction(Ko, "readwrite"), { id: c, ...p } = i;
      return Number(await av(l.objectStore(Ko).add(p)));
    },
    async remove(i) {
      const o = await a();
      if (!o) return e.remove(i);
      await av(o.transaction(Ko, "readwrite").objectStore(Ko).delete(i));
    },
    async listPath(i) {
      const o = await a();
      return o ? (await av(o.transaction(Ko, "readonly").objectStore(Ko).index("by_path").getAll(i))).sort((c, p) => (c.id ?? 0) - (p.id ?? 0)) : e.listPath(i);
    },
    hold(i) {
      const o = t.hold(i), l = N1();
      if (!l || !i) return o;
      let c = () => {
      };
      const p = new Promise((m) => c = m);
      return l.request(I1 + i, () => p).catch(() => {
      }), () => {
        o(), c();
      };
    },
    async live(i) {
      if (!i) return !1;
      if (await t.live(i)) return !0;
      const o = N1();
      if (!o) return !1;
      try {
        return await o.request(I1 + i, { ifAvailable: !0 }, (l) => l === null);
      } catch {
        return !1;
      }
    }
  };
}
const gl = 12, CH = "filex-coedit-outbox-v1", sT = new TextEncoder();
function lT(e) {
  return new Uint8Array(sT.encode(JSON.stringify([CH, e]))).buffer;
}
async function zH(e, t, n) {
  const a = crypto.getRandomValues(new Uint8Array(gl)), i = sT.encode(JSON.stringify(n)), o = new Uint8Array(await crypto.subtle.encrypt({ name: "AES-GCM", iv: a, additionalData: lT(t) }, e, i));
  i.fill(0);
  const l = new Uint8Array(gl + o.length);
  return l.set(a, 0), l.set(o, gl), Ma(l);
}
async function MH(e, t, n) {
  let a;
  try {
    a = ea(n);
  } catch {
    return;
  }
  if (!(a.length <= gl))
    for (const i of e)
      try {
        const o = await crypto.subtle.decrypt(
          { name: "AES-GCM", iv: a.slice(0, gl), additionalData: lT(t) },
          i,
          a.slice(gl)
        );
        return JSON.parse(new TextDecoder().decode(o));
      } catch {
      }
}
const PH = [1e3, 2e3, 4e3, 8e3, 15e3, 3e4];
function B1(e) {
  const t = ol(e);
  return t ? t.status === 0 ? !0 : t.code === "coedit_off" || t.code === "coedit_no_secret_key" ? !1 : t.status === 502 || t.status === 503 || t.status === 504 : (e == null ? void 0 : e.said) === !0;
}
const F1 = 1;
function ol(e) {
  const t = e ?? {};
  if (typeof t.status != "number") return null;
  let n;
  if (typeof t.detail == "string")
    try {
      const a = JSON.parse(t.detail);
      typeof a.head == "number" && (n = a.head);
    } catch {
    }
  return { status: t.status, code: typeof t.code == "string" ? t.code : "", head: n };
}
function Cr(e) {
  if (e instanceof ct) return e;
  const t = ol(e);
  if (!t) return new ct("failed", "failed");
  switch (t.code) {
    case "coedit_read_only":
      return new ct("read_only", "read_only");
    case "coedit_too_large":
      return new ct("too_large", "too_large");
    case "coedit_no_blob":
      return new ct("not_found", "not_found");
    case "coedit_blob_exists":
      return new ct("failed", "exists");
    case "coedit_no_lease":
    case "coedit_log_full":
    case "coedit_save_order":
    case "coedit_conflict":
      return new ct("failed", t.code.slice(7));
    case "coedit_gone":
    case "coedit_not_ready":
    case "coedit_nothing_to_watch":
    case "coedit_busy":
      return new ct("unavailable", t.code.slice(7));
    case "coedit_off":
    case "coedit_no_secret_key":
    case "coedit_build":
    case "coedit_file_changed":
    case "coedit_full":
    case "encrypted":
      return new ct("unavailable", t.code);
    case "not_granted":
      return new ct("not_granted", "not_granted");
    case "coedit_invalid":
    case "bad_json":
      return new ct("invalid", "invalid");
  }
  return t.status === 404 ? new ct("not_found", t.code || "not_found") : new ct("failed", /^[a-z][a-z0-9_]{0,39}$/.test(t.code) ? t.code : "failed");
}
const OH = ["changes", "lock", "release"];
function LH(e) {
  try {
    return JSON.parse(e);
  } catch {
    return;
  }
}
function U1(e) {
  if (!e || typeof e != "object") return null;
  const t = e;
  return typeof t.client != "string" ? null : {
    client: t.client,
    user: typeof t.user == "string" ? t.user : "",
    name: typeof t.name == "string" ? t.name : "",
    indexUser: typeof t.index_user == "number" ? t.index_user : 0,
    canEdit: t.can_edit === !0
  };
}
class wp {
  constructor(t, n, a, i, o, l, c, p) {
    It(this, "reader");
    It(this, "t");
    /** The app subscribed from here (null: not yet - entries wait). */
    It(this, "from", null);
    /** Entries read before the app subscribed. */
    It(this, "held", []);
    /** Entries waiting to be read, in order (the reader takes one at a time). */
    It(this, "inbox", []);
    It(this, "reading", !1);
    It(this, "sock", null);
    It(this, "closed", !1);
    It(this, "broken", !1);
    It(this, "ctr", 0);
    It(this, "ephCtr", 0);
    It(this, "ephSeen", /* @__PURE__ */ new Map());
    It(this, "appending", Promise.resolve());
    It(this, "waiters", []);
    /** What the socket said of each entry besides what the reader checks. */
    It(this, "extras", /* @__PURE__ */ new Map());
    It(this, "cursorTimer", null);
    It(this, "cursorNext", null);
    It(this, "cursorLast", 0);
    It(this, "reconnectDelay", 1e3);
    /** The seq of the last `changes` entry the reader took. */
    It(this, "changesSeen", 0);
    It(this, "outbox");
    It(this, "doc", "");
    It(this, "owner", "");
    /** The file's path as the host named it (where its kept changes are found). */
    It(this, "path", "");
    /** Releases this member's lock (lib/coeditOutbox `hold`). */
    It(this, "release", null);
    this.transport = t, this.ev = n, this.sid = a, this.me = i, this.token = o, this.keys = l, this.info = c, this.reader = new _H(l.log, a), this.t = {
      catchUpMs: 15e3,
      cursorGapMs: 200,
      ...p
    }, this.outbox = p.outbox ?? kp();
  }
  /**
   * Join (or start) the session of the file at `path`. A session whose
   * creator has not stored the base yet is asked again for a while, then
   * `unavailable` (`not_ready`).
   */
  static async join(t, n, a, i = {}) {
    const o = Date.now() + (i.readyWaitMs ?? 2e4), l = (z) => new Promise((D) => (i.setTimeout ?? setTimeout)(D, z)), c = i.outbox ?? kp(), p = await c.listPath(n).catch(() => []), m = [];
    for (const z of p) await c.live(z.client).catch(() => !1) || m.push(z);
    const v = {};
    i.folder && (v.e2e = !0), m.length > 0 && (v.unsent = { count: m.length });
    let x;
    for (; ; )
      try {
        x = await t.join(n, v);
        break;
      } catch (z) {
        const D = ol(z);
        if ((D == null ? void 0 : D.code) === "coedit_not_ready" && Date.now() < o) {
          await l(1e3);
          continue;
        }
        throw Cr(z);
      }
    const w = String(x.session ?? ""), S = U1(x.me), k = String(x.token ?? "");
    if (!/^[0-9a-f]{32}$/.test(w) || !S || !k) throw new ct("failed", "failed");
    const b = String(x.doc ?? ""), C = await wp.keysOf(t, x, w, S.client, k, b, i), T = new wp(t, a, w, S, k, C, {
      head: Number(x.head ?? 0),
      changesHead: Number(x.changes_head ?? 0),
      savedThrough: Number(x.saved_through ?? 0),
      created: x.created === !0
    }, i);
    T.doc = b, T.owner = String(x.owner ?? ""), T.path = n, T.release = c.hold(S.client);
    const A = x.socket ?? {};
    T.connect(String(A.url ?? ""), String(A.ticket ?? ""));
    const L = m.filter((z) => z.doc === T.doc && z.owner === T.owner && T.owner !== "");
    if (L.length > 0) {
      const z = x.unsent_words ?? {};
      await T.recover(L, Number(x.head ?? 0), z);
    }
    return T;
  }
  /**
   * The session's three keys. An ordinary folder: the server's key, handed
   * over. An encrypted folder (KeyFolder): the member that started the
   * session makes the key here, seals it with the folder key and gives the
   * server only that; a member that joins opens the one the starter sealed.
   */
  static async keysOf(t, n, a, i, o, l, c) {
    if (n.key_mode === "server" && typeof n.key == "string") {
      const x = ea(n.key);
      try {
        return await by(x, a);
      } finally {
        x.fill(0);
      }
    }
    if (n.key_mode !== "folder" || !c.folder || !l) throw new ct("unavailable", "encrypted");
    const p = c.folder();
    if (!p) throw new ct("unavailable", "locked");
    const m = { sid: a, file: l };
    if (n.created === !0) {
      const x = mH();
      try {
        const w = await vH(p.fmk, x, m);
        try {
          await t.call(a, "key", { client: i, token: o, sealed: w });
        } catch (S) {
          throw Cr(S);
        }
        return await by(x, a);
      } finally {
        x.fill(0);
      }
    }
    const v = typeof n.sealed_key == "string" ? n.sealed_key : "";
    for (const x of [p.fmk, p.previous]) {
      if (!x || !v) continue;
      const w = await yH(x, v, m);
      if (w) return w;
    }
    throw new ct("failed", "forged");
  }
  /**
   * The changes of an earlier opening, kept in this browser (lib/coeditOutbox):
   * sent at once when they are this session's and nobody changed the
   * document since; otherwise the person is asked (the server's words), and
   * they are sent on top of what is there now, or thrown away. Sent before
   * the interface reads the log, so its editor opens with them in it.
   */
  async recover(t, n, a) {
    var x, w;
    try {
      await this.until(n);
    } catch {
      return;
    }
    const i = t[0], o = i.sid === this.sid && i.changesBase === this.changesSeen;
    let l = o;
    if (!o) {
      const S = String((i.sid === this.sid ? a.behind : a.ended) ?? "");
      if (!S || !this.t.askUnsent) return;
      const k = await this.t.askUnsent({ text: S, apply: String(a.apply ?? ""), discard: String(a.discard ?? "") }).catch(() => null);
      if (k === null) return;
      l = k;
    }
    if (!l) {
      for (const S of t) S.id !== void 0 && await this.outbox.remove(S.id).catch(() => {
      });
      return;
    }
    const c = ((w = (x = this.t).folder) == null ? void 0 : w.call(x)) ?? null, p = c ? [c.fmk, c.previous].filter((S) => !!S) : [];
    let m = !1, v = 0;
    try {
      for (const S of t) {
        const k = S.sealed ? await MH(p, S.doc, S.body) : LH(S.body);
        if (S.id !== void 0 && await this.outbox.remove(S.id).catch(() => {
        }), k !== void 0) {
          if (m = m || await this.takeLease(), !m) {
            await this.keep("changes", k);
            continue;
          }
          v = (await this.append("changes", k)).seq;
        }
      }
    } finally {
      m && await this.lease("release", this.changesSeen).catch(() => !1);
    }
    v > 0 && (await this.until(v).catch(() => {
    }), this.info.head = Math.max(this.info.head, v), this.info.changesHead = Math.max(this.info.changesHead, v));
  }
  /** The lease for the changes being recovered, a few tries while another writer holds it. */
  async takeLease() {
    for (let t = 0; t < 10 && !this.closed; t++) {
      if (await this.lease("acquire", this.changesSeen).catch(() => !1)) return !0;
      await new Promise((n) => (this.t.setTimeout ?? setTimeout)(n, 1e3));
    }
    return !1;
  }
  /** What `coedit.join` answers the interface. */
  hello() {
    return { session: this.sid, me: { ...this.me }, ...this.info };
  }
  /** The query a save made in this session adds (`file.save`'s `through`). */
  saveParams(t) {
    return this.closed || !Number.isInteger(t) || t < 0 || t > this.reader.head ? null : { coedit: this.sid, client: this.me.client, token: this.token, through: String(t) };
  }
  /** The entries after `from` go to the interface, in order, then each new one. */
  subscribe(t) {
    if (!Number.isInteger(t) || t < 0) throw new ct("invalid", "from is an entry seq");
    this.from = t;
    const n = this.held;
    this.held = [];
    for (const a of n) a.seq > t && this.ev.entry(a);
  }
  /** Seal an entry at the place this page read last and have the relay place it. */
  append(t, n) {
    if (!OH.includes(t)) return Promise.reject(new ct("invalid", "kind is changes, lock or release"));
    const a = this.appending.then(() => this.place(t, n));
    return this.appending = a.catch(() => {
    }), a;
  }
  async place(t, n) {
    const a = t === "changes" ? await this.keep(t, n) : void 0, i = () => a !== void 0 ? this.outbox.remove(a).catch(() => {
    }) : void 0, o = this.t.retryMs ?? PH;
    let l = 0;
    for (let c = 0; c < 50; ) {
      if (this.closed || this.broken) throw new ct("unavailable", this.broken ? "broken" : "gone");
      const p = this.reader.head, m = ++this.ctr, v = await gH(this.keys.log, { sid: this.sid, seq: p + 1, client: this.me.client, ctr: m, kind: t }, this.reader.digest, n);
      try {
        const x = await this.transport.call(this.sid, "append", { client: this.me.client, token: this.token, kind: t, base: p, ctr: m, ct: v });
        return await i(), { seq: Number(x.seq ?? p + 1) };
      } catch (x) {
        const w = ol(x);
        if ((w == null ? void 0 : w.code) === "coedit_conflict" && typeof w.head == "number") {
          c++, await this.until(w.head);
          continue;
        }
        if (B1(x)) {
          await new Promise((S) => (this.t.setTimeout ?? setTimeout)(S, o[Math.min(l, o.length - 1)])), l++;
          continue;
        }
        throw (w == null ? void 0 : w.code) === "coedit_gone" ? (this.gone(), Cr(x)) : (await i(), Cr(x));
      }
    }
    throw new ct("unavailable", "busy");
  }
  /** Keep a change in this browser (sealed in an encrypted folder); its record's id. */
  async keep(t, n) {
    var l, c;
    if (t !== "changes" || !this.doc || !this.owner || !this.me.canEdit) return;
    const a = ((c = (l = this.t).folder) == null ? void 0 : c.call(l)) ?? null;
    let i, o = !1;
    if (this.t.folder) {
      if (!a) return;
      i = await zH(a.fmk, this.doc, n), o = !0;
    } else
      i = JSON.stringify(n);
    try {
      return await this.outbox.add({
        doc: this.doc,
        owner: this.owner,
        sid: this.sid,
        client: this.me.client,
        path: this.path,
        changesBase: this.changesSeen,
        at: Date.now(),
        body: i,
        sealed: o
      });
    } catch {
      return;
    }
  }
  /** Resolves once the reader has taken entry `head` (or fails after catchUpMs). */
  until(t) {
    return this.reader.head >= t ? Promise.resolve() : new Promise((n, a) => {
      const i = this.t.setTimeout ?? setTimeout, o = this.t.clearTimeout ?? ((p) => clearTimeout(p)), l = {
        head: t,
        done: () => {
          o(c), n();
        },
        fail: (p) => {
          o(c), a(p);
        }
      }, c = i(() => {
        const p = this.waiters.indexOf(l);
        p >= 0 && this.waiters.splice(p, 1), a(new ct("unavailable", "behind"));
      }, this.t.catchUpMs);
      this.waiters.push(l);
    });
  }
  /** The changes lease: one writer at a time, and only one that has seen every change. */
  async lease(t, n) {
    var a;
    if (t !== "acquire" && t !== "release") throw new ct("invalid", "op is acquire or release");
    try {
      return (await this.transport.call(this.sid, "lease", { client: this.me.client, token: this.token, op: t, changes_seen: n })).granted === !0;
    } catch (i) {
      if (B1(i)) return !1;
      throw ((a = ol(i)) == null ? void 0 : a.code) === "coedit_gone" && this.gone(), Cr(i);
    }
  }
  /** A cursor for the others: sealed, not kept, a few a second at most (the last one wins). */
  cursor(t) {
    if (this.closed || !this.me.canEdit || (this.cursorNext = { cursor: t }, this.cursorTimer !== null)) return;
    const n = Math.max(0, this.cursorLast + this.t.cursorGapMs - Date.now()), a = this.t.setTimeout ?? setTimeout;
    this.cursorTimer = a(() => {
      this.cursorTimer = null;
      const i = this.cursorNext;
      this.cursorNext = null, i && this.sendCursor(i.cursor);
    }, n);
  }
  async sendCursor(t) {
    if (!this.sock || this.sock.readyState !== F1) return;
    this.cursorLast = Date.now();
    const n = ++this.ephCtr, a = await xH(this.keys.eph, { sid: this.sid, client: this.me.client, ctr: n }, t);
    this.sock && this.sock.readyState === F1 && this.sock.send(JSON.stringify({ type: "cursor", ctr: n, ct: a }));
  }
  /** Seal and store a blob of the session (the base document, an image). */
  async putBlob(t, n) {
    if (!/^[A-Za-z0-9._-]{1,128}$/.test(t)) throw new ct("invalid", "a blob name");
    const a = await $H(this.keys.blob, { sid: this.sid, name: t }, new Uint8Array(n));
    try {
      await this.transport.putBlob(this.sid, t, { client: this.me.client, token: this.token }, a);
    } catch (i) {
      throw Cr(i);
    }
  }
  /** Read and open a blob of the session. */
  async getBlob(t) {
    if (!/^[A-Za-z0-9._-]{1,128}$/.test(t)) throw new ct("invalid", "a blob name");
    let n;
    try {
      n = await this.transport.getBlob(this.sid, t, { client: this.me.client, token: this.token });
    } catch (i) {
      throw Cr(i);
    }
    const a = await TH(this.keys.blob, { sid: this.sid, name: t }, new Uint8Array(n));
    if (!a) throw new ct("failed", "forged");
    return a.buffer.slice(a.byteOffset, a.byteOffset + a.byteLength);
  }
  /** Leave the session. `keepalive` for a page that is going away. */
  async leave(t = {}) {
    if (!this.closed) {
      this.close();
      try {
        await this.transport.call(this.sid, "leave", { client: this.me.client, token: this.token }, t);
      } catch {
      }
    }
  }
  /** Stop: no socket, no event, nothing waits. */
  close() {
    var n;
    this.closed = !0, (n = this.release) == null || n.call(this), this.release = null;
    const t = this.sock;
    if (this.sock = null, t) {
      t.onclose = null, t.onmessage = null;
      try {
        t.close(1e3);
      } catch {
      }
    }
    this.cursorTimer !== null && (this.t.clearTimeout ?? ((a) => clearTimeout(a)))(this.cursorTimer), this.cursorTimer = null;
  }
  // -------------------------------------------------------------------------
  // The socket
  // -------------------------------------------------------------------------
  connect(t, n) {
    if (this.closed || !t || !n) return;
    const a = this.t.socket ?? ((o) => new WebSocket(o));
    let i;
    try {
      i = a(`${t}${t.includes("?") ? "&" : "?"}ticket=${encodeURIComponent(n)}`);
    } catch {
      this.reconnectLater();
      return;
    }
    this.sock = i, i.onopen = () => {
      this.reconnectDelay = 1e3, i.send(JSON.stringify({ type: "subscribe", from: this.reader.head + this.inbox.length }));
    }, i.onmessage = (o) => this.onFrame(o.data), i.onclose = () => {
      this.sock === i && (this.sock = null), this.reconnectLater();
    }, i.onerror = () => {
    };
  }
  reconnectLater() {
    if (this.closed || this.broken) return;
    const t = this.reconnectDelay;
    this.reconnectDelay = Math.min(this.reconnectDelay * 2, 3e4), (this.t.setTimeout ?? setTimeout)(() => void this.reconnect(), t);
  }
  async reconnect() {
    var t;
    if (!(this.closed || this.broken || this.sock))
      try {
        const n = await this.transport.call(this.sid, "ticket", { client: this.me.client, token: this.token });
        this.connect(String(n.url ?? ""), String(n.ticket ?? ""));
      } catch (n) {
        if (((t = ol(n)) == null ? void 0 : t.code) === "coedit_gone") {
          this.gone();
          return;
        }
        this.reconnectLater();
      }
  }
  onFrame(t) {
    if (this.closed || typeof t != "string") return;
    let n;
    try {
      n = JSON.parse(t);
    } catch {
      return;
    }
    switch (n.type) {
      case "entry":
        n.entry && this.take(n.entry);
        return;
      case "eph":
        this.takeCursor(n);
        return;
      case "ended":
        n.reason === "broken" ? this.stopBroken() : this.gone();
        return;
    }
  }
  take(t) {
    if (typeof t.seq != "number" || typeof t.kind != "string" || typeof t.client != "string") return;
    const n = this.reader.head + this.inbox.length;
    if (t.seq <= n) return;
    this.inbox.push({ seq: t.seq, kind: t.kind, client: t.client, ctr: t.ctr, ct: t.ct });
    const a = { at: typeof t.at == "number" ? t.at : 0, member: t.member, through: t.through };
    this.extras.set(t.seq, a), this.drain();
  }
  async drain() {
    if (!this.reading) {
      this.reading = !0;
      try {
        for (; this.inbox.length > 0 && !this.closed && !this.broken; ) {
          const t = this.inbox.shift(), n = this.extras.get(t.seq) ?? { at: 0 };
          this.extras.delete(t.seq);
          const a = await this.reader.read(t);
          if (!a.ok) {
            this.stopBroken();
            return;
          }
          a.kind === "changes" && (this.changesSeen = a.seq);
          const i = this.entryOf(a.seq, a.kind, a.client, a.body, n);
          i && (this.from === null ? this.held.push(i) : i.seq > this.from && this.ev.entry(i));
          for (const o of [...this.waiters])
            this.reader.head >= o.head && (this.waiters.splice(this.waiters.indexOf(o), 1), o.done());
        }
      } finally {
        this.reading = !1;
      }
    }
  }
  entryOf(t, n, a, i, o) {
    const l = { seq: t, at: o.at, client: a };
    switch (n) {
      case "join": {
        const c = U1(o.member);
        return c ? { ...l, kind: "join", member: c } : null;
      }
      case "leave":
        return { ...l, kind: "leave" };
      case "saved":
        return { ...l, kind: "saved", through: typeof o.through == "number" ? o.through : 0 };
      case "changes":
      case "lock":
      case "release":
        return { ...l, kind: n, body: i };
    }
    return null;
  }
  async takeCursor(t) {
    if (typeof t.client != "string" || typeof t.ctr != "number" || typeof t.ct != "string" || t.client === this.me.client || t.ctr <= (this.ephSeen.get(t.client) ?? 0)) return;
    this.ephSeen.set(t.client, t.ctr);
    const n = await SH(this.keys.eph, { sid: this.sid, client: t.client, ctr: t.ctr }, t.ct);
    n === void 0 || this.closed || this.ev.cursor({ client: t.client, cursor: n });
  }
  /** The membership ended: say so once, stop. */
  gone() {
    if (this.closed) return;
    const t = this.reader.head;
    this.close(), this.rejectWaiters("gone"), this.ev.dropped({ from: t, reason: "gone" });
  }
  /** The log stopped checking out: the editors would build different documents. */
  stopBroken() {
    if (this.broken || this.closed) return;
    this.broken = !0;
    const t = this.reader.head;
    this.close(), this.rejectWaiters("broken"), this.ev.dropped({ from: t, reason: "broken" });
  }
  rejectWaiters(t) {
    for (const n of this.waiters.splice(0)) n.fail(new ct("unavailable", t));
  }
}
const DH = { "data-testid": "plugin-confirm-message" }, uT = /* @__PURE__ */ lt({
  __name: "PluginConfirmModal",
  props: {
    open: { type: Boolean },
    locale: {},
    theme: {},
    title: {},
    message: {},
    danger: { type: Boolean }
  },
  emits: ["close", "confirm"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = pt(() => n.locale);
    return (o, l) => (f(), Ge(ta, {
      open: e.open,
      title: e.title || u(i)("plugin.confirm.title"),
      size: "sm",
      theme: e.theme,
      locale: e.locale,
      onClose: l[2] || (l[2] = (c) => a("close"))
    }, {
      actions: mt(() => [
        d("button", {
          type: "button",
          class: "fe-btn",
          onClick: l[0] || (l[0] = (c) => a("close"))
        }, y(u(i)("plugin.confirm.cancel")), 1),
        d("button", {
          type: "button",
          class: Re(["fe-btn", e.danger ? "fe-btn--danger" : "fe-btn--primary"]),
          "data-testid": "plugin-confirm-run",
          onClick: l[1] || (l[1] = (c) => a("confirm"))
        }, y(u(i)("plugin.confirm.run")), 3)
      ]),
      default: mt(() => [
        d("p", DH, y(e.message), 1)
      ]),
      _: 1
    }, 8, ["open", "title", "theme", "locale"]));
  }
}), RH = ["data-app", "data-connected"], IH = {
  key: 0,
  class: "fe-appframe__note",
  role: "status",
  "data-testid": "appframe-updated"
}, NH = { class: "fe-appframe__note-text" }, BH = {
  key: 1,
  class: "fe-appframe__note fe-appframe__consent fe-appframe__over",
  role: "alertdialog",
  "aria-live": "assertive",
  "data-testid": "appframe-unsent"
}, FH = { class: "fe-appframe__note-text" }, UH = {
  key: 2,
  class: "fe-appframe__note fe-appframe__consent",
  role: "alertdialog",
  "aria-live": "assertive",
  "data-testid": "appframe-consent"
}, HH = { class: "fe-appframe__note-text" }, KH = ["disabled"], VH = ["role", "aria-live", "aria-hidden", "inert", "data-shown"], jH = { class: "fe-appframe__note-text" }, qH = { "data-testid": "appframe-unsaved" }, WH = ["disabled"], YH = ["disabled"], GH = ["disabled"], H1 = 5e3, K1 = 600, Fg = /* @__PURE__ */ lt({
  __name: "AppFrame",
  props: {
    api: {},
    app: {},
    version: {},
    view: {},
    placement: {},
    ui: {},
    files: {},
    savePath: {},
    readOnly: { type: Boolean },
    locale: {},
    theme: {},
    userName: {},
    title: {},
    storages: {},
    startAt: {},
    e2e: {}
  },
  emits: ["connected", "dirty", "title", "toast", "close", "saved", "saved-as", "op"],
  setup(e, { expose: t, emit: n }) {
    const a = e, i = n, { t: o } = pt(() => a.locale), l = Il(), c = $(null);
    let p = null, m = null;
    const v = $(!1), x = $(!1), w = $(null), S = $(!1), k = $(0), b = $(null), C = E(() => b.value ?? a.ui), T = $(""), A = $(""), L = E(() => a.api.appUIUrl(C.value.url)), z = E(() => new Set(C.value.grants ?? [])), D = E(() => {
      var Z;
      return ((Z = b.value) == null ? void 0 : Z.version) || a.version || a.ui.version || "";
    }), U = E(
      () => a.theme === "dark" || a.theme !== "light" && l.value ? "dark" : "light"
    ), q = [
      "--fe-bg",
      "--fe-bg-elev",
      "--fe-bg-hover",
      "--fe-bg-selected",
      "--fe-border",
      "--fe-border-soft",
      "--fe-border-strong",
      "--fe-text",
      "--fe-text-muted",
      "--fe-text-on-primary",
      "--fe-primary",
      "--fe-primary-hover",
      "--fe-primary-soft",
      "--fe-primary-ink",
      "--fe-danger",
      "--fe-danger-hover",
      "--fe-warning",
      "--fe-ok",
      "--fe-radius",
      "--fe-radius-sm",
      "--fe-radius-md",
      "--fe-radius-lg",
      "--fe-font",
      "--fe-font-mono",
      "--fe-text-xs",
      "--fe-text-sm",
      "--fe-text-md",
      "--fe-shadow",
      "--fe-shadow-sm"
    ];
    function P() {
      const Z = {};
      if (c.value && typeof getComputedStyle == "function") {
        const ee = getComputedStyle(c.value);
        for (const we of q) {
          const Ye = ee.getPropertyValue(we).trim();
          Ye && (Z[we] = Ye);
        }
      }
      return { mode: U.value, tokens: Z };
    }
    function R(Z) {
      const ee = Z.lastIndexOf(".");
      return ee > 0 ? Z.slice(ee + 1).toLowerCase() : "";
    }
    function W(Z) {
      const ee = a.e2e;
      return !ee || !z.value.has(G$) ? !1 : Z.encrypted === "folder" || Z.encrypted === "vault" && !!ee.vault;
    }
    const N = E(() => (a.files ?? []).some(W));
    function J(Z) {
      return !!a.readOnly || !!Z.readOnly || Qu(Z.encrypted) && !W(Z);
    }
    function H() {
      const Z = z.value.has("files:write");
      return (a.files ?? []).map((ee, we) => ({
        index: we,
        name: ee.name,
        ext: R(ee.name),
        size: ee.size ?? 0,
        mime: ee.mime ?? "",
        readOnly: !Z || J(ee),
        // Only when the server said so: absent means not encrypted.
        ...Qu(ee.encrypted) ? { encrypted: ee.encrypted } : {},
        ...W(ee) ? { plaintext: !0 } : {}
      }));
    }
    function ne() {
      return {
        v: z$,
        app: { name: a.app, version: D.value },
        view: { id: a.view, placement: a.placement },
        locale: a.locale,
        dir: kl(a.locale),
        theme: P(),
        user: { name: a.userName ?? "" },
        // The document editors' fixed language (#214), as the server's list
        // said it for this interface (filex 0.57).
        ...C.value.editor_lang ? { editor_lang: C.value.editor_lang } : {},
        files: H(),
        grants: [...z.value]
      };
    }
    function j(Z) {
      if (!z.value.has(Z)) throw new ct("not_granted", `this app was not granted ${Z}`);
    }
    function re(Z) {
      const ee = typeof Z == "number" ? Z : 0, we = (a.files ?? [])[ee];
      if (!Number.isInteger(ee) || !we) throw new ct("not_found", `no file at ${String(Z)}`);
      return we;
    }
    async function he(Z, ee) {
      const we = typeof ee == "string" && ee.length < 200 ? ee : "";
      if (typeof Z == "string") return new Blob([Z], { type: we || "text/plain;charset=utf-8" });
      if (Z instanceof ArrayBuffer) return new Blob([Z], { type: we });
      if (typeof ReadableStream < "u" && Z instanceof ReadableStream) return Z;
      throw new ct("invalid", "save takes a string, an ArrayBuffer or a ReadableStream");
    }
    const ue = /* @__PURE__ */ new Map(), ae = /* @__PURE__ */ new Map();
    function fe(Z, ee) {
      const we = ue.get(Z);
      return we ? `${we.size}:${we.modified}` : typeof ee.size == "number" && typeof ee.modified == "number" ? `${ee.size}:${ee.modified}` : void 0;
    }
    function _() {
      return new ct("too_large", `at most ${Ol >> 20} MiB in an encrypted folder`);
    }
    function Q() {
      return new ct("unavailable", "the encrypted folder was locked");
    }
    async function K() {
      const Z = (a.files ?? []).find(W);
      return !Z || !a.e2e ? null : Z.encrypted === "vault" ? a.e2e.vault ? a.e2e.vault.ledger(Z.path, a.app) : null : a.e2e.ledger(Z.path, a.app);
    }
    function I() {
      return o("appframe.state_no_account");
    }
    async function Y(Z) {
      const ee = typeof ReadableStream < "u" && Z instanceof ReadableStream;
      if (typeof Z != "string" && !(Z instanceof ArrayBuffer) && !ee)
        throw new ct("invalid", "save takes a string, an ArrayBuffer or a ReadableStream");
      const we = [];
      let Ye = 0;
      try {
        for await (const Bt of te(Z)) {
          if (Ye += Bt.byteLength, Ye > Ol) throw _();
          we.push(Bt);
        }
      } catch (Bt) {
        for (const Qt of we) Qt.fill(0);
        throw Bt;
      }
      const rt = new Uint8Array(Ye);
      let vt = 0;
      for (const Bt of we)
        rt.set(Bt, vt), vt += Bt.byteLength, Bt.fill(0);
      return rt;
    }
    async function B(Z) {
      const ee = a.e2e, we = a.api.pluginUIRead;
      if (!ee || typeof we != "function") throw new ct("unavailable", "this host does not hand over encrypted files");
      const Ye = await we(a.app, a.view, Z.path, { e2e: !0 }), rt = Ye.body ?? new Blob([await Ye.arrayBuffer()]).stream();
      try {
        return await ee.open(Z.path, rt);
      } catch (vt) {
        throw vt instanceof Nr ? _() : new ct("failed", "the file could not be decrypted here");
      }
    }
    const V = /* @__PURE__ */ new Map();
    function be(Z, ee) {
      if (Z instanceof ct) return Z;
      if (Z instanceof Nr) return _();
      if (!(Z instanceof bp)) return new ct("failed", ee);
      switch (Z.why) {
        case "locked":
          return new ct("unavailable", "the vault was locked");
        case "too_large":
          return _();
        case "gone":
          return new ct("not_found", "the file is not in the vault any more");
        case "read_only":
          return new ct("read_only", "the vault is read-only here");
        case "changed":
          return new ct("failed", "changed");
        case "held":
          return new ct("failed", "vault_locked");
        case "lock_lost":
          return new ct("failed", "vault_lock_lost");
        default:
          return new ct("failed", ee);
      }
    }
    async function Fe(Z) {
      var we;
      const ee = (we = a.e2e) == null ? void 0 : we.vault;
      if (!ee) throw new ct("unavailable", "this host does not hand over files of a vault");
      try {
        const Ye = await ee.read(Z.path);
        return Ye ? (V.set(Z.path, Ye.sig), Ye.bytes) : null;
      } catch (Ye) {
        throw be(Ye, "the file could not be decrypted here");
      }
    }
    async function ze(Z, ee, we) {
      var Qt;
      const Ye = (Qt = a.e2e) == null ? void 0 : Qt.vault;
      if (!Ye) throw new ct("unavailable", "the vault was locked");
      const rt = await Y(we), vt = rt.byteLength;
      let Bt;
      try {
        Bt = await Ye.save(ee.path, rt, V.get(ee.path) ?? fe(Z, ee));
      } catch (en) {
        throw be(en, "the vault did not save it");
      } finally {
        rt.fill(0);
      }
      return V.set(ee.path, Bt.sig), i("saved", { path: ee.path, size: Bt.size, index: Z }), x.value = !1, i("dirty", !1), { saved: !0, size: vt };
    }
    async function Ue(Z, ee) {
      const we = Z.encrypted === "vault" ? await Fe(Z) : await B(Z);
      if (!we) throw Z.encrypted === "vault" ? be(new bp("locked"), "") : Q();
      const Ye = { name: Z.name, size: we.byteLength, mime: Z.mime || "" };
      switch (ee ?? "stream") {
        case "text": {
          if (we.byteLength > ya.maxTextBytes)
            throw we.fill(0), new ct("too_large", "read a file this large as bytes");
          const rt = new TextDecoder().decode(we);
          return we.fill(0), { ...Ye, text: rt };
        }
        case "bytes":
          return { ...Ye, bytes: we.buffer };
        case "stream": {
          const rt = we;
          return {
            ...Ye,
            stream: new ReadableStream({
              start(vt) {
                vt.enqueue(rt), vt.close();
              }
            })
          };
        }
        default:
          throw we.fill(0), new ct("invalid", "as is stream, bytes or text");
      }
    }
    async function We(Z, ee, we, Ye) {
      if (ee.encrypted === "vault") return ze(Z, ee, we);
      const rt = a.e2e;
      if (!rt) throw Q();
      const vt = await Y(we), Bt = vt.byteLength;
      let Qt;
      try {
        Qt = await rt.seal(ee.path, vt);
      } catch (kn) {
        throw kn instanceof Nr ? _() : kn;
      } finally {
        vt.fill(0);
      }
      if (!Qt) throw Q();
      const en = fn && typeof Ye == "number" ? fn.saveParams(Ye) : null, Ot = await a.api.pluginUISave(a.app, a.view, { path: ee.path }, new Blob([Qt], { type: "application/octet-stream" }), {
        e2e: !0,
        expect: fe(Z, ee),
        ...en ? { extra: en } : {}
      });
      return typeof Ot.modified == "number" && ue.set(Z, { size: Ot.size, modified: Ot.modified }), i("saved", { path: Ot.path || ee.path, size: Ot.size, index: Z }), x.value = !1, i("dirty", !1), { saved: !0, size: Bt };
    }
    function $t(Z) {
      if (N.value) throw new ct("unavailable", `${Z} is not offered while a file of an encrypted folder is open`);
    }
    const St = $(null), at = E(() => {
      const Z = (a.title || "").trim();
      return Z ? Z.toLowerCase().includes(a.app.toLowerCase()) ? Z : `${Z} (${a.app})` : a.app;
    }), kt = $(null);
    let ht = Number.NEGATIVE_INFINITY, Ie = Number.NEGATIVE_INFINITY;
    function se() {
      const Z = typeof navigator < "u" ? navigator.userActivation : void 0;
      return !!(Z != null && Z.isActive);
    }
    function xe() {
      Ie = Date.now();
    }
    function me() {
      if (!se()) return !1;
      const Z = Date.now();
      return Z - ht < H1 || Z - Ie < H1 ? !1 : (ht = Z, !0);
    }
    async function De(Z) {
      me() || await gt(Z);
    }
    const ot = $(!1);
    let ft = null;
    async function gt(Z) {
      if (kt.value) throw new ct("unavailable", "a question is already on screen");
      if (ot.value = !1, ft && clearTimeout(ft), ft = setTimeout(() => {
        ot.value = !0;
      }, K1), !await new Promise((we) => {
        kt.value = { text: Z, resolve: we };
      })) throw new ct("cancelled");
    }
    function Ut() {
      return o("appframe.consent_clipboard", { app: at.value });
    }
    function Xe(Z) {
      return o("appframe.consent_job", { app: at.value, action: Z });
    }
    function je(Z) {
      return o("appframe.consent_download", { app: at.value, name: Z });
    }
    function Be(Z) {
      return o("appframe.consent_print", { app: at.value, name: Z });
    }
    function ie() {
      return o("appframe.consent_allow");
    }
    function ge(Z) {
      if (Z && !ot.value) return;
      const ee = kt.value;
      kt.value = null, ft && clearTimeout(ft), ft = null, ee == null || ee.resolve(Z);
    }
    function G(Z) {
      const ee = typeof Z == "string" ? Z.trim() : "";
      if (!ee || ee.length > 255 || ee === "." || ee === ".." || /[\\/\u0000-\u001f]/.test(ee))
        throw new ct("invalid", "name is a file name, without a folder");
      return ee;
    }
    function ye() {
      return new ct("too_large", `at most ${ya.maxDownloadBytes >> 20} MiB`);
    }
    async function* te(Z) {
      if (typeof Z == "string") {
        yield new TextEncoder().encode(Z);
        return;
      }
      if (Z instanceof ArrayBuffer) {
        yield new Uint8Array(Z);
        return;
      }
      const ee = Z.getReader();
      let we = !1;
      try {
        for (; ; ) {
          const Ye = await ee.read();
          if (Ye.done) {
            we = !0;
            return;
          }
          Ye.value && (yield Ye.value);
        }
      } finally {
        we || await ee.cancel().catch(() => {
        });
      }
    }
    async function Ce(Z, ee, we) {
      var en;
      const Ye = window.showSaveFilePicker;
      if (typeof Ye == "function") {
        let Ot = null;
        try {
          Ot = await Ye.call(window, { suggestedName: Z });
        } catch (kn) {
          if ((kn == null ? void 0 : kn.name) === "AbortError") throw new ct("cancelled");
          Ot = null;
        }
        if (Ot) {
          const kn = await Ot.createWritable();
          let Pa = 0;
          try {
            for await (const cn of te(ee)) {
              if (Pa += cn.byteLength, Pa > ya.maxDownloadBytes) throw ye();
              await kn.write(cn);
            }
          } catch (cn) {
            throw await ((en = kn.abort) == null ? void 0 : en.call(kn).catch(() => {
            })), cn;
          }
          return await kn.close(), { saved: !0, size: Pa };
        }
      }
      const rt = [];
      let vt = 0;
      for await (const Ot of te(ee)) {
        if (vt += Ot.byteLength, vt > ya.maxDownloadBytes) throw ye();
        rt.push(Ot);
      }
      const Bt = URL.createObjectURL(new Blob(rt, { type: we })), Qt = document.createElement("a");
      Qt.href = Bt, Qt.download = Z, Qt.rel = "noopener", Qt.style.display = "none", document.body.appendChild(Qt);
      try {
        Qt.click();
      } finally {
        Qt.remove(), setTimeout(() => URL.revokeObjectURL(Bt), 6e4);
      }
      return { saved: !0, size: vt };
    }
    const Ne = $(null), _e = $(null);
    let Ae = null, Pe = null, _t = !1;
    function Et() {
      Pe == null || Pe.abort(), Pe = null, Ae == null || Ae.remove(), Ae = null, Ne.value = null;
    }
    function xn() {
      Pe == null || Pe.abort();
    }
    function Dt() {
      const Z = c.value;
      if (!Z) return {};
      const ee = document.createElement("span");
      ee.className = "fe-btn fe-btn--primary", ee.setAttribute("aria-hidden", "true"), ee.style.cssText = "position:absolute;visibility:hidden;pointer-events:none;inset-inline-start:0;top:0", ee.textContent = o("appframe.consent_allow"), Z.appendChild(ee);
      try {
        return SU(ee);
      } finally {
        ee.remove();
      }
    }
    function bn() {
      return new ct("too_large", `at most ${ya.maxPrintBytes >> 20} MiB`);
    }
    const un = $(null);
    let Jt = !1, Ln = null;
    function Vn() {
      var Ye, rt;
      const Z = ((rt = (Ye = a.files) == null ? void 0 : Ye[0]) == null ? void 0 : rt.path) ?? "", ee = Z.includes("://") ? Pg(Z, !1) ?? "" : "";
      if (ee && !Wf(ee)) return ee;
      const we = a.startAt ?? "";
      return we.includes("://") && !Wf(we) ? we : ee ? zv(ee) : void 0;
    }
    async function Ft(Z) {
      var ee;
      if ((ee = a.storages) != null && ee.length) return a.storages;
      if (Ln) return Ln;
      try {
        const we = await a.api.index(Z ?? "");
        return Ln = Array.isArray(we == null ? void 0 : we.storages) ? we.storages.filter((Ye) => typeof Ye == "string" && !!Ye) : [], Ln;
      } catch {
        return [];
      }
    }
    async function na(Z) {
      if (Jt || un.value) throw new ct("unavailable", "a question is already on screen");
      Jt = !0;
      try {
        const ee = Vn(), we = await Ft(ee);
        if (!ee && !we.length) throw new ct("unavailable", "there is no folder to save into here");
        return await new Promise((Ye) => {
          un.value = { name: Z, storages: we, startAt: ee, resolve: Ye };
        });
      } finally {
        Jt = !1;
      }
    }
    function Kt(Z) {
      const ee = un.value;
      un.value = null, ee == null || ee.resolve(Z);
    }
    function bt(Z) {
      return o("appframe.save_as_title", { app: at.value, name: Z });
    }
    async function Dn(Z) {
      typeof ReadableStream < "u" && Z instanceof ReadableStream && await Z.cancel().catch(() => {
      });
    }
    async function In(Z) {
      try {
        const we = (await a.api.pluginActions()).actions.find((rt) => rt.plugin === a.app && rt.id === Z), Ye = we ? Xt(we.label, a.locale) : "";
        if (Ye) return Ye;
      } catch {
      }
      return Z;
    }
    const Cn = {
      "session.get": () => ne(),
      async "file.read"(Z) {
        j("files:read");
        const ee = Z ?? {}, we = re(ee.index);
        if (W(we)) return Ue(we, ee.as);
        const Ye = a.api.pluginUIRead, rt = typeof Ye == "function" ? await Ye(a.app, a.view, we.path) : await a.api.fetchResponse(we.path), vt = Number(rt.headers.get("content-length") ?? we.size ?? 0) || (we.size ?? 0), Bt = we.mime || rt.headers.get("content-type") || "", Qt = rH(rt.headers.get(oH));
        Qt && ue.set(typeof ee.index == "number" ? ee.index : 0, Qt);
        const en = WP(rt.headers.get(qP)), Ot = { name: we.name, size: vt, mime: Bt, ...en ? { text_dialect: en } : {} };
        switch (ee.as ?? "stream") {
          case "text": {
            if (vt > ya.maxTextBytes) throw new ct("too_large", "read a file this large as a stream");
            return en && en.encoding !== "utf-8" ? { ...Ot, text: YP(await rt.arrayBuffer(), en.encoding) } : { ...Ot, text: await rt.text() };
          }
          case "bytes":
            return { ...Ot, bytes: await rt.arrayBuffer() };
          case "stream":
            return rt.body ? { ...Ot, stream: rt.body } : { ...Ot, bytes: await rt.arrayBuffer() };
          default:
            throw new ct("invalid", "as is stream, bytes or text");
        }
      },
      async "file.save"(Z) {
        j("files:write");
        const ee = Z ?? {}, we = typeof ee.index == "number" ? ee.index : 0, Ye = re(we);
        if (J(Ye)) throw new ct("read_only", "this file cannot be saved over here");
        if (q2(ee.csv) === null) throw new ct("invalid", "csv is {delimiter, encoding, bom, eol}");
        const rt = lH(ee);
        if (rt === null) throw new ct("invalid", "beside is a file extension; conflict is 'copy'");
        if (W(Ye)) {
          if (rt.beside && rt.beside !== R(Ye.name))
            throw new ct("unavailable", "a file of an encrypted folder is saved only in its own format");
          return We(we, Ye, ee.data, ee.through);
        }
        const vt = await he(ee.data, ee.mime), Bt = fn && typeof ee.through == "number" ? fn.saveParams(ee.through) : null, Qt = we === 0 && a.savePath ? a.savePath : Ye.path, en = Bt ? Qt : ae.get(we) ?? Qt, Ot = rt.conflict && !Bt ? fe(we, Ye) : void 0, kn = { ...Bt ?? {} };
        rt.beside && (kn.beside = rt.beside), rt.conflict && (kn.conflict = rt.conflict);
        const Pa = {
          ...Object.keys(kn).length ? { extra: kn } : {},
          ...ee.csv ? { csv: ee.csv } : {},
          ...Ot ? { expect: Ot } : {}
        }, cn = Object.keys(Pa).length ? await a.api.pluginUISave(a.app, a.view, { path: en }, vt, Pa) : await a.api.pluginUISave(a.app, a.view, { path: en }, vt);
        typeof cn.modified == "number" && ue.set(we, { size: cn.size, modified: cn.modified }), !Bt && cn.path && cn.path !== en && (cn.beside || cn.conflict) && ae.set(we, cn.path), i("saved", { path: cn.path || en, size: cn.size, index: we }), x.value = !1, i("dirty", !1);
        const pe = cn.beside || typeof cn.conflict == "string";
        return {
          saved: !0,
          size: cn.size,
          ...pe && cn.name ? { name: cn.name } : {},
          ...cn.beside ? { beside: !0 } : {},
          ...typeof cn.conflict == "string" ? { conflict: cn.conflict } : {}
        };
      },
      async "file.saveAs"(Z) {
        j("files:write");
        const ee = Z ?? {}, we = typeof ee.name == "string" ? ee.name.trim() : "";
        if (!we || we.includes("/") || we.includes("\\") || we === "." || we === ".." || we.length > 255)
          throw new ct("invalid", "name is a file name, without a folder");
        N.value && (typeof ReadableStream < "u" && ee.data instanceof ReadableStream && await ee.data.cancel().catch(() => {
        }), $t("save as"));
        const Ye = await he(ee.data, ee.mime);
        let rt;
        try {
          rt = await na(we);
        } catch (Bt) {
          throw await Dn(Ye), Bt;
        }
        if (!rt)
          throw await Dn(Ye), new ct("cancelled");
        const vt = await a.api.pluginUISave(a.app, a.view, { dir: rt, name: we }, Ye);
        return i("saved-as", { path: vt.path, name: vt.name, size: vt.size }), { saved: !0, name: vt.name, size: vt.size };
      },
      "ui.dirty"(Z) {
        return x.value = !!(Z != null && Z.dirty), i("dirty", x.value), null;
      },
      "ui.title"(Z) {
        const ee = String((Z == null ? void 0 : Z.text) ?? "").slice(0, ya.maxLineChars);
        return i("title", ee), null;
      },
      "ui.toast"(Z) {
        const ee = Z ?? {}, we = ee.tone === "success" || ee.tone === "warning" || ee.tone === "error" ? ee.tone : "info";
        return i("toast", { text: `${at.value}: ${String(ee.text ?? "").slice(0, ya.maxLineChars)}`, tone: we }), null;
      },
      "ui.confirm"(Z) {
        const ee = typeof Z == "object" && Z ? Z : {};
        if (St.value) throw new ct("unavailable", "a question is already on screen");
        return new Promise((we) => {
          St.value = {
            text: String(ee.text ?? "").slice(0, 1e3),
            title: ee.title ? String(ee.title).slice(0, ya.maxLineChars) : void 0,
            danger: !!ee.danger,
            resolve: we
          };
        });
      },
      "ui.close"() {
        return i("close"), null;
      },
      async "clipboard.write"(Z) {
        var we;
        const ee = String((Z == null ? void 0 : Z.text) ?? "");
        if (ee.length > 1 << 20) throw new ct("too_large", "at most 1 MiB of text");
        if (typeof navigator > "u" || !((we = navigator.clipboard) != null && we.writeText))
          throw new ct("unavailable", "this browser offers no clipboard here");
        if (me())
          try {
            return await navigator.clipboard.writeText(ee), null;
          } catch (Ye) {
            if ((Ye == null ? void 0 : Ye.name) !== "NotAllowedError") throw Ye;
          }
        return await gt(Ut()), await navigator.clipboard.writeText(ee), null;
      },
      async "ui.download"(Z) {
        j("ui:download");
        const ee = Z ?? {}, we = G(ee.name), Ye = ee.data, rt = typeof ReadableStream < "u" && Ye instanceof ReadableStream;
        if (typeof Ye != "string" && !(Ye instanceof ArrayBuffer) && !rt)
          throw new ct("invalid", "download takes a string, an ArrayBuffer or a ReadableStream");
        if ((typeof Ye == "string" ? new Blob([Ye]).size : Ye instanceof ArrayBuffer ? Ye.byteLength : 0) > ya.maxDownloadBytes) throw ye();
        const Bt = typeof ee.mime == "string" && /^[\w.+-]+\/[\w.+-]+$/.test(ee.mime) ? ee.mime : "application/octet-stream";
        try {
          await De(je(we));
        } catch (Qt) {
          throw rt && await Ye.cancel().catch(() => {
          }), Qt;
        }
        return Ce(we, Ye, Bt);
      },
      /**
       * 0.55: print a PDF the interface hands over (`ui:print`) - the print
       * dialog can save the PDF, so it is the person's call every time: filex
       * asks, and the dialog opens on their click on the row's Allow, a button of
       * the server's print page (lib/printPdf; security review sec055 S9). The
       * PDF is held once, as one Blob: refused at its first bytes when they are
       * not a PDF's and past LIMITS.maxPrintBytes (S10). `unavailable` where the
       * host names no print page, or while another print is being asked about.
       */
      async "ui.print"(Z) {
        j("ui:print");
        const ee = Z ?? {}, we = ee.data, Ye = typeof ReadableStream < "u" && we instanceof ReadableStream, rt = async () => {
          Ye && await we.cancel().catch(() => {
          });
        };
        let vt = "";
        try {
          if (vt = G(ee.name), !(we instanceof ArrayBuffer) && !Ye)
            throw new ct("invalid", "print takes a PDF as an ArrayBuffer or a ReadableStream");
          if (ee.mime !== void 0 && ee.mime !== "application/pdf") throw new ct("invalid", "print takes a PDF (application/pdf)");
          if (we instanceof ArrayBuffer && we.byteLength > ya.maxPrintBytes) throw bn();
          if (we instanceof ArrayBuffer && !ac(we)) throw new ct("invalid", "the data is not a PDF");
        } catch (Qt) {
          throw await rt(), Qt;
        }
        const Bt = typeof a.api.printFrameUrl == "function" ? a.api.printFrameUrl() : "";
        if (!Bt)
          throw await rt(), new ct("unavailable", "this host offers no printing");
        if (_t)
          throw await rt(), new ct("unavailable", "another print is waiting for the person");
        _t = !0;
        try {
          let Qt;
          try {
            Qt = await xU(we instanceof ArrayBuffer ? we : te(we), ya.maxPrintBytes);
          } catch (Ot) {
            throw Ot instanceof ua ? Ot.code === "too_large" ? bn() : new ct(Ot.code, Ot.message) : Ot;
          }
          Et();
          const en = new AbortController();
          Pe = en, Ne.value = { text: Be(vt), shown: !1, width: 0, height: 0 }, await Gt();
          try {
            Ae = await AU(Bt, Qt, {
              mount: _e.value ?? c.value,
              label: ie(),
              look: Dt(),
              armMs: K1,
              signal: en.signal,
              onAsk: ({ width: Ot, height: kn }) => {
                Pe === en && Ne.value && (Ne.value = { ...Ne.value, shown: !0, width: Ot, height: kn });
              }
            });
          } catch (Ot) {
            throw Pe === en && (Ne.value = null), Ot instanceof ua ? new ct(Ot.code, Ot.message) : Ot;
          }
          return Ne.value && (Ne.value = { ...Ne.value, shown: !1 }), { printed: !0, size: Qt.size };
        } finally {
          _t = !1, Pe = null;
        }
      },
      async "engine.call"(Z) {
        if (!C.value.engine) throw new ct("unavailable", "this app has no module");
        $t("the app's module");
        const ee = Z ?? {};
        if (typeof ee.method != "string" || !ee.method) throw new ct("invalid", "method is required");
        return (await a.api.pluginUICall(a.app, a.view, {
          method: ee.method,
          params: ee.params,
          paths: (a.files ?? []).map((Ye) => Ye.path)
        })).result;
      },
      async "job.submit"(Z) {
        if (!C.value.engine) throw new ct("unavailable", "this app has no module");
        $t("the app's module");
        const ee = Z ?? {};
        if (typeof ee.action != "string" || !ee.action) throw new ct("invalid", "action is required");
        me() || await gt(Xe(await In(ee.action)));
        const Ye = (await a.api.pluginActionRun(a.app, ee.action, {
          paths: (a.files ?? []).map((rt) => rt.path),
          params: ee.params && typeof ee.params == "object" ? ee.params : {}
        })).op;
        if (!Ye) throw new ct("failed", "nothing was queued");
        return i("op", Ye), { op: Ye };
      },
      /* An encrypted session (the frame holds plaintext of an encrypted folder)
         reads and writes its own sealed store; a locked folder reads as an empty
         one. Any other session: the app's ordinary store, as always. */
      async "state.get"(Z) {
        const ee = String((Z == null ? void 0 : Z.key) ?? "");
        if (N.value) {
          const we = await K().catch(() => null);
          return we ? await UU(a.app, we, ee) ?? null : null;
        }
        return pU(a.app, ee) ?? null;
      },
      /**
       * 0.52.0: what the app's license says (`LicenseInfo`) - the status, and for a
       * valid license its dates. filex keeps the key and the licensee's name; the
       * app sees neither (only these three fields cross the bridge, whatever the
       * server answers). A free app reads `{status: "free"}`.
       */
      async "license.get"() {
        const Z = await a.api.pluginLicense(a.app), ee = { status: String(Z.status ?? "free") };
        return Z.valid_until && (ee.valid_until = Z.valid_until), Z.updates_until && (ee.updates_until = Z.updates_until), ee;
      },
      async "state.set"(Z) {
        const ee = Z ?? {};
        try {
          if (N.value) {
            const we = await K();
            if (!we) throw Q();
            await HU(a.app, we, String(ee.key ?? ""), ee.value);
          } else
            hU(a.app, String(ee.key ?? ""), ee.value);
        } catch (we) {
          throw we instanceof Sc ? new ct("too_large", we.message) : we instanceof W$ ? new ct("unavailable", I()) : we;
        }
        return null;
      },
      /* ── editing together (0.56, files:co-edit) ─────────────────────────── */
      async "coedit.join"(Z) {
        j("files:co-edit"), j("files:read");
        const we = re((Z ?? {}).index), Ye = Qu(we.encrypted), rt = a.e2e;
        if (Ye && (we.encrypted !== "folder" || !W(we) || typeof (rt == null ? void 0 : rt.folderKeys) != "function"))
          throw new ct("unavailable", "encrypted");
        const vt = Ye && (rt != null && rt.folderKeys) ? () => rt.folderKeys(we.path) : void 0, Bt = aa();
        if (!Bt) throw new ct("unavailable", "this host offers no editing together");
        const Qt = fn;
        fn = null, Qt && await Qt.leave();
        const en = await wp.join(Bt, we.path, {
          entry: (Ot) => m == null ? void 0 : m.emit("coedit.entry", Ot),
          cursor: (Ot) => m == null ? void 0 : m.emit("coedit.cursor", Ot),
          dropped: (Ot) => {
            fn === en && (fn = null), m == null || m.emit("coedit.dropped", Ot);
          }
        }, { folder: vt, outbox: Mn(), askUnsent: ve });
        if (!m)
          throw en.leave({ keepalive: !0 }), new ct("unavailable", "gone");
        return fn = en, en.hello();
      },
      "coedit.subscribe"(Z) {
        const ee = Z ?? {};
        return mn().subscribe(Number(ee.from ?? 0)), null;
      },
      async "coedit.append"(Z) {
        const ee = Z ?? {};
        return mn().append(ee.kind, ee.body);
      },
      async "coedit.lease"(Z) {
        const ee = Z ?? {};
        return { granted: await mn().lease(ee.op, Number(ee.changesSeen ?? 0)) };
      },
      "coedit.cursor"(Z) {
        return mn().cursor(Z == null ? void 0 : Z.cursor), null;
      },
      async "coedit.blob.put"(Z) {
        const ee = mn(), we = Z ?? {};
        if (!(we.data instanceof ArrayBuffer)) throw new ct("invalid", "a blob is an ArrayBuffer");
        return await ee.putBlob(String(we.name ?? ""), we.data), null;
      },
      async "coedit.blob.get"(Z) {
        const we = String((Z ?? {}).name ?? "");
        return { name: we, bytes: await mn().getBlob(we) };
      },
      async "coedit.leave"() {
        const Z = fn;
        return fn = null, await (Z == null ? void 0 : Z.leave()), null;
      }
    };
    let fn = null;
    function mn() {
      if (!fn) throw new ct("unavailable", "not in a session (coedit.join first)");
      return fn;
    }
    function aa() {
      const Z = a.api;
      return typeof Z.coeditJoin != "function" || typeof Z.coeditCall != "function" ? null : {
        join: (ee, we) => Z.coeditJoin(a.app, a.view, ee, we),
        call: (ee, we, Ye, rt) => Z.coeditCall(a.app, a.view, ee, we, Ye, rt),
        putBlob: (ee, we, Ye, rt) => Z.coeditBlobPut(a.app, a.view, ee, we, Ye, rt),
        getBlob: (ee, we, Ye) => Z.coeditBlobGet(a.app, a.view, ee, we, Ye)
      };
    }
    let zn = null;
    function Mn() {
      return zn ?? (zn = EH()), zn;
    }
    const rn = $(null);
    function ve(Z) {
      return rn.value ? Promise.resolve(null) : new Promise((ee) => {
        rn.value = { ...Z, resolve: ee };
      });
    }
    function Le(Z) {
      const ee = rn.value;
      rn.value = null, ee == null || ee.resolve(Z);
    }
    function He() {
      const Z = fn;
      fn = null, Z && Z.leave({ keepalive: !0 });
    }
    function Ke(Z) {
      const ee = St.value;
      St.value = null, ee == null || ee.resolve(Z);
    }
    function xt() {
      const Z = document.createElement("iframe");
      return Z.setAttribute("sandbox", "allow-scripts"), Z.setAttribute("referrerpolicy", "no-referrer"), Z.setAttribute("title", a.title || a.app), Z.className = "fe-appframe__frame", Z.dataset.testid = "app-frame", Z.setAttribute("src", L.value), Z;
    }
    function Qe() {
      if (ce(), !c.value) return;
      const Z = xt(), ee = JF({
        frame: () => Z,
        handlers: Cn,
        onConnect: () => {
          v.value = !0, i("connected");
        },
        onDisconnect: () => {
          v.value = !1;
        }
      });
      Z.addEventListener("load", () => ee.frameLoaded()), p = Z, m = ee, c.value.appendChild(Z);
    }
    function ce() {
      He(), rn.value && Le(null), m == null || m.destroy(), m = null, Et(), p && (p.remove(), p = null), v.value = !1, x.value = !1, St.value && Ke(!1), kt.value && ge(!1), w.value && nn("keep"), un.value && Kt(null);
    }
    let qe = null;
    const dt = ["pointerdown", "keydown", "touchstart"];
    jt(() => {
      se() && (Ie = Date.now());
      for (const ee of dt) window.addEventListener(ee, xe, !0);
      window.addEventListener("pagehide", He), Qe(), qe = z3((ee, we) => {
        ee !== a.app || !we || we === D.value || (T.value = we, oe(we));
      });
      const Z = D.value;
      if (Z) {
        const ee = mU(a.app);
        ee && ee !== Z && (A.value = Z), ee !== Z && C1(a.app, Z);
      }
    }), Tt(() => {
      for (const Z of dt) window.removeEventListener(Z, xe, !0);
      window.removeEventListener("pagehide", He), qe == null || qe(), qe = null, ce();
    }), Je([L, k], () => Qe()), Je(
      () => a.ui,
      () => {
        b.value = null;
      }
    ), Je(U, () => m == null ? void 0 : m.emit("theme", P())), Je(
      () => a.locale,
      (Z) => m == null ? void 0 : m.emit("locale", { locale: Z, dir: kl(Z) })
    );
    async function Nt() {
      if (!m || !v.value) return !1;
      try {
        return await m.ask("save"), !0;
      } catch {
        return !1;
      }
    }
    async function hn() {
      if (!x.value || !v.value)
        return le(), !0;
      const Z = await new Promise((ee) => {
        w.value = ee;
      });
      if (Z === "keep") return !1;
      if (Z === "save") {
        S.value = !0;
        try {
          if (!await Nt()) return !1;
        } finally {
          S.value = !1;
        }
      }
      return le(), !0;
    }
    function nn(Z) {
      const ee = w.value;
      w.value = null, ee == null || ee(Z);
    }
    function oe(Z) {
      m == null || m.emit("app.updated", { version: Z });
    }
    function le() {
      m == null || m.emit("close.request");
    }
    function Me() {
      k.value++;
    }
    async function Ve() {
      var we, Ye;
      if (!await hn()) return;
      const Z = T.value;
      let ee = null;
      try {
        const rt = await a.api.pluginActions();
        ee = ((we = rt.views.find((vt) => vt.plugin === a.app && vt.id === a.view && vt.ui)) == null ? void 0 : we.ui) ?? ((Ye = rt.actions.find((vt) => vt.plugin === a.app && vt.view === a.view && vt.ui)) == null ? void 0 : Ye.ui) ?? null;
      } catch {
      }
      T.value = "", A.value = "", ee && (b.value = ee, C1(a.app, ee.version || Z)), Me();
    }
    function it() {
      T.value = "", A.value = "";
    }
    return t({ requestSave: Nt, confirmClose: hn, notifyUpdated: oe, notifyClosing: le, reload: Me, reloadNewer: Ve, connected: v, dirty: x }), (Z, ee) => (f(), h("div", {
      ref_key: "host",
      ref: c,
      class: Re(["fe-appframe", `fe-appframe--${e.placement}`]),
      "data-app": e.app,
      "data-connected": v.value ? "true" : "false"
    }, [
      T.value || A.value ? (f(), h("div", IH, [
        d("span", NH, y(T.value ? u(o)("appframe.updated_reload", { app: e.title || e.app }) : u(o)("appframe.updated", { app: e.title || e.app, version: A.value })), 1),
        T.value ? (f(), h("button", {
          key: 0,
          type: "button",
          class: "fe-btn fe-btn--primary",
          "data-testid": "appframe-reload",
          onClick: Ve
        }, y(u(o)("appframe.reload")), 1)) : O("", !0),
        d("button", {
          type: "button",
          class: "fe-btn",
          "data-testid": "appframe-dismiss",
          onClick: it
        }, y(u(o)("appframe.dismiss")), 1)
      ])) : O("", !0),
      rn.value ? (f(), h("div", BH, [
        d("span", FH, y(rn.value.text), 1),
        d("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          "data-testid": "appframe-unsent-apply",
          onClick: ee[0] || (ee[0] = (we) => Le(!0))
        }, y(rn.value.apply), 1),
        d("button", {
          type: "button",
          class: "fe-btn",
          "data-testid": "appframe-unsent-discard",
          onClick: ee[1] || (ee[1] = (we) => Le(!1))
        }, y(rn.value.discard), 1)
      ])) : O("", !0),
      kt.value ? (f(), h("div", UH, [
        d("span", HH, y(kt.value.text), 1),
        d("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          "data-testid": "appframe-consent-allow",
          disabled: !ot.value,
          onClick: ee[2] || (ee[2] = (we) => ge(!0))
        }, y(u(o)("appframe.consent_allow")), 9, KH),
        d("button", {
          type: "button",
          class: "fe-btn",
          "data-testid": "appframe-consent-deny",
          onClick: ee[3] || (ee[3] = (we) => ge(!1))
        }, y(u(o)("appframe.consent_deny")), 1)
      ])) : O("", !0),
      Ne.value ? (f(), h("div", {
        key: 3,
        class: Re(["fe-appframe__note fe-appframe__consent fe-appframe__print", { "fe-appframe__print--parked": !Ne.value.shown }]),
        role: Ne.value.shown ? "alertdialog" : void 0,
        "aria-live": Ne.value.shown ? "assertive" : void 0,
        "aria-hidden": Ne.value.shown ? void 0 : "true",
        inert: Ne.value.shown ? void 0 : !0,
        "data-shown": Ne.value.shown ? "true" : "false",
        "data-testid": "appframe-print-ask"
      }, [
        d("span", jH, y(Ne.value.text), 1),
        d("span", {
          ref_key: "printSlot",
          ref: _e,
          class: "fe-appframe__print-slot",
          style: Wt(Ne.value.shown ? { width: `${Ne.value.width}px`, height: `${Ne.value.height}px` } : void 0)
        }, null, 4),
        d("button", {
          type: "button",
          class: "fe-btn",
          "data-testid": "appframe-print-deny",
          onClick: xn
        }, y(u(o)("appframe.consent_deny")), 1)
      ], 10, VH)) : O("", !0),
      St.value ? (f(), Ge(uT, {
        key: 4,
        open: !0,
        locale: e.locale,
        theme: e.theme,
        title: `${at.value}: ${St.value.title || u(o)("appframe.confirm_title")}`,
        message: St.value.text,
        danger: St.value.danger,
        onClose: ee[4] || (ee[4] = (we) => Ke(!1)),
        onConfirm: ee[5] || (ee[5] = (we) => Ke(!0))
      }, null, 8, ["locale", "theme", "title", "message", "danger"])) : O("", !0),
      w.value ? (f(), Ge(ta, {
        key: 5,
        open: !0,
        size: "sm",
        locale: e.locale,
        theme: e.theme,
        busy: S.value,
        title: u(o)("appframe.unsaved_title"),
        onClose: ee[9] || (ee[9] = (we) => nn("keep"))
      }, {
        actions: mt(() => [
          d("button", {
            type: "button",
            class: "fe-btn",
            "data-testid": "appframe-keep",
            disabled: S.value,
            onClick: ee[6] || (ee[6] = (we) => nn("keep"))
          }, y(u(o)("appframe.keep_open")), 9, WH),
          d("button", {
            type: "button",
            class: "fe-btn fe-btn--danger",
            "data-testid": "appframe-discard",
            disabled: S.value,
            onClick: ee[7] || (ee[7] = (we) => nn("discard"))
          }, y(u(o)("appframe.discard")), 9, YH),
          d("button", {
            type: "button",
            class: "fe-btn fe-btn--primary",
            "data-testid": "appframe-save-close",
            disabled: S.value,
            onClick: ee[8] || (ee[8] = (we) => nn("save"))
          }, y(u(o)("appframe.save_close")), 9, GH)
        ]),
        default: mt(() => [
          d("p", qH, y(u(o)("appframe.unsaved_text", { app: e.title || e.app })), 1)
        ]),
        _: 1
      }, 8, ["locale", "theme", "busy", "title"])) : O("", !0),
      un.value ? (f(), Ge(Dg, {
        key: 6,
        open: !0,
        api: e.api,
        locale: e.locale,
        theme: e.theme,
        mode: "save",
        title: bt(un.value.name),
        storages: un.value.storages,
        "start-at": un.value.startAt,
        onClose: ee[10] || (ee[10] = (we) => Kt(null)),
        onPick: Kt
      }, null, 8, ["api", "locale", "theme", "title", "storages", "start-at"])) : O("", !0)
    ], 10, RH));
  }
}), XH = ["data-testid"], JH = { class: "fe-inspector__heading fe-pinsp__heading" }, ZH = ["aria-expanded", "aria-controls", "data-testid"], QH = ["id"], eK = ["id"], tK = {
  key: 0,
  class: "fe-inspector__empty"
}, nK = {
  key: 1,
  class: "fe-surface__error",
  role: "alert"
}, aK = {
  key: 0,
  class: "fe-pinsp__actions"
}, iK = /* @__PURE__ */ lt({
  __name: "PluginInspectorSection",
  props: {
    api: {},
    view: {},
    path: {},
    locale: {},
    theme: {},
    storages: {},
    node: {},
    writable: { type: Boolean },
    userName: {}
  },
  emits: ["op", "toast", "open"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = pt(() => n.locale), o = $(!1), l = $(!1), c = $(""), p = Gp(
      {
        api: n.api,
        plugin: n.view.plugin,
        view: n.view.id,
        path: () => n.path,
        locale: () => n.locale,
        errorText: () => i("plugin.view.error")
      },
      {
        onOp: (k) => a("op", k),
        onOpen: (k) => a("open", k),
        // The conversation ended (a job was queued, or the plugin said `done`):
        // what the section shows next is the view's fresh state.
        onDone: () => void x(),
        onToast: (k) => a("toast", k)
      }
    ), m = E(() => Xt(n.view.label, n.locale) || n.view.id), v = E(() => `fe-plugin-insp-${n.view.plugin}-${n.view.id}`);
    async function x() {
      var k;
      l.value = !0, c.value = "";
      try {
        const b = await n.api.pluginView(n.view.plugin, n.view.id, n.path);
        p.setSurface((b == null ? void 0 : b.surface) ?? null), b != null && b.surface || (c.value = i("plugin.view.error"));
      } catch (b) {
        p.setSurface(null), c.value = ((k = i.foreign) == null ? void 0 : k.call(i, String((b == null ? void 0 : b.message) ?? b))) || i("plugin.view.error");
      } finally {
        l.value = !1;
      }
    }
    const w = E(
      () => n.node && n.node.type === "file" ? [{
        path: n.node.path,
        name: n.node.basename,
        size: n.node.size,
        mime: n.node.mime_type,
        readOnly: n.writable === !1 || !!n.node.read_only,
        ...n.node.encrypted ? { encrypted: n.node.encrypted } : {}
      }] : []
    );
    function S() {
      o.value = !o.value, !n.view.ui && o.value && !p.current.value && !l.value && x();
    }
    return Je(
      () => n.path,
      () => {
        o.value = !1, c.value = "", p.setSurface(null);
      }
    ), (k, b) => (f(), h("section", {
      class: "fe-inspector__section fe-pinsp",
      "data-testid": `inspector-plugin-${e.view.plugin}-${e.view.id}`
    }, [
      d("h3", JH, [
        d("button", {
          type: "button",
          class: "fe-pinsp__toggle",
          "aria-expanded": o.value,
          "aria-controls": v.value,
          "data-testid": `inspector-plugin-toggle-${e.view.plugin}-${e.view.id}`,
          onClick: S
        }, [
          (f(), h("svg", {
            class: Re(["fe-ficon fe-pinsp__chev", { "is-open": o.value }]),
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "aria-hidden": "true",
            focusable: "false"
          }, [...b[2] || (b[2] = [
            d("path", { d: "M9 5l7 7-7 7" }, null, -1)
          ])], 2)),
          d("span", null, y(m.value), 1)
        ], 8, ZH)
      ]),
      o.value && e.view.ui ? (f(), h("div", {
        key: 0,
        id: v.value,
        class: "fe-pinsp__body"
      }, [
        (f(), Ge(Fg, {
          key: e.path,
          api: e.api,
          app: e.view.plugin,
          version: e.view.ui.version,
          view: e.view.id,
          placement: "inspector",
          ui: e.view.ui,
          files: w.value,
          storages: e.storages,
          "start-at": e.path,
          locale: e.locale,
          theme: e.theme,
          title: m.value,
          "user-name": e.userName,
          onToast: b[0] || (b[0] = (C) => a("toast", C.text)),
          onOp: b[1] || (b[1] = (C) => a("op", C))
        }, null, 8, ["api", "app", "version", "view", "ui", "files", "storages", "start-at", "locale", "theme", "title", "user-name"]))
      ], 8, QH)) : o.value ? (f(), h("div", {
        key: 1,
        id: v.value,
        class: "fe-pinsp__body"
      }, [
        l.value ? (f(), h("p", tK, y(u(i)("plugin.view.loading")), 1)) : c.value ? (f(), h("p", nK, y(c.value), 1)) : u(p).current.value ? (f(), h(Te, { key: 2 }, [
          Ze(Xp, {
            conv: u(p),
            locale: e.locale,
            theme: e.theme,
            api: e.api,
            plugin: e.view.plugin,
            storages: e.storages,
            "start-at": e.path
          }, null, 8, ["conv", "locale", "theme", "api", "plugin", "storages", "start-at"]),
          u(p).footer.value.length ? (f(), h("div", aK, [
            Ze(Jp, {
              conv: u(p),
              locale: e.locale,
              "testid-prefix": "inspector-plugin",
              small: ""
            }, null, 8, ["conv", "locale"])
          ])) : O("", !0)
        ], 64)) : O("", !0)
      ], 8, eK)) : O("", !0)
    ], 8, XH));
  }
}), oK = ["aria-label"], rK = { class: "fe-inspector__head" }, sK = ["innerHTML"], lK = { class: "fe-inspector__head-text" }, uK = ["title"], cK = { class: "fe-inspector__caption" }, dK = {
  key: 0,
  class: "fe-inspector__held",
  role: "note",
  "data-testid": "inspector-held"
}, fK = ["title", "aria-label"], pK = ["innerHTML"], hK = ["title", "aria-label"], mK = ["innerHTML"], vK = ["aria-label"], yK = ["aria-selected"], gK = ["aria-selected"], bK = { class: "fe-inspector__scroll" }, kK = {
  key: 0,
  class: "fe-inspector__section"
}, wK = { class: "fe-inspector__heading" }, _K = {
  key: 0,
  class: "fe-inspector__lock",
  role: "note",
  "data-testid": "inspector-lock"
}, xK = ["data-link-state"], SK = {
  key: 2,
  class: "fe-inspector__unavailable",
  role: "note",
  "data-testid": "inspector-unavailable"
}, $K = {
  key: 3,
  class: "fe-inspector__meta"
}, TK = { class: "fe-inspector__row" }, AK = ["title"], EK = ["src"], CK = { class: "fe-inspector__meta" }, zK = { class: "fe-inspector__row" }, MK = { class: "fe-inspector__row" }, PK = { class: "fe-inspector__pathcell" }, OK = ["title"], LK = ["title", "aria-label"], DK = ["innerHTML"], RK = {
  key: 0,
  class: "fe-inspector__row"
}, IK = { class: "fe-inspector__row" }, NK = {
  key: 1,
  class: "fe-inspector__row"
}, BK = { class: "fe-inspector__mime" }, FK = {
  key: 2,
  class: "fe-inspector__row"
}, UK = { class: "fe-inspector__pathcell" }, HK = { class: "fe-inspector__path" }, KK = ["title", "aria-label"], VK = ["innerHTML"], jK = {
  key: 3,
  class: "fe-inspector__row"
}, qK = { class: "fe-inspector__pathcell" }, WK = ["title"], YK = ["title", "aria-label"], GK = ["innerHTML"], XK = {
  key: 5,
  class: "fe-inspector__empty"
}, JK = {
  key: 1,
  class: "fe-inspector__section",
  "data-testid": "inspector-tags"
}, ZK = { class: "fe-inspector__heading" }, QK = {
  key: 3,
  class: "fe-inspector__section"
}, e9 = { class: "fe-inspector__heading" }, t9 = {
  key: 0,
  class: "fe-inspector__empty"
}, n9 = {
  key: 0,
  class: "fe-inspector__empty"
}, a9 = {
  key: 1,
  class: "fe-inspector__versions"
}, i9 = { class: "fe-inspector__version-main" }, o9 = { class: "fe-inspector__version-n" }, r9 = { class: "fe-inspector__version-meta" }, s9 = {
  key: 0,
  class: "fe-inspector__confirm"
}, l9 = { class: "fe-inspector__confirm-q" }, u9 = { class: "fe-inspector__check" }, c9 = { class: "fe-inspector__confirm-actions" }, d9 = ["disabled", "aria-busy", "onClick"], f9 = ["disabled"], p9 = ["disabled", "onClick"], h9 = ["disabled", "aria-busy"], m9 = {
  key: 4,
  class: "fe-inspector__section"
}, v9 = { class: "fe-inspector__heading" }, y9 = { class: "fe-inspector__permrow" }, g9 = {
  key: 5,
  class: "fe-inspector__section",
  "data-testid": "inspector-people"
}, b9 = { class: "fe-inspector__heading" }, k9 = {
  key: 0,
  class: "fe-inspector__empty"
}, w9 = {
  key: 1,
  class: "fe-inspector__people"
}, _9 = {
  class: "fe-inspector__avatar",
  "aria-hidden": "true"
}, x9 = { class: "fe-inspector__person-main" }, S9 = ["title"], $9 = { class: "fe-inspector__person-sub" }, T9 = {
  key: 6,
  class: "fe-inspector__section",
  "data-testid": "inspector-shares"
}, A9 = { class: "fe-inspector__heading" }, E9 = {
  key: 0,
  class: "fe-inspector__linkrow"
}, C9 = ["innerHTML"], z9 = { class: "fe-inspector__linknone" }, M9 = ["disabled"], P9 = {
  key: 1,
  class: "fe-inspector__empty"
}, O9 = {
  key: 2,
  class: "fe-inspector__shares"
}, L9 = ["title"], D9 = {
  key: 0,
  class: "fe-inspector__badge fe-inspector__badge--pin"
}, R9 = {
  key: 1,
  class: "fe-inspector__share-exp"
}, I9 = ["title", "aria-label", "onClick"], N9 = ["innerHTML"], B9 = {
  key: 7,
  class: "fe-inspector__section"
}, F9 = { class: "fe-inspector__heading" }, U9 = {
  key: 0,
  class: "fe-inspector__countbadge"
}, H9 = {
  key: 0,
  class: "fe-inspector__empty"
}, K9 = {
  key: 0,
  class: "fe-inspector__empty"
}, V9 = {
  key: 1,
  class: "fe-inspector__comments"
}, j9 = { class: "fe-inspector__comment-top" }, q9 = ["title"], W9 = ["title"], Y9 = ["disabled", "title", "aria-label", "onClick"], G9 = { class: "fe-inspector__comment-body" }, X9 = ["placeholder", "aria-label", "disabled"], J9 = ["disabled"], Z9 = {
  key: 8,
  class: "fe-inspector__section",
  "data-testid": "inspector-activity-empty"
}, Q9 = { class: "fe-inspector__empty" }, e7 = {
  key: 0,
  class: "fe-inspector__hint"
}, t7 = /* @__PURE__ */ lt({
  __name: "InspectorPanel",
  props: {
    api: {},
    nodes: {},
    dirLabel: {},
    dirCount: {},
    dirPerm: { default: "" },
    heldIn: {},
    locale: {},
    narrow: { type: Boolean, default: !1 },
    callerAdmin: { type: Boolean },
    sharing: {},
    inEncrypted: { type: Boolean },
    thumbSrc: { type: Function, default: void 0 },
    tabs: { type: Boolean, default: !0 },
    apiBase: {},
    authHeaders: {},
    authCredentials: {},
    pluginViews: { default: () => [] },
    theme: {},
    storages: {},
    userName: {}
  },
  emits: ["close", "share-created", "manage-permissions", "toast", "changed", "tags-changed", "open-tag", "plugin-op", "plugin-open"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i, formatSize: o, formatNodeSize: l, nodeSizeHint: c, formatDate: p, nodeDisplayName: m, nodeName: v } = pt(
      () => n.locale
    );
    function x(_e) {
      if (typeof _e.e2e_display_dir != "string" || typeof _e.e2e_stored != "string") return _e.path;
      const Ae = _e.path.indexOf("://");
      return `${Ae === -1 ? "" : _e.path.slice(0, Ae + 3)}${_e.e2e_display_dir ? `${_e.e2e_display_dir}/` : ""}${_e.basename}`;
    }
    const w = E(
      () => n.nodes.length === 1 ? n.nodes[0] : null
    ), S = E(() => n.nodes.length > 1), k = E(() => Yr(qc(w.value), { t: i, formatDate: p, locale: n.locale })), b = E(() => Wc(w.value, { t: i })), C = E(() => Yc(w.value, { t: i })), T = E(() => {
      var _e;
      return ((_e = w.value) == null ? void 0 : _e.type) === "file";
    }), A = E(
      () => {
        var _e;
        return typeof ((_e = w.value) == null ? void 0 : _e.id) == "number" ? w.value.id : null;
      }
    ), L = E(
      () => n.nodes.reduce((_e, Ae) => _e + (typeof Ae.size == "number" ? Ae.size : 0), 0)
    ), z = E(() => ({
      size: L.value,
      size_partial: n.nodes.some((_e) => _e.size_partial === !0)
    })), D = E(() => {
      var Ae;
      const _e = (Ae = w.value) == null ? void 0 : Ae.etag;
      return typeof _e == "string" && _e !== "" ? _e : null;
    }), U = E(
      () => w.value && T.value && n.thumbSrc ? n.thumbSrc(w.value) : null
    ), q = E(() => {
      const _e = w.value;
      return !_e || cc(_e) || _e.trashed === !0 ? [] : (n.pluginViews ?? []).filter(
        (Ae) => Ae.placement === "inspector" && tg(Ae.applies, [_e], Ae.plugin)
      );
    }), P = E(() => S.value ? i("inspector.items", { n: n.nodes.length }) : w.value ? m(w.value) : n.dirLabel), R = E(() => {
      if (S.value) return l(z.value);
      const _e = w.value;
      if (_e) {
        const Ae = jv(_e, i);
        if (_e.type === "dir") return Ae;
        const Pe = typeof _e.size == "number" ? o(_e.size) : "";
        return Pe ? `${Ae} · ${Pe}` : Ae;
      }
      return i("inspector.folder_items", { n: n.dirCount });
    }), W = E(
      () => {
        var _e;
        return U.value && /^(image|video)[/]/.test(String(((_e = w.value) == null ? void 0 : _e.mime_type) ?? "")) ? U.value : null;
      }
    ), N = E(
      () => wa(w.value && !S.value ? w.value : { type: "dir" })
    ), J = E(
      () => A.value != null && n.apiBase !== void 0 && !S.value
    );
    function H(_e) {
      return _e.length > 12 ? `${_e.slice(0, 12)}…` : _e;
    }
    function ne(_e) {
      return p(_e, { time: !0 }) || "-";
    }
    function j(_e) {
      if (!_e) return "-";
      const Ae = Date.parse(_e);
      return Number.isNaN(Ae) ? _e : ne(Ae);
    }
    async function re(_e) {
      try {
        await navigator.clipboard.writeText(_e), a("toast", i("inspector.copied"));
      } catch {
        a("toast", _e);
      }
    }
    const he = E(() => {
      if (!w.value) return "";
      const _e = w.value.perm;
      return typeof _e == "string" && _e !== "" ? _e : n.dirPerm || "";
    }), ue = E(() => n.sharing ?? P5), ae = E(() => GS(n.nodes, n.inEncrypted === !0)), fe = E(() => he.value === "owner" && ue.value.users);
    function _(_e) {
      return i(`inspector.perm.${_e}`) === `inspector.perm.${_e}` ? _e : i(`inspector.perm.${_e}`);
    }
    const Q = $("idle"), K = $([]), I = $(null), Y = $(!0), B = $(null), V = E(() => B.value !== null), be = $("idle"), Fe = $([]);
    let ze = 0;
    async function Ue() {
      const _e = ++ze;
      if (I.value = null, K.value = [], Fe.value = [], w.value && T.value && A.value != null ? (Q.value = "loading", We(_e)) : Q.value = "hidden", w.value) {
        be.value = "loading";
        const Ae = w.value.path;
        try {
          const { shares: Pe } = await n.api.listShares(Ae);
          if (_e !== ze) return;
          Fe.value = Array.isArray(Pe) ? Pe : [], be.value = "ok";
        } catch {
          if (_e !== ze) return;
          be.value = "hidden";
        }
      } else
        be.value = "hidden";
    }
    async function We(_e) {
      const Ae = A.value;
      if (Ae != null)
        try {
          const Pe = await n.api.listVersions(Ae);
          if (_e !== ze) return;
          K.value = Pe, Q.value = "ok";
        } catch (Pe) {
          if (_e !== ze) return;
          const _t = Pe.status;
          _t === 401 || _t === 403 || _t === 404 ? Q.value = "hidden" : Q.value = "error";
        }
    }
    function $t(_e) {
      I.value = _e.id, Y.value = !0;
    }
    async function St(_e) {
      const Ae = A.value;
      if (!(Ae == null || V.value)) {
        B.value = "restore";
        try {
          await n.api.restoreVersion(Ae, _e.id, Y.value), a("toast", i("inspector.versions.restored")), I.value = null, a("changed"), await We(++ze);
        } catch (Pe) {
          const _t = cy(Pe);
          a("toast", _t ? Yr(_t, { t: i, formatDate: p, locale: n.locale }) : Pe.message);
        } finally {
          B.value = null;
        }
      }
    }
    async function at() {
      const _e = A.value;
      if (!(_e == null || V.value)) {
        B.value = "snapshot";
        try {
          await n.api.snapshotVersion(_e), a("toast", i("inspector.versions.snapshotted")), await We(++ze);
        } catch (Ae) {
          const Pe = Ae.status;
          Pe === 404 || Pe === 405 || Pe === 501 ? a("toast", i("inspector.versions.unsupported")) : a("toast", Ae.message);
        } finally {
          B.value = null;
        }
      }
    }
    const kt = $("details"), ht = $("hidden"), Ie = $([]);
    let se = 0;
    async function xe() {
      const _e = ++se, Ae = w.value;
      if (!n.tabs || !Ae) {
        ht.value = "hidden", Ie.value = [];
        return;
      }
      ht.value = "loading";
      try {
        const Pe = await n.api.listPermissions(Ae.path);
        if (_e !== se) return;
        if (!Pe.storage_rbac) {
          ht.value = "hidden", Ie.value = [];
          return;
        }
        Ie.value = [...Pe.direct ?? [], ...Pe.inherited ?? []], ht.value = "ok";
      } catch {
        if (_e !== se) return;
        Ie.value = [], ht.value = "hidden";
      }
    }
    function me(_e) {
      return _e.kind === "group" ? { name: _e.group_name } : { name: _e.user_name, display_name: _e.user_display_name, email: _e.user_email };
    }
    function De(_e) {
      return Yp(me(_e)) || `#${_e.kind === "group" ? _e.group_id : _e.user_id}`;
    }
    function ot(_e) {
      return w8(me(_e), gi(n.locale)) || (_e.kind === "group" ? "#" : "?");
    }
    E(() => Fe.value.length ? Fe.value[0] : null);
    const ft = $(!1);
    async function gt() {
      var Ae;
      const _e = w.value;
      if (!(!_e || ft.value || !ue.value.links || ae.value)) {
        ft.value = !0;
        try {
          const _t = ((Ae = (await n.api.createShare({ path: _e.path })).share) == null ? void 0 : Ae.url) ?? "", { shares: Et } = await n.api.listShares(_e.path);
          Fe.value = Array.isArray(Et) ? Et : [], be.value = "ok", _t && (a("share-created", { path: _e.path, url: _t }), await re(_t));
        } catch (Pe) {
          a("toast", Pe.message);
        } finally {
          ft.value = !1;
        }
      }
    }
    Je(
      () => [n.nodes.map((_e) => _e.path).join("|"), n.tabs],
      () => void xe(),
      { immediate: !0 }
    );
    const Ut = E(
      () => Q.value !== "hidden" || Xe.value !== "hidden"
    );
    Je(
      () => n.nodes.map((_e) => _e.path).join("\0"),
      () => void Ue(),
      { immediate: !0 }
    );
    const Xe = $("hidden"), je = $([]), Be = $("");
    Je(Be, (_e) => {
      const Ae = Dy(_e, Pc("comment_max_runes"));
      Ae !== _e && (Be.value = Ae);
    });
    const ie = $(!1), ge = E(
      () => {
        var _e;
        return typeof ((_e = w.value) == null ? void 0 : _e.id) == "number" ? w.value.id : null;
      }
    );
    let G = 0;
    async function ye() {
      const _e = ++G, Ae = ge.value;
      if (Ae == null) {
        Xe.value = "hidden", je.value = [];
        return;
      }
      Xe.value = je.value.length > 0 ? "ok" : "loading";
      try {
        const Pe = await n.api.listComments(Ae);
        if (_e !== G) return;
        je.value = Pe, Xe.value = "ok";
      } catch (Pe) {
        if (_e !== G) return;
        je.value = [];
        const _t = Pe.status;
        Xe.value = _t === 401 || _t === 403 || _t === 404 ? "hidden" : "error";
      }
    }
    async function te() {
      const _e = ge.value, Ae = Be.value.trim();
      if (!(_e == null || Ae === "" || ie.value)) {
        ie.value = !0;
        try {
          await n.api.addComment(_e, Ae), Be.value = "", await ye();
        } catch (Pe) {
          a("toast", Pe.message);
        } finally {
          ie.value = !1;
        }
      }
    }
    async function Ce(_e) {
      if (!ie.value) {
        ie.value = !0;
        try {
          await n.api.deleteComment(_e.id), await ye();
        } catch (Ae) {
          a("toast", Ae.message);
        } finally {
          ie.value = !1;
        }
      }
    }
    function Ne(_e) {
      const Ae = Date.parse(_e);
      if (Number.isNaN(Ae)) return _e;
      const Pe = Math.round((Ae - Date.now()) / 1e3), _t = Math.abs(Pe), Et = [
        ["year", 31536e3],
        ["month", 2592e3],
        ["day", 86400],
        ["hour", 3600],
        ["minute", 60]
      ];
      try {
        const xn = new Intl.RelativeTimeFormat(
          gi(n.locale),
          { numeric: "auto" }
        );
        for (const [Dt, bn] of Et)
          if (_t >= bn) return xn.format(Math.trunc(Pe / bn), Dt);
        return xn.format(Pe, "second");
      } catch {
        return j(_e);
      }
    }
    return Je(
      () => ge.value,
      () => {
        je.value = [], Be.value = "", ye();
      },
      { immediate: !0 }
    ), (_e, Ae) => (f(), h("aside", {
      class: Re(["fe-inspector", { "fe-inspector--overlay": e.narrow }]),
      role: "complementary",
      "aria-label": u(i)("inspector.title")
    }, [
      d("header", rK, [
        d("span", {
          class: "fe-inspector__head-icon",
          "aria-hidden": "true",
          innerHTML: N.value
        }, null, 8, sK),
        d("div", lK, [
          d("h2", {
            class: "fe-inspector__title",
            title: P.value
          }, [
            d("bdi", null, y(P.value), 1)
          ], 8, uK),
          d("p", cK, y(R.value), 1),
          e.heldIn ? (f(), h("p", dK, y(u(i)("inspector.held", { where: e.heldIn })), 1)) : O("", !0)
        ]),
        w.value ? (f(), h("button", {
          key: 0,
          type: "button",
          class: "fe-inspector__iconbtn",
          title: u(i)("inspector.copy_name"),
          "aria-label": u(i)("inspector.copy_name"),
          "data-testid": "inspector-copy-name",
          onClick: Ae[0] || (Ae[0] = (Pe) => re(w.value ? u(v)(w.value) : P.value))
        }, [
          d("span", {
            "aria-hidden": "true",
            innerHTML: u(zt)("copy")
          }, null, 8, pK)
        ], 8, fK)) : O("", !0),
        d("button", {
          type: "button",
          class: "fe-inspector__iconbtn fe-inspector__close",
          title: u(i)("inspector.close"),
          "aria-label": u(i)("inspector.close"),
          onClick: Ae[1] || (Ae[1] = (Pe) => a("close"))
        }, [
          d("span", {
            "aria-hidden": "true",
            innerHTML: u(zt)("close")
          }, null, 8, mK)
        ], 8, hK)
      ]),
      e.tabs ? (f(), h("div", {
        key: 0,
        class: "fe-inspector__tabs",
        role: "tablist",
        "aria-label": u(i)("inspector.title")
      }, [
        d("button", {
          type: "button",
          class: Re(["fe-inspector__tab", { "is-active": kt.value === "details" }]),
          role: "tab",
          "aria-selected": kt.value === "details",
          "data-testid": "inspector-tab-details",
          onClick: Ae[2] || (Ae[2] = (Pe) => kt.value = "details")
        }, y(u(i)("inspector.tab.details")), 11, yK),
        d("button", {
          type: "button",
          class: Re(["fe-inspector__tab", { "is-active": kt.value === "activity" }]),
          role: "tab",
          "aria-selected": kt.value === "activity",
          "data-testid": "inspector-tab-activity",
          onClick: Ae[3] || (Ae[3] = (Pe) => kt.value = "activity")
        }, y(u(i)("inspector.tab.activity")), 11, gK)
      ], 8, vK)) : O("", !0),
      d("div", bK, [
        !e.tabs || kt.value === "details" ? (f(), h("section", kK, [
          d("h3", wK, y(u(i)("inspector.section.general")), 1),
          k.value ? (f(), h("p", _K, [
            Ae[18] || (Ae[18] = d("span", { "aria-hidden": "true" }, "🔒", -1)),
            d("span", null, [
              d("strong", null, y(u(i)("applock.inspector")), 1),
              Ae[17] || (Ae[17] = d("br", null, null, -1)),
              Ht(y(k.value), 1)
            ])
          ])) : O("", !0),
          b.value ? (f(), h("p", {
            key: 1,
            class: "fe-inspector__linknote",
            role: "note",
            "data-testid": "inspector-symlink",
            "data-link-state": b.value.state
          }, [
            Ae[20] || (Ae[20] = d("span", { "aria-hidden": "true" }, "🔗", -1)),
            d("span", null, [
              d("strong", null, y(u(i)("symlink.inspector")), 1),
              Ae[19] || (Ae[19] = d("br", null, null, -1)),
              Ht(y(b.value.why), 1)
            ])
          ], 8, xK)) : O("", !0),
          C.value ? (f(), h("p", SK, [
            Ae[23] || (Ae[23] = d("span", { "aria-hidden": "true" }, "!", -1)),
            d("span", null, [
              d("strong", null, y(u(i)("unavailable.inspector")), 1),
              Ae[22] || (Ae[22] = d("br", null, null, -1)),
              Ht(y(C.value.why) + " ", 1),
              C.value.reason ? (f(), h(Te, { key: 0 }, [
                Ae[21] || (Ae[21] = d("br", null, null, -1)),
                d("bdi", null, y(C.value.reason), 1)
              ], 64)) : O("", !0)
            ])
          ])) : O("", !0),
          S.value ? (f(), h("dl", $K, [
            d("div", TK, [
              d("dt", null, y(u(i)("inspector.size")), 1),
              d("dd", {
                title: u(c)(z.value)
              }, y(u(l)(z.value)), 9, AK)
            ])
          ])) : w.value ? (f(), h(Te, { key: 4 }, [
            W.value ? (f(), h("img", {
              key: 0,
              class: "fe-inspector__preview",
              src: W.value,
              alt: "",
              "aria-hidden": "true"
            }, null, 8, EK)) : O("", !0),
            d("dl", CK, [
              d("div", zK, [
                d("dt", null, y(u(i)("inspector.type")), 1),
                d("dd", null, y(u(jv)(w.value, u(i))), 1)
              ]),
              d("div", MK, [
                d("dt", null, y(u(i)("inspector.path")), 1),
                d("dd", PK, [
                  d("span", {
                    class: "fe-inspector__path",
                    title: w.value.path
                  }, [
                    d("bdi", null, y(x(w.value)), 1)
                  ], 8, OK),
                  d("button", {
                    type: "button",
                    class: "fe-inspector__copy",
                    title: u(i)("inspector.copy"),
                    "aria-label": u(i)("inspector.copy"),
                    onClick: Ae[4] || (Ae[4] = (Pe) => re(w.value.path))
                  }, [
                    d("span", {
                      "aria-hidden": "true",
                      innerHTML: u(zt)("copy")
                    }, null, 8, DK)
                  ], 8, LK)
                ])
              ]),
              T.value ? (f(), h("div", RK, [
                d("dt", null, y(u(i)("inspector.size")), 1),
                d("dd", null, y(u(o)(typeof w.value.size == "number" ? w.value.size : null)), 1)
              ])) : O("", !0),
              d("div", IK, [
                d("dt", null, y(u(i)("inspector.modified")), 1),
                d("dd", null, y(ne(w.value.last_modified)), 1)
              ]),
              T.value && w.value.mime_type ? (f(), h("div", NK, [
                d("dt", null, y(u(i)("inspector.mime")), 1),
                d("dd", BK, y(w.value.mime_type), 1)
              ])) : O("", !0),
              e.callerAdmin && typeof w.value.id == "number" ? (f(), h("div", FK, [
                d("dt", null, y(u(i)("inspector.nodeId")), 1),
                d("dd", UK, [
                  d("span", HK, y(w.value.id), 1),
                  d("button", {
                    type: "button",
                    class: "fe-inspector__copy",
                    title: u(i)("inspector.copy"),
                    "aria-label": u(i)("inspector.copy"),
                    onClick: Ae[5] || (Ae[5] = (Pe) => re(String(w.value.id)))
                  }, [
                    d("span", {
                      "aria-hidden": "true",
                      innerHTML: u(zt)("copy")
                    }, null, 8, VK)
                  ], 8, KK)
                ])
              ])) : O("", !0),
              D.value ? (f(), h("div", jK, [
                d("dt", null, y(u(i)("inspector.etag")), 1),
                d("dd", qK, [
                  d("span", {
                    class: "fe-inspector__path",
                    title: D.value
                  }, y(H(D.value)), 9, WK),
                  d("button", {
                    type: "button",
                    class: "fe-inspector__copy",
                    title: u(i)("inspector.copy"),
                    "aria-label": u(i)("inspector.copy"),
                    onClick: Ae[6] || (Ae[6] = (Pe) => re(D.value))
                  }, [
                    d("span", {
                      "aria-hidden": "true",
                      innerHTML: u(zt)("copy")
                    }, null, 8, GK)
                  ], 8, YK)
                ])
              ])) : O("", !0)
            ])
          ], 64)) : (f(), h("p", XK, y(u(i)("inspector.select_hint")), 1))
        ])) : O("", !0),
        J.value && (!e.tabs || kt.value === "details") ? (f(), h("section", JK, [
          d("h3", ZK, y(u(i)("inspector.section.tags")), 1),
          Ze(wx, {
            "node-id": A.value,
            locale: e.locale,
            "api-base": e.apiBase,
            "auth-headers": e.authHeaders,
            "auth-credentials": e.authCredentials,
            onChange: Ae[7] || (Ae[7] = (Pe) => a("tags-changed", Pe)),
            onOpen: Ae[8] || (Ae[8] = (Pe, _t) => a("open-tag", Pe, _t)),
            onError: Ae[9] || (Ae[9] = () => a("toast", u(i)("inspector.error")))
          }, null, 8, ["node-id", "locale", "api-base", "auth-headers", "auth-credentials"])
        ])) : O("", !0),
        w.value && (!e.tabs || kt.value === "details") ? (f(!0), h(Te, { key: 2 }, nt(q.value, (Pe) => (f(), Ge(iK, {
          key: `${Pe.plugin}/${Pe.id}`,
          api: e.api,
          view: Pe,
          path: w.value.path,
          node: w.value,
          locale: e.locale,
          theme: e.theme,
          storages: e.storages,
          "user-name": e.userName,
          onOp: Ae[10] || (Ae[10] = (_t) => a("plugin-op", _t)),
          onToast: Ae[11] || (Ae[11] = (_t) => a("toast", _t)),
          onOpen: (_t) => a("plugin-open", { plugin: Pe.plugin, req: _t })
        }, null, 8, ["api", "view", "path", "node", "locale", "theme", "storages", "user-name", "onOpen"]))), 128)) : O("", !0),
        (Q.value === "ok" || Q.value === "error") && (!e.tabs || kt.value === "activity") ? (f(), h("section", QK, [
          d("h3", e9, y(u(i)("inspector.section.versions")), 1),
          Q.value === "error" ? (f(), h("p", t9, y(u(i)("inspector.error")), 1)) : (f(), h(Te, { key: 1 }, [
            K.value.length === 0 ? (f(), h("p", n9, y(u(i)("inspector.versions.empty")), 1)) : (f(), h("ul", a9, [
              (f(!0), h(Te, null, nt(K.value, (Pe) => (f(), h("li", {
                key: Pe.id,
                class: "fe-inspector__version"
              }, [
                d("div", i9, [
                  d("span", o9, y(u(i)("inspector.versions.v", { n: Pe.version_n })), 1),
                  d("span", r9, y(j(Pe.created_at)) + " · " + y(u(o)(Pe.size)), 1)
                ]),
                I.value === Pe.id ? (f(), h("div", s9, [
                  d("p", l9, y(u(i)("inspector.versions.restore_confirm")), 1),
                  d("label", u9, [
                    ln(d("input", {
                      "onUpdate:modelValue": Ae[12] || (Ae[12] = (_t) => Y.value = _t),
                      type: "checkbox"
                    }, null, 512), [
                      [zc, Y.value]
                    ]),
                    Ht(" " + y(u(i)("inspector.versions.snapshot_current")), 1)
                  ]),
                  d("div", c9, [
                    d("button", {
                      type: "button",
                      class: "fe-btn fe-btn--primary fe-btn--sm",
                      disabled: V.value,
                      "aria-busy": B.value === "restore",
                      onClick: (_t) => St(Pe)
                    }, y(B.value === "restore" ? u(i)("inspector.versions.restoring") : u(i)("inspector.versions.confirm")), 9, d9),
                    d("button", {
                      type: "button",
                      class: "fe-btn fe-btn--sm",
                      disabled: V.value,
                      onClick: Ae[13] || (Ae[13] = (_t) => I.value = null)
                    }, y(u(i)("inspector.versions.cancel")), 9, f9)
                  ])
                ])) : (f(), h("button", {
                  key: 1,
                  type: "button",
                  class: "fe-btn fe-btn--sm",
                  disabled: V.value,
                  onClick: (_t) => $t(Pe)
                }, y(u(i)("inspector.versions.restore")), 9, p9))
              ]))), 128))
            ])),
            d("button", {
              type: "button",
              class: "fe-btn fe-btn--sm fe-inspector__snapshot",
              disabled: V.value,
              "aria-busy": B.value === "snapshot",
              onClick: at
            }, y(B.value === "snapshot" ? u(i)("inspector.versions.snapshotting") : u(i)("inspector.versions.take_snapshot")), 9, h9)
          ], 64))
        ])) : O("", !0),
        w.value && he.value && (!e.tabs || kt.value === "details") && !(e.tabs && ht.value === "ok") ? (f(), h("section", m9, [
          d("h3", v9, y(u(i)("inspector.section.permissions")), 1),
          d("div", y9, [
            d("span", {
              class: Re(["fe-inspector__badge", `fe-inspector__badge--${he.value}`])
            }, y(_(he.value)), 3),
            fe.value ? (f(), h("button", {
              key: 0,
              type: "button",
              class: "fe-btn fe-btn--sm",
              onClick: Ae[14] || (Ae[14] = (Pe) => a("manage-permissions", w.value))
            }, y(u(i)("inspector.perm.manage")), 1)) : O("", !0)
          ])
        ])) : O("", !0),
        e.tabs && kt.value === "details" && ht.value === "ok" ? (f(), h("section", g9, [
          d("h3", b9, y(u(i)("inspector.people")), 1),
          Ie.value.length === 0 ? (f(), h("p", k9, y(u(i)("inspector.people.empty")), 1)) : (f(), h("ul", w9, [
            (f(!0), h(Te, null, nt(Ie.value, (Pe) => (f(), h("li", {
              key: `${Pe.kind ?? "user"}-${Pe.id}-${Pe.inherited ? "inherited" : "direct"}`,
              class: "fe-inspector__person"
            }, [
              d("span", _9, y(ot(Pe)), 1),
              d("span", x9, [
                d("span", {
                  class: "fe-inspector__person-name",
                  title: Pe.kind === "group" ? u(i)("access.ui.group_title", { name: De(Pe) }) : Pe.user_email
                }, y(De(Pe)), 9, S9),
                d("span", $9, [
                  Pe.kind === "group" ? (f(), h(Te, { key: 0 }, [
                    Ht(y(u(i)("access.ui.group")) + " · ", 1)
                  ], 64)) : O("", !0),
                  Ht(" " + y(_(Pe.level)), 1),
                  Pe.inherited ? (f(), h(Te, { key: 1 }, [
                    Ht(" · " + y(u(i)("inspector.people.inherited")), 1)
                  ], 64)) : O("", !0)
                ])
              ])
            ]))), 128))
          ])),
          fe.value && w.value ? (f(), h("button", {
            key: 2,
            type: "button",
            class: "fe-btn fe-btn--sm",
            onClick: Ae[15] || (Ae[15] = (Pe) => a("manage-permissions", w.value))
          }, y(u(i)("inspector.people.manage")), 1)) : O("", !0)
        ])) : O("", !0),
        be.value === "ok" && (!e.tabs || kt.value === "details") ? (f(), h("section", T9, [
          d("h3", A9, y(e.tabs ? u(i)("inspector.link") : u(i)("inspector.section.shares")), 1),
          e.tabs && Fe.value.length === 0 ? (f(), h("div", E9, [
            d("span", {
              class: "fe-inspector__linkicon",
              "aria-hidden": "true",
              innerHTML: u(zt)("link")
            }, null, 8, C9),
            d("span", z9, y(u(i)("inspector.link.none")), 1),
            ue.value.links && !ae.value ? (f(), h("button", {
              key: 0,
              type: "button",
              class: "fe-btn fe-btn--sm",
              disabled: ft.value || !w.value,
              "data-testid": "inspector-create-link",
              onClick: gt
            }, y(u(i)("inspector.link.create")), 9, M9)) : O("", !0)
          ])) : Fe.value.length === 0 ? (f(), h("p", P9, y(u(i)("inspector.shares.empty")), 1)) : (f(), h("ul", O9, [
            (f(!0), h(Te, null, nt(Fe.value, (Pe) => (f(), h("li", {
              key: Pe.uuid,
              class: "fe-inspector__share"
            }, [
              d("span", {
                class: "fe-inspector__share-url",
                title: Pe.url
              }, y(Pe.url), 9, L9),
              Pe.password_pin ? (f(), h("span", D9, "PIN")) : O("", !0),
              Pe.expires_at ? (f(), h("span", R9, y(j(Pe.expires_at)), 1)) : O("", !0),
              d("button", {
                type: "button",
                class: "fe-inspector__copy",
                title: u(i)("inspector.shares.copy"),
                "aria-label": u(i)("inspector.shares.copy"),
                onClick: (_t) => re(Pe.url)
              }, [
                d("span", {
                  "aria-hidden": "true",
                  innerHTML: u(zt)("copy")
                }, null, 8, N9)
              ], 8, I9)
            ]))), 128))
          ]))
        ])) : O("", !0),
        (Xe.value === "ok" || Xe.value === "error") && (!e.tabs || kt.value === "activity") ? (f(), h("section", B9, [
          d("h3", F9, [
            Ht(y(u(i)("inspector.section.comments")) + " ", 1),
            je.value.length > 0 ? (f(), h("span", U9, y(je.value.length), 1)) : O("", !0)
          ]),
          Xe.value === "error" ? (f(), h("p", H9, y(u(i)("inspector.error")), 1)) : (f(), h(Te, { key: 1 }, [
            je.value.length === 0 ? (f(), h("p", K9, y(u(i)("inspector.comments.empty")), 1)) : (f(), h("ul", V9, [
              (f(!0), h(Te, null, nt(je.value, (Pe) => (f(), h("li", {
                key: Pe.id,
                class: "fe-inspector__comment"
              }, [
                d("div", j9, [
                  d("span", {
                    class: "fe-inspector__comment-author",
                    title: Pe.author_name
                  }, y(Pe.author_name || "-"), 9, q9),
                  d("span", {
                    class: "fe-inspector__comment-time",
                    title: j(Pe.created_at)
                  }, y(Ne(Pe.created_at)), 9, W9),
                  Pe.can_delete ? (f(), h("button", {
                    key: 0,
                    type: "button",
                    class: "fe-inspector__comment-del",
                    disabled: ie.value,
                    title: u(i)("inspector.comments.delete"),
                    "aria-label": u(i)("inspector.comments.delete"),
                    onClick: (_t) => Ce(Pe)
                  }, "×", 8, Y9)) : O("", !0)
                ]),
                d("p", G9, y(Pe.body), 1)
              ]))), 128))
            ])),
            d("form", {
              class: "fe-inspector__comment-form",
              onSubmit: yt(te, ["prevent"])
            }, [
              ln(d("input", {
                "onUpdate:modelValue": Ae[16] || (Ae[16] = (Pe) => Be.value = Pe),
                type: "text",
                class: "fe-inspector__comment-input",
                placeholder: u(i)("inspector.comments.placeholder"),
                "aria-label": u(i)("inspector.comments.placeholder"),
                disabled: ie.value
              }, null, 8, X9), [
                [_n, Be.value]
              ]),
              d("button", {
                type: "submit",
                class: "fe-btn fe-btn--primary fe-btn--sm",
                disabled: ie.value || Be.value.trim() === ""
              }, y(u(i)("inspector.comments.send")), 9, J9)
            ], 32)
          ], 64))
        ])) : O("", !0),
        e.tabs && kt.value === "activity" && !Ut.value ? (f(), h("section", Z9, [
          d("p", Q9, y(w.value ? u(i)("inspector.activity.empty") : u(i)("inspector.activity.select")), 1),
          w.value ? (f(), h("p", e7, y(u(i)("inspector.activity.hint")), 1)) : O("", !0)
        ])) : O("", !0)
      ])
    ], 10, oK));
  }
});
/*! @license DOMPurify 3.4.2 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.4.2/LICENSE */
const {
  entries: cT,
  setPrototypeOf: V1,
  isFrozen: n7,
  getPrototypeOf: a7,
  getOwnPropertyDescriptor: i7
} = Object;
let {
  freeze: _a,
  seal: ii,
  create: Js
} = Object, {
  apply: ky,
  construct: wy
} = typeof Reflect < "u" && Reflect;
_a || (_a = function(t) {
  return t;
});
ii || (ii = function(t) {
  return t;
});
ky || (ky = function(t, n) {
  for (var a = arguments.length, i = new Array(a > 2 ? a - 2 : 0), o = 2; o < a; o++)
    i[o - 2] = arguments[o];
  return t.apply(n, i);
});
wy || (wy = function(t) {
  for (var n = arguments.length, a = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
    a[i - 1] = arguments[i];
  return new t(...a);
});
const Nu = Kn(Array.prototype.forEach), o7 = Kn(Array.prototype.lastIndexOf), j1 = Kn(Array.prototype.pop), Bu = Kn(Array.prototype.push), r7 = Kn(Array.prototype.splice), va = Array.isArray, Wu = Kn(String.prototype.toLowerCase), iv = Kn(String.prototype.toString), q1 = Kn(String.prototype.match), Ws = Kn(String.prototype.replace), W1 = Kn(String.prototype.indexOf), s7 = Kn(String.prototype.trim), l7 = Kn(Number.prototype.toString), u7 = Kn(Boolean.prototype.toString), Y1 = typeof BigInt > "u" ? null : Kn(BigInt.prototype.toString), G1 = typeof Symbol > "u" ? null : Kn(Symbol.prototype.toString), Rn = Kn(Object.prototype.hasOwnProperty), Fu = Kn(Object.prototype.toString), oa = Kn(RegExp.prototype.test), hf = c7(TypeError);
function Kn(e) {
  return function(t) {
    t instanceof RegExp && (t.lastIndex = 0);
    for (var n = arguments.length, a = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
      a[i - 1] = arguments[i];
    return ky(e, t, a);
  };
}
function c7(e) {
  return function() {
    for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
      n[a] = arguments[a];
    return wy(e, n);
  };
}
function Yt(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Wu;
  if (V1 && V1(e, null), !va(t))
    return e;
  let a = t.length;
  for (; a--; ) {
    let i = t[a];
    if (typeof i == "string") {
      const o = n(i);
      o !== i && (n7(t) || (t[a] = o), i = o);
    }
    e[i] = !0;
  }
  return e;
}
function d7(e) {
  for (let t = 0; t < e.length; t++)
    Rn(e, t) || (e[t] = null);
  return e;
}
function Ta(e) {
  const t = Js(null);
  for (const [n, a] of cT(e))
    Rn(e, n) && (va(a) ? t[n] = d7(a) : a && typeof a == "object" && a.constructor === Object ? t[n] = Ta(a) : t[n] = a);
  return t;
}
function f7(e) {
  switch (typeof e) {
    case "string":
      return e;
    case "number":
      return l7(e);
    case "boolean":
      return u7(e);
    case "bigint":
      return Y1 ? Y1(e) : "0";
    case "symbol":
      return G1 ? G1(e) : "Symbol()";
    case "undefined":
      return Fu(e);
    case "function":
    case "object": {
      if (e === null)
        return Fu(e);
      const t = e, n = Zs(t, "toString");
      if (typeof n == "function") {
        const a = n(t);
        return typeof a == "string" ? a : Fu(a);
      }
      return Fu(e);
    }
    default:
      return Fu(e);
  }
}
function Zs(e, t) {
  for (; e !== null; ) {
    const a = i7(e, t);
    if (a) {
      if (a.get)
        return Kn(a.get);
      if (typeof a.value == "function")
        return Kn(a.value);
    }
    e = a7(e);
  }
  function n() {
    return null;
  }
  return n;
}
function p7(e) {
  try {
    return oa(e, ""), !0;
  } catch {
    return !1;
  }
}
const X1 = _a(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "search", "section", "select", "shadow", "slot", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), ov = _a(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "enterkeyhint", "exportparts", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "inputmode", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "part", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), rv = _a(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), h7 = _a(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), sv = _a(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), m7 = _a(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), J1 = _a(["#text"]), Z1 = _a(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "exportparts", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inert", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "part", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "slot", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns"]), lv = _a(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "mask-type", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), Q1 = _a(["accent", "accentunder", "align", "bevelled", "close", "columnalign", "columnlines", "columnspacing", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lquote", "lspace", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), mf = _a(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), v7 = ii(/\{\{[\w\W]*|[\w\W]*\}\}/gm), y7 = ii(/<%[\w\W]*|[\w\W]*%>/gm), g7 = ii(/\$\{[\w\W]*/gm), b7 = ii(/^data-[\-\w.\u00B7-\uFFFF]+$/), k7 = ii(/^aria-[\-\w]+$/), dT = ii(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), w7 = ii(/^(?:\w+script|data):/i), _7 = ii(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), fT = ii(/^html$/i), x7 = ii(/^[a-z][.\w]*(-[.\w]+)+$/i);
var e0 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ARIA_ATTR: k7,
  ATTR_WHITESPACE: _7,
  CUSTOM_ELEMENT: x7,
  DATA_ATTR: b7,
  DOCTYPE_NAME: fT,
  ERB_EXPR: y7,
  IS_ALLOWED_URI: dT,
  IS_SCRIPT_OR_DATA: w7,
  MUSTACHE_EXPR: v7,
  TMPLIT_EXPR: g7
});
const Uu = {
  element: 1,
  text: 3,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9
}, S7 = function() {
  return typeof window > "u" ? null : window;
}, $7 = function(t, n) {
  if (typeof t != "object" || typeof t.createPolicy != "function")
    return null;
  let a = null;
  const i = "data-tt-policy-suffix";
  n && n.hasAttribute(i) && (a = n.getAttribute(i));
  const o = "dompurify" + (a ? "#" + a : "");
  try {
    return t.createPolicy(o, {
      createHTML(l) {
        return l;
      },
      createScriptURL(l) {
        return l;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + o + " could not be created."), null;
  }
}, t0 = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
};
function pT() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : S7();
  const t = (Qe) => pT(Qe);
  if (t.version = "3.4.2", t.removed = [], !e || !e.document || e.document.nodeType !== Uu.document || !e.Element)
    return t.isSupported = !1, t;
  let {
    document: n
  } = e;
  const a = n, i = a.currentScript, {
    DocumentFragment: o,
    HTMLTemplateElement: l,
    Node: c,
    Element: p,
    NodeFilter: m,
    NamedNodeMap: v = e.NamedNodeMap || e.MozNamedAttrMap,
    HTMLFormElement: x,
    DOMParser: w,
    trustedTypes: S
  } = e, k = p.prototype, b = Zs(k, "cloneNode"), C = Zs(k, "remove"), T = Zs(k, "nextSibling"), A = Zs(k, "childNodes"), L = Zs(k, "parentNode");
  if (typeof l == "function") {
    const Qe = n.createElement("template");
    Qe.content && Qe.content.ownerDocument && (n = Qe.content.ownerDocument);
  }
  let z, D = "";
  const {
    implementation: U,
    createNodeIterator: q,
    createDocumentFragment: P,
    getElementsByTagName: R
  } = n, {
    importNode: W
  } = a;
  let N = t0();
  t.isSupported = typeof cT == "function" && typeof L == "function" && U && U.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: J,
    ERB_EXPR: H,
    TMPLIT_EXPR: ne,
    DATA_ATTR: j,
    ARIA_ATTR: re,
    IS_SCRIPT_OR_DATA: he,
    ATTR_WHITESPACE: ue,
    CUSTOM_ELEMENT: ae
  } = e0;
  let {
    IS_ALLOWED_URI: fe
  } = e0, _ = null;
  const Q = Yt({}, [...X1, ...ov, ...rv, ...sv, ...J1]);
  let K = null;
  const I = Yt({}, [...Z1, ...lv, ...Q1, ...mf]);
  let Y = Object.seal(Js(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), B = null, V = null;
  const be = Object.seal(Js(null, {
    tagCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    }
  }));
  let Fe = !0, ze = !0, Ue = !1, We = !0, $t = !1, St = !0, at = !1, kt = !1, ht = !1, Ie = !1, se = !1, xe = !1, me = !0, De = !1;
  const ot = "user-content-";
  let ft = !0, gt = !1, Ut = {}, Xe = null;
  const je = Yt({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let Be = null;
  const ie = Yt({}, ["audio", "video", "img", "source", "image", "track"]);
  let ge = null;
  const G = Yt({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), ye = "http://www.w3.org/1998/Math/MathML", te = "http://www.w3.org/2000/svg", Ce = "http://www.w3.org/1999/xhtml";
  let Ne = Ce, _e = !1, Ae = null;
  const Pe = Yt({}, [ye, te, Ce], iv);
  let _t = Yt({}, ["mi", "mo", "mn", "ms", "mtext"]), Et = Yt({}, ["annotation-xml"]);
  const xn = Yt({}, ["title", "style", "font", "a", "script"]);
  let Dt = null;
  const bn = ["application/xhtml+xml", "text/html"], un = "text/html";
  let Jt = null, Ln = null;
  const Vn = n.createElement("form"), Ft = function(ce) {
    return ce instanceof RegExp || ce instanceof Function;
  }, na = function() {
    let ce = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (Ln && Ln === ce)
      return;
    (!ce || typeof ce != "object") && (ce = {}), ce = Ta(ce), Dt = // eslint-disable-next-line unicorn/prefer-includes
    bn.indexOf(ce.PARSER_MEDIA_TYPE) === -1 ? un : ce.PARSER_MEDIA_TYPE, Jt = Dt === "application/xhtml+xml" ? iv : Wu, _ = Rn(ce, "ALLOWED_TAGS") && va(ce.ALLOWED_TAGS) ? Yt({}, ce.ALLOWED_TAGS, Jt) : Q, K = Rn(ce, "ALLOWED_ATTR") && va(ce.ALLOWED_ATTR) ? Yt({}, ce.ALLOWED_ATTR, Jt) : I, Ae = Rn(ce, "ALLOWED_NAMESPACES") && va(ce.ALLOWED_NAMESPACES) ? Yt({}, ce.ALLOWED_NAMESPACES, iv) : Pe, ge = Rn(ce, "ADD_URI_SAFE_ATTR") && va(ce.ADD_URI_SAFE_ATTR) ? Yt(Ta(G), ce.ADD_URI_SAFE_ATTR, Jt) : G, Be = Rn(ce, "ADD_DATA_URI_TAGS") && va(ce.ADD_DATA_URI_TAGS) ? Yt(Ta(ie), ce.ADD_DATA_URI_TAGS, Jt) : ie, Xe = Rn(ce, "FORBID_CONTENTS") && va(ce.FORBID_CONTENTS) ? Yt({}, ce.FORBID_CONTENTS, Jt) : je, B = Rn(ce, "FORBID_TAGS") && va(ce.FORBID_TAGS) ? Yt({}, ce.FORBID_TAGS, Jt) : Ta({}), V = Rn(ce, "FORBID_ATTR") && va(ce.FORBID_ATTR) ? Yt({}, ce.FORBID_ATTR, Jt) : Ta({}), Ut = Rn(ce, "USE_PROFILES") ? ce.USE_PROFILES && typeof ce.USE_PROFILES == "object" ? Ta(ce.USE_PROFILES) : ce.USE_PROFILES : !1, Fe = ce.ALLOW_ARIA_ATTR !== !1, ze = ce.ALLOW_DATA_ATTR !== !1, Ue = ce.ALLOW_UNKNOWN_PROTOCOLS || !1, We = ce.ALLOW_SELF_CLOSE_IN_ATTR !== !1, $t = ce.SAFE_FOR_TEMPLATES || !1, St = ce.SAFE_FOR_XML !== !1, at = ce.WHOLE_DOCUMENT || !1, Ie = ce.RETURN_DOM || !1, se = ce.RETURN_DOM_FRAGMENT || !1, xe = ce.RETURN_TRUSTED_TYPE || !1, ht = ce.FORCE_BODY || !1, me = ce.SANITIZE_DOM !== !1, De = ce.SANITIZE_NAMED_PROPS || !1, ft = ce.KEEP_CONTENT !== !1, gt = ce.IN_PLACE || !1, fe = p7(ce.ALLOWED_URI_REGEXP) ? ce.ALLOWED_URI_REGEXP : dT, Ne = typeof ce.NAMESPACE == "string" ? ce.NAMESPACE : Ce, _t = Rn(ce, "MATHML_TEXT_INTEGRATION_POINTS") && ce.MATHML_TEXT_INTEGRATION_POINTS && typeof ce.MATHML_TEXT_INTEGRATION_POINTS == "object" ? Ta(ce.MATHML_TEXT_INTEGRATION_POINTS) : Yt({}, ["mi", "mo", "mn", "ms", "mtext"]), Et = Rn(ce, "HTML_INTEGRATION_POINTS") && ce.HTML_INTEGRATION_POINTS && typeof ce.HTML_INTEGRATION_POINTS == "object" ? Ta(ce.HTML_INTEGRATION_POINTS) : Yt({}, ["annotation-xml"]);
    const qe = Rn(ce, "CUSTOM_ELEMENT_HANDLING") && ce.CUSTOM_ELEMENT_HANDLING && typeof ce.CUSTOM_ELEMENT_HANDLING == "object" ? Ta(ce.CUSTOM_ELEMENT_HANDLING) : Js(null);
    if (Y = Js(null), Rn(qe, "tagNameCheck") && Ft(qe.tagNameCheck) && (Y.tagNameCheck = qe.tagNameCheck), Rn(qe, "attributeNameCheck") && Ft(qe.attributeNameCheck) && (Y.attributeNameCheck = qe.attributeNameCheck), Rn(qe, "allowCustomizedBuiltInElements") && typeof qe.allowCustomizedBuiltInElements == "boolean" && (Y.allowCustomizedBuiltInElements = qe.allowCustomizedBuiltInElements), $t && (ze = !1), se && (Ie = !0), Ut && (_ = Yt({}, J1), K = Js(null), Ut.html === !0 && (Yt(_, X1), Yt(K, Z1)), Ut.svg === !0 && (Yt(_, ov), Yt(K, lv), Yt(K, mf)), Ut.svgFilters === !0 && (Yt(_, rv), Yt(K, lv), Yt(K, mf)), Ut.mathMl === !0 && (Yt(_, sv), Yt(K, Q1), Yt(K, mf))), be.tagCheck = null, be.attributeCheck = null, Rn(ce, "ADD_TAGS") && (typeof ce.ADD_TAGS == "function" ? be.tagCheck = ce.ADD_TAGS : va(ce.ADD_TAGS) && (_ === Q && (_ = Ta(_)), Yt(_, ce.ADD_TAGS, Jt))), Rn(ce, "ADD_ATTR") && (typeof ce.ADD_ATTR == "function" ? be.attributeCheck = ce.ADD_ATTR : va(ce.ADD_ATTR) && (K === I && (K = Ta(K)), Yt(K, ce.ADD_ATTR, Jt))), Rn(ce, "ADD_URI_SAFE_ATTR") && va(ce.ADD_URI_SAFE_ATTR) && Yt(ge, ce.ADD_URI_SAFE_ATTR, Jt), Rn(ce, "FORBID_CONTENTS") && va(ce.FORBID_CONTENTS) && (Xe === je && (Xe = Ta(Xe)), Yt(Xe, ce.FORBID_CONTENTS, Jt)), Rn(ce, "ADD_FORBID_CONTENTS") && va(ce.ADD_FORBID_CONTENTS) && (Xe === je && (Xe = Ta(Xe)), Yt(Xe, ce.ADD_FORBID_CONTENTS, Jt)), ft && (_["#text"] = !0), at && Yt(_, ["html", "head", "body"]), _.table && (Yt(_, ["tbody"]), delete B.tbody), ce.TRUSTED_TYPES_POLICY) {
      if (typeof ce.TRUSTED_TYPES_POLICY.createHTML != "function")
        throw hf('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
      if (typeof ce.TRUSTED_TYPES_POLICY.createScriptURL != "function")
        throw hf('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
      z = ce.TRUSTED_TYPES_POLICY, D = z.createHTML("");
    } else
      z === void 0 && (z = $7(S, i)), z !== null && typeof D == "string" && (D = z.createHTML(""));
    _a && _a(ce), Ln = ce;
  }, Kt = Yt({}, [...ov, ...rv, ...h7]), bt = Yt({}, [...sv, ...m7]), Dn = function(ce) {
    let qe = L(ce);
    (!qe || !qe.tagName) && (qe = {
      namespaceURI: Ne,
      tagName: "template"
    });
    const dt = Wu(ce.tagName), Nt = Wu(qe.tagName);
    return Ae[ce.namespaceURI] ? ce.namespaceURI === te ? qe.namespaceURI === Ce ? dt === "svg" : qe.namespaceURI === ye ? dt === "svg" && (Nt === "annotation-xml" || _t[Nt]) : !!Kt[dt] : ce.namespaceURI === ye ? qe.namespaceURI === Ce ? dt === "math" : qe.namespaceURI === te ? dt === "math" && Et[Nt] : !!bt[dt] : ce.namespaceURI === Ce ? qe.namespaceURI === te && !Et[Nt] || qe.namespaceURI === ye && !_t[Nt] ? !1 : !bt[dt] && (xn[dt] || !Kt[dt]) : !!(Dt === "application/xhtml+xml" && Ae[ce.namespaceURI]) : !1;
  }, In = function(ce) {
    Bu(t.removed, {
      element: ce
    });
    try {
      L(ce).removeChild(ce);
    } catch {
      C(ce);
    }
  }, Cn = function(ce, qe) {
    try {
      Bu(t.removed, {
        attribute: qe.getAttributeNode(ce),
        from: qe
      });
    } catch {
      Bu(t.removed, {
        attribute: null,
        from: qe
      });
    }
    if (qe.removeAttribute(ce), ce === "is")
      if (Ie || se)
        try {
          In(qe);
        } catch {
        }
      else
        try {
          qe.setAttribute(ce, "");
        } catch {
        }
  }, fn = function(ce) {
    let qe = null, dt = null;
    if (ht)
      ce = "<remove></remove>" + ce;
    else {
      const nn = q1(ce, /^[\r\n\t ]+/);
      dt = nn && nn[0];
    }
    Dt === "application/xhtml+xml" && Ne === Ce && (ce = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + ce + "</body></html>");
    const Nt = z ? z.createHTML(ce) : ce;
    if (Ne === Ce)
      try {
        qe = new w().parseFromString(Nt, Dt);
      } catch {
      }
    if (!qe || !qe.documentElement) {
      qe = U.createDocument(Ne, "template", null);
      try {
        qe.documentElement.innerHTML = _e ? D : Nt;
      } catch {
      }
    }
    const hn = qe.body || qe.documentElement;
    return ce && dt && hn.insertBefore(n.createTextNode(dt), hn.childNodes[0] || null), Ne === Ce ? R.call(qe, at ? "html" : "body")[0] : at ? qe.documentElement : hn;
  }, mn = function(ce) {
    return q.call(
      ce.ownerDocument || ce,
      ce,
      // eslint-disable-next-line no-bitwise
      m.SHOW_ELEMENT | m.SHOW_COMMENT | m.SHOW_TEXT | m.SHOW_PROCESSING_INSTRUCTION | m.SHOW_CDATA_SECTION,
      null
    );
  }, aa = function(ce) {
    return ce instanceof x && (typeof ce.nodeName != "string" || typeof ce.textContent != "string" || typeof ce.removeChild != "function" || !(ce.attributes instanceof v) || typeof ce.removeAttribute != "function" || typeof ce.setAttribute != "function" || typeof ce.namespaceURI != "string" || typeof ce.insertBefore != "function" || typeof ce.hasChildNodes != "function");
  }, zn = function(ce) {
    return typeof c == "function" && ce instanceof c;
  };
  function Mn(Qe, ce, qe) {
    Nu(Qe, (dt) => {
      dt.call(t, ce, qe, Ln);
    });
  }
  const rn = function(ce) {
    let qe = null;
    if (Mn(N.beforeSanitizeElements, ce, null), aa(ce))
      return In(ce), !0;
    const dt = Jt(ce.nodeName);
    if (Mn(N.uponSanitizeElement, ce, {
      tagName: dt,
      allowedTags: _
    }), St && ce.hasChildNodes() && !zn(ce.firstElementChild) && oa(/<[/\w!]/g, ce.innerHTML) && oa(/<[/\w!]/g, ce.textContent) || St && ce.namespaceURI === Ce && dt === "style" && zn(ce.firstElementChild) || ce.nodeType === Uu.progressingInstruction || St && ce.nodeType === Uu.comment && oa(/<[/\w]/g, ce.data))
      return In(ce), !0;
    if (B[dt] || !(be.tagCheck instanceof Function && be.tagCheck(dt)) && !_[dt]) {
      if (!B[dt] && He(dt) && (Y.tagNameCheck instanceof RegExp && oa(Y.tagNameCheck, dt) || Y.tagNameCheck instanceof Function && Y.tagNameCheck(dt)))
        return !1;
      if (ft && !Xe[dt]) {
        const Nt = L(ce) || ce.parentNode, hn = A(ce) || ce.childNodes;
        if (hn && Nt) {
          const nn = hn.length;
          for (let oe = nn - 1; oe >= 0; --oe) {
            const le = b(hn[oe], !0);
            Nt.insertBefore(le, T(ce));
          }
        }
      }
      return In(ce), !0;
    }
    return ce instanceof p && !Dn(ce) || (dt === "noscript" || dt === "noembed" || dt === "noframes") && oa(/<\/no(script|embed|frames)/i, ce.innerHTML) ? (In(ce), !0) : ($t && ce.nodeType === Uu.text && (qe = ce.textContent, Nu([J, H, ne], (Nt) => {
      qe = Ws(qe, Nt, " ");
    }), ce.textContent !== qe && (Bu(t.removed, {
      element: ce.cloneNode()
    }), ce.textContent = qe)), Mn(N.afterSanitizeElements, ce, null), !1);
  }, ve = function(ce, qe, dt) {
    if (V[qe] || me && (qe === "id" || qe === "name") && (dt in n || dt in Vn))
      return !1;
    const Nt = K[qe] || be.attributeCheck instanceof Function && be.attributeCheck(qe, ce);
    if (!(ze && !V[qe] && oa(j, qe))) {
      if (!(Fe && oa(re, qe))) {
        if (!Nt || V[qe]) {
          if (
            // First condition does a very basic check if a) it's basically a valid custom element tagname AND
            // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
            !(He(ce) && (Y.tagNameCheck instanceof RegExp && oa(Y.tagNameCheck, ce) || Y.tagNameCheck instanceof Function && Y.tagNameCheck(ce)) && (Y.attributeNameCheck instanceof RegExp && oa(Y.attributeNameCheck, qe) || Y.attributeNameCheck instanceof Function && Y.attributeNameCheck(qe, ce)) || // Alternative, second condition checks if it's an `is`-attribute, AND
            // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            qe === "is" && Y.allowCustomizedBuiltInElements && (Y.tagNameCheck instanceof RegExp && oa(Y.tagNameCheck, dt) || Y.tagNameCheck instanceof Function && Y.tagNameCheck(dt)))
          ) return !1;
        } else if (!ge[qe]) {
          if (!oa(fe, Ws(dt, ue, ""))) {
            if (!((qe === "src" || qe === "xlink:href" || qe === "href") && ce !== "script" && W1(dt, "data:") === 0 && Be[ce])) {
              if (!(Ue && !oa(he, Ws(dt, ue, "")))) {
                if (dt)
                  return !1;
              }
            }
          }
        }
      }
    }
    return !0;
  }, Le = Yt({}, ["annotation-xml", "color-profile", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "missing-glyph"]), He = function(ce) {
    return !Le[Wu(ce)] && oa(ae, ce);
  }, Ke = function(ce) {
    Mn(N.beforeSanitizeAttributes, ce, null);
    const {
      attributes: qe
    } = ce;
    if (!qe || aa(ce))
      return;
    const dt = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: K,
      forceKeepAttr: void 0
    };
    let Nt = qe.length;
    for (; Nt--; ) {
      const hn = qe[Nt], {
        name: nn,
        namespaceURI: oe,
        value: le
      } = hn, Me = Jt(nn), Ve = le;
      let it = nn === "value" ? Ve : s7(Ve);
      if (dt.attrName = Me, dt.attrValue = it, dt.keepAttr = !0, dt.forceKeepAttr = void 0, Mn(N.uponSanitizeAttribute, ce, dt), it = dt.attrValue, De && (Me === "id" || Me === "name") && W1(it, ot) !== 0 && (Cn(nn, ce), it = ot + it), St && oa(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, it)) {
        Cn(nn, ce);
        continue;
      }
      if (Me === "attributename" && q1(it, "href")) {
        Cn(nn, ce);
        continue;
      }
      if (dt.forceKeepAttr)
        continue;
      if (!dt.keepAttr) {
        Cn(nn, ce);
        continue;
      }
      if (!We && oa(/\/>/i, it)) {
        Cn(nn, ce);
        continue;
      }
      $t && Nu([J, H, ne], (ee) => {
        it = Ws(it, ee, " ");
      });
      const Z = Jt(ce.nodeName);
      if (!ve(Z, Me, it)) {
        Cn(nn, ce);
        continue;
      }
      if (z && typeof S == "object" && typeof S.getAttributeType == "function" && !oe)
        switch (S.getAttributeType(Z, Me)) {
          case "TrustedHTML": {
            it = z.createHTML(it);
            break;
          }
          case "TrustedScriptURL": {
            it = z.createScriptURL(it);
            break;
          }
        }
      if (it !== Ve)
        try {
          oe ? ce.setAttributeNS(oe, nn, it) : ce.setAttribute(nn, it), aa(ce) ? In(ce) : j1(t.removed);
        } catch {
          Cn(nn, ce);
        }
    }
    Mn(N.afterSanitizeAttributes, ce, null);
  }, xt = function(ce) {
    let qe = null;
    const dt = mn(ce);
    for (Mn(N.beforeSanitizeShadowDOM, ce, null); qe = dt.nextNode(); )
      Mn(N.uponSanitizeShadowNode, qe, null), rn(qe), Ke(qe), qe.content instanceof o && xt(qe.content);
    Mn(N.afterSanitizeShadowDOM, ce, null);
  };
  return t.sanitize = function(Qe) {
    let ce = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, qe = null, dt = null, Nt = null, hn = null;
    if (_e = !Qe, _e && (Qe = "<!-->"), typeof Qe != "string" && !zn(Qe) && (Qe = f7(Qe), typeof Qe != "string"))
      throw hf("dirty is not a string, aborting");
    if (!t.isSupported)
      return Qe;
    if (kt || na(ce), t.removed = [], typeof Qe == "string" && (gt = !1), gt) {
      const le = Qe.nodeName;
      if (typeof le == "string") {
        const Me = Jt(le);
        if (!_[Me] || B[Me])
          throw hf("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (Qe instanceof c)
      qe = fn("<!---->"), dt = qe.ownerDocument.importNode(Qe, !0), dt.nodeType === Uu.element && dt.nodeName === "BODY" || dt.nodeName === "HTML" ? qe = dt : qe.appendChild(dt);
    else {
      if (!Ie && !$t && !at && // eslint-disable-next-line unicorn/prefer-includes
      Qe.indexOf("<") === -1)
        return z && xe ? z.createHTML(Qe) : Qe;
      if (qe = fn(Qe), !qe)
        return Ie ? null : xe ? D : "";
    }
    qe && ht && In(qe.firstChild);
    const nn = mn(gt ? Qe : qe);
    for (; Nt = nn.nextNode(); )
      rn(Nt), Ke(Nt), Nt.content instanceof o && xt(Nt.content);
    if (gt)
      return Qe;
    if (Ie) {
      if ($t) {
        qe.normalize();
        let le = qe.innerHTML;
        Nu([J, H, ne], (Me) => {
          le = Ws(le, Me, " ");
        }), qe.innerHTML = le;
      }
      if (se)
        for (hn = P.call(qe.ownerDocument); qe.firstChild; )
          hn.appendChild(qe.firstChild);
      else
        hn = qe;
      return (K.shadowroot || K.shadowrootmode) && (hn = W.call(a, hn, !0)), hn;
    }
    let oe = at ? qe.outerHTML : qe.innerHTML;
    return at && _["!doctype"] && qe.ownerDocument && qe.ownerDocument.doctype && qe.ownerDocument.doctype.name && oa(fT, qe.ownerDocument.doctype.name) && (oe = "<!DOCTYPE " + qe.ownerDocument.doctype.name + `>
` + oe), $t && Nu([J, H, ne], (le) => {
      oe = Ws(oe, le, " ");
    }), z && xe ? z.createHTML(oe) : oe;
  }, t.setConfig = function() {
    let Qe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    na(Qe), kt = !0;
  }, t.clearConfig = function() {
    Ln = null, kt = !1;
  }, t.isValidAttribute = function(Qe, ce, qe) {
    Ln || na({});
    const dt = Jt(Qe), Nt = Jt(ce);
    return ve(dt, Nt, qe);
  }, t.addHook = function(Qe, ce) {
    typeof ce == "function" && Bu(N[Qe], ce);
  }, t.removeHook = function(Qe, ce) {
    if (ce !== void 0) {
      const qe = o7(N[Qe], ce);
      return qe === -1 ? void 0 : r7(N[Qe], qe, 1)[0];
    }
    return j1(N[Qe]);
  }, t.removeHooks = function(Qe) {
    N[Qe] = [];
  }, t.removeAllHooks = function() {
    N = t0();
  }, t;
}
var T7 = pT();
const hT = [
  "a",
  "abbr",
  "b",
  "bdi",
  "bdo",
  "blockquote",
  "br",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "dd",
  "del",
  "details",
  "dfn",
  "div",
  "dl",
  "dt",
  "em",
  "figcaption",
  "figure",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "hr",
  "i",
  "img",
  "ins",
  "kbd",
  "li",
  "mark",
  "ol",
  "p",
  "picture",
  "pre",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "small",
  "source",
  "span",
  "strike",
  "strong",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "time",
  "tr",
  "tt",
  "u",
  "ul",
  "var",
  "wbr"
], mT = [
  "abbr",
  "align",
  "alt",
  "cite",
  "class",
  "colspan",
  "datetime",
  "dir",
  "height",
  "href",
  "id",
  "lang",
  "loading",
  "media",
  "open",
  "rel",
  "reversed",
  "rowspan",
  "scope",
  "span",
  "src",
  "srcset",
  "start",
  "style",
  "target",
  "title",
  "valign",
  "width"
], A7 = [
  "script",
  "iframe",
  "frame",
  "frameset",
  "object",
  "embed",
  "applet",
  "form",
  "input",
  "button",
  "select",
  "option",
  "textarea",
  "base",
  "meta",
  "link",
  "noscript",
  "template",
  "portal",
  "dialog"
], E7 = ["action", "formaction", "srcdoc", "ping", "background", "poster"], C7 = hT.filter((e) => e !== "picture" && e !== "source"), z7 = mT.filter((e) => e !== "srcset" && e !== "style" && e !== "loading" && e !== "media"), M7 = {
  document: {
    ALLOWED_TAGS: hT,
    ALLOWED_ATTR: mT,
    // Ids a document brings are prefixed (`user-content-…`) so they can never
    // shadow a global the page reads (DOM clobbering).
    SANITIZE_NAMED_PROPS: !0,
    // Parsed into an inert document and its pictures from elsewhere held
    // back there (documentMarkup, RemoteImages).
    RETURN_DOM_FRAGMENT: !0
  },
  assistant: {
    ALLOWED_TAGS: C7,
    ALLOWED_ATTR: z7,
    SANITIZE_NAMED_PROPS: !0,
    // Parsed into an inert document and reshaped there (assistantMarkup):
    // nothing is attached to the page, so nothing is fetched on the way.
    RETURN_DOM_FRAGMENT: !0
  },
  code: {
    ALLOWED_TAGS: ["span", "br"],
    ALLOWED_ATTR: ["class"]
  },
  diagram: {
    USE_PROFILES: { svg: !0, svgFilters: !0, html: !0 },
    // What Mermaid itself keeps when it sanitizes its output: HTML labels
    // live in <foreignObject> (an HTML integration point for them), and text
    // anchoring needs dominant-baseline.
    ADD_TAGS: ["foreignobject"],
    ADD_ATTR: ["dominant-baseline"],
    HTML_INTEGRATION_POINTS: { foreignobject: !0 }
  },
  math: {
    USE_PROFILES: { html: !0, mathMl: !0 }
  }
};
let uv = null;
function P7() {
  if (uv) return uv;
  if (typeof window > "u") return null;
  const e = T7(window);
  return e.isSupported ? (e.addHook("uponSanitizeAttribute", (t, n) => {
    if (n.attrName === "style") {
      const a = O7(n.attrValue);
      a === "" ? n.keepAttr = !1 : n.attrValue = a;
    }
  }), e.addHook("uponSanitizeElement", (t, n) => {
    n.tagName === "style" && t.textContent && (t.textContent = L7(t.textContent));
  }), e.addHook("afterSanitizeAttributes", (t) => {
    if (t.tagName === "A") {
      const n = t.getAttribute("target");
      n && n !== "_blank" && t.removeAttribute("target"), t.getAttribute("target") === "_blank" && t.setAttribute("rel", "noopener noreferrer");
    }
  }), uv = e, e) : null;
}
function O7(e) {
  return e.split(";").map((t) => t.trim()).filter((t) => t !== "" && !D7(t)).join("; ");
}
function L7(e) {
  return /\\/.test(e) ? "" : e.replace(/@import[^;]*;?/gi, "").replace(/url\s*\(\s*(['"]?)(?!#)[^)]*\)/gi, "none").replace(/image-set\s*\([^)]*\)/gi, "none").replace(/expression\s*\(/gi, "x(");
}
function D7(e) {
  return /\\/.test(e) || /expression\s*\(|@import|behavior\s*:|-moz-binding|image-set\s*\(|javascript:/i.test(e) ? !0 : (e.match(/url\s*\(\s*(['"]?)([^)'"]*)/gi) ?? []).some((n) => !/url\s*\(\s*['"]?#/i.test(n));
}
function R7(e) {
  return e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
}
function vT() {
  try {
    return typeof location < "u" ? location.origin : null;
  } catch {
    return null;
  }
}
function Qr(e) {
  const t = e.trim();
  if (/^data:image\//i.test(t)) return !0;
  const n = vT();
  if (!n) return !1;
  let a;
  try {
    a = new URL(t, n + "/");
  } catch {
    return !1;
  }
  if (a.protocol === "blob:")
    try {
      return new URL(a.pathname).origin === n;
    } catch {
      return !1;
    }
  return (a.protocol === "https:" || a.protocol === "http:") && a.origin === n;
}
function I7(e) {
  const t = e.ownerDocument;
  for (const n of Array.from(e.querySelectorAll("img"))) {
    const a = n.getAttribute("src") ?? "";
    if (a && Qr(a)) continue;
    const i = (n.getAttribute("alt") ?? "").trim(), o = t.createElement("a");
    o.setAttribute("href", a), o.setAttribute("data-remote-image", ""), o.textContent = i || a, n.replaceWith(o);
  }
  for (const n of Array.from(e.querySelectorAll("a"))) {
    const a = n.getAttribute("href");
    if (!a) {
      n.removeAttribute("target"), n.removeAttribute("rel");
      continue;
    }
    if (n.setAttribute("target", "_blank"), n.setAttribute("rel", "noopener noreferrer nofollow"), n.setAttribute("title", a), (n.textContent ?? "").trim() !== a.trim()) {
      const o = t.createElement("span");
      o.setAttribute("class", "fe-md-href"), o.textContent = ` (${a})`, n.after(o);
    }
  }
  return Ug(e);
}
function Ug(e) {
  const t = e.ownerDocument.createElement("div");
  return t.appendChild(e), t.innerHTML;
}
function es(e) {
  if (!e.trim()) return null;
  const t = vT();
  try {
    const n = new URL(e.trim(), t ? t + "/" : void 0);
    return n.protocol === "https:" || n.protocol === "http:" ? n : null;
  } catch {
    return null;
  }
}
function Hg(e) {
  const t = [];
  let n = 0;
  for (; n < e.length; ) {
    for (; n < e.length && /[\s,]/.test(e[n]); ) n++;
    if (n >= e.length) break;
    let a = n;
    for (; a < e.length && !/\s/.test(e[a]); ) a++;
    let i = e.slice(n, a), o = "";
    if (i.endsWith(","))
      i = i.replace(/,+$/, ""), n = a;
    else {
      let l = a;
      for (; l < e.length && e[l] !== ","; ) l++;
      o = e.slice(a, l).trim(), n = l + 1;
    }
    i && t.push({ url: i, descriptor: o });
  }
  return t;
}
const yT = ["alt", "title", "width", "height", "class", "align"];
function gT(e, t) {
  var a;
  if (Qr(e)) return !0;
  const n = es(e);
  return !!n && !!((a = t.load) != null && a.call(t, n.href));
}
function n0(e, t) {
  const n = e.getAttribute("srcset");
  if (n === null) return;
  const a = Hg(n).filter((i) => gT(i.url, t));
  a.length ? e.setAttribute("srcset", a.map((i) => i.descriptor ? `${i.url} ${i.descriptor}` : i.url).join(", ")) : e.removeAttribute("srcset");
}
function N7(e, t, n, a) {
  const i = e.createElement("span");
  i.setAttribute("class", "fe-remote-img");
  const o = es(n);
  o && (i.setAttribute("data-remote-image", o.href), i.setAttribute("data-remote-host", o.host), i.setAttribute("role", "button"), i.setAttribute("tabindex", "0"), i.setAttribute("title", o.href));
  for (const p of yT) {
    const m = t.getAttribute(p);
    m && i.setAttribute(`data-remote-${p}`, m);
  }
  const l = (p, m) => {
    const v = e.createElement("span");
    v.setAttribute("class", p), m ? v.textContent = m : v.setAttribute("aria-hidden", "true"), i.appendChild(v);
  };
  l("fe-remote-img__icon", "");
  const c = (t.getAttribute("alt") ?? "").trim();
  return c && l("fe-remote-img__alt", c), l("fe-remote-img__label", a), o && l("fe-remote-img__host", o.host), i;
}
function B7(e, t) {
  return bT(e, t), Ug(e);
}
function bT(e, t) {
  var i;
  const n = e.ownerDocument, a = t.label || "Remote image";
  for (const o of Array.from(e.querySelectorAll("*")))
    for (const l of Array.from(o.attributes))
      l.name.startsWith("data-remote") && o.removeAttribute(l.name);
  for (const o of Array.from(e.querySelectorAll("source")))
    n0(o, t), o.hasAttribute("srcset") || o.remove();
  for (const o of Array.from(e.querySelectorAll("img"))) {
    const l = (o.getAttribute("src") ?? "").trim(), c = ((i = Hg(o.getAttribute("srcset") ?? "").find((m) => !Qr(m.url))) == null ? void 0 : i.url) ?? "";
    n0(o, t);
    const p = l && !Qr(l) ? l : !l && !o.hasAttribute("srcset") ? c : "";
    if (p && !gT(p, t)) {
      o.replaceWith(N7(n, o, p, a));
      continue;
    }
    j7(o) && o.setAttribute("referrerpolicy", "no-referrer");
  }
}
const Yu = "http://www.w3.org/2000/svg", kT = "http://www.w3.org/1999/xhtml", a0 = "#fe-remote=", F7 = ["x", "y", "width", "height", "transform", "preserveAspectRatio"];
function U7(e) {
  return (e.getAttribute("href") ?? e.getAttribute("xlink:href") ?? "").trim();
}
function H7(e) {
  const t = e.startsWith("data:") ? e.indexOf(a0) : -1;
  if (t < 0) return e;
  try {
    return decodeURIComponent(e.slice(t + a0.length));
  } catch {
    return "";
  }
}
function wT(e, t, n) {
  const a = e.createElementNS(Yu, "foreignObject");
  for (const o of ["x", "y", "width", "height", "transform"]) {
    const l = n(o);
    l !== null && l !== "" && a.setAttribute(o, l);
  }
  const i = e.createElementNS(kT, "img");
  return i.setAttribute("referrerpolicy", "no-referrer"), i.setAttribute("style", "width: 100%; height: 100%; object-fit: contain;"), i.setAttribute("alt", ""), i.setAttribute("src", t), a.appendChild(i), a;
}
function K7(e, t, n, a) {
  const i = e.createElementNS(Yu, "g");
  i.setAttribute("class", "fe-remote-svgimg");
  const o = es(n);
  if (o) {
    i.setAttribute("data-remote-image", o.href), i.setAttribute("data-remote-host", o.host), i.setAttribute("role", "button"), i.setAttribute("tabindex", "0"), i.setAttribute("aria-label", `${a} ${o.host}`);
    const b = e.createElementNS(Yu, "title");
    b.textContent = o.href, i.appendChild(b);
  }
  for (const b of F7) {
    const C = t.getAttribute(b);
    C && i.setAttribute(`data-remote-${b.toLowerCase()}`, C);
  }
  const l = t.getAttribute("transform");
  l && i.setAttribute("transform", l);
  const c = (b, C) => {
    const T = parseFloat(t.getAttribute(b) ?? "");
    return Number.isFinite(T) ? T : C;
  }, [p, m, v, x] = [c("x", 0), c("y", 0), c("width", 120), c("height", 80)], w = e.createElementNS(Yu, "rect");
  w.setAttribute("class", "fe-remote-svgimg__box");
  const S = [["x", p], ["y", m], ["width", v], ["height", x], ["rx", 4]];
  for (const [b, C] of S) w.setAttribute(b, String(C));
  i.appendChild(w);
  const k = e.createElementNS(Yu, "text");
  return k.setAttribute("class", "fe-remote-svgimg__label"), k.setAttribute("x", String(p + v / 2)), k.setAttribute("y", String(m + x / 2)), k.setAttribute("text-anchor", "middle"), k.setAttribute("dominant-baseline", "middle"), k.textContent = a, i.appendChild(k), i;
}
function V7(e, t) {
  var i;
  const n = e.ownerDocument, a = t.label || "Remote image";
  bT(e, t);
  for (const o of Array.from(e.querySelectorAll("video, audio, track, input"))) o.remove();
  for (const o of Array.from(e.querySelectorAll("image"))) {
    const l = U7(o), c = H7(l);
    if (c === l && Qr(l)) continue;
    const p = es(c);
    if (p && ((i = t.load) != null && i.call(t, p.href))) {
      o.replaceWith(wT(n, p.href, (m) => o.getAttribute(m)));
      continue;
    }
    o.replaceWith(K7(n, o, c, a));
  }
  for (const o of Array.from(e.querySelectorAll("*")))
    if (!(o.localName === "a" || o.localName === "image" || o.namespaceURI === kT))
      for (const l of ["href", "xlink:href"]) {
        const c = (o.getAttribute(l) ?? "").trim();
        c && !c.startsWith("#") && o.removeAttribute(l);
      }
  return Ug(e);
}
function j7(e) {
  var a;
  const t = (i) => {
    const o = (i.getAttribute("src") ?? "").trim();
    return i.tagName === "IMG" && o && !Qr(o) ? !0 : Hg(i.getAttribute("srcset") ?? "").some((l) => !Qr(l.url));
  };
  if (t(e)) return !0;
  const n = ((a = e.parentElement) == null ? void 0 : a.tagName) === "PICTURE" ? e.parentElement : null;
  return !!n && Array.from(n.querySelectorAll("source")).some(t);
}
function q7(e, t = "document", n = {}) {
  const a = P7();
  if (!a) return R7(e);
  const i = {
    ...M7[t],
    FORBID_TAGS: A7,
    FORBID_ATTR: E7,
    ALLOW_UNKNOWN_PROTOCOLS: !1,
    RETURN_TRUSTED_TYPE: !1
  };
  if (t === "assistant")
    return I7(a.sanitize(e, { ...i, RETURN_DOM_FRAGMENT: !0 }));
  if (t === "document" || t === "diagram") {
    const o = a.sanitize(e, { ...i, RETURN_DOM_FRAGMENT: !0 });
    return t === "document" ? B7(o, n.remoteImages ?? {}) : V7(o, n.remoteImages ?? {});
  }
  return String(a.sanitize(e, i));
}
let vf = null;
function W7() {
  return vf || (vf = import(
    /* @vite-ignore */
    "markdown-it"
  ).then((e) => {
    const t = e, n = t.default ?? t;
    return new n({ html: !0, linkify: !0, breaks: !0, typographer: !0 });
  }).catch(() => (vf = null, null))), vf;
}
async function Y7(e, t = "document", n = {}) {
  const a = await W7();
  return a ? q7(a.render(e), t, n) : null;
}
const G7 = ["aria-label"], X7 = { class: "fe-assistant__head" }, J7 = { class: "fe-assistant__head-text" }, Z7 = { class: "fe-assistant__title" }, Q7 = {
  key: 0,
  class: "fe-assistant__provider",
  "data-testid": "assistant-provider"
}, eV = ["title", "aria-label", "disabled"], tV = ["title", "aria-label", "aria-pressed"], nV = ["title", "aria-label"], aV = {
  key: 0,
  class: "fe-assistant__history",
  "data-testid": "assistant-history-list"
}, iV = {
  key: 0,
  class: "fe-assistant__muted"
}, oV = {
  key: 1,
  class: "fe-assistant__convs"
}, rV = ["onClick"], sV = { class: "fe-assistant__conv-title" }, lV = { class: "fe-assistant__conv-date" }, uV = ["title", "aria-label", "onClick"], cV = {
  key: 0,
  class: "fe-assistant__intro",
  "data-testid": "assistant-intro"
}, dV = {
  key: 0,
  class: "fe-assistant__msg fe-assistant__msg--user"
}, fV = { class: "fe-assistant__text" }, pV = {
  key: 0,
  class: "fe-assistant__chips"
}, hV = ["title"], mV = {
  key: 1,
  class: "fe-assistant__msg fe-assistant__msg--bot"
}, vV = ["innerHTML"], yV = {
  key: 1,
  class: "fe-assistant__text"
}, gV = {
  key: 2,
  class: "fe-assistant__note",
  role: "note"
}, bV = ["data-testid"], kV = { class: "fe-assistant__step-body" }, wV = { class: "fe-assistant__step-label" }, _V = ["title"], xV = ["title"], SV = { class: "fe-assistant__step-status" }, $V = {
  key: 2,
  class: "fe-assistant__step-error"
}, TV = ["disabled", "data-testid", "onClick"], AV = {
  key: 0,
  class: "fe-assistant__msg fe-assistant__msg--user"
}, EV = { class: "fe-assistant__text" }, CV = {
  key: 0,
  class: "fe-assistant__chips"
}, zV = ["title"], MV = { class: "fe-assistant__step-body" }, PV = { class: "fe-assistant__step-label" }, OV = ["title"], LV = { class: "fe-assistant__step-status" }, DV = {
  key: 1,
  class: "fe-assistant__msg fe-assistant__msg--bot"
}, RV = { class: "fe-assistant__text" }, IV = {
  key: 2,
  class: "fe-assistant__muted"
}, NV = ["aria-label"], BV = { class: "fe-assistant__card-question" }, FV = {
  key: 0,
  class: "fe-assistant__card-note"
}, UV = {
  key: 1,
  class: "fe-assistant__card-args"
}, HV = { class: "fe-assistant__card-actions" }, KV = ["disabled"], VV = ["disabled"], jV = {
  key: 3,
  class: "fe-assistant__error",
  role: "alert",
  "data-testid": "assistant-error"
}, qV = { class: "fe-assistant__foot" }, WV = {
  key: 0,
  class: "fe-assistant__with"
}, YV = { class: "fe-assistant__compose" }, GV = ["placeholder", "aria-label"], XV = ["title", "aria-label"], JV = ["title", "aria-label", "disabled"], ZV = /* @__PURE__ */ lt({
  __name: "AssistantPanel",
  props: {
    client: {},
    locale: {},
    selection: {},
    narrow: { type: Boolean }
  },
  emits: ["close", "changed"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i, formatDate: o } = pt(() => n.locale ?? "en"), l = $(null), c = $(null), p = $(!1), m = $([]), v = $(""), x = $(!0), w = $(!1), S = $("");
    let k = null;
    const b = $(null), C = $(null), T = $(null), A = E(() => {
      var I;
      return ((I = c.value) == null ? void 0 : I.items) ?? [];
    }), L = E(() => {
      var Y, B;
      return ((Y = b.value) == null ? void 0 : Y.steps.find((V) => V.status === "waiting")) ?? ((B = c.value) == null ? void 0 : B.waiting) ?? null;
    }), z = E(() => n.selection.length), D = E(() => {
      const I = l.value;
      return !(I != null && I.provider) || !I.model ? "" : `${U(I.provider)} · ${I.model}`;
    });
    function U(I) {
      switch (I) {
        case "anthropic":
          return "Anthropic";
        case "openai":
          return "OpenAI";
        case "ollama":
          return "Ollama";
      }
      return I;
    }
    function q(I) {
      if (!I) return "";
      const Y = I.replace(/\/+$/, ""), B = Y.lastIndexOf("/");
      return B >= 0 && B < Y.length - 1 ? Y.slice(B + 1) : Y;
    }
    const P = $({});
    async function R(I) {
      if (P.value[I] !== void 0) return;
      const Y = await Y7(I, "assistant");
      Y !== null && (P.value = { ...P.value, [I]: Y });
    }
    Je(
      A,
      (I) => {
        for (const Y of I) Y.kind === "assistant" && Y.text && R(Y.text);
      },
      { immediate: !0 }
    );
    function W() {
      Gt(() => {
        const I = C.value;
        I && (I.scrollTop = I.scrollHeight);
      });
    }
    function N(I) {
      if (!b.value) return;
      const Y = b.value.steps.findIndex((B) => B.id === I.id);
      Y >= 0 ? b.value.steps.splice(Y, 1, I) : b.value.steps.push(I), I.class !== "read" && I.status === "done" && a("changed");
    }
    function J(I) {
      var Y;
      switch (I.name) {
        case "conversation":
          (!c.value || c.value.id !== I.data.id) && (c.value = { id: I.data.id, title: I.data.title, updated_ms: Date.now(), provider: "", model: "", items: ((Y = c.value) == null ? void 0 : Y.items) ?? [] });
          break;
        case "text":
          b.value && (b.value.reply += I.data.delta);
          break;
        case "step":
        case "approval":
          N(I.data);
          break;
        case "error":
          S.value = I.data.message || I.data.error;
          break;
        case "done":
          c.value = I.data.conversation, b.value = null;
          break;
      }
      W();
    }
    async function H(I) {
      var Y;
      S.value = "", w.value = !0, k = new AbortController();
      try {
        await I(k.signal);
      } catch (B) {
        if ((B == null ? void 0 : B.name) !== "AbortError" && (S.value = Za(B, n.locale)), (Y = c.value) != null && Y.id)
          try {
            c.value = await n.client.get(c.value.id);
          } catch {
          }
        b.value = null;
      } finally {
        w.value = !1, k = null, W();
      }
    }
    async function ne() {
      const I = v.value.trim();
      if (!I || w.value) return;
      const Y = x.value ? [...n.selection] : [];
      v.value = "", b.value = { text: I, paths: Y, reply: "", steps: [] }, W(), await H(
        (B) => {
          var V;
          return n.client.chat(
            { conversation_id: ((V = c.value) == null ? void 0 : V.id) || void 0, message: I, paths: Y.length ? Y : void 0 },
            J,
            B
          );
        }
      );
    }
    async function j(I) {
      var B;
      const Y = (B = c.value) == null ? void 0 : B.id;
      !Y || w.value || (b.value = { text: "", paths: [], reply: "", steps: [] }, await H((V) => n.client.decide(Y, I, J, V)));
    }
    function re() {
      k == null || k.abort();
    }
    async function he(I) {
      var B;
      const Y = (B = c.value) == null ? void 0 : B.id;
      if (!(!Y || w.value)) {
        S.value = "";
        try {
          const V = await n.client.undo(Y, I.id);
          c.value = V.conversation, a("changed");
        } catch (V) {
          S.value = Za(V, n.locale);
        }
      }
    }
    function ue() {
      w.value || (c.value = null, b.value = null, S.value = "", p.value = !1, Gt(() => {
        var I;
        return (I = T.value) == null ? void 0 : I.focus();
      }));
    }
    async function ae() {
      if (p.value = !p.value, !!p.value)
        try {
          m.value = await n.client.list();
        } catch (I) {
          S.value = Za(I, n.locale);
        }
    }
    async function fe(I) {
      try {
        c.value = await n.client.get(I), p.value = !1, W();
      } catch (Y) {
        S.value = Za(Y, n.locale);
      }
    }
    async function _(I) {
      var Y;
      try {
        await n.client.remove(I), m.value = m.value.filter((B) => B.id !== I), ((Y = c.value) == null ? void 0 : Y.id) === I && (c.value = null);
      } catch (B) {
        S.value = Za(B, n.locale);
      }
    }
    function Q(I) {
      I.key === "Enter" && !I.shiftKey && !I.isComposing && (I.preventDefault(), ne());
    }
    function K(I) {
      return Object.entries(I.args ?? {}).map(([Y, B]) => [Y, typeof B == "string" ? B : JSON.stringify(B)]);
    }
    return jt(async () => {
      try {
        l.value = await n.client.me();
      } catch {
      }
      Gt(() => {
        var I;
        return (I = T.value) == null ? void 0 : I.focus();
      });
    }), Tt(() => k == null ? void 0 : k.abort()), (I, Y) => {
      var B;
      return f(), h("aside", {
        class: Re(["fe-assistant", { "fe-assistant--overlay": e.narrow }]),
        role: "complementary",
        "aria-label": u(i)("ai.assistant"),
        "data-testid": "assistant-panel"
      }, [
        d("header", X7, [
          Ze(u(aP), {
            class: "fe-assistant__mark",
            "aria-hidden": "true"
          }),
          d("div", J7, [
            d("h2", Z7, y(((B = c.value) == null ? void 0 : B.title) || u(i)("ai.assistant")), 1),
            D.value ? (f(), h("p", Q7, y(D.value), 1)) : O("", !0)
          ]),
          d("button", {
            type: "button",
            class: "fe-assistant__iconbtn",
            title: u(i)("assistant.new"),
            "aria-label": u(i)("assistant.new"),
            disabled: w.value,
            "data-testid": "assistant-new",
            onClick: ue
          }, [
            Ze(u(iP), { "aria-hidden": "true" })
          ], 8, eV),
          d("button", {
            type: "button",
            class: Re(["fe-assistant__iconbtn", { "is-active": p.value }]),
            title: u(i)("assistant.history"),
            "aria-label": u(i)("assistant.history"),
            "aria-pressed": p.value,
            "data-testid": "assistant-history",
            onClick: ae
          }, [
            Ze(u(oP), { "aria-hidden": "true" })
          ], 10, tV),
          d("button", {
            type: "button",
            class: "fe-assistant__iconbtn",
            title: u(i)("assistant.close"),
            "aria-label": u(i)("assistant.close"),
            "data-testid": "assistant-close",
            onClick: Y[0] || (Y[0] = (V) => a("close"))
          }, [
            Ze(u(rP), { "aria-hidden": "true" })
          ], 8, nV)
        ]),
        p.value ? (f(), h("div", aV, [
          m.value.length === 0 ? (f(), h("p", iV, y(u(i)("assistant.history_empty")), 1)) : (f(), h("ul", oV, [
            (f(!0), h(Te, null, nt(m.value, (V) => (f(), h("li", {
              key: V.id,
              class: "fe-assistant__conv"
            }, [
              d("button", {
                type: "button",
                class: "fe-assistant__conv-open",
                onClick: (be) => fe(V.id)
              }, [
                d("span", sV, [
                  d("bdi", null, y(V.title || u(i)("ai.assistant")), 1)
                ]),
                d("span", lV, y(u(o)(V.updated_ms, { time: !0 })), 1)
              ], 8, rV),
              d("button", {
                type: "button",
                class: "fe-assistant__iconbtn",
                title: u(i)("assistant.delete"),
                "aria-label": u(i)("assistant.delete"),
                onClick: (be) => _(V.id)
              }, [
                Ze(u(sP), { "aria-hidden": "true" })
              ], 8, uV)
            ]))), 128))
          ]))
        ])) : (f(), h("div", {
          key: 1,
          ref_key: "scroller",
          ref: C,
          class: "fe-assistant__scroll",
          "aria-live": "polite"
        }, [
          A.value.length === 0 && !b.value ? (f(), h("p", cV, y(u(i)("assistant.intro")), 1)) : O("", !0),
          (f(!0), h(Te, null, nt(A.value, (V, be) => (f(), h(Te, { key: be }, [
            V.kind === "user" ? (f(), h("div", dV, [
              d("p", fV, y(V.text), 1),
              V.paths && V.paths.length ? (f(), h("ul", pV, [
                (f(!0), h(Te, null, nt(V.paths, (Fe) => (f(), h("li", {
                  key: Fe,
                  class: "fe-assistant__chip",
                  title: Fe
                }, [
                  d("bdi", null, y(q(Fe)), 1)
                ], 8, hV))), 128))
              ])) : O("", !0)
            ])) : V.kind === "assistant" ? (f(), h("div", mV, [
              V.text && P.value[V.text] !== void 0 ? (f(), h("div", {
                key: 0,
                class: "fe-assistant__md",
                innerHTML: P.value[V.text]
              }, null, 8, vV)) : (f(), h("p", yV, y(V.text), 1))
            ])) : V.kind === "note" ? (f(), h("div", gV, y(V.text), 1)) : V.kind === "step" && V.step && V.step.status !== "waiting" ? (f(), h("div", {
              key: 3,
              class: Re(["fe-assistant__step", `is-${V.step.status}`]),
              "data-testid": `assistant-step-${V.step.id}`
            }, [
              V.step.status === "done" ? (f(), Ge(u(Av), {
                key: 0,
                class: "fe-assistant__step-icon",
                "aria-hidden": "true"
              })) : V.step.status === "undone" ? (f(), Ge(u(lP), {
                key: 1,
                class: "fe-assistant__step-icon",
                "aria-hidden": "true"
              })) : V.step.status === "denied" || V.step.status === "not_run" ? (f(), Ge(u(uP), {
                key: 2,
                class: "fe-assistant__step-icon",
                "aria-hidden": "true"
              })) : (f(), Ge(u(t_), {
                key: 3,
                class: "fe-assistant__step-icon",
                "aria-hidden": "true"
              })),
              d("span", kV, [
                d("span", wV, y(V.step.label), 1),
                V.step.target ? (f(), h("span", {
                  key: 0,
                  class: "fe-assistant__step-target",
                  title: V.step.target
                }, [
                  d("bdi", null, y(q(V.step.target)), 1)
                ], 8, _V)) : O("", !0),
                V.step.to ? (f(), h("span", {
                  key: 1,
                  class: "fe-assistant__step-to",
                  title: V.step.to
                }, [
                  d("bdi", null, y(q(V.step.to)), 1)
                ], 8, xV)) : O("", !0),
                d("span", SV, y(V.step.status_label), 1),
                V.step.error ? (f(), h("span", $V, y(V.step.error), 1)) : O("", !0)
              ]),
              V.step.can_undo ? (f(), h("button", {
                key: 4,
                type: "button",
                class: "fe-assistant__undo",
                disabled: w.value,
                "data-testid": `assistant-undo-${V.step.id}`,
                onClick: (Fe) => he(V.step)
              }, y(u(i)("assistant.undo")), 9, TV)) : O("", !0)
            ], 10, bV)) : O("", !0)
          ], 64))), 128)),
          b.value ? (f(), h(Te, { key: 1 }, [
            b.value.text ? (f(), h("div", AV, [
              d("p", EV, y(b.value.text), 1),
              b.value.paths.length ? (f(), h("ul", CV, [
                (f(!0), h(Te, null, nt(b.value.paths, (V) => (f(), h("li", {
                  key: V,
                  class: "fe-assistant__chip",
                  title: V
                }, [
                  d("bdi", null, y(q(V)), 1)
                ], 8, zV))), 128))
              ])) : O("", !0)
            ])) : O("", !0),
            (f(!0), h(Te, null, nt(b.value.steps.filter((V) => V.status !== "waiting"), (V) => (f(), h("div", {
              key: `live-${V.id}`,
              class: Re(["fe-assistant__step", `is-${V.status}`])
            }, [
              V.status === "running" ? (f(), Ge(u(n_), {
                key: 0,
                class: "fe-assistant__step-icon fe-assistant__spin",
                "aria-hidden": "true"
              })) : V.status === "done" ? (f(), Ge(u(Av), {
                key: 1,
                class: "fe-assistant__step-icon",
                "aria-hidden": "true"
              })) : (f(), Ge(u(t_), {
                key: 2,
                class: "fe-assistant__step-icon",
                "aria-hidden": "true"
              })),
              d("span", MV, [
                d("span", PV, y(V.label), 1),
                V.target ? (f(), h("span", {
                  key: 0,
                  class: "fe-assistant__step-target",
                  title: V.target
                }, [
                  d("bdi", null, y(q(V.target)), 1)
                ], 8, OV)) : O("", !0),
                d("span", LV, y(V.status_label), 1)
              ])
            ], 2))), 128)),
            b.value.reply ? (f(), h("div", DV, [
              d("p", RV, y(b.value.reply), 1)
            ])) : w.value ? (f(), h("p", IV, [
              Ze(u(n_), {
                class: "fe-assistant__spin fe-assistant__inline-icon",
                "aria-hidden": "true"
              }),
              Ht(y(u(i)("assistant.working")), 1)
            ])) : O("", !0)
          ], 64)) : O("", !0),
          L.value ? (f(), h("section", {
            key: 2,
            class: "fe-assistant__card",
            role: "group",
            "aria-label": L.value.label,
            "data-testid": "assistant-approval"
          }, [
            d("p", BV, y(L.value.question), 1),
            L.value.note ? (f(), h("p", FV, y(L.value.note), 1)) : O("", !0),
            K(L.value).length ? (f(), h("dl", UV, [
              (f(!0), h(Te, null, nt(K(L.value), ([V, be]) => (f(), h(Te, { key: V }, [
                d("dt", null, y(V), 1),
                d("dd", null, [
                  d("bdi", null, y(be), 1)
                ])
              ], 64))), 128))
            ])) : O("", !0),
            d("div", HV, [
              d("button", {
                type: "button",
                class: "fe-btn",
                disabled: w.value,
                "data-testid": "assistant-decline",
                onClick: Y[1] || (Y[1] = (V) => j(!1))
              }, y(u(i)("assistant.decline")), 9, KV),
              d("button", {
                type: "button",
                class: "fe-btn fe-btn--primary",
                disabled: w.value,
                "data-testid": "assistant-approve",
                onClick: Y[2] || (Y[2] = (V) => j(!0))
              }, y(u(i)("assistant.approve")), 9, VV)
            ])
          ], 8, NV)) : O("", !0),
          S.value ? (f(), h("p", jV, y(S.value), 1)) : O("", !0)
        ], 512)),
        d("footer", qV, [
          z.value > 0 ? (f(), h("label", WV, [
            ln(d("input", {
              "onUpdate:modelValue": Y[3] || (Y[3] = (V) => x.value = V),
              type: "checkbox",
              "data-testid": "assistant-with-selection"
            }, null, 512), [
              [zc, x.value]
            ]),
            d("span", null, y(u(i)("assistant.with_selection", { count: z.value })), 1)
          ])) : O("", !0),
          d("div", YV, [
            ln(d("textarea", {
              ref_key: "field",
              ref: T,
              "onUpdate:modelValue": Y[4] || (Y[4] = (V) => v.value = V),
              class: "fe-assistant__input",
              rows: "2",
              placeholder: u(i)("assistant.placeholder"),
              "aria-label": u(i)("assistant.placeholder"),
              "data-testid": "assistant-input",
              onKeydown: Q
            }, null, 40, GV), [
              [_n, v.value]
            ]),
            w.value ? (f(), h("button", {
              key: 0,
              type: "button",
              class: "fe-btn fe-assistant__send",
              title: u(i)("assistant.stop"),
              "aria-label": u(i)("assistant.stop"),
              "data-testid": "assistant-stop",
              onClick: re
            }, [
              Ze(u(cP), { "aria-hidden": "true" })
            ], 8, XV)) : (f(), h("button", {
              key: 1,
              type: "button",
              class: "fe-btn fe-btn--primary fe-assistant__send",
              title: u(i)("assistant.send"),
              "aria-label": u(i)("assistant.send"),
              disabled: !v.value.trim(),
              "data-testid": "assistant-send",
              onClick: ne
            }, [
              Ze(u(dP), { "aria-hidden": "true" })
            ], 8, JV))
          ])
        ])
      ], 10, G7);
    };
  }
});
function QV(e) {
  return e.replace(/\/manager(\?.*)?$/, "/assistant");
}
function ej(e) {
  let t = "";
  const n = (a) => {
    let i = "";
    const o = [];
    for (const l of a.split(`
`))
      l.startsWith("event:") ? i = l.slice(6).trim() : l.startsWith("data:") && o.push(l.slice(5).replace(/^ /, ""));
    if (!(!i || o.length === 0))
      try {
        e({ name: i, data: JSON.parse(o.join(`
`)) });
      } catch {
      }
  };
  return (a, i = !1) => {
    t += a.replace(/\r\n/g, `
`);
    let o = t.indexOf(`

`);
    for (; o >= 0; )
      n(t.slice(0, o)), t = t.slice(o + 2), o = t.indexOf(`

`);
    i && t.trim() && (n(t), t = "");
  };
}
async function i0(e, t, n, a, i) {
  var m;
  const o = await e.request(t, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "text/event-stream" },
    body: JSON.stringify(n),
    signal: i
  });
  if (!o.ok)
    throw e.failure(o.status, await o.text().catch(() => ""));
  const l = ej(a), c = (m = o.body) == null ? void 0 : m.getReader();
  if (!c) {
    l(await o.text(), !0);
    return;
  }
  const p = new TextDecoder();
  for (; ; ) {
    const { done: v, value: x } = await c.read();
    if (v) break;
    l(p.decode(x, { stream: !0 }));
  }
  l(p.decode(), !0);
}
function tj(e, t) {
  const n = t.replace(/\/+$/, ""), a = (i, o) => ({
    method: i,
    headers: { "Content-Type": "application/json" },
    ...o === void 0 ? {} : { body: JSON.stringify(o) }
  });
  return {
    me: () => e.json(`${n}`),
    setPrefs: (i) => e.json(`${n}/prefs`, a("PUT", i)),
    list: async () => (await e.json(`${n}/conversations`)).conversations ?? [],
    get: (i) => e.json(`${n}/conversations/${i}`),
    remove: (i) => e.json(`${n}/conversations/${i}`, { method: "DELETE" }),
    clear: () => e.json(`${n}/conversations`, { method: "DELETE" }),
    chat: (i, o, l) => i0(e, `${n}/chat`, i, o, l),
    decide: (i, o, l, c) => i0(e, `${n}/conversations/${i}/decide`, { approve: o }, l, c),
    undo: (i, o) => e.json(
      `${n}/conversations/${i}/undo`,
      a("POST", { step_id: o })
    )
  };
}
const _y = 500, nj = 800, o0 = 10, aj = 'button, a, input, select, textarea, label, [role="checkbox"], [data-fe-control]';
function Kg(e, t) {
  return { ctrl: e.ctrlKey || e.metaKey, shift: e.shiftKey, touch: t };
}
function Vg(e) {
  return { ctrl: !0, shift: e.shiftKey, check: !0 };
}
function ij(e) {
  const t = e.target;
  if (typeof (t == null ? void 0 : t.closest) != "function") return !1;
  const n = t.closest(aj), a = e.currentTarget;
  return n !== null && (a === null || typeof a.contains != "function" || a.contains(n));
}
function jg(e, t = {}) {
  let n, a = null, i = { clientX: 0, clientY: 0 }, o = !1, l = 0, c = !1;
  function p() {
    n && clearTimeout(n), n = void 0;
  }
  function m(S, k) {
    const b = k.touches[0];
    b && (p(), a = S, o = !1, i = { clientX: b.clientX, clientY: b.clientY }, c = !ij(k), n = setTimeout(() => {
      n = void 0, a !== null && (o = !0, e(a, i));
    }, _y));
  }
  function v(S) {
    const k = S.touches[0];
    (!k || Math.abs(k.clientX - i.clientX) > o0 || Math.abs(k.clientY - i.clientY) > o0) && (p(), a = null);
  }
  function x(S) {
    p();
    const k = a, b = o, C = k !== null && !b;
    C && (l = Date.now()), a = null, C && c && t.onTap && (S != null && S.cancelable && S.preventDefault(), t.onTap(k)), b && (S != null && S.cancelable) && S.preventDefault(), c = !1;
  }
  function w(S) {
    const k = S.pointerType;
    return k ? k === "touch" : Date.now() - l < nj;
  }
  return Tt(p), { onTouchStart: m, onTouchMove: v, onTouchEnd: x, isTap: w };
}
const r0 = 5, s0 = 10, oj = 300, l0 = 28;
function rj(e) {
  const t = $(null), n = $(null), a = $(!1);
  let i = null, o = 0;
  function l(C) {
    const T = e.keys();
    for (let A = 0; A < T.length; A++) {
      const L = e.rowEl(T[A]);
      if (!L) continue;
      const z = L.getBoundingClientRect();
      if (C < z.top + z.height / 2) return A;
    }
    return T.length;
  }
  function c(C, T) {
    const A = T.pointerType === "touch";
    if (!A && T.button !== 0) return;
    k();
    const L = e.touchDelayMs ?? _y, z = {
      key: C,
      pointerId: T.pointerId,
      touch: A,
      startX: T.clientX,
      startY: T.clientY,
      pressed: !A || L <= 0,
      armed: !1
    };
    A && L > 0 && (z.timer = setTimeout(() => {
      i === z && (z.pressed = !0, t.value = C);
    }, L)), i = z, window.addEventListener("pointermove", m), window.addEventListener("pointerup", x), window.addEventListener("pointercancel", S), window.addEventListener("blur", S), window.addEventListener("keydown", w, !0), A && window.addEventListener("touchmove", p, { passive: !1 });
  }
  function p(C) {
    i != null && i.pressed && C.cancelable && C.preventDefault();
  }
  function m(C) {
    var q;
    const T = i;
    if (!T || C.pointerId !== T.pointerId) return;
    const A = C.clientX - T.startX, L = C.clientY - T.startY;
    if (!T.armed) {
      if (!T.pressed) {
        (Math.abs(A) > s0 || Math.abs(L) > s0) && k();
        return;
      }
      if (Math.abs(A) < r0 && Math.abs(L) < r0) return;
      T.armed = !0, t.value = T.key, a.value = !0;
    }
    const z = l(C.clientY), D = e.keys().indexOf(T.key);
    n.value = z === D || z === D + 1 ? null : z;
    const U = (q = e.scroller) == null ? void 0 : q.call(e);
    if (U) {
      const P = U.getBoundingClientRect();
      C.clientY < P.top + l0 ? U.scrollTop -= 12 : C.clientY > P.bottom - l0 && (U.scrollTop += 12);
    }
  }
  function v() {
    const C = (L) => {
      L.cancelable && L.preventDefault(), A();
    }, T = setTimeout(() => A(), 600);
    function A() {
      clearTimeout(T), window.removeEventListener("touchend", C, !0);
    }
    window.addEventListener("touchend", C, { capture: !0, passive: !1 });
  }
  function x(C) {
    var L;
    const T = i;
    if (!T || C.pointerId !== T.pointerId) return;
    const A = n.value;
    if (k(), T.touch && T.pressed && v(), T.armed) {
      o = Date.now(), A !== null && e.onDrop(T.key, A);
      return;
    }
    T.touch && T.pressed && (e.touchDelayMs ?? _y) > 0 && (o = Date.now(), (L = e.onHold) == null || L.call(e, T.key));
  }
  function w(C) {
    C.key !== "Escape" || !i || (C.preventDefault(), C.stopPropagation(), S());
  }
  function S() {
    const C = (i == null ? void 0 : i.armed) === !0;
    k(), C && (o = Date.now());
  }
  function k() {
    i != null && i.timer && clearTimeout(i.timer), i = null, t.value = null, n.value = null, a.value = !1, window.removeEventListener("pointermove", m), window.removeEventListener("pointerup", x), window.removeEventListener("pointercancel", S), window.removeEventListener("blur", S), window.removeEventListener("keydown", w, !0), window.removeEventListener("touchmove", p);
  }
  function b(C) {
    Date.now() - o < oj && (C.preventDefault(), C.stopPropagation());
  }
  return Tt(k), {
    dragKey: t,
    dropGap: n,
    reordering: a,
    touchActive: () => (i == null ? void 0 : i.touch) === !0,
    onPointerDown: c,
    onClickCapture: b
  };
}
function Ja(e) {
  return e.uid || e.name;
}
function _T(e) {
  return e.map(Ja);
}
function rh(e) {
  if (typeof e != "string" || !e) return [];
  let t;
  try {
    t = JSON.parse(e);
  } catch {
    return [];
  }
  if (!Array.isArray(t)) return [];
  const n = [], a = /* @__PURE__ */ new Set();
  for (const i of t)
    typeof i != "string" || !i || a.has(i) || (a.add(i), n.push(i));
  return n;
}
function sj(e) {
  return e.length ? JSON.stringify(e) : "";
}
function lj(e) {
  return typeof e == "number" && Number.isFinite(e) ? e : null;
}
function uj(e) {
  return e.map((t, n) => ({ s: t, i: n, p: lj(t.sortOrder) })).sort((t, n) => t.p === null || n.p === null ? t.p === n.p ? t.i - n.i : t.p === null ? 1 : -1 : t.p - n.p || t.i - n.i).map((t) => t.s);
}
function cj(e, t) {
  const n = uj(e);
  if (!t.length || n.length < 2) return n;
  const a = /* @__PURE__ */ new Map();
  t.forEach((c, p) => {
    a.has(c) || a.set(c, p);
  });
  const i = (c) => (c.uid ? a.get(c.uid) : void 0) ?? a.get(c.name), o = n.filter((c) => i(c) !== void 0).sort((c, p) => (i(c) ?? 0) - (i(p) ?? 0));
  let l = 0;
  return n.map((c) => i(c) === void 0 ? c : o[l++]);
}
function u0(e, t, n) {
  const a = _T(e), i = a.indexOf(t), o = i + n;
  return i < 0 || n === 0 || o < 0 || o >= a.length ? null : (a.splice(i, 1), a.splice(o, 0, t), a);
}
function dj(e, t, n) {
  const a = _T(e), i = a.indexOf(t);
  if (i < 0) return null;
  const o = Math.max(0, Math.min(a.length, Math.trunc(n)));
  return o === i || o === i + 1 ? null : (a.splice(i, 1), a.splice(o > i ? o - 1 : o, 0, t), a);
}
function c0(e) {
  return e.map((t, n) => ({ s: t, i: n })).sort((t, n) => HS(t.s.label || t.s.name, n.s.label || n.s.name) || t.i - n.i).map((t) => Ja(t.s));
}
function fj(e, t, n) {
  const a = [...e];
  if (!n.length) return a;
  const i = /* @__PURE__ */ new Map();
  for (const l of t)
    i.set(l.name, Ja(l)), l.uid && i.set(l.uid, Ja(l));
  let o = null;
  for (const l of n) {
    const c = i.get(l);
    if (c !== void 0) {
      o = c;
      continue;
    }
    if (a.includes(l)) continue;
    const p = o === null ? 0 : a.indexOf(o) + 1;
    a.splice(p, 0, l), o = l;
  }
  return a;
}
const qo = $([]);
let Ys = null, cv = "";
function pj() {
  return nr() ? rh(gp("storageOrder")) : [];
}
function hj(e, t) {
  const n = e.length ? fj(e, t, qo.value) : [];
  qo.value = n;
  const a = sj(n);
  if (!Fl()) {
    Gr("storageOrder", a);
    return;
  }
  if (L$()) {
    d0(a);
    return;
  }
  Gr("storageOrder", a), cv = a, !Ys && (Ys = Jc(() => {
    Ys == null || Ys(), Ys = null, d0(cv), qo.value = rh(cv);
  }));
}
function d0(e) {
  Zi("storageOrder", e), dU();
}
function mj() {
  qo.value = pj();
  const e = Jc(() => {
    qo.value = rh(Qi().storageOrder);
  });
  return Zo() && Tt(e), { saved: qo, custom: E(() => qo.value.length > 0) };
}
if (typeof window < "u")
  try {
    window.addEventListener("storage", (e) => {
      e.key !== _c.storageOrder || !nr() || (qo.value = rh(e.newValue));
    });
  } catch {
  }
const vj = {
  class: "fe-stags",
  "data-testid": "storage-tags"
}, yj = ["title"], gj = {
  key: 1,
  class: "fe-stag fe-stag--warn tbl-pill",
  "data-testid": "storage-tag-readonly"
}, bj = {
  key: 2,
  class: "fe-stag tbl-pill",
  "data-testid": "storage-tag-disabled"
}, xT = /* @__PURE__ */ lt({
  __name: "StorageTags",
  props: {
    driver: {},
    readOnly: { type: Boolean },
    enabled: { type: Boolean, default: void 0 },
    locale: {}
  },
  setup(e) {
    const t = e, { t: n } = pt(() => t.locale ?? "en"), a = E(() => {
      if (!t.driver) return "";
      const i = `storages.driver.${t.driver}`, o = n(i);
      return o === i ? t.driver : o;
    });
    return (i, o) => (f(), h("span", vj, [
      e.driver ? (f(), h("span", {
        key: 0,
        class: "fe-stag tbl-pill",
        title: e.driver,
        "data-testid": "storage-tag-driver"
      }, y(a.value), 9, yj)) : O("", !0),
      e.readOnly ? (f(), h("span", gj, y(u(n)("sidenav.storage.readOnly")), 1)) : O("", !0),
      e.enabled === !1 ? (f(), h("span", bj, y(u(n)("conn.list.disabled")), 1)) : O("", !0)
    ]));
  }
}), kj = ["aria-label"], wj = {
  key: 0,
  class: "fe-sidenav__head"
}, _j = ["aria-expanded", "title", "aria-label"], xj = { class: "fe-sidenav__primary" }, Sj = ["title", "aria-label"], $j = { class: "fe-sidenav__new-main" }, Tj = {
  key: 0,
  class: "fe-sidenav__text"
}, Aj = {
  key: 0,
  class: "fe-sidenav__new-rule",
  "aria-hidden": "true"
}, Ej = {
  key: 1,
  class: "fe-sidenav__new-caret",
  "aria-hidden": "true"
}, Cj = { class: "fe-sidenav__scroll" }, zj = ["aria-label"], Mj = ["aria-current", "title", "aria-label", "data-testid", "onClick"], Pj = {
  class: "fe-ficon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true",
  focusable: "false"
}, Oj = {
  key: 1,
  d: "M3.5 7.5A1.5 1.5 0 0 1 5 6h4l2 2.5h8A1.5 1.5 0 0 1 20.5 10v7.5A1.5 1.5 0 0 1 19 19H5a1.5 1.5 0 0 1-1.5-1.5z"
}, Lj = {
  key: 3,
  d: "M12 4l2.4 4.9 5.4.8-3.9 3.8.9 5.4-4.8-2.5-4.8 2.5.9-5.4-3.9-3.8 5.4-.8z"
}, Dj = {
  key: 0,
  class: "fe-sidenav__text"
}, Rj = { key: 0 }, Ij = ["title", "aria-label"], Nj = {
  key: 0,
  class: "fe-sidenav__text"
}, Bj = {
  key: 0,
  class: "fe-sidenav__section"
}, Fj = { class: "fe-sidenav__heading" }, Uj = ["data-testid"], Hj = ["aria-label"], Kj = ["aria-current", "title", "aria-label", "data-testid", "data-tag-kind", "onClick"], Vj = { class: "fe-sidenav__text" }, jj = ["aria-label"], qj = { key: 0 }, Wj = { class: "fe-sidenav__hint" }, Yj = { key: 1 }, Gj = { key: 2 }, Xj = ["aria-label"], Jj = ["title", "aria-label"], Zj = {
  key: 1,
  class: "fe-sidenav__section"
}, Qj = {
  key: 0,
  class: "fe-sidenav__heading"
}, eq = {
  key: 1,
  class: "fe-sidenav__rule",
  "aria-hidden": "true"
}, tq = ["aria-label"], nq = ["title", "aria-label", "data-testid", "onClick", "onContextmenu", "onKeydown", "onPointerdown"], aq = {
  class: "fe-ficon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true",
  focusable: "false"
}, iq = {
  key: 0,
  class: "fe-sidenav__text"
}, oq = ["aria-label"], rq = {
  key: 2,
  class: "fe-sidenav__section",
  "data-testid": "sidenav-apps"
}, sq = {
  key: 0,
  class: "fe-sidenav__heading"
}, lq = {
  key: 1,
  class: "fe-sidenav__rule",
  "aria-hidden": "true"
}, uq = ["aria-label"], cq = ["title", "aria-label", "data-testid", "onClick"], dq = ["innerHTML"], fq = {
  key: 0,
  class: "fe-sidenav__text"
}, pq = { key: 0 }, hq = ["title", "aria-label"], mq = {
  key: 0,
  class: "fe-sidenav__text"
}, vq = {
  key: 3,
  class: "fe-sidenav__section",
  "data-testid": "sidenav-connections"
}, yq = ["aria-label"], gq = ["title", "aria-label"], bq = {
  key: 0,
  class: "fe-sidenav__text"
}, kq = { key: 0 }, wq = ["title", "aria-label"], _q = {
  key: 0,
  class: "fe-sidenav__text"
}, xq = {
  key: 1,
  class: "fe-sidenav__quota",
  "data-testid": "sidenav-quota"
}, Sq = {
  key: 0,
  class: "fe-sidenav__quota-label"
}, $q = ["aria-valuenow", "aria-label", "title"], Tq = {
  key: 1,
  class: "fe-sidenav__quota-text"
}, f0 = 8, Aq = /* @__PURE__ */ lt({
  __name: "SideNav",
  props: {
    expanded: { type: Boolean },
    narrow: { type: Boolean },
    activeView: {},
    activeStorage: {},
    storages: {},
    storageOrderCustom: { type: Boolean },
    sharedStorages: {},
    trashVisible: { type: Boolean },
    draftsVisible: { type: Boolean },
    draftCount: {},
    tags: {},
    tagsLoaded: { type: Boolean },
    activeTag: {},
    activeTagKind: {},
    showConnections: { type: Boolean },
    showMyShares: { type: Boolean },
    showAppStore: { type: Boolean },
    showIdentitySurfaces: { type: Boolean },
    canWrite: { type: Boolean },
    locale: {},
    canRequestFiles: { type: Boolean },
    requestFilesAllowed: { type: Boolean, default: !0 },
    canNewDocument: { type: Boolean },
    quota: {},
    theme: {},
    apps: {}
  },
  emits: ["toggle", "open-view", "open-tag", "open-storage", "open-root", "upload", "new-folder", "new-document", "open-connections", "open-tokens", "open-my-shares", "open-app-store", "open-app", "request-files", "reorder-storages", "close"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i, formatSize: o, dir: l } = pt(() => n.locale), c = E(() => n.expanded || !!n.narrow), p = E(() => new Set(n.sharedStorages ?? [])), m = /* @__PURE__ */ new Set(["recent", "starred", "shared", "drafts"]), v = E(() => {
      const Ie = [
        { key: "home", label: i("sidenav.home") },
        ...n.storages.length <= 1 ? [{ key: "myfiles", label: i("sidenav.myfiles") }] : [],
        { key: "shared", label: i("sidenav.shared") },
        { key: "recent", label: i("sidenav.recent") },
        { key: "starred", label: i("sidenav.starred") }
      ];
      return n.draftsVisible && Ie.push({ key: "drafts", label: i("sidenav.drafts") }), n.trashVisible !== !1 && Ie.push({ key: "trash", label: i("sidenav.trash") }), n.showIdentitySurfaces === !1 ? Ie.filter((se) => !m.has(se.key)) : Ie;
    }), x = E(() => n.canWrite !== !1), w = E(
      () => (n.apps ?? []).map((Ie) => ({
        ...Ie,
        svg: zt(Ie.icon && zt(Ie.icon) !== "" ? Ie.icon : "plugin")
      }))
    ), S = E(
      () => !!n.activeStorage && n.storages.some((Ie) => Ie.name === n.activeStorage && Ie.readOnly === !0)
    ), k = E(() => !S.value && n.activeView !== "trash");
    function b(Ie) {
      const se = n.draftCount ?? 0;
      return Ie.key !== "drafts" || se <= 0 ? Ie.label : `${Ie.label}, ${i("sidenav.drafts.count", { n: se })}`;
    }
    function C(Ie) {
      return Ie === "myfiles" ? !n.activeView && !n.activeStorage : n.activeView === Ie;
    }
    const T = $(!1), A = E(() => n.tags ?? []), L = E(
      () => ["personal", "team"].map((Ie) => {
        const se = A.value.filter((xe) => xe.kind === Ie);
        return { kind: Ie, list: se, visible: T.value ? se : se.slice(0, f0) };
      }).filter((Ie) => Ie.list.length > 0)
    ), z = E(
      () => L.value.reduce((Ie, se) => Ie + se.list.length - se.visible.length, 0)
    ), D = E(() => L.value.some((Ie) => Ie.list.length > f0));
    function U(Ie) {
      return n.activeView !== "tag" || n.activeTag !== Ie.name ? !1 : !n.activeTagKind || n.activeTagKind === Ie.kind;
    }
    const q = E(() => !!n.tagsLoaded || A.value.length > 0), P = $(null), R = $(null), W = E(() => {
      const Ie = [
        /* ⚠ NO `icon:` on any of these three, and that is the fix rather than an
           omission. `ContextMenu.iconFor` resolves `actionIconSvg(a.icon || a.key)`,
           so an `icon` string is an OVERRIDE — and `'⬆'` / `'📁'` / `'🔗'` are not
           keys, so the lookup missed, the component fell through to its literal
           branch and printed the emoji. Meanwhile `new-document`, which carries no
           override, resolved by key and drew a proper glyph: one menu, two icon
           systems, three rows apart. All three keys have had stroked glyphs in
           `lib/actionIcons.ts` the whole time (`upload`, `new-folder`,
           `request-files`); dropping the override is what reaches them.
           ⚠ Emoji in markup is forbidden here for a reason that is visible in this
           very menu: they are rendered by whatever font the OS ships, so the row
           came out flat-grey on one machine and full-colour on another, at a weight
           that matched nothing beside it. */
        { key: "upload", label: i("drive.new.upload"), disabled: !x.value },
        { key: "new-folder", label: i("drive.new.folder"), disabled: !x.value }
      ];
      return n.canNewDocument && Ie.push({ key: "new-document", label: i("drive.new.document"), disabled: !x.value }), n.requestFilesAllowed !== !1 && (Ie.push({ divider: !0, key: "new-sep", label: "" }), Ie.push({
        key: "request-files",
        label: i("drive.new.request"),
        disabled: !n.canRequestFiles
      })), Ie;
    });
    function N() {
      var se, xe;
      const Ie = (se = P.value) == null ? void 0 : se.getBoundingClientRect();
      (xe = R.value) == null || xe.show(
        // ⚠ RTL: hangs from the pill's START edge (its right side in RTL).
        { clientX: Ie ? Ur(Ie, l.value) : 0, clientY: Ie ? Ie.bottom + 6 : 0 },
        []
      );
    }
    function J(Ie) {
      Ie.key === "upload" ? a("upload") : Ie.key === "new-document" ? a("new-document") : Ie.key === "new-folder" ? a("new-folder") : Ie.key === "request-files" && a("request-files");
    }
    const H = E(() => {
      const Ie = n.quota;
      return !Ie || Ie.unlimited || Ie.total <= 0 ? 0 : Math.max(0, Math.min(100, Math.round(Ie.used / Ie.total * 100)));
    }), ne = E(() => {
      const Ie = n.quota;
      return Ie ? Ie.unlimited || Ie.total <= 0 ? Ie.partial ? i("drive.storage.used_partial", { used: o(Ie.used) }) : i("drive.storage.used_unlimited", { used: o(Ie.used) }) : i("drive.storage.used", { used: o(Ie.used), total: o(Ie.total) }) : "";
    }), j = E(() => i("sidenav.close")), re = E(() => n.storages.length > 1), he = /* @__PURE__ */ new Map();
    function ue(Ie, se) {
      se instanceof HTMLElement ? he.set(Ie, se) : he.delete(Ie);
    }
    const ae = $(null), fe = $(null), _ = $(""), Q = $(!1);
    function K(Ie) {
      return n.storages.findIndex((se) => Ja(se) === Ie);
    }
    const I = E(() => {
      const Ie = K(_.value), se = n.storages.length, xe = n.storages.map(Ja), De = c0(n.storages).every((ot, ft) => ot === xe[ft]);
      return [
        {
          key: "storage-move-up",
          icon: "move-up",
          label: i("sidenav.storage.moveUp"),
          disabled: Ie <= 0,
          testid: "sidenav-storage-move-up"
        },
        {
          key: "storage-move-down",
          icon: "move-down",
          label: i("sidenav.storage.moveDown"),
          disabled: Ie < 0 || Ie >= se - 1,
          testid: "sidenav-storage-move-down"
        },
        { divider: !0, key: "storage-order-sep", label: "" },
        {
          key: "storage-sort-name",
          icon: "sort-name",
          label: i("sidenav.storage.sortName"),
          disabled: De,
          // ⚠ A greyed row says why, or it reads as broken (ContextAction.title).
          title: De ? i("sidenav.storage.sortName.done") : void 0,
          testid: "sidenav-storage-sort-name"
        },
        {
          // "Use default order": drop the person's own order and fall back to the
          // administrator's (or, with none, the host's). Not "Reset": nothing of
          // the default is being reset, the person's order is being let go.
          key: "storage-default-order",
          icon: "reset-order",
          label: i("sidenav.storage.defaultOrder"),
          disabled: !n.storageOrderCustom,
          title: n.storageOrderCustom ? void 0 : i("sidenav.storage.defaultOrder.none"),
          testid: "sidenav-storage-default-order"
        }
      ];
    });
    function Y(Ie, se, xe = !1) {
      var ot, ft;
      if (!re.value) return;
      const me = Ja(Ie);
      _.value = me, Q.value = xe;
      let De = se;
      if (!De) {
        const gt = (ot = he.get(me)) == null ? void 0 : ot.getBoundingClientRect();
        De = gt ? { clientX: Ur(gt, l.value), clientY: gt.bottom + 4 } : { clientX: 0, clientY: 0 };
      }
      (ft = fe.value) == null || ft.show(De, []);
    }
    function B(Ie, se) {
      re.value && (se.preventDefault(), se.stopPropagation(), !We.touchActive() && Y(Ie, { clientX: se.clientX, clientY: se.clientY }));
    }
    let V = null;
    function be(Ie = !1) {
      V == null || V();
      const se = (De) => {
        const ot = De.target, ft = typeof (ot == null ? void 0 : ot.closest) == "function" && !!ot.closest(".fe-ctx-backdrop");
        !Ie && !ft || (De.preventDefault(), De.stopPropagation(), me());
      }, xe = setTimeout(() => me(), 1e3);
      function me() {
        clearTimeout(xe), window.removeEventListener("contextmenu", se, !0), V = null;
      }
      window.addEventListener("contextmenu", se, !0), V = me;
    }
    Tt(() => V == null ? void 0 : V());
    function Fe(Ie, se) {
      se.key !== "ContextMenu" && !(se.key === "F10" && se.shiftKey) || re.value && (se.preventDefault(), se.stopPropagation(), be(), Y(Ie, null));
    }
    async function ze(Ie, se) {
      var xe;
      Ie !== null && (a("reorder-storages", Ie), await Gt(), (xe = he.get(se)) == null || xe.focus());
    }
    function Ue(Ie) {
      const se = _.value;
      Ie.key === "storage-move-up" ? ze(u0(n.storages, se, -1), se) : Ie.key === "storage-move-down" ? ze(u0(n.storages, se, 1), se) : Ie.key === "storage-sort-name" ? ze(c0(n.storages), se) : Ie.key === "storage-default-order" && ze([], se);
    }
    const We = rj({
      keys: () => n.storages.map(Ja),
      rowEl: (Ie) => he.get(Ie),
      scroller: () => {
        var Ie;
        return (Ie = ae.value) == null ? void 0 : Ie.querySelector(".fe-sidenav__scroll");
      },
      onDrop: (Ie, se) => void ze(dj(n.storages, Ie, se), Ie),
      onHold: (Ie) => {
        const se = n.storages.find((xe) => Ja(xe) === Ie);
        se && (be(!0), Y(se, null, !0));
      }
    }), { dragKey: $t, dropGap: St, reordering: at, onClickCapture: kt } = We;
    function ht(Ie, se) {
      re.value && We.onPointerDown(Ja(Ie), se);
    }
    return (Ie, se) => (f(), h("nav", {
      ref_key: "navEl",
      ref: ae,
      class: Re(["fe-sidenav", {
        "fe-sidenav--rail": !e.expanded && !e.narrow,
        "fe-sidenav--drawer": e.narrow,
        "fe-sidenav--reordering": u(at)
      }]),
      role: "navigation",
      "aria-label": u(i)("sidenav.title"),
      "data-testid": "sidenav"
    }, [
      e.narrow ? (f(), h("div", wj, [
        d("button", {
          type: "button",
          class: "fe-sidenav__toggle",
          "aria-expanded": c.value,
          title: j.value,
          "aria-label": j.value,
          "data-testid": "sidenav-toggle",
          onClick: se[0] || (se[0] = (xe) => a("close"))
        }, [...se[9] || (se[9] = [
          d("svg", {
            class: "fe-ficon",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "1.8",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "aria-hidden": "true",
            focusable: "false"
          }, [
            d("path", { d: "M6 6l12 12M18 6L6 18" })
          ], -1)
        ])], 8, _j)
      ])) : O("", !0),
      d("div", xj, [
        k.value ? (f(), h("button", {
          key: 0,
          ref_key: "newBtnEl",
          ref: P,
          type: "button",
          class: "fe-sidenav__new",
          "aria-haspopup": "menu",
          title: u(i)("drive.new"),
          "aria-label": u(i)("drive.new"),
          "data-testid": "sidenav-new",
          onClick: N
        }, [
          d("span", $j, [
            se[10] || (se[10] = d("svg", {
              class: "fe-ficon",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "aria-hidden": "true",
              focusable: "false"
            }, [
              d("path", { d: "M12 5v14M5 12h14" })
            ], -1)),
            c.value ? (f(), h("span", Tj, y(u(i)("drive.new")), 1)) : O("", !0)
          ]),
          c.value ? (f(), h("span", Aj)) : O("", !0),
          c.value ? (f(), h("span", Ej, [...se[11] || (se[11] = [
            d("svg", {
              class: "fe-ficon",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "aria-hidden": "true",
              focusable: "false"
            }, [
              d("path", { d: "M7 10l5 5 5-5" })
            ], -1)
          ])])) : O("", !0)
        ], 8, Sj)) : O("", !0)
      ]),
      d("div", Cj, [
        d("ul", {
          class: "fe-sidenav__group",
          "aria-label": u(i)("sidenav.views")
        }, [
          (f(!0), h(Te, null, nt(v.value, (xe) => (f(), h(Te, {
            key: xe.key
          }, [
            d("li", null, [
              d("button", {
                type: "button",
                class: Re(["fe-sidenav__item", { "is-active": C(xe.key) }]),
                "aria-current": C(xe.key) ? "page" : void 0,
                title: b(xe),
                "aria-label": b(xe),
                "data-testid": `sidenav-view-${xe.key}`,
                onClick: (me) => a("open-view", xe.key)
              }, [
                (f(), h("svg", Pj, [
                  xe.key === "home" ? (f(), h(Te, { key: 0 }, [
                    se[12] || (se[12] = d("path", { d: "M4 10.5L12 4l8 6.5" }, null, -1)),
                    se[13] || (se[13] = d("path", { d: "M6 9.8V19a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V9.8" }, null, -1)),
                    se[14] || (se[14] = d("path", { d: "M10 20v-5.5h4V20" }, null, -1))
                  ], 64)) : xe.key === "myfiles" ? (f(), h("path", Oj)) : xe.key === "recent" ? (f(), h(Te, { key: 2 }, [
                    se[15] || (se[15] = d("circle", {
                      cx: "12",
                      cy: "12",
                      r: "8.5"
                    }, null, -1)),
                    se[16] || (se[16] = d("path", { d: "M12 7.5V12l3 2" }, null, -1))
                  ], 64)) : xe.key === "starred" ? (f(), h("path", Lj)) : xe.key === "shared" ? (f(), h(Te, { key: 4 }, [
                    se[17] || (se[17] = d("circle", {
                      cx: "17.5",
                      cy: "6.5",
                      r: "2.5"
                    }, null, -1)),
                    se[18] || (se[18] = d("circle", {
                      cx: "6.5",
                      cy: "12",
                      r: "2.5"
                    }, null, -1)),
                    se[19] || (se[19] = d("circle", {
                      cx: "17.5",
                      cy: "17.5",
                      r: "2.5"
                    }, null, -1)),
                    se[20] || (se[20] = d("path", { d: "M8.8 10.8l6.4-3.2M8.8 13.2l6.4 3.2" }, null, -1))
                  ], 64)) : xe.key === "drafts" ? (f(), h(Te, { key: 5 }, [
                    se[21] || (se[21] = d("path", { d: "M13.5 4H7a1.5 1.5 0 0 0-1.5 1.5v13A1.5 1.5 0 0 0 7 20h10a1.5 1.5 0 0 0 1.5-1.5V9z" }, null, -1)),
                    se[22] || (se[22] = d("path", { d: "M13.5 4v5h5" }, null, -1)),
                    se[23] || (se[23] = d("path", { d: "M9 15.5l4.8-4.8 1.7 1.7-4.8 4.8H9z" }, null, -1))
                  ], 64)) : (f(), h(Te, { key: 6 }, [
                    se[24] || (se[24] = d("path", { d: "M4.5 7h15" }, null, -1)),
                    se[25] || (se[25] = d("path", { d: "M9.5 7V5.2A1.2 1.2 0 0 1 10.7 4h2.6a1.2 1.2 0 0 1 1.2 1.2V7" }, null, -1)),
                    se[26] || (se[26] = d("path", { d: "M6.5 7l.9 11.1A1.4 1.4 0 0 0 8.8 19.4h6.4a1.4 1.4 0 0 0 1.4-1.3L17.5 7" }, null, -1))
                  ], 64))
                ])),
                c.value ? (f(), h("span", Dj, y(xe.label), 1)) : O("", !0),
                xe.key === "drafts" && (e.draftCount ?? 0) > 0 ? (f(), h("span", {
                  key: 1,
                  class: Re(["fe-sidenav__count", { "fe-sidenav__count--rail": !c.value }]),
                  "aria-hidden": "true",
                  "data-testid": "sidenav-drafts-count"
                }, y(e.draftCount), 3)) : O("", !0)
              ], 10, Mj)
            ]),
            xe.key === "shared" && e.showMyShares ? (f(), h("li", Rj, [
              d("button", {
                type: "button",
                class: "fe-sidenav__item",
                title: u(i)("sidenav.myshares"),
                "aria-label": u(i)("sidenav.myshares"),
                "data-testid": "sidenav-my-shares",
                onClick: se[1] || (se[1] = (me) => a("open-my-shares"))
              }, [
                se[27] || (se[27] = d("svg", {
                  class: "fe-ficon",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "1.8",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "aria-hidden": "true",
                  focusable: "false"
                }, [
                  d("path", { d: "M10 13.5a4.5 4.5 0 0 0 6.8.5l2.7-2.7a4.5 4.5 0 0 0-6.36-6.36L11.6 6.5" }),
                  d("path", { d: "M14 10.5a4.5 4.5 0 0 0-6.8-.5l-2.7 2.7a4.5 4.5 0 0 0 6.36 6.36l1.53-1.53" })
                ], -1)),
                c.value ? (f(), h("span", Nj, y(u(i)("sidenav.myshares")), 1)) : O("", !0)
              ], 8, Ij)
            ])) : O("", !0)
          ], 64))), 128))
        ], 8, zj),
        q.value ? (f(), h("div", Bj, [
          c.value ? (f(), h(Te, { key: 0 }, [
            d("p", Fj, y(u(i)("sidenav.tags")), 1),
            (f(!0), h(Te, null, nt(L.value, (xe) => (f(), h(Te, {
              key: xe.kind
            }, [
              d("p", {
                class: "fe-sidenav__subheading",
                "data-testid": `sidenav-tags-${xe.kind}`
              }, [
                Ze(Vv, {
                  kind: xe.kind,
                  size: 12
                }, null, 8, ["kind"]),
                d("span", null, y(u(i)(`sidenav.tags.${xe.kind}`)), 1)
              ], 8, Uj),
              d("ul", {
                class: "fe-sidenav__group",
                "aria-label": `${u(i)("sidenav.tags")} - ${u(i)(`sidenav.tags.${xe.kind}`)}`
              }, [
                (f(!0), h(Te, null, nt(xe.visible, (me) => (f(), h("li", {
                  key: `${me.kind}:${me.name}`
                }, [
                  d("button", {
                    type: "button",
                    class: Re(["fe-sidenav__item fe-sidenav__item--tag", { "is-active": U(me) }]),
                    "aria-current": U(me) ? "page" : void 0,
                    title: u(i)(`tags.chip.${me.kind}`, { tag: me.name }),
                    "aria-label": u(i)(`tags.chip.${me.kind}`, { tag: me.name }),
                    "data-testid": `sidenav-tag-${me.name}`,
                    "data-tag-kind": me.kind,
                    onClick: (De) => a("open-tag", me.name, me.kind)
                  }, [
                    Ze(Vv, {
                      class: "fe-ficon",
                      kind: me.kind,
                      size: 16
                    }, null, 8, ["kind"]),
                    d("span", Vj, y(me.name), 1)
                  ], 10, Kj)
                ]))), 128))
              ], 8, Hj)
            ], 64))), 128)),
            d("ul", {
              class: "fe-sidenav__group",
              "aria-label": u(i)("sidenav.tags")
            }, [
              A.value.length === 0 ? (f(), h("li", qj, [
                d("p", Wj, y(u(i)("sidenav.tags.empty")), 1)
              ])) : O("", !0),
              z.value > 0 ? (f(), h("li", Yj, [
                d("button", {
                  type: "button",
                  class: "fe-sidenav__more",
                  "data-testid": "sidenav-tags-more",
                  onClick: se[2] || (se[2] = (xe) => T.value = !0)
                }, y(u(i)("sidenav.tags.more", { count: z.value })), 1)
              ])) : T.value && D.value ? (f(), h("li", Gj, [
                d("button", {
                  type: "button",
                  class: "fe-sidenav__more",
                  "data-testid": "sidenav-tags-less",
                  onClick: se[3] || (se[3] = (xe) => T.value = !1)
                }, y(u(i)("sidenav.tags.less")), 1)
              ])) : O("", !0)
            ], 8, jj)
          ], 64)) : (f(), h(Te, { key: 1 }, [
            se[29] || (se[29] = d("hr", {
              class: "fe-sidenav__rule",
              "aria-hidden": "true"
            }, null, -1)),
            d("ul", {
              class: "fe-sidenav__group",
              "aria-label": u(i)("sidenav.tags")
            }, [
              d("li", null, [
                d("button", {
                  type: "button",
                  class: Re(["fe-sidenav__item", { "is-active": e.activeView === "tag" }]),
                  title: u(i)("sidenav.tags"),
                  "aria-label": u(i)("sidenav.tags"),
                  "data-testid": "sidenav-tags-rail",
                  onClick: se[4] || (se[4] = (xe) => a("toggle"))
                }, [...se[28] || (se[28] = [
                  d("svg", {
                    class: "fe-ficon",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "1.8",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "aria-hidden": "true",
                    focusable: "false"
                  }, [
                    d("path", { d: "M4 4.5h7l9 9-6.5 6.5-9-9z" }),
                    d("circle", {
                      cx: "8",
                      cy: "8.5",
                      r: "1.4"
                    })
                  ], -1)
                ])], 10, Jj)
              ])
            ], 8, Xj)
          ], 64))
        ])) : O("", !0),
        e.storages.length ? (f(), h("div", Zj, [
          c.value ? (f(), h("p", Qj, y(u(i)("sidenav.storages")), 1)) : (f(), h("hr", eq)),
          d("ul", {
            class: "fe-sidenav__group",
            "aria-label": u(i)("sidenav.storages"),
            "data-testid": "sidenav-storages",
            onClickCapture: se[5] || (se[5] = //@ts-ignore
            (...xe) => u(kt) && u(kt)(...xe))
          }, [
            (f(!0), h(Te, null, nt(e.storages, (xe, me) => (f(), h("li", {
              key: xe.name,
              class: Re({
                "is-drop-before": u(St) === me,
                "is-drop-after": u(St) === e.storages.length && me === e.storages.length - 1
              })
            }, [
              d("button", {
                ref_for: !0,
                ref: (De) => ue(u(Ja)(xe), De),
                type: "button",
                class: Re(["fe-sidenav__item fe-sidenav__item--storage", {
                  "is-active": !e.activeView && e.activeStorage === xe.name,
                  "is-dragging": u($t) === u(Ja)(xe)
                }]),
                title: p.value.has(xe.name) ? `${xe.label || xe.name} - ${u(i)("sidenav.storage.shared")}` : xe.label || xe.name,
                "aria-label": p.value.has(xe.name) ? `${xe.label || xe.name} - ${u(i)("sidenav.storage.shared")}` : xe.label || xe.name,
                "data-testid": `sidenav-storage-${xe.name}`,
                onClick: (De) => a("open-storage", xe.name),
                onContextmenu: (De) => B(xe, De),
                onKeydown: (De) => Fe(xe, De),
                onPointerdown: (De) => ht(xe, De)
              }, [
                (f(), h("svg", aq, [
                  p.value.has(xe.name) ? (f(), h(Te, { key: 0 }, [
                    se[30] || (se[30] = d("path", { d: "M3 8.5A1.5 1.5 0 0 1 4.5 7h5L11 9h8.5A1.5 1.5 0 0 1 21 10.5v7A1.5 1.5 0 0 1 19.5 19h-15A1.5 1.5 0 0 1 3 17.5z" }, null, -1)),
                    se[31] || (se[31] = d("circle", {
                      cx: "15.6",
                      cy: "13.6",
                      r: "1.6"
                    }, null, -1)),
                    se[32] || (se[32] = d("circle", {
                      cx: "9.4",
                      cy: "15.4",
                      r: "1.6"
                    }, null, -1)),
                    se[33] || (se[33] = d("path", { d: "M10.9 14.7l3.3-.9" }, null, -1))
                  ], 64)) : (f(), h(Te, { key: 1 }, [
                    se[34] || (se[34] = d("rect", {
                      x: "3",
                      y: "5",
                      width: "18",
                      height: "6",
                      rx: "1.6"
                    }, null, -1)),
                    se[35] || (se[35] = d("rect", {
                      x: "3",
                      y: "13",
                      width: "18",
                      height: "6",
                      rx: "1.6"
                    }, null, -1)),
                    se[36] || (se[36] = d("path", { d: "M6.5 8h.01M6.5 16h.01" }, null, -1))
                  ], 64))
                ])),
                c.value ? (f(), h("span", iq, y(xe.label || xe.name), 1)) : O("", !0),
                c.value && p.value.has(xe.name) ? (f(), h("span", {
                  key: 1,
                  class: "fe-sidenav__tag",
                  role: "img",
                  "aria-label": u(i)("sidenav.storage.shared")
                }, y(u(i)("sidenav.storage.shared")), 9, oq)) : O("", !0),
                c.value && xe.readOnly ? (f(), Ge(xT, {
                  key: 2,
                  "read-only": "",
                  locale: e.locale,
                  class: "fe-sidenav__stags",
                  "data-testid": "sidenav-storage-readonly"
                }, null, 8, ["locale"])) : O("", !0)
              ], 42, nq)
            ], 2))), 128))
          ], 40, tq)
        ])) : O("", !0),
        w.value.length || e.showAppStore ? (f(), h("div", rq, [
          c.value ? (f(), h("p", sq, y(u(i)("sidenav.apps")), 1)) : (f(), h("hr", lq)),
          d("ul", {
            class: "fe-sidenav__group",
            "aria-label": u(i)("sidenav.apps")
          }, [
            (f(!0), h(Te, null, nt(w.value, (xe) => (f(), h("li", {
              key: xe.key
            }, [
              d("button", {
                type: "button",
                class: "fe-sidenav__item",
                title: xe.label,
                "aria-label": xe.label,
                "data-testid": `sidenav-app-${xe.key}`,
                onClick: (me) => a("open-app", xe.key)
              }, [
                d("span", {
                  class: "fe-sidenav__appicon",
                  "aria-hidden": "true",
                  innerHTML: xe.svg
                }, null, 8, dq),
                c.value ? (f(), h("span", fq, y(xe.label), 1)) : O("", !0)
              ], 8, cq)
            ]))), 128)),
            e.showAppStore ? (f(), h("li", pq, [
              d("button", {
                type: "button",
                class: "fe-sidenav__item",
                title: u(i)("sidenav.appstore"),
                "aria-label": u(i)("sidenav.appstore"),
                "data-testid": "sidenav-app-store",
                onClick: se[6] || (se[6] = (xe) => a("open-app-store"))
              }, [
                se[37] || (se[37] = d("svg", {
                  class: "fe-ficon",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "1.8",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "aria-hidden": "true",
                  focusable: "false"
                }, [
                  d("path", { d: "M3 9l1.5-5h15L21 9" }),
                  d("path", { d: "M3 9a3 3 0 0 0 6 0a3 3 0 0 0 6 0a3 3 0 0 0 6 0" }),
                  d("path", { d: "M5 11.5V20h14v-8.5" }),
                  d("path", { d: "M10 20v-5h4v5" })
                ], -1)),
                c.value ? (f(), h("span", mq, y(u(i)("sidenav.appstore")), 1)) : O("", !0)
              ], 8, hq)
            ])) : O("", !0)
          ], 8, uq)
        ])) : O("", !0),
        e.showConnections ? (f(), h("div", vq, [
          se[40] || (se[40] = d("hr", {
            class: "fe-sidenav__rule",
            "aria-hidden": "true"
          }, null, -1)),
          d("ul", {
            class: "fe-sidenav__group",
            "aria-label": u(i)("sidenav.connections")
          }, [
            d("li", null, [
              d("button", {
                type: "button",
                class: "fe-sidenav__item",
                title: u(i)("sidenav.connect"),
                "aria-label": u(i)("sidenav.connect"),
                "data-testid": "sidenav-connect",
                onClick: se[7] || (se[7] = (xe) => a("open-connections"))
              }, [
                se[38] || (se[38] = d("svg", {
                  class: "fe-ficon",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "1.8",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "aria-hidden": "true",
                  focusable: "false"
                }, [
                  d("path", { d: "M9.5 14.5l-2.6 2.6a3.7 3.7 0 0 1-5.2-5.2l2.6-2.6" }),
                  d("path", { d: "M14.5 9.5l2.6-2.6a3.7 3.7 0 0 1 5.2 5.2l-2.6 2.6" }),
                  d("path", { d: "M9 15l6-6" })
                ], -1)),
                c.value ? (f(), h("span", bq, y(u(i)("sidenav.connect")), 1)) : O("", !0)
              ], 8, gq)
            ]),
            e.showIdentitySurfaces !== !1 ? (f(), h("li", kq, [
              d("button", {
                type: "button",
                class: "fe-sidenav__item",
                title: u(i)("sidenav.apikeys"),
                "aria-label": u(i)("sidenav.apikeys"),
                "data-testid": "sidenav-apikeys",
                onClick: se[8] || (se[8] = (xe) => a("open-tokens"))
              }, [
                se[39] || (se[39] = d("svg", {
                  class: "fe-ficon",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "1.8",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "aria-hidden": "true",
                  focusable: "false"
                }, [
                  d("circle", {
                    cx: "8",
                    cy: "12",
                    r: "3.5"
                  }),
                  d("path", { d: "M11.5 12H21" }),
                  d("path", { d: "M17.5 12v3.2M20 12v2.2" })
                ], -1)),
                c.value ? (f(), h("span", _q, y(u(i)("sidenav.apikeys")), 1)) : O("", !0)
              ], 8, wq)
            ])) : O("", !0)
          ], 8, yq)
        ])) : O("", !0)
      ]),
      e.quota ? (f(), h("div", xq, [
        c.value ? (f(), h("p", Sq, y(u(i)("drive.storage.label")), 1)) : O("", !0),
        d("div", {
          class: "fe-sidenav__quota-bar",
          role: "progressbar",
          "aria-valuenow": H.value,
          "aria-valuemin": "0",
          "aria-valuemax": "100",
          "aria-label": ne.value,
          title: ne.value
        }, [
          d("span", {
            class: "fe-sidenav__quota-fill",
            style: Wt({ width: H.value + "%" })
          }, null, 4)
        ], 8, $q),
        c.value ? (f(), h("p", Tq, y(ne.value), 1)) : O("", !0)
      ])) : O("", !0),
      Ze(_l, {
        ref_key: "newMenuRef",
        ref: R,
        locale: e.locale,
        theme: e.theme,
        actions: W.value,
        onSelect: J
      }, null, 8, ["locale", "theme", "actions"]),
      Ze(_l, {
        ref_key: "storageMenuRef",
        ref: fe,
        locale: e.locale,
        theme: e.theme,
        sheet: Q.value,
        actions: I.value,
        onSelect: Ue
      }, null, 8, ["locale", "theme", "sheet", "actions"])
    ], 10, kj));
  }
}), Eq = 200;
function p0(e) {
  if (!e || typeof e != "object") return !1;
  const t = e, n = t.e2e_name_state;
  return n === "enc" || n === "locked" || n === "unreadable" ? !0 : typeof t.vault_root == "string" && t.vault_root !== "";
}
function ic(e, t, n, a) {
  const i = $(null), o = $(!1), l = $(!1);
  let c = null, p = null;
  function m() {
    c && clearTimeout(c), c = null, p == null || p.abort(), p = null;
  }
  async function v(x, w) {
    const S = a();
    if (!S) {
      o.value = !0;
      return;
    }
    const k = new AbortController();
    p = k, l.value = !0;
    try {
      const b = await S(x, w, k.signal);
      if (k.signal.aborted) return;
      i.value = { q: x, names: new Set(b.map((C) => w[C]).filter((C) => typeof C == "string")) }, o.value = !1;
    } catch (b) {
      if ((b == null ? void 0 : b.name) === "AbortError" || k.signal.aborted) return;
      o.value = !0;
    } finally {
      p === k && (p = null, l.value = !1);
    }
  }
  return Je(
    () => {
      const x = e().trim();
      if (!x) return "";
      const w = /* @__PURE__ */ new Set();
      for (const S of t())
        p0(S) || w.add(n(S) || "");
      return JSON.stringify([x, [...w].sort()]);
    },
    (x) => {
      if (m(), !x) {
        i.value = null, l.value = !1;
        return;
      }
      const [w, S] = JSON.parse(x);
      if (S.length === 0) {
        i.value = { q: w, names: /* @__PURE__ */ new Set() };
        return;
      }
      l.value = !0, c = setTimeout(() => {
        c = null, v(w, S);
      }, Eq);
    },
    { immediate: !0 }
  ), y2() && Oy(m), {
    pending: l,
    apply(x) {
      const w = e().trim();
      if (!w) return x;
      const S = i.value;
      return x.filter((k) => {
        const b = n(k) || "";
        return p0(k) || o.value || !a() ? e$(b, w) : !S || S.q !== w ? !0 : S.names.has(b);
      });
    }
  };
}
const ST = "application/x-brf-files", Cq = "application/x-brf-files-src";
let rl = null;
const zq = 5 * 6e4;
function Mq(e, t) {
  rl = { items: e.slice(), origin: t, startedAt: Date.now() };
}
function zr() {
  rl = null;
}
function Tc() {
  return rl ? Date.now() - rl.startedAt > zq ? (rl = null, null) : rl : null;
}
function ti(e) {
  var t;
  return (t = e.dataTransfer) != null && t.types.includes(ST) ? !0 : Tc() !== null;
}
function If(e) {
  var a;
  const t = (a = e.dataTransfer) == null ? void 0 : a.getData(ST);
  if (t)
    try {
      const i = JSON.parse(t);
      return Array.isArray(i) && i.length > 0 ? i : null;
    } catch {
      return null;
    }
  const n = Tc();
  return n && n.items.length > 0 ? n.items : null;
}
function xy(e) {
  var n, a;
  const t = (n = e.dataTransfer) == null ? void 0 : n.getData(Cq);
  return t || ((a = Tc()) == null ? void 0 : a.origin) || void 0;
}
function dv(e) {
  const t = Pq(e);
  return t === void 0 || t === "none" || t === "csrf";
}
function Pq(e) {
  if (!e || typeof e != "object") return;
  const t = e;
  return typeof t.kind == "string" ? t.kind : typeof t.type == "string" ? t.type : void 0;
}
function Oq(e, t, n) {
  if (e.type !== "file") return null;
  let a = t;
  try {
    a = new URL(t, typeof location < "u" ? location.href : void 0).toString();
  } catch {
    return null;
  }
  if (!/^https?:/i.test(a)) return null;
  const i = e.basename.replace(/[:\r\n]/g, "_");
  return `${n && n.trim() ? n : "application/octet-stream"}:${i}:${a}`;
}
function Lq(e) {
  return e.map((t) => t.path).sort().join("\0");
}
function Dq(e, t = {}) {
  const n = t.now ?? (() => Date.now()), a = t.refreshBelowMs ?? 3e4, i = t.usableAboveMs ?? 5e3, o = t.failPauseMs ?? 3e4, l = t.max ?? 32, c = /* @__PURE__ */ new Map(), p = /* @__PURE__ */ new Map();
  let m = null, v = null, x = !0;
  function w(C) {
    const T = c.get(C);
    return T ? T.expiresAt - n() : -1 / 0;
  }
  function S(C) {
    m = C;
    let T;
    try {
      T = e(C);
    } catch (A) {
      T = Promise.reject(A);
    }
    T.then((A) => {
      var L;
      if (A === null) {
        x && (x = !1, c.clear(), (L = t.onUnsupported) == null || L.call(t));
        return;
      }
      for (c.delete(C), c.set(C, { url: A.url, expiresAt: n() + A.ttlMs }); c.size > l; ) {
        const z = c.keys().next().value;
        if (z === void 0) break;
        c.delete(z);
      }
    }).catch(() => {
      p.set(C, n() + o);
    }).finally(() => {
      m = null;
      const A = v;
      v = null, A && k(A);
    });
  }
  function k(C) {
    if (!x || !C || w(C) > a) return;
    const T = p.get(C);
    if (T !== void 0) {
      if (T > n()) return;
      p.delete(C);
    }
    if (m !== C) {
      if (m !== null) {
        v = C;
        return;
      }
      S(C);
    }
  }
  function b(C) {
    const T = c.get(C);
    return T ? (c.delete(C), T.expiresAt - n() > i ? T.url : null) : null;
  }
  return {
    warm: k,
    take: b,
    get supported() {
      return x;
    }
  };
}
function _p(e) {
  return !!e && e.basename !== ".trash" && !Zy(e) && !(typeof e.vault_root == "string" && e.vault_root !== "");
}
function Nf(e) {
  return { path: e.path, basename: e.basename, type: e.type };
}
function h0(e, t = {}) {
  return t.inEncryptedFolder || e.length === 0 || !e.every((n) => _p(n)) ? null : e.map(Nf);
}
function m0(e) {
  return !!e && e.type === "file" && _p(e);
}
function Rq(e, t) {
  const { t: n } = t, a = !!e.dropped;
  return e.error === "drop_not_found" ? { kind: "flash", message: n("dragout.not_found") } : e.error === "cancelled" ? { kind: "flash", message: n("dragout.stopped") } : e.error ? a || !t.quiet ? { kind: "flash", message: e.error } : null : a ? e.finished ? { kind: "flash", message: n("dragout.done") } : {
    kind: "hold",
    message: e.files ? n("dragout.downloading_n", { n: e.files }) : n("dragout.downloading"),
    stoppable: t.stoppable
  } : t.quiet ? null : !e.finished && e.done === 0 ? { kind: "flash", message: n("dragout.preparing") } : null;
}
const Iq = ["corrupt", "encrypted", "too_large"], Nq = {
  corrupt: [
    "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z",
    "M14 2v4a2 2 0 0 0 2 2h4",
    "m14.5 12.5-5 5",
    "m9.5 12.5 5 5"
  ],
  encrypted: ["M5 11h14a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2Z", "M7 11V7a5 5 0 0 1 10 0v4"],
  too_large: ["M15 3h6v6", "M9 21H3v-6", "M21 3l-7 7", "M3 21l7-7"]
}, v0 = /* @__PURE__ */ new Map();
function Bq(e) {
  if (!e || e.type !== "file" || e.thumb_url) return null;
  const t = e.thumb_note;
  return t && Iq.includes(t) ? t : null;
}
function qg(e, t) {
  const n = Bq(e);
  if (!n) return null;
  let a, i;
  switch (n) {
    case "corrupt":
      a = t.t("thumbNote.corrupt"), i = t.t("thumbNote.corrupt_why");
      break;
    case "encrypted":
      a = t.t("thumbNote.encrypted"), i = t.t("thumbNote.encrypted_why");
      break;
    default:
      a = t.t("thumbNote.too_large"), i = t.t("thumbNote.too_large_why");
  }
  const o = t.t("thumbNote.full", { label: a, why: i }), l = `${n}|${o}`;
  let c = v0.get(l);
  return c || (c = { note: n, label: a, why: i, full: o, paths: Nq[n] }, v0.set(l, c)), c;
}
const Gs = 8 * 1024, Fq = 4 * 1024 * 1024, Uq = 3, Hq = 24, y0 = 120, Kq = 16, Vq = 8, jq = 400, qq = /* @__PURE__ */ new Set(["csv", "tsv"]);
function Wq(e) {
  if (e.trashed) return !0;
  const t = e.extra_metadata;
  return !!t && typeof t == "object" && "deleted_at" in t;
}
function xp(e) {
  if (e.type !== "file" || e.basename === ".trash" || e.mime_type === "inode/storage" || Wq(e)) return null;
  const t = e.size ?? 0;
  if (t <= 0 || t > Fq) return null;
  const n = (e.extension || "").trim().toLowerCase();
  if (qq.has(n)) return "table";
  const a = xi(e);
  return a === "code" ? "code" : a === "text" ? "text" : null;
}
function Wg(e) {
  if (e.type !== "file") return !1;
  switch (xi(e)) {
    case "pdf":
    case "doc":
    case "sheet":
    case "slides":
      return !0;
    default:
      return !1;
  }
}
function $T(e) {
  return e.type === "file" && xi(e) === "video";
}
const Yq = /* @__PURE__ */ new Set([
  "pdf",
  "doc",
  "sheet",
  "slides",
  "text",
  "archive"
]);
function Gq(e) {
  return e.type === "file" && Yq.has(xi(e));
}
const Xq = /* @__PURE__ */ new Set(["image", "video"]), g0 = /* @__PURE__ */ new Map();
function TT(e) {
  if (e.type !== "file") return null;
  const t = xi(e);
  if (Xq.has(t)) return null;
  const n = Tx(e);
  if (!n) return null;
  const a = `${t}:${n}`;
  let i = g0.get(a);
  return i || (i = { family: t, label: n }, g0.set(a, i)), i;
}
const Jq = /* @__PURE__ */ new Set([
  "import",
  "export",
  "from",
  "require",
  "include",
  "use",
  "using",
  "package",
  "module",
  "namespace",
  "const",
  "let",
  "var",
  "function",
  "func",
  "fn",
  "def",
  "class",
  "struct",
  "enum",
  "interface",
  "type",
  "impl",
  "trait",
  "public",
  "private",
  "protected",
  "static",
  "async",
  "await",
  "return",
  "if",
  "else",
  "for",
  "while",
  "switch",
  "case",
  "try",
  "catch",
  "select",
  "insert",
  "update",
  "delete",
  "create",
  "alter",
  "drop"
]), Zq = /^(#{1,6}|[-*+]|>|\d+\.)$/;
function Qq(e) {
  return e.replace(/[(){}[\];:,.]+$/, "").toLowerCase();
}
function eW(e, t) {
  const n = e.length > y0 ? e.slice(0, y0) : e, a = /^(\s*)(\S+)([\s\S]*)$/.exec(n);
  if (!a) return { indent: "", tint: "", text: n };
  const [, i, o, l] = a;
  return (t === "code" ? Jq.has(Qq(o)) : Zq.test(o)) ? { indent: i, tint: o, text: l } : { indent: "", tint: "", text: n };
}
function tW(e, t) {
  const n = [];
  let a = "", i = !1;
  for (let o = 0; o < e.length; o++) {
    const l = e[o];
    i ? l === '"' ? e[o + 1] === '"' ? (a += '"', o++) : i = !1 : a += l : l === '"' ? i = !0 : l === t ? (n.push(a), a = "") : a += l;
  }
  return n.push(a), n;
}
function nW(e, t) {
  return e === "tsv" ? "	" : !t.includes(",") && t.includes(";") ? ";" : ",";
}
function aW(e, t, n, a) {
  for (let c = 0; c < e.length; c++)
    if (e[c] === 0) return null;
  const i = new TextDecoder("utf-8", { fatal: !1 }).decode(e);
  let o = 0;
  for (const c of i) c === "�" && o++;
  if (i.length > 0 && o / i.length > 0.1) return null;
  const l = i.split(/\r\n|\r|\n/);
  for (a && l.length > 1 && l.pop(); l.length && l[0].trim() === ""; ) l.shift();
  for (; l.length && l[l.length - 1].trim() === ""; ) l.pop();
  if (l.length === 0) return null;
  if (t === "table") {
    const c = nW(n, l[0]), p = l.filter((v) => v.trim() !== "").slice(0, Kq).map((v) => tW(v, c).slice(0, Vq).map((x) => x.trim().slice(0, 24)));
    if (p.length === 0) return null;
    const m = p.reduce((v, x) => Math.max(v, x.length), 0);
    for (const v of p) for (; v.length < m; ) v.push("");
    return { kind: t, lines: [], rows: p, cols: m };
  }
  return {
    kind: t,
    lines: l.slice(0, Hq).map((c) => eW(c, t)),
    rows: [],
    cols: 0
  };
}
const iW = "\0";
function Hu(e) {
  const n = (typeof e.etag == "string" ? e.etag : "") || String(e.last_modified ?? "") || String(e.size ?? "");
  return `${e.path}${iW}${n}`;
}
function AT(e) {
  const t = e.apiBase !== void 0 && typeof e.authHeaders == "function" && typeof IntersectionObserver < "u" && typeof fetch == "function", n = $({}), a = [], i = /* @__PURE__ */ new Set(), o = /* @__PURE__ */ new Set(), l = [], c = /* @__PURE__ */ new Set(), p = /* @__PURE__ */ new WeakMap();
  let m = 0, v = null;
  const x = /* @__PURE__ */ new Map();
  function w(z) {
    const D = ux({ apiBase: e.apiBase }).manager, U = D.includes("?") ? "&" : "?", q = new URLSearchParams({ q: "preview", action: "preview", path: z });
    return `${D}${U}${q.toString()}`;
  }
  function S(z, D) {
    if (a.length >= jq) {
      const U = a.shift();
      if (U) {
        const q = { ...n.value };
        delete q[U], n.value = q;
      }
    }
    a.push(z), n.value = { ...n.value, [z]: D };
  }
  async function k(z) {
    const D = z.body;
    if (!D) {
      const N = new Uint8Array(await z.arrayBuffer());
      return { bytes: N.slice(0, Gs), truncated: N.length > Gs };
    }
    const U = D.getReader(), q = [];
    let P = 0;
    try {
      for (; P < Gs; ) {
        const { done: N, value: J } = await U.read();
        if (N) break;
        J && J.length && (q.push(J), P += J.length);
      }
    } finally {
      try {
        await U.cancel();
      } catch {
      }
    }
    const R = new Uint8Array(Math.min(P, Gs));
    let W = 0;
    for (const N of q) {
      if (W >= R.length) break;
      R.set(N.subarray(0, R.length - W), W), W += N.length;
    }
    return { bytes: R, truncated: P >= Gs };
  }
  async function b(z, D) {
    const U = Hu(z), q = new AbortController();
    c.add(q);
    try {
      const P = e.authHeaders ? await e.authHeaders() : {}, R = await fetch(w(z.path), {
        headers: { ...P, Accept: "*/*", Range: `bytes=0-${Gs - 1}` },
        credentials: e.credentials,
        signal: q.signal
      });
      if (!R.ok && R.status !== 206) throw new Error(String(R.status));
      const { bytes: W, truncated: N } = await k(R);
      q.abort();
      const J = (z.extension || "").trim().toLowerCase(), H = aW(W, D, J, N);
      if (!H) {
        i.add(U);
        return;
      }
      S(U, H);
    } catch {
      i.add(U);
    } finally {
      c.delete(q);
    }
  }
  function C() {
    for (; m < Uq && l.length > 0; ) {
      const z = l.shift(), D = xp(z);
      o.delete(Hu(z)), D && (m++, b(z, D).finally(() => {
        m--, C();
      }));
    }
  }
  function T(z) {
    const D = Hu(z);
    n.value[D] || i.has(D) || o.has(D) || (o.add(D), l.push(z), C());
  }
  function A() {
    return t ? (v || (v = new IntersectionObserver(
      (z) => {
        for (const D of z) {
          if (!D.isIntersecting) continue;
          const U = x.get(D.target);
          v == null || v.unobserve(D.target), x.delete(D.target), U && T(U);
        }
      },
      { rootMargin: "150px" }
    )), v) : null;
  }
  function L(z) {
    var D;
    return !t || (D = e.disabled) != null && D.call(e) ? null : xp(z);
  }
  return {
    enabled: t,
    kindFor: L,
    get(z) {
      return t ? n.value[Hu(z)] ?? null : null;
    },
    bind(z, D) {
      if (!z || !L(D)) return;
      const U = Hu(D);
      if (p.get(z) === U || (p.set(z, U), n.value[U] || i.has(U))) return;
      const q = A();
      q && (x.set(z, D), q.observe(z));
    },
    stats: () => ({
      loaded: a.length,
      inflight: m,
      queued: l.length,
      failed: i.size
    }),
    dispose() {
      v == null || v.disconnect(), v = null, x.clear();
      for (const z of c) z.abort();
      c.clear(), l.length = 0, o.clear();
    }
  };
}
function oW(e, t) {
  if (!e) return { id: "none", label: t.t("group.no_date") };
  const n = /* @__PURE__ */ new Date(), a = d_(n), i = d_(e);
  if (i >= a) return { id: "today", label: t.t("group.today") };
  if (i === a - 1) return { id: "yesterday", label: t.t("group.yesterday") };
  if (i > a - 7) return { id: "week", label: t.t("group.this_week") };
  const o = t.zonedYearMonth(e);
  return o === t.zonedYearMonth(n) ? { id: "month", label: t.t("group.this_month") } : { id: `m-${o}`, label: t.formatMonthYear(e) };
}
function Yg(e, t) {
  return t !== "relevance" && e === "modified";
}
function Gg(e, t) {
  var i;
  const n = [];
  if (!t.active)
    n.push({ id: "all", label: null, items: [...e] });
  else {
    let o = null;
    for (const l of e) {
      const c = ((i = t.aside) == null ? void 0 : i.call(t, l)) ?? null, p = c ? { id: c.id, label: c.label ?? null } : oW(t.dateOf(l), t.labels);
      (!o || o.id !== p.id) && (o = { id: p.id, label: p.label, items: [] }, n.push(o)), o.items.push(l);
    }
  }
  const a = /* @__PURE__ */ new Map();
  for (const o of n)
    o.label && o.items.length && a.set(o.items[0], o.label);
  return {
    active: t.active,
    runs: n,
    headingBefore: (o) => a.get(o) ?? null
  };
}
async function ET(e, t, n = {}) {
  const a = {
    "Content-Type": "application/json",
    ...await (n.authHeaders ?? (() => ({})))()
  }, i = n.apiBase ?? "", o = await fetch(`${i}/api/files/manager/star`, {
    method: "POST",
    headers: a,
    credentials: n.authCredentials ?? "same-origin",
    body: JSON.stringify({ node_id: e, starred: t })
  });
  if (!o.ok) throw fa(o.status, await o.text().catch(() => ""), n.locale);
}
const rW = ["aria-pressed", "title", "aria-label"], sW = {
  viewBox: "0 0 24 24",
  width: "16",
  height: "16",
  "aria-hidden": "true"
}, lW = ["fill"], uW = {
  key: 0,
  class: "filex-star-label"
}, Xg = /* @__PURE__ */ lt({
  __name: "StarButton",
  props: {
    starred: { type: Boolean },
    nodeId: {},
    apiBase: {},
    authHeaders: { type: Function },
    authCredentials: {},
    compact: { type: Boolean },
    card: { type: Boolean },
    locale: {}
  },
  emits: ["change", "error"],
  setup(e, { emit: t }) {
    const n = e, a = t, i = $(n.starred);
    Je(() => n.starred, (p) => {
      i.value = p;
    });
    const { t: o } = pt(() => Wi(n.locale)), l = E(() => o(i.value ? "ctx.unstar" : "ctx.star"));
    async function c() {
      const p = !i.value;
      i.value = p;
      try {
        await ET(n.nodeId, p, {
          apiBase: n.apiBase,
          authHeaders: n.authHeaders,
          authCredentials: n.authCredentials,
          locale: Wi(n.locale)
        }), a("change", p);
      } catch (m) {
        i.value = !p, a("error", m instanceof Error ? m.message : String(m));
      }
    }
    return (p, m) => (f(), h("button", {
      type: "button",
      class: Re(["filex-star-btn", { "is-starred": i.value, "is-compact": e.compact, "is-card": e.card }]),
      "aria-pressed": i.value,
      title: l.value,
      "aria-label": l.value,
      "data-testid": "star-toggle",
      onClick: yt(c, ["stop"])
    }, [
      (f(), h("svg", sW, [
        d("path", {
          fill: i.value ? "currentColor" : "none",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linejoin": "round",
          d: "M12 2.5l3.09 6.26 6.91 1-5 4.87 1.18 6.87L12 18.27l-6.18 3.23L7 14.63 2 9.76l6.91-1z"
        }, null, 8, lW)
      ])),
      e.compact ? O("", !0) : (f(), h("span", uW, y(l.value), 1))
    ], 10, rW));
  }
}), b0 = "300px";
let ho = null;
const sl = /* @__PURE__ */ new Map();
function cW() {
  return ho || (ho = new IntersectionObserver(
    (e) => {
      for (const t of e) {
        if (!t.isIntersecting) continue;
        const n = sl.get(t.target);
        n && (sl.delete(t.target), ho == null || ho.unobserve(t.target), n.forEach((a) => a()));
      }
    },
    // `rootMargin` widens the viewport only: a tile in the pane's own scroll
    // box is still cut off at that box's edge. `scrollMargin` widens the
    // scroll boxes too (Chromium 120+; an engine that does not know it
    // ignores it, and the picture is asked for as the tile scrolls in).
    { rootMargin: b0, scrollMargin: b0 }
  )), ho;
}
function dW(e, t) {
  if (!e || typeof IntersectionObserver > "u")
    return t(), () => {
    };
  let n = sl.get(e);
  return n || (n = /* @__PURE__ */ new Set(), sl.set(e, n), cW().observe(e)), n.add(t), () => {
    const a = sl.get(e);
    a && (a.delete(t), a.size === 0 && (sl.delete(e), ho == null || ho.unobserve(e)));
  };
}
const fW = ["src"], pW = {
  key: 2,
  class: "fe-thumb__play",
  "aria-hidden": "true"
}, hW = ["aria-label", "data-note"], mW = {
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  focusable: "false"
}, vW = ["d"], yW = ["dir"], Qc = /* @__PURE__ */ lt({
  inheritAttrs: !1,
  __name: "ThumbTile",
  props: {
    node: {},
    srcOf: { type: Function },
    videoBadge: { type: Boolean },
    typeBadge: {},
    note: {}
  },
  setup(e) {
    const t = e, n = $(!1);
    let a = null;
    jt(() => {
      var L;
      const A = (L = Zo()) == null ? void 0 : L.subTree.el;
      a = dW(A == null ? void 0 : A.parentElement, () => {
        n.value = !0;
      });
    }), Tt(() => {
      a == null || a(), w();
    });
    const i = E(() => n.value ? t.srcOf(t.node) : null), o = $(null), l = $(null), c = $(!1), p = $("ltr");
    function m() {
      const A = l.value, L = o.value;
      if (!A || !L) return;
      const z = L.getBoundingClientRect(), D = window.innerWidth, U = window.innerHeight, q = A.offsetWidth, P = A.offsetHeight, R = p.value, W = Oc(R === "rtl" ? z.right : z.left, q, D, R);
      let N = z.bottom + 6;
      N + P > U - 8 && (N = Math.max(8, z.top - P - 6)), A.style.insetInlineStart = `${Math.round(R === "rtl" ? D - W - q : W)}px`, A.style.top = `${Math.round(N)}px`, A.style.zIndex = String(Rc(L));
    }
    function v(A) {
      o.value && A.target instanceof Node && o.value.contains(A.target) || w();
    }
    function x() {
      c.value || !o.value || (p.value = ei(o.value), c.value = !0, document.addEventListener("pointerdown", v, !0), window.addEventListener("scroll", w, !0), Gt(m));
    }
    function w() {
      c.value && (c.value = !1, document.removeEventListener("pointerdown", v, !0), window.removeEventListener("scroll", w, !0));
    }
    function S(A) {
      A.pointerType === "mouse" && x();
    }
    function k(A) {
      A.pointerType === "mouse" && w();
    }
    let b = "";
    function C(A) {
      b = A.pointerType;
    }
    function T() {
      if (b === "mouse") {
        x();
        return;
      }
      c.value ? w() : x();
    }
    return (A, L) => (f(), h(Te, null, [
      i.value ? (f(), h("img", Tv({ key: 0 }, A.$attrs, {
        src: i.value,
        draggable: "false"
      }), null, 16, fW)) : On(A.$slots, "default", { key: 1 }),
      i.value && e.videoBadge ? (f(), h("span", pW)) : O("", !0),
      i.value && e.typeBadge ? (f(), h("span", {
        key: 3,
        class: Re(["fe-thumb__type", `fe-ftile--${e.typeBadge.family}`, { "fe-thumb__type--long": e.typeBadge.label.length > 4 }]),
        "aria-hidden": "true"
      }, y(e.typeBadge.label), 3)) : O("", !0),
      !i.value && e.note ? (f(), h("span", {
        key: 4,
        ref_key: "mark",
        ref: o,
        class: Re(["fe-thumb__note", `fe-thumb__note--${e.note.note}`]),
        role: "img",
        "aria-label": e.note.full,
        "data-note": e.note.note,
        "data-testid": "thumb-note",
        onPointerenter: S,
        onPointerleave: k,
        onPointerdown: C,
        onClick: yt(T, ["stop"]),
        onDblclick: L[0] || (L[0] = yt(() => {
        }, ["stop"]))
      }, [
        (f(), h("svg", mW, [
          (f(!0), h(Te, null, nt(e.note.paths, (z, D) => (f(), h("path", {
            key: D,
            d: z
          }, null, 8, vW))), 128))
        ]))
      ], 42, hW)) : O("", !0),
      (f(), Ge(wi, { to: "body" }, [
        c.value && e.note ? (f(), h("span", {
          key: 0,
          ref_key: "tip",
          ref: l,
          class: "fe-thumb__note-tip",
          dir: p.value,
          role: "tooltip",
          "data-testid": "thumb-note-tip"
        }, y(e.note.full), 9, yW)) : O("", !0)
      ]))
    ], 64));
  }
}), gW = ["innerHTML"], bW = {
  key: 1,
  class: "fe-fmosaic__stage"
}, kW = ["innerHTML"], Jg = /* @__PURE__ */ lt({
  __name: "FolderMosaic",
  props: {
    node: {},
    srcOf: {},
    shape: { default: "peek" }
  },
  setup(e) {
    const t = e, n = E(() => t.shape === "mini" ? 1 : 3), a = E(
      () => (t.node.preview ?? []).slice(0, n.value).map((o) => {
        const l = o.name.lastIndexOf(".");
        return {
          path: `${t.node.path.replace(/\/+$/, "")}/${o.name}`,
          basename: o.name,
          type: "file",
          extension: l > 0 ? o.name.slice(l + 1).toLowerCase() : void 0,
          thumb_url: o.thumb_url
        };
      })
    ), i = E(() => {
      const [o, l, c] = a.value;
      return c ? [{ it: c, at: 1 }, { it: l, at: 3 }, { it: o, at: 2 }] : l ? [{ it: l, at: 1 }, { it: o, at: 2 }] : o ? [{ it: o, at: 1 }] : [];
    });
    return (o, l) => (f(), h("div", {
      class: Re(["fe-fmosaic", [`fe-fmosaic--${e.shape}`, `fe-fmosaic--${a.value.length}`]]),
      "aria-hidden": "true",
      "data-fe-mosaic": ""
    }, [
      u(Vr)(e.node) ? (f(), h("span", {
        key: 0,
        class: "fe-fmosaic__glyph fe-grid__icon fe-grid__icon--svg",
        innerHTML: u(xl)()
      }, null, 8, gW)) : (f(), h("div", bW, [
        l[0] || (l[0] = d("svg", {
          class: "fe-fmosaic__back",
          viewBox: "0 0 120 88",
          preserveAspectRatio: "none",
          focusable: "false"
        }, [
          d("path", { d: "M0 10a6 6 0 0 1 6-6h27.5a6 6 0 0 1 4.4 1.9L43.6 12H114a6 6 0 0 1 6 6v64a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z" })
        ], -1)),
        (f(!0), h(Te, null, nt(i.value, (c) => (f(), h("div", {
          key: c.it.path,
          class: Re(["fe-fmosaic__print", [`fe-fmosaic__print--${c.at}`, { "is-icon": !c.it.thumb_url }]])
        }, [
          Ze(Qc, {
            node: c.it,
            "src-of": e.srcOf,
            alt: "",
            class: "fe-fmosaic__img"
          }, {
            default: mt(() => [
              d("span", {
                class: "fe-fmosaic__icon fe-grid__icon--svg",
                innerHTML: u(wa)(c.it)
              }, null, 8, kW)
            ]),
            _: 2
          }, 1032, ["node", "src-of"])
        ], 2))), 128)),
        l[1] || (l[1] = d("svg", {
          class: "fe-fmosaic__front",
          viewBox: "0 0 120 56",
          preserveAspectRatio: "none",
          focusable: "false"
        }, [
          d("path", { d: "M5 0h110a5 5 0 0 1 5 5.4l-3.3 44.6a6 6 0 0 1-6 5.6H9.3a6 6 0 0 1-6-5.6L0 5.4A5 5 0 0 1 5 0z" })
        ], -1))
      ]))
    ], 2));
  }
});
function Sy(e) {
  const t = [];
  if (!e) return t;
  const n = /«([^«»]*)»/g;
  let a = 0, i;
  for (; (i = n.exec(e)) !== null; )
    i.index > a && t.push({ text: e.slice(a, i.index), match: !1 }), i[1] && t.push({ text: i[1], match: !0 }), a = i.index + i[0].length;
  return a < e.length && t.push({ text: e.slice(a), match: !1 }), t;
}
function wW(e) {
  return e === "content" || e === "both";
}
function Zg(e, t, n) {
  const a = e.dataTransfer;
  if (!(!a || typeof document > "u" || typeof a.setDragImage != "function"))
    try {
      const i = document.createElement("div");
      i.className = "fe-dragghost";
      const o = document.createElement("span");
      if (o.className = "fe-dragghost__name", o.dir = "auto", o.textContent = t, i.appendChild(o), n > 1) {
        const l = document.createElement("span");
        l.className = "fe-dragghost__badge", l.textContent = String(n), i.appendChild(l);
      }
      i.style.position = "fixed", i.style.top = "-1000px", i.style.left = "-1000px", document.body.appendChild(i), a.setDragImage(i, 14, 14), setTimeout(() => i.remove(), 0);
    } catch {
    }
}
const _W = { class: "fe-gridbox" }, xW = {
  key: 0,
  class: "fe-grid__refreshing",
  role: "status"
}, SW = { class: "fe-sr-only" }, $W = ["aria-label", "aria-busy"], TW = {
  key: 0,
  class: "fe-grid__heading",
  "aria-hidden": "true"
}, AW = ["aria-selected", "aria-label", "data-fe-path", "onClick", "onDblclick", "onContextmenu", "onDragstart", "onDragover", "onDragleave", "onDrop", "onTouchstartPassive", "onPointerenter", "onPointerleave"], EW = ["dir"], CW = {
  key: 0,
  class: "fe-fprev__tint"
}, zW = ["innerHTML"], MW = ["aria-label", "innerHTML"], PW = ["innerHTML"], OW = {
  key: 1,
  class: "fe-grid__thumb fe-grid__thumb--folder"
}, LW = { class: "fe-grid__foot" }, DW = ["aria-label", "innerHTML"], RW = ["innerHTML"], IW = ["onClick"], NW = { class: "fe-grid__main" }, BW = ["title"], FW = ["title", "aria-label"], UW = ["title"], HW = ["title", "aria-label"], KW = ["title", "aria-label", "data-link-state"], VW = ["title", "aria-label"], jW = ["title"], qW = ["title"], WW = {
  key: 0,
  class: "fe-grid__mark"
}, YW = ["aria-label", "title", "onClick"], GW = {
  key: 0,
  class: "fe-grid__empty"
}, $y = /* @__PURE__ */ lt({
  __name: "GridView",
  props: {
    files: {},
    selected: {},
    clipped: {},
    showParentPath: { type: Boolean },
    locale: {},
    loading: { type: Boolean },
    thumbSrc: {},
    keepBadgeFor: {},
    starredIds: {},
    starEnabled: { type: Boolean },
    apiBase: {},
    authHeaders: {},
    authCredentials: {},
    sections: { type: Boolean },
    order: {},
    e2eActive: { type: Boolean },
    selectable: { type: Boolean, default: !0 }
  },
  emits: ["click-card", "dbl-card", "context-card", "item-drag-start", "item-drop-into", "star-change", "display-order", "peek", "peek-end"],
  setup(e, { emit: t }) {
    const n = e, a = t, i = E(() => n.files.some((ze) => {
      var Ue;
      return ze.type === "dir" && (((Ue = ze.preview) == null ? void 0 : Ue.length) ?? 0) > 0;
    }));
    function o(ze, Ue) {
      ze.type === "dir" && a("peek", ze, Ue.currentTarget, Ue.pointerType);
    }
    const { t: l, formatSize: c, nodeDisplayName: p, formatDate: m, formatMonthYear: v, zonedYearMonth: x, toDate: w } = pt(() => n.locale);
    function S(ze) {
      return Yr(qc(ze), { t: l, formatDate: m, locale: n.locale });
    }
    function k(ze) {
      return Wc(ze, { t: l });
    }
    function b(ze) {
      return Yc(ze, { t: l });
    }
    function C(ze) {
      return qg(ze, { t: l });
    }
    const T = E(() => [...n.files].sort(dp));
    Je(
      T,
      (ze) => a("display-order", ze),
      { immediate: !0 }
    );
    const A = E(() => {
      var ze;
      return ((ze = T.value.find((Ue) => Ue.type === "dir")) == null ? void 0 : ze.path) ?? null;
    }), L = E(() => {
      var ze;
      return ((ze = T.value.find((Ue) => Ue.type !== "dir")) == null ? void 0 : ze.path) ?? null;
    }), z = Vc(), D = E(
      () => Gg(T.value, {
        active: Yg(z.key.value, n.order),
        dateOf: (ze) => w(ze.last_modified),
        /* Folders keep their own run at the top — the same rule the list follows,
         * and the reason "folders before files" survives a date sort. Here the run
         * is the one that already had a name. */
        aside: (ze) => ze.type === "dir" ? { id: "dirs", label: n.sections ? l("drive.section.folders") : null } : null,
        labels: { t: l, formatMonthYear: v, zonedYearMonth: x }
      })
    );
    function U(ze) {
      return D.value.active ? D.value.headingBefore(ze) : n.sections ? ze.path === A.value ? l("drive.section.folders") : ze.path === L.value ? l("drive.section.files") : null : null;
    }
    function q(ze) {
      return n.thumbSrc ? n.thumbSrc(ze) : ze.thumb_url ?? null;
    }
    const P = AT({
      // Read once: the explorer's `config.apiBase` is fixed for the life of a
      // mounted panel, and `enabled` has to be answerable at construction.
      apiBase: n.apiBase,
      // Wrapped rather than passed, so a parent that re-creates its arrow on each
      // render is still called through the CURRENT prop. ⚠ The builder is async;
      // `createFilePreviews` awaits it (see the note there — a Promise spread into
      // a headers object sends no Authorization and 401s in silence).
      authHeaders: n.authHeaders ? () => n.authHeaders() : void 0,
      credentials: n.authCredentials,
      disabled: () => n.e2eActive === !0
    });
    Tt(() => P.dispose());
    function R(ze) {
      return P.kindFor(ze);
    }
    function W(ze) {
      const Ue = P.get(ze);
      return Ue ? [Ue] : [];
    }
    function N(ze, Ue) {
      P.bind(ze instanceof Element ? ze : null, Ue);
    }
    function J(ze) {
      return n.starEnabled === !1 ? !1 : n.apiBase !== void 0 && typeof ze.id == "number" && ze.type === "file";
    }
    function H(ze) {
      return n.selected.has(ze.path);
    }
    function ne(ze, Ue) {
      a("click-card", ze, Vg(Ue));
    }
    function j(ze, Ue) {
      a("click-card", ze, Kg(Ue, I.isTap(Ue)));
    }
    function re(ze) {
      a("dbl-card", ze);
    }
    function he(ze, Ue) {
      Ue.preventDefault(), Ue.stopPropagation(), a("context-card", ze, Ue);
    }
    function ue(ze, Ue) {
      he(ze, Ue);
    }
    function ae(ze, Ue) {
      Zg(
        Ue,
        p(ze),
        n.selected.has(ze.path) ? n.selected.size : 1
      ), a("item-drag-start", ze, Ue);
    }
    const fe = $(null);
    function _(ze, Ue) {
      ze.type === "dir" && ti(Ue) && (Ue.preventDefault(), Ue.stopPropagation(), Ue.dataTransfer && (Ue.dataTransfer.dropEffect = "move"), fe.value = ze.path);
    }
    function Q(ze) {
      fe.value === ze.path && (fe.value = null);
    }
    function K(ze, Ue) {
      fe.value = null, ze.type === "dir" && ti(Ue) && (Ue.preventDefault(), Ue.stopPropagation(), a("item-drop-into", ze, Ue));
    }
    const I = jg(
      (ze, Ue) => a("context-card", ze, { ...Ue, preventDefault: () => {
      }, stopPropagation: () => {
      } }),
      {
        // A finger lifted on the item, off its controls, opens at touchend — see useRowTouch.
        onTap: (ze) => a("click-card", ze, { ctrl: !1, shift: !1, touch: !0 })
      }
    );
    function Y(ze) {
      return m(ze);
    }
    function B(ze) {
      if (ze.type === "dir") return l("node.folder");
      const Ue = Y(ze.last_modified), We = c(ze.size);
      return Ue ? `${We} • ${Ue}` : We;
    }
    function V(ze) {
      return ze === "kept" ? "✓" : ze === "syncing" ? "⟳" : ze === "partial" ? "◐" : "☁";
    }
    function be(ze) {
      const Ue = ze.snippet;
      return typeof Ue == "string" ? Ue : "";
    }
    function Fe(ze) {
      return Sy(ze).map((Ue) => Ue.text).join("");
    }
    return (ze, Ue) => (f(), h("div", _W, [
      e.loading && T.value.length > 0 ? (f(), h("div", xW, [
        d("span", SW, y(u(l)("loading")), 1)
      ])) : O("", !0),
      d("div", {
        class: Re(["fe-grid", { "is-loading": e.loading, "has-selection": e.selectable && e.selected.size > 0, "has-folder-previews": i.value }]),
        role: "listbox",
        "aria-multiselectable": "true",
        "aria-label": u(l)("grid.aria"),
        "aria-busy": e.loading ? "true" : void 0
      }, [
        (f(!0), h(Te, null, nt(T.value, (We) => {
          var $t, St;
          return f(), h(Te, {
            key: We.path
          }, [
            U(We) ? (f(), h("p", TW, y(U(We)), 1)) : O("", !0),
            d("div", {
              class: Re(["fe-grid__card", {
                "fe-grid__card--folder": We.type === "dir",
                "fe-grid__card--file": We.type !== "dir",
                "is-selected": H(We),
                "is-dir": We.type === "dir",
                "is-trash": We.trashed,
                "is-clipped": ($t = e.clipped) == null ? void 0 : $t.has(We.path),
                "is-droptarget": fe.value === We.path
              }]),
              tabindex: "0",
              role: "option",
              "aria-selected": H(We) ? "true" : "false",
              "aria-label": u(p)(We),
              "data-fe-path": We.path,
              draggable: "true",
              onClick: (at) => j(We, at),
              onDblclick: (at) => re(We),
              onContextmenu: (at) => he(We, at),
              onDragstart: (at) => ae(We, at),
              onDragover: (at) => _(We, at),
              onDragleave: (at) => Q(We),
              onDrop: (at) => K(We, at),
              onTouchstartPassive: (at) => u(I).onTouchStart(We, at),
              onTouchend: Ue[4] || (Ue[4] = //@ts-ignore
              (...at) => u(I).onTouchEnd && u(I).onTouchEnd(...at)),
              onTouchmovePassive: Ue[5] || (Ue[5] = //@ts-ignore
              (...at) => u(I).onTouchMove && u(I).onTouchMove(...at)),
              onPointerenter: (at) => o(We, at),
              onPointerleave: (at) => We.type === "dir" && a("peek-end"),
              onPointerdown: Ue[6] || (Ue[6] = (at) => a("peek-end"))
            }, [
              We.type !== "dir" ? (f(), h("div", {
                key: 0,
                class: "fe-grid__thumb",
                ref_for: !0,
                ref: (at) => N(at, We)
              }, [
                R(We) ? (f(), h(Te, { key: 0 }, [
                  (f(!0), h(Te, null, nt(W(We), (at) => (f(), h("div", {
                    key: "fprev",
                    class: Re(["fe-fprev", "fe-fprev--" + at.kind]),
                    dir: u(B2)(at.kind),
                    style: Wt(at.kind === "table" ? { "--fprev-cols": String(at.cols) } : void 0),
                    "aria-hidden": "true"
                  }, [
                    at.kind === "table" ? (f(!0), h(Te, { key: 0 }, nt(at.rows, (kt, ht) => (f(), h(Te, { key: ht }, [
                      (f(!0), h(Te, null, nt(kt, (Ie, se) => (f(), h("span", {
                        key: se,
                        class: Re(["fe-fprev__cell", { "is-head": ht === 0 }])
                      }, y(Ie), 3))), 128))
                    ], 64))), 128)) : (f(!0), h(Te, { key: 1 }, nt(at.lines, (kt, ht) => (f(), h("div", {
                      key: ht,
                      class: "fe-fprev__line"
                    }, [
                      kt.tint ? (f(), h("span", CW, y(kt.indent) + y(kt.tint), 1)) : O("", !0),
                      Ht(y(kt.text), 1)
                    ]))), 128))
                  ], 14, EW))), 128)),
                  W(We).length === 0 ? (f(), h("span", {
                    key: 0,
                    class: "fe-grid__icon fe-grid__icon--svg",
                    innerHTML: u(wa)(We)
                  }, null, 8, zW)) : O("", !0)
                ], 64)) : (f(), Ge(Qc, {
                  key: 1,
                  node: We,
                  "src-of": q,
                  "video-badge": u($T)(We),
                  note: C(We),
                  alt: We.basename,
                  class: Re({
                    "fe-thumb--page": u(Wg)(We)
                    /* gorunum:v1-preview — crop a page from its TOP */
                  })
                }, {
                  default: mt(() => [
                    u(Vr)(We) ? (f(), h("span", {
                      key: 0,
                      class: "fe-grid__icon fe-grid__icon--svg",
                      role: "img",
                      "aria-label": u(l)("e2e.badge"),
                      innerHTML: u(xl)()
                    }, null, 8, MW)) : (f(), h("span", {
                      key: 1,
                      class: "fe-grid__icon fe-grid__icon--svg",
                      innerHTML: u(wa)(We)
                    }, null, 8, PW))
                  ]),
                  _: 2
                }, 1032, ["node", "video-badge", "note", "alt", "class"])),
                J(We) ? (f(), h("div", {
                  key: 2,
                  class: "fe-grid__star",
                  onClick: Ue[0] || (Ue[0] = yt(() => {
                  }, ["stop"])),
                  onDblclick: Ue[1] || (Ue[1] = yt(() => {
                  }, ["stop"]))
                }, [
                  Ze(Xg, {
                    starred: !!((St = e.starredIds) != null && St.has(We.id)),
                    "node-id": We.id,
                    "api-base": e.apiBase,
                    "auth-headers": e.authHeaders,
                    "auth-credentials": e.authCredentials,
                    locale: e.locale,
                    compact: "",
                    card: "",
                    onChange: (at) => a("star-change", We, at)
                  }, null, 8, ["starred", "node-id", "api-base", "auth-headers", "auth-credentials", "locale", "onChange"])
                ], 32)) : O("", !0)
              ], 512)) : i.value ? (f(), h("div", OW, [
                Ze(Jg, {
                  node: We,
                  "src-of": q
                }, null, 8, ["node"])
              ])) : O("", !0),
              d("div", LW, [
                d("span", {
                  class: Re(["fe-grid__lead", { "fe-grid__lead--pick": e.selectable }])
                }, [
                  u(Vr)(We) ? (f(), h("span", {
                    key: 0,
                    class: "fe-grid__tile fe-grid__tile--svg",
                    role: "img",
                    "aria-label": u(l)("e2e.badge"),
                    innerHTML: u(xl)()
                  }, null, 8, DW)) : (f(), h("span", {
                    key: 1,
                    class: "fe-grid__tile fe-grid__tile--svg",
                    innerHTML: u(wa)(We)
                  }, null, 8, RW)),
                  e.selectable ? (f(), h("span", {
                    key: 2,
                    class: "fe-item-check",
                    "data-fe-control": "",
                    onClick: yt((at) => ne(We, at), ["stop"]),
                    onDblclick: Ue[2] || (Ue[2] = yt(() => {
                    }, ["stop"]))
                  }, [
                    Ze(Mg, {
                      on: H(We),
                      label: u(p)(We)
                    }, null, 8, ["on", "label"])
                  ], 40, IW)) : O("", !0)
                ], 2),
                d("div", NW, [
                  d("div", {
                    class: "fe-grid__label",
                    title: u(p)(We)
                  }, [
                    d("bdi", null, y(u(p)(We)), 1),
                    e.keepBadgeFor && e.keepBadgeFor(We) ? (f(), h("span", {
                      key: 0,
                      class: Re(["fe-keepbadge", "fe-keepbadge--" + e.keepBadgeFor(We)]),
                      title: u(l)("keep.badge_" + e.keepBadgeFor(We)),
                      role: "img",
                      "aria-label": u(l)("keep.badge_" + e.keepBadgeFor(We))
                    }, y(V(e.keepBadgeFor(We))), 11, FW)) : O("", !0)
                  ], 8, BW),
                  d("div", {
                    class: "fe-grid__meta",
                    title: B(We)
                  }, [
                    S(We) ? (f(), h("span", {
                      key: 0,
                      class: "fe-applock",
                      role: "img",
                      title: S(We),
                      "aria-label": S(We),
                      "data-testid": "lock-badge"
                    }, [
                      Ue[7] || (Ue[7] = d("span", {
                        class: "fe-applock__glyph",
                        "aria-hidden": "true"
                      }, "🔒", -1)),
                      Ht(y(u(l)("applock.badge")), 1)
                    ], 8, HW)) : O("", !0),
                    k(We) ? (f(), h("span", {
                      key: 1,
                      class: Re(["fe-symlink", "fe-symlink--" + k(We).state]),
                      role: "img",
                      title: k(We).why,
                      "aria-label": k(We).why,
                      "data-testid": "symlink-badge",
                      "data-link-state": k(We).state
                    }, [
                      Ue[8] || (Ue[8] = d("span", {
                        class: "fe-symlink__glyph",
                        "aria-hidden": "true"
                      }, "🔗", -1)),
                      Ht(y(k(We).badge), 1)
                    ], 10, KW)) : O("", !0),
                    b(We) ? (f(), h("span", {
                      key: 2,
                      class: "fe-unavailable",
                      role: "img",
                      title: b(We).full,
                      "aria-label": b(We).full,
                      "data-testid": "unavailable-badge"
                    }, y(b(We).badge), 9, VW)) : O("", !0),
                    Ht(" " + y(B(We)), 1)
                  ], 8, UW),
                  e.showParentPath && u(Ir)(We) ? (f(), h("div", {
                    key: 0,
                    class: "fe-grid__parent",
                    title: u(Ir)(We)
                  }, [
                    d("bdi", null, y(u(Ir)(We)), 1)
                  ], 8, jW)) : O("", !0),
                  be(We) ? (f(), h("div", {
                    key: 1,
                    class: "fe-grid__snippet",
                    title: Fe(be(We))
                  }, [
                    (f(!0), h(Te, null, nt(u(Sy)(be(We)), (at, kt) => (f(), h(Te, { key: kt }, [
                      at.match ? (f(), h("mark", WW, y(at.text), 1)) : (f(), h(Te, { key: 1 }, [
                        Ht(y(at.text), 1)
                      ], 64))
                    ], 64))), 128))
                  ], 8, qW)) : O("", !0)
                ]),
                d("button", {
                  type: "button",
                  class: "fe-grid__menu",
                  "aria-label": u(l)("toolbar.more"),
                  title: u(l)("toolbar.more"),
                  onClick: yt((at) => ue(We, at), ["stop"]),
                  onDblclick: Ue[3] || (Ue[3] = yt(() => {
                  }, ["stop"]))
                }, "⋮", 40, YW)
              ])
            ], 42, AW)
          ], 64);
        }), 128)),
        !e.loading && e.files.length === 0 ? (f(), h("div", GW, y(u(l)("empty.folder")), 1)) : O("", !0)
      ], 10, $W)
    ]));
  }
}), XW = {
  class: "fe-home",
  "data-testid": "home-view"
}, JW = {
  class: "fe-home__section",
  "data-testid": "home-storages"
}, ZW = { class: "fe-home__heading" }, QW = {
  key: 0,
  class: "fe-home__storages"
}, eY = ["data-storage", "title", "onClick"], tY = ["innerHTML"], nY = { class: "fe-home__storage-main" }, aY = { class: "fe-home__storage-label" }, iY = ["data-partial"], oY = {
  key: 1,
  class: "fe-home__nomatch",
  "data-testid": "home-storages-nomatch"
}, rY = {
  key: 2,
  class: "fe-state fe-home__state",
  "data-testid": "home-storages-empty"
}, sY = { class: "fe-state__title" }, lY = { class: "fe-state__hint" }, uY = {
  class: "fe-home__section",
  "data-testid": "home-recent"
}, cY = { class: "fe-home__heading" }, dY = {
  key: 1,
  class: "fe-home__loading"
}, fY = {
  key: 2,
  class: "fe-home__nomatch",
  "data-testid": "home-recent-nomatch"
}, pY = {
  key: 3,
  class: "fe-state fe-home__state",
  "data-testid": "home-recent-empty"
}, hY = { class: "fe-state__title" }, mY = { class: "fe-state__hint" }, vY = {
  class: "fe-home__section",
  "data-testid": "home-starred"
}, yY = { class: "fe-home__heading" }, gY = {
  key: 1,
  class: "fe-home__loading"
}, bY = {
  key: 2,
  class: "fe-home__nomatch",
  "data-testid": "home-starred-nomatch"
}, kY = {
  key: 3,
  class: "fe-state fe-home__state",
  "data-testid": "home-starred-empty"
}, wY = { class: "fe-state__title" }, _Y = { class: "fe-state__hint" }, xY = /* @__PURE__ */ lt({
  __name: "HomeView",
  props: {
    storages: {},
    recent: {},
    starred: {},
    loading: { type: Boolean },
    locale: {},
    nameFilter: {},
    matchNames: { type: Function },
    thumbSrc: { type: Function }
  },
  emits: ["open-storage", "open-node", "context-node"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i, formatSize: o } = pt(() => n.locale), l = E(() => (n.nameFilter ?? "").trim()), c = E(() => l.value !== ""), p = ic(
      () => l.value,
      () => n.storages,
      (z) => z.label || z.name,
      () => n.matchNames
    ), m = ic(
      () => l.value,
      () => n.recent,
      (z) => z.basename || "",
      () => n.matchNames
    ), v = ic(
      () => l.value,
      () => n.starred,
      (z) => z.basename || "",
      () => n.matchNames
    ), x = E(() => p.apply(n.storages)), w = E(() => m.apply(n.recent)), S = E(() => v.apply(n.starred));
    function k(z, D) {
      return c.value && z > 0 && D === 0;
    }
    const b = /* @__PURE__ */ new Set(), C = wa({ type: "dir", mime_type: "inode/storage" });
    function T(z) {
      return typeof z.usedBytes != "number" || z.usedBytes < 0 ? i("conn.guide.storage") : z.usedPartial ? i("drive.storage.used_partial", { used: o(z.usedBytes) }) : i("drive.storage.used_unlimited", { used: o(z.usedBytes) });
    }
    const A = $({ path: "", at: 0 });
    function L(z) {
      const D = Date.now();
      z.path === A.value.path && D - A.value.at < 700 || (A.value = { path: z.path, at: D }, a("open-node", z));
    }
    return (z, D) => (f(), h("div", XW, [
      d("section", JW, [
        d("h2", ZW, y(u(i)("sidenav.storages")), 1),
        x.value.length ? (f(), h("div", QW, [
          (f(!0), h(Te, null, nt(x.value, (U) => (f(), h("button", {
            key: U.name,
            type: "button",
            class: "fe-home__storage",
            "data-testid": "home-storage-card",
            "data-storage": U.name,
            title: U.label || U.name,
            onClick: (q) => a("open-storage", U.name)
          }, [
            d("span", {
              class: "fe-home__storage-tile",
              "aria-hidden": "true",
              innerHTML: u(C)
            }, null, 8, tY),
            d("span", nY, [
              d("span", aY, y(U.label || U.name), 1),
              d("span", {
                class: "fe-home__storage-meta",
                "data-testid": "home-storage-used",
                "data-partial": U.usedPartial ? "true" : void 0
              }, y(T(U)), 9, iY),
              U.readOnly ? (f(), Ge(xT, {
                key: 0,
                "read-only": "",
                locale: e.locale,
                class: "fe-home__storage-ro",
                "data-testid": "home-storage-readonly"
              }, null, 8, ["locale"])) : O("", !0)
            ])
          ], 8, eY))), 128))
        ])) : k(e.storages.length, x.value.length) ? (f(), h("p", oY, y(u(i)("filter.empty.title")), 1)) : (f(), h("div", rY, [
          D[2] || (D[2] = d("svg", {
            class: "fe-state__art",
            viewBox: "0 0 120 100",
            width: "96",
            height: "80",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "aria-hidden": "true"
          }, [
            d("rect", {
              x: "26",
              y: "30",
              width: "68",
              height: "18",
              rx: "5"
            }),
            d("rect", {
              x: "26",
              y: "54",
              width: "68",
              height: "18",
              rx: "5"
            }),
            d("path", { d: "M38 39h.01M38 63h.01" })
          ], -1)),
          d("p", sY, y(u(i)("home.storages.empty")), 1),
          d("p", lY, y(u(i)("home.storages.hint")), 1)
        ]))
      ]),
      d("section", uY, [
        d("h2", cY, y(u(i)("sidenav.recent")), 1),
        w.value.length ? (f(), Ge($y, {
          key: 0,
          files: w.value,
          selected: u(b),
          selectable: !1,
          locale: e.locale,
          "thumb-src": e.thumbSrc,
          onClickCard: L,
          onDblCard: L,
          onContextCard: D[0] || (D[0] = (U, q) => a("context-node", U, q))
        }, null, 8, ["files", "selected", "locale", "thumb-src"])) : e.loading ? (f(), h("p", dY, y(u(i)("loading")), 1)) : k(e.recent.length, w.value.length) ? (f(), h("p", fY, y(u(i)("filter.empty.title")), 1)) : (f(), h("div", pY, [
          D[3] || (D[3] = d("svg", {
            class: "fe-state__art",
            viewBox: "0 0 120 100",
            width: "96",
            height: "80",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "aria-hidden": "true"
          }, [
            d("circle", {
              cx: "60",
              cy: "50",
              r: "28"
            }),
            d("path", { d: "M60 32v18l12 8" })
          ], -1)),
          d("p", hY, y(u(i)("empty.recent.title")), 1),
          d("p", mY, y(u(i)("empty.recent.hint")), 1)
        ]))
      ]),
      d("section", vY, [
        d("h2", yY, y(u(i)("sidenav.starred")), 1),
        S.value.length ? (f(), Ge($y, {
          key: 0,
          files: S.value,
          selected: u(b),
          selectable: !1,
          locale: e.locale,
          "thumb-src": e.thumbSrc,
          onClickCard: L,
          onDblCard: L,
          onContextCard: D[1] || (D[1] = (U, q) => a("context-node", U, q))
        }, null, 8, ["files", "selected", "locale", "thumb-src"])) : e.loading ? (f(), h("p", gY, y(u(i)("loading")), 1)) : k(e.starred.length, S.value.length) ? (f(), h("p", bY, y(u(i)("filter.empty.title")), 1)) : (f(), h("div", kY, [
          D[4] || (D[4] = d("svg", {
            class: "fe-state__art",
            viewBox: "0 0 120 100",
            width: "96",
            height: "80",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "aria-hidden": "true"
          }, [
            d("path", { d: "M60 26l9 18.6 20.4 3-14.8 14.4 3.5 20.4L60 72.8 41.9 82.4l3.5-20.4L30.6 47.6l20.4-3z" })
          ], -1)),
          d("p", wY, y(u(i)("empty.starred.title")), 1),
          d("p", _Y, y(u(i)("empty.starred.hint")), 1)
        ]))
      ])
    ]));
  }
}), SY = {
  class: "fe-drafts",
  "data-testid": "drafts-view"
}, $Y = { class: "fe-drafts__head" }, TY = { class: "fe-drafts__lead" }, AY = {
  key: 0,
  class: "fe-drafts__count",
  "data-testid": "drafts-count-line"
}, EY = {
  key: 0,
  class: "fe-state",
  "data-testid": "empty-drafts"
}, CY = { class: "fe-state__title" }, zY = { class: "fe-state__hint" }, MY = { class: "fe-drafts__name" }, PY = ["innerHTML"], OY = ["title", "data-testid", "onClick"], LY = { class: "fe-drafts__target" }, DY = /* @__PURE__ */ lt({
  __name: "DraftsView",
  props: {
    drafts: {},
    loading: { type: Boolean },
    limit: {},
    locale: {},
    nameFilter: {},
    matchNames: { type: Function },
    busyKey: {}
  },
  emits: ["open", "save", "delete"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i, formatDate: o } = pt(() => n.locale), l = ic(
      () => n.nameFilter ?? "",
      () => n.drafts,
      (C) => C.name,
      () => n.matchNames
    ), c = E(() => l.apply(n.drafts));
    function p(C) {
      const T = C.lastIndexOf(".");
      return T > 0 ? C.slice(T + 1).toLowerCase() : "";
    }
    function m(C) {
      return wa({ type: "file", basename: C.name, extension: p(C.name) || C.type });
    }
    function v(C) {
      const T = C.target_dir.indexOf("://"), A = (T >= 0 ? C.target_dir.slice(T + 3) : C.target_dir).replace(/^\/+|\/+$/g, "");
      return A ? A.split("/").filter(Boolean).join(" / ") : "/";
    }
    function x(C) {
      return Date.parse(C.modified_at || C.created_at) || 0;
    }
    const w = E(() => [
      {
        id: "name",
        label: i("col.name"),
        lead: !0,
        sortable: !0,
        width: 280,
        min: 160,
        format: (C) => C.name
      },
      {
        id: "target",
        label: i("drafts.col.target"),
        sortable: !0,
        width: 240,
        format: v,
        title: (C) => C.target
      },
      {
        id: "storage",
        label: i("drafts.col.storage"),
        sortable: !0,
        width: 140,
        format: (C) => C.storage
      },
      {
        id: "modified",
        label: i("col.modified"),
        sortable: !0,
        sortDir: "desc",
        width: 170,
        format: (C) => o(x(C)),
        sortValue: (C) => x(C)
      }
    ]);
    function S(C) {
      const T = n.busyKey === C.key;
      return [
        { key: "open", label: i("ctx.open"), icon: "open", disabled: T },
        { key: "save", label: i("drafts.action.save"), icon: "check", disabled: T },
        { key: "delete", label: i("ctx.delete"), icon: "delete", danger: !0, disabled: T }
      ];
    }
    function k(C, T) {
      C === "open" ? a("open", T) : C === "save" ? a("save", T) : C === "delete" && a("delete", T);
    }
    const b = E(
      () => n.limit && n.limit > 0 ? i("drafts.count_of", { n: n.drafts.length, limit: n.limit }) : ""
    );
    return (C, T) => (f(), h("section", SY, [
      d("header", $Y, [
        d("p", TY, y(u(i)("drafts.lead")), 1),
        b.value && e.drafts.length ? (f(), h("p", AY, y(b.value), 1)) : O("", !0)
      ]),
      !e.loading && e.drafts.length === 0 ? (f(), h("div", EY, [
        T[2] || (T[2] = d("svg", {
          class: "fe-state__art",
          viewBox: "0 0 120 100",
          width: "110",
          height: "92",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "aria-hidden": "true"
        }, [
          d("path", { d: "M66 18H38a6 6 0 0 0-6 6v52a6 6 0 0 0 6 6h44a6 6 0 0 0 6-6V40z" }),
          d("path", { d: "M66 18v22h22" }),
          d("path", { d: "M50 66l18-18 6 6-18 18H50z" })
        ], -1)),
        d("p", CY, y(u(i)("empty.drafts.title")), 1),
        d("p", zY, y(u(i)("empty.drafts.hint")), 1)
      ])) : (f(), Ge(os, {
        key: 1,
        "table-id": "explorer.drafts",
        columns: w.value,
        rows: c.value,
        "row-key": "key",
        locale: e.locale,
        loading: e.loading,
        framed: !1,
        empty: u(i)("drafts.no_match"),
        "aria-label": u(i)("node.drafts"),
        "row-attrs": (A) => ({ "data-testid": `draft-row-${A.key}`, "data-draft-name": A.name }),
        "row-actions": S,
        "row-actions-test-id": (A) => `draft-actions-${A.key}`,
        onRowAction: T[0] || (T[0] = (A, L) => k(A, L)),
        onRowDblclick: T[1] || (T[1] = (A) => a("open", A))
      }, {
        "cell-name": mt(({ row: A }) => [
          d("span", MY, [
            d("span", {
              class: "fe-drafts__tile",
              "aria-hidden": "true",
              innerHTML: m(A)
            }, null, 8, PY),
            d("button", {
              type: "button",
              class: "fe-drafts__open",
              title: u(i)("drafts.open_hint", { name: A.name }),
              "data-testid": `draft-open-${A.key}`,
              onClick: yt((L) => a("open", A), ["stop"])
            }, [
              d("bdi", null, y(u(da)(A.name)), 1)
            ], 8, OY)
          ])
        ]),
        "cell-target": mt(({ row: A }) => [
          d("bdi", LY, y(v(A)), 1)
        ]),
        _: 1
      }, 8, ["columns", "rows", "locale", "loading", "empty", "aria-label", "row-attrs", "row-actions-test-id"]))
    ]));
  }
});
function ca(e) {
  if (e.apiBase != null) return e.apiBase.replace(/\/+$/, "");
  const t = e.endpoint ?? "", n = t.indexOf("/api/");
  return n >= 0 ? t.slice(0, n) : "";
}
function RY(e, t) {
  const n = String(t ?? "").trim();
  if (/^https?:\/\/[^/]/i.test(n)) return n.replace(/\/+$/, "");
  const a = ca(e);
  if (/^https?:\/\//i.test(a))
    try {
      const i = new URL(a);
      return i.origin + i.pathname.replace(/\/+$/, "");
    } catch {
      return a;
    }
  return typeof window < "u" && window.location ? window.location.origin + (a.startsWith("/") ? a : "") : a;
}
function IY(e) {
  const t = Rl(e), n = ca(e), a = (N) => `${n}${N}`, i = Ea([]), o = Ea([]), l = Ea([]), c = $(null), p = $(null), m = $(null), v = $(!1), x = $(!1), w = $(null), S = $(null), k = $(null);
  function b(N) {
    return N == null ? void 0 : N.status;
  }
  function C(N) {
    return Za(N, e.locale);
  }
  async function T() {
    v.value = !0, w.value = null;
    try {
      const N = t.capabilities().then((J) => {
        const H = J == null ? void 0 : J.public_url;
        m.value = typeof H == "string" && H ? H : null;
      }).catch(() => {
        m.value = null;
      });
      try {
        const J = await t.jsonFetch(a("/api/auth/me"));
        c.value = (J == null ? void 0 : J.user) ?? null, p.value = typeof (J == null ? void 0 : J.realm) == "string" && J.realm ? J.realm : null;
      } catch (J) {
        b(J) === 401 && (S.value = !1, k.value = "anonymous"), c.value = null;
      }
      try {
        i.value = await t.jsonFetch(
          a("/api/admin/storage-drivers")
        ), S.value = !0, k.value = null;
      } catch (J) {
        i.value = [], S.value = !1;
        const H = b(J);
        H === 403 ? k.value = "none" : H === 401 ? k.value = "anonymous" : (k.value = "unreachable", w.value = C(J));
      }
      if (S.value)
        try {
          const J = await t.jsonFetch(a("/api/admin/storages"));
          o.value = Array.isArray(J) ? J : [], l.value = o.value.map((H) => H.name);
        } catch (J) {
          w.value = C(J);
        }
      else
        try {
          const J = await t.index("");
          l.value = Array.isArray(J == null ? void 0 : J.storages) ? J.storages : [];
        } catch {
          l.value = [];
        }
      await N, x.value = !0;
    } finally {
      v.value = !1;
    }
  }
  async function A(N) {
    const J = await t.jsonFetch(a("/api/admin/storages"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(N)
    });
    return await T(), J;
  }
  async function L(N, J) {
    const H = await t.jsonFetch(a(`/api/admin/storages/${N}`), {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(J)
    });
    return await T(), H;
  }
  async function z(N) {
    await t.jsonFetch(a(`/api/admin/storages/${N}`), { method: "DELETE" }), await T();
  }
  async function D(N) {
    try {
      return await t.jsonFetch(a("/api/admin/storages/test"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(N)
      });
    } catch (J) {
      return { ok: !1, error: C(J) };
    }
  }
  function U(N) {
    return i.value.find((J) => J.driver === N);
  }
  function q(N) {
    var J;
    return ((J = U(N)) == null ? void 0 : J.fields) ?? [];
  }
  function P(N) {
    const J = {};
    for (const H of q(N))
      H.default !== void 0 && H.default !== null && (J[H.key] = H.default);
    return J;
  }
  function R(N, J) {
    return q(N).filter((H) => {
      if (!H.required || H.default !== void 0) return !1;
      for (const ne of [H.key, ...H.aliases ?? []]) {
        const j = J[ne];
        if (j != null && !(typeof j == "string" && j.trim() === ""))
          return !1;
      }
      return !0;
    });
  }
  const W = E(() => i.value.map((N) => N.driver));
  return {
    // state
    drivers: i,
    driverNames: W,
    storages: o,
    visible: l,
    me: c,
    realm: p,
    publicUrl: m,
    loading: v,
    loaded: x,
    error: w,
    canManage: S,
    denial: k,
    // actions
    load: T,
    createStorage: A,
    updateStorage: L,
    deleteStorage: z,
    testStorage: D,
    // descriptor helpers
    descriptor: U,
    fields: q,
    defaults: P,
    missingRequired: R
  };
}
function CT(e) {
  return /^http:\/\//i.test(e);
}
function NY(e, t) {
  const n = e.replace(/\/+$/, "");
  return t ? `${n}/dav/${t}/` : `${n}/dav/`;
}
function BY(e, t) {
  let n;
  try {
    n = new URL(e);
  } catch {
    return e.replace(/^https:/i, "davs:").replace(/^http:/i, "dav:");
  }
  return `${n.protocol === "http:" ? "dav" : "davs"}://${n.host}${n.pathname}`;
}
function FY(e) {
  return ["use", e.letter, e.url, `/user:${e.user}`, e.password, "/persistent:yes"];
}
function UY(e) {
  const [t, n, a, ...i] = FY(e);
  return ["net", t, n, `"${a}"`, ...i].join(" ");
}
const k0 = "HKLM\\SYSTEM\\CurrentControlSet\\Services\\WebClient\\Parameters", HY = 4294967295, KY = 2e7, VY = [
  `reg add "${k0}" /v FileSizeLimitInBytes /t REG_DWORD /d ${HY} /f`,
  `reg add "${k0}" /v FileAttributesLimitInBytes /t REG_DWORD /d ${KY} /f`,
  "net stop webclient && net start webclient"
];
function ts(e) {
  try {
    return new URL(e).host;
  } catch {
    return e.replace(/^https?:\/\//i, "").replace(/\/+$/, "");
  }
}
function jY(e) {
  try {
    return new URL(e).pathname.replace(/\/+$/, "");
  } catch {
    return "";
  }
}
function qY(e, t) {
  const n = String(e ?? "").trim(), a = String(t ?? "").trim();
  return n && a ? `${a}/${n}` : n;
}
function Qg(e, t) {
  return e.user || t("conn.guide.userPlaceholder");
}
const WY = (e, t) => {
  const n = e.origin.replace(/\/+$/, ""), a = NY(n, e.storage), i = Qg(e, t), o = t("conn.guide.secretPlaceholder"), l = [
    { label: t("conn.guide.fact.url"), value: a, hint: e.storage ? t("conn.guide.fact.urlStorageHint", { storage: e.storage }) : t("conn.guide.fact.urlRootHint") },
    { label: t("conn.guide.fact.user"), value: i, hint: t("conn.guide.webdav.userHint") },
    { label: t("conn.guide.fact.password"), value: o, hint: t("conn.guide.webdav.passwordHint"), placeholderOnly: !0 }
  ], c = [
    {
      id: "windows",
      name: "Windows Explorer",
      platform: "windows",
      blocks: [
        {
          kind: "steps",
          steps: [
            t("conn.guide.webdav.win.s1"),
            t("conn.guide.webdav.win.s2", { url: a }),
            t("conn.guide.webdav.win.s3")
          ]
        },
        {
          kind: "code",
          caption: t("conn.guide.webdav.win.cmdCaption"),
          code: UY({ letter: "Z:", url: a, user: i, password: o })
        },
        {
          kind: "warn",
          text: t("conn.guide.webdav.win.limits")
        },
        {
          kind: "code",
          caption: t("conn.guide.webdav.win.regCaption"),
          code: VY.join(`
`)
        },
        { kind: "note", text: t("conn.guide.webdav.win.https") },
        { kind: "note", text: t("conn.guide.webdav.win.persist") },
        { kind: "note", text: t("conn.guide.webdav.win.service") }
      ]
    },
    {
      id: "macos",
      name: "macOS Finder",
      platform: "macos",
      blocks: [
        {
          kind: "steps",
          steps: [
            t("conn.guide.webdav.mac.s1"),
            t("conn.guide.webdav.mac.s2", { url: a }),
            t("conn.guide.webdav.mac.s3")
          ]
        },
        { kind: "note", text: t("conn.guide.webdav.mac.note") }
      ]
    },
    {
      id: "linux",
      name: "Linux (davfs2 / GNOME / KDE)",
      platform: "linux",
      blocks: [
        {
          kind: "code",
          caption: t("conn.guide.webdav.linux.mountCaption"),
          code: [
            `sudo mount -t davfs ${a} /mnt/filex`,
            "",
            `# ${t("conn.guide.webdav.linux.gvfsComment")}`,
            `gio mount ${BY(a)}`
          ].join(`
`)
        },
        {
          kind: "warn",
          text: t("conn.guide.webdav.linux.locks")
        },
        {
          kind: "code",
          caption: "/etc/davfs2/davfs2.conf",
          code: "use_locks 0"
        }
      ]
    },
    {
      id: "rclone",
      name: "rclone",
      platform: "any",
      blocks: [
        {
          kind: "code",
          caption: t("conn.guide.webdav.rclone.obscureCaption"),
          code: `rclone obscure "${o}"`
        },
        {
          kind: "code",
          caption: "~/.config/rclone/rclone.conf",
          code: [
            "[filex]",
            "type = webdav",
            `url = ${n}/dav`,
            "vendor = other",
            `user = ${i}`,
            `pass = ${t("conn.guide.webdav.rclone.passPlaceholder")}`
          ].join(`
`)
        },
        {
          kind: "code",
          caption: t("conn.guide.webdav.rclone.useCaption"),
          code: [
            "rclone lsd filex:",
            e.storage ? `rclone lsl filex:${e.storage}` : "rclone lsl filex:<storage>",
            e.storage ? `rclone copy ./local filex:${e.storage}/backup` : "rclone copy ./local filex:<storage>/backup",
            "rclone mount filex: /mnt/filex"
          ].join(`
`)
        }
      ]
    },
    {
      id: "cyberduck",
      name: "Cyberduck / Mountain Duck",
      platform: "any",
      blocks: [
        {
          kind: "steps",
          steps: [
            t("conn.guide.webdav.duck.s1"),
            t("conn.guide.webdav.duck.s2", { host: ts(n) }),
            t("conn.guide.webdav.duck.s3", { path: jY(n) + (e.storage ? `/dav/${e.storage}/` : "/dav/") }),
            t("conn.guide.webdav.duck.s4", { user: i })
          ]
        }
      ]
    }
  ], p = [
    { kind: "note", text: t("conn.guide.webdav.note.delete") },
    { kind: "note", text: t("conn.guide.webdav.note.locks") },
    { kind: "note", text: t("conn.guide.webdav.note.permissions") }
  ];
  return CT(n) && p.unshift({ kind: "warn", text: t("conn.guide.webdav.note.http") }), {
    id: "webdav",
    name: "WebDAV",
    summary: t("conn.guide.webdav.summary"),
    facts: l,
    clients: c,
    notes: p
  };
}, YY = (e, t) => {
  const n = (e.s3Endpoint || `${e.origin.replace(/\/+$/, "")}/s3`).replace(/\/+$/, ""), a = e.storage || e.storages[0] || "<bucket>", i = e.s3AccessKeyID || t("conn.guide.s3.keyPlaceholder"), o = e.s3Secret || t("conn.guide.s3.secretPlaceholder"), l = e.s3PathStyle !== !1, c = ts(n), p = [
    { label: t("conn.guide.s3.fact.endpoint"), value: n, hint: t("conn.guide.s3.fact.endpointHint") },
    { label: t("conn.guide.s3.fact.bucket"), value: a, hint: t("conn.guide.s3.fact.bucketHint") },
    { label: t("conn.guide.s3.fact.key"), value: i, hint: t("conn.guide.s3.fact.keyHint") },
    {
      label: t("conn.guide.s3.fact.secret"),
      value: o,
      hint: t("conn.guide.s3.fact.secretHint"),
      // ⚠ Only real right after minting. filex stores the secret sealed and
      // cannot show it again, and a guide that printed something secret-shaped
      // would be teaching a value that authenticates as nothing.
      placeholderOnly: !e.s3Secret
    },
    { label: t("conn.guide.s3.fact.region"), value: "us-east-1", hint: t("conn.guide.s3.fact.regionHint") },
    {
      label: t("conn.guide.s3.fact.addressing"),
      value: t(l ? "conn.guide.s3.fact.pathStyle" : "conn.guide.s3.fact.virtualHosted"),
      hint: t(l ? "conn.guide.s3.fact.pathStyleHint" : "conn.guide.s3.fact.virtualHostedHint")
    }
  ], m = [
    {
      id: "rclone",
      name: "rclone",
      platform: "any",
      blocks: [
        {
          kind: "code",
          caption: "~/.config/rclone/rclone.conf",
          code: [
            "[filex]",
            "type = s3",
            "provider = Other",
            `endpoint = ${n}`,
            `access_key_id = ${i}`,
            `secret_access_key = ${o}`,
            "region = us-east-1",
            ...l ? ["force_path_style = true"] : []
          ].join(`
`)
        },
        {
          kind: "code",
          caption: t("conn.guide.s3.rclone.useCaption"),
          code: [
            "rclone lsd filex:",
            `rclone copy ./local filex:${a}/backup -P`,
            `rclone sync ./local filex:${a}/backup`,
            `rclone mount filex:${a} /mnt/filex`
          ].join(`
`)
        },
        { kind: "note", text: t("conn.guide.s3.rclone.mtime") }
      ]
    },
    {
      id: "awscli",
      name: "AWS CLI",
      platform: "any",
      blocks: [
        {
          kind: "code",
          caption: t("conn.guide.s3.aws.configureCaption"),
          code: [
            "aws configure set aws_access_key_id " + i,
            "aws configure set aws_secret_access_key " + o,
            "aws configure set region us-east-1"
          ].join(`
`)
        },
        {
          kind: "code",
          caption: t("conn.guide.s3.aws.useCaption"),
          code: [
            `aws --endpoint-url ${n} s3 ls`,
            `aws --endpoint-url ${n} s3 cp ./file.pdf s3://${a}/file.pdf`,
            `aws --endpoint-url ${n} s3 sync ./local s3://${a}/backup`,
            `aws --endpoint-url ${n} s3 presign s3://${a}/file.pdf --expires-in 300`
          ].join(`
`)
        },
        ...l ? [
          {
            kind: "note",
            text: t("conn.guide.s3.aws.pathStyle")
          },
          {
            kind: "code",
            caption: "~/.aws/config",
            code: ["[default]", "s3 =", "    addressing_style = path"].join(`
`)
          }
        ] : []
      ]
    },
    {
      id: "restic",
      name: "restic",
      platform: "any",
      blocks: [
        {
          kind: "code",
          caption: t("conn.guide.s3.restic.envCaption"),
          code: [
            `export AWS_ACCESS_KEY_ID=${i}`,
            `export AWS_SECRET_ACCESS_KEY=${o}`,
            `export RESTIC_REPOSITORY="s3:${n}/${a}/restic"`,
            "export RESTIC_PASSWORD=…"
          ].join(`
`)
        },
        {
          kind: "code",
          caption: t("conn.guide.s3.restic.useCaption"),
          code: [
            `restic init${l ? " -o s3.bucket-lookup=path" : ""}`,
            `restic backup ~/Documents${l ? " -o s3.bucket-lookup=path" : ""}`,
            `restic check --read-data${l ? " -o s3.bucket-lookup=path" : ""}`,
            `restic forget --keep-daily 7 --prune${l ? " -o s3.bucket-lookup=path" : ""}`
          ].join(`
`)
        },
        { kind: "note", text: t("conn.guide.s3.restic.verified") }
      ]
    },
    {
      id: "mc",
      name: "MinIO Client (mc)",
      platform: "any",
      blocks: [
        {
          kind: "code",
          caption: t("conn.guide.s3.mc.aliasCaption"),
          code: `mc alias set filex ${n} ${i} ${o} --api S3v4${l ? " --path on" : ""}`
        },
        {
          kind: "code",
          caption: t("conn.guide.s3.mc.useCaption"),
          code: [
            "mc ls filex",
            `mc cp ./file.pdf filex/${a}/file.pdf`,
            `mc mirror ./local filex/${a}/backup`,
            `mc du filex/${a}`
          ].join(`
`)
        }
      ]
    },
    {
      id: "s3fs",
      name: "s3fs (Linux / macOS)",
      platform: "linux",
      blocks: [
        {
          kind: "code",
          caption: t("conn.guide.s3.s3fs.credsCaption"),
          code: [
            `echo "${i}:${o}" > ~/.passwd-s3fs`,
            "chmod 600 ~/.passwd-s3fs"
          ].join(`
`)
        },
        {
          kind: "code",
          caption: t("conn.guide.s3.s3fs.mountCaption"),
          code: [
            `s3fs ${a} /mnt/filex \\`,
            "  -o passwd_file=~/.passwd-s3fs \\",
            `  -o url=${n} \\`,
            ...l ? ["  -o use_path_request_style"] : []
          ].join(`
`)
        },
        { kind: "note", text: t("conn.guide.s3.s3fs.note") }
      ]
    },
    {
      id: "cyberduck",
      name: "Cyberduck / Mountain Duck",
      platform: "any",
      blocks: [
        {
          kind: "steps",
          steps: [
            t("conn.guide.s3.duck.s1"),
            t("conn.guide.s3.duck.s2", { host: c }),
            t("conn.guide.s3.duck.s3", { key: i }),
            t("conn.guide.s3.duck.s4")
          ]
        },
        ...l ? [{ kind: "warn", text: t("conn.guide.s3.duck.pathStyle") }] : []
      ]
    },
    {
      id: "sdk",
      name: "SDK (Go / Python / JS)",
      platform: "any",
      blocks: [
        {
          kind: "code",
          caption: "boto3",
          code: [
            "import boto3",
            "s3 = boto3.client(",
            '    "s3",',
            `    endpoint_url="${n}",`,
            `    aws_access_key_id="${i}",`,
            `    aws_secret_access_key="${o}",`,
            '    region_name="us-east-1",',
            ...l ? [
              '    config=boto3.session.Config(s3={"addressing_style": "path"}),'
            ] : [],
            ")",
            `print([o["Key"] for o in s3.list_objects_v2(Bucket="${a}").get("Contents", [])])`
          ].join(`
`)
        },
        { kind: "note", text: t("conn.guide.s3.sdk.note") }
      ]
    }
  ], v = [
    { kind: "note", text: t("conn.guide.s3.note.buckets") },
    { kind: "note", text: t("conn.guide.s3.note.permissions") },
    { kind: "note", text: t("conn.guide.s3.note.trash") },
    { kind: "note", text: t("conn.guide.s3.note.mtime") }
  ];
  return l && v.unshift({ kind: "warn", text: t("conn.guide.s3.note.pathStyle") }), CT(n) && v.unshift({ kind: "warn", text: t("conn.guide.s3.note.http") }), {
    id: "s3",
    name: "S3",
    summary: t("conn.guide.s3.summary"),
    facts: p,
    clients: m,
    notes: v
  };
}, GY = (e, t) => {
  const n = e.sftpHost || ts(e.origin), a = e.sftpPort || 2022, i = e.sftpLogin || Qg(e, t), o = e.storage ? `/${e.storage}` : "/<storage>", l = a === 22 ? "" : ` -P ${a}`, c = [
    { label: t("conn.guide.sftp.fact.host"), value: n, hint: t("conn.guide.sftp.fact.hostHint") },
    { label: t("conn.guide.sftp.fact.port"), value: String(a), hint: t("conn.guide.sftp.fact.portHint") },
    { label: t("conn.guide.fact.user"), value: i, hint: t("conn.guide.sftp.fact.userHint") },
    {
      label: t("conn.guide.sftp.fact.auth"),
      value: e.sftpHasKey ? t("conn.guide.sftp.fact.authKey") : t("conn.guide.sftp.fact.authPassword"),
      hint: t("conn.guide.sftp.fact.authHint"),
      placeholderOnly: !0
    },
    { label: t("conn.guide.sftp.fact.path"), value: o, hint: t("conn.guide.sftp.fact.pathHint") }
  ], p = [
    {
      id: "openssh",
      name: "OpenSSH (sftp / scp)",
      platform: "any",
      blocks: [
        {
          kind: "code",
          caption: t("conn.guide.sftp.openssh.connectCaption"),
          code: [
            `sftp${l} ${i}@${n}`,
            `scp${l} ./report.pdf ${i}@${n}:${o}/report.pdf`,
            `scp${l} ${i}@${n}:${o}/report.pdf ./`
          ].join(`
`)
        },
        {
          kind: "code",
          caption: "~/.ssh/config",
          code: [
            "Host filex",
            `  HostName ${n}`,
            `  Port ${a}`,
            `  User ${i}`,
            "  # IdentityFile ~/.ssh/id_ed25519"
          ].join(`
`)
        },
        { kind: "note", text: t("conn.guide.sftp.openssh.noShell") }
      ]
    },
    {
      id: "key",
      name: t("conn.guide.sftp.key.tab"),
      platform: "any",
      blocks: [
        {
          kind: "steps",
          steps: [
            t("conn.guide.sftp.key.s1"),
            t("conn.guide.sftp.key.s2"),
            t("conn.guide.sftp.key.s3")
          ]
        },
        {
          kind: "code",
          caption: t("conn.guide.sftp.key.genCaption"),
          code: ['ssh-keygen -t ed25519 -C "filex"', "cat ~/.ssh/id_ed25519.pub"].join(`
`)
        },
        // ⚠ The one command people reach for, and the one that cannot work.
        { kind: "warn", text: t("conn.guide.sftp.key.noCopyId") }
      ]
    },
    {
      id: "winscp",
      name: "WinSCP",
      platform: "windows",
      blocks: [
        {
          kind: "steps",
          steps: [
            t("conn.guide.sftp.winscp.s1"),
            t("conn.guide.sftp.winscp.s2", { host: n, port: String(a) }),
            t("conn.guide.sftp.winscp.s3", { user: i }),
            t("conn.guide.sftp.winscp.s4")
          ]
        }
      ]
    },
    {
      id: "filezilla",
      name: "FileZilla",
      platform: "any",
      blocks: [
        {
          kind: "steps",
          steps: [
            t("conn.guide.sftp.filezilla.s1"),
            t("conn.guide.sftp.filezilla.s2", { host: `sftp://${n}`, port: String(a) }),
            t("conn.guide.sftp.filezilla.s3", { user: i })
          ]
        }
      ]
    },
    {
      id: "rclone",
      name: "rclone",
      platform: "any",
      blocks: [
        {
          kind: "code",
          caption: "~/.config/rclone/rclone.conf",
          code: [
            "[filex-sftp]",
            "type = sftp",
            `host = ${n}`,
            `port = ${a}`,
            `user = ${i}`,
            "key_file = ~/.ssh/id_ed25519",
            "# filex has no shell, so tell rclone not to look for one:",
            "shell_type = none",
            "md5sum_command = none",
            "sha1sum_command = none"
          ].join(`
`)
        },
        {
          kind: "code",
          caption: t("conn.guide.sftp.rclone.useCaption"),
          code: [
            "rclone lsd filex-sftp:",
            `rclone copy ./local filex-sftp:${o}/backup -P`,
            `rclone sync ./local filex-sftp:${o}/backup`
          ].join(`
`)
        }
      ]
    },
    {
      id: "sshfs",
      name: "sshfs (Linux / macOS)",
      platform: "linux",
      blocks: [
        {
          kind: "code",
          caption: t("conn.guide.sftp.sshfs.mountCaption"),
          code: [
            `sshfs -p ${a} ${i}@${n}:${o} /mnt/filex`,
            "fusermount -u /mnt/filex"
          ].join(`
`)
        },
        { kind: "note", text: t("conn.guide.sftp.sshfs.note") }
      ]
    }
  ], m = [
    { kind: "note", text: t("conn.guide.sftp.note.storages") },
    { kind: "note", text: t("conn.guide.sftp.note.permissions") },
    { kind: "note", text: t("conn.guide.sftp.note.trash") },
    { kind: "note", text: t("conn.guide.sftp.note.totp") }
  ];
  return e.sftpEnabled === !1 && m.unshift({ kind: "warn", text: t("conn.guide.sftp.note.disabled") }), {
    id: "sftp",
    name: "SFTP",
    summary: t("conn.guide.sftp.summary"),
    facts: c,
    clients: p,
    notes: m
  };
}, XY = (e, t) => {
  const n = e.ftpsHost || ts(e.origin), a = e.ftpsPort || 2121, i = e.sftpLogin || Qg(e, t), o = t("conn.guide.secretPlaceholder"), l = e.storage ? `/${e.storage}` : "/<storage>", c = e.ftpsPasvMin && e.ftpsPasvMax ? `${e.ftpsPasvMin}-${e.ftpsPasvMax}` : "30000-30100", p = [
    { label: t("conn.guide.ftps.fact.host"), value: n, hint: t("conn.guide.ftps.fact.hostHint") },
    { label: t("conn.guide.ftps.fact.port"), value: String(a), hint: t("conn.guide.ftps.fact.portHint") },
    { label: t("conn.guide.ftps.fact.mode"), value: t("conn.guide.ftps.fact.modeValue"), hint: t("conn.guide.ftps.fact.modeHint") },
    { label: t("conn.guide.fact.user"), value: i, hint: t("conn.guide.ftps.fact.userHint") },
    { label: t("conn.guide.fact.password"), value: o, hint: t("conn.guide.ftps.fact.passwordHint"), placeholderOnly: !0 },
    { label: t("conn.guide.ftps.fact.pasv"), value: c, hint: t("conn.guide.ftps.fact.pasvHint") }
  ], m = [
    {
      id: "filezilla",
      name: "FileZilla",
      platform: "any",
      blocks: [
        {
          kind: "steps",
          steps: [
            t("conn.guide.ftps.filezilla.s1"),
            t("conn.guide.ftps.filezilla.s2", { host: n, port: String(a) }),
            t("conn.guide.ftps.filezilla.s3", { user: i }),
            t("conn.guide.ftps.filezilla.s4")
          ]
        }
      ]
    },
    {
      id: "winscp",
      name: "WinSCP",
      platform: "windows",
      blocks: [
        {
          kind: "steps",
          steps: [
            t("conn.guide.ftps.winscp.s1"),
            t("conn.guide.ftps.winscp.s2", { host: n, port: String(a) }),
            t("conn.guide.ftps.winscp.s3", { user: i })
          ]
        }
      ]
    },
    {
      id: "curl",
      name: "curl",
      platform: "any",
      blocks: [
        {
          kind: "code",
          caption: t("conn.guide.ftps.curl.caption"),
          code: [
            `curl --ssl-reqd --ftp-pasv --user ${i} \\`,
            `  -T ./report.pdf "ftp://${n}:${a}${l}/report.pdf"`,
            "",
            `curl --ssl-reqd --ftp-pasv --user ${i} \\`,
            `  -o ./report.pdf "ftp://${n}:${a}${l}/report.pdf"`
          ].join(`
`)
        },
        // ⚠ The flag that matters. Without it curl will happily fall back to
        // plaintext against a server that allows it — this one does not, but
        // the habit is what protects you against the ones that do.
        { kind: "note", text: t("conn.guide.ftps.curl.sslReqd") }
      ]
    },
    {
      id: "lftp",
      name: "lftp",
      platform: "any",
      blocks: [
        {
          kind: "code",
          caption: "~/.lftprc",
          code: [
            "set ftp:ssl-force true",
            "set ftp:ssl-protect-data true",
            "set ftp:passive-mode true"
          ].join(`
`)
        },
        {
          kind: "code",
          caption: t("conn.guide.ftps.lftp.caption"),
          code: [
            `lftp -u ${i} ftp://${n}:${a}`,
            `# then: cd ${l}; put ./report.pdf; ls`
          ].join(`
`)
        },
        { kind: "note", text: t("conn.guide.ftps.lftp.protectData") }
      ]
    },
    {
      id: "rclone",
      name: "rclone",
      platform: "any",
      blocks: [
        {
          kind: "code",
          caption: "~/.config/rclone/rclone.conf",
          code: [
            "[filex-ftp]",
            "type = ftp",
            `host = ${n}`,
            `port = ${a}`,
            `user = ${i}`,
            '# rclone obscure "<your password>"',
            "pass = …",
            "explicit_tls = true"
          ].join(`
`)
        },
        {
          kind: "code",
          caption: t("conn.guide.ftps.rclone.useCaption"),
          code: [
            "rclone lsd filex-ftp:",
            `rclone copy ./local filex-ftp:${l}/backup -P`
          ].join(`
`)
        }
      ]
    },
    {
      id: "printer",
      name: t("conn.guide.ftps.printer.tab"),
      platform: "any",
      blocks: [
        {
          kind: "steps",
          steps: [
            t("conn.guide.ftps.printer.s1", { host: n, port: String(a) }),
            t("conn.guide.ftps.printer.s2", { user: i }),
            t("conn.guide.ftps.printer.s3", { path: l }),
            t("conn.guide.ftps.printer.s4")
          ]
        },
        // ⚠ The honest warning: plenty of scan-to-FTP firmware cannot do TLS
        // at all, and this endpoint will not talk to it. Saying so beats an
        // afternoon spent debugging a device that was never going to connect.
        { kind: "warn", text: t("conn.guide.ftps.printer.noTLS") }
      ]
    }
  ], v = [
    { kind: "warn", text: t("conn.guide.ftps.note.tls") },
    { kind: "note", text: t("conn.guide.ftps.note.passive") },
    { kind: "note", text: t("conn.guide.ftps.note.storages") },
    { kind: "note", text: t("conn.guide.ftps.note.trash") },
    { kind: "note", text: t("conn.guide.ftps.note.prefer") }
  ];
  return e.ftpsSelfSigned && v.push({ kind: "warn", text: t("conn.guide.ftps.note.selfSigned") }), e.ftpsEnabled === !1 && v.unshift({ kind: "warn", text: t("conn.guide.ftps.note.disabled") }), {
    id: "ftps",
    name: "FTPS",
    summary: t("conn.guide.ftps.summary"),
    facts: p,
    clients: m,
    notes: v
  };
}, JY = (e, t) => {
  const n = e.nfsHost || ts(e.origin), a = e.nfsPort || 2049, i = e.nfsPath || t("conn.guide.nfs.pathPlaceholder"), o = e.nfsReadOnly ? ",ro" : "", l = `nfsvers=3,tcp,port=${a},mountport=${a},nolock${o}`, c = [
    { label: t("conn.guide.nfs.fact.host"), value: n, hint: t("conn.guide.nfs.fact.hostHint") },
    { label: t("conn.guide.nfs.fact.port"), value: String(a), hint: t("conn.guide.nfs.fact.portHint") },
    {
      label: t("conn.guide.nfs.fact.export"),
      value: i,
      hint: t("conn.guide.nfs.fact.exportHint"),
      // ⚠ Only real right after minting: the path is stored hashed and cannot
      // be shown again, and printing something path-shaped would produce a
      // mount line that fails with no clue why.
      placeholderOnly: !e.nfsPath
    },
    { label: t("conn.guide.nfs.fact.options"), value: l, hint: t("conn.guide.nfs.fact.optionsHint") }
  ], p = [
    {
      id: "linux",
      name: "Linux",
      platform: "linux",
      blocks: [
        {
          kind: "code",
          caption: t("conn.guide.nfs.linux.mountCaption"),
          code: [
            "sudo mkdir -p /mnt/filex",
            `sudo mount -t nfs -o ${l} ${n}:${i} /mnt/filex`,
            "",
            "# and to unmount:",
            "sudo umount /mnt/filex"
          ].join(`
`)
        },
        {
          kind: "code",
          caption: "/etc/fstab",
          code: `${n}:${i}  /mnt/filex  nfs  ${l},_netdev,noauto,x-systemd.automount  0  0`
        },
        // ⚠ The warning that belongs next to the fstab line rather than in a
        // document: that file is world-readable on most systems.
        { kind: "warn", text: t("conn.guide.nfs.linux.fstabSecret") }
      ]
    },
    {
      id: "macos",
      name: "macOS",
      platform: "macos",
      blocks: [
        {
          kind: "code",
          caption: t("conn.guide.nfs.mac.mountCaption"),
          code: [
            "sudo mkdir -p /Volumes/filex",
            `sudo mount -t nfs -o vers=3,tcp,port=${a},mountport=${a},nolock${o},resvport ${n}:${i} /Volumes/filex`
          ].join(`
`)
        },
        { kind: "note", text: t("conn.guide.nfs.mac.resvport") }
      ]
    },
    {
      id: "windows",
      name: "Windows (Client for NFS)",
      platform: "windows",
      blocks: [
        {
          kind: "steps",
          steps: [
            t("conn.guide.nfs.win.s1"),
            t("conn.guide.nfs.win.s2"),
            t("conn.guide.nfs.win.s3")
          ]
        },
        {
          kind: "code",
          caption: t("conn.guide.nfs.win.cmdCaption"),
          code: `mount -o anon nolock ${n}:${i} Z:`
        },
        // ⚠ Windows' client has no way to say "the mount service is on this
        // port", so it only works when filex is on 2049.
        { kind: "warn", text: t("conn.guide.nfs.win.port") }
      ]
    },
    {
      id: "synology",
      name: t("conn.guide.nfs.nas.tab"),
      platform: "any",
      blocks: [
        {
          kind: "steps",
          steps: [
            t("conn.guide.nfs.nas.s1", { host: n, port: String(a) }),
            t("conn.guide.nfs.nas.s2"),
            t("conn.guide.nfs.nas.s3")
          ]
        }
      ]
    }
  ], m = [
    { kind: "warn", text: t("conn.guide.nfs.note.unencrypted") },
    { kind: "warn", text: t("conn.guide.nfs.note.pathIsSecret") },
    { kind: "note", text: t("conn.guide.nfs.note.noPortmapper") },
    { kind: "note", text: t("conn.guide.nfs.note.uid") },
    { kind: "note", text: t("conn.guide.nfs.note.trash") },
    { kind: "note", text: t("conn.guide.nfs.note.revoke") }
  ];
  return e.nfsEnabled === !1 && m.unshift({ kind: "warn", text: t("conn.guide.nfs.note.disabled") }), {
    id: "nfs",
    name: "NFS",
    summary: t("conn.guide.nfs.summary"),
    facts: c,
    clients: p,
    notes: m
  };
}, ZY = (e, t) => {
  const n = e.origin.replace(/\/+$/, ""), a = e.storage || e.storages[0] || "main", i = [
    { label: t("conn.guide.mount.fact.url"), value: n, hint: t("conn.guide.mount.fact.urlHint") },
    {
      label: t("conn.guide.mount.fact.token"),
      value: t("conn.guide.mount.fact.tokenPlaceholder"),
      hint: t("conn.guide.mount.fact.tokenHint"),
      // filex never has the plaintext of a token after it is minted, and a
      // fact row that looked like one would be a lie the user pastes.
      placeholderOnly: !0
    },
    { label: t("conn.guide.mount.fact.remote"), value: `${a}://`, hint: t("conn.guide.mount.fact.remoteHint") }
  ], o = [
    {
      id: "linux",
      name: "Linux",
      platform: "linux",
      blocks: [
        {
          kind: "code",
          caption: t("conn.guide.mount.linux.mountCaption"),
          code: [
            `export FILEX_URL=${n}`,
            "export FILEX_TOKEN=<token>",
            "",
            "mkdir -p ~/filex",
            "filex mount ~/filex",
            "",
            "# one storage only, or a subfolder of it:",
            `filex mount --remote '${a}://' ~/filex`,
            `filex mount --remote '${a}://projects/acme' --read-only ~/acme`
          ].join(`
`)
        },
        {
          kind: "code",
          caption: t("conn.guide.mount.linux.umountCaption"),
          code: "fusermount -u ~/filex"
        },
        // ⚠ The one that costs an afternoon if it is not said: killing the
        // process leaves a directory where every `ls` hangs.
        { kind: "warn", text: t("conn.guide.mount.linux.umountWarn") },
        {
          kind: "code",
          caption: t("conn.guide.mount.linux.systemdCaption"),
          code: [
            "# ~/.config/systemd/user/filex-mount.service",
            "[Unit]",
            "Description=filex mount",
            "After=network-online.target",
            "",
            "[Service]",
            `Environment=FILEX_URL=${n}`,
            "Environment=FILEX_TOKEN=<token>",
            "ExecStart=%h/.local/bin/filex mount %h/filex",
            "ExecStop=/bin/fusermount -u %h/filex",
            "Restart=on-failure",
            "",
            "[Install]",
            "WantedBy=default.target"
          ].join(`
`)
        }
      ]
    },
    {
      id: "windows",
      name: "Windows",
      platform: "windows",
      blocks: [
        { kind: "note", text: t("conn.guide.mount.win.winfsp") },
        {
          kind: "code",
          caption: t("conn.guide.mount.win.mountCaption"),
          code: [
            `$env:FILEX_URL   = "${n}"`,
            '$env:FILEX_TOKEN = "<token>"',
            "",
            "filex mount Z:"
          ].join(`
`)
        },
        // ⚠ The drive letter is CREATED, not reused — pointing it at one that
        // already exists is the commonest way this fails, and the message the
        // driver gives for it says nothing useful.
        { kind: "warn", text: t("conn.guide.mount.win.freeLetter") },
        { kind: "note", text: t("conn.guide.mount.win.stop") }
      ]
    },
    {
      id: "macos",
      name: "macOS",
      platform: "macos",
      blocks: [
        // ⚠⚠ A refusal stated up front rather than discovered. macFUSE's Go
        // binding needs a C toolchain filex deliberately does not use, and its
        // licence forbids a commercial program from installing it. Pretending
        // otherwise would mean a command that appears to work and does nothing.
        { kind: "warn", text: t("conn.guide.mount.mac.unsupported") },
        { kind: "note", text: t("conn.guide.mount.mac.alternatives") }
      ]
    }
  ], l = [
    { kind: "note", text: t("conn.guide.mount.note.notASync") },
    { kind: "note", text: t("conn.guide.mount.note.reachable") },
    { kind: "note", text: t("conn.guide.mount.note.wholeFileWrites") },
    { kind: "note", text: t("conn.guide.mount.note.trash") },
    { kind: "note", text: t("conn.guide.mount.note.revoke") }
  ];
  return {
    id: "mount",
    name: "filex mount",
    summary: t("conn.guide.mount.summary"),
    facts: i,
    clients: o,
    notes: l
  };
}, zT = {
  webdav: WY,
  s3: YY,
  sftp: GY,
  ftps: XY,
  nfs: JY,
  mount: ZY
}, QY = {
  webdav: "WebDAV",
  s3: "S3",
  sftp: "SFTP",
  ftps: "FTPS",
  nfs: "NFS",
  mount: "filex mount"
};
function eG(e) {
  return QY[e] || e.toUpperCase();
}
function tG() {
  return Object.keys(zT);
}
function nG(e, t, n) {
  const a = zT[e];
  return a ? a(t, n) : null;
}
const aG = { class: "fe-guide" }, iG = { class: "fe-guide__summary" }, oG = {
  class: "fe-guide__facts",
  "data-testid": "guide-facts"
}, rG = { class: "fe-guide__factlabel" }, sG = { class: "fe-guide__factvalue" }, lG = ["data-testid", "onClick"], uG = {
  key: 0,
  class: "fe-guide__facthint"
}, cG = {
  class: "fe-guide__tabs",
  role: "tablist"
}, dG = ["aria-selected", "data-testid", "onClick"], fG = {
  key: 0,
  class: "fe-guide__body",
  role: "tabpanel"
}, pG = {
  key: 0,
  class: "fe-guide__steps"
}, hG = {
  key: 1,
  class: "fe-guide__codewrap"
}, mG = { class: "fe-guide__codehead" }, vG = { class: "fe-guide__caption" }, yG = ["data-testid", "onClick"], gG = { class: "fe-guide__code" }, bG = {
  key: 2,
  class: "fe-guide__warn"
}, kG = {
  key: 3,
  class: "fe-guide__note"
}, wG = {
  key: 4,
  class: "fe-guide__text"
}, _G = {
  key: 1,
  class: "fe-guide__notes"
}, xG = { class: "fe-guide__notestitle" }, SG = /* @__PURE__ */ lt({
  __name: "ConnectionGuideView",
  props: {
    guide: {},
    locale: {}
  },
  setup(e) {
    var v;
    const t = e, { t: n } = pt(() => t.locale), a = $(((v = t.guide.clients[0]) == null ? void 0 : v.id) ?? ""), i = $(null);
    let o = null;
    const l = E(
      () => t.guide.clients.find((x) => x.id === a.value) ?? t.guide.clients[0]
    );
    async function c(x, w) {
      let S = !1;
      try {
        await navigator.clipboard.writeText(x), S = !0;
      } catch {
        try {
          const k = document.createElement("textarea");
          k.value = x, k.setAttribute("readonly", ""), k.style.position = "fixed", k.style.opacity = "0", document.body.appendChild(k), k.select(), S = document.execCommand("copy"), document.body.removeChild(k);
        } catch {
          S = !1;
        }
      }
      i.value = S ? w : null, o && clearTimeout(o), o = setTimeout(() => {
        i.value = null;
      }, 1600);
    }
    function p(x, w) {
      return `${x}-${w}`;
    }
    function m(x) {
      return x.kind === "code";
    }
    return (x, w) => (f(), h("div", aG, [
      d("p", iG, y(e.guide.summary), 1),
      d("section", oG, [
        (f(!0), h(Te, null, nt(e.guide.facts, (S, k) => (f(), h("div", {
          key: S.label,
          class: "fe-guide__fact"
        }, [
          d("span", rG, y(S.label), 1),
          d("span", sG, [
            d("code", {
              class: Re({ "fe-guide__ph": S.placeholderOnly })
            }, y(S.value), 3),
            S.placeholderOnly ? O("", !0) : (f(), h("button", {
              key: 0,
              type: "button",
              class: "fe-guide__copy",
              "data-testid": `copy-fact-${k}`,
              onClick: (b) => c(S.value, p("fact", k))
            }, y(i.value === p("fact", k) ? u(n)("conn.guide.copied") : u(n)("conn.guide.copy")), 9, lG))
          ]),
          S.hint ? (f(), h("span", uG, y(S.hint), 1)) : O("", !0)
        ]))), 128))
      ]),
      d("nav", cG, [
        (f(!0), h(Te, null, nt(e.guide.clients, (S) => (f(), h("button", {
          key: S.id,
          type: "button",
          role: "tab",
          class: Re(["fe-guide__tab", { "is-active": l.value && S.id === l.value.id }]),
          "aria-selected": l.value && S.id === l.value.id,
          "data-testid": `guide-tab-${S.id}`,
          onClick: (k) => a.value = S.id
        }, y(S.name), 11, dG))), 128))
      ]),
      l.value ? (f(), h("div", fG, [
        (f(!0), h(Te, null, nt(l.value.blocks, (S, k) => (f(), h(Te, { key: k }, [
          S.kind === "steps" ? (f(), h("ol", pG, [
            (f(!0), h(Te, null, nt(S.steps ?? [], (b, C) => (f(), h("li", { key: C }, y(b), 1))), 128))
          ])) : m(S) ? (f(), h("div", hG, [
            d("div", mG, [
              d("span", vG, y(S.caption), 1),
              d("button", {
                type: "button",
                class: "fe-guide__copy",
                "data-testid": `copy-code-${k}`,
                onClick: (b) => c(S.code ?? "", p(l.value.id, k))
              }, y(i.value === p(l.value.id, k) ? u(n)("conn.guide.copied") : u(n)("conn.guide.copy")), 9, yG)
            ]),
            d("pre", gG, [
              d("code", null, y(S.code), 1)
            ])
          ])) : S.kind === "warn" ? (f(), h("p", bG, y(S.text), 1)) : S.kind === "note" ? (f(), h("p", kG, y(S.text), 1)) : (f(), h("p", wG, y(S.text), 1))
        ], 64))), 128))
      ])) : O("", !0),
      e.guide.notes.length ? (f(), h("section", _G, [
        d("h4", xG, y(u(n)("conn.guide.goodToKnow")), 1),
        (f(!0), h(Te, null, nt(e.guide.notes, (S, k) => (f(), h("p", {
          key: k,
          class: Re(S.kind === "warn" ? "fe-guide__warn" : "fe-guide__note")
        }, y(S.text), 3))), 128))
      ])) : O("", !0)
    ]));
  }
});
function $G(e) {
  const t = Rl(e), n = ca(e), a = (z) => `${n}${z}`, i = Ea([]), o = $(null), l = $(!1), c = $(!1), p = $(null), m = $(null), v = $(null), x = $(null);
  function w(z) {
    return m.value = (z == null ? void 0 : z.hint) ?? null, Za(z, e.locale);
  }
  function S(z) {
    return z == null ? void 0 : z.status;
  }
  async function k() {
    l.value = !0, p.value = null, m.value = null;
    try {
      const z = await t.jsonFetch(
        a("/api/auth/s3-keys")
      );
      i.value = Array.isArray(z == null ? void 0 : z.keys) ? z.keys : [], o.value = {
        endpoint: (z == null ? void 0 : z.endpoint) ?? "",
        enabled: (z == null ? void 0 : z.enabled) !== !1,
        path_style: (z == null ? void 0 : z.path_style) !== !1
      }, v.value = !0;
    } catch (z) {
      i.value = [];
      const D = S(z);
      D === 401 || D === 403 ? v.value = !1 : (v.value = !1, p.value = w(z));
    } finally {
      l.value = !1, c.value = !0;
    }
  }
  async function b(z) {
    p.value = null, m.value = null;
    try {
      const D = await t.jsonFetch(a("/api/auth/s3-keys"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(z)
      });
      return x.value = D, D != null && D.endpoint && (o.value = {
        endpoint: D.endpoint,
        enabled: D.enabled !== !1,
        path_style: D.path_style !== !1
      }), await k(), D;
    } catch (D) {
      return p.value = w(D), null;
    }
  }
  async function C(z, D) {
    p.value = null, m.value = null;
    try {
      await t.jsonFetch(a(`/api/auth/s3-keys/${z}/state`), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ disabled: D })
      }), await k();
    } catch (U) {
      p.value = w(U);
    }
  }
  async function T(z) {
    var D, U;
    p.value = null, m.value = null;
    try {
      await t.jsonFetch(a(`/api/auth/s3-keys/${z}`), { method: "DELETE" }), ((U = (D = x.value) == null ? void 0 : D.key) == null ? void 0 : U.id) === z && (x.value = null), await k();
    } catch (q) {
      p.value = w(q);
    }
  }
  function A() {
    x.value = null;
  }
  const L = E(() => {
    var D;
    if ((D = x.value) != null && D.key) return x.value.key;
    const z = i.value.filter((U) => !U.disabled_at);
    return z.length ? z.reduce((U, q) => U.created_at >= q.created_at ? U : q) : null;
  });
  return {
    keys: i,
    connection: o,
    loading: l,
    loaded: c,
    error: p,
    errorHint: m,
    canMint: v,
    revealed: x,
    guideKey: L,
    load: k,
    create: b,
    setDisabled: C,
    remove: T,
    dismissSecret: A
  };
}
const TG = {
  class: "fe-s3keys",
  "data-testid": "s3-keys"
}, AG = { class: "fe-s3keys__head" }, EG = { class: "fe-s3keys__title" }, CG = { class: "fe-s3keys__lead" }, zG = {
  key: 0,
  class: "fe-s3keys__warn"
}, MG = {
  key: 1,
  class: "fe-s3keys__muted"
}, PG = {
  key: 2,
  class: "fe-s3keys__warn"
}, OG = {
  key: 3,
  class: "fe-s3keys__hint",
  "data-testid": "s3keys-admin-hint"
}, LG = {
  key: 4,
  class: "fe-s3keys__form"
}, DG = ["placeholder"], RG = ["placeholder", "disabled"], IG = ["disabled"], NG = {
  key: 5,
  class: "fe-s3keys__hint"
}, BG = {
  key: 6,
  class: "fe-s3keys__secret",
  "data-testid": "s3-key-secret"
}, FG = { class: "fe-s3keys__once" }, UG = { class: "fe-s3keys__pair" }, HG = { class: "fe-s3keys__k" }, KG = { class: "fe-s3keys__pair" }, VG = { class: "fe-s3keys__k" }, jG = {
  key: 7,
  class: "fe-s3keys__muted"
}, qG = { class: "tbl-mono" }, WG = /* @__PURE__ */ lt({
  __name: "S3KeysPanel",
  props: {
    config: {},
    storages: {}
  },
  emits: ["active"],
  setup(e, { emit: t }) {
    const n = e, a = t, i = E(() => Wi(n.config.locale)), { t: o, formatDate: l } = pt(i), {
      keys: c,
      connection: p,
      loading: m,
      error: v,
      errorHint: x,
      canMint: w,
      revealed: S,
      guideKey: k,
      load: b,
      create: C,
      setDisabled: T,
      remove: A,
      dismissSecret: L
    } = $G(n.config), z = $(""), D = $(""), U = E(() => [
      { value: "", label: o("conn.s3keys.everyBucket") },
      ...n.storages.map((Q) => ({ value: Q, label: Q }))
    ]), q = $(""), P = $(!1), R = $(null), W = $(null);
    let N = null;
    function J() {
      var K, I, Y, B, V;
      const Q = p.value;
      Q && a("active", {
        accessKeyID: ((K = k.value) == null ? void 0 : K.access_key_id) ?? "",
        // Only the freshly minted one. Re-emitting a stale secret would put a
        // dead credential into the commands.
        secret: ((Y = (I = S.value) == null ? void 0 : I.key) == null ? void 0 : Y.id) === ((B = k.value) == null ? void 0 : B.id) ? (V = S.value) == null ? void 0 : V.secret : void 0,
        endpoint: Q.endpoint,
        pathStyle: Q.path_style
      });
    }
    jt(async () => {
      await b(), J();
    });
    async function H() {
      P.value = !0;
      try {
        await C({
          label: z.value.trim() || o("conn.s3keys.defaultLabel"),
          bucket: D.value.trim() || void 0,
          prefix: q.value.trim() || void 0
        }), z.value = "", J();
      } finally {
        P.value = !1;
      }
    }
    function ne(Q) {
      return [
        {
          key: "toggle",
          label: Q.disabled_at ? o("conn.s3keys.enable") : o("conn.s3keys.disable"),
          icon: Q.disabled_at ? "check" : "lock",
          disabled: P.value
        },
        {
          key: "revoke",
          label: R.value === Q.id ? o("conn.s3keys.confirm") : o("conn.s3keys.revoke"),
          icon: "delete",
          danger: !0,
          disabled: P.value
        }
      ];
    }
    const j = E(() => [
      {
        id: "label",
        label: o("conn.s3keys.col.label"),
        sortable: !0,
        width: 180,
        format: (Q) => Q.label || o("conn.s3keys.noLabel")
      },
      {
        id: "key",
        label: o("conn.s3keys.col.key"),
        sortable: !0,
        width: 200,
        sortValue: (Q) => Q.access_key_id,
        title: (Q) => Q.access_key_id
      },
      { id: "scope", label: o("conn.s3keys.col.scope"), sortable: !0, width: 160, format: _ },
      {
        id: "lastUsed",
        label: o("conn.s3keys.col.lastUsed"),
        sortable: !0,
        sortDir: "desc",
        width: 140,
        format: (Q) => Q.last_used_at ? fe(Q.last_used_at) : o("conn.s3keys.neverUsed"),
        sortValue: (Q) => Q.last_used_at ? new Date(Q.last_used_at).getTime() : null
      }
    ]);
    function re(Q, K) {
      Q === "toggle" ? he(K) : Q === "revoke" && ue(K);
    }
    async function he(Q) {
      P.value = !0;
      try {
        await T(Q.id, !Q.disabled_at), J();
      } finally {
        P.value = !1;
      }
    }
    async function ue(Q) {
      if (R.value !== Q.id) {
        R.value = Q.id;
        return;
      }
      R.value = null, P.value = !0;
      try {
        await A(Q.id), J();
      } finally {
        P.value = !1;
      }
    }
    async function ae(Q, K) {
      let I = !1;
      try {
        await navigator.clipboard.writeText(Q), I = !0;
      } catch {
        try {
          const Y = document.createElement("textarea");
          Y.value = Q, Y.setAttribute("readonly", ""), Y.style.position = "fixed", Y.style.opacity = "0", document.body.appendChild(Y), Y.select(), I = document.execCommand("copy"), document.body.removeChild(Y);
        } catch {
          I = !1;
        }
      }
      I && (W.value = K, N && clearTimeout(N), N = setTimeout(() => W.value = null, 1600));
    }
    function fe(Q) {
      const K = new Date(Q ?? "").getTime();
      return Number.isNaN(K) ? "" : l(K);
    }
    function _(Q) {
      return Q.bucket ? Q.prefix ? `${Q.bucket}/${Q.prefix}` : Q.bucket : o("conn.s3keys.scopeAll");
    }
    return (Q, K) => (f(), h("section", TG, [
      d("header", AG, [
        d("h4", EG, y(u(o)("conn.s3keys.title")), 1),
        d("p", CG, y(u(o)("conn.s3keys.lead")), 1)
      ]),
      u(p) && !u(p).enabled ? (f(), h("p", zG, y(u(o)("conn.s3keys.disabled")), 1)) : O("", !0),
      u(w) === !1 ? (f(), h("p", MG, y(u(o)("conn.s3keys.cannotMint")), 1)) : O("", !0),
      u(v) ? (f(), h("p", PG, y(u(v)), 1)) : O("", !0),
      u(v) && u(x) ? (f(), h("p", OG, y(u(x)), 1)) : O("", !0),
      u(w) ? (f(), h("div", LG, [
        ln(d("input", {
          "onUpdate:modelValue": K[0] || (K[0] = (I) => z.value = I),
          class: "fe-cfield__input",
          placeholder: u(o)("conn.s3keys.label"),
          "data-testid": "s3-key-label"
        }, null, 8, DG), [
          [_n, z.value]
        ]),
        Ze(kc, {
          "model-value": D.value,
          options: U.value,
          "aria-label": u(o)("conn.s3keys.col.scope"),
          testid: "s3-key-bucket",
          "onUpdate:modelValue": K[1] || (K[1] = (I) => D.value = String(I))
        }, null, 8, ["model-value", "options", "aria-label"]),
        ln(d("input", {
          "onUpdate:modelValue": K[2] || (K[2] = (I) => q.value = I),
          class: "fe-cfield__input",
          placeholder: u(o)("conn.s3keys.prefix"),
          disabled: !D.value,
          "data-testid": "s3-key-prefix"
        }, null, 8, RG), [
          [_n, q.value]
        ]),
        d("button", {
          class: "fe-s3keys__btn",
          disabled: P.value,
          "data-testid": "s3-key-mint",
          onClick: H
        }, y(u(o)("conn.s3keys.mint")), 9, IG)
      ])) : O("", !0),
      u(w) ? (f(), h("p", NG, y(u(o)("conn.s3keys.inheritNote")), 1)) : O("", !0),
      u(S) ? (f(), h("div", BG, [
        d("p", FG, y(u(o)("conn.s3keys.once")), 1),
        d("div", UG, [
          d("span", HG, y(u(o)("conn.s3keys.accessKeyID")), 1),
          d("code", null, y(u(S).key.access_key_id), 1),
          d("button", {
            class: "fe-s3keys__copy",
            onClick: K[3] || (K[3] = (I) => ae(u(S).key.access_key_id, "akid"))
          }, y(W.value === "akid" ? u(o)("conn.guide.copied") : u(o)("conn.guide.copy")), 1)
        ]),
        d("div", KG, [
          d("span", VG, y(u(o)("conn.s3keys.secret")), 1),
          d("code", null, y(u(S).secret), 1),
          d("button", {
            class: "fe-s3keys__copy",
            onClick: K[4] || (K[4] = (I) => ae(u(S).secret, "secret"))
          }, y(W.value === "secret" ? u(o)("conn.guide.copied") : u(o)("conn.guide.copy")), 1)
        ]),
        d("button", {
          class: "fe-s3keys__dismiss",
          onClick: K[5] || (K[5] = //@ts-ignore
          (...I) => u(L) && u(L)(...I))
        }, y(u(o)("conn.s3keys.dismiss")), 1)
      ])) : O("", !0),
      u(m) ? (f(), h("p", jG, "…")) : (f(), Ge(os, {
        key: 8,
        "table-id": "conn.s3keys",
        columns: j.value,
        rows: u(c),
        "row-key": "id",
        locale: i.value,
        empty: u(o)("conn.s3keys.empty"),
        "row-class": (I) => I.disabled_at ? "is-muted" : void 0,
        "row-actions": ne,
        "row-actions-test-id": (I) => `s3-key-actions-${I.id}`,
        onRowAction: K[6] || (K[6] = (I, Y) => re(I, Y))
      }, {
        "cell-key": mt(({ row: I }) => [
          d("code", qG, y(I.access_key_id), 1)
        ]),
        _: 1
      }, 8, ["columns", "rows", "locale", "empty", "row-class", "row-actions-test-id"]))
    ]));
  }
});
function YG(e) {
  const t = Rl(e), n = ca(e), a = (T) => `${n}${T}`, i = Ea([]), o = $(null), l = $(!1), c = $(!1), p = $(null), m = $(null);
  function v(T) {
    return Za(T, e.locale);
  }
  function x(T) {
    return T == null ? void 0 : T.status;
  }
  async function w() {
    l.value = !0, p.value = null;
    try {
      const T = await t.jsonFetch(
        a("/api/auth/ssh-keys")
      );
      i.value = Array.isArray(T == null ? void 0 : T.keys) ? T.keys : [], o.value = {
        enabled: (T == null ? void 0 : T.enabled) !== !1,
        host: (T == null ? void 0 : T.host) ?? "",
        port: (T == null ? void 0 : T.port) ?? 2022,
        login: (T == null ? void 0 : T.login) ?? "",
        ftps: T == null ? void 0 : T.ftps
      }, m.value = !0;
    } catch (T) {
      i.value = [], m.value = !1, x(T) !== 401 && x(T) !== 403 && (p.value = v(T));
    } finally {
      l.value = !1, c.value = !0;
    }
  }
  async function S(T, A) {
    p.value = null;
    try {
      return await t.jsonFetch(a("/api/auth/ssh-keys"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ key: T, name: A })
      }), await w(), !0;
    } catch (L) {
      return p.value = v(L), !1;
    }
  }
  async function k(T, A) {
    p.value = null;
    try {
      await t.jsonFetch(a(`/api/auth/ssh-keys/${T}/state`), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ disabled: A })
      }), await w();
    } catch (L) {
      p.value = v(L);
    }
  }
  async function b(T) {
    p.value = null;
    try {
      await t.jsonFetch(a(`/api/auth/ssh-keys/${T}`), { method: "DELETE" }), await w();
    } catch (A) {
      p.value = v(A);
    }
  }
  const C = E(() => i.value.some((T) => !T.disabled_at));
  return { keys: i, connection: o, loading: l, loaded: c, error: p, canAdd: m, hasUsableKey: C, load: w, add: S, setDisabled: k, remove: b };
}
const GG = {
  key: 0,
  class: "fe-s3keys",
  "data-testid": "ssh-keys"
}, XG = { class: "fe-s3keys__head" }, JG = { class: "fe-s3keys__title" }, ZG = { class: "fe-s3keys__lead" }, QG = {
  key: 0,
  class: "fe-s3keys__warn"
}, eX = {
  key: 1,
  class: "fe-s3keys__muted"
}, tX = {
  key: 2,
  class: "fe-s3keys__warn"
}, nX = {
  key: 3,
  class: "fe-sshkeys__form"
}, aX = ["placeholder"], iX = { class: "fe-sshkeys__row" }, oX = ["placeholder"], rX = ["disabled"], sX = { class: "fe-s3keys__hint" }, lX = {
  key: 4,
  class: "fe-s3keys__muted"
}, uX = { class: "tbl-mono" }, cX = /* @__PURE__ */ lt({
  __name: "SSHKeysPanel",
  props: {
    config: {},
    keysVisible: { type: Boolean }
  },
  emits: ["active"],
  setup(e, { emit: t }) {
    const n = e, a = E(() => n.keysVisible !== !1), i = t, o = E(() => Wi(n.config.locale)), { t: l, formatDate: c } = pt(o), { keys: p, connection: m, loading: v, error: x, canAdd: w, hasUsableKey: S, load: k, add: b, setDisabled: C, remove: T } = YG(n.config), A = $(""), L = $(""), z = $(!1), D = $(null);
    function U() {
      const j = m.value;
      j && i("active", {
        host: j.host,
        port: j.port,
        login: j.login,
        enabled: j.enabled,
        hasKey: S.value,
        // The FTPS endpoint travels with the SSH facts: for the user this is one
        // question ("how do I reach this from a program?"), and two calls to
        // answer it would be two chances to disagree.
        ftps: j.ftps
      });
    }
    jt(async () => {
      await k(), U();
    });
    async function q() {
      if (A.value.trim()) {
        z.value = !0;
        try {
          await b(A.value.trim(), L.value.trim() || void 0) && (A.value = "", L.value = ""), U();
        } finally {
          z.value = !1;
        }
      }
    }
    function P(j) {
      return [
        {
          key: "toggle",
          label: j.disabled_at ? l("conn.sshkeys.enable") : l("conn.sshkeys.disable"),
          icon: j.disabled_at ? "check" : "lock",
          disabled: z.value
        },
        {
          key: "remove",
          label: D.value === j.id ? l("conn.sshkeys.confirm") : l("conn.sshkeys.remove"),
          icon: "delete",
          danger: !0,
          disabled: z.value
        }
      ];
    }
    const R = E(() => [
      {
        id: "name",
        label: l("conn.sshkeys.col.name"),
        sortable: !0,
        width: 180,
        format: (j) => j.name || l("conn.sshkeys.noName")
      },
      {
        id: "fingerprint",
        label: l("conn.sshkeys.col.fingerprint"),
        sortable: !0,
        width: 240,
        sortValue: (j) => ne(j),
        title: (j) => ne(j)
      },
      {
        id: "lastUsed",
        label: l("conn.sshkeys.col.lastUsed"),
        sortable: !0,
        sortDir: "desc",
        width: 140,
        format: (j) => j.last_used_at ? H(j.last_used_at) : l("conn.sshkeys.neverUsed"),
        sortValue: (j) => j.last_used_at ? new Date(j.last_used_at).getTime() : null
      }
    ]);
    function W(j, re) {
      j === "toggle" ? N(re) : j === "remove" && J(re);
    }
    async function N(j) {
      z.value = !0;
      try {
        await C(j.id, !j.disabled_at), U();
      } finally {
        z.value = !1;
      }
    }
    async function J(j) {
      if (D.value !== j.id) {
        D.value = j.id;
        return;
      }
      D.value = null, z.value = !0;
      try {
        await T(j.id), U();
      } finally {
        z.value = !1;
      }
    }
    function H(j) {
      const re = new Date(j ?? "").getTime();
      return Number.isNaN(re) ? "" : c(re);
    }
    function ne(j) {
      return "SHA256:" + j.fingerprint;
    }
    return (j, re) => a.value ? (f(), h("section", GG, [
      d("header", XG, [
        d("h4", JG, y(u(l)("conn.sshkeys.title")), 1),
        d("p", ZG, y(u(l)("conn.sshkeys.lead")), 1)
      ]),
      u(m) && !u(m).enabled ? (f(), h("p", QG, y(u(l)("conn.sshkeys.disabled")), 1)) : O("", !0),
      u(w) === !1 ? (f(), h("p", eX, y(u(l)("conn.sshkeys.cannotAdd")), 1)) : O("", !0),
      u(x) ? (f(), h("p", tX, y(u(x)), 1)) : O("", !0),
      u(w) ? (f(), h("div", nX, [
        ln(d("textarea", {
          "onUpdate:modelValue": re[0] || (re[0] = (he) => A.value = he),
          class: "fe-cfield__input fe-sshkeys__paste",
          rows: "2",
          spellcheck: "false",
          placeholder: u(l)("conn.sshkeys.paste"),
          "data-testid": "ssh-key-input"
        }, null, 8, aX), [
          [_n, A.value]
        ]),
        d("div", iX, [
          ln(d("input", {
            "onUpdate:modelValue": re[1] || (re[1] = (he) => L.value = he),
            class: "fe-cfield__input",
            placeholder: u(l)("conn.sshkeys.name"),
            "data-testid": "ssh-key-name"
          }, null, 8, oX), [
            [_n, L.value]
          ]),
          d("button", {
            class: "fe-s3keys__btn",
            disabled: z.value,
            "data-testid": "ssh-key-add",
            onClick: q
          }, y(u(l)("conn.sshkeys.add")), 9, rX)
        ]),
        d("p", sX, y(u(l)("conn.sshkeys.noCopyId")), 1)
      ])) : O("", !0),
      u(v) ? (f(), h("p", lX, "…")) : (f(), Ge(os, {
        key: 5,
        "table-id": "conn.sshkeys",
        columns: R.value,
        rows: u(p),
        "row-key": "id",
        locale: o.value,
        empty: u(l)("conn.sshkeys.empty"),
        "row-class": (he) => he.disabled_at ? "is-muted" : void 0,
        "row-actions": P,
        "row-actions-test-id": (he) => `ssh-key-actions-${he.id}`,
        onRowAction: re[2] || (re[2] = (he, ue) => W(he, ue))
      }, {
        "cell-fingerprint": mt(({ row: he }) => [
          d("code", uX, y(ne(he)), 1)
        ]),
        _: 1
      }, 8, ["columns", "rows", "locale", "empty", "row-class", "row-actions-test-id"]))
    ])) : O("", !0);
  }
});
function dX(e) {
  const t = Rl(e), n = ca(e), a = (L) => `${n}${L}`, i = Ea([]), o = $(null), l = $(!1), c = $(!1), p = $(null), m = $(null), v = $(null);
  function x(L) {
    return Za(L, e.locale);
  }
  function w(L) {
    return L == null ? void 0 : L.status;
  }
  async function S() {
    l.value = !0, p.value = null;
    try {
      const L = await t.jsonFetch(
        a("/api/auth/nfs-exports")
      );
      i.value = Array.isArray(L == null ? void 0 : L.exports) ? L.exports : [], o.value = {
        enabled: (L == null ? void 0 : L.enabled) !== !1,
        host: (L == null ? void 0 : L.host) ?? "",
        port: (L == null ? void 0 : L.port) ?? 2049
      }, m.value = !0;
    } catch (L) {
      i.value = [], m.value = !1, w(L) !== 401 && w(L) !== 403 && (p.value = x(L));
    } finally {
      l.value = !1, c.value = !0;
    }
  }
  async function k(L) {
    p.value = null;
    try {
      const z = await t.jsonFetch(a("/api/auth/nfs-exports"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(L)
      });
      return v.value = z, z != null && z.host && (o.value = { enabled: z.enabled !== !1, host: z.host, port: z.port }), await S(), z;
    } catch (z) {
      return p.value = x(z), null;
    }
  }
  async function b(L, z) {
    p.value = null;
    try {
      await t.jsonFetch(a(`/api/auth/nfs-exports/${L}/state`), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ disabled: z })
      }), await S();
    } catch (D) {
      p.value = x(D);
    }
  }
  async function C(L) {
    var z, D;
    p.value = null;
    try {
      await t.jsonFetch(a(`/api/auth/nfs-exports/${L}`), { method: "DELETE" }), ((D = (z = v.value) == null ? void 0 : z.export) == null ? void 0 : D.id) === L && (v.value = null), await S();
    } catch (U) {
      p.value = x(U);
    }
  }
  function T() {
    v.value = null;
  }
  const A = E(() => {
    var z;
    if ((z = v.value) != null && z.export) return v.value.export;
    const L = i.value.filter((D) => !D.disabled_at);
    return L.length ? L.reduce((D, U) => D.created_at >= U.created_at ? D : U) : null;
  });
  return {
    exports: i,
    connection: o,
    loading: l,
    loaded: c,
    error: p,
    canMint: m,
    revealed: v,
    guideExport: A,
    load: S,
    create: k,
    setDisabled: b,
    remove: C,
    dismissPath: T
  };
}
const fX = {
  class: "fe-s3keys",
  "data-testid": "nfs-exports"
}, pX = { class: "fe-s3keys__head" }, hX = { class: "fe-s3keys__title" }, mX = { class: "fe-s3keys__lead" }, vX = { class: "fe-s3keys__warn" }, yX = {
  key: 0,
  class: "fe-s3keys__warn"
}, gX = {
  key: 1,
  class: "fe-s3keys__muted"
}, bX = {
  key: 2,
  class: "fe-s3keys__warn"
}, kX = {
  key: 3,
  class: "fe-s3keys__form fe-nfs__form"
}, wX = ["placeholder"], _X = ["placeholder", "disabled"], xX = ["placeholder"], SX = { class: "fe-nfs__ro" }, $X = ["disabled"], TX = {
  key: 4,
  class: "fe-s3keys__hint"
}, AX = {
  key: 5,
  class: "fe-s3keys__secret",
  "data-testid": "nfs-path"
}, EX = { class: "fe-s3keys__once" }, CX = { class: "fe-s3keys__pair" }, zX = {
  key: 6,
  class: "fe-s3keys__muted"
}, MX = /* @__PURE__ */ lt({
  __name: "NFSExportsPanel",
  props: {
    config: {},
    storages: {}
  },
  emits: ["active"],
  setup(e, { emit: t }) {
    const n = e, a = t, i = E(() => Wi(n.config.locale)), { t: o, formatDate: l } = pt(i), {
      exports: c,
      connection: p,
      loading: m,
      error: v,
      canMint: x,
      revealed: w,
      guideExport: S,
      load: k,
      create: b,
      setDisabled: C,
      remove: T,
      dismissPath: A
    } = dX(n.config), L = $(""), z = $(""), D = E(() => [
      { value: "", label: o("conn.nfs.everyStorage") },
      ...n.storages.map((I) => ({ value: I, label: I }))
    ]), U = $(""), q = $(!0), P = $(""), R = $(!1), W = $(null), N = $(!1);
    let J = null;
    function H() {
      var Y, B;
      const I = p.value;
      I && a("active", {
        host: I.host,
        port: I.port,
        enabled: I.enabled,
        // Only the freshly minted path — the stored ones cannot be recovered, and
        // printing a placeholder in a mount line somebody copies would produce a
        // command that fails with no clue why.
        path: (Y = w.value) == null ? void 0 : Y.path,
        readOnly: ((B = S.value) == null ? void 0 : B.read_only) ?? q.value
      });
    }
    jt(async () => {
      await k(), H();
    });
    async function ne() {
      R.value = !0;
      try {
        await b({
          label: L.value.trim() || o("conn.nfs.defaultLabel"),
          storage: z.value.trim() || void 0,
          prefix: U.value.trim() || void 0,
          read_only: q.value,
          allow_cidrs: P.value.trim() || void 0
        }), L.value = "", H();
      } finally {
        R.value = !1;
      }
    }
    function j(I) {
      return [
        {
          key: "toggle",
          label: I.disabled_at ? o("conn.nfs.enable") : o("conn.nfs.disable"),
          icon: I.disabled_at ? "check" : "lock",
          disabled: R.value
        },
        {
          key: "revoke",
          label: W.value === I.id ? o("conn.nfs.confirm") : o("conn.nfs.revoke"),
          icon: "delete",
          danger: !0,
          disabled: R.value
        }
      ];
    }
    const re = E(() => [
      {
        id: "label",
        label: o("conn.nfs.col.label"),
        sortable: !0,
        width: 180,
        format: (I) => I.label || o("conn.nfs.noLabel")
      },
      { id: "scope", label: o("conn.nfs.col.scope"), sortable: !0, width: 180, format: K },
      {
        id: "mode",
        label: o("conn.nfs.col.mode"),
        sortable: !0,
        width: 120,
        format: (I) => I.read_only ? o("conn.nfs.modeRead") : o("conn.nfs.modeWrite")
      },
      {
        id: "lastUsed",
        label: o("conn.nfs.col.lastUsed"),
        sortable: !0,
        sortDir: "desc",
        width: 140,
        format: (I) => I.last_used_at ? Q(I.last_used_at) : o("conn.nfs.neverUsed"),
        sortValue: (I) => I.last_used_at ? new Date(I.last_used_at).getTime() : null
      }
    ]);
    function he(I, Y) {
      I === "toggle" ? ue(Y) : I === "revoke" && ae(Y);
    }
    async function ue(I) {
      R.value = !0;
      try {
        await C(I.id, !I.disabled_at), H();
      } finally {
        R.value = !1;
      }
    }
    async function ae(I) {
      if (W.value !== I.id) {
        W.value = I.id;
        return;
      }
      W.value = null, R.value = !0;
      try {
        await T(I.id), H();
      } finally {
        R.value = !1;
      }
    }
    const fe = E(() => {
      var V, be, Fe;
      const I = p.value, Y = (V = w.value) == null ? void 0 : V.path;
      if (!I || !Y) return "";
      const B = (Fe = (be = w.value) == null ? void 0 : be.export) != null && Fe.read_only ? ",ro" : "";
      return `sudo mount -t nfs -o nfsvers=3,tcp,port=${I.port},mountport=${I.port},nolock${B} ${I.host}:${Y} /mnt/filex`;
    });
    async function _() {
      const I = fe.value;
      if (!I) return;
      let Y = !1;
      try {
        await navigator.clipboard.writeText(I), Y = !0;
      } catch {
        try {
          const B = document.createElement("textarea");
          B.value = I, B.setAttribute("readonly", ""), B.style.position = "fixed", B.style.opacity = "0", document.body.appendChild(B), B.select(), Y = document.execCommand("copy"), document.body.removeChild(B);
        } catch {
          Y = !1;
        }
      }
      Y && (N.value = !0, J && clearTimeout(J), J = setTimeout(() => N.value = !1, 1600));
    }
    function Q(I) {
      const Y = new Date(I ?? "").getTime();
      return Number.isNaN(Y) ? "" : l(Y);
    }
    function K(I) {
      return I.storage_name ? I.prefix ? `${I.storage_name}/${I.prefix}` : I.storage_name : o("conn.nfs.scopeAll");
    }
    return (I, Y) => (f(), h("section", fX, [
      d("header", pX, [
        d("h4", hX, y(u(o)("conn.nfs.title")), 1),
        d("p", mX, y(u(o)("conn.nfs.lead")), 1)
      ]),
      d("p", vX, y(u(o)("conn.nfs.pathIsSecret")), 1),
      u(p) && !u(p).enabled ? (f(), h("p", yX, y(u(o)("conn.nfs.disabled")), 1)) : O("", !0),
      u(x) === !1 ? (f(), h("p", gX, y(u(o)("conn.nfs.cannotMint")), 1)) : O("", !0),
      u(v) ? (f(), h("p", bX, y(u(v)), 1)) : O("", !0),
      u(x) ? (f(), h("div", kX, [
        ln(d("input", {
          "onUpdate:modelValue": Y[0] || (Y[0] = (B) => L.value = B),
          class: "fe-cfield__input",
          placeholder: u(o)("conn.nfs.label"),
          "data-testid": "nfs-label"
        }, null, 8, wX), [
          [_n, L.value]
        ]),
        Ze(kc, {
          "model-value": z.value,
          options: D.value,
          "aria-label": u(o)("conn.nfs.col.scope"),
          testid: "nfs-storage",
          "onUpdate:modelValue": Y[1] || (Y[1] = (B) => z.value = String(B))
        }, null, 8, ["model-value", "options", "aria-label"]),
        ln(d("input", {
          "onUpdate:modelValue": Y[2] || (Y[2] = (B) => U.value = B),
          class: "fe-cfield__input",
          placeholder: u(o)("conn.nfs.prefix"),
          disabled: !z.value,
          "data-testid": "nfs-prefix"
        }, null, 8, _X), [
          [_n, U.value]
        ]),
        ln(d("input", {
          "onUpdate:modelValue": Y[3] || (Y[3] = (B) => P.value = B),
          class: "fe-cfield__input",
          placeholder: u(o)("conn.nfs.allowCidrs"),
          "data-testid": "nfs-cidrs"
        }, null, 8, xX), [
          [_n, P.value]
        ]),
        d("label", SX, [
          ln(d("input", {
            type: "checkbox",
            "onUpdate:modelValue": Y[4] || (Y[4] = (B) => q.value = B),
            "data-testid": "nfs-readonly"
          }, null, 512), [
            [zc, q.value]
          ]),
          Ht(" " + y(u(o)("conn.nfs.readOnly")), 1)
        ]),
        d("button", {
          class: "fe-s3keys__btn",
          disabled: R.value,
          "data-testid": "nfs-mint",
          onClick: ne
        }, y(u(o)("conn.nfs.mint")), 9, $X)
      ])) : O("", !0),
      u(x) ? (f(), h("p", TX, y(u(o)("conn.nfs.readOnlyHint")), 1)) : O("", !0),
      u(w) ? (f(), h("div", AX, [
        d("p", EX, y(u(o)("conn.nfs.once")), 1),
        d("div", CX, [
          d("code", null, y(fe.value), 1),
          d("button", {
            class: "fe-s3keys__copy",
            onClick: _
          }, y(N.value ? u(o)("conn.guide.copied") : u(o)("conn.guide.copy")), 1)
        ]),
        d("button", {
          class: "fe-s3keys__dismiss",
          onClick: Y[5] || (Y[5] = //@ts-ignore
          (...B) => u(A) && u(A)(...B))
        }, y(u(o)("conn.nfs.dismiss")), 1)
      ])) : O("", !0),
      u(m) ? (f(), h("p", zX, "…")) : (f(), Ge(os, {
        key: 7,
        "table-id": "conn.nfs",
        columns: re.value,
        rows: u(c),
        "row-key": "id",
        locale: i.value,
        empty: u(o)("conn.nfs.empty"),
        "row-class": (B) => B.disabled_at ? "is-muted" : void 0,
        "row-actions": j,
        "row-actions-test-id": (B) => `nfs-export-actions-${B.id}`,
        onRowAction: Y[6] || (Y[6] = (B, V) => he(B, V))
      }, null, 8, ["columns", "rows", "locale", "empty", "row-class", "row-actions-test-id"]))
    ]));
  }
});
function PX(e) {
  const t = Rl(e), n = ca(e), a = (T) => `${n}${T}`, i = Ea([]), o = $(!1), l = $(!1), c = $(null), p = $(null), m = $(null);
  function v(T) {
    return Za(T, e.locale);
  }
  function x(T) {
    return T == null ? void 0 : T.status;
  }
  async function w() {
    o.value = !0, c.value = null;
    try {
      const T = await t.jsonFetch(a("/api/tokens"));
      i.value = Array.isArray(T == null ? void 0 : T.tokens) ? T.tokens : [], p.value = !0;
    } catch (T) {
      i.value = [];
      const A = x(T);
      p.value = !1, A !== 401 && A !== 403 && (c.value = v(T));
    } finally {
      o.value = !1, l.value = !0;
    }
  }
  async function S(T) {
    c.value = null;
    try {
      const A = await t.jsonFetch(a("/api/tokens"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(T)
      });
      return m.value = A, await w(), A;
    } catch (A) {
      return c.value = v(A), null;
    }
  }
  async function k(T) {
    var A, L;
    c.value = null;
    try {
      await t.jsonFetch(a(`/api/tokens/${T}`), { method: "DELETE" }), ((L = (A = m.value) == null ? void 0 : A.row) == null ? void 0 : L.id) === T && (m.value = null), await w();
    } catch (z) {
      c.value = v(z);
    }
  }
  async function b(T, A) {
    c.value = null;
    try {
      return await t.jsonFetch(a(`/api/tokens/${T}`), {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ permissions: A })
      }), await w(), !0;
    } catch (L) {
      return c.value = v(L), !1;
    }
  }
  function C() {
    m.value = null;
  }
  return { tokens: i, loading: o, loaded: l, error: c, canMint: p, revealed: m, load: w, create: S, remove: k, setPermissions: b, dismiss: C };
}
const OX = {
  class: "fe-s3keys",
  "data-testid": "api-tokens"
}, LX = { class: "fe-s3keys__head" }, DX = { class: "fe-s3keys__title" }, RX = { class: "fe-s3keys__lead" }, IX = {
  key: 0,
  class: "fe-s3keys__muted"
}, NX = {
  key: 1,
  class: "fe-s3keys__warn"
}, BX = {
  key: 2,
  class: "fe-s3keys__form"
}, FX = ["placeholder"], UX = ["disabled"], HX = {
  key: 3,
  class: "fe-tokform",
  "data-testid": "token-form-full"
}, KX = ["placeholder"], VX = { class: "fe-tokform__scopes" }, jX = { class: "fe-tokform__legend" }, qX = ["onUpdate:modelValue", "data-testid"], WX = {
  key: 0,
  class: "fe-s3keys__hint fe-tokform__required",
  role: "alert",
  "data-testid": "token-scopes-required"
}, YX = { class: "fe-tokform__field" }, GX = {
  id: "token-comments-label",
  class: "fe-tokform__label"
}, XX = { class: "fe-s3keys__hint" }, JX = { class: "fe-tokform__field" }, ZX = { class: "fe-tokform__label" }, QX = ["placeholder"], eJ = { class: "fe-tokform__row" }, tJ = { class: "fe-tokform__field fe-tokform__field--narrow" }, nJ = { class: "fe-tokform__label" }, aJ = ["placeholder"], iJ = ["disabled"], oJ = { class: "fe-s3keys__hint" }, rJ = {
  key: 4,
  class: "fe-s3keys__secret",
  "data-testid": "token-secret"
}, sJ = { class: "fe-s3keys__once" }, lJ = { class: "fe-s3keys__pair" }, uJ = {
  key: 5,
  class: "fe-s3keys__muted"
}, cJ = { class: "tbl-mono" }, dJ = {
  key: 7,
  class: "fe-s3keys__hint"
}, MT = /* @__PURE__ */ lt({
  __name: "TokensPanel",
  props: {
    config: {},
    full: { type: Boolean },
    protocol: {},
    host: {}
  },
  emits: ["active"],
  setup(e, { emit: t }) {
    const n = e, a = t, i = E(() => Wi(n.config.locale)), { t: o, formatDate: l } = pt(i), { tokens: c, loading: p, error: m, canMint: v, revealed: x, load: w, create: S, remove: k, setPermissions: b, dismiss: C } = PX(
      n.config
    ), T = $(""), A = $(!1), L = $(!1), z = $(null), D = ["read", "write", "delete", "mcp"], U = $({
      read: !0,
      write: !1,
      delete: !1,
      mcp: !1
    }), q = $(""), P = $(null), R = $("read"), W = E(() => [
      { value: "read", label: o("conn.tokens.commentsRead") },
      { value: "rw", label: o("conn.tokens.commentsRw") }
    ]);
    function N(Y) {
      var B;
      return ((B = Y.permissions) == null ? void 0 : B.comments) === "rw" ? o("conn.tokens.commentsRw") : o("conn.tokens.commentsRead");
    }
    const J = E(() => !D.some((Y) => U.value[Y]));
    function H() {
      const Y = D.filter((V) => U.value[V]), B = q.value.trim();
      return B && Y.push("root:" + B), R.value === "rw" && Y.push("comments:rw"), Y.join(",");
    }
    jt(async () => {
      await w(), a("active", { hasToken: c.value.length > 0 });
    });
    function ne() {
      const Y = (n.protocol || "").toUpperCase();
      return Y ? n.host ? `${Y} - ${n.host}` : Y : o("conn.tokens.defaultName", { date: (/* @__PURE__ */ new Date()).toISOString().slice(0, 10) });
    }
    function j() {
      return n.protocol ? ne() : o("conn.tokens.namePlaceholder");
    }
    async function re() {
      if (!A.value) {
        A.value = !0, L.value = !1;
        try {
          if (n.full) {
            if (J.value) return;
            const Y = H();
            await S({
              label: T.value.trim() || ne(),
              scopes: Y,
              expires_in_days: P.value && P.value > 0 ? P.value : void 0
            }), await w(), a("active", { hasToken: c.value.length > 0 }), T.value = "", q.value = "", R.value = "read";
            return;
          }
          await S({ label: T.value.trim() || ne(), scopes: "read,write,delete" }), await w(), a("active", { hasToken: c.value.length > 0 }), T.value = "";
        } finally {
          A.value = !1;
        }
      }
    }
    const he = E(() => [
      {
        id: "label",
        label: o("conn.tokens.col.label"),
        sortable: !0,
        width: 200,
        format: (Y) => Y.label || "-"
      },
      { id: "scopes", label: o("conn.tokens.col.scopes"), sortable: !0, width: 200 },
      {
        id: "comments",
        label: o("conn.tokens.col.comments"),
        sortable: !0,
        width: 140,
        format: N
      },
      {
        id: "used",
        label: o("conn.tokens.col.used"),
        sortable: !0,
        sortDir: "desc",
        width: 140,
        format: I,
        sortValue: (Y) => Y.last_used_at ? new Date(Y.last_used_at).getTime() : null
      }
    ]);
    function ue(Y) {
      var V;
      const B = ((V = Y.permissions) == null ? void 0 : V.comments) === "rw";
      return [
        {
          key: "comments",
          label: o(B ? "conn.tokens.commentsToRead" : "conn.tokens.commentsToRw"),
          icon: "rename",
          disabled: A.value
        },
        {
          key: "revoke",
          label: z.value === Y.id ? o("conn.tokens.confirm") : o("conn.tokens.revoke"),
          icon: "delete",
          danger: !0,
          /* The whole control used to be `:disabled="busy"`; the table draws the
             control, so the verb carries it — RowActions greys a button with
             nothing usable behind it. */
          disabled: A.value
        }
      ];
    }
    function ae(Y, B) {
      Y === "revoke" ? _(B) : Y === "comments" && fe(B);
    }
    async function fe(Y) {
      var B;
      A.value = !0;
      try {
        await b(Y.id, { comments: ((B = Y.permissions) == null ? void 0 : B.comments) === "rw" ? "read" : "rw" });
      } finally {
        A.value = !1;
      }
    }
    async function _(Y) {
      if (z.value !== Y.id) {
        z.value = Y.id;
        return;
      }
      z.value = null, A.value = !0;
      try {
        await k(Y.id), a("active", { hasToken: c.value.length > 0 });
      } finally {
        A.value = !1;
      }
    }
    async function Q() {
      var Y;
      if ((Y = x.value) != null && Y.token)
        try {
          await navigator.clipboard.writeText(x.value.token), L.value = !0, window.setTimeout(() => L.value = !1, 1600);
        } catch {
        }
    }
    function K(Y) {
      const B = new Date(Y ?? "").getTime();
      return Number.isNaN(B) ? "" : l(B);
    }
    function I(Y) {
      return Y.last_used_at ? K(Y.last_used_at) : o("conn.tokens.neverUsed");
    }
    return (Y, B) => (f(), h("section", OX, [
      d("header", LX, [
        d("h4", DX, y(u(o)("conn.tokens.title")), 1),
        d("p", RX, y(u(o)("conn.tokens.lead")), 1)
      ]),
      u(v) === !1 ? (f(), h("p", IX, y(u(o)("conn.tokens.cannotMint")), 1)) : O("", !0),
      u(m) ? (f(), h("p", NX, y(u(m)), 1)) : O("", !0),
      u(v) && !e.full ? (f(), h("div", BX, [
        ln(d("input", {
          "onUpdate:modelValue": B[0] || (B[0] = (V) => T.value = V),
          class: "fe-cfield__input",
          placeholder: j(),
          "data-testid": "token-label"
        }, null, 8, FX), [
          [_n, T.value]
        ]),
        d("button", {
          class: "fe-s3keys__btn",
          disabled: A.value,
          "data-testid": "token-mint",
          onClick: re
        }, y(u(o)("conn.tokens.mint")), 9, UX)
      ])) : u(v) ? (f(), h("div", HX, [
        ln(d("input", {
          "onUpdate:modelValue": B[1] || (B[1] = (V) => T.value = V),
          class: "fe-cfield__input",
          placeholder: j(),
          "data-testid": "token-label"
        }, null, 8, KX), [
          [_n, T.value]
        ]),
        d("fieldset", VX, [
          d("legend", jX, y(u(o)("conn.tokens.scopes")), 1),
          (f(), h(Te, null, nt(D, (V) => d("label", {
            key: V,
            class: "fe-tokform__scope"
          }, [
            ln(d("input", {
              "onUpdate:modelValue": (be) => U.value[V] = be,
              type: "checkbox",
              "data-testid": `token-scope-${V}`
            }, null, 8, qX), [
              [zc, U.value[V]]
            ]),
            d("span", null, y(V), 1)
          ])), 64)),
          J.value ? (f(), h("p", WX, y(u(o)("conn.tokens.scopesRequired")), 1)) : O("", !0)
        ]),
        d("div", YX, [
          d("span", GX, y(u(o)("conn.tokens.comments")), 1),
          Ze(mi, {
            "model-value": R.value,
            options: W.value,
            "aria-labelledby": "token-comments-label",
            "testid-prefix": "token-comments",
            "onUpdate:modelValue": B[2] || (B[2] = (V) => R.value = V)
          }, null, 8, ["model-value", "options"]),
          d("p", XX, y(u(o)("conn.tokens.commentsHint")), 1)
        ]),
        d("label", JX, [
          d("span", ZX, y(u(o)("conn.tokens.root")), 1),
          ln(d("input", {
            "onUpdate:modelValue": B[3] || (B[3] = (V) => q.value = V),
            class: "fe-cfield__input",
            placeholder: u(o)("conn.tokens.rootPlaceholder"),
            "data-testid": "token-root"
          }, null, 8, QX), [
            [_n, q.value]
          ])
        ]),
        d("div", eJ, [
          d("label", tJ, [
            d("span", nJ, y(u(o)("conn.tokens.expiry")), 1),
            ln(d("input", {
              "onUpdate:modelValue": B[4] || (B[4] = (V) => P.value = V),
              type: "number",
              min: "0",
              class: "fe-cfield__input",
              placeholder: u(o)("conn.tokens.expiryNever"),
              "data-testid": "token-expiry"
            }, null, 8, aJ), [
              [
                _n,
                P.value,
                void 0,
                { number: !0 }
              ]
            ])
          ]),
          d("button", {
            class: "fe-s3keys__btn",
            disabled: A.value || J.value,
            "data-testid": "token-mint",
            onClick: re
          }, y(u(o)("conn.tokens.mint")), 9, iJ)
        ]),
        d("p", oJ, y(u(o)("conn.tokens.capNote")), 1)
      ])) : O("", !0),
      u(x) ? (f(), h("div", rJ, [
        d("p", sJ, y(u(o)("conn.tokens.once")), 1),
        d("div", lJ, [
          d("code", null, y(u(x).token), 1),
          d("button", {
            class: "fe-s3keys__copy",
            onClick: Q
          }, y(L.value ? u(o)("conn.guide.copied") : u(o)("conn.guide.copy")), 1)
        ]),
        d("button", {
          class: "fe-s3keys__dismiss",
          onClick: B[5] || (B[5] = //@ts-ignore
          (...V) => u(C) && u(C)(...V))
        }, y(u(o)("conn.tokens.dismiss")), 1)
      ])) : O("", !0),
      u(p) ? (f(), h("p", uJ, "…")) : (f(), Ge(os, {
        key: 6,
        "table-id": "conn.tokens",
        columns: he.value,
        rows: u(c),
        "row-key": "id",
        locale: i.value,
        empty: u(o)("conn.tokens.empty"),
        "row-actions": ue,
        "row-actions-test-id": (V) => `api-token-actions-${V.id}`,
        onRowAction: B[6] || (B[6] = (V, be) => ae(V, be))
      }, {
        "cell-scopes": mt(({ row: V }) => [
          d("code", cJ, y(V.scopes), 1)
        ]),
        _: 1
      }, 8, ["columns", "rows", "locale", "empty", "row-actions-test-id"])),
      u(v) ? (f(), h("p", dJ, y(u(o)("conn.tokens.revokeHint")), 1)) : O("", !0)
    ]));
  }
}), fJ = { class: "fe-conn__head" }, pJ = { class: "fe-conn__title" }, hJ = { class: "fe-conn__sub" }, mJ = ["aria-label"], vJ = ["innerHTML"], yJ = {
  key: 0,
  class: "fe-conn__error",
  "data-testid": "conn-error"
}, gJ = { class: "fe-conn__body" }, bJ = { class: "fe-conn__guidebar" }, kJ = {
  key: 0,
  class: "fe-conn__pick"
}, wJ = { class: "fe-cfield__label" }, _J = { class: "fe-conn__pick" }, xJ = { class: "fe-cfield__label" }, SJ = /* @__PURE__ */ lt({
  __name: "ConnectionsPanel",
  props: {
    config: {},
    closable: { type: Boolean }
  },
  emits: ["close", "error"],
  setup(e, { emit: t }) {
    const n = e, a = t, i = E(() => Wi(n.config.locale)), { t: o } = pt(i), { visible: l, me: c, realm: p, publicUrl: m, error: v, load: x } = IY(n.config), w = E(() => {
      var R;
      return qY(((R = c.value) == null ? void 0 : R.email) ?? "", p.value);
    }), S = Il(), k = E(() => {
      const R = n.config.theme ?? "auto";
      return R === "light" || R === "dark" ? R : S.value ? "dark" : "light";
    }), b = tG(), C = $(b[0] ?? "webdav"), T = $(""), A = E(() => b.map((R) => ({ value: R, label: eG(R) }))), L = E(() => [
      { value: "", label: o("conn.guide.allStorages") },
      ...l.value.map((R) => ({ value: R, label: R }))
    ]), z = $(
      null
    ), D = E(() => RY(n.config, m.value)), U = $(
      null
    ), q = $(null), P = E(
      () => {
        var R, W, N, J, H, ne, j, re, he, ue, ae, fe, _, Q, K, I, Y, B, V, be, Fe, ze, Ue, We, $t, St;
        return nG(
          C.value,
          {
            origin: D.value,
            user: w.value,
            storages: l.value,
            storage: T.value || void 0,
            s3Endpoint: (R = U.value) == null ? void 0 : R.endpoint,
            s3PathStyle: (W = U.value) == null ? void 0 : W.pathStyle,
            s3AccessKeyID: ((N = U.value) == null ? void 0 : N.accessKeyID) || void 0,
            s3Secret: (J = U.value) == null ? void 0 : J.secret,
            sftpHost: ((H = q.value) == null ? void 0 : H.host) || void 0,
            sftpPort: (ne = q.value) == null ? void 0 : ne.port,
            sftpEnabled: (j = q.value) == null ? void 0 : j.enabled,
            sftpLogin: ((re = q.value) == null ? void 0 : re.login) || void 0,
            sftpHasKey: (he = q.value) == null ? void 0 : he.hasKey,
            ftpsHost: ((ae = (ue = q.value) == null ? void 0 : ue.ftps) == null ? void 0 : ae.host) || void 0,
            ftpsPort: (_ = (fe = q.value) == null ? void 0 : fe.ftps) == null ? void 0 : _.port,
            ftpsEnabled: (K = (Q = q.value) == null ? void 0 : Q.ftps) == null ? void 0 : K.enabled,
            ftpsPasvMin: (Y = (I = q.value) == null ? void 0 : I.ftps) == null ? void 0 : Y.pasv_min,
            ftpsPasvMax: (V = (B = q.value) == null ? void 0 : B.ftps) == null ? void 0 : V.pasv_max,
            ftpsSelfSigned: (Fe = (be = q.value) == null ? void 0 : be.ftps) == null ? void 0 : Fe.self_signed,
            nfsHost: ((ze = z.value) == null ? void 0 : ze.host) || void 0,
            nfsPort: (Ue = z.value) == null ? void 0 : Ue.port,
            nfsEnabled: (We = z.value) == null ? void 0 : We.enabled,
            nfsPath: ($t = z.value) == null ? void 0 : $t.path,
            nfsReadOnly: (St = z.value) == null ? void 0 : St.readOnly
          },
          o
        );
      }
    );
    return Je(
      () => l.value,
      (R) => {
        !T.value && R.length === 1 && (T.value = R[0]);
      }
    ), jt(() => {
      x();
    }), Je(
      () => [n.config.apiBase, n.config.endpoint],
      () => {
        x();
      }
    ), (R, W) => (f(), h("div", {
      class: Re(["fe-conn", {
        "fe--theme-dark": k.value === "dark",
        "fe--theme-light": k.value === "light"
      }]),
      "data-testid": "connections-panel"
    }, [
      d("header", fJ, [
        d("div", null, [
          d("h2", pJ, y(u(o)("conn.title")), 1),
          d("p", hJ, y(u(o)("conn.subtitle", { host: u(ts)(D.value) })), 1)
        ]),
        e.closable ? (f(), h("button", {
          key: 0,
          type: "button",
          class: "fe-conn__btn",
          "data-testid": "connections-close",
          "aria-label": u(o)("conn.close"),
          onClick: W[0] || (W[0] = (N) => a("close"))
        }, [
          d("span", {
            "aria-hidden": "true",
            innerHTML: u(zt)("close")
          }, null, 8, vJ)
        ], 8, mJ)) : O("", !0)
      ]),
      u(v) ? (f(), h("p", yJ, y(u(v)), 1)) : O("", !0),
      d("section", gJ, [
        d("div", bJ, [
          u(b).length > 1 ? (f(), h("label", kJ, [
            d("span", wJ, y(u(o)("conn.guide.protocol")), 1),
            Ze(kc, {
              "model-value": C.value,
              options: A.value,
              testid: "guide-protocol",
              "onUpdate:modelValue": W[1] || (W[1] = (N) => C.value = String(N))
            }, null, 8, ["model-value", "options"])
          ])) : O("", !0),
          d("label", _J, [
            d("span", xJ, y(u(o)("conn.guide.storage")), 1),
            Ze(kc, {
              "model-value": T.value,
              options: L.value,
              testid: "guide-storage",
              "onUpdate:modelValue": W[2] || (W[2] = (N) => T.value = String(N))
            }, null, 8, ["model-value", "options"])
          ])
        ]),
        C.value === "s3" ? (f(), Ge(WG, {
          key: 0,
          config: e.config,
          storages: u(l),
          onActive: W[3] || (W[3] = (N) => U.value = N)
        }, null, 8, ["config", "storages"])) : O("", !0),
        C.value === "sftp" || C.value === "ftps" ? (f(), Ge(cX, {
          key: 1,
          config: e.config,
          "keys-visible": C.value === "sftp",
          onActive: W[4] || (W[4] = (N) => q.value = N)
        }, null, 8, ["config", "keys-visible"])) : O("", !0),
        C.value === "nfs" ? (f(), Ge(MX, {
          key: 2,
          config: e.config,
          storages: u(l),
          onActive: W[5] || (W[5] = (N) => z.value = N)
        }, null, 8, ["config", "storages"])) : O("", !0),
        C.value === "ftps" || C.value === "webdav" || C.value === "mount" ? (f(), Ge(MT, {
          key: 3,
          config: e.config,
          protocol: C.value,
          host: u(ts)(D.value)
        }, null, 8, ["config", "protocol", "host"])) : O("", !0),
        P.value ? (f(), Ge(SG, {
          key: 4,
          guide: P.value,
          locale: i.value
        }, null, 8, ["guide", "locale"])) : O("", !0)
      ])
    ], 2));
  }
});
function Lhe(e = "") {
  return {
    text: "",
    tags: [],
    excludeTags: [],
    scope: "name",
    filters: { ...jo, pathBase: e }
  };
}
function w0(e, t) {
  const n = e.trim();
  if (!n) return "";
  const a = /\s/.test(n) ? `"${n}"` : n;
  return `${t ? "-" : ""}tag:${a}`;
}
function Ty(e) {
  const t = [], n = e.text.trim();
  n && t.push(n);
  for (const a of e.tags) {
    const i = w0(a, !1);
    i && t.push(i);
  }
  for (const a of e.excludeTags) {
    const i = w0(a, !0);
    i && t.push(i);
  }
  return t.join(" ");
}
function $J(e, t = Date.now(), n = {}) {
  const a = {};
  e.type && e.type !== "any" && (a.type = e.type === "folder" ? "dir" : e.type);
  const i = ZS(e, t);
  (i == null ? void 0 : i.after) !== void 0 && (a.modified_after = String(Math.floor(i.after))), (i == null ? void 0 : i.before) !== void 0 && (a.modified_before = String(Math.floor(i.before)));
  const o = QS(e);
  (o == null ? void 0 : o.min) !== void 0 && (a.min_size = String(Math.max(0, Math.floor(o.min)))), (o == null ? void 0 : o.max) !== void 0 && (a.max_size = String(Math.max(0, Math.floor(o.max))));
  const l = (e.pathBase ?? "").replace(/\/+$/, "");
  l && e.pathMode === "here" && (a.under = l), l && e.pathMode === "skip" && (a.not_under = l);
  const c = e.people ?? "any";
  return c === "me" || c === "system" ? a.owner = c : c.startsWith("u:") && (a.owner = c.slice(2)), n.showHidden === !1 && (a.hidden = "false"), a;
}
function Dhe(e) {
  return Ty(e) === "";
}
function Rhe(e) {
  return pN(e, { newlines: !0 });
}
function fv(e, t, n) {
  return typeof n == "boolean" ? n : e >= t;
}
const TJ = { class: "fe-shortcuts" }, AJ = { class: "fe-shortcuts__heading" }, EJ = { class: "fe-shortcuts__table" }, CJ = { class: "fe-shortcuts__keys" }, zJ = {
  key: 0,
  class: "fe-shortcuts__unbound"
}, MJ = { class: "fe-kbd" }, PJ = {
  key: 0,
  class: "fe-shortcuts__or",
  "aria-hidden": "true"
}, OJ = { class: "fe-shortcuts__desc" }, LJ = ["title"], DJ = ["innerHTML"], RJ = /* @__PURE__ */ lt({
  __name: "ShortcutsHelp",
  props: {
    open: { type: Boolean },
    locale: {}
  },
  emits: ["close", "customize"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = pt(() => n.locale), o = t3(), l = E(() => {
      const c = [], p = /* @__PURE__ */ new Map();
      for (const m of o.value)
        p.has(m.groupKey) || (p.set(m.groupKey, []), c.push(m.groupKey)), p.get(m.groupKey).push(m);
      return c.map((m) => ({ key: m, items: p.get(m) }));
    });
    return (c, p) => (f(), Ge(ta, {
      open: e.open,
      title: u(i)("shortcuts.title"),
      size: "md",
      onClose: p[2] || (p[2] = (m) => a("close"))
    }, {
      actions: mt(() => [
        d("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          onClick: p[0] || (p[0] = (m) => a("customize"))
        }, [
          d("span", {
            class: "fe-icon",
            "aria-hidden": "true",
            innerHTML: u(zt)("shortcut-settings")
          }, null, 8, DJ),
          Ht(" " + y(u(i)("shortcuts.customize")), 1)
        ]),
        d("button", {
          type: "button",
          class: "fe-btn",
          onClick: p[1] || (p[1] = (m) => a("close"))
        }, y(u(i)("viewer.close")), 1)
      ]),
      default: mt(() => [
        d("div", TJ, [
          (f(!0), h(Te, null, nt(l.value, (m) => (f(), h("section", {
            key: m.key,
            class: "fe-shortcuts__group"
          }, [
            d("h3", AJ, y(u(i)(m.key)), 1),
            d("div", EJ, [
              (f(!0), h(Te, null, nt(m.items, (v) => (f(), h("div", {
                key: v.id,
                class: "fe-shortcuts__row"
              }, [
                d("span", CJ, [
                  v.keys.length === 0 ? (f(), h("span", zJ, y(u(i)("shortcuts.settings.unbound")), 1)) : (f(!0), h(Te, { key: 1 }, nt(v.keys, (x, w) => (f(), h(Te, { key: x }, [
                    d("kbd", MJ, y(x), 1),
                    w < v.keys.length - 1 ? (f(), h("span", PJ, "/")) : O("", !0)
                  ], 64))), 128))
                ]),
                d("span", OJ, [
                  Ht(y(u(i)(v.labelKey)) + " ", 1),
                  v.overridden ? (f(), h("span", {
                    key: 0,
                    class: "fe-shortcuts__custom",
                    title: u(i)("shortcuts.settings.customized")
                  }, "●", 8, LJ)) : O("", !0)
                ])
              ]))), 128))
            ])
          ]))), 128))
        ])
      ]),
      _: 1
    }, 8, ["open", "title"]));
  }
});
function PT(e) {
  return !e || typeof e != "object" || e.complete === !0 ? null : e;
}
function IJ(e) {
  const t = Math.max(0, e.catalogued_folders ?? 0), n = Math.max(0, e.pending_folders ?? 0);
  if (t + n === 0) return 0;
  const a = Math.floor(t * 100 / (t + n));
  return n > 0 ? Math.min(a, 99) : a;
}
function NJ(e) {
  switch (e.reason) {
    case "lazy_on_open":
      return { key: "coverage.lazy_on_open", vars: {} };
    case "lazy_filling":
      return { key: "coverage.lazy_filling", vars: { pct: IJ(e) } };
    default:
      return { key: "coverage.first_scan", vars: {} };
  }
}
function BJ(e) {
  const t = {};
  if (!Array.isArray(e)) return t;
  for (const n of e)
    !n || typeof n.name != "string" || n.name === "" || (t[n.name] = PT(n.coverage ?? null));
  return t;
}
function FJ(e) {
  const { map: t, adapter: n, searching: a, crossStorage: i, admin: o } = e;
  if (a && i) {
    const c = Object.keys(t).filter((p) => t[p] !== null).sort((p, m) => p.localeCompare(m));
    return c.length === 0 ? null : c.length === 1 ? _0(c[0], t[c[0]], o) : { key: "coverage.search_some", vars: { names: c.join(", ") }, offerCatalogAll: !1 };
  }
  const l = t[n];
  return l ? _0(n, l, o) : null;
}
function _0(e, t, n) {
  const a = NJ(t);
  return { key: a.key, vars: a.vars, storage: e, offerCatalogAll: n && t.reason === "lazy_on_open" };
}
function UJ() {
  let e = 0, t = null, n = Promise.resolve();
  return {
    begin(a, i) {
      return e += 1, { ticket: e, want: a ?? t ?? i };
    },
    going(a) {
      t = a;
    },
    view() {
      return t = null, e += 1, e;
    },
    isNewest(a) {
      return a === e;
    },
    end(a) {
      a === e && (t = null);
    },
    async follow(a) {
      let i;
      const o = new Promise((c) => i = c);
      n = o;
      try {
        await a();
      } finally {
        i();
      }
      let l = o;
      for (; n !== l; )
        l = n, await l;
    }
  };
}
function HJ() {
  let e = 0, t = [];
  function n() {
    if (e > 0 || t.length === 0) return;
    const a = t;
    t = [];
    for (const i of a) i();
  }
  return {
    start() {
      e++;
      let a = !1;
      return () => {
        a || (a = !0, e--, n());
      };
    },
    settled(a) {
      return e === 0 ? Promise.resolve(!0) : new Promise((i) => {
        let o;
        const l = () => {
          o !== void 0 && clearTimeout(o), i(!0);
        };
        t.push(l), o = setTimeout(() => {
          t = t.filter((c) => c !== l), i(!1);
        }, Math.max(0, a));
      });
    },
    get count() {
      return e;
    }
  };
}
const oc = "filex.menuAnswers.v1|", yf = 1, KJ = 1500, VJ = 6, jJ = 196608, x0 = 7 * 24 * 60 * 60 * 1e3, qJ = 3e4, WJ = 400, YJ = ["allowed", "request", "denied"], GJ = ["p", "e:file", "e:folder", "e:new_folder"], Sp = /* @__PURE__ */ new Set();
function gf(e) {
  const t = e.indexOf("://");
  return t > 0 ? e.slice(0, t) : "";
}
function S0(e) {
  const t = e.indexOf("://");
  return t < 0 ? e : e.slice(0, t + 3) + e.slice(t + 3).replace(/^\/+|\/+$/g, "");
}
function pv(e) {
  const t = e.indexOf("://");
  if (t < 0) return null;
  const n = e.slice(t + 3);
  if (!n) return null;
  const a = n.lastIndexOf("/");
  return e.slice(0, t + 3) + (a < 0 ? "" : n.slice(0, a));
}
function hv(e) {
  return e === "p" ? "p" : "e";
}
function XJ(e, t) {
  return e === "p" ? Array.isArray(t) && t.every((n) => typeof n == "string") : typeof t == "string" && YJ.includes(t);
}
function JJ(e) {
  let t = 2166136261, n = 1523705862;
  for (let a = 0; a < e.length; a++) {
    const i = e.charCodeAt(a);
    t = Math.imul(t ^ i, 16777619), n = Math.imul(n ^ i, 1540483477);
  }
  return (t >>> 0).toString(16).padStart(8, "0") + (n >>> 0).toString(16).padStart(8, "0");
}
function ZJ() {
  try {
    const e = globalThis.localStorage;
    if (!e) return null;
    const t = `${oc}probe`;
    return e.setItem(t, "1"), e.removeItem(t), e;
  } catch {
    return null;
  }
}
function QJ(e = {}) {
  const t = e.now ?? (() => Date.now()), n = $(0), a = /* @__PURE__ */ new Map(), i = Math.random().toString(36).slice(2, 8);
  let o = 0, l = `${i}.0`, c = null, p = null, m = {}, v = null, x = !1;
  const w = () => `${oc}${c}`, S = (U) => `${oc}${c}|${encodeURIComponent(U)}`;
  function k(U, q) {
    var N;
    if (!p || !c || !U) return;
    let P = null;
    try {
      P = JSON.parse(p.getItem(S(U)) ?? "null");
    } catch {
      P = null;
    }
    if (!P || P.v !== yf || !Array.isArray(P.r)) return;
    const R = t(), W = /* @__PURE__ */ new Map();
    for (const J of P.r) {
      if (!Array.isArray(J)) continue;
      const [H, ne, j] = J;
      if (typeof H != "string" || typeof j != "number" || R - j > x0) continue;
      const re = H.slice(0, H.indexOf("|"));
      !GJ.includes(re) || ((N = P.sig) == null ? void 0 : N[hv(re)]) !== m[hv(re)] || !XJ(re, ne) || q.rows.has(H) || W.set(H, [ne, j, "", 1]);
    }
    for (const [J, H] of q.rows) W.set(J, H);
    q.rows = W;
  }
  function b(U) {
    let q = a.get(U);
    return q || (q = { sig: { ...m }, rows: /* @__PURE__ */ new Map(), dirty: !1 }, a.set(U, q), k(U, q)), q;
  }
  function C() {
    !p || !c || v || x || (v = setTimeout(L, WJ));
  }
  function T(U, q, P) {
    if (!p) return;
    let R = [...q.rows].filter(([, W]) => W[3] === 1).map(([W, N]) => [W, N[0], N[1]]);
    for (; R.length > 0; ) {
      const W = JSON.stringify({ v: yf, at: P, sig: q.sig, r: R });
      if (W.length <= jJ)
        try {
          p.setItem(S(U), W);
          return;
        } catch {
        }
      R = R.slice(Math.ceil(R.length / 2));
    }
    try {
      p.removeItem(S(U));
    } catch {
    }
  }
  function A() {
    try {
      const U = JSON.parse((p == null ? void 0 : p.getItem(w())) ?? "null");
      if (U && U.v === yf && U.s && typeof U.s == "object") {
        const q = {};
        for (const [P, R] of Object.entries(U.s)) typeof R == "number" && (q[P] = R);
        return q;
      }
    } catch {
    }
    return {};
  }
  function L() {
    if (v && clearTimeout(v), v = null, !p || !c) return;
    const U = t(), q = A();
    for (const [R, W] of a)
      W.dirty && (W.dirty = !1, R && (q[R] = U, T(R, W, U)));
    const P = Object.entries(q).sort((R, W) => W[1] - R[1]);
    for (const [R] of P.slice(VJ)) {
      delete q[R];
      try {
        p.removeItem(S(R));
      } catch {
      }
    }
    try {
      p.setItem(w(), JSON.stringify({ v: yf, at: U, s: q }));
    } catch {
    }
  }
  function z() {
    var P;
    if (!p) return;
    const U = t(), q = [];
    try {
      for (let R = 0; R < p.length; R++) {
        const W = p.key(R);
        if (!W || !W.startsWith(oc)) continue;
        let N = 0;
        try {
          N = Number((P = JSON.parse(p.getItem(W) ?? "null")) == null ? void 0 : P.at) || 0;
        } catch {
          N = 0;
        }
        U - N > x0 && q.push(W);
      }
      for (const R of q) p.removeItem(R);
    } catch {
    }
  }
  const D = {
    rev: n,
    attach(U, q) {
      if (x) return;
      L();
      const P = U ? JJ(U) : null;
      c !== null && P !== c && a.clear(), c = P, p = P ? e.storage ? e.storage() : ZJ() : null;
      for (const R of ["p", "e"]) m[R] !== void 0 && m[R] !== q[R] && D.sign(R, q[R]);
      if (m = { ...q }, p) {
        z();
        for (const [R, W] of a)
          W.sig = { ...m }, k(R, W), W.dirty = !0;
        C();
      }
      n.value++;
    },
    sign(U, q) {
      if (m[U] !== q) {
        m = { ...m, [U]: q };
        for (const P of a.values()) {
          for (const R of [...P.rows.keys()]) hv(R.slice(0, R.indexOf("|"))) === U && P.rows.delete(R);
          P.sig = { ...m }, P.dirty = !0;
        }
        C(), n.value++;
      }
    },
    peek(U, q) {
      var P;
      return n.value, (P = b(gf(q)).rows.get(`${U}|${q}`)) == null ? void 0 : P[0];
    },
    fresh(U, q) {
      const P = b(gf(q)).rows.get(`${U}|${q}`);
      return !!P && P[2] === l && t() - P[1] < qJ;
    },
    put(U, q, P, R = !0) {
      if (x) return;
      const W = b(gf(q)), N = `${U}|${q}`;
      for (W.rows.delete(N), W.rows.set(N, [P, t(), l, R ? 1 : 0]); W.rows.size > KJ; ) {
        const J = W.rows.keys().next().value;
        if (J === void 0) break;
        W.rows.delete(J);
      }
      R && (W.dirty = !0, C());
    },
    stale() {
      o++, l = `${i}.${o}`, n.value++;
    },
    around(U) {
      const q = gf(U);
      if (!q) return [];
      const P = S0(U), R = `${q}://`, W = pv(P), N = /* @__PURE__ */ new Set([R, P]);
      W !== null && N.add(W);
      const J = [];
      for (const H of b(q).rows.keys()) {
        const ne = H.indexOf("|"), j = H.slice(ne + 1), re = S0(j), he = pv(re);
        (N.has(re) || he !== null && (N.has(he) || pv(he) === P)) && J.push({ q: H.slice(0, ne), path: j });
      }
      return J;
    },
    flush() {
      L();
    },
    forget() {
      v && clearTimeout(v), v = null, a.clear(), c = null, p = null, n.value++;
    },
    dispose() {
      L(), x = !0, Sp.delete(D);
    }
  };
  return Sp.add(D), D;
}
function eZ() {
  for (const e of Sp) e.forget();
  try {
    const e = globalThis.localStorage;
    if (!e) return;
    const t = [];
    for (let n = 0; n < e.length; n++) {
      const a = e.key(n);
      a && a.startsWith(oc) && t.push(a);
    }
    for (const n of t) e.removeItem(n);
  } catch {
  }
}
aU(eZ);
typeof window < "u" && typeof window.addEventListener == "function" && window.addEventListener("pagehide", () => {
  for (const e of Sp) e.flush();
});
function Bf(e) {
  return typeof e == "number" && Number.isFinite(e) && e >= 0 ? e : null;
}
function OT(e) {
  return !!e && !e.unlimited && e.quota_bytes > 0;
}
function tZ(e, t) {
  return !e || OT(e) ? !1 : t.length === 0 || t.some((n) => Bf(n.usedBytes) === null);
}
function nZ(e, t, n) {
  if (!e) return null;
  if (OT(e))
    return { used: Bf(e.used_bytes) ?? 0, total: e.quota_bytes, unlimited: !1, partial: !1 };
  const a = /* @__PURE__ */ new Map();
  for (const m of n ?? []) m && typeof m.name == "string" && a.set(m.name, m);
  const i = t.length ? t : [...a.keys()].map((m) => ({ name: m }));
  let o = 0, l = 0, c = !1;
  const p = /* @__PURE__ */ new Set();
  for (const m of i) {
    if (p.has(m.name)) continue;
    p.add(m.name);
    const v = Bf(m.usedBytes), x = v === null ? a.get(m.name) : void 0, w = v ?? Bf(x == null ? void 0 : x.used_bytes);
    if (w === null) {
      c = !0;
      continue;
    }
    o += w, l++, (v !== null ? m.usedPartial === !0 : PT(x == null ? void 0 : x.coverage) !== null) && (c = !0);
  }
  return !l || o <= 0 ? null : { used: o, total: 0, unlimited: !0, partial: c };
}
const aZ = "custom:", $p = "filex.palette", $0 = "filex.theme", Fa = "default", LT = [
  {
    // Stock palette — the maps duplicate variables.css ONLY for the
    // gallery preview; applying this theme clears all overrides.
    id: Fa,
    nameKey: "theme.name.default",
    light: {
      /* ⚠ Mirrors styles/variables.css exactly — web/tests/api/themeContrast.test.ts
       * fails on any drift. It has drifted before: the stock primary was
       * darkened for contrast and this preview map kept the old blue, so the
       * gallery card advertised a colour the product no longer used. */
      "--fe-bg": "#ffffff",
      "--fe-bg-elev": "#f7f8fb",
      "--fe-bg-hover": "#f3f4f6",
      "--fe-bg-selected": "#eef3ff",
      "--fe-border": "#e5e7eb",
      "--fe-border-soft": "#eef0f4",
      "--fe-border-strong": "#d1d5db",
      "--fe-text": "#1f2937",
      "--fe-text-muted": "#6b7280",
      "--fe-text-on-primary": "#ffffff",
      "--fe-primary": "#2f6ceb",
      "--fe-primary-hover": "#2559c9",
      "--fe-primary-soft": "#e6ecfa",
      "--fe-primary-ink": "#2559c9",
      "--fe-danger": "#dc2626",
      "--fe-danger-hover": "#b91c1c",
      /* The outward-facing pages, as the stock palette defines them (#74):
       * the share page's ground and card (variables.css `.fe.fe-ppage`) and
       * the sign-in page's (`--fe-login-*`, which are the palette's own
       * sunken ground and surface). Optional for every theme - PAGE_TOKENS
       * below. */
      "--fe-ppage-ground-1": "#f5f7fb",
      "--fe-ppage-ground-2": "#e9edf4",
      "--fe-ppage-card": "#ffffff",
      "--fe-login-ground": "#f7f8fb",
      "--fe-login-card": "#ffffff"
    },
    dark: {
      "--fe-bg": "#15171c",
      "--fe-bg-elev": "#1a1d23",
      "--fe-bg-hover": "#1f232a",
      "--fe-bg-selected": "#1c2740",
      "--fe-border": "#2e333c",
      "--fe-border-soft": "#262a32",
      "--fe-border-strong": "#3d444f",
      "--fe-text": "#e6e8ec",
      "--fe-text-muted": "#888f9b",
      /* Dark ink, not white: white on the button measures 3.16 against the 4.5
       * this file claims. Mirrors styles/variables.css. */
      "--fe-text-on-primary": "#15171c",
      "--fe-primary": "#5b8cff",
      "--fe-primary-hover": "#7ba3ff",
      "--fe-primary-soft": "#1c2740",
      "--fe-primary-ink": "#7ba3ff",
      "--fe-danger": "#f87171",
      "--fe-danger-hover": "#ef4444",
      "--fe-ppage-ground-1": "#12151a",
      "--fe-ppage-ground-2": "#191e25",
      "--fe-ppage-card": "#1f242c",
      "--fe-login-ground": "#1a1d23",
      "--fe-login-card": "#15171c"
    }
  },
  {
    // Night Blue — deep indigo/navy.
    id: "night",
    nameKey: "theme.name.night",
    light: {
      "--fe-bg": "#f6f8fd",
      "--fe-bg-elev": "#edf1fa",
      "--fe-bg-hover": "#e2e9f7",
      "--fe-bg-selected": "#d2ddf4",
      "--fe-border": "#d6deee",
      "--fe-border-soft": "#e3e8f4",
      "--fe-border-strong": "#aebfda",
      "--fe-text": "#151f38",
      "--fe-text-muted": "#49587a",
      "--fe-text-on-primary": "#ffffff",
      "--fe-primary": "#2c4a9e",
      "--fe-primary-hover": "#213a80",
      "--fe-primary-soft": "#e0e6f4",
      "--fe-primary-ink": "#213a80",
      "--fe-danger": "#c62828",
      "--fe-danger-hover": "#a51f1f"
    },
    dark: {
      "--fe-bg": "#0a1024",
      "--fe-bg-elev": "#111a35",
      "--fe-bg-hover": "#1a2547",
      "--fe-bg-selected": "#243665",
      "--fe-border": "#26335a",
      "--fe-border-soft": "#1d2748",
      "--fe-border-strong": "#3c4e84",
      "--fe-text": "#dfe6f7",
      "--fe-text-muted": "#96a5cc",
      "--fe-text-on-primary": "#050b26",
      "--fe-primary": "#6d8dfc",
      "--fe-primary-hover": "#5273f2",
      "--fe-primary-soft": "#182243",
      "--fe-primary-ink": "#6d8dfc",
      "--fe-danger": "#f87171",
      "--fe-danger-hover": "#ef4444"
    }
  },
  {
    // Forest — calm greens.
    id: "forest",
    nameKey: "theme.name.forest",
    light: {
      "--fe-bg": "#f5faf5",
      "--fe-bg-elev": "#eaf3eb",
      "--fe-bg-hover": "#dcecdf",
      "--fe-bg-selected": "#c8e2ce",
      "--fe-border": "#d2e2d4",
      "--fe-border-soft": "#e0ece1",
      "--fe-border-strong": "#a2c3a8",
      "--fe-text": "#182b1d",
      "--fe-text-muted": "#42604a",
      "--fe-text-on-primary": "#ffffff",
      "--fe-primary": "#2b7a41",
      "--fe-primary-hover": "#226334",
      "--fe-primary-soft": "#dbe9dc",
      "--fe-primary-ink": "#226334",
      "--fe-danger": "#c62828",
      "--fe-danger-hover": "#a51f1f"
    },
    dark: {
      "--fe-bg": "#0d1611",
      "--fe-bg-elev": "#132019",
      "--fe-bg-hover": "#1b2d23",
      "--fe-bg-selected": "#264532",
      "--fe-border": "#28402f",
      "--fe-border-soft": "#1f3225",
      "--fe-border-strong": "#3e5f49",
      "--fe-text": "#dcebe0",
      "--fe-text-muted": "#93b09b",
      "--fe-text-on-primary": "#04180b",
      "--fe-primary": "#54c17a",
      "--fe-primary-hover": "#3fae66",
      "--fe-primary-soft": "#16291d",
      "--fe-primary-ink": "#54c17a",
      "--fe-danger": "#f87171",
      "--fe-danger-hover": "#ef4444"
    }
  },
  {
    // Amber — warm amber/bronze.
    id: "amber",
    nameKey: "theme.name.amber",
    light: {
      "--fe-bg": "#fdf9f0",
      "--fe-bg-elev": "#f7efdd",
      "--fe-bg-hover": "#f0e3c8",
      "--fe-bg-selected": "#ead6ab",
      "--fe-border": "#e6dabf",
      "--fe-border-soft": "#efe6d3",
      "--fe-border-strong": "#c6b184",
      "--fe-text": "#33270f",
      "--fe-text-muted": "#655631",
      "--fe-text-on-primary": "#ffffff",
      "--fe-primary": "#9a4b00",
      "--fe-primary-hover": "#7c3c00",
      "--fe-primary-soft": "#f3e5d7",
      "--fe-primary-ink": "#7c3c00",
      "--fe-danger": "#c62828",
      "--fe-danger-hover": "#a51f1f"
    },
    dark: {
      "--fe-bg": "#191307",
      "--fe-bg-elev": "#231a0c",
      "--fe-bg-hover": "#2f2312",
      "--fe-bg-selected": "#44331b",
      "--fe-border": "#3b2e17",
      "--fe-border-soft": "#302512",
      "--fe-border-strong": "#5b4a29",
      "--fe-text": "#f2e7d4",
      "--fe-text-muted": "#bda887",
      "--fe-text-on-primary": "#2a1c02",
      "--fe-primary": "#f5a524",
      "--fe-primary-hover": "#ffb84d",
      "--fe-primary-soft": "#31230c",
      "--fe-primary-ink": "#ffb84d",
      "--fe-danger": "#f87171",
      "--fe-danger-hover": "#ef4444"
    }
  },
  {
    // Lilac — soft purple.
    id: "lilac",
    nameKey: "theme.name.lilac",
    light: {
      "--fe-bg": "#faf7fd",
      "--fe-bg-elev": "#f2ecfa",
      "--fe-bg-hover": "#e8ddf5",
      "--fe-bg-selected": "#dccaf0",
      "--fe-border": "#e1d6ee",
      "--fe-border-soft": "#ebe3f4",
      "--fe-border-strong": "#bda6d9",
      "--fe-text": "#241a33",
      "--fe-text-muted": "#584871",
      "--fe-text-on-primary": "#ffffff",
      "--fe-primary": "#7231e0",
      "--fe-primary-hover": "#5f21c4",
      "--fe-primary-soft": "#e9e3fc",
      "--fe-primary-ink": "#5f21c4",
      "--fe-danger": "#c62828",
      "--fe-danger-hover": "#a51f1f"
    },
    dark: {
      "--fe-bg": "#130f1c",
      "--fe-bg-elev": "#1b1527",
      "--fe-bg-hover": "#261d37",
      "--fe-bg-selected": "#37294f",
      "--fe-border": "#302546",
      "--fe-border-soft": "#261e38",
      "--fe-border-strong": "#4b3a6d",
      "--fe-text": "#e9e2f5",
      "--fe-text-muted": "#a999c5",
      "--fe-text-on-primary": "#180d33",
      "--fe-primary": "#b197fa",
      "--fe-primary-hover": "#9c7cf4",
      "--fe-primary-soft": "#272038",
      "--fe-primary-ink": "#b197fa",
      "--fe-danger": "#f87171",
      "--fe-danger-hover": "#ef4444"
    }
  },
  {
    // High Contrast — black/white with strong borders, saturated accents.
    id: "contrast",
    nameKey: "theme.name.contrast",
    light: {
      "--fe-bg": "#ffffff",
      "--fe-bg-elev": "#f2f2f2",
      "--fe-bg-hover": "#e0e0e0",
      "--fe-bg-selected": "#c9dcff",
      "--fe-border": "#5c5c5c",
      "--fe-border-soft": "#5c5c5c",
      "--fe-border-strong": "#000000",
      "--fe-text": "#000000",
      "--fe-text-muted": "#3d3d3d",
      "--fe-text-on-primary": "#ffffff",
      "--fe-primary": "#003d99",
      "--fe-primary-hover": "#002a6b",
      "--fe-primary-soft": "#e7edf7",
      "--fe-primary-ink": "#002a6b",
      "--fe-danger": "#a80000",
      "--fe-danger-hover": "#7d0000",
      "--fe-shadow": "0 0 0 1px #000000, 0 10px 32px rgba(0, 0, 0, 0.25)",
      "--fe-shadow-sm": "0 0 0 1px #000000"
    },
    dark: {
      "--fe-bg": "#000000",
      "--fe-bg-elev": "#0d0d0d",
      "--fe-bg-hover": "#212121",
      "--fe-bg-selected": "#003d80",
      "--fe-border": "#8f8f8f",
      "--fe-border-soft": "#8f8f8f",
      "--fe-border-strong": "#ffffff",
      "--fe-text": "#ffffff",
      "--fe-text-muted": "#d6d6d6",
      "--fe-text-on-primary": "#001430",
      "--fe-primary": "#7ab8ff",
      "--fe-primary-hover": "#9ccaff",
      "--fe-primary-soft": "#0e1a29",
      "--fe-primary-ink": "#9ccaff",
      "--fe-danger": "#ff7575",
      "--fe-danger-hover": "#ff9999",
      "--fe-shadow": "0 0 0 1px #ffffff, 0 12px 32px rgba(0, 0, 0, 0.65)",
      "--fe-shadow-sm": "0 0 0 1px #ffffff"
    }
  },
  {
    // Soft Gray — desaturated, quiet neutral.
    id: "gray",
    nameKey: "theme.name.gray",
    light: {
      "--fe-bg": "#f7f7f8",
      "--fe-bg-elev": "#efeff1",
      "--fe-bg-hover": "#e4e4e7",
      "--fe-bg-selected": "#d6d7db",
      "--fe-border": "#dfdfe2",
      "--fe-border-soft": "#e9e9eb",
      "--fe-border-strong": "#b9b9c0",
      "--fe-text": "#26272b",
      "--fe-text-muted": "#585a63",
      "--fe-text-on-primary": "#ffffff",
      "--fe-primary": "#4b4b54",
      "--fe-primary-hover": "#38383f",
      "--fe-primary-soft": "#e4e4e6",
      "--fe-primary-ink": "#38383f",
      "--fe-danger": "#c62828",
      "--fe-danger-hover": "#a51f1f"
    },
    dark: {
      "--fe-bg": "#131316",
      "--fe-bg-elev": "#1b1b1f",
      "--fe-bg-hover": "#26262b",
      "--fe-bg-selected": "#35353c",
      "--fe-border": "#2d2d33",
      "--fe-border-soft": "#242429",
      "--fe-border-strong": "#4a4a52",
      "--fe-text": "#e6e6e9",
      "--fe-text-muted": "#a4a4ad",
      "--fe-text-on-primary": "#17171b",
      "--fe-primary": "#b0b0ba",
      "--fe-primary-hover": "#c4c4cd",
      "--fe-primary-soft": "#242428",
      "--fe-primary-ink": "#c4c4cd",
      "--fe-danger": "#f87171",
      "--fe-danger-hover": "#ef4444"
    }
  },
  {
    // Terminal Green — phosphor green, monospace face for the full CRT vibe.
    id: "terminal",
    nameKey: "theme.name.terminal",
    light: {
      "--fe-bg": "#f3f9f4",
      "--fe-bg-elev": "#e5f2e8",
      "--fe-bg-hover": "#d5ead9",
      "--fe-bg-selected": "#bce3c6",
      "--fe-border": "#cbe2d1",
      "--fe-border-soft": "#dbebdf",
      "--fe-border-strong": "#94c2a0",
      "--fe-text": "#0c2913",
      "--fe-text-muted": "#31573c",
      "--fe-text-on-primary": "#ffffff",
      "--fe-primary": "#116b33",
      "--fe-primary-hover": "#0c5427",
      "--fe-primary-soft": "#dbe9dd",
      "--fe-primary-ink": "#0c5427",
      "--fe-danger": "#c62828",
      "--fe-danger-hover": "#a51f1f",
      "--fe-font": 'ui-monospace, "SF Mono", Consolas, Menlo, monospace'
    },
    dark: {
      "--fe-bg": "#050d07",
      "--fe-bg-elev": "#0a1710",
      "--fe-bg-hover": "#112418",
      "--fe-bg-selected": "#1a3a26",
      "--fe-border": "#1c3a2a",
      "--fe-border-soft": "#142b1e",
      "--fe-border-strong": "#316144",
      "--fe-text": "#4fdd8b",
      "--fe-text-muted": "#38a668",
      "--fe-text-on-primary": "#03180a",
      "--fe-primary": "#25c95e",
      "--fe-primary-hover": "#4fdd8b",
      "--fe-primary-soft": "#0c2412",
      "--fe-primary-ink": "#4fdd8b",
      "--fe-danger": "#ff6b62",
      "--fe-danger-hover": "#ff8d86",
      "--fe-font": 'ui-monospace, "SF Mono", Consolas, Menlo, monospace'
    }
  }
], sh = $([]);
function Ihe(e) {
  sh.value = Array.isArray(e) ? e : [], Jo.value !== Fa && !ed(Jo.value) && IT(Fa);
}
function Nhe() {
  return { customThemes: sh };
}
function DT() {
  return [...LT, ...sh.value];
}
function ed(e) {
  if (e)
    return LT.find((t) => t.id === e) ?? sh.value.find((t) => t.id === e);
}
function iZ(e, t) {
  return e.name ?? (e.nameKey ? t(e.nameKey) : e.id);
}
function oZ() {
  return Array.from(
    new Set(DT().flatMap((e) => [...Object.keys(e.light), ...Object.keys(e.dark)]))
  );
}
function td(e) {
  return !!e && (!!ed(e) || e.startsWith(aZ));
}
function RT() {
  if (!nr()) return Fa;
  try {
    const e = localStorage.getItem($p);
    if (td(e)) return e;
    const t = localStorage.getItem($0);
    return t && ed(t) ? (localStorage.setItem($p, t), localStorage.removeItem($0), t) : Fa;
  } catch {
    return Fa;
  }
}
const Jo = $(
  typeof window > "u" ? Fa : RT()
);
function rZ(e) {
  const t = td(e) ? e : Fa;
  Jo.value = t;
  try {
    localStorage.setItem($p, t);
  } catch {
  }
  Zi("palette", t);
}
function IT(e) {
  if (!e) return;
  const t = td(e) ? e : Fa;
  Jo.value = t, Gr("palette", t);
}
function Bhe(e) {
  e && td(e) && (Jo.value = e);
}
function sZ() {
  return { themeId: Jo, setTheme: rZ };
}
const Ac = "filex.thememode";
nU(Ac);
const eb = ["host", "auto", "light", "dark"];
function NT() {
  if (!nr()) return "host";
  try {
    const e = localStorage.getItem(Ac);
    return e && eb.includes(e) ? e : "host";
  } catch {
    return "host";
  }
}
const lh = $(
  typeof window > "u" ? "host" : NT()
);
function lZ(e) {
  const t = eb.includes(e) ? e : "host";
  lh.value = t;
  try {
    t === "host" ? localStorage.removeItem(Ac) : localStorage.setItem(Ac, t);
  } catch {
  }
}
function Fhe() {
  Jo.value = RT(), lh.value = NT();
}
function uZ() {
  return { themeMode: lh, setThemeMode: lZ };
}
if (typeof window < "u")
  try {
    window.addEventListener("storage", (e) => {
      if (e.key !== Ac || !nr()) return;
      const t = e.newValue;
      lh.value = t && eb.includes(t) ? t : "host";
    });
  } catch {
  }
if (typeof window < "u")
  try {
    window.addEventListener("storage", (e) => {
      e.key !== $p || !nr() || (Jo.value = td(e.newValue) ? e.newValue : Fa);
    });
  } catch {
  }
function cZ(e, t, n) {
  for (const o of oZ()) e.style.removeProperty(o);
  if (t === Fa) return;
  const a = ed(t);
  if (!a) return;
  const i = n ? a.dark : a.light;
  for (const [o, l] of Object.entries(i)) e.style.setProperty(o, l);
}
const T0 = "data-filex-theme";
function bf(e) {
  return Object.entries(e).map(([t, n]) => `${t}:${n};`).join("");
}
const tb = ["--fe-ppage-ground-1", "--fe-ppage-ground-2", "--fe-ppage-card"], dZ = ["--fe-login-ground", "--fe-login-card"], Uhe = [...tb, ...dZ], fZ = {
  light: {
    "--fe-ppage-ground-1": "color-mix(in srgb, var(--fe-bg) 96%, var(--fe-text))",
    "--fe-ppage-ground-2": "color-mix(in srgb, var(--fe-bg) 90%, var(--fe-text))",
    "--fe-ppage-card": "var(--fe-bg)"
  },
  dark: {
    "--fe-ppage-ground-1": "color-mix(in srgb, var(--fe-bg) 88%, #000000)",
    "--fe-ppage-ground-2": "color-mix(in srgb, var(--fe-bg) 96%, var(--fe-text))",
    "--fe-ppage-card": "color-mix(in srgb, var(--fe-bg) 92%, var(--fe-text))"
  }
};
function A0(e, t) {
  const n = e[t] ?? {}, a = {};
  for (const i of tb) {
    const o = typeof n[i] == "string" ? n[i].trim() : "";
    a[i] = o || fZ[t][i];
  }
  return a;
}
const pZ = new Set(tb);
function E0(e) {
  const t = {};
  for (const [n, a] of Object.entries(e)) pZ.has(n) || (t[n] = a);
  return t;
}
function hZ(e) {
  const t = bf(E0(e.light)), n = bf(E0(e.dark)), a = bf(A0(e, "light")), i = bf(A0(e, "dark")), o = [
    ".fe.fe-ppage.fe--theme-dark",
    ":root[data-theme='dark'] .fe.fe-ppage",
    ":root.dark .fe.fe-ppage",
    ".dark .fe.fe-ppage"
  ].join(","), l = [
    ".fe--theme-dark",
    ":root[data-theme='dark'] .fe",
    ".fe.fe--theme-dark",
    ":root.dark",
    ".dark",
    ":root.dark .fe",
    ".dark .fe",
    ".fe-ctx-backdrop--theme-dark",
    ".fe-ctx-backdrop--theme-auto[data-prefers-dark='1']"
  ].join(","), c = [
    ".fe:not(.fe--theme-light)",
    ".fe-ctx-backdrop--theme-auto:not(.fe-ctx-backdrop--theme-light)"
  ].join(",");
  return `/* filex theme: ${e.id} */:root,.fe{${t}}${l}{${n}}@media (prefers-color-scheme: dark){${c}{${n}}}.fe.fe-ppage{${a}}${o}{${i}}@media (prefers-color-scheme: dark){.fe.fe-ppage:not(.fe--theme-light){${i}}}`;
}
function mZ(e) {
  if (typeof document > "u") return;
  let t = document.head.querySelector(`style[${T0}]`);
  const n = e === Fa ? void 0 : ed(e);
  if (!n) {
    t && (t.textContent = "");
    return;
  }
  t ? t !== document.head.lastElementChild && document.head.appendChild(t) : (t = document.createElement("style"), t.setAttribute(T0, ""), document.head.appendChild(t));
  const a = hZ(n);
  t.textContent !== a && (t.textContent = a);
}
const vZ = {
  key: 0,
  class: "fe-themes__hint"
}, yZ = ["aria-label"], gZ = ["aria-selected", "data-theme-id", "onClick"], bZ = { class: "fe-themecard__name" }, kZ = ["title"], wZ = /* @__PURE__ */ lt({
  __name: "ThemePalette",
  props: {
    locale: {},
    dark: { type: Boolean },
    current: {},
    hint: { type: Boolean }
  },
  emits: ["select"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = pt(() => n.locale);
    function o(l) {
      return n.dark ? l.dark : l.light;
    }
    return (l, c) => (f(), h(Te, null, [
      e.hint !== !1 ? (f(), h("p", vZ, y(u(i)("theme.hint")), 1)) : O("", !0),
      d("div", {
        class: "fe-themes",
        role: "listbox",
        "aria-label": u(i)("theme.title")
      }, [
        (f(!0), h(Te, null, nt(u(DT)(), (p) => (f(), h("button", {
          key: p.id,
          type: "button",
          class: Re(["fe-themecard", { "is-selected": p.id === e.current }]),
          role: "option",
          "aria-selected": p.id === e.current,
          "data-theme-id": p.id,
          style: Wt(o(p)),
          onClick: (m) => a("select", p.id)
        }, [
          c[0] || (c[0] = g2('<span class="fe-themecard__preview" aria-hidden="true"><span class="fe-themecard__topbar"><span class="fe-themecard__chip fe-themecard__chip--primary"></span><span class="fe-themecard__chip"></span><span class="fe-themecard__chip fe-themecard__chip--ghost"></span></span><span class="fe-themecard__row"><span class="fe-themecard__dot"></span><span class="fe-themecard__line" style="width:62%;"></span></span><span class="fe-themecard__row fe-themecard__row--selected"><span class="fe-themecard__dot fe-themecard__dot--primary"></span><span class="fe-themecard__line" style="width:44%;"></span></span><span class="fe-themecard__row"><span class="fe-themecard__dot fe-themecard__dot--muted"></span><span class="fe-themecard__line fe-themecard__line--muted" style="width:74%;"></span></span></span>', 1)),
          d("span", bZ, [
            Ht(y(u(iZ)(p, u(i))) + " ", 1),
            p.id === e.current ? (f(), h("span", {
              key: 0,
              class: "fe-themecard__check",
              title: u(i)("theme.selected")
            }, "✓", 8, kZ)) : O("", !0)
          ])
        ], 14, gZ))), 128))
      ], 8, yZ)
    ], 64));
  }
}), _Z = ["aria-label"], xZ = { class: "fe-thememode__label" }, SZ = { class: "fe-thememode__seg" }, $Z = ["aria-pressed", "onClick"], TZ = {
  class: "fe-ficon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true",
  focusable: "false"
}, AZ = {
  key: 1,
  d: "M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z"
}, EZ = ["disabled"], CZ = /* @__PURE__ */ lt({
  __name: "ThemeGallery",
  props: {
    open: { type: Boolean },
    locale: {},
    theme: {},
    dark: { type: Boolean },
    current: {},
    mode: {},
    hostMode: {}
  },
  emits: ["close", "select", "mode"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = pt(() => n.locale), o = [
      { id: "light", labelKey: "theme.mode.light" },
      { id: "dark", labelKey: "theme.mode.dark" },
      { id: "auto", labelKey: "theme.mode.auto" }
    ], l = E(() => n.mode === "host" ? n.hostMode : n.mode), c = Fa;
    return (p, m) => (f(), Ge(ta, {
      open: e.open,
      title: u(i)("theme.title"),
      size: "lg",
      theme: e.theme,
      onClose: m[3] || (m[3] = (v) => a("close"))
    }, {
      actions: mt(() => [
        d("button", {
          type: "button",
          class: "fe-btn",
          disabled: e.current === u(c),
          onClick: m[1] || (m[1] = (v) => a("select", u(c)))
        }, y(u(i)("theme.reset")), 9, EZ),
        d("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          onClick: m[2] || (m[2] = (v) => a("close"))
        }, y(u(i)("theme.close")), 1)
      ]),
      default: mt(() => [
        d("div", {
          class: "fe-thememode",
          role: "group",
          "aria-label": u(i)("theme.mode.label")
        }, [
          d("span", xZ, y(u(i)("theme.mode.label")), 1),
          d("div", SZ, [
            (f(), h(Te, null, nt(o, (v) => d("button", {
              key: v.id,
              type: "button",
              class: Re(["fe-thememode__opt", { "is-active": l.value === v.id }]),
              "aria-pressed": l.value === v.id,
              onClick: (x) => a("mode", v.id)
            }, [
              (f(), h("svg", TZ, [
                v.id === "light" ? (f(), h(Te, { key: 0 }, [
                  m[4] || (m[4] = d("circle", {
                    cx: "12",
                    cy: "12",
                    r: "4"
                  }, null, -1)),
                  m[5] || (m[5] = d("path", { d: "M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" }, null, -1))
                ], 64)) : v.id === "dark" ? (f(), h("path", AZ)) : (f(), h(Te, { key: 2 }, [
                  m[6] || (m[6] = d("circle", {
                    cx: "12",
                    cy: "12",
                    r: "9"
                  }, null, -1)),
                  m[7] || (m[7] = d("path", {
                    d: "M12 3a9 9 0 0 1 0 18z",
                    fill: "currentColor",
                    stroke: "none"
                  }, null, -1))
                ], 64))
              ])),
              d("span", null, y(u(i)(v.labelKey)), 1)
            ], 10, $Z)), 64))
          ])
        ], 8, _Z),
        Ze(wZ, {
          locale: e.locale,
          dark: e.dark,
          current: e.current,
          onSelect: m[0] || (m[0] = (v) => a("select", v))
        }, null, 8, ["locale", "dark", "current"])
      ]),
      _: 1
    }, 8, ["open", "title", "theme"]));
  }
}), BT = "filex.density";
function zZ(e) {
  if (!(e !== "comfortable" && e !== "compact")) {
    Gr("density", e);
    try {
      window.dispatchEvent(new CustomEvent("filex:density", { detail: e }));
    } catch {
    }
  }
}
function Hhe() {
  try {
    return localStorage.getItem(BT) === "compact" ? "compact" : "comfortable";
  } catch {
    return "comfortable";
  }
}
function Khe(e) {
  try {
    localStorage.setItem(BT, e);
  } catch {
  }
  Zi("density", e);
  try {
    window.dispatchEvent(new CustomEvent("filex:density", { detail: e }));
  } catch {
  }
}
function MZ(e) {
  const t = Symbol("filex-explorer");
  Wo(nx, t), Je(
    () => e.config().timeZone,
    (i) => gO(t, i),
    { immediate: !0 }
  );
  const n = () => {
    var i;
    return e.config().callerKind ?? ((i = e.capabilities.value) == null ? void 0 : i.caller_kind);
  };
  let a = !1;
  return Je(
    n,
    (i) => {
      if (i !== "user") {
        Sf(t, null);
        return;
      }
      a || (a = !0, e.fetchMe().then((o) => {
        var c;
        if (n() !== "user") return;
        const l = (c = o == null ? void 0 : o.user) == null ? void 0 : c.timezone;
        Sf(t, typeof l == "string" ? l : null);
      }).catch(() => Sf(t, null)));
    },
    { immediate: !0 }
  ), Tt(() => wO(t)), t;
}
const PZ = ["aria-label"], OZ = { class: "fe-opc__head" }, LZ = ["aria-label"], DZ = { class: "fe-opc__body" }, RZ = {
  key: 0,
  class: "fe-opc__section",
  "aria-live": "polite"
}, IZ = { class: "fe-opc__section-title" }, NZ = { class: "fe-opc__list" }, BZ = {
  class: "fe-opc__kicon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true",
  focusable: "false"
}, FZ = ["d"], UZ = { class: "fe-opc__mid" }, HZ = ["title"], KZ = { class: "fe-opc__sub" }, VZ = { class: "fe-opc__kind" }, jZ = ["title"], qZ = { class: "fe-opc__state" }, WZ = {
  key: 0,
  class: "fe-opc__sub fe-opc__sub--detail",
  "data-testid": "opc-error-detail"
}, YZ = ["aria-valuenow"], GZ = {
  key: 0,
  class: "fe-opc__spin",
  "aria-hidden": "true"
}, XZ = { class: "fe-opc__acts" }, JZ = ["onClick"], ZZ = ["onClick"], QZ = ["onClick"], eQ = ["aria-label", "onClick"], tQ = {
  key: 1,
  class: "fe-opc__section"
}, nQ = { class: "fe-opc__section-title" }, aQ = { class: "fe-opc__list fe-opc__list--history" }, iQ = {
  class: "fe-opc__kicon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true",
  focusable: "false"
}, oQ = ["d"], rQ = { class: "fe-opc__mid" }, sQ = ["title"], lQ = {
  key: 0,
  class: "fe-opc__sub"
}, uQ = ["title"], cQ = {
  key: 1,
  class: "fe-opc__sub fe-opc__sub--err"
}, dQ = {
  key: 2,
  class: "fe-opc__sub fe-opc__sub--detail",
  "data-testid": "opc-error-detail"
}, fQ = ["onClick"], pQ = {
  key: 2,
  class: "fe-opc__empty"
}, hQ = ["aria-expanded", "aria-label"], mQ = ["stroke-dashoffset"], vQ = { class: "fe-opc__count" }, yQ = {
  key: 0,
  class: "fe-opc__pct"
}, mv = 8.5, gQ = /* @__PURE__ */ lt({
  __name: "OperationsCenter",
  props: {
    center: {},
    locale: {},
    narrow: { type: Boolean }
  },
  setup(e) {
    const t = e, { t: n, formatSize: a } = pt(() => t.locale), i = $(!1), o = $(null), l = E(() => t.center.active.value), c = E(() => t.center.history.value), p = E(() => t.center.hasError.value), m = E(() => t.center.overallPercent.value), v = E(() => t.center.runningCount.value), x = E(() => l.value.length > 0 || i.value && c.value.length > 0);
    Je(x, (N) => {
      N || (i.value = !1);
    }), Je(
      () => {
        var N;
        return ((N = t.center.revealRequests) == null ? void 0 : N.value) ?? 0;
      },
      (N, J) => {
        N > J && (i.value = !0);
      }
    );
    const w = 2 * Math.PI * mv, S = E(() => {
      const N = m.value;
      return N === null ? w * 0.72 : w * (1 - Math.min(100, Math.max(0, N)) / 100);
    }), k = E(() => m.value === null && v.value > 0), b = E(() => v.value === 0 || m.value === null ? "" : n("opc.percent", { n: m.value })), C = E(() => n("opc.aria_badge", { n: l.value.length })), T = {
      upload: "M12 16V5M7 9.5 12 5l5 4.5M5 19h14",
      copy: "M9 9h11v11H9zM5 15V4h11",
      move: "M4 12h13M12 6l6 6-6 6",
      delete: "M5 7h14M9 7V5h6v2M8 7l1 13h6l1-13",
      /* A folder given a new name, and one brought back from the trash. */
      rename: "M4 20h4L18.5 9.5l-4-4L4 16zM13 7l4 4",
      restore: "M9 14 4 9l5-5M4 9h10.5a5.5 5.5 0 0 1 0 11H11",
      /* A trash entry taken out for good: the bin, crossed. */
      purge: "M5 7h14M9 7V5h6v2M8 7l1 13h6l1-13M10 11l4 5M14 11l-4 5",
      convert: "M20 8A8 8 0 0 0 6 6L4 8M4 16a8 8 0 0 0 14 2l2-2M20 3v5h-5M4 21v-5h5",
      archive: "M4 8V5h16v3zM5 8h14v12H5zM10 12h4",
      /* "Empty the trash" — the bin, with the lines of what is going. */
      trash: "M5 7h14M9 7V5h6v2M8 7l1 13h6l1-13M10.5 11v5M13.5 11v5",
      /* "Repair thumbnails" (Admin → Tools): a picture, its frame and its hill. */
      thumbs: "M4 5h16v14H4zM4 16l5-5 4 4 3-3 4 4M15 9.5h.01",
      /* An app-plugin job — the puzzle piece its menu row wears (lib/actionIcons). */
      plugin: "M9.5 4.5a2 2 0 1 1 4 0h3a1.5 1.5 0 0 1 1.5 1.5v3a2 2 0 1 1 0 4v3a1.5 1.5 0 0 1-1.5 1.5h-3a2 2 0 1 1-4 0h-3A1.5 1.5 0 0 1 5 16v-3a2 2 0 1 1 0-4V6a1.5 1.5 0 0 1 1.5-1.5z",
      "archive-create": "M4 8V5h16v3zM5 8h14v12H5zM10 12h4",
      "archive-extract": "M4 8V5h16v3zM5 8h14v12H5zM10 12h4"
    };
    function A(N) {
      return n(`opc.kind.${N.kind}`);
    }
    function L(N) {
      return N.name || A(N);
    }
    function z(N) {
      return N.outputMode === "sibling" ? n("plugin.output.sibling") : N.outputMode === "version" ? n("plugin.output.version") : "";
    }
    function D(N) {
      return N.outputMode === "sibling" ? n("plugin.output.sibling_title") : N.outputMode === "version" ? n("plugin.output.version_title") : "";
    }
    function U(N) {
      return N.status === "running" ? N.cancelling ? n("opc.cancelling") : N.queued ? N.waitText || n("opc.queued") : N.message ? N.message : N.totalBytes && N.totalBytes > 0 ? `${a(N.uploadedBytes ?? 0)} / ${a(N.totalBytes)}` : (N.kind === "archive-create" || N.kind === "archive-extract") && N.percent !== null ? n("opc.percent", { n: N.percent }) : N.itemsTotal && N.itemsTotal > 0 ? n("opc.items", { done: N.itemsDone ?? 0, total: N.itemsTotal }) : N.percent !== null && N.totalCount && N.totalCount > 1 ? `${N.doneCount ?? 0}/${N.totalCount}` : n("opc.status.running") : N.status === "done" ? N.message || n("opc.status.done") : N.status === "aborted" ? n("opc.status.aborted") : N.error || n("opc.status.error");
    }
    function q(N) {
      return N.status === "done" && N.outputs.length > 0;
    }
    function P(N) {
      return n(`opc.status.${N.status === "running" ? "running" : N.status}`);
    }
    function R(N) {
      if (!i.value) return;
      const J = o.value;
      J && N.target instanceof Node && !J.contains(N.target) && (i.value = !1);
    }
    function W(N) {
      i.value && N.key === "Escape" && (i.value = !1);
    }
    return jt(() => {
      document.addEventListener("mousedown", R), document.addEventListener("keydown", W);
    }), Tt(() => {
      document.removeEventListener("mousedown", R), document.removeEventListener("keydown", W);
    }), (N, J) => x.value ? (f(), h("div", {
      key: 0,
      ref_key: "rootEl",
      ref: o,
      class: Re(["fe-opc", { "fe-opc--narrow": e.narrow, "fe-opc--open": i.value }])
    }, [
      Ze(Rr, { name: "fe-opc-pop" }, {
        default: mt(() => [
          i.value ? (f(), h("section", {
            key: 0,
            class: "fe-opc__panel",
            role: "dialog",
            "aria-label": u(n)("opc.title")
          }, [
            d("header", OZ, [
              d("strong", null, y(u(n)("opc.title")), 1),
              d("button", {
                type: "button",
                class: "fe-opc__x",
                "aria-label": u(n)("opc.close"),
                onClick: J[0] || (J[0] = (H) => i.value = !1)
              }, "×", 8, LZ)
            ]),
            d("div", DZ, [
              l.value.length > 0 ? (f(), h("div", RZ, [
                d("h3", IZ, y(u(n)("opc.active")), 1),
                d("ul", NZ, [
                  (f(!0), h(Te, null, nt(l.value, (H) => (f(), h("li", {
                    key: H.key,
                    class: Re(["fe-opc__item", `is-${H.status}`])
                  }, [
                    (f(), h("svg", BZ, [
                      d("path", {
                        d: T[H.kind]
                      }, null, 8, FZ)
                    ])),
                    d("div", UZ, [
                      d("div", {
                        class: "fe-opc__name",
                        title: L(H)
                      }, y(L(H)), 9, HZ),
                      d("div", KZ, [
                        d("span", VZ, y(A(H)), 1),
                        z(H) ? (f(), h(Te, { key: 0 }, [
                          J[3] || (J[3] = d("span", {
                            class: "fe-opc__dot",
                            "aria-hidden": "true"
                          }, "·", -1)),
                          d("span", {
                            class: "fe-opc__outmode",
                            title: D(H),
                            "data-testid": "opc-output-mode"
                          }, y(z(H)), 9, jZ)
                        ], 64)) : O("", !0),
                        J[4] || (J[4] = d("span", {
                          class: "fe-opc__dot",
                          "aria-hidden": "true"
                        }, "·", -1)),
                        d("span", qZ, y(U(H)), 1)
                      ]),
                      H.status === "error" && H.errorDetail ? (f(), h("div", WZ, y(H.errorDetail), 1)) : O("", !0),
                      H.status === "running" && H.percent !== null ? (f(), h("div", {
                        key: 1,
                        class: "fe-opc__bar",
                        role: "progressbar",
                        "aria-valuenow": H.percent,
                        "aria-valuemin": "0",
                        "aria-valuemax": "100"
                      }, [
                        d("div", {
                          class: "fe-opc__bar-fill",
                          style: Wt({ width: H.percent + "%" })
                        }, null, 4)
                      ], 8, YZ)) : O("", !0)
                    ]),
                    H.status === "running" && H.percent === null && !H.queued ? (f(), h("span", GZ)) : O("", !0),
                    d("div", XZ, [
                      H.status === "running" && H.cancellable ? (f(), h("button", {
                        key: 0,
                        type: "button",
                        class: "fe-opc__act",
                        onClick: (ne) => e.center.cancel(H.key)
                      }, y(u(n)("opc.cancel")), 9, JZ)) : O("", !0),
                      q(H) ? (f(), h("button", {
                        key: 1,
                        type: "button",
                        class: "fe-opc__act",
                        "data-testid": "opc-open",
                        onClick: (ne) => e.center.open(H.key)
                      }, y(u(n)("opc.open")), 9, ZZ)) : O("", !0),
                      H.status === "error" && H.retryable ? (f(), h("button", {
                        key: 2,
                        type: "button",
                        class: "fe-opc__act fe-opc__act--retry",
                        onClick: (ne) => e.center.retry(H.key)
                      }, y(u(n)("opc.retry")), 9, QZ)) : O("", !0),
                      H.status !== "running" ? (f(), h("button", {
                        key: 3,
                        type: "button",
                        class: "fe-opc__x",
                        "aria-label": u(n)("opc.dismiss"),
                        onClick: (ne) => e.center.dismiss(H.key)
                      }, "×", 8, eQ)) : O("", !0)
                    ])
                  ], 2))), 128))
                ])
              ])) : O("", !0),
              c.value.length > 0 ? (f(), h("div", tQ, [
                d("h3", nQ, [
                  Ht(y(u(n)("opc.history")) + " ", 1),
                  d("button", {
                    type: "button",
                    class: "fe-opc__act",
                    onClick: J[1] || (J[1] = (H) => e.center.clearHistory())
                  }, y(u(n)("opc.clear")), 1)
                ]),
                d("ul", aQ, [
                  (f(!0), h(Te, null, nt(c.value, (H) => (f(), h("li", {
                    key: "h-" + H.key,
                    class: Re(["fe-opc__item fe-opc__item--history", `is-${H.status}`])
                  }, [
                    (f(), h("svg", iQ, [
                      d("path", {
                        d: T[H.kind]
                      }, null, 8, oQ)
                    ])),
                    d("div", rQ, [
                      d("div", {
                        class: "fe-opc__name",
                        title: L(H)
                      }, y(L(H)), 9, sQ),
                      z(H) ? (f(), h("div", lQ, [
                        d("span", {
                          class: "fe-opc__outmode",
                          title: D(H),
                          "data-testid": "opc-output-mode"
                        }, y(z(H)), 9, uQ)
                      ])) : O("", !0),
                      H.status === "error" && H.error ? (f(), h("div", cQ, y(H.error), 1)) : O("", !0),
                      H.status === "error" && H.errorDetail ? (f(), h("div", dQ, y(H.errorDetail), 1)) : O("", !0)
                    ]),
                    q(H) ? (f(), h("button", {
                      key: 0,
                      type: "button",
                      class: "fe-opc__act",
                      onClick: (ne) => e.center.open(H.key)
                    }, y(u(n)("opc.open")), 9, fQ)) : O("", !0),
                    d("span", {
                      class: Re(["fe-opc__chip", `is-${H.status}`])
                    }, y(P(H)), 3)
                  ], 2))), 128))
                ])
              ])) : O("", !0),
              l.value.length === 0 && c.value.length === 0 ? (f(), h("p", pQ, y(u(n)("opc.empty")), 1)) : O("", !0)
            ])
          ], 8, PZ)) : O("", !0)
        ]),
        _: 1
      }),
      d("button", {
        type: "button",
        class: Re(["fe-opc__badge", { "is-error": p.value }]),
        "aria-expanded": i.value,
        "aria-label": C.value,
        onClick: J[2] || (J[2] = (H) => i.value = !i.value)
      }, [
        (f(), h("svg", {
          class: Re(["fe-opc__ring", { "fe-opc__ring--spin": k.value }]),
          viewBox: "0 0 22 22",
          "aria-hidden": "true",
          focusable: "false"
        }, [
          d("circle", {
            class: "fe-opc__ring-track",
            cx: "11",
            cy: "11",
            r: mv,
            fill: "none",
            "stroke-width": "2.5"
          }),
          d("circle", {
            class: "fe-opc__ring-fill",
            cx: "11",
            cy: "11",
            r: mv,
            fill: "none",
            "stroke-width": "2.5",
            "stroke-linecap": "round",
            "stroke-dasharray": w,
            "stroke-dashoffset": S.value,
            transform: "rotate(-90 11 11)"
          }, null, 8, mQ)
        ], 2)),
        d("span", vQ, y(l.value.length), 1),
        b.value ? (f(), h("span", yQ, y(b.value), 1)) : O("", !0)
      ], 10, hQ)
    ], 2)) : O("", !0);
  }
}), bQ = 4e3, C0 = 50;
function kQ(e, t, n) {
  const a = t.status !== "running";
  return {
    key: e,
    kind: t.kind,
    name: t.name,
    percent: t.percent,
    status: t.status,
    error: t.error ?? null,
    errorDetail: t.errorDetail ?? null,
    queued: t.queued ?? !1,
    waitText: t.waitText ?? null,
    cancelling: t.cancelling ?? !1,
    doneCount: t.doneCount ?? null,
    totalCount: t.totalCount ?? null,
    itemsDone: t.itemsDone ?? null,
    itemsTotal: t.itemsTotal ?? null,
    uploadedBytes: t.uploadedBytes ?? null,
    totalBytes: t.totalBytes ?? null,
    cancellable: t.cancellable ?? !1,
    retryable: t.retryable ?? !1,
    message: t.message ?? null,
    outputs: t.outputs ?? [],
    outputMode: t.outputMode ?? null,
    startedAt: (n == null ? void 0 : n.startedAt) ?? Date.now(),
    settledAt: (n == null ? void 0 : n.settledAt) ?? (a ? Date.now() : null)
  };
}
function wQ() {
  const e = $([]), t = $([]), n = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Set(), i = /* @__PURE__ */ new Map();
  function o(z) {
    const D = i.get(z);
    D !== void 0 && (clearTimeout(D), i.delete(z));
  }
  function l(z, D = {}) {
    o(z);
    const U = e.value.findIndex((P) => P.key === z);
    if (U === -1) return;
    const [q] = e.value.splice(U, 1);
    e.value = [...e.value], a.add(z), D.toHistory !== !1 && (t.value = [{ ...q, settledAt: q.settledAt ?? Date.now() }, ...t.value].slice(
      0,
      C0
    ));
  }
  function c(z) {
    i.has(z) || i.set(
      z,
      setTimeout(() => {
        var U;
        i.delete(z);
        const D = n.get(z);
        l(z), (U = D == null ? void 0 : D.dismiss) == null || U.call(D);
      }, bQ)
    );
  }
  function p(z, D) {
    const U = `${z}:`, q = /* @__PURE__ */ new Set();
    let P = [...e.value], R = !1;
    for (const W of D) {
      const N = `${z}:${W.input.id}`;
      if (q.add(N), W.actions && n.set(N, W.actions), a.has(N)) continue;
      const J = P.findIndex((ne) => ne.key === N), H = kQ(N, W.input, J === -1 ? void 0 : P[J]);
      J === -1 ? (P = [H, ...P], R = !0) : JSON.stringify(P[J]) !== JSON.stringify(H) && (P[J] = H, R = !0), (H.status === "done" || H.status === "aborted") && c(N);
    }
    for (const W of [...P])
      !W.key.startsWith(U) || q.has(W.key) || W.status !== "error" && (o(W.key), P = P.filter((N) => N.key !== W.key), R = !0, W.status !== "running" && (a.add(W.key), t.value = [{ ...W, settledAt: W.settledAt ?? Date.now() }, ...t.value].slice(
        0,
        C0
      )));
    for (const W of [...a])
      W.startsWith(U) && !q.has(W) && a.delete(W);
    for (const W of [...n.keys()])
      if (W.startsWith(U) && !q.has(W) && !e.value.some((N) => N.key === W)) {
        if (P.some((N) => N.key === W) || t.value.some((N) => N.key === W && N.outputs.length > 0)) continue;
        n.delete(W);
      }
    R && (e.value = P);
  }
  function m(z) {
    var D, U;
    (U = (D = n.get(z)) == null ? void 0 : D.cancel) == null || U.call(D);
  }
  function v(z) {
    var U, q;
    const D = n.get(z);
    l(z), (U = D == null ? void 0 : D.dismiss) == null || U.call(D), (q = D == null ? void 0 : D.retry) == null || q.call(D);
  }
  function x(z) {
    var U;
    const D = n.get(z);
    l(z), (U = D == null ? void 0 : D.dismiss) == null || U.call(D);
  }
  function w(z, D) {
    var P, R;
    const U = e.value.find((W) => W.key === z) ?? t.value.find((W) => W.key === z), q = D ?? (U == null ? void 0 : U.outputs[0]);
    q && ((R = (P = n.get(z)) == null ? void 0 : P.open) == null || R.call(P, q));
  }
  function S() {
    t.value = [];
  }
  const k = $(0);
  function b() {
    k.value += 1;
  }
  const C = E(
    () => e.value.filter((z) => z.status === "running").length
  ), T = E(() => e.value.filter((z) => z.status === "error").length), A = E(() => T.value > 0), L = E(() => {
    const z = e.value.filter((q) => q.status === "running");
    let D = 0, U = 0;
    for (const q of z)
      q.percent !== null && (D += Math.min(1, Math.max(0, q.percent / 100)), U += 1);
    return U === 0 ? null : Math.round(D / U * 100);
  });
  return y2() && Oy(() => {
    for (const z of i.values()) clearTimeout(z);
    i.clear();
  }), {
    active: e,
    history: t,
    runningCount: C,
    errorCount: T,
    hasError: A,
    overallPercent: L,
    sync: p,
    cancel: m,
    retry: v,
    dismiss: x,
    open: w,
    clearHistory: S,
    revealRequests: k,
    reveal: b
  };
}
const FT = "filex.tourDone", z0 = "done", _Q = 900, xQ = 5e3;
function SQ() {
  try {
    return !!localStorage.getItem(FT);
  } catch {
    return !0;
  }
}
function vv() {
  return SQ() || !!Qi().tour;
}
let Dr = null;
function UT() {
  try {
    localStorage.setItem(FT, "1");
  } catch {
  }
  if (!Fl()) return;
  if (L$()) {
    Qi().tour || Zi("tour", z0);
    return;
  }
  if (Dr) return;
  const e = Jc((t) => {
    e(), Dr = null, t.tour || Zi("tour", z0);
  });
  Dr = e;
}
function $Q(e, t = {}) {
  const n = t.delayMs ?? _Q, a = t.accountWaitMs ?? xQ;
  let i = !1, o, l, c;
  const p = () => {
    i = !0, o && clearTimeout(o), l && clearTimeout(l), c == null || c();
  };
  if (vv()) return p;
  const m = () => {
    l && clearTimeout(l), c == null || c(), !(i || vv()) && (UT(), e());
  };
  return o = setTimeout(() => {
    if (!(i || vv())) {
      if (!Fl() || oU()) {
        m();
        return;
      }
      l = setTimeout(m, a), c = rU(m);
    }
  }, n), p;
}
function Vhe() {
  Dr == null || Dr(), Dr = null;
}
const TQ = ["aria-label"], AQ = {
  key: 0,
  class: "fe-tabs__scroll"
}, EQ = ["aria-selected", "title", "onClick", "onKeydown", "onAuxclick", "onDragstart", "onDragover", "onDragleave", "onDrop"], CQ = {
  key: 0,
  class: "fe-tabs__splitdot",
  "aria-hidden": "true"
}, zQ = { class: "fe-tabs__label" }, MQ = ["aria-label", "title", "onClick"], PQ = ["aria-label", "title"], OQ = ["aria-label", "title", "aria-pressed"], LQ = ["aria-pressed", "title", "aria-label"], DQ = /* @__PURE__ */ lt({
  __name: "TabBar",
  props: {
    tabs: {},
    activeId: {},
    locale: {},
    splitEnabled: { type: Boolean },
    splitActive: { type: Boolean },
    inspectorEnabled: { type: Boolean },
    inspectorOpen: { type: Boolean },
    hideTabs: { type: Boolean }
  },
  emits: ["select", "close", "new", "reorder", "toggle-split", "toggle-inspector"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = pt(() => n.locale), o = $(null), l = $(null);
    function c(k, b) {
      var C;
      o.value = k, b.dataTransfer && (b.dataTransfer.effectAllowed = "move", b.dataTransfer.setData("text/plain", ((C = n.tabs[k]) == null ? void 0 : C.id) ?? ""));
    }
    function p(k, b) {
      o.value !== null && (b.preventDefault(), b.stopPropagation(), b.dataTransfer && (b.dataTransfer.dropEffect = "move"), l.value = k);
    }
    function m(k) {
      l.value === k && (l.value = null);
    }
    function v(k, b) {
      o.value !== null && (b.preventDefault(), b.stopPropagation(), o.value !== k && a("reorder", o.value, k), o.value = null, l.value = null);
    }
    function x() {
      o.value = null, l.value = null;
    }
    function w(k) {
      k.button === 1 && k.preventDefault();
    }
    function S(k, b) {
      b.button === 1 && (b.preventDefault(), b.stopPropagation(), !(n.tabs.length <= 1) && a("close", k));
    }
    return (k, b) => (f(), h("div", {
      class: "fe-tabs",
      role: "tablist",
      "aria-label": u(i)("tabs.strip")
    }, [
      e.hideTabs ? O("", !0) : (f(), h("div", AQ, [
        (f(!0), h(Te, null, nt(e.tabs, (C, T) => (f(), h("div", {
          key: C.id,
          class: Re(["fe-tabs__tab", {
            "is-active": C.id === e.activeId,
            "is-dragover": l.value === T && o.value !== null && o.value !== T
          }]),
          role: "tab",
          "aria-selected": C.id === e.activeId ? "true" : "false",
          tabindex: "0",
          draggable: "true",
          title: C.label,
          onClick: (A) => a("select", C.id),
          onKeydown: Ca(yt((A) => a("select", C.id), ["prevent"]), ["enter"]),
          onMousedown: b[0] || (b[0] = (A) => w(A)),
          onAuxclick: (A) => S(C.id, A),
          onDragstart: (A) => c(T, A),
          onDragover: (A) => p(T, A),
          onDragleave: (A) => m(T),
          onDrop: (A) => v(T, A),
          onDragend: x
        }, [
          C.split ? (f(), h("span", CQ)) : O("", !0),
          d("span", zQ, [
            d("bdi", null, y(C.label), 1)
          ]),
          e.tabs.length > 1 ? (f(), h("button", {
            key: 1,
            type: "button",
            class: "fe-tabs__close",
            "aria-label": u(i)("tabs.close"),
            title: u(i)("tabs.close"),
            onClick: yt((A) => a("close", C.id), ["stop"])
          }, "×", 8, MQ)) : O("", !0)
        ], 42, EQ))), 128))
      ])),
      e.hideTabs ? O("", !0) : (f(), h("button", {
        key: 1,
        type: "button",
        class: "fe-tabs__new",
        "aria-label": u(i)("tabs.new"),
        title: u(i)("tabs.new"),
        onClick: b[1] || (b[1] = (C) => a("new"))
      }, "+", 8, PQ)),
      e.splitEnabled !== !1 ? (f(), h("button", {
        key: 2,
        type: "button",
        class: Re(["fe-tabs__split", { "is-active": e.splitActive }]),
        "aria-label": e.splitActive ? u(i)("tabs.split_off") : u(i)("tabs.split"),
        title: e.splitActive ? u(i)("tabs.split_off") : u(i)("tabs.split"),
        "aria-pressed": e.splitActive ? "true" : "false",
        "data-testid": "tabs-split",
        onClick: b[2] || (b[2] = (C) => a("toggle-split"))
      }, [...b[4] || (b[4] = [
        d("svg", {
          class: "fe-ficon",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "1.8",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "aria-hidden": "true",
          focusable: "false"
        }, [
          d("rect", {
            x: "3",
            y: "4",
            width: "18",
            height: "16",
            rx: "2"
          }),
          d("path", { d: "M12 4v16" })
        ], -1)
      ])], 10, OQ)) : O("", !0),
      e.inspectorEnabled ? (f(), h("button", {
        key: 3,
        type: "button",
        class: Re(["fe-tabs__inspector", { "is-active": e.inspectorOpen }]),
        "aria-pressed": e.inspectorOpen ? "true" : "false",
        title: u(i)("toolbar.inspector"),
        "aria-label": u(i)("toolbar.inspector"),
        "data-testid": "tabs-inspector",
        onClick: b[3] || (b[3] = (C) => a("toggle-inspector"))
      }, [...b[5] || (b[5] = [
        d("svg", {
          class: "fe-ficon",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "1.8",
          "stroke-linecap": "round",
          "aria-hidden": "true",
          focusable: "false"
        }, [
          d("circle", {
            cx: "12",
            cy: "12",
            r: "9"
          }),
          d("path", { d: "M12 11v5" }),
          d("circle", {
            cx: "12",
            cy: "7.6",
            r: "1",
            fill: "currentColor",
            stroke: "none"
          })
        ], -1)
      ])], 10, LQ)) : O("", !0)
    ], 8, TQ));
  }
}), HT = Symbol("filex.e2eLock"), RQ = ["width", "height"], IQ = { class: "fe-state__title" }, NQ = { class: "fe-state__hint" }, BQ = ["placeholder", "aria-label", "disabled"], FQ = ["disabled"], UQ = {
  key: 0,
  class: "fe-form__error",
  role: "alert"
}, KT = /* @__PURE__ */ lt({
  __name: "E2eLockScreen",
  props: {
    locale: {},
    busy: { type: Boolean, default: !1 },
    error: { default: "" },
    showRecovery: { type: Boolean, default: !0 },
    compact: { type: Boolean, default: !1 }
  },
  emits: ["unlock", "recovery"],
  setup(e, { expose: t, emit: n }) {
    const a = e, i = n, { t: o } = pt(() => a.locale), l = $("");
    function c() {
      !l.value || a.busy || i("unlock", l.value);
    }
    return t({ clear: () => l.value = "" }), (p, m) => (f(), h("div", {
      class: Re(["fe-state fe-e2e-lock", { "fe-e2e-lock--compact": e.compact }]),
      "data-testid": "e2e-lock"
    }, [
      (f(), h("svg", {
        class: "fe-state__art",
        viewBox: "0 0 120 100",
        width: e.compact ? 80 : 110,
        height: e.compact ? 67 : 92,
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "aria-hidden": "true"
      }, [...m[2] || (m[2] = [
        d("rect", {
          x: "38",
          y: "44",
          width: "44",
          height: "34",
          rx: "6"
        }, null, -1),
        d("path", { d: "M46 44v-8a14 14 0 0 1 28 0v8" }, null, -1),
        d("circle", {
          cx: "60",
          cy: "59",
          r: "3",
          fill: "currentColor",
          stroke: "none"
        }, null, -1),
        d("path", { d: "M60 62v7" }, null, -1)
      ])], 8, RQ)),
      d("p", IQ, y(u(o)("e2e.locked.title")), 1),
      d("p", NQ, y(u(o)("e2e.locked.hint")), 1),
      d("form", {
        class: "fe-e2e-lock__form",
        onSubmit: yt(c, ["prevent"])
      }, [
        ln(d("input", {
          "onUpdate:modelValue": m[0] || (m[0] = (v) => l.value = v),
          type: "password",
          class: "fe-input fe-e2e-lock__input",
          placeholder: u(o)("e2e.locked.pw_placeholder"),
          "aria-label": u(o)("e2e.locked.pw_placeholder"),
          autocomplete: "current-password",
          disabled: e.busy
        }, null, 8, BQ), [
          [_n, l.value]
        ]),
        d("button", {
          type: "submit",
          class: "fe-btn fe-btn--primary",
          disabled: e.busy || !l.value
        }, y(e.busy ? u(o)("e2e.locked.busy") : u(o)("e2e.locked.unlock")), 9, FQ)
      ], 32),
      e.error ? (f(), h("p", UQ, y(e.error), 1)) : O("", !0),
      e.showRecovery ? (f(), h("button", {
        key: 1,
        type: "button",
        class: "fe-e2e-optlink",
        onClick: m[1] || (m[1] = (v) => i("recovery"))
      }, y(u(o)("e2e.locked.use_recovery")), 1)) : O("", !0)
    ], 2));
  }
}), HQ = ["aria-label"], KQ = ["aria-current", "title", "aria-label"], VQ = ["innerHTML"], jQ = {
  key: 0,
  class: "fe-breadcrumb__sep",
  "aria-hidden": "true"
}, qQ = ["aria-current", "onClick", "onContextmenu", "onDrop"], WQ = {
  key: 0,
  class: "fe-breadcrumb__sep",
  "aria-hidden": "true"
}, YQ = ["aria-expanded", "aria-label", "title"], GQ = {
  key: 0,
  class: "fe-breadcrumb__menu",
  role: "menu"
}, XQ = ["onClick"], JQ = ["aria-current", "onClick", "onContextmenu", "onDrop"], ZQ = {
  key: 0,
  class: "fe-breadcrumb__sep",
  "aria-hidden": "true"
}, QQ = ["aria-expanded", "title", "aria-label"], eee = ["innerHTML"], tee = {
  key: 0,
  class: "fe-breadcrumb__menu",
  role: "menu"
}, nee = ["onClick"], aee = {
  key: 0,
  class: "fe-breadcrumb__menu-empty"
}, iee = ["title", "aria-label"], oee = ["innerHTML"], ree = ["placeholder", "onKeydown"], see = 4, lee = /* @__PURE__ */ lt({
  __name: "Breadcrumb",
  props: {
    dirname: {},
    adapter: {},
    rootLabel: {},
    locale: {},
    multiStorageRoot: { type: Boolean },
    rootPath: {},
    subfolders: {}
  },
  emits: ["navigate", "copy-path", "crumb-context", "crumb-drop"],
  setup(e, { emit: t }) {
    const n = e, a = E(() => {
      if (!n.rootPath) return "";
      const K = n.rootPath, I = K.indexOf("://");
      return (I >= 0 ? K.slice(I + 3) : K).replace(/^\/+|\/+$/g, "");
    }), i = E(() => {
      const K = a.value;
      if (!K) return n.rootLabel || n.adapter;
      const I = K.split("/");
      return I[I.length - 1] || n.rootLabel || n.adapter;
    }), { t: o } = pt(() => n.locale), l = bi(jc, null), c = t, p = E(() => {
      const K = n.adapter ? `${n.adapter}://` : "", I = K && n.dirname.startsWith(K) ? n.dirname.slice(K.length) : n.dirname, Y = I.split("/").filter(Boolean), B = (Fe) => (l == null ? void 0 : l.segmentLabel(Fe)) ?? null, V = [];
      if (n.rootPath) {
        const Fe = a.value, ze = I.replace(/^\/+|\/+$/g, ""), Ue = Fe && (ze === Fe || ze.startsWith(Fe + "/")) ? ze.slice(Fe.length).replace(/^\/+/, "") : "";
        V.push({ label: i.value, adapterPath: n.rootPath });
        let We = Fe;
        for (const $t of Ue.split("/").filter(Boolean))
          We = We ? `${We}/${$t}` : $t, V.push({
            label: cp($t, o) || da(B(`${K}${We}`) || $t),
            adapterPath: `${K}${We}`
          });
        return V;
      }
      n.multiStorageRoot ? (V.push({ label: "/", adapterPath: "" }), n.adapter && V.push({ label: n.rootLabel || n.adapter, adapterPath: K })) : (n.adapter || n.rootLabel) && V.push({
        label: n.rootLabel || n.adapter,
        adapterPath: K
      });
      let be = "";
      for (const Fe of Y) {
        be = be ? `${be}/${Fe}` : Fe;
        const ze = cp(Fe, o) || da(B(`${K}${be}`) || Fe);
        V.push({ label: ze, adapterPath: `${K}${be}` });
      }
      return V;
    }), m = E(() => {
      const K = p.value[0];
      return K && n.multiStorageRoot && K.adapterPath === "" ? K : null;
    }), v = E(
      () => m.value ? p.value.slice(1) : p.value
    ), x = E(() => !!m.value && v.value.length === 0), w = E(() => v.value.length > see), S = E(
      () => w.value ? v.value.slice(0, 1) : v.value
    ), k = E(
      () => w.value ? v.value.slice(1, -2) : []
    ), b = E(
      () => w.value ? v.value.slice(-2) : []
    ), C = $(!1), T = $(null), A = $(!1), L = $(null), z = E(() => C.value || A.value);
    function D() {
      C.value = !1, A.value = !1;
    }
    function U(K) {
      D(), c("navigate", K.adapterPath);
    }
    function q() {
      C.value = !1, A.value = !A.value;
    }
    function P(K) {
      var Y, B;
      const I = K.target;
      if (!(I instanceof Node)) {
        D();
        return;
      }
      (Y = T.value) != null && Y.contains(I) || (B = L.value) != null && B.contains(I) || D();
    }
    function R(K) {
      K.key === "Escape" && (K.stopPropagation(), D());
    }
    Je(z, (K) => {
      K ? (document.addEventListener("click", P, !0), document.addEventListener("keydown", R, !0)) : (document.removeEventListener("click", P, !0), document.removeEventListener("keydown", R, !0));
    }), Je(p, D), Tt(() => {
      document.removeEventListener("click", P, !0), document.removeEventListener("keydown", R, !0);
    });
    function W(K) {
      c("navigate", K.adapterPath);
    }
    function N() {
      m.value && W(m.value);
    }
    function J(K) {
      m.value && ne(K, m.value);
    }
    function H(K) {
      m.value && re(K, m.value);
    }
    function ne(K, I) {
      K.preventDefault(), K.stopPropagation(), c("crumb-context", {
        x: K.clientX,
        y: K.clientY,
        adapterPath: I.adapterPath,
        label: I.label
      });
    }
    function j(K) {
      ti(K) && (K.preventDefault(), K.stopPropagation(), K.dataTransfer && (K.dataTransfer.dropEffect = "move"));
    }
    function re(K, I) {
      ti(K) && (K.preventDefault(), K.stopPropagation(), c("crumb-drop", I.adapterPath, K));
    }
    const he = $(!1), ue = $(""), ae = $(null);
    function fe() {
      const K = `${n.adapter}://`, I = n.dirname.startsWith(K) ? n.dirname.slice(K.length) : n.dirname;
      if (n.rootPath) {
        const Y = a.value, B = I.replace(/^\/+|\/+$/g, ""), V = Y && (B === Y || B.startsWith(Y + "/")) ? B.slice(Y.length).replace(/^\/+/, "") : "";
        ue.value = V ? `/${V}` : "/", he.value = !0, Gt(() => {
          var be, Fe;
          (be = ae.value) == null || be.focus(), (Fe = ae.value) == null || Fe.select();
        });
        return;
      }
      if (n.multiStorageRoot)
        if (!n.adapter)
          ue.value = "/";
        else {
          const Y = I.replace(/^\/+|\/+$/g, "");
          ue.value = Y ? `/${n.adapter}/${Y}` : `/${n.adapter}`;
        }
      else
        ue.value = I;
      he.value = !0, Gt(() => {
        var Y, B;
        (Y = ae.value) == null || Y.focus(), (B = ae.value) == null || B.select();
      });
    }
    function _() {
      const K = ue.value.trim();
      if (he.value = !1, n.rootPath) {
        const Y = K.replace(/^\/+|\/+$/g, ""), B = a.value, V = Y ? B ? `${B}/${Y}` : Y : B;
        c("navigate", V ? `${n.adapter}://${V}` : `${n.adapter}://`);
        return;
      }
      if (n.multiStorageRoot) {
        const Y = K.replace(/^\/+|\/+$/g, "");
        if (!Y) {
          c("navigate", "");
          return;
        }
        const B = Y.indexOf("/"), V = B === -1 ? Y : Y.slice(0, B), be = B === -1 ? "" : Y.slice(B + 1);
        c("navigate", be ? `${V}://${be}` : `${V}://`);
        return;
      }
      const I = K.replace(/^\/+|\/+$/g, "");
      I && c("navigate", `${n.adapter}://${I}`);
    }
    function Q() {
      he.value = !1;
    }
    return (K, I) => (f(), h("nav", {
      class: "fe-breadcrumb",
      "aria-label": u(o)("breadcrumb.aria")
    }, [
      he.value ? ln((f(), h("input", {
        key: 1,
        ref_key: "pathInput",
        ref: ae,
        "onUpdate:modelValue": I[1] || (I[1] = (Y) => ue.value = Y),
        type: "text",
        class: "fe-breadcrumb__input",
        placeholder: u(o)("breadcrumb.path_placeholder"),
        spellcheck: "false",
        autocomplete: "off",
        onKeydown: [
          Ca(yt(_, ["prevent"]), ["enter"]),
          Ca(yt(Q, ["prevent"]), ["escape"])
        ],
        onBlur: Q
      }, null, 40, ree)), [
        [_n, ue.value]
      ]) : (f(), h(Te, { key: 0 }, [
        m.value ? (f(), h("button", {
          key: 0,
          type: "button",
          class: Re(["fe-breadcrumb__crumb fe-breadcrumb__home", { "is-last": x.value }]),
          "aria-current": x.value ? "page" : void 0,
          title: u(o)("breadcrumb.root"),
          "aria-label": u(o)("breadcrumb.root"),
          "data-testid": "breadcrumb-home",
          onClick: N,
          onContextmenu: J,
          onDragover: j,
          onDrop: H
        }, [
          d("span", {
            class: "fe-icon",
            "aria-hidden": "true",
            innerHTML: u(zt)("home")
          }, null, 8, VQ),
          x.value ? O("", !0) : (f(), h("span", jQ, "›"))
        ], 42, KQ)) : O("", !0),
        (f(!0), h(Te, null, nt(S.value, (Y, B) => (f(), h("button", {
          key: Y.adapterPath,
          class: Re(["fe-breadcrumb__crumb", { "is-last": !w.value && B === S.value.length - 1 }]),
          type: "button",
          "aria-current": !w.value && B === S.value.length - 1 ? "page" : void 0,
          onClick: (V) => W(Y),
          onContextmenu: (V) => ne(V, Y),
          onDragover: j,
          onDrop: (V) => re(V, Y)
        }, [
          d("span", null, [
            d("bdi", null, y(Y.label), 1)
          ]),
          w.value || B < S.value.length - 1 ? (f(), h("span", WQ, "›")) : O("", !0)
        ], 42, qQ))), 128)),
        k.value.length ? (f(), h("span", {
          key: 1,
          ref_key: "moreWrapEl",
          ref: T,
          class: "fe-breadcrumb__more-wrap"
        }, [
          d("button", {
            type: "button",
            class: "fe-breadcrumb__more",
            "aria-haspopup": "menu",
            "aria-expanded": C.value,
            "aria-label": u(o)("breadcrumb.more"),
            title: u(o)("breadcrumb.more"),
            onClick: I[0] || (I[0] = (Y) => C.value = !C.value)
          }, "…", 8, YQ),
          I[2] || (I[2] = d("span", {
            class: "fe-breadcrumb__sep",
            "aria-hidden": "true"
          }, "›", -1)),
          C.value ? (f(), h("div", GQ, [
            (f(!0), h(Te, null, nt(k.value, (Y) => (f(), h("button", {
              key: Y.adapterPath,
              type: "button",
              class: "fe-breadcrumb__menu-item",
              role: "menuitem",
              onClick: (B) => U(Y)
            }, [
              d("bdi", null, y(Y.label), 1)
            ], 8, XQ))), 128))
          ])) : O("", !0)
        ], 512)) : O("", !0),
        (f(!0), h(Te, null, nt(b.value, (Y, B) => (f(), h("button", {
          key: Y.adapterPath,
          class: Re(["fe-breadcrumb__crumb", { "is-last": B === b.value.length - 1 }]),
          type: "button",
          "aria-current": B === b.value.length - 1 ? "page" : void 0,
          onClick: (V) => W(Y),
          onContextmenu: (V) => ne(V, Y),
          onDragover: j,
          onDrop: (V) => re(V, Y)
        }, [
          d("span", null, [
            d("bdi", null, y(Y.label), 1)
          ]),
          B < b.value.length - 1 ? (f(), h("span", ZQ, "›")) : O("", !0)
        ], 42, JQ))), 128)),
        e.subfolders ? (f(), h("span", {
          key: 2,
          ref_key: "subWrapEl",
          ref: L,
          class: "fe-breadcrumb__sub-wrap"
        }, [
          d("button", {
            type: "button",
            class: "fe-breadcrumb__sub",
            "aria-haspopup": "menu",
            "aria-expanded": A.value,
            title: u(o)("breadcrumb.subfolders"),
            "aria-label": u(o)("breadcrumb.subfolders"),
            "data-testid": "breadcrumb-subfolders",
            onClick: q
          }, [
            d("span", {
              class: "fe-icon",
              "aria-hidden": "true",
              innerHTML: u(zt)("subfolders")
            }, null, 8, eee)
          ], 8, QQ),
          A.value ? (f(), h("div", tee, [
            (f(!0), h(Te, null, nt(e.subfolders, (Y) => (f(), h("button", {
              key: Y.adapterPath,
              type: "button",
              class: "fe-breadcrumb__menu-item",
              role: "menuitem",
              onClick: (B) => U(Y)
            }, [
              d("bdi", null, y(Y.label), 1)
            ], 8, nee))), 128)),
            e.subfolders.length ? O("", !0) : (f(), h("p", aee, y(u(o)("breadcrumb.subfolders.empty")), 1))
          ])) : O("", !0)
        ], 512)) : O("", !0),
        d("button", {
          type: "button",
          class: "fe-breadcrumb__edit",
          title: u(o)("breadcrumb.go_to_path"),
          "aria-label": u(o)("breadcrumb.go_to_path"),
          "data-testid": "breadcrumb-edit-path",
          onClick: fe
        }, [
          d("span", {
            class: "fe-icon",
            "aria-hidden": "true",
            innerHTML: u(zt)("edit-path")
          }, null, 8, oee)
        ], 8, iee)
      ], 64))
    ], 8, HQ));
  }
}), uee = ["data-mode"], cee = ["aria-label"], dee = ["aria-expanded", "data-testid", "onClick"], fee = { class: "fe-filterbar__label" }, pee = { class: "fe-filterbar__find" }, hee = ["placeholder", "aria-label", "value", "onKeydown"], mee = {
  key: 2,
  class: "fe-filterbar__count",
  role: "status",
  "data-testid": "filter-count"
}, vee = {
  key: 3,
  class: "fe-filterbar__sort"
}, yee = ["disabled", "title"], gee = { class: "fe-sr-only" }, bee = {
  key: 0,
  class: "fe-ficon fe-filterbar__sortarrow",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true",
  focusable: "false"
}, kee = ["aria-label", "title", "disabled", "aria-expanded"], wee = ["aria-label", "title", "aria-expanded"], _ee = ["dir", "role", "aria-label"], xee = {
  key: 0,
  class: "fe-filterpop__rule",
  "aria-hidden": "true"
}, See = ["disabled", "aria-disabled", "data-testid", "onClick"], $ee = ["data-active", "data-testid", "onClick"], Tee = ["aria-selected", "data-checked", "data-active", "data-testid", "onClick"], Aee = {
  class: "fe-filterpop__tick",
  "aria-hidden": "true"
}, Eee = /* @__PURE__ */ lt({
  __name: "FilterBar",
  props: {
    value: {},
    locale: {},
    theme: {},
    shown: {},
    total: {},
    files: {},
    canPaste: { type: Boolean },
    canWrite: { type: Boolean },
    order: {},
    mode: {},
    findLabel: {}
  },
  emits: ["update:value", "new-folder", "upload", "paste", "select-all"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i, dir: o } = pt(() => n.locale), l = E(() => (n.mode ?? "full") === "full"), c = E(() => n.findLabel || i("filter.find")), p = ["type", "people", "modified", "size"], m = [
      "any",
      "folder",
      "document",
      "spreadsheet",
      "presentation",
      "pdf",
      "image",
      "video",
      "audio",
      "archive",
      "code"
    ], v = ["any", "today", "7d", "30d", "year"], x = ["any", "lt1", "1to10", "10to100", "gt100"], w = E(() => f8(n.files ?? []));
    function S(se) {
      return se === "people" ? w.value.map((xe) => xe.value) : se === "type" ? m : se === "modified" ? v : x;
    }
    function k(se, xe) {
      var me;
      return se === "people" && xe.startsWith("u:") ? ((me = w.value.find((De) => De.value === xe)) == null ? void 0 : me.name) || xe.slice(2) : i(`filter.${se}.${xe}`);
    }
    function b(se) {
      const xe = se === "people" ? n.value.people ?? "any" : n.value[se];
      return xe === "any" ? i(`filter.${se}`) : k(se, xe);
    }
    function C(se) {
      return se === "people" ? n.value.people ?? "any" : n.value[se];
    }
    const T = E(() => n8(n.value)), A = Vc(), L = E(() => A.key.value), z = E(() => A.dir.value === "asc"), D = E(() => n.order === "relevance"), U = E(() => D.value ? i("sort.relevance") : i(`col.${L.value}`)), q = E(
      () => D.value ? i("sort.relevance_why") : i(z.value ? "sort.asc" : "sort.desc")
    );
    Je(() => n.locale, (se) => _g(se), { immediate: !0 });
    function P(se) {
      A.setSort(se), Y(!0);
    }
    function R() {
      D.value || A.toggleSortDir();
    }
    function W() {
      D.value || I("sort");
    }
    const N = E(() => [
      { key: "new-folder", label: i("toolbar.new_folder"), disabled: n.canWrite === !1 },
      { key: "upload", label: i("toolbar.upload"), disabled: n.canWrite === !1 },
      { key: "paste", label: i("ctx.paste"), disabled: !n.canPaste || n.canWrite === !1 },
      { key: "sep", label: "", divider: !0, disabled: !0 },
      { key: "select-all", label: i("shortcuts.select_all"), disabled: !1 }
    ]);
    function J(se) {
      Y(!0), se === "new-folder" ? a("new-folder") : se === "upload" ? a("upload") : se === "paste" ? a("paste") : se === "select-all" && a("select-all");
    }
    const H = $(null), ne = $({ x: 0, y: 0 }), j = $(null), re = $({});
    function he(se, xe) {
      re.value[se] = xe ?? null;
    }
    const ue = E(
      () => H.value && H.value !== "sort" && H.value !== "actions" ? H.value : null
    ), ae = E(() => ue.value ? S(ue.value) : []), fe = E(
      () => ue.value ? i(`filter.${ue.value}`) : H.value === "actions" ? i("filter.actions") : i("sort.by")
    );
    function _(se) {
      return !!ue.value && C(ue.value) === se;
    }
    function Q(se) {
      return ue.value ? k(ue.value, se) : se;
    }
    function K(se) {
      ue.value && B(ue.value, se);
    }
    async function I(se) {
      var ot, ft, gt;
      if (H.value === se) {
        Y();
        return;
      }
      const xe = (ot = re.value[se]) == null ? void 0 : ot.getBoundingClientRect(), me = xe ? Ur(xe, o.value) : 8;
      ne.value = { x: me, y: xe ? xe.bottom + 6 : 8 }, H.value = se, await Gt();
      const De = j.value;
      if (De) {
        const Ut = De.getBoundingClientRect();
        if (ne.value = { ...ne.value, x: Oc(me, Ut.width, window.innerWidth, o.value) }, Ut.bottom > window.innerHeight - 8) {
          const Xe = (ft = re.value[se]) == null ? void 0 : ft.getBoundingClientRect();
          ne.value = { ...ne.value, y: Math.max(8, (Xe ? Xe.top : 0) - Ut.height - 6) };
        }
        (gt = De.querySelector('[data-active="true"]')) == null || gt.focus();
      }
    }
    function Y(se = !1) {
      var me;
      const xe = H.value;
      H.value = null, se && xe && ((me = re.value[xe]) == null || me.focus());
    }
    Je(
      () => n.order,
      (se) => {
        se === "relevance" && H.value === "sort" && Y();
      }
    );
    function B(se, xe) {
      a("update:value", { ...n.value, [se]: xe }), Y(!0);
    }
    function V() {
      be.value = "", a("update:value", {
        ...n.value,
        type: "any",
        modified: "any",
        size: "any",
        name: "",
        people: "any"
      });
    }
    const be = $(n.value.name ?? "");
    Je(
      () => n.value.name ?? "",
      (se) => {
        se !== be.value.trim() && (be.value = se);
      }
    );
    let Fe;
    function ze(se) {
      be.value = se.target.value, Fe && clearTimeout(Fe), Fe = setTimeout(() => {
        a("update:value", { ...n.value, name: be.value.trim() });
      }, 140);
    }
    function Ue() {
      Fe && clearTimeout(Fe), be.value = "", a("update:value", { ...n.value, name: "" });
    }
    Tt(() => {
      Fe && clearTimeout(Fe);
    });
    function We(se) {
      var me;
      if (!H.value) return;
      const xe = se.target;
      (me = j.value) != null && me.contains(xe) || Object.values(re.value).some((De) => De == null ? void 0 : De.contains(xe)) || Y();
    }
    function $t(se) {
      se.key === "Escape" && H.value && (se.stopPropagation(), Y(!0));
    }
    jt(() => {
      document.addEventListener("pointerdown", We, !0), document.addEventListener("keydown", $t, !0);
    }), Tt(() => {
      document.removeEventListener("pointerdown", We, !0), document.removeEventListener("keydown", $t, !0);
    });
    const St = $(null), at = $({ start: !1, end: !1 });
    function kt() {
      const se = St.value;
      if (!se) return;
      const xe = Ov(se);
      (xe.start !== at.value.start || xe.end !== at.value.end) && (at.value = xe);
    }
    let ht = null;
    function Ie() {
      const se = St.value;
      if (!(!se || !ht)) {
        ht.observe(se);
        for (const xe of Array.from(se.querySelectorAll(":scope > *, .fe-filterbar__chip"))) ht.observe(xe);
      }
    }
    return Je(
      St,
      (se) => {
        ht == null || ht.disconnect(), ht = null, se && (typeof ResizeObserver < "u" && (ht = new ResizeObserver(() => kt()), Ie()), kt());
      },
      { flush: "post" }
    ), ZM(() => {
      Ie(), kt();
    }), Tt(() => {
      ht == null || ht.disconnect(), ht = null;
    }), (se, xe) => (f(), h("div", {
      class: "fe-filterbar",
      "data-mode": l.value ? "full" : "find",
      "data-testid": "filterbar"
    }, [
      d("div", {
        ref_key: "trackEl",
        ref: St,
        class: Re(["fe-filterbar__track", { "is-more-start": at.value.start, "is-more-end": at.value.end }]),
        "data-testid": "filterbar-track",
        onScrollPassive: kt
      }, [
        l.value ? (f(), h("div", {
          key: 0,
          class: "fe-filterbar__chips",
          role: "group",
          "aria-label": u(i)("filter.aria")
        }, [
          (f(), h(Te, null, nt(p, (me) => d("button", {
            key: me,
            ref_for: !0,
            ref: (De) => he(me, De),
            type: "button",
            class: Re(["fe-filterbar__chip", { "is-set": C(me) !== "any", "is-open": H.value === me }]),
            "aria-expanded": H.value === me,
            "aria-haspopup": "listbox",
            "data-testid": `filter-${me}`,
            onClick: (De) => I(me)
          }, [
            d("span", fee, y(b(me)), 1),
            xe[3] || (xe[3] = d("svg", {
              class: "fe-ficon fe-filterbar__caret",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "aria-hidden": "true",
              focusable: "false"
            }, [
              d("path", { d: "M7 10l5 5 5-5" })
            ], -1))
          ], 10, dee)), 64))
        ], 8, cee)) : O("", !0),
        d("div", pee, [
          xe[4] || (xe[4] = d("svg", {
            class: "fe-ficon fe-filterbar__find-glass",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "1.9",
            "stroke-linecap": "round",
            "aria-hidden": "true",
            focusable: "false"
          }, [
            d("circle", {
              cx: "11",
              cy: "11",
              r: "6.5"
            }),
            d("path", { d: "M16 16l4.5 4.5" })
          ], -1)),
          d("input", {
            type: "search",
            class: "fe-filterbar__find-input",
            placeholder: c.value,
            "aria-label": c.value,
            value: be.value,
            "data-testid": "filter-find",
            onInput: ze,
            onKeydown: Ca(yt(Ue, ["stop", "prevent"]), ["esc"])
          }, null, 40, hee)
        ]),
        l.value && T.value > 0 ? (f(), h("button", {
          key: 1,
          type: "button",
          class: "fe-filterbar__clear",
          "data-testid": "filter-clear",
          onClick: V
        }, y(u(i)("filter.clear")), 1)) : O("", !0),
        l.value && T.value > 0 && typeof e.shown == "number" && typeof e.total == "number" ? (f(), h("span", mee, y(u(i)("filter.count", { shown: String(e.shown), total: String(e.total) })), 1)) : O("", !0),
        l.value ? (f(), h("div", vee, [
          d("button", {
            ref: (me) => he("sort", me),
            type: "button",
            class: Re(["fe-filterbar__sortdir", { "is-ranked": D.value }]),
            disabled: D.value,
            title: D.value ? q.value : void 0,
            "data-testid": "sort-dir",
            onClick: xe[0] || (xe[0] = (me) => R())
          }, [
            d("span", null, y(U.value), 1),
            d("span", gee, ", " + y(q.value), 1),
            D.value ? O("", !0) : (f(), h("svg", bee, [
              z.value ? (f(), h(Te, { key: 0 }, [
                xe[5] || (xe[5] = d("path", { d: "M12 19V5" }, null, -1)),
                xe[6] || (xe[6] = d("path", { d: "M5 12l7-7 7 7" }, null, -1))
              ], 64)) : (f(), h(Te, { key: 1 }, [
                xe[7] || (xe[7] = d("path", { d: "M12 5v14" }, null, -1)),
                xe[8] || (xe[8] = d("path", { d: "M19 12l-7 7-7-7" }, null, -1))
              ], 64))
            ]))
          ], 10, yee),
          d("button", {
            type: "button",
            class: "fe-filterbar__sortpick",
            "aria-label": D.value ? q.value : u(i)("sort.by"),
            title: D.value ? q.value : u(i)("sort.by"),
            disabled: D.value,
            "aria-haspopup": "menu",
            "aria-expanded": H.value === "sort",
            "data-testid": "sort-menu",
            onClick: xe[1] || (xe[1] = (me) => W())
          }, [...xe[9] || (xe[9] = [
            d("svg", {
              class: "fe-ficon fe-filterbar__caret",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "aria-hidden": "true",
              focusable: "false"
            }, [
              d("path", { d: "M7 10l5 5 5-5" })
            ], -1)
          ])], 8, kee)
        ])) : O("", !0)
      ], 34),
      l.value ? (f(), h("button", {
        key: 0,
        ref: (me) => he("actions", me),
        type: "button",
        class: "fe-filterbar__actions",
        "aria-label": u(i)("filter.actions"),
        title: u(i)("filter.actions"),
        "aria-haspopup": "menu",
        "aria-expanded": H.value === "actions",
        "data-testid": "listing-actions",
        onClick: xe[2] || (xe[2] = (me) => I("actions"))
      }, [...xe[10] || (xe[10] = [
        d("svg", {
          class: "fe-ficon",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "aria-hidden": "true",
          focusable: "false"
        }, [
          d("circle", {
            cx: "12",
            cy: "5.5",
            r: "1.2",
            fill: "currentColor",
            stroke: "none"
          }),
          d("circle", {
            cx: "12",
            cy: "12",
            r: "1.2",
            fill: "currentColor",
            stroke: "none"
          }),
          d("circle", {
            cx: "12",
            cy: "18.5",
            r: "1.2",
            fill: "currentColor",
            stroke: "none"
          })
        ], -1)
      ])], 8, wee)) : O("", !0),
      (f(), Ge(wi, { to: "body" }, [
        H.value ? (f(), h("div", {
          key: 0,
          ref_key: "panelEl",
          ref: j,
          class: Re(["fe-filterpop", {
            "fe--theme-light": e.theme === "light",
            "fe--theme-dark": e.theme === "dark",
            "fe-filterpop--sort": H.value === "sort",
            "fe-filterpop--actions": H.value === "actions"
          }]),
          dir: u(o),
          role: H.value === "sort" || H.value === "actions" ? "menu" : "listbox",
          "aria-label": fe.value,
          style: Wt({ left: ne.value.x + "px", top: ne.value.y + "px" })
        }, [
          H.value === "actions" ? (f(!0), h(Te, { key: 0 }, nt(N.value, (me) => (f(), h(Te, {
            key: me.key
          }, [
            me.divider ? (f(), h("hr", xee)) : (f(), h("button", {
              key: 1,
              type: "button",
              class: "fe-filterpop__item",
              role: "menuitem",
              disabled: me.disabled,
              "aria-disabled": me.disabled,
              "data-active": "false",
              "data-testid": `listing-action-${me.key}`,
              onClick: (De) => J(me.key)
            }, [
              d("span", null, y(me.label), 1)
            ], 8, See))
          ], 64))), 128)) : H.value === "sort" ? (f(!0), h(Te, { key: 1 }, nt(u(wg), (me) => (f(), h("button", {
            key: me,
            type: "button",
            class: "fe-filterpop__item",
            role: "menuitem",
            "data-active": L.value === me ? "true" : "false",
            "data-testid": `sort-opt-${me}`,
            onClick: (De) => P(me)
          }, [
            d("span", null, y(u(i)(`col.${me}`)), 1)
          ], 8, $ee))), 128)) : (f(!0), h(Te, { key: 2 }, nt(ae.value, (me) => (f(), h("button", {
            key: me,
            type: "button",
            class: "fe-filterpop__item",
            role: "option",
            "aria-selected": _(me),
            "data-checked": _(me) ? "true" : "false",
            "data-active": _(me) ? "true" : "false",
            "data-testid": `filter-opt-${me}`,
            onClick: (De) => K(me)
          }, [
            d("span", Aee, y(_(me) ? "✓" : ""), 1),
            d("span", null, y(Q(me)), 1)
          ], 8, Tee))), 128))
        ], 14, _ee)) : O("", !0)
      ]))
    ], 8, uee));
  }
}), Cee = ["aria-label"], zee = ["aria-selected", "title", "aria-label"], Mee = ["innerHTML"], Pee = ["aria-selected", "title", "aria-label"], Oee = ["innerHTML"], Lee = ["aria-selected", "title", "aria-label"], Dee = ["innerHTML"], Ree = /* @__PURE__ */ lt({
  __name: "ViewSwitcher",
  props: {
    viewMode: {},
    locale: {},
    modes: {}
  },
  emits: ["update:viewMode"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = pt(() => n.locale);
    function o(l) {
      return !n.modes || n.modes.includes(l);
    }
    return (l, c) => (f(), h("div", {
      class: "fe-toolbar__view",
      role: "tablist",
      "aria-label": u(i)("toolbar.view_label")
    }, [
      o("list") ? (f(), h("button", {
        key: 0,
        type: "button",
        class: Re(["fe-btn fe-btn--icon-only", { "is-active": e.viewMode === "list" }]),
        role: "tab",
        "aria-selected": e.viewMode === "list",
        title: u(i)("toolbar.view.list"),
        "aria-label": u(i)("toolbar.view.list"),
        "data-testid": "view-list",
        onClick: c[0] || (c[0] = (p) => a("update:viewMode", "list"))
      }, [
        d("span", {
          class: "fe-icon",
          "aria-hidden": "true",
          innerHTML: u(zt)("view-list")
        }, null, 8, Mee)
      ], 10, zee)) : O("", !0),
      o("grid") ? (f(), h("button", {
        key: 1,
        type: "button",
        class: Re(["fe-btn fe-btn--icon-only", { "is-active": e.viewMode === "grid" }]),
        role: "tab",
        "aria-selected": e.viewMode === "grid",
        title: u(i)("toolbar.view.grid"),
        "aria-label": u(i)("toolbar.view.grid"),
        "data-testid": "view-grid",
        onClick: c[1] || (c[1] = (p) => a("update:viewMode", "grid"))
      }, [
        d("span", {
          class: "fe-icon",
          "aria-hidden": "true",
          innerHTML: u(zt)("view-grid")
        }, null, 8, Oee)
      ], 10, Pee)) : O("", !0),
      o("gallery") ? (f(), h("button", {
        key: 2,
        type: "button",
        class: Re(["fe-btn fe-btn--icon-only", { "is-active": e.viewMode === "gallery" }]),
        role: "tab",
        "aria-selected": e.viewMode === "gallery",
        title: u(i)("toolbar.view.gallery"),
        "aria-label": u(i)("toolbar.view.gallery"),
        "data-testid": "view-gallery",
        onClick: c[2] || (c[2] = (p) => a("update:viewMode", "gallery"))
      }, [
        d("span", {
          class: "fe-icon",
          "aria-hidden": "true",
          innerHTML: u(zt)("view-gallery")
        }, null, 8, Dee)
      ], 10, Lee)) : O("", !0)
    ], 8, Cee));
  }
});
function Iee(e, t) {
  return typeof e != "number" || !Number.isFinite(e) ? "-" : e <= 0 ? t("trash.days_remaining_due") : t("trash.days_remaining", { n: e });
}
const Nee = ["aria-label", "innerHTML"], Bee = {
  key: 2,
  class: "fe-list__thumb"
}, Fee = ["innerHTML"], Uee = { class: "fe-list__name-wrap" }, Hee = ["title"], Kee = {
  key: 0,
  class: "fe-list__badge"
}, Vee = ["title", "aria-label"], jee = {
  key: 0,
  class: "fe-list__snippet"
}, qee = {
  key: 0,
  class: "fe-list__mark"
}, Wee = ["title", "aria-label"], Yee = { class: "tbl-pill__text" }, Gee = ["title", "aria-label", "data-link-state"], Xee = { class: "tbl-pill__text" }, Jee = ["title", "aria-label"], Zee = {
  key: 6,
  class: "fe-list__kind"
}, Qee = ["title", "aria-label", "onClick"], ete = {
  key: 0,
  class: "fe-colmenu__sep",
  role: "separator"
}, tte = {
  key: 1,
  class: "fe-colmenu__title"
}, nte = {
  key: 2,
  class: "fe-colmenu__hint"
}, ate = ["onClick"], ite = { class: "fe-colmenu__label" }, ote = ["onClick"], rte = { class: "fe-colmenu__label" }, ste = /* @__PURE__ */ lt({
  __name: "ListView",
  props: {
    files: {},
    selected: {},
    clipped: {},
    showParentPath: { type: Boolean },
    locale: {},
    loading: { type: Boolean },
    starredIds: {},
    starEnabled: { type: Boolean },
    apiBase: {},
    authHeaders: { type: Function },
    authCredentials: {},
    keepBadgeFor: { type: Function },
    order: {},
    folderKey: {},
    theme: {},
    thumbSrc: { type: Function },
    trash: { type: Boolean }
  },
  emits: ["click-row", "dbl-row", "context-row", "item-drag-start", "item-drop-into", "star-change", "display-order", "peek", "peek-end"],
  setup(e, { emit: t }) {
    const n = e, a = t, {
      t: i,
      formatNodeSize: o,
      nodeSizeHint: l,
      formatDate: c,
      formatDateFull: p,
      formatMonthYear: m,
      zonedYearMonth: v,
      toDate: x,
      nodeDisplayName: w,
      dir: S
    } = pt(() => n.locale);
    function k(G) {
      return Yr(qc(G), { t: i, formatDate: c, locale: n.locale });
    }
    function b(G) {
      return Wc(G, { t: i });
    }
    function C(G) {
      return Yc(G, { t: i });
    }
    function T(G) {
      return qg(G, { t: i });
    }
    function A(G) {
      return n.selected.has(G.path);
    }
    function L(G, ye) {
      a("click-row", G, Kg(ye, H.isTap(ye)));
    }
    function z(G) {
      a("dbl-row", G);
    }
    function D(G, ye) {
      ye.preventDefault(), ye.stopPropagation(), a("context-row", G, ye);
    }
    function U(G, ye) {
      const te = ye.currentTarget, Ce = te == null ? void 0 : te.getBoundingClientRect();
      a("context-row", G, {
        // ⚠ RTL: the button's START corner — its right one in RTL — so the menu
        // hangs from the control and opens the way the line reads.
        clientX: Ce ? Ur(Ce, S.value) : ye.clientX,
        clientY: Ce ? Ce.bottom : ye.clientY,
        preventDefault: () => {
        },
        stopPropagation: () => {
        }
      });
    }
    function q(G, ye) {
      a("click-row", G, Vg(ye));
    }
    function P(G, ye) {
      Zg(
        ye,
        w(G),
        n.selected.has(G.path) ? n.selected.size : 1
      ), a("item-drag-start", G, ye);
    }
    const R = $(null);
    function W(G, ye) {
      G.type === "dir" && ti(ye) && (ye.preventDefault(), ye.stopPropagation(), ye.dataTransfer && (ye.dataTransfer.dropEffect = "move"), R.value = G.path);
    }
    function N(G) {
      R.value === G.path && (R.value = null);
    }
    function J(G, ye) {
      R.value = null, G.type === "dir" && ti(ye) && (ye.preventDefault(), ye.stopPropagation(), a("item-drop-into", G, ye));
    }
    const H = jg(
      (G, ye) => a("context-row", G, { ...ye, preventDefault: () => {
      }, stopPropagation: () => {
      } }),
      {
        // A finger lifted on the item, off its controls, opens at touchend — see useRowTouch.
        onTap: (G) => a("click-row", G, { ctrl: !1, shift: !1, touch: !0 })
      }
    );
    function ne(G) {
      return G === "kept" ? "✓" : G === "syncing" ? "⟳" : G === "partial" ? "◐" : "☁";
    }
    function j(G) {
      return G.basename === ".trash" || cc(G);
    }
    function re(G) {
      return c(G, { time: !0 }) || "-";
    }
    function he(G) {
      return p(G);
    }
    function ue(G) {
      return j(G) ? "-" : jv(G, i);
    }
    function ae(G) {
      return G.type === "dir" || xp(G) ? null : n.thumbSrc ? n.thumbSrc(G) : G.thumb_url ?? null;
    }
    const fe = E(() => n.files.some((G) => {
      var ye;
      return G.type === "dir" && (((ye = G.preview) == null ? void 0 : ye.length) ?? 0) > 0;
    }));
    function _(G) {
      return n.thumbSrc ? n.thumbSrc(G) : G.thumb_url ?? null;
    }
    const Q = E(() => at.value.includes("type"));
    function K(G) {
      return G.type === "dir" && !j(G);
    }
    function I(G) {
      var Ce;
      if ((Ce = G.extra_metadata) != null && Ce.draft)
        return i("node.drafts");
      const ye = Ir(G);
      return [String(G.storage ?? "").trim(), ye].filter(Boolean).join("/");
    }
    function Y(G) {
      const ye = G.extra_metadata;
      if (ye != null && ye.purging) return i("trash.purging");
      const te = ye == null ? void 0 : ye.ttl_days;
      return Iee(te, i);
    }
    function B(G) {
      const ye = G.snippet;
      return typeof ye == "string" ? ye : "";
    }
    function V(G) {
      return wW(G.matched);
    }
    const be = Vc(), Fe = E(() => be.key.value), ze = E(() => n.order === "relevance");
    Je(() => n.locale, (G) => _g(G), { immediate: !0 });
    const Ue = E(
      () => ze.value ? null : { key: Fe.value, dir: be.dir.value }
    );
    function We(G) {
      ze.value || wg.includes(G.key) && be.chooseSortKey(G.key);
    }
    const $t = E(() => {
      if (n.trash) return ["type", "location", "owner", "modified", "remaining", "size"];
      const G = ["type"];
      return n.showParentPath && G.push("location"), G.push("owner", "modified", "size"), n.starEnabled !== !1 && (n.apiBase || n.apiBase === "") && G.push("star"), G;
    }), St = RS(() => n.folderKey ?? ""), at = E(
      () => St.order().filter((G) => G !== "name" && $t.value.includes(G) && !St.hidden(G))
    ), kt = E(() => [
      { id: "name", label: i("col.name"), lead: !0, sortable: !0, class: "fe-list__col--name" },
      { id: "type", label: i("col.type"), sortable: !0, class: "fe-list__col--type", format: ue },
      {
        id: "location",
        label: n.trash ? i("col.deleted_from") : i("col.location"),
        class: "fe-list__col--location",
        format: I,
        title: (G) => I(G) || void 0
      },
      {
        id: "owner",
        label: n.trash ? i("col.deleted_by") : i("col.owner"),
        class: "fe-list__col--owner",
        format: n.trash ? je : Ut,
        title: n.trash ? Be : Xe
      },
      {
        id: "modified",
        label: n.trash ? i("col.deleted") : i("col.modified"),
        sortable: !0,
        sortDir: "desc",
        class: "fe-list__col--mod",
        format: (G) => re(G.last_modified),
        title: (G) => he(G.last_modified)
      },
      {
        id: "remaining",
        label: i("col.remaining"),
        class: "fe-list__col--remaining",
        format: Y
      },
      {
        id: "size",
        label: i("col.size"),
        sortable: !0,
        class: "fe-list__col--size",
        // A folder the catalog does not cover in full says so: "≥ 1.2 GB", or
        // "—" when nothing below it is known (useLocale formatNodeSize).
        format: (G) => o(G),
        title: (G) => l(G)
      },
      { id: "star", label: i("col.star"), class: "fe-list__col--star", headerLabel: !1 }
    ]);
    function ht(G) {
      const ye = w(G);
      if (!n.showParentPath || at.value.includes("location")) return ye;
      const te = I(G);
      return te ? `${ye} · ${te}` : ye;
    }
    function Ie(G) {
      const ye = {
        tabindex: 0,
        "aria-label": w(G),
        "data-fe-path": G.path,
        draggable: "true"
      };
      return G.type === "dir" && (ye.onPointerenter = (te) => a("peek", G, te.currentTarget, te.pointerType), ye.onPointerleave = () => a("peek-end"), ye.onPointerdown = () => a("peek-end")), ye;
    }
    function se(G) {
      var ye;
      return {
        "is-dir": G.type === "dir",
        "is-trash": !!G.trashed,
        "is-clipped": !!((ye = n.clipped) != null && ye.has(G.path)),
        "is-droptarget": R.value === G.path
      };
    }
    const xe = E(() => c5()), me = E(() => !!n.folderKey && iy(n.folderKey));
    function De(G) {
      p5({
        v: "list",
        ...ze.value ? {} : { k: be.key.value, d: be.dir.value },
        c: St.state()
      }), G();
    }
    function ot(G) {
      n.folderKey && OS(n.folderKey), G();
    }
    const ft = E(() => {
      const G = [], ye = [];
      for (const te of n.files) (j(te) ? G : ye).push(te);
      return [...G, ...ye.sort(be.compareInOrder(n.order ?? "sort"))];
    }), gt = E(() => ({ t: i, formatMonthYear: m, zonedYearMonth: v }));
    Je(
      ft,
      (G) => a("display-order", G),
      { immediate: !0 }
    );
    function Ut(G) {
      return Wp(G) ? i("owner.you") : gc(G) === null ? i("owner.system") : Tg(G) || i("owner.unknown");
    }
    function Xe(G) {
      const ye = [Ut(G)];
      d8(G) && ye.push(i("owner.external"));
      const te = G.last_actor_name, Ce = G.last_actor_self === !0, Ne = G.last_actor_id;
      if (Ce || typeof te == "string" && te) {
        const _e = Ce ? i("owner.you") : String(te);
        _e !== ye[0] && ye.push(i("owner.last_actor", { who: _e }));
      } else Ne === void 0 && gc(G) !== null && ye.push(i("owner.last_actor", { who: i("owner.system") }));
      return ye.join(" · ");
    }
    function je(G) {
      return p1(G) ? i("owner.you") : f1(G) === null ? "-" : c8(G) || i("owner.unknown");
    }
    function Be(G) {
      return f1(G) === null && !p1(G) ? i("trash.deleted_by_nobody") : je(G);
    }
    const ie = E(
      () => Gg(ft.value, {
        /* ⚠ `ranked` is half of this and not a detail: over a search's ranked
         * answer the key is still `modified` (nothing cleared it), the listing
         * just is not obeying it — see `lib/dateGroups.groupingActive`. */
        active: Yg(Fe.value, n.order),
        dateOf: (G) => x(G.last_modified),
        /* ⚠ Folders are their OWN run, above the first date heading, and that is
         * what lets "folders before files" hold while sorted by date. The rule
         * used to be softened instead — rows sorted by date, folders floating to
         * the top of each bucket — because hoisting them all would have split a
         * bucket in two and drawn "Today" twice, once over the folders and once
         * over the files. A run of their own removes that reason, and a folder has
         * no meaningful modification date to file under anyway. */
        aside: (G) => j(G) ? { id: "pinned" } : G.type === "dir" ? { id: "dirs" } : null,
        labels: gt.value
      }).runs
    ), ge = E(
      () => ie.value.map((G) => ({ id: G.id, label: G.label ?? void 0, items: G.items }))
    );
    return (G, ye) => (f(), Ge(os, {
      rows: ft.value,
      groups: ge.value,
      columns: kt.value,
      "column-store": u(St),
      candidates: $t.value,
      metrics: u(DS),
      "row-key": (te) => te.path,
      locale: e.locale,
      theme: e.theme,
      loading: e.loading,
      empty: u(i)("empty.folder"),
      "aria-label": u(i)("list.aria"),
      framed: !1,
      selectable: "",
      "is-selected": A,
      sort: Ue.value,
      "sort-closed": ze.value ? u(i)("sort.relevance_why") : null,
      "row-class": se,
      "row-attrs": Ie,
      onSort: We,
      onRowClick: L,
      onRowDblclick: z,
      onRowContextmenu: D,
      onCheckClick: q,
      onRowDragstart: P,
      onRowDragover: W,
      onRowDragleave: N,
      onRowDrop: J,
      onRowTouchstart: ye[2] || (ye[2] = (te, Ce) => u(H).onTouchStart(te, Ce)),
      onRowTouchend: ye[3] || (ye[3] = (te) => u(H).onTouchEnd(te)),
      onRowTouchmove: ye[4] || (ye[4] = (te) => u(H).onTouchMove(te))
    }, {
      "cell-name": mt(({ row: te }) => [
        u(Vr)(te) ? (f(), h("span", {
          key: 0,
          class: "fe-list__icon fe-list__icon--svg",
          role: "img",
          "aria-label": u(i)("e2e.badge"),
          innerHTML: u(xl)()
        }, null, 8, Nee)) : te.type === "dir" && fe.value ? (f(), Ge(Jg, {
          key: 1,
          shape: "mini",
          node: te,
          "src-of": _,
          class: "fe-list__icon"
        }, null, 8, ["node"])) : (f(), h("span", Bee, [
          Ze(Qc, {
            node: te,
            "src-of": ae,
            "type-badge": u(TT)(te),
            note: T(te),
            class: Re(["fe-list__icon fe-list__icon--img", { "fe-thumb--page": u(Wg)(te) }]),
            alt: "",
            "aria-hidden": "true"
          }, {
            default: mt(() => [
              d("span", {
                class: "fe-list__icon fe-list__icon--svg",
                "aria-hidden": "true",
                innerHTML: u(wa)(te)
              }, null, 8, Fee)
            ]),
            _: 2
          }, 1032, ["node", "type-badge", "note", "class"])
        ])),
        d("div", Uee, [
          d("span", {
            class: "fe-list__name",
            title: ht(te)
          }, [
            d("bdi", null, y(u(w)(te)), 1),
            V(te) ? (f(), h("span", Kee, y(u(i)("search.in_content")), 1)) : O("", !0),
            e.keepBadgeFor && e.keepBadgeFor(te) ? (f(), h("span", {
              key: 1,
              class: Re(["fe-keepbadge", "fe-keepbadge--" + e.keepBadgeFor(te)]),
              title: u(i)("keep.badge_" + e.keepBadgeFor(te)),
              role: "img",
              "aria-label": u(i)("keep.badge_" + e.keepBadgeFor(te))
            }, y(ne(e.keepBadgeFor(te))), 11, Vee)) : O("", !0)
          ], 8, Hee),
          B(te) ? (f(), h("span", jee, [
            (f(!0), h(Te, null, nt(u(Sy)(B(te)), (Ce, Ne) => (f(), h(Te, { key: Ne }, [
              Ce.match ? (f(), h("mark", qee, y(Ce.text), 1)) : (f(), h(Te, { key: 1 }, [
                Ht(y(Ce.text), 1)
              ], 64))
            ], 64))), 128))
          ])) : O("", !0)
        ]),
        k(te) ? (f(), h("span", {
          key: 3,
          class: "fe-applock tbl-pill",
          role: "img",
          title: k(te),
          "aria-label": k(te),
          "data-testid": "lock-badge"
        }, [
          ye[5] || (ye[5] = d("span", {
            class: "fe-applock__glyph",
            "aria-hidden": "true"
          }, "🔒", -1)),
          d("span", Yee, y(u(i)("applock.badge")), 1)
        ], 8, Wee)) : O("", !0),
        b(te) ? (f(), h("span", {
          key: 4,
          class: Re(["fe-symlink tbl-pill", "fe-symlink--" + b(te).state]),
          role: "img",
          title: b(te).why,
          "aria-label": b(te).why,
          "data-testid": "symlink-badge",
          "data-link-state": b(te).state
        }, [
          ye[6] || (ye[6] = d("span", {
            class: "fe-symlink__glyph",
            "aria-hidden": "true"
          }, "🔗", -1)),
          d("span", Xee, y(b(te).badge), 1)
        ], 10, Gee)) : O("", !0),
        C(te) ? (f(), h("span", {
          key: 5,
          class: "fe-unavailable",
          role: "img",
          title: C(te).full,
          "aria-label": C(te).full,
          "data-testid": "unavailable-badge"
        }, y(C(te).badge), 9, Jee)) : O("", !0),
        K(te) && !Q.value ? (f(), h("span", Zee, y(u(i)("node.folder")), 1)) : O("", !0)
      ]),
      "cell-star": mt(({ row: te }) => {
        var Ce;
        return [
          e.starEnabled !== !1 && typeof te.id == "number" && te.type === "file" ? (f(), h("span", {
            key: 0,
            class: "fe-list__star-hit",
            "data-fe-control": "",
            onClick: ye[0] || (ye[0] = yt(() => {
            }, ["stop"])),
            onDblclick: ye[1] || (ye[1] = yt(() => {
            }, ["stop"]))
          }, [
            Ze(Xg, {
              starred: !!((Ce = e.starredIds) != null && Ce.has(te.id)),
              "node-id": te.id,
              "api-base": e.apiBase,
              "auth-headers": e.authHeaders,
              "auth-credentials": e.authCredentials,
              locale: e.locale,
              compact: "",
              onChange: (Ne) => a("star-change", te, Ne)
            }, null, 8, ["starred", "node-id", "api-base", "auth-headers", "auth-credentials", "locale", "onChange"])
          ], 32)) : O("", !0)
        ];
      }),
      actions: mt(({ row: te }) => [
        d("button", {
          type: "button",
          class: "fe-list__menu",
          title: u(i)("toolbar.more"),
          "aria-label": u(i)("toolbar.more"),
          onClick: (Ce) => U(te, Ce)
        }, [...ye[7] || (ye[7] = [
          d("span", { "aria-hidden": "true" }, "⋮", -1)
        ])], 8, Qee)
      ]),
      "colmenu-extra": mt(({ close: te }) => [
        me.value || xe.value > 0 ? (f(), h("div", ete)) : O("", !0),
        me.value || xe.value > 0 ? (f(), h("p", tte, y(u(i)("cols.folder_title")), 1)) : O("", !0),
        me.value || xe.value > 0 ? (f(), h("p", nte, y(u(i)("cols.folder_hint")), 1)) : O("", !0),
        me.value ? (f(), h("button", {
          key: 3,
          type: "button",
          class: "fe-colmenu__row",
          onClick: (Ce) => ot(te)
        }, [
          d("span", ite, y(u(i)("cols.forget_folder")), 1)
        ], 8, ate)) : O("", !0),
        xe.value > 0 || me.value ? (f(), h("button", {
          key: 4,
          type: "button",
          class: "fe-colmenu__row",
          onClick: (Ce) => De(te)
        }, [
          d("span", rte, y(u(i)("cols.apply_all", { count: xe.value })), 1)
        ], 8, ote)) : O("", !0)
      ]),
      _: 1
    }, 8, ["rows", "groups", "columns", "column-store", "candidates", "metrics", "row-key", "locale", "theme", "loading", "empty", "aria-label", "sort", "sort-closed"]));
  }
}), lte = ["aria-label", "aria-busy"], ute = {
  key: 0,
  class: "fe-gal__heading",
  "aria-hidden": "true"
}, cte = ["aria-selected", "aria-label", "data-fe-path", "onClick", "onDblclick", "onContextmenu", "onDragstart", "onDragover", "onDragleave", "onDrop", "onTouchstartPassive"], dte = ["dir"], fte = {
  key: 0,
  class: "fe-fprev__tint"
}, pte = ["innerHTML"], hte = ["aria-label", "innerHTML"], mte = ["innerHTML"], vte = ["onClick"], yte = {
  class: "fe-gal__meta",
  "aria-hidden": "true"
}, gte = {
  key: 0,
  class: "fe-gal__meta-line"
}, bte = ["title"], kte = ["title"], wte = {
  key: 0,
  class: "fe-gal__meta-line"
}, _te = ["title", "aria-label", "data-link-state"], xte = {
  key: 1,
  class: "fe-gal__meta-line"
}, Ste = ["title", "aria-label"], $te = {
  key: 2,
  class: "fe-gal__meta-line"
}, Tte = ["title", "aria-label"], Ate = {
  key: 0,
  class: "fe-gal__empty"
}, Ete = /* @__PURE__ */ lt({
  __name: "GalleryView",
  props: {
    files: {},
    selected: {},
    clipped: {},
    showParentPath: { type: Boolean },
    locale: {},
    loading: { type: Boolean },
    thumbSrc: {},
    starredIds: {},
    starEnabled: { type: Boolean },
    apiBase: {},
    authHeaders: {},
    authCredentials: {},
    e2eActive: { type: Boolean },
    order: {},
    selectable: { type: Boolean, default: !0 }
  },
  emits: ["click-card", "dbl-card", "context-card", "item-drag-start", "item-drop-into", "star-change"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i, formatSize: o, nodeDisplayName: l, formatDate: c, formatMonthYear: p, zonedYearMonth: m, toDate: v } = pt(() => n.locale);
    function x(_) {
      return Yr(qc(_), { t: i, formatDate: c, locale: n.locale });
    }
    function w(_) {
      return Wc(_, { t: i });
    }
    function S(_) {
      return Yc(_, { t: i });
    }
    function k(_) {
      return qg(_, { t: i });
    }
    const b = Vc(), C = E(
      () => Gg(n.files, {
        active: Yg(b.key.value, n.order),
        dateOf: (_) => v(_.last_modified),
        aside: (_) => _.type === "dir" ? { id: "dirs" } : null,
        labels: { t: i, formatMonthYear: p, zonedYearMonth: m }
      })
    ), T = E(() => n.files.some((_) => {
      var Q;
      return _.type === "dir" && (((Q = _.preview) == null ? void 0 : Q.length) ?? 0) > 0;
    }));
    function A(_) {
      return n.thumbSrc ? n.thumbSrc(_) : _.thumb_url ?? null;
    }
    const L = AT({
      apiBase: n.apiBase,
      authHeaders: n.authHeaders ? () => n.authHeaders() : void 0,
      credentials: n.authCredentials,
      disabled: () => n.e2eActive === !0
    });
    Tt(() => L.dispose());
    function z(_) {
      return L.kindFor(_);
    }
    function D(_) {
      const Q = L.get(_);
      return Q ? [Q] : [];
    }
    function U(_, Q) {
      L.bind(_ instanceof Element ? _ : null, Q);
    }
    function q(_) {
      return n.starEnabled === !1 ? !1 : n.apiBase !== void 0 && typeof _.id == "number" && _.type === "file";
    }
    function P(_) {
      return n.selected.has(_.path);
    }
    function R(_, Q) {
      a("click-card", _, Vg(Q));
    }
    function W(_, Q) {
      a("click-card", _, Kg(Q, ue.isTap(Q)));
    }
    function N(_) {
      a("dbl-card", _);
    }
    function J(_, Q) {
      Q.preventDefault(), Q.stopPropagation(), a("context-card", _, Q);
    }
    function H(_, Q) {
      Zg(
        Q,
        l(_),
        n.selected.has(_.path) ? n.selected.size : 1
      ), a("item-drag-start", _, Q);
    }
    const ne = $(null);
    function j(_, Q) {
      _.type === "dir" && ti(Q) && (Q.preventDefault(), Q.stopPropagation(), Q.dataTransfer && (Q.dataTransfer.dropEffect = "move"), ne.value = _.path);
    }
    function re(_) {
      ne.value === _.path && (ne.value = null);
    }
    function he(_, Q) {
      ne.value = null, _.type === "dir" && ti(Q) && (Q.preventDefault(), Q.stopPropagation(), a("item-drop-into", _, Q));
    }
    const ue = jg(
      (_, Q) => a("context-card", _, { ...Q, preventDefault: () => {
      }, stopPropagation: () => {
      } }),
      {
        // A finger lifted on the item, off its controls, opens at touchend — see useRowTouch.
        onTap: (_) => a("click-card", _, { ctrl: !1, shift: !1, touch: !0 })
      }
    );
    function ae(_) {
      return c(_, { time: !0 });
    }
    function fe(_) {
      const Q = ae(_.last_modified);
      return [_.type === "dir" ? "" : o(_.size), Q].filter((I) => !!I).join(" · ");
    }
    return (_, Q) => (f(), h("div", {
      class: Re(["fe-gal", { "is-loading": e.loading, "has-selection": e.selectable && e.selected.size > 0 }]),
      role: "listbox",
      "aria-multiselectable": "true",
      "aria-label": u(i)("gallery.aria"),
      "aria-busy": e.loading ? "true" : void 0
    }, [
      (f(!0), h(Te, null, nt(e.files, (K) => {
        var I, Y;
        return f(), h(Te, {
          key: K.path
        }, [
          C.value.headingBefore(K) ? (f(), h("p", ute, y(C.value.headingBefore(K)), 1)) : O("", !0),
          d("div", {
            class: Re(["fe-gal__card", {
              "is-selected": P(K),
              "is-dir": K.type === "dir",
              "is-trash": K.trashed,
              "is-clipped": (I = e.clipped) == null ? void 0 : I.has(K.path),
              "is-droptarget": ne.value === K.path
            }]),
            tabindex: "0",
            role: "option",
            "aria-selected": P(K) ? "true" : "false",
            "aria-label": u(l)(K),
            "data-fe-path": K.path,
            draggable: "true",
            onClick: (B) => W(K, B),
            onDblclick: (B) => N(K),
            onContextmenu: (B) => J(K, B),
            onDragstart: (B) => H(K, B),
            onDragover: (B) => j(K, B),
            onDragleave: (B) => re(K),
            onDrop: (B) => he(K, B),
            onTouchstartPassive: (B) => u(ue).onTouchStart(K, B),
            onTouchend: Q[3] || (Q[3] = //@ts-ignore
            (...B) => u(ue).onTouchEnd && u(ue).onTouchEnd(...B)),
            onTouchmovePassive: Q[4] || (Q[4] = //@ts-ignore
            (...B) => u(ue).onTouchMove && u(ue).onTouchMove(...B))
          }, [
            d("div", {
              class: "fe-gal__thumb",
              ref_for: !0,
              ref: (B) => U(B, K)
            }, [
              z(K) ? (f(), h(Te, { key: 0 }, [
                (f(!0), h(Te, null, nt(D(K), (B) => (f(), h("div", {
                  key: "fprev",
                  class: Re(["fe-fprev", "fe-fprev--" + B.kind]),
                  dir: u(B2)(B.kind),
                  style: Wt(B.kind === "table" ? { "--fprev-cols": String(B.cols) } : void 0),
                  "aria-hidden": "true"
                }, [
                  B.kind === "table" ? (f(!0), h(Te, { key: 0 }, nt(B.rows, (V, be) => (f(), h(Te, { key: be }, [
                    (f(!0), h(Te, null, nt(V, (Fe, ze) => (f(), h("span", {
                      key: ze,
                      class: Re(["fe-fprev__cell", { "is-head": be === 0 }])
                    }, y(Fe), 3))), 128))
                  ], 64))), 128)) : (f(!0), h(Te, { key: 1 }, nt(B.lines, (V, be) => (f(), h("div", {
                    key: be,
                    class: "fe-fprev__line"
                  }, [
                    V.tint ? (f(), h("span", fte, y(V.indent) + y(V.tint), 1)) : O("", !0),
                    Ht(y(V.text), 1)
                  ]))), 128))
                ], 14, dte))), 128)),
                D(K).length === 0 ? (f(), h("span", {
                  key: 0,
                  class: "fe-gal__icon fe-gal__icon--svg",
                  innerHTML: u(wa)(K)
                }, null, 8, pte)) : O("", !0)
              ], 64)) : K.type === "dir" && T.value && !u(Vr)(K) ? (f(), Ge(Jg, {
                key: 1,
                shape: "fan",
                node: K,
                "src-of": A
              }, null, 8, ["node"])) : (f(), Ge(Qc, {
                key: 2,
                node: K,
                "src-of": A,
                "video-badge": u($T)(K),
                note: k(K),
                alt: K.basename,
                class: Re({
                  "fe-thumb--page": u(Wg)(K)
                  /* gorunum:v1-preview — crop a page from its TOP */
                })
              }, {
                default: mt(() => [
                  u(Vr)(K) ? (f(), h("span", {
                    key: 0,
                    class: "fe-gal__icon fe-gal__icon--svg",
                    role: "img",
                    "aria-label": u(i)("e2e.badge"),
                    innerHTML: u(xl)()
                  }, null, 8, hte)) : (f(), h("span", {
                    key: 1,
                    class: "fe-gal__icon fe-gal__icon--svg",
                    innerHTML: u(wa)(K)
                  }, null, 8, mte))
                ]),
                _: 2
              }, 1032, ["node", "video-badge", "note", "alt", "class"])),
              e.selectable ? (f(), h("span", {
                key: 3,
                class: "fe-item-check fe-gal__check",
                "data-fe-control": "",
                onClick: yt((B) => R(K, B), ["stop"]),
                onDblclick: Q[0] || (Q[0] = yt(() => {
                }, ["stop"]))
              }, [
                Ze(Mg, {
                  on: P(K),
                  label: u(l)(K)
                }, null, 8, ["on", "label"])
              ], 40, vte)) : O("", !0),
              q(K) ? (f(), h("div", {
                key: 4,
                class: "fe-gal__star",
                onClick: Q[1] || (Q[1] = yt(() => {
                }, ["stop"])),
                onDblclick: Q[2] || (Q[2] = yt(() => {
                }, ["stop"]))
              }, [
                Ze(Xg, {
                  starred: !!((Y = e.starredIds) != null && Y.has(K.id)),
                  "node-id": K.id,
                  "api-base": e.apiBase,
                  "auth-headers": e.authHeaders,
                  "auth-credentials": e.authCredentials,
                  locale: e.locale,
                  compact: "",
                  card: "",
                  onChange: (B) => a("star-change", K, B)
                }, null, 8, ["starred", "node-id", "api-base", "auth-headers", "auth-credentials", "locale", "onChange"])
              ], 32)) : O("", !0),
              d("div", yte, [
                fe(K) ? (f(), h("span", gte, y(fe(K)), 1)) : O("", !0),
                e.showParentPath && u(Ir)(K) ? (f(), h("span", {
                  key: 1,
                  class: "fe-gal__meta-line fe-gal__meta-line--path",
                  title: u(Ir)(K)
                }, [
                  d("bdi", null, y(u(Ir)(K)), 1)
                ], 8, bte)) : O("", !0)
              ])
            ], 512),
            d("div", {
              class: "fe-gal__label",
              title: u(l)(K)
            }, [
              d("bdi", null, y(u(l)(K)), 1)
            ], 8, kte),
            w(K) ? (f(), h("div", wte, [
              d("span", {
                class: Re(["fe-symlink", "fe-symlink--" + w(K).state]),
                role: "img",
                title: w(K).why,
                "aria-label": w(K).why,
                "data-testid": "symlink-badge",
                "data-link-state": w(K).state
              }, [
                Q[5] || (Q[5] = d("span", {
                  class: "fe-symlink__glyph",
                  "aria-hidden": "true"
                }, "🔗", -1)),
                Ht(y(w(K).badge), 1)
              ], 10, _te)
            ])) : O("", !0),
            S(K) ? (f(), h("div", xte, [
              d("span", {
                class: "fe-unavailable",
                role: "img",
                title: S(K).full,
                "aria-label": S(K).full,
                "data-testid": "unavailable-badge"
              }, y(S(K).badge), 9, Ste)
            ])) : O("", !0),
            x(K) ? (f(), h("div", $te, [
              x(K) ? (f(), h("span", {
                key: 0,
                class: "fe-applock",
                role: "img",
                title: x(K),
                "aria-label": x(K),
                "data-testid": "lock-badge"
              }, [
                Q[6] || (Q[6] = d("span", {
                  class: "fe-applock__glyph",
                  "aria-hidden": "true"
                }, "🔒", -1)),
                Ht(y(u(i)("applock.badge")), 1)
              ], 8, Tte)) : O("", !0)
            ])) : O("", !0)
          ], 42, cte)
        ], 64);
      }), 128)),
      !e.loading && e.files.length === 0 ? (f(), h("div", Ate, y(u(i)("empty.folder")), 1)) : O("", !0)
    ], 10, lte));
  }
}), Cte = ["dir", "aria-label"], zte = { class: "fe-fpeek__head" }, Mte = { class: "fe-fpeek__name" }, Pte = {
  key: 0,
  class: "fe-fpeek__count"
}, Ote = {
  key: 0,
  class: "fe-fpeek__loading"
}, Lte = {
  key: 1,
  class: "fe-fpeek__list"
}, Dte = { class: "fe-fpeek__tile" }, Rte = ["innerHTML"], Ite = ["innerHTML"], Nte = ["innerHTML"], Bte = { class: "fe-fpeek__label" }, Fte = {
  key: 2,
  class: "fe-fpeek__more"
}, Ute = /* @__PURE__ */ lt({
  __name: "FolderPeek",
  props: {
    state: {},
    srcOf: { type: Function },
    locale: {}
  },
  setup(e) {
    const t = e, { t: n, dir: a, nodeDisplayName: i } = pt(() => t.locale), o = $(null), l = (m) => {
      if (m.type === "dir" || xp(m)) return !1;
      const v = xi(m);
      return v === "image" || v === "video" || Gq(m);
    }, c = E(() => t.state ? Math.max(0, t.state.total - t.state.items.length) : 0);
    function p() {
      const m = o.value, v = t.state;
      if (!m || !v) return;
      const x = window.innerWidth, w = window.innerHeight, S = m.offsetWidth, k = m.offsetHeight, b = ei(m), C = b === "rtl" ? v.anchor.right : v.anchor.left, T = Oc(C, S, x, b);
      let A = v.anchor.bottom + 6;
      A + k > w - 8 && (A = Math.max(8, v.anchor.top - k - 6)), m.style.insetInlineStart = `${Math.round(b === "rtl" ? x - T - S : T)}px`, m.style.top = `${Math.round(A)}px`, m.style.zIndex = String(Rc(document.elementFromPoint(v.anchor.left + 1, v.anchor.top + 1)));
    }
    return Je(
      () => t.state,
      async () => {
        await Gt(), p();
      }
    ), (m, v) => (f(), Ge(wi, { to: "body" }, [
      e.state ? (f(), h("div", {
        key: 0,
        ref_key: "box",
        ref: o,
        class: "fe-fpeek",
        dir: u(a),
        role: "tooltip",
        "data-fe-peek": "",
        "aria-label": u(i)(e.state.node)
      }, [
        d("p", zte, [
          d("bdi", Mte, y(u(i)(e.state.node)), 1),
          e.state.loading ? O("", !0) : (f(), h("span", Pte, y(e.state.total === 0 ? u(n)("peek.empty") : u(n)("peek.items", { n: e.state.total })), 1))
        ]),
        e.state.loading ? (f(), h("p", Ote, y(u(n)("peek.loading")), 1)) : e.state.items.length ? (f(), h("ul", Lte, [
          (f(!0), h(Te, null, nt(e.state.items, (x) => (f(), h("li", {
            key: x.path,
            class: "fe-fpeek__row"
          }, [
            d("span", Dte, [
              l(x) ? (f(), Ge(Qc, {
                key: 0,
                node: x,
                "src-of": e.srcOf,
                "type-badge": u(TT)(x),
                alt: "",
                class: "fe-fpeek__img"
              }, {
                default: mt(() => [
                  d("span", {
                    class: "fe-grid__tile--svg",
                    innerHTML: u(wa)(x)
                  }, null, 8, Rte)
                ]),
                _: 2
              }, 1032, ["node", "src-of", "type-badge"])) : u(Vr)(x) ? (f(), h("span", {
                key: 1,
                class: "fe-grid__tile--svg",
                innerHTML: u(xl)()
              }, null, 8, Ite)) : (f(), h("span", {
                key: 2,
                class: "fe-grid__tile--svg",
                innerHTML: u(wa)(x)
              }, null, 8, Nte))
            ]),
            d("bdi", Bte, y(u(i)(x)), 1)
          ]))), 128))
        ])) : O("", !0),
        !e.state.loading && c.value > 0 ? (f(), h("p", Fte, y(u(n)("peek.more", { n: c.value })), 1)) : O("", !0)
      ], 8, Cte)) : O("", !0)
    ]));
  }
}), Hte = 500, Kte = 3e4, Vte = 8;
function jte(e, t = () => !0) {
  const n = Ea(null), a = /* @__PURE__ */ new Map();
  let i, o = 0;
  async function l(v) {
    const x = a.get(v);
    if (x && Date.now() - x.at < Kte) return x;
    const S = [...(await e(v)).files ?? []].sort(dp), k = { at: Date.now(), items: S.slice(0, Vte), total: S.length };
    return a.set(v, k), k;
  }
  function c(v, x, w = "mouse") {
    if (v.type !== "dir" || w !== "mouse" || !x || !t()) return;
    const S = ++o;
    clearTimeout(i), i = setTimeout(async () => {
      if (S !== o) return;
      const k = x.getBoundingClientRect();
      n.value = { node: v, anchor: k, loading: !0, items: [], total: 0 };
      try {
        const b = await l(v.path);
        if (S !== o) return;
        n.value = { node: v, anchor: k, loading: !1, items: b.items, total: b.total };
      } catch {
        S === o && (n.value = null);
      }
    }, Hte);
  }
  function p() {
    o++, clearTimeout(i), i = void 0, n.value = null;
  }
  function m(v) {
    v ? a.delete(v) : a.clear();
  }
  return { state: n, enter: c, leave: p, forget: m };
}
const qte = ["data-pane", "data-testid", "aria-label"], Wte = {
  key: 0,
  class: "fe-subhead"
}, Yte = { class: "fe-subhead__actions" }, Gte = ["title", "aria-label"], Xte = {
  key: 2,
  class: "fe__skeleton",
  role: "status"
}, Jte = { class: "fe-sr-only" }, Zte = {
  key: 0,
  class: "fe-skel-grid",
  "aria-hidden": "true"
}, Qte = {
  key: 1,
  class: "fe-skel-list",
  "aria-hidden": "true"
}, ene = {
  key: 3,
  class: "fe-state"
}, tne = { class: "fe-state__title" }, nne = { class: "fe-state__hint" }, ane = { class: "fe-state__actions" }, ine = { class: "fe-state__details" }, one = { class: "fe-state__details-summary" }, rne = { class: "fe-state__details-pre" }, sne = {
  key: 4,
  class: "fe-state",
  "data-testid": "empty-filtered"
}, lne = { class: "fe-state__title" }, une = { class: "fe-state__hint" }, cne = { class: "fe-state__actions" }, dne = { class: "fe-state" }, fne = { class: "fe-state__title" }, pne = "application/x-brf-files", hne = "application/x-brf-files-src", mne = 500, M0 = /* @__PURE__ */ lt({
  __name: "FilePane",
  props: {
    paneId: {},
    api: {},
    locale: {},
    theme: {},
    focused: { type: Boolean },
    closable: { type: Boolean },
    path: {},
    selfDriven: { type: Boolean },
    qualify: {},
    toUser: {},
    clamp: {},
    rootLabel: {},
    rootPath: {},
    floor: {},
    multiRoot: { type: Boolean },
    virtualRows: {},
    trashVisible: { type: Boolean, default: !0 },
    navOffersTrash: { type: Boolean },
    rows: {},
    loading: { type: Boolean },
    error: {},
    order: {},
    viewMode: {},
    viewModes: {},
    showCrumbs: { type: Boolean, default: !0 },
    showFilterBar: { type: Boolean, default: !0 },
    filterMode: {},
    findLabel: {},
    showViewSwitcher: { type: Boolean, default: !0 },
    crumbSubfolders: {},
    folderKey: {},
    showParentPath: { type: Boolean },
    trash: { type: Boolean },
    clipped: {},
    extraFilters: {},
    extraFiltersOnServer: { type: Boolean },
    canWrite: { type: Boolean },
    canPaste: { type: Boolean },
    selected: {},
    filters: {},
    thumbSrc: {},
    folderPreviews: { type: Boolean },
    keepBadgeFor: {},
    starredIds: {},
    starOverrides: {},
    starEnabled: { type: Boolean },
    apiBase: {},
    authHeaders: {},
    authCredentials: {},
    e2eActive: { type: Boolean },
    bodyOverride: { type: Boolean },
    openTrigger: { default: "double" }
  },
  emits: ["activate", "close", "navigate", "open", "open-trash", "click-row", "context", "clear-selection", "display-order", "item-drag-start", "item-drop-into", "transfer", "update:viewMode", "update:filters", "crumb-context", "copy-path", "crumb-drop", "new-folder", "upload", "paste", "select-all", "clear-filters", "star-change", "retry"],
  setup(e, { expose: t, emit: n }) {
    const a = e, i = n, { t: o } = pt(() => a.locale), l = a.paneId === "main" ? Vc() : VS();
    Wo(jS, l);
    const c = $(""), p = $([]), m = $(!1), v = $(""), x = $("");
    function w(je) {
      return xi(je) === "storage";
    }
    const S = bi(jc, null), k = bi(HT, null), b = $(""), C = $(!1), T = $(""), A = E(
      () => a.selfDriven && !!k && !!b.value && k.locked(b.value)
    );
    async function L(je) {
      if (!(!k || !b.value || C.value)) {
        C.value = !0, T.value = "";
        try {
          const Be = await k.unlock(b.value, je);
          Be ? T.value = Be : await R(c.value);
        } finally {
          C.value = !1;
        }
      }
    }
    const z = E(() => a.selfDriven ? c.value : a.path ?? ""), D = E(
      () => a.selfDriven ? p.value : a.rows ?? []
    ), U = E(() => a.selfDriven ? m.value : !!a.loading), q = E(() => a.selfDriven ? v.value : a.error ?? ""), P = E(
      () => !!a.multiRoot && !(z.value ?? "").replace(/^\/+|\/+$/g, "")
    );
    async function R(je) {
      const Be = a.clamp(je ?? c.value ?? "");
      m.value = !0, v.value = "";
      try {
        if (a.multiRoot && !Be) {
          p.value = a.virtualRows ? a.virtualRows() : [], x.value = "", b.value = "", c.value = "", i("navigate", "");
          return;
        }
        const ie = await a.api.index(a.qualify(Be));
        x.value = ie.perm || "";
        const ge = typeof ie.e2e_root == "string" ? ie.e2e_root : "";
        ge !== b.value && (T.value = ""), b.value = ge;
        const G = S ? await S.decorate(ie.files, { root: ge || null }) : ie.files;
        p.value = Mr(G), kS(p.value, ie.adapter, ie.dirname, a.trashVisible !== !1, {
          navOffersTrash: a.navOffersTrash
        }) && wS(p.value, ie.adapter, a.api), c.value = a.toUser(ie.dirname), i("navigate", c.value);
      } catch (ie) {
        v.value = ie instanceof Error ? ie.message : String(ie);
      } finally {
        m.value = !1;
      }
    }
    a.selfDriven && R(a.path ?? "");
    function W(je) {
      i("activate"), a.selfDriven ? R(je) : i("navigate", je);
    }
    const N = E(
      () => TS(z.value) ? z.value : a.qualify(z.value)
    ), J = E(() => {
      const je = N.value, Be = je.indexOf("://");
      return Be === -1 ? "" : je.slice(0, Be);
    });
    function H(je) {
      if (i("activate"), !a.selfDriven) {
        i("navigate", je);
        return;
      }
      if (a.multiRoot && !je) {
        R("");
        return;
      }
      R(a.toUser(je));
    }
    const ne = jte(
      (je) => a.api.index(je),
      () => a.folderPreviews !== !1
    );
    function j(je) {
      return a.thumbSrc ? a.thumbSrc(je) : je.thumb_url ?? null;
    }
    function re() {
      ne.leave();
    }
    Je(D, () => ne.forget()), jt(() => {
      window.addEventListener("scroll", re, !0), window.addEventListener("dragstart", re, !0), window.addEventListener("keydown", re, !0);
    }), Tt(() => {
      window.removeEventListener("scroll", re, !0), window.removeEventListener("dragstart", re, !0), window.removeEventListener("keydown", re, !0), ne.leave();
    });
    const he = ic(
      () => Sg(a.filters),
      () => D.value,
      (je) => je.basename || "",
      () => a.api.matchNames
    ), ue = E(() => {
      const je = he.apply(uy(D.value, a.filters));
      return l.sortListing(
        a.extraFilters && !a.extraFiltersOnServer ? uy(je, a.extraFilters) : je,
        a.order ?? "sort"
      );
    }), ae = E(() => {
      const je = new Set(a.starredIds ?? []);
      for (const Be of D.value)
        typeof Be.id == "number" && Be.starred === !0 && je.add(Be.id);
      for (const [Be, ie] of a.starOverrides ?? /* @__PURE__ */ new Map())
        ie ? je.add(Be) : je.delete(Be);
      return je;
    }), fe = E(() => al(a.filters) || !!a.extraFilters), _ = E(
      () => P.value ? "find" : a.filterMode ?? "full"
    ), Q = E(
      () => P.value ? o("filter.find.storages") : a.findLabel ?? ""
    ), K = E(
      () => D.value.filter((je) => je.type === "dir").map((je) => ({ label: je.basename, adapterPath: je.path }))
    );
    let I = 0;
    function Y() {
      return Date.now() - I < mne;
    }
    function B(je, Be) {
      if (!Y()) {
        if (Be.check) {
          i("activate"), i("click-row", je, { ctrl: !0, shift: Be.shift });
          return;
        }
        if (Be.touch || a.openTrigger === "single") {
          I = Date.now(), Ue(je);
          return;
        }
        i("activate"), i("click-row", je, { ctrl: Be.ctrl, shift: Be.shift });
      }
    }
    function V(je) {
      Y() || (I = Date.now(), Ue(je));
    }
    function be(je, Be) {
      Be.preventDefault(), Be.stopPropagation(), i("activate"), i("context", je, Be);
    }
    function Fe(je) {
      je.preventDefault(), je.stopPropagation(), i("activate"), i("clear-selection"), i("context", null, je);
    }
    function ze() {
      i("clear-selection");
    }
    function Ue(je) {
      if (i("activate"), je.basename === ".trash") {
        i("open-trash");
        return;
      }
      if (je.type === "dir" && a.selfDriven) {
        R(w(je) ? je.path : a.toUser(je.path));
        return;
      }
      i("open", je);
    }
    function We(je, Be) {
      if (!Be.dataTransfer) return;
      if (w(je) || P.value || je.basename === ".trash") {
        Be.preventDefault();
        return;
      }
      const ie = D.value.filter((G) => a.selected.has(G.path) && !w(G)).filter((G) => {
        var ye;
        return !((ye = a.clipped) != null && ye.has(G.path));
      }).map((G) => ({ path: G.path, basename: G.basename, type: G.type })), ge = ie.length > 0 ? ie : [{ path: je.path, basename: je.basename, type: je.type }];
      Be.dataTransfer.setData(pne, JSON.stringify(ge)), Be.dataTransfer.setData(hne, N.value), Be.dataTransfer.setData("text/plain", ge.map((G) => G.path).join(`
`)), Be.dataTransfer.effectAllowed = "move", i("item-drag-start", je, Be);
    }
    const $t = $(!1);
    function St(je) {
      return ti(je);
    }
    function at(je, Be) {
      const ie = If(je);
      if (!ie || !Be) return;
      const ge = xy(je), G = ie.map((ye) => ye.path).filter((ye) => ye && ye !== Be && !Be.startsWith(ye + "/"));
      G.length !== 0 && (je.preventDefault(), je.stopPropagation(), i("transfer", { sources: G, targetWire: Be, originWire: ge }));
    }
    function kt(je, Be) {
      $t.value = !1, !(je.type !== "dir" || w(je)) && St(Be) && i("item-drop-into", je, Be);
    }
    function ht(je) {
      !St(je) || P.value || (je.preventDefault(), je.stopPropagation(), je.dataTransfer && (je.dataTransfer.dropEffect = "move"), $t.value = !0);
    }
    function Ie() {
      $t.value = !1;
    }
    function se(je) {
      $t.value = !1, !(!St(je) || P.value) && at(je, N.value);
    }
    function xe() {
      return a.selfDriven ? R() : Promise.resolve();
    }
    function me() {
      const je = (z.value ?? "").replace(/^\/+|\/+$/g, ""), Be = (a.floor || "").replace(/^\/+|\/+$/g, "");
      if (!je || je === Be) return;
      const ie = je.lastIndexOf("/");
      W(ie === -1 ? "" : je.slice(0, ie));
    }
    function De() {
      return z.value;
    }
    function ot() {
      return ue.value.filter((je) => !w(je));
    }
    function ft() {
      return D.value.length;
    }
    function gt() {
      return D.value.map((je) => je.path);
    }
    function Ut() {
      return a.selfDriven ? x.value : "";
    }
    function Xe() {
      return a.selfDriven ? b.value : "";
    }
    return t({ reload: xe, goUp: me, getPath: De, visibleNodes: ot, loadFolder: R, rowCount: ft, rowPaths: gt, dirPerm: Ut, e2eRoot: Xe }), Je(z, () => {
      $t.value = !1;
    }), (je, Be) => (f(), h("section", {
      class: Re(["fe__primary fe-pane", {
        "fe-pane--focus": e.focused,
        "fe-pane--split": e.paneId === "split",
        "fe-pane--dropover": $t.value
      }]),
      "data-pane": e.paneId,
      "data-testid": `pane-${e.paneId}`,
      role: "region",
      "aria-label": e.paneId === "split" ? u(o)("split.pane") : u(o)("toolbar.view_label"),
      onPointerdownCapture: Be[18] || (Be[18] = (ie) => i("activate"))
    }, [
      e.showCrumbs || je.$slots.heading || e.showViewSwitcher || e.closable ? (f(), h("div", Wte, [
        On(je.$slots, "heading", {}, () => [
          e.showCrumbs ? (f(), Ge(lee, {
            key: 0,
            dirname: N.value,
            adapter: J.value,
            "root-label": e.rootLabel || J.value,
            locale: e.locale,
            "multi-storage-root": e.multiRoot,
            "root-path": e.rootPath,
            subfolders: e.crumbSubfolders ?? K.value,
            onNavigate: H,
            onCopyPath: Be[0] || (Be[0] = (ie) => i("copy-path", ie)),
            onCrumbContext: Be[1] || (Be[1] = (ie) => i("crumb-context", ie)),
            onCrumbDrop: Be[2] || (Be[2] = (ie, ge) => i("crumb-drop", ie, ge))
          }, null, 8, ["dirname", "adapter", "root-label", "locale", "multi-storage-root", "root-path", "subfolders"])) : O("", !0)
        ]),
        d("div", Yte, [
          e.showViewSwitcher ? (f(), Ge(Ree, {
            key: 0,
            "view-mode": e.viewMode,
            locale: e.locale,
            modes: e.viewModes,
            "onUpdate:viewMode": Be[3] || (Be[3] = (ie) => {
              i("activate"), i("update:viewMode", ie);
            })
          }, null, 8, ["view-mode", "locale", "modes"])) : O("", !0),
          e.closable ? (f(), h("button", {
            key: 1,
            type: "button",
            class: "fe-btn fe-btn--icon-only fe-pane__close",
            title: u(o)("split.close"),
            "aria-label": u(o)("split.close"),
            "data-testid": "pane-close",
            onClick: Be[4] || (Be[4] = (ie) => i("close"))
          }, [...Be[19] || (Be[19] = [
            d("svg", {
              class: "fe-ficon",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "1.8",
              "stroke-linecap": "round",
              "aria-hidden": "true",
              focusable: "false"
            }, [
              d("path", { d: "M6 6l12 12M18 6L6 18" })
            ], -1)
          ])], 8, Gte)) : O("", !0)
        ])
      ])) : O("", !0),
      Be[25] || (Be[25] = d("div", { class: "fe-selbar-slot" }, null, -1)),
      e.showFilterBar ? (f(), Ge(Eee, {
        key: 1,
        value: e.filters,
        locale: e.locale,
        theme: e.theme,
        mode: _.value,
        "find-label": Q.value,
        order: e.order,
        shown: ue.value.length,
        total: D.value.length,
        files: D.value,
        "can-paste": e.canPaste,
        "can-write": e.canWrite,
        "onUpdate:value": Be[5] || (Be[5] = (ie) => {
          i("activate"), i("update:filters", ie);
        }),
        onNewFolder: Be[6] || (Be[6] = (ie) => {
          i("activate"), i("new-folder");
        }),
        onUpload: Be[7] || (Be[7] = (ie) => {
          i("activate"), i("upload");
        }),
        onPaste: Be[8] || (Be[8] = (ie) => {
          i("activate"), i("paste");
        }),
        onSelectAll: Be[9] || (Be[9] = (ie) => {
          i("activate"), i("select-all");
        })
      }, null, 8, ["value", "locale", "theme", "mode", "find-label", "order", "shown", "total", "files", "can-paste", "can-write"])) : O("", !0),
      On(je.$slots, "banners"),
      d("div", {
        class: Re(["fe__body", { "is-dropover": $t.value }]),
        onClick: yt(ze, ["self"]),
        onContextmenu: Fe,
        onDragover: ht,
        onDragleave: Ie,
        onDrop: se
      }, [
        e.bodyOverride ? On(je.$slots, "body", { key: 0 }) : A.value ? (f(), Ge(KT, {
          key: 1,
          compact: "",
          locale: e.locale,
          busy: C.value,
          error: T.value,
          onUnlock: L,
          onRecovery: Be[10] || (Be[10] = (ie) => {
            var ge;
            return (ge = u(k)) == null ? void 0 : ge.recovery(b.value);
          })
        }, null, 8, ["locale", "busy", "error"])) : U.value && D.value.length === 0 ? (f(), h("div", Xte, [
          d("span", Jte, y(u(o)("loading")), 1),
          e.viewMode !== "list" ? (f(), h("div", Zte, [
            (f(), h(Te, null, nt(8, (ie) => d("div", {
              key: ie,
              class: "fe-skel-card"
            }, [...Be[20] || (Be[20] = [
              d("div", { class: "fe-skel fe-skel--thumb" }, null, -1),
              d("div", { class: "fe-skel fe-skel--label" }, null, -1)
            ])])), 64))
          ])) : (f(), h("div", Qte, [
            (f(), h(Te, null, nt(8, (ie) => d("div", {
              key: ie,
              class: "fe-skel-row"
            }, [...Be[21] || (Be[21] = [
              d("div", { class: "fe-skel fe-skel--icon" }, null, -1),
              d("div", { class: "fe-skel fe-skel--name" }, null, -1),
              d("div", { class: "fe-skel fe-skel--size" }, null, -1),
              d("div", { class: "fe-skel fe-skel--date" }, null, -1)
            ])])), 64))
          ]))
        ])) : q.value && D.value.length === 0 ? (f(), h("div", ene, [
          Be[22] || (Be[22] = g2('<svg class="fe-state__art" viewBox="0 0 120 100" width="110" height="92" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="60" cy="50" r="28"></circle><path d="M60 36v18"></path><circle cx="60" cy="63" r="1.8" fill="currentColor" stroke="none"></circle><path d="M24 88h72" stroke-dasharray="3 5"></path></svg>', 1)),
          d("p", tne, y(u(o)("error.title")), 1),
          d("p", nne, y(u(o)("error.hint")), 1),
          d("div", ane, [
            d("button", {
              type: "button",
              class: "fe-btn fe-btn--primary",
              onClick: Be[11] || (Be[11] = (ie) => e.selfDriven ? R() : i("retry"))
            }, y(u(o)("error.retry")), 1)
          ]),
          d("details", ine, [
            d("summary", one, y(u(o)("error.details")), 1),
            d("pre", rne, y(q.value), 1)
          ])
        ])) : !U.value && fe.value && ue.value.length === 0 && D.value.length > 0 ? (f(), h("div", sne, [
          Be[23] || (Be[23] = d("svg", {
            class: "fe-state__art",
            viewBox: "0 0 120 100",
            width: "110",
            height: "92",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "aria-hidden": "true"
          }, [
            d("path", { d: "M26 28h68L68 58v24l-16 8V58z" })
          ], -1)),
          d("p", lne, y(u(o)("filter.empty.title")), 1),
          d("p", une, y(u(o)("filter.empty.hint")), 1),
          d("div", cne, [
            d("button", {
              type: "button",
              class: "fe-btn",
              onClick: Be[12] || (Be[12] = (ie) => i("clear-filters"))
            }, y(u(o)("filter.clear")), 1)
          ])
        ])) : !U.value && D.value.length === 0 ? On(je.$slots, "empty", { key: 5 }, () => [
          d("div", dne, [
            Be[24] || (Be[24] = d("svg", {
              class: "fe-state__art",
              viewBox: "0 0 120 100",
              width: "110",
              height: "92",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "aria-hidden": "true"
            }, [
              d("path", { d: "M18 36v42a6 6 0 0 0 6 6h72a6 6 0 0 0 6-6V44a6 6 0 0 0-6-6H62l-9-10H24a6 6 0 0 0-6 6z" })
            ], -1)),
            d("p", fne, y(u(o)("empty.folder")), 1)
          ])
        ]) : e.viewMode === "list" ? (f(), Ge(ste, {
          key: 6,
          files: ue.value,
          order: e.order,
          selected: e.selected,
          clipped: e.clipped,
          "show-parent-path": e.showParentPath,
          trash: e.trash,
          locale: e.locale,
          loading: U.value,
          "folder-key": e.folderKey,
          theme: e.theme,
          "thumb-src": e.thumbSrc,
          "keep-badge-for": e.keepBadgeFor,
          "starred-ids": ae.value,
          "star-enabled": e.starEnabled,
          "api-base": e.apiBase,
          "auth-headers": e.authHeaders,
          "auth-credentials": e.authCredentials,
          onClickRow: B,
          onDisplayOrder: Be[13] || (Be[13] = (ie) => i("display-order", ie)),
          onDblRow: V,
          onContextRow: be,
          onItemDragStart: We,
          onItemDropInto: kt,
          onStarChange: Be[14] || (Be[14] = (ie, ge) => i("star-change", ie, ge)),
          onPeek: u(ne).enter,
          onPeekEnd: re
        }, null, 8, ["files", "order", "selected", "clipped", "show-parent-path", "trash", "locale", "loading", "folder-key", "theme", "thumb-src", "keep-badge-for", "starred-ids", "star-enabled", "api-base", "auth-headers", "auth-credentials", "onPeek"])) : e.viewMode === "grid" ? (f(), Ge($y, {
          key: 7,
          files: ue.value,
          order: e.order,
          sections: !0,
          selected: e.selected,
          clipped: e.clipped,
          "show-parent-path": e.showParentPath,
          locale: e.locale,
          loading: U.value,
          "keep-badge-for": e.keepBadgeFor,
          "thumb-src": e.thumbSrc,
          "e2e-active": e.e2eActive,
          "starred-ids": ae.value,
          "star-enabled": e.starEnabled,
          "api-base": e.apiBase,
          "auth-headers": e.authHeaders,
          "auth-credentials": e.authCredentials,
          onClickCard: B,
          onDisplayOrder: Be[15] || (Be[15] = (ie) => i("display-order", ie)),
          onDblCard: V,
          onContextCard: be,
          onItemDragStart: We,
          onItemDropInto: kt,
          onStarChange: Be[16] || (Be[16] = (ie, ge) => i("star-change", ie, ge)),
          onPeek: u(ne).enter,
          onPeekEnd: re
        }, null, 8, ["files", "order", "selected", "clipped", "show-parent-path", "locale", "loading", "keep-badge-for", "thumb-src", "e2e-active", "starred-ids", "star-enabled", "api-base", "auth-headers", "auth-credentials", "onPeek"])) : (f(), Ge(Ete, {
          key: 8,
          files: ue.value,
          order: e.order,
          selected: e.selected,
          clipped: e.clipped,
          "show-parent-path": e.showParentPath,
          locale: e.locale,
          loading: U.value,
          "thumb-src": e.thumbSrc,
          "e2e-active": e.e2eActive,
          "starred-ids": ae.value,
          "star-enabled": e.starEnabled,
          "api-base": e.apiBase,
          "auth-headers": e.authHeaders,
          "auth-credentials": e.authCredentials,
          onClickCard: B,
          onDblCard: V,
          onContextCard: be,
          onItemDragStart: We,
          onItemDropInto: kt,
          onStarChange: Be[17] || (Be[17] = (ie, ge) => i("star-change", ie, ge))
        }, null, 8, ["files", "order", "selected", "clipped", "show-parent-path", "locale", "loading", "thumb-src", "e2e-active", "starred-ids", "star-enabled", "api-base", "auth-headers", "auth-credentials"]))
      ], 34),
      Ze(Ute, {
        state: u(ne).state.value,
        "src-of": j,
        locale: e.locale
      }, null, 8, ["state", "locale"])
    ], 42, qte));
  }
});
function vne(e) {
  const t = $([]), n = $(""), a = E(
    () => t.value.find((C) => C.id === n.value) ?? null
  ), i = E(() => t.value.findIndex((C) => C.id === n.value)), o = E(() => t.value.length > 1);
  function l() {
    if (!e.storageKey) return !1;
    try {
      const C = localStorage.getItem(e.storageKey);
      if (!C) return !1;
      const T = JSON.parse(C);
      if (!T || !Array.isArray(T.tabs) || T.tabs.length === 0) return !1;
      const A = [];
      for (const L of T.tabs) {
        if (!L || typeof L.path != "string") continue;
        const z = typeof L.viewMode == "string" && L.viewMode ? L.viewMode : "list", D = L.split, U = D && typeof D == "object" && typeof D.path == "string" ? {
          path: D.path,
          viewMode: typeof D.viewMode == "string" && D.viewMode ? D.viewMode : void 0
        } : null;
        A.push({
          id: typeof L.id == "string" && L.id ? L.id : ul(),
          path: L.path,
          viewMode: z,
          split: U
        });
      }
      return A.length === 0 ? !1 : (t.value = A, n.value = A.some((L) => L.id === T.active) ? String(T.active) : A[0].id, !0);
    } catch {
      return !1;
    }
  }
  function c() {
    if (e.storageKey)
      try {
        localStorage.setItem(
          e.storageKey,
          JSON.stringify({ v: 1, active: n.value, tabs: t.value })
        );
      } catch {
      }
  }
  Je([t, n], c, { deep: !0 });
  function p(C, T) {
    if (t.value.length > 0) return;
    const A = { id: ul(), path: C, viewMode: T, split: null };
    t.value = [A], n.value = A.id;
  }
  function m(C) {
    const T = a.value;
    T && (C.path !== void 0 && (T.path = C.path), C.viewMode !== void 0 && (T.viewMode = C.viewMode));
  }
  function v(C, T) {
    const A = { id: ul(), path: C, viewMode: T.viewMode, split: T.split ?? null }, L = i.value;
    return t.value.splice(L === -1 ? t.value.length : L + 1, 0, A), T.background || (n.value = A.id), A;
  }
  function x(C) {
    if (t.value.length <= 1) return null;
    const T = t.value.findIndex((z) => z.id === C);
    if (T === -1) return null;
    const A = t.value[T].id === n.value;
    if (t.value.splice(T, 1), !A) return null;
    const L = t.value[Math.min(T, t.value.length - 1)];
    return n.value = L.id, L;
  }
  function w(C) {
    const T = t.value.find((A) => A.id === C);
    return !T || T.id === n.value ? null : (n.value = T.id, T);
  }
  function S(C) {
    if (t.value.length < 2) return null;
    const T = i.value === -1 ? 0 : i.value, A = t.value[(T + C + t.value.length) % t.value.length];
    return w(A.id);
  }
  function k(C, T) {
    if (C === T || C < 0 || T < 0 || C >= t.value.length || T >= t.value.length) return;
    const A = [...t.value], [L] = A.splice(C, 1);
    A.splice(T, 0, L), t.value = A;
  }
  function b(C) {
    const T = a.value;
    T && (T.split = C);
  }
  return {
    tabs: t,
    activeId: n,
    activeTab: a,
    activeIndex: i,
    hasMultiple: o,
    restore: l,
    seed: p,
    syncActive: m,
    openTab: v,
    closeTab: x,
    activate: w,
    step: S,
    move: k,
    setSplit: b
  };
}
function VT(e, t) {
  const n = e.lastIndexOf(".");
  return n <= 0 ? `${e} (${t})` : `${e.slice(0, n)} (${t})${e.slice(n)}`;
}
function yne(e, t) {
  if (e.length !== t.length) return !1;
  for (let n = 0; n < e.length; n++) if (e[n] !== t[n]) return !1;
  return !0;
}
async function gne(e, t, n, a) {
  if (!t) return null;
  for (const i of a) {
    if (yne(i, n)) continue;
    const o = await Nx(e, t, i);
    if (o !== null) return Gi(o) ? null : o;
  }
  return null;
}
async function bne(e, t, n) {
  var o;
  const a = Nl(e);
  return a.kind === "file" || a.kind === "dir" ? a.encoded ?? null : a.kind !== "long" && a.kind !== "longdir" ? null : (((o = await n.readSidecar(t, `${a.hash}.fxl.name`)) == null ? void 0 : o.trim()) ?? "") || null;
}
async function kne(e, t, n, a) {
  const i = [], o = [{ wire: t, id: e.rootId }];
  for (; o.length; ) {
    if (n.stopped()) return;
    const c = o.shift();
    let p;
    try {
      p = await n.list(c.wire);
    } catch {
      a.failed++;
      continue;
    }
    i.push({ ...c, rows: p });
    for (const m of p)
      m.type === "dir" && o.push({ wire: m.path, id: await Wv(e, c.id, m.basename) });
  }
  const l = i.map((c) => c.id);
  for (const c of i.reverse()) {
    const p = new Set(c.rows.map((m) => m.basename));
    for (const m of c.rows) {
      if (n.stopped()) return;
      const v = m.basename;
      if (v === ga) continue;
      const x = await Bx(e, v, c.id, (C) => n.readSidecar(c.wire, C));
      if (x.state === "enc" || x.state === "sidecar") continue;
      a.seen++;
      const w = await gne(e, await bne(v, c.wire, n), c.id, l), S = w ?? (x.state === "plain" ? v : null);
      if (S === null || Gi(S)) {
        a.failed++;
        continue;
      }
      const k = m.type === "dir" ? { dirId: await Wv(e, c.id, v) } : {};
      let b = await Yv(e, S, c.id, k);
      for (let C = 2; p.has(b.stored) && C < 100; C++)
        b = await Yv(e, VT(S, C), c.id, k);
      if (p.has(b.stored)) {
        a.failed++;
        continue;
      }
      try {
        b.sidecar && await n.writeSidecar(c.wire, b.sidecar.name, b.sidecar.content), await n.rename(c.wire, m, b.stored), p.delete(v), p.add(b.stored), a.renamed++, w !== null && (a.repaired = (a.repaired ?? 0) + 1);
      } catch {
        a.failed++;
      }
    }
  }
}
function P0(e) {
  return typeof e.size != "number" || typeof e.last_modified != "number" ? null : `${e.size}:${e.last_modified}`;
}
async function wne(e, t, n, a) {
  const i = [], o = [e], l = (c) => c.replace(/\/+$/, "") === e.replace(/\/+$/, "");
  for (; o.length; ) {
    if (t.stopped()) return;
    const c = o.shift();
    let p;
    try {
      p = await t.list(c);
    } catch {
      n.failed++;
      continue;
    }
    for (const m of p) {
      if (m.type === "dir") {
        o.push(m.path);
        continue;
      }
      l(c) && m.basename === ga || Nl(m.basename).kind !== "sidecar" && i.push({ dir: c, row: m });
    }
  }
  n.total = i.length;
  for (const { dir: c, row: p } of i) {
    if (t.stopped()) return;
    try {
      if (Tl(await t.head(p.path))) {
        n.skipped++;
        continue;
      }
      if (typeof p.size == "number" && p.size > a.maxBytes) {
        t.writeLarge && await t.writeLarge(c, p, P0(p)) ? (n.done++, n.large = (n.large ?? 0) + 1) : n.tooBig++;
        continue;
      }
      const m = await t.read(p.path);
      if (m.byteLength > a.maxBytes) {
        n.tooBig++;
        continue;
      }
      const v = await t.encrypt(m);
      await t.write(c, p, new Blob([v], { type: "application/octet-stream" }), P0(p)), n.done++;
    } catch {
      n.failed++;
    }
  }
}
const Ay = /* @__PURE__ */ new Set(), Ey = $(0);
function _ne(e) {
  return Ay.add(e), Ey.value++, () => {
    Ay.delete(e) && Ey.value++;
  };
}
function xne(e, t) {
  Ey.value;
  for (const n of Ay) {
    const a = n(e, t);
    if (a) return a;
  }
  return null;
}
const Sne = {
  key: 0,
  class: "fe-e2e-form",
  "data-testid": "e2e-too-big"
}, $ne = { class: "fe-e2e-rk__lead" }, Tne = { class: "fe-e2e-big__steps" }, Ane = { class: "fe-e2e-big__cmd" }, Ene = { "data-testid": "e2e-too-big-command" }, Cne = { class: "fe-e2e-names__hint" }, zne = /* @__PURE__ */ lt({
  __name: "E2eTooBigModal",
  props: {
    open: { type: Boolean },
    locale: {},
    info: {}
  },
  emits: ["close", "download"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i, formatSize: o } = pt(() => n.locale), l = $(!1);
    Je(
      () => n.open,
      (m) => {
        m && (l.value = !1);
      }
    );
    const c = E(() => {
      const m = n.info;
      if (!m) return "";
      const v = o(m.limit);
      return m.size !== null ? i("e2e.big.lead", { name: m.name, size: o(m.size), limit: v }) : i("e2e.big.lead_grew", { name: m.name, limit: v });
    });
    async function p() {
      var v;
      const m = (v = n.info) == null ? void 0 : v.command;
      if (m)
        try {
          await navigator.clipboard.writeText(m), l.value = !0;
        } catch {
        }
    }
    return (m, v) => (f(), Ge(ta, {
      open: e.open,
      title: u(i)("e2e.big.title"),
      size: "sm",
      onClose: v[2] || (v[2] = (x) => a("close"))
    }, {
      actions: mt(() => {
        var x;
        return [
          d("button", {
            type: "button",
            class: "fe-btn",
            onClick: v[0] || (v[0] = (w) => a("close"))
          }, y(u(i)("e2e.big.close")), 1),
          d("button", {
            type: "button",
            class: "fe-btn fe-btn--primary",
            "data-testid": "e2e-too-big-download",
            onClick: v[1] || (v[1] = (w) => a("download"))
          }, y(((x = e.info) == null ? void 0 : x.encrypted.kind) === "folder" ? u(i)("e2e.big.download_folder") : u(i)("e2e.big.download_file")), 1)
        ];
      }),
      default: mt(() => [
        e.info ? (f(), h("div", Sne, [
          d("p", $ne, y(c.value), 1),
          d("p", null, y(u(i)("e2e.big.instead")), 1),
          d("ol", Tne, [
            d("li", null, y(e.info.encrypted.kind === "file" ? u(i)("e2e.big.step_file") : u(i)("e2e.big.step_folder")), 1),
            d("li", null, [
              Ht(y(u(i)("e2e.big.step_run")) + " ", 1),
              d("span", Ane, [
                d("code", Ene, y(e.info.command), 1),
                d("button", {
                  type: "button",
                  class: "fe-e2e-optlink",
                  "data-testid": "e2e-too-big-copy",
                  onClick: p
                }, y(l.value ? u(i)("e2e.big.copied") : u(i)("e2e.big.copy")), 1)
              ])
            ])
          ]),
          d("p", Cne, y(u(i)("e2e.big.other_ways")), 1)
        ])) : O("", !0)
      ]),
      _: 1
    }, 8, ["open", "title"]));
  }
}), Mne = "filexfxe", jT = 1, Tp = ".fxe", qT = 64 * 1024, Pne = [], Ff = new TextEncoder().encode(Mne), Ec = 13, One = 32;
function WT(e) {
  return typeof e == "string" && e.length > Tp.length && e.toLowerCase().endsWith(Tp);
}
function Lne() {
  const e = crypto.getRandomValues(new Uint8Array(4));
  return `encrypted-${Array.from(e, (t) => t.toString(16).padStart(2, "0")).join("")}${Tp}`;
}
function Dne(e) {
  return /^encrypted-[0-9a-f]{8}\.fxe$/i.test(e);
}
function O0(e, t) {
  return t ? Lne() : `${e}${Tp}`;
}
function nb(e) {
  const t = { v: 2, salt: e.salt, iter: e.iter, verify: e.verify, fmk: "wrapped", fmk_pw: e.fmk_pw };
  return e.rk && (t.rk = e.rk), e.esc && (t.esc = e.esc), t;
}
function L0(e) {
  return !!e.rk && typeof e.rk.salt == "string" && typeof e.rk.blob == "string";
}
function YT(e) {
  const t = new TextEncoder().encode(JSON.stringify(e));
  if (t.length === 0 || t.length > qT) throw new Error("e2e: the .fxe header is too large");
  const n = new Uint8Array(Ec + t.length);
  return n.set(Ff, 0), n[8] = jT, new DataView(n.buffer).setUint32(9, t.length, !1), n.set(t, Ec), n;
}
function Rne(e) {
  if (e.length < Ff.length) return !1;
  for (let t = 0; t < Ff.length; t++) if (e[t] !== Ff[t]) return !1;
  return !0;
}
class Br extends Error {
  constructor(t) {
    super(t), this.name = "FxeFormatError";
  }
}
function Ine(e) {
  if (e.length < Ec || !Rne(e)) throw new Br("e2e: not a filex encrypted file (.fxe)");
  if (e[8] !== jT) throw new Br(`e2e: unsupported .fxe version ${e[8]} - a newer filex wrote it`);
  const t = new DataView(e.buffer, e.byteOffset, e.byteLength).getUint32(9, !1);
  if (t === 0 || t > qT) throw new Br("e2e: the .fxe header length is out of range");
  return t;
}
function D0(e, t) {
  if (typeof e != "string" || e.length === 0) return !1;
  try {
    const n = ea(e);
    return t === void 0 || n.length === t;
  } catch {
    return !1;
  }
}
function Nne(e, t) {
  var o, l, c, p, m;
  let n;
  try {
    n = JSON.parse(new TextDecoder("utf-8", { fatal: !0 }).decode(e));
  } catch {
    throw new Br("e2e: the .fxe header is not readable");
  }
  const a = (v) => new Br(`e2e: the .fxe header is damaged (${v})`);
  if (!n || typeof n != "object" || Array.isArray(n)) throw a("not an object");
  if (!D0(n.salt)) throw a("salt");
  if (typeof n.iter != "number" || !Number.isInteger(n.iter) || n.iter < 1 || n.iter > eS) throw a("iter");
  if (typeof n.verify != "string") throw a("verify");
  if (n.fmk !== "wrapped" || typeof n.fmk_pw != "string") throw a("fmk");
  if (n.rk !== void 0 && (typeof n.rk != "object" || typeof ((o = n.rk) == null ? void 0 : o.salt) != "string" || typeof ((l = n.rk) == null ? void 0 : l.blob) != "string"))
    throw a("rk");
  if (n.esc !== void 0 && (typeof n.esc != "object" || typeof ((c = n.esc) == null ? void 0 : c.kid) != "string" || typeof ((p = n.esc) == null ? void 0 : p.alg) != "string" || typeof ((m = n.esc) == null ? void 0 : m.blob) != "string"))
    throw a("esc");
  if (typeof n.dek != "string" || typeof n.name != "string") throw a("dek/name");
  if (!Nc(n.chunk)) throw a("chunk");
  if (!D0(n.nonce, jr)) throw a("nonce");
  if (typeof n.size != "number" || !Number.isSafeInteger(n.size) || n.size < 0) throw a("size");
  const i = [];
  if (n.req !== void 0) {
    if (!Array.isArray(n.req) || n.req.some((v) => typeof v != "string")) throw a("req");
    for (const v of n.req) Pne.includes(v) || i.push(v);
  }
  return { header: n, unsupported: i, prefixLength: t };
}
async function Bne(e) {
  const t = new Rp(e);
  try {
    const n = await t.read(Ec), a = Ine(n), i = await t.read(a);
    if (i.length < a) throw new Br("e2e: the .fxe file is truncated");
    return { parsed: Nne(i, Ec + a), body: t.rest() };
  } catch (n) {
    throw await t.cancel().catch(() => {
    }), n;
  }
}
async function Fne(e, t) {
  const n = await q_(t, e.dek);
  if (!n || n.length !== One) return null;
  let a;
  try {
    a = await Ip(new Uint8Array(n));
  } finally {
    n.fill(0);
  }
  const i = await q_(t, e.name);
  if (!i) return null;
  let o;
  try {
    o = new TextDecoder("utf-8", { fatal: !0 }).decode(i);
  } catch {
    return null;
  }
  return Gi(o) ? null : { header: e, fmk: t, dek: a, name: o.normalize("NFC") };
}
async function Une(e, t) {
  const n = nb(e);
  let a;
  if ("password" in t) {
    const o = await cS(n, t.password);
    if ("error" in o) return { error: o.error };
    a = o.fmk;
  } else if ("recoveryKey" in t) {
    if (a = await dS(n, t.recoveryKey), !a) return { error: "wrong" };
  } else if (a = await fS(n, t.escrowKey), !a) return { error: "wrong" };
  const i = await Fne(e, a);
  return i ? { key: i } : { error: "damaged" };
}
function Hne(e, t) {
  return { ...e, header: t };
}
async function Kne(e, t, n, a, i = {}) {
  const o = (e ?? "").normalize("NFC"), l = Gi(o);
  if (l) throw new Error(`e2e: invalid name (${l})`);
  if ((a ?? "").length < sp)
    throw new Error(`e2e: the password must be at least ${sp} characters`);
  if (!Number.isSafeInteger(t) || t < 0) throw new Error("e2e: bad file size");
  const c = i.chunkLog2 ?? So;
  if (!Nc(c)) throw new Error("e2e: bad chunk size");
  const p = await ny(a, {
    escrowPublicKey: i.escrowPublicKey ?? null,
    iterations: i.iterations
  }), m = Yx();
  let v, x;
  try {
    v = await j_(p.fmk, m), x = await Ip(m);
  } finally {
    m.fill(0);
  }
  const w = jx(), S = p.marker, k = {
    salt: S.salt,
    iter: S.iter,
    verify: S.verify,
    fmk: "wrapped",
    fmk_pw: S.fmk_pw,
    ...S.rk ? { rk: S.rk } : {},
    ...S.esc ? { esc: S.esc } : {},
    dek: v,
    name: await j_(p.fmk, new TextEncoder().encode(o)),
    chunk: c,
    nonce: Ma(w),
    size: t
  }, b = YT(k), C = n.pipeThrough(
    qx(x, w, c, { expectSize: t, onProgress: i.onProgress })
  );
  return {
    header: k,
    stream: Fc(b, C),
    size: b.length + lg(t, c),
    recoveryKey: p.recoveryKey,
    key: { header: k, fmk: p.fmk, dek: x, name: o }
  };
}
function yv(e, t) {
  const n = e.header;
  return t.pipeThrough(Wx(e.dek, ea(n.nonce), n.chunk, { expectSize: n.size }));
}
async function Vne(e, t, n) {
  const a = await vS(nb(e), t, n);
  if (a.fmk !== "wrapped" || !a.fmk_pw) throw new dn("e2e: the password slot did not re-seal");
  return { ...e, salt: a.salt, iter: a.iter, verify: a.verify, fmk: "wrapped", fmk_pw: a.fmk_pw };
}
function jne(e, t) {
  const n = YT(e);
  return { stream: Fc(n, t), size: n.length + lg(e.size, e.chunk) };
}
const vi = 1024 * 1024 * 1024;
function GT() {
  if (typeof window > "u") return null;
  const e = window;
  return typeof e.showSaveFilePicker == "function" && e.isSecureContext !== !1 ? e.showSaveFilePicker.bind(window) : null;
}
function qne() {
  return GT() !== null;
}
class Qs extends Error {
  constructor() {
    super("save cancelled"), this.name = "SaveCancelled";
  }
}
class Uf extends Error {
  constructor() {
    super("the save dialog needs a click"), this.name = "SaveNeedsGesture";
  }
}
class Xa extends Error {
  constructor(t, n) {
    super(`e2e: ${t} bytes is more than this browser can save from memory (${n})`), this.size = t, this.limit = n, this.name = "SaveTooLarge";
  }
}
async function gv(e, t) {
  const n = GT();
  if (n) {
    let a;
    try {
      a = await n({ suggestedName: e });
    } catch (i) {
      const o = i == null ? void 0 : i.name;
      throw o === "AbortError" ? new Qs() : o === "SecurityError" || o === "NotAllowedError" ? new Uf() : i;
    }
    return Wne(e, a);
  }
  if (t !== void 0 && t > vi) throw new Xa(t, vi);
  return Yne(e);
}
function Wne(e, t) {
  let n = null;
  return {
    kind: "fsa",
    name: e,
    async write(a) {
      var l;
      n = await t.createWritable();
      const i = n, o = a.getReader();
      try {
        for (; ; ) {
          const { done: c, value: p } = await o.read();
          if (c) break;
          await i.write(p);
        }
        await i.close();
      } catch (c) {
        throw await i.abort(c).catch(() => {
        }), await o.cancel(c).catch(() => {
        }), await ((l = t.remove) == null ? void 0 : l.call(t).catch(() => {
        })), c;
      }
    },
    async discard() {
      var a;
      n && await n.abort().catch(() => {
      }), await ((a = t.remove) == null ? void 0 : a.call(t).catch(() => {
      }));
    }
  };
}
function Yne(e) {
  return {
    kind: "blob",
    name: e,
    async write(t, n) {
      const a = [];
      let i = 0;
      const o = t.getReader();
      try {
        for (; ; ) {
          const { done: m, value: v } = await o.read();
          if (m) break;
          if (i += v.length, i > vi) throw new Xa(i, vi);
          a.push(new Blob([v]));
        }
      } catch (m) {
        throw await o.cancel(m).catch(() => {
        }), m;
      }
      const l = new Blob(a, { type: (n == null ? void 0 : n.mime) || "application/octet-stream" }), c = URL.createObjectURL(l), p = document.createElement("a");
      p.href = c, p.download = e, p.rel = "noopener", document.body.appendChild(p), p.click(), p.remove(), setTimeout(() => URL.revokeObjectURL(c), 6e4);
    },
    async discard() {
    }
  };
}
const ba = 4294967295, Hf = 65535, Gne = new TextEncoder();
let bv = null;
function Xne() {
  if (bv) return bv;
  const e = new Uint32Array(256);
  for (let t = 0; t < 256; t++) {
    let n = t;
    for (let a = 0; a < 8; a++) n = n & 1 ? 3988292384 ^ n >>> 1 : n >>> 1;
    e[t] = n >>> 0;
  }
  return bv = e, e;
}
function Jne(e, t = 0) {
  const n = Xne();
  let a = (t ^ ba) >>> 0;
  for (let i = 0; i < e.length; i++) a = n[(a ^ e[i]) & 255] ^ a >>> 8;
  return (a ^ ba) >>> 0;
}
class Fr {
  constructor(t) {
    It(this, "buf");
    It(this, "dv");
    It(this, "o", 0);
    this.buf = new Uint8Array(t), this.dv = new DataView(this.buf.buffer);
  }
  u16(t) {
    return this.dv.setUint16(this.o, t, !0), this.o += 2, this;
  }
  u32(t) {
    return this.dv.setUint32(this.o, t >>> 0, !0), this.o += 4, this;
  }
  u64(t) {
    return this.dv.setUint32(this.o, t % 2 ** 32, !0), this.dv.setUint32(this.o + 4, Math.floor(t / 2 ** 32), !0), this.o += 8, this;
  }
  bytes(t) {
    return this.buf.set(t, this.o), this.o += t.length, this;
  }
  done() {
    if (this.o !== this.buf.length) throw new Error(`zip: record size ${this.o} != ${this.buf.length}`);
    return this.buf;
  }
}
function Zne(e) {
  const t = e.getFullYear();
  return t < 1980 ? { time: 0, date: 33 } : {
    time: e.getHours() << 11 | e.getMinutes() << 5 | Math.floor(e.getSeconds() / 2),
    date: Math.min(t, 2107) - 1980 << 9 | e.getMonth() + 1 << 5 | e.getDate()
  };
}
const XT = 2048, JT = 8, ZT = 813, Qne = 33188, eae = 16877;
function tae(e) {
  const t = e.zip64Local ? 20 : 0, n = new Fr(30 + e.name.length + t).u32(67324752).u16(e.zip64Local ? 45 : 20).u16(XT | (e.dir ? 0 : JT)).u16(0).u16(e.time).u16(e.date).u32(0).u32(e.zip64Local ? ba : 0).u32(e.zip64Local ? ba : 0).u16(e.name.length).u16(t).bytes(e.name);
  return e.zip64Local && n.u16(1).u16(16).u64(0).u64(0), n.done();
}
function nae(e) {
  return e.zip64Local ? new Fr(24).u32(134695760).u32(e.crc).u64(e.size).u64(e.size).done() : new Fr(16).u32(134695760).u32(e.crc).u32(e.size).u32(e.size).done();
}
function aae(e, t) {
  const n = t || e.size >= ba, a = t || e.offset >= ba, i = n || a ? 4 + (n ? 16 : 0) + (a ? 8 : 0) : 0, o = new Fr(46 + e.name.length + i).u32(33639248).u16(ZT).u16(n || a || e.zip64Local ? 45 : 20).u16(XT | (e.dir ? 0 : JT)).u16(0).u16(e.time).u16(e.date).u32(e.crc).u32(n ? ba : e.size).u32(n ? ba : e.size).u16(e.name.length).u16(i).u16(0).u16(0).u16(0).u32((e.dir ? eae : Qne) * 65536 + (e.dir ? 16 : 0) >>> 0).u32(a ? ba : e.offset).bytes(e.name);
  return i && (o.u16(1).u16(i - 4), n && o.u64(e.size).u64(e.size), a && o.u64(e.offset)), o.done();
}
function iae(e, t, n, a) {
  const i = [], o = a || e >= Hf || t >= ba || n >= ba;
  if (o) {
    const l = t + n;
    i.push(
      new Fr(56).u32(101075792).u64(44).u16(ZT).u16(45).u32(0).u32(0).u64(e).u64(e).u64(n).u64(t).done()
    ), i.push(new Fr(20).u32(117853008).u32(0).u64(l).u32(1).done());
  }
  return i.push(
    new Fr(22).u32(101010256).u16(0).u16(0).u16(o ? Hf : e).u16(o ? Hf : e).u32(o ? ba : n).u32(o ? ba : t).u16(0).done()
  ), i;
}
function oae(e, t) {
  const n = e.replace(/\\/g, "/").split("/").filter((a) => a !== "" && a !== ".");
  if (n.length === 0 || n.some((a) => a === "..")) throw new Error(`zip: unsafe entry name ${JSON.stringify(e)}`);
  return n.join("/") + (t ? "/" : "");
}
async function* rae(e, t) {
  const n = !!t.forceZip64, a = [];
  let i = 0;
  const o = (p) => {
    var m;
    return i += p.length, (m = t.onProgress) == null || m.call(t, i), p;
  };
  for await (const p of e) {
    const m = p.name.endsWith("/") && !p.data, v = Gne.encode(oae(p.name, m));
    if (v.length > Hf) throw new Error("zip: entry name too long");
    const { time: x, date: w } = Zne(p.mtime ?? /* @__PURE__ */ new Date()), S = {
      name: v,
      dir: m,
      zip64Local: !m && (n || p.sizeHint === void 0 || p.sizeHint >= ba),
      crc: 0,
      size: 0,
      offset: i,
      time: x,
      date: w
    };
    if (yield o(tae(S)), !m && p.data) {
      const b = (typeof p.data == "function" ? await p.data() : p.data).getReader();
      try {
        for (; ; ) {
          const { done: C, value: T } = await b.read();
          if (C) break;
          !T || T.length === 0 || (S.crc = Jne(T, S.crc), S.size += T.length, yield o(T));
        }
      } catch (C) {
        throw await b.cancel(C).catch(() => {
        }), C;
      } finally {
        b.releaseLock();
      }
      if (!S.zip64Local && S.size >= ba) throw new Error(`zip: ${p.name} grew past its size hint and 4 GiB`);
      yield o(nae(S));
    }
    a.push(S);
  }
  const l = i;
  for (const p of a) yield o(aae(p, n));
  const c = i - l;
  for (const p of iae(a.length, l, c, n)) yield o(p);
}
function sae(e, t = {}) {
  const n = rae(e, t);
  return new ReadableStream({
    async pull(a) {
      const { value: i, done: o } = await n.next();
      o ? a.close() : a.enqueue(i);
    },
    async cancel() {
      await n.return(void 0);
    }
  });
}
function R0(e, t) {
  let n = null;
  const a = () => n ?? (n = new Rp(e));
  let i = 0, o = new Uint8Array(0), l = 0, c = !1;
  return {
    size: t,
    async read(p, m) {
      if (c) throw new Error("upload source cancelled");
      if (p < i || p > l || m < p || m > t)
        throw new Error(`upload source: cannot read [${p}, ${m}) after [${i}, ${l})`);
      const v = o.subarray(p - i);
      if (m > l) {
        const x = await a().read(m - l);
        if (x.length < m - l) throw new Error("upload source: the stream ended early");
        const w = new Uint8Array(v.length + x.length);
        w.set(v, 0), w.set(x, v.length), o = w, l = m;
      } else
        o = v.slice();
      return i = p, new Blob([o.subarray(0, m - p)]);
    },
    cancel() {
      c || (c = !0, (n ? n.cancel() : e.cancel()).catch(() => {
      }));
    }
  };
}
async function I0(e, t, n = "application/octet-stream") {
  const a = [], i = e.getReader();
  for (; ; ) {
    const { done: o, value: l } = await i.read();
    if (o) break;
    a.push(new Blob([l]));
  }
  return new File(a, t, { type: n });
}
const lae = [
  "fxe-encrypt",
  "fxe-request",
  "fxe-download-raw",
  "fxe-remove",
  "fxe-password",
  "e2e-download-encrypted"
];
function uae(e) {
  return lae.includes(e);
}
function Ui(e) {
  return !!e && e.type === "file" && WT(typeof e.e2e_stored == "string" ? e.e2e_stored : e.basename);
}
function QT(e, t) {
  const n = e.length === 1 ? e[0] : null;
  return !n || n.type !== "file" || Ui(n) || t.inEncrypted || n.e2e_root || !t.canWrite ? null : n;
}
function cae(e, t) {
  const n = e.lastIndexOf(".");
  return n <= 0 ? `${e} (${t})` : `${e.slice(0, n)} (${t})${e.slice(n)}`;
}
function dae(e) {
  const { api: t, t: n } = e, a = /* @__PURE__ */ new Map(), i = $(0), o = /* @__PURE__ */ new Map();
  function l() {
    for (const ie of o.values()) URL.revokeObjectURL(ie);
    o.clear();
  }
  Tt(() => {
    l(), a.clear();
  });
  const c = $(null), p = $(!1), m = $(null), v = $(null), x = $(null), w = $("open"), S = $(!1), k = $(null), b = $(null), C = $(!1), T = $(!0), A = $("off"), L = $(null), z = $(null), D = $(!1), U = $(null), q = $(null);
  async function P(ie) {
    const ge = await t.authHeaders(), G = await fetch(t.previewUrl(ie), {
      headers: ge,
      credentials: t.credentialsMode(),
      cache: "no-store"
    });
    if (!G.ok) {
      const ye = await G.text().catch(() => "");
      throw fa(G.status, ye, e.locale());
    }
    if (!G.body) throw new Error("e2e: this browser cannot read a download as a stream");
    return G.body;
  }
  async function R(ie) {
    const ge = await t.index(ie);
    return new Set((ge.files ?? []).map((G) => G.basename));
  }
  function W(ie, ge) {
    if (!ge.has(ie)) return ie;
    for (let G = 2; G < 1e3; G++) {
      const ye = cae(ie, G);
      if (!ge.has(ye)) return ye;
    }
    throw new Error("e2e: no free name");
  }
  async function N(ie, ge, G, ye, te, Ce = {}) {
    const Ne = new File([], ge, { type: "application/octet-stream" }), { fields: _e, signal: Ae } = Ce;
    if (Ae != null && Ae.aborted)
      throw await G.cancel().catch(() => {
      }), new DOMException("Aborted by user", "AbortError");
    if (ye > e.chunked.threshold()) {
      const _t = R0(G, ye);
      let Et = null;
      const xn = () => Et == null ? void 0 : Et.cancel();
      Ae == null || Ae.addEventListener("abort", xn);
      try {
        await e.chunked.uploadFile({
          path: ie,
          file: Ne,
          source: _t,
          commitQuery: _e,
          onProgress: (Dt) => {
            Et = Dt, Ae != null && Ae.aborted && Dt.cancel(), te == null || te(Dt.uploadedBytes);
          }
        });
        return;
      } catch (Dt) {
        if (!Yy(Dt)) throw Dt;
        if (ye > vi)
          throw await G.cancel().catch(() => {
          }), new Xa(ye, vi);
      } finally {
        Ae == null || Ae.removeEventListener("abort", xn);
      }
    }
    const Pe = await I0(G, ge);
    if (Pe.size !== ye) throw new Error("e2e: the upload came out a different size than it should");
    if (Ae != null && Ae.aborted) throw new DOMException("Aborted by user", "AbortError");
    await t.uploadMultipart(ie, [Pe], (_t) => te == null ? void 0 : te(Math.round(_t / 100 * ye)), _e);
  }
  async function J(ie) {
    const ge = Na(ie);
    if (t.endpoints.deleteAsync) {
      const { op: G } = await t.deleteAsync([ie], ge);
      e.registerOp(G);
      return;
    }
    await t.deleteItems(ge, [ie]);
  }
  function H(ie) {
    return ie instanceof Error && ie.message ? ie.message : String(ie);
  }
  function ne(ie) {
    return ie instanceof Br ? n("e2e.fxe.not_readable") : ie instanceof dn ? n("e2e.fxe.damaged") : H(ie);
  }
  async function j(ie) {
    const { parsed: ge, body: G } = await Bne(await P(ie));
    return { header: ge.header, unsupported: ge.unsupported, body: G };
  }
  function re(ie, ge) {
    return ie.header.dek === ge.dek && ie.header.nonce === ge.nonce && ie.header.size === ge.size;
  }
  function he(ie) {
    var ge;
    return i.value, (ge = a.get(ie)) == null ? void 0 : ge.name;
  }
  function ue(ie, ge) {
    const G = ie.length === 1 ? ie[0] : null, ye = !!G && Ui(G), te = QT(ie, ge) !== null, Ce = ge.encryptAnswer ?? "allowed";
    return [
      {
        key: "fxe-encrypt",
        label: n("e2e.fxe.ctx_encrypt"),
        icon: "lock",
        hidden: !te || Ce !== "allowed"
      },
      /* wiring:e2 policy — the same place, where encrypting needs an approval. */
      {
        key: "fxe-request",
        label: n("e2e.request.ctx"),
        icon: "lock",
        hidden: !te || Ce !== "request"
      },
      { key: "fxe-download-raw", label: n("e2e.fxe.ctx_download_raw"), icon: "download", hidden: !ye },
      {
        key: "e2e-download-encrypted",
        label: n("e2e.dl.ctx_encrypted_copy"),
        icon: "download",
        hidden: ye || ie.length === 0 || !ge.unlockedEncryptedCopy
      },
      { key: "fxe-password", label: n("e2e.fxe.ctx_password"), icon: "lock", hidden: !ye || !ge.canWrite },
      { key: "fxe-remove", label: n("e2e.fxe.ctx_remove"), icon: "restore", hidden: !ye || !ge.canWrite }
    ];
  }
  function ae(ie) {
    c.value = ie, m.value = null, v.value = null;
  }
  function fe() {
    p.value || (c.value = null);
  }
  async function _(ie, ge) {
    for (const G of await t.listVersions(ge)) await t.purgeVersion(G.id);
    await t.deleteItems(Na(ie.path), [ie.path]);
    try {
      await t.purgeTrash(ge);
    } catch (G) {
      if (G.status !== 404) throw G;
    }
  }
  async function Q(ie) {
    const ge = c.value;
    if (!(!ge || p.value)) {
      p.value = !0, m.value = null, v.value = 0;
      try {
        const G = Na(ge.path), ye = typeof ge.size == "number" ? ge.size : NaN;
        if (!Number.isSafeInteger(ye) || ye < 0) throw new Error(n("e2e.fxe.size_unknown"));
        const te = ie.purge === !0;
        if (te && typeof ge.id != "number") throw new Error(n("e2e.fxe.purge_no_id"));
        if (Gi(ge.basename)) throw new Error(n("e2e.fxe.bad_name"));
        const Ce = await R(G);
        let Ne = O0(ge.basename, ie.hideName);
        if (ie.hideName)
          for (let Pe = 0; Ce.has(Ne) && Pe < 20; Pe++) Ne = O0(ge.basename, !0);
        else
          Ne = `${W(ge.basename, new Set([...Ce].filter(WT).map((Pe) => Pe.slice(0, -4))))}.fxe`;
        if (Gi(Ne)) throw new Error(n("e2e.fxe.name_too_long"));
        const _e = await Kne(ge.basename, ye, await P(ge.path), ie.password, {
          escrowPublicKey: e.escrowPublicKey()
        });
        await N(G, Ne, _e.stream, _e.size, (Pe) => {
          v.value = _e.size > 0 ? Math.min(100, Math.round(Pe / _e.size * 100)) : 100;
        });
        const Ae = tl(G, Ne);
        if (a.set(Ae, _e.key), i.value++, te) {
          try {
            await _(ge, ge.id);
          } catch (Pe) {
            c.value = null, e.emitError(H(Pe), "fxe-purge-original"), e.toast(n("e2e.fxe.purge_failed", { name: ge.basename, reason: H(Pe) }), !0), e.showRecoveryKey(_e.recoveryKey, ge.basename), await e.reload();
            return;
          }
          c.value = null, e.showRecoveryKey(_e.recoveryKey, ge.basename), e.toast(n("e2e.fxe.purged", { name: ge.basename })), await e.reload();
          return;
        }
        try {
          await J(ge.path);
        } catch (Pe) {
          c.value = null, e.emitError(H(Pe), "fxe-trash-original"), e.toast(n("e2e.fxe.original_kept", { name: ge.basename }), !0), e.showRecoveryKey(_e.recoveryKey, ge.basename), await e.reload();
          return;
        }
        c.value = null, e.showRecoveryKey(_e.recoveryKey, ge.basename), e.toast(n("e2e.fxe.encrypted", { name: ge.basename })), await e.reload();
      } catch (G) {
        m.value = G instanceof Xa ? n("e2e.fxe.upload_too_big") : H(G), e.emitError(H(G), "fxe-encrypt");
      } finally {
        p.value = !1, v.value = null;
      }
    }
  }
  function K(ie, ge) {
    x.value = ie, w.value = ge, k.value = null, C.value = !1, b.value = null, T.value = !0, A.value = "off", L.value = null, a.has(ie.path) || I(ie);
  }
  async function I(ie) {
    var ge, G, ye;
    try {
      const { header: te, body: Ce } = await j(ie.path);
      if (await Ce.cancel().catch(() => {
      }), ((ge = x.value) == null ? void 0 : ge.path) !== ie.path) return;
      T.value = L0(te), A.value = sS(nb(te), ((G = e.escrowKid) == null ? void 0 : G.call(e)) ?? null), L.value = ((ye = te.esc) == null ? void 0 : ye.kid) ?? null;
    } catch {
    }
  }
  async function Y(ie, ge) {
    const G = await t.e2eEscrowChallenge(ie), ye = new Uint8Array(
      await crypto.subtle.decrypt({ name: "RSA-OAEP" }, ge, ea(G.challenge).buffer)
    );
    await t.e2eEscrowUsed({ path: ie, id: G.id, nonce: Ma(ye) });
  }
  function B() {
    S.value || (x.value = null, C.value = !1);
  }
  async function V(ie) {
    const ge = a.get(ie.path);
    if (!ge) {
      K(ie, "open");
      return;
    }
    try {
      await kt(ie, ge);
    } catch (G) {
      at(ie, G, "fxe-open");
    }
  }
  async function be(ie) {
    if (await St(ie)) return;
    const ge = a.get(ie.path);
    if (!ge) {
      K(ie, "download");
      return;
    }
    try {
      await ht(ie, ge);
    } catch (G) {
      if (G instanceof Uf) {
        K(ie, "download"), C.value = !0;
        return;
      }
      at(ie, G, "fxe-download");
    }
  }
  function Fe(ie) {
    K(ie, "remove");
  }
  function ze(ie) {
    return `"${ie.replace(/(["\\$`])/g, "\\$1")}"`;
  }
  function Ue(ie, ge, G) {
    var te;
    const ye = pl(ie.path);
    q.value = {
      name: ((te = a.get(ie.path)) == null ? void 0 : te.name) ?? ie.basename,
      size: ge,
      limit: G,
      encrypted: { kind: "file", path: ie.path },
      command: `filex decrypt ${ze(ye)}`
    };
  }
  function We(ie, ge, G, ye) {
    const te = pl(ge) || "filex";
    q.value = {
      name: ie,
      size: G,
      limit: ye,
      encrypted: { kind: "folder", path: ge },
      command: `filex decrypt ${ze(`${te}.zip`)}`
    };
  }
  function $t() {
    q.value = null;
  }
  async function St(ie) {
    var ye;
    if (qne()) return !1;
    const ge = (ye = a.get(ie.path)) == null ? void 0 : ye.header.size;
    let G = typeof ge == "number" ? ge : null;
    if (G === null) {
      if (typeof ie.size != "number" || ie.size <= vi) return !1;
      try {
        const { header: te, body: Ce } = await j(ie.path);
        await Ce.cancel().catch(() => {
        }), G = te.size;
      } catch {
        return !1;
      }
    }
    return G <= vi ? !1 : (Ue(ie, G, vi), !0);
  }
  function at(ie, ge, G) {
    if (!(ge instanceof Qs)) {
      if (ge instanceof Xa) {
        Ue(ie, ge.size, ge.limit);
        return;
      }
      ge instanceof dn && (a.delete(ie.path), i.value++), e.emitError(H(ge), G), e.toast(ne(ge), !0);
    }
  }
  async function kt(ie, ge) {
    const { header: G, body: ye } = await j(ie.path);
    if (!re(ge, G))
      throw await ye.cancel().catch(() => {
      }), new dn("e2e: the file changed since it was opened");
    if (G.size > vi)
      throw await ye.cancel().catch(() => {
      }), new Xa(G.size, vi);
    const te = op(ge.name), Ce = await I0(yv(ge, ye), ge.name, il(te)), Ne = o.get(ie.path);
    Ne && URL.revokeObjectURL(Ne);
    const _e = URL.createObjectURL(Ce);
    o.set(ie.path, _e), e.openPreview(
      { ...ie, basename: ge.name, extension: te, mime_type: il(te), size: G.size, fxe_name: ge.name },
      _e
    );
  }
  async function ht(ie, ge, G) {
    const ye = await gv(ge.name, ge.header.size);
    let te = !1;
    try {
      const { header: Ce, body: Ne } = await j(ie.path);
      if (!re(ge, Ce))
        throw await Ne.cancel().catch(() => {
        }), new dn("e2e: the file changed since it was opened");
      te = !0, await ye.write(yv(ge, Ne), { mime: il(op(ge.name)) }), e.toast(n("e2e.fxe.downloaded", { name: ge.name }));
    } catch (Ce) {
      throw te || await ye.discard(), Ce;
    }
  }
  async function Ie(ie, ge) {
    const G = Na(ie.path), { header: ye, body: te } = await j(ie.path);
    if (!re(ge, ye))
      throw await te.cancel().catch(() => {
      }), new dn("e2e: the file changed since it was opened");
    const Ce = W(ge.name, await R(G));
    b.value = 0, await N(G, Ce, yv(ge, te), ye.size, (Ne) => {
      b.value = ye.size > 0 ? Math.min(100, Math.round(Ne / ye.size * 100)) : 100;
    }), await J(ie.path), a.delete(ie.path), i.value++, e.toast(n("e2e.fxe.removed", { name: Ce })), await e.reload();
  }
  async function se(ie = {}) {
    const ge = x.value;
    if (!(!ge || S.value)) {
      S.value = !0, k.value = null;
      try {
        let G = a.get(ge.path);
        if (!G || ie.password || ie.recoveryKey || ie.escrowKey) {
          let ye;
          if (ie.escrowKey)
            try {
              ye = { escrowKey: await aS(ie.escrowKey) };
            } catch {
              k.value = n("e2e.recover.bad_escrow_key");
              return;
            }
          else ie.recoveryKey ? ye = { recoveryKey: ie.recoveryKey } : ye = { password: ie.password ?? "" };
          const { header: te, unsupported: Ce, body: Ne } = await j(ge.path);
          if (await Ne.cancel().catch(() => {
          }), T.value = L0(te), Ce.length > 0) {
            k.value = n("e2e.fxe.unsupported", { features: Ce.join(", ") });
            return;
          }
          const _e = await Une(te, ye);
          if ("error" in _e) {
            k.value = _e.error === "damaged" ? n("e2e.fxe.damaged") : "escrowKey" in ye ? n("e2e.fxe.wrong_escrow") : "recoveryKey" in ye ? n("e2e.fxe.wrong_recovery") : n("e2e.fxe.wrong_password");
            return;
          }
          if ("escrowKey" in ye) {
            try {
              await Y(ge.path, ye.escrowKey);
            } catch (Ae) {
              k.value = n("e2e.fxe.escrow_notify_failed"), e.emitError(H(Ae), "fxe-escrow-notify");
              return;
            }
            e.toast(n("e2e.fxe.escrow_done"));
          }
          G = _e.key, a.set(ge.path, G), i.value++;
        }
        if (w.value === "open")
          await kt(ge, G), x.value = null;
        else if (w.value === "download") {
          try {
            await ht(ge, G);
          } catch (ye) {
            if (ye instanceof Uf) {
              C.value = !0;
              return;
            }
            throw ye;
          }
          x.value = null, C.value = !1;
        } else
          await Ie(ge, G), x.value = null;
      } catch (G) {
        if (G instanceof Qs) return;
        if (G instanceof Xa && w.value === "download") {
          x.value = null, Ue(ge, G.size, G.limit);
          return;
        }
        k.value = G instanceof Xa ? n("e2e.dl.too_big", { size: je(G.size), limit: je(G.limit) }) : ne(G), G instanceof dn && (a.delete(ge.path), i.value++), e.emitError(H(G), `fxe-${w.value}`);
      } finally {
        S.value = !1, b.value = null;
      }
    }
  }
  function xe(ie) {
    z.value = ie, U.value = null;
  }
  function me() {
    D.value || (z.value = null);
  }
  async function De(ie) {
    const ge = z.value;
    if (!ge || D.value) return;
    if (!ie.proof) {
      U.value = n("e2e.password.current_required");
      return;
    }
    D.value = !0, U.value = null;
    const G = "recoveryKey" in ie.proof ? "recovery_key" : "password";
    try {
      const { header: ye, unsupported: te, body: Ce } = await j(ge.path);
      if (te.length > 0) {
        await Ce.cancel().catch(() => {
        }), U.value = n("e2e.fxe.unsupported", { features: te.join(", ") });
        return;
      }
      let Ne;
      try {
        Ne = await Vne(ye, ie.proof, ie.newPassword);
      } catch (Pe) {
        if (await Ce.cancel().catch(() => {
        }), Pe instanceof dn) {
          U.value = n(G === "recovery_key" ? "e2e.password.wrong_recovery" : "e2e.password.wrong_current");
          return;
        }
        throw Pe;
      }
      const _e = jne(Ne, Ce);
      await N(Na(ge.path), pl(ge.path), _e.stream, _e.size);
      const Ae = a.get(ge.path);
      Ae && a.set(ge.path, Hne(Ae, Ne)), i.value++, z.value = null, e.toast(n("e2e.fxe.password_done")), await e.reload();
    } catch (ye) {
      U.value = n("e2e.password.failed"), e.emitError(H(ye), "fxe-password");
    } finally {
      D.value = !1;
    }
  }
  async function ot(ie, ge, G, ye) {
    const te = (Ne) => {
      ye ? We(ie.basename, ye, Ne.size, Ne.limit) : e.toast(n("e2e.dl.too_big", { size: je(Ne.size), limit: je(Ne.limit) }), !0);
    };
    let Ce;
    try {
      Ce = await gv(ie.basename, ie.size);
    } catch (Ne) {
      Ne instanceof Xa ? te(Ne) : at(ie, Ne, "e2e-download");
      return;
    }
    try {
      const Ne = Qv(ge, G, await P(ie.path), { passPlain: !0 });
      await Ce.write(Ne, { mime: il(ie.extension) });
    } catch (Ne) {
      if (await Ce.discard(), Ne instanceof Qs) return;
      if (Ne instanceof Xa) {
        te(Ne);
        return;
      }
      e.emitError(H(Ne), "e2e-download"), e.toast(n("e2e.download.failed"), !0);
    }
  }
  async function ft(ie, ge) {
    let G;
    try {
      G = await gv(ge.zipName);
    } catch (Ae) {
      if (Ae instanceof Qs) return;
      if (Ae instanceof Uf) {
        e.toast(n("e2e.dl.click_again"), !0);
        return;
      }
      throw Ae;
    }
    let ye = 0;
    const te = (Ae, Pe) => ({
      name: Pe,
      sizeHint: typeof Ae.size == "number" ? Ae.size : void 0,
      mtime: typeof Ae.last_modified == "number" ? new Date(Ae.last_modified) : void 0,
      data: async () => Qv(ge.fmk, ge.previous, await P(Ae.path), {
        passPlain: !0,
        onPlain: () => ye++
      })
    }), Ce = (Ae) => (Ae.e2e_name_state === "locked" || Ae.e2e_name_state === "unreadable") && typeof Ae.e2e_stored == "string" ? Ae.e2e_stored : Ae.basename;
    async function* Ne(Ae, Pe) {
      yield { name: `${Pe}/` };
      const _t = await t.index(Ae.path), Et = await ge.decorate(_t.files ?? [], { root: ge.root }), xn = /* @__PURE__ */ new Set();
      for (const Dt of Et) {
        if (Dt.basename === ga || typeof Dt.e2e_stored != "string" && Dt.basename === ga) continue;
        const bn = W(Ce(Dt), xn);
        xn.add(bn), Dt.type === "dir" ? yield* Ne(Dt, `${Pe}/${bn}`) : yield te(Dt, `${Pe}/${bn}`);
      }
    }
    async function* _e() {
      const Ae = /* @__PURE__ */ new Set();
      for (const Pe of ie) {
        const _t = W(Ce(Pe), Ae);
        Ae.add(_t), Pe.type === "dir" ? yield* Ne(Pe, _t) : yield te(Pe, _t);
      }
    }
    e.toast(n("e2e.dl.zip_started", { name: ge.zipName }));
    try {
      await G.write(sae(_e()), { mime: "application/zip" }), e.toast(
        ye > 0 ? n("e2e.dl.zip_done_plain", { name: ge.zipName, n: ye }) : n("e2e.dl.zip_done", { name: ge.zipName })
      );
    } catch (Ae) {
      if (await G.discard(), Ae instanceof Qs) return;
      if (Ae instanceof Xa) {
        We(ge.zipName, ge.root, null, Ae.limit);
        return;
      }
      e.emitError(H(Ae), "e2e-download-zip"), e.toast(Ae instanceof dn ? n("e2e.dl.zip_damaged") : n("e2e.download.failed"), !0);
    }
  }
  async function gt(ie, ge) {
    const G = await V_(ge, ie.size, ie.stream());
    return R0(G.stream, G.size);
  }
  async function Ut(ie, ge, G, ye = {}) {
    const te = ie.size;
    if (typeof te != "number" || !Number.isSafeInteger(te) || te < 0)
      throw new Error("e2e: unknown file size");
    const Ce = await V_(ge, te, await P(ie.path)), Ne = ye.onProgress ? (_e) => ye.onProgress(Ce.size > 0 ? Math.min(1, _e / Ce.size) : 1) : void 0;
    try {
      await N(Na(ie.path), ie.basename, Ce.stream, Ce.size, Ne, {
        fields: { e2e_convert: "1", ...G ? { expect: G } : {} },
        signal: ye.signal
      });
    } catch (_e) {
      if (_e instanceof Xa) return !1;
      throw _e;
    }
    return !0;
  }
  async function Xe(ie, ge, G) {
    const ye = new Rp(await P(ie.path)), te = await ye.read(y4);
    if (!Tl(te))
      return await ye.cancel().catch(() => {
      }), !1;
    const Ce = await gS(te.buffer, ge, G);
    if (!Ce)
      return await ye.cancel().catch(() => {
      }), !0;
    const Ne = typeof ie.size == "number" ? ie.size : NaN;
    if (!Number.isSafeInteger(Ne))
      throw await ye.cancel().catch(() => {
      }), new Error("e2e: unknown file size");
    const _e = typeof ie.e2e_stored == "string" ? ie.e2e_stored : ie.basename;
    return await N(Na(ie.path), _e, Fc(new Uint8Array(Ce), ye.rest()), Ne), !0;
  }
  const { formatSize: je } = pt(() => e.locale() ?? "en");
  async function Be(ie, ge, G) {
    var te;
    const ye = ge[0];
    switch (ie) {
      case "fxe-encrypt":
        return ye && ae(ye), !0;
      case "fxe-request":
        return ye && ((te = e.requestEncrypt) == null || te.call(e, ye)), !0;
      case "fxe-download-raw":
        return ye && window.open(t.downloadUrl(ye.path), "_blank"), !0;
      case "fxe-password":
        return ye && xe(ye), !0;
      case "fxe-remove":
        return ye && Fe(ye), !0;
      case "e2e-download-encrypted":
        return await G(ge), !0;
    }
    return !1;
  }
  return {
    ringVer: i,
    realName: he,
    isHiddenFxeName: Dne,
    menuRows: ue,
    dispatch: Be,
    // encrypt
    encryptTarget: c,
    encryptBusy: p,
    encryptError: m,
    encryptProgress: v,
    startEncrypt: ae,
    closeEncrypt: fe,
    submitEncrypt: Q,
    // open / download / remove
    unlockTarget: x,
    unlockIntent: w,
    unlockBusy: S,
    unlockError: k,
    unlockProgress: b,
    unlockNeedsSave: C,
    unlockHasRecovery: T,
    unlockEscrow: A,
    unlockEscrowKid: L,
    open: V,
    download: be,
    startRemove: Fe,
    closeUnlock: B,
    submitUnlock: se,
    // password
    pwTarget: z,
    pwBusy: D,
    pwError: U,
    // too big for this browser
    tooBig: q,
    closeTooBig: $t,
    startPassword: xe,
    closePassword: me,
    submitPassword: De,
    // encrypted folders
    downloadFolderFile: ot,
    downloadDecryptedZip: ft,
    folderUploadSource: gt,
    convertLarge: Ut,
    rewrapLarge: Xe,
    revokeAll: l
  };
}
function fae(e, t) {
  const n = String(t ?? "").replace(/\/+$/, "");
  return n === e ? "" : n.slice(e.length + 1);
}
function pae(e) {
  const t = new Set(hae()), n = b2({}), a = $(0);
  let i = null, o = null;
  function l(b) {
    t.has(b) || (t.add(b), N0([...t]));
  }
  function c(b) {
    t.delete(b) && N0([...t]);
  }
  function p(b) {
    const C = String(b ?? "").replace(/\/+$/, "");
    let T = null;
    for (const A of [...(i == null ? void 0 : i.openRoots()) ?? [], ...t])
      (C === A || C.startsWith(A + "/")) && (!T || A.length > T.length) && (T = A);
    return T;
  }
  function m() {
    return [.../* @__PURE__ */ new Set([...(i == null ? void 0 : i.openRoots()) ?? [], ...t])];
  }
  const v = { strips: n, version: a, rootOf: p, remember: l };
  function x() {
    return i ? Promise.resolve(i) : (o || (o = import("./e2eVaultEngine-DPQR7NDk.js").then(
      (b) => i = b.createVaultEngine(e, v),
      (b) => {
        throw o = null, b;
      }
    )), o);
  }
  function w(b) {
    return !!b && typeof b.vault_root == "string" && !!b.vault_root;
  }
  function S(b) {
    if (i) {
      i.lock(b);
      return;
    }
    e.dropKeys(b), e.onLocked(b, "manual");
  }
  function k() {
    i == null || i.onPageHide();
  }
  return {
    version: a,
    strips: n,
    rootOf: p,
    roots: m,
    isVaultRow: w,
    forget: c,
    relOf: fae,
    isOpen: (b) => !!(i != null && i.isOpen(b)),
    permOf: (b) => i == null ? void 0 : i.permOf(b),
    node: (...b) => (i == null ? void 0 : i.node(...b)) ?? null,
    rows: (...b) => (i == null ? void 0 : i.rows(...b)) ?? null,
    search: (...b) => (i == null ? void 0 : i.search(...b)) ?? null,
    close: (...b) => i == null ? void 0 : i.close(...b),
    closeAll: (...b) => i == null ? void 0 : i.closeAll(...b),
    touch: (...b) => i == null ? void 0 : i.touch(...b),
    onVisible: () => i == null ? void 0 : i.onVisible(),
    onEvent: (...b) => i == null ? void 0 : i.onEvent(...b),
    dismiss: (...b) => i == null ? void 0 : i.dismiss(...b),
    lock: S,
    onPageHide: k,
    open: async (...b) => (await x()).open(...b),
    create: async (...b) => (await x()).create(...b),
    readBytes: async (...b) => (await x()).readBytes(...b),
    readUrl: async (...b) => (await x()).readUrl(...b),
    /** filex 0.56 (#189): an app's interface reads / saves a file of an open
     *  vault (lib/appPlaintext createAppVaultDoor). No engine: no vault is
     *  open, so nothing is loaded for it. */
    readForApp: async (...b) => i ? i.readForApp(...b) : { ok: !1, why: "locked" },
    saveForApp: async (...b) => i ? i.saveForApp(...b) : { ok: !1, why: "locked" },
    keyForApp: (...b) => (i == null ? void 0 : i.keyForApp(...b)) ?? null,
    download: async (...b) => (await x()).download(...b),
    upload: async (...b) => (await x()).upload(...b),
    mkdir: async (...b) => (await x()).mkdir(...b),
    rename: async (...b) => (await x()).rename(...b),
    move: async (...b) => (await x()).move(...b),
    copy: async (...b) => (await x()).copy(...b),
    remove: async (...b) => (await x()).remove(...b),
    takeOver: async (...b) => (await x()).takeOver(...b),
    continueFromShown: async (...b) => (await x()).continueFromShown(...b),
    /** The person's idle time (minutes, 1-10), kept on the server. */
    idlePrefs: {
      get: async () => (await x()).idlePrefs.get(),
      set: async (b) => (await x()).idlePrefs.set(b)
    }
  };
}
const eA = "filex.e2e.vaults", tA = 200;
function hae() {
  try {
    const e = typeof localStorage > "u" ? null : localStorage.getItem(eA), t = e ? JSON.parse(e) : [];
    return Array.isArray(t) ? t.filter((n) => typeof n == "string" && n.includes("://")).slice(-tA) : [];
  } catch {
    return [];
  }
}
function N0(e) {
  try {
    typeof localStorage < "u" && localStorage.setItem(eA, JSON.stringify(e.slice(-tA)));
  } catch {
  }
}
const mae = {
  class: "fe-e2e-names__hint",
  "data-testid": "e2e-request-lead"
}, vae = { class: "fe-field" }, yae = { class: "fe-field__label" }, gae = ["placeholder", "disabled"], bae = {
  key: 0,
  class: "fe-form__error",
  role: "alert",
  "data-testid": "e2e-request-error"
}, kae = ["disabled"], wae = ["disabled", "aria-busy"], _ae = /* @__PURE__ */ lt({
  __name: "E2eRequestModal",
  props: {
    open: { type: Boolean },
    locale: {},
    api: {},
    path: {},
    kind: {},
    name: {}
  },
  emits: ["close", "sent"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = pt(() => n.locale), o = E(
      () => n.kind === "file" ? i("e2e.request.lead_file") : n.kind === "folder" ? i("e2e.request.lead_folder") : i("e2e.request.lead")
    ), l = E(() => Pc("e2e_request_reason_max_runes")), c = $("");
    Je(c, (x) => {
      const w = Dy(x, l.value);
      w !== x && (c.value = w);
    });
    const p = $(!1), m = $(null);
    Je(
      () => n.open,
      (x) => {
        x && (c.value = "", m.value = null);
      }
    );
    async function v() {
      if (p.value) return;
      const x = c.value.trim();
      if (!x) {
        m.value = i("e2e.request.reason_required");
        return;
      }
      p.value = !0, m.value = null;
      try {
        const w = await n.api.e2eRequest({ path: n.path, kind: n.kind, reason: x });
        a("sent", w);
      } catch (w) {
        m.value = H2(w, i("e2e.request.failed"), { t: i }).text;
      } finally {
        p.value = !1;
      }
    }
    return (x, w) => (f(), Ge(ta, {
      open: e.open,
      locale: e.locale,
      title: u(i)("e2e.request.title", { name: e.name }),
      size: "sm",
      busy: p.value,
      onClose: w[2] || (w[2] = (S) => a("close"))
    }, {
      actions: mt(() => [
        d("button", {
          type: "button",
          class: "fe-btn",
          disabled: p.value,
          onClick: w[1] || (w[1] = (S) => a("close"))
        }, y(u(i)("modal.newfolder.cancel")), 9, kae),
        d("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          disabled: p.value,
          "aria-busy": p.value ? "true" : void 0,
          "data-testid": "e2e-request-send",
          onClick: v
        }, y(p.value ? u(i)("e2e.request.sending") : u(i)("e2e.request.send")), 9, wae)
      ]),
      default: mt(() => [
        d("form", {
          class: "fe-e2e-form",
          "data-testid": "e2e-request",
          onSubmit: yt(v, ["prevent"])
        }, [
          d("p", mae, y(o.value), 1),
          d("label", vae, [
            d("span", yae, y(u(i)("e2e.request.reason")), 1),
            ln(d("textarea", {
              "onUpdate:modelValue": w[0] || (w[0] = (S) => c.value = S),
              class: "fe-input",
              rows: "4",
              placeholder: u(i)("e2e.request.reason_placeholder"),
              disabled: p.value,
              "data-testid": "e2e-request-reason"
            }, null, 8, gae), [
              [_n, c.value]
            ])
          ]),
          m.value ? (f(), h("p", bae, y(m.value), 1)) : O("", !0)
        ], 32)
      ]),
      _: 1
    }, 8, ["open", "locale", "title", "busy"]));
  }
}), xae = /* @__PURE__ */ new Set(["none", "viewer", "editor", "owner"]);
function B0(e) {
  if (typeof e != "string" || !e) return;
  const t = Date.parse(e);
  return Number.isFinite(t) ? t : void 0;
}
function Sae(e, t) {
  var S;
  const n = String((e == null ? void 0 : e.path) ?? "").replace(/^\/+/, "");
  if (!n) return null;
  const a = t.storages ?? [], i = typeof e.storage == "string" && e.storage ? e.storage : a.length === 1 ? a[0].name : "";
  if (t.multiStorageRoot && !i) return null;
  const o = String(e.name ?? n.split("/").pop() ?? ""), l = e.type === "dir", c = e.type === "symlink", p = typeof e.size == "number" ? e.size : 0, m = typeof e.id == "number" ? e.id : void 0, v = typeof e.perm == "string" && xae.has(e.perm) ? e.perm : void 0, x = ((S = a.find((k) => k.name === i)) == null ? void 0 : S.readOnly) === !0, w = typeof e.read_only == "boolean" ? e.read_only : x;
  return {
    type: l ? "dir" : "file",
    id: m,
    /* tablo:t1 — ⚠⚠ THE DATE. A node row carries `backend_mtime` (what the
       storage says) and `db_mtime` (what our last scan recorded) as RFC3339
       strings; `FileNode.last_modified` is unix MILLISECONDS. Nothing mapped
       between the two, so every row from Recent, Starred and a tag view
       arrived with no date at all — measured on Recent: eleven rows, eleven em
       dashes in the Modified column, and a Modified column header you could
       click that then sorted nothing. It also made the date grouping this view
       is supposed to show impossible, because every row fell in the "No date"
       bucket. Storage first: `backend_mtime` is the file's own truth and
       `db_mtime` only says when we last looked at it. */
    last_modified: B0(e.backend_mtime) ?? B0(e.db_mtime),
    path: i ? `${i}://${n}` : n,
    basename: o,
    extension: l ? "" : o.includes(".") ? (o.split(".").pop() || "").toLowerCase() : "",
    storage: i,
    visibility: "private",
    size: p,
    file_size: p,
    mime_type: typeof e.mime == "string" ? e.mime : "",
    ...v ? { perm: v } : {},
    read_only: w,
    /* #207 (0.54) — whether the row is starred is the row's own fact: the
       server puts `starred: true` on every listing and view row it answers
       (handlers/meta.go), and the explorer no longer fetches a star list of
       its own to match ids against. Dropped here, every Starred / Recent /
       tag / Home row read as unstarred, so the menu offered "Star" on a file
       in Starred and the inline star was hollow. */
    ...e.starred === !0 ? { starred: !0 } : {},
    /* ...and WHY it will not open, under the folder listing's own name: the
       node row carries the reason the sync recorded (`link_state`, migration
       00098), so the badge here says "Outside storage" exactly where the
       folder says it. A row without one reads as the general "Link". */
    ...c ? {
      symlink: !0,
      ...typeof e.link_state == "string" && e.link_state ? { link_state: e.link_state } : {}
    } : {},
    /* issue #104 - an entry the storage could not answer for. The raw node
       row carries the flag and the storage's answer under the same names the
       folder listing uses, so Recent, Starred, a tag view and Home badge it
       and refuse it exactly as the folder does (lib/unavailable). */
    ...e.unavailable === !0 ? {
      unavailable: !0,
      ...typeof e.unavailable_reason == "string" ? { unavailable_reason: e.unavailable_reason } : {}
    } : {},
    // ⚠⚠ The SERVER's `thumb_url`, never one built here. It used to be
    // `/api/files/thumb/<id>` for every file, and the endpoint answers
    // `404 "not ready"` for everything it has not rendered — a docx, a
    // markdown note, a diagram: opening Recent with ten such files fired ten
    // requests and all ten 404'd (2026-09-21). The rows now carry the URL
    // exactly when there is an image behind it (handlers/meta.go, the folder
    // listing's rule), so a file with none is never asked about.
    thumb_url: !l && typeof e.thumb_url == "string" && e.thumb_url ? e.thumb_url : void 0,
    /* wiring:e2 names — the encrypted folder the row sits in (the server
       answers it for rows outside a folder listing). The explorer's name view
       reads it to name the row, and openNode to open it in its folder. */
    ...typeof e.e2e_root == "string" && e.e2e_root ? { e2e_root: e.e2e_root } : {},
    /* #189 - how the file is end-to-end encrypted, as the SERVER stamps the
       row (`folder` / `vault` / `file`, handlers/meta.go, the folder
       listing's rule). An app's interface opened from Recent, Starred, a tag
       view or Home is handed it as is (FileInfo.encrypted); dropped here, it
       was told an encrypted file is not. */
    ...Qu(e.encrypted) ? { encrypted: e.encrypted } : {},
    extra_metadata: {}
  };
}
const $ae = /* @__PURE__ */ new Set(["none", "viewer", "editor", "owner"]);
function Tae(e) {
  return typeof e == "string" && $ae.has(e);
}
function Aae(e, t) {
  return Tae(t) ? e.map((n) => typeof n.perm == "string" ? n : { ...n, perm: t }) : e;
}
function Eae(e, t) {
  if (!e)
    return t || void 0;
}
function kv(e, t) {
  return e.openInHost && t.type === "file" ? "host" : "page";
}
class nA extends Error {
}
const Cae = 1500;
function aA(e) {
  try {
    const t = JSON.parse(e);
    return t && typeof t == "object" ? t : {};
  } catch {
    return {};
  }
}
async function zae(e) {
  return aA(await e.text().catch(() => ""));
}
async function Mae(e, t = Cae) {
  var c, p, m, v;
  const n = e.sleep ?? ((x) => new Promise((w) => setTimeout(w, x))), a = await e.start(), i = await a.text().catch(() => ""), o = aA(i);
  let l;
  if (a.status === 409 && o.code === "BUSY") {
    const x = o.job;
    if (!(x != null && x.running))
      throw new nA(typeof o.message == "string" && o.message ? o.message : String(o.error ?? "busy"));
    (c = e.onBusy) == null || c.call(e, typeof o.message == "string" ? o.message : ""), l = x;
  } else if (a.ok)
    l = o;
  else
    throw fa(a.status, i, e.locale);
  for ((p = e.onStart) == null || p.call(e, l); l.running; ) {
    if ((m = e.onProgress) == null || m.call(e, l), await n(t), (v = e.stopped) != null && v.call(e)) return null;
    try {
      const x = await e.status(), w = x.ok ? await zae(x) : {};
      typeof w.running == "boolean" && (l = w);
    } catch {
    }
  }
  return l;
}
function F0(e) {
  const t = String(e ?? "").indexOf("://");
  return t === -1 ? "" : e.slice(0, t);
}
function U0(e, t, n = "auto") {
  const a = F0(t), i = e.some((o) => {
    const l = F0(o);
    return l !== "" && a !== "" && l !== a;
  });
  return n === "copy" ? { kind: "copy", cross: i } : n === "move" ? { kind: "move", cross: i } : { kind: i ? "copy" : "move", cross: i };
}
function iA(e) {
  return e.split("?")[0].replace(/\/manager$/, "/archive/download");
}
const H0 = "/api/files/manager";
function oA(e, t) {
  if (/^https?:\/\//i.test(t)) return t;
  const n = e.split("?")[0];
  if (n.endsWith(H0)) return Ly(n.slice(0, -H0.length), t);
  const a = /^(https?:\/\/[^/]+)/i.exec(n);
  return a ? a[1] + t : t;
}
async function Pae(e, t, n) {
  const a = iA(e.endpoints.manager);
  return e.jsonFetch(a, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(n ? { paths: t, name: n } : { paths: t })
  });
}
async function Oae(e, t) {
  const n = await e.jsonFetch(
    iA(e.endpoints.manager),
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ paths: [t], mode: "file" })
    }
  );
  if (!n || n.mode !== "file" || typeof n.url != "string") return null;
  const a = Number(n.ttl_seconds);
  return {
    url: oA(e.endpoints.manager, n.url),
    ttlMs: Number.isFinite(a) && a > 0 ? a * 1e3 : 6e4
  };
}
const Lae = 6e4;
function Dae(e, t = document) {
  const n = t.createElement("iframe");
  n.hidden = !0, n.setAttribute("aria-hidden", "true"), n.style.display = "none", n.src = e, t.body.appendChild(n), setTimeout(() => n.remove(), Lae);
}
async function Rae(e, t, n = {}) {
  const a = await Pae(e, t, n.name);
  return Dae(
    oA(e.endpoints.manager, a.url),
    n.doc ?? document
  ), a;
}
function rA(e) {
  return String(e.path ?? "").replace(/^\/+|\/+$/g, "");
}
function Cy(e, t) {
  return typeof e.storage == "string" && e.storage ? e.storage : typeof e.storage_name == "string" && e.storage_name ? e.storage_name : t.configured.length === 1 && t.configured[0] ? t.configured[0] : t.current || "";
}
function Kf(e, t) {
  const n = String(e.path ?? "").replace(/^\/+/, ""), a = typeof e.storage == "string" && e.storage ? e.storage : t, i = String(e.name ?? n.split("/").pop() ?? ""), o = i.lastIndexOf("."), l = typeof e.backend_mtime == "string" ? e.backend_mtime : e.updated_at, c = typeof l == "string" ? Date.parse(l) : NaN;
  return {
    id: typeof e.id == "number" ? e.id : void 0,
    path: a ? `${a}://${n}` : n,
    basename: i,
    relativePath: n,
    type: e.type === "dir" ? "dir" : "file",
    extension: o > 0 ? i.slice(o + 1).toLowerCase() : "",
    size: typeof e.size == "number" ? e.size : 0,
    // ⚠ Left UNSET when the row carries no parseable timestamp rather than
    // defaulted to 0 or to now: `matchesModified` treats a missing timestamp
    // as "unknown" and drops the row from a date filter, which is the honest
    // answer. Stamping it with `Date.now()` would file every such file under
    // "Today".
    last_modified: Number.isNaN(c) ? void 0 : c,
    mime_type: typeof e.mime == "string" ? e.mime : "",
    /* The content snippet the hit came with, so a content match can show why
       it matched. Undefined on name-only hits, exactly as the backend sends. */
    snippet: typeof e.snippet == "string" && e.snippet ? e.snippet : void 0,
    /* Owner, so the People filter and the Owner column mean the same thing in a
       content result as they do in a folder listing. Undefined rather than
       guessed when the backend does not send it. */
    owner_id: typeof e.owner_id == "number" ? e.owner_id : void 0,
    owner_name: typeof e.owner_name == "string" ? e.owner_name : void 0,
    owner_self: e.owner_self === !0 ? !0 : void 0,
    /* wiring:e2 names — the encrypted folder the hit sits in (the server
       answers it); the explorer's name view reads it. */
    ...typeof e.e2e_root == "string" && e.e2e_root ? { e2e_root: e.e2e_root } : {},
    /* #189 - how the hit is end-to-end encrypted, as the server stamps it
       (`folder` / `vault` / `file`); an app's interface opened from a
       search result is handed it as is (FileInfo.encrypted). */
    ...Qu(e.encrypted) ? { encrypted: e.encrypted } : {}
  };
}
function Iae(e, t) {
  const n = Cy(e, t);
  if (!rA(e) || !n) return null;
  const a = Kf(e, n);
  return {
    path: a.path,
    basename: a.basename,
    type: a.type,
    ...a.e2e_root ? { e2e_root: a.e2e_root } : {},
    ...a.encrypted ? { encrypted: a.encrypted } : {}
  };
}
function jhe(e, t) {
  var i;
  const n = [], a = /* @__PURE__ */ new Map();
  for (const o of e) {
    const l = ((i = o.account) == null ? void 0 : i.id) ?? "";
    let c = a.get(l);
    c || (c = { account: o.account, hits: [] }, a.set(l, c), n.push(c)), c.hits.length < t && c.hits.push(o);
  }
  return n;
}
function Nae(e) {
  if (!e) return [];
  const t = e.items;
  if (t && t.length > 0) {
    const n = [];
    let a = !1;
    for (let i = 0; i < t.length; i++) {
      const o = t[i];
      if (!o || o.kind !== "file") continue;
      a = !0;
      const l = o.webkitGetAsEntry ?? o.getAsEntry, c = typeof l == "function" ? l.call(o) : null;
      if (c && c.isDirectory) {
        n.push({ kind: "entry", entry: c });
        continue;
      }
      const p = o.getAsFile();
      p ? n.push({ kind: "file", file: p }) : c && c.isFile && n.push({ kind: "entry", entry: c });
    }
    if (a) return n;
  }
  return Array.from(e.files ?? []).map((n) => ({ kind: "file", file: n }));
}
function Bae(e) {
  return new Promise((t, n) => {
    if (typeof e.file != "function") {
      n(new Error("not a file entry"));
      return;
    }
    e.file(t, n);
  });
}
async function Fae(e) {
  if (typeof e.createReader != "function") throw new Error("not a folder entry");
  const t = e.createReader(), n = [];
  for (; ; ) {
    const a = await new Promise((i, o) => t.readEntries(i, o));
    if (a.length === 0) return n;
    n.push(...a);
  }
}
function Uae(e, t) {
  return e ? `${e}/${t}` : t;
}
async function Hae(e) {
  const t = { dirs: [], files: [], unreadable: [] }, n = async (a, i) => {
    const o = Uae(i, a.name);
    if (a.isDirectory) {
      let l;
      try {
        l = await Fae(a);
      } catch {
        t.unreadable.push(o);
        return;
      }
      t.dirs.push(o);
      for (const c of l) await n(c, o);
      return;
    }
    if (a.isFile)
      try {
        t.files.push({ file: await Bae(a), dir: i });
      } catch {
        t.unreadable.push(o);
      }
  };
  for (const a of e)
    a.kind === "file" ? t.files.push({ file: a.file, dir: "" }) : await n(a.entry, "");
  return t;
}
function Kae(e) {
  const t = /* @__PURE__ */ new Set();
  for (const { dir: n } of e.files)
    for (let a = n; a; a = a.includes("/") ? a.slice(0, a.lastIndexOf("/")) : "") t.add(a);
  return e.dirs.filter((n) => !t.has(n));
}
async function Vae(e, t, n) {
  const a = /* @__PURE__ */ new Map([["", t]]);
  for (const o of e.dirs) {
    const l = o.lastIndexOf("/"), c = a.get(l === -1 ? "" : o.slice(0, l));
    if (c !== void 0)
      try {
        a.set(o, await n.mkdir(c, o.slice(l + 1)));
      } catch (p) {
        n.failed(o, p);
      }
  }
  const i = /* @__PURE__ */ new Map();
  for (const { file: o, dir: l } of e.files) {
    const c = i.get(l);
    c ? c.push(o) : i.set(l, [o]);
  }
  for (const [o, l] of i) {
    const c = a.get(o);
    if (c !== void 0)
      try {
        await n.upload(l, c);
      } catch (p) {
        n.failed(o || l[0].name, p);
      }
  }
}
function jae(e, t) {
  return Object.defineProperty(e, "webkitRelativePath", { value: t, configurable: !0 }), e;
}
const qae = { class: "fe-field" }, Wae = { class: "fe-field__label" }, Yae = ["onKeydown"], Gae = {
  key: 0,
  class: "fe-form__error",
  role: "alert"
}, Xae = ["innerHTML"], Jae = ["innerHTML"], Zae = ["disabled"], Qae = ["disabled", "aria-busy"], eie = /* @__PURE__ */ lt({
  __name: "NewFolderModal",
  props: {
    open: { type: Boolean },
    locale: {},
    encryptedOption: { type: Boolean },
    encryptedRequest: { type: Boolean },
    error: {},
    busy: { type: Boolean }
  },
  emits: ["close", "submit", "encrypted", "request-encrypted"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = pt(() => n.locale), o = $(""), l = $(null);
    Je(() => n.open, (p) => {
      p && (o.value = "", l.value = null);
    }), Je(
      () => n.error,
      (p) => {
        p && (l.value = p);
      }
    );
    function c() {
      if (n.busy) return;
      const p = Hy(o.value), m = Y2(p);
      if (m === "empty") {
        l.value = i("modal.newfolder.placeholder");
        return;
      }
      if (m) {
        l.value = i("modal.newfolder.invalid");
        return;
      }
      if (zp(p)) {
        l.value = i("names.reserved", { name: p });
        return;
      }
      a("submit", p);
    }
    return (p, m) => (f(), Ge(ta, {
      open: e.open,
      title: u(i)("modal.newfolder.title"),
      size: "sm",
      busy: e.busy,
      onClose: m[4] || (m[4] = (v) => a("close"))
    }, {
      actions: mt(() => [
        d("button", {
          type: "button",
          class: "fe-btn",
          disabled: e.busy,
          onClick: m[3] || (m[3] = (v) => a("close"))
        }, y(u(i)("modal.newfolder.cancel")), 9, Zae),
        d("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          disabled: e.busy,
          "aria-busy": e.busy ? "true" : void 0,
          onClick: c
        }, y(e.busy ? u(i)("modal.newfolder.creating") : u(i)("modal.newfolder.create")), 9, Qae)
      ]),
      default: mt(() => [
        d("form", {
          onSubmit: yt(c, ["prevent"])
        }, [
          d("label", qae, [
            d("span", Wae, y(u(i)("modal.newfolder.placeholder")), 1),
            ln(d("input", {
              "onUpdate:modelValue": m[0] || (m[0] = (v) => o.value = v),
              type: "text",
              class: "fe-input",
              autocomplete: "off",
              onKeydown: Ca(yt(c, ["prevent"]), ["enter"])
            }, null, 40, Yae), [
              [_n, o.value]
            ])
          ]),
          l.value ? (f(), h("p", Gae, y(l.value), 1)) : O("", !0),
          e.encryptedOption !== !1 ? (f(), h("button", {
            key: 1,
            type: "button",
            class: "fe-e2e-optlink",
            onClick: m[1] || (m[1] = (v) => a("encrypted"))
          }, [
            d("span", {
              class: "fe-e2e-optlink__icon",
              "aria-hidden": "true",
              innerHTML: u(zt)("lock")
            }, null, 8, Xae),
            Ht(" " + y(u(i)("e2e.create.option")), 1)
          ])) : e.encryptedRequest ? (f(), h("button", {
            key: 2,
            type: "button",
            class: "fe-e2e-optlink",
            "data-testid": "e2e-request-option",
            onClick: m[2] || (m[2] = (v) => a("request-encrypted"))
          }, [
            d("span", {
              class: "fe-e2e-optlink__icon",
              "aria-hidden": "true",
              innerHTML: u(zt)("lock")
            }, null, 8, Jae),
            Ht(" " + y(u(i)("e2e.request.option")), 1)
          ])) : O("", !0)
        ], 32)
      ]),
      _: 1
    }, 8, ["open", "title", "busy"]));
  }
}), tie = { class: "fe-field__hint" }, nie = { class: "fe-field" }, aie = { class: "fe-field__label" }, iie = ["disabled"], oie = {
  key: 0,
  class: "fe-form__error"
}, rie = ["disabled"], sie = ["disabled", "aria-busy"], lie = /* @__PURE__ */ lt({
  __name: "ArchiveExtractModal",
  props: {
    open: { type: Boolean },
    locale: {},
    archiveName: {},
    suggestedFolder: {},
    busy: { type: Boolean },
    error: {}
  },
  emits: ["close", "submit"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = pt(() => n.locale), o = $(""), l = $("");
    Je(() => n.open, (p) => {
      p && (o.value = n.suggestedFolder, l.value = "");
    });
    function c() {
      if (!n.busy) {
        if (!o.value.trim() || /[\\/]/.test(o.value)) {
          l.value = i("archive.invalid_folder");
          return;
        }
        a("submit", { folder: o.value.trim() });
      }
    }
    return (p, m) => (f(), Ge(ta, {
      open: e.open,
      title: u(i)("archive.extract_title"),
      size: "sm",
      busy: e.busy,
      onClose: m[2] || (m[2] = (v) => a("close"))
    }, {
      actions: mt(() => [
        d("button", {
          type: "button",
          class: "fe-btn",
          disabled: e.busy,
          onClick: m[1] || (m[1] = (v) => a("close"))
        }, y(u(i)("archive.cancel")), 9, rie),
        d("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          disabled: e.busy,
          "aria-busy": e.busy ? "true" : void 0,
          onClick: c
        }, y(e.busy ? u(i)("archive.extracting") : u(i)("archive.extract_to_folder")), 9, sie)
      ]),
      default: mt(() => [
        d("form", {
          class: "fe-form",
          onSubmit: yt(c, ["prevent"])
        }, [
          d("p", tie, y(e.archiveName), 1),
          d("label", nie, [
            d("span", aie, y(u(i)("archive.destination_folder")), 1),
            ln(d("input", {
              "onUpdate:modelValue": m[0] || (m[0] = (v) => o.value = v),
              class: "fe-input",
              autocomplete: "off",
              disabled: e.busy
            }, null, 8, iie), [
              [_n, o.value]
            ])
          ]),
          l.value || e.error ? (f(), h("p", oie, y(l.value || e.error), 1)) : O("", !0)
        ], 32)
      ]),
      _: 1
    }, 8, ["open", "title", "busy"]));
  }
}), uie = { class: "fe-field__hint" }, cie = { class: "fe-field" }, die = { class: "fe-field__label" }, fie = ["disabled"], pie = {
  key: 0,
  class: "fe-form__error",
  role: "alert"
}, hie = ["disabled"], mie = ["disabled", "aria-busy"], vie = /* @__PURE__ */ lt({
  __name: "ArchivePasswordModal",
  props: {
    open: { type: Boolean },
    locale: {},
    archiveName: {},
    busy: { type: Boolean },
    error: {}
  },
  emits: ["close", "submit"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = pt(() => n.locale), o = $("");
    Je(() => n.open, (c) => {
      c && (o.value = "");
    });
    function l() {
      !o.value || n.busy || a("submit", o.value);
    }
    return (c, p) => (f(), Ge(ta, {
      open: e.open,
      title: u(i)("archive.password_title"),
      size: "sm",
      busy: e.busy,
      onClose: p[2] || (p[2] = (m) => a("close"))
    }, {
      actions: mt(() => [
        d("button", {
          type: "button",
          class: "fe-btn",
          disabled: e.busy,
          onClick: p[1] || (p[1] = (m) => a("close"))
        }, y(u(i)("archive.cancel")), 9, hie),
        d("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          disabled: e.busy || !o.value,
          "aria-busy": e.busy ? "true" : void 0,
          onClick: l
        }, y(e.busy ? u(i)("archive.opening") : u(i)("archive.continue")), 9, mie)
      ]),
      default: mt(() => [
        d("form", {
          class: "fe-form",
          onSubmit: yt(l, ["prevent"])
        }, [
          d("p", uie, y(e.archiveName), 1),
          d("label", cie, [
            d("span", die, y(u(i)("archive.password_required")), 1),
            ln(d("input", {
              "onUpdate:modelValue": p[0] || (p[0] = (m) => o.value = m),
              class: "fe-input",
              type: "password",
              autocomplete: "off",
              "data-1p-ignore": "",
              "data-bwignore": "true",
              "data-lpignore": "true",
              autofocus: "",
              disabled: e.busy
            }, null, 8, fie), [
              [_n, o.value]
            ])
          ]),
          e.error ? (f(), h("p", pie, y(e.error), 1)) : O("", !0)
        ], 32)
      ]),
      _: 1
    }, 8, ["open", "title", "busy"]));
  }
}), yie = {
  class: "fe-draftq",
  "data-testid": "draft-taken-dialog"
}, gie = { class: "fe-draftq__body" }, bie = {
  key: 0,
  class: "fe-form__error",
  role: "alert"
}, kie = ["disabled"], wie = ["disabled", "aria-busy"], K0 = /* @__PURE__ */ lt({
  __name: "DraftConflictModal",
  props: {
    open: { type: Boolean },
    locale: {},
    theme: {},
    name: {},
    suggested: {},
    folder: {},
    busy: { type: Boolean },
    error: {},
    kind: {}
  },
  emits: ["cancel", "confirm"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = pt(() => n.locale), o = () => n.kind === "upload";
    return (l, c) => (f(), Ge(ta, {
      open: e.open,
      locale: e.locale,
      theme: e.theme,
      title: u(i)("draft.taken.title"),
      size: "sm",
      busy: e.busy,
      onClose: c[2] || (c[2] = (p) => a("cancel"))
    }, {
      actions: mt(() => [
        d("button", {
          type: "button",
          class: "fe-btn",
          disabled: e.busy,
          "data-testid": "draft-taken-cancel",
          onClick: c[0] || (c[0] = (p) => a("cancel"))
        }, y(u(i)("modal.rename.cancel")), 9, kie),
        d("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          disabled: e.busy,
          "aria-busy": e.busy ? "true" : void 0,
          "data-testid": "draft-taken-confirm",
          onClick: c[1] || (c[1] = (p) => a("confirm"))
        }, y(u(i)(o() ? "upload.taken.confirm" : "draft.taken.confirm", { name: e.suggested })), 9, wie)
      ]),
      default: mt(() => [
        d("div", yie, [
          d("p", gie, y(u(i)(o() ? "upload.taken.body" : "draft.taken.body", { name: e.name, folder: e.folder, suggested: e.suggested })), 1),
          e.error ? (f(), h("p", bie, y(e.error), 1)) : O("", !0)
        ])
      ]),
      _: 1
    }, 8, ["open", "locale", "theme", "title", "busy"]));
  }
});
function _ie(e, t) {
  const n = $(!1), a = $(null), i = $(null);
  let o = null;
  function l(v) {
    i.value = null, a.value = null;
    const x = o;
    o = null, x == null || x(v);
  }
  async function c(v) {
    const x = e();
    if (!x) return null;
    n.value = !0;
    try {
      const w = await x.save(v.key);
      if (w.saved) return { path: w.path, name: w.name, targetDir: w.targetDir };
      i.value = {
        key: v.key,
        name: w.name,
        suggested: w.suggested,
        folder: K2(w.targetDir)
      }, a.value = null;
    } finally {
      n.value = !1;
    }
    return new Promise((w) => {
      o = w;
    });
  }
  async function p() {
    const v = i.value, x = e();
    if (!(!v || !x || n.value)) {
      n.value = !0, a.value = null;
      try {
        const w = await x.save(v.key, v.suggested);
        if (w.saved) {
          l({ path: w.path, name: w.name, targetDir: w.targetDir });
          return;
        }
        i.value = { ...v, name: w.name || v.name, suggested: w.suggested };
      } catch (w) {
        a.value = t(w);
      } finally {
        n.value = !1;
      }
    }
  }
  function m() {
    n.value || l(null);
  }
  return { busy: n, error: a, question: i, save: c, confirm: p, cancel: m };
}
const xie = ["onKeydown"], Sie = {
  key: 0,
  class: "fe-form__error",
  role: "alert",
  "data-testid": "rename-error"
}, $ie = ["disabled"], Tie = ["disabled", "aria-busy"], Aie = /* @__PURE__ */ lt({
  __name: "RenameModal",
  props: {
    open: { type: Boolean },
    locale: {},
    currentName: {},
    error: {},
    busy: { type: Boolean }
  },
  emits: ["close", "submit"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = pt(() => n.locale), o = $(""), l = $(null);
    Je(
      () => [n.open, n.currentName],
      ([m, v]) => {
        m && (o.value = v, l.value = n.error ?? null);
      }
    ), Je(
      () => n.error,
      (m) => {
        l.value = m ?? null;
      },
      { immediate: !0 }
    );
    function c() {
      l.value = null;
    }
    function p() {
      if (n.busy) return;
      if (o.value === n.currentName) {
        a("close");
        return;
      }
      const m = Hy(o.value), v = Y2(m);
      if (v === "empty") {
        l.value = i("modal.rename.empty");
        return;
      }
      if (v) {
        l.value = i("modal.newfolder.invalid");
        return;
      }
      if (zp(m)) {
        l.value = i("names.reserved", { name: m });
        return;
      }
      a("submit", m);
    }
    return (m, v) => (f(), Ge(ta, {
      open: e.open,
      title: u(i)("modal.rename.title"),
      size: "sm",
      busy: e.busy,
      onClose: v[2] || (v[2] = (x) => a("close"))
    }, {
      actions: mt(() => [
        d("button", {
          type: "button",
          class: "fe-btn",
          disabled: e.busy,
          onClick: v[1] || (v[1] = (x) => a("close"))
        }, y(u(i)("modal.rename.cancel")), 9, $ie),
        d("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          disabled: e.busy,
          "aria-busy": e.busy ? "true" : void 0,
          onClick: p
        }, y(e.busy ? u(i)("modal.rename.saving") : u(i)("modal.rename.save")), 9, Tie)
      ]),
      default: mt(() => [
        d("form", {
          onSubmit: yt(p, ["prevent"])
        }, [
          ln(d("input", {
            "onUpdate:modelValue": v[0] || (v[0] = (x) => o.value = x),
            type: "text",
            class: "fe-input",
            autocomplete: "off",
            onInput: c,
            onKeydown: Ca(yt(p, ["prevent"]), ["enter"])
          }, null, 40, xie), [
            [_n, o.value]
          ]),
          l.value ? (f(), h("p", Sie, y(l.value), 1)) : O("", !0)
        ], 32)
      ]),
      _: 1
    }, 8, ["open", "title", "busy"]));
  }
}), Eie = {
  key: 0,
  class: "fe-form__error",
  role: "alert"
}, Cie = ["disabled"], zie = ["disabled", "aria-busy"], Mie = /* @__PURE__ */ lt({
  __name: "DeleteConfirmModal",
  props: {
    open: { type: Boolean },
    locale: {},
    count: {},
    error: {},
    busy: { type: Boolean },
    permanent: { type: Boolean }
  },
  emits: ["close", "confirm"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = pt(() => n.locale);
    function o() {
      n.busy || a("confirm");
    }
    return (l, c) => (f(), Ge(ta, {
      open: e.open,
      title: e.permanent ? u(i)("modal.delete.permanent_title") : u(i)("modal.delete.title"),
      size: "sm",
      busy: e.busy,
      onClose: c[1] || (c[1] = (p) => a("close"))
    }, {
      actions: mt(() => [
        d("button", {
          type: "button",
          class: "fe-btn",
          disabled: e.busy,
          onClick: c[0] || (c[0] = (p) => a("close"))
        }, y(u(i)("modal.delete.cancel")), 9, Cie),
        d("button", {
          type: "button",
          class: "fe-btn fe-btn--danger",
          disabled: e.busy,
          "aria-busy": e.busy ? "true" : void 0,
          onClick: o
        }, y(e.busy ? u(i)(e.permanent ? "modal.delete.permanent_working" : "modal.delete.working") : u(i)(e.permanent ? "modal.delete.permanent_confirm" : "modal.delete.confirm")), 9, zie)
      ]),
      default: mt(() => [
        d("p", null, y(e.permanent ? u(i)("modal.delete.permanent_message", { count: e.count }) : u(i)("modal.delete.message", { count: e.count })), 1),
        e.error ? (f(), h("p", Eie, y(e.error), 1)) : O("", !0)
      ]),
      _: 1
    }, 8, ["open", "title", "busy"]));
  }
});
function Pie(e, t) {
  return e && e.queued ? t("toast.undo_queued") : e && e.summary ? e.summary : t("toast.undone");
}
function V0(e, t, n) {
  return !e || e.source === t ? !0 : e.source === "drag-out-stopping" ? n === "end" : !1;
}
function j0(e, t, n, a) {
  return (e == null ? void 0 : e.kind) === "plain" ? t === "running" ? e.running : e.done : t === "running" ? a("toast.undoing") : Pie(n, a);
}
function wv(e, t = {}) {
  const n = $(!1), a = $(null);
  let i = 0;
  Je(e, (l, c) => {
    !l || c || (i++, n.value = !1, a.value = null);
  });
  function o(l) {
    return l === i && e.value;
  }
  return {
    busy: n,
    error: a,
    begin() {
      return n.value ? null : (n.value = !0, a.value = null, i);
    },
    end(l) {
      l === i && (n.value = !1);
    },
    refuse(l, c) {
      var p;
      return o(l) ? (a.value = c, !0) : ((p = t.say) == null || p.call(t, c), !1);
    },
    inDialog: o
  };
}
const Oie = 3e3, Lie = 20;
function Die(e) {
  const t = e.last_sync_error || void 0;
  switch (e.last_sync_state) {
    case "ok":
      return { status: "ok" };
    case "failed":
    case "error":
      return t ? { status: "failed", error: t } : { status: "failed" };
    case "aborted":
      return { status: "aborted" };
    default:
      return { status: "unknown" };
  }
}
function Rie(e) {
  const t = e.pollMs ?? Oie, n = e.giveUpAfter ?? Lie, a = /* @__PURE__ */ new Map(), i = $(0);
  let o, l = !1, c = !1, p = 0;
  const m = /* @__PURE__ */ new Set();
  function v() {
    c || o !== void 0 || l || a.size === 0 || (o = setTimeout(() => {
      o = void 0, x();
    }, t));
  }
  async function x() {
    if (c || a.size === 0) return;
    l = !0;
    let S = null;
    try {
      S = await e.list(), p = 0;
    } catch {
      p++;
    } finally {
      l = !1;
    }
    if (c) return;
    const k = S === null && p >= n;
    if (S !== null || k) {
      for (const [b, C] of a) {
        const T = S == null ? void 0 : S.find((L) => L.id === C.id), A = C.settle.filter((L) => !L(T, k));
        A.length === 0 ? a.delete(b) : C.settle = A;
      }
      i.value++;
    }
    v();
  }
  function w(S, k, b) {
    return c ? Promise.resolve(null) : new Promise((C) => {
      const T = (D) => {
        m.delete(T), C(D);
      };
      m.add(T);
      const A = `${k}:${S}`, L = (D, U) => {
        const q = b(D, U);
        return q === void 0 ? !1 : (T(q), !0);
      }, z = a.get(A);
      z ? z.settle.push(L) : a.set(A, { id: S, kind: k, settle: [L] }), i.value++, v();
    });
  }
  return {
    scan: (S) => w(S, "scan", (k, b) => b ? { status: "unknown" } : k ? k.running ? void 0 : Die(k) : { status: "gone" }),
    deletion: (S) => w(S, "deletion", (k, b) => b ? !1 : k ? void 0 : !0),
    watching(S) {
      return i.value, a.has(`deletion:${S}`) ? "deletion" : a.has(`scan:${S}`) ? "scan" : null;
    },
    stop() {
      c = !0, o !== void 0 && clearTimeout(o), o = void 0, a.clear(), i.value++;
      for (const S of [...m]) S(null);
    }
  };
}
const Iie = ["aria-label"], Nie = ["aria-selected", "tabindex", "disabled", "data-testid", "data-section", "onClick", "onKeydown"], Bie = { class: "fe-sections__label" }, Fie = ["data-testid"], sA = /* @__PURE__ */ lt({
  __name: "SurfaceSections",
  props: {
    sections: {},
    active: {},
    locale: {},
    label: {},
    disabled: { type: Boolean }
  },
  emits: ["select"],
  setup(e, { emit: t }) {
    const n = e, a = t, i = E(
      () => n.sections.filter((c) => c && typeof c.id == "string" && c.id).map((c) => ({
        id: c.id,
        label: Xt(c.label, n.locale) || c.id,
        count: typeof c.count == "number" && Number.isFinite(c.count) ? c.count : null
      }))
    );
    function o(c) {
      n.disabled || c === n.active || a("select", c);
    }
    function l(c, p) {
      var S, k;
      if (!["ArrowRight", "ArrowLeft", "Home", "End"].includes(c.key)) return;
      c.preventDefault();
      const v = i.value.length;
      if (!v) return;
      let x = p;
      c.key === "ArrowRight" ? x = (p + 1) % v : c.key === "ArrowLeft" ? x = (p - 1 + v) % v : c.key === "Home" ? x = 0 : c.key === "End" && (x = v - 1);
      const w = (S = c.currentTarget.parentElement) == null ? void 0 : S.querySelectorAll('[role="tab"]');
      (k = w == null ? void 0 : w[x]) == null || k.focus(), o(i.value[x].id);
    }
    return (c, p) => (f(), h("nav", {
      class: "fe-sections",
      role: "tablist",
      "aria-label": e.label,
      "data-testid": "surface-sections"
    }, [
      (f(!0), h(Te, null, nt(i.value, (m, v) => (f(), h("button", {
        key: m.id,
        type: "button",
        role: "tab",
        class: Re(["fe-sections__tab", { "is-active": m.id === e.active }]),
        "aria-selected": m.id === e.active ? "true" : "false",
        tabindex: m.id === e.active || !e.active && v === 0 ? 0 : -1,
        disabled: e.disabled,
        "data-testid": `surface-section-${m.id}`,
        "data-section": m.id,
        onClick: (x) => o(m.id),
        onKeydown: (x) => l(x, v)
      }, [
        d("span", Bie, y(m.label), 1),
        m.count !== null ? (f(), h("span", {
          key: 0,
          class: "fe-sections__count",
          "data-testid": `surface-section-count-${m.id}`
        }, y(m.count), 9, Fie)) : O("", !0)
      ], 42, Nie))), 128))
    ], 8, Iie));
  }
}), Uie = {
  class: "fe-plugin-view",
  "data-testid": "plugin-view"
}, Hie = {
  key: 0,
  class: "fe-surface__text fe-surface__text--muted",
  role: "status",
  "data-testid": "plugin-view-opening"
}, Kie = ["disabled"], Vie = /* @__PURE__ */ lt({
  __name: "PluginViewModal",
  props: {
    open: { type: Boolean },
    locale: {},
    theme: {},
    api: {},
    plugin: {},
    view: {},
    surface: {},
    path: {},
    paths: {},
    storages: {},
    startAt: {},
    size: {},
    label: {}
  },
  emits: ["close", "op", "toast", "open"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = pt(() => n.locale), o = Gp(
      {
        api: n.api,
        plugin: n.plugin,
        view: n.view,
        path: () => n.path,
        paths: () => n.paths,
        locale: () => n.locale,
        errorText: () => i("plugin.view.error")
      },
      {
        onOp: (x) => a("op", x),
        onDone: () => a("close"),
        onToast: (x) => a("toast", x),
        onOpen: (x) => a("open", x)
      }
    );
    Je(
      () => n.surface,
      (x) => o.setSurface(x),
      { immediate: !0 }
    );
    const l = o.current, c = E(() => {
      var x;
      return Xt((x = l.value) == null ? void 0 : x.title, n.locale) || n.label || n.view;
    }), p = E(() => {
      var x;
      return ((x = l.value) == null ? void 0 : x.sections) ?? [];
    });
    async function m(x) {
      var w, S;
      if (!(!x || x === ((w = l.value) == null ? void 0 : w.section)))
        try {
          const k = await n.api.pluginView(n.plugin, n.view, n.path, x);
          k != null && k.surface && o.setSurface(k.surface);
        } catch (k) {
          a("toast", ((S = i.foreign) == null ? void 0 : S.call(i, String((k == null ? void 0 : k.message) ?? ""))) || i("plugin.view.error"));
        }
    }
    const v = E(() => {
      var w;
      if (n.size) return n.size;
      const x = (w = l.value) == null ? void 0 : w.size;
      return x === "sm" || x === "lg" || x === "xl" ? x : "md";
    });
    return (x, w) => (f(), Ge(ta, {
      open: e.open,
      title: c.value,
      size: v.value,
      theme: e.theme,
      locale: e.locale,
      busy: u(o).busy.value,
      onClose: w[1] || (w[1] = (S) => a("close"))
    }, {
      actions: mt(() => [
        u(o).footer.value.length ? O("", !0) : (f(), h("button", {
          key: 0,
          type: "button",
          class: "fe-btn",
          disabled: u(o).busy.value,
          "data-testid": "plugin-view-close",
          onClick: w[0] || (w[0] = (S) => a("close"))
        }, y(u(i)("plugin.view.close")), 9, Kie)),
        Ze(Jp, {
          conv: u(o),
          locale: e.locale,
          "testid-prefix": "plugin-view"
        }, null, 8, ["conv", "locale"])
      ]),
      default: mt(() => {
        var S;
        return [
          d("div", Uie, [
            u(l) ? O("", !0) : (f(), h("p", Hie, y(u(i)("plugin.view.loading")), 1)),
            p.value.length ? (f(), Ge(sA, {
              key: 1,
              sections: p.value,
              active: (S = u(l)) == null ? void 0 : S.section,
              locale: e.locale,
              label: c.value,
              disabled: u(o).busy.value,
              onSelect: m
            }, null, 8, ["sections", "active", "locale", "label", "disabled"])) : O("", !0),
            Ze(Xp, {
              conv: u(o),
              locale: e.locale,
              theme: e.theme,
              api: e.api,
              plugin: e.plugin,
              storages: e.storages,
              "start-at": e.startAt
            }, null, 8, ["conv", "locale", "theme", "api", "plugin", "storages", "start-at"])
          ])
        ];
      }),
      _: 1
    }, 8, ["open", "title", "size", "theme", "locale", "busy"]));
  }
}), jie = { class: "fe-appframe-modal__body" }, qie = /* @__PURE__ */ lt({
  __name: "AppFrameModal",
  props: {
    api: {},
    locale: {},
    theme: {},
    plugin: {},
    view: {},
    placement: {},
    ui: {},
    label: {},
    files: {},
    userName: {},
    storages: {},
    startAt: {}
  },
  emits: ["close", "toast", "op"],
  setup(e, { emit: t }) {
    const n = t, a = $(null), i = $("");
    async function o() {
      a.value && !await a.value.confirmClose() || n("close");
    }
    return (l, c) => (f(), Ge(ta, {
      open: !0,
      size: e.placement === "home" ? "xl" : "lg",
      title: i.value ? `${e.label} - ${i.value}` : e.label,
      locale: e.locale,
      theme: e.theme,
      "close-on-backdrop": !1,
      "data-testid": "app-frame-modal",
      onClose: o
    }, {
      default: mt(() => [
        d("div", jie, [
          Ze(Fg, {
            ref_key: "frame",
            ref: a,
            api: e.api,
            app: e.plugin,
            version: e.ui.version,
            view: e.view,
            placement: e.placement,
            ui: e.ui,
            files: e.files,
            storages: e.storages,
            "start-at": e.startAt,
            locale: e.locale,
            theme: e.theme,
            "user-name": e.userName,
            title: e.label,
            onTitle: c[0] || (c[0] = (p) => i.value = p),
            onToast: c[1] || (c[1] = (p) => n("toast", p.text)),
            onOp: c[2] || (c[2] = (p) => n("op", p)),
            onClose: o
          }, null, 8, ["api", "app", "version", "view", "placement", "ui", "files", "storages", "start-at", "locale", "theme", "user-name", "title"])
        ])
      ]),
      _: 1
    }, 8, ["size", "title", "locale", "theme"]));
  }
}), nd = $(0);
function lA() {
  const e = Qi().openWith;
  if (!e) return {};
  try {
    const t = JSON.parse(e);
    if (!t || typeof t != "object" || Array.isArray(t)) return {};
    const n = {};
    for (const [a, i] of Object.entries(t))
      typeof i == "string" && ab(a) && ib(i, a) && (n[a] = i);
    return n;
  } catch {
    return {};
  }
}
function ab(e) {
  return /^[a-z0-9][a-z0-9_+-]{0,31}$/.test(e);
}
function ib(e, t) {
  return e === Ll ? t === void 0 || nh(t) : e === "builtin" || /^app:[a-z0-9][a-z0-9_-]{0,31}\/[a-z0-9][a-z0-9_.-]{0,63}$/.test(e);
}
function Wie() {
  return nd.value, lA();
}
function Yie(e) {
  return e ? Wie()[e.toLowerCase()] ?? null : null;
}
async function uA(e, t) {
  const n = await I$(e, t);
  if (!(!n || !n.ok))
    try {
      const a = await n.json();
      if (!a || !a.choices || typeof a.choices != "object" || Array.isArray(a.choices)) return;
      const i = {};
      for (const [o, l] of Object.entries(a.choices))
        typeof l == "string" && ab(o) && ib(l, o) && (i[o] = l);
      Ng("openWith", JSON.stringify(i)), nd.value++;
    } catch {
    }
}
function Gie(e, t) {
  const n = e.toLowerCase();
  if (!ab(n) || t !== null && !ib(t, n)) return;
  const a = lA();
  t === null ? delete a[n] : a[n] = t, Ng("openWith", JSON.stringify(a)), nd.value++;
  const i = `/api/me/open-with/${encodeURIComponent(n)}`;
  uA(i, t === null ? { method: "DELETE" } : { method: "PUT", body: JSON.stringify({ handler: t }) });
}
function qhe() {
  Ng("openWith", "{}"), nd.value++, uA("/api/me/open-with", { method: "DELETE" });
}
function Xie() {
  return Jc(() => {
    nd.value++;
  });
}
const Jie = {
  class: "fe-openwith",
  "data-testid": "open-with-dialog"
}, Zie = { class: "fe-openwith__lead" }, Qie = {
  key: 0,
  class: "fe-openwith__always"
}, eoe = {
  key: 1,
  class: "fe-openwith__hint"
}, toe = ["disabled"], noe = /* @__PURE__ */ lt({
  __name: "OpenWithDialog",
  props: {
    open: { type: Boolean },
    locale: {},
    theme: {},
    name: {},
    kind: {},
    handlers: {},
    current: {},
    remembered: {}
  },
  emits: ["cancel", "open"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = pt(() => n.locale), o = $(null), l = $(!1);
    Je(
      () => n.open,
      (v) => {
        var x;
        v && (o.value = n.current ?? ((x = n.handlers[0]) == null ? void 0 : x.id) ?? null, l.value = !!n.remembered && n.remembered === o.value);
      },
      { immediate: !0 }
    );
    function c(v) {
      return Rf(v) ? i("openWith.onlyoffice") : v.view ? Xt(v.view.label, n.locale) || v.view.plugin : i("openWith.builtin");
    }
    const p = E(
      () => n.handlers.map((v) => ({
        value: v.id,
        label: c(v),
        help: v.id === n.current ? i("openWith.now") : void 0
      }))
    );
    function m() {
      o.value && a("open", o.value, l.value && !!n.kind);
    }
    return (v, x) => (f(), Ge(ta, {
      open: e.open,
      locale: e.locale,
      theme: e.theme,
      title: u(i)("openWith.title"),
      size: "sm",
      onClose: x[3] || (x[3] = (w) => a("cancel"))
    }, {
      actions: mt(() => [
        d("button", {
          type: "button",
          class: "fe-btn",
          "data-testid": "open-with-cancel",
          onClick: x[2] || (x[2] = (w) => a("cancel"))
        }, y(u(i)("modal.rename.cancel")), 1),
        d("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          disabled: !o.value,
          "data-testid": "open-with-open",
          onClick: m
        }, y(u(i)("openWith.open")), 9, toe)
      ]),
      default: mt(() => [
        d("div", Jie, [
          d("p", Zie, y(u(i)("openWith.lead", { name: e.name })), 1),
          Ze(mi, {
            "model-value": o.value,
            "onUpdate:modelValue": x[0] || (x[0] = (w) => o.value = typeof w == "string" ? w : null),
            options: p.value,
            "aria-label": u(i)("openWith.title"),
            "testid-prefix": "open-with-choice"
          }, null, 8, ["model-value", "options", "aria-label"]),
          e.kind ? (f(), h("label", Qie, [
            ln(d("input", {
              "onUpdate:modelValue": x[1] || (x[1] = (w) => l.value = w),
              type: "checkbox",
              "data-testid": "open-with-always"
            }, null, 512), [
              [zc, l.value]
            ]),
            d("span", null, y(u(i)("openWith.always", { ext: "." + e.kind })), 1)
          ])) : O("", !0),
          e.kind ? (f(), h("p", eoe, y(u(i)("openWith.hint")), 1)) : O("", !0)
        ])
      ]),
      _: 1
    }, 8, ["open", "locale", "theme", "title"]));
  }
}), Ap = "filex.embed.locale", cA = "filex:embed-locale";
function aoe(e) {
  var t;
  return !((t = e.accountPrefs) != null && t.surface) && !Fl();
}
const Pr = (e) => String(e ?? "").trim();
function q0(e) {
  const t = () => P2(e.browser ?? []);
  if (!e.embedded) {
    const l = Pr(e.account) || Pr(e.host);
    if (l && Vu(l))
      return { locale: Aa(l), tier: Pr(e.account) ? "account" : "host" };
    const c = t();
    return c ? { locale: c, tier: "browser" } : { locale: "en", tier: "default" };
  }
  const n = Pr(e.chosen);
  if (n && Vu(n)) return { locale: Aa(n), tier: "chosen" };
  const a = Pr(e.account);
  if (a && Vu(a)) return { locale: Aa(a), tier: "account" };
  const i = t();
  if (i) return { locale: i, tier: "browser" };
  const o = Pr(e.host);
  return o && Vu(o) ? { locale: Aa(o), tier: "host" } : { locale: "en", tier: "default" };
}
async function ioe(e) {
  var i;
  if (!e.person) return "";
  let t;
  try {
    t = (i = await e.me()) == null ? void 0 : i.user;
  } catch {
    return "";
  }
  if (!t) return "";
  const n = typeof t.locale == "string" ? t.locale.trim() : "";
  if (n) return n;
  const a = Pr(e.host);
  return e.embedded || !a || e.updateProfile({ locale: a }).catch(() => {
  }), "";
}
function ooe(e, t) {
  roe(e);
  const n = Cc.value;
  return n && t.person && t.updateProfile({ locale: n }).catch(() => {
  }), n;
}
function ob(e) {
  const t = typeof e == "string" ? e.trim().toLowerCase().replace(/_/g, "-") : "";
  return $2(t) ? t : "";
}
function dA() {
  try {
    return ob(localStorage.getItem(Ap));
  } catch {
    return "";
  }
}
const fA = typeof window < "u", Cc = $(fA ? dA() : "");
function W0() {
  return Cc.value;
}
function roe(e) {
  const t = ob(e);
  Cc.value = t;
  try {
    t ? localStorage.setItem(Ap, t) : localStorage.removeItem(Ap);
  } catch {
  }
  try {
    window.dispatchEvent(new CustomEvent(cA, { detail: t }));
  } catch {
  }
}
if (fA)
  try {
    window.addEventListener("storage", (e) => {
      (e.key === null || e.key === Ap) && (Cc.value = dA());
    }), window.addEventListener(cA, (e) => {
      Cc.value = ob(e.detail);
    });
  } catch {
  }
function pA(e) {
  if (!e) return null;
  if (typeof HTMLElement < "u" && e instanceof HTMLElement) return e;
  const t = e.$el;
  return typeof HTMLElement < "u" && t instanceof HTMLElement ? t : null;
}
function rb() {
  if (typeof window > "u") return { width: 0, height: 0 };
  const e = typeof document < "u" ? document.documentElement : null, t = e && e.clientWidth > 0 ? e.clientWidth : window.innerWidth, n = e && e.clientHeight > 0 ? e.clientHeight : window.innerHeight;
  return { width: t, height: n };
}
function sb(e, t, n = {}) {
  const a = n.dir === "rtl", i = a ? "left" : "right", o = n.gutter ?? 8, l = Math.round(e.bottom + (n.gap ?? 6)), c = Math.round(a ? e.left ?? 0 : t.width - e.right), p = Math.max(200, t.height - l - o), m = `${n.maxHeight ? Math.min(n.maxHeight, p) : p}px`;
  if (!n.width) return { top: `${l}px`, [i]: `${c}px`, maxHeight: m };
  const v = Math.max(0, Math.min(n.width, t.width - o * 2)), x = Math.min(Math.max(c, o), t.width - v - o);
  return { top: `${l}px`, [i]: `${Math.round(x)}px`, width: `${Math.round(v)}px`, maxHeight: m };
}
function Vo(e) {
  return typeof e == "string" ? e : "";
}
function soe(e, t) {
  const n = { title: Vo(e.title), body: Vo(e.body) }, a = e.e2e;
  if (!a || typeof t != "function" || !Array.isArray(a.names)) return n;
  const i = a.names.map((l) => {
    let c = null;
    try {
      c = t(Vo(l == null ? void 0 : l.wire), Vo(l == null ? void 0 : l.root));
    } catch {
      c = null;
    }
    return c ? l.part === "path" ? Vo(c.path) : Vo(c.name) : Vo(l == null ? void 0 : l.locked);
  }), o = (l, c) => Array.isArray(l) ? l.map((p) => typeof (p == null ? void 0 : p.name) == "number" ? i[p.name] ?? "" : Vo(p == null ? void 0 : p.text)).join("") : c;
  return { title: o(a.title, n.title), body: o(a.body, n.body) };
}
function loe() {
  function e(t) {
    return soe(t, xne);
  }
  return { notificationText: e };
}
const Ep = ".trash";
function Y0(e, t) {
  const n = (a) => {
    const i = String(a ?? ""), o = i.indexOf("://");
    return o < 0 ? i : `${i.slice(0, o + 3)}${i.slice(o + 3).replace(/^\/+/, "")}`;
  };
  return n(e) === n(t);
}
function uoe(e) {
  let t = String(e ?? "").trim().replace(/\\/g, "/");
  const n = t.indexOf("://");
  return n >= 0 && (t = t.slice(n + 3)), t.replace(/^\/+/, "").replace(/\/+$/, "");
}
function coe(e) {
  const t = e.lastIndexOf("/");
  return t < 0 ? "" : e.slice(0, t);
}
function hA(e) {
  var i, o, l;
  if (!e || !e.kind || e.kind === "none") return { kind: "none" };
  if (e.kind === "share") {
    const c = String(e.id ?? "").trim();
    return c ? { kind: "share", token: c } : { kind: "none" };
  }
  if (e.kind === "app") {
    const c = String(((i = e.open) == null ? void 0 : i.plugin) ?? "").trim(), p = String(((o = e.open) == null ? void 0 : o.view) ?? "").trim(), m = String(((l = e.open) == null ? void 0 : l.section) ?? "").trim();
    return !c || !p ? { kind: "none" } : { kind: "app", plugin: c, view: p, ...m ? { section: m } : {} };
  }
  const t = String(e.storage ?? "").trim(), n = uoe(e.path);
  if (e.kind === "trash")
    return t && n ? { kind: "trash", select: `${t}://${n}` } : { kind: "trash" };
  if (!t) return { kind: "none" };
  const a = doe(e);
  return e.kind === "dir" ? { kind: "folder", storage: t, folder: n, ...a ? { open: a } : {} } : e.kind === "file" ? n ? {
    kind: "folder",
    storage: t,
    folder: coe(n),
    select: `${t}://${n}`,
    ...a ? { open: a } : {}
  } : { kind: "folder", storage: t, folder: "", ...a ? { open: a } : {} } : { kind: "none" };
}
function doe(e) {
  const t = e.open;
  if (!t || typeof t != "object") return;
  const n = String(t.plugin ?? "").trim(), a = String(t.action ?? "").trim(), i = String(t.view ?? "").trim();
  if (!(!n || !a && !i))
    return { plugin: n, ...a ? { action: a } : {}, ...i ? { view: i } : {} };
}
function foe(e) {
  return hA(e).kind !== "none";
}
function poe(e) {
  return typeof e.opens == "boolean" ? e.opens : foe(e.target);
}
function zy(e) {
  return e.kind === "trash" ? Ep : e.kind !== "folder" ? "" : e.folder ? `${e.storage}/${e.folder}` : e.storage;
}
function mA(e) {
  return e ? e.split("/").map(encodeURIComponent).join("/") : "";
}
function hoe(e) {
  return e.kind === "trash" ? Ep : e.kind !== "folder" ? "" : `${e.storage}://${e.folder}`;
}
function Whe(e, t = {}) {
  const n = String(e ?? "").replace(/^#/, "").replace(/^\/+/, "");
  if (!n) return "";
  let a = n;
  if (!t.decoded)
    try {
      a = decodeURIComponent(n);
    } catch {
    }
  const i = a.indexOf("/");
  return i < 0 ? `${a}://` : `${a.slice(0, i)}://${a.slice(i + 1)}`;
}
function Yhe(e) {
  if (e.kind === "app")
    return {
      name: "app-home",
      params: { plugin: e.plugin, view: e.view },
      query: e.section ? { section: e.section } : {},
      hash: ""
    };
  if (e.kind === "folder") {
    const t = e.select ? { select: e.select } : {};
    return e.open && (t.app = e.open.plugin, e.open.action ? t.appAction = e.open.action : e.open.view && (t.appView = e.open.view)), {
      name: "explore",
      query: t,
      // vue-router wants the '#'; the explorer encodes segment-by-segment, so
      // we hand over the readable form and let the browser escape it.
      hash: `#${zy(e)}`
    };
  }
  return e.kind === "trash" ? {
    name: "explore",
    query: e.select ? { select: e.select } : {},
    hash: `#${zy(e)}`
  } : null;
}
function vA(e, t = "") {
  return `${t.replace(/\/+$/, "")}/s/${encodeURIComponent(e)}`;
}
function Ghe(e, t = "/", n = "") {
  if (e.kind === "share") return vA(e.token, n);
  const a = `${String(t || "/").replace(/\/+$/, "")}/`;
  if (e.kind === "app") {
    const l = `${a}app/${encodeURIComponent(e.plugin)}/${encodeURIComponent(e.view)}`;
    return e.section ? `${l}?section=${encodeURIComponent(e.section)}` : l;
  }
  if (e.kind !== "folder" && e.kind !== "trash") return "";
  const i = [];
  e.select && i.push(`select=${encodeURIComponent(e.select)}`), e.kind === "folder" && e.open && (i.push(`app=${encodeURIComponent(e.open.plugin)}`), e.open.action ? i.push(`appAction=${encodeURIComponent(e.open.action)}`) : e.open.view && i.push(`appView=${encodeURIComponent(e.open.view)}`));
  const o = mA(zy(e));
  return `${a}explore${i.length ? `?${i.join("&")}` : ""}${o ? `#${o}` : ""}`;
}
const moe = { class: "fx-nrow__body" }, voe = { class: "fx-nrow__meta" }, yoe = { class: "fx-nrow__when" }, goe = { class: "fx-nrow__title" }, boe = {
  key: 0,
  class: "fx-nrow__body-text"
}, yA = /* @__PURE__ */ lt({
  __name: "NotificationRow",
  props: {
    item: {},
    locale: {}
  },
  emits: ["open"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = pt(() => n.locale), { notificationText: o } = loe(), l = E(() => o(n.item)), c = E(() => poe(n.item)), p = E(() => !n.item.read_at), m = E(() => rx(n.item.created_at, n.locale, { time: !0 }) || "-");
    function v(w) {
      const S = `notifications.severity.${w}`, k = i(S);
      return k === S ? w : k;
    }
    function x(w) {
      return w === "critical" || w === "error" ? "danger" : w === "warning" ? "warning" : "info";
    }
    return (w, S) => (f(), Ge(Ki(c.value ? "button" : "div"), {
      type: c.value ? "button" : void 0,
      class: Re(["fx-nrow", { "is-unread": p.value, "has-target": c.value, "is-static": !c.value }]),
      title: c.value ? u(i)("notifications.openTarget") : void 0,
      "data-testid": "notification-row",
      "data-clickable": c.value ? "yes" : "no",
      "data-notification-id": e.item.id,
      onClick: S[0] || (S[0] = (k) => c.value ? a("open", e.item) : void 0)
    }, {
      default: mt(() => [
        S[1] || (S[1] = d("span", {
          class: "fx-nrow__dot",
          "aria-hidden": "true"
        }, null, -1)),
        d("span", moe, [
          d("span", voe, [
            d("span", {
              class: Re(["fx-nrow__sev", `is-${x(e.item.severity)}`])
            }, y(v(e.item.severity)), 3),
            d("span", yoe, y(m.value), 1)
          ]),
          d("span", goe, y(l.value.title), 1),
          l.value.body ? (f(), h("span", boe, y(l.value.body), 1)) : O("", !0)
        ])
      ]),
      _: 1
    }, 8, ["type", "class", "title", "data-clickable", "data-notification-id"]));
  }
}), G0 = 99;
function koe(e) {
  const t = Math.floor(Number(e ?? 0));
  return !Number.isFinite(t) || t <= 0 ? "" : t > G0 ? `${G0}+` : String(t);
}
function Xhe(e) {
  const t = Math.floor(Number(e ?? 0));
  return Number.isFinite(t) && t > 0 ? t : 0;
}
const woe = {
  key: 0,
  class: "fx-badge",
  "aria-hidden": "true",
  "data-testid": "unread-badge"
}, gA = /* @__PURE__ */ lt({
  __name: "UnreadBadge",
  props: {
    count: {}
  },
  setup(e) {
    const t = e, n = E(() => koe(t.count));
    return (a, i) => n.value ? (f(), h("span", woe, y(n.value), 1)) : O("", !0);
  }
}), _oe = ["innerHTML"], xoe = { class: "fx-bell__heading" }, Soe = ["innerHTML"], $oe = {
  key: 0,
  class: "fx-bell__empty"
}, Toe = { class: "fx-bell__foot" }, Aoe = ["onClick"], Eoe = ["href", "onClick"], _v = 360, Coe = /* @__PURE__ */ lt({
  __name: "NotificationBell",
  props: {
    feed: {},
    locale: {},
    manageHref: {}
  },
  emits: ["open", "manage"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = pt(() => n.locale), o = E(() => Math.max(0, n.feed.unreadCount || 0)), l = E(
      () => o.value > 0 ? `${i("notifications.bell")} - ${i("notifications.unreadCount", { n: o.value })}` : i("notifications.bell")
    ), c = $(null), p = $({
      top: "0px",
      right: "0px",
      width: `${_v}px`,
      maxHeight: "420px"
    });
    function m() {
      const b = pA(c.value), C = b == null ? void 0 : b.getBoundingClientRect();
      if (!C) return;
      const T = sb(
        C,
        rb(),
        // The list scrolls inside the panel; 520 keeps ~6 rows on a laptop and
        // the head + foot visible on a phone. ⚠ RTL: flush with the bell's END
        // edge — its left one in a right-to-left header.
        { width: _v, maxHeight: 520, dir: ei(b) }
      );
      p.value = { top: T.top, right: T.right, left: T.left, width: T.width ?? `${_v}px`, maxHeight: T.maxHeight };
    }
    function v() {
      m(), n.feed.refreshFeed();
    }
    async function x(b, C) {
      C(), b.read_at || await n.feed.markRead(b.id).catch(() => {
      }), a("open", b);
    }
    function w(b) {
      b(), n.feed.openPanel();
    }
    function S(b) {
      b(), a("manage");
    }
    const k = E(() => n.feed.feed.slice(0, 15));
    return (b, C) => (f(), Ge(u(fP), { class: "fx-bell" }, {
      default: mt(({ open: T, close: A }) => [
        Ze(u(pP), {
          ref_key: "btnEl",
          ref: c,
          class: Re(["fx-bell__btn", { "is-open": T }]),
          title: l.value,
          "aria-label": l.value,
          "data-testid": "notification-bell",
          onClick: m,
          onKeydown: m
        }, {
          default: mt(() => [
            d("span", {
              class: "fx-bell__icon",
              "aria-hidden": "true",
              innerHTML: u(zt)("bell")
            }, null, 8, _oe),
            Ze(gA, { count: o.value }, null, 8, ["count"])
          ]),
          _: 1
        }, 8, ["class", "title", "aria-label"]),
        (f(), Ge(wi, { to: "body" }, [
          Ze(u(hP), {
            class: "fx-bell__panel",
            style: Wt({ top: p.value.top, right: p.value.right, left: p.value.left, width: p.value.width }),
            "data-testid": "notification-panel"
          }, {
            default: mt(() => [
              d("div", {
                class: "fx-bell__head",
                onVnodeMounted: v
              }, [
                d("span", xoe, y(u(i)("notifications.title")), 1),
                e.feed.hasUnread ? (f(), h("button", {
                  key: 0,
                  type: "button",
                  class: "fx-bell__markall",
                  "data-testid": "notification-mark-all",
                  onClick: C[0] || (C[0] = (L) => e.feed.markAllRead())
                }, [
                  d("span", {
                    class: "fx-bell__markall-icon",
                    "aria-hidden": "true",
                    innerHTML: u(zt)("check")
                  }, null, 8, Soe),
                  Ht(" " + y(u(i)("notifications.markAllRead")), 1)
                ])) : O("", !0)
              ], 512),
              d("ul", {
                class: "fx-bell__list",
                style: Wt({ maxHeight: p.value.maxHeight }),
                "data-testid": "notification-list"
              }, [
                !k.value.length && !e.feed.feedLoading ? (f(), h("li", $oe, y(u(i)("notifications.empty")), 1)) : O("", !0),
                (f(!0), h(Te, null, nt(k.value, (L) => (f(), h("li", {
                  key: L.id
                }, [
                  Ze(yA, {
                    item: L,
                    locale: e.locale,
                    onOpen: (z) => x(z, A)
                  }, null, 8, ["item", "locale", "onOpen"])
                ]))), 128))
              ], 4),
              d("div", Toe, [
                d("button", {
                  type: "button",
                  class: "fx-bell__all",
                  "data-testid": "notification-view-all",
                  onClick: (L) => w(A)
                }, y(u(i)("notifications.viewAll")), 9, Aoe),
                e.manageHref ? (f(), h("a", {
                  key: 0,
                  href: e.manageHref,
                  class: "fx-bell__manage",
                  "data-testid": "notification-manage",
                  onClick: yt((L) => S(A), ["prevent"])
                }, y(u(i)("notifications.manageAdmin")), 9, Eoe)) : O("", !0)
              ])
            ]),
            _: 2
          }, 1032, ["style"])
        ]))
      ]),
      _: 1
    }));
  }
}), zoe = ["aria-label"], Moe = { class: "fx-nall__sheet" }, Poe = { class: "fx-nall__head" }, Ooe = { class: "fx-nall__title" }, Loe = {
  class: "fx-nall__title-icon",
  "aria-hidden": "true"
}, Doe = ["innerHTML"], Roe = { class: "fx-nall__tools" }, Ioe = ["aria-pressed"], Noe = ["aria-label"], Boe = ["innerHTML"], Foe = {
  key: 0,
  class: "fx-nall__error",
  "data-testid": "notifications-screen-error"
}, Uoe = {
  class: "fx-nall__list",
  "data-testid": "notifications-screen-list"
}, Hoe = {
  key: 0,
  class: "fx-nall__empty"
}, Koe = ["title", "aria-label", "onClick"], Voe = ["innerHTML"], joe = {
  key: 1,
  class: "fx-nall__foot",
  "data-testid": "notifications-screen-pager"
}, qoe = ["disabled"], Woe = { class: "fx-nall__count" }, Yoe = ["disabled"], Goe = /* @__PURE__ */ lt({
  __name: "NotificationsPanel",
  props: {
    feed: {},
    locale: {}
  },
  emits: ["open"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = pt(() => n.locale), o = E(() => Math.floor(n.feed.mineOffset / n.feed.mineLimit) + 1), l = E(() => Math.max(1, Math.ceil(n.feed.mineTotal / n.feed.mineLimit)));
    function c(w) {
      w < 1 || w > l.value || (n.feed.setMinePage(w), n.feed.fetchMine());
    }
    function p() {
      n.feed.setMineUnreadFilter(!n.feed.mineUnreadOnly), n.feed.fetchMine();
    }
    async function m(w) {
      n.feed.closePanel(), w.read_at || await n.feed.markRead(w.id).catch(() => {
      }), a("open", w);
    }
    async function v(w) {
      w.read_at || await n.feed.markRead(w.id).catch(() => {
      });
    }
    function x(w) {
      w.key === "Escape" && n.feed.closePanel();
    }
    return Je(
      () => n.feed.panelOpen,
      (w) => {
        w ? window.addEventListener("keydown", x) : window.removeEventListener("keydown", x);
      },
      { immediate: !0 }
    ), Tt(() => window.removeEventListener("keydown", x)), (w, S) => (f(), Ge(wi, { to: "body" }, [
      e.feed.panelOpen ? (f(), h("div", {
        key: 0,
        class: "fx-nall",
        role: "dialog",
        "aria-modal": "true",
        "aria-label": u(i)("notifications.title"),
        "data-testid": "notifications-screen"
      }, [
        d("div", {
          class: "fx-nall__scrim",
          onClick: S[0] || (S[0] = yt((k) => e.feed.closePanel(), ["self"]))
        }),
        d("section", Moe, [
          d("header", Poe, [
            d("span", Ooe, [
              d("span", Loe, [
                d("span", {
                  innerHTML: u(zt)("bell")
                }, null, 8, Doe),
                Ze(gA, {
                  count: e.feed.unreadCount
                }, null, 8, ["count"])
              ]),
              Ht(" " + y(u(i)("notifications.title")), 1)
            ]),
            d("div", Roe, [
              d("button", {
                type: "button",
                class: Re(["fx-nall__tool", { "is-on": e.feed.mineUnreadOnly }]),
                "aria-pressed": e.feed.mineUnreadOnly,
                "data-testid": "notifications-screen-unread",
                onClick: p
              }, y(u(i)("notifications.unreadOnly")), 11, Ioe),
              e.feed.hasUnread ? (f(), h("button", {
                key: 0,
                type: "button",
                class: "fx-nall__tool",
                "data-testid": "notifications-screen-mark-all",
                onClick: S[1] || (S[1] = (k) => e.feed.markAllRead())
              }, y(u(i)("notifications.markAllRead")), 1)) : O("", !0),
              d("button", {
                type: "button",
                class: "fx-nall__close",
                "aria-label": u(i)("modal.close"),
                "data-testid": "notifications-screen-close",
                onClick: S[2] || (S[2] = (k) => e.feed.closePanel())
              }, [
                d("span", {
                  "aria-hidden": "true",
                  innerHTML: u(zt)("close")
                }, null, 8, Boe)
              ], 8, Noe)
            ])
          ]),
          e.feed.mineError ? (f(), h("p", Foe, y(e.feed.mineError), 1)) : O("", !0),
          d("ul", Uoe, [
            !e.feed.mine.length && !e.feed.mineLoading ? (f(), h("li", Hoe, y(u(i)("notifications.empty")), 1)) : O("", !0),
            (f(!0), h(Te, null, nt(e.feed.mine, (k) => (f(), h("li", {
              key: k.id,
              class: "fx-nall__item"
            }, [
              Ze(yA, {
                item: k,
                locale: e.locale,
                onOpen: m
              }, null, 8, ["item", "locale"]),
              k.read_at ? O("", !0) : (f(), h("button", {
                key: 0,
                type: "button",
                class: "fx-nall__read",
                title: u(i)("notifications.markRead"),
                "aria-label": u(i)("notifications.markRead"),
                "data-testid": "notifications-screen-mark-one",
                onClick: (b) => v(k)
              }, [
                d("span", {
                  "aria-hidden": "true",
                  innerHTML: u(zt)("check")
                }, null, 8, Voe)
              ], 8, Koe))
            ]))), 128))
          ]),
          l.value > 1 ? (f(), h("footer", joe, [
            d("button", {
              type: "button",
              class: "fx-nall__page",
              disabled: o.value <= 1,
              onClick: S[3] || (S[3] = (k) => c(o.value - 1))
            }, y(u(i)("common.prev")), 9, qoe),
            d("span", Woe, y(u(i)("notifications.pageOf", { page: o.value, pages: l.value, total: e.feed.mineTotal })), 1),
            d("button", {
              type: "button",
              class: "fx-nall__page",
              disabled: o.value >= l.value,
              onClick: S[4] || (S[4] = (k) => c(o.value + 1))
            }, y(u(i)("common.next")), 9, Yoe)
          ])) : O("", !0)
        ])
      ], 8, zoe)) : O("", !0)
    ]));
  }
}), Xoe = "filex", Joe = "0.0.0";
function Jhe(e) {
  return /^[0-9a-f]{8,}$/i.test(e) ? e.slice(0, 7) : e;
}
function bA(e) {
  const t = String(e ?? "").trim();
  return !t || t === Joe ? "" : `${Xoe} ${t}`;
}
const Zoe = {
  key: 0,
  class: "fe-version",
  "data-testid": "product-version"
}, Qoe = /* @__PURE__ */ lt({
  __name: "ProductVersion",
  props: {
    version: {}
  },
  setup(e) {
    const t = e, n = E(() => bA(t.version));
    return (a, i) => n.value ? (f(), h("p", Zoe, [
      d("bdi", null, y(n.value), 1)
    ])) : O("", !0);
  }
}), ere = {
  class: "fx-account__face",
  "aria-hidden": "true"
}, tre = ["src"], nre = {
  key: 1,
  class: "fx-account__initial"
}, are = {
  key: 2,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  focusable: "false"
}, ire = { class: "fx-acctmenu__who" }, ore = ["data-testid", "onClick"], rre = ["innerHTML"], sre = { class: "fx-acctmenu__label" }, lre = /* @__PURE__ */ lt({
  __name: "AccountMenu",
  props: {
    actions: {},
    user: {},
    version: {},
    locale: {},
    fallbackLabel: {}
  },
  emits: ["select"],
  setup(e, { emit: t }) {
    const n = e, a = t, i = E(() => Yp(n.user ?? null)), o = E(() => {
      var x;
      return (((x = n.user) == null ? void 0 : x.avatar_url) || "").trim();
    }), l = E(() => {
      const x = i.value;
      return x ? [...x][0].toLocaleUpperCase(gi(n.locale)) : "";
    }), c = E(() => i.value || n.fallbackLabel), p = $(null), m = $({ top: "0px", right: "0px" });
    function v() {
      const x = pA(p.value), w = x == null ? void 0 : x.getBoundingClientRect();
      if (!w) return;
      const { top: S, right: k, left: b } = sb(
        w,
        rb(),
        { dir: ei(x) }
      );
      m.value = { top: S, right: k, left: b };
    }
    return (x, w) => (f(), Ge(u(mP), {
      as: "div",
      class: "fx-account"
    }, {
      default: mt(({ open: S }) => [
        Ze(u(vP), {
          ref_key: "btnEl",
          ref: p,
          class: Re(["fx-account__btn", { "is-open": S }]),
          title: c.value,
          "aria-label": c.value,
          "data-testid": "explore-account",
          onClick: v,
          onKeydown: v
        }, {
          default: mt(() => [
            d("span", ere, [
              o.value ? (f(), h("img", {
                key: 0,
                class: "fx-account__img",
                src: o.value,
                alt: ""
              }, null, 8, tre)) : l.value ? (f(), h("span", nre, y(l.value), 1)) : (f(), h("svg", are, [...w[0] || (w[0] = [
                d("circle", {
                  cx: "12",
                  cy: "8.5",
                  r: "3.5"
                }, null, -1),
                d("path", { d: "M5.5 19.5a6.5 6.5 0 0 1 13 0" }, null, -1)
              ])]))
            ]),
            w[1] || (w[1] = d("svg", {
              class: "fx-account__chev",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "aria-hidden": "true",
              focusable: "false"
            }, [
              d("path", { d: "M7 10l5 5 5-5" })
            ], -1))
          ]),
          _: 1
        }, 8, ["class", "title", "aria-label"]),
        (f(), Ge(wi, { to: "body" }, [
          Ze(Rr, {
            "enter-active-class": "fx-acct-in",
            "leave-active-class": "fx-acct-out"
          }, {
            default: mt(() => [
              Ze(u(yP), {
                class: "fx-acctmenu",
                style: Wt({ top: m.value.top, right: m.value.right, left: m.value.left }),
                "data-testid": "explore-account-menu"
              }, {
                default: mt(() => [
                  d("p", ire, y(c.value), 1),
                  (f(!0), h(Te, null, nt(e.actions, (k) => (f(), Ge(u(gP), {
                    key: k.key
                  }, {
                    default: mt(({ active: b }) => [
                      d("button", {
                        type: "button",
                        class: Re(["fx-acctmenu__item", { "is-active": b, "is-separated": k.separated }]),
                        "data-testid": `explore-${k.key}`,
                        onClick: (C) => a("select", k.key)
                      }, [
                        d("span", {
                          class: "fx-acctmenu__icon",
                          "aria-hidden": "true",
                          innerHTML: u(zt)(k.icon || k.key)
                        }, null, 8, rre),
                        d("span", sre, y(k.label), 1)
                      ], 10, ore)
                    ]),
                    _: 2
                  }, 1024))), 128)),
                  u(bA)(e.version) ? (f(), Ge(Qoe, {
                    key: 0,
                    version: e.version,
                    class: "fx-acctmenu__version"
                  }, null, 8, ["version"])) : O("", !0)
                ]),
                _: 1
              }, 8, ["style"])
            ]),
            _: 1
          })
        ]))
      ]),
      _: 1
    }));
  }
});
function X0(e, t) {
  const n = t.replace(/\/+$/, ""), a = (i, o) => ({
    method: i,
    headers: { "Content-Type": "application/json" },
    ...o === void 0 ? {} : { body: JSON.stringify(o) }
  });
  return {
    updateProfile: (i) => e(`${n}/api/auth/profile`, a("PATCH", i)),
    checkAccount: (i) => e(`${n}/api/auth/account/check`, a("POST", i)),
    changePassword: async (i, o) => {
      await e(`${n}/api/auth/password`, a("POST", { current_password: i, new_password: o }));
    },
    enrollTotp: () => e(`${n}/api/auth/totp/enroll`, a("POST")),
    verifyTotp: async (i) => {
      await e(`${n}/api/auth/totp/verify`, a("POST", { code: i }));
    },
    disableTotp: async (i) => {
      await e(`${n}/api/auth/totp/disable`, a("POST", { code: i }));
    },
    quota: () => e(`${n}/api/files/quota/me`),
    notificationSettings: () => e(`${n}/api/notifications/settings`),
    updateNotificationSettings: (i) => e(`${n}/api/notifications/settings`, a("PATCH", i)),
    pluginActions: () => e(`${n}/api/files/plugins/actions`),
    vaultIdle: async () => (await e(`${n}/api/files/e2e/vault/prefs`)).idle_minutes,
    setVaultIdle: async (i) => (await e(`${n}/api/files/e2e/vault/prefs`, a("PUT", { idle_minutes: i }))).idle_minutes,
    assistant: () => e(`${n}/api/files/assistant`),
    setAssistantPrefs: (i) => e(`${n}/api/files/assistant/prefs`, a("PUT", i)),
    clearAssistantHistory: async () => {
      await e(`${n}/api/files/assistant/conversations`, a("DELETE"));
    }
  };
}
const ure = 50, cre = 15e3;
function dre(e) {
  const t = e.transport, n = e.errorText ?? ((ne) => ne instanceof Error ? ne.message : String(ne)), a = () => {
    var ne;
    return ((ne = e.alsoStamp) == null ? void 0 : ne.call(e)) ?? [];
  }, i = $([]), o = $(!1), l = $([]), c = $(0), p = $(25), m = $(0), v = $(!1), x = $(!1), w = $(null);
  let S = 0;
  const k = $(!1);
  let b = null, C = 0;
  const T = $(0), A = E(() => T.value > 0);
  async function L() {
    const ne = ++C;
    o.value = !0;
    try {
      const [j, re] = await Promise.all([
        t.list({ unread: !1, limit: ure, offset: 0 }),
        t.unreadCount()
      ]);
      return ne !== C || (i.value = j.items ?? [], T.value = re, b = re), !0;
    } catch {
      return !1;
    } finally {
      ne === C && (o.value = !1);
    }
  }
  async function z() {
    try {
      T.value = await t.unreadCount();
    } catch {
    }
  }
  async function D() {
    await z(), b !== T.value && await L();
  }
  async function U(ne) {
    const j = Math.max(0, Math.floor(Number(ne) || 0));
    T.value = j, b !== j && await L();
  }
  async function q() {
    const ne = ++S;
    x.value = !0, w.value = null;
    try {
      const j = await t.list({
        unread: v.value,
        limit: p.value,
        offset: m.value
      });
      if (ne !== S) return;
      l.value = j.items ?? [], c.value = j.total ?? 0;
    } catch (j) {
      if (ne !== S) return;
      w.value = n(j);
    } finally {
      ne === S && (x.value = !1);
    }
  }
  function P(ne) {
    m.value = Math.max(0, (ne - 1) * p.value);
  }
  function R(ne) {
    v.value = ne, m.value = 0;
  }
  function W() {
    k.value = !0, m.value = 0, q();
  }
  function N() {
    k.value = !1;
  }
  async function J(ne) {
    var ae;
    await t.markRead(ne);
    const j = (/* @__PURE__ */ new Date()).toISOString(), re = (fe) => fe.id === ne && !fe.read_at ? { ...fe, read_at: j } : fe, he = [i, l, ...a()], ue = he.some((fe) => fe.value.some((_) => _.id === ne && !_.read_at));
    for (const fe of he) fe.value = fe.value.map(re);
    ue && T.value > 0 && (T.value -= 1, b !== null && b > 0 && (b -= 1)), (ae = e.onRead) == null || ae.call(e);
  }
  async function H() {
    var re;
    await t.markAllRead();
    const ne = (/* @__PURE__ */ new Date()).toISOString(), j = (he) => ({ ...he, read_at: he.read_at ?? ne });
    for (const he of [i, l, ...a()]) he.value = he.value.map(j);
    T.value = 0, b !== null && (b = 0), (re = e.onRead) == null || re.call(e), k.value && v.value && (m.value = 0, q());
  }
  return {
    feed: i,
    feedLoading: o,
    unreadCount: T,
    hasUnread: A,
    mine: l,
    mineTotal: c,
    mineLimit: p,
    mineOffset: m,
    mineUnreadOnly: v,
    mineLoading: x,
    mineError: w,
    panelOpen: k,
    refreshFeed: L,
    fetchUnread: z,
    syncUnread: D,
    acceptCount: U,
    fetchMine: q,
    setMinePage: P,
    setMineUnreadFilter: R,
    openPanel: W,
    closePanel: N,
    markRead: J,
    markAllRead: H
  };
}
function fre(e, t) {
  const n = `${t.replace(/\/+$/, "")}/api/notifications`;
  return {
    async list(a) {
      const i = [];
      return a.unread && i.push("unread=true"), a.limit != null && i.push(`limit=${encodeURIComponent(String(a.limit))}`), a.offset != null && i.push(`offset=${encodeURIComponent(String(a.offset))}`), await e(
        i.length ? `${n}?${i.join("&")}` : n
      ) ?? { items: [], total: 0 };
    },
    async unreadCount() {
      const a = await e(`${n}/unread-count`);
      return Math.max(0, Number((a == null ? void 0 : a.count) ?? 0) || 0);
    },
    async markRead(a) {
      await e(`${n}/${encodeURIComponent(String(a))}/read`, { method: "POST" });
    },
    async markAllRead() {
      await e(`${n}/read-all`, { method: "POST" });
    }
  };
}
const pre = ["view-list", "view-grid", "view-gallery", "inspector", "nav"], hre = ["theme", "density", "timezone", "shortcut-settings"], My = "fe:";
function mre(e, t, n = {}) {
  const a = new Set(n.omit ?? []), i = [...e];
  t.filter((o) => !o.divider && !a.has(o.key)).forEach(
    (o, l) => i.push({
      key: `${My}${o.key}`,
      label: o.label,
      icon: o.icon || o.key,
      separated: l === 0
    })
  );
  for (const o of n.tail ?? []) i.push({ ...o, separated: o.separated ?? !0 });
  return i;
}
function vre(e) {
  return e.startsWith(My) ? e.slice(My.length) : null;
}
function Xn(e) {
  return k2({ loader: e, suspensible: !1 });
}
const yre = ["dir"], gre = ["title", "aria-label"], bre = { class: "fe__stack" }, kre = { class: "fe__panes" }, wre = {
  key: 0,
  class: "fe-search-cut",
  role: "status"
}, _re = {
  key: 1,
  class: "fe-search-cut fe-nav-more",
  role: "status",
  "data-testid": "nav-more"
}, xre = ["disabled", "aria-busy"], Sre = {
  key: 2,
  class: "fe-coverage",
  role: "status",
  "data-testid": "catalog-coverage"
}, $re = { class: "fe-coverage__text" }, Tre = ["disabled", "aria-busy"], Are = {
  key: 3,
  class: "fe__presence"
}, Ere = ["title"], Cre = {
  key: 4,
  class: "fe-e2e-upgrade",
  role: "alert"
}, zre = { class: "fe-e2e-upgrade__text" }, Mre = {
  key: 0,
  class: "fe-e2e-upgrade__escrow"
}, Pre = { class: "fe-e2e-upgrade__actions" }, Ore = ["disabled"], Lre = ["disabled"], Dre = {
  key: 5,
  class: "fe-e2e-upgrade fe-e2e-upgrade--escrow",
  role: "alert"
}, Rre = { class: "fe-e2e-upgrade__text" }, Ire = { class: "fe-e2e-upgrade__escrow" }, Nre = {
  key: 0,
  class: "fe-e2e-upgrade__escrow"
}, Bre = {
  key: 1,
  class: "fe-e2e-upgrade__pw"
}, Fre = ["disabled"], Ure = {
  key: 2,
  class: "fe-form__error",
  role: "alert"
}, Hre = { class: "fe-e2e-upgrade__actions" }, Kre = ["disabled"], Vre = ["disabled"], jre = {
  key: 6,
  class: "fe-e2e-upgrade fe-e2e-upgrade--names",
  role: "status",
  "data-testid": "e2e-convert-strip"
}, qre = { class: "fe-e2e-upgrade__text" }, Wre = { key: 0 }, Yre = {
  key: 1,
  class: "fe-e2e-upgrade__progress",
  "data-testid": "e2e-convert-progress"
}, Gre = {
  key: 2,
  class: "fe-e2e-upgrade__progress",
  "data-testid": "e2e-convert-large"
}, Xre = {
  key: 3,
  class: "fe-form__error",
  role: "alert"
}, Jre = { class: "fe-e2e-upgrade__actions" }, Zre = {
  key: 7,
  class: "fe-e2e-upgrade fe-e2e-upgrade--names",
  role: "status",
  "data-testid": "e2e-names-progress-strip"
}, Qre = { class: "fe-e2e-upgrade__text" }, ese = { key: 0 }, tse = {
  key: 1,
  class: "fe-e2e-upgrade__progress",
  "data-testid": "e2e-names-progress"
}, nse = {
  key: 2,
  class: "fe-form__error",
  role: "alert"
}, ase = { class: "fe-e2e-upgrade__actions" }, ise = {
  key: 8,
  class: "fe-e2e-upgrade fe-e2e-upgrade--rekey",
  role: "status",
  "data-testid": "e2e-rekey-offer"
}, ose = { class: "fe-e2e-upgrade__text" }, rse = {
  key: 0,
  class: "fe-e2e-upgrade__progress",
  "data-testid": "e2e-rekey-progress"
}, sse = {
  key: 1,
  class: "fe-form__error",
  role: "alert"
}, lse = { class: "fe-e2e-upgrade__actions" }, use = ["disabled"], cse = {
  key: 10,
  class: "fe-e2e-strip",
  role: "status"
}, dse = ["innerHTML"], fse = { class: "fe-e2e-strip__label" }, pse = {
  class: "fe-e2e-strip__names",
  "data-testid": "e2e-names-status"
}, hse = ["disabled"], mse = {
  key: 11,
  class: "fe-trashbar"
}, vse = { class: "fe-trashbar__text" }, yse = {
  key: 0,
  class: "fe-trashbar__count",
  "data-testid": "trash-summary"
}, gse = {
  key: 0,
  class: "fe-trashbar__shown"
}, bse = ["disabled"], kse = {
  key: 2,
  class: "fe-trashbar__progress",
  role: "status",
  "aria-live": "polite"
}, wse = ["disabled"], _se = {
  key: 2,
  class: "fe-state"
}, xse = { class: "fe-state__title" }, Sse = { class: "fe-state__path" }, $se = { class: "fe-state__hint" }, Tse = { class: "fe-state__actions" }, Ase = {
  key: 0,
  class: "fe-state"
}, Ese = { class: "fe-state__title" }, Cse = { class: "fe-state__hint" }, zse = ["data-testid"], Mse = {
  class: "fe-state__art",
  viewBox: "0 0 120 100",
  width: "110",
  height: "92",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true"
}, Pse = {
  key: 1,
  d: "M60 26l9 18.6 20.4 3-14.8 14.4 3.5 20.4L60 72.8 41.9 82.4l3.5-20.4L30.6 47.6l20.4-3z"
}, Ose = { class: "fe-state__title" }, Lse = { class: "fe-state__hint" }, Dse = {
  key: 2,
  class: "fe-state"
}, Rse = { class: "fe-state__title" }, Ise = { class: "fe-state__hint" }, Nse = {
  key: 3,
  class: "fe-state"
}, Bse = {
  class: "fe-state__art",
  viewBox: "0 0 120 100",
  width: "110",
  height: "92",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true"
}, Fse = { key: 0 }, Use = { class: "fe-state__title" }, Hse = {
  key: 0,
  class: "fe-state__hint"
}, Kse = {
  key: 1,
  class: "fe-state__actions"
}, Vse = { class: "fe-overlay__head" }, jse = { class: "fe-overlay__title" }, qse = ["title", "aria-label"], Wse = {
  key: 1,
  class: "fe__dragover"
}, Yse = { class: "fe__dragover-card" }, Gse = ["innerHTML"], Xse = ["title", "aria-label"], Jse = {
  key: 3,
  class: "fe-keep-strip",
  role: "status",
  "aria-live": "polite"
}, Zse = { class: "fe-keep-strip__label" }, Qse = {
  key: 0,
  class: "fe-keep-strip__bar",
  "aria-hidden": "true"
}, ele = {
  key: 0,
  "data-testid": "trash-empty-count"
}, tle = {
  key: 1,
  class: "fe-form__error",
  role: "alert"
}, nle = {
  key: 2,
  role: "status"
}, ale = ["disabled"], ile = { class: "fe-recents__header" }, ole = ["aria-label"], rle = { class: "fe-modal__head" }, sle = { class: "fe-modal__title" }, lle = ["aria-label"], ule = { class: "fe-modal__body" }, cle = { class: "fe-toast__msg" }, J0 = "brf-file-explorer:view-mode", kf = 250, Z0 = 3, Q0 = "user-settings", dle = 800, e2 = "filex.inspector", t2 = "filex.sidenav", n2 = 250, Ku = 100, fle = 500, ple = 2e3, hi = 2500, yn = 6e3, wf = 10 * 60 * 1e3, a2 = 200, xv = "brf-file-explorer:path", hle = 40, mle = "application/x-brf-files", vle = 8 * 1024 * 1024, yle = 10, gle = "/files/edit", i2 = "filex.tabs", ble = "https://docs.filex.sh/E2E-ENCRYPTION#what-escrow-can-and-cannot-do", kle = 6e4, wle = 2e3, Zhe = /* @__PURE__ */ lt({
  __name: "FileExplorer",
  props: {
    config: {}
  },
  emits: ["share-created", "file-opened", "error", "upload-progress", "selection-change", "navigate", "refresh", "open-my-shares", "open-app-store", "open-app-home"],
  setup(e, { expose: t, emit: n }) {
    var Hw;
    const a = () => import("./E2eVaultStrip-T4mTzvG6.js"), i = k2(a), o = Xn(() => import("./PreviewModal-BvoO-1IK.js").then((r) => r.P)), l = Xn(() => import("./QuickLook-BYGOJ4a0.js")), c = Xn(() => import("./UserSettingsDialog-DuTnZYxg.js")), p = Xn(() => import("./TimeZoneDialog-BG3uZ9WF.js")), m = Xn(() => import("./LanguageDialog-D3wLbGqC.js")), v = Xn(() => import("./PermissionsModal-CGTzgMe5.js")), x = Xn(() => import("./AdvancedSearch-CtCbg5wv.js")), w = Xn(() => import("./CommandPalette-DGmyvsw1.js")), S = Xn(() => import("./NewDocumentModal-BRNAHjdS.js")), k = Xn(() => import("./ArchiveCreateModal-DS-cjOG5.js")), b = Xn(() => import("./OnboardingTour-Bp9wpXBL.js")), C = Xn(() => import("./ShortcutSettings-DK0cNtSf.js")), T = Xn(() => import("./EncryptedFolderModal-CkKHphe8.js")), A = Xn(() => import("./E2eSettingsModal-AkYy2NYf.js")), L = Xn(() => import("./E2eChangePasswordModal-B6qWhYw4.js")), z = Xn(() => import("./RecoveryKeyModal-WUs7WQfz.js")), D = Xn(() => import("./E2eRecoveryUnlockModal-DqtSuXGF.js")), U = Xn(() => import("./E2eFileEncryptModal-8RyVGIKR.js")), q = Xn(() => import("./E2eFileUnlockModal-DxfAOzU8.js")), P = e, R = n, W = $(""), N = E(() => aoe(P.config)), J = E(
      () => q0({
        embedded: N.value,
        chosen: W0(),
        account: W.value,
        browser: Cv(),
        host: P.config.locale
      })
    ), H = E(() => J.value.locale), ne = E(
      () => P.config.locale === H.value ? P.config : { ...P.config, locale: H.value }
    ), j = Rl(P.config, { screenLocale: () => H.value }), re = $(null), he = E(
      () => {
        var r;
        return P.config.permissions ?? ((r = re.value) == null ? void 0 : r.permissions);
      }
    ), ue = E(
      () => {
        var r;
        return P.config.permissions ? P.config.permissionsByFolder : (r = re.value) == null ? void 0 : r.byFolder;
      }
    );
    let ae = Promise.resolve();
    function fe() {
      P.config.permissions || (ae = j.myPermissions().then(
        (r) => {
          re.value = r && !r.admin ? { permissions: r.permissions, byFolder: r.byFolder } : null;
        },
        () => {
          re.value = null;
        }
      ));
    }
    jt(fe), Wo(sx, () => H.value), Je(H, (r) => _g(r), { immediate: !0 });
    const { t: _, formatDate: Q, dir: K } = pt(H), I = pae({
      http: {
        endpoints: j.endpoints,
        authHeaders: (r) => j.authHeaders(r),
        credentialsMode: () => j.credentialsMode(),
        downloadUrl: (r) => j.downloadUrl(r),
        acceptLanguage: () => gi(H.value)
      },
      headersNow: () => j.authHeadersSync(),
      t: (r, s) => _(r, s),
      toast: (r, s) => qt({ message: r }, s ? yn : hi),
      emitError: (r, s) => R("error", { message: r, context: { op: s } }),
      // The lock's holder says which client: the desktop app is the explorer that
      // was handed the shell's hooks.
      clientKind: () => P.config.desktopSync || P.config.dragOut ? "desktop" : "web",
      dropKeys: (r) => gM(r),
      formatCount: (r) => new Intl.NumberFormat(gi(H.value)).format(r),
      onLocked: (r, s) => bM(r, s),
      onChanged: (r) => kM(r),
      onLockSoon: (r, s) => dM(r, s),
      askName: (r) => B(r)
    }), Y = $(null);
    function B(r) {
      return new Promise((s) => {
        Y.value = { ...r, resolve: s };
      });
    }
    function V(r) {
      const s = Y.value;
      Y.value = null, s == null || s.resolve(r);
    }
    function be(r) {
      return I.rootOf(r) ?? r;
    }
    function Fe(r) {
      const s = String(r ?? "").replace(/\/+$/, ""), g = I.rootOf(s);
      if (!g || !I.isOpen(g)) return null;
      const M = I.rows(s) ? s : g, F = I.permOf(g);
      return {
        adapter: M.slice(0, M.indexOf("://")),
        storages: [],
        dirname: M,
        read_only: !1,
        ...F ? { perm: F } : {},
        e2e_root: g,
        e2e_vault_root: g,
        files: Mr(I.rows(M) ?? [])
      };
    }
    function ze(r) {
      const s = String(r.dirname ?? "").replace(/\/+$/, ""), g = typeof r.e2e_vault_root == "string" && r.e2e_vault_root ? r.e2e_vault_root : I.rootOf(s);
      return g ? { ...r, e2e_vault_root: g, files: [] } : r;
    }
    const Ue = {
      ...j,
      index: async (r) => {
        const s = Fe(r);
        if (s) return s;
        const g = I.rootOf(String(r ?? ""));
        return ze(await j.index(g ?? r));
      }
    }, We = () => Promise.reject(new Error("vault: not asked")), $t = {
      ...j,
      listShares: (r) => I.rootOf(r) ? We() : j.listShares(r),
      listPermissions: (r) => I.rootOf(r) ? We() : j.listPermissions(r),
      createShare: (r) => I.rootOf(r.path) ? We() : j.createShare(r)
    };
    function St() {
      typeof document < "u" && document.visibilityState === "visible" && I.onVisible();
    }
    jt(() => {
      typeof document < "u" && document.addEventListener("visibilitychange", St), typeof window < "u" && window.addEventListener("pagehide", I.onPageHide);
    }), Tt(() => {
      typeof document < "u" && document.removeEventListener("visibilitychange", St), typeof window < "u" && window.removeEventListener("pagehide", I.onPageHide), I.closeAll("manual");
    });
    const at = L3(j, {
      reload: () => wt(),
      onVault: (r) => I.onEvent(r),
      onAccess: (r) => hC(r)
    }), kt = at.presenceUsers, ht = at.degraded;
    function Ie(r) {
      const s = (r || "").replace(/^\/+|\/+$/g, "");
      if (s === ".trash" || s.startsWith(".trash/")) return null;
      const g = Rt(s);
      return !g || !g.includes("://") || g.startsWith("://") ? null : I.rootOf(g) ?? g;
    }
    jt(() => {
      at.start(), at.subscribe(Ie(Xe.value));
    }), Tt(() => at.stop());
    const se = I3(P.config.apiBase, j), xe = WO(P.config, j), me = /* @__PURE__ */ new Map(), De = vx(P.config, j, {
      onSettled: (r) => {
        var M, F;
        const s = me.get(r.id);
        if (me.delete(r.id), r.op_type === "trash-empty") {
          wt();
          return;
        }
        const g = cm.get(r.id);
        if (g) {
          cm.delete(r.id), bu(g, !1);
          const X = r.summary || (r.status === "error" ? Zf(r, _).text : "");
          X && r.status !== "cancelled" && qt({ message: X }, r.status === "done" ? hi : yn), Ft.value && zi();
          return;
        }
        if (r.status === "cancelled") {
          const X = r.op_type === "archive-extract" ? _("archive.extraction_cancelled", { count: r.progress_done }) : _("opc.status.aborted");
          tt(X);
        } else if (r.op_type === "restore" && r.summary)
          qt({ message: r.summary }, r.status === "done" ? hi : yn);
        else if (r.status === "error")
          tt(Zf(r, _).text);
        else if (s)
          $d(r.op_type === "rename" ? s.message : `${s.message} (${r.progress_total})`, s.fn);
        else if (r.op_type === "plugin") {
          tt(r.message || _("plugin.done", { label: tE(r) }));
          const X = XS(r, { busy: !!Nn.value || !!La.value });
          if (X) {
            hh(X.plugin, X.open), (M = Zt.value) == null || M.reload();
            return;
          }
        } else if (r.op_type === "rename")
          tt(_("toast.renamed"));
        else if (r.op_type === "restore")
          tt(_("toast.restored", { n: r.progress_done }));
        else {
          const X = r.op_type === "archive-create" ? _("archive.created") : r.op_type === "archive-extract" ? _("archive.extraction_completed") : r.op_type === "copy" ? _("toast.copied") : r.op_type === "move" ? _("toast.moved") : _("toast.deleted");
          tt(r.op_type.startsWith("archive-") ? X : `${X} (${r.progress_total})`);
        }
        wt(), (F = Zt.value) == null || F.reload();
      }
    }), ot = $(!1), ft = (P.config.rootPath || "").trim(), gt = ft.replace("://", "/").replace(/^\/+|\/+$/g, ""), Ut = gt || P.config.initialPath || "", Xe = $(Ut), je = UJ(), Be = (r) => je.isNewest(r), ie = $(P.config.defaultAdapter || "brf"), ge = $(Ut), G = $([]), ye = $(""), te = $(!1), Ce = $(""), Ne = $("");
    let _e;
    function Ae() {
      wt(_e);
    }
    const Pe = $(
      (() => {
        try {
          const r = localStorage.getItem(J0);
          if (r === "list" || r === "grid" || r === "gallery") return r;
        } catch {
        }
        return P.config.viewMode ?? "list";
      })()
    ), _t = $("comfortable"), Et = $(""), xn = $(!1), Dt = $({}), bn = $({}), un = $({});
    let Jt = null;
    function Ln() {
      if (!Jt) {
        const r = ca(P.config);
        Jt = Rie({
          list: async () => {
            const s = await j.jsonFetch(`${r}/api/admin/storages`);
            return Array.isArray(s) ? s : [];
          }
        });
      }
      return Jt;
    }
    function Vn(r) {
      return !!r && r in un.value;
    }
    const Ft = $(!1), na = $(""), Kt = E(() => Ft.value), bt = $(""), Dn = $(""), In = E(
      () => bt.value !== "" && bt.value !== "trash" && bt.value !== "home"
    ), Cn = E(
      () => bt.value === "recent" || bt.value === "starred" || bt.value === "shared" || bt.value === "tag"
    ), fn = E(() => P.config.rememberFolderView !== !1), mn = E(() => {
      if (!fn.value) return "";
      const r = String(Xe.value ?? "").replace(/^\/+|\/+$/g, "");
      if (!r) return u5;
      const [s, ...g] = r.split("/"), M = (P.config.storages ?? []).find((F) => F.name === s);
      return Z_((M == null ? void 0 : M.uid) || s, g.join("/"));
    });
    function aa() {
      const r = jp().v;
      if (r) return r;
      if (!Xs())
        try {
          const s = localStorage.getItem(J0);
          if (s === "list" || s === "grid" || s === "gallery") return s;
        } catch {
        }
      return P.config.viewMode ?? "list";
    }
    Oy(
      NS(() => {
        Xs() && Mn(mn.value);
      })
    );
    let zn = null;
    function Mn(r) {
      if (!r && fn.value) return;
      d5(r);
      const s = r ? m5(r) : {}, g = s.v ?? aa();
      if (g !== Pe.value && (Pe.value = g), s.k) u1(s.k, s.d ?? El(s.k));
      else {
        const M = xg();
        u1(M.key, M.dir);
      }
      zn = { key: r, v: Pe.value, k: s1(), d: l1() };
    }
    jt(() => {
      C5({
        apiBase: P.config.apiBase ?? "",
        headers: Qn,
        credentials: j.credentialsMode()
      });
    }), Je(
      [mn, () => Xs()],
      ([r, s]) => {
        s && Mn(r);
      },
      { immediate: !0, flush: "post" }
    ), Je(
      () => [mn.value, Pe.value, s1(), l1()],
      ([r, s, g, M]) => {
        if (!Xs() || !zn || zn.key !== r) return;
        const F = {};
        s !== zn.v && (F.v = s), (g !== zn.k || M !== zn.d) && (F.k = g, F.d = M), zn = { key: r, v: s, k: g, d: M }, Object.keys(F).length && (r ? PS(r, F) : fn.value || LS(F));
      },
      /* ⚠⚠ `post`, and registered AFTER the applier: a navigation changes
       * `currentFolderKey`, which both watchers depend on. Pre-flush this would
       * run first, while the view state is still the folder you LEFT, and record
       * that folder's setup against the one you arrived in. */
      { flush: "post" }
    ), Je(
      () => iy(mn.value),
      (r, s) => {
        s && !r && Xs() && Mn(mn.value);
      }
    );
    const rn = $(""), ve = $(""), Le = {
      home: ".home",
      recent: ".recent",
      starred: ".starred",
      shared: ".shared",
      drafts: ".drafts"
    };
    function He(r) {
      if (!TS(r)) return null;
      const s = String(r ?? "").replace(/^\/+|\/+$/g, ""), g = i5(s);
      return g ? { kind: "tag", tag: g, tagKind: a5(s) } : { kind: s.slice(1), tag: "", tagKind: "" };
    }
    const Ke = E(() => {
      if (!Sn.value) return "";
      const r = P.config.storages ?? [];
      return r.length === 1 ? r[0].name : "";
    }), xt = E(() => {
      const r = (Xe.value ?? "").replace(/^\/+|\/+$/g, "");
      return gt && r === gt || Ke.value && r === Ke.value ? !1 : r.length > 0;
    }), Qe = E(() => bt.value && bt.value !== "trash" ? !0 : Sn.value ? !(Xe.value ?? "").replace(/^\/+|\/+$/g, "") : !1), ce = E(
      () => bt.value === "home" ? "find" : "full"
    );
    function qe() {
      if (Ft.value) {
        wt(na.value);
        return;
      }
      if (bt.value) {
        wt(Dn.value);
        return;
      }
      const r = (Xe.value ?? "").replace(/^\/+|\/+$/g, "");
      if (!r || r === gt || Ke.value && r === Ke.value) return;
      const s = r.lastIndexOf("/");
      let g = s === -1 ? "" : r.slice(0, s);
      gt && !(g === gt || g.startsWith(gt + "/")) && (g = gt), wt(g);
    }
    const dt = $([]), Nt = E(
      () => (dt.value.length ? dt.value : G.value).filter((r) => r.type !== "dir")
    ), hn = E(() => {
      var M;
      const r = Nt.value, s = (M = pn.value) == null ? void 0 : M.path, g = s ? r.findIndex((F) => F.path === s) : -1;
      return { index: g === -1 ? 0 : g + 1, total: g === -1 ? 0 : r.length };
    });
    async function nn(r) {
      const s = Nt.value, g = s.findIndex((F) => {
        var X;
        return F.path === ((X = pn.value) == null ? void 0 : X.path);
      });
      if (g === -1) return;
      const M = s[g + r];
      if (M) {
        if (Ui(M) && !an.value && !M.e2e_root) {
          la.value = !1, Mt.open(M);
          return;
        }
        if (Yn.value && M.type === "file")
          try {
            await ef(M);
          } catch {
            tt(_("e2e.decrypt_failed"));
            return;
          }
        pn.value = M;
      }
    }
    function oe(r) {
      const s = Date.now(), g = /* @__PURE__ */ new Set([...G.value, ...dt.value]);
      pn.value && g.add(pn.value);
      for (const M of g)
        M.path === r.path && (typeof r.size == "number" && (M.size = r.size), M.last_modified = s);
    }
    const le = S_(() => dt.value.length ? dt.value : G.value);
    Je(
      () => [...le.selected.value],
      () => {
        R(
          "selection-change",
          /* wiring:e2 names — `basename` stays what the server calls the item
             (hosts pass it back to the API); an encrypted-names row adds its
             plaintext as `display_name` for a host that draws it. */
          le.nodes.value.map((s) => ({
            path: s.path,
            basename: Mf(s),
            type: s.type,
            ...s.e2e_stored ? { display_name: s.basename } : {}
          }))
        );
        const r = le.nodes.value.filter((s) => s.type === "file");
        at.setFocus(r.length === 1 && !I.isVaultRow(r[0]) ? Mf(r[0]) : null);
      }
    );
    const Me = $({ mode: null, items: [], sourcePath: null }), Ve = $(null);
    let it = null;
    function Z() {
      return it || (j.endpoints.capabilities ? (it = (async () => {
        for (let r = 1; r <= Z0; r++)
          try {
            Ve.value = await j.capabilities();
            return;
          } catch (s) {
            if (r === Z0) {
              R("error", {
                message: `capabilities: ${(s == null ? void 0 : s.message) ?? String(s)}`,
                context: { what: "capabilities", attempts: r }
              });
              return;
            }
            await new Promise((g) => setTimeout(g, 200 * r));
          }
      })(), it) : (it = Promise.resolve(), it));
    }
    const ee = $(!1);
    let we = null;
    function Ye() {
      return we || (we = j.jsonFetch(`${ca(P.config)}/api/auth/me`), we.catch(() => {
        we = null;
      })), we;
    }
    const rt = MZ({
      config: () => P.config,
      capabilities: Ve,
      fetchMe: () => Ye()
    }), vt = P.config.notifications ? b2(
      dre({
        // The server says each row in the language on screen (`lang=`).
        transport: fre(j.jsonFetch, ca(P.config)),
        errorText: (r) => (r == null ? void 0 : r.message) || _("inspector.error"),
        onRead: () => {
          var r, s;
          return (s = (r = P.config.notifications) == null ? void 0 : r.onRead) == null ? void 0 : s.call(r);
        }
      })
    ) : null;
    let Bt = null;
    jt(() => {
      var s;
      const r = P.config.notifications;
      !vt || !r || (vt.refreshFeed(), r.poll !== !1 && (Bt = setInterval(() => void vt.syncUnread(), cre)), (s = r.onUnread) == null || s.call(r, (g) => void vt.acceptCount(g)));
    }), Tt(() => {
      Bt && clearInterval(Bt), Bt = null;
    }), Je(H, () => {
      vt && (vt.refreshFeed(), vt.panelOpen && vt.fetchMine());
    });
    const Qt = E(() => {
      var g, M, F;
      const r = (M = (g = P.config.notifications) == null ? void 0 : g.manage) == null ? void 0 : M.href;
      return r && (pa.value || ((F = Un.value) == null ? void 0 : F.role) === "admin") ? r : void 0;
    });
    function en() {
      var r, s;
      (s = (r = P.config.notifications) == null ? void 0 : r.manage) == null || s.open();
    }
    let Ot = () => {
    };
    const kn = new Promise((r) => {
      Ot = r;
    });
    async function Pa(r) {
      var M;
      if (await kn, r.kind === "none") return !1;
      if (r.kind === "share")
        return window.open(vA(r.token, ca(P.config)), "_blank", "noopener"), !0;
      if (r.kind === "app")
        return await Z(), await Oa.refresh(), await bb(`${r.plugin}/${r.view}`), !0;
      const s = hoe(r);
      if (!s) return !1;
      s === Ep ? await wt(Ep) : await wt(Sn.value ? Co(s) : Va(s));
      const g = r.select;
      if (g) {
        const F = G.value.find((X) => Y0(X.path, g));
        if (F) {
          le.click(F.path), await Gt();
          const X = Array.from(((M = Tn.value) == null ? void 0 : M.querySelectorAll("[data-fe-path]")) ?? []).find(
            (de) => Y0(de.getAttribute("data-fe-path"), g)
          );
          X == null || X.scrollIntoView({ block: "center" });
        }
      }
      if (r.kind === "folder" && r.open) {
        const F = r.select || s;
        await ph({ plugin: r.open.plugin, action: r.open.action, view: r.open.view, path: F });
      }
      return !0;
    }
    function cn(r) {
      Pa(hA(r.target));
    }
    const pe = E(() => {
      var r;
      return (P.config.callerKind ?? ((r = Ve.value) == null ? void 0 : r.caller_kind)) === "user";
    });
    function ke() {
      return {
        person: pe.value,
        embedded: N.value,
        host: P.config.locale,
        me: Ye,
        updateProfile: (r) => X0(j.jsonFetch, ca(P.config)).updateProfile(r)
      };
    }
    function Oe() {
      ioe(ke()).then((r) => {
        r && (W.value = r);
      });
    }
    let st = !1;
    Je(
      pe,
      (r) => {
        if (!r) {
          W.value = "";
          return;
        }
        st || (st = !0, Oe());
      },
      { immediate: !0 }
    ), Je(
      () => P.config.locale,
      () => {
        N.value || (W.value = "");
      }
    );
    const tn = $(!1), Lt = E(
      () => q0({
        embedded: !0,
        chosen: "",
        account: W.value,
        browser: Cv(),
        host: P.config.locale
      })
    );
    function xa(r) {
      const s = ooe(r, ke());
      s && pe.value && (W.value = s);
    }
    jt(() => {
      N.value && TP({
        base: ca(P.config),
        headers: () => j.authHeaders(),
        timeoutMs: SP
      });
    });
    const Un = $(((Hw = P.config.account) == null ? void 0 : Hw.person) ?? null);
    jt(() => {
      !P.config.account || P.config.account.person || Ye().then((r) => {
        Un.value = (r == null ? void 0 : r.user) ?? null;
      }).catch(() => {
      });
    });
    const Si = $([]);
    let ir = null;
    function Ul(r) {
      if (!P.config.account) return;
      const s = r.detail;
      !s || !Array.isArray(s.items) || (s.claimed = !0, r.stopPropagation(), Si.value = s.items, ir = typeof s.run == "function" ? s.run : null);
    }
    jt(() => {
      var r;
      return (r = Tn.value) == null ? void 0 : r.addEventListener("fe:header-menu", Ul);
    }), Tt(() => {
      var r;
      return (r = Tn.value) == null ? void 0 : r.removeEventListener("fe:header-menu", Ul);
    });
    const To = E(() => {
      const r = P.config.account;
      if (!r) return [];
      const s = Un.value, g = typeof r.actions == "function" ? r.actions(s) : r.actions ?? [], M = r.settings ? [{ key: Q0, label: _("userSettings.open"), icon: "account" }, ...g] : g, F = typeof r.tail == "function" ? r.tail(s) : r.tail ?? [], X = pre.filter((Se) => Se !== "inspector" || P.config.showInfoPanel !== !1), de = r.settings ? hre : [];
      return mre(M, Si.value, {
        omit: [...X, ...de, ...r.omit ?? []],
        tail: F
      });
    });
    function ad(r) {
      var g, M;
      const s = vre(r);
      if (s !== null) {
        ir == null || ir(s);
        return;
      }
      if (r === Q0 && ((g = P.config.account) != null && g.settings)) {
        id.value = !0;
        return;
      }
      (M = P.config.account) == null || M.select(r, Un.value);
    }
    const id = $(!1), NA = {
      get locale() {
        return String(H.value);
      },
      get user() {
        return Un.value;
      },
      get isAdmin() {
        var r;
        return ((r = Un.value) == null ? void 0 : r.role) === "admin";
      },
      get demoReadOnly() {
        var r;
        return ((r = Ve.value) == null ? void 0 : r.demo_mode) === !0;
      },
      get capabilities() {
        return Ve.value;
      },
      api: X0(j.jsonFetch, ca(P.config)),
      setUser(r) {
        Un.value = { ...Un.value ?? {}, ...r };
      },
      toast(r, s) {
        qt({ message: s }, r === "success" ? hi : yn);
      },
      errorText: (r, s) => (r == null ? void 0 : r.message) || s,
      zone: kO(rt),
      mode: {
        get: () => {
          const r = ku.value === "host" ? P.config.theme || "auto" : ku.value;
          return r === "light" || r === "dark" ? r : "auto";
        },
        set: (r) => pb(r)
      },
      // The rows only the host can carry out (ExplorerConfig.account.settings as
      // an object, task #258): the desktop app's language, its click setting and
      // its own notifications. Read per access, so a host that swaps its config
      // is followed.
      get language() {
        var r;
        return (r = od()) == null ? void 0 : r.language;
      },
      get openTrigger() {
        var r;
        return (r = od()) == null ? void 0 : r.openTrigger;
      },
      get deviceNotifications() {
        var r;
        return (r = od()) == null ? void 0 : r.deviceNotifications;
      }
    };
    function od() {
      var s;
      const r = (s = P.config.account) == null ? void 0 : s.settings;
      return r && typeof r == "object" ? r : void 0;
    }
    function pb(r) {
      var s;
      Zk(r), (s = P.config.accountPrefs) != null && s.surface && (r === "light" || r === "dark" || r === "auto") && Zi("theme", r);
    }
    jt(() => {
      var s;
      const r = (s = P.config.accountPrefs) == null ? void 0 : s.surface;
      r && (iU({ surface: r, base: ca(P.config), headers: () => j.authHeaders() }), cU().then((g) => {
        g && ((g.theme === "light" || g.theme === "dark" || g.theme === "auto") && Zk(g.theme), IT(g.palette), zZ(g.density));
      }));
    });
    const BA = E(
      () => {
        var r, s;
        return ((r = Ve.value) == null ? void 0 : r.share_link_max_days) ?? ((s = Ve.value) == null ? void 0 : s.share_max_ttl_days) ?? 0;
      }
    ), or = E(() => {
      var r, s;
      return typeof P.config.plugins == "boolean" ? P.config.plugins : ((s = (r = Ve.value) == null ? void 0 : r.app_plugins) == null ? void 0 : s.enabled) === !0;
    }), Oa = x3(j, () => or.value), Nn = $(null);
    let hb = 0;
    const ch = $(!1);
    let dh;
    Tt(() => clearTimeout(dh));
    function FA(r) {
      const s = ++hb;
      return Nn.value = { ...r, surface: null, ticket: s }, ch.value = !1, clearTimeout(dh), dh = setTimeout(() => {
        rd(s) && (ch.value = !0);
      }, dle), s;
    }
    const UA = E(
      () => !!Nn.value && (Nn.value.surface !== null || ch.value)
    );
    function rd(r) {
      var s;
      return r > 0 && ((s = Nn.value) == null ? void 0 : s.ticket) === r;
    }
    const La = $(null);
    function HA(r) {
      return r.filter((s) => s.type === "file").map((s) => ({
        path: s.path,
        name: s.basename,
        size: s.size,
        mime: s.mime_type,
        readOnly: !!s.read_only || !io(s),
        ...s.encrypted ? { encrypted: s.encrypted } : {}
      }));
    }
    const Hl = E(() => or.value ? Oa.views.value : []), Kl = E(() => or.value ? Oa.openRules.value : {}), mb = E(() => ({ onlyOffice: !!rr.value }));
    function rs(r) {
      return { ...mb.value, inEncrypted: an.value || I.isVaultRow(r), e2ePlaintext: !!fh(r) };
    }
    function fh(r) {
      var M;
      if (Wn.value, !r || r.type !== "file" || Ui(r) || ((M = Ve.value) == null ? void 0 : M.apps_e2e_plaintext) !== !0) return null;
      if (I.isVaultRow(r)) return KA(r);
      if (r.encrypted && r.encrypted !== "folder") return null;
      const s = typeof r.e2e_root == "string" && r.e2e_root || (an.value ? Ct.value : null), g = Vt.rootOf(r.path, s);
      return !g || !sn.has(g) ? null : g;
    }
    function KA(r) {
      I.version.value;
      const s = typeof r.vault_root == "string" ? r.vault_root : "";
      return s && I.isOpen(s) ? s : null;
    }
    function Vl(r, s, g) {
      const M = qu(Hl.value, r, s, Kl.value, jl(r), rs(r));
      return M != null && M.view ? ($i.value = s, Ha.value = g === "edit" && io(r) ? "edit" : "view", pn.value = r, la.value = !0, R("file-opened", { path: r.path, basename: r.basename }), Ua(r), !0) : !1;
    }
    function vb(r) {
      return Q$(Hl.value, r, Kl.value, rs(r));
    }
    function jl(r) {
      return r ? Yie(Lr(r)) : null;
    }
    const $i = $(null), yb = E(
      () => qu(
        Hl.value,
        pn.value,
        $i.value,
        Kl.value,
        jl(pn.value),
        rs(pn.value)
      )
    ), gb = E(() => {
      var r;
      return ((r = yb.value) == null ? void 0 : r.view) ?? null;
    }), VA = E(() => Rf(yb.value));
    function jA(r) {
      return Rf(r) ? _("ctx.open_with", { app: "ONLYOFFICE" }) : r.view ? _("ctx.open_with", { app: Xt(r.view.label, H.value) || r.view.plugin }) : _("ctx.open_with_builtin");
    }
    function qA(r) {
      var M;
      if (r.length !== 1) return [];
      const { on: s } = vb(r[0]), g = !X$(r[0], rs(r[0])) && ((M = r[0]) == null ? void 0 : M.type) === "file" && nh(Lr(r[0])) && !mb.value.onlyOffice ? [
        {
          key: `open-with:${Ll}`,
          label: _("ctx.open_with", { app: "ONLYOFFICE" }),
          icon: "open",
          testid: `ctx-open-with-${Ll}`,
          ...Km(!1, pa.value, _("ctx.needs_onlyoffice"))
        }
      ].filter((F) => !F.hidden) : [];
      return s.length < 2 && g.length === 0 ? [] : [
        ...s.map((F) => ({ key: `open-with:${F.id}`, label: jA(F), icon: "open", testid: `ctx-open-with-${F.id}` })),
        ...g,
        ...s.length < 2 ? [] : [{ key: "open-with-choose", label: _("ctx.open_with_choose"), icon: "open", testid: "ctx-open-with-choose" }]
      ];
    }
    const Da = $(null), WA = E(() => vb(Da.value).on), YA = E(
      () => Da.value && !nH(Da.value) ? Lr(Da.value) : ""
    ), GA = E(() => {
      var s;
      const r = Da.value;
      return r ? ((s = qu(Hl.value, r, null, Kl.value, jl(r), rs(r))) == null ? void 0 : s.id) ?? null : null;
    });
    function XA(r, s) {
      const g = Da.value;
      if (!g) return;
      const M = Lr(g);
      if (Da.value = null, s && M && Gie(M, r), (Yn.value || I.isVaultRow(g)) && fh(g)) {
        (r === bo || !Vl(g, r, "edit")) && ($i.value = bo, Ns(g));
        return;
      }
      Dd(g), $i.value = r, r !== "builtin" && io(g) && (Ha.value = "edit");
    }
    const JA = Xie();
    Tt(JA);
    const ZA = E(
      () => or.value ? Oa.views.value.filter((r) => r.placement === "inspector") : []
    ), QA = E(
      () => or.value ? Oa.views.value.filter((r) => r.placement === "home").map((r) => ({ key: `${r.plugin}/${r.id}`, label: Xt(r.label, H.value) || r.id, icon: r.icon })) : []
    );
    async function bb(r) {
      const s = Oa.views.value.find((g) => `${g.plugin}/${g.id}` === r);
      if (s) {
        if (Eo(), P.config.appHomePage === !0) {
          R("open-app-home", { plugin: s.plugin, view: s.id });
          return;
        }
        if (s.ui) {
          La.value = {
            plugin: s.plugin,
            view: s.id,
            placement: "home",
            ui: s.ui,
            label: Xt(s.label, H.value) || s.plugin,
            files: []
          };
          return;
        }
        try {
          const g = await j.pluginView(s.plugin, s.id);
          if (!(g != null && g.surface)) {
            tt(_("plugin.view.error"));
            return;
          }
          Nn.value = { plugin: s.plugin, view: s.id, surface: g.surface, size: "xl" };
        } catch (g) {
          tt((g == null ? void 0 : g.message) || _("plugin.view.error"));
        }
      }
    }
    const Ti = $(null);
    function eE(r) {
      return or.value ? b3(Oa.actions.value, r, {
        locale: H.value,
        trash: Kt.value,
        e2e: an.value,
        readOnly: te.value || ak(r),
        // The level each row answers with — the same one the built-in verbs
        // read — so an app's row a viewer could only be refused is not offered.
        permOf: (s) => Ih(s),
        hasIcon: (s) => zt(s) !== "",
        // Greyed rows with the reason are an ADMINISTRATOR's (the server sends
        // `gated` to them only; asked here too, so no other caller draws one).
        needWords: pa.value ? (s) => p3(s, _) : void 0
      }) : [];
    }
    function tE(r) {
      return r.label || r.action || _("opc.kind.plugin");
    }
    function nE(r) {
      var s;
      if (!(!r.plugin || !r.action))
        return (s = Oa.actions.value.find((g) => g.plugin === r.plugin && g.id === r.action)) == null ? void 0 : s.output_mode;
    }
    async function kb(r, s) {
      const g = Oa.byKey(r);
      if (!g || s.length === 0) return;
      if (Xt(g.confirm, H.value)) {
        Ti.value = { action: g, targets: s };
        return;
      }
      await _b(g, s);
    }
    async function aE() {
      const r = Ti.value;
      Ti.value = null, r && await _b(r.action, r.targets);
    }
    function wb(r, s) {
      var Se, $e, ut;
      const g = r.view, M = P.config.pluginPageBase;
      if (!g || M === void 0) return !1;
      const F = { plugin: r.plugin, view: g, path: (Se = s[0]) == null ? void 0 : Se.path }, X = mx(M, F);
      if (((ut = ($e = P.config).openPluginPage) == null ? void 0 : ut.call($e, { ...F, url: X })) === !0) return !0;
      const de = window.open(X, "_blank");
      if (!de)
        return tt(_("plugin.page_view.blocked")), !1;
      try {
        de.opener = null;
      } catch {
      }
      return !0;
    }
    function ql(r, s, g = {}) {
      const M = P.config.refusalToasts !== !1, F = cy(r);
      F ? M && tt(Yr(F, { t: _, formatDate: Q, locale: H.value })) : !g.inDialog && M && qt({ message: g.words ?? Zn(r) }, yn), R("error", { message: (r == null ? void 0 : r.message) ?? String(r), context: s });
    }
    function Wl(r, s, g, M, F = Zn(g)) {
      ql(g, M, { inDialog: r.refuse(s, F), words: F });
    }
    function Zn(r, s = _("toast.failed")) {
      return H2(r, s, { t: _, callerAdmin: pa.value }).text;
    }
    async function _b(r, s) {
      var X;
      const g = Xt(r.label, H.value);
      if (tp(r.view_placement) && wb(r, s)) return;
      if (r.ui) {
        La.value = {
          plugin: r.plugin,
          view: r.view || r.id,
          placement: "modal",
          ui: r.ui,
          label: g || r.plugin,
          files: HA(s)
        };
        return;
      }
      const M = {
        plugin: r.plugin,
        view: r.view || r.id,
        path: (X = s[0]) == null ? void 0 : X.path,
        paths: s.map((de) => de.path),
        label: g
      }, F = r.view ? FA(M) : 0;
      try {
        const de = await Oa.run(r, s);
        if (de.surface) {
          if (r.view && !rd(F)) return;
          Nn.value = { ...M, surface: de.surface, ticket: F || ++hb };
          return;
        }
        rd(F) && (Nn.value = null), de.op && Yl(de.op, g);
      } catch (de) {
        rd(F) && (Nn.value = null);
        const Se = de, $e = cy(Se);
        $e ? tt(Yr($e, { t: _, formatDate: Q, locale: H.value })) : qt({ message: Zn(Se, _("plugin.failed", { label: g })) }, yn);
      }
    }
    function Yl(r, s) {
      De.register(r);
      const g = s || (typeof r.label == "string" ? r.label : "") || _("opc.kind.plugin");
      tt(_("plugin.queued", { label: g }));
    }
    async function ph(r) {
      if (!r.plugin || !r.path) return !1;
      if (await Z(), !or.value)
        return R("error", {
          message: "app plugins are off on this instance - deep link ignored",
          context: { what: "openAppTarget", plugin: r.plugin, path: r.path }
        }), !1;
      await Oa.refresh();
      const s = G.value.find((M) => M.path === r.path) ?? { path: r.path, basename: r.path.split("/").pop() ?? r.path, type: "file" };
      if (r.action) {
        const M = Oa.byKey(`plugin:${r.plugin}/${r.action}`);
        return M ? (await kb(ag(M), [s]), !0) : (tt(_("plugin.not_applicable")), R("error", {
          message: `no such plugin action: ${r.plugin}/${r.action}`,
          context: { what: "openAppTarget", path: r.path }
        }), !1);
      }
      if (!r.view) return !1;
      const g = Oa.actions.value.find((M) => M.plugin === r.plugin && M.view === r.view);
      if (g && tp(g.view_placement) && wb(g, [s]))
        return !0;
      try {
        const M = await j.pluginView(r.plugin, r.view, r.path);
        return M != null && M.surface ? (Nn.value = { plugin: r.plugin, view: r.view, surface: M.surface, path: r.path }, !0) : (tt(_("plugin.view.error")), !1);
      } catch (M) {
        return tt((M == null ? void 0 : M.message) || _("plugin.view.error")), !1;
      }
    }
    async function hh(r, s) {
      if (!r || !(s != null && s.path)) return;
      Nn.value = null;
      const g = s.path.indexOf("://"), M = g === -1 ? "" : s.path.slice(0, g), F = Va(s.path).replace(/^\/+|\/+$/g, ""), X = F.lastIndexOf("/"), de = X === -1 ? "" : F.slice(0, X), Se = Sn.value && M ? de ? `${M}/${de}` : M : de;
      try {
        await wt(Se);
      } catch {
      }
      await ph({ plugin: r, action: s.action, view: s.view, path: s.path });
    }
    async function iE(r, s) {
      const g = s.indexOf("://"), M = g === -1 ? "" : s.slice(0, g), F = Va(s).replace(/^\/+|\/+$/g, ""), X = F.lastIndexOf("/"), de = X === -1 ? "" : F.slice(0, X), Se = Sn.value && M ? de ? `${M}/${de}` : M : de;
      await wt(Se);
      const $e = G.value.find((ut) => ut.path === s);
      if ($e) {
        le.click($e.path);
        return;
      }
      tt(_("plugin.output_missing"));
    }
    const ss = $(/* @__PURE__ */ new Map()), ls = $(!1), Gl = $(!1), Xl = $(null), xb = $(0);
    function Sb(r) {
      return typeof r.id != "number" ? !1 : ss.value.get(r.id) ?? r.starred === !0;
    }
    function mh(r, s) {
      const g = new Map(ss.value);
      g.set(r, s), ss.value = g;
    }
    const $b = E(() => {
      const r = /* @__PURE__ */ new Set();
      for (const s of G.value) Sb(s) && r.add(s.id);
      for (const [s, g] of ss.value) g && r.add(s);
      return r;
    });
    function Tb(r, s) {
      typeof r.id == "number" && mh(r.id, s);
    }
    function vh(r) {
      return gs.value ? r.filter((s) => typeof s.id == "number" && s.type === "file") : [];
    }
    function Ab(r) {
      const s = vh(r);
      return s.length > 0 && s.every((g) => Sb(g));
    }
    async function Eb(r) {
      const s = vh(r);
      if (s.length === 0) return;
      const g = !Ab(s), M = {
        apiBase: P.config.apiBase ?? "",
        authHeaders: () => Qn(),
        authCredentials: j.credentialsMode()
      };
      for (const X of s) mh(X.id, g);
      let F = 0;
      await Promise.all(
        s.map(async (X) => {
          try {
            await ET(X.id, g, M);
          } catch {
            F += 1, mh(X.id, !g);
          }
        })
      ), F > 0 && tt(_("star.failed")), bt.value === "starred" && await uu("starred");
    }
    async function Ua(r) {
      if (typeof r.id == "number")
        try {
          const s = P.config.apiBase ?? "";
          await fetch(`${s}/api/files/manager/recent`, {
            method: "POST",
            headers: await Qn({ "Content-Type": "application/json" }),
            credentials: j.credentialsMode(),
            body: JSON.stringify({ node_id: r.id })
          }), xb.value += 1;
        } catch {
        }
    }
    function oE(r) {
      typeof r.id == "number" && (Xl.value = r, Gl.value = !0);
    }
    function rE(r, s = "") {
      Gl.value = !1, _s(r, s);
    }
    function sE() {
      Dh(), bt.value === "tag" && rn.value && _s(rn.value, ve.value);
    }
    const lE = wD(sE);
    Tt(lE);
    function uE(r) {
      const s = vd(r) ?? {
        type: "file",
        path: r.path,
        basename: r.name,
        extension: (r.name.split(".").pop() || "").toLowerCase(),
        id: r.id
      };
      ls.value = !1, qa(s);
    }
    function cE(r, s) {
      const g = vd(r);
      g && (ls.value = !1, im(g, s));
    }
    const rr = E(() => {
      var s, g, M;
      if (P.config.onlyOfficeBase) return P.config.onlyOfficeBase;
      const r = (g = (s = Ve.value) == null ? void 0 : s.external) == null ? void 0 : g.onlyoffice;
      return r && !Ev(r) ? null : ((M = Ve.value) == null ? void 0 : M.onlyoffice_url) || null;
    }), pa = E(() => {
      var r;
      return ((r = Ve.value) == null ? void 0 : r.caller_admin) === !0;
    });
    function sd(r) {
      var s, g;
      return ((g = (s = Ve.value) == null ? void 0 : s.queued) == null ? void 0 : g.includes(r)) === !0;
    }
    const Cb = E(() => rr.value && j.endpoints.onlyOfficeConfig || null), Jl = E(() => {
      var g, M, F;
      const r = P.config.drawioUrl || P.config.drawioBase;
      if (r) return r;
      const s = (M = (g = Ve.value) == null ? void 0 : g.external) == null ? void 0 : M.drawio;
      return s && !Ev(s) ? null : ((F = Ve.value) == null ? void 0 : F.drawio_url) || null;
    }), zb = E(() => {
      var r;
      return ((r = Ve.value) == null ? void 0 : r.newdoc_types) ?? null;
    }), dE = E(() => {
      const r = zb.value;
      return !r || r.length === 0 ? !1 : r.some(
        (s) => s.requires === "onlyoffice" ? !!rr.value : s.requires === "drawio" ? !!Jl.value : !0
      );
    }), sr = E(() => {
      var r;
      return !!((r = Ve.value) != null && r.drafts);
    }), us = $(0), yh = $([]), gh = $(0), bh = $(!1), lr = $(null);
    async function kh() {
      if (!sr.value) {
        us.value = 0;
        return;
      }
      try {
        const { count: r, limit: s } = await j.drafts.count();
        us.value = r, gh.value = s;
      } catch {
      }
    }
    async function Mb() {
      bh.value = !0;
      try {
        const r = await j.drafts.list();
        yh.value = r.drafts, gh.value = r.limit, us.value = r.count;
      } catch (r) {
        yh.value = [];
        const s = Zn(r);
        R("error", { message: s, context: { op: "nav-view:drafts" } }), tt(s);
      } finally {
        bh.value = !1;
      }
    }
    async function Zl() {
      bt.value === "drafts" ? await Mb() : await kh();
    }
    Je(sr, (r) => void (r ? kh() : us.value = 0), { immediate: !0 });
    function fE(r) {
      const s = r.lastIndexOf(".");
      return s > 0 ? r.slice(s + 1).toLowerCase() : "";
    }
    function Pb(r, s = null) {
      const g = {
        type: "file",
        path: r.path,
        basename: r.name,
        extension: fE(r.name),
        storage: r.storage,
        size: r.size,
        file_size: r.size,
        mime_type: r.mime ?? "",
        visibility: "private",
        extra_metadata: {}
      };
      if (kv(P.config, g) === "host") {
        R("file-opened", { path: g.path, basename: g.basename });
        return;
      }
      vs.value = r.type ? { path: g.path, ext: r.type } : null, $i.value = s, pn.value = g, Ha.value = "edit", la.value = !0;
    }
    function Ob(r) {
      tt(_("draft.saved_to", { name: r.name, folder: K2(r.targetDir) }));
    }
    const eo = _ie(() => sr.value ? j.drafts : null, (r) => Zn(r));
    async function pE(r) {
      if (!lr.value) {
        lr.value = r.key;
        try {
          const s = await eo.save(r);
          s && (Ob(s), await Zl());
        } catch (s) {
          qt({ message: Zn(s) }, yn);
        } finally {
          lr.value = null;
        }
      }
    }
    async function hE(r) {
      if (!lr.value) {
        lr.value = r.key;
        try {
          await j.drafts.discard(r.key), tt(_("draft.discarded", { name: r.name })), await Zl();
        } catch (s) {
          qt({ message: Zn(s) }, yn);
        } finally {
          lr.value = null;
        }
      }
    }
    function mE(r) {
      Ob(r), Zl(), !bt.value && !Ft.value && wt();
    }
    function vE() {
      var s;
      const r = ((s = pn.value) == null ? void 0 : s.basename) ?? "";
      tt(_("draft.discarded", { name: r })), Zl();
    }
    function yE() {
      Ql.value = !1, uu("drafts");
    }
    const jn = $([]), Lb = $(null), sa = $(!1), Ql = $(!1), to = $(!1), ha = $(!1), la = $(!1), ld = $(!1), ur = $(!1), cs = $(!1), eu = $([]), Ao = $(null), ds = $(""), wh = $(!1), cr = $(/* @__PURE__ */ new Set()), Ai = $(""), fs = $(!1), ps = $(""), dr = $(null), gE = E(() => {
      var r;
      return eu.value.length !== 1 ? "archive" : ((r = eu.value[0]) == null ? void 0 : r.basename.replace(/\.[^.]+$/, "")) || "archive";
    }), bE = ["zip", "7z", "tar", "tar.gz", "tar.bz2", "tar.xz"], tu = E(() => {
      var s, g;
      return (((g = (s = Ve.value) == null ? void 0 : s.archive) == null ? void 0 : g.allowed_formats) ?? []).filter((M) => bE.includes(M));
    }), kE = E(() => {
      var s, g;
      const r = (g = (s = Ve.value) == null ? void 0 : s.archive) == null ? void 0 : g.default_format;
      return r && tu.value.includes(r) ? r : tu.value.includes("7z") ? "7z" : tu.value[0] ?? "zip";
    }), wE = E(() => {
      var r, s;
      return ((s = (r = Ve.value) == null ? void 0 : r.archive) == null ? void 0 : s.encryption) !== !1;
    }), _E = E(
      () => {
        var r;
        return (((r = Ao.value) == null ? void 0 : r.basename) || "archive").replace(/\.(tar\.(gz|bz2|xz)|zip|7z|rar|tgz|gz|bz2|xz)$/i, "") || "archive";
      }
    ), fr = $(null), hs = wv(to), ms = wv(sa), Sa = wv(ha), { busy: xE, error: SE } = hs, { busy: $E, error: TE } = ms, { busy: AE, error: EE } = Sa, Ei = $(!1), pn = $(null), Ha = $("edit"), vs = $(null), CE = E(
      () => {
        var r;
        return vs.value && ((r = pn.value) == null ? void 0 : r.path) === vs.value.path ? vs.value.ext : null;
      }
    );
    Je(la, (r) => {
      r || (vs.value = null), !r && sr.value && pn.value && i_(pn.value.path) && Zl();
    });
    const pr = $(!1), si = $(null), ys = $(!1), ud = $("move"), cd = $([]), zE = E(() => (I.version.value, ys.value, I.roots())), ME = E(() => {
      const r = cd.value[0];
      return r ? I.rootOf(r.path) : null;
    }), dd = $(!1), Ra = $(
      (() => {
        try {
          return localStorage.getItem(e2) === "1";
        } catch {
          return !1;
        }
      })()
    );
    function fd(r) {
      try {
        localStorage.setItem(e2, r ? "1" : "0");
      } catch {
      }
    }
    function _h() {
      Ra.value = !Ra.value, fd(Ra.value), Ra.value && (no.value = !1);
    }
    function PE() {
      Ra.value || (Ra.value = !0, fd(!0)), no.value = !1;
    }
    const no = $(!1), xh = E(() => {
      var r, s;
      return ((s = (r = Ve.value) == null ? void 0 : r.assistant) == null ? void 0 : s.button) === !0;
    }), OE = tj(
      {
        request: j.rawRequest,
        json: j.jsonFetch,
        failure: (r, s) => fa(r, s, H.value)
      },
      QV(j.endpoints.manager)
    );
    function LE() {
      no.value = !no.value, no.value && Ra.value && (Ra.value = !1, fd(!1));
    }
    const DE = E(() => ia().map((r) => r.path));
    Je(xh, (r) => {
      r || (no.value = !1);
    });
    function Db() {
      Ra.value && (Ra.value = !1, fd(!1));
    }
    const RE = E(() => K5(P.config.uiProfile)), nu = E(() => RE.value === "simple"), Rb = E(() => P.config.showInfoPanel !== !1), au = $(
      (() => {
        try {
          const r = localStorage.getItem(t2);
          if (r === "1") return !0;
          if (r === "0") return !1;
        } catch {
        }
        return !0;
      })()
    );
    function IE(r) {
      try {
        localStorage.setItem(t2, r ? "1" : "0");
      } catch {
      }
    }
    const hr = $(!1), iu = E(() => P.config.sideNav ?? !ft), Sh = E(
      () => iu.value && ($a.value ? hr.value : !0)
    ), Ib = E(
      () => iu.value && P.config.trashVisible !== !1
    ), NE = E(
      () => $a.value ? hr.value : au.value
    );
    function Nb() {
      if (iu.value) {
        if ($a.value) {
          hr.value = !hr.value;
          return;
        }
        au.value = !au.value, IE(au.value);
      }
    }
    function Eo() {
      hr.value = !1;
    }
    const $h = $([]), BE = E(() => P.config.connections ?? !nu.value), FE = E(() => P.config.mySharesVisible === !0), pd = E(
      () => {
        var r;
        return (P.config.callerKind ?? ((r = Ve.value) == null ? void 0 : r.caller_kind)) === "app";
      }
    ), gs = E(() => !pd.value), Th = $(!1);
    let Bb = 0;
    Je(
      () => [P.config.appStorePage === !0, pd.value],
      async ([r, s]) => {
        const g = ++Bb;
        if (!YS(r, s)) {
          Th.value = !1;
          return;
        }
        const M = await j.appStoreStatus();
        g === Bb && (Th.value = c1(r, s, M));
      },
      { immediate: !0 }
    );
    const UE = E(() => c1(P.config.appStorePage === !0, pd.value, { visible: Th.value })), bs = $(!1), ou = $(!1);
    function HE() {
      ou.value = !1, bs.value = !0;
    }
    function KE() {
      pd.value || (bs.value = !1, ou.value = !0);
    }
    function hd() {
      bs.value = !1, ou.value = !1;
    }
    const VE = E(() => bs.value || ou.value);
    function jE(r) {
      const s = r instanceof Error ? r.message : String(r);
      R("error", { message: s, context: { op: "connections" } }), tt(s);
    }
    const Ah = E(
      () => nu.value ? ["list", "grid"] : void 0
    );
    QM(() => {
      nu.value && Pe.value === "gallery" && (Pe.value = "grid");
    });
    const ks = $({ ...jo }), ws = $(null), md = $("name"), qE = E(
      () => Et.value || Cn.value ? "relevance" : "sort"
    );
    function WE() {
      ws.value = null, Fb({ ...jo });
    }
    function Fb(r) {
      ks.value = r, le.clear();
    }
    Je(
      () => `${Xe.value}|${bt.value}`,
      () => {
        al(ks.value) && (ks.value = { ...jo }), Et.value || (ws.value = null);
      }
    );
    const ru = $(!1), Ub = $([]);
    Je(ru, async (r) => {
      r && (Ub.value = await D_({
        apiBase: P.config.apiBase ?? "",
        authHeaders: () => Qn(),
        authCredentials: j.credentialsMode()
      }));
    });
    const Hb = $(""), YE = E(() => !0);
    function Eh(r = ws.value) {
      return $J(r ?? jo, Date.now(), { showHidden: tc.value });
    }
    const Kb = $(!1);
    async function Vb(r, s, g, M = Eh()) {
      var de;
      if (r === "name") {
        const Se = await Ow(g, s), $e = Se ?? await j.search(g, s, M);
        return {
          rows: Mr(await Vt.decorate($e.files, { root: $e.e2e_root || null })),
          truncated: fv($e.files.length, kf, $e.truncated),
          local: !!Se
        };
      }
      const F = await j.globalSearchPage(s, { limit: n2, scope: r, narrow: M }), X = ie.value || ((de = (P.config.storages ?? [])[0]) == null ? void 0 : de.name) || "";
      return {
        rows: Mr(await Vt.decorate(F.hits.map((Se) => Kf(Se, X)))),
        truncated: fv(F.hits.length, n2, F.truncated),
        local: !1
      };
    }
    function GE() {
      const r = Xe.value ?? "";
      return Sn.value ? Td(r) : Rt(r);
    }
    async function XE(r) {
      const s = Ty(r), { rows: g, truncated: M, local: F } = await Vb(r.scope, s, GE(), Eh(r.filters));
      return {
        count: (F && al(r.filters) ? uy(g, r.filters) : g).length,
        capped: M
      };
    }
    function JE(r) {
      Hb.value = Rt(Xe.value ?? "") || "", jb.value = r, ru.value = !0;
    }
    const jb = $("");
    function ZE(r) {
      ru.value = !1, md.value = r.scope, ws.value = al(r.filters) ? { ...r.filters } : null;
      const s = Ty(r);
      s === Et.value ? wt() : Et.value = s;
    }
    function QE(r) {
      ws.value = null, md.value = "name", bt.value !== "home" && (Et.value = r);
    }
    const qb = E(() => {
      if (bt.value || Qe.value) return "";
      const r = ie.value;
      if (!r) return "";
      const s = (P.config.storages ?? []).find((g) => g.name === r);
      return (s == null ? void 0 : s.label) || r;
    }), Ch = $("");
    function eC(r) {
      Ch.value = r, Od.value = !0;
    }
    const su = $(void 0);
    function tC() {
      const r = Rt(Xe.value);
      if (!r || !lk.value) return;
      const s = Xe.value.split("/").filter(Boolean);
      si.value = {
        path: r,
        basename: s.length ? s[s.length - 1] : ie.value,
        type: "dir"
      }, su.value = "drop", pr.value = !0;
    }
    function nC(r) {
      R("share-created", { path: r.path, url: r.url, pin: null }), tt(_("inspector.copied"));
    }
    const zh = $(null), Wb = $(null), aC = E(() => nZ(zh.value, Oh.value, Wb.value));
    async function Yb() {
      if (!gs.value) {
        zh.value = null;
        return;
      }
      const r = await j.quotaMe();
      zh.value = r, Wb.value = tZ(r, Oh.value) ? await j.storageUsage() : null;
    }
    function vd(r) {
      return Sae(r, {
        storages: P.config.storages ?? [],
        multiStorageRoot: Sn.value
      });
    }
    const ao = $(null), lu = $(!1), yd = E(() => {
      if (!Cn.value) return "";
      const r = mn.value;
      if (!r || !iy(r)) return "";
      const s = MS(r);
      return s != null && s.k ? `${s.d === "desc" ? "-" : ""}${s.k}` : "";
    });
    Je(yd, (r, s) => {
      r === s || !Cn.value || (bt.value === "tag" && rn.value ? _s(rn.value, ve.value) : (bt.value === "recent" || bt.value === "starred" || bt.value === "shared") && uu(bt.value));
    });
    async function gd(r, s = 0) {
      const g = P.config.apiBase ?? "", M = new URLSearchParams({ limit: String(Ku), offset: String(s) });
      yd.value && M.set("sort", yd.value);
      const F = r === "shared" ? `${g}/api/files/manager/shared-with-me?${M}` : r === "starred" ? `${g}/api/files/manager/star/list?${M}` : `${g}/api/files/manager/recent?${M}`, X = await fetch(F, {
        headers: await Qn(),
        // ⚠ NOT 'include' — with a bearer token this is cross-origin for every
        // embedder serving the UI from another origin (the desktop app): a credentialed
        // cross-origin request cannot be answered with `ACAO: *`.
        credentials: j.credentialsMode()
      });
      if (!X.ok) throw new Error(String(X.status));
      const de = await X.json(), Se = (ut) => ({
        rows: ut,
        total: typeof (de == null ? void 0 : de.total) == "number" ? de.total : s + ut.length,
        truncated: (de == null ? void 0 : de.truncated) === !0
      });
      if (r === "shared")
        return $h.value = Array.isArray(de == null ? void 0 : de.storages) ? de.storages : [], Se(await Vt.decorate(Array.isArray(de == null ? void 0 : de.files) ? de.files : []));
      const $e = Array.isArray(de == null ? void 0 : de.nodes) ? de.nodes : [];
      return Se(await Vt.decorate($e.map(vd).filter((ut) => ut !== null)));
    }
    async function iC() {
      const r = ao.value;
      if (!r || !r.truncated || lu.value) return;
      lu.value = !0;
      const s = Xe.value;
      try {
        const g = r.kind === "tag" ? await Zb(rn.value, ve.value, r.next) : await gd(r.kind, r.next);
        if (Xe.value !== s) return;
        G.value = [...G.value, ...g.rows], ao.value = { kind: r.kind, total: g.total, truncated: g.truncated, next: r.next + Ku };
      } catch (g) {
        tt(g instanceof Error ? g.message : String(g));
      } finally {
        lu.value = !1;
      }
    }
    const Gb = $([]), Xb = $([]), Mh = $(!1), Jb = mj(), Ph = E(() => cj(P.config.storages ?? [], Jb.saved.value));
    function oC(r) {
      hj(r, Ph.value);
    }
    const Oh = E(
      () => Ph.value.map(
        (r) => r.usedPartial !== void 0 || !(r.name in Dt.value) ? r : { ...r, usedPartial: Dt.value[r.name] !== null }
      )
    );
    async function rC() {
      Mh.value = !0;
      try {
        const [r, s] = await Promise.all([
          gd("recent").then((g) => g.rows).catch(() => []),
          gd("starred").then((g) => g.rows).catch(() => [])
        ]);
        Gb.value = r, Xb.value = s;
      } finally {
        Mh.value = !1;
      }
    }
    async function uu(r) {
      Eo();
      const s = je.view();
      if (r === "home") {
        bt.value || (Dn.value = Xe.value ?? ""), bt.value = "home", rn.value = "", ve.value = "", Ft.value = !1, Ct.value = "", bd(), le.clear(), G.value = [], ge.value = Le.home, Xe.value = Le.home, ie.value = "", await rC();
        return;
      }
      if (r === "tag") {
        rn.value && await _s(rn.value, ve.value);
        return;
      }
      if (r === "drafts") {
        bt.value || (Dn.value = Xe.value ?? ""), bt.value = "drafts", rn.value = "", ve.value = "", Ft.value = !1, Ct.value = "", bd(), le.clear(), G.value = [], ge.value = Le.drafts, Xe.value = Le.drafts, ie.value = "", await Mb();
        return;
      }
      if (r === "trash") {
        wC(), await zi(), bt.value = "trash", rn.value = "", ve.value = "";
        return;
      }
      ot.value = !0, bt.value || (Dn.value = Xe.value ?? ""), bt.value = r, rn.value = "", ve.value = "", Ft.value = !1, Ct.value = "", bd(), le.clear(), ge.value = Le[r], Xe.value = Le[r], ao.value = null;
      try {
        const g = await gd(r);
        if (!Be(s)) return;
        G.value = g.rows, ao.value = { kind: r, total: g.total, truncated: g.truncated, next: Ku }, ie.value = "";
      } catch (g) {
        if (!Be(s)) return;
        const M = g instanceof Error ? g.message : String(g);
        G.value = [], R("error", { message: M, context: { op: `nav-view:${r}` } }), tt(M);
      } finally {
        Be(s) && (ot.value = !1);
      }
    }
    async function Zb(r, s, g) {
      const M = await xD(
        r,
        {
          apiBase: P.config.apiBase ?? "",
          authHeaders: () => Qn(),
          authCredentials: j.credentialsMode()
        },
        { limit: Ku, offset: g, kind: s, sort: yd.value }
      );
      return { rows: await Vt.decorate(M.rows.map(vd).filter((X) => X !== null)), total: M.total, truncated: M.truncated };
    }
    async function _s(r, s = "") {
      Eo();
      const g = String(r ?? "").trim();
      if (!g) return;
      const M = je.view();
      ot.value = !0, bt.value || (Dn.value = Xe.value ?? ""), bt.value = "tag", rn.value = g, ve.value = s, Ft.value = !1, Ct.value = "", bd(), le.clear();
      const F = n5(g, s);
      ge.value = F, Xe.value = F, ao.value = null;
      try {
        const X = await Zb(g, s, 0);
        if (!Be(M)) return;
        G.value = X.rows, ao.value = { kind: "tag", total: X.total, truncated: X.truncated, next: Ku }, ie.value = "";
      } catch (X) {
        if (!Be(M)) return;
        const de = X instanceof Error ? X.message : String(X);
        G.value = [], R("error", { message: de, context: { op: `nav-view:tag:${s ? `${s}:` : ""}${g}` } }), tt(de);
      } finally {
        Be(M) && (ot.value = !1);
      }
    }
    const Qb = $([]), Lh = $(!1);
    async function Dh(r = !1) {
      Sh.value && (Qb.value = await D_({
        apiBase: P.config.apiBase ?? "",
        authHeaders: () => Qn(),
        authCredentials: j.credentialsMode(),
        force: r
      }), Lh.value = !0);
    }
    function sC(r) {
      if (r === "myfiles") {
        Eo(), wt("");
        return;
      }
      uu(r);
    }
    function ek(r) {
      Eo(), wt(Sn.value ? r : "");
    }
    async function lC() {
      try {
        const r = P.config.apiBase ?? "", s = await fetch(`${r}/api/files/manager/shared-with-me?limit=1`, {
          headers: await Qn(),
          credentials: j.credentialsMode()
        });
        if (!s.ok) return;
        const g = await s.json();
        $h.value = Array.isArray(g == null ? void 0 : g.storages) ? g.storages : [];
      } catch {
      }
    }
    function Rh(r) {
      const s = (r ?? "").replace(/^\/+|\/+$/g, "");
      if (!s) return Sn.value ? _("breadcrumb.root") : ie.value || _("breadcrumb.root");
      const g = s.split("/").pop() || s, M = cp(g, _);
      return M || (Vt.segmentLabel(Rt(s)) ?? g);
    }
    function uC(r) {
      si.value = r, pr.value = !0;
    }
    function cu(r) {
      return te.value ? !1 : r === void 0 || r === "editor" || r === "owner";
    }
    function bd() {
      ye.value = "", te.value = !1;
    }
    const cC = E(() => !!bt.value && bt.value !== "trash");
    function Ih(r) {
      return typeof r.perm == "string" ? r.perm : Eae(cC.value, ye.value);
    }
    function tk(r) {
      if (r.read_only === !0) return !0;
      const s = typeof r.storage == "string" ? r.storage : "";
      return s ? (P.config.storages ?? []).some((g) => g.name === s && g.readOnly === !0) : !1;
    }
    function io(r) {
      return cu(Ih(r)) && !tk(r);
    }
    const nk = { none: 0, viewer: 1, editor: 2, owner: 3 };
    function dC(r) {
      if (r.length === 0) return ye.value;
      let s, g = !1;
      for (const M of r) {
        const F = Ih(M);
        if (F === void 0) {
          g = !0;
          continue;
        }
        (s === void 0 || (nk[F] ?? 0) < (nk[s] ?? 0)) && (s = F);
      }
      return s ?? (g ? void 0 : ye.value);
    }
    function ak(r) {
      return r.some(tk);
    }
    const du = HJ(), Ia = QJ();
    Tt(() => Ia.dispose());
    function Nh() {
      var s;
      const r = (s = Ve.value) == null ? void 0 : s.e2e_policy;
      return {
        p: [...ue.value ?? []].sort().join(","),
        e: r ? `${r.available}|${r.policy}` : ""
      };
    }
    async function fC() {
      var M, F, X;
      if (await Promise.all([Z(), ae]), !((M = Ve.value) != null && M.e2e_policy) && !((F = ue.value) != null && F.length)) return;
      let r;
      try {
        r = (X = await Ye()) == null ? void 0 : X.user;
      } catch {
        r = null;
      }
      const s = ca(P.config) || (typeof location < "u" ? location.origin : ""), g = r && typeof r.id == "number" ? [s, r.id, r.provider_id ?? "", gt].join("|") : null;
      Ia.attach(g, Nh()), Uh();
    }
    jt(() => void fC());
    const kd = $({}), wd = /* @__PURE__ */ new Set();
    let Bh = 0;
    Je(
      () => [he.value, ue.value],
      () => {
        Bh++, wd.clear(), kd.value = {}, Ia.sign("p", Nh().p);
      }
    );
    function ik(r) {
      const s = ue.value;
      if (!(s != null && s.length)) return;
      const g = r.filter((Se) => !Ia.fresh("p", Se) && !wd.has(Se));
      if (!g.length) return;
      g.forEach((Se) => wd.add(Se));
      const M = [...s], F = Bh, X = (Se, $e) => {
        if (F !== Bh) return;
        const ut = { ...kd.value };
        g.forEach((et, Pt) => {
          ut[et] = Se[Pt] ?? [], Ia.put("p", et, ut[et], $e), wd.delete(et);
        }), kd.value = ut;
      }, de = g.some((Se) => ok(Se) === void 0) ? du.start() : () => {
      };
      j.allowedAt(g, M).then(
        (Se) => X(Se, !0),
        () => X(g.map(() => M), !1)
      ).finally(de);
    }
    function ok(r) {
      return kd.value[r] ?? Ia.peek("p", r);
    }
    function fu(r, s) {
      var M;
      const g = [...new Set(s.map(be))];
      return !he.value || !g.length || !((M = ue.value) != null && M.includes(r)) ? Ms(r) : (ik(g), g.every((F) => {
        var X;
        return ((X = ok(F)) == null ? void 0 : X.includes(r)) ?? !1;
      }));
    }
    const _d = $({}), xd = /* @__PURE__ */ new Set();
    let Fh = 0;
    function pC() {
      Fh++, xd.clear(), _d.value = {}, Ia.sign("e", Nh().e);
    }
    Je(
      () => {
        var r, s, g, M;
        return [
          he.value,
          ue.value,
          (s = (r = Ve.value) == null ? void 0 : r.e2e_policy) == null ? void 0 : s.available,
          (M = (g = Ve.value) == null ? void 0 : g.e2e_policy) == null ? void 0 : M.policy
        ];
      },
      pC
    );
    function pu(r, s) {
      return `${s}:${r}`;
    }
    async function rk(r) {
      const s = r.filter((de) => {
        const Se = pu(de.path, de.kind);
        return !Ia.fresh(`e:${de.kind}`, de.path) && !xd.has(Se);
      });
      if (!s.length) return;
      for (const de of s) xd.add(pu(de.path, de.kind));
      const g = Fh, F = s.some((de) => sk(de.path, de.kind) === void 0) ? du.start() : () => {
      };
      let X = !1;
      try {
        const de = await j.e2eAllowedAt(s, {
          onFailed: () => {
            X = !0;
          }
        });
        if (g !== Fh) return;
        const Se = { ..._d.value };
        s.forEach(($e, ut) => {
          const et = pu($e.path, $e.kind);
          Se[et] = de[ut] ?? "allowed", Ia.put(`e:${$e.kind}`, $e.path, Se[et], !X), xd.delete(et);
        }), _d.value = Se;
      } finally {
        F();
      }
    }
    function sk(r, s) {
      return _d.value[pu(r, s)] ?? Ia.peek(`e:${s}`, r);
    }
    function Uh() {
      var de, Se;
      if (Ft.value || bt.value || Ce.value || Ne.value) return;
      const r = Rt(Xe.value ?? "");
      if (!r.includes("://") || I.rootOf(r)) return;
      const s = !!((de = Ve.value) != null && de.e2e_policy) && !an.value, g = !!he.value && !!((Se = ue.value) != null && Se.length);
      if (!s && !g) return;
      const M = /* @__PURE__ */ new Set(), F = /* @__PURE__ */ new Map(), X = ($e, ut) => {
        if ($e === "p")
          g && M.add(ut);
        else if (s) {
          const et = $e.slice(2);
          F.set(pu(ut, et), { path: ut, kind: et });
        }
      };
      X("p", r), X("e:new_folder", r);
      for (const $e of G.value.slice(0, fle))
        !$e || typeof $e.path != "string" || !$e.path.includes("://") || cc($e) || I.isVaultRow($e) || (X("p", $e.path), !(!io($e) || $e.e2e || $e.e2e_root) && ($e.type === "dir" ? X("e:folder", $e.path) : Ui($e) || X("e:file", $e.path)));
      for (const $e of Ia.around(r)) X($e.q, $e.path);
      M.size && ik([...M].slice(0, 1e3)), F.size && rk([...F.values()].slice(0, 1e3));
    }
    let xs = null;
    function hC(r) {
      if (Ia.stale(), r.resync) {
        Uh();
        return;
      }
      xs || (xs = setTimeout(
        () => {
          xs = null, fe(), wt();
        },
        r.all ? Math.random() * ple : 0
      ));
    }
    Tt(() => {
      xs && clearTimeout(xs), xs = null;
    });
    function Hh(r, s) {
      var F;
      const g = be(r);
      return ((F = Ve.value) == null ? void 0 : F.e2e_policy) ? (rk([{ path: g, kind: s }]), sk(g, s) ?? "denied") : "allowed";
    }
    const li = E(
      () => cu(ye.value) && fu("files.create", Xe.value ? [Rt(Xe.value)] : [])
    ), Sd = E(
      () => li.value && !Qe.value && !Ft.value
    ), lk = E(
      () => Bd(Xe.value ? [Rt(Xe.value)] : []).uploadLinks
    ), mC = E(
      () => si.value && he.value ? Bd([si.value.path]) : void 0
    ), Kh = $(null), Tn = $(null), uk = $(null), $a = $(!1), ck = $(!1);
    let Ss, ui;
    function Vh(r) {
      ck.value = !!(r && "matches" in r && r.matches);
    }
    jt(() => {
      var r;
      typeof ResizeObserver < "u" && Tn.value && (Ss = new ResizeObserver((s) => {
        var M, F, X;
        const g = ((F = (M = s[0]) == null ? void 0 : M.contentRect) == null ? void 0 : F.width) ?? ((X = Tn.value) == null ? void 0 : X.clientWidth) ?? 0;
        $a.value = g > 0 && g < 560;
      }), Ss.observe(Tn.value)), typeof window < "u" && window.matchMedia && (ui = window.matchMedia("(pointer: coarse)"), Vh(ui), (r = ui.addEventListener) == null || r.call(ui, "change", Vh));
    }), Tt(() => {
      var r;
      Ss == null || Ss.disconnect(), Ss = void 0, (r = ui == null ? void 0 : ui.removeEventListener) == null || r.call(ui, "change", Vh), ui = void 0;
    });
    const ma = $(null);
    let Ka, $s = null;
    function qt(r, s) {
      ma.value = r, Ka && clearTimeout(Ka), Ka = setTimeout(dk, s);
    }
    function tt(r) {
      qt({ message: r }, hi);
    }
    function dk() {
      Ka = void 0, ma.value = null;
      const r = $s;
      $s = null, r && qt({ message: r.message, source: "drag-out" }, r.ms);
    }
    Tt(() => {
      Ka && clearTimeout(Ka), Ka = void 0, $s = null;
    });
    const Ci = E(() => {
      if (bt.value || Kt.value || Ce.value) return null;
      const r = !!Et.value, s = Va(ge.value).replace(/^\/+|\/+$/g, "") === "";
      return FJ({
        map: Dt.value,
        adapter: ie.value,
        searching: r,
        crossStorage: r && s && Object.keys(Dt.value).length > 1,
        admin: pa.value
      });
    });
    async function vC(r) {
      if (!r || Vn(r)) return;
      un.value = { ...un.value, [r]: 0 };
      const s = () => {
        const { [r]: F, ...X } = un.value;
        un.value = X;
      };
      let g;
      try {
        const F = ca(P.config), X = await j.jsonFetch(`${F}/api/admin/storages`), de = Array.isArray(X) ? X.find(($e) => $e.name === r) : void 0;
        if (!de) throw new Error("no such storage");
        const Se = await j.jsonFetch(`${F}/api/admin/storages/${de.id}/sync`, { method: "POST" });
        g = de.id, un.value = { ...un.value, [r]: g }, tt((Se == null ? void 0 : Se.status) === "running" ? _("coverage.catalog_joined", { storage: r }) : _("coverage.catalog_started"));
      } catch (F) {
        s(), qt({ message: Zn(F) }, yn);
        return;
      }
      const M = await Ln().scan(g);
      s(), M !== null && (M.status === "ok" ? (tt(_("coverage.catalog_done", { storage: r })), await wt()) : M.status === "failed" ? qt({ message: _("coverage.catalog_failed", { storage: r }) }, yn) : M.status === "aborted" ? qt({ message: _("coverage.catalog_stopped", { storage: r }) }, yn) : M.status === "gone" ? qt({ message: _("coverage.catalog_gone", { storage: r }) }, yn) : qt({ message: _("coverage.catalog_unfollowed", { storage: r }) }, yn));
    }
    function $d(r, s) {
      qt({ message: r, actionLabel: _("toast.undo"), action: s, after: { kind: "undo" } }, 8e3);
    }
    function jh() {
      Ka && clearTimeout(Ka), dk();
    }
    async function yC() {
      const r = ma.value, s = r == null ? void 0 : r.action;
      if (Ka && clearTimeout(Ka), Ka = void 0, ma.value = null, !r || !s) return;
      const g = r.after ?? { kind: "undo" }, M = g.kind === "plain", F = M && r.source ? "drag-out-stopping" : void 0;
      qt({ message: j0(g, "running", void 0, _), source: F }, wf);
      try {
        const X = await s();
        qt({ message: j0(g, "done", X, _), source: F }, hi), M || await wt();
      } catch (X) {
        M ? qt({ message: Zn(X) }, yn) : tt(_("toast.undo_failed"));
      }
    }
    const Sn = E(() => P.config.multiStorageRoot === !0);
    function gC(r) {
      const s = r.replace(/^\/+|\/+$/g, "");
      if (!s) return { adapter: "", rel: "" };
      const g = s.indexOf("/");
      return g === -1 ? { adapter: s, rel: "" } : { adapter: s.slice(0, g), rel: s.slice(g + 1) };
    }
    function Td(r) {
      if (r.includes("://")) return r;
      const { adapter: s, rel: g } = gC(r);
      return s ? g ? `${s}://${g}` : `${s}://` : "";
    }
    function Co(r) {
      const s = r.indexOf("://");
      if (s === -1) return r.replace(/^\/+|\/+$/g, "");
      const g = r.slice(0, s), M = r.slice(s + 3).replace(/^\/+|\/+$/g, "");
      return M ? `${g}/${M}` : g;
    }
    function fk() {
      return (P.config.storages ?? []).map((s) => ({
        type: "dir",
        path: s.name,
        // virtual path (no adapter prefix)
        basename: s.label || s.name,
        extension: "",
        storage: s.name,
        visibility: "private",
        file_size: 0,
        mime_type: "inode/storage",
        extra_metadata: { driver: s.driver, readOnly: s.readOnly }
      }));
    }
    function pk() {
      var r;
      J4(!tc.value), wt(), (r = Zt.value) == null || r.reload();
    }
    function hk() {
      wt(), Yb(), R("refresh");
    }
    function wt(r) {
      return je.follow(() => bC(r));
    }
    async function bC(r) {
      var Se;
      xn.value = !1;
      const { ticket: s, want: g } = je.begin(r, Xe.value ?? "");
      at.connected.value || Ia.stale();
      const M = He(g);
      if (M) {
        if (!(M.kind === "trash" ? P.config.trashVisible !== !1 : iu.value))
          return Gh(""), await wt("");
        M.kind === "tag" ? await _s(M.tag, M.tagKind) : await uu(M.kind);
        return;
      }
      const F = String(Xe.value ?? "").replace(/^\/+|\/+$/g, ""), X = ($e) => {
        String($e ?? "").replace(/^\/+|\/+$/g, "") !== F && (le.clear(), dt.value = []);
      };
      ot.value = !0, Ft.value = !1, bt.value = "", rn.value = "", ve.value = "";
      let de = g;
      je.going(g);
      try {
        if (Ce.value = "", Ne.value = "", gt) {
          const vn = String(de).replace(/^\/+|\/+$/g, "");
          (!vn || !(vn === gt || vn.startsWith(gt + "/"))) && (de = gt);
        }
        if (Sn.value && !Td(de)) {
          if (Ke.value) return await wt(Ke.value);
          X(""), Xe.value = "", ie.value = "", ge.value = "", Ct.value = "", G.value = fk();
          return;
        }
        const $e = Sn.value ? Td(de) : Rt(de), ut = I.rootOf($e);
        if (ut) {
          const vn = String($e).replace(/\/+$/, "");
          if (I.isOpen(ut)) {
            const $n = I.rows(vn) ? vn : ut, Fi = Et.value ? I.search($n, Et.value) : I.rows($n);
            if (!Be(s)) return;
            I.touch($n), xn.value = !1, ie.value = $n.slice(0, $n.indexOf("://")), ge.value = $n, ye.value = I.permOf(ut) || "", te.value = !!((Se = I.strips[ut]) != null && Se.readOnly), Ct.value = ut;
            const Ga = Di($n);
            X(Ga), G.value = Mr(Fi ?? []), Xe.value = Ga;
            return;
          }
          if (vn !== ut) return await wt(Di(ut));
        }
        const Pt = !!Et.value && md.value !== "name" ? await Vb(md.value, Et.value, $e) : null;
        let En = !1;
        const At = Pt ? {
          adapter: ie.value,
          storages: (P.config.storages ?? []).map((vn) => vn.name),
          dirname: ge.value,
          read_only: !1,
          files: Pt.rows,
          truncated: Pt.truncated
        } : Et.value ? await (async () => {
          const vn = await Ow($e, Et.value);
          return En = !!vn, vn ?? await j.search($e, Et.value, Eh());
        })() : await j.index($e);
        if (!Pt && !Et.value && typeof At.e2e_vault_root == "string" && At.e2e_vault_root) {
          const vn = At.e2e_vault_root.replace(/\/+$/, "");
          if (String(At.dirname ?? "").replace(/\/+$/, "") !== vn)
            return Be(s) ? await wt(Di(vn)) : void 0;
          At.files = [];
        }
        if (At.files = await Vt.decorate(At.files, {
          root: typeof At.e2e_root == "string" && At.e2e_root ? At.e2e_root : null
        }), !Be(s)) return;
        At.files = Aae(At.files, At.perm), xn.value = !!Et.value && fv(At.files.length, kf, At.truncated), Kb.value = !!Et.value && (Pt ? Pt.local : En), Array.isArray(At.storage_info) && (Dt.value = BJ(At.storage_info), bn.value = B5(At.storage_info)), ie.value = At.adapter, ge.value = At.dirname, ye.value = At.perm || "", te.value = At.read_only === !0, Ct.value = typeof At.e2e_root == "string" ? At.e2e_root : "";
        {
          const vn = String(At.dirname ?? "").replace(/\/+$/, ""), $n = typeof At.e2e_root == "string" ? At.e2e_root.replace(/\/+$/, "") : "";
          I.rootOf(vn) === vn && $n !== vn && I.forget(vn);
        }
        const Ya = Sn.value ? Co(At.dirname) : Va(At.dirname);
        X(Ya), G.value = Mr(At.files), kS(G.value, At.adapter, At.dirname, P.config.trashVisible !== !1, {
          isSearchResult: !!Et.value,
          navOffersTrash: Ib.value
        }) && wS(G.value, At.adapter, j), Xe.value = Ya, Uh();
      } catch ($e) {
        if (!Be(s)) return;
        const ut = $e instanceof Error ? $e.message : String($e), et = $e.status;
        if (et === 404 || et === 403) {
          Ce.value = String(de), X(String(de)), Ct.value = "", G.value = [], R("error", { message: ut, context: { path: r } });
          return;
        }
        Ne.value = ut, _e = typeof de == "string" ? de : void 0, R("error", { message: ut, context: { path: r } }), G.value.length > 0 && tt(ut);
      } finally {
        Be(s) && (ot.value = !1), je.end(s);
      }
    }
    function Va(r) {
      const s = r.indexOf("://");
      return s === -1 ? r : r.slice(s + 3);
    }
    function kC() {
      Ce.value = "", Gh(""), wt("");
    }
    const Ad = $(null), zo = $(!1), Ed = $(!1), hu = $(!1), qh = $(null);
    let mk = !1;
    Tt(() => {
      mk = !0, Jt == null || Jt.stop();
    });
    async function wC() {
      try {
        const r = await fetch(`${P.config.apiBase ?? ""}/api/admin/protection`, {
          headers: await Qn(),
          credentials: j.credentialsMode()
        });
        if (!r.ok) {
          Ad.value = null, zo.value = !1;
          return;
        }
        const s = await r.json(), g = s == null ? void 0 : s.trash_retention_days;
        Ad.value = typeof g == "number" && g > 0 ? g : null, zo.value = !0;
      } catch {
      }
    }
    const _C = E(
      () => Ad.value !== null ? _("trash.retention", { days: Ad.value }) : _("trash.retention_unknown")
    ), Ts = $(null), Cd = $("");
    let Wh = 0;
    async function xC() {
      Ts.value = null, Cd.value = "", hu.value = !0;
      const r = ++Wh;
      try {
        const s = await j.trashEmptyPreview();
        r === Wh && (Ts.value = s);
      } catch (s) {
        r === Wh && (Cd.value = Za(s, H.value));
      }
    }
    const vk = E(() => {
      const r = qh.value;
      return r != null && r.running ? r.summary ?? "" : "";
    });
    async function SC() {
      if (hu.value = !1, !zo.value || Ed.value) return;
      const r = j.endpoints.trashEmpty;
      if (r) {
        Ed.value = !0;
        try {
          const s = await Mae({
            start: async () => fetch(j.withScreenLang(r), {
              method: "POST",
              headers: await Qn(),
              credentials: j.credentialsMode()
            }),
            status: async () => fetch(j.withScreenLang(r), { headers: await Qn(), credentials: j.credentialsMode() }),
            locale: H.value,
            /* The run is an ops row: it goes into the operations centre (progress,
             * Cancel) the moment the server names it — a run done within the wait
             * as well, like any other operation the person started. */
            onStart: (g) => {
              g.op_id && De.register({
                id: g.op_id,
                kind: "trash-empty",
                status: g.running ? g.queued ? "pending" : "running" : g.cancelled ? "cancelled" : "ok",
                total: g.total ?? 0,
                done: g.scanned ?? 0
              });
            },
            onProgress: (g) => {
              qh.value = g;
            },
            onBusy: (g) => {
              g && tt(g);
            },
            stopped: () => mk
          });
          if (s === null || (Ft.value && await zi(), !s.started_at || !s.summary)) return;
          qt({ message: s.summary }, s.error || s.failed ? yn : hi);
        } catch (s) {
          if (s instanceof nA) {
            tt(s.message);
            return;
          }
          const g = Za(s, H.value);
          R("error", { message: (s == null ? void 0 : s.message) ?? String(s), context: { op: "trash:empty" } }), tt(g);
        } finally {
          qh.value = null, Ed.value = !1;
        }
      }
    }
    const As = $(0), Mo = $(0), zd = $(""), Md = $(!1), $C = E(() => {
      const r = new Intl.NumberFormat(gi(H.value));
      return _("trash.shown_of", { shown: r.format(Mo.value), total: r.format(As.value) });
    });
    function yk(r) {
      return r.map(
        (s) => ({
          type: "file",
          id: s.id,
          /* Which storage's trash it is in: a permanent delete is one job per
             storage, and each job's rows are the ones it deletes. */
          storage_id: s.storage_id,
          /* ⚠ The ORIGINAL path, which the server sends with its leading
             slash: `depo:///x.txt` put an empty segment in the Location
             column ("depo/"), so it is dropped here. */
          path: s.storage_name ? `${s.storage_name}://${s.path.replace(/^\/+/, "")}` : s.path,
          basename: s.name,
          extension: s.name.includes(".") && s.name.split(".").pop() || "",
          storage: s.storage_name || "",
          visibility: "private",
          /* tablo:t1 — ⚠ BOTH. Every view reads `size` (the Size column, the
             info panel); only the upload code reads `file_size`. Setting one of
             the two left every trashed row with a blank Size cell. */
          size: s.size,
          file_size: s.size,
          mime_type: s.mime || "",
          /* The date the Trash's date column prints and sorts by — WHEN it was
             deleted. A trashed row has no modification date to show, and the
             column read "—" for every row. */
          last_modified: Date.parse(s.deleted_at) || void 0,
          extra_metadata: {
            deleted_at: s.deleted_at,
            ttl_days: s.ttl_days ?? null,
            /* A permanent delete is on its way for it (purgeSelection). */
            purging: Ps.value.has(s.id),
            /* #71 — a discarded draft of the asker's: its Location reads
               "Drafts" (ListView), which is where Restore puts it back. */
            ...s.draft ? { draft: !0 } : {}
          },
          /* Who put it here — the Trash draws it where a folder draws the
             owner. Keys absent when nobody is named, as the listing sends. */
          ...s.deleted_by_id !== void 0 ? { deleted_by_id: s.deleted_by_id } : {},
          ...s.deleted_by_name ? { deleted_by_name: s.deleted_by_name } : {},
          ...s.deleted_by_self ? { deleted_by_self: !0 } : {},
          /* wiring:e2 names — the encrypted folder it was deleted from. */
          ...s.e2e_root ? { e2e_root: s.e2e_root } : {}
        })
      );
    }
    async function zi() {
      const r = je.view(), s = Ft.value;
      ot.value = !0, na.value = ie.value || "", Ft.value = !0, Ct.value = "", s || le.clear();
      try {
        const g = await j.listTrash(void 0, { limit: a2 }), M = await Vt.decorate(yk(g.entries));
        if (!Be(r)) return;
        G.value = M, Mo.value = g.entries.length, As.value = g.total, zd.value = g.summary ?? "", ge.value = ".trash", Xe.value = ".trash";
      } catch (g) {
        if (!Be(r)) return;
        const M = g instanceof Error ? g.message : String(g);
        R("error", { message: M, context: { op: "trash-list" } }), tt(M);
      } finally {
        Be(r) && (ot.value = !1);
      }
    }
    async function TC() {
      if (Md.value || Mo.value >= As.value) return;
      const r = Mo.value;
      Md.value = !0;
      try {
        const s = await j.listTrash(void 0, { limit: a2, offset: r }), g = await Vt.decorate(yk(s.entries));
        if (!Ft.value || Mo.value !== r) return;
        G.value = [...G.value, ...g], Mo.value = r + s.entries.length, As.value = s.total, zd.value = s.summary ?? "";
      } catch (s) {
        qt({ message: Zn(s) }, yn);
      } finally {
        Md.value = !1;
      }
    }
    function Rt(r) {
      if (r && r.includes("://")) return r;
      if (Sn.value) {
        const s = Td(r ?? "");
        return s || (ie.value ? `${ie.value}://` : "");
      }
      return r ? `${ie.value}://${r.replace(/^\/+/, "")}` : `${ie.value}://`;
    }
    function Mi(r) {
      const s = r.indexOf("://"), g = (s === -1 ? r : r.slice(s + 3)).replace(/\/+$/, ""), M = g.lastIndexOf("/");
      return M === -1 ? g : g.slice(M + 1);
    }
    function oo(r) {
      const s = r.indexOf("://"), g = s === -1 ? "" : r.slice(0, s + 3), M = (s === -1 ? r : r.slice(s + 3)).replace(/\/+$/, ""), F = M.lastIndexOf("/");
      return F === -1 ? g : g + M.slice(0, F);
    }
    function Yh(r, s) {
      const g = (M) => {
        const F = M.indexOf("://"), X = F === -1 ? "" : M.slice(0, F + 3), de = (F === -1 ? M : M.slice(F + 3)).replace(/\/+$/, "");
        return X + de;
      };
      return g(r) === g(s);
    }
    function ja(r, s) {
      return r ? r.endsWith("://") || r.endsWith("/") ? r + s : `${r}/${s}` : s;
    }
    async function gk(r, s) {
      try {
        const g = await j.index(s), M = new Set((g.files ?? []).map((F) => String(F.basename ?? "").toLowerCase()));
        return r.some((F) => M.has(Mi(F).toLowerCase()));
      } catch {
        return !0;
      }
    }
    function bk(r, s, g, M, F) {
      if (!M || !g || F) return;
      const X = s.map((de) => ja(g, Mi(de)));
      X.length !== 0 && me.set(r, {
        message: _("toast.moved"),
        fn: async () => {
          const { op: de } = await j.moveAsync(X, M, g);
          return De.register(de), { queued: !0 };
        }
      });
    }
    Je(
      () => Et.value,
      () => void wt()
    );
    function Pd() {
      return P.config.pathPersist ?? "hash";
    }
    function kk() {
      const r = Pd();
      return r === "hash" || r === "hash+localStorage";
    }
    function AC(r) {
      try {
        return decodeURIComponent(r);
      } catch {
        return r;
      }
    }
    function wk() {
      try {
        return localStorage.getItem(xv) || "";
      } catch {
        return "";
      }
    }
    function _k() {
      const r = window.location.hash || "";
      return r.startsWith("#") ? AC(r.slice(1)).replace(/^\/+|\/+$/g, "") : "";
    }
    function EC() {
      if (typeof window > "u") return "";
      const r = Pd();
      if (r === "none") return "";
      if (r === "localStorage") return wk();
      const s = _k();
      return s || r === "hash" ? s : Ut ? "" : wk();
    }
    function Gh(r) {
      if (typeof window > "u") return;
      const s = Pd();
      if (s === "none") return;
      if (s === "localStorage" || s === "hash+localStorage") {
        try {
          r ? localStorage.setItem(xv, r) : localStorage.removeItem(xv);
        } catch {
        }
        if (s === "localStorage") return;
      }
      const g = mA(r), M = g ? `#${g}` : "";
      (window.location.hash || "") !== M && history.replaceState(
        history.state,
        "",
        M || window.location.pathname + window.location.search
      );
    }
    function xk() {
      if (!kk()) return;
      const r = _k();
      r && r !== Xe.value && wt(r);
    }
    Je(Xe, (r) => {
      const s = I.rootOf(Rt(r)) ? Di(I.rootOf(Rt(r))) : r;
      Gh(s), R("navigate", { path: s }), at.subscribe(Ie(r));
    }), t({
      reload: () => wt(),
      /* App plugins — a notification's `target.open` lands here (see the
         function's own note for why this is a method and not a prop). */
      openAppTarget: ph,
      /* A notification's destination, carried out in this explorer — the desktop
         app hands a clicked OS notification here (see the function's note). */
      revealNotification: Pa
    }), jt(async () => {
      var s;
      Op();
      const r = EC();
      try {
        await wt(r || void 0);
      } finally {
        Ot();
      }
      await Gt(), (s = Tn.value) == null || s.focus(), lC(), Dh(), Yb(), Je(Sh, (g) => {
        g && !Lh.value && Dh();
      }), kk() && window.addEventListener("hashchange", xk), j.endpoints.opsList && De.startPolling(), Z();
    });
    const Od = $(!1), Ld = $(!1);
    function Xh() {
      return { configured: (P.config.storages ?? []).map((r) => r.name), current: ie.value };
    }
    function Es(r) {
      const s = P.config.accountSearch, g = r.account;
      return !s || !g || g.id === s.self.id ? null : g;
    }
    function mu(r) {
      return Iae(r, Es(r) ? { configured: [], current: "" } : Xh());
    }
    async function CC(r) {
      var F;
      if (!r.some((X) => typeof X.e2e_root == "string" && X.e2e_root)) return r;
      const s = ie.value || ((F = (P.config.storages ?? [])[0]) == null ? void 0 : F.name) || "", g = await Promise.all(
        r.map((X) => Vt.decorate([Kf(X, s)]).then((de) => de[0] ?? null))
      ), M = [];
      return r.forEach((X, de) => {
        const Se = g[de];
        Se && M.push(Se.e2e_stored ? { ...X, name: Se.basename, e2e_display_dir: Se.e2e_display_dir } : X);
      }), M;
    }
    async function zC(r) {
      const s = j.globalSearch(r, { limit: 8, scope: "all" }).then(CC), g = P.config.accountSearch;
      if (!g) return s;
      let M = [];
      try {
        M = await g.others() ?? [];
      } catch {
        M = [];
      }
      if (M.length === 0) return s;
      const F = [g.self, ...M], X = await Promise.allSettled([
        s,
        ...M.map((Se) => g.search(Se.id, r, { limit: 8, scope: "all" }))
      ]), de = [];
      return X.forEach((Se, $e) => {
        if (!(Se.status !== "fulfilled" || !Array.isArray(Se.value)))
          for (const ut of Se.value) de.push({ ...ut, account: F[$e] });
      }), de;
    }
    async function MC(r) {
      const s = rA(r);
      if (!s) return;
      const g = r.type === "dir", M = s.lastIndexOf("/"), F = g ? s : M === -1 ? "" : s.slice(0, M);
      let X = F;
      if (Sn.value) {
        const $e = Cy(r, Xh());
        if (!$e) return;
        X = F ? `${$e}/${F}` : $e;
      }
      if (await wt(X), g) return;
      const de = String(r.name ?? s.slice(M + 1)), Se = G.value.find(($e) => $e.type === "file" && $e.basename === de);
      Se && (le.click(Se.path), qa(Se));
    }
    function Jh(r) {
      return (s) => R("error", { message: (s == null ? void 0 : s.message) ?? String(s), context: { op: r } });
    }
    function PC(r) {
      const s = Es(r), g = P.config.accountSearch;
      if (s && g) {
        const M = mu(r);
        M && Promise.resolve(g.open(s.id, Nf(M))).catch(Jh("search-open"));
        return;
      }
      MC(r);
    }
    function OC(r, s) {
      const g = mu(r);
      if (!g || s === "drag" && !_p(g)) return !1;
      if (Es(r)) {
        const M = P.config.accountSearch;
        return s === "download" ? !!(M != null && M.download) : !!(M != null && M.dragStart);
      }
      return s === "download" ? !0 : !!fi.value || g.type === "file" && (dv(P.config.auth) || Uk.value);
    }
    function LC(r) {
      if (Es(r)) return;
      const s = mu(r);
      s && m0(s) && Vk(s.path);
    }
    function DC(r) {
      const s = mu(r);
      if (!s) return;
      const g = Es(r);
      if (g) {
        const M = P.config.accountSearch;
        M != null && M.download && Promise.resolve(M.download(g.id, Nf(s))).catch(Jh("search-download"));
        return;
      }
      Fd([Kf(r, Cy(r, Xh()))]);
    }
    function RC(r, s) {
      const g = mu(r);
      if (!g || !s.dataTransfer || !_p(g)) {
        s.preventDefault();
        return;
      }
      s.dataTransfer.effectAllowed = "copy";
      const M = Es(r);
      if (M) {
        const F = P.config.accountSearch;
        s.preventDefault(), F != null && F.dragStart && Promise.resolve(F.dragStart(M.id, [Nf(g)])).catch(Jh("drag-out"));
        return;
      }
      Fk(s, [g], null, typeof r.mime == "string" ? r.mime : void 0, !1);
    }
    function IC() {
      zr(), Os();
    }
    o3(Tn, {
      onDelete: () => {
        if (Ft.value && !An.value && !zo.value) {
          le.isEmpty.value || tt(_("toast.trash_retention"));
          return;
        }
        if (An.value) {
          const r = qn.nodes.value;
          r.length && (Po.value = r, Ei.value = !0, ha.value = !0);
        } else le.isEmpty.value || (Ei.value = !1, ha.value = !0);
      },
      onRename: () => {
        if (An.value) {
          const r = qn.nodes.value;
          r.length === 1 && (fr.value = r[0], Ei.value = !0, to.value = !0);
        } else le.nodes.value.length === 1 && (fr.value = le.nodes.value[0], Ei.value = !1, to.value = !0);
      },
      onSelectAll: () => An.value ? qn.selectAll() : le.selectAll(),
      onOpen: () => {
        if (An.value) {
          const s = qn.nodes.value[0];
          s && qz("split", s);
          return;
        }
        const r = le.nodes.value[0];
        r && qa(r);
      },
      onClose: () => {
        var r;
        if (sa.value = !1, to.value = !1, ha.value = !1, pn.value && i_(pn.value.path) || (la.value = !1), (r = Kh.value) == null || r.hide(), jh(), VE.value) {
          hd();
          return;
        }
        if (hr.value) {
          Eo();
          return;
        }
        $a.value && Db();
      },
      onFocusSearch: () => {
        var r;
        return (r = uk.value) == null ? void 0 : r.focusSearch();
      },
      onCut: () => An.value ? pw() : nz(),
      onCopy: () => An.value ? hw() : az(),
      onPaste: () => An.value ? void mw() : void Pk(),
      onGoUp: () => {
        var r;
        return An.value ? (r = Zt.value) == null ? void 0 : r.goUp() : qe();
      },
      /* cila:c wiring */
      onPathJump: () => {
        Ch.value = "", Od.value = !0;
      },
      onShowHelp: () => {
        Ld.value = !0;
      },
      /* /cila:c wiring */
      onQuickLook: () => zz(),
      onToggleHidden: () => pk(),
      onStar: () => void Eb(le.nodes.value),
      onToggleInspector: () => _h(),
      /* wiring:d1 — tab actions (registry: tab-new/close/next/prev) */
      onTabNew: () => km(),
      onTabClose: () => nw(bm.value),
      onTabNext: () => Bz(),
      onTabPrev: () => Fz(),
      /* /wiring:d1 */
      /* tus:t1 — the menu verbs, routed through the SAME dispatcher the right-click
       * menu and the toolbar use (dispatchItemAction), so a key and a click cannot
       * drift apart. The ones that act on a selection do nothing without one, which
       * is what the menu does too. */
      onNewFolder: () => {
        sa.value = !0;
      },
      onUpload: () => Oo(),
      onRefresh: () => void wt(),
      onDownload: () => void Oi("download", ia()),
      onPreview: () => void Oi("preview", ia()),
      /* The share dialog is a door that makes links: the key opens it only where
         the menu offers Share (a role without any sharing permission gets
         nothing from the key either). */
      onShare: () => {
        const r = ia();
        XC("access", r) && Oi("access", r);
      },
      onTags: () => void Oi("tags", ia()),
      onOpenTab: () => void Oi("open-tab", ia()),
      onCopyPath: () => {
        const r = ia()[0];
        r && Kd(r.path);
      },
      onCopyId: () => void Oi("copy-id", ia()),
      onRestore: () => void Oi("restore", ia()),
      /* /tus:t1 */
      hasSelection: () => !le.isEmpty.value
    });
    function ia() {
      return An.value ? qn.nodes.value : le.nodes.value;
    }
    function qa(r) {
      if (r.basename === ".trash") {
        zi();
        return;
      }
      const s = Wc(r, { t: _ });
      if (s) {
        qt({ message: s.why }, 8e3);
        return;
      }
      const g = Yc(r, { t: _ });
      if (g) {
        qt({ message: g.full }, 8e3);
        return;
      }
      if (r.type === "dir") {
        const X = Sn.value ? Co(r.path) : Va(r.path);
        wt(X);
        return;
      }
      if (I.isVaultRow(r) && r.type === "file") {
        if (Vl(r, null, "edit")) return;
        Ns(r);
        return;
      }
      if (Ui(r) && !an.value && !r.e2e_root) {
        Mt.open(r);
        return;
      }
      if (r.type === "file" && !an.value && typeof r.e2e_root == "string" && r.e2e_root) {
        const X = Na(r.path);
        wt(Sn.value ? Co(X) : Va(X));
        return;
      }
      if (Yn.value && r.type === "file") {
        if (Vl(r, null, "edit")) return;
        Ns(r);
        return;
      }
      if (Au.value && r.type === "file") return;
      if (kv(P.config, r) === "host") {
        R("file-opened", { path: r.path, basename: r.basename }), Ua(r);
        return;
      }
      const M = (r.extension || "").toLowerCase();
      Ha.value = io(r) ? BC(M) : "view", $i.value = null;
      const F = qu(Hl.value, r, null, Kl.value, jl(r), rs(r));
      F != null && F.view && io(r) ? Ha.value = "edit" : Rf(F) && (Ha.value = "view"), pn.value = r, la.value = !0, R("file-opened", { path: r.path, basename: r.basename }), Ua(r);
    }
    const NC = /* @__PURE__ */ new Set([
      "drawio",
      "dio",
      "pdf",
      "epub",
      "ipynb",
      "tiff",
      "tif",
      "psd",
      "mmd",
      "mermaid",
      "glb",
      "gltf",
      "obj",
      "stl",
      "fbx",
      "3ds",
      "zip",
      "rar",
      "7z",
      "tar",
      "gz",
      "tgz",
      "jpg",
      "jpeg",
      "png",
      "webp",
      "gif",
      "bmp",
      "avif",
      "svg",
      "heic",
      "mp4",
      "webm",
      "mov",
      "mkv",
      "m4v",
      "ogv",
      "mp3",
      "wav",
      "ogg",
      "flac",
      "m4a",
      "aac",
      "opus"
    ]);
    function BC(r) {
      return Mv(r) || NC.has(r) ? "view" : "edit";
    }
    const Zh = $(!1);
    async function FC(r) {
      if (Zh.value) return;
      const s = r ?? le.nodes.value;
      if (s.length !== 0) {
        Zh.value = !0;
        try {
          if (Ft.value) {
            const F = s.map((de) => de.id).filter((de) => typeof de == "number");
            if (sd("restore")) {
              const { ops: de, summary: Se } = await j.restoreQueued(F);
              for (const $e of de) De.register($e);
              Se && tt(Se), le.clear();
              return;
            }
            const X = await j.restoreBatch(F);
            qt({ message: X.summary }, X.failed ? yn : hi), le.clear(), await zi();
            return;
          }
          if (!j.endpoints.restore) return;
          const g = s.map((F) => F.path), { restored: M } = await j.restore(g);
          tt(_("toast.restored", { n: M })), le.clear(), await wt();
        } catch (g) {
          qt({ message: Zn(g) }, yn), R("error", { message: g.message, context: { op: "restore" } });
        } finally {
          Zh.value = !1;
        }
      }
    }
    function Dd(r) {
      if (I.isVaultRow(r) && r.type === "file") {
        if (Vl(r, null, "view")) return;
        Ns(r);
        return;
      }
      if (Ui(r) && !an.value && !r.e2e_root) {
        Mt.open(r);
        return;
      }
      if (Yn.value && r.type === "file") {
        if (Vl(r, null, "view")) return;
        Ns(r);
        return;
      }
      Ha.value = "view", $i.value = null, pn.value = r, la.value = !0, Ua(r);
    }
    function UC(r) {
      if (r.type === "dir") {
        const de = Sn.value ? Co(r.path) : Va(r.path);
        wt(de);
        return;
      }
      if (Ui(r) && !an.value && !r.e2e_root) {
        Mt.open(r);
        return;
      }
      if (an.value) {
        Yn.value && Ns(r);
        return;
      }
      if (P.config.openInHost) {
        qa(r);
        return;
      }
      if (!io(r)) {
        Dd(r);
        return;
      }
      const s = (r.extension || "").toLowerCase(), g = P.config.openPageBase;
      if (!g) {
        qa(r);
        return;
      }
      const M = Xk(g), F = M.includes("?") ? "&" : "?", X = `${M}${F}path=${encodeURIComponent(r.path)}&type=${encodeURIComponent(s)}&mode=edit`;
      window.open(X, "_blank", "noopener"), R("file-opened", { path: r.path, basename: r.basename }), Ua(r);
    }
    const Pi = $("selection"), Qh = $(""), Po = $([]), HC = $(""), KC = E(() => {
      const r = ia();
      return r.length === 0 ? "none" : r.length === 1 ? r[0].type === "dir" ? "single-dir" : "single-file" : "multi";
    });
    async function em(r) {
      const s = ia();
      if (r === "open") {
        s[0] && qa(s[0]);
        return;
      }
      await Oi(r, s);
    }
    const ci = E(() => P.config.desktopSync ?? null), Rd = $([]);
    let Sk = !1;
    async function mr() {
      if (!ci.value) return;
      const r = Sk ? () => {
      } : du.start();
      try {
        Rd.value = await ci.value.kept(), Sk = !0;
      } catch {
      } finally {
        r();
      }
    }
    const Cs = $(null);
    async function $k() {
      const r = ci.value;
      if (r != null && r.status)
        try {
          Cs.value = (await r.status()).active ?? null;
        } catch {
          Cs.value = null;
        }
    }
    let zs = null, tm = !0;
    function VC() {
      zs || !tm || (zs = setTimeout(() => {
        zs = null, tm && ($k(), mr());
      }, 300));
    }
    jt(() => {
      var r, s;
      mr(), $k(), (s = (r = ci.value) == null ? void 0 : r.onChange) == null || s.call(r, VC);
    }), Tt(() => {
      tm = !1, zs && (clearTimeout(zs), zs = null);
    });
    function vu(r) {
      const s = String(r.path ?? "");
      return s.includes("://") ? s.replace(/\/+$/, "") : `${s}://`;
    }
    function Id(r, s) {
      return s.endsWith("://") ? r.startsWith(s) && r !== s : r === s ? !1 : r.startsWith(s + "/");
    }
    function nm(r) {
      return Rd.value.some((s) => s.remote === r) ? "kept" : Rd.value.some((s) => Id(r, s.remote)) ? "inherited" : Rd.value.some((s) => Id(s.remote, r)) ? "partial" : "none";
    }
    function Tk(r) {
      if (!ci.value || Kt.value || r.basename === ".trash") return null;
      const s = vu(r), g = Cs.value;
      if (g && (s === g.remote || Id(s, g.remote) || Id(g.remote, s)))
        return "syncing";
      const M = nm(s);
      return M === "kept" || M === "inherited" ? "kept" : M === "partial" ? "partial" : "cloud";
    }
    const jC = E(() => {
      const r = Cs.value;
      if (!r) return "";
      const s = r.remote.endsWith("://") ? r.remote.slice(0, -3) : r.remote.slice(r.remote.lastIndexOf("/") + 1);
      return r.phase === "transfer" && r.total > 0 ? _("keep.strip_transfer", {
        name: s,
        done: String(r.done),
        total: String(r.total),
        pct: String(Math.min(100, Math.round(r.done * 100 / r.total)))
      }) : r.phase === "settling" ? _("keep.strip_settling", { name: s }) : _("keep.strip_inventory", { name: s });
    }), Ak = E(() => {
      const r = Cs.value;
      return !r || r.phase !== "transfer" || r.total <= 0 ? null : Math.min(100, Math.round(r.done * 100 / r.total));
    });
    function Ek(r) {
      const s = r[0], g = String((s == null ? void 0 : s.storage) || (s == null ? void 0 : s.path) || ""), M = F5(g, P.config.storages, bn.value);
      return [
        ...I5(_, {
          manages: U5({ admin: pa.value, level: M }),
          shareUsers: Ms("share.users")
        }),
        ...Ck(r)
      ];
    }
    function Ck(r) {
      var F, X, de;
      const s = ci.value, g = r.length === 1 && (((F = r[0]) == null ? void 0 : F.type) === "dir" || ((X = r[0]) == null ? void 0 : X.type) === "file");
      if (!s || !g || Kt.value || an.value || ((de = r[0]) == null ? void 0 : de.e2e) === !0) return [];
      const M = nm(vu(r[0]));
      return [
        { divider: !0, key: "sep-keep", label: "" },
        { key: "keep-local", label: _("ctx.keep_local"), hidden: M === "kept" || M === "inherited" },
        { key: "keep-online", label: _("ctx.keep_online"), hidden: M !== "kept" },
        { key: "keep-inherited", label: _("ctx.keep_inherited"), disabled: !0, hidden: M !== "inherited" },
        { key: "keep-reveal", label: _("ctx.keep_reveal"), hidden: M !== "kept" && M !== "inherited" }
      ];
    }
    const am = $([]);
    let Nd = 0;
    async function yu(r, s) {
      var M;
      const g = ++Nd;
      if (s.length > 0 && (Mk.value, du.count > 0 && typeof window < "u")) {
        const F = (X) => {
          X.type === "keydown" && X.key !== "Escape" || g === Nd && Nd++;
        };
        window.addEventListener("pointerdown", F, !0), window.addEventListener("keydown", F, !0);
        try {
          await du.settled(hle);
        } finally {
          window.removeEventListener("pointerdown", F, !0), window.removeEventListener("keydown", F, !0);
        }
      }
      g === Nd && ((M = Kh.value) == null || M.show(r, s));
    }
    async function im(r, s) {
      Pi.value = "selection", mr(), le.has(r.path) || (le.click(r.path), await Gt()), am.value = le.nodes.value.length ? [] : [r];
      const g = le.nodes.value.length ? le.nodes.value : [r];
      await yu({ clientX: s.clientX, clientY: s.clientY }, g);
    }
    function qC(r) {
      r.preventDefault(), Pi.value = "selection", le.clear(), am.value = [], yu({ clientX: r.clientX, clientY: r.clientY }, []);
    }
    function WC(r) {
      Pi.value = "breadcrumb", Qh.value = r.adapterPath, HC.value = r.label, yu({ clientX: r.x, clientY: r.y }, []);
    }
    async function zk(r, s, g) {
      if (mr(), r === "split") {
        pi.value = "split";
        const M = qn.nodes.value;
        s && !qn.has(s.path) && (qn.click(s.path), await Gt());
        const F = qn.nodes.value;
        Po.value = s ? F.length > 0 ? F : M.length > 0 ? M : [s] : [], Pi.value = "pane", await yu({ clientX: g.clientX, clientY: g.clientY }, Po.value);
        return;
      }
      if (pi.value = "main", Pi.value = "selection", !s) {
        le.clear(), yu({ clientX: g.clientX, clientY: g.clientY }, []);
        return;
      }
      await im(s, g);
    }
    const Mk = E(() => {
      if (Pi.value === "breadcrumb")
        return [
          { key: "open", label: _("ctx.open") },
          { key: "copy-path", label: _("breadcrumb.copy_path") }
        ];
      if (Pi.value === "pane") {
        const X = Po.value;
        return X.length === 0 ? [
          { key: "new-folder", label: _("toolbar.new_folder") },
          { key: "paste", label: _("ctx.paste"), disabled: !Me.value.mode }
        ] : gu(X);
      }
      const r = le.nodes.value.length ? le.nodes.value : am.value, s = r.length > 0, g = r.length === 1;
      if (Kt.value)
        return s ? [
          { key: "restore", label: _("ctx.restore"), hidden: !Ms("files.create") },
          ...zo.value ? [
            { divider: !0, key: "sep1", label: "" },
            { key: "delete", label: _("ctx.delete_perm"), danger: !0, hidden: !Ms("files.purge") }
          ] : []
        ] : [];
      const M = (Xe.value ?? "").replace(/^\/+|\/+$/g, "");
      if (Sn.value && M === "")
        return s ? g ? Ek(r) : [] : [];
      if (!s) {
        const X = [
          {
            key: "toggle-hidden",
            label: tc.value ? _("ctx.hide_hidden") : _("ctx.show_hidden")
          }
        ];
        return cu(ye.value) ? [
          { key: "new-folder", label: _("toolbar.new_folder") },
          { key: "paste", label: _("ctx.paste"), disabled: !Me.value.mode },
          ...X
        ] : X;
      }
      return gu(r);
    });
    function Ms(r) {
      const s = he.value;
      return !s || s.includes(r);
    }
    const YC = {
      rename: ["files.rename"],
      cut: ["files.move"],
      "move-to": ["files.move"],
      delete: ["files.delete"],
      download: ["files.download"],
      convert: ["files.create"],
      "copy-to": ["files.create"],
      paste: ["files.create", "files.move"],
      tags: ["files.tag"],
      /* wiring:e2 policy — the four rows that START an encryption make something,
         a key file or a `.fxe`, and the server asks files.create for that beside
         files.encrypt (backend perm.FilesEncrypt: "carved out of files.create,
         which the same write needs as well"). A place can allow the one and deny
         the other; the row is then hidden, not offered to be refused. */
      "fxe-encrypt": ["files.create"],
      "fxe-request": ["files.create"],
      "e2e-convert": ["files.create"],
      "e2e-request": ["files.create"]
    };
    function Bd(r) {
      return O5((s) => fu(s, r));
    }
    function GC(r, s) {
      if (!he.value || s.length > 0 && s.every((M) => I.isVaultRow(M))) return r;
      const g = s.map((M) => M.path);
      return r.map((M) => {
        if (M.key === "access") {
          const X = s.length > 0 && s.every((de) => de.type === "dir");
          return L5(Bd(g), X) ? M : { ...M, hidden: !0 };
        }
        const F = YC[M.key];
        return F && !F.some((X) => fu(X, g)) ? { ...M, hidden: !0 } : M;
      });
    }
    function XC(r, s) {
      return gu(s).some((g) => g.key === r && !g.hidden && !g.disabled);
    }
    function gu(r) {
      const s = GC(ZC(r), r);
      return r.some(a$) ? s.map((g) => g.divider || g.key === "details" ? g : { ...g, disabled: !0 }) : s;
    }
    function JC(r) {
      var X;
      const s = String(r[0].vault_root ?? ""), g = r.length === 1, M = g && r[0].type === "file", F = cu(I.permOf(s)) && !((X = I.strips[s]) != null && X.readOnly) && fu("files.create", [s]) && fu("files.delete", [s]);
      return [
        { key: "preview", label: _("ctx.preview"), hidden: !g, disabled: !M },
        { key: "download", label: _("ctx.download"), disabled: r.length === 0 },
        { key: "details", label: _("ctx.details") },
        { divider: !0, key: "sep1", label: "", hidden: !F },
        { key: "rename", label: _("ctx.rename"), hidden: !g || !F },
        { key: "cut", label: _("ctx.cut"), hidden: !F },
        { key: "copy", label: _("ctx.copy") },
        { key: "paste", label: _("ctx.paste"), hidden: !F, disabled: !Me.value.mode },
        { divider: !0, key: "sep2", label: "", hidden: !F },
        { key: "delete", label: _("ctx.delete"), danger: !0, hidden: !F }
      ];
    }
    function ZC(r) {
      var vn, $n, Fi, Ga;
      if (r.length > 0 && r.every((sf) => I.isVaultRow(sf))) return JC(r);
      const s = r.length > 0, g = r.length === 1;
      if (r.some(cc))
        return g ? Ek(r) : [];
      const M = g && ((vn = r[0]) == null ? void 0 : vn.type) === "file", F = _("ctx.tags_menu"), X = g && om(r[0]), de = g && typeof (($n = r[0]) == null ? void 0 : $n.id) == "number", Se = vh(r).length > 0, $e = Ab(r), ut = dC(r), et = cu(ut) && !ak(r), Pt = _("shortcuts.share"), En = String(((Fi = r[0]) == null ? void 0 : Fi.extension) ?? "").toLowerCase(), At = M ? Mv(En) ? Km(!!rr.value, pa.value, _("ctx.needs_onlyoffice")) : En === "drawio" || En === "dio" ? Km(!!Jl.value, pa.value, _("ctx.needs_drawio")) : {} : {}, Ya = QT(r, { canWrite: et, inEncrypted: an.value });
      return [
        { key: "open", label: _("ctx.open"), ...At, hidden: !g || At.hidden === !0 },
        { key: "open-tab", label: _("ctx.open_new_tab"), hidden: !g || ((Ga = r[0]) == null ? void 0 : Ga.type) !== "dir" },
        { key: "preview", label: _("ctx.preview"), hidden: !g, disabled: !M },
        /* tasi:m1 — Download works on ANY selection now. It used to disappear the
           moment a second row was ticked, because the only implementation was one
           `window.open` per node and the browser blocks the second popup; there is
           one streaming archive behind it now (lib/downloadSelection), and the
           server expands a selected folder itself, so a lone folder is a zip too.
           Inside an encrypted folder the server has no plaintext to zip: the zip
           is made in this tab (below), and a LOCKED folder downloads one row at
           a time. */
        /* wiring:e2 fxe — inside an unlocked encrypted folder a selection of any
           size downloads DECRYPTED now (a zip made in this tab); the ciphertext is
           "Download encrypted copy" below. */
        { key: "download", label: _("ctx.download"), hidden: !s || Au.value && !g, disabled: !s },
        /* wiring:e2 fxe — single encrypted files, and the ciphertext copy.
           wiring:e2 policy — "Encrypt with E2EE…" asks the answer for the file it
           would encrypt, and becomes "Request encryption…" under the approval
           policy (useE2eFiles menuRows). */
        ...Mt.menuRows(r, {
          canWrite: et,
          inEncrypted: an.value,
          unlockedEncryptedCopy: Yn.value || g && Uw(r[0]) !== null,
          encryptAnswer: Ya ? Hh(Ya.path, "file") : void 0
        }),
        { key: "archive-create", label: _("ctx.archive_create"), hidden: !s || g && X || !et || an.value || tu.value.length === 0, disabled: !s },
        { key: "archive-extract", label: _("ctx.archive_extract"), hidden: !X || !et || an.value, disabled: !X },
        { key: "archive-extract-here", icon: "archive-extract", label: _("archive.extract_here"), hidden: !X || !et || an.value, disabled: !X },
        /* tasi:m1 — VISIBLE and grey above a multi-selection, not gone. Sharing
           really is one item at a time (a share link addresses one node), and the
           row now says so in its tooltip; vanishing taught the reader that filex
           cannot share the thing they are looking at. */
        {
          key: "access",
          label: Pt,
          hidden: !s || !et || GS(r, an.value),
          disabled: !g,
          title: g ? void 0 : _("ctx.access.one_only")
        },
        { key: "details", label: _("ctx.details"), hidden: !s },
        /* wiring:e2 convert — encrypt a folder that already exists, in place.
           wiring:e2 policy — offered where the policy lets this account encrypt
           that folder; where it wants an approval, the menu asks for one. */
        { key: "e2e-convert", label: _("e2e.convert.ctx"), icon: "lock", hidden: !Rw(r, et, "allowed") },
        { key: "e2e-request", label: _("e2e.request.ctx"), icon: "lock", hidden: !Rw(r, et, "request") },
        /* ⚠ "Copy node id" is NOT here any more (owner's call, 2026-09-13): it is a
           developer's handle on a support ticket, not an everyday verb, and this
           list is rendered by BOTH the right-click menu and the selection bar — so
           one row put it in front of everyone, twice. It lives in the details
           panel now, beside Path and ETag, which is where the other technical
           facts about a file already are. The `copy-id` case below stays: the
           panel dispatches it. */
        { divider: !0, key: "sep1", label: "", hidden: !et },
        { key: "rename", label: _("ctx.rename"), hidden: !g || !et, disabled: !g },
        { key: "cut", label: _("ctx.cut"), hidden: !s || !et, disabled: !s },
        { key: "copy", label: _("ctx.copy"), hidden: !s, disabled: !s },
        /* tasi:m1 — "somewhere else", without the clipboard. Cut+paste has always
           been able to do this, but only by navigating away from the rows you had
           just picked; these two ask WHERE in a dialog and leave the listing where
           it is.
           ⚠ `icon:` is not decoration here — `actionIconSvg` answers '' for a key
           it does not know, and a bar button with no glyph is an empty 28px box.
           They borrow the clipboard verbs' marks, which is what they are. */
        { key: "move-to", label: _("ctx.move_to"), icon: "cut", hidden: !s || !et, disabled: !s },
        { key: "copy-to", label: _("ctx.copy_to"), icon: "copy", hidden: !s, disabled: !s },
        /* Paste needs a destination folder; a virtual view (Recent / Starred /
           Shared / a tag / Home) has none, so it is the one write verb the row
           menu does not carry there — every per-row verb above and below does. */
        { key: "paste", label: _("ctx.paste"), hidden: !et || Qe.value, disabled: !Me.value.mode },
        { divider: !0, key: "sep-meta", label: "", hidden: !de && !Se },
        /* yildiz:s1 — "star must be an action, like a tag" (owner, v0.30.0).
           Beside Tags on purpose: they are the same kind of verb, and this is the
           ONLY star a grid/gallery user reaches with the keyboard. Works on a
           multi-selection; the label follows the selection's state. */
        {
          key: "star",
          label: _($e ? "ctx.unstar" : "ctx.star"),
          icon: $e ? "unstar" : "star",
          hidden: !Se
        },
        { key: "tags", label: F, hidden: !de, disabled: !de },
        /* App plugins — one row per action whose `applies` rule accepts the
           selection, under its own `sep-plugins` divider; `[]` when the feature
           is off, in the trash, or inside an encrypted folder (lib/pluginMenu). */
        ...qA(r),
        ...eE(r),
        ...Ck(r),
        { divider: !0, key: "sep2", label: "", hidden: !et },
        { key: "delete", label: _("ctx.delete"), danger: !0, hidden: !s || !et, disabled: !s }
      ];
    }
    const QC = /* @__PURE__ */ new Set(["zip", "7z", "rar", "tar", "gz", "tgz", "bz2", "tbz2", "xz", "txz"]);
    function om(r) {
      return !!r && r.type === "file" && QC.has((r.extension || "").toLowerCase());
    }
    const ez = E(() => {
      const r = ia();
      if (An.value) return r.length ? gu(r).filter((g) => g.key !== "archive-extract-here") : [];
      if (Kt.value)
        return r.length === 0 ? [] : [
          { key: "restore", label: _("ctx.restore"), hidden: !Ms("files.create") },
          ...zo.value ? [{ key: "delete", label: _("ctx.delete_perm"), danger: !0, hidden: !Ms("files.purge") }] : []
        ];
      const s = (Xe.value ?? "").replace(/^\/+|\/+$/g, "");
      return Sn.value && s === "" ? r.length === 1 ? [{ key: "open", label: _("ctx.open") }] : [] : r.length === 0 ? [] : gu(r).filter((g) => g.key !== "archive-extract-here");
    });
    async function tz(r, s) {
      if (Pi.value === "breadcrumb") {
        r.key === "open" ? wt(Va(Qh.value)) : r.key === "copy-path" && await Kd(Qh.value);
        return;
      }
      if (Pi.value === "pane") {
        await Oi(r.key, Po.value);
        return;
      }
      await Oi(r.key, s);
    }
    function di() {
      return Pi.value === "pane" || An.value;
    }
    async function Oi(r, s) {
      var g, M;
      if (h3(r)) {
        await kb(r, s);
        return;
      }
      if (r === "open-with-choose") {
        s[0] && (Da.value = s[0]);
        return;
      }
      if (r.startsWith("open-with:")) {
        const F = s[0];
        if (F) {
          const X = r.slice(10);
          Dd(F), $i.value = X, X !== "builtin" && io(F) && (Ha.value = "edit");
        }
        return;
      }
      if (uae(r)) {
        await Mt.dispatch(r, s, (F) => Fd(F, { encrypted: !0 }));
        return;
      }
      switch (r) {
        case "clear-selection":
          An.value ? qn.clear() : le.clear();
          return;
        case "open":
          s[0] && UC(s[0]);
          break;
        case "preview":
          s[0] && Dd(s[0]);
          break;
        case "e2e-convert":
          s[0] && MM(s[0]);
          break;
        case "e2e-request":
          s[0] && Sm(s[0].path, "folder", s[0].basename);
          break;
        case "download":
          await Fd(s);
          break;
        case "archive-create":
          if (s.length === 0) break;
          eu.value = s, fs.value = di(), ds.value = fs.value ? Rt(((g = Zt.value) == null ? void 0 : g.getPath()) ?? "") : Rt(Xe.value), Ai.value = "", ld.value = !0;
          break;
        case "archive-extract":
          if (!s[0] || !om(s[0])) break;
          Ao.value = s[0], fs.value = di(), ds.value = oo(s[0].path), Ai.value = "", ur.value = !0;
          break;
        case "archive-extract-here":
          if (!s[0] || !om(s[0])) break;
          Ao.value = s[0], fs.value = di(), ds.value = oo(s[0].path), Ai.value = "", await um(s[0], ds.value, fs.value);
          break;
        case "move-to":
        case "copy-to":
          if (s.length === 0) break;
          ud.value = r === "move-to" ? "move" : "copy", cd.value = s, dd.value = !1, ys.value = !0;
          break;
        case "keep-local": {
          const F = ci.value;
          if (!F || !s[0]) break;
          const X = vu(s[0]);
          try {
            await F.keep(X, s[0].type === "file" ? "file" : "dir"), await mr(), nm(X) !== "none" && tt(_("keep.started"));
          } catch (de) {
            await mr(), tt(`${_("keep.failed")}: ${String((de == null ? void 0 : de.message) ?? de)}`);
          }
          break;
        }
        case "keep-online": {
          const F = ci.value;
          if (!F || !s[0]) break;
          try {
            await F.unkeep(vu(s[0]));
          } catch {
          }
          await mr();
          break;
        }
        case "keep-reveal": {
          const F = ci.value;
          F && s[0] && F.reveal(vu(s[0]));
          break;
        }
        case "access":
          s[0] && (si.value = s[0], pr.value = !0);
          break;
        case "storage-access":
          s[0] && (si.value = R5(s[0]), su.value = "perms", pr.value = !0);
          break;
        case "details":
          PE();
          break;
        case "copy-id":
          if (s[0] && typeof s[0].id == "number") {
            const F = s[0].id;
            (M = navigator.clipboard) == null || M.writeText(String(F)).then(
              () => tt(_("toast.node_id_copied", { id: F })),
              () => tt(`#${F}`)
            );
          }
          break;
        case "star":
          await Eb(s);
          break;
        case "tags":
          s[0] && oE(s[0]);
          break;
        case "rename":
          s[0] && (fr.value = s[0], Ei.value = di(), to.value = !0);
          break;
        case "cut":
          di() ? pw() : (Me.value = { mode: "cut", items: s, sourcePath: Xe.value }, tt(_("toast.cut_ready")));
          break;
        case "copy":
          di() ? hw() : (Me.value = { mode: "copy", items: s, sourcePath: Xe.value }, tt(_("toast.copy_ready")));
          break;
        case "paste":
          di() ? await mw() : await Pk();
          break;
        case "delete": {
          const F = di();
          F && (Po.value = s), Ei.value = F, ha.value = !0;
          break;
        }
        case "restore":
          s.length > 0 && await FC(s);
          break;
        case "toggle-hidden":
          pk();
          break;
        case "new-folder":
          Ei.value = di(), sa.value = !0;
          break;
        case "duplicate":
          s[0] && await iz(s[0]);
          break;
        case "open-tab":
          s[0] && aw(s[0]);
          break;
      }
    }
    function nz() {
      le.isEmpty.value || (Me.value = { mode: "cut", items: le.nodes.value, sourcePath: Xe.value }, tt(_("toast.cut")));
    }
    function az() {
      le.isEmpty.value || (Me.value = { mode: "copy", items: le.nodes.value, sourcePath: Xe.value }, tt(_("toast.copied")));
    }
    let rm = !1;
    async function Pk() {
      const r = Me.value;
      if (!(!r.mode || r.items.length === 0 || rm)) {
        rm = !0;
        try {
          const s = r.items.map(($e) => $e.path), g = r.sourcePath || "";
          if (r.mode === "cut" && g === Xe.value) {
            tt(_("toast.same_folder_cut"));
            return;
          }
          const F = Rt(Xe.value), X = $w(s, F);
          if (X === "cross") {
            tt(_("e2e.vault.cross"));
            return;
          }
          if (X === "inside") {
            (r.mode === "cut" ? await I.move(s, F) : await I.copy(s, F)) && r.mode === "cut" && (Me.value = { mode: null, items: [], sourcePath: null });
            return;
          }
          const de = U0(s, F, r.mode === "cut" ? "move" : "copy"), Se = await Om(r.mode === "cut" ? "move" : "copy", s, F, Rt(g) || void 0);
          if (Se) {
            Se.undo && Se.ops.length && me.set(Se.ops[Se.ops.length - 1].id, { message: _("toast.moved"), fn: Se.undo }), Se.ops.length && tt(r.mode === "cut" ? _("split.move_queued") : _("split.copy_queued")), Me.value = { mode: null, items: [], sourcePath: null };
            return;
          }
          if (r.mode === "cut") {
            const $e = Rt(g) || void 0, ut = await gk(s, F), { op: et } = await j.moveAsync(s, F, $e);
            bk(et.id, s, F, $e, ut), De.register(et), tt(
              ut ? _("toast.move_kept_both") : de.cross ? _("split.cross_move") : _("split.move_queued")
            );
          } else {
            const { op: $e } = await j.copy(s, F);
            De.register($e), tt(de.cross ? _("split.cross_copy") : _("split.copy_queued"));
          }
          Me.value = { mode: null, items: [], sourcePath: null };
        } catch (s) {
          ql(s, { op: "paste" });
        } finally {
          rm = !1;
        }
      }
    }
    async function iz(r) {
      try {
        const { op: s } = await j.copy([r.path], Rt(Xe.value));
        De.register(s);
      } catch (s) {
        ql(s, { op: "duplicate" });
      }
    }
    function oz(r) {
      if (I.isVaultRow(r)) {
        I.download([r]);
        return;
      }
      if (Yn.value) {
        pM(r);
        return;
      }
      const s = j.downloadUrl(r.path);
      window.open(s, "_blank");
    }
    const sm = $(!1);
    async function Fd(r, s = {}) {
      if (r.length !== 0) {
        if (r.every((g) => I.isVaultRow(g))) {
          await I.download(r);
          return;
        }
        if (!(!s.encrypted && await HM(r))) {
          if (r.length === 1 && r[0].type === "file") {
            if (s.encrypted) {
              window.open(j.downloadUrl(r[0].path), "_blank");
              return;
            }
            oz(r[0]);
            return;
          }
          if (!sm.value) {
            sm.value = !0, qt({ message: _("toast.archive.preparing") }, wf);
            try {
              const g = await Rae(j, r.map((F) => F.path)), M = r.length === 1 && r[0].e2e_stored ? `${r[0].basename}.zip` : g.name;
              tt(_("toast.archive.started", { name: M, count: String(g.files) }));
            } catch (g) {
              const M = g;
              qt({ message: M.status === 409 ? _("toast.archive.empty") : Zn(g) }, yn), R("error", { message: M.message, context: { op: "archive-download" } });
            } finally {
              sm.value = !1;
            }
          }
        }
      }
    }
    async function rz(r) {
      var F;
      const s = cd.value;
      if (!r || s.length === 0) {
        ys.value = !1;
        return;
      }
      const g = ud.value === "move", M = di() ? Rt(((F = Zt.value) == null ? void 0 : F.getPath()) ?? "") : Rt(Xe.value);
      dd.value = !0;
      try {
        const X = await Rs(s.map((Se) => Se.path), r, M || void 0, g ? "move" : "copy"), de = Vt.segmentLabel(r) ?? ml(r, r);
        X === "queued" ? tt(g ? _("toast.moved_to", { name: de }) : _("toast.copied_to", { name: de })) : X === "nothing" && tt(_("toast.already_there", { name: de })), g && (X === "queued" || X === "done") && (di() ? qn.clear() : le.clear());
      } finally {
        dd.value = !1, ys.value = !1;
      }
    }
    async function sz(r) {
      Ql.value = !1;
      const s = r.app ? `${r.app.plugin}/${r.app.view}` : null;
      if (r.draft) {
        us.value += 1, Pb(r.draft, s), kh();
        return;
      }
      const g = r.path.slice(0, r.path.lastIndexOf("/"));
      g && g !== Rt(Xe.value) ? await wt(g) : await wt();
      const M = r.name.lastIndexOf("."), F = G.value.find((X) => X.path === r.path) ?? {
        type: "file",
        path: r.path,
        basename: r.name,
        extension: M > 0 ? r.name.slice(M + 1).toLowerCase() : ""
      };
      if (kv(P.config, F) === "host") {
        R("file-opened", { path: F.path, basename: F.basename }), Ua(F);
        return;
      }
      vs.value = r.ext ? { path: F.path, ext: r.ext } : null, $i.value = s, pn.value = F, Ha.value = io(F) ? "edit" : "view", la.value = !0, R("file-opened", { path: F.path, basename: F.basename }), Ua(F);
    }
    function lz(r) {
      const s = r == null ? void 0 : r.detail;
      if (s)
        try {
          return JSON.parse(s).code;
        } catch {
          return;
        }
    }
    function lm(r) {
      const s = r == null ? void 0 : r.detail;
      if (s)
        try {
          const g = JSON.parse(s), M = {
            PASSWORD_REQUIRED: "archive.password_required",
            BAD_PASSWORD: "archive.bad_password",
            TARGET_EXISTS: "archive.target_exists",
            PASSWORD_CHARSET: "archive.password_charset",
            UNSUPPORTED_FORMAT: "archive.error_unsupported",
            ARCHIVE_LIMIT_EXCEEDED: "archive.error_limit",
            PROVIDER_UNAVAILABLE: "archive.error_unavailable"
          };
          if (g.code && M[g.code]) return _(M[g.code]);
          if (g.error) return g.error;
        } catch {
        }
      return (r == null ? void 0 : r.message) || _("toast.failed");
    }
    async function uz(r) {
      wh.value = !0, Ai.value = "";
      try {
        const { op: s } = await j.archiveCreate({
          dest: ja(ds.value, r.name),
          sources: eu.value.map((g) => g.path),
          format: r.format,
          password: r.password,
          encrypt_filenames: r.encrypt_filenames,
          compression: r.compression,
          solid: r.solid,
          dictionary_size_mb: r.dictionary_size_mb
        });
        De.register(s), ld.value = !1, _u.reveal(), tt(_("archive.queued"));
      } catch (s) {
        Ai.value = lm(s), R("error", { message: Ai.value, context: { op: "archive-create" } });
      } finally {
        wh.value = !1;
      }
    }
    async function um(r, s, g, M) {
      var de, Se;
      if (cr.value.has(r.path)) {
        tt(_("archive.already_preparing", { name: r.basename }));
        return;
      }
      cr.value = new Set(cr.value).add(r.path), Ai.value = "";
      const F = _("archive.preparing_extract", { name: r.basename }), X = setTimeout(() => {
        !ur.value && !cs.value && qt({ message: F }, wf);
      }, 600);
      try {
        const $e = await j.archiveExtract(r.path, {
          dest: s,
          password: M
        });
        if (ur.value = !1, cs.value = !1, dr.value = null, ps.value = "", $e.op) {
          De.register($e.op), _u.reveal(), tt(_("archive.extraction_queued"));
          return;
        }
        g ? await ((de = Zt.value) == null ? void 0 : de.reload()) : await wt(), tt(_("archive.extracted", { count: $e.count ?? 0 }));
      } catch ($e) {
        const ut = lz($e);
        if (ut === "PASSWORD_REQUIRED" || ut === "BAD_PASSWORD") {
          dr.value = { target: r, dest: s, inPane: g }, ps.value = ut === "BAD_PASSWORD" ? _("archive.bad_password") : "", ur.value = !1, cs.value = !0;
          return;
        }
        const et = lm($e);
        cs.value ? ps.value = et : ur.value ? Ai.value = et : qt({ message: et }, 6e3);
      } finally {
        clearTimeout(X), ((Se = ma.value) == null ? void 0 : Se.message) === F && (ma.value = null);
        const $e = new Set(cr.value);
        $e.delete(r.path), cr.value = $e;
      }
    }
    async function cz(r) {
      const s = Ao.value;
      s && await um(
        s,
        ja(ds.value, r.folder),
        fs.value
      );
    }
    async function dz(r) {
      const s = dr.value;
      s && (ps.value = "", await um(s.target, s.dest, s.inPane, r));
    }
    function fz() {
      cs.value = !1, dr.value = null, ps.value = "";
    }
    async function pz(r) {
      try {
        await j.opsCancel(r), await De.poll();
      } catch (s) {
        const g = De.ops.value.find((F) => F.id === r), M = (g == null ? void 0 : g.op_type) === "archive-create" || (g == null ? void 0 : g.op_type) === "archive-extract";
        qt({ message: M ? lm(s) : Zn(s, _("plugin.cancel_failed")) }, yn);
      }
    }
    async function hz(r) {
      var M, F;
      const s = ms.begin();
      if (s === null) return;
      const g = Ei.value;
      try {
        const X = Rt(g ? ((M = Zt.value) == null ? void 0 : M.getPath()) ?? "" : Xe.value);
        if (I.rootOf(X)) {
          await I.mkdir(X, r) && (sa.value = !1, ms.end(s));
          return;
        }
        await Ok(X, r), sa.value = !1, ms.end(s), g ? await ((F = Zt.value) == null ? void 0 : F.reload()) : await wt();
      } catch (X) {
        Wl(ms, s, X, { op: "newfolder" });
      } finally {
        ms.end(s);
      }
    }
    async function Ok(r, s) {
      const g = Hy(await Pw(r, s, { isDir: !0 }));
      return await j.newFolder(r, g), ja(r, g);
    }
    async function mz(r) {
      var F, X;
      const s = fr.value;
      if (!s) return;
      const g = hs.begin();
      if (g === null) return;
      const M = Ei.value;
      try {
        const de = Rt(M ? ((F = Zt.value) == null ? void 0 : F.getPath()) ?? "" : Xe.value), Se = s.path;
        if (I.rootOf(Se)) {
          await I.rename(Se, r) && (to.value = !1, fr.value = null, hs.end(g));
          return;
        }
        const $e = Mf(s), ut = await Pw(
          oo(Se),
          r,
          s.type === "dir" ? { keepIdOf: Se } : {}
        ), et = s.type === "dir" && sd("rename");
        let Pt;
        et ? Pt = (await j.renameQueued(de, Se, ut)).op : await j.rename(de, Se, ut), to.value = !1, fr.value = null, hs.end(g);
        const En = ja(oo(Se), ut), At = ut && ut !== $e ? async () => {
          if (!et) {
            await j.rename(de, En, $e);
            return;
          }
          const Ya = (await j.renameQueued(de, En, $e)).op;
          return Ya && De.register(Ya), { queued: !0 };
        } : null;
        if (Pt) {
          At && me.set(Pt.id, { message: _("toast.renamed"), fn: At }), De.register(Pt), tt(_("toast.rename_queued", { name: r }));
          return;
        }
        M ? await ((X = Zt.value) == null ? void 0 : X.reload()) : await wt(), At && $d(_("toast.renamed"), At);
      } catch (de) {
        const Se = de, $e = de instanceof Mw ? _("e2e.names.bad_name", { name: r }) : Se.status === 409 ? _("newdoc.err.exists", { name: r }) : Zn(de);
        Wl(hs, g, de, { op: "rename" }, $e);
      } finally {
        hs.end(g);
      }
    }
    const Ps = $(/* @__PURE__ */ new Set()), cm = /* @__PURE__ */ new Map();
    function bu(r, s) {
      const g = new Set(Ps.value);
      for (const M of r)
        s ? g.add(M) : g.delete(M);
      Ps.value = g;
      for (const M of G.value) {
        const F = M.id, X = M.extra_metadata;
        typeof F == "number" && r.includes(F) && X && (X.purging = s);
      }
    }
    async function vz() {
      const r = le.nodes.value.map(($e) => $e.id).filter(($e) => typeof $e == "number");
      if (r.length === 0) {
        ha.value = !1;
        return;
      }
      const s = r.filter(($e) => !Ps.value.has($e));
      if (s.length === 0) {
        ha.value = !1, tt(_("trash.row_busy"));
        return;
      }
      const g = Sa.begin();
      if (g === null) return;
      const M = sd("purge");
      bu(s, !0);
      let F;
      try {
        F = await j.purgeBatch(s, { queued: M });
      } catch ($e) {
        bu(s, !1), Sa.end(g), Wl(Sa, g, $e, { op: "purge" });
        return;
      }
      Sa.end(g);
      const X = F.ops ?? [];
      X.length === 0 && bu(s, !1);
      const de = ($e) => {
        var ut;
        return (ut = G.value.find((et) => et.id === $e)) == null ? void 0 : ut.storage_id;
      }, Se = /* @__PURE__ */ new Set();
      for (const $e of X) {
        De.register($e);
        const ut = $e.storage_id, et = X.length === 1 ? s : s.filter((Pt) => de(Pt) === ut);
        for (const Pt of et) Se.add(Pt);
        cm.set($e.id, et);
      }
      if (X.length > 1 && bu(s.filter(($e) => !Se.has($e)), !1), F.done === 0) {
        Wl(Sa, g, new Error(F.summary), { op: "purge" }, F.summary);
        return;
      }
      ha.value = !1, le.clear(), qt({ message: F.summary }, F.failed ? yn : hi), X.length === 0 && Ft.value && await zi();
    }
    async function yz() {
      var Se, $e, ut;
      if (Sa.busy.value) return;
      if (Ft.value) {
        if (!zo.value) {
          ha.value = !1, tt(_("toast.trash_retention"));
          return;
        }
        await vz();
        return;
      }
      const r = Ei.value, s = r ? Po.value : le.nodes.value, g = Rt(r ? ((Se = Zt.value) == null ? void 0 : Se.getPath()) ?? "" : Xe.value), M = s.map((et) => et.path);
      if (M.length === 0) {
        ha.value = !1;
        return;
      }
      if (I.rootOf(M[0])) {
        const et = Sa.begin();
        if (et === null) return;
        try {
          await I.remove(M) && (ha.value = !1, r || le.clear());
        } finally {
          Sa.end(et);
        }
        return;
      }
      const F = s.map((et) => et.id).filter((et) => typeof et == "number"), X = j.endpoints.trashRestore && F.length === s.length ? async () => {
        const et = await j.restoreBatch(F);
        if (et.done === 0) throw new Error(et.summary);
        return { summary: et.summary };
      } : null, de = Sa.begin();
      if (de !== null)
        try {
          if (j.endpoints.deleteAsync) {
            const { op: et } = await j.deleteAsync(M, g);
            X && me.set(et.id, { message: _("toast.trashed"), fn: X }), De.register(et), tt(_("toast.delete_queued")), ha.value = !1, Sa.end(de);
          } else
            await j.deleteItems(g, M), ha.value = !1, Sa.end(de), r ? await (($e = Zt.value) == null ? void 0 : $e.reload()) : await wt(), X && $d(_("toast.trashed"), X);
          r ? (ut = Zt.value) == null || ut.reload() : le.clear();
        } catch (et) {
          Wl(Sa, de, et, { op: "delete" });
        } finally {
          Sa.end(de);
        }
    }
    function Oo() {
      var r;
      if (!li.value) {
        tt(_("toast.read_only_here"));
        return;
      }
      (r = Lb.value) == null || r.click();
    }
    function gz(r) {
      const s = r.target, g = s.files ? Array.from(s.files) : [];
      s.value = "", dm(g);
    }
    async function dm(r, s, g = {}) {
      if (r.length === 0) return;
      const M = s ?? Rt(Xe.value);
      if (I.rootOf(M)) {
        if (!I.isOpen(I.rootOf(M))) {
          tt(_("e2e.upload.locked"));
          return;
        }
        await I.upload(M, r);
        return;
      }
      if (Au.value) {
        tt(_("e2e.upload.locked"));
        return;
      }
      if (Yn.value) {
        const F = await hM(r, M);
        if (r = F.files, r.length === 0) return;
        if (F.sidecars.length > 0)
          try {
            await j.uploadMultipart(M, F.sidecars);
          } catch (X) {
            R("error", { message: X.message, context: { op: "e2e-name-sidecar" } }), tt(_("e2e.names.write_failed"));
            return;
          }
      }
      for (const F of r) {
        const X = gw.get(F);
        if (X) {
          await fm(F, M, X) || tt(_("e2e.upload.streaming_unsupported"));
          continue;
        }
        if (xe.shouldChunk(F)) {
          const de = xe.resumableFor(M, F);
          if (de && tt(
            _("upload.resuming", {
              name: vr.get(F) ?? F.name,
              percent: F.size > 0 ? Math.round(de.offset / F.size * 100) : 0
            })
          ), await fm(F, M)) continue;
        }
        await Dk(F, M);
      }
      g.reload !== !1 && await wt();
    }
    function Lk() {
      return an.value ? `${Ct.value}|${Yn.value ? "open" : "locked"}` : "";
    }
    async function bz(r, s) {
      const g = Lk(), M = await Hae(r);
      for (const de of M.unreadable) tt(_("upload.failed", { name: de }));
      if (M.dirs.length === 0) {
        await dm(M.files.map((de) => de.file), s);
        return;
      }
      const F = I.rootOf(s);
      if (F) {
        if (!I.isOpen(F)) {
          tt(_("e2e.upload.locked"));
          return;
        }
        const de = M.files.map(({ file: Se, dir: $e }) => $e ? jae(Se, `${$e}/${Se.name}`) : Se);
        de.length > 0 && await I.upload(s, de);
        for (const Se of Kae(M)) {
          const $e = Se.lastIndexOf("/");
          await I.mkdir($e === -1 ? s : ja(s, Se.slice(0, $e)), Se.slice($e + 1));
        }
        return;
      }
      if (Au.value) {
        tt(_("e2e.upload.locked"));
        return;
      }
      const X = (de) => Lk() === g ? de() : Promise.reject(new Error("the encrypted folder was left during the upload"));
      await Vae(M, s, {
        mkdir: (de, Se) => X(() => Ok(de, Se)),
        upload: (de, Se) => X(() => dm(de, Se, { reload: !1 })),
        failed: (de, Se) => {
          tt(_("upload.failed", { name: de })), R("error", { message: Se.message, context: { op: "upload", file: de } });
        }
      }), await wt();
    }
    async function Dk(r, s) {
      const g = ul(), M = s ?? Rt(Xe.value);
      jn.value = [
        ...jn.value,
        { id: g, file: r, displayName: vr.get(r), path: M, totalBytes: r.size, uploadedBytes: 0, percent: 0, status: "uploading", cancel() {
        } }
      ];
      const F = (X) => {
        const de = jn.value.findIndex(($e) => $e.id === g);
        if (de === -1) return;
        const Se = [...jn.value];
        Se[de] = { ...Se[de], ...X }, jn.value = Se;
      };
      try {
        await j.uploadMultipart(M, [r], (X) => {
          F({ percent: X, uploadedBytes: Math.round(X / 100 * r.size) }), R("upload-progress", { uploadId: g, percent: X, done: X >= 100 });
        }), F({ percent: 100, uploadedBytes: r.size, status: "done" }), R("upload-progress", { uploadId: g, percent: 100, done: !0 });
      } catch (X) {
        const de = X.message;
        F({ status: "error", error: de }), tt(_("upload.failed", { name: r.name })), R("error", {
          message: de,
          context: { op: "upload", file: r.name }
        });
      }
    }
    async function fm(r, s, g) {
      const M = ul();
      let F = !1;
      const X = (Se) => {
        if (!F) {
          jn.value = [...jn.value, { ...Se, id: M, displayName: vr.get(r) }], F = !0;
          return;
        }
        const $e = jn.value.findIndex((ut) => ut.id === M);
        if ($e !== -1) {
          const ut = [...jn.value];
          ut[$e] = { ...Se, id: M, displayName: vr.get(r) }, jn.value = ut;
        }
      }, de = s ?? Rt(Xe.value);
      try {
        return await xe.uploadFile({
          path: de,
          file: r,
          source: g,
          onProgress: (Se) => {
            !F && Se.status !== "uploading" && Se.uploadedBytes <= 0 || (X(Se), R("upload-progress", {
              uploadId: Se.uploadId ?? M,
              percent: Se.percent,
              done: Se.status === "done"
            }));
          }
        }), !0;
      } catch (Se) {
        if (Yy(Se))
          return F && (jn.value = jn.value.filter((ut) => ut.id !== M)), !1;
        const $e = Se.message;
        return F || (jn.value = [
          ...jn.value,
          {
            id: M,
            file: r,
            displayName: vr.get(r),
            path: de,
            totalBytes: r.size,
            uploadedBytes: 0,
            percent: 0,
            status: "error",
            error: $e,
            cancel() {
            }
          }
        ], F = !0), tt(_("upload.failed", { name: vr.get(r) ?? r.name })), R("error", { message: $e, context: { op: "upload", file: r.name } }), !0;
      }
    }
    const Lo = $(0), Do = $(!1);
    function pm(r) {
      const s = r.dataTransfer;
      if (!s || s.types && s.types.includes(mle) || Tc()) return !1;
      if (s.items && s.items.length > 0) {
        let g = !1;
        for (const M of Array.from(s.items))
          if (M.kind === "file") {
            g = !0;
            break;
          }
        return g;
      }
      return s.types ? s.types.includes("Files") : !1;
    }
    function kz(r) {
      pm(r) && (r.preventDefault(), Lo.value++, Do.value = !0);
    }
    function wz() {
      Lo.value = Math.max(0, Lo.value - 1), Lo.value === 0 && (Do.value = !1);
    }
    function _z(r) {
      if (ti(r)) {
        r.preventDefault();
        return;
      }
      pm(r) && r.preventDefault();
    }
    function xz(r) {
      if (ti(r)) {
        const g = xy(r) || "", M = Rt(Xe.value), F = If(r);
        if (F && g && M && g !== M && !Ft.value && li.value) {
          r.preventDefault(), Lo.value = 0, Do.value = !1, zr(), Os(), Rs(F.map((X) => X.path), M, g);
          return;
        }
      }
      if (ti(r)) {
        Lo.value = 0, Do.value = !1, zr(), Os();
        return;
      }
      if (!pm(r)) {
        Lo.value = 0, Do.value = !1;
        return;
      }
      if (r.preventDefault(), Lo.value = 0, Do.value = !1, !li.value) {
        tt(_("toast.read_only_here"));
        return;
      }
      const s = Nae(r.dataTransfer);
      s.length !== 0 && bz(s, Rt(Xe.value));
    }
    function Rk(r) {
      var s;
      (s = r.dataTransfer) != null && s.types.includes("Files") && r.preventDefault();
    }
    function Ik(r) {
      const s = Tn.value, g = r.target;
      s && g && !s.contains(g) && r.preventDefault();
    }
    jt(() => {
      var r, s;
      window.addEventListener("dragover", Rk), window.addEventListener("drop", Ik), window.addEventListener("pointerup", Ud), window.addEventListener("blur", Ud), (s = (r = fi.value) == null ? void 0 : r.onProgress) == null || s.call(r, (g) => {
        var F;
        if (!g) return;
        const M = Rq(g, { quiet: vm, stoppable: !!((F = fi.value) != null && F.stop), t: _ });
        if (M) {
          if (M.kind === "flash") {
            const X = g.error && g.error !== "cancelled" ? yn : hi;
            V0(ma.value, "drag-out", "end") ? ($s = null, qt({ message: M.message, source: "drag-out" }, X)) : $s = { message: M.message, ms: X };
            return;
          }
          V0(ma.value, "drag-out", "hold") && ($s = null, qt(
            M.stoppable ? {
              message: M.message,
              actionLabel: _("dragout.stop"),
              action: () => {
                var X, de;
                return (de = (X = fi.value) == null ? void 0 : X.stop) == null ? void 0 : de.call(X);
              },
              after: { kind: "plain", running: _("dragout.stopping"), done: _("dragout.stopped") },
              source: "drag-out"
            } : { message: M.message, source: "drag-out" },
            wf
          ));
        }
      });
    });
    function Ud() {
      Tc() && zr();
    }
    function Os() {
      var r;
      (r = fi.value) != null && r.cancel && Promise.resolve(fi.value.cancel()).catch(() => {
      });
    }
    Tt(() => {
      window.removeEventListener("dragover", Rk), window.removeEventListener("drop", Ik), window.removeEventListener("hashchange", xk), window.removeEventListener("pointerup", Ud), window.removeEventListener("blur", Ud);
    });
    const hm = E(() => {
      const r = new Set(Me.value.mode === "cut" ? Me.value.items.map((s) => s.path) : []);
      if (Ft.value && Ps.value.size)
        for (const s of G.value) {
          const g = s.id;
          typeof g == "number" && Ps.value.has(g) && r.add(s.path);
        }
      return r;
    });
    function Nk(r, s, g) {
      (r === "split" ? qn : le).click(s.path, g);
    }
    function Bk(r, s, g) {
      var Se;
      if (!g.dataTransfer) return;
      if (s.basename === ".trash") {
        g.preventDefault();
        return;
      }
      const M = r === "split" ? qn.nodes.value : le.nodes.value, F = Rt(r === "split" ? ((Se = Zt.value) == null ? void 0 : Se.getPath()) ?? "" : Xe.value), de = (M.some(($e) => $e.path === s.path) ? M : [s]).filter(($e) => !hm.value.has($e.path)).filter(($e) => $e.basename !== ".trash");
      de.length !== 0 && Fk(g, de, F, s.mime_type, _m(r));
    }
    function Fk(r, s, g, M, F) {
      const X = h0(s, { inEncryptedFolder: F });
      if (X) {
        if (fi.value) {
          r.preventDefault(), g !== null && Mq(X, g), Promise.resolve(fi.value.start(X)).catch((de) => {
            zr(), Os(), R("error", { message: de.message, context: { op: "drag-out" } });
          }), Wk(X);
          return;
        }
        if (X.length === 1 && X[0] && r.dataTransfer) {
          const de = X[0], Se = dv(P.config.auth) ? j.downloadUrl(de.path) : Hk.take(de.path), $e = Se ? Oq(de, Se, M) : null;
          $e && r.dataTransfer.setData("DownloadURL", $e);
        }
      }
    }
    const Uk = $(!0), Hk = Dq((r) => Oae(j, r), {
      onUnsupported: () => {
        Uk.value = !1;
      }
    }), Kk = E(() => !fi.value && !dv(P.config.auth));
    function Vk(r) {
      !r || !Kk.value || Kt.value || Hk.warm(r);
    }
    function Hd(r) {
      if (r.pointerType === "touch" || !Kk.value) return;
      const s = r.target, g = s && typeof s.closest == "function" ? s.closest("[data-fe-path]") : null, M = g == null ? void 0 : g.getAttribute("data-fe-path");
      if (!M) return;
      const F = G.value.find((X) => X.path === M) ?? xu.value.find((X) => X.path === M);
      F && m0(F) && Vk(F.path);
    }
    jt(() => {
      var r, s;
      (r = Tn.value) == null || r.addEventListener("pointerover", Hd, { passive: !0 }), (s = Tn.value) == null || s.addEventListener("pointerdown", Hd, { capture: !0, passive: !0 });
    }), Tt(() => {
      var r, s;
      (r = Tn.value) == null || r.removeEventListener("pointerover", Hd), (s = Tn.value) == null || s.removeEventListener("pointerdown", Hd, { capture: !0 });
    });
    const fi = E(() => P.config.dragOut ?? null), jk = $(""), mm = $(!1);
    let vm = !1, qk;
    Je(
      () => le.selected.value,
      () => {
        if (!fi.value) return;
        clearTimeout(qk);
        const r = le.nodes.value;
        if (r.length === 0 || r.length > yle || r.some((M) => M.type !== "file")) return;
        const s = h0(r, { inEncryptedFolder: an.value });
        !s || r.reduce((M, F) => M + (F.size ?? 0), 0) > vle || (qk = setTimeout(() => void Wk(s, !0), 400));
      },
      { deep: !0 }
    );
    async function Wk(r, s = !1) {
      const g = fi.value;
      if (!g || mm.value) return;
      const M = Lq(r);
      if (M !== jk.value) {
        mm.value = !0, vm = s;
        try {
          const F = await g.prepare(r);
          F != null && F.ready ? (jk.value = M, s || tt(_("dragout.ready"))) : F != null && F.error && !s && tt(F.error);
        } catch (F) {
          R("error", { message: F.message, context: { op: "drag-out-prepare" } });
        } finally {
          mm.value = !1, vm = !1;
        }
      }
    }
    async function Sz(r, s, g, M) {
      try {
        const F = M ?? Rt(Xe.value), X = await Om("move", r, s, F);
        if (X)
          return X.undo && X.ops.length && me.set(X.ops[X.ops.length - 1].id, { message: _("toast.moved"), fn: X.undo }), X.ops.length && tt(_("split.move_queued")), le.clear(), "queued";
        const de = await gk(r, s);
        if (j.endpoints.moveAsync) {
          const { op: Se } = await j.moveAsync(r, s, F);
          bk(Se.id, r, s, F, de), De.register(Se), tt(_(de ? "toast.move_kept_both" : "split.move_queued"));
        } else if (await j.move(F, r, s), await wt(), de)
          tt(_("toast.move_kept_both"));
        else {
          const Se = r.map(($e) => ja(s, Mi($e)));
          $d(_("toast.moved"), async () => {
            await j.move(s, Se, F);
          });
        }
        return le.clear(), j.endpoints.moveAsync ? "queued" : "done";
      } catch (F) {
        return ql(F, { op: g, targetDir: s }), "refused";
      }
    }
    async function Yk(r, s) {
      if (r.type !== "dir") return;
      const g = If(s);
      if (!g || g.length === 0) return;
      zr(), Os();
      const M = r.path, F = g.map((X) => X.path).filter((X) => X && X !== M && !M.startsWith(X + "/") && !Yh(oo(X), M));
      F.length !== 0 && await Rs(F, M, vw(s));
    }
    async function Gk(r, s) {
      const g = If(s);
      if (!g || g.length === 0) return;
      zr(), Os();
      const M = r, F = g.map((X) => X.path).filter((X) => X && X !== M && !M.startsWith(X + "/") && !Yh(oo(X), M));
      F.length !== 0 && await Rs(F, M, vw(s));
    }
    function $z(r) {
      r.cancel();
    }
    function Tz(r) {
      jn.value = jn.value.filter((s) => s.id !== r.id);
    }
    function Az(r) {
      if (Sn.value && !r) {
        wt("");
        return;
      }
      if (Sn.value) {
        wt(Co(r));
        return;
      }
      wt(Va(r));
    }
    async function Kd(r) {
      try {
        await navigator.clipboard.writeText(r), tt(_("breadcrumb.copy_path"));
      } catch {
      }
    }
    function Qn(r = {}) {
      return j.authHeaders({ ...r });
    }
    function Xk(r) {
      if (/^[a-z][a-z0-9+.-]*:\/\//i.test(r)) return r;
      const s = P.config.apiBase;
      if (!s) return r;
      try {
        return new URL(r, s.endsWith("/") ? s : `${s}/`).toString();
      } catch {
        return r;
      }
    }
    const Jk = E(
      () => P.config.viewerBaseUrl ? Xk(P.config.viewerBaseUrl) : Ly(P.config.apiBase, gle)
    ), Vd = $(!1), { themeId: jd, setTheme: Ez } = sZ(), { themeMode: ku, setThemeMode: Zk } = uZ(), wn = E(
      () => ku.value === "host" ? P.config.theme || "auto" : ku.value
    );
    z5({ locale: H, theme: wn });
    const Cz = Il(), ym = E(
      () => wn.value === "dark" || wn.value !== "light" && Cz.value
    );
    Je(
      [jd, ym, Tn],
      () => {
        mZ(jd.value), Tn.value && cZ(Tn.value, jd.value, ym.value);
      },
      { immediate: !0 }
    );
    const wu = $(!1), ro = $(!1), Li = $(null);
    function zz() {
      if (ro.value) {
        ro.value = !1;
        return;
      }
      const r = le.nodes.value, s = r.length === 1 ? r[0] : null;
      if (!(!s || s.type !== "file" || s.basename === ".trash")) {
        if (Ui(s) && !an.value && !s.e2e_root) {
          Mt.open(s);
          return;
        }
        if (an.value) {
          if (!Yn.value) return;
          (async () => {
            try {
              await ef(s);
            } catch {
              tt(_("e2e.decrypt_failed"));
              return;
            }
            Li.value = s, ro.value = !0, Ua(s);
          })();
          return;
        }
        Li.value = s, ro.value = !0, Ua(s);
      }
    }
    function Mz(r) {
      const s = G.value.filter((X) => X.type === "file");
      if (s.length === 0) return;
      const g = Li.value;
      let M = g ? s.findIndex((X) => X.path === g.path) : -1;
      M = M === -1 ? r > 0 ? 0 : s.length - 1 : (M + r + s.length) % s.length;
      const F = s[M];
      !F || F.path === (g == null ? void 0 : g.path) || le.click(F.path);
    }
    function Pz() {
      const r = Li.value;
      ro.value = !1, r && qa(r);
    }
    Je(
      () => le.nodes.value,
      (r) => {
        var g, M;
        if (!ro.value) return;
        const s = r.length === 1 && r[0].type === "file" ? r[0] : null;
        if (s && s.path !== ((g = Li.value) == null ? void 0 : g.path) && Yn.value) {
          (async () => {
            try {
              await ef(s);
            } catch {
            }
            Li.value = s, Ua(s);
          })();
          return;
        }
        s && s.path !== ((M = Li.value) == null ? void 0 : M.path) && (Li.value = s, Ua(s));
      }
    );
    const _u = wQ();
    function Oz(r) {
      jn.value = jn.value.filter((M) => M.id !== r.id);
      const s = r.file, g = r.path || Rt(Xe.value);
      (async () => {
        if (xe.shouldChunk(s) && await fm(s, g)) {
          await wt();
          return;
        }
        await Dk(s, g), await wt();
      })();
    }
    const qd = $(!1);
    let Wd;
    function gm() {
      qd.value = !0;
    }
    function Lz() {
      var r;
      qd.value = !1, UT(), (r = Tn.value) == null || r.focus();
    }
    function Qk() {
      gm();
    }
    jt(() => {
      var r;
      (r = Tn.value) == null || r.addEventListener("fe:tour-restart", Qk), Wd = $Q(() => {
        qd.value || gm();
      });
    }), Tt(() => {
      var r;
      Wd == null || Wd(), (r = Tn.value) == null || r.removeEventListener("fe:tour-restart", Qk);
    });
    function Dz() {
      return Pd() === "none" ? null : ft ? `${i2}:${ft}` : i2;
    }
    const Hn = vne({ storageKey: Dz() }), Rz = Hn.restore(), bm = Hn.activeId, so = E(() => {
      var r;
      return ((r = Hn.activeTab.value) == null ? void 0 : r.split) ?? null;
    });
    function Iz(r) {
      const s = (r || "").replace(/^\/+|\/+$/g, ""), g = cp(s.split("/").pop() || s, _);
      if (g) return g;
      if (!s) return Sn.value ? _("breadcrumb.root") : ie.value || _("breadcrumb.root");
      const M = Vt.segmentLabel(Rt(s));
      return M !== null ? M : s.split("/").pop() || s;
    }
    const ew = E(
      () => Hn.tabs.value.map((r) => ({ id: r.id, label: Iz(r.path), split: !!r.split }))
    ), tw = E(
      () => (
        /* gezinti:g1 — the simple profile has no tab strip at all, not even once a
           second tab exists: tabs were the first thing #14 named as power-user
           chrome. The tab STATE is untouched, so switching the profile back brings
           the strip and its tabs straight back. */
        !nu.value && (Hn.hasMultiple.value || P.config.tabStrip !== "auto" && ew.value.length > 0)
      )
    );
    Je(Xe, (r) => Hn.syncActive({ path: r })), Je(Pe, (r) => Hn.syncActive({ viewMode: r })), jt(() => {
      Rz || Hn.seed(Xe.value ?? "", Pe.value);
    });
    function Yd(r) {
      !fn.value && r.viewMode && r.viewMode !== Pe.value && (Pe.value = r.viewMode);
      const s = () => Mn(mn.value);
      if (r.path === ".trash") {
        zi().then(s, s);
        return;
      }
      wt(r.path).then(s, s);
    }
    function Nz(r) {
      const s = Hn.activate(r);
      s && Yd(s);
    }
    function km() {
      Hn.openTab(Xe.value ?? "", { viewMode: Pe.value, background: !1 });
    }
    function nw(r) {
      const s = Hn.closeTab(r);
      s && Yd(s);
    }
    function Bz() {
      const r = Hn.step(1);
      r && Yd(r);
    }
    function Fz() {
      const r = Hn.step(-1);
      r && Yd(r);
    }
    function aw(r) {
      if (r.type !== "dir" || r.basename === ".trash") return;
      const s = Sn.value ? Co(r.path) : Va(r.path);
      Hn.openTab(s, { viewMode: Pe.value, background: !0 });
    }
    function iw(r) {
      if (r.button !== 1) return;
      const s = r.target, g = s && typeof s.closest == "function" ? s.closest("[data-fe-path]") : null, M = g == null ? void 0 : g.getAttribute("data-fe-path");
      if (!M) return;
      const F = G.value.find((X) => X.path === M);
      !F || F.type !== "dir" || F.basename === ".trash" || (r.preventDefault(), aw(F));
    }
    function ow(r) {
      if (r.button !== 1) return;
      const s = r.target;
      s && typeof s.closest == "function" && s.closest("[data-fe-path]") && r.preventDefault();
    }
    jt(() => {
      var r, s;
      (r = Tn.value) == null || r.addEventListener("auxclick", iw), (s = Tn.value) == null || s.addEventListener("mousedown", ow);
    }), Tt(() => {
      var r, s;
      (r = Tn.value) == null || r.removeEventListener("auxclick", iw), (s = Tn.value) == null || s.removeEventListener("mousedown", ow);
    });
    const Uz = $(null), Zt = $(null), xu = $([]), qn = S_(
      () => {
        var r;
        return xu.value.length ? xu.value : ((r = Zt.value) == null ? void 0 : r.visibleNodes()) ?? [];
      }
    ), Su = $({ ...jo }), Hz = E(() => {
      var F;
      if (!fn.value) return "";
      const r = String(((F = Zt.value) == null ? void 0 : F.getPath()) ?? "").replace(/^\/+|\/+$/g, "");
      if (!r) return "";
      const [s, ...g] = r.split("/"), M = (P.config.storages ?? []).find((X) => X.name === s);
      return Z_((M == null ? void 0 : M.uid) || s, g.join("/"));
    }), Kz = E(
      () => tw.value || Rb.value || $u.value
    ), Gd = E(() => bt.value === "home" ? "home" : bt.value === "drafts" ? "drafts" : ot.value && G.value.length === 0 ? "" : Ce.value ? "notfound" : Ne.value && G.value.length === 0 ? "" : Au.value ? "locked" : ""), $u = E(() => !$a.value && !nu.value), Ls = E(
      () => !!so.value && $u.value
      /* gezinti:g1 */
    );
    function rw() {
      if (so.value) {
        Hn.setSplit(null), pi.value = "main";
        return;
      }
      $u.value && Hn.setSplit({ path: Xe.value ?? "", viewMode: Pe.value });
    }
    function Vz() {
      Hn.setSplit(null), pi.value = "main";
    }
    function jz(r) {
      Hn.setSplit({ ...so.value ?? {}, path: r }), al(Su.value) && (Su.value = { ...jo }), qn.clear(), xu.value = [];
    }
    function qz(r, s) {
      var g;
      if (s.type === "dir" && s.basename !== ".trash") {
        (g = Zt.value) == null || g.loadFolder(
          /* A multi-storage drive row's path is already the wire form for that
             storage's root; a real row needs converting. The predicate comes from
             `lib/fileIcons`, which is that concept's one home. */
          xi(s) === "storage" ? s.path : Di(s.path)
        );
        return;
      }
      qa(s);
    }
    function Wz() {
      pi.value = "main", zi();
    }
    const sw = E(() => {
      var r;
      return ((r = so.value) == null ? void 0 : r.viewMode) ?? Pe.value;
    });
    function lw(r) {
      so.value && Hn.setSplit({ ...so.value, viewMode: r });
    }
    const wm = E(
      () => An.value ? sw.value : Pe.value
    );
    function uw(r) {
      An.value ? lw(r) : Pe.value = r;
    }
    const pi = $("main");
    function Yz() {
      pi.value = "main";
    }
    Je(Ls, (r) => {
      r || (pi.value = "main");
    });
    const An = E(() => pi.value === "split" && Ls.value), Gz = E(() => Ls.value && pi.value === "main"), Xd = E(() => An.value ? "split" : "main"), Ds = $(null);
    function _m(r) {
      var s;
      return r === "split" ? !!((s = Zt.value) != null && s.e2eRoot()) : an.value;
    }
    const cw = E(
      () => {
        var r;
        return An.value ? ((r = Zt.value) == null ? void 0 : r.getPath()) ?? "" : Xe.value ?? "";
      }
    );
    function Xz(r) {
      var s;
      return r === "split" ? ((s = Zt.value) == null ? void 0 : s.getPath()) ?? "" : Xe.value ?? "";
    }
    function Jz(r) {
      var s;
      return r === "split" ? ((s = Zt.value) == null ? void 0 : s.rowPaths()) ?? [] : G.value.map((g) => g.path);
    }
    Je(
      () => ia(),
      (r) => {
        r.length && (Ds.value = {
          nodes: r,
          pane: Xd.value,
          path: cw.value,
          // Where the item was when it was selected: a held item keeps the
          // folder it came from, whatever folder the pane shows now.
          inEncrypted: _m(Xd.value)
        });
      },
      { deep: !1 }
    );
    const Jd = E(() => {
      const r = Ds.value;
      if (!r || !r.nodes.length || r.pane === "split" && !Ls.value) return !1;
      if (Xz(r.pane) !== r.path) return !0;
      const s = new Set(Jz(r.pane));
      return r.nodes.some((g) => s.has(g.path));
    });
    Je(Jd, (r) => {
      r || (Ds.value = null);
    });
    const Zz = E(() => ia().length === 0 && Jd.value), dw = E(() => {
      var s;
      const r = ia();
      return r.length ? r : Jd.value ? ((s = Ds.value) == null ? void 0 : s.nodes) ?? [] : [];
    }), Qz = E(() => {
      const r = dw.value;
      return r.length === 1 && he.value ? Bd([r[0].path]) : void 0;
    }), eM = E(
      () => {
        var r;
        return ia().length ? _m(Xd.value) : Jd.value && ((r = Ds.value) == null ? void 0 : r.inEncrypted) === !0;
      }
    ), tM = E(
      () => {
        var r;
        return Zz.value ? Rh(((r = Ds.value) == null ? void 0 : r.path) ?? "") : "";
      }
    ), nM = E(() => Rh(cw.value)), aM = E(
      () => {
        var r;
        return An.value ? ((r = Zt.value) == null ? void 0 : r.rowCount()) ?? 0 : G.value.length;
      }
    ), iM = E(
      () => {
        var r;
        return An.value ? ((r = Zt.value) == null ? void 0 : r.dirPerm()) ?? "" : ye.value;
      }
    );
    function Di(r) {
      return Sn.value ? Co(r) : Va(r);
    }
    function fw(r) {
      const s = String(r ?? "").replace(/^\/+|\/+$/g, "");
      return gt && (!s || !(s === gt || s.startsWith(gt + "/"))) ? gt : s;
    }
    function pw() {
      var s;
      const r = qn.nodes.value;
      r.length !== 0 && (Me.value = { mode: "cut", items: r, sourcePath: ((s = Zt.value) == null ? void 0 : s.getPath()) ?? "" }, tt(_("toast.cut")));
    }
    function hw() {
      var s;
      const r = qn.nodes.value;
      r.length !== 0 && (Me.value = { mode: "copy", items: r, sourcePath: ((s = Zt.value) == null ? void 0 : s.getPath()) ?? "" }, tt(_("toast.copied")));
    }
    async function mw() {
      const r = Me.value, s = Zt.value;
      if (!r.mode || r.items.length === 0 || !s) return;
      const g = Rt(s.getPath() ?? ""), M = Rt(r.sourcePath || "") || void 0;
      if (r.mode === "cut" && M === g) {
        tt(_("toast.same_folder_cut"));
        return;
      }
      await Rs(r.items.map((F) => F.path), g, M, r.mode === "copy" ? "copy" : "move"), Me.value = { mode: null, items: [], sourcePath: null };
    }
    function vw(r) {
      return xy(r);
    }
    async function Rs(r, s, g, M = "auto") {
      var $e, ut, et;
      const F = r.filter(
        (Pt) => Pt && Pt !== s && !s.startsWith(Pt + "/") && !Yh(oo(Pt), s)
      );
      if (F.length === 0 || !s) return "nothing";
      const X = $w(F, s);
      if (X === "cross")
        return tt(_("e2e.vault.cross")), "refused";
      if (X === "inside") {
        const Pt = M === "copy" ? await I.copy(F, s) : await I.move(F, s);
        return ($e = Zt.value) == null || $e.reload(), Pt ? "done" : "refused";
      }
      const de = U0(F, s, M);
      let Se;
      if (de.kind === "copy")
        try {
          if (await Om("copy", F, s))
            return tt(_("split.copy_queued")), (ut = Zt.value) == null || ut.reload(), "queued";
          const { op: En } = await j.copy(F, s);
          De.register(En), tt(de.cross ? _("split.cross_copy") : _("split.copy_queued")), Se = "queued";
        } catch (Pt) {
          return ql(Pt, { op: "transfer", targetWire: s }), "refused";
        }
      else
        de.cross && tt(_("split.cross_move")), Se = await Sz(F, s, "move-transfer", g);
      return (et = Zt.value) == null || et.reload(), Se;
    }
    function yw(r) {
      Rs(r.sources, r.targetWire, r.originWire);
    }
    const sn = W4(), Wn = $(0), gw = /* @__PURE__ */ new WeakMap(), Mt = dae({
      api: j,
      chunked: xe,
      locale: () => H.value,
      t: (r, s) => _(r, s),
      toast: (r, s) => qt({ message: r }, s ? yn : hi),
      emitError: (r, s) => R("error", { message: r, context: { op: s } }),
      escrowPublicKey: () => _r.value,
      escrowKid: () => Wa.value,
      registerOp: (r) => De.register(r),
      reload: () => wt(),
      openPreview: (r, s) => {
        lo.set(r.path, s), Ha.value = "view", pn.value = r, la.value = !0, R("file-opened", { path: r.path, basename: r.basename }), r.fxe_name && (G.value = G.value.map((g) => g.path === r.path ? { ...g, fxe_name: r.fxe_name } : g));
      },
      showRecoveryKey: (r, s) => {
        Io.value = r, No.value = s, kr.value = "file", Ro.value = !0;
      },
      /* wiring:e2 policy — "Request encryption…" on a plain file. */
      requestEncrypt: (r) => Sm(r.path, "file", r.basename)
    }), Tu = E(() => {
      var r;
      return !!((r = pn.value) != null && r.fxe_name);
    }), Vt = V5({
      api: j,
      ring: sn,
      lockedLabel: () => _("e2e.names.locked_item"),
      unreadableLabel: () => _("e2e.names.unreadable_item"),
      fileName: (r) => Mt.realName(r)
    });
    Wo(jc, Vt);
    const oM = _ne((r, s) => {
      Vt.version.value;
      const g = Vt.rootOf(r, s);
      if (!g || !sn.names(g)) return null;
      const M = Vt.segmentLabel(r);
      return !M || M === "…" ? null : { name: M, path: Vt.displayPath(r) };
    });
    Tt(oM);
    const vr = /* @__PURE__ */ new WeakMap(), bw = $([]), Ct = $(""), lo = /* @__PURE__ */ new Map(), an = E(() => !!Ct.value && !Ft.value), Yn = E(() => (Wn.value, an.value && sn.has(Ct.value))), Au = E(() => (Wn.value, an.value && !sn.has(Ct.value))), Zd = $(!1), xm = $(""), yr = $(!1), gr = $(!1), kw = E(
      () => sa.value && !an.value && li.value ? Hh(Rt(Xe.value), "new_folder") : "denied"
    ), br = $(null);
    function Sm(r, s, g) {
      br.value = { path: r, kind: s, name: g };
    }
    function rM() {
      sa.value = !1, Sm(Rt(Xe.value), "new_folder", Rh(Xe.value));
    }
    function sM(r) {
      br.value = null, tt(r.created ? _("e2e.request.sent") : _("e2e.request.already"));
    }
    const on = $(null), Qd = $(!1), $m = $(!1), uo = $(null), Ro = $(!1), Io = $(""), kr = $("created"), No = $(""), Is = $(!1), wr = $(""), Eu = $(!1), Bo = $(!1), Cu = $("unlock"), Ri = $(""), Ii = $(!1), Ni = $(""), _r = E(
      () => {
        var r, s;
        return ((s = (r = Ve.value) == null ? void 0 : r.e2e_escrow) == null ? void 0 : s.public_key) || null;
      }
    ), Wa = E(
      () => {
        var r, s;
        return ((s = (r = Ve.value) == null ? void 0 : r.e2e_escrow) == null ? void 0 : s.kid) || null;
      }
    );
    function Tm() {
      return sn.get(Ct.value) ?? null;
    }
    function Am() {
      for (const r of lo.values()) URL.revokeObjectURL(r);
      lo.clear();
    }
    Tt(Am);
    async function ww(r, s) {
      var Se;
      let g = "";
      try {
        const { blob: $e, url: ut } = await j.fetchBlob(ja(r, ga), { fresh: !0 });
        URL.revokeObjectURL(ut), g = await $e.text();
      } catch {
        return _("e2e.unlock.marker_missing");
      }
      const M = lp(g);
      if (!M) return _("e2e.unlock.marker_missing");
      const F = r === Ct.value;
      if (M.unsupported.length > 0)
        return F && (bw.value = M.unsupported), _("e2e.unlock.unsupported", { features: M.unsupported.join(", ") });
      const X = M.marker;
      F && (on.value = X);
      const de = await cS(X, s);
      return "error" in de ? de.error === "damaged" ? _("e2e.unlock.damaged") : _("e2e.unlock.wrong") : await _w(r, X, de.fmk) ? (F && (X.v === 1 ? (wr.value = s, Is.value = !0) : W_(X, Wa.value) === "offer" && (Ri.value = s, Cu.value = "unlock", Ni.value = "", Bo.value = !0)), F && await wt(), (Se = Zt.value) == null || Se.reload(), null) : qr(X) ? _("e2e.vault.open_failed") : _("e2e.names.key_failed");
    }
    async function lM(r) {
      if (!(!r || Zd.value || !Ct.value)) {
        Zd.value = !0, xm.value = "";
        try {
          const s = await ww(Ct.value, r);
          s && (xm.value = s);
        } finally {
          Zd.value = !1;
        }
      }
    }
    Wo(HT, {
      locked: (r) => (Wn.value, !sn.has(r)),
      unlock: ww,
      recovery: (r) => {
        pi.value = "main", wt(Di(r)).then(() => {
          Ct.value === r && Ew();
        });
      }
    });
    async function _w(r, s, g) {
      if (qr(s)) {
        sn.set(r, g, null, null), Vt.setMarker(r, s), Wn.value++, a().catch(() => {
        });
        try {
          await I.open(r, s, g, { perm: r === Ct.value && ye.value || void 0 });
        } catch (X) {
          return sn.lock(r), Wn.value++, R("error", { message: (X == null ? void 0 : X.message) ?? String(X), context: { op: "e2e-vault-open" } }), !1;
        }
        return !0;
      }
      let M = null;
      if (qi(s) && (M = await R4(s, g), !M))
        return !1;
      let F = null;
      return fl(s) && (F = await H4(s, g), !F) ? !1 : (sn.set(r, g, M, F), Vt.setMarker(r, s), Wn.value++, !0);
    }
    function Em() {
      if (!Ct.value) return;
      const r = Ct.value;
      I.isOpen(r) && I.close(r, "manual"), sn.lock(r), Vt.forget(r), Wn.value++, Am();
      const s = Aw(r);
      Bi.value = !1, Hs = null, Us.value = !1, s ? qt({ message: s }, yn) : tt(_("e2e.locked_toast")), wt();
    }
    function xw(r) {
      return il(r.extension);
    }
    async function ef(r) {
      const s = lo.get(r.path);
      if (s) return s;
      if (I.isVaultRow(r)) {
        const de = await I.readUrl(r.path, xw(r));
        return lo.set(r.path, de), de;
      }
      const g = Tm();
      if (!g) return null;
      const M = await j.fetchArrayBuffer(r.path);
      if (!Tl(M)) return null;
      const F = await q4(g, sn.previous(Ct.value), M), X = URL.createObjectURL(new Blob([F], { type: xw(r) }));
      return lo.set(r.path, X), X;
    }
    function tf(r) {
      return lo.get(r) ?? j.previewUrl(r);
    }
    async function Ns(r) {
      try {
        await ef(r);
      } catch {
        tt(_("e2e.decrypt_failed"));
        return;
      }
      Ha.value = "view", $i.value = bo, pn.value = r, la.value = !0, R("file-opened", { path: r.path, basename: r.basename }), Ua(r);
    }
    const uM = VU(
      (r) => {
        const s = Vt.rootOf(r, an.value ? Ct.value : null), g = s ? sn.get(s) : void 0;
        return s && g ? { fmk: g, previous: sn.previous(s) ?? null } : null;
      },
      /* a vault's file: the vault engine reads and writes it (useE2eVault). */
      qU(I)
    ), zu = $(!1);
    function cM(r) {
      zu.value = r;
      const s = pn.value;
      r && s && I.isVaultRow(s) && I.touch(s.path), r || Sw();
    }
    Je(la, (r) => {
      r || (zu.value = !1, Sw());
    });
    let Mu = null;
    function dM(r, s) {
      const g = pn.value;
      if (!la.value || !g || !nl(g.path, r) || !zu.value || !s.app_lock_soon || !s.app_lock_soon_keep) return;
      const M = s.app_lock_kept || s.app_lock_soon_keep;
      Mu = {
        message: s.app_lock_soon,
        actionLabel: s.app_lock_soon_keep,
        action: () => I.touch(r),
        after: { kind: "plain", running: M, done: M }
      }, qt(Mu, kle);
    }
    function Sw() {
      var r;
      Mu && ((r = ma.value) == null ? void 0 : r.message) === Mu.message && jh(), Mu = null;
    }
    const fM = E(() => gb.value && fh(pn.value) ? uM : null);
    async function pM(r) {
      if (I.isVaultRow(r)) {
        await I.download([r]);
        return;
      }
      const s = Tm();
      if (!s) {
        tt(_("e2e.download.failed"));
        return;
      }
      await Mt.downloadFolderFile(r, s, sn.previous(Ct.value), Ct.value);
    }
    async function hM(r, s) {
      const g = Tm();
      if (!g) return { files: [], sidecars: [] };
      const M = [], F = [];
      await Pm(s);
      const X = !!Vt.writesEncrypted(s);
      for (const de of r)
        if (de.name !== ga) {
          if (X && Gi(de.name)) {
            tt(_("e2e.names.bad_name", { name: de.name }));
            continue;
          }
          try {
            const Se = de.size > ec ? await Mt.folderUploadSource(de, g) : null, $e = Se ? null : await ay(g, await de.arrayBuffer());
            let ut = de.name;
            if (X) {
              const Pt = await Vt.nameForWrite(s, de.name);
              if (!Pt) throw new Error("e2e: the folder name key is missing");
              ut = Pt.stored, Pt.sidecar && F.push(new File([Pt.sidecar.content], Pt.sidecar.name, { type: "text/plain" }));
            }
            const et = new File($e ? [$e] : [], ut, { type: "application/octet-stream" });
            Se && gw.set(et, Se), X && vr.set(et, de.name), M.push(et);
          } catch (Se) {
            R("error", { message: Se.message, context: { op: "e2e-encrypt" } });
          }
        }
      return { files: M, sidecars: F };
    }
    async function mM(r) {
      if (an.value) {
        tt(_("e2e.create.nested"));
        return;
      }
      if (r.level === "vault") {
        await vM(r);
        return;
      }
      gr.value = !0;
      let s = !1;
      try {
        const g = Rt(Xe.value);
        await j.newFolder(g, r.name), s = !0;
        const { marker: M, fmk: F, recoveryKey: X, names: de } = await ny(r.password, {
          escrowPublicKey: _r.value,
          encryptNames: r.level === "names"
        }), Se = new File([JSON.stringify(M)], ga, {
          type: "application/json"
        }), $e = ja(g, r.name);
        await j.uploadMultipart($e, [Se]), sn.set($e, F, de ?? null), Vt.setMarker($e, M), Wn.value++, yr.value = !1, Io.value = X, No.value = r.name, kr.value = "created", Ro.value = !0, await wt();
      } catch (g) {
        R("error", { message: g.message, context: { op: "e2e-create" } }), qt({ message: Zn(g, _("e2e.create.failed")) }, yn), s && await wt();
      } finally {
        gr.value = !1;
      }
    }
    async function vM(r) {
      var s;
      if (((s = Ve.value) == null ? void 0 : s.e2e_vault) !== !0) {
        qt({ message: _("e2e.create.failed") }, yn);
        return;
      }
      gr.value = !0;
      try {
        const g = Rt(Xe.value), M = ja(g, r.name), F = await z4(r.password, {
          escrowPublicKey: _r.value,
          packLog2: r.packLog2
        });
        await I.create(M, F.marker, F.index), sn.set(M, F.fmk, null, null), Vt.setMarker(M, F.marker), Wn.value++, a().catch(() => {
        }), await I.open(M, F.marker, F.fmk, { justMade: !0, perm: ye.value || void 0 }), yr.value = !1, Io.value = F.recoveryKey, No.value = r.name, kr.value = "created", Ro.value = !0, await wt();
      } catch (g) {
        R("error", { message: g.message, context: { op: "e2e-vault-create" } }), qt({ message: Zn(g, _("e2e.create.failed")) }, yn);
      } finally {
        gr.value = !1;
      }
    }
    function $w(r, s) {
      const g = I.rootOf(s), M = r.map((F) => I.rootOf(F));
      return !g && M.every((F) => !F) ? "none" : g && I.isOpen(g) && M.every((F) => F === g) ? "inside" : "cross";
    }
    const Cm = E(() => {
      I.version.value;
      const r = Ct.value;
      return r ? I.strips[r] ?? null : null;
    }), Pu = E(() => !!pn.value && I.isVaultRow(pn.value)), yM = E(() => [...le.nodes.value, ...Po.value].some((r) => I.isVaultRow(r)));
    function zm(r, s) {
      return !!r && (r === s || r.startsWith(s + "/"));
    }
    function Tw(r, s) {
      var g;
      for (const [M, F] of [...lo])
        zm(M, r) && ((s || M !== ((g = pn.value) == null ? void 0 : g.path)) && URL.revokeObjectURL(F), lo.delete(M));
    }
    let Mm = "";
    function Aw(r) {
      const s = pn.value;
      if (!la.value || !s || !nl(s.path, r)) return "";
      const g = zu.value;
      return la.value = !1, zu.value = !1, g ? _("e2e.app_closed_unsaved", { name: s.basename }) : "";
    }
    function gM(r) {
      var s;
      sn.lock(r), Vt.forget(r), Wn.value++, Mm = Aw(r), zm((s = Li.value) == null ? void 0 : s.path, r) && (ro.value = !1), Tw(r, !0);
    }
    function bM(r, s) {
      var M;
      const g = Mm;
      if (Mm = "", s === "idle") {
        const F = _("e2e.vault.locked_idle_toast", { name: Mi(r) });
        qt({ message: g ? `${F} ${g}` : F }, g ? 12e3 : 8e3);
      } else g && qt({ message: g }, yn);
      (Ct.value === r || zm(Rt(Xe.value), r)) && (Bi.value = !1, wt(Di(r))), (M = Zt.value) == null || M.reload();
    }
    function kM(r) {
      var s;
      Tw(r, !1), Ct.value === r && wt(), (s = Zt.value) == null || s.reload();
    }
    async function wM(r) {
      if (!(!on.value || !Ct.value)) {
        $m.value = !0, uo.value = null;
        try {
          let s = null;
          if (r.mode === "recovery") {
            if (s = await dS(on.value, r.value), !s) {
              uo.value = _("e2e.recover.wrong_recovery");
              return;
            }
          } else {
            let g;
            try {
              g = await aS(r.value);
            } catch {
              uo.value = _("e2e.recover.bad_escrow_key");
              return;
            }
            if (s = await fS(on.value, g), !s) {
              uo.value = _("e2e.recover.wrong_escrow");
              return;
            }
            try {
              const M = await j.e2eEscrowChallenge(Ct.value), F = new Uint8Array(
                await crypto.subtle.decrypt(
                  { name: "RSA-OAEP" },
                  g,
                  ea(M.challenge).buffer
                )
              );
              await j.e2eEscrowUsed({
                path: Ct.value,
                id: M.id,
                nonce: Ma(F)
              });
            } catch (M) {
              uo.value = _("e2e.recover.notify_failed"), R("error", {
                message: M.message,
                context: { op: "e2e-escrow-notify" }
              });
              return;
            }
          }
          if (!await _w(Ct.value, on.value, s)) {
            uo.value = _("e2e.names.key_failed");
            return;
          }
          Qd.value = !1, tt(
            r.mode === "escrow" ? _("e2e.recover.escrow_done") : _("e2e.recover.recovery_done")
          ), await wt(), r.mode === "recovery" && (Hs = r.value, Nw("reset"));
        } catch (s) {
          uo.value = s.message;
        } finally {
          $m.value = !1;
        }
      }
    }
    async function Ew() {
      if (!on.value && Ct.value)
        try {
          const { blob: r, url: s } = await j.fetchBlob(ja(Ct.value, ga), { fresh: !0 });
          URL.revokeObjectURL(s);
          const g = lp(await r.text());
          on.value = g && g.unsupported.length === 0 ? g.marker : null;
        } catch {
          on.value = null;
        }
      uo.value = null, Qd.value = !0;
    }
    async function _M() {
      if (!(!on.value || !Ct.value || !wr.value)) {
        Eu.value = !0;
        try {
          const r = await M4(on.value, wr.value, {
            escrowPublicKey: _r.value
          }), s = new File([JSON.stringify(r.marker)], ga, {
            type: "application/json"
          });
          await j.uploadMultipart(Ct.value, [s]), on.value = r.marker, Vt.setMarker(Ct.value, r.marker), Is.value = !1, wr.value = "", Io.value = r.recoveryKey, No.value = Mi(Ct.value), kr.value = "upgraded", Ro.value = !0;
        } catch (r) {
          R("error", { message: r.message, context: { op: "e2e-upgrade" } }), tt(_("e2e.upgrade.failed"));
        } finally {
          Eu.value = !1;
        }
      }
    }
    const Cw = E(() => W_(on.value, Wa.value));
    function xM() {
      Cu.value = "manual", Ri.value = "", Ni.value = "", Bo.value = !0;
    }
    async function Fo(r) {
      const s = new File([JSON.stringify(r)], ga, { type: "application/json" });
      await j.uploadMultipart(Ct.value, [s]), on.value = r, Vt.setMarker(Ct.value, r);
    }
    async function zw() {
      const r = on.value, s = _r.value;
      if (!(!r || !s || !Ct.value || Ii.value)) {
        if (!Ri.value) {
          Ni.value = _("e2e.escrowoffer.password_required");
          return;
        }
        Ii.value = !0, Ni.value = "";
        try {
          const g = await P4(r, Ri.value, s);
          await Fo(g), Bo.value = !1, Ri.value = "", tt(_("e2e.escrowoffer.done"));
        } catch (g) {
          (g == null ? void 0 : g.name) === "E2eDecryptError" ? Ni.value = _("e2e.escrowoffer.wrong_password") : (Ni.value = _("e2e.escrowoffer.failed"), R("error", { message: g.message, context: { op: "e2e-escrow-offer" } }));
        } finally {
          Ii.value = !1;
        }
      }
    }
    async function SM() {
      const r = on.value;
      if (!(!r || !Ct.value || Ii.value)) {
        Ii.value = !0;
        try {
          await Fo(O4(r, (/* @__PURE__ */ new Date()).toISOString())), Bo.value = !1, Ri.value = "", tt(_("e2e.escrowoffer.declined_toast"));
        } catch (s) {
          Ni.value = _("e2e.escrowoffer.decline_failed"), R("error", { message: s.message, context: { op: "e2e-escrow-decline" } });
        } finally {
          Ii.value = !1;
        }
      }
    }
    function $M() {
      Bo.value = !1, Ri.value = "", Ni.value = "";
    }
    function TM() {
      Is.value = !1, wr.value = "";
    }
    class Mw extends Error {
      constructor(s) {
        super(`e2e: invalid name (${s})`), this.problem = s, this.name = "E2eNameRefused";
      }
    }
    async function Pw(r, s, g = {}) {
      if (await Pm(r), !Vt.writesEncrypted(r)) return s;
      const M = Gi(s);
      if (M) throw new Mw(M);
      const F = await Vt.nameForWrite(r, s, g);
      return F ? (F.sidecar && await j.uploadMultipart(r, [
        new File([F.sidecar.content], F.sidecar.name, { type: "text/plain" })
      ]), F.stored) : s;
    }
    async function Pm(r) {
      const s = Ct.value;
      if (!s) return;
      const g = r.replace(/\/+$/, ""), M = s.replace(/\/+$/, "");
      (g === M || g.startsWith(M.endsWith("://") ? M : `${M}/`)) && await Vt.markerFor(s);
    }
    async function Om(r, s, g, M) {
      await Pm(g);
      const F = Vt.writesEncrypted(g);
      if (!F || !sn.names(F) || !s.every((et) => Vt.rootOf(et) === F)) return null;
      const X = [], de = [], Se = (et, Pt) => et.replace(/\/+$/, "") === Pt.replace(/\/+$/, "");
      let $e = /* @__PURE__ */ new Set();
      try {
        $e = new Set(((await j.index(g)).files ?? []).map((et) => et.basename));
      } catch {
      }
      for (const et of s) {
        const Pt = oo(et);
        if (r === "move" && Se(Pt, g)) continue;
        const En = Mi(et), At = await Vt.plainNameOf(et);
        if (!At || At.state === "unreadable" || At.name === null)
          throw new Error(_("e2e.names.move_unreadable"));
        const vn = await AM(et) ? { keepIdOf: et } : {};
        let $n = await Vt.nameForWrite(g, At.name, vn);
        if (!$n) return null;
        for (let Ga = 2; r === "copy" && $e.has($n.stored) && Ga < 100; Ga++)
          $n = await Vt.nameForWrite(g, VT(At.name, Ga), vn);
        if ($e.has($n.stored)) throw new Error(_("e2e.names.move_taken", { name: At.name }));
        $e.add($n.stored), $n.sidecar && await j.uploadMultipart(g, [
          new File([$n.sidecar.content], $n.sidecar.name, { type: "text/plain" })
        ]);
        const { op: Fi } = await j.transferNamed(r, et, g, $n.stored, M);
        De.register(Fi), X.push(Fi), de.push({ moved: ja(g, $n.stored), origin: Pt, name: En });
      }
      return { ops: X, undo: r === "move" ? async () => {
        for (const et of de) {
          const { op: Pt } = await j.transferNamed("move", et.moved, et.origin, et.name);
          De.register(Pt);
        }
        return { queued: !0 };
      } : null };
    }
    async function AM(r) {
      var M;
      const s = G.value.find((F) => F.path === r) ?? (((M = Zt.value) == null ? void 0 : M.visibleNodes()) ?? []).find((F) => F.path === r);
      if (s) return s.type === "dir";
      const g = Nl(Mi(r)).kind;
      if (g === "dir" || g === "longdir") return !0;
      if (g === "file" || g === "long") return !1;
      try {
        return ((await j.index(oo(r))).files ?? []).some((X) => X.path === r && X.type === "dir");
      } catch {
        return !1;
      }
    }
    async function Ow(r, s) {
      const g = Vt.writesEncrypted(r);
      if (!g) return null;
      const M = r.indexOf("://"), X = {
        adapter: M === -1 ? ie.value : r.slice(0, M),
        storages: (P.config.storages ?? []).map((ut) => ut.name),
        dirname: r,
        read_only: !1,
        files: [],
        e2e_root: g
      };
      if (!sn.names(g)) return X;
      const de = [], Se = [r];
      let $e = 0;
      for (; Se.length > 0 && de.length < kf && $e < wle; ) {
        const ut = Se.shift();
        $e++;
        let et;
        try {
          et = await j.index(ut);
        } catch {
          continue;
        }
        const Pt = Mr(await Vt.decorate(et.files ?? [], { root: g }));
        for (const En of Pt)
          if (En.type === "dir" && Se.push(En.path), e$(En.basename, s) && de.push(En), de.length >= kf) break;
      }
      return { ...X, files: de, truncated: Se.length > 0 };
    }
    const Bi = $(!1);
    Je(Ct, async (r, s) => {
      if (r === s) return;
      if (Is.value = !1, wr.value = "", Bo.value = !1, Ri.value = "", Bi.value = !1, xr.value = "", Sr.value = null, bw.value = [], !r) {
        on.value = null;
        return;
      }
      const g = Vt.markerCached(r);
      if (on.value = g === void 0 ? null : g, g === void 0) {
        const M = await Vt.markerFor(r);
        Ct.value === r && (on.value = M);
      }
    });
    const co = $(!1), xr = $(""), Sr = $(null);
    let Bs = !1;
    const nf = E(() => (Wn.value, B4(on.value))), Lw = E(() => nf.value !== "content"), EM = E(() => (Wn.value, F4(on.value))), CM = E(
      () => Lw.value ? G.value.filter((r) => r.e2e_name_state === "plain" || r.e2e_name_state === "unreadable").length : 0
    );
    async function af() {
      var M;
      const r = Ct.value, s = r ? sn.get(r) : void 0;
      let g = on.value;
      if (!r || !s || !g || co.value) return !1;
      Bi.value = !1, co.value = !0, xr.value = "", Bs = !1;
      try {
        if (!qi(g)) {
          const Se = await Y_(g, s);
          await Fo(Se.marker), sn.setNames(r, Se.names), Wn.value++, g = Se.marker;
        }
        const F = sn.names(r);
        if (!F) throw new Error("e2e: the folder name key is missing");
        Sr.value = { renamed: 0, failed: 0, seen: 0 };
        const X = Sr.value;
        if (await kne(F, r, {
          list: async (Se) => (await j.index(Se)).files ?? [],
          readSidecar: async (Se, $e) => {
            try {
              return new TextDecoder().decode(await j.fetchArrayBuffer(tl(Se, $e)));
            } catch {
              return null;
            }
          },
          writeSidecar: async (Se, $e, ut) => {
            await j.uploadMultipart(Se, [new File([ut], $e, { type: "text/plain" })]);
          },
          // A folder rename is a job of the queue where the server has one: the
          // queue keeps order, so a folder is renamed after its contents.
          rename: async (Se, $e, ut) => {
            if ($e.type === "dir" && sd("rename")) {
              const et = (await j.renameQueued(Se, $e.path, ut)).op;
              et && De.register(et);
            } else
              await j.rename(Se, $e.path, ut);
          },
          stopped: () => Bs
        }, X), Bs)
          return tt(_("e2e.names.stopped", { n: X.renamed })), !1;
        if (X.failed > 0)
          return xr.value = _("e2e.names.partial", { n: X.failed }), !1;
        const de = on.value ?? g;
        return (M = de.names) != null && M.pending && await Fo(I4(de)), Sr.value = null, tt(_("e2e.names.done", { n: X.renamed })), !0;
      } catch (F) {
        return xr.value = _("e2e.names.failed"), R("error", { message: F.message, context: { op: "e2e-names" } }), !1;
      } finally {
        co.value = !1, await wt();
      }
    }
    const $r = $(null), Uo = $(!1), Tr = $(""), fo = $(null);
    let of = !1, Ou = null;
    const Fs = $(null), Dw = E(() => (Wn.value, X_(on.value)));
    function zM(r, s) {
      const g = r.length === 1 ? r[0] : null;
      return !!g && g.type === "dir" && s && !an.value && !g.e2e && !g.e2e_root && !Kt.value && typeof crypto < "u" && !!crypto.subtle;
    }
    function Rw(r, s, g) {
      return zM(r, s) && Hh(r[0].path, "folder") === g;
    }
    function MM(r) {
      $r.value = r, yr.value = !0;
    }
    async function PM(r) {
      const s = [r];
      for (; s.length; ) {
        const g = s.shift(), M = await j.index(g);
        if (g !== r && typeof M.e2e_root == "string" && M.e2e_root) return !0;
        for (const F of M.files ?? [])
          if (F.type === "dir") {
            if (F.e2e) return !0;
            s.push(F.path);
          }
      }
      return !1;
    }
    async function OM(r) {
      const s = $r.value;
      if (!s) return;
      const g = s.path;
      gr.value = !0;
      try {
        if (await PM(g)) {
          tt(_("e2e.convert.nested"));
          return;
        }
        const M = await ny(r.password, { escrowPublicKey: _r.value });
        let F = M.marker, X = null;
        if (r.level === "names") {
          const de = await Y_(F, M.fmk);
          F = de.marker, X = de.names;
        }
        F = K4(F, void 0, r.cleanup ?? { versions: !1, trash: !1 }), await j.uploadMultipart(g, [
          new File([JSON.stringify(F)], ga, { type: "application/json" })
        ]), sn.set(g, M.fmk, X), Vt.setMarker(g, F), Wn.value++, yr.value = !1, $r.value = null, Io.value = M.recoveryKey, No.value = r.name, kr.value = "created", Ro.value = !0, await wt(Di(g)), await Gt(), Ct.value === g && (on.value = F, Iw());
      } catch (M) {
        R("error", { message: M.message, context: { op: "e2e-convert" } }), qt({ message: Zn(M, _("e2e.convert.failed")) }, yn);
      } finally {
        gr.value = !1;
      }
    }
    async function Iw() {
      var X, de, Se;
      const r = Ct.value, s = r ? sn.get(r) : void 0, g = on.value;
      if (!r || !s || !g || !X_(g) || Uo.value) return;
      Uo.value = !0, Tr.value = "", of = !1;
      const M = new AbortController();
      Ou = M, fo.value = { total: 0, done: 0, skipped: 0, tooBig: 0, failed: 0 };
      const F = fo.value;
      try {
        if (await wne(
          r,
          {
            list: async (et) => (await j.index(et)).files ?? [],
            head: (et) => j.fetchHead(et, 16),
            read: (et) => j.fetchArrayBuffer(et),
            write: async (et, Pt, En, At) => {
              await j.uploadMultipart(
                et,
                [new File([En], Pt.basename, { type: "application/octet-stream" })],
                void 0,
                { e2e_convert: "1", ...At ? { expect: At } : {} }
              );
            },
            encrypt: (et) => ay(s, et),
            /* wiring:e2 convert - over 200 MB: STREAM (0x02), streamed both ways. */
            writeLarge: async (et, Pt, En) => {
              Fs.value = { name: Pt.basename, percent: 0 };
              try {
                return await Mt.convertLarge(Pt, s, En, {
                  signal: M.signal,
                  onProgress: (At) => {
                    Fs.value = { name: Pt.basename, percent: Math.floor(At * 100) };
                  }
                });
              } finally {
                Fs.value = null;
              }
            },
            stopped: () => of
          },
          F,
          { maxBytes: ec }
        ), of) {
          tt(_("e2e.convert.stopped", { n: F.done }));
          return;
        }
        if (F.tooBig > 0 && F.failed === 0) {
          Tr.value = _("e2e.convert.too_large_here", { n: F.tooBig });
          return;
        }
        if (F.failed + F.tooBig > 0) {
          Tr.value = _("e2e.convert.partial", { n: F.failed + F.tooBig });
          return;
        }
        if ((de = (X = on.value) == null ? void 0 : X.names) != null && de.pending && !await af()) return;
        const $e = on.value ?? g, ut = (Se = $e.conv) == null ? void 0 : Se.cleanup;
        await Fo(V4($e)), fo.value = null;
        try {
          const et = await j.e2eCleanup({ path: r, versions: !!(ut != null && ut.versions), trash: !!(ut != null && ut.trash) });
          tt(
            _("e2e.convert.done", {
              n: F.done + F.skipped,
              versions: et.versions_deleted,
              trash: et.trash_purged
            })
          );
        } catch (et) {
          tt(_("e2e.convert.cleanup_failed")), R("error", { message: et.message, context: { op: "e2e-convert-cleanup" } });
        }
      } catch ($e) {
        Tr.value = Zn($e, _("e2e.convert.failed")), R("error", { message: $e.message, context: { op: "e2e-convert" } });
      } finally {
        Uo.value = !1, Ou = null, await wt();
      }
    }
    function LM() {
      of = !0, Ou == null || Ou.abort();
    }
    function DM() {
      Bi.value = !1, Nw("change");
    }
    function RM() {
      Bi.value = !1, xM();
    }
    const Us = $(!1), Lm = $("change"), Lu = $(!1), Ar = $(null);
    let Hs = null;
    const Er = $(!1), Du = $(""), Ks = $(null), IM = E(() => (Wn.value, fl(on.value))), NM = E(() => !!on.value && mS(on.value));
    function Nw(r) {
      Lm.value = r, Ar.value = null, Us.value = !0;
    }
    function BM() {
      if (!Lu.value) {
        if (Lm.value === "reset") {
          Em();
          return;
        }
        Us.value = !1;
      }
    }
    async function FM(r) {
      const s = Ct.value, g = on.value;
      if (!s || !g || Lu.value) return;
      const M = r.proof ?? (Hs ? { recoveryKey: Hs } : null);
      if (!M) {
        Ar.value = _("e2e.password.current_required");
        return;
      }
      const F = "recoveryKey" in M ? "recovery_key" : "password";
      Lu.value = !0, Ar.value = null;
      try {
        if (!r.rotate) {
          const de = await vS(g, M, r.newPassword);
          await Fo(de), Hs = null, Us.value = !1, tt(_("e2e.password.done"));
          return;
        }
        const X = await U4(g, M, r.newPassword, {
          escrowPublicKey: _r.value
        });
        await Fo(X.marker), Is.value = !1, wr.value = "", sn.set(s, X.fmk, X.names ?? sn.names(s) ?? null, X.previous), Wn.value++, Am(), Hs = null, Us.value = !1, X.recoveryKeyIsNew && (Io.value = X.recoveryKey, No.value = Mi(s), kr.value = "replaced", Ro.value = !0), await Fw();
      } catch (X) {
        X instanceof dn ? Ar.value = _(F === "recovery_key" ? "e2e.password.wrong_recovery" : "e2e.password.wrong_current") : X instanceof yS ? Ar.value = _("e2e.password.escrow_blocked") : (Ar.value = _("e2e.password.failed"), R("error", { message: X.message, context: { op: "e2e-password" } }));
      } finally {
        Lu.value = !1;
      }
    }
    async function UM(r, s, g) {
      const M = new File([g], s, { type: "application/octet-stream" });
      if (xe.shouldChunk(M)) {
        await xe.uploadFile({ path: r, file: M });
        return;
      }
      await j.uploadMultipart(r, [M]);
    }
    async function Bw(r, s, g) {
      const M = Ks.value;
      let F;
      try {
        F = await j.index(r);
      } catch {
        M.failed++;
        return;
      }
      for (const X of F.files ?? [])
        if (X.basename !== ga) {
          if (X.type === "dir") {
            await Bw(X.path, s, g);
            continue;
          }
          try {
            if ((X.size ?? 0) > ec) {
              await Mt.rewrapLarge(X, s, g) && M.done++;
              continue;
            }
            const de = await j.fetchArrayBuffer(X.path);
            if (!Tl(de)) continue;
            const Se = await gS(de, s, g);
            Se && await UM(r, X.basename, Se), M.done++;
          } catch {
            M.failed++;
          }
        }
    }
    async function Fw() {
      const r = Ct.value, s = r ? sn.get(r) : void 0, g = r ? sn.previous(r) : void 0;
      if (!(!r || !s || !g || Er.value)) {
        Er.value = !0, Du.value = "", Ks.value = { done: 0, failed: 0 };
        try {
          await Bw(r, g, s);
          const M = Ks.value;
          if (M.failed > 0) {
            Du.value = _("e2e.password.rekey_partial", { n: M.failed });
            return;
          }
          const F = on.value;
          F && fl(F) && await Fo(j4(F)), sn.dropPrevious(r), Wn.value++, tt(_("e2e.password.rekey_done", { n: M.done }));
        } catch (M) {
          Du.value = _("e2e.password.failed"), R("error", { message: M.message, context: { op: "e2e-rekey" } });
        } finally {
          Er.value = !1, await wt();
        }
      }
    }
    function rf(r) {
      return r.replace(/\/+$/, "");
    }
    function Uw(r) {
      if (!r || r.type !== "dir" || r.e2e !== !0) return null;
      const s = rf(r.path);
      return sn.roots().find((g) => rf(g) === s) ?? null;
    }
    async function HM(r) {
      const s = r.length === 1 ? r[0] : null;
      if (s && Ui(s) && !an.value && !s.e2e_root)
        return await Mt.download(s), !0;
      let g = null;
      if (Yn.value ? g = Ct.value : s && (g = Uw(s)), !g && r.length > 0) {
        const de = r.map(($e) => Vt.rootOf($e.path, $e.e2e_root ?? null)), Se = de[0];
        Se && de.every(($e) => $e === Se) && (g = sn.roots().find(($e) => rf($e) === rf(Se)) ?? null);
      }
      if (!g) return !1;
      const M = sn.get(g);
      if (!M) return !1;
      if (s && s.type === "file")
        return await Mt.downloadFolderFile(s, M, sn.previous(g), g), !0;
      const F = Vt.segmentLabel(Rt(Xe.value)) ?? Mi(Rt(Xe.value)), X = `${s ? s.basename : F || "filex"}.zip`;
      return await Mt.downloadDecryptedZip(r, {
        root: g,
        fmk: M,
        previous: sn.previous(g),
        decorate: (de, Se) => Vt.decorate(de, Se),
        zipName: X
      }), !0;
    }
    function KM() {
      const r = Mt.tooBig.value;
      if (Mt.closeTooBig(), !r) return;
      if (r.encrypted.kind === "file") {
        window.open(j.downloadUrl(r.encrypted.path), "_blank");
        return;
      }
      const s = { path: r.encrypted.path, basename: Mi(r.encrypted.path), type: "dir" };
      Fd([s], { encrypted: !0 });
    }
    function VM() {
      Ro.value = !1, Io.value = "", No.value = "";
    }
    return (r, s) => {
      var g, M, F, X, de, Se, $e, ut, et, Pt, En, At, Ya, vn, $n, Fi, Ga, sf, Kw, Vw, jw, qw, Ww, Yw, Gw, Xw, Jw, Zw, Qw, e_;
      return f(), h("div", {
        ref_key: "rootEl",
        ref: Tn,
        class: Re(["fe", {
          "fe--theme-light": wn.value === "light",
          "fe--theme-dark": wn.value === "dark",
          "fe--is-dragover": Do.value,
          "fe--density-compact": _t.value === "compact",
          "fe--narrow": $a.value
        }]),
        dir: u(K),
        tabindex: "-1",
        onDragenter: kz,
        onDragover: _z,
        onDragleave: wz,
        onDrop: xz,
        onContextmenu: qC
      }, [
        Ze(yD, {
          ref_key: "toolbarRef",
          ref: uk,
          "view-mode": wm.value,
          "search-query": Et.value,
          "trash-active": Kt.value,
          actions: ez.value,
          "selection-mode": KC.value,
          "selection-count": ia().length,
          "selection-pane": Xd.value,
          "paste-enabled": !!Me.value.mode,
          "can-go-up": xt.value,
          "at-virtual-root": Qe.value,
          "can-write": li.value,
          locale: H.value,
          "language-row": N.value && !((g = od()) != null && g.language),
          narrow: $a.value,
          theme: wn.value,
          "inspector-open": Ra.value,
          "assistant-button": xh.value,
          "assistant-open": no.value,
          "nav-open": NE.value,
          "nav-enabled": iu.value,
          "view-modes": Ah.value,
          "scope-label": qb.value,
          "brand-name": (M = e.config.brand) == null ? void 0 : M.name,
          "brand-mark-url": (F = e.config.brand) == null ? void 0 : F.markUrl,
          "search-escalates": bt.value === "home",
          onOpenPalette: eC,
          onToggleInspector: _h,
          onToggleAssistant: LE,
          onToggleNav: Nb,
          onOpenTheme: s[0] || (s[0] = (Ee) => Vd.value = !0),
          "onUpdate:viewMode": s[1] || (s[1] = (Ee) => uw(Ee)),
          "onUpdate:searchQuery": QE,
          onOpenAdvancedSearch: JE,
          "onUpdate:density": s[2] || (s[2] = (Ee) => _t.value = Ee),
          onOpenShortcutSettings: s[3] || (s[3] = (Ee) => wu.value = !0),
          onOpenTimezone: s[4] || (s[4] = (Ee) => ee.value = !0),
          onOpenLanguage: s[5] || (s[5] = (Ee) => tn.value = !0),
          onNewFolder: s[6] || (s[6] = (Ee) => sa.value = !0),
          onUpload: Oo,
          onRefresh: hk,
          onGoUp: qe,
          onAction: em,
          onOpenRecents: s[7] || (s[7] = (Ee) => ls.value = !0)
        }, eP({
          "header-actions": mt(() => {
            var Ee;
            return [
              u(vt) ? (f(), Ge(Coe, {
                key: 0,
                feed: u(vt),
                locale: H.value,
                "manage-href": Qt.value,
                onOpen: cn,
                onManage: en
              }, null, 8, ["feed", "locale", "manage-href"])) : O("", !0),
              e.config.account ? (f(), Ge(lre, {
                key: 1,
                actions: To.value,
                user: Un.value,
                version: (Ee = Ve.value) == null ? void 0 : Ee.release,
                locale: H.value,
                "fallback-label": u(_)("explore.account"),
                onSelect: ad
              }, null, 8, ["actions", "user", "version", "locale", "fallback-label"])) : O("", !0),
              On(r.$slots, "header-actions")
            ];
          }),
          _: 2
        }, [
          r.$slots.brand ? {
            name: "brand",
            fn: mt(() => [
              On(r.$slots, "brand")
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["view-mode", "search-query", "trash-active", "actions", "selection-mode", "selection-count", "selection-pane", "paste-enabled", "can-go-up", "at-virtual-root", "can-write", "locale", "language-row", "narrow", "theme", "inspector-open", "assistant-button", "assistant-open", "nav-open", "nav-enabled", "view-modes", "scope-label", "brand-name", "brand-mark-url", "search-escalates", "onOpenPalette", "onToggleInspector", "onToggleNav", "onUpdate:searchQuery", "onOpenAdvancedSearch", "onRefresh"]),
        d("div", {
          class: Re([
            "fe__main",
            { "fe__main--split": Ls.value }
            /* wiring:d1 */
          ])
        }, [
          Sh.value ? (f(), Ge(Aq, {
            key: 0,
            expanded: au.value,
            narrow: $a.value,
            "active-view": bt.value,
            "active-tag": rn.value,
            "active-tag-kind": ve.value,
            tags: Qb.value,
            "tags-loaded": Lh.value,
            "active-storage": ie.value,
            storages: Ph.value,
            "storage-order-custom": u(Jb).custom.value,
            onReorderStorages: oC,
            "shared-storages": $h.value,
            "trash-visible": e.config.trashVisible !== !1,
            "drafts-visible": sr.value && gs.value,
            "draft-count": us.value,
            "show-connections": BE.value,
            "show-my-shares": FE.value,
            "show-identity-surfaces": gs.value,
            "can-write": li.value && !Qe.value && !Kt.value,
            locale: H.value,
            "can-request-files": li.value && !Qe.value && !Kt.value && !bt.value && !an.value,
            "request-files-allowed": lk.value,
            "can-new-document": dE.value && !Kt.value && !bt.value && !an.value,
            onNewDocument: s[8] || (s[8] = (Ee) => Ql.value = !0),
            quota: aC.value,
            theme: wn.value,
            onRequestFiles: tC,
            onToggle: Nb,
            onClose: Eo,
            onOpenView: sC,
            onOpenTag: _s,
            onOpenStorage: ek,
            onUpload: Oo,
            onNewFolder: s[9] || (s[9] = (Ee) => sa.value = !0),
            onOpenConnections: HE,
            onOpenTokens: KE,
            onOpenMyShares: s[10] || (s[10] = (Ee) => R("open-my-shares")),
            "show-app-store": UE.value,
            onOpenAppStore: s[11] || (s[11] = (Ee) => R("open-app-store")),
            apps: QA.value,
            onOpenApp: bb
          }, null, 8, ["expanded", "narrow", "active-view", "active-tag", "active-tag-kind", "tags", "tags-loaded", "active-storage", "storages", "storage-order-custom", "shared-storages", "trash-visible", "drafts-visible", "draft-count", "show-connections", "show-my-shares", "show-identity-surfaces", "can-write", "locale", "can-request-files", "request-files-allowed", "can-new-document", "quota", "theme", "onRequestFiles", "onOpenView", "show-app-store", "apps"])) : O("", !0),
          $a.value && hr.value ? (f(), h("button", {
            key: 1,
            type: "button",
            class: "fe-sidenav__scrim",
            title: u(_)("sidenav.close"),
            "aria-label": u(_)("sidenav.close"),
            onClick: Eo
          }, null, 8, gre)) : O("", !0),
          d("div", bre, [
            Kz.value ? (f(), Ge(DQ, {
              key: 0,
              tabs: ew.value,
              "active-id": u(bm),
              locale: H.value,
              "hide-tabs": !tw.value,
              "split-enabled": $u.value,
              "split-active": !!so.value,
              "inspector-enabled": Rb.value,
              "inspector-open": Ra.value,
              onSelect: Nz,
              onClose: nw,
              onNew: km,
              onReorder: s[12] || (s[12] = (Ee, Gn) => u(Hn).move(Ee, Gn)),
              onToggleSplit: rw,
              onToggleInspector: _h
            }, null, 8, ["tabs", "active-id", "locale", "hide-tabs", "split-enabled", "split-active", "inspector-enabled", "inspector-open"])) : O("", !0),
            d("div", kre, [
              Ze(M0, {
                "pane-id": "main",
                ref_key: "mainPaneRef",
                ref: Uz,
                api: Ue,
                locale: H.value,
                theme: wn.value,
                focused: Gz.value,
                path: Xe.value,
                qualify: Rt,
                "to-user": Di,
                clamp: fw,
                "root-path": u(ft),
                floor: u(gt),
                "multi-root": Sn.value,
                rows: G.value,
                loading: ot.value,
                error: Ne.value,
                order: qE.value,
                "view-mode": Pe.value,
                "view-modes": Ah.value,
                "open-trigger": P.config.openTrigger,
                "show-crumbs": bt.value !== "home",
                "filter-mode": ce.value,
                "find-label": bt.value === "home" ? u(_)("filter.find.home") : "",
                "show-view-switcher": bt.value !== "home",
                "folder-key": mn.value,
                "show-parent-path": !!Et.value || In.value,
                trash: Kt.value,
                clipped: hm.value,
                "extra-filters": ws.value,
                "extra-filters-on-server": !Kb.value,
                "can-write": li.value && !Kt.value,
                "can-paste": !!Me.value.mode,
                selected: u(le).selected.value,
                filters: ks.value,
                "thumb-src": u(se).src,
                "folder-previews": ((X = Ve.value) == null ? void 0 : X.folder_previews) !== !1,
                "keep-badge-for": ci.value ? Tk : void 0,
                "starred-ids": $b.value,
                "star-overrides": ss.value,
                "star-enabled": gs.value,
                "api-base": P.config.apiBase ?? "",
                "auth-headers": () => Qn(),
                "auth-credentials": u(j).credentialsMode(),
                "e2e-active": an.value,
                "body-override": Gd.value !== "",
                onActivate: Yz,
                onNavigate: Az,
                onOpen: qa,
                onOpenTrash: s[23] || (s[23] = () => zi()),
                onClickRow: s[24] || (s[24] = (Ee, Gn) => Nk("main", Ee, Gn)),
                onContext: s[25] || (s[25] = (Ee, Gn) => zk("main", Ee, Gn)),
                onClearSelection: s[26] || (s[26] = (Ee) => u(le).clear()),
                onDisplayOrder: s[27] || (s[27] = (Ee) => dt.value = Ee),
                onItemDragStart: s[28] || (s[28] = (Ee, Gn) => Bk("main", Ee, Gn)),
                onItemDropInto: Yk,
                onTransfer: yw,
                "onUpdate:viewMode": s[29] || (s[29] = (Ee) => Pe.value = Ee),
                "onUpdate:filters": Fb,
                onCrumbContext: WC,
                onCopyPath: Kd,
                onCrumbDrop: Gk,
                onNewFolder: s[30] || (s[30] = (Ee) => sa.value = !0),
                onUpload: Oo,
                onPaste: s[31] || (s[31] = (Ee) => em("paste")),
                onSelectAll: s[32] || (s[32] = (Ee) => u(le).selectAll()),
                onClearFilters: WE,
                onStarChange: Tb,
                onRetry: Ae
              }, {
                banners: mt(() => [
                  Et.value && xn.value && !bt.value && !Kt.value ? (f(), h("div", wre, y(u(_)("search.truncated")), 1)) : O("", !0),
                  ao.value && ao.value.truncated && Cn.value && !Et.value ? (f(), h("div", _re, [
                    d("span", null, y(u(_)("nav.more_shown", { shown: G.value.length, total: ao.value.total })), 1),
                    d("button", {
                      type: "button",
                      class: "fe-coverage__action",
                      "data-testid": "nav-more-load",
                      disabled: lu.value,
                      "aria-busy": lu.value ? "true" : void 0,
                      onClick: iC
                    }, y(u(_)("nav.load_more")), 9, xre)
                  ])) : O("", !0),
                  Ci.value ? (f(), h("div", Sre, [
                    d("span", $re, y(Vn(Ci.value.storage) ? u(_)("coverage.cataloging", { storage: Ci.value.storage ?? "" }) : u(_)(Ci.value.key, Ci.value.vars)), 1),
                    Ci.value.offerCatalogAll ? (f(), h("button", {
                      key: 0,
                      type: "button",
                      class: "fe-coverage__action",
                      "data-testid": "catalog-coverage-all",
                      disabled: Vn(Ci.value.storage),
                      "aria-busy": Vn(Ci.value.storage) ? "true" : void 0,
                      onClick: s[13] || (s[13] = (Ee) => vC(Ci.value.storage))
                    }, y(Vn(Ci.value.storage) ? u(_)("coverage.catalog_running") : u(_)("coverage.catalog_all")), 9, Tre)) : O("", !0)
                  ])) : O("", !0),
                  u(kt).length || u(ht) ? (f(), h("div", Are, [
                    u(kt).length ? (f(), Ge(eL, {
                      key: 0,
                      users: u(kt),
                      locale: H.value
                    }, null, 8, ["users", "locale"])) : O("", !0),
                    u(ht) ? (f(), h("span", {
                      key: 1,
                      class: "fe-connbadge",
                      role: "status",
                      title: u(_)("conn.tooltip")
                    }, [
                      s[115] || (s[115] = d("span", {
                        class: "fe-connbadge__dot",
                        "aria-hidden": "true"
                      }, null, -1)),
                      Ht(" " + y(u(_)("conn.offline")), 1)
                    ], 8, Ere)) : O("", !0)
                  ])) : O("", !0),
                  Is.value ? (f(), h("div", Cre, [
                    d("div", zre, [
                      d("strong", null, y(u(_)("e2e.upgrade.title")), 1),
                      d("p", null, y(u(_)("e2e.upgrade.body")), 1),
                      Wa.value ? (f(), h("p", Mre, y(u(_)("e2e.upgrade.escrow_note")), 1)) : O("", !0)
                    ]),
                    d("div", Pre, [
                      d("button", {
                        type: "button",
                        class: "fe-btn",
                        disabled: Eu.value,
                        onClick: TM
                      }, y(u(_)("e2e.upgrade.decline")), 9, Ore),
                      d("button", {
                        type: "button",
                        class: "fe-btn fe-btn--primary",
                        disabled: Eu.value,
                        onClick: _M
                      }, y(Eu.value ? u(_)("e2e.upgrade.busy") : u(_)("e2e.upgrade.accept")), 9, Lre)
                    ])
                  ])) : O("", !0),
                  Bo.value ? (f(), h("div", Dre, [
                    d("div", Rre, [
                      d("strong", null, y(u(_)("e2e.escrowoffer.title")), 1),
                      d("p", null, y(u(_)("e2e.escrowoffer.body")), 1),
                      d("p", Ire, [
                        Ht(y(u(_)("e2e.escrowoffer.consequence")) + " ", 1),
                        d("a", {
                          href: ble,
                          target: "_blank",
                          rel: "noopener noreferrer"
                        }, y(u(_)("e2e.escrowoffer.learn_more")), 1)
                      ]),
                      Wa.value ? (f(), h("p", Nre, [
                        Ht(y(u(_)("e2e.recover.escrow_kid")) + ": ", 1),
                        d("code", null, y(Wa.value), 1)
                      ])) : O("", !0),
                      Cu.value === "manual" ? (f(), h("label", Bre, [
                        d("span", null, y(u(_)("e2e.escrowoffer.password_label")), 1),
                        ln(d("input", {
                          "onUpdate:modelValue": s[14] || (s[14] = (Ee) => Ri.value = Ee),
                          type: "password",
                          class: "fe-input",
                          autocomplete: "current-password",
                          disabled: Ii.value,
                          onKeyup: Ca(zw, ["enter"])
                        }, null, 40, Fre), [
                          [_n, Ri.value]
                        ])
                      ])) : O("", !0),
                      Ni.value ? (f(), h("p", Ure, y(Ni.value), 1)) : O("", !0)
                    ]),
                    d("div", Hre, [
                      d("button", {
                        type: "button",
                        class: "fe-btn",
                        disabled: Ii.value,
                        onClick: s[15] || (s[15] = (Ee) => Cu.value === "manual" ? $M() : SM())
                      }, y(Cu.value === "manual" ? u(_)("e2e.escrowoffer.cancel") : u(_)("e2e.escrowoffer.decline")), 9, Kre),
                      d("button", {
                        type: "button",
                        class: "fe-btn fe-btn--primary",
                        disabled: Ii.value,
                        onClick: zw
                      }, y(Ii.value ? u(_)("e2e.escrowoffer.busy") : u(_)("e2e.escrowoffer.accept")), 9, Vre)
                    ])
                  ])) : O("", !0),
                  Yn.value && (Dw.value || Uo.value || Tr.value) ? (f(), h("div", jre, [
                    d("div", qre, [
                      d("strong", null, y(Uo.value ? u(_)("e2e.convert.busy") : u(_)("e2e.convert.resume_title")), 1),
                      Uo.value ? O("", !0) : (f(), h("p", Wre, y(u(_)("e2e.convert.resume_body")), 1)),
                      fo.value ? (f(), h("p", Yre, y(u(_)("e2e.convert.progress", {
                        n: fo.value.done + fo.value.skipped,
                        total: fo.value.total,
                        failed: fo.value.failed + fo.value.tooBig
                      })), 1)) : O("", !0),
                      Fs.value ? (f(), h("p", Gre, y(u(_)("e2e.convert.large_progress", { name: Fs.value.name, percent: Fs.value.percent })), 1)) : O("", !0),
                      Tr.value ? (f(), h("p", Xre, y(Tr.value), 1)) : O("", !0)
                    ]),
                    d("div", Jre, [
                      Uo.value ? (f(), h("button", {
                        key: 0,
                        type: "button",
                        class: "fe-btn",
                        "data-testid": "e2e-convert-stop",
                        onClick: LM
                      }, y(u(_)("e2e.names.stop")), 1)) : (f(), h("button", {
                        key: 1,
                        type: "button",
                        class: "fe-btn fe-btn--primary",
                        "data-testid": "e2e-convert-resume",
                        onClick: Iw
                      }, y(u(_)("e2e.names.resume")), 1))
                    ])
                  ])) : O("", !0),
                  Yn.value && !Dw.value && !Uo.value && (nf.value === "pending" || co.value || xr.value) ? (f(), h("div", Zre, [
                    d("div", Qre, [
                      d("strong", null, y(co.value ? u(_)("e2e.names.busy") : u(_)("e2e.names.resume_title")), 1),
                      co.value ? O("", !0) : (f(), h("p", ese, y(u(_)("e2e.names.resume_body")), 1)),
                      Sr.value ? (f(), h("p", tse, y(u(_)("e2e.names.progress", { n: Sr.value.renamed, failed: Sr.value.failed })), 1)) : O("", !0),
                      xr.value ? (f(), h("p", nse, y(xr.value), 1)) : O("", !0)
                    ]),
                    d("div", ase, [
                      co.value ? (f(), h("button", {
                        key: 0,
                        type: "button",
                        class: "fe-btn",
                        "data-testid": "e2e-names-stop",
                        onClick: s[16] || (s[16] = (Ee) => tP(Bs) ? Bs.value = !0 : Bs = !0)
                      }, y(u(_)("e2e.names.stop")), 1)) : (f(), h("button", {
                        key: 1,
                        type: "button",
                        class: "fe-btn fe-btn--primary",
                        "data-testid": "e2e-names-resume",
                        onClick: af
                      }, y(u(_)("e2e.names.resume")), 1))
                    ])
                  ])) : O("", !0),
                  Yn.value && (IM.value || Er.value) ? (f(), h("div", ise, [
                    d("div", ose, [
                      d("strong", null, y(u(_)("e2e.password.resume_title")), 1),
                      d("p", null, y(u(_)("e2e.password.resume_body")), 1),
                      Ks.value ? (f(), h("p", rse, y(u(_)("e2e.password.progress", { n: Ks.value.done, failed: Ks.value.failed })), 1)) : O("", !0),
                      Du.value ? (f(), h("p", sse, y(Du.value), 1)) : O("", !0)
                    ]),
                    d("div", lse, [
                      d("button", {
                        type: "button",
                        class: "fe-btn fe-btn--primary",
                        "data-testid": "e2e-rekey-resume",
                        disabled: Er.value,
                        onClick: Fw
                      }, y(Er.value ? u(_)("e2e.password.busy") : u(_)("e2e.names.resume")), 9, use)
                    ])
                  ])) : O("", !0),
                  Yn.value && Cm.value ? (f(), Ge(u(i), {
                    key: 9,
                    locale: H.value,
                    state: Cm.value,
                    onSettings: s[17] || (s[17] = (Ee) => Bi.value = !0),
                    onLock: Em,
                    onTakeOver: s[18] || (s[18] = (Ee) => u(I).takeOver(Ct.value)),
                    onContinue: s[19] || (s[19] = (Ee) => u(I).continueFromShown(Ct.value)),
                    onDismiss: s[20] || (s[20] = (Ee) => u(I).dismiss(Ct.value))
                  }, null, 8, ["locale", "state"])) : O("", !0),
                  Yn.value && !Cm.value ? (f(), h("div", cse, [
                    d("span", {
                      class: "fe-e2e-strip__icon",
                      "aria-hidden": "true",
                      innerHTML: u(zt)("lock")
                    }, null, 8, dse),
                    d("span", fse, y(u(_)("e2e.strip.label")), 1),
                    d("span", pse, y(Lw.value ? u(_)("e2e.level.names") : u(_)("e2e.level.content")), 1),
                    d("button", {
                      type: "button",
                      class: "fe-btn fe-e2e-strip__btn",
                      "data-testid": "e2e-settings-open",
                      disabled: Er.value || co.value,
                      onClick: s[21] || (s[21] = (Ee) => Bi.value = !0)
                    }, y(u(_)("e2e.settings.open")), 9, hse),
                    d("button", {
                      type: "button",
                      class: "fe-btn fe-e2e-strip__btn",
                      onClick: Em
                    }, y(u(_)("e2e.strip.lock")), 1)
                  ])) : O("", !0),
                  Ft.value && !ot.value ? (f(), h("div", mse, [
                    d("p", vse, y(_C.value), 1),
                    zd.value ? (f(), h("p", yse, [
                      Ht(y(zd.value), 1),
                      Mo.value < As.value ? (f(), h("span", gse, " · " + y($C.value), 1)) : O("", !0)
                    ])) : O("", !0),
                    Mo.value < As.value ? (f(), h("button", {
                      key: 1,
                      type: "button",
                      class: "fe-btn fe-trashbar__more",
                      "data-testid": "trash-more",
                      disabled: Md.value,
                      onClick: TC
                    }, y(u(_)("trash.show_more")), 9, bse)) : O("", !0),
                    vk.value ? (f(), h("p", kse, y(vk.value), 1)) : O("", !0),
                    zo.value ? (f(), h("button", {
                      key: 3,
                      type: "button",
                      class: "fe-btn fe-btn--danger fe-trashbar__action",
                      disabled: G.value.length === 0 || Ed.value,
                      "data-testid": "trash-empty",
                      onClick: xC
                    }, y(u(_)("trash.empty_action")), 9, wse)) : O("", !0)
                  ])) : O("", !0)
                ]),
                body: mt(() => [
                  Gd.value === "home" ? (f(), Ge(xY, {
                    key: 0,
                    storages: Oh.value,
                    recent: Gb.value,
                    starred: Xb.value,
                    loading: Mh.value,
                    locale: H.value,
                    "match-names": u(j).matchNames,
                    "name-filter": ks.value.name ?? "",
                    "thumb-src": u(se).src,
                    onOpenStorage: ek,
                    onOpenNode: qa,
                    onContextNode: im
                  }, null, 8, ["storages", "recent", "starred", "loading", "locale", "match-names", "name-filter", "thumb-src"])) : Gd.value === "drafts" ? (f(), Ge(DY, {
                    key: 1,
                    drafts: yh.value,
                    loading: bh.value,
                    limit: gh.value,
                    locale: H.value,
                    "name-filter": ks.value.name ?? "",
                    "match-names": u(j).matchNames,
                    "busy-key": lr.value,
                    onOpen: s[22] || (s[22] = (Ee) => Pb(Ee)),
                    onSave: pE,
                    onDelete: hE
                  }, null, 8, ["drafts", "loading", "limit", "locale", "name-filter", "match-names", "busy-key"])) : Gd.value === "notfound" ? (f(), h("div", _se, [
                    s[116] || (s[116] = d("svg", {
                      class: "fe-state__art",
                      viewBox: "0 0 120 100",
                      width: "110",
                      height: "92",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "aria-hidden": "true"
                    }, [
                      d("path", { d: "M18 36v42a6 6 0 0 0 6 6h72a6 6 0 0 0 6-6V44a6 6 0 0 0-6-6H62l-9-10H24a6 6 0 0 0-6 6z" }),
                      d("path", { d: "M52 55c0-4.6 3.6-8 8-8s8 3.4 8 8c0 5.5-8 4.8-8 11" }),
                      d("circle", {
                        cx: "60",
                        cy: "73",
                        r: "1.6",
                        fill: "currentColor",
                        stroke: "none"
                      })
                    ], -1)),
                    d("p", xse, y(u(_)("notFound.title")), 1),
                    d("p", Sse, y(Ce.value), 1),
                    d("p", $se, y(u(_)("notFound.desc")), 1),
                    d("div", Tse, [
                      d("button", {
                        type: "button",
                        class: "fe-btn",
                        onClick: kC
                      }, y(u(_)("notFound.goRoot")), 1)
                    ])
                  ])) : (f(), Ge(KT, {
                    key: 3,
                    locale: H.value,
                    busy: Zd.value,
                    error: xm.value,
                    onUnlock: lM,
                    onRecovery: Ew
                  }, null, 8, ["locale", "busy", "error"]))
                ]),
                empty: mt(() => [
                  Et.value ? (f(), h("div", Ase, [
                    s[117] || (s[117] = d("svg", {
                      class: "fe-state__art",
                      viewBox: "0 0 120 100",
                      width: "110",
                      height: "92",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "aria-hidden": "true"
                    }, [
                      d("circle", {
                        cx: "52",
                        cy: "44",
                        r: "22"
                      }),
                      d("path", { d: "M68 61l20 20" }),
                      d("path", { d: "M46 38l12 12M58 38l-12 12" })
                    ], -1)),
                    d("p", Ese, y(u(_)("empty.search.title")), 1),
                    d("p", Cse, y(u(_)("empty.search.hint")), 1)
                  ])) : bt.value && bt.value !== "trash" ? (f(), h("div", {
                    key: 1,
                    class: "fe-state",
                    "data-testid": `empty-${bt.value}`
                  }, [
                    (f(), h("svg", Mse, [
                      bt.value === "recent" ? (f(), h(Te, { key: 0 }, [
                        s[118] || (s[118] = d("circle", {
                          cx: "60",
                          cy: "50",
                          r: "28"
                        }, null, -1)),
                        s[119] || (s[119] = d("path", { d: "M60 32v18l12 8" }, null, -1))
                      ], 64)) : bt.value === "starred" ? (f(), h("path", Pse)) : bt.value === "tag" ? (f(), h(Te, { key: 2 }, [
                        s[120] || (s[120] = d("path", { d: "M30 30h24l32 32-24 24-32-32z" }, null, -1)),
                        s[121] || (s[121] = d("circle", {
                          cx: "43",
                          cy: "43",
                          r: "4.5"
                        }, null, -1))
                      ], 64)) : (f(), h(Te, { key: 3 }, [
                        s[122] || (s[122] = d("circle", {
                          cx: "84",
                          cy: "34",
                          r: "9"
                        }, null, -1)),
                        s[123] || (s[123] = d("circle", {
                          cx: "36",
                          cy: "52",
                          r: "9"
                        }, null, -1)),
                        s[124] || (s[124] = d("circle", {
                          cx: "84",
                          cy: "70",
                          r: "9"
                        }, null, -1)),
                        s[125] || (s[125] = d("path", { d: "M44.5 47.5l31-9M44.5 56.5l31 9" }, null, -1))
                      ], 64))
                    ])),
                    d("p", Ose, y(bt.value === "tag" ? u(_)("empty.tag.title", { tag: rn.value }) : u(_)(`empty.${bt.value}.title`)), 1),
                    d("p", Lse, y(bt.value === "tag" ? u(_)("empty.tag.hint") : u(_)(`empty.${bt.value}.hint`)), 1)
                  ], 8, zse)) : Ft.value ? (f(), h("div", Dse, [
                    s[126] || (s[126] = d("svg", {
                      class: "fe-state__art",
                      viewBox: "0 0 120 100",
                      width: "110",
                      height: "92",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "aria-hidden": "true"
                    }, [
                      d("path", { d: "M38 34l4 48a6 6 0 0 0 6 5.6h24a6 6 0 0 0 6-5.6l4-48" }),
                      d("path", { d: "M32 34h56" }),
                      d("path", { d: "M50 34v-6a6 6 0 0 1 6-6h8a6 6 0 0 1 6 6v6" }),
                      d("path", {
                        d: "M52 44v32M60 44v32M68 44v32",
                        opacity: "0.5"
                      })
                    ], -1)),
                    d("p", Rse, y(u(_)("empty.trash.title")), 1),
                    d("p", Ise, y(u(_)("empty.trash.hint")), 1)
                  ])) : (f(), h("div", Nse, [
                    (f(), h("svg", Bse, [
                      s[128] || (s[128] = d("path", { d: "M18 36v42a6 6 0 0 0 6 6h72a6 6 0 0 0 6-6V44a6 6 0 0 0-6-6H62l-9-10H24a6 6 0 0 0-6 6z" }, null, -1)),
                      Sd.value ? (f(), h("g", Fse, [...s[127] || (s[127] = [
                        d("path", {
                          d: "M60 50v14",
                          "stroke-dasharray": "3 4"
                        }, null, -1),
                        d("path", { d: "M53 59l7 8 7-8" }, null, -1)
                      ])])) : O("", !0)
                    ])),
                    d("p", Use, y(u(_)("empty.folder")), 1),
                    Sd.value ? (f(), h("p", Hse, y(u(_)("empty.hint")), 1)) : O("", !0),
                    Sd.value ? (f(), h("div", Kse, [
                      d("button", {
                        type: "button",
                        class: "fe-btn fe-btn--primary",
                        onClick: Oo
                      }, y(u(_)("empty.upload")), 1)
                    ])) : O("", !0)
                  ]))
                ]),
                _: 1
              }, 8, ["api", "locale", "theme", "focused", "path", "root-path", "floor", "multi-root", "rows", "loading", "error", "order", "view-mode", "view-modes", "open-trigger", "show-crumbs", "filter-mode", "find-label", "show-view-switcher", "folder-key", "show-parent-path", "trash", "clipped", "extra-filters", "extra-filters-on-server", "can-write", "can-paste", "selected", "filters", "thumb-src", "folder-previews", "keep-badge-for", "starred-ids", "star-overrides", "star-enabled", "api-base", "auth-headers", "auth-credentials", "e2e-active", "body-override"]),
              Ls.value && so.value ? (f(), Ge(M0, {
                ref_key: "splitPaneRef",
                ref: Zt,
                key: "split-" + u(bm),
                "pane-id": "split",
                "self-driven": "",
                closable: "",
                api: Ue,
                locale: H.value,
                theme: wn.value,
                focused: An.value,
                path: so.value.path,
                qualify: Rt,
                "to-user": Di,
                clamp: fw,
                "root-path": u(ft),
                floor: u(gt),
                "multi-root": Sn.value,
                "virtual-rows": fk,
                "trash-visible": e.config.trashVisible !== !1,
                "nav-offers-trash": Ib.value,
                "view-mode": sw.value,
                "view-modes": Ah.value,
                "open-trigger": P.config.openTrigger,
                clipped: hm.value,
                "can-write": li.value,
                "can-paste": !!Me.value.mode,
                selected: u(qn).selected.value,
                filters: Su.value,
                "folder-key": Hz.value,
                "thumb-src": u(se).src,
                "folder-previews": ((de = Ve.value) == null ? void 0 : de.folder_previews) !== !1,
                "keep-badge-for": ci.value ? Tk : void 0,
                "starred-ids": $b.value,
                "star-overrides": ss.value,
                "star-enabled": gs.value,
                "api-base": P.config.apiBase ?? "",
                "auth-headers": () => Qn(),
                "auth-credentials": u(j).credentialsMode(),
                onActivate: s[33] || (s[33] = (Ee) => pi.value = "split"),
                onClose: Vz,
                onNavigate: jz,
                onOpen: qa,
                onOpenTrash: Wz,
                onClickRow: s[34] || (s[34] = (Ee, Gn) => Nk("split", Ee, Gn)),
                onContext: s[35] || (s[35] = (Ee, Gn) => zk("split", Ee, Gn)),
                onClearSelection: s[36] || (s[36] = (Ee) => u(qn).clear()),
                onDisplayOrder: s[37] || (s[37] = (Ee) => xu.value = Ee),
                onItemDragStart: s[38] || (s[38] = (Ee, Gn) => Bk("split", Ee, Gn)),
                onItemDropInto: Yk,
                onTransfer: yw,
                "onUpdate:viewMode": lw,
                "onUpdate:filters": s[39] || (s[39] = (Ee) => Su.value = Ee),
                onCopyPath: Kd,
                onCrumbDrop: Gk,
                onNewFolder: s[40] || (s[40] = (Ee) => sa.value = !0),
                onUpload: Oo,
                onPaste: s[41] || (s[41] = (Ee) => em("paste")),
                onSelectAll: s[42] || (s[42] = (Ee) => u(qn).selectAll()),
                onClearFilters: s[43] || (s[43] = (Ee) => Su.value = { ...u(jo) }),
                onStarChange: Tb
              }, null, 8, ["api", "locale", "theme", "focused", "path", "root-path", "floor", "multi-root", "trash-visible", "nav-offers-trash", "view-mode", "view-modes", "open-trigger", "clipped", "can-write", "can-paste", "selected", "filters", "folder-key", "thumb-src", "folder-previews", "keep-badge-for", "starred-ids", "star-overrides", "star-enabled", "api-base", "auth-headers", "auth-credentials"])) : O("", !0)
            ])
          ]),
          Ra.value ? (f(), Ge(t7, {
            key: 2,
            api: $t,
            nodes: dw.value,
            "dir-label": nM.value,
            "dir-count": aM.value,
            "dir-perm": iM.value,
            "held-in": tM.value,
            locale: H.value,
            narrow: $a.value,
            "caller-admin": pa.value,
            sharing: Qz.value,
            "in-encrypted": eM.value,
            "thumb-src": u(se).src,
            "api-base": P.config.apiBase ?? "",
            "auth-headers": () => Qn(),
            "auth-credentials": u(j).credentialsMode(),
            "plugin-views": ZA.value,
            theme: wn.value,
            storages: (P.config.storages ?? []).map((Ee) => Ee.name),
            "user-name": P.config.userName || "",
            onPluginOp: s[44] || (s[44] = (Ee) => Yl(Ee)),
            onPluginOpen: s[45] || (s[45] = (Ee) => hh(Ee.plugin, Ee.req)),
            onOpenTag: rE,
            onClose: Db,
            onShareCreated: nC,
            onManagePermissions: uC,
            onToast: tt,
            onChanged: s[46] || (s[46] = () => {
              var Ee;
              return An.value ? void ((Ee = Zt.value) == null ? void 0 : Ee.reload()) : void wt();
            })
          }, null, 8, ["api", "nodes", "dir-label", "dir-count", "dir-perm", "held-in", "locale", "narrow", "caller-admin", "sharing", "in-encrypted", "thumb-src", "api-base", "auth-headers", "auth-credentials", "plugin-views", "theme", "storages", "user-name", "onOpenTag", "onShareCreated"])) : O("", !0),
          no.value && xh.value ? (f(), Ge(ZV, {
            key: 3,
            client: u(OE),
            locale: H.value,
            selection: DE.value,
            narrow: $a.value,
            onClose: s[47] || (s[47] = (Ee) => no.value = !1),
            onChanged: s[48] || (s[48] = () => {
              var Ee;
              return An.value ? void ((Ee = Zt.value) == null ? void 0 : Ee.reload()) : void wt();
            })
          }, null, 8, ["client", "locale", "selection", "narrow"])) : O("", !0)
        ], 2),
        bs.value || ou.value ? (f(), h("div", {
          key: 0,
          class: "fe-overlay",
          "data-testid": "explorer-overlay",
          onClick: yt(hd, ["self"])
        }, [
          d("div", {
            class: "fe-overlay__card",
            onClick: s[49] || (s[49] = yt(() => {
            }, ["stop"]))
          }, [
            bs.value ? (f(), Ge(SJ, {
              key: 0,
              config: ne.value,
              closable: "",
              onClose: hd,
              onError: jE
            }, null, 8, ["config"])) : (f(), h(Te, { key: 1 }, [
              d("header", Vse, [
                d("h2", jse, y(u(_)("sidenav.apikeys")), 1),
                d("button", {
                  type: "button",
                  class: "fe-overlay__close",
                  title: u(_)("overlay.close"),
                  "aria-label": u(_)("overlay.close"),
                  onClick: hd
                }, " × ", 8, qse)
              ]),
              Ze(MT, {
                config: ne.value,
                full: ""
              }, null, 8, ["config"])
            ], 64))
          ])
        ])) : O("", !0),
        Do.value ? (f(), h("div", Wse, [
          d("div", Yse, [
            d("span", {
              class: "fe-icon",
              "aria-hidden": "true",
              innerHTML: u(zt)("upload")
            }, null, 8, Gse),
            d("p", null, y(u(_)("dropzone.hint")), 1)
          ])
        ])) : O("", !0),
        Ze(h8, {
          jobs: jn.value,
          locale: H.value,
          center: u(_u),
          onCancel: $z,
          onDismiss: Tz,
          onRetry: Oz
        }, null, 8, ["jobs", "locale", "center"]),
        Ze(v8, {
          ops: u(De).ops.value,
          locale: H.value,
          center: u(_u),
          "output-mode-of": nE,
          "caller-admin": pa.value,
          onCancel: pz,
          onDismiss: s[50] || (s[50] = (Ee) => u(De).dismiss(Ee)),
          onOpen: iE
        }, null, 8, ["ops", "locale", "center", "caller-admin"]),
        Ze(gQ, {
          center: u(_u),
          locale: H.value,
          narrow: $a.value
        }, null, 8, ["center", "locale", "narrow"]),
        $a.value && Sd.value ? (f(), h("button", {
          key: 2,
          type: "button",
          class: "fe-fab",
          title: u(_)("toolbar.upload"),
          "aria-label": u(_)("toolbar.upload"),
          onClick: Oo
        }, [...s[129] || (s[129] = [
          d("svg", {
            class: "fe-ficon",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2.2",
            "stroke-linecap": "round",
            "aria-hidden": "true",
            focusable: "false"
          }, [
            d("path", { d: "M12 5v14M5 12h14" })
          ], -1)
        ])], 8, Xse)) : O("", !0),
        Cs.value ? (f(), h("div", Jse, [
          s[130] || (s[130] = d("span", {
            class: "fe-keep-strip__icon",
            "aria-hidden": "true"
          }, "⟳", -1)),
          d("span", Zse, y(jC.value), 1),
          Ak.value !== null ? (f(), h("div", Qse, [
            d("div", {
              class: "fe-keep-strip__fill",
              style: Wt({ width: Ak.value + "%" })
            }, null, 4)
          ])) : O("", !0)
        ])) : O("", !0),
        Ze(_l, {
          ref_key: "ctxRef",
          ref: Kh,
          locale: H.value,
          theme: wn.value,
          sheet: ck.value,
          actions: Mk.value,
          onSelect: tz
        }, null, 8, ["locale", "theme", "sheet", "actions"]),
        Ze(u(S), {
          open: Ql.value,
          locale: H.value,
          theme: wn.value,
          api: u(j),
          types: zb.value,
          "current-path": Rt(Xe.value),
          storages: (P.config.storages ?? []).map((Ee) => Ee.name),
          "only-office-ready": !!rr.value,
          "drawio-ready": !!Jl.value,
          "can-configure": pa.value,
          "withheld-words": ((Se = Ve.value) == null ? void 0 : Se.newdoc_withheld) ?? null,
          drafts: sr.value,
          onClose: s[51] || (s[51] = (Ee) => Ql.value = !1),
          onOpenDrafts: yE,
          onCreated: sz,
          onError: s[52] || (s[52] = (Ee) => R("error", { message: Ee.message, context: { op: "newdoc" } }))
        }, null, 8, ["open", "locale", "theme", "api", "types", "current-path", "storages", "only-office-ready", "drawio-ready", "can-configure", "withheld-words", "drafts"]),
        Ze(eie, {
          open: sa.value,
          locale: H.value,
          "encrypted-option": kw.value === "allowed",
          "encrypted-request": kw.value === "request",
          busy: u($E),
          error: u(TE),
          onClose: s[53] || (s[53] = (Ee) => sa.value = !1),
          onSubmit: hz,
          onEncrypted: s[54] || (s[54] = (Ee) => {
            sa.value = !1, yr.value = !0;
          }),
          onRequestEncrypted: rM
        }, null, 8, ["open", "locale", "encrypted-option", "encrypted-request", "busy", "error"]),
        Ze(u(k), {
          open: ld.value,
          locale: H.value,
          count: eu.value.length,
          "suggested-name": gE.value,
          "default-format": kE.value,
          "allowed-formats": tu.value,
          encryption: wE.value,
          busy: wh.value,
          "request-error": Ai.value,
          onClose: s[55] || (s[55] = (Ee) => ld.value = !1),
          onSubmit: uz
        }, null, 8, ["open", "locale", "count", "suggested-name", "default-format", "allowed-formats", "encryption", "busy", "request-error"]),
        Ze(lie, {
          open: ur.value,
          locale: H.value,
          "archive-name": (($e = Ao.value) == null ? void 0 : $e.basename) || "",
          "suggested-folder": _E.value,
          busy: !!Ao.value && cr.value.has(Ao.value.path),
          error: Ai.value,
          onClose: s[56] || (s[56] = (Ee) => ur.value = !1),
          onSubmit: cz
        }, null, 8, ["open", "locale", "archive-name", "suggested-folder", "busy", "error"]),
        Ze(vie, {
          open: cs.value,
          locale: H.value,
          "archive-name": ((ut = dr.value) == null ? void 0 : ut.target.basename) || ((et = Ao.value) == null ? void 0 : et.basename) || "",
          busy: !!dr.value && cr.value.has(dr.value.target.path),
          error: ps.value,
          onClose: fz,
          onSubmit: dz
        }, null, 8, ["open", "locale", "archive-name", "busy", "error"]),
        Ze(Dg, {
          open: ys.value,
          api: Ue,
          "vault-roots": zE.value,
          "vault-from": ME.value,
          locale: H.value,
          mode: ud.value,
          busy: dd.value,
          storages: (P.config.storages ?? []).map((Ee) => Ee.name),
          "start-at": Rt(An.value ? ((Pt = Zt.value) == null ? void 0 : Pt.getPath()) ?? "" : Xe.value),
          moving: ud.value === "move" ? cd.value.filter((Ee) => Ee.type === "dir").map((Ee) => Ee.path) : [],
          onClose: s[57] || (s[57] = (Ee) => ys.value = !1),
          onPick: rz
        }, null, 8, ["open", "api", "vault-roots", "vault-from", "locale", "mode", "busy", "storages", "start-at", "moving"]),
        Ze(u(T), {
          open: yr.value,
          locale: H.value,
          busy: gr.value,
          "escrow-kid": Wa.value,
          existing: $r.value ? $r.value.basename : null,
          "vault-available": ((En = Ve.value) == null ? void 0 : En.e2e_vault) === !0,
          onClose: s[58] || (s[58] = (Ee) => {
            yr.value = !1, $r.value = null;
          }),
          onSubmit: s[59] || (s[59] = (Ee) => $r.value ? OM(Ee) : mM(Ee))
        }, null, 8, ["open", "locale", "busy", "escrow-kid", "existing", "vault-available"]),
        Ze(_ae, {
          open: !!br.value,
          locale: H.value,
          api: u(j),
          path: ((At = br.value) == null ? void 0 : At.path) ?? "",
          kind: ((Ya = br.value) == null ? void 0 : Ya.kind) ?? "folder",
          name: ((vn = br.value) == null ? void 0 : vn.name) ?? "",
          onClose: s[60] || (s[60] = (Ee) => br.value = null),
          onSent: sM
        }, null, 8, ["open", "locale", "api", "path", "kind", "name"]),
        Ze(u(z), {
          open: Ro.value,
          locale: H.value,
          "recovery-key": Io.value,
          "folder-name": No.value,
          "escrow-kid": Wa.value,
          variant: kr.value,
          onClose: VM
        }, null, 8, ["open", "locale", "recovery-key", "folder-name", "escrow-kid", "variant"]),
        Ze(u(A), {
          open: Bi.value,
          locale: H.value,
          level: nf.value,
          "can-raise": EM.value,
          "plain-named": CM.value,
          "escrow-state": Cw.value === "n/a" || Bo.value ? "n/a" : Cw.value,
          busy: co.value,
          onClose: s[61] || (s[61] = (Ee) => Bi.value = !1),
          onRaiseLevel: af,
          onFixNames: af,
          onChangePassword: DM,
          onEscrow: RM
        }, null, 8, ["open", "locale", "level", "can-raise", "plain-named", "escrow-state", "busy"]),
        Ze(u(L), {
          open: Us.value,
          locale: H.value,
          mode: Lm.value,
          "needs-rekey": NM.value,
          vault: nf.value === "vault",
          "has-recovery": u(G_)(on.value),
          "has-escrow": u(rS)(on.value),
          busy: Lu.value,
          error: Ar.value,
          onClose: BM,
          onSubmit: FM
        }, null, 8, ["open", "locale", "mode", "needs-rekey", "vault", "has-recovery", "has-escrow", "busy", "error"]),
        Ze(u(D), {
          open: Qd.value,
          locale: H.value,
          "has-recovery": u(G_)(on.value),
          "escrow-state": u(sS)(on.value, Wa.value),
          "escrow-kid": ((Fi = ($n = on.value) == null ? void 0 : $n.esc) == null ? void 0 : Fi.kid) || Wa.value,
          busy: $m.value,
          error: uo.value,
          onClose: s[62] || (s[62] = (Ee) => Qd.value = !1),
          onSubmit: wM
        }, null, 8, ["open", "locale", "has-recovery", "escrow-state", "escrow-kid", "busy", "error"]),
        Ze(u(U), {
          open: !!u(Mt).encryptTarget.value,
          locale: H.value,
          "file-name": ((Ga = u(Mt).encryptTarget.value) == null ? void 0 : Ga.basename) ?? "",
          busy: u(Mt).encryptBusy.value,
          error: u(Mt).encryptError.value,
          progress: u(Mt).encryptProgress.value,
          "escrow-kid": Wa.value,
          "can-purge": pa.value,
          "not-owner": !!u(Mt).encryptTarget.value && !u(Wp)(u(Mt).encryptTarget.value),
          "owner-name": u(Mt).encryptTarget.value ? u(Tg)(u(Mt).encryptTarget.value) : "",
          onClose: s[63] || (s[63] = (Ee) => u(Mt).closeEncrypt()),
          onSubmit: s[64] || (s[64] = (Ee) => u(Mt).submitEncrypt(Ee))
        }, null, 8, ["open", "locale", "file-name", "busy", "error", "progress", "escrow-kid", "can-purge", "not-owner", "owner-name"]),
        Ze(u(q), {
          open: !!u(Mt).unlockTarget.value,
          locale: H.value,
          intent: u(Mt).unlockIntent.value,
          "file-name": u(Mt).unlockTarget.value ? u(Mt).realName(u(Mt).unlockTarget.value.path) ?? u(Mt).unlockTarget.value.basename : "",
          known: !!u(Mt).unlockTarget.value && !!u(Mt).realName(u(Mt).unlockTarget.value.path),
          "has-recovery": u(Mt).unlockHasRecovery.value,
          busy: u(Mt).unlockBusy.value,
          error: u(Mt).unlockError.value,
          progress: u(Mt).unlockProgress.value,
          "needs-save": u(Mt).unlockNeedsSave.value,
          "escrow-state": u(Mt).unlockEscrow.value,
          "escrow-kid": u(Mt).unlockEscrowKid.value || Wa.value,
          onClose: s[65] || (s[65] = (Ee) => u(Mt).closeUnlock()),
          onSubmit: s[66] || (s[66] = (Ee) => u(Mt).submitUnlock(Ee))
        }, null, 8, ["open", "locale", "intent", "file-name", "known", "has-recovery", "busy", "error", "progress", "needs-save", "escrow-state", "escrow-kid"]),
        Ze(zne, {
          open: !!u(Mt).tooBig.value,
          locale: H.value,
          info: u(Mt).tooBig.value,
          onClose: s[67] || (s[67] = (Ee) => u(Mt).closeTooBig()),
          onDownload: KM
        }, null, 8, ["open", "locale", "info"]),
        Ze(u(L), {
          open: !!u(Mt).pwTarget.value,
          locale: H.value,
          mode: "change",
          subject: "file",
          "needs-rekey": !1,
          "has-recovery": !0,
          "has-escrow": !1,
          busy: u(Mt).pwBusy.value,
          error: u(Mt).pwError.value,
          onClose: s[68] || (s[68] = (Ee) => u(Mt).closePassword()),
          onSubmit: s[69] || (s[69] = (Ee) => u(Mt).submitPassword(Ee))
        }, null, 8, ["open", "locale", "busy", "error"]),
        Ze(Aie, {
          open: to.value,
          locale: H.value,
          "current-name": ((sf = fr.value) == null ? void 0 : sf.basename) || "",
          error: u(SE),
          busy: u(xE),
          onClose: s[70] || (s[70] = (Ee) => to.value = !1),
          onSubmit: mz
        }, null, 8, ["open", "locale", "current-name", "error", "busy"]),
        Ze(ta, {
          open: hu.value,
          title: u(_)("trash.empty_confirm_title"),
          size: "sm",
          onClose: s[72] || (s[72] = (Ee) => hu.value = !1)
        }, {
          actions: mt(() => [
            d("button", {
              type: "button",
              class: "fe-btn",
              onClick: s[71] || (s[71] = (Ee) => hu.value = !1)
            }, y(u(_)("modal.delete.cancel")), 1),
            d("button", {
              type: "button",
              class: "fe-btn fe-btn--danger",
              "data-testid": "trash-empty-confirm",
              disabled: !Ts.value || Ts.value.count === 0,
              onClick: SC
            }, y(u(_)("trash.empty_action")), 9, ale)
          ]),
          default: mt(() => [
            Ts.value ? (f(), h("p", ele, y(Ts.value.summary), 1)) : Cd.value ? (f(), h("p", tle, y(Cd.value), 1)) : (f(), h("p", nle, y(u(_)("trash.empty_counting")), 1))
          ]),
          _: 1
        }, 8, ["open", "title"]),
        Ze(Mie, {
          open: ha.value,
          locale: H.value,
          count: u(le).size.value,
          permanent: Ft.value || yM.value,
          busy: u(AE),
          error: u(EE),
          onClose: s[73] || (s[73] = (Ee) => ha.value = !1),
          onConfirm: yz
        }, null, 8, ["open", "locale", "count", "permanent", "busy", "error"]),
        Ze(u(o), {
          open: la.value,
          locale: H.value,
          file: pn.value,
          theme: wn.value,
          "preview-url": (Ee) => tf(Ee),
          "download-url": (Ee) => Yn.value || Tu.value || u(I).rootOf(Ee) ? tf(Ee) : u(j).downloadUrl(Ee),
          "only-office-base": an.value || Tu.value || Pu.value ? null : rr.value,
          "only-office-config-endpoint": Cb.value,
          "can-configure": pa.value,
          "new-tab-enabled": !an.value && !Tu.value && !Pu.value,
          "save-text-endpoint": an.value || Tu.value || Pu.value ? null : u(j).endpoints.saveText || null,
          "archive-list-endpoint": Pu.value ? null : u(j).endpoints.archiveList || null,
          "open-mode": Ha.value,
          "open-as": CE.value,
          "auth-headers": () => Qn({ "Content-Type": "application/json" }),
          "auth-credentials": u(j).credentialsMode(),
          "drawio-url": Jl.value,
          "pdf-worker-url": P.config.pdfWorkerUrl || null,
          "pdf-save-url": P.config.pdfSaveUrl || null,
          "viewer-base-url": Jk.value,
          index: hn.value.index,
          total: hn.value.total,
          "nav-enabled": hn.value.total > 1,
          "share-enabled": !an.value && !Tu.value && !Pu.value,
          onShare: s[74] || (s[74] = (Ee) => {
            const Gn = Ee ?? pn.value;
            Gn && (si.value = Gn, su.value = void 0, pr.value = !0);
          }),
          "api-base": P.config.apiBase ?? "",
          "drafts-endpoint": sr.value ? u(j).draftsBase : null,
          "app-viewer": gb.value,
          "app-e2e": fM.value,
          "in-office": VA.value,
          api: u(j),
          "user-name": P.config.userName || "",
          storages: (P.config.storages ?? []).map((Ee) => Ee.name),
          onToast: tt,
          onOp: s[75] || (s[75] = (Ee) => Yl(Ee)),
          onNav: nn,
          onDraftSaved: mE,
          onDraftDiscarded: vE,
          onSaved: oe,
          onAppDirty: cM,
          onClose: s[76] || (s[76] = (Ee) => la.value = !1)
        }, null, 8, ["open", "locale", "file", "theme", "preview-url", "download-url", "only-office-base", "only-office-config-endpoint", "can-configure", "new-tab-enabled", "save-text-endpoint", "archive-list-endpoint", "open-mode", "open-as", "auth-headers", "auth-credentials", "drawio-url", "pdf-worker-url", "pdf-save-url", "viewer-base-url", "index", "total", "nav-enabled", "share-enabled", "api-base", "drafts-endpoint", "app-viewer", "app-e2e", "in-office", "api", "user-name", "storages", "onAppDirty"]),
        Ze(noe, {
          open: !!Da.value,
          locale: H.value,
          theme: wn.value,
          name: ((Kw = Da.value) == null ? void 0 : Kw.basename) ?? "",
          kind: YA.value,
          handlers: WA.value,
          current: GA.value,
          remembered: Da.value ? jl(Da.value) : null,
          onCancel: s[77] || (s[77] = (Ee) => Da.value = null),
          onOpen: XA
        }, null, 8, ["open", "locale", "theme", "name", "kind", "handlers", "current", "remembered"]),
        Ze(K0, {
          open: !!Y.value,
          kind: "upload",
          locale: H.value,
          theme: wn.value,
          name: ((Vw = Y.value) == null ? void 0 : Vw.name) ?? "",
          suggested: ((jw = Y.value) == null ? void 0 : jw.suggested) ?? "",
          folder: ((qw = Y.value) == null ? void 0 : qw.folder) ?? "",
          onCancel: s[78] || (s[78] = (Ee) => V(!1)),
          onConfirm: s[79] || (s[79] = (Ee) => V(!0))
        }, null, 8, ["open", "locale", "theme", "name", "suggested", "folder"]),
        Ze(K0, {
          open: !!u(eo).question.value,
          locale: H.value,
          theme: wn.value,
          name: ((Ww = u(eo).question.value) == null ? void 0 : Ww.name) ?? "",
          suggested: ((Yw = u(eo).question.value) == null ? void 0 : Yw.suggested) ?? "",
          folder: ((Gw = u(eo).question.value) == null ? void 0 : Gw.folder) ?? "",
          busy: u(eo).busy.value,
          error: u(eo).error.value,
          onCancel: u(eo).cancel,
          onConfirm: u(eo).confirm
        }, null, 8, ["open", "locale", "theme", "name", "suggested", "folder", "busy", "error", "onCancel", "onConfirm"]),
        La.value ? (f(), Ge(qie, {
          key: `${La.value.plugin}/${La.value.view}`,
          api: u(j),
          locale: H.value,
          theme: wn.value,
          plugin: La.value.plugin,
          view: La.value.view,
          placement: La.value.placement,
          ui: La.value.ui,
          label: La.value.label,
          files: La.value.files,
          "user-name": P.config.userName || "",
          storages: (P.config.storages ?? []).map((Ee) => Ee.name),
          "start-at": Rt(An.value ? ((Xw = Zt.value) == null ? void 0 : Xw.getPath()) ?? "" : Xe.value),
          onClose: s[80] || (s[80] = (Ee) => La.value = null),
          onToast: tt,
          onOp: s[81] || (s[81] = (Ee) => Yl(Ee))
        }, null, 8, ["api", "locale", "theme", "plugin", "view", "placement", "ui", "label", "files", "user-name", "storages", "start-at"])) : O("", !0),
        Nn.value ? (f(), Ge(Vie, {
          key: 5,
          open: UA.value,
          api: u(j),
          locale: H.value,
          theme: wn.value,
          plugin: Nn.value.plugin,
          view: Nn.value.view,
          surface: Nn.value.surface,
          path: Nn.value.path,
          paths: Nn.value.paths,
          size: Nn.value.size,
          label: Nn.value.label,
          storages: (P.config.storages ?? []).map((Ee) => Ee.name),
          "start-at": Rt(An.value ? ((Jw = Zt.value) == null ? void 0 : Jw.getPath()) ?? "" : Xe.value),
          onClose: s[82] || (s[82] = (Ee) => Nn.value = null),
          onOp: s[83] || (s[83] = (Ee) => Yl(Ee)),
          onToast: tt,
          onOpen: s[84] || (s[84] = (Ee) => {
            var Gn;
            return hh(((Gn = Nn.value) == null ? void 0 : Gn.plugin) ?? "", Ee);
          })
        }, null, 8, ["open", "api", "locale", "theme", "plugin", "view", "surface", "path", "paths", "size", "label", "storages", "start-at"])) : O("", !0),
        Ze(uT, {
          open: !!Ti.value,
          locale: H.value,
          theme: wn.value,
          title: Ti.value ? u(Xt)(Ti.value.action.label, H.value) : "",
          message: Ti.value ? u(Xt)(Ti.value.action.confirm, H.value) : "",
          danger: ((Zw = Ti.value) == null ? void 0 : Zw.action.danger) === !0,
          onClose: s[85] || (s[85] = (Ee) => Ti.value = null),
          onConfirm: aE
        }, null, 8, ["open", "locale", "theme", "title", "message", "danger"]),
        pr.value && si.value ? (f(), Ge(u(v), {
          key: 6,
          api: u(j),
          path: si.value.path,
          "is-dir": si.value.type === "dir",
          locale: H.value,
          "share-max-ttl-days": BA.value,
          "initial-tab": su.value,
          "mail-ready": (e_ = (Qw = Ve.value) == null ? void 0 : Qw.mail) == null ? void 0 : e_.ready,
          "can-configure": pa.value,
          perm: si.value.perm || ye.value,
          sharing: mC.value,
          onClose: s[86] || (s[86] = (Ee) => {
            pr.value = !1, su.value = void 0;
          })
        }, null, 8, ["api", "path", "is-dir", "locale", "share-max-ttl-days", "initial-tab", "mail-ready", "can-configure", "perm", "sharing"])) : O("", !0),
        Ze(Rr, { name: "fe-modal" }, {
          default: mt(() => [
            ls.value ? (f(), h("div", {
              key: 0,
              class: Re(["fe fe-modal__backdrop fe-recents__backdrop", {
                "fe--theme-light": wn.value === "light",
                "fe--theme-dark": wn.value === "dark"
              }]),
              onClick: s[90] || (s[90] = (Ee) => ls.value = !1)
            }, [
              d("div", {
                class: "fe-recents__panel",
                onClick: s[89] || (s[89] = yt(() => {
                }, ["stop"]))
              }, [
                d("div", ile, [
                  d("strong", null, y(u(_)("recents.title")), 1),
                  d("button", {
                    class: "fe-recents__close",
                    "aria-label": u(_)("recents.close"),
                    onClick: s[87] || (s[87] = (Ee) => ls.value = !1)
                  }, "×", 8, ole)
                ]),
                Ze(t8, {
                  locale: H.value,
                  "api-base": P.config.apiBase ?? "",
                  "auth-headers": () => Qn(),
                  "auth-credentials": u(j).credentialsMode(),
                  limit: 20,
                  "refresh-key": xb.value,
                  onOpen: uE,
                  onContext: cE,
                  onError: s[88] || (s[88] = (Ee) => R("error", { message: Ee, context: { op: "recents" } }))
                }, null, 8, ["locale", "api-base", "auth-headers", "auth-credentials", "refresh-key"])
              ])
            ], 2)) : O("", !0)
          ]),
          _: 1
        }),
        Ze(Rr, { name: "fe-modal" }, {
          default: mt(() => [
            Gl.value && Xl.value && typeof Xl.value.id == "number" ? (f(), h("div", {
              key: 0,
              class: "fe-modal__backdrop",
              onClick: s[95] || (s[95] = (Ee) => Gl.value = !1)
            }, [
              d("div", {
                class: "fe-modal__card fe-modal__card--md",
                onClick: s[94] || (s[94] = yt(() => {
                }, ["stop"]))
              }, [
                d("header", rle, [
                  d("h2", sle, y(u(_)("tags.title")) + " - " + y(Xl.value.basename), 1),
                  d("button", {
                    class: "fe-modal__close",
                    "aria-label": u(_)("tags.close"),
                    onClick: s[91] || (s[91] = (Ee) => Gl.value = !1)
                  }, "×", 8, lle)
                ]),
                d("div", ule, [
                  Ze(wx, {
                    "node-id": Xl.value.id,
                    locale: H.value,
                    "api-base": P.config.apiBase ?? "",
                    "auth-headers": () => Qn(),
                    "auth-credentials": u(j).credentialsMode(),
                    onOpen: s[92] || (s[92] = (Ee) => {
                    }),
                    onError: s[93] || (s[93] = (Ee) => R("error", { message: Ee, context: { op: "tags" } }))
                  }, null, 8, ["node-id", "locale", "api-base", "auth-headers", "auth-credentials"])
                ])
              ])
            ])) : O("", !0)
          ]),
          _: 1
        }),
        Ze(u(x), {
          open: ru.value,
          locale: H.value,
          theme: wn.value,
          "initial-query": jb.value,
          "folder-label": qb.value,
          "path-base": Hb.value,
          "content-search": YE.value,
          count: XE,
          "known-tags": Ub.value,
          onClose: s[96] || (s[96] = (Ee) => ru.value = !1),
          onSubmit: ZE
        }, null, 8, ["open", "locale", "theme", "initial-query", "folder-label", "path-base", "content-search", "known-tags"]),
        Ze(u(w), {
          "initial-query": Ch.value,
          open: Od.value,
          locale: H.value,
          files: G.value,
          "view-mode": Pe.value,
          "can-write": li.value && !Qe.value && !Kt.value,
          "can-go-up": xt.value,
          "global-search": zC,
          "hit-can": OC,
          onClose: s[97] || (s[97] = (Ee) => Od.value = !1),
          onOpenHit: PC,
          onDownloadHit: DC,
          onDragHit: RC,
          onWarmHit: LC,
          onDropInside: IC,
          onOpenNode: qa,
          onNavigate: s[98] || (s[98] = (Ee) => wt(Ee)),
          onNewFolder: s[99] || (s[99] = (Ee) => sa.value = !0),
          onUpload: Oo,
          onToggleView: s[100] || (s[100] = (Ee) => uw(wm.value === "list" ? "grid" : wm.value === "grid" ? "gallery" : "list")),
          onOpenTrash: zi,
          onRefresh: hk,
          onGoUp: qe,
          onOpenTheme: s[101] || (s[101] = (Ee) => Vd.value = !0),
          onOpenShortcutSettings: s[102] || (s[102] = (Ee) => wu.value = !0),
          onStartTour: s[103] || (s[103] = (Ee) => gm()),
          "split-enabled": $u.value,
          onTabNew: s[104] || (s[104] = (Ee) => km()),
          onSplitToggle: s[105] || (s[105] = (Ee) => rw())
        }, null, 8, ["initial-query", "open", "locale", "files", "view-mode", "can-write", "can-go-up", "hit-can", "onOpenHit", "onDownloadHit", "onDragHit", "onWarmHit", "onDropInside", "onRefresh", "split-enabled"]),
        Ze(RJ, {
          open: Ld.value,
          locale: H.value,
          onClose: s[106] || (s[106] = (Ee) => Ld.value = !1),
          onCustomize: s[107] || (s[107] = (Ee) => {
            Ld.value = !1, wu.value = !0;
          })
        }, null, 8, ["open", "locale"]),
        id.value ? (f(), Ge(u(c), {
          key: 7,
          modelValue: id.value,
          "onUpdate:modelValue": s[108] || (s[108] = (Ee) => id.value = Ee),
          host: NA
        }, null, 8, ["modelValue"])) : O("", !0),
        u(vt) ? (f(), Ge(Goe, {
          key: 8,
          feed: u(vt),
          locale: H.value,
          onOpen: cn
        }, null, 8, ["feed", "locale"])) : O("", !0),
        Ze(CZ, {
          open: Vd.value,
          locale: H.value,
          theme: wn.value,
          dark: ym.value,
          current: u(jd),
          mode: u(ku),
          "host-mode": e.config.theme || "auto",
          onClose: s[109] || (s[109] = (Ee) => Vd.value = !1),
          onSelect: u(Ez),
          onMode: s[110] || (s[110] = (Ee) => pb(Ee))
        }, null, 8, ["open", "locale", "theme", "dark", "current", "mode", "host-mode", "onSelect"]),
        d("input", {
          ref_key: "fileInputEl",
          ref: Lb,
          type: "file",
          multiple: "",
          class: "fe__file-input",
          onChange: gz
        }, null, 544),
        Ze(Rr, { name: "fe-toast" }, {
          default: mt(() => [
            ma.value ? (f(), h("div", {
              key: 0,
              class: Re(["fe-toast", { "fe-toast--action": !!ma.value.actionLabel }]),
              role: "status",
              onClick: jh
            }, [
              d("span", cle, y(ma.value.message), 1),
              ma.value.actionLabel && ma.value.action ? (f(), h("button", {
                key: 0,
                type: "button",
                class: "fe-toast__action",
                onClick: yt(yC, ["stop"])
              }, y(ma.value.actionLabel), 1)) : O("", !0)
            ], 2)) : O("", !0)
          ]),
          _: 1
        }),
        Ze(u(p), {
          open: ee.value,
          locale: H.value,
          theme: wn.value,
          onClose: s[111] || (s[111] = (Ee) => ee.value = !1)
        }, null, 8, ["open", "locale", "theme"]),
        N.value ? (f(), Ge(u(m), {
          key: 9,
          open: tn.value,
          locale: H.value,
          theme: wn.value,
          chosen: u(W0)(),
          fallback: Lt.value,
          personal: pe.value,
          onPick: xa,
          onClose: s[112] || (s[112] = (Ee) => tn.value = !1)
        }, null, 8, ["open", "locale", "theme", "chosen", "fallback", "personal"])) : O("", !0),
        Ze(u(C), {
          open: wu.value,
          locale: H.value,
          theme: wn.value,
          onClose: s[113] || (s[113] = (Ee) => wu.value = !1)
        }, null, 8, ["open", "locale", "theme"]),
        Ze(u(l), {
          open: ro.value,
          locale: H.value,
          file: Li.value,
          theme: wn.value,
          "preview-url": (Ee) => tf(Ee),
          "download-url": (Ee) => Yn.value || u(I).rootOf(Ee) ? tf(Ee) : u(j).downloadUrl(Ee),
          "only-office-base": an.value ? null : rr.value,
          "only-office-config-endpoint": Cb.value,
          "can-configure": pa.value,
          "auth-headers": () => Qn({ "Content-Type": "application/json" }),
          "auth-credentials": u(j).credentialsMode(),
          "drawio-url": Jl.value,
          "pdf-worker-url": P.config.pdfWorkerUrl || null,
          "viewer-base-url": Jk.value,
          onClose: s[114] || (s[114] = (Ee) => ro.value = !1),
          onNav: Mz,
          onOpenFull: Pz
        }, null, 8, ["open", "locale", "file", "theme", "preview-url", "download-url", "only-office-base", "only-office-config-endpoint", "can-configure", "auth-headers", "auth-credentials", "drawio-url", "pdf-worker-url", "viewer-base-url"]),
        Ze(u(b), {
          open: qd.value,
          locale: H.value,
          root: Tn.value,
          theme: wn.value,
          onClose: Lz
        }, null, 8, ["open", "locale", "root", "theme"])
      ], 42, yre);
    };
  }
}), _le = "/web-apps/apps/api/documents/api.js", xle = "/?embed=1&proto=json", Sle = 1e4;
function $le(e) {
  return e.trim().replace(/\/+$/, "");
}
function Tle(e, t) {
  return new Promise((n) => {
    const a = document.createElement("script");
    let i = !1;
    const o = (c) => {
      i || (i = !0, clearTimeout(l), a.remove(), n(c));
    }, l = setTimeout(() => o("timeout"), t);
    a.async = !0, a.src = e, a.onload = () => o("load"), a.onerror = () => o("error"), document.head.appendChild(a);
  });
}
function Ale(e, t) {
  return new Promise((n) => {
    let a = null;
    try {
      a = new URL(e, window.location.href).origin;
    } catch {
      a = null;
    }
    const i = document.createElement("iframe");
    i.setAttribute("aria-hidden", "true"), i.style.cssText = "position:absolute;inset-inline-start:-9999px;width:1px;height:1px;border:0";
    let o = !1;
    const l = (m) => {
      o || (o = !0, clearTimeout(p), window.removeEventListener("message", c), i.remove(), n(m));
    }, c = (m) => {
      if (a && m.origin !== a) return;
      let v = m.data;
      if (typeof v == "string")
        try {
          v = JSON.parse(v);
        } catch {
          return;
        }
      v && typeof v == "object" && v.event === "init" && l("ready");
    };
    window.addEventListener("message", c);
    const p = setTimeout(() => l("timeout"), t);
    i.src = e, document.body.appendChild(i);
  });
}
async function Ele(e) {
  try {
    return await fetch(e, { mode: "no-cors", cache: "no-store" }), !0;
  } catch {
    return !1;
  }
}
const Cle = {
  loadScript: Tle,
  loadFramed: Ale,
  reachable: Ele,
  hasDocsAPI: () => {
    var e;
    return !!((e = window.DocsAPI) != null && e.DocEditor);
  },
  pageProtocol: () => window.location.protocol,
  now: () => typeof performance < "u" ? performance.now() : Date.now()
};
function zle(e, t) {
  const n = $le(t);
  return n ? e === "onlyoffice" ? n + _le : e === "drawio" ? n + xle : "" : "";
}
async function Qhe(e, t, n = {}) {
  const a = { ...Cle, ...n.deps ?? {} }, i = n.timeoutMs ?? Sle, o = zle(e, t ?? ""), l = e === "onlyoffice" ? "script" : e === "drawio" ? "iframe" : "none";
  if (!o)
    return { service: e, state: "skipped", url: "", ms: 0, mechanism: l };
  if (a.pageProtocol() === "https:" && o.startsWith("http://"))
    return { service: e, state: "blocked-mixed-content", url: o, ms: 0, mechanism: l };
  const c = a.now(), p = () => Math.round(a.now() - c);
  if (l === "script") {
    const m = await a.loadScript(o, i);
    if (m === "timeout") return { service: e, state: "timeout", url: o, ms: p(), mechanism: l };
    if (m === "load")
      return {
        service: e,
        state: a.hasDocsAPI() ? "ok" : "wrong-content",
        url: o,
        ms: p(),
        mechanism: l
      };
    const v = await a.reachable(o);
    return {
      service: e,
      state: v ? "wrong-content" : "unreachable",
      url: o,
      ms: p(),
      mechanism: l
    };
  }
  if (l === "iframe") {
    if (await a.loadFramed(o, i) === "ready") return { service: e, state: "ok", url: o, ms: p(), mechanism: l };
    const v = await a.reachable(o);
    return {
      service: e,
      state: v ? "wrong-content" : "unreachable",
      url: o,
      ms: p(),
      mechanism: l
    };
  }
  return { service: e, state: "skipped", url: "", ms: 0, mechanism: l };
}
const Py = "filex:remote-images";
function o2() {
  return nr() && Qi().remoteImages === "on";
}
function Mle() {
  return Fl() && nr();
}
function eme(e) {
  Zi("remoteImages", e ? "on" : "");
  try {
    window.dispatchEvent(new CustomEvent(Py, { detail: e }));
  } catch {
  }
}
const Ple = {
  class: "fe-remote-ask",
  "data-testid": "remote-image-dialog"
}, Ole = { class: "fe-remote-ask__text" }, Lle = {
  class: "fe-remote-ask__host",
  dir: "ltr",
  "data-testid": "remote-image-host"
}, Dle = {
  key: 0,
  class: "fe-remote-ask__hint",
  "data-testid": "remote-image-hint"
}, tme = /* @__PURE__ */ lt({
  __name: "RemoteImageDialog",
  props: {
    gate: {},
    locale: {},
    theme: {}
  },
  setup(e) {
    const t = e, { t: n } = pt(() => t.locale ?? "en"), a = E(() => t.gate.asking.value), i = E(() => !!a.value && Mle());
    return (o, l) => (f(), Ge(ta, {
      open: !!a.value,
      title: u(n)("viewer.remote_image.title"),
      size: "sm",
      theme: e.theme,
      locale: String(e.locale ?? "en"),
      onClose: l[3] || (l[3] = (c) => e.gate.dismiss())
    }, {
      actions: mt(() => {
        var c, p, m, v;
        return [
          d("button", {
            type: "button",
            class: "fe-btn",
            "data-testid": "remote-image-cancel",
            onClick: l[0] || (l[0] = (x) => e.gate.dismiss())
          }, y(u(n)("common.cancel")), 1),
          (c = a.value) != null && c.whole || (((p = a.value) == null ? void 0 : p.others) ?? 0) > 0 ? (f(), h("button", {
            key: 0,
            type: "button",
            class: Re(["fe-btn", { "fe-btn--primary": (m = a.value) == null ? void 0 : m.whole }]),
            "data-testid": "remote-image-load-all",
            onClick: l[1] || (l[1] = (x) => e.gate.acceptAll())
          }, y(u(n)("viewer.remote_image.load_all")), 3)) : O("", !0),
          (v = a.value) != null && v.whole ? O("", !0) : (f(), h("button", {
            key: 1,
            type: "button",
            class: "fe-btn fe-btn--primary",
            "data-testid": "remote-image-load",
            onClick: l[2] || (l[2] = (x) => e.gate.accept())
          }, y(u(n)("viewer.remote_image.load")), 1))
        ];
      }),
      default: mt(() => {
        var c;
        return [
          d("div", Ple, [
            d("p", Ole, y(u(n)("viewer.remote_image.body")), 1),
            d("p", Lle, y((c = a.value) == null ? void 0 : c.host), 1),
            i.value ? (f(), h("p", Dle, y(u(n)("viewer.remote_image.setting_hint")), 1)) : O("", !0)
          ])
        ];
      }),
      _: 1
    }, 8, ["open", "title", "theme", "locale"]));
  }
}), kA = Symbol("fe-remote-images"), r2 = "[data-remote-image]";
function s2(e) {
  const t = es(e.getAttribute("data-remote-image") ?? "");
  if (!t) return null;
  if (e.namespaceURI === "http://www.w3.org/2000/svg") {
    const a = wT(e.ownerDocument, t.href, (o) => e.getAttribute(`data-remote-${o.toLowerCase()}`)), i = e.getAttribute("transform");
    return i && a.setAttribute("transform", i), e.replaceWith(a), a.querySelector("img");
  }
  const n = e.ownerDocument.createElement("img");
  n.setAttribute("referrerpolicy", "no-referrer");
  for (const a of yT) {
    const i = e.getAttribute(`data-remote-${a}`);
    i !== null && n.setAttribute(a, i);
  }
  return n.setAttribute("src", t.href), e.replaceWith(n), n;
}
function nme(e = () => "en") {
  const { t } = pt(() => e() ?? "en"), n = $(null), a = $(o2()), i = $(!1), o = /* @__PURE__ */ new Set(), l = [];
  function c() {
    const k = [];
    for (const b of l)
      b.value && k.push(...Array.from(b.value.querySelectorAll(r2)));
    return k;
  }
  function p(k) {
    for (const b of c())
      k(b.getAttribute("data-remote-image") ?? "") && s2(b);
  }
  function m(k) {
    return a.value || i.value || o.has(k);
  }
  function v(k) {
    const b = es(k.getAttribute("data-remote-image") ?? "");
    if (!b) return;
    if (m(b.href)) {
      s2(k);
      return;
    }
    const C = c().filter((T) => T.getAttribute("data-remote-image") !== b.href).length;
    n.value = { src: b.href, host: b.host, others: C };
  }
  function x(k) {
    const b = k.target, C = b && typeof b.closest == "function" ? b.closest(r2) : null, T = k.currentTarget;
    return C && (!T || typeof T.contains != "function" || T.contains(C)) ? C : null;
  }
  const w = () => {
    a.value = o2();
  }, S = Jc(w);
  return typeof window < "u" && window.addEventListener(Py, w), Zo() && Tt(() => {
    S(), typeof window < "u" && window.removeEventListener(Py, w);
  }), Je(a, (k) => {
    k && (n.value = null, p(() => !0));
  }), {
    asking: n,
    settingOn: a,
    allLoaded: E(() => a.value || i.value),
    askWhole(k) {
      const b = k.map((C) => es(C)).find((C) => !!C);
      !b || a.value || i.value || (n.value = { src: b.href, host: b.host, others: Math.max(0, k.length - 1), whole: !0 });
    },
    policy: () => ({ label: t("viewer.remote_image.label"), load: m }),
    watchRoot(k) {
      l.push(k);
    },
    onClick(k) {
      const b = x(k);
      b && (k.preventDefault(), k.stopPropagation(), v(b));
    },
    onKeydown(k) {
      if (k.key !== "Enter" && k.key !== " ") return;
      const b = x(k);
      b && (k.preventDefault(), k.stopPropagation(), v(b));
    },
    accept() {
      const k = n.value;
      n.value = null, k && (o.add(k.src), p((b) => b === k.src));
    },
    acceptAll() {
      n.value = null, i.value = !0, p(() => !0);
    },
    dismiss() {
      n.value = null;
    },
    reset() {
      n.value = null, i.value = !1, o.clear();
    }
  };
}
function ame(e) {
  Wo(kA, e);
}
function ime() {
  return Zo() ? bi(kA, null) : null;
}
function ome(e) {
  return e ? e.replace(/diagnose$/, "session") : null;
}
async function rme(e, t, n) {
  try {
    const a = await e(t, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ action: "state", ...n })
    });
    if (!a.ok) return null;
    const i = await a.json();
    return { stale: i.stale === !0, known: i.known === !0 };
  } catch {
    return null;
  }
}
function sme(e, t) {
  return e || t.pending ? "ask" : "reload";
}
function lme(e, t) {
  return /(^|\/|:\/\/)\.filex-open\//.test(e) ? t.replace(/^[0-9a-f]{12}-/, "") : t;
}
const Rle = {
  viewBox: "0 0 32 32",
  "aria-hidden": "true"
}, l2 = /* @__PURE__ */ lt({
  __name: "LogoMark",
  setup(e) {
    return (t, n) => (f(), h("svg", Rle, [...n[0] || (n[0] = [
      d("rect", {
        width: "32",
        height: "32",
        rx: "7",
        fill: "var(--fe-primary, #2f6ceb)"
      }, null, -1),
      d("path", {
        d: "M7 11a2 2 0 0 1 2-2h5l2 2h7a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2V11z",
        fill: "none",
        stroke: "#fff",
        "stroke-width": "1.8",
        "stroke-linejoin": "round"
      }, null, -1),
      d("path", {
        d: "M11.5 17.5l3 2.5 5.5-6",
        fill: "none",
        stroke: "#fff",
        "stroke-width": "1.8",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1)
    ])]));
  }
});
function ume(e) {
  return e.trim().toLowerCase();
}
const Ile = 250;
function cme(e, t = Ile) {
  let n = 0, a = null;
  return (i) => {
    const o = ++n;
    return a && (clearTimeout(a.timer), a.resolve(null), a = null), new Promise((l) => {
      a = { timer: setTimeout(() => {
        a = null, e(i).then(
          (p) => l(o === n ? p ?? {} : null),
          () => l(null)
        );
      }, t), resolve: l };
    });
  };
}
function dme(e) {
  var n;
  let t = (n = e == null ? void 0 : e.response) == null ? void 0 : n.data;
  if (!t) {
    const a = e == null ? void 0 : e.detail;
    if (typeof a == "string" && a.trim().startsWith("{"))
      try {
        t = JSON.parse(a);
      } catch {
        t = void 0;
      }
  }
  return !t || typeof t.field != "string" || typeof t.message != "string" ? null : { field: t.field, message: t.message };
}
async function Nle(e, { maxPx: t, maxBytes: n }) {
  const a = await Ble(e), i = Math.min(a.width, a.height), o = Math.min(t, i), l = document.createElement("canvas");
  l.width = o, l.height = o;
  const c = l.getContext("2d");
  if (!c) throw new Error("canvas unavailable");
  c.fillStyle = "#ffffff", c.fillRect(0, 0, o, o), c.drawImage(
    a,
    (a.width - i) / 2,
    (a.height - i) / 2,
    i,
    i,
    0,
    0,
    o,
    o
  );
  for (const p of [0.85, 0.7, 0.55, 0.4]) {
    const m = l.toDataURL("image/jpeg", p);
    if (m.length <= n) return m;
  }
  if (o > 64)
    return Nle(e, { maxPx: Math.floor(o / 2), maxBytes: n });
  throw new Error("image too large");
}
async function Ble(e) {
  if (typeof createImageBitmap == "function")
    return createImageBitmap(e);
  const t = URL.createObjectURL(e);
  try {
    return await new Promise((n, a) => {
      const i = new Image();
      i.onload = () => n(i), i.onerror = () => a(new Error("decode failed")), i.src = t;
    });
  } finally {
    URL.revokeObjectURL(t);
  }
}
const fme = [
  "file.uploaded",
  "file.updated",
  "file.upload_failed",
  "file.infected",
  "file.deleted",
  "file.trashed",
  "file.moved",
  "archive.created",
  "archive.extracted",
  "share.created",
  "drop.received",
  "comment.added",
  "e2e.escrow_used",
  "e2e.password_changed",
  "e2e.request_created",
  "e2e.request_decided",
  "plugin.notice",
  // One person's held notifications, told together (backend notify/digest.go).
  // A target receives it only when it ticks it; the person's own switch mutes
  // their digests, and it has no "urgent" switch of its own (DIGEST_EVENT).
  "notification.digest"
], pme = "notification.digest";
function wA(e) {
  return e.replace(/\./g, "_");
}
function hme(e) {
  return `webhooks.events.${wA(e)}`;
}
function mme(e) {
  return `userSettings.notifications.events.${wA(e)}`;
}
const Fle = "filex.notify.push";
function u2(e) {
  const t = e.replace(/-/g, "+").replace(/_/g, "/").replace(/=+$/, ""), n = t + "=".repeat((4 - t.length % 4) % 4), a = atob(n), i = new Uint8Array(a.length);
  for (let o = 0; o < a.length; o++) i[o] = a.charCodeAt(o);
  return i;
}
const Ule = [
  [/Edg(e|A|iOS)?\//, "Edge"],
  [/OPR\/|Opera/, "Opera"],
  [/SamsungBrowser\//, "Samsung Internet"],
  [/Firefox\/|FxiOS\//, "Firefox"],
  [/Chrome\/|CriOS\//, "Chrome"],
  [/Safari\//, "Safari"]
], Hle = [
  [/iPhone/, "iPhone"],
  [/iPad/, "iPad"],
  [/Android/, "Android"],
  [/CrOS/, "ChromeOS"],
  [/Windows/, "Windows"],
  [/Mac OS X|Macintosh/, "macOS"],
  [/Linux/, "Linux"]
];
function Kle(e) {
  const t = (n) => {
    var a;
    return ((a = n.find(([i]) => i.test(e))) == null ? void 0 : a[1]) ?? "";
  };
  return [t(Ule), t(Hle)].filter(Boolean).join(" · ");
}
async function Vle(e) {
  const t = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(e));
  return Array.from(new Uint8Array(t), (n) => n.toString(16).padStart(2, "0")).join("");
}
function jle() {
  try {
    return typeof localStorage > "u" ? null : localStorage;
  } catch {
    return null;
  }
}
function c2(e, t) {
  var i;
  const n = (i = e.options) == null ? void 0 : i.applicationServerKey;
  if (!n) return !1;
  const a = new Uint8Array(n);
  if (a.length !== t.length) return !1;
  for (let o = 0; o < t.length; o++) if (a[o] !== t[o]) return !1;
  return !0;
}
function qle(e, t) {
  var a, i;
  const n = e.toJSON();
  return {
    endpoint: n.endpoint ?? e.endpoint,
    keys: { p256dh: ((a = n.keys) == null ? void 0 : a.p256dh) ?? "", auth: ((i = n.keys) == null ? void 0 : i.auth) ?? "" },
    label: t
  };
}
async function Wle(e) {
  if (!e || !e.pushManager) return null;
  if (e.active) return e;
  const t = e.installing ?? e.waiting;
  return t ? (await new Promise((n) => {
    const a = setTimeout(n, 1e4);
    t.addEventListener("statechange", () => {
      t.state === "activated" && (clearTimeout(a), n());
    });
  }), e.active ? e : null) : null;
}
function vme(e, t) {
  const n = t.storage === void 0 ? jle() : t.storage, a = t.userId ? `${Fle}.${t.userId}` : "", i = t.sha256 ?? Vle, o = t.userAgent ?? (typeof navigator > "u" ? "" : navigator.userAgent ?? "");
  let l = null;
  const c = () => t.notification !== void 0 ? t.notification : typeof window < "u" && "Notification" in window ? window.Notification : null, p = () => t.supported ? t.supported() : typeof window < "u" && "PushManager" in window && typeof navigator < "u" && "serviceWorker" in navigator && c() !== null, m = () => {
    const D = c();
    return !D || !p() ? "unsupported" : D.permission ?? "default";
  }, v = () => {
    if (!a || !n) return !1;
    try {
      return n.getItem(a) === "1";
    } catch {
      return !1;
    }
  }, x = (D) => {
    if (!(!a || !n))
      try {
        D ? n.setItem(a, "1") : n.removeItem(a);
      } catch {
      }
  }, w = async () => {
    try {
      l = await e.status();
    } catch {
      l = null;
    }
    return l;
  }, S = async () => {
    if (!p()) return null;
    try {
      const D = await t.registration();
      return D != null && D.pushManager ? await D.pushManager.getSubscription() : null;
    } catch {
      return null;
    }
  }, k = async (D) => {
    const U = await Wle(await t.registration());
    if (!U) throw new Error("no service worker");
    const q = u2(D);
    let P = await U.pushManager.getSubscription();
    P && !c2(P, q) && (await P.unsubscribe().catch(() => !1), P = null), P || (P = await U.pushManager.subscribe({ userVisibleOnly: !0, applicationServerKey: q })), await e.subscribe(qle(P, Kle(o)));
  };
  async function b() {
    var R;
    const D = await w();
    let U = null;
    const q = D ? await S() : null;
    if (q && D)
      try {
        const W = await i(q.endpoint);
        U = ((R = D.devices.find((N) => N.endpoint_hash === W)) == null ? void 0 : R.id) ?? null;
      } catch {
        U = null;
      }
    const P = m();
    return { supported: p(), permission: P, status: D, on: U !== null && P === "granted", thisDevice: U };
  }
  async function C() {
    const D = c();
    if (!D || !p()) return b();
    let U = D.permission;
    if (U === "default") {
      const P = await Promise.resolve(D.requestPermission());
      U = typeof P == "string" ? P : D.permission;
    }
    if (U !== "granted") return b();
    const q = l ?? await w();
    return !(q != null && q.available) || !q.public_key || (await k(q.public_key), x(!0)), b();
  }
  async function T() {
    x(!1);
    const D = await S();
    return D && (await e.forget(D.endpoint).catch(() => {
    }), await D.unsubscribe().catch(() => !1)), b();
  }
  async function A(D) {
    const U = await b();
    if (await e.remove(D), U.thisDevice === D) {
      x(!1);
      const q = await S();
      await (q == null ? void 0 : q.unsubscribe().catch(() => !1));
    }
    return b();
  }
  async function L() {
    if (!v() || m() !== "granted") return;
    const D = await w();
    if (!(!(D != null && D.available) || !D.public_key))
      try {
        const U = await S();
        if (U && c2(U, u2(D.public_key))) {
          const q = await i(U.endpoint);
          if (D.devices.some((P) => P.endpoint_hash === q)) return;
        }
        await k(D.public_key);
      } catch {
      }
  }
  async function z() {
    const D = await S();
    D && (await e.forget(D.endpoint).catch(() => {
    }), await D.unsubscribe().catch(() => !1));
  }
  return {
    state: b,
    enable: C,
    disable: T,
    remove: A,
    test: () => e.test(),
    reconcile: L,
    forgetDevice: z
  };
}
function Or(e) {
  return !e.sections && typeof e.href == "string";
}
function Yle(e) {
  const t = [];
  for (const n of e) {
    if (Or(n)) {
      t.push(n);
      continue;
    }
    const a = (n.sections ?? []).filter((i) => i.items.length > 0);
    a.length > 0 && t.push({ ...n, sections: a });
  }
  return t;
}
function Gle(e) {
  return Or(e) ? e.active === !0 : (e.sections ?? []).some((t) => t.items.some((n) => n.active === !0));
}
function Xle(e, t, n) {
  if (n <= 0) return null;
  switch (e) {
    case "ArrowDown":
      return Math.min(t + 1, n - 1);
    case "ArrowUp":
      return Math.max(t - 1, 0);
    case "Home":
      return 0;
    case "End":
      return n - 1;
    default:
      return null;
  }
}
function Jle(e, t, n, a = "ltr") {
  if (n <= 0) return null;
  const i = Yf(e, a);
  return i !== 0 ? (t + i + n) % n : e === "Home" ? 0 : e === "End" ? n - 1 : null;
}
function Zle(e) {
  return e.button === 0 && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey && !e.defaultPrevented;
}
const Qle = ["aria-label"], eue = {
  key: 0,
  class: "fx-mega__bar"
}, tue = ["href", "aria-current", "data-mega-top", "data-testid", "onClick", "onKeydown"], nue = ["aria-expanded", "aria-controls", "data-mega-top", "data-testid", "onClick", "onKeydown"], aue = ["id", "data-mega-panel", "data-testid", "onKeydown"], iue = ["data-testid"], oue = ["id"], rue = ["aria-labelledby"], sue = ["href", "aria-current", "data-testid", "onClick"], lue = {
  class: "fx-mega__icon",
  "aria-hidden": "true"
}, uue = ["innerHTML"], cue = { class: "fx-mega__text" }, due = { class: "fx-mega__label" }, fue = {
  key: 0,
  class: "fx-mega__hint"
}, pue = {
  key: 1,
  class: "fx-mega__list"
}, hue = ["href", "aria-current", "data-testid", "onClick"], mue = {
  class: "fx-mega__icon",
  "aria-hidden": "true"
}, vue = { class: "fx-mega__text" }, yue = { class: "fx-mega__label" }, gue = ["aria-labelledby", "data-testid"], bue = ["id"], kue = ["data-testid"], wue = ["id"], _ue = ["aria-labelledby"], xue = ["href", "aria-current", "data-testid", "onClick"], Sue = {
  class: "fx-mega__icon",
  "aria-hidden": "true"
}, $ue = ["innerHTML"], Tue = { class: "fx-mega__text" }, Aue = { class: "fx-mega__label" }, yme = /* @__PURE__ */ lt({
  __name: "MegaMenu",
  props: {
    entries: {},
    label: {},
    mode: { default: "bar" }
  },
  emits: ["navigate"],
  setup(e, { emit: t }) {
    const n = e, a = t, i = `fx-mega-${Math.random().toString(36).slice(2, 10)}`, o = E(() => Yle(n.entries)), l = $(null), c = $(null), p = (U) => `${i}-${U.id}`, m = (U, q) => `${i}-${U.id}-${q}`;
    function v() {
      c.value = null;
    }
    function x(U) {
      c.value = c.value === U ? null : U;
    }
    function w() {
      var U;
      return Array.from(((U = l.value) == null ? void 0 : U.querySelectorAll("[data-mega-top]")) ?? []);
    }
    function S(U) {
      var P;
      const q = (P = l.value) == null ? void 0 : P.querySelector(`[data-mega-panel="${U}"]`);
      return Array.from((q == null ? void 0 : q.querySelectorAll("a.fx-mega__item")) ?? []);
    }
    function k(U) {
      var q;
      return ((q = l.value) == null ? void 0 : q.querySelector(`[data-mega-top="${U}"]`)) ?? null;
    }
    async function b(U, q) {
      var R;
      c.value = U, await Gt();
      const P = S(U);
      (R = q === "first" ? P[0] : P[P.length - 1]) == null || R.focus();
    }
    function C(U, q, P) {
      var N;
      const R = w(), W = Jle(U.key, q, R.length, ei(l.value));
      if (W !== null) {
        U.preventDefault(), v(), (N = R[W]) == null || N.focus();
        return;
      }
      Or(P) || (U.key === "ArrowDown" ? (U.preventDefault(), b(P.id, "first")) : U.key === "ArrowUp" ? (U.preventDefault(), b(P.id, "last")) : U.key === "Escape" && c.value === P.id && (U.preventDefault(), v()));
    }
    function T(U, q) {
      var N, J, H;
      if (U.key === "Escape") {
        U.preventDefault(), U.stopPropagation(), v(), (N = k(q.id)) == null || N.focus();
        return;
      }
      const P = S(q.id), R = P.indexOf(document.activeElement);
      if (R < 0) return;
      if (U.key === "ArrowUp" && R === 0) {
        U.preventDefault(), (J = k(q.id)) == null || J.focus();
        return;
      }
      const W = Xle(U.key, R, P.length);
      W !== null && (U.preventDefault(), (H = P[W]) == null || H.focus());
    }
    function A(U, q) {
      !q.href || !Zle(U) || (U.preventDefault(), v(), a("navigate", { id: q.id, href: q.href }));
    }
    function L(U) {
      const q = U.relatedTarget;
      q && l.value && !l.value.contains(q) && v();
    }
    function z(U) {
      if (c.value === null) return;
      const q = U.target;
      q && l.value && !l.value.contains(q) && v();
    }
    jt(() => document.addEventListener("pointerdown", z, !0)), Tt(() => document.removeEventListener("pointerdown", z, !0));
    const D = E(
      () => o.value.flatMap(
        (U) => Or(U) ? U.active ? [U.id] : [] : (U.sections ?? []).flatMap((q) => q.items.filter((P) => P.active).map((P) => P.id))
      ).join("|")
    );
    return Je(D, v), (U, q) => (f(), h("nav", {
      ref_key: "root",
      ref: l,
      class: Re(["fx-mega", `fx-mega--${e.mode}`]),
      "aria-label": e.label,
      "data-testid": "mega-menu",
      onFocusout: L
    }, [
      e.mode === "bar" ? (f(), h("ul", eue, [
        (f(!0), h(Te, null, nt(o.value, (P, R) => {
          var W;
          return f(), h("li", {
            key: P.id,
            class: Re(["fx-mega__top", !u(Or)(P) && (((W = P.sections) == null ? void 0 : W.length) ?? 0) <= 1 && "fx-mega__top--narrow"])
          }, [
            u(Or)(P) ? (f(), h("a", {
              key: 0,
              href: P.href,
              class: Re(["fx-mega__toplink", P.active && "is-current"]),
              "aria-current": P.active ? "page" : void 0,
              "data-mega-top": P.id,
              "data-testid": `nav-${P.id}`,
              onClick: (N) => A(N, P),
              onKeydown: (N) => C(N, R, P)
            }, y(P.label), 43, tue)) : (f(), h(Te, { key: 1 }, [
              d("button", {
                type: "button",
                class: Re(["fx-mega__topbtn", c.value === P.id && "is-open", u(Gle)(P) && "is-current"]),
                "aria-expanded": c.value === P.id ? "true" : "false",
                "aria-controls": p(P),
                "data-mega-top": P.id,
                "data-testid": `nav-top-${P.id}`,
                onClick: (N) => x(P.id),
                onKeydown: (N) => C(N, R, P)
              }, [
                d("span", null, y(P.label), 1),
                q[0] || (q[0] = d("svg", {
                  class: "fx-mega__chev",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "aria-hidden": "true"
                }, [
                  d("path", { d: "m6 9 6 6 6-6" })
                ], -1))
              ], 42, nue),
              ln(d("div", {
                id: p(P),
                class: "fx-mega__panel",
                "data-mega-panel": P.id,
                "data-testid": `nav-panel-${P.id}`,
                onKeydown: (N) => T(N, P)
              }, [
                (f(!0), h(Te, null, nt(P.sections, (N) => (f(), h("div", {
                  key: N.id,
                  class: "fx-mega__section",
                  "data-testid": `nav-group-${N.id}`
                }, [
                  d("p", {
                    id: m(P, N.id),
                    class: "fx-mega__heading"
                  }, y(N.label), 9, oue),
                  d("ul", {
                    class: "fx-mega__items",
                    "aria-labelledby": m(P, N.id)
                  }, [
                    (f(!0), h(Te, null, nt(N.items, (J) => (f(), h("li", {
                      key: J.id
                    }, [
                      d("a", {
                        href: J.href,
                        class: Re(["fx-mega__item", J.active && "is-current"]),
                        "aria-current": J.active ? "page" : void 0,
                        "data-testid": `nav-${J.id}`,
                        onClick: (H) => A(H, J)
                      }, [
                        d("span", lue, [
                          J.iconName ? (f(), h("span", {
                            key: 0,
                            class: "fx-mega__glyph",
                            innerHTML: u(zt)(J.iconName)
                          }, null, 8, uue)) : J.icon ? (f(), Ge(Ki(J.icon), {
                            key: 1,
                            class: "fx-mega__glyph"
                          })) : O("", !0)
                        ]),
                        d("span", cue, [
                          d("span", due, y(J.label), 1),
                          J.hint ? (f(), h("span", fue, y(J.hint), 1)) : O("", !0)
                        ])
                      ], 10, sue)
                    ]))), 128))
                  ], 8, rue)
                ], 8, iue))), 128))
              ], 40, aue), [
                [w2, c.value === P.id]
              ])
            ], 64))
          ], 2);
        }), 128))
      ])) : (f(), h("div", pue, [
        (f(!0), h(Te, null, nt(o.value, (P) => (f(), h(Te, {
          key: P.id
        }, [
          u(Or)(P) ? (f(), h("a", {
            key: 0,
            href: P.href,
            class: Re(["fx-mega__item", "fx-mega__item--top", P.active && "is-current"]),
            "aria-current": P.active ? "page" : void 0,
            "data-testid": `nav-${P.id}`,
            onClick: (R) => A(R, P)
          }, [
            d("span", mue, [
              P.icon ? (f(), Ge(Ki(P.icon), {
                key: 0,
                class: "fx-mega__glyph"
              })) : O("", !0)
            ]),
            d("span", vue, [
              d("span", yue, y(P.label), 1)
            ])
          ], 10, hue)) : (f(), h("section", {
            key: 1,
            class: "fx-mega__group",
            "aria-labelledby": p(P),
            "data-testid": `nav-top-${P.id}`
          }, [
            d("p", {
              id: p(P),
              class: "fx-mega__grouphead"
            }, y(P.label), 9, bue),
            (f(!0), h(Te, null, nt(P.sections, (R) => (f(), h("div", {
              key: R.id,
              class: "fx-mega__section",
              "data-testid": `nav-group-${R.id}`
            }, [
              d("p", {
                id: m(P, R.id),
                class: "fx-mega__heading"
              }, y(R.label), 9, wue),
              d("ul", {
                class: "fx-mega__items",
                "aria-labelledby": m(P, R.id)
              }, [
                (f(!0), h(Te, null, nt(R.items, (W) => (f(), h("li", {
                  key: W.id
                }, [
                  d("a", {
                    href: W.href,
                    class: Re(["fx-mega__item", W.active && "is-current"]),
                    "aria-current": W.active ? "page" : void 0,
                    "data-testid": `nav-${W.id}`,
                    onClick: (N) => A(N, W)
                  }, [
                    d("span", Sue, [
                      W.iconName ? (f(), h("span", {
                        key: 0,
                        class: "fx-mega__glyph",
                        innerHTML: u(zt)(W.iconName)
                      }, null, 8, $ue)) : W.icon ? (f(), Ge(Ki(W.icon), {
                        key: 1,
                        class: "fx-mega__glyph"
                      })) : O("", !0)
                    ]),
                    d("span", Tue, [
                      d("span", Aue, y(W.label), 1)
                    ])
                  ], 10, xue)
                ]))), 128))
              ], 8, _ue)
            ], 8, kue))), 128))
          ], 8, gue))
        ], 64))), 128))
      ]))
    ], 42, Qle));
  }
}), Eue = [
  "page",
  "setting",
  "app",
  "user",
  "group",
  "key",
  "storage",
  "share",
  "file"
], Cue = {
  file: "file",
  user: "user",
  app: "app",
  key: "key",
  group: "group",
  storage: "storage",
  setting: "setting"
}, zue = ["file", "user", "app", "key", "group", "storage", "setting"], Mue = 6, _A = 3, xA = 25;
function d2(e) {
  return yo(e ?? "").split(/\s+/).filter((t) => t.length > 0);
}
function SA(e) {
  const t = (e ?? "").replace(/^\s+/, ""), n = /^([A-Za-z]+)\s*:/.exec(t);
  if (n) {
    const i = n[1].toLowerCase(), o = Cue[i];
    if (o) {
      const l = t.slice(n[0].length).trim();
      return { kind: o, prefix: i, text: l, words: d2(l) };
    }
  }
  const a = t.trim();
  return { kind: null, prefix: "", text: a, words: d2(a) };
}
function f2(e, t) {
  const n = SA(e);
  return t ? `${t}:${n.text}` : n.text;
}
function Pue(e, t) {
  return t === 0 ? !0 : !/[\p{L}\p{N}]/u.test(e[t - 1]);
}
function _f(e, t, n) {
  if (!e) return 0;
  const a = e.indexOf(t);
  return a < 0 ? 0 : a === 0 ? n : Pue(e, a) ? Math.round(n * 0.8) : Math.round(n * 0.5);
}
function Oue(e, t) {
  if (t.length === 0) return 0;
  const n = yo(e.label ?? ""), a = (e.terms ?? []).map((p) => yo(p)), i = (e.aliases ?? []).map((p) => yo(p)), o = yo(e.detail ?? "");
  let l = 0;
  for (const p of t) {
    let m = _f(n, p, 100);
    for (const v of a) m = Math.max(m, _f(v, p, 70));
    for (const v of i) m = Math.max(m, _f(v, p, 50));
    if (m = Math.max(m, _f(o, p, 25)), m <= 0) return e.found ? 1 : -1;
    l += m;
  }
  const c = t.join(" ");
  return n === c ? l += 300 : a.includes(c) ? l += 200 : i.includes(c) ? l += 150 : n.startsWith(c) && (l += 80), l -= Math.min(n.length, 60) / 10, l;
}
function Lue(e, t) {
  if (t.length === 0) return !1;
  const n = t.join(" ");
  return yo(e.label ?? "") === n ? !0 : (e.terms ?? []).some((a) => yo(a) === n);
}
function Due(e, t, n = {}) {
  if (t.words.length === 0) return [];
  const a = /* @__PURE__ */ new Map();
  for (const l of e) {
    if (t.kind && l.kind !== t.kind) continue;
    const c = Oue(l, t.words);
    if (c < 0) continue;
    const p = a.get(l.kind) ?? [];
    p.push({ item: l, score: c }), a.set(l.kind, p);
  }
  const i = [], o = [];
  for (const l of Eue) {
    const c = a.get(l);
    if (!c || c.length === 0) continue;
    c.sort((v, x) => x.score - v.score);
    const p = n[l] ?? (t.kind ? xA : l === "file" ? _A : Mue), m = { kind: l, items: c.slice(0, p).map((v) => v.item), total: c.length };
    (Lue(c[0].item, t.words) ? i : o).push(m);
  }
  return [...i, ...o];
}
function gme(e) {
  return e.flatMap((t) => t.items);
}
const Rue = ["aria-label", "aria-expanded"], Iue = ["innerHTML"], Nue = {
  key: 0,
  class: "fx-psearch__trigger-text"
}, Bue = {
  key: 1,
  class: "fx-psearch__kbd"
}, Fue = ["aria-modal", "aria-label"], Uue = { class: "fx-psearch__field" }, Hue = ["aria-label"], Kue = ["innerHTML"], Vue = ["innerHTML"], jue = ["aria-label", "aria-expanded", "aria-activedescendant", "placeholder"], que = ["aria-label"], Wue = ["innerHTML"], Yue = ["aria-label"], Gue = ["aria-labelledby", "data-testid"], Xue = ["id"], Jue = ["id", "aria-selected", "data-testid", "data-id", "onMouseenter", "onClick"], Zue = {
  class: "fx-psearch__icon",
  "aria-hidden": "true"
}, Que = ["innerHTML"], ece = { class: "fx-psearch__text" }, tce = { class: "fx-psearch__label" }, nce = {
  key: 0,
  class: "fx-psearch__detail"
}, ace = {
  class: "fx-psearch__icon",
  "aria-hidden": "true"
}, ice = ["innerHTML"], oce = { class: "fx-psearch__text" }, rce = { class: "fx-psearch__label" }, sce = {
  class: "fx-psearch__icon",
  "aria-hidden": "true"
}, lce = ["innerHTML"], uce = { class: "fx-psearch__text" }, cce = { class: "fx-psearch__label" }, dce = ["aria-label", "title", "onClick"], fce = ["innerHTML"], pce = {
  key: 0,
  class: "fx-psearch__note"
}, hce = {
  key: 1,
  class: "fx-psearch__note",
  "data-testid": "panel-search-empty"
}, mce = {
  key: 2,
  class: "fx-psearch__note fx-psearch__note--warn",
  role: "alert",
  "data-testid": "panel-search-failed"
}, vce = { class: "fx-psearch__foot" }, yce = { class: "fx-psearch__foot-label" }, gce = ["aria-pressed", "data-testid", "onClick"], bce = {
  class: "fe-sr-only",
  role: "status",
  "aria-live": "polite"
}, p2 = 2, kce = 200, bme = /* @__PURE__ */ lt({
  __name: "PanelSearch",
  props: {
    locale: {},
    compact: { type: Boolean, default: !1 },
    items: {},
    remote: { type: Function, default: void 0 },
    files: { type: Function, default: void 0 },
    recent: { default: void 0 },
    shortcut: { type: Boolean, default: !0 }
  },
  emits: ["choose"],
  setup(e, { expose: t, emit: n }) {
    const a = e, i = n, { t: o } = pt(() => a.locale), l = `fx-psearch-${Math.random().toString(36).slice(2, 10)}`, c = `${l}-list`, p = $(null), m = $(null), v = $(null), x = $(null), w = $(!1), S = $(""), k = $(0), b = $(null), C = $(80), T = E(() => SA(S.value)), A = $([]), L = $([]), z = $(!1), D = $(!1);
    let U, q = 0;
    function P(me) {
      U && clearTimeout(U);
      const De = ++q;
      if (me.text.length < p2 || !a.remote && !a.files) {
        A.value = [], L.value = [], z.value = !1, D.value = !1;
        return;
      }
      z.value = !0, U = setTimeout(() => void R(me, De), kce);
    }
    async function R(me, De) {
      const ot = !!a.remote && me.kind !== "file" && me.kind !== "page" && me.kind !== "setting", ft = !!a.files && (me.kind === null || me.kind === "file"), gt = me.kind === "file" ? xA : _A, [Ut, Xe] = await Promise.allSettled([
        ot && a.remote ? a.remote(me) : Promise.resolve([]),
        ft && a.files ? a.files(me.text, gt) : Promise.resolve([])
      ]);
      De === q && (A.value = Ut.status === "fulfilled" ? Ut.value.map((je) => ({ ...je, found: !0 })) : [], L.value = Xe.status === "fulfilled" ? Xe.value.map((je) => ({ ...je, kind: "file", found: !0 })) : [], D.value = Ut.status === "rejected" || Xe.status === "rejected", z.value = !1);
    }
    Je(S, () => {
      k.value = 0, P(T.value);
    });
    const W = $([]);
    async function N() {
      if (a.recent)
        try {
          W.value = await a.recent.list();
        } catch {
        }
    }
    function J(me) {
      const De = me.trim();
      !De || !a.recent || (W.value = [{ id: `local-${De}`, query: De }, ...W.value.filter((ot) => ot.query !== De)], a.recent.add(De).then(N, () => {
      }));
    }
    async function H(me) {
      var De;
      W.value = W.value.filter((ot) => ot.id !== me.id), k.value >= ue.value.length && (k.value = Math.max(0, ue.value.length - 1));
      try {
        await ((De = a.recent) == null ? void 0 : De.remove(me.id));
      } catch {
        await N();
      }
    }
    async function ne() {
      var me, De;
      W.value = [], k.value = 0;
      try {
        await ((me = a.recent) == null ? void 0 : me.clear());
      } catch {
        await N();
      }
      (De = v.value) == null || De.focus();
    }
    const j = {
      page: "panelsearch.group.page",
      setting: "panelsearch.group.setting",
      app: "panelsearch.group.app",
      user: "panelsearch.group.user",
      group: "panelsearch.group.group",
      key: "panelsearch.group.key",
      storage: "panelsearch.group.storage",
      share: "panelsearch.group.share",
      file: "panelsearch.group.file"
    }, re = E(() => !!a.files && T.value.kind === null && T.value.text.length >= p2), he = E(() => {
      let me = 0;
      const De = [], ot = T.value;
      if (ot.words.length === 0)
        return ot.kind === null && W.value.length && De.push({
          key: "recent",
          heading: o("panelsearch.group.recent"),
          rows: W.value.map((gt) => ({ type: "recent", id: `recent:${gt.id}`, index: me++, entry: gt }))
        }), De;
      const ft = Due([...a.items, ...A.value, ...L.value], ot);
      for (const gt of ft)
        De.push({
          key: gt.kind,
          heading: o(j[gt.kind]),
          rows: gt.items.map((Ut) => ({ type: "item", id: `item:${Ut.id}`, index: me++, item: Ut }))
        });
      if (re.value) {
        const gt = De.find((Xe) => Xe.key === "file"), Ut = { type: "files-all", id: "files-all", index: me++ };
        gt ? gt.rows.push(Ut) : De.push({ key: "file", heading: o(j.file), rows: [Ut] });
      }
      return De;
    }), ue = E(() => he.value.flatMap((me) => me.rows)), ae = (me) => `${l}-opt-${me}`, fe = E(() => ue.value.length && k.value < ue.value.length ? ae(k.value) : void 0), _ = E(() => {
      if (!w.value || T.value.words.length === 0) return "";
      if (z.value) return o("panelsearch.searching");
      const me = ue.value.filter((De) => De.type === "item").length;
      return me === 0 ? o("panelsearch.empty", { q: T.value.text }) : o("panelsearch.count", { n: me });
    }), Q = E(
      () => T.value.words.length > 0 && !z.value && ue.value.every((me) => me.type !== "item")
    );
    function K(me) {
      if (me.kind === "file") {
        const De = me.label ?? "", ot = De.lastIndexOf(".");
        return wa({
          type: me.isDir ? "dir" : "file",
          basename: De,
          extension: !me.isDir && ot > 0 ? De.slice(ot + 1) : ""
        });
      }
      return zt(me.iconName ?? I[me.kind]);
    }
    const I = {
      page: "goto",
      setting: "admin",
      app: "plugin",
      user: "account",
      group: "account",
      key: "lock",
      storage: "connect",
      share: "link",
      file: "open"
    };
    function Y() {
      const me = p.value;
      if (!(!me || typeof window > "u")) {
        if (C.value = Rc([me]), a.compact) {
          b.value = null;
          return;
        }
        b.value = sb(
          me.getBoundingClientRect(),
          rb(),
          { width: 560, gutter: 16, gap: 6, maxHeight: 620, dir: ei(me) }
        );
      }
    }
    const B = E(() => {
      const me = { zIndex: String(C.value) };
      return b.value && (me.top = b.value.top, me.right = b.value.right, me.left = b.value.left, me.width = b.value.width, me.maxHeight = b.value.maxHeight), me;
    });
    async function V(me) {
      var De, ot;
      w.value || (Y(), w.value = !0, N()), typeof me == "string" && (S.value = me), await Gt(), (De = v.value) == null || De.focus(), typeof me != "string" && ((ot = v.value) == null || ot.select());
    }
    function be(me) {
      w.value && (w.value = !1, U && clearTimeout(U), z.value = !1, me && Gt(() => {
        var De;
        return (De = p.value) == null ? void 0 : De.focus();
      }));
    }
    function Fe(me) {
      me.key.length === 1 && !me.ctrlKey && !me.metaKey && !me.altKey && me.key !== " " ? (me.preventDefault(), V(me.key)) : me.key === "ArrowDown" && (me.preventDefault(), V());
    }
    function ze(me) {
      if (me) {
        if (me.type === "recent") {
          S.value = me.entry.query, Gt(() => {
            var De;
            return (De = v.value) == null ? void 0 : De.focus();
          });
          return;
        }
        if (me.type === "files-all") {
          S.value = f2(S.value, "file"), Gt(() => {
            var De;
            return (De = v.value) == null ? void 0 : De.focus();
          });
          return;
        }
        J(S.value), be(!1), i("choose", me.item);
      }
    }
    function Ue(me) {
      S.value = f2(S.value, me), Gt(() => {
        var De;
        return (De = v.value) == null ? void 0 : De.focus();
      });
    }
    function We() {
      S.value = "", Gt(() => {
        var me;
        return (me = v.value) == null ? void 0 : me.focus();
      });
    }
    function $t(me) {
      const De = ue.value.length;
      De && (k.value = (k.value + me + De) % De, Gt(() => {
        var ft;
        const ot = (ft = x.value) == null ? void 0 : ft.querySelector(`#${ae(k.value)}`);
        ot && typeof ot.scrollIntoView == "function" && ot.scrollIntoView({ block: "nearest" });
      }));
    }
    function St(me) {
      switch (me.key) {
        case "ArrowDown":
          me.preventDefault(), $t(1);
          break;
        case "ArrowUp":
          me.preventDefault(), $t(-1);
          break;
        case "Enter":
          if (me.isComposing) return;
          me.preventDefault(), ze(ue.value[k.value] ?? ue.value[0]);
          break;
        case "Escape":
          me.preventDefault(), me.stopPropagation(), be(!0);
          break;
        case "Delete": {
          const De = ue.value[k.value];
          S.value === "" && (De == null ? void 0 : De.type) === "recent" && (me.preventDefault(), H(De.entry));
          break;
        }
      }
    }
    function at(me) {
      var De, ot;
      return me ? !!((De = m.value) != null && De.contains(me) || (ot = p.value) != null && ot.contains(me)) : !1;
    }
    function kt(me) {
      if (a.compact) return;
      const De = me.relatedTarget;
      De && !at(De) && be(!1);
    }
    function ht(me) {
      !w.value || a.compact || at(me.target) || be(!1);
    }
    function Ie(me) {
      var De, ot;
      !a.shortcut || me.defaultPrevented || hx(me, "palette") && (dx(me.target) && !at(me.target) || (me.preventDefault(), w.value ? ((De = v.value) == null || De.focus(), (ot = v.value) == null || ot.select()) : V()));
    }
    function se() {
      w.value && Y();
    }
    jt(() => {
      document.addEventListener("keydown", Ie), document.addEventListener("pointerdown", ht, !0), window.addEventListener("resize", se);
    }), Tt(() => {
      U && clearTimeout(U), document.removeEventListener("keydown", Ie), document.removeEventListener("pointerdown", ht, !0), window.removeEventListener("resize", se);
    });
    const xe = E(() => a.shortcut ? Jy("palette") : "");
    return t({ openPanel: V, close: be }), (me, De) => (f(), h("div", {
      class: Re(["fx-psearch", e.compact ? "fx-psearch--compact" : "fx-psearch--box"])
    }, [
      d("button", {
        ref_key: "trigger",
        ref: p,
        type: "button",
        class: "fx-psearch__trigger",
        "aria-label": u(o)("panelsearch.label"),
        "aria-haspopup": "dialog",
        "aria-expanded": w.value ? "true" : "false",
        "data-testid": "panel-search-open",
        onClick: De[0] || (De[0] = (ot) => w.value ? be(!0) : V()),
        onKeydown: Fe
      }, [
        d("span", {
          class: "fx-psearch__glyph",
          "aria-hidden": "true",
          innerHTML: u(zt)("search")
        }, null, 8, Iue),
        e.compact ? O("", !0) : (f(), h("span", Nue, y(u(o)("panelsearch.trigger")), 1)),
        !e.compact && xe.value ? (f(), h("kbd", Bue, y(xe.value), 1)) : O("", !0)
      ], 40, Rue),
      (f(), Ge(wi, { to: "body" }, [
        w.value ? (f(), h("div", {
          key: 0,
          ref_key: "layer",
          ref: m,
          class: Re(["fx-psearch__layer", e.compact ? "fx-psearch__layer--full" : "fx-psearch__layer--drop"]),
          style: Wt(B.value),
          role: "dialog",
          "aria-modal": e.compact ? "true" : void 0,
          "aria-label": u(o)("panelsearch.label"),
          "data-testid": "panel-search",
          onFocusout: kt
        }, [
          d("div", Uue, [
            e.compact ? (f(), h("button", {
              key: 0,
              type: "button",
              class: "fx-psearch__iconbtn",
              "aria-label": u(o)("panelsearch.close"),
              "data-testid": "panel-search-close",
              onClick: De[1] || (De[1] = (ot) => be(!0))
            }, [
              d("span", {
                class: "fx-psearch__glyph",
                "aria-hidden": "true",
                innerHTML: u(zt)("close")
              }, null, 8, Kue)
            ], 8, Hue)) : (f(), h("span", {
              key: 1,
              class: "fx-psearch__glyph fx-psearch__glyph--field",
              "aria-hidden": "true",
              innerHTML: u(zt)("search")
            }, null, 8, Vue)),
            ln(d("input", {
              ref_key: "inputEl",
              ref: v,
              "onUpdate:modelValue": De[2] || (De[2] = (ot) => S.value = ot),
              type: "text",
              class: "fx-psearch__input",
              role: "combobox",
              "aria-label": u(o)("panelsearch.label"),
              "aria-autocomplete": "list",
              "aria-expanded": ue.value.length > 0 ? "true" : "false",
              "aria-controls": c,
              "aria-activedescendant": fe.value,
              placeholder: u(o)("panelsearch.placeholder"),
              autocomplete: "off",
              autocapitalize: "off",
              spellcheck: "false",
              enterkeyhint: "search",
              "data-testid": "panel-search-input",
              onKeydown: St
            }, null, 40, jue), [
              [_n, S.value]
            ]),
            S.value ? (f(), h("button", {
              key: 2,
              type: "button",
              class: "fx-psearch__iconbtn",
              "aria-label": u(o)("panelsearch.clear"),
              "data-testid": "panel-search-clear",
              onClick: We
            }, [
              d("span", {
                class: "fx-psearch__glyph",
                "aria-hidden": "true",
                innerHTML: u(zt)("close")
              }, null, 8, Wue)
            ], 8, que)) : O("", !0)
          ]),
          d("div", {
            id: c,
            ref_key: "listEl",
            ref: x,
            class: "fx-psearch__list",
            role: "listbox",
            "aria-label": u(o)("panelsearch.results")
          }, [
            (f(!0), h(Te, null, nt(he.value, (ot) => (f(), h("div", {
              key: ot.key,
              class: "fx-psearch__group",
              role: "group",
              "aria-labelledby": `${l}-h-${ot.key}`,
              "data-testid": `panel-search-group-${ot.key}`
            }, [
              d("div", {
                id: `${l}-h-${ot.key}`,
                class: "fx-psearch__heading",
                role: "presentation"
              }, y(ot.heading), 9, Xue),
              (f(!0), h(Te, null, nt(ot.rows, (ft) => (f(), h("div", {
                id: ae(ft.index),
                key: ft.id,
                class: Re(["fx-psearch__row", ft.index === k.value && "is-active"]),
                role: "option",
                "aria-selected": ft.index === k.value ? "true" : "false",
                "data-testid": ft.type === "item" ? `panel-search-row-${ft.item.kind}` : `panel-search-${ft.type}`,
                "data-id": ft.type === "item" ? ft.item.id : void 0,
                onMousedown: De[3] || (De[3] = yt(() => {
                }, ["prevent"])),
                onMouseenter: (gt) => k.value = ft.index,
                onClick: (gt) => ze(ft)
              }, [
                ft.type === "item" ? (f(), h(Te, { key: 0 }, [
                  d("span", Zue, [
                    ft.item.icon && ft.item.kind !== "file" ? (f(), Ge(Ki(ft.item.icon), {
                      key: 0,
                      class: "fx-psearch__svg"
                    })) : (f(), h("span", {
                      key: 1,
                      class: "fx-psearch__svg",
                      innerHTML: K(ft.item)
                    }, null, 8, Que))
                  ]),
                  d("span", ece, [
                    d("span", tce, [
                      d("bdi", null, y(ft.item.label), 1)
                    ]),
                    ft.item.detail ? (f(), h("span", nce, [
                      d("bdi", null, y(ft.item.detail), 1)
                    ])) : O("", !0)
                  ])
                ], 64)) : ft.type === "files-all" ? (f(), h(Te, { key: 1 }, [
                  d("span", ace, [
                    d("span", {
                      class: "fx-psearch__svg",
                      innerHTML: u(zt)("search")
                    }, null, 8, ice)
                  ]),
                  d("span", oce, [
                    d("span", rce, y(u(o)("panelsearch.files_all", { q: T.value.text })), 1)
                  ])
                ], 64)) : (f(), h(Te, { key: 2 }, [
                  d("span", sce, [
                    d("span", {
                      class: "fx-psearch__svg",
                      innerHTML: u(zt)("search")
                    }, null, 8, lce)
                  ]),
                  d("span", uce, [
                    d("span", cce, [
                      d("bdi", null, y(ft.entry.query), 1)
                    ])
                  ]),
                  d("button", {
                    type: "button",
                    class: "fx-psearch__iconbtn fx-psearch__remove",
                    tabindex: "-1",
                    "aria-label": u(o)("panelsearch.recent_remove"),
                    title: u(o)("panelsearch.recent_remove"),
                    "data-testid": "panel-search-recent-remove",
                    onClick: yt((gt) => H(ft.entry), ["stop"])
                  }, [
                    d("span", {
                      class: "fx-psearch__glyph",
                      "aria-hidden": "true",
                      innerHTML: u(zt)("close")
                    }, null, 8, fce)
                  ], 8, dce)
                ], 64))
              ], 42, Jue))), 128))
            ], 8, Gue))), 128)),
            z.value && ue.value.length === 0 ? (f(), h("p", pce, y(u(o)("panelsearch.searching")), 1)) : Q.value ? (f(), h("p", hce, y(u(o)("panelsearch.empty", { q: T.value.text })), 1)) : O("", !0),
            D.value ? (f(), h("p", mce, y(u(o)("panelsearch.failed")), 1)) : O("", !0)
          ], 8, Yue),
          d("div", vce, [
            d("span", yce, y(u(o)("panelsearch.prefixes")), 1),
            (f(!0), h(Te, null, nt(u(zue), (ot) => (f(), h("button", {
              key: ot,
              type: "button",
              class: Re(["fx-psearch__chip", T.value.prefix === ot && "is-on"]),
              "aria-pressed": T.value.prefix === ot ? "true" : "false",
              "data-testid": `panel-search-prefix-${ot}`,
              onMousedown: De[4] || (De[4] = yt(() => {
              }, ["prevent"])),
              onClick: (ft) => Ue(T.value.prefix === ot ? "" : ot)
            }, y(ot) + ":", 43, gce))), 128)),
            T.value.words.length === 0 && T.value.kind === null && W.value.length ? (f(), h("button", {
              key: 0,
              type: "button",
              class: "fx-psearch__clearall",
              "data-testid": "panel-search-recent-clear",
              onMousedown: De[5] || (De[5] = yt(() => {
              }, ["prevent"])),
              onClick: ne
            }, y(u(o)("panelsearch.recent_clear")), 33)) : O("", !0)
          ]),
          d("p", bce, y(_.value), 1)
        ], 46, Fue)) : O("", !0)
      ]))
    ], 2));
  }
});
function $A(e, t = {}) {
  return e === "app" ? "wide" : e === "folder" ? t.list ? "wide" : "form" : e === "drop" ? "form" : "gate";
}
function wce(e, t) {
  const n = (t ?? []).map((o) => o.trim().replace(/^\./, "").toLowerCase()).filter(Boolean);
  if (!n.length) return !0;
  const a = e.lastIndexOf("."), i = a > 0 || a === 0 && e.length > 1 ? e.slice(a + 1).toLowerCase() : "";
  return n.includes(i);
}
function _ce(e, t, n) {
  const a = { accepted: [], refused: [] }, i = (t == null ? void 0 : t.max_file_size_mb) ?? 0;
  let o = t != null && t.max_files && t.max_files > 0 ? t.max_files : 1 / 0;
  typeof n == "number" && Number.isFinite(n) && (o = Math.min(o, Math.max(0, n)));
  for (const l of e)
    wce(l.name, t == null ? void 0 : t.allowed_ext) ? i > 0 && l.size > i * 1024 * 1024 ? a.refused.push({ file: l, reason: { code: "too_large", name: l.name, mb: i } }) : a.accepted.length >= o ? a.refused.push({ file: l, reason: { code: "too_many", count: o } }) : a.accepted.push(l) : a.refused.push({ file: l, reason: { code: "ext", name: l.name } });
  return a;
}
const kme = ["login", "demo_login", "share_password", "file_request"], xce = "captcha_token", Sce = "captcha_local";
function TA(e, t) {
  return `${(e ?? "").replace(/\/+$/, "")}/api/captcha/${t}`;
}
function $ce(e, t) {
  return !e || e.provider === "none" ? !1 : Array.isArray(e.forms) && e.forms.includes(t);
}
function Vf(e) {
  if (!e || !e.body) return null;
  const t = e.body.captcha;
  return typeof t != "string" || !t ? null : e.status === 409 && t === "fallback" && AA(e.body.challenge) ? "fallback" : e.status === 422 ? "refused" : e.status === 503 ? "unavailable" : null;
}
function AA(e) {
  if (!e || typeof e != "object") return null;
  const t = e;
  if (typeof t.salt != "string" || typeof t.hash != "string" || typeof t.signature != "string") return null;
  const n = Number(t.maxnumber);
  return !Number.isInteger(n) || n < 0 ? null : {
    algorithm: typeof t.algorithm == "string" && t.algorithm ? t.algorithm : "SHA-256",
    salt: t.salt,
    hash: t.hash,
    signature: t.signature,
    maxnumber: n
  };
}
function Tce(e, t) {
  const n = JSON.stringify({
    algorithm: e.algorithm || "SHA-256",
    salt: e.salt,
    number: Math.trunc(t),
    hash: e.hash,
    signature: e.signature
  }), a = new TextEncoder().encode(n);
  let i = "";
  for (const o of a) i += String.fromCharCode(o);
  return btoa(i);
}
const Ace = `
'use strict';
var K = new Uint32Array([
  0x428a2f98,0x71374491,0xb5c0fbcf,0xe9b5dba5,0x3956c25b,0x59f111f1,0x923f82a4,0xab1c5ed5,
  0xd807aa98,0x12835b01,0x243185be,0x550c7dc3,0x72be5d74,0x80deb1fe,0x9bdc06a7,0xc19bf174,
  0xe49b69c1,0xefbe4786,0x0fc19dc6,0x240ca1cc,0x2de92c6f,0x4a7484aa,0x5cb0a9dc,0x76f988da,
  0x983e5152,0xa831c66d,0xb00327c8,0xbf597fc7,0xc6e00bf3,0xd5a79147,0x06ca6351,0x14292967,
  0x27b70a85,0x2e1b2138,0x4d2c6dfc,0x53380d13,0x650a7354,0x766a0abb,0x81c2c92e,0x92722c85,
  0xa2bfe8a1,0xa81a664b,0xc24b8b70,0xc76c51a3,0xd192e819,0xd6990624,0xf40e3585,0x106aa070,
  0x19a4c116,0x1e376c08,0x2748774c,0x34b0bcb5,0x391c0cb3,0x4ed8aa4a,0x5b9cca4f,0x682e6ff3,
  0x748f82ee,0x78a5636f,0x84c87814,0x8cc70208,0x90befffa,0xa4506ceb,0xbef9a3f7,0xc67178f2
]);
var W = new Uint32Array(64);
var H = new Uint32Array(8);
var block = new Uint8Array(384);
var view = new DataView(block.buffer);

function sha256Words(bytes, len) {
  H[0]=0x6a09e667; H[1]=0xbb67ae85; H[2]=0x3c6ef372; H[3]=0xa54ff53a;
  H[4]=0x510e527f; H[5]=0x9b05688c; H[6]=0x1f83d9ab; H[7]=0x5be0cd19;
  var total = (len + 9 + 63) & ~63;
  for (var i = len; i < total; i++) bytes[i] = 0;
  bytes[len] = 0x80;
  view.setUint32(total - 4, (len * 8) >>> 0, false);
  view.setUint32(total - 8, Math.floor((len * 8) / 4294967296), false);
  for (var off = 0; off < total; off += 64) {
    for (var t = 0; t < 16; t++) W[t] = view.getUint32(off + t * 4, false);
    for (t = 16; t < 64; t++) {
      var w15 = W[t-15], w2 = W[t-2];
      var s0 = ((w15 >>> 7) | (w15 << 25)) ^ ((w15 >>> 18) | (w15 << 14)) ^ (w15 >>> 3);
      var s1 = ((w2 >>> 17) | (w2 << 15)) ^ ((w2 >>> 19) | (w2 << 13)) ^ (w2 >>> 10);
      W[t] = (W[t-16] + s0 + W[t-7] + s1) >>> 0;
    }
    var a=H[0],b=H[1],c=H[2],d=H[3],e=H[4],f=H[5],g=H[6],h=H[7];
    for (t = 0; t < 64; t++) {
      var S1 = ((e >>> 6) | (e << 26)) ^ ((e >>> 11) | (e << 21)) ^ ((e >>> 25) | (e << 7));
      var ch = (e & f) ^ (~e & g);
      var t1 = (h + S1 + ch + K[t] + W[t]) >>> 0;
      var S0 = ((a >>> 2) | (a << 30)) ^ ((a >>> 13) | (a << 19)) ^ ((a >>> 22) | (a << 10));
      var maj = (a & b) ^ (a & c) ^ (b & c);
      var t2 = (S0 + maj) >>> 0;
      h = g; g = f; f = e; e = (d + t1) >>> 0; d = c; c = b; b = a; a = (t1 + t2) >>> 0;
    }
    H[0]=(H[0]+a)>>>0; H[1]=(H[1]+b)>>>0; H[2]=(H[2]+c)>>>0; H[3]=(H[3]+d)>>>0;
    H[4]=(H[4]+e)>>>0; H[5]=(H[5]+f)>>>0; H[6]=(H[6]+g)>>>0; H[7]=(H[7]+h)>>>0;
  }
  return H;
}

self.onmessage = function (ev) {
  var data = ev.data || {};
  var salt = String(data.salt || '');
  var target = String(data.hash || '').toLowerCase();
  var max = Number(data.maxnumber);
  if (!/^[0-9a-f]{64}$/.test(target) || salt.length > 256 || !(max >= 0) || max !== Math.floor(max)) {
    self.postMessage({ type: 'fail', reason: 'bad_challenge' });
    return;
  }
  var tw = new Uint32Array(8);
  for (var i = 0; i < 8; i++) tw[i] = parseInt(target.substr(i * 8, 8), 16) >>> 0;
  var sl = salt.length;
  for (i = 0; i < sl; i++) {
    var code = salt.charCodeAt(i);
    if (code > 0x7f) { self.postMessage({ type: 'fail', reason: 'bad_salt' }); return; }
    block[i] = code;
  }
  var start = Date.now();
  for (var n = 0; n <= max; n++) {
    var s = String(n);
    var len = sl + s.length;
    for (i = 0; i < s.length; i++) block[sl + i] = s.charCodeAt(i);
    var hw = sha256Words(block, len);
    if (hw[0] === tw[0] && hw[1] === tw[1] && hw[2] === tw[2] && hw[3] === tw[3] &&
        hw[4] === tw[4] && hw[5] === tw[5] && hw[6] === tw[6] && hw[7] === tw[7]) {
      self.postMessage({ type: 'done', number: n, ms: Date.now() - start });
      return;
    }
    if ((n & 4095) === 0) self.postMessage({ type: 'progress', n: n, max: max });
  }
  self.postMessage({ type: 'fail', reason: 'not_found', ms: Date.now() - start });
};
`;
let Sv = null;
function Ece() {
  return Sv === null && (Sv = URL.createObjectURL(new Blob([Ace], { type: "text/javascript" }))), new Worker(Sv);
}
function Cce(e, t = {}) {
  return new Promise((n, a) => {
    var p, m;
    let i;
    try {
      i = (t.createWorker ?? Ece)();
    } catch {
      a(new Error("worker_failed"));
      return;
    }
    let o = !1;
    const l = (v) => {
      var x;
      if (!o) {
        o = !0, (x = t.signal) == null || x.removeEventListener("abort", c);
        try {
          i.terminate();
        } catch {
        }
        v();
      }
    }, c = () => l(() => a(new Error("aborted")));
    if ((p = t.signal) != null && p.aborted) {
      c();
      return;
    }
    (m = t.signal) == null || m.addEventListener("abort", c), i.onmessage = (v) => {
      var w, S;
      const x = v.data ?? {};
      if (x.type === "progress") {
        x.max && ((w = t.onProgress) == null || w.call(t, Math.min(100, Math.round((x.n ?? 0) / x.max * 100))));
        return;
      }
      if (x.type === "done" && typeof x.number == "number") {
        const k = x.number, b = x.ms ?? 0;
        (S = t.onProgress) == null || S.call(t, 100), l(() => n({ number: k, ms: b, payload: Tce(e, k) }));
        return;
      }
      x.type === "fail" && l(() => a(new Error(x.reason || "not_found")));
    }, i.onerror = () => l(() => a(new Error("worker_failed"))), i.postMessage({ salt: e.salt, hash: e.hash, maxnumber: e.maxnumber });
  });
}
function jf(e) {
  var n;
  if (typeof window > "u") return null;
  const t = window;
  return e === "turnstile" ? t.turnstile ?? null : e === "recaptcha" && (n = t.grecaptcha) != null && n.render ? t.grecaptcha : null;
}
const $v = /* @__PURE__ */ new Map();
let zce = 0;
function Mce(e, t, n = {}) {
  if (jf(e)) return Promise.resolve();
  const a = `${e} ${t}`, i = $v.get(a);
  if (i) return i;
  const o = new Promise((l, c) => {
    const p = window, m = `__filexCaptchaOnload${++zce}`, v = window.setTimeout(() => {
      delete p[m], c(new Error("script_timeout"));
    }, n.timeoutMs ?? 1e4);
    p[m] = () => {
      window.clearTimeout(v), delete p[m], l();
    };
    const x = new URL(t, window.location.href);
    x.searchParams.set("render", "explicit"), x.searchParams.set("onload", m), e === "recaptcha" && n.lang && x.searchParams.set("hl", n.lang);
    const w = document.createElement("script");
    w.src = x.toString(), w.async = !0, w.dataset.filexCaptcha = e, w.onerror = () => {
      window.clearTimeout(v), delete p[m], w.remove(), c(new Error("script_error"));
    }, document.head.appendChild(w);
  });
  return $v.set(a, o), o.catch(() => $v.delete(a)), o;
}
const Pce = /* @__PURE__ */ new Set([
  "ar",
  "bg",
  "cs",
  "da",
  "de",
  "el",
  "en",
  "es",
  "fa",
  "fi",
  "fr",
  "he",
  "hi",
  "hr",
  "hu",
  "id",
  "it",
  "ja",
  "ko",
  "lt",
  "ms",
  "nb",
  "nl",
  "pl",
  "pt",
  "ro",
  "ru",
  "sk",
  "sl",
  "sr",
  "sv",
  "th",
  "tl",
  "tr",
  "uk",
  "vi",
  "zh"
]);
function Oce(e) {
  const t = String(e ?? "").toLowerCase().split(/[-_]/)[0];
  return Pce.has(t) ? t : "auto";
}
async function Lce(e, t) {
  try {
    const n = await (t ?? fetch)(TA(e, "config"), {
      headers: { Accept: "application/json" },
      credentials: "same-origin",
      cache: "no-store"
    });
    return n.ok ? Dce(await n.json()) : null;
  } catch {
    return null;
  }
}
function Dce(e) {
  const t = e;
  return !t || typeof t != "object" || typeof t.provider != "string" ? null : {
    provider: ["none", "turnstile", "recaptcha"].includes(t.provider) ? t.provider : "none",
    site_key: t.site_key ?? null,
    script: t.script ?? null,
    fallback: t.fallback === "off" ? "off" : "local",
    forms: Array.isArray(t.forms) ? t.forms : [],
    misconfigured: t.misconfigured === !0,
    fallback_active: t.fallback_active === !0,
    local_field: t.local_field || Sce,
    token_field: t.token_field || xce
  };
}
async function Rce(e, t = {}) {
  try {
    const n = { Accept: "application/json" };
    t.locale && (n["Accept-Language"] = t.locale);
    const a = await (t.fetchImpl ?? fetch)(TA(e, "local/challenge"), {
      method: "POST",
      headers: n,
      credentials: "same-origin",
      cache: "no-store"
    }), i = await a.json().catch(() => null), o = AA(i == null ? void 0 : i.challenge);
    if (a.ok && o) return { kind: "challenge", challenge: o };
    const l = typeof (i == null ? void 0 : i.message) == "string" ? i.message : void 0;
    return a.status === 409 ? { kind: "provider", message: l } : a.status === 404 ? { kind: "disabled", message: l } : { kind: "unavailable", message: l };
  } catch {
    return { kind: "unavailable" };
  }
}
class uh extends Error {
  constructor(t, n, a, i = null) {
    super(a || n || String(t)), this.status = t, this.code = n, this.body = i, this.name = "PublicLinkError";
  }
}
function EA(e) {
  if (e.ok) return null;
  const t = e.error;
  return t instanceof uh ? { status: t.status, body: t.body } : null;
}
function CA(e) {
  return Vf(e instanceof uh ? { status: e.status, body: e.body } : null) !== null;
}
function lb(e, t, n) {
  const a = (e ?? "").replace(/\/+$/, "");
  return (i = "") => `${a}${t}${encodeURIComponent(n)}${i}`;
}
function Ice(e, t) {
  return lb(e, "/api/public/s/", t);
}
function h2(e, t) {
  return lb(e, "/api/public/d/", t);
}
function ub(e, t) {
  return lb(e, "/api/p/", t);
}
function cb(e, t) {
  const n = (...i) => (t.fetchImpl ?? fetch)(...i);
  async function a(i, o = {}) {
    const l = { Accept: "application/json", "Accept-Language": t.locale() };
    o.body !== void 0 && (l["Content-Type"] = "application/json");
    const c = await n(e(i), {
      method: o.method ?? "GET",
      headers: l,
      credentials: "same-origin",
      cache: "no-store",
      body: o.body !== void 0 ? JSON.stringify(o.body) : void 0
    });
    let p = null;
    try {
      p = await c.json();
    } catch {
      p = null;
    }
    if (!c.ok) {
      const m = p ?? {};
      throw new uh(
        c.status,
        m.error ?? "",
        m.message,
        p && typeof p == "object" ? p : null
      );
    }
    return { status: c.status, body: p };
  }
  return {
    /** What the link is and what the visitor may see of it. */
    info: (i = "") => a(i).then((o) => o.body),
    /** The PIN, with the bot check's field when the form is protected. */
    pin: (i, o = {}) => a("/pin", { method: "POST", body: { pin: i, ...o } }).then((l) => l.body),
    /**
     * A file request's upload pass (`POST /captcha`), asked for right before
     * the upload. ⚠ A multipart upload cannot be answered "solve this first"
     * halfway through its bytes, so the check is a JSON call of its own and
     * the upload only carries the pass it returned (`X-Captcha-Pass`).
     */
    uploadPass: (i) => a("/captcha", { method: "POST", body: { ...i } }).then((o) => o.body),
    /**
     * The app's opening screen.
     *
     * ⚠ There is no `/view` route: an open is `POST /event
     * {"event":"open"}`, because the opening surface and every later one are
     * the same call to the app. One endpoint, one code path in the plugin.
     */
    open: () => a("/event", { method: "POST", body: { event: "open", state: {}, data: {} } }).then(
      (i) => i.body
    ),
    /** `{surface}`, or `{op}` when the server queued a job (202). */
    event: async (i) => {
      var l, c, p;
      const o = await a("/event", {
        method: "POST",
        body: i
      });
      return o.status === 202 || (l = o.body) != null && l.accepted ? { op: { accepted: !0, job_id: (c = o.body) == null ? void 0 : c.job_id }, job_id: (p = o.body) == null ? void 0 : p.job_id } : { surface: o.body.surface };
    },
    /** Where the browser loads an exposed copy from (`pub:N`). */
    fileUrl: (i) => e(`/file/${encodeURIComponent(i)}`),
    /**
     * The same copy, asked for as a DOWNLOAD — the Download button's link.
     * ⚠ Kept apart from `fileUrl` because only this one counts as a download
     * (handlers/public_api.go serveExposed): the page's own viewer loads the
     * document to SHOW it, and the owner ruled on 2026-09-21 that looking at
     * a signing link is not downloading it.
     */
    fileDownloadUrl: (i) => e(`/file/${encodeURIComponent(i)}?download=1`),
    url: e
  };
}
function db(e, t) {
  const n = cb(e, t), a = $("loading"), i = $(null), o = $(""), l = $(""), c = $(""), p = $(""), m = $(""), v = $(""), x = Gp(
    {
      api: { pluginViewEvent: (A, L, z) => n.event(z) },
      plugin: "",
      view: "",
      locale: t.locale,
      errorText: t.errorText
    },
    {
      onOp: (A) => {
        c.value = String(A.job_id ?? ""), a.value = "accepted";
      },
      onDone: () => {
        a.value !== "accepted" && (a.value = "done");
      },
      onToast: (A) => {
        p.value = A;
      }
    }
  );
  function w(A) {
    const L = A;
    (L == null ? void 0 : L.status) === 404 ? (a.value = "not_found", v.value = "not_found") : (L == null ? void 0 : L.status) === 410 ? (a.value = "gone", v.value = "gone") : (a.value = "error", v.value = "error", m.value = Yi(t.locale(), String((A == null ? void 0 : A.message) ?? A)) || t.errorText());
  }
  async function S() {
    try {
      const A = await n.open(), L = A == null ? void 0 : A.surface;
      if (!L) {
        a.value = "error", m.value = t.errorText();
        return;
      }
      x.setSurface(L), a.value = L.done ? "done" : "ready";
    } catch (A) {
      if ((A == null ? void 0 : A.status) === 401) {
        a.value = "pin";
        return;
      }
      w(A);
    }
  }
  function k(A) {
    return (A == null ? void 0 : A.expired) === !0 || (A == null ? void 0 : A.revoked) === !0;
  }
  async function b(A = "") {
    var L, z, D, U;
    a.value = "loading", m.value = "", v.value = "";
    try {
      i.value = await n.info(A);
    } catch (q) {
      w(q);
      return;
    }
    if (k(i.value)) {
      a.value = "gone", v.value = "gone";
      return;
    }
    if ((L = i.value) != null && L.needs_pin && !((z = i.value) != null && z.unlocked)) {
      a.value = "pin", o.value = ((D = i.value) == null ? void 0 : D.locked) === !0 ? "locked" : "";
      return;
    }
    if ((U = t.hasSurface) != null && U.call(t, i.value)) {
      await S();
      return;
    }
    a.value = "ready";
  }
  const C = $(!1);
  async function T(A) {
    var L, z;
    if (!C.value) {
      o.value = "", l.value = "", C.value = !0;
      try {
        const D = A.trim(), U = (L = t.captcha) == null ? void 0 : L.pin;
        i.value = U ? await U.protect((q) => n.pin(D, q), EA) : await n.pin(D), k(i.value) ? (a.value = "gone", v.value = "gone") : (z = t.hasSurface) != null && z.call(t, i.value) ? await S() : a.value = "ready";
      } catch (D) {
        const U = D;
        if (CA(D)) return;
        (U == null ? void 0 : U.status) === 429 ? (o.value = "locked", l.value = Yi(t.locale(), U.message ?? "")) : (U == null ? void 0 : U.status) === 401 || (U == null ? void 0 : U.status) === 403 ? o.value = "wrong" : w(D);
      } finally {
        C.value = !1;
      }
    }
  }
  return {
    status: a,
    info: i,
    reason: v,
    pinFailure: o,
    lockMessage: l,
    pinBusy: C,
    failure: m,
    toast: p,
    jobId: c,
    conv: x,
    load: b,
    submitPin: T,
    fileUrl: n.fileUrl,
    fileDownloadUrl: n.fileDownloadUrl,
    /**
     * A `FileRefResolver` for the surface renderer: the URL, plus the name
     * and type the link's own `files[]` already told us.
     *
     * ⚠ The renderer needs the mime to decide how to draw the thing (a
     * picture, an embedded PDF, a link). Handing it a bare URL makes every
     * exposed copy render as "something to download", which is what a
     * `preview` node is specifically not for.
     */
    resolveFile: (A) => {
      var D, U;
      const L = (U = (D = i.value) == null ? void 0 : D.app) == null ? void 0 : U.files, z = L == null ? void 0 : L.find((q) => q.ref === A);
      return { url: n.fileUrl(A), name: z == null ? void 0 : z.name, mime: z == null ? void 0 : z.mime };
    },
    url: n.url
  };
}
function Nce(e, t, n = {}) {
  const a = (e ?? "").replace(/\/+$/, ""), i = encodeURIComponent(t);
  return n.path ? `${a}/s/${i}/f/${n.path.split("/").map(encodeURIComponent).join("/")}?download=1` : `${a}/s/${i}?${n.zip ? "zip=1" : "download=1"}`;
}
function Bce(e, t) {
  return `${(e ?? "").replace(/\/+$/, "")}/s/${encodeURIComponent(t)}?nojs=1`;
}
function Fce(e, t) {
  return {
    ...db(Ice(t.base, e), {
      ...t,
      hasSurface: (a) => (a == null ? void 0 : a.kind) === "app"
    }),
    downloadUrl: (a = {}) => Nce(t.base, e, a),
    noJsUrl: () => Bce(t.base, e)
  };
}
const Uce = /* @__PURE__ */ new Set([504, 524]);
function Hce(e, t) {
  const n = db(h2(t.base, e), t), a = cb(h2(t.base, e), t), i = $([]);
  function o(m, v, x) {
    i.value = i.value.map((w, S) => S >= m && S < v ? { ...w, ...x } : w);
  }
  function l(m, v, x, w) {
    const S = v + m.length;
    return new Promise((k) => {
      let b;
      try {
        b = new XMLHttpRequest();
      } catch {
        o(v, S, { state: "failed", error: t.errorText() }), k();
        return;
      }
      b.open("POST", n.url("/upload")), b.withCredentials = !0, b.setRequestHeader("Accept", "application/json"), b.setRequestHeader("Accept-Language", t.locale()), w && b.setRequestHeader("X-Captcha-Pass", w), b.upload.onprogress = (L) => {
        L.lengthComputable && L.total > 0 && o(v, S, { percent: Math.round(L.loaded / L.total * 100) });
      };
      let C = !1;
      b.upload.onload = () => {
        C = !0, o(v, S, { state: "saving", percent: 100 });
      };
      const T = () => o(v, S, { state: "unconfirmed", error: (t.unansweredText ?? t.errorText)() });
      b.onload = () => {
        var L;
        if (b.status >= 200 && b.status < 300)
          o(v, S, { state: "done", percent: 100 });
        else {
          let z = "";
          try {
            z = String(((L = JSON.parse(b.responseText)) == null ? void 0 : L.message) ?? "");
          } catch {
            z = "";
          }
          !z && C && Uce.has(b.status) ? T() : o(v, S, { state: "failed", error: z || t.errorText() });
        }
        k();
      }, b.onerror = () => {
        C ? T() : o(v, S, { state: "failed", error: t.errorText() }), k();
      };
      const A = new FormData();
      for (const L of m) A.append("file", L, L.name);
      for (const L of m) A.append("name[]", L.name);
      x && A.append("uploader_name", x), b.send(A);
    });
  }
  async function c(m, v = {}) {
    const x = n.info.value, { accepted: w, refused: S } = _ce(Array.from(m), x == null ? void 0 : x.limits, (x == null ? void 0 : x.uploads_left) ?? null), k = v.refusedText ?? (() => t.errorText());
    if (i.value = [
      ...i.value,
      ...S.map(({ file: T, reason: A }) => ({
        name: T.name,
        size: T.size,
        percent: -1,
        state: "refused",
        error: k(A)
      }))
    ], !w.length) return;
    const b = i.value.length;
    i.value = [
      ...i.value,
      ...w.map((T) => ({ name: T.name, size: T.size, percent: -1, state: "sending" }))
    ];
    const C = await p(b);
    C !== null && (await l(w, b, (v.name ?? "").trim(), C), await n.load());
  }
  async function p(m) {
    var x, w;
    const v = (x = t.captcha) == null ? void 0 : x.upload;
    if (!v || (await v.load(), !v.active.value)) return "";
    try {
      const S = await v.protect((k) => a.uploadPass(k), EA);
      return (S == null ? void 0 : S.pass) ?? "";
    } catch (S) {
      if (CA(S))
        i.value = i.value.slice(0, m);
      else {
        const k = S instanceof uh ? (w = S.body) == null ? void 0 : w.message : "", b = typeof k == "string" ? k : "";
        o(m, i.value.length, { state: "failed", error: b || t.errorText() });
      }
      return null;
    }
  }
  return { ...n, uploads: i, upload: c };
}
function wme(e, t, n = "") {
  return ub(e, t)(n);
}
function _me(e, t) {
  return cb(ub(t.base, e), t);
}
function xme(e, t) {
  return db(ub(t.base, e), { ...t, hasSurface: () => !0 });
}
function zA(e) {
  const t = $(null);
  let n = null;
  return {
    config: t,
    load: () => (n || (n = (e.load ? e.load().catch(() => null) : Lce(e.base, e.fetchImpl)).then((i) => (t.value = i, i))), n)
  };
}
const m2 = 3e4;
function v2(e) {
  const t = e.config ?? zA({ base: e.base, fetchImpl: e.fetchImpl }), { t: n } = pt(() => e.locale()), a = E(() => typeof e.form == "function" ? e.form() : e.form), i = t.config, o = E(() => $ce(i.value, a.value)), l = E(() => {
    var K;
    return ((K = i.value) == null ? void 0 : K.provider) ?? "none";
  }), c = $("loading"), p = $(""), m = $(""), v = $(0), x = $(null), w = $(!1);
  let S = "", k = "", b = "widget", C = null, T = null, A = 0, L = null, z = null, D = !1;
  function U(K, I) {
    p.value = K, m.value = K ? I : "";
  }
  async function q() {
    await t.load(), D = !0, o.value ? c.value === "off" && (c.value = "loading") : c.value = "off";
  }
  Je(o, (K) => {
    D && (K || (c.value = "off", U("", "")));
  });
  function P(K) {
    S = K, !(L || k) && (K ? c.value = "solved" : c.value === "solved" && (c.value = T !== null ? "ready" : "loading"));
  }
  function R(K) {
    var be, Fe;
    const I = l.value, Y = jf(I), B = ((be = i.value) == null ? void 0 : be.site_key) ?? "";
    if (!Y || !B) return !1;
    K.innerHTML = "";
    const V = ((Fe = e.theme) == null ? void 0 : Fe.call(e)) ?? "auto";
    return I === "turnstile" ? T = Y.render(K, {
      sitekey: B,
      theme: V,
      language: Oce(e.locale()),
      size: "flexible",
      callback: (ze) => P(ze),
      "expired-callback": () => P(""),
      "timeout-callback": () => P(""),
      "error-callback": () => (he(), !0)
    }) ?? null : T = Y.render(K, {
      sitekey: B,
      theme: V === "dark" ? "dark" : "light",
      callback: (ze) => P(ze),
      "expired-callback": () => P(""),
      "error-callback": () => {
        he();
      }
    }), c.value = "ready", !0;
  }
  async function W(K) {
    if (C = K, D || await q(), !o.value || C !== K) return;
    const I = i.value;
    if (I.misconfigured || !I.site_key || !I.script) {
      b = "local", await he();
      return;
    }
    c.value = "loading";
    try {
      await Mce(I.provider, I.script, { lang: e.locale() });
    } catch {
      if (C !== K) return;
      b = "local", await he();
      return;
    }
    C === K && (b = "widget", w.value = !1, R(K) || (b = "local", await he()));
  }
  function N() {
    const K = jf(l.value);
    if (T !== null && K && l.value === "turnstile")
      try {
        K.remove(String(T));
      } catch {
      }
    T = null;
  }
  function J() {
    z == null || z.abort(), N(), C = null, S = "", k = "";
  }
  function H() {
    S = "";
    const K = jf(l.value);
    if (!(T === null || !K))
      try {
        l.value === "turnstile" ? K.reset(String(T)) : K.reset(Number(T)), c.value = "ready";
      } catch {
      }
  }
  function ne() {
    k = "", w.value = !1, v.value = 0, b === "widget" ? H() : (S = "", c.value === "solved" && (c.value = "loading"));
  }
  function j() {
    return k ? { captcha_local: k } : S ? { captcha_token: S } : {};
  }
  function re(K) {
    return L || (z = new AbortController(), w.value = !0, v.value = 0, c.value = "solving", U(n("captcha.fallback_intro"), "info"), L = Cce(K, {
      signal: z.signal,
      createWorker: e.createWorker,
      onProgress: (I) => {
        v.value = I;
      }
    }).then((I) => (k = I.payload, S = "", x.value = I.ms, c.value = "solved", U(n("captcha.fallback_done"), "ok"), !0)).catch((I) => ((I == null ? void 0 : I.message) !== "aborted" && (c.value = "error", U(n("captcha.fallback_failed"), "error")), !1)).finally(() => {
      L = null;
    }), L);
  }
  async function he() {
    if (Date.now() - A < m2)
      return c.value = "error", U(n("captcha.widget_failed"), "error"), !1;
    const K = await Rce(e.base, { fetchImpl: e.fetchImpl, locale: e.locale() });
    return K.kind === "challenge" ? (b = "local", re(K.challenge)) : K.kind === "disabled" ? (c.value = "off", U("", ""), !1) : (K.kind === "provider" && (A = Date.now()), c.value = "error", U(K.kind === "provider" ? n("captcha.widget_failed") : K.message || n("captcha.unavailable"), "error"), !1);
  }
  function ue() {
    return c.value !== "loading" && c.value !== "ready" && c.value !== "solving" ? Promise.resolve() : L ? L.then(() => {
    }) : new Promise((K) => {
      const I = setTimeout(B, e.settleMs ?? 8e3), Y = Je(c, (V) => {
        V !== "loading" && V !== "ready" && B();
      });
      function B() {
        clearTimeout(I), Y(), K();
      }
    });
  }
  async function ae(K, I) {
    try {
      return { ok: !0, value: await K(I) };
    } catch (Y) {
      return { ok: !1, error: Y };
    }
  }
  function fe(K) {
    K.captcha_local && (k = ""), K.captcha_token && H(), (c.value === "solved" || c.value === "ready") && (c.value = S ? "solved" : b === "widget" && T !== null ? "ready" : "loading");
  }
  function _(K) {
    var Y;
    const I = typeof ((Y = K.body) == null ? void 0 : Y.message) == "string" ? K.body.message : "";
    if (k = "", w.value = !1, v.value = 0, b === "widget" ? H() : c.value !== "error" && (c.value = "loading"), b === "local" && Date.now() - A < m2) {
      c.value = "error", U(n("captcha.widget_failed"), "error");
      return;
    }
    U(I || n(Vf(K) === "unavailable" ? "captcha.unavailable" : "captcha.invalid"), "error");
  }
  async function Q(K, I) {
    D || await q(), m.value === "error" && c.value !== "error" && U("", ""), o.value && (b === "local" && !k && c.value !== "error" && c.value !== "solving" && await he(), await ue());
    let Y = j(), B = await ae(K, Y);
    fe(Y);
    let V = I(B);
    Vf(V) === "fallback" && await re(V.body.challenge) && (Y = j(), B = await ae(K, Y), fe(Y), V = I(B));
    const be = Vf(V);
    if (be === "refused" || be === "unavailable" ? _(V) : ((m.value === "ok" || m.value === "info") && U("", ""), b === "widget" && (w.value = !1)), B.ok) return B.value;
    throw B.error;
  }
  return {
    config: i,
    active: o,
    form: a,
    provider: l,
    state: c,
    message: p,
    messageKind: m,
    progress: v,
    solveMs: x,
    widgetHidden: w,
    load: q,
    attach: W,
    detach: J,
    fields: j,
    reset: ne,
    protect: Q
  };
}
const Kce = ["data-captcha-form", "data-captcha-provider", "data-captcha-state", "data-captcha-solve-ms", "aria-label"], Vce = ["data-kind"], jce = {
  key: 0,
  "data-testid": "captcha-message"
}, qce = ["aria-valuenow", "aria-label"], MA = /* @__PURE__ */ lt({
  __name: "CaptchaWidget",
  props: {
    captcha: {},
    locale: {}
  },
  setup(e) {
    const t = e, { t: n } = pt(() => t.locale), a = $(null);
    return jt(() => {
      a.value && t.captcha.attach(a.value);
    }), Tt(() => t.captcha.detach()), Je(
      () => t.captcha.active.value,
      (i) => {
        i && a.value && t.captcha.attach(a.value);
      }
    ), (i, o) => (f(), h("div", {
      class: "fe-captcha",
      "data-testid": "captcha",
      "data-captcha-form": e.captcha.form.value,
      "data-captcha-provider": e.captcha.provider.value,
      "data-captcha-state": e.captcha.state.value,
      "data-captcha-solve-ms": e.captcha.solveMs.value ?? void 0,
      role: "group",
      "aria-label": u(n)("captcha.label")
    }, [
      ln(d("div", {
        ref_key: "host",
        ref: a,
        class: "fe-captcha__widget",
        "data-testid": "captcha-widget"
      }, null, 512), [
        [w2, !e.captcha.widgetHidden.value]
      ]),
      d("div", {
        class: "fe-captcha__status",
        "data-kind": e.captcha.messageKind.value || void 0,
        role: "status",
        "aria-live": "polite"
      }, [
        e.captcha.message.value ? (f(), h("span", jce, y(e.captcha.message.value), 1)) : O("", !0),
        e.captcha.state.value === "solving" ? (f(), h("div", {
          key: 1,
          class: "fe-sprogress__track",
          role: "progressbar",
          "aria-valuemin": "0",
          "aria-valuemax": "100",
          "aria-valuenow": e.captcha.progress.value,
          "aria-label": u(n)("captcha.progress"),
          "data-testid": "captcha-progress"
        }, [
          d("div", {
            class: "fe-sprogress__bar",
            style: Wt({ width: `${e.captcha.progress.value}%` })
          }, null, 4)
        ], 8, qce)) : O("", !0)
      ], 8, Vce)
    ], 8, Kce));
  }
}), PA = Symbol("filex-public-text");
function OA(e) {
  const t = $({}), n = $(""), a = $(!1);
  let i = 0;
  async function o(l) {
    const c = ++i;
    a.value = !1;
    const p = e.fetchImpl ?? (typeof fetch == "function" ? fetch : null);
    try {
      if (!p) return;
      const m = await p(`${Yo(e.base)}/api/public/strings?lang=${encodeURIComponent(l)}`, {
        method: "GET",
        headers: { Accept: "application/json" },
        credentials: "same-origin"
      });
      if (!m.ok) return;
      const v = await m.json();
      if (c !== i) return;
      t.value = v != null && v.strings && typeof v.strings == "object" ? v.strings : {}, n.value = (v == null ? void 0 : v.lang) || l;
    } catch {
    } finally {
      c === i && (a.value = !0);
    }
  }
  return Je(e.locale, (l) => void o(l), { immediate: !0 }), { table: t, lang: n, ready: a };
}
function LA(e) {
  Wo(PA, e);
}
const Wce = ["count", "n"];
function DA(e, t, n, a = {}) {
  let i;
  const o = Wce.find((l) => l in a);
  if (o !== void 0) {
    const l = Uy(t || "en", Number(a[o]));
    l !== "other" && (i = e[`${n}_${l}`]);
  }
  return i = i || e[n] || "", Object.entries(a).reduce((l, [c, p]) => l.replaceAll(`{${c}}`, String(p)), i);
}
function fb(e) {
  const t = bi(PA, null), n = E(() => (t == null ? void 0 : t.table.value) ?? {}), a = E(() => (t == null ? void 0 : t.lang.value) || (e ? e() : "") || "en"), i = E(() => (t == null ? void 0 : t.ready.value) ?? !0);
  function o(l, c = {}) {
    const p = DA(n.value, a.value, l, c);
    return p ? Yi(a.value, p) : "";
  }
  return { pt: o, ready: i };
}
const Yce = { class: "fe-ppage__state" }, Gce = { class: "fe-ppage__state-title" }, Xce = { class: "fe-surface__text fe-surface__text--muted" }, Jce = {
  class: "fe-ppage__srlabel",
  for: "fe-ppage-pin"
}, Zce = ["maxlength", "disabled", "aria-invalid"], Qce = {
  key: 0,
  class: "fe-ppage__error",
  role: "alert",
  "data-testid": "public-page-pin-error"
}, ede = ["disabled"], tde = /* @__PURE__ */ lt({
  __name: "PublicPinGate",
  props: {
    locale: {},
    busy: { type: Boolean },
    failure: {},
    lockMessage: {},
    maxLength: {},
    captcha: {}
  },
  emits: ["submit"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = pt(() => n.locale), o = $(""), l = $(null), c = () => n.failure === "wrong" ? i("plugin.page.pin_wrong") : n.failure === "locked" ? i("plugin.page.pin_locked") : "";
    Je(
      () => n.failure,
      async (m) => {
        var v;
        m === "wrong" && (o.value = "", await Gt(), (v = l.value) == null || v.focus());
      }
    ), jt(() => {
      var m;
      return (m = l.value) == null ? void 0 : m.focus();
    });
    function p() {
      var m;
      if (!(n.busy || n.failure === "locked")) {
        if (!o.value.trim()) {
          (m = l.value) == null || m.focus();
          return;
        }
        a("submit", o.value);
      }
    }
    return (m, v) => {
      var x;
      return f(), h("form", {
        class: "fe-ppage__pin",
        "data-testid": "public-page-pin",
        onSubmit: yt(p, ["prevent"])
      }, [
        d("div", Yce, [
          d("h2", Gce, y(u(i)("plugin.page.pin_title")), 1),
          d("p", Xce, y(u(i)("plugin.page.pin_hint")), 1)
        ]),
        d("label", Jce, y(u(i)("plugin.pin.label")), 1),
        ln(d("input", {
          id: "fe-ppage-pin",
          ref_key: "input",
          ref: l,
          "onUpdate:modelValue": v[0] || (v[0] = (w) => o.value = w),
          class: Re(["fe-cfield__input fe-ppage__pinput", { "is-invalid": !!c() }]),
          type: "text",
          inputmode: "numeric",
          autocomplete: "one-time-code",
          spellcheck: "false",
          maxlength: e.maxLength && e.maxLength > 0 ? e.maxLength : void 0,
          disabled: e.busy || e.failure === "locked",
          "aria-invalid": c() ? "true" : void 0,
          "data-testid": "public-page-pin-input"
        }, null, 10, Zce), [
          [_n, o.value]
        ]),
        c() ? (f(), h("p", Qce, [
          Ht(y(c()), 1),
          e.lockMessage ? (f(), h(Te, { key: 0 }, [
            Ht(" (" + y(e.lockMessage) + ")", 1)
          ], 64)) : O("", !0)
        ])) : O("", !0),
        (x = e.captcha) != null && x.active.value ? (f(), Ge(MA, {
          key: 1,
          captcha: e.captcha,
          locale: String(e.locale)
        }, null, 8, ["captcha", "locale"])) : O("", !0),
        d("button", {
          type: "submit",
          class: "fe-btn fe-btn--primary",
          disabled: e.busy || e.failure === "locked",
          "data-testid": "public-page-pin-submit"
        }, y(u(i)("plugin.page.pin_submit")), 9, ede)
      ], 32);
    };
  }
}), nde = {
  key: 0,
  class: "fe-plang",
  role: "group",
  "data-testid": "public-language"
}, ade = ["lang", "aria-pressed", "title", "data-testid", "onClick"], ide = {
  key: 0,
  class: "fe-plang__src"
}, ode = /* @__PURE__ */ lt({
  __name: "PublicLanguagePicker",
  props: {
    modelValue: {},
    pluginNote: { type: Function }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, a = t, i = E(() => (oi.value, mo())), o = E(() => i.value.length > 1);
    return (l, c) => o.value ? (f(), h("div", nde, [
      (f(!0), h(Te, null, nt(i.value, (p) => (f(), h("button", {
        key: p.code,
        type: "button",
        class: Re(["fe-plang__btn", { "is-on": p.code === n.modelValue }]),
        lang: p.code,
        "aria-pressed": p.code === n.modelValue ? "true" : "false",
        title: p.source === "plugin" && p.plugin && e.pluginNote ? e.pluginNote(p.plugin) : void 0,
        "data-testid": `public-language-${p.code}`,
        onClick: (m) => a("update:modelValue", p.code)
      }, [
        Ht(y(p.label) + " ", 1),
        p.source === "plugin" && p.plugin ? (f(), h("small", ide, y(p.plugin), 1)) : O("", !0)
      ], 10, ade))), 128))
    ])) : O("", !0);
  }
}), rde = ["dir", "data-state", "data-layout"], sde = {
  class: "fe-ppage__brand",
  "data-testid": "public-brand"
}, lde = ["src", "alt"], ude = { class: "fe-ppage__brandname" }, cde = ["data-badge"], dde = {
  key: 0,
  class: "fe-ppage__spinner"
}, fde = ["stroke-width"], pde = {
  key: 1,
  d: "M4.5 12.5l5 5 10-11"
}, hde = {
  key: 1,
  class: "fe-ppage__head"
}, mde = {
  key: 0,
  class: "fe-ppage__title",
  "data-testid": "public-page-title"
}, vde = {
  key: 1,
  class: "fe-ppage__subject",
  "data-testid": "public-page-subject"
}, yde = {
  key: 2,
  class: "fe-ppage__meta",
  "data-testid": "public-page-meta"
}, gde = { key: 0 }, bde = {
  key: 1,
  "aria-hidden": "true"
}, kde = { key: 2 }, wde = {
  key: 3,
  class: "fe-surface__text fe-surface__text--muted",
  "data-testid": "public-page-loading"
}, _de = {
  key: 6,
  class: "fe-ppage__state fe-ppage__state--ok",
  "data-testid": "public-page-accepted"
}, xde = { class: "fe-ppage__state-title" }, Sde = { class: "fe-surface__text" }, $de = {
  key: 7,
  class: "fe-ppage__state fe-ppage__state--ok",
  "data-testid": "public-page-done"
}, Tde = { class: "fe-ppage__state-title" }, Ade = { class: "fe-surface__text" }, Ede = {
  key: 8,
  class: "fe-ppage__state",
  "data-testid": "public-page-error"
}, Cde = { class: "fe-ppage__state-title" }, zde = {
  key: 0,
  class: "fe-ppage__error"
}, Mde = {
  key: 9,
  class: "fe-ppage__state",
  "data-testid": "public-page-unavailable"
}, Pde = { class: "fe-ppage__state-title" }, Ode = { class: "fe-surface__text fe-surface__text--muted" }, Lde = { class: "fe-ppage__foot" }, Dde = {
  key: 0,
  class: "fe-ppage__footline",
  "data-testid": "public-footer-text"
}, Rde = {
  key: 1,
  class: "fe-ppage__footmark",
  "data-testid": "public-footer-powered"
}, Ide = ["src"], RA = /* @__PURE__ */ lt({
  __name: "PublicShell",
  props: {
    status: {},
    locale: {},
    theme: {},
    brandName: {},
    logoUrl: {},
    accentStyle: {},
    footerText: {},
    hidePoweredBy: { type: Boolean },
    layout: {},
    badge: {},
    title: {},
    subject: {},
    expiresAt: {},
    visitsLeft: {},
    pinMax: {},
    pinBusy: { type: Boolean },
    pinFailure: {},
    lockMessage: {},
    failure: {},
    embedded: { type: Boolean },
    pinCaptcha: {}
  },
  emits: ["pin", "retry", "update:locale"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i, formatDate: o, dir: l } = pt(() => n.locale), { pt: c } = fb(() => String(n.locale)), p = E(() => n.status === "ready"), m = E(() => p.value ? n.layout ?? "form" : "gate"), v = E(
      () => n.theme === "dark" ? "fe--theme-dark" : n.theme === "light" ? "fe--theme-light" : ""
    ), x = E(() => {
      if (!n.expiresAt) return "";
      const T = Date.parse(n.expiresAt);
      return Number.isFinite(T) ? c("expires", { when: o(T, { time: !0 }) }) : "";
    }), w = E(() => {
      const T = n.visitsLeft;
      return T == null || !Number.isFinite(T) ? "" : c("visits_left", { count: T });
    }), S = E(() => n.status === "pin" ? "lock" : n.status === "accepted" || n.status === "done" ? "check" : n.status === "loading" ? "loading" : p.value ? n.badge ?? "" : "alert"), k = E(
      () => S.value === "check" ? "fe-ppage__badge--ok" : S.value === "alert" ? "fe-ppage__badge--err" : ""
    ), b = E(() => !n.logoUrl && n.brandName === mp);
    function C(T) {
      return c("language_from", { app: T });
    }
    return (T, A) => (f(), h("div", {
      class: Re(["fe fe-ppage", [v.value, `fe-ppage--${m.value}`]]),
      dir: u(l),
      style: Wt(e.accentStyle),
      "data-testid": "public-page",
      "data-state": e.status,
      "data-layout": m.value
    }, [
      d("header", sde, [
        e.logoUrl ? (f(), h("img", {
          key: 0,
          class: "fe-ppage__logo",
          src: e.logoUrl,
          alt: e.brandName
        }, null, 8, lde)) : b.value ? (f(), Ge(l2, {
          key: 1,
          class: "fe-ppage__logo"
        })) : O("", !0),
        d("span", ude, y(e.brandName), 1)
      ]),
      (f(), Ge(Ki(e.embedded ? "div" : "main"), { class: "fe-ppage__card" }, {
        default: mt(() => [
          S.value ? (f(), h("div", {
            key: 0,
            class: Re(["fe-ppage__badge", k.value]),
            "data-testid": "public-page-badge",
            "data-badge": S.value,
            "aria-hidden": "true"
          }, [
            S.value === "loading" ? (f(), h("span", dde)) : (f(), h("svg", {
              key: 1,
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": S.value === "check" ? 2 : 1.8,
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, [
              S.value === "lock" ? (f(), h(Te, { key: 0 }, [
                A[3] || (A[3] = d("rect", {
                  x: "4.5",
                  y: "10.5",
                  width: "15",
                  height: "9.5",
                  rx: "2"
                }, null, -1)),
                A[4] || (A[4] = d("path", { d: "M8 10.5V7a4 4 0 0 1 8 0v3.5" }, null, -1)),
                A[5] || (A[5] = d("path", { d: "M12 14.5v2" }, null, -1))
              ], 64)) : S.value === "check" ? (f(), h("path", pde)) : S.value === "alert" ? (f(), h(Te, { key: 2 }, [
                A[6] || (A[6] = d("path", { d: "M10.3 4.2 2.6 17.9a2 2 0 0 0 1.7 3h15.4a2 2 0 0 0 1.7-3L13.7 4.2a2 2 0 0 0-3.4 0z" }, null, -1)),
                A[7] || (A[7] = d("path", { d: "M12 9.5v4.5" }, null, -1)),
                A[8] || (A[8] = d("path", { d: "M12 17.4h.01" }, null, -1))
              ], 64)) : S.value === "folder" ? (f(), h(Te, { key: 3 }, [
                A[9] || (A[9] = d("path", { d: "M3.5 7a2 2 0 0 1 2-2h4l2 2h7a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-13a2 2 0 0 1-2-2V7z" }, null, -1)),
                A[10] || (A[10] = d("path", { d: "M12 10.5V16" }, null, -1)),
                A[11] || (A[11] = d("path", { d: "M9.5 13.5 12 16l2.5-2.5" }, null, -1))
              ], 64)) : (f(), h(Te, { key: 4 }, [
                A[12] || (A[12] = d("path", { d: "M7 3.5h7l4 4V20a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 6 20V5A1.5 1.5 0 0 1 7.5 3.5z" }, null, -1)),
                A[13] || (A[13] = d("path", { d: "M13.5 3.5V8H18" }, null, -1)),
                A[14] || (A[14] = d("path", { d: "M12 11.5V17" }, null, -1)),
                A[15] || (A[15] = d("path", { d: "M9.5 14.5 12 17l2.5-2.5" }, null, -1))
              ], 64))
            ], 8, fde))
          ], 10, cde)) : O("", !0),
          (e.title || e.subject) && p.value ? (f(), h("header", hde, [
            e.title ? (f(), h("h1", mde, [
              d("bdi", null, y(e.title), 1)
            ])) : O("", !0),
            e.subject ? (f(), h("p", vde, y(e.subject), 1)) : O("", !0)
          ])) : O("", !0),
          (x.value || w.value) && p.value ? (f(), h("p", yde, [
            x.value ? (f(), h("span", gde, y(x.value), 1)) : O("", !0),
            x.value && w.value ? (f(), h("span", bde, "·")) : O("", !0),
            w.value ? (f(), h("span", kde, y(w.value), 1)) : O("", !0)
          ])) : O("", !0),
          e.status === "loading" ? (f(), h("p", wde, y(u(i)("plugin.page.loading")), 1)) : e.status === "pin" ? (f(), Ge(tde, {
            key: 4,
            locale: e.locale,
            busy: e.pinBusy,
            failure: e.pinFailure,
            "lock-message": e.lockMessage,
            "max-length": e.pinMax ?? void 0,
            captcha: e.pinCaptcha,
            onSubmit: A[0] || (A[0] = (L) => a("pin", L))
          }, null, 8, ["locale", "busy", "failure", "lock-message", "max-length", "captcha"])) : p.value ? On(T.$slots, "default", { key: 5 }) : e.status === "accepted" ? (f(), h("div", _de, [
            On(T.$slots, "accepted", {}, () => [
              d("h2", xde, y(u(i)("plugin.page.accepted_title")), 1),
              d("p", Sde, y(u(i)("plugin.page.accepted_text")), 1)
            ])
          ])) : e.status === "done" ? (f(), h("div", $de, [
            On(T.$slots, "done", {}, () => [
              d("h2", Tde, y(u(i)("plugin.page.done_title")), 1),
              d("p", Ade, y(u(i)("plugin.page.done_text")), 1)
            ])
          ])) : e.status === "error" ? (f(), h("div", Ede, [
            d("h2", Cde, y(u(i)("plugin.page.error_title")), 1),
            e.failure ? (f(), h("p", zde, y(e.failure), 1)) : O("", !0),
            d("button", {
              type: "button",
              class: "fe-btn fe-btn--primary",
              onClick: A[1] || (A[1] = (L) => a("retry"))
            }, y(u(i)("plugin.page.retry")), 1)
          ])) : (f(), h("div", Mde, [
            d("h2", Pde, y(u(i)("plugin.page.unavailable_title")), 1),
            d("p", Ode, y(u(i)("plugin.page.unavailable_text")), 1)
          ])),
          On(T.$slots, "extra")
        ]),
        _: 3
      })),
      d("footer", Lde, [
        Ze(ode, {
          "model-value": String(e.locale),
          "plugin-note": C,
          "onUpdate:modelValue": A[2] || (A[2] = (L) => a("update:locale", L))
        }, null, 8, ["model-value"]),
        e.footerText ? (f(), h("p", Dde, y(e.footerText), 1)) : O("", !0),
        e.hidePoweredBy ? O("", !0) : (f(), h("span", Rde, [
          e.logoUrl ? (f(), h("img", {
            key: 0,
            src: e.logoUrl,
            alt: ""
          }, null, 8, Ide)) : b.value ? (f(), Ge(l2, { key: 1 })) : O("", !0),
          Ht(" " + y(u(c)("served_by", { name: e.brandName })), 1)
        ]))
      ])
    ], 14, rde));
  }
}), Nde = {
  key: 0,
  class: "fe-ppage__actions"
}, Bde = {
  key: 1,
  class: "fe-ppage__appfiles",
  "data-testid": "public-page-files"
}, Fde = { class: "fe-surface__text" }, Ude = {
  key: 0,
  class: "fe-ppage__filesize"
}, Hde = ["href", "title", "data-testid"], Kde = {
  key: 1,
  class: "fe-ppage__file-one",
  "data-testid": "public-share-unavailable"
}, Vde = {
  key: 0,
  class: "fe-surface__text"
}, jde = {
  class: "fe-surface__text fe-surface__text--muted",
  role: "status"
}, qde = {
  key: 2,
  class: "fe-ppage__file-one",
  "data-testid": "public-share-folder"
}, Wde = {
  key: 0,
  class: "fe-surface__text"
}, Yde = {
  key: 1,
  class: "fe-ppage__crumbs",
  "data-testid": "public-share-crumbs"
}, Gde = { class: "fe-ppage__crumb" }, Xde = {
  key: 2,
  class: "fe-ppage__files",
  "data-testid": "public-share-entries"
}, Jde = ["data-dir"], Zde = ["data-testid", "onClick"], Qde = ["href", "data-testid"], efe = {
  key: 2,
  class: "fe-ppage__filesize"
}, tfe = {
  key: 3,
  class: "fe-ppage__filesize"
}, nfe = { class: "fe-ppage__actions" }, afe = ["href"], ife = ["href"], ofe = {
  key: 3,
  class: "fe-ppage__file-one",
  "data-testid": "public-share-file"
}, rfe = ["src", "alt"], sfe = {
  class: "fe-surface__text fe-surface__text--muted",
  "data-testid": "public-share-fileline"
}, lfe = { key: 0 }, ufe = {
  key: 1,
  class: "fe-ppage__filesize"
}, cfe = ["href"], IA = /* @__PURE__ */ lt({
  __name: "PublicShareBody",
  props: {
    link: {},
    locale: {},
    theme: {}
  },
  emits: ["navigate"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i, formatSize: o, formatDate: l } = pt(() => n.locale), { pt: c } = fb(() => String(n.locale)), p = E(() => n.link.info.value), m = E(() => {
      var C;
      return ((C = p.value) == null ? void 0 : C.kind) ?? "file";
    }), v = E(() => {
      var C;
      return ((C = p.value) == null ? void 0 : C.node) ?? null;
    }), x = E(() => {
      var C;
      return ((C = p.value) == null ? void 0 : C.app) ?? null;
    }), w = E(() => {
      var C;
      return ((C = p.value) == null ? void 0 : C.entries) ?? [];
    }), S = E(() => {
      var C;
      return ((C = p.value) == null ? void 0 : C.unavailable) === !0;
    }), k = E(() => {
      var C;
      return (((C = v.value) == null ? void 0 : C.mime) ?? "").startsWith("image/");
    }), b = E(() => {
      var A;
      const C = (((A = p.value) == null ? void 0 : A.path) ?? "").replace(/\/+$/, "");
      if (!C) return null;
      const T = C.lastIndexOf("/");
      return T <= 0 ? "" : C.slice(0, T);
    });
    return (C, T) => {
      var A, L, z, D, U, q, P, R, W, N, J, H, ne, j;
      return m.value === "app" ? (f(), h(Te, { key: 0 }, [
        Ze(Xp, {
          conv: e.link.conv,
          locale: e.locale,
          theme: e.theme,
          "file-url": e.link.resolveFile,
          toast: e.link.toast.value,
          layout: "page",
          "page-height": "min(80vh, 1000px)"
        }, null, 8, ["conv", "locale", "theme", "file-url", "toast"]),
        e.link.conv.footer.value.length ? (f(), h("div", Nde, [
          Ze(Jp, {
            conv: e.link.conv,
            locale: e.locale,
            "testid-prefix": "public-page"
          }, null, 8, ["conv", "locale"])
        ])) : O("", !0),
        (L = (A = x.value) == null ? void 0 : A.files) != null && L.length ? (f(), h("section", Bde, [
          (f(!0), h(Te, null, nt(((z = x.value) == null ? void 0 : z.files) ?? [], (re) => (f(), h("div", {
            key: re.ref,
            class: "fe-ppage__file-one fe-ppage__appfile"
          }, [
            d("p", Fde, [
              d("strong", null, y(u(da)(re.name)), 1),
              re.size ? (f(), h("span", Ude, " · " + y(u(o)(re.size)), 1)) : O("", !0)
            ]),
            d("a", {
              class: "fe-btn",
              href: e.link.fileDownloadUrl(re.ref),
              download: "",
              title: u(i)("plugin.page.open_file", { name: u(da)(re.name) }),
              "data-testid": `public-page-file-${re.ref}`
            }, y(u(i)("ctx.download")), 9, Hde)
          ]))), 128))
        ])) : O("", !0)
      ], 64)) : S.value ? (f(), h("div", Kde, [
        (D = v.value) != null && D.name ? O("", !0) : (f(), h("p", Vde, [
          d("strong", null, y(u(da)(((U = p.value) == null ? void 0 : U.subject) ?? "")), 1)
        ])),
        d("p", jde, y(u(c)("err_unavailable_body")), 1)
      ])) : m.value === "folder" ? (f(), h("div", qde, [
        (q = v.value) != null && q.name ? O("", !0) : (f(), h("p", Wde, [
          d("strong", null, y(u(da)(((P = p.value) == null ? void 0 : P.subject) ?? "")), 1)
        ])),
        (R = p.value) != null && R.path ? (f(), h("nav", Yde, [
          d("button", {
            type: "button",
            class: "fe-btn fe-btn--sm",
            onClick: T[0] || (T[0] = (re) => a("navigate", b.value ?? ""))
          }, y(u(c)("folder_up")), 1),
          d("span", Gde, y(u(da)(((W = p.value) == null ? void 0 : W.path) ?? "")), 1)
        ])) : O("", !0),
        w.value.length ? (f(), h("ul", Xde, [
          (f(!0), h(Te, null, nt(w.value, (re) => (f(), h("li", {
            key: re.path,
            class: "fe-ppage__file",
            "data-dir": re.is_dir ? "1" : void 0
          }, [
            re.is_dir ? (f(), h("button", {
              key: 0,
              type: "button",
              class: "fe-ppage__entry",
              "data-testid": `public-entry-${re.name}`,
              onClick: (he) => a("navigate", re.path)
            }, [
              d("bdi", null, y(u(da)(re.name)), 1)
            ], 8, Zde)) : (f(), h("a", {
              key: 1,
              href: re.url || e.link.downloadUrl({ path: re.path }),
              class: "fe-ppage__entry",
              "data-testid": `public-entry-${re.name}`,
              download: ""
            }, [
              d("bdi", null, y(u(da)(re.name)), 1)
            ], 8, Qde)),
            !re.is_dir && re.size !== void 0 ? (f(), h("span", efe, y(u(o)(re.size)), 1)) : O("", !0),
            re.modified ? (f(), h("span", tfe, y(u(l)(re.modified)), 1)) : O("", !0)
          ], 8, Jde))), 128))
        ])) : O("", !0),
        d("div", nfe, [
          d("a", {
            class: "fe-btn fe-btn--primary",
            href: e.link.downloadUrl({ zip: !0 }),
            "data-testid": "public-share-zip"
          }, y(u(c)("folder_zip")), 9, afe),
          w.value.length ? O("", !0) : (f(), h("a", {
            key: 0,
            class: "fe-btn",
            href: e.link.noJsUrl(),
            "data-testid": "public-share-browse"
          }, y(u(c)("browse")), 9, ife))
        ])
      ])) : (f(), h("div", ofe, [
        k.value ? (f(), h("img", {
          key: 0,
          class: "fe-ppage__shot",
          src: e.link.downloadUrl(),
          alt: u(da)(((N = v.value) == null ? void 0 : N.name) ?? "")
        }, null, 8, rfe)) : O("", !0),
        d("p", sfe, [
          (J = v.value) != null && J.name ? O("", !0) : (f(), h("strong", lfe, y(u(da)(((H = p.value) == null ? void 0 : H.subject) ?? "")), 1)),
          ((ne = v.value) == null ? void 0 : ne.size) !== void 0 ? (f(), h("span", ufe, y(u(o)((j = v.value) == null ? void 0 : j.size)), 1)) : O("", !0)
        ]),
        d("a", {
          class: "fe-btn fe-btn--primary",
          href: e.link.downloadUrl(),
          "data-testid": "public-share-download"
        }, y(u(i)("ctx.download")), 9, cfe)
      ]));
    };
  }
}), dfe = {
  class: "fe-pdrop",
  "data-testid": "public-request"
}, ffe = {
  key: 0,
  class: "fe-surface__text",
  "data-testid": "public-request-folder"
}, pfe = {
  class: "fe-surface__text fe-surface__text--muted",
  "data-testid": "public-request-lead"
}, hfe = {
  key: 1,
  class: "fe-pdrop__who",
  "data-testid": "public-request-name"
}, mfe = { class: "fe-pdrop__wholabel" }, vfe = ["maxlength", "placeholder", "disabled"], yfe = ["onKeydown"], gfe = { class: "fe-pdrop__lead" }, bfe = {
  key: 0,
  class: "fe-surface__text fe-surface__text--muted"
}, kfe = ["accept", "disabled"], wfe = {
  key: 3,
  class: "fe-ppage__meta",
  "data-testid": "public-request-limits"
}, _fe = {
  key: 0,
  "aria-hidden": "true"
}, xfe = {
  key: 4,
  class: "fe-pdrop__list",
  "data-testid": "public-request-uploads"
}, Sfe = ["data-state"], $fe = { class: "fe-pdrop__name" }, Tfe = { class: "fe-ppage__filesize" }, Afe = ["value"], Efe = {
  class: "fe-pdrop__saving",
  role: "status"
}, Cfe = {
  key: 2,
  class: "fe-pdrop__ok"
}, zfe = {
  key: 3,
  class: "fe-pdrop__unconfirmed",
  role: "status"
}, Mfe = {
  key: 4,
  class: "fe-surface__error"
}, Pfe = /* @__PURE__ */ lt({
  __name: "PublicRequestBody",
  props: {
    info: {},
    uploads: {},
    locale: {},
    disabled: { type: Boolean },
    hideFolder: { type: Boolean },
    captcha: {}
  },
  emits: ["files"],
  setup(e, { emit: t }) {
    const n = e, a = t, i = $(""), o = E(() => {
      var L, z;
      return ((z = (L = n.info) == null ? void 0 : L.limits) == null ? void 0 : z.ask_name) === !0;
    });
    function l(L) {
      a("files", L, o.value ? i.value.trim() : "");
    }
    const { formatSize: c } = pt(() => n.locale), { pt: p } = fb(() => String(n.locale)), m = E(() => {
      var z, D;
      const L = (D = (z = n.info) == null ? void 0 : z.limits) == null ? void 0 : D.name_max;
      return typeof L == "number" && L > 0 ? L : void 0;
    }), v = $(null), x = $(!1), w = E(() => {
      var L;
      return ((L = n.info) == null ? void 0 : L.limits) ?? {};
    }), S = E(() => {
      const L = w.value.allowed_ext ?? [];
      return L.length ? L.map((z) => `.${z.replace(/^\./, "")}`).join(",") : void 0;
    }), k = E(() => {
      var q;
      const L = [], z = w.value.max_file_size_mb;
      z && z > 0 && L.push(p("drop_limit_size", { mb: z }));
      const D = w.value.allowed_ext ?? [];
      D.length && L.push(p("drop_limit_ext", { types: D.map((P) => P.toUpperCase()).join(", ") }));
      const U = (q = n.info) == null ? void 0 : q.uploads_left;
      return U != null && Number.isFinite(U) && L.push(p("files_left", { count: U })), L;
    }), b = E(() => {
      var z;
      const L = (z = n.info) == null ? void 0 : z.uploads_left;
      return L != null && Number.isFinite(L) && L <= 0;
    });
    function C() {
      var L;
      n.disabled || b.value || (L = v.value) == null || L.click();
    }
    function T(L) {
      const z = L.target, D = Array.from(z.files ?? []);
      D.length && l(D), z.value = "";
    }
    function A(L) {
      var D;
      if (x.value = !1, n.disabled || b.value) return;
      const z = Array.from(((D = L.dataTransfer) == null ? void 0 : D.files) ?? []);
      z.length && l(z);
    }
    return (L, z) => {
      var D, U, q;
      return f(), h("div", dfe, [
        (D = e.info) != null && D.folder && !e.hideFolder ? (f(), h("p", ffe, [
          d("strong", null, y((U = e.info) == null ? void 0 : U.folder), 1)
        ])) : O("", !0),
        d("p", pfe, y(u(p)("drop_sub")), 1),
        o.value && !b.value ? (f(), h("label", hfe, [
          d("span", mfe, y(u(p)("drop_name_label")), 1),
          ln(d("input", {
            "onUpdate:modelValue": z[0] || (z[0] = (P) => i.value = P),
            class: "fe-pdrop__whoinput",
            type: "text",
            maxlength: m.value,
            autocomplete: "name",
            placeholder: u(p)("drop_name_ph"),
            disabled: e.disabled,
            "data-testid": "public-request-name-input"
          }, null, 8, vfe), [
            [_n, i.value]
          ])
        ])) : O("", !0),
        (q = e.captcha) != null && q.active.value && !b.value ? (f(), Ge(MA, {
          key: 2,
          captcha: e.captcha,
          locale: String(e.locale)
        }, null, 8, ["captcha", "locale"])) : O("", !0),
        d("div", {
          class: Re(["fe-pdrop__zone", { "is-over": x.value, "is-disabled": e.disabled || b.value }]),
          role: "button",
          tabindex: "0",
          "data-testid": "public-request-drop",
          onClick: C,
          onKeydown: [
            Ca(yt(C, ["prevent"]), ["enter"]),
            Ca(yt(C, ["prevent"]), ["space"])
          ],
          onDragover: z[1] || (z[1] = yt((P) => x.value = !0, ["prevent"])),
          onDragleave: z[2] || (z[2] = (P) => x.value = !1),
          onDrop: yt(A, ["prevent"])
        }, [
          z[3] || (z[3] = d("svg", {
            class: "fe-pdrop__icon",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "1.7",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "aria-hidden": "true"
          }, [
            d("path", { d: "M4 14.9A7 7 0 1 1 15.7 8h1.8a4.5 4.5 0 0 1 2.5 8.2" }),
            d("path", { d: "M12 12v9" }),
            d("path", { d: "m16 16-4-4-4 4" })
          ], -1)),
          d("p", gfe, y(b.value ? u(p)("request_full") : u(p)("drop_zone_big")), 1),
          b.value ? O("", !0) : (f(), h("p", bfe, y(u(p)("drop_zone_hint")), 1)),
          d("input", {
            ref_key: "input",
            ref: v,
            class: "fe-pdrop__input",
            type: "file",
            multiple: "",
            accept: S.value,
            disabled: e.disabled || b.value,
            "data-testid": "public-request-input",
            onChange: T
          }, null, 40, kfe)
        ], 42, yfe),
        k.value.length ? (f(), h("p", wfe, [
          (f(!0), h(Te, null, nt(k.value, (P, R) => (f(), h(Te, { key: R }, [
            R ? (f(), h("span", _fe, "·")) : O("", !0),
            d("span", null, y(P), 1)
          ], 64))), 128))
        ])) : O("", !0),
        e.uploads.length ? (f(), h("ul", xfe, [
          (f(!0), h(Te, null, nt(e.uploads, (P, R) => (f(), h("li", {
            key: `${P.name}-${R}`,
            class: "fe-pdrop__item",
            "data-state": P.state
          }, [
            d("span", $fe, [
              d("bdi", null, y(u(da)(P.name)), 1)
            ]),
            d("span", Tfe, y(u(c)(P.size)), 1),
            P.state === "sending" ? (f(), h("progress", {
              key: 0,
              class: "fe-pdrop__bar",
              max: 100,
              value: P.percent >= 0 ? P.percent : void 0
            }, null, 8, Afe)) : P.state === "saving" ? (f(), h(Te, { key: 1 }, [
              z[4] || (z[4] = d("progress", {
                class: "fe-pdrop__bar",
                max: 100
              }, null, -1)),
              d("span", Efe, y(u(p)("upload_saving")), 1)
            ], 64)) : P.state === "done" ? (f(), h("span", Cfe, y(u(p)("upload_done")), 1)) : P.state === "unconfirmed" ? (f(), h("span", zfe, y(P.error || u(p)("upload_unanswered")), 1)) : (f(), h("span", Mfe, y(P.error || u(p)("drop_err_generic")), 1))
          ], 8, Sfe))), 128))
        ])) : O("", !0)
      ]);
    };
  }
}), Sme = /* @__PURE__ */ lt({
  __name: "PublicLinkPage",
  props: {
    kind: {},
    token: {},
    base: {},
    locale: {},
    theme: {}
  },
  setup(e) {
    const t = e, n = $(""), a = E(() => {
      if (t.locale) return String(t.locale);
      if (n.value) return n.value;
      const H = Aa(gp("locale"));
      return H && qf(H) ? H : M2();
    });
    function i(H) {
      const ne = Aa(H);
      !ne || !qf(ne) || (n.value = ne, Gr("locale", ne));
    }
    const { t: o } = pt(() => a.value), l = OA({ base: t.base ?? rc(), locale: () => a.value });
    LA(l);
    const c = $(!1);
    Je(
      () => l.ready.value,
      (H) => {
        H && (c.value = !0);
      },
      { immediate: !0 }
    );
    function p(H, ne = {}) {
      return DA(l.table.value, l.lang.value || a.value, H, ne);
    }
    const m = t.base ?? rc(), v = e6({ base: m }), x = Il(), w = E(() => {
      const H = t.theme && t.theme !== "auto" ? t.theme : gp("theme") || v.themeDefault.value;
      return H === "light" || H === "dark" ? H : x.value ? "dark" : "light";
    }), S = zA({ base: m }), k = {
      base: m,
      locale: () => a.value,
      theme: () => w.value,
      config: S
    }, b = v2({ ...k, form: "share_password" }), C = t.kind === "request" ? v2({ ...k, form: "file_request" }) : null, T = {
      base: m,
      locale: () => a.value,
      errorText: () => o("plugin.view.error"),
      captcha: { pin: b, upload: C }
    }, A = t.kind === "share" ? Fce(t.token ?? "", T) : null, L = t.kind === "request" ? Hce(t.token ?? "", {
      ...T,
      errorText: () => p("drop_err_generic"),
      unansweredText: () => p("upload_unanswered")
    }) : null;
    function z(H) {
      return H.code === "ext" ? p("drop_err_ext", { name: H.name }) : H.code === "too_large" ? p("drop_err_too_large", { name: H.name, mb: H.mb }) : H.count <= 0 ? p("request_full") : p("drop_err_too_many", { count: H.count });
    }
    const D = A ?? L, U = E(() => (A == null ? void 0 : A.info.value) ?? null), q = E(() => (L == null ? void 0 : L.info.value) ?? null), P = E(() => {
      var j, re, he, ue, ae;
      const H = (j = U.value) == null ? void 0 : j.app, ne = Xt((re = A == null ? void 0 : A.conv.current.value) == null ? void 0 : re.title, a.value);
      return H ? ne || Xt(H.title, a.value) || "" : da(((ue = (he = U.value) == null ? void 0 : he.node) == null ? void 0 : ue.name) || ((ae = q.value) == null ? void 0 : ae.folder) || "");
    }), R = E(() => {
      var ne;
      const H = da(((ne = D.info.value) == null ? void 0 : ne.subject) ?? "");
      return H && H !== P.value ? H : "";
    }), W = E(
      () => {
        var H, ne, j;
        return $A(((H = U.value) == null ? void 0 : H.kind) ?? (L ? "drop" : ""), {
          list: (((j = (ne = U.value) == null ? void 0 : ne.entries) == null ? void 0 : j.length) ?? 0) > 0
        });
      }
    ), N = E(() => {
      var ne;
      if (L) return "";
      const H = (ne = U.value) == null ? void 0 : ne.kind;
      return H === "folder" ? "folder" : H === "app" ? "" : "file";
    });
    function J(H) {
      D.load(H ? `?path=${encodeURIComponent(H)}` : "");
    }
    return Je(P, (H) => {
      H && typeof document < "u" && (document.title = H);
    }), Je(
      a,
      (H) => {
        typeof document < "u" && (document.documentElement.lang = H);
      },
      { immediate: !0 }
    ), Je(a, () => {
      var H;
      D.status.value === "ready" && ((H = U.value) == null ? void 0 : H.kind) === "app" && (D.conv.current.value ? D.conv.post("change") : D.load());
    }), jt(() => {
      if (v.load(), S.load(), !t.token) {
        D.status.value = "not_found";
        return;
      }
      D.load();
    }), (H, ne) => {
      var j, re, he, ue;
      return f(), Ge(RA, {
        status: c.value ? u(D).status.value : "loading",
        locale: a.value,
        theme: w.value,
        "brand-name": u(v).name.value,
        "logo-url": u(v).logo.value,
        "accent-style": u(v).accentStyle.value,
        "footer-text": u(v).footerText.value,
        "hide-powered-by": u(v).hidePoweredBy.value,
        layout: W.value,
        badge: N.value,
        title: P.value,
        subject: R.value,
        "expires-at": ((j = u(D).info.value) == null ? void 0 : j.expires_at) ?? null,
        "visits-left": ((re = U.value) == null ? void 0 : re.visits_left) ?? ((he = q.value) == null ? void 0 : he.uploads_left) ?? null,
        "pin-max": ((ue = u(D).info.value) == null ? void 0 : ue.pin_max) ?? null,
        "pin-busy": u(D).pinBusy.value,
        "pin-failure": u(D).pinFailure.value,
        "lock-message": u(D).lockMessage.value,
        failure: u(D).failure.value,
        "pin-captcha": u(b),
        onPin: ne[1] || (ne[1] = (ae) => u(D).submitPin(ae)),
        onRetry: ne[2] || (ne[2] = () => u(D).load()),
        "onUpdate:locale": i
      }, {
        default: mt(() => [
          u(A) ? (f(), Ge(IA, {
            key: 0,
            link: u(A),
            locale: a.value,
            theme: w.value,
            onNavigate: J
          }, null, 8, ["link", "locale", "theme"])) : u(L) ? (f(), Ge(Pfe, {
            key: 1,
            info: q.value,
            uploads: u(L).uploads.value,
            locale: a.value,
            captcha: u(C),
            "hide-folder": "",
            onFiles: ne[0] || (ne[0] = (ae, fe) => u(L).upload(ae, { name: fe, refusedText: z }))
          }, null, 8, ["info", "uploads", "locale", "captcha"])) : O("", !0)
        ]),
        _: 1
      }, 8, ["status", "locale", "theme", "brand-name", "logo-url", "accent-style", "footer-text", "hide-powered-by", "layout", "badge", "title", "subject", "expires-at", "visits-left", "pin-max", "pin-busy", "pin-failure", "lock-message", "failure", "pin-captcha"]);
    };
  }
}), Ofe = {
  class: "fe-ppreview",
  inert: "",
  "data-testid": "public-link-preview"
}, $me = /* @__PURE__ */ lt({
  __name: "PublicLinkPreview",
  props: {
    brandName: {},
    logoUrl: {},
    accent: {},
    footerText: {},
    hidePoweredBy: { type: Boolean },
    locale: {},
    theme: {},
    sample: {}
  },
  setup(e) {
    const t = e, n = E(() => t.sample ?? { name: "report-2026.pdf", size: 124e4, mime: "application/pdf" }), a = E(() => ({
      kind: "file",
      node: { name: n.value.name, size: n.value.size, mime: n.value.mime ?? "application/pdf" }
    })), i = E(
      () => ({
        info: $(a.value),
        downloadUrl: () => "#",
        noJsUrl: () => "#"
      })
    ), o = E(() => {
      var l;
      return ((l = t.brandName) == null ? void 0 : l.trim()) || mp;
    });
    return LA(OA({ base: rc(), locale: () => String(t.locale) })), (l, c) => {
      var p, m;
      return f(), h("div", Ofe, [
        Ze(RA, {
          status: "ready",
          locale: e.locale,
          theme: e.theme ?? "light",
          "brand-name": o.value,
          "logo-url": ((p = e.logoUrl) == null ? void 0 : p.trim()) || "",
          "accent-style": u(C$)(e.accent),
          "footer-text": ((m = e.footerText) == null ? void 0 : m.trim()) || "",
          "hide-powered-by": e.hidePoweredBy === !0,
          layout: u($A)("file"),
          badge: "file",
          title: n.value.name,
          embedded: ""
        }, {
          default: mt(() => [
            Ze(IA, {
              link: i.value,
              locale: e.locale,
              theme: e.theme ?? "light"
            }, null, 8, ["link", "locale", "theme"])
          ]),
          _: 1
        }, 8, ["locale", "theme", "brand-name", "logo-url", "accent-style", "footer-text", "hide-powered-by", "layout", "title"])
      ]);
    };
  }
}), Lfe = {
  key: 0,
  class: "fe-apppage__bar"
}, Dfe = {
  class: "fe-apppage__title",
  "data-testid": "plugin-page-title"
}, Rfe = ["title"], Ife = ["href"], Nfe = {
  key: 0,
  class: "fe-surface__text",
  role: "status"
}, Bfe = {
  class: "fe-surface__text fe-surface__text--muted",
  "data-testid": "plugin-page-loading"
}, Ffe = {
  key: 1,
  class: "fe-surface__text fe-surface__text--muted",
  "data-testid": "plugin-page-loading"
}, Ufe = ["data-job"], Hfe = {
  class: "fe-apppage__state-title",
  "data-testid": "plugin-page-job-title"
}, Kfe = ["role"], Vfe = { class: "fe-apppage__state-actions" }, jfe = ["href"], qfe = ["href"], Wfe = {
  key: 4,
  class: "fe-apppage__state",
  "data-testid": "plugin-page-done"
}, Yfe = { class: "fe-apppage__state-title" }, Gfe = { class: "fe-surface__text" }, Xfe = { class: "fe-apppage__state-actions" }, Jfe = ["href"], Zfe = {
  key: 5,
  class: "fe-apppage__state",
  "data-testid": "plugin-page-error"
}, Qfe = { class: "fe-apppage__state-title" }, epe = {
  key: 0,
  class: "fe-surface__error"
}, tpe = { class: "fe-apppage__state-actions" }, npe = ["href"], ape = {
  key: 4,
  class: "fe-apppage__foot"
}, Tme = /* @__PURE__ */ lt({
  __name: "PluginPageView",
  props: {
    locale: {},
    theme: {},
    api: {},
    userName: {},
    plugin: {},
    view: {},
    path: {},
    storages: {},
    startAt: {},
    backHref: {},
    opsHref: {},
    mountBase: {},
    frame: {},
    section: {}
  },
  emits: ["op", "section"],
  setup(e, { expose: t, emit: n }) {
    const a = e, i = n, { t: o } = pt(() => a.locale), l = E(() => a.frame === "embedded"), c = E(() => l.value ? "div" : "main"), p = $("loading"), m = $(""), v = $(""), x = $("running"), w = $(""), S = $(/* @__PURE__ */ new Set());
    function k(ue) {
      const ae = $_(ue, {
        plugin: a.plugin,
        base: a.mountBase,
        placementOf: (fe) => S.value.has(fe) ? "page" : void 0
      });
      if (!ae.href) return !1;
      try {
        return window.location.assign(ae.href), !0;
      } catch {
        return !1;
      }
    }
    function b(ue) {
      if (ue.status === "done") {
        w.value = ue.message ?? "";
        const ae = XS(ue);
        if (ae && k(ae.open)) {
          x.value = "opening";
          return;
        }
        x.value = "done";
        return;
      }
      w.value = Zf(ue, o).text, x.value = "failed";
    }
    const C = vx({}, a.api, { onSettled: b });
    function T(ue) {
      var ae;
      x.value = "running", w.value = "", (ae = a.api.endpoints) != null && ae.opsList && C.register(ue);
    }
    const A = E(() => {
      switch (x.value) {
        case "done":
          return o("plugin.page_view.finished_title");
        case "failed":
          return o("plugin.page_view.failed_title");
        case "opening":
          return o("plugin.page_view.opening_title");
        default:
          return o("plugin.page_view.queued_title");
      }
    }), L = E(() => x.value === "running" ? o("plugin.page_view.queued_text") : x.value === "done" ? w.value || o("plugin.page_view.finished_text") : w.value), z = Gp(
      {
        api: a.api,
        plugin: a.plugin,
        view: a.view,
        path: () => a.path,
        locale: () => a.locale,
        errorText: () => o("plugin.view.error")
      },
      {
        // ⚠ `onOp` fires BEFORE `onDone` (usePluginSurface posts them in that
        // order), so the queued state has to be set after both — otherwise
        // `onDone` would overwrite it with "finished" and the person would never
        // see that a job is running.
        /**
         * v3 §3.0 — "go to this file, and start that screen on it".
         *
         * ⚠ A real navigation, not a tab: this IS a whole page, and the person
         * asked to be taken to a document. The address is the explorer deep link
         * a notification already uses, so the placement question is answered
         * where it is answerable — the explorer knows which of the plugin's
         * views is a `page` and opens that one in its own tab.
         */
        onOpen: (ue) => {
          const ae = $_(ue, { plugin: a.plugin, base: a.mountBase });
          if (ae.href)
            try {
              if (ae.newTab) {
                const fe = window.open(ae.href, "_blank");
                fe ? fe.opener = null : window.location.assign(ae.href);
              } else
                window.location.assign(ae.href);
            } catch {
            }
        },
        onOp: (ue) => {
          i("op", ue), p.value = "queued", T(ue);
        },
        onDone: () => {
          p.value !== "queued" && (p.value = "done");
        },
        onToast: (ue) => v.value = ue
      }
    ), D = z.current, U = E(() => {
      var ue;
      return Xt((ue = D.value) == null ? void 0 : ue.title, a.locale) || a.view;
    }), q = $(a.section ?? ""), P = E(() => {
      var ue;
      return ((ue = D.value) == null ? void 0 : ue.sections) ?? [];
    }), R = E(() => {
      var ue;
      return ((ue = D.value) == null ? void 0 : ue.section) || q.value;
    });
    function W(ue) {
      !ue || ue === R.value || (q.value = ue, i("section", ue), N());
    }
    Je(
      () => a.section,
      (ue) => {
        const ae = ue ?? "";
        ae !== q.value && (q.value = ae, N());
      }
    );
    async function N() {
      var ue;
      D.value || (p.value = "loading"), m.value = "";
      try {
        const ae = q.value ? await a.api.pluginView(a.plugin, a.view, a.path, q.value) : await a.api.pluginView(a.plugin, a.view, a.path);
        if (!(ae != null && ae.surface)) {
          m.value = o("plugin.view.error"), p.value = "error";
          return;
        }
        z.setSurface(ae.surface), p.value = "surface";
        const fe = ae.surface.section ?? "";
        !q.value && fe && (q.value = fe, i("section", fe, { replace: !0 }));
      } catch (ae) {
        m.value = ((ue = o.foreign) == null ? void 0 : ue.call(o, String((ae == null ? void 0 : ae.message) ?? ""))) || o("plugin.view.error"), p.value = "error";
      }
    }
    const J = $(null), H = $("page"), ne = $(!1), j = E(
      () => a.path ? [{ path: a.path, name: a.path.split("/").pop() || a.path }] : []
    );
    async function re() {
      try {
        const ue = await a.api.pluginActions();
        S.value = new Set(
          (ue.actions ?? []).filter((_) => _.plugin === a.plugin && _.view && tp(_.view_placement)).map((_) => _.view)
        );
        const ae = ue.views.find((_) => _.plugin === a.plugin && _.id === a.view && _.ui);
        if (ae != null && ae.ui) {
          J.value = ae.ui, H.value = ae.placement === "home" ? "home" : "page";
          return;
        }
        const fe = ue.actions.find((_) => _.plugin === a.plugin && _.view === a.view && _.ui);
        fe != null && fe.ui && (J.value = fe.ui);
      } catch {
      } finally {
        ne.value = !0;
      }
    }
    jt(async () => {
      await re(), J.value || N();
    }), t({ reload: N });
    const he = E(() => {
      var ae;
      let ue = !1;
      return Gc((ae = z.current.value) == null ? void 0 : ae.nodes, (fe) => {
        var _;
        fe.type === "pdf-fields" && ((_ = fe.props) == null ? void 0 : _.mode) !== "define" && (ue = !0);
      }), ue;
    });
    return (ue, ae) => (f(), h("div", {
      class: Re(["fe fe-apppage", [
        e.theme === "dark" ? "fe--theme-dark" : e.theme === "light" ? "fe--theme-light" : "",
        { "is-doc": he.value && !l.value, "fe-apppage--embedded": l.value }
      ]]),
      "data-testid": "plugin-page"
    }, [
      l.value ? O("", !0) : (f(), h("header", Lfe, [
        d("h1", Dfe, y(U.value), 1),
        e.path ? (f(), h("p", {
          key: 0,
          class: "fe-apppage__path",
          title: e.path
        }, y(e.path), 9, Rfe)) : O("", !0),
        e.backHref ? (f(), h("a", {
          key: 1,
          class: "fe-btn fe-apppage__back",
          href: e.backHref,
          "data-testid": "plugin-page-back"
        }, y(u(o)("plugin.page_view.back")), 9, Ife)) : O("", !0)
      ])),
      J.value ? (f(), Ge(Ki(c.value), {
        key: 1,
        class: "fe-apppage__body fe-apppage__body--ui"
      }, {
        default: mt(() => [
          Ze(Fg, {
            api: e.api,
            app: e.plugin,
            version: J.value.version,
            view: e.view,
            placement: H.value,
            ui: J.value,
            files: j.value,
            storages: e.storages,
            "start-at": e.startAt,
            locale: e.locale,
            theme: e.theme,
            title: U.value,
            "user-name": e.userName,
            onToast: ae[0] || (ae[0] = (fe) => v.value = fe.text),
            onOp: ae[1] || (ae[1] = (fe) => i("op", fe))
          }, null, 8, ["api", "app", "version", "view", "placement", "ui", "files", "storages", "start-at", "locale", "theme", "title", "user-name"]),
          v.value ? (f(), h("p", Nfe, y(v.value), 1)) : O("", !0)
        ]),
        _: 1
      })) : ne.value ? (f(), Ge(Ki(c.value), {
        key: 3,
        class: "fe-apppage__body"
      }, {
        default: mt(() => [
          p.value === "surface" && P.value.length ? (f(), Ge(sA, {
            key: 0,
            sections: P.value,
            active: R.value,
            locale: e.locale,
            label: U.value,
            disabled: u(z).busy.value,
            onSelect: W
          }, null, 8, ["sections", "active", "locale", "label", "disabled"])) : O("", !0),
          p.value === "loading" ? (f(), h("p", Ffe, y(u(o)("plugin.view.loading")), 1)) : p.value === "surface" ? (f(), Ge(Xp, {
            key: 2,
            conv: u(z),
            locale: e.locale,
            theme: e.theme,
            api: e.api,
            plugin: e.plugin,
            storages: e.storages,
            "start-at": e.startAt,
            toast: v.value,
            layout: l.value ? "inline" : "page"
          }, null, 8, ["conv", "locale", "theme", "api", "plugin", "storages", "start-at", "toast", "layout"])) : p.value === "queued" ? (f(), h("div", {
            key: 3,
            class: "fe-apppage__state",
            "data-testid": "plugin-page-queued",
            "data-job": x.value
          }, [
            d("h2", Hfe, y(A.value), 1),
            d("p", {
              class: Re(x.value === "failed" ? "fe-surface__error" : "fe-surface__text"),
              role: x.value === "failed" ? "alert" : "status",
              "data-testid": "plugin-page-job-text"
            }, y(L.value), 11, Kfe),
            d("div", Vfe, [
              e.opsHref ? (f(), h("a", {
                key: 0,
                class: "fe-btn fe-btn--primary",
                href: e.opsHref,
                "data-testid": "plugin-page-ops"
              }, y(u(o)("plugin.page_view.open_ops")), 9, jfe)) : O("", !0),
              e.backHref ? (f(), h("a", {
                key: 1,
                class: "fe-btn",
                href: e.backHref
              }, y(u(o)("plugin.page_view.back")), 9, qfe)) : O("", !0)
            ])
          ], 8, Ufe)) : p.value === "done" ? (f(), h("div", Wfe, [
            d("h2", Yfe, y(u(o)("plugin.page_view.done_title")), 1),
            d("p", Gfe, y(u(o)("plugin.page_view.done_text")), 1),
            d("div", Xfe, [
              e.backHref ? (f(), h("a", {
                key: 0,
                class: "fe-btn fe-btn--primary",
                href: e.backHref
              }, y(u(o)("plugin.page_view.back")), 9, Jfe)) : O("", !0)
            ])
          ])) : (f(), h("div", Zfe, [
            d("h2", Qfe, y(u(o)("plugin.page_view.error_title")), 1),
            m.value ? (f(), h("p", epe, y(m.value), 1)) : O("", !0),
            d("div", tpe, [
              d("button", {
                type: "button",
                class: "fe-btn",
                onClick: ae[2] || (ae[2] = (fe) => N())
              }, y(u(o)("plugin.page_view.retry")), 1),
              e.backHref ? (f(), h("a", {
                key: 0,
                class: "fe-btn",
                href: e.backHref
              }, y(u(o)("plugin.page_view.back")), 9, npe)) : O("", !0)
            ])
          ]))
        ]),
        _: 1
      })) : (f(), Ge(Ki(c.value), {
        key: 2,
        class: "fe-apppage__body"
      }, {
        default: mt(() => [
          d("p", Bfe, y(u(o)("plugin.view.loading")), 1)
        ]),
        _: 1
      })),
      p.value === "surface" && u(z).footer.value.length ? (f(), h("footer", ape, [
        Ze(Jp, {
          conv: u(z),
          locale: e.locale,
          "testid-prefix": "plugin-page"
        }, null, 8, ["conv", "locale"])
      ])) : O("", !0)
    ], 2));
  }
});
function Ame(e) {
  const t = e.trim().toLowerCase();
  return t === "7z" ? "7z" : t.toUpperCase();
}
const ipe = {
  key: 0,
  class: "fe-connlost",
  role: "status",
  "aria-live": "polite",
  "data-testid": "connection-notice"
}, ope = { class: "fe-connlost__text" }, Eme = /* @__PURE__ */ lt({
  __name: "ConnectionNotice",
  props: {
    locale: {}
  },
  setup(e) {
    const t = e, { t: n } = pt(() => t.locale ?? "en");
    return (a, i) => u(OO) ? (f(), h("div", ipe, [
      i[0] || (i[0] = d("span", {
        class: "fe-connlost__dot",
        "aria-hidden": "true"
      }, null, -1)),
      d("span", ope, y(u(n)("err.network")), 1)
    ])) : O("", !0);
  }
});
export {
  Wie as $,
  Y7 as A,
  q7 as B,
  N3 as C,
  gi as D,
  Wi as E,
  sme as F,
  zle as G,
  a0 as H,
  F3 as I,
  H2 as J,
  B3 as K,
  rme as L,
  Q2 as M,
  Tpe as N,
  t3 as O,
  Lpe as P,
  Dpe as Q,
  A3 as R,
  as as S,
  Rpe as T,
  Ipe as U,
  fx as V,
  Dc as W,
  Npe as X,
  mp as Y,
  Xie as Z,
  ta as _,
  Xt as a,
  D5 as a$,
  Q$ as a0,
  bhe as a1,
  w8 as a2,
  mo as a3,
  Il as a4,
  Ape as a5,
  Zpe as a6,
  Qpe as a7,
  c5 as a8,
  fme as a9,
  DN as aA,
  Dg as aB,
  jv as aC,
  Sx as aD,
  xi as aE,
  zl as aF,
  Yf as aG,
  _pe as aH,
  Spe as aI,
  S$ as aJ,
  Jy as aK,
  dx as aL,
  hx as aM,
  Wpe as aN,
  qpe as aO,
  Zx as aP,
  k4 as aQ,
  sp as aR,
  pg as aS,
  nx as aT,
  Z2 as aU,
  hO as aV,
  mO as aW,
  yO as aX,
  Epe as aY,
  rx as aZ,
  zpe as a_,
  Km as aa,
  Qoe as ab,
  Yp as ac,
  wZ as ad,
  Jpe as ae,
  kc as af,
  Gie as ag,
  mi as ah,
  qhe as ai,
  mme as aj,
  Ll as ak,
  cme as al,
  Yi as am,
  Nle as an,
  dme as ao,
  sZ as ap,
  rZ as aq,
  ep as ar,
  LS as as,
  Khe as at,
  eme as au,
  pme as av,
  Hhe as aw,
  o2 as ax,
  Y2 as ay,
  zp as az,
  Xo as b,
  SP as b$,
  khe as b0,
  P5 as b1,
  pN as b2,
  Za as b3,
  jo as b4,
  Rhe as b5,
  Lhe as b6,
  Dhe as b7,
  Ty as b8,
  Vv as b9,
  BT as bA,
  Lae as bB,
  VP as bC,
  HP as bD,
  KP as bE,
  Jn as bF,
  os as bG,
  Bp as bH,
  tS as bI,
  Ic as bJ,
  x4 as bK,
  ga as bL,
  Np as bM,
  ec as bN,
  Cf as bO,
  So as bP,
  cg as bQ,
  dn as bR,
  Ap as bS,
  pre as bT,
  DS as bU,
  My as bV,
  ure as bW,
  J_ as bX,
  Zhe as bY,
  M0 as bZ,
  zT as b_,
  Upe as ba,
  jhe as bb,
  wW as bc,
  Sy as bd,
  yo as be,
  Ame as bf,
  Ile as bg,
  bP as bh,
  lre as bi,
  x2 as bj,
  bo as bk,
  kme as bl,
  Sce as bm,
  xce as bn,
  Ace as bo,
  ZP as bp,
  tr as bq,
  aZ as br,
  MA as bs,
  SG as bt,
  Eme as bu,
  SJ as bv,
  Sle as bw,
  r$ as bx,
  Fa as by,
  jm as bz,
  mpe as c,
  Ac as c$,
  dZ as c0,
  vp as c1,
  l2 as c2,
  i3 as c3,
  oc as c4,
  yme as c5,
  v5 as c6,
  ehe as c7,
  MX as c8,
  cre as c9,
  Sme as cA,
  $me as cB,
  tde as cC,
  Pfe as cD,
  IA as cE,
  RA as cF,
  u5 as cG,
  t8 as cH,
  iI as cI,
  WG as cJ,
  yy as cK,
  hre as cL,
  tR as cM,
  Cl as cN,
  cX as cO,
  Oie as cP,
  eR as cQ,
  HR as cR,
  xT as cS,
  Xp as cT,
  Jp as cU,
  TF as cV,
  OF as cW,
  T$ as cX,
  qS as cY,
  LT as cZ,
  $p as c_,
  Coe as ca,
  yA as cb,
  Goe as cc,
  GU as cd,
  gQ as ce,
  Uhe as cf,
  _A as cg,
  Mue as ch,
  Eue as ci,
  xA as cj,
  Cue as ck,
  zue as cl,
  Pf as cm,
  dy as cn,
  k3 as co,
  r3 as cp,
  M$ as cq,
  ZF as cr,
  _c as cs,
  Xoe as ct,
  tb as cu,
  PA as cv,
  bme as cw,
  Tme as cx,
  ode as cy,
  uh as cz,
  Mv as d,
  eZ as d$,
  Qf as d0,
  Ju as d1,
  dO as d2,
  FT as d3,
  Ep as d4,
  DQ as d5,
  wx as d6,
  CZ as d7,
  MT as d8,
  H5 as d9,
  Bhe as dA,
  T8 as dB,
  IT as dC,
  cZ as dD,
  p5 as dE,
  iA as dF,
  QV as dG,
  tj as dH,
  C5 as dI,
  w5 as dJ,
  u2 as dK,
  Lg as dL,
  XY as dM,
  nG as dN,
  JY as dO,
  YY as dP,
  GY as dQ,
  WY as dR,
  ohe as dS,
  Vf as dT,
  $ce as dU,
  TA as dV,
  AA as dW,
  Vne as dX,
  Oc as dY,
  hl as dZ,
  Nl as d_,
  G0 as da,
  gA as db,
  Fle as dc,
  ghe as dd,
  whe as de,
  yhe as df,
  oA as dg,
  C$ as dh,
  Vu as di,
  ioe as dj,
  mre as dk,
  bO as dl,
  kO as dm,
  Fpe as dn,
  pO as dp,
  P4 as dq,
  DT as dr,
  sb as ds,
  _he as dt,
  rc as du,
  XU as dv,
  Qy as dw,
  eg as dx,
  tg as dy,
  zZ as dz,
  nme as e,
  C2 as e$,
  Iu as e0,
  Dy as e1,
  nhe as e2,
  che as e3,
  oy as e4,
  rhe as e5,
  phe as e6,
  a3 as e7,
  h$ as e8,
  iU as e9,
  yv as eA,
  Bx as eB,
  jp as eC,
  t6 as eD,
  VO as eE,
  uj as eF,
  O8 as eG,
  er as eH,
  NN as eI,
  mhe as eJ,
  M2 as eK,
  Kle as eL,
  r4 as eM,
  ei as eN,
  Rae as eO,
  BN as eP,
  dj as eQ,
  hpe as eR,
  Wv as eS,
  W0 as eT,
  Kp as eU,
  el as eV,
  Tce as eW,
  mA as eX,
  ay as eY,
  V_ as eZ,
  Yv as e_,
  OO as ea,
  Mpe as eb,
  Ppe as ec,
  ca as ed,
  RY as ee,
  J2 as ef,
  BJ as eg,
  PT as eh,
  NJ as ei,
  FJ as ej,
  IJ as ek,
  CS as el,
  ny as em,
  Kne as en,
  W4 as eo,
  Kpe as ep,
  dre as eq,
  Rie as er,
  Wx as es,
  qx as et,
  vme as eu,
  Qi as ev,
  oW as ew,
  O4 as ex,
  up as ey,
  Qv as ez,
  wa as f,
  n3 as f$,
  Gle as f0,
  sS as f1,
  iS as f2,
  W_ as f3,
  wA as f4,
  zy as f5,
  aoe as f6,
  hoe as f7,
  vre as f8,
  Lce as f9,
  OT as fA,
  qf as fB,
  Tl as fC,
  nr as fD,
  IF as fE,
  Z8 as fF,
  Iae as fG,
  Cy as fH,
  Kf as fI,
  ts as fJ,
  cU as fK,
  aS as fL,
  C4 as fM,
  FN as fN,
  E$ as fO,
  o_ as fP,
  Pv as fQ,
  Ur as fR,
  w3 as fS,
  Og as fT,
  BF as fU,
  Dl as fV,
  xpe as fW,
  Ev as fX,
  f$ as fY,
  Or as fZ,
  hN as f_,
  v$ as fa,
  p$ as fb,
  _8 as fc,
  dU as fd,
  RS as fe,
  iy as ff,
  Z_ as fg,
  Gpe as fh,
  MS as fi,
  OS as fj,
  Mhe as fk,
  y$ as fl,
  xO as fm,
  E4 as fn,
  CO as fo,
  The as fp,
  She as fq,
  uhe as fr,
  Up as fs,
  hZ as ft,
  U3 as fu,
  Gg as fv,
  Yg as fw,
  tG as fx,
  qY as fy,
  hy as fz,
  lme as g,
  Aa as g$,
  foe as g0,
  Rf as g1,
  Pp as g2,
  tp as g3,
  fy as g4,
  Zle as g5,
  CT as g6,
  h3 as g7,
  bc as g8,
  ju as g9,
  xP as gA,
  bl as gB,
  oi as gC,
  qc as gD,
  y8 as gE,
  g8 as gF,
  Yr as gG,
  cy as gH,
  X8 as gI,
  By as gJ,
  UT as gK,
  rS as gL,
  qi as gM,
  G_ as gN,
  r5 as gO,
  px as gP,
  R_ as gQ,
  ahe as gR,
  ihe as gS,
  u0 as gT,
  nH as gU,
  Gi as gV,
  tZ as gW,
  Lv as gX,
  Ag as gY,
  Rg as gZ,
  Of as g_,
  Yy as ga,
  bD as gb,
  a$ as gc,
  xhe as gd,
  ns as ge,
  N2 as gf,
  UP as gg,
  XS as gh,
  Ml as gi,
  NO as gj,
  ml as gk,
  n$ as gl,
  k8 as gm,
  Wc as gn,
  jO as go,
  $P as gp,
  TP as gq,
  n6 as gr,
  OA as gs,
  b_ as gt,
  gp as gu,
  sU as gv,
  kl as gw,
  S2 as gx,
  E2 as gy,
  ppe as gz,
  jP as h,
  $A as h$,
  T_ as h0,
  R1 as h1,
  S8 as h2,
  ume as h3,
  Dv as h4,
  Rv as h5,
  Ghe as h6,
  Yhe as h7,
  soe as h8,
  fre as h9,
  Ohe as hA,
  ooe as hB,
  qu as hC,
  $he as hD,
  QU as hE,
  $2 as hF,
  ag as hG,
  bx as hH,
  f3 as hI,
  b3 as hJ,
  s3 as hK,
  mx as hL,
  ng as hM,
  eO as hN,
  Uy as hO,
  $pe as hP,
  Fl as hQ,
  L$ as hR,
  oU as hS,
  Op as hT,
  Qhe as hU,
  bA as hV,
  LA as hW,
  z5 as hX,
  Yle as hY,
  cx as hZ,
  EA as h_,
  $Q as ha,
  nh as hb,
  Jc as hc,
  rU as hd,
  NS as he,
  tO as hf,
  t$ as hg,
  m8 as hh,
  r_ as hi,
  J$ as hj,
  l3 as hk,
  Lr as hl,
  $_ as hm,
  Yie as hn,
  cj as ho,
  ub as hp,
  Lue as hq,
  Oue as hr,
  Due as hs,
  gme as ht,
  d2 as hu,
  Pg as hv,
  jpe as hw,
  SA as hx,
  rh as hy,
  Ahe as hz,
  Wf as i,
  roe as i$,
  cb as i0,
  _me as i1,
  A0 as i2,
  wme as i3,
  DA as i4,
  Whe as i5,
  wP as i6,
  Dce as i7,
  Vp as i8,
  Bne as i9,
  xne as iA,
  ux as iB,
  q0 as iC,
  m5 as iD,
  hA as iE,
  Fhe as iF,
  K5 as iG,
  Dm as iH,
  s2 as iI,
  WS as iJ,
  poe as iK,
  A8 as iL,
  $8 as iM,
  l$ as iN,
  wne as iO,
  kne as iP,
  vpe as iQ,
  Y0 as iR,
  Zi as iS,
  hj as iT,
  zhe as iU,
  Pc as iV,
  kpe as iW,
  Sf as iX,
  dhe as iY,
  she as iZ,
  Ihe as i_,
  f5 as ia,
  pA as ib,
  a1 as ic,
  BP as id,
  wpe as ie,
  _ne as ig,
  _P as ih,
  aU as ii,
  nU as ij,
  Hne as ik,
  wO as il,
  PS as im,
  tU as io,
  Cpe as ip,
  the as iq,
  jne as ir,
  Pae as is,
  Rce as it,
  h2 as iu,
  fhe as iv,
  Ope as iw,
  fpe as ix,
  Phe as iy,
  Vhe as iz,
  i_ as j,
  Nhe as j$,
  Xpe as j0,
  gO as j1,
  h5 as j2,
  Gr as j3,
  A2 as j4,
  z2 as j5,
  QR as j6,
  lZ as j7,
  QB as j8,
  Nce as j9,
  PP as jA,
  ed as jB,
  iZ as jC,
  vO as jD,
  j8 as jE,
  d5 as jF,
  vv as jG,
  _2 as jH,
  Iee as jI,
  Dae as jJ,
  Oce as jK,
  Yc as jL,
  Ly as jM,
  Une as jN,
  R4 as jO,
  fS as jP,
  Ype as jQ,
  dS as jR,
  P8 as jS,
  Xhe as jT,
  koe as jU,
  dpe as jV,
  M4 as jW,
  Rm as jX,
  v2 as jY,
  zA as jZ,
  IY as j_,
  vA as ja,
  Bce as jb,
  Ice as jc,
  Jhe as jd,
  s$ as je,
  iR as jf,
  Cce as jg,
  bpe as jh,
  gpe as ji,
  Jle as jj,
  Xle as jk,
  FF as jl,
  G8 as jm,
  nZ as jn,
  Ja as jo,
  h4 as jp,
  Q8 as jq,
  q8 as jr,
  w1 as js,
  ype as jt,
  mZ as ju,
  JR as jv,
  ES as jw,
  hhe as jx,
  ZR as jy,
  Uv as jz,
  K2 as k,
  Rl as k0,
  o3 as k1,
  Bpe as k2,
  dX as k3,
  loe as k4,
  wQ as k5,
  vx as k6,
  x3 as k7,
  Gp as k8,
  e6 as k9,
  f2 as kA,
  d_ as kB,
  ug as kC,
  Jx as kD,
  Hpe as kE,
  ime as kF,
  Che as kG,
  JB as kH,
  vie as kI,
  Hg as kJ,
  Ma as kK,
  VT as kL,
  gv as kM,
  Qs as kN,
  Uf as kO,
  Xa as kP,
  il as kQ,
  sae as kR,
  qr as kS,
  Vpe as kT,
  fae as kU,
  db as ka,
  xme as kb,
  Hce as kc,
  Fce as kd,
  fb as ke,
  rj as kf,
  $G as kg,
  YG as kh,
  S_ as ki,
  mj as kj,
  M5 as kk,
  vne as kl,
  uZ as km,
  PX as kn,
  WO as ko,
  X0 as kp,
  lS as kq,
  vhe as kr,
  E5 as ks,
  Xs as kt,
  b5 as ku,
  Z$ as kv,
  Cg as kw,
  hme as kx,
  lhe as ky,
  Ehe as kz,
  Qr as l,
  _ie as m,
  zt as n,
  ome as o,
  ame as p,
  Xg as q,
  es as r,
  Fg as s,
  K0 as t,
  pt as u,
  da as v,
  tme as w,
  I2 as x,
  cpe as y,
  fa as z
};
//# sourceMappingURL=index-C3y7-wee.js.map
